
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefc40"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefc40"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cmoHh", function(module, exports) {
// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license -
// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
(function(global, module1, define1) {
    function Alea(seed) {
        var me = this, mash = Mash();
        me.next = function() {
            var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
            me.s0 = me.s1;
            me.s1 = me.s2;
            return me.s2 = t - (me.c = t | 0);
        };
        // Apply the seeding algorithm from Baagoe.
        me.c = 1;
        me.s0 = mash(' ');
        me.s1 = mash(' ');
        me.s2 = mash(' ');
        me.s0 -= mash(seed);
        if (me.s0 < 0) me.s0 += 1;
        me.s1 -= mash(seed);
        if (me.s1 < 0) me.s1 += 1;
        me.s2 -= mash(seed);
        if (me.s2 < 0) me.s2 += 1;
        mash = null;
    }
    function copy(f, t) {
        t.c = f.c;
        t.s0 = f.s0;
        t.s1 = f.s1;
        t.s2 = f.s2;
        return t;
    }
    function impl(seed, opts) {
        var xg = new Alea(seed), state = opts && opts.state, prng = xg.next;
        prng.int32 = function() {
            return xg.next() * 0x100000000 | 0;
        };
        prng.double = function() {
            return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
        };
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    function Mash() {
        var n = 0xefc8249d;
        var mash = function(data) {
            data = String(data);
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.alea = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("euRi5", function(module, exports) {
// A Javascript implementaion of the "xor128" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x << 11;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            return me.w ^= me.w >>> 19 ^ t ^ t >>> 8;
        };
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor128 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("hDsEw", function(module, exports) {
// A Javascript implementaion of the "xorwow" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x >>> 2;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            me.w = me.v;
            return (me.d = me.d + 362437 | 0) + (me.v = me.v ^ me.v << 4 ^ (t ^ t << 1)) | 0;
        };
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        me.v = 0;
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            if (k == strseed.length) me.d = me.x << 10 ^ me.x >>> 4;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        t.v = f.v;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorwow = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("3J2Zm", function(module, exports) {
// A Javascript implementaion of the "xorshift7" algorithm by
// François Panneton and Pierre L'ecuyer:
// "On the Xorgshift Random Number Generators"
// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            // Update xor generator.
            var X = me.x, i = me.i, t, v, w;
            t = X[i];
            t ^= t >>> 7;
            v = t ^ t << 24;
            t = X[i + 1 & 7];
            v ^= t ^ t >>> 10;
            t = X[i + 3 & 7];
            v ^= t ^ t >>> 3;
            t = X[i + 4 & 7];
            v ^= t ^ t << 7;
            t = X[i + 7 & 7];
            t = t ^ t << 13;
            v ^= t ^ t << 9;
            X[i] = v;
            me.i = i + 1 & 7;
            return v;
        };
        function init(me, seed) {
            var j, w, X = [];
            if (seed === (seed | 0)) // Seed state array using a 32-bit integer.
            w = X[0] = seed;
            else {
                // Seed state using a string.
                seed = '' + seed;
                for(j = 0; j < seed.length; ++j)X[j & 7] = X[j & 7] << 15 ^ seed.charCodeAt(j) + X[j + 1 & 7] << 13;
            }
            // Enforce an array length of 8, not all zeroes.
            while(X.length < 8)X.push(0);
            for(j = 0; j < 8 && X[j] === 0; ++j);
            if (j == 8) w = X[7] = -1;
            else w = X[j];
            me.x = X;
            me.i = 0;
            // Discard an initial 256 values.
            for(j = 256; j > 0; --j)me.next();
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.x = f.x.slice();
        t.i = f.i;
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.x) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorshift7 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("6Px8M", function(module, exports) {
// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
//
// This fast non-cryptographic random number generator is designed for
// use in Monte-Carlo algorithms. It combines a long-period xorshift
// generator with a Weyl generator, and it passes all common batteries
// of stasticial tests for randomness while consuming only a few nanoseconds
// for each prng generated.  For background on the generator, see Brent's
// paper: "Some long-period random number generators using shifts and xors."
// http://arxiv.org/pdf/1004.3115v1.pdf
//
// Usage:
//
// var xor4096 = require('xor4096');
// random = xor4096(1);                        // Seed with int32 or string.
// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
//
// For nonzero numeric keys, this impelementation provides a sequence
// identical to that by Brent's xorgens 3 implementaion in C.  This
// implementation also provides for initalizing the generator with
// string seeds, or for saving and restoring the state of the generator.
//
// On Chrome, this prng benchmarks about 2.1 times slower than
// Javascript's built-in Math.random().
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            var w = me.w, X = me.X, i = me.i, t, v;
            // Update Weyl generator.
            me.w = w = w + 0x61c88647 | 0;
            // Update xor generator.
            v = X[i + 34 & 127];
            t = X[i = i + 1 & 127];
            v ^= v << 13;
            t ^= t << 17;
            v ^= v >>> 15;
            t ^= t >>> 12;
            // Update Xor generator array state.
            v = X[i] = v ^ t;
            me.i = i;
            // Result is the combination.
            return v + (w ^ w >>> 16) | 0;
        };
        function init(me, seed) {
            var t, v, i, j, w, X = [], limit = 128;
            if (seed === (seed | 0)) {
                // Numeric seeds initialize v, which is used to generates X.
                v = seed;
                seed = null;
            } else {
                // String seeds are mixed into v and X one character at a time.
                seed = seed + '\0';
                v = 0;
                limit = Math.max(limit, seed.length);
            }
            // Initialize circular array and weyl value.
            for(i = 0, j = -32; j < limit; ++j){
                // Put the unicode characters into the array, and shuffle them.
                if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
                // After 32 shuffles, take v as the starting w value.
                if (j === 0) w = v;
                v ^= v << 10;
                v ^= v >>> 15;
                v ^= v << 4;
                v ^= v >>> 13;
                if (j >= 0) {
                    w = w + 0x61c88647 | 0; // Weyl.
                    t = X[j & 127] ^= v + w; // Combine xor and weyl to init array.
                    i = 0 == t ? i + 1 : 0; // Count zeroes.
                }
            }
            // We have detected all zeroes; make the key nonzero.
            if (i >= 128) X[(seed && seed.length || 0) & 127] = -1;
            // Run the generator 512 times to further mix the state before using it.
            // Factoring this as a function slows the main generator, so it is just
            // unrolled here.  The weyl generator is not advanced while warming up.
            i = 127;
            for(j = 512; j > 0; --j){
                v = X[i + 34 & 127];
                t = X[i = i + 1 & 127];
                v ^= v << 13;
                t ^= t << 17;
                v ^= v >>> 15;
                t ^= t >>> 12;
                X[i] = v ^ t;
            }
            // Storing state as object members is faster than using closure variables.
            me.w = w;
            me.X = X;
            me.i = i;
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.i = f.i;
        t.w = f.w;
        t.X = f.X.slice();
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.X) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor4096 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("lDm0S", function(module, exports) {
// A Javascript implementaion of the "Tyche-i" prng algorithm by
// Samuel Neves and Filipe Araujo.
// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        // Set up generator function.
        me.next = function() {
            var b = me.b, c = me.c, d = me.d, a = me.a;
            b = b << 25 ^ b >>> 7 ^ c;
            c = c - d | 0;
            d = d << 24 ^ d >>> 8 ^ a;
            a = a - b | 0;
            me.b = b = b << 20 ^ b >>> 12 ^ c;
            me.c = c = c - d | 0;
            me.d = d << 16 ^ c >>> 16 ^ a;
            return me.a = a - b | 0;
        };
        /* The following is non-inverted tyche, which has better internal
   * bit diffusion, but which is about 25% slower than tyche-i in JS.
  me.next = function() {
    var a = me.a, b = me.b, c = me.c, d = me.d;
    a = (me.a + me.b | 0) >>> 0;
    d = me.d ^ a; d = d << 16 ^ d >>> 16;
    c = me.c + d | 0;
    b = me.b ^ c; b = b << 12 ^ d >>> 20;
    me.a = a = a + b | 0;
    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
    me.c = c = c + d | 0;
    b = b ^ c;
    return me.b = (b << 7 ^ b >>> 25);
  }
  */ me.a = 0;
        me.b = 0;
        me.c = -1640531527;
        me.d = 1367130551;
        if (seed === Math.floor(seed)) {
            // Integer seed.
            me.a = seed / 0x100000000 | 0;
            me.b = seed | 0;
        } else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 20; k++){
            me.b ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.a = f.a;
        t.b = f.b;
        t.c = f.c;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.tychei = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("izYfB", function(module, exports) {

$parcel$export(module.exports, "Tephigramme", () => Tephigramme);
$parcel$export(module.exports, "Tephi_reference_points", () => Tephi_reference_points);
$parcel$export(module.exports, "Tephi_control", () => Tephi_control);
parcelRequire("iMQia");
var $kAvwT = parcelRequire("kAvwT");
var $l7VLp = parcelRequire("l7VLp");
var $dIG9p = parcelRequire("dIG9p");
var $inIMS = parcelRequire("inIMS");
var $bdrRp = parcelRequire("bdrRp");
var $3xcD3 = parcelRequire("3xcD3");
var $5ydre = parcelRequire("5ydre");
var $bnthu = parcelRequire("bnthu");
var $lrKvI = parcelRequire("lrKvI");
var $c3RIb = parcelRequire("c3RIb");
var $iMQia = parcelRequire("iMQia");
var $cJntk = parcelRequire("cJntk");
class Tephigramme {
    constructor(tephi_map, mapping_solftware, tephi_control, version){
        this.tephi_map = tephi_map;
        this.mapping_solftware = mapping_solftware;
        this.tephi_control = tephi_control;
        this.version = version;
        this.cappa = 0.2854912179500E+00;
        this.tcdk = 0.2731500000000E+03;
        this.p0theta = 1000.;
        this.ni = 3300;
        this.nj = 2550;
        //this.ni=parseInt(document.getElementById(tephi_map).style.width);
        //this.nj=parseInt(document.getElementById(tephi_map).style.height);      
        this.group_list = [];
        this.fcstind = 0;
        this.lat = 0.;
        this.lon = 0.;
        this.nhours = 0;
        this.stop = 0;
        this.dateo = new Date();
        this.datev = new Date();
        this.profile_features_list = [];
        this.deg2rad = (0, $kAvwT.pi) / 180.;
        this.etalon = 20;
        // The scaling_factor is zero for minzoom and 1.0 for maxzoom.
        this.scaling_factor = 0;
        this.set_scaling_factor();
        this.ray = 7 - 4 * (1. - this.scaling_factor);
    }
    add_reference_points(gg, tmin, tmax) {
        gg.slops();
        gg.tmin = tmin;
        gg.tmax = tmax;
        this.group_list.push(gg);
    }
    plot_reference_lines(gg) {
        var ii = this.ni;
        if (this.mapping_solftware == "Leaflet") {
            // Tracer la ligne de reference de temperature
            var jj = gg.p0.j + gg.pt * (ii - gg.p0.i);
            var polyline = L.polyline([
                [
                    gg.p0.j,
                    gg.p0.i
                ],
                [
                    jj,
                    ii
                ]
            ], {
                color: 'red',
                weight: 1
            }).addTo(this.map);
            // Tracer le ligne de reference de theta vers la droite
            var jj = gg.p0.j + gg.pf * (ii - gg.p0.i);
            var polyline = L.polyline([
                [
                    gg.p0.j,
                    gg.p0.i
                ],
                [
                    jj,
                    ii
                ]
            ], {
                color: 'red',
                weight: 1
            }).addTo(this.map);
            // Tracer la ligne de reference de theta vers la gauche
            ii = 0;
            jj = gg.p0.j + gg.pf * (ii - gg.p0.i);
            var polyline = L.polyline([
                [
                    gg.p0.j,
                    gg.p0.i
                ],
                [
                    jj,
                    ii
                ]
            ], {
                color: 'blue',
                weight: 1
            }).addTo(this.map);
        } else if (this.mapping_solftware == "OpenLayers") {
            // Tracer la ligne de reference de temperature
            var jj = gg.p0.j + gg.pt * (ii - gg.p0.i);
            var trash = trash = this.segment([
                [
                    gg.p0.i,
                    gg.p0.j
                ],
                [
                    ii,
                    jj
                ]
            ]);
            // Tracer le ligne de reference de theta vers la droite
            var jj = gg.p0.j + gg.pf * (ii - gg.p0.i);
            trash = this.segment([
                [
                    gg.p0.i,
                    gg.p0.j
                ],
                [
                    ii,
                    jj
                ]
            ]);
            // Tracer la ligne de reference de theta vers la gauche
            ii = 0;
            jj = gg.p0.j + gg.pf * (ii - gg.p0.i);
            trash = this.segment([
                [
                    gg.p0.i,
                    gg.p0.j
                ],
                [
                    ii,
                    jj
                ]
            ]);
        }
    }
    set_scaling_factor() {
        // fraction is 0 at minzoom and one at maxzoom
        this.scaling_factor = ((0, $iMQia.tephi_map_maxzoom) - this.tephi_map.getView().getZoom()) / ((0, $iMQia.tephi_map_maxzoom) - (0, $iMQia.tephi_map_minzoom));
    }
    reqListener() {
        //alert('dans reqListener');
        if (this.readyState == XMLHttpRequest.DONE) {
            //alert(this.status);
            if (this.status == 200) {
                this.myJson = eval(this.responseText);
                //alert(this.myJson);
                if (this.myJson.status != 'OK') //alert(this.myJson.status);
                alert('ERREUR : ' + this.myJson.status);
                this.plot_json_data(this.myJson);
            } else alert('Probleme avec la requete RDPS : ' + this.status + this.responseText);
        }
    }
    plot_profile_wms(p0, diag, temp, pres, nom_variabale, color = 'red') {
        var width = 1 + 1.5 * (1. - this.scaling_factor);
        var count = 0;
        var last_level_plotted;
        if (pres[0] >= p0) {
            alert("Le point le plus haut du profil de " + nom_variabale + " est \xe0 " + pres[0] + " hPa, ce qui est sous la surface qui a une pression de " + Math.ceil(p0) + " hPa.\nVeillez \xe0 mettre un niveau au-dessus de la surface pour le profile de " + nom_variabale);
            return;
        }
        for(var k = 0; k < temp.length; k++){
            //if pressure is below surface we don't plot it.
            if (pres[k] <= p0) {
                last_level_plotted = pres[k];
                var ijp = this.temp_pres_to_i_j(temp[k], pres[k]);
                //L.circle(ijp, {radius: 5, color: color, weight: 1.}).addTo(this.map);
                //this.profile_features_list.push(this.ol_circle(ijp,color,width,this.ray));
                //this.profile_features_list.push(this.ol_circle(ijp,'black',width,2*this.ray));
                this.profile_features_list.push(this.ol_circle(ijp, color, width, this.ray));
                count;
                //myLayerGroup.addLayer(L.circle(ijp, {radius: 5, color: color, weight: 1.}));
                if (count != 0) //this.polyline = L.polyline([ijm,ijp], {color: color, weight: 1}).addTo(this.map);
                //myLayerGroup.addLayer(L.polyline([ijm,ijp], {color: color, weight: 1}))
                this.profile_features_list.push(this.segment([
                    ijm,
                    ijp
                ], color, width));
                count++;
            }
            var ijm = ijp;
        }
        // Plot diag point ?
        // If there is one or more levels between p0 et the last levels plotted then
        // we don't plot the diag level.
        // Find index of last_level_plotted in tephi_control.levels list
        var ind;
        for(let i = 0; i < this.tephi_control.levels.length; i++)if (this.tephi_control.levels[i] > last_level_plotted) {
            ind = i;
            break;
        }
        if (ind < this.tephi_control.levels.length - 1) {
            if (this.tephi_control.levels[ind + 1] < p0) return;
        }
        var ijp = this.temp_pres_to_i_j(diag, p0);
        //this.profile_features_list.push(this.ol_circle(ijp,'black',width,2*this.ray));
        this.profile_features_list.push(this.ol_circle(ijp, color, width, this.ray));
        this.profile_features_list.push(this.segment([
            ijm,
            ijp
        ], color, width));
    //myLayerGroup.addTo(this.map);
    //return myLayerGroup;
    }
    plot_GZ_profile_wms(p0, diag, data, pres, T_imax, p_imax, color = 'black') {
        for(var k = -1; k < data.length; k++){
            var gz_val;
            var pp;
            var offset = 0;
            var extra = '';
            var space_for_wind = 0;
            if (this.tephi_control.id_height_agl.checked) offset = diag;
            if (k == -1) {
                gz_val = diag - offset;
                pp = p0;
            } else {
                gz_val = data[k] - offset;
                pp = pres[k];
            }
            //If pressure is below surface we don't plot it.
            if (pp >= p0 && k != -1) continue;
            // Trouver la Temperature sur la droite verticale sur le tephi qui passe par
            // le point (T_imax, p_imax)
            var TT = this.get_T_on_vertical_line_at_p(T_imax + 3., pp, T_imax + 3., p_imax);
            var ijc = this.temp_pres_to_i_j(TT, pp);
            var textAdjust = 'left';
            if (pp == p0) extra = ' niveau du sol ';
            if (this.tephi_control.id_wind.checked) space_for_wind = 5 * this.etalon * this.scaling_factor;
            if (this.tephi_control.id_plot_wind_val.checked) space_for_wind = space_for_wind + 5 * this.etalon * this.scaling_factor;
            var ijm = [
                ijc[0] - .1 + space_for_wind,
                ijc[1]
            ];
            var ijp = [
                ijc[0] + .1 + space_for_wind,
                ijc[1]
            ];
            this.profile_features_list.push(this.segment_text([
                ijm,
                ijp
            ], " " + (0, $kAvwT.round)(gz_val).toString() + ' m ' + extra, textAdjust));
        }
    }
    plot_winds_wms(p0, wind_module_diag, wind_module, wind_dir_diag, wind_dir, pres, i_max, T_imax, p_imax, color = 'black') {
        // This code is an adaptation of R code git@gitlab.com:toutoumeteo/R_tephi.git
        //
        //
        //
        //    
        //     |   \   \
        //    wy0   \   \
        //     |     \wxd\
        //           -------------
        //      ->| w |<-         ijc
        //          x 
        //          0
        //
        var ijm = 0;
        var ijp = 0;
        var ij3 = 0;
        var corp = this.etalon + 2 * this.etalon * this.scaling_factor;
        var width = 1 + 2 * (1. - this.scaling_factor);
        var alpha = 0.;
        var wx0 = 0.15 * corp;
        var wy0 = -0.25 * corp;
        var wxd = .17 * corp;
        var xx = wx0;
        var total = 0;
        var nb_50 = 0;
        var nb_10 = 0;
        var nb_5 = 0;
        var ijc;
        var cosa = 0.;
        var sina = 0.;
        var xx = corp;
        var yy = 0;
        var module = 0;
        var dir = -1;
        var pp = -1;
        for(var k = -1; k < wind_dir.length; k++){
            if (k == -1) {
                module = wind_module_diag;
                dir = wind_dir_diag;
                pp = p0;
            } else {
                module = wind_module[k];
                dir = wind_dir[k];
                pp = pres[k];
            }
            //If pressure is below surface we don't plot it.
            if (pp >= p0 && k != -1) continue;
            total = 0;
            // Trouver la Temperature sur la droite verticale sur le tephi qui passe par
            // le point (T_imax, p_imax)
            var TT = this.get_T_on_vertical_line_at_p(T_imax + 3., pp, T_imax + 3., p_imax);
            ijc = this.temp_pres_to_i_j(TT, pp);
            //ijc[0]=i_max+corp+wx0*1.2+this.ray;
            //ijc[0]=i_max;
            alpha = this.deg2rad * (270 - dir);
            cosa = (0, $kAvwT.cos)(alpha);
            sina = (0, $kAvwT.sin)(alpha);
            // Draw 50 knots flags
            nb_50 = (0, $kAvwT.floor)(module / 50);
            if (nb_50 > 0) for(var i = 0; i < nb_50; i++){
                xx = corp - i * wxd;
                yy = 0;
                // Apply rotation matrix
                ijm = [
                    ijc[0] - (xx * cosa - yy * sina),
                    ijc[1] - (xx * sina + yy * cosa)
                ];
                xx = corp + wx0 - i * wxd;
                yy = wy0;
                // Apply rotation matrix
                ijp = [
                    ijc[0] - (xx * cosa - yy * sina),
                    ijc[1] - (xx * sina + yy * cosa)
                ];
                xx = corp - i * wxd - .85 * wxd;
                yy = 0;
                // Apply rotation matrix
                ij3 = [
                    ijc[0] - (xx * cosa - yy * sina),
                    ijc[1] - (xx * sina + yy * cosa)
                ];
                this.profile_features_list.push(this.segment([
                    ijm,
                    ijp
                ], color, width));
                this.profile_features_list.push(this.segment([
                    ijp,
                    ij3
                ], color, width));
                //this.profile_features_list.push(this.filled_triangle([ijm,ijp,ij3]));
                total = total + 50;
            }
            // draw 10 knots barbs                  
            nb_10 = (0, $kAvwT.floor)((module - total) / 10.);
            for(var i = 0; i < nb_10; i++){
                xx = corp - nb_50 * wxd - i * wxd;
                yy = 0;
                // Apply rotation matrix
                ijm = [
                    ijc[0] - (xx * cosa - yy * sina),
                    ijc[1] - (xx * sina + yy * cosa)
                ];
                xx = xx + wx0;
                yy = wy0;
                // Apply rotation matrix
                ijp = [
                    ijc[0] - (xx * cosa - yy * sina),
                    ijc[1] - (xx * sina + yy * cosa)
                ];
                this.profile_features_list.push(this.segment([
                    ijm,
                    ijp
                ], color, width));
                total = total + 10;
            }
            if (module - total >= 2.5) {
                if (nb_50 + nb_10 == 0) xx = corp - wxd;
                else xx = corp - (nb_50 + nb_10 - 1) * wxd - wxd;
                yy = 0;
                // Apply rotation matrix
                ijm = [
                    ijc[0] - (xx * cosa - yy * sina),
                    ijc[1] - (xx * sina + yy * cosa)
                ];
                xx = xx + wx0 / 2.;
                yy = wy0 / 2.;
                // Apply rotation matrix
                ijp = [
                    ijc[0] - (xx * cosa - yy * sina),
                    ijc[1] - (xx * sina + yy * cosa)
                ];
                this.profile_features_list.push(this.segment([
                    ijm,
                    ijp
                ], color, width));
            }
            if (module > 2.5) {
                // Corp de la barbule
                ijp = [
                    ijc[0] - corp * cosa,
                    ijc[1] - corp * sina
                ];
                this.profile_features_list.push(this.segment([
                    ijc,
                    ijp
                ], color, width));
            } else this.profile_features_list.push(this.ol_circle(ijc, color, width, corp * .15));
            // Did not find plain text in openlayers. Must draw a very short line one pixel long and
            // put text on it. To best hide point, put segment ponts on each side of centre point ijc
            ijm = [
                ijc[0] - .1,
                ijc[1]
            ];
            ijp = [
                ijc[0] + .1,
                ijc[1]
            ];
            var textAdjust = 'left';
            if (dir < 180) textAdjust = 'right';
            if (this.tephi_control.id_plot_wind_val.checked) this.profile_features_list.push(this.segment_text([
                ijm,
                ijp
            ], " " + (0, $kAvwT.round)(module).toString() + ' kts ', textAdjust));
        }
    }
    get_T_on_vertical_line_at_p(T_trial, pres, T_imax, p_imax) {
        // The following points define the slope of vertical lines on the tephi
        const T0 = 16. + this.tcdk;
        const lntheta0 = (0, $kAvwT.log)(290.);
        const T1 = -58 + this.tcdk;
        const lntheta1 = (0, $kAvwT.log)(415.);
        const slope = (T1 - T0) / (lntheta1 - lntheta0);
        // Define the vertical line passing by point t_imax, p_imax    
        const bb = T_imax + this.tcdk - slope * (0, $kAvwT.log)(this.theta_from_temp_pres(T_imax, p_imax));
        // Iteration de Newton-Raphson 
        var TTm = T_trial + this.tcdk;
        var TTp;
        for(let i = 0; i < 100; i++){
            // Fonction to find the zero of
            var ff = slope * (0, $kAvwT.log)(this.theta_from_temp_pres(TTm - this.tcdk, pres)) - TTm + bb;
            // Its derivative
            var fp = slope / TTm - 1.;
            TTp = TTm - ff / fp;
            if ((0, $kAvwT.abs)(TTp - TTm) < 0.1) break;
            TTm = TTp;
        }
        return TTp - this.tcdk;
    }
    clear_profile() {
        for(var i = 0; i < this.profile_features_list.length; i++)this.profile_features_list[i].clear();
    }
    //redraw_profile(){
    //  for (var i = 0; i < this.profile_features_list.length; i++){
    //    this.profile_features_list[i].redraw();
    //  }
    //}
    remove_all_layers(map) {
        map.removeLayer(this.temp_profile);
        map.removeLayer(this.td_profile);
    //map.eachLayer(function (layer) {
    //  map.removeLayer(layer);
    //});
    //this.map.eachLayer(function(layer){
    //  layer.removeLayer();
    //});
    //for(var i = 0; i < this.mapMarkers.length; i++){
    //  this.map.removeLayer(this.mapMarkers[i]);
    //}
    }
    theta_from_temp_pres(temp, pres) {
        return (temp + this.tcdk) * (0, $kAvwT.pow)(this.p0theta / pres, this.cappa);
    }
    pres_from_temp_theta(temp, theta) {
        return this.p0theta * (0, $kAvwT.pow)((temp + this.tcdk) / theta, 1. / this.cappa);
    }
    temp_theta_to_i_j(temp, theta) {
        return this.temp_phi_to_i_j(temp, (0, $kAvwT.log)(theta));
    }
    temp_pres_to_i_j(temp, pres) {
        return this.temp_phi_to_i_j(temp, (0, $kAvwT.log)((temp + this.tcdk) * (0, $kAvwT.pow)(this.p0theta / pres, this.cappa)));
    }
    temp_phi_to_i_j(temp, phi) {
        // Loop on refernce point to find which one supports actual temperature
        // TODO handle error if temp do not fit in anay points group.
        var found = 0;
        for(var k = 0; k < this.group_list.length; k++){
            var g = this.group_list[k];
            if (temp > g.tmin && temp <= g.tmax) {
                found = 1;
                var pp_t = temp;
                // Calul de phi=ln(theta)
                var pp_f = phi;
                //Trouver le point ii,jj sur l'isotherme defini par g.p0 et g.p1 ou f = pp_f
                var ii = g.p0.i + (g.p1.i - g.p0.i) / (g.p1.f - g.p0.f) * (pp_f - g.p0.f);
                var jj = g.p0.j + (g.p1.j - g.p0.j) / (g.p1.f - g.p0.f) * (pp_f - g.p0.f);
                //var sol = L.latLng([ jj, ii]);
                //L.marker(sol).addTo(this.map);
                // A partir de ce point suivre theta constant jusqua pp_t
                ii = ii + (g.p2.i - g.p0.i) / (g.p2.t - g.p0.t) * (pp_t - g.p0.t);
                jj = jj + (g.p2.j - g.p0.j) / (g.p2.t - g.p0.t) * (pp_t - g.p0.t);
                //var sol = L.latLng([ jj, ii]);
                //L.marker(sol).addTo(this.map);
                if (this.mapping_software == "Leaflet") return [
                    jj,
                    ii
                ];
                else return [
                    ii,
                    jj
                ];
            }
        }
        if (found == 0) {
            alert("No point group fits temperature or td");
            return [
                0,
                0
            ];
        }
    }
    plot_point(temp, pres) {
        L.marker(L.latLng(this.temp_pres_to_i_j(temp, pres))).addTo(this.map);
    }
    plot_point_t_theta(temp, theta) {
        L.marker(L.latLng(this.temp_theta_to_i_j(temp, theta))).addTo(this.map);
    }
    plot_control_points() {
        // To validate tephi positioning plot control points
        for(var temp = -60; temp <= 40; temp = temp + 5)for(var pres = 1050; pres >= 300; pres = pres - 50)//L.marker(L.latLng(this.temp_pres_to_i_j(temp,pres))).addTo(this.map);
        var trash = this.ol_circle(this.temp_pres_to_i_j(temp, pres));
        for(var temp = -80; temp <= -30; temp = temp + 5)for(var pres = 250; pres >= 100; pres = pres - 10)//L.marker(L.latLng(this.temp_pres_to_i_j(temp,pres))).addTo(this.map);
        trash = this.ol_circle(this.temp_pres_to_i_j(temp, pres));
    }
    inc_hr() {
        this.fcstind++;
        if (this.fcstind >= this.nhours) this.fcstind = 0;
        this.plot_json_data();
        document.getElementById('id_fcst').selectedIndex = this.fcstind;
    }
    dec_hr() {
        this.fcstind--;
        if (this.fcstind < 0) this.fcstind = this.nhours - 1;
        document.getElementById('id_fcst').selectedIndex = this.fcstind;
        this.plot_json_data();
    }
    // add optional argument offserY with default to 0
    segment_text(points, text, textAlign) {
        var text_size = 10 + 20 * (1. - this.scaling_factor);
        var style = new (0, $c3RIb.default)({
            stroke: new (0, $lrKvI.default)({
                color: 'Black',
                width: 1
            }),
            // Ne marche pas :
            //backgroundFill: new Fill({
            //  color: 'white'
            //}),
            text: new (0, $cJntk.default)({
                textAlign: textAlign,
                font: text_size + 'px sans-serif',
                text: text
            })
        });
        var featureLine = new (0, $dIG9p.default)({
            geometry: new (0, $3xcD3.default)(points)
        });
        featureLine.setStyle(style);
        //featureLine.getStyle().getText().setText('new content');
        //featureLine.setText(text);
        var sourceLine = new (0, $bnthu.default)({
            features: [
                featureLine
            ]
        });
        var vectorLine = new (0, $bdrRp.default)({
            source: sourceLine
        });
        this.tephi_map.addLayer(vectorLine);
        return sourceLine;
    }
    segment(points, color = 'red', width = 1) {
        var style = new (0, $c3RIb.default)({
            stroke: new (0, $lrKvI.default)({
                color: color,
                width: width
            })
        });
        var featureLine = new (0, $dIG9p.default)({
            geometry: new (0, $3xcD3.default)(points)
        });
        featureLine.setStyle(style);
        var sourceLine = new (0, $bnthu.default)({
            features: [
                featureLine
            ]
        });
        var vectorLine = new (0, $bdrRp.default)({
            source: sourceLine
        });
        this.tephi_map.addLayer(vectorLine);
        return sourceLine;
    }
    filled_triangle(points, color = 'black') {
        var style = new (0, $c3RIb.default)({
            stroke: new (0, $lrKvI.default)({
                color: color,
                width: 1
            }),
            fill: new (0, $inIMS.default)({
                color: color
            })
        });
        var featurePoly = new (0, $dIG9p.default)({
            geometry: new (0, $5ydre.default)(points)
        });
        featurePoly.setStyle(style);
        var sourcePoly = new (0, $bnthu.default)({
            features: [
                featurePoly
            ]
        });
        var vectorPoly = new (0, $bdrRp.default)({
            source: sourcePoly
        });
        this.tephi_map.addLayer(vectorPoly);
        return sourcePoly;
    }
    ol_circle(point, color = 'red', width = 1, ray = 7) {
        var style = new (0, $c3RIb.default)({
            stroke: new (0, $lrKvI.default)({
                color: color,
                width: width
            })
        });
        var featureCircle = new (0, $dIG9p.default)({
            geometry: new (0, $l7VLp.default)(point, ray)
        });
        featureCircle.setStyle(style);
        var sourceCircle = new (0, $bnthu.default)({
            features: [
                featureCircle
            ]
        });
        var vectorCircle = new (0, $bdrRp.default)({
            source: sourceCircle
        });
        this.tephi_map.addLayer(vectorCircle);
        return sourceCircle;
    }
}
class Tephi_point {
    constructor(t, f, i, j){
        this.t = t;
        this.f = (0, $kAvwT.log)(f);
        this.i = i;
        this.j = j;
    }
}
class Tephi_reference_points {
    // The reference lines are difined by points p0, p1 and p2
    // To plot these in the thephi use method plot_reference_lines()
    // Example for isotherme -30 C and adiabatic 310 K
    //
    //           p1
    //      
    //       -30C
    //      
    //    p0
    //
    //      theta=310
    //
    //               p2
    //
    // Note tha point p2 may be positioned on the other side
    // of isotherme like in the following figure
    //
    //           p2            p1
    //      
    //                     -30 C
    //         theta=310
    //                   p0
    //
    constructor(t0, f0, i0, j0, t1, f1, i1, j1, t2, f2, i2, j2){
        this.p0 = new Tephi_point(t0, f0, i0, j0);
        this.p1 = new Tephi_point(t1, f1, i1, j1);
        this.p2 = new Tephi_point(t2, f2, i2, j2);
        this.tmin = -100;
        this.tmax = 50.;
    }
    slops() {
        if ((0, $kAvwT.abs)(this.p0.f - this.p2.f) / this.p0.f > 1.e-4) alert("Tephi_reference_points theta value should be the same for p0 and p2 but are not. Please review construction oj objects Tephi_reference_points");
        // Calcul de la pente des isothermes sur la carte
        this.pt = (this.p1.j - this.p0.j) / (this.p1.i - this.p0.i);
        // En pricipe this.pf = 1/this.pt mais le scanner introduit une legere distortion dans l'hortogonalite.
        this.pf = (this.p2.j - this.p0.j) / (this.p2.i - this.p0.i);
    }
}
class Tephi_control {
    constructor({ id_plot_wind = null, id_model = null, id_datev_message = null, id_datev_menu = null, id_temp = null, id_T_max_level = null, id_T_min_level = null, id_td = null, id_Td_max_level = null, id_Td_min_level = null, id_wind = null, id_V_max_level = null, id_V_min_level = null, id_message = null, id_plot_wind_val = null, id_height_no = null, id_height_agl = null, id_height_asl = null, id_product_displayed = null, levels = null }){
        this.id_plot_wind = id_plot_wind;
        this.id_model = id_model, this.id_datev_message = id_datev_message;
        this.id_datev_menu = id_datev_menu;
        this.id_datev_menu = id_datev_menu;
        this.id_temp = id_temp;
        this.id_T_max_level = id_T_max_level;
        this.id_T_min_level = id_T_min_level;
        this.id_td = id_td;
        this.id_Td_max_level = id_Td_max_level;
        this.id_Td_min_level = id_Td_min_level;
        this.id_wind = id_wind;
        this.id_V_max_level = id_V_max_level;
        this.id_V_min_level = id_V_min_level;
        this.id_message = id_message;
        this.id_plot_wind_val = id_plot_wind_val;
        this.id_height_no = id_height_no;
        this.id_height_agl = id_height_agl;
        this.id_height_asl = id_height_asl;
        this.id_product_displayed = id_product_displayed;
        this.levels = levels;
        this.cook_life = 100;
    }
    get_model() {
        return this.id_model.options[this.id_model.selectedIndex].value;
    }
    get_datev_menu_value() {
        return this.id_datev_menu.options[this.id_datev_menu.selectedIndex].value;
    }
    get_datev_menu_text() {
        return this.id_datev_menu.options[this.id_datev_menu.selectedIndex].text;
    }
    init_from_cookies() {
        var model_ind = this.lit_cook('tephi_id_model_ind');
        if (model_ind != "") this.id_model.selectedIndex = model_ind;
        var id_temp_checked = this.lit_cook('tephi_id_temp_checked');
        if (id_temp_checked == "") // Check T by default
        this.id_temp.checked = true;
        else {
            var value = false;
            if (id_temp_checked == 'T') value = true;
            this.id_temp.checked = value;
        }
        var id_td_checked = this.lit_cook('tephi_id_td_checked');
        if (id_td_checked == "") // Check Td by default
        this.id_td.checked = true;
        else {
            var value = false;
            if (id_td_checked == 'T') value = true;
            this.id_td.checked = value;
        }
        var id_wind_checked = this.lit_cook('tephi_id_wind_checked');
        if (id_wind_checked == "") this.id_wind.checked = false;
        else {
            var value = false;
            if (id_wind_checked == 'T') value = true;
            this.id_wind.checked = value;
        }
        var id_plot_wind_val_checked = this.lit_cook('tephi_id_plot_wind_val_checked');
        if (id_plot_wind_val_checked == "") this.id_plot_wind_val.checked = false;
        else {
            var value = false;
            if (id_plot_wind_val_checked == 'T') value = true;
            this.id_plot_wind_val.checked = value;
        }
        var id_height_no_checked = this.lit_cook('tephi_id_height_no_checked');
        if (id_height_no_checked == "") this.id_height_no.checked = false;
        else {
            var value = false;
            if (id_height_no_checked == 'T') value = true;
            this.id_height_no.checked = value;
        }
        var id_height_agl_checked = this.lit_cook('tephi_id_height_agl_checked');
        if (id_height_agl_checked == "") this.id_height_agl.checked = false;
        else {
            var value = false;
            if (id_height_agl_checked == 'T') value = true;
            this.id_height_agl.checked = value;
        }
        // If none is checked, default is no height
        if (!this.id_height_no.checked && !this.id_height_agl.checked && !this.id_height_asl.checked) this.id_height_no.checked = true;
        var id_height_asl_checked = this.lit_cook('tephi_id_height_asl_checked');
        if (id_height_asl_checked == "") this.id_height_asl.checked = false;
        else {
            var value = false;
            if (id_height_asl_checked == 'T') value = true;
            this.id_height_asl.checked = value;
        }
        var id_T_max_level_ind = this.lit_cook('tephi_id_T_max_level_ind');
        if (id_T_max_level_ind != "") this.id_T_max_level.selectedIndex = id_T_max_level_ind;
        var id_T_min_level_ind = this.lit_cook('tephi_id_T_min_level_ind');
        if (id_T_min_level_ind != "") this.id_T_min_level.selectedIndex = id_T_min_level_ind;
        var id_Td_max_level_ind = this.lit_cook('tephi_id_Td_max_level_ind');
        if (id_Td_max_level_ind != "") this.id_Td_max_level.selectedIndex = id_Td_max_level_ind;
        var id_Td_min_level_ind = this.lit_cook('tephi_id_Td_min_level_ind');
        if (id_Td_min_level_ind != "") this.id_Td_min_level.selectedIndex = id_Td_min_level_ind;
        var id_V_max_level_ind = this.lit_cook('tephi_id_V_max_level_ind');
        if (id_V_max_level_ind != "") this.id_V_max_level.selectedIndex = id_V_max_level_ind;
        var id_V_min_level_ind = this.lit_cook('tephi_id_V_min_level_ind');
        if (id_V_min_level_ind != "") this.id_V_min_level.selectedIndex = id_V_min_level_ind;
    }
    set_cook_from_id(id) {
        // Note a switch case dod not work with string!
        if (id == "id_model") this.cre_cook('tephi_id_model_ind', this.id_model.selectedIndex);
        else if (id == "id_temp") {
            var value = 'F';
            if (this.id_temp.checked) value = 'T';
            this.cre_cook('tephi_id_temp_checked', value);
        } else if (id == "id_td") {
            var value = 'F';
            if (this.id_td.checked) value = 'T';
            this.cre_cook('tephi_id_td_checked', value);
        } else if (id == "id_wind") {
            var value = 'F';
            if (this.id_wind.checked) value = 'T';
            this.cre_cook('tephi_id_wind_checked', value);
        } else if (id == "id_plot_wind_val") {
            var value = 'F';
            if (this.id_plot_wind_val.checked) value = 'T';
            this.cre_cook('tephi_id_plot_wind_val_checked', value);
        } else if (id == "id_height_no") {
            var value = 'F';
            if (this.id_height_no.checked) {
                value = 'T';
                this.cre_cook('tephi_id_height_agl_checked', 'F');
                this.cre_cook('tephi_id_height_asl_checked', 'F');
            }
            this.cre_cook('tephi_id_height_no_checked', value);
        } else if (id == "id_height_agl") {
            var value = 'F';
            if (this.id_height_agl.checked) {
                value = 'T';
                this.cre_cook('tephi_id_height_no_checked', 'F');
                this.cre_cook('tephi_id_height_asl_checked', 'F');
            }
            this.cre_cook('tephi_id_height_agl_checked', value);
        } else if (id == "id_height_asl") {
            var value = 'F';
            if (this.id_height_asl.checked) {
                value = 'T';
                this.cre_cook('tephi_id_height_no_checked', 'F');
                this.cre_cook('tephi_id_height_agl_checked', 'F');
            }
            this.cre_cook('tephi_id_height_asl_checked', value);
        } else if (id == 'id_T_max_level') this.cre_cook('tephi_id_T_max_level_ind', this.id_T_max_level.selectedIndex);
        else if (id == 'id_T_min_level') this.cre_cook('tephi_id_T_min_level_ind', this.id_T_min_level.selectedIndex);
        else if (id == 'id_Td_max_level') this.cre_cook('tephi_id_Td_max_level_ind', this.id_Td_max_level.selectedIndex);
        else if (id == 'id_Td_min_level') this.cre_cook('tephi_id_Td_min_level_ind', this.id_Td_min_level.selectedIndex);
        else if (id == 'id_V_max_level') this.cre_cook('tephi_id_V_max_level_ind', this.id_V_max_level.selectedIndex);
        else if (id == 'id_V_min_level') this.cre_cook('tephi_id_V_min_level_ind', this.id_V_min_level.selectedIndex);
        else alert("Internal error in class Tephi_control, please add id " + id + " to switch case");
    }
    cre_cook(nom, contenu) {
        var jours = 100;
        var expireDate = new Date();
        expireDate.setTime(expireDate.getTime() + jours * 86400000);
        document.cookie = nom + "=" + escape(contenu) + ";expires=" + expireDate.toGMTString() + ";path=/;SameSite=None;secure";
    }
    lit_cook(nom) {
        var deb, fin;
        deb = document.cookie.indexOf(nom + "=");
        if (deb >= 0) {
            deb += nom.length + 1;
            fin = document.cookie.indexOf(";", deb);
            if (fin < 0) fin = document.cookie.length;
            return unescape(document.cookie.substring(deb, fin));
        }
        return "";
    }
    check_td_levels() {
        if (!this.id_td.checked) return;
        if (!this.id_temp.checked) {
            alert("Vous devez cocher la variable temp\xe9rature pour avoir le point de ros\xe9e");
            this.id_temp.checked = true;
        }
        var message = "";
        var p1 = this.get_pres_val(this.id_Td_max_level);
        var p2 = this.get_pres_val(this.id_T_max_level);
        if (p1 > p2) {
            message = "Le niveaux le plus bas de Td doit \xeatre \xe9gal ou au-dessus de celui de T.";
            this.id_Td_max_level.selectedIndex = this.id_T_max_level.selectedIndex;
        }
        var p1 = this.get_pres_val(this.id_Td_min_level);
        var p2 = this.get_pres_val(this.id_T_min_level);
        if (p1 < p2) {
            message = message + "Le niveaux le plus haut de Td doit \xe9gal ou sous celui de T.";
            this.id_Td_min_level.selectedIndex = this.id_T_min_level.selectedIndex;
        }
        if (message != "") {
            alert(message);
            return;
        }
        return;
    }
    get_pres_val(id_menu) {
        var pp = id_menu.options[id_menu.selectedIndex].value;
        if (pp == "Surface") return 2000;
        else return parseInt(pp);
    }
}

});
parcelRegister("iMQia", function(module, exports) {

$parcel$export(module.exports, "tephi_map_minzoom", () => $dad545c909cfec2d$export$ee397303aec5eecb);
$parcel$export(module.exports, "tephi_map_maxzoom", () => $dad545c909cfec2d$export$6154bdbec96a1fc9);
$parcel$export(module.exports, "mytephi", () => $dad545c909cfec2d$export$675953c4a50f82e2);
$parcel$export(module.exports, "Feature", () => (parcelRequire("dIG9p")).default);
$parcel$export(module.exports, "LineString", () => (parcelRequire("3xcD3")).default);
$parcel$export(module.exports, "Polygon", () => (parcelRequire("5ydre")).default);
$parcel$export(module.exports, "sourceVector", () => (parcelRequire("bnthu")).default);
$parcel$export(module.exports, "layerVector", () => (parcelRequire("bdrRp")).default);
$parcel$export(module.exports, "Circle", () => (parcelRequire("l7VLp")).default);
$parcel$export(module.exports, "Fill", () => (parcelRequire("inIMS")).default);
$parcel$export(module.exports, "Stroke", () => (parcelRequire("lrKvI")).default);
$parcel$export(module.exports, "Style", () => (parcelRequire("c3RIb")).default);
$parcel$export(module.exports, "Text", () => (parcelRequire("cJntk")).default);
$parcel$export(module.exports, "log", () => (parcelRequire("kAvwT")).log);
$parcel$export(module.exports, "abs", () => (parcelRequire("kAvwT")).abs);
$parcel$export(module.exports, "round", () => (parcelRequire("kAvwT")).round);
$parcel$export(module.exports, "pow", () => (parcelRequire("kAvwT")).pow);
$parcel$export(module.exports, "sin", () => (parcelRequire("kAvwT")).sin);
$parcel$export(module.exports, "cos", () => (parcelRequire("kAvwT")).cos);
$parcel$export(module.exports, "pi", () => (parcelRequire("kAvwT")).pi);
$parcel$export(module.exports, "floor", () => (parcelRequire("kAvwT")).floor);


var $1Kugc = parcelRequire("1Kugc");

var $9qhtr = parcelRequire("9qhtr");

var $dpRHA = parcelRequire("dpRHA");

var $cmeSF = parcelRequire("cmeSF");

var $dIG9p = parcelRequire("dIG9p");
var $5DwXE = parcelRequire("5DwXE");
var $9DiKA = parcelRequire("9DiKA");


var $4mWlF = parcelRequire("4mWlF");

var $9jDAx = parcelRequire("9jDAx");

var $hi5Ai = parcelRequire("hi5Ai");

var $2o3CH = parcelRequire("2o3CH");

var $fVglf = parcelRequire("fVglf");
var $f3WAG = parcelRequire("f3WAG");

var $bnthu = parcelRequire("bnthu");

var $bdrRp = parcelRequire("bdrRp");

var $3xcD3 = parcelRequire("3xcD3");

var $5ydre = parcelRequire("5ydre");

var $l7VLp = parcelRequire("l7VLp");

var $inIMS = parcelRequire("inIMS");
var $lrKvI = parcelRequire("lrKvI");
var $c3RIb = parcelRequire("c3RIb");
var $cJntk = parcelRequire("cJntk");

var $kAvwT = parcelRequire("kAvwT");

var $izYfB = parcelRequire("izYfB");

var $dBOsW = parcelRequire("dBOsW");

var $hCh95 = parcelRequire("hCh95");
const $dad545c909cfec2d$var$levels = [
    100,
    150,
    175,
    200,
    225,
    250,
    275,
    300,
    350,
    400,
    450,
    500,
    550,
    600,
    650,
    700,
    750,
    800,
    850,
    875,
    900,
    925,
    950,
    970,
    985,
    1000,
    1015
];
const $dad545c909cfec2d$var$message_datev = "Date validit&eacute, le menu sera mise a jour apr&egrave;s la selection du mod&egrave;le";
document.getElementById('hamburger').onclick = function() {
    document.getElementById("mySidenav").style.width = "250px";
    document.getElementById("main").style.marginLeft = "250px";
};
document.getElementById("x_to_close_side").onclick = function() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("main").style.marginLeft = "0";
};
// Map views always need a projection.  Here we just want to map image
// coordinates directly to map coordinates, so we create a projection that uses
// the image extent in pixels.
var $dad545c909cfec2d$var$extent = [
    0,
    0,
    3300,
    2550
];
var $dad545c909cfec2d$var$projection = new (0, $9qhtr.default)({
    code: 'xkcd-image',
    units: 'pixels',
    extent: $dad545c909cfec2d$var$extent
});
var $dad545c909cfec2d$var$mousePositionControl = new (0, $hi5Ai.default)({
    coordinateFormat: (0, $2o3CH.createStringXY)(4),
    projection: $dad545c909cfec2d$var$projection,
    // comment the following two lines to have the mouse position
    // be placed within the map.
    //className: 'custom-mouse-position',
    //target: document.getElementById('tephi'),
    undefinedHTML: '&nbsp;'
});
var $dad545c909cfec2d$export$ee397303aec5eecb = 2;
var $dad545c909cfec2d$export$6154bdbec96a1fc9 = 5;
var $dad545c909cfec2d$var$tephi_map = new (0, $5DwXE.default)({
    controls: (0, $f3WAG.defaults)().extend([
        $dad545c909cfec2d$var$mousePositionControl
    ]),
    layers: [
        new (0, $1Kugc.default)({
            source: new (0, $cmeSF.default)({
                url: 'https://imeteo.ca/html/images/tephi_complet_20_dpi.jpg',
                projection: $dad545c909cfec2d$var$projection,
                imageExtent: $dad545c909cfec2d$var$extent
            })
        })
    ],
    target: 'id_tephi',
    view: new (0, $9DiKA.default)({
        projection: $dad545c909cfec2d$var$projection,
        center: [
            2500,
            500
        ],
        zoom: 3,
        minZoom: $dad545c909cfec2d$export$ee397303aec5eecb,
        maxZoom: $dad545c909cfec2d$export$6154bdbec96a1fc9
    })
});
const $dad545c909cfec2d$var$map = new (0, $5DwXE.default)({
    target: 'map',
    layers: [
        new (0, $4mWlF.default)({
            source: new (0, $9jDAx.default)()
        })
    ],
    view: new (0, $9DiKA.default)({
        // Zoom over sourthern Quebec.
        center: (0, $dpRHA.fromLonLat)([
            -74,
            45.
        ]),
        zoom: 6
    })
});
var $dad545c909cfec2d$var$tephi_control = new $izYfB.Tephi_control({
    id_plot_wind: document.getElementById('id_plot_wind'),
    id_model: document.querySelector('.id_model'),
    id_datev_message: document.getElementById('id_datev_message'),
    id_datev_menu: document.getElementById('id_datev_menu'),
    id_temp: document.getElementById('id_temp'),
    id_T_max_level: document.getElementById('id_T_max_level'),
    id_T_min_level: document.getElementById('id_T_min_level'),
    id_td: document.getElementById('id_td'),
    id_Td_max_level: document.getElementById('id_Td_max_level'),
    id_Td_min_level: document.getElementById('id_Td_min_level'),
    id_wind: document.getElementById('id_wind'),
    id_V_max_level: document.getElementById('id_V_max_level'),
    id_V_min_level: document.getElementById('id_V_min_level'),
    id_message: document.getElementById('id_message'),
    id_plot_wind_val: document.getElementById('id_plot_wind_val'),
    id_height_no: document.getElementById('id_height_no'),
    id_height_agl: document.getElementById('id_height_agl'),
    id_height_asl: document.getElementById('id_height_asl'),
    id_product_displayed: document.getElementById('id_product_displayed'),
    levels: $dad545c909cfec2d$var$levels
});
var $dad545c909cfec2d$export$675953c4a50f82e2 = new $izYfB.Tephigramme($dad545c909cfec2d$var$tephi_map, 'OpenLayers', $dad545c909cfec2d$var$tephi_control, 'https://imeteo.ca/imeteo');
var $dad545c909cfec2d$var$markers = new (0, $hCh95.GridPointMarkers)($dad545c909cfec2d$var$map);
var $dad545c909cfec2d$var$wms_req = new $dBOsW.WMS_request($dad545c909cfec2d$var$tephi_control, $dad545c909cfec2d$var$levels, $dad545c909cfec2d$var$markers);
// Bouton "Effacer les points passés", affiché sur la carte sous le zoom
// +/- (même emplacement/style que les contrôles OpenLayers standards),
// en plus de celui de la barre latérale.
class $dad545c909cfec2d$var$ClearPastControl extends (0, $fVglf.default) {
    constructor(opt_options){
        var options = opt_options || {};
        var button = document.createElement('button');
        button.innerHTML = '&#128465;';
        button.title = "Effacer les points pass\xe9s";
        var element = document.createElement('div');
        element.className = 'clear-past-control ol-unselectable ol-control';
        element.appendChild(button);
        super({
            element: element,
            target: options.target
        });
        button.addEventListener('click', ()=>$dad545c909cfec2d$var$wms_req.clear_past());
    }
}
$dad545c909cfec2d$var$map.addControl(new $dad545c909cfec2d$var$ClearPastControl());
// Make mytephi available in index.html
window.mytephi = $dad545c909cfec2d$export$675953c4a50f82e2;
var $dad545c909cfec2d$var$g1 = new $izYfB.Tephi_reference_points(0., 290., 2314.05, 368.6, 0., 350., 2877.7, 1008.5, 20., 290., 2605.3, 110.9);
$dad545c909cfec2d$export$675953c4a50f82e2.add_reference_points($dad545c909cfec2d$var$g1, -15, 500.);
//mytephi.plot_reference_lines(g1);
var $dad545c909cfec2d$var$g2 = new $izYfB.Tephi_reference_points(-30, 310., 2075.8, 981.7, -30, 440., 3125.8, 2176.7, -65, 310., 1566.9, 1433.1);
$dad545c909cfec2d$export$675953c4a50f82e2.add_reference_points($dad545c909cfec2d$var$g2, -40, -15);
//mytephi.plot_reference_lines(g2);
var $dad545c909cfec2d$var$g3 = new $izYfB.Tephi_reference_points(-50, 320., 1880.5, 1347.9, -50, 410., 2623.7, 2193.2, -75, 320., 1516.9, 1669.6);
$dad545c909cfec2d$export$675953c4a50f82e2.add_reference_points($dad545c909cfec2d$var$g3, -100, -40);
//mytephi.plot_reference_lines(g3);
//mytephi.plot_control_points();
//mytephi.segment_text([[2000,1000],[2100,1000]]);
//var temp=[10.,5.0,0.,];
//var td=[8.,5.0,-10.,];
//var levs=[1000.,850.0,700.,];
//mytephi.plot_profile(temp,levs,'red');
//mytephi.plot_profile(td,levs,'blue');
//var levs     = [1000,  950,  900,  850,  800,  750,  700,  650,  600,  550,  500,  450,  400,  350,  300,  250,  200];
//var force    = [   0,    5,   10,   15,   20,   25,   30,   35,   40,   45,   50,   55,   60,  100,  155,  235,  300];
//var wind_dir = [   0, 22.5, 45.0, 67.5, 90.0,112.5,135.0,157.5,180.0,202.5,225.0,247.5,270.0,292.5,315.0,337.5,360.0];
//mytephi.plot_winds(force,wind_dir,levs,20.,'black');
var $dad545c909cfec2d$var$hasSelectedPoint = false;
var $dad545c909cfec2d$var$pendingMarker = null;
// Un seul marqueur temporaire à la fois : si un point précédent n'a jamais
// déclenché de requête (ex. point restauré au chargement, puis l'utilisateur
// clique ailleurs avant de choisir une date), son cercle resterait sinon
// affiché indéfiniment sur la carte.
function $dad545c909cfec2d$var$setPendingMarker(lonLat) {
    if ($dad545c909cfec2d$var$pendingMarker) $dad545c909cfec2d$var$pendingMarker.clear();
    $dad545c909cfec2d$var$pendingMarker = $dad545c909cfec2d$var$markers.pending(lonLat);
    return $dad545c909cfec2d$var$pendingMarker;
}
$dad545c909cfec2d$var$map.on('click', function(evt) {
    $dad545c909cfec2d$export$675953c4a50f82e2.clear_profile();
    var coords = (0, $dpRHA.toLonLat)(evt.coordinate);
    $dad545c909cfec2d$var$wms_req.lat = coords[1];
    $dad545c909cfec2d$var$wms_req.lon = coords[0];
    if ($dad545c909cfec2d$export$675953c4a50f82e2.tephi_control.get_model() == "UNDEF") {
        alert("Vous devez choisir un mod\xe8le avec le menu en haut \xe0 gauche");
        return;
    }
    $dad545c909cfec2d$var$wms_req.model = $dad545c909cfec2d$export$675953c4a50f82e2.tephi_control.get_model();
    $dad545c909cfec2d$var$wms_req.tephi_control.cre_cook('lat', $dad545c909cfec2d$var$wms_req.lat);
    $dad545c909cfec2d$var$wms_req.tephi_control.cre_cook('lon', $dad545c909cfec2d$var$wms_req.lon);
    $dad545c909cfec2d$var$hasSelectedPoint = true;
    $dad545c909cfec2d$var$setPendingMarker([
        $dad545c909cfec2d$var$wms_req.lon,
        $dad545c909cfec2d$var$wms_req.lat
    ]);
    $dad545c909cfec2d$var$wms_req.get_data($dad545c909cfec2d$var$pendingMarker);
});
var $dad545c909cfec2d$var$currZoom = $dad545c909cfec2d$var$tephi_map.getView().getZoom();
$dad545c909cfec2d$var$tephi_map.on('moveend', function(e) {
    var newZoom = $dad545c909cfec2d$var$tephi_map.getView().getZoom();
    if ($dad545c909cfec2d$var$currZoom != newZoom) //alert('zoom end, new zoom: ' + newZoom);
    $dad545c909cfec2d$var$currZoom = newZoom;
});
window.addEventListener('load', (event)=>{
    $dad545c909cfec2d$var$wms_req.tephi_control.id_datev_message.innerHTML = $dad545c909cfec2d$var$message_datev;
    $dad545c909cfec2d$var$build_level_menu("id_T_max_level", true);
    $dad545c909cfec2d$var$build_level_menu("id_Td_max_level", true);
    $dad545c909cfec2d$var$build_level_menu("id_V_max_level", true);
    $dad545c909cfec2d$var$build_level_menu("id_T_min_level");
    $dad545c909cfec2d$var$build_level_menu("id_Td_min_level");
    $dad545c909cfec2d$var$build_level_menu("id_V_min_level");
    for(let i = 0; i < $dad545c909cfec2d$var$levels.length; i++){
        if ($dad545c909cfec2d$var$levels[i] <= 600) document.getElementById("id_T_min_level").selectedIndex = i;
        if ($dad545c909cfec2d$var$levels[i] <= 600) document.getElementById("id_Td_min_level").selectedIndex = i;
        if ($dad545c909cfec2d$var$levels[i] <= 600) document.getElementById("id_V_min_level").selectedIndex = i;
    }
    document.getElementById("id_T_max_level").selectedIndex = $dad545c909cfec2d$var$levels.length;
    document.getElementById("id_Td_max_level").selectedIndex = $dad545c909cfec2d$var$levels.length;
    document.getElementById("id_V_max_level").selectedIndex = $dad545c909cfec2d$var$levels.length;
    var lat = $dad545c909cfec2d$var$wms_req.tephi_control.lit_cook('lat');
    var lon = $dad545c909cfec2d$var$wms_req.tephi_control.lit_cook('lon');
    if (lat != "" && lon != "") {
        $dad545c909cfec2d$var$wms_req.lat = lat;
        $dad545c909cfec2d$var$wms_req.lon = lon;
        $dad545c909cfec2d$var$hasSelectedPoint = true;
        $dad545c909cfec2d$var$setPendingMarker([
            lon,
            lat
        ]);
    } else {
        lat = 45.;
        lon = -74;
    }
    $dad545c909cfec2d$var$map.getView().setCenter((0, $dpRHA.fromLonLat)([
        parseFloat(lon),
        parseFloat(lat)
    ]));
    $dad545c909cfec2d$var$wms_req.tephi_control.init_from_cookies();
    $dad545c909cfec2d$var$wms_req.model = $dad545c909cfec2d$var$tephi_control.get_model();
    $dad545c909cfec2d$var$wms_req.get_fcst_dates(lat, lon);
    $dad545c909cfec2d$var$tephi_control.id_datev_message.innerHTML = $dad545c909cfec2d$var$wms_req.model + ", DateV ";
});
function $dad545c909cfec2d$var$build_level_menu(id, sfc = false) {
    const menu = document.getElementById(id);
    var list = [
        ...$dad545c909cfec2d$var$levels
    ];
    if (sfc) list.push('Surface');
    for(let i = 0; i < list.length; i++){
        let option = document.createElement("option");
        option.setAttribute('value', list[i]);
        let unit = " hPa";
        if (list[i] == 'Surface') unit = "";
        let optionText = document.createTextNode(list[i] + unit);
        option.appendChild(optionText);
        menu.appendChild(option);
    }
}
document.querySelector('.id_model').addEventListener('change', (event)=>{
    if (event.target.value == "UNDEF") {
        $dad545c909cfec2d$var$wms_req.clear_datev_menu();
        $dad545c909cfec2d$var$wms_req.tephi_control.id_datev_message.innerHTML = $dad545c909cfec2d$var$message_datev;
    } else {
        $dad545c909cfec2d$var$wms_req.tephi_control.set_cook_from_id('id_model');
        id_datev_message.innerHTML = event.target.value + ", DateV ";
        var lat = $dad545c909cfec2d$var$wms_req.tephi_control.lit_cook('lat');
        var lon = $dad545c909cfec2d$var$wms_req.tephi_control.lit_cook('lon');
        if (lat != "" && lon != "") {
            $dad545c909cfec2d$var$wms_req.lat = lat;
            $dad545c909cfec2d$var$wms_req.lon = lon;
            $dad545c909cfec2d$var$hasSelectedPoint = true;
            $dad545c909cfec2d$var$setPendingMarker([
                lon,
                lat
            ]);
        } else {
            lat = 45.;
            lon = -70;
        }
        $dad545c909cfec2d$var$wms_req.get_fcst_dates(lat, lon);
    }
});
document.getElementById('id_clear_past').addEventListener('click', function() {
    $dad545c909cfec2d$var$wms_req.clear_past();
});
// I tried to put this in a look with an array, but it dd not work.
document.getElementById('id_temp').addEventListener('change', (event)=>{
    $dad545c909cfec2d$var$wms_req.tephi_control.check_td_levels();
    $dad545c909cfec2d$var$wms_req.tephi_control.set_cook_from_id('id_temp');
});
document.getElementById('id_td').addEventListener('change', (event)=>{
    $dad545c909cfec2d$var$wms_req.tephi_control.check_td_levels();
    $dad545c909cfec2d$var$wms_req.tephi_control.set_cook_from_id('id_td');
});
document.getElementById('id_wind').addEventListener('change', (event)=>{
    $dad545c909cfec2d$var$wms_req.tephi_control.set_cook_from_id('id_wind');
});
document.getElementById('id_plot_wind_val').addEventListener('change', (event)=>{
    $dad545c909cfec2d$var$wms_req.tephi_control.set_cook_from_id('id_plot_wind_val');
});
document.getElementById('id_height_no').addEventListener('change', (event)=>{
    $dad545c909cfec2d$var$wms_req.tephi_control.set_cook_from_id('id_height_no');
});
document.getElementById('id_height_agl').addEventListener('change', (event)=>{
    $dad545c909cfec2d$var$wms_req.tephi_control.set_cook_from_id('id_height_agl');
});
document.getElementById('id_height_asl').addEventListener('change', (event)=>{
    $dad545c909cfec2d$var$wms_req.tephi_control.set_cook_from_id('id_height_asl');
});
document.getElementById('id_T_max_level').addEventListener('change', (event)=>{
    $dad545c909cfec2d$var$wms_req.tephi_control.check_td_levels();
    $dad545c909cfec2d$var$wms_req.tephi_control.set_cook_from_id('id_T_max_level');
});
document.getElementById('id_T_min_level').addEventListener('change', (event)=>{
    $dad545c909cfec2d$var$wms_req.tephi_control.check_td_levels();
    $dad545c909cfec2d$var$wms_req.tephi_control.set_cook_from_id('id_T_min_level');
});
document.getElementById('id_Td_max_level').addEventListener('change', (event)=>{
    $dad545c909cfec2d$var$wms_req.tephi_control.check_td_levels();
    $dad545c909cfec2d$var$wms_req.tephi_control.set_cook_from_id('id_Td_max_level');
});
document.getElementById('id_Td_min_level').addEventListener('change', (event)=>{
    $dad545c909cfec2d$var$wms_req.tephi_control.check_td_levels();
    $dad545c909cfec2d$var$wms_req.tephi_control.set_cook_from_id('id_Td_min_level');
});
document.getElementById('id_V_max_level').addEventListener('change', (event)=>{
    $dad545c909cfec2d$var$wms_req.tephi_control.set_cook_from_id('id_V_max_level');
});
document.getElementById('id_V_min_level').addEventListener('change', (event)=>{
    $dad545c909cfec2d$var$wms_req.tephi_control.set_cook_from_id('id_V_min_level');
});
document.getElementById('id_datev_menu').addEventListener("change", function() {
    if (!$dad545c909cfec2d$var$hasSelectedPoint) {
        alert('Choisir un point sur la carte');
        return;
    }
    $dad545c909cfec2d$var$wms_req.get_data($dad545c909cfec2d$var$pendingMarker);
});
document.getElementById('id_dec_datev').addEventListener("click", function() {
    if (!$dad545c909cfec2d$var$hasSelectedPoint) {
        alert('Choisir un point sur la carte');
        return;
    }
    var id_inc = document.getElementById('id_datev_increment');
    var delta = parseInt(id_inc[id_inc.selectedIndex].value);
    var datev_menu = document.getElementById('id_datev_menu');
    var ind = datev_menu.selectedIndex - delta;
    $dad545c909cfec2d$var$wms_req.model = $dad545c909cfec2d$export$675953c4a50f82e2.tephi_control.get_model();
    if (ind < 0) ind = datev_menu.length - 1;
    datev_menu.selectedIndex = ind;
    $dad545c909cfec2d$var$wms_req.get_data($dad545c909cfec2d$var$pendingMarker);
});
document.getElementById('id_inc_datev').addEventListener("click", function() {
    if (!$dad545c909cfec2d$var$hasSelectedPoint) {
        alert('Choisir un point sur la carte');
        return;
    }
    var id_inc = document.getElementById('id_datev_increment');
    var delta = parseInt(id_inc[id_inc.selectedIndex].value);
    var datev_menu = document.getElementById('id_datev_menu');
    var ind = datev_menu.selectedIndex + delta;
    $dad545c909cfec2d$var$wms_req.model = $dad545c909cfec2d$export$675953c4a50f82e2.tephi_control.get_model();
    if (ind >= datev_menu.length) ind = 0;
    datev_menu.selectedIndex = ind;
    $dad545c909cfec2d$var$wms_req.get_data($dad545c909cfec2d$var$pendingMarker);
});

});
parcelRegister("1Kugc", function(module, exports) {

$parcel$export(module.exports, "default", () => $14618f63634d34fc$export$2e2bcd8739ae039);
/**
 * @module ol/layer/Image
 */ 
var $hU3iK = parcelRequire("hU3iK");

var $4yJW3 = parcelRequire("4yJW3");
/**
 * @classdesc
 * Server-rendered images that are available for arbitrary extents and
 * resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Image.js").default} ImageSourceType
 * @extends {BaseImageLayer<ImageSourceType, CanvasImageLayerRenderer>}
 * @api
 */ class $14618f63634d34fc$var$ImageLayer extends (0, $4yJW3.default) {
    /**
   * @param {import("./BaseImage.js").Options<ImageSourceType>} [options] Layer options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $hU3iK.default)(this);
    }
    /**
   * Get data for a pixel location.  A four element RGBA array will be returned.  For requests outside the
   * layer extent, `null` will be returned.  Data for an image can only be retrieved if the
   * source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   * @override
   */ getData(pixel) {
        return super.getData(pixel);
    }
}
var $14618f63634d34fc$export$2e2bcd8739ae039 = $14618f63634d34fc$var$ImageLayer;

});
parcelRegister("hU3iK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d08a3a38b8c630d8$export$2e2bcd8739ae039);
/**
 * @module ol/renderer/canvas/ImageLayer
 */ 
var $aSvtr = parcelRequire("aSvtr");

var $aKuSF = parcelRequire("aKuSF");

var $9pD6L = parcelRequire("9pD6L");

var $dpRHA = parcelRequire("dpRHA");

var $jpXrt = parcelRequire("jpXrt");

var $5FKVH = parcelRequire("5FKVH");
/**
 * @classdesc
 * Canvas renderer for image layers.
 * @api
 */ class $d08a3a38b8c630d8$var$CanvasImageLayerRenderer extends (0, $5FKVH.default) {
    /**
   * @param {import("../../layer/Image.js").default} imageLayer Image layer.
   */ constructor(imageLayer){
        super(imageLayer);
        /**
     * @protected
     * @type {?import("../../Image.js").default}
     */ this.image = null;
        /**
     * @private
     * @type {number}
     */ this.renderedSourceRevision_ = 0;
    }
    /**
   * @return {import('../../DataTile.js').ImageLike} Image.
   */ getImage() {
        return !this.image ? null : this.image.getImage();
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const pixelRatio = frameState.pixelRatio;
        const viewState = frameState.viewState;
        const viewResolution = viewState.resolution;
        const imageSource = this.getLayer().getSource();
        const hints = frameState.viewHints;
        let renderedExtent = frameState.extent;
        if (layerState.extent !== undefined) renderedExtent = (0, $9pD6L.getIntersection)(renderedExtent, (0, $dpRHA.fromUserExtent)(layerState.extent, viewState.projection));
        if (!hints[(0, $aKuSF.default).ANIMATING] && !hints[(0, $aKuSF.default).INTERACTING] && !(0, $9pD6L.isEmpty)(renderedExtent)) {
            if (imageSource) {
                if (!this.getLayer().rendered && this.renderedSourceRevision_ !== imageSource.getRevision()) this.image = null;
                this.renderedSourceRevision_ = imageSource.getRevision();
                const projection = viewState.projection;
                const image = imageSource.getImage(renderedExtent, viewResolution, pixelRatio, projection);
                if (image) {
                    if (this.loadImage(image)) this.image = image;
                    else if (image.getState() === (0, $aSvtr.default).EMPTY) this.image = null;
                }
            } else this.image = null;
        }
        return !!this.image;
    }
    /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray} Data at the pixel location.
   * @override
   */ getData(pixel) {
        const frameState = this.frameState;
        if (!frameState) return null;
        const layer = this.getLayer();
        const coordinate = (0, $jpXrt.apply)(frameState.pixelToCoordinateTransform, pixel.slice());
        const layerExtent = layer.getExtent();
        if (layerExtent) {
            if (!(0, $9pD6L.containsCoordinate)(layerExtent, coordinate)) return null;
        }
        const imageExtent = this.image.getExtent();
        const img = this.image.getImage();
        const imageMapWidth = (0, $9pD6L.getWidth)(imageExtent);
        const col = Math.floor(img.width * ((coordinate[0] - imageExtent[0]) / imageMapWidth));
        if (col < 0 || col >= img.width) return null;
        const imageMapHeight = (0, $9pD6L.getHeight)(imageExtent);
        const row = Math.floor(img.height * ((imageExtent[3] - coordinate[1]) / imageMapHeight));
        if (row < 0 || row >= img.height) return null;
        return this.getImageData(img, col, row);
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        const image = this.image;
        const imageExtent = image.getExtent();
        const imageResolution = image.getResolution();
        const [imageResolutionX, imageResolutionY] = Array.isArray(imageResolution) ? imageResolution : [
            imageResolution,
            imageResolution
        ];
        const imagePixelRatio = image.getPixelRatio();
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const pixelRatio = frameState.pixelRatio;
        const viewState = frameState.viewState;
        const viewCenter = viewState.center;
        const viewResolution = viewState.resolution;
        const scaleX = pixelRatio * imageResolutionX / (viewResolution * imagePixelRatio);
        const scaleY = pixelRatio * imageResolutionY / (viewResolution * imagePixelRatio);
        this.prepareContainer(frameState, target);
        // desired dimensions of the canvas in pixels
        const width = this.context.canvas.width;
        const height = this.context.canvas.height;
        const context = this.getRenderContext(frameState);
        // clipped rendering if layer extent is set
        let clipped = false;
        let render = true;
        if (layerState.extent) {
            const layerExtent = (0, $dpRHA.fromUserExtent)(layerState.extent, viewState.projection);
            render = (0, $9pD6L.intersects)(layerExtent, frameState.extent);
            clipped = render && !(0, $9pD6L.containsExtent)(layerExtent, frameState.extent);
            if (clipped) this.clipUnrotated(context, frameState, layerExtent);
        }
        const img = image.getImage();
        const transform = (0, $jpXrt.compose)(this.tempTransform, width / 2, height / 2, scaleX, scaleY, 0, imagePixelRatio * (imageExtent[0] - viewCenter[0]) / imageResolutionX, imagePixelRatio * (viewCenter[1] - imageExtent[3]) / imageResolutionY);
        this.renderedResolution = imageResolutionY * pixelRatio / imagePixelRatio;
        const dw = img.width * transform[0];
        const dh = img.height * transform[3];
        if (!this.getLayer().getSource().getInterpolate()) context.imageSmoothingEnabled = false;
        this.preRender(context, frameState);
        if (render && dw >= 0.5 && dh >= 0.5) {
            const dx = transform[4];
            const dy = transform[5];
            const opacity = layerState.opacity;
            if (opacity !== 1) {
                context.save();
                context.globalAlpha = opacity;
            }
            context.drawImage(img, 0, 0, +img.width, +img.height, dx, dy, dw, dh);
            if (opacity !== 1) context.restore();
        }
        this.postRender(this.context, frameState);
        if (clipped) context.restore();
        context.imageSmoothingEnabled = true;
        return this.container;
    }
}
var $d08a3a38b8c630d8$export$2e2bcd8739ae039 = $d08a3a38b8c630d8$var$CanvasImageLayerRenderer;

});
parcelRegister("aSvtr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eb75c96a6b6f2c6$export$2e2bcd8739ae039);
/**
 * @module ol/ImageState
 */ /**
 * @enum {number}
 */ var $7eb75c96a6b6f2c6$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    ERROR: 3,
    EMPTY: 4
};

});

parcelRegister("aKuSF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d362782b4ccb93d$export$2e2bcd8739ae039);
/**
 * @module ol/ViewHint
 */ /**
 * @enum {number}
 */ var $7d362782b4ccb93d$export$2e2bcd8739ae039 = {
    ANIMATING: 0,
    INTERACTING: 1
};

});

parcelRegister("9pD6L", function(module, exports) {

$parcel$export(module.exports, "boundingExtent", () => $6da4c8ed3074c92b$export$8aceca7c77505534);
$parcel$export(module.exports, "createEmpty", () => $6da4c8ed3074c92b$export$fe201bb3bbe031e9);
$parcel$export(module.exports, "extendCoordinate", () => $6da4c8ed3074c92b$export$1f820e3920fa5715);
$parcel$export(module.exports, "createOrUpdate", () => $6da4c8ed3074c92b$export$958e3e1a02eac4b6);
$parcel$export(module.exports, "buffer", () => $6da4c8ed3074c92b$export$ab1029bcae9ddb4a);
$parcel$export(module.exports, "clone", () => $6da4c8ed3074c92b$export$9cd59f9826255e47);
$parcel$export(module.exports, "closestSquaredDistanceXY", () => $6da4c8ed3074c92b$export$cbe64c389534206f);
$parcel$export(module.exports, "containsCoordinate", () => $6da4c8ed3074c92b$export$ac68c24d37ca240f);
$parcel$export(module.exports, "containsXY", () => $6da4c8ed3074c92b$export$805bdfd6d6690e97);
$parcel$export(module.exports, "containsExtent", () => $6da4c8ed3074c92b$export$be866b1e0809b17e);
$parcel$export(module.exports, "coordinateRelationship", () => $6da4c8ed3074c92b$export$f97905ead28c61a8);
$parcel$export(module.exports, "createOrUpdateEmpty", () => $6da4c8ed3074c92b$export$3e2152b047719fa1);
$parcel$export(module.exports, "createOrUpdateFromCoordinate", () => $6da4c8ed3074c92b$export$4838bf78d04a9440);
$parcel$export(module.exports, "createOrUpdateFromFlatCoordinates", () => $6da4c8ed3074c92b$export$be0ab0bf96ca59ca);
$parcel$export(module.exports, "extendFlatCoordinates", () => $6da4c8ed3074c92b$export$30570204156ffd18);
$parcel$export(module.exports, "equals", () => $6da4c8ed3074c92b$export$e9bab7fafb253603);
$parcel$export(module.exports, "extend", () => $6da4c8ed3074c92b$export$8b58be045bf06082);
$parcel$export(module.exports, "forEachCorner", () => $6da4c8ed3074c92b$export$f9ed8a3d123a08e2);
$parcel$export(module.exports, "getBottomLeft", () => $6da4c8ed3074c92b$export$8d09f5e2e1bf560d);
$parcel$export(module.exports, "getBottomRight", () => $6da4c8ed3074c92b$export$e77c1cf70445e168);
$parcel$export(module.exports, "getTopRight", () => $6da4c8ed3074c92b$export$b84fa077c8b05295);
$parcel$export(module.exports, "getTopLeft", () => $6da4c8ed3074c92b$export$cb1538b07e6964ff);
$parcel$export(module.exports, "getArea", () => $6da4c8ed3074c92b$export$520c40045967cb15);
$parcel$export(module.exports, "isEmpty", () => $6da4c8ed3074c92b$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "getWidth", () => $6da4c8ed3074c92b$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "getHeight", () => $6da4c8ed3074c92b$export$c08559766941f856);
$parcel$export(module.exports, "getCenter", () => $6da4c8ed3074c92b$export$c91255cadecfe081);
$parcel$export(module.exports, "getCorner", () => $6da4c8ed3074c92b$export$a1cfd206661d0801);
$parcel$export(module.exports, "getForViewAndSize", () => $6da4c8ed3074c92b$export$13ba650faf8308);
$parcel$export(module.exports, "getRotatedViewport", () => $6da4c8ed3074c92b$export$4b7a6fb4002cd6ac);
$parcel$export(module.exports, "getIntersection", () => $6da4c8ed3074c92b$export$72209efa88586d42);
$parcel$export(module.exports, "intersects", () => $6da4c8ed3074c92b$export$7b0a31e10bbff018);
$parcel$export(module.exports, "returnOrUpdate", () => $6da4c8ed3074c92b$export$6a4fe494c558c238);
$parcel$export(module.exports, "intersectsSegment", () => $6da4c8ed3074c92b$export$a6a5a7a461419425);
$parcel$export(module.exports, "applyTransform", () => $6da4c8ed3074c92b$export$9f9dcb98c894b623);
$parcel$export(module.exports, "wrapX", () => $6da4c8ed3074c92b$export$39a9ce3624977b84);
$parcel$export(module.exports, "wrapAndSliceX", () => $6da4c8ed3074c92b$export$9031237f01de0947);
/**
 * @module ol/extent
 */ 
var $iM9A6 = parcelRequire("iM9A6");
function $6da4c8ed3074c92b$export$8aceca7c77505534(coordinates) {
    const extent = $6da4c8ed3074c92b$export$fe201bb3bbe031e9();
    for(let i = 0, ii = coordinates.length; i < ii; ++i)$6da4c8ed3074c92b$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
/**
 * @param {Array<number>} xs Xs.
 * @param {Array<number>} ys Ys.
 * @param {Extent} [dest] Destination extent.
 * @private
 * @return {Extent} Extent.
 */ function $6da4c8ed3074c92b$var$_boundingExtentXYs(xs, ys, dest) {
    const minX = Math.min.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxX = Math.max.apply(null, xs);
    const maxY = Math.max.apply(null, ys);
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest);
}
function $6da4c8ed3074c92b$export$ab1029bcae9ddb4a(extent, value, dest) {
    if (dest) {
        dest[0] = extent[0] - value;
        dest[1] = extent[1] - value;
        dest[2] = extent[2] + value;
        dest[3] = extent[3] + value;
        return dest;
    }
    return [
        extent[0] - value,
        extent[1] - value,
        extent[2] + value,
        extent[3] + value
    ];
}
function $6da4c8ed3074c92b$export$9cd59f9826255e47(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent.slice();
}
function $6da4c8ed3074c92b$export$cbe64c389534206f(extent, x, y) {
    let dx, dy;
    if (x < extent[0]) dx = extent[0] - x;
    else if (extent[2] < x) dx = x - extent[2];
    else dx = 0;
    if (y < extent[1]) dy = extent[1] - y;
    else if (extent[3] < y) dy = y - extent[3];
    else dy = 0;
    return dx * dx + dy * dy;
}
function $6da4c8ed3074c92b$export$ac68c24d37ca240f(extent, coordinate) {
    return $6da4c8ed3074c92b$export$805bdfd6d6690e97(extent, coordinate[0], coordinate[1]);
}
function $6da4c8ed3074c92b$export$be866b1e0809b17e(extent1, extent2) {
    return extent1[0] <= extent2[0] && extent2[2] <= extent1[2] && extent1[1] <= extent2[1] && extent2[3] <= extent1[3];
}
function $6da4c8ed3074c92b$export$805bdfd6d6690e97(extent, x, y) {
    return extent[0] <= x && x <= extent[2] && extent[1] <= y && y <= extent[3];
}
function $6da4c8ed3074c92b$export$f97905ead28c61a8(extent, coordinate) {
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const x = coordinate[0];
    const y = coordinate[1];
    let relationship = (0, $iM9A6.default).UNKNOWN;
    if (x < minX) relationship = relationship | (0, $iM9A6.default).LEFT;
    else if (x > maxX) relationship = relationship | (0, $iM9A6.default).RIGHT;
    if (y < minY) relationship = relationship | (0, $iM9A6.default).BELOW;
    else if (y > maxY) relationship = relationship | (0, $iM9A6.default).ABOVE;
    if (relationship === (0, $iM9A6.default).UNKNOWN) relationship = (0, $iM9A6.default).INTERSECTING;
    return relationship;
}
function $6da4c8ed3074c92b$export$fe201bb3bbe031e9() {
    return [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
}
function $6da4c8ed3074c92b$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest) {
    if (dest) {
        dest[0] = minX;
        dest[1] = minY;
        dest[2] = maxX;
        dest[3] = maxY;
        return dest;
    }
    return [
        minX,
        minY,
        maxX,
        maxY
    ];
}
function $6da4c8ed3074c92b$export$3e2152b047719fa1(dest) {
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(Infinity, Infinity, -Infinity, -Infinity, dest);
}
function $6da4c8ed3074c92b$export$4838bf78d04a9440(coordinate, dest) {
    const x = coordinate[0];
    const y = coordinate[1];
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(x, y, x, y, dest);
}
function $6da4c8ed3074c92b$export$29e3ad4dbd0cb863(coordinates, dest) {
    const extent = $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    return $6da4c8ed3074c92b$export$795cd48be4d5f252(extent, coordinates);
}
function $6da4c8ed3074c92b$export$be0ab0bf96ca59ca(flatCoordinates, offset, end, stride, dest) {
    const extent = $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    return $6da4c8ed3074c92b$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride);
}
function $6da4c8ed3074c92b$export$73b4897e93bc5c83(rings, dest) {
    const extent = $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    return $6da4c8ed3074c92b$export$9b319549574402d7(extent, rings);
}
function $6da4c8ed3074c92b$export$e9bab7fafb253603(extent1, extent2) {
    return extent1[0] == extent2[0] && extent1[2] == extent2[2] && extent1[1] == extent2[1] && extent1[3] == extent2[3];
}
function $6da4c8ed3074c92b$export$998afeab28643bd6(extent1, extent2, tolerance) {
    return Math.abs(extent1[0] - extent2[0]) < tolerance && Math.abs(extent1[2] - extent2[2]) < tolerance && Math.abs(extent1[1] - extent2[1]) < tolerance && Math.abs(extent1[3] - extent2[3]) < tolerance;
}
function $6da4c8ed3074c92b$export$8b58be045bf06082(extent1, extent2) {
    if (extent2[0] < extent1[0]) extent1[0] = extent2[0];
    if (extent2[2] > extent1[2]) extent1[2] = extent2[2];
    if (extent2[1] < extent1[1]) extent1[1] = extent2[1];
    if (extent2[3] > extent1[3]) extent1[3] = extent2[3];
    return extent1;
}
function $6da4c8ed3074c92b$export$1f820e3920fa5715(extent, coordinate) {
    if (coordinate[0] < extent[0]) extent[0] = coordinate[0];
    if (coordinate[0] > extent[2]) extent[2] = coordinate[0];
    if (coordinate[1] < extent[1]) extent[1] = coordinate[1];
    if (coordinate[1] > extent[3]) extent[3] = coordinate[1];
}
function $6da4c8ed3074c92b$export$795cd48be4d5f252(extent, coordinates) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i)$6da4c8ed3074c92b$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
function $6da4c8ed3074c92b$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride) {
    for(; offset < end; offset += stride)$6da4c8ed3074c92b$export$f1dab130b92b85a9(extent, flatCoordinates[offset], flatCoordinates[offset + 1]);
    return extent;
}
function $6da4c8ed3074c92b$export$9b319549574402d7(extent, rings) {
    for(let i = 0, ii = rings.length; i < ii; ++i)$6da4c8ed3074c92b$export$795cd48be4d5f252(extent, rings[i]);
    return extent;
}
function $6da4c8ed3074c92b$export$f1dab130b92b85a9(extent, x, y) {
    extent[0] = Math.min(extent[0], x);
    extent[1] = Math.min(extent[1], y);
    extent[2] = Math.max(extent[2], x);
    extent[3] = Math.max(extent[3], y);
}
function $6da4c8ed3074c92b$export$f9ed8a3d123a08e2(extent, callback) {
    let val;
    val = callback($6da4c8ed3074c92b$export$8d09f5e2e1bf560d(extent));
    if (val) return val;
    val = callback($6da4c8ed3074c92b$export$e77c1cf70445e168(extent));
    if (val) return val;
    val = callback($6da4c8ed3074c92b$export$b84fa077c8b05295(extent));
    if (val) return val;
    val = callback($6da4c8ed3074c92b$export$cb1538b07e6964ff(extent));
    if (val) return val;
    return false;
}
function $6da4c8ed3074c92b$export$520c40045967cb15(extent) {
    let area = 0;
    if (!$6da4c8ed3074c92b$export$dd1bc94b04021eeb(extent)) area = $6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) * $6da4c8ed3074c92b$export$c08559766941f856(extent);
    return area;
}
function $6da4c8ed3074c92b$export$8d09f5e2e1bf560d(extent) {
    return [
        extent[0],
        extent[1]
    ];
}
function $6da4c8ed3074c92b$export$e77c1cf70445e168(extent) {
    return [
        extent[2],
        extent[1]
    ];
}
function $6da4c8ed3074c92b$export$c91255cadecfe081(extent) {
    return [
        (extent[0] + extent[2]) / 2,
        (extent[1] + extent[3]) / 2
    ];
}
function $6da4c8ed3074c92b$export$a1cfd206661d0801(extent, corner) {
    let coordinate;
    if (corner === 'bottom-left') coordinate = $6da4c8ed3074c92b$export$8d09f5e2e1bf560d(extent);
    else if (corner === 'bottom-right') coordinate = $6da4c8ed3074c92b$export$e77c1cf70445e168(extent);
    else if (corner === 'top-left') coordinate = $6da4c8ed3074c92b$export$cb1538b07e6964ff(extent);
    else if (corner === 'top-right') coordinate = $6da4c8ed3074c92b$export$b84fa077c8b05295(extent);
    else throw new Error('Invalid corner');
    return coordinate;
}
function $6da4c8ed3074c92b$export$7d6fa884b32a3751(extent1, extent2) {
    const minX = Math.min(extent1[0], extent2[0]);
    const minY = Math.min(extent1[1], extent2[1]);
    const maxX = Math.max(extent1[2], extent2[2]);
    const maxY = Math.max(extent1[3], extent2[3]);
    return (maxX - minX) * (maxY - minY);
}
function $6da4c8ed3074c92b$export$13ba650faf8308(center, resolution, rotation, size, dest) {
    const [x0, y0, x1, y1, x2, y2, x3, y3] = $6da4c8ed3074c92b$export$4b7a6fb4002cd6ac(center, resolution, rotation, size);
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(Math.min(x0, x1, x2, x3), Math.min(y0, y1, y2, y3), Math.max(x0, x1, x2, x3), Math.max(y0, y1, y2, y3), dest);
}
function $6da4c8ed3074c92b$export$4b7a6fb4002cd6ac(center, resolution, rotation, size) {
    const dx = resolution * size[0] / 2;
    const dy = resolution * size[1] / 2;
    const cosRotation = Math.cos(rotation);
    const sinRotation = Math.sin(rotation);
    const xCos = dx * cosRotation;
    const xSin = dx * sinRotation;
    const yCos = dy * cosRotation;
    const ySin = dy * sinRotation;
    const x = center[0];
    const y = center[1];
    return [
        x - xCos + ySin,
        y - xSin - yCos,
        x - xCos - ySin,
        y - xSin + yCos,
        x + xCos - ySin,
        y + xSin + yCos,
        x + xCos + ySin,
        y + xSin - yCos,
        x - xCos + ySin,
        y - xSin - yCos
    ];
}
function $6da4c8ed3074c92b$export$c08559766941f856(extent) {
    return extent[3] - extent[1];
}
function $6da4c8ed3074c92b$export$f3fe0e9a60cde324(extent1, extent2) {
    const intersection = $6da4c8ed3074c92b$export$72209efa88586d42(extent1, extent2);
    return $6da4c8ed3074c92b$export$520c40045967cb15(intersection);
}
function $6da4c8ed3074c92b$export$72209efa88586d42(extent1, extent2, dest) {
    const intersection = dest ? dest : $6da4c8ed3074c92b$export$fe201bb3bbe031e9();
    if ($6da4c8ed3074c92b$export$7b0a31e10bbff018(extent1, extent2)) {
        if (extent1[0] > extent2[0]) intersection[0] = extent1[0];
        else intersection[0] = extent2[0];
        if (extent1[1] > extent2[1]) intersection[1] = extent1[1];
        else intersection[1] = extent2[1];
        if (extent1[2] < extent2[2]) intersection[2] = extent1[2];
        else intersection[2] = extent2[2];
        if (extent1[3] < extent2[3]) intersection[3] = extent1[3];
        else intersection[3] = extent2[3];
    } else $6da4c8ed3074c92b$export$3e2152b047719fa1(intersection);
    return intersection;
}
function $6da4c8ed3074c92b$export$1bc603050bd777b1(extent) {
    return $6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) + $6da4c8ed3074c92b$export$c08559766941f856(extent);
}
function $6da4c8ed3074c92b$export$31b21d0167753bb4(extent) {
    return [
        extent[2] - extent[0],
        extent[3] - extent[1]
    ];
}
function $6da4c8ed3074c92b$export$cb1538b07e6964ff(extent) {
    return [
        extent[0],
        extent[3]
    ];
}
function $6da4c8ed3074c92b$export$b84fa077c8b05295(extent) {
    return [
        extent[2],
        extent[3]
    ];
}
function $6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) {
    return extent[2] - extent[0];
}
function $6da4c8ed3074c92b$export$7b0a31e10bbff018(extent1, extent2) {
    return extent1[0] <= extent2[2] && extent1[2] >= extent2[0] && extent1[1] <= extent2[3] && extent1[3] >= extent2[1];
}
function $6da4c8ed3074c92b$export$dd1bc94b04021eeb(extent) {
    return extent[2] < extent[0] || extent[3] < extent[1];
}
function $6da4c8ed3074c92b$export$6a4fe494c558c238(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent;
}
function $6da4c8ed3074c92b$export$80cbab86674143b6(extent, value) {
    const deltaX = (extent[2] - extent[0]) / 2 * (value - 1);
    const deltaY = (extent[3] - extent[1]) / 2 * (value - 1);
    extent[0] -= deltaX;
    extent[2] += deltaX;
    extent[1] -= deltaY;
    extent[3] += deltaY;
}
function $6da4c8ed3074c92b$export$a6a5a7a461419425(extent, start, end) {
    let intersects = false;
    const startRel = $6da4c8ed3074c92b$export$f97905ead28c61a8(extent, start);
    const endRel = $6da4c8ed3074c92b$export$f97905ead28c61a8(extent, end);
    if (startRel === (0, $iM9A6.default).INTERSECTING || endRel === (0, $iM9A6.default).INTERSECTING) intersects = true;
    else {
        const minX = extent[0];
        const minY = extent[1];
        const maxX = extent[2];
        const maxY = extent[3];
        const startX = start[0];
        const startY = start[1];
        const endX = end[0];
        const endY = end[1];
        const slope = (endY - startY) / (endX - startX);
        let x, y;
        if (!!(endRel & (0, $iM9A6.default).ABOVE) && !(startRel & (0, $iM9A6.default).ABOVE)) {
            // potentially intersects top
            x = endX - (endY - maxY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $iM9A6.default).RIGHT) && !(startRel & (0, $iM9A6.default).RIGHT)) {
            // potentially intersects right
            y = endY - (endX - maxX) * slope;
            intersects = y >= minY && y <= maxY;
        }
        if (!intersects && !!(endRel & (0, $iM9A6.default).BELOW) && !(startRel & (0, $iM9A6.default).BELOW)) {
            // potentially intersects bottom
            x = endX - (endY - minY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $iM9A6.default).LEFT) && !(startRel & (0, $iM9A6.default).LEFT)) {
            // potentially intersects left
            y = endY - (endX - minX) * slope;
            intersects = y >= minY && y <= maxY;
        }
    }
    return intersects;
}
function $6da4c8ed3074c92b$export$9f9dcb98c894b623(extent, transformFn, dest, stops) {
    if ($6da4c8ed3074c92b$export$dd1bc94b04021eeb(extent)) return $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    let coordinates = [];
    if (stops > 1) {
        const width = extent[2] - extent[0];
        const height = extent[3] - extent[1];
        for(let i = 0; i < stops; ++i)coordinates.push(extent[0] + width * i / stops, extent[1], extent[2], extent[1] + height * i / stops, extent[2] - width * i / stops, extent[3], extent[0], extent[3] - height * i / stops);
    } else coordinates = [
        extent[0],
        extent[1],
        extent[2],
        extent[1],
        extent[2],
        extent[3],
        extent[0],
        extent[3]
    ];
    transformFn(coordinates, coordinates, 2);
    const xs = [];
    const ys = [];
    for(let i = 0, l = coordinates.length; i < l; i += 2){
        xs.push(coordinates[i]);
        ys.push(coordinates[i + 1]);
    }
    return $6da4c8ed3074c92b$var$_boundingExtentXYs(xs, ys, dest);
}
function $6da4c8ed3074c92b$export$39a9ce3624977b84(extent, projection) {
    const projectionExtent = projection.getExtent();
    const center = $6da4c8ed3074c92b$export$c91255cadecfe081(extent);
    if (projection.canWrapX() && (center[0] < projectionExtent[0] || center[0] >= projectionExtent[2])) {
        const worldWidth = $6da4c8ed3074c92b$export$3c49c185de0c2bfc(projectionExtent);
        const worldsAway = Math.floor((center[0] - projectionExtent[0]) / worldWidth);
        const offset = worldsAway * worldWidth;
        extent[0] -= offset;
        extent[2] -= offset;
    }
    return extent;
}
function $6da4c8ed3074c92b$export$9031237f01de0947(extent, projection, multiWorld) {
    if (projection.canWrapX()) {
        const projectionExtent = projection.getExtent();
        if (!isFinite(extent[0]) || !isFinite(extent[2])) return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        $6da4c8ed3074c92b$export$39a9ce3624977b84(extent, projection);
        const worldWidth = $6da4c8ed3074c92b$export$3c49c185de0c2bfc(projectionExtent);
        if ($6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) > worldWidth && !multiWorld) // the extent wraps around on itself
        return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        if (extent[0] < projectionExtent[0]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0] + worldWidth,
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2],
                extent[3]
            ]
        ];
        if (extent[2] > projectionExtent[2]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2] - worldWidth,
                extent[3]
            ]
        ];
    }
    return [
        extent
    ];
}

});
parcelRegister("iM9A6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dab4245bc22b806c$export$2e2bcd8739ae039);
/**
 * @module ol/extent/Relationship
 */ /**
 * Relationship to an extent.
 * @enum {number}
 */ var $dab4245bc22b806c$export$2e2bcd8739ae039 = {
    UNKNOWN: 0,
    INTERSECTING: 1,
    ABOVE: 2,
    RIGHT: 4,
    BELOW: 8,
    LEFT: 16
};

});


parcelRegister("dpRHA", function(module, exports) {

$parcel$export(module.exports, "disableCoordinateWarning", () => $9c4744460e43e41b$export$ed949affbc7c4223);
$parcel$export(module.exports, "identityTransform", () => $9c4744460e43e41b$export$83e8ab53904f8022);
$parcel$export(module.exports, "get", () => $9c4744460e43e41b$export$3988ae62b71be9a3);
$parcel$export(module.exports, "getPointResolution", () => $9c4744460e43e41b$export$2d8f7b4eec383d44);
$parcel$export(module.exports, "getTransformFromProjections", () => $9c4744460e43e41b$export$e3c4995a701c26a3);
$parcel$export(module.exports, "createProjection", () => $9c4744460e43e41b$export$549167224996a0fb);
$parcel$export(module.exports, "createTransformFromCoordinateTransform", () => $9c4744460e43e41b$export$6b4aafd331159e0d);
$parcel$export(module.exports, "fromLonLat", () => $9c4744460e43e41b$export$b15d9668511529b9);
$parcel$export(module.exports, "transform", () => $9c4744460e43e41b$export$51186ad6e864892a);
$parcel$export(module.exports, "toLonLat", () => $9c4744460e43e41b$export$3fb495868742d370);
$parcel$export(module.exports, "equivalent", () => $9c4744460e43e41b$export$fe091d73a555748b);
$parcel$export(module.exports, "getTransform", () => $9c4744460e43e41b$export$fce0c6cfca85ed96);
$parcel$export(module.exports, "getUserProjection", () => $9c4744460e43e41b$export$3973b77d5f6f2790);
$parcel$export(module.exports, "toUserCoordinate", () => $9c4744460e43e41b$export$698f563af1ba02a5);
$parcel$export(module.exports, "fromUserCoordinate", () => $9c4744460e43e41b$export$d4b8ec0b96db1ee2);
$parcel$export(module.exports, "toUserExtent", () => $9c4744460e43e41b$export$96bfd09e2cffb006);
$parcel$export(module.exports, "fromUserExtent", () => $9c4744460e43e41b$export$494be3a3a25689ca);
$parcel$export(module.exports, "toUserResolution", () => $9c4744460e43e41b$export$b56bb8ad8b3a00e9);
$parcel$export(module.exports, "fromUserResolution", () => $9c4744460e43e41b$export$bd1cd3b88140b906);
$parcel$export(module.exports, "METERS_PER_UNIT", () => (parcelRequire("kUyy5")).METERS_PER_UNIT);
/**
 * @module ol/proj
 */ /**
 * The ol/proj module stores:
 * a list of {@link module:ol/proj/Projection~Projection}
 * objects, one for each projection supported by the application
 * a list of transform functions needed to convert coordinates in one projection
 * into another.
 *
 * The static functions are the methods used to maintain these.
 * Each transform function can handle not only simple coordinate pairs, but also
 * large arrays of coordinates such as vector geometries.
 *
 * When loaded, the library adds projection objects for EPSG:4326 (WGS84
 * geographic coordinates) and EPSG:3857 (Web or Spherical Mercator, as used
 * for example by Bing Maps or OpenStreetMap), together with the relevant
 * transform functions.
 *
 * Additional transforms may be added by using the http://proj4js.org/
 * library (version 2.2 or later). You can use the full build supplied by
 * Proj4js, or create a custom build to support those projections you need; see
 * the Proj4js website for how to do this. You also need the Proj4js definitions
 * for the required projections. These definitions can be obtained from
 * https://spatialreference.org/, and are a JS function, so can be loaded in a
 * script tag (as in the examples) or pasted into your application.
 *
 * After all required projection definitions are added to proj4's registry (by
 * using `proj4.defs()`), simply call `register(proj4)` from the `ol/proj/proj4`
 * package. Existing transforms are not changed by this function. See
 * examples/wms-image-custom-proj for an example of this.
 *
 * Additional projection definitions can be registered with `proj4.defs()` any
 * time. Just make sure to call `register(proj4)` again; for example, with user-supplied data where you don't
 * know in advance what projections are needed, you can initially load minimal
 * support and then load whichever are requested.
 *
 * Note that Proj4js does not support projection extents. If you want to add
 * one for creating default tile grids, you can add it after the Projection
 * object has been created with `setExtent`, for example,
 * `get('EPSG:1234').setExtent(extent)`.
 *
 * In addition to Proj4js support, any transform functions can be added with
 * {@link module:ol/proj.addCoordinateTransforms}. To use this, you must first create
 * a {@link module:ol/proj/Projection~Projection} object for the new projection and add it with
 * {@link module:ol/proj.addProjection}. You can then add the forward and inverse
 * functions with {@link module:ol/proj.addCoordinateTransforms}. See
 * examples/wms-custom-proj for an example of this.
 *
 * Note that if no transforms are needed and you only need to define the
 * projection, just add a {@link module:ol/proj/Projection~Projection} with
 * {@link module:ol/proj.addProjection}. See examples/wms-no-proj for an example of
 * this.
 */ 
var $c3kwQ = parcelRequire("c3kwQ");

var $2o3CH = parcelRequire("2o3CH");

var $9pD6L = parcelRequire("9pD6L");

var $9byFX = parcelRequire("9byFX");


var $kUyy5 = parcelRequire("kUyy5");

var $bof21 = parcelRequire("bof21");

var $fAlut = parcelRequire("fAlut");

var $l72II = parcelRequire("l72II");

var $1wgRP = parcelRequire("1wgRP");

var $8acUl = parcelRequire("8acUl");

var $lAvh5 = parcelRequire("lAvh5");
/**
 * A projection as {@link module:ol/proj/Projection~Projection}, SRS identifier
 * string or undefined.
 * @typedef {Projection|string|undefined} ProjectionLike
 * @api
 */ /**
 * @typedef {Object} Transforms
 * @property {TransformFunction} forward The forward transform (from geographic).
 * @property {TransformFunction} inverse The inverse transform (to geographic).
 */ /**
 * @type {Array<function(Projection): Transforms|null>}
 */ const $9c4744460e43e41b$var$transformFactories = [
    (0, $8acUl.makeTransforms)
];
/**
 * @type {Array<function(string): Projection|null>}
 */ const $9c4744460e43e41b$var$projectionFactories = [
    (0, $8acUl.makeProjection)
];
let $9c4744460e43e41b$var$showCoordinateWarning = true;
function $9c4744460e43e41b$export$ed949affbc7c4223(disable) {
    const hide = disable === undefined ? true : disable;
    $9c4744460e43e41b$var$showCoordinateWarning = !hide;
}
function $9c4744460e43e41b$export$dd516654c5f598fb(input, output) {
    if (output !== undefined) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        output;
    } else output = input.slice();
    return output;
}
function $9c4744460e43e41b$export$83e8ab53904f8022(input, output) {
    if (output !== undefined && input !== output) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        input = output;
    }
    return input;
}
function $9c4744460e43e41b$export$59ae956cd3e343f7(projection) {
    (0, $l72II.add)(projection.getCode(), projection);
    (0, $1wgRP.add)(projection, projection, $9c4744460e43e41b$export$dd516654c5f598fb);
}
function $9c4744460e43e41b$export$638ad73f7aafb913(projections) {
    projections.forEach($9c4744460e43e41b$export$59ae956cd3e343f7);
}
function $9c4744460e43e41b$export$3988ae62b71be9a3(projectionLike) {
    if (!(typeof projectionLike === 'string')) return projectionLike;
    const projection = (0, $l72II.get)(projectionLike);
    if (projection) return projection;
    for (const makeProjection of $9c4744460e43e41b$var$projectionFactories){
        const projection = makeProjection(projectionLike);
        if (projection) return projection;
    }
    return null;
}
function $9c4744460e43e41b$export$2d8f7b4eec383d44(projection, resolution, point, units) {
    projection = $9c4744460e43e41b$export$3988ae62b71be9a3(projection);
    let pointResolution;
    const getter = projection.getPointResolutionFunc();
    if (getter) {
        pointResolution = getter(resolution, point);
        if (units && units !== projection.getUnits()) {
            const metersPerUnit = projection.getMetersPerUnit();
            if (metersPerUnit) pointResolution = pointResolution * metersPerUnit / (0, $kUyy5.METERS_PER_UNIT)[units];
        }
    } else {
        const projUnits = projection.getUnits();
        if (projUnits == 'degrees' && !units || units == 'degrees') pointResolution = resolution;
        else {
            // Estimate point resolution by transforming the center pixel to EPSG:4326,
            // measuring its width and height on the normal sphere, and taking the
            // average of the width and height.
            const toEPSG4326 = $9c4744460e43e41b$export$e3c4995a701c26a3(projection, $9c4744460e43e41b$export$3988ae62b71be9a3('EPSG:4326'));
            if (!toEPSG4326 && projUnits !== 'degrees') // no transform is available
            pointResolution = resolution * projection.getMetersPerUnit();
            else {
                let vertices = [
                    point[0] - resolution / 2,
                    point[1],
                    point[0] + resolution / 2,
                    point[1],
                    point[0],
                    point[1] - resolution / 2,
                    point[0],
                    point[1] + resolution / 2
                ];
                vertices = toEPSG4326(vertices, vertices, 2);
                const width = (0, $lAvh5.getDistance)(vertices.slice(0, 2), vertices.slice(2, 4));
                const height = (0, $lAvh5.getDistance)(vertices.slice(4, 6), vertices.slice(6, 8));
                pointResolution = (width + height) / 2;
            }
            const metersPerUnit = units ? (0, $kUyy5.METERS_PER_UNIT)[units] : projection.getMetersPerUnit();
            if (metersPerUnit !== undefined) pointResolution /= metersPerUnit;
        }
    }
    return pointResolution;
}
function $9c4744460e43e41b$export$eeb8392580a05a37(projections) {
    $9c4744460e43e41b$export$638ad73f7aafb913(projections);
    projections.forEach(function(source) {
        projections.forEach(function(destination) {
            if (source !== destination) (0, $1wgRP.add)(source, destination, $9c4744460e43e41b$export$dd516654c5f598fb);
        });
    });
}
function $9c4744460e43e41b$export$4856f21c2f184f24(projections1, projections2, forwardTransform, inverseTransform) {
    projections1.forEach(function(projection1) {
        projections2.forEach(function(projection2) {
            (0, $1wgRP.add)(projection1, projection2, forwardTransform);
            (0, $1wgRP.add)(projection2, projection1, inverseTransform);
        });
    });
}
function $9c4744460e43e41b$export$4860237d10380594() {
    (0, $l72II.clear)();
    (0, $1wgRP.clear)();
}
function $9c4744460e43e41b$export$549167224996a0fb(projection, defaultCode) {
    if (!projection) return $9c4744460e43e41b$export$3988ae62b71be9a3(defaultCode);
    if (typeof projection === 'string') return $9c4744460e43e41b$export$3988ae62b71be9a3(projection);
    return /** @type {Projection} */ projection;
}
function $9c4744460e43e41b$export$6b4aafd331159e0d(coordTransform) {
    return(/**
     * @param {Array<number>} input Input.
     * @param {Array<number>} [output] Output.
     * @param {number} [dimension] Dimensions that should be transformed.
     * @param {number} [stride] Stride.
     * @return {Array<number>} Output.
     */ function(input, output, dimension, stride) {
        const length = input.length;
        dimension = dimension !== undefined ? dimension : 2;
        stride = stride ?? dimension;
        output = output !== undefined ? output : new Array(length);
        for(let i = 0; i < length; i += stride){
            const point = coordTransform(input.slice(i, i + dimension));
            const pointLength = point.length;
            for(let j = 0, jj = stride; j < jj; ++j)output[i + j] = j >= pointLength ? input[i + j] : point[j];
        }
        return output;
    });
}
function $9c4744460e43e41b$export$6b1c2e6623f4f49d(source, destination, forward, inverse) {
    const sourceProj = $9c4744460e43e41b$export$3988ae62b71be9a3(source);
    const destProj = $9c4744460e43e41b$export$3988ae62b71be9a3(destination);
    (0, $1wgRP.add)(sourceProj, destProj, $9c4744460e43e41b$export$6b4aafd331159e0d(forward));
    (0, $1wgRP.add)(destProj, sourceProj, $9c4744460e43e41b$export$6b4aafd331159e0d(inverse));
}
function $9c4744460e43e41b$export$b15d9668511529b9(coordinate, projection) {
    $9c4744460e43e41b$export$ed949affbc7c4223();
    return $9c4744460e43e41b$export$51186ad6e864892a(coordinate, 'EPSG:4326', projection !== undefined ? projection : 'EPSG:3857');
}
function $9c4744460e43e41b$export$3fb495868742d370(coordinate, projection) {
    const lonLat = $9c4744460e43e41b$export$51186ad6e864892a(coordinate, projection !== undefined ? projection : 'EPSG:3857', 'EPSG:4326');
    const lon = lonLat[0];
    if (lon < -180 || lon > 180) lonLat[0] = (0, $9byFX.modulo)(lon + 180, 360) - 180;
    return lonLat;
}
function $9c4744460e43e41b$export$fe091d73a555748b(projection1, projection2) {
    if (projection1 === projection2) return true;
    const equalUnits = projection1.getUnits() === projection2.getUnits();
    if (projection1.getCode() === projection2.getCode()) return equalUnits;
    const transformFunc = $9c4744460e43e41b$export$e3c4995a701c26a3(projection1, projection2);
    return transformFunc === $9c4744460e43e41b$export$dd516654c5f598fb && equalUnits;
}
function $9c4744460e43e41b$export$e3c4995a701c26a3(source, destination) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    let transformFunc = (0, $1wgRP.get)(sourceCode, destinationCode);
    if (transformFunc) return transformFunc;
    /**
   * @type {Transforms|null}
   */ let sourceTransforms = null;
    /**
   * @type {Transforms|null}
   */ let destinationTransforms = null;
    // lazily add projections if we have supported transforms
    for (const makeTransforms of $9c4744460e43e41b$var$transformFactories){
        if (!sourceTransforms) sourceTransforms = makeTransforms(source);
        if (!destinationTransforms) destinationTransforms = makeTransforms(destination);
    }
    if (!sourceTransforms && !destinationTransforms) return null;
    const intermediateCode = 'EPSG:4326';
    if (!destinationTransforms) {
        const toDestination = (0, $1wgRP.get)(intermediateCode, destinationCode);
        if (toDestination) transformFunc = $9c4744460e43e41b$var$composeTransformFuncs(sourceTransforms.inverse, toDestination);
    } else if (!sourceTransforms) {
        const fromSource = (0, $1wgRP.get)(sourceCode, intermediateCode);
        if (fromSource) transformFunc = $9c4744460e43e41b$var$composeTransformFuncs(fromSource, destinationTransforms.forward);
    } else transformFunc = $9c4744460e43e41b$var$composeTransformFuncs(sourceTransforms.inverse, destinationTransforms.forward);
    if (transformFunc) {
        $9c4744460e43e41b$export$59ae956cd3e343f7(source);
        $9c4744460e43e41b$export$59ae956cd3e343f7(destination);
        (0, $1wgRP.add)(source, destination, transformFunc);
    }
    return transformFunc;
}
/**
 * @param {TransformFunction} t1 The first transform function.
 * @param {TransformFunction} t2 The second transform function.
 * @return {TransformFunction} The composed transform function.
 */ function $9c4744460e43e41b$var$composeTransformFuncs(t1, t2) {
    return function(input, output, dimensions, stride) {
        output = t1(input, output, dimensions, stride);
        return t2(output, output, dimensions, stride);
    };
}
function $9c4744460e43e41b$export$fce0c6cfca85ed96(source, destination) {
    const sourceProjection = $9c4744460e43e41b$export$3988ae62b71be9a3(source);
    const destinationProjection = $9c4744460e43e41b$export$3988ae62b71be9a3(destination);
    return $9c4744460e43e41b$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
}
function $9c4744460e43e41b$export$51186ad6e864892a(coordinate, source, destination) {
    const transformFunc = $9c4744460e43e41b$export$fce0c6cfca85ed96(source, destination);
    if (!transformFunc) {
        const sourceCode = $9c4744460e43e41b$export$3988ae62b71be9a3(source).getCode();
        const destinationCode = $9c4744460e43e41b$export$3988ae62b71be9a3(destination).getCode();
        throw new Error(`No transform available between ${sourceCode} and ${destinationCode}`);
    }
    return transformFunc(coordinate, undefined, coordinate.length);
}
function $9c4744460e43e41b$export$751c68e0e0efff79(extent, source, destination, stops) {
    const transformFunc = $9c4744460e43e41b$export$fce0c6cfca85ed96(source, destination);
    return (0, $9pD6L.applyTransform)(extent, transformFunc, undefined, stops);
}
function $9c4744460e43e41b$export$affbde93b1db73f8(point, sourceProjection, destinationProjection) {
    const transformFunc = $9c4744460e43e41b$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
    return transformFunc(point);
}
/**
 * @type {Projection|null}
 */ let $9c4744460e43e41b$var$userProjection = null;
function $9c4744460e43e41b$export$d0aeadbeac54116e(projection) {
    $9c4744460e43e41b$var$userProjection = $9c4744460e43e41b$export$3988ae62b71be9a3(projection);
}
function $9c4744460e43e41b$export$1ae11279759d4e8f() {
    $9c4744460e43e41b$var$userProjection = null;
}
function $9c4744460e43e41b$export$3973b77d5f6f2790() {
    return $9c4744460e43e41b$var$userProjection;
}
function $9c4744460e43e41b$export$aa7494edfbe36197() {
    $9c4744460e43e41b$export$d0aeadbeac54116e('EPSG:4326');
}
function $9c4744460e43e41b$export$698f563af1ba02a5(coordinate, sourceProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return coordinate;
    return $9c4744460e43e41b$export$51186ad6e864892a(coordinate, sourceProjection, $9c4744460e43e41b$var$userProjection);
}
function $9c4744460e43e41b$export$d4b8ec0b96db1ee2(coordinate, destProjection) {
    if (!$9c4744460e43e41b$var$userProjection) {
        if ($9c4744460e43e41b$var$showCoordinateWarning && !(0, $2o3CH.equals)(coordinate, [
            0,
            0
        ]) && coordinate[0] >= -180 && coordinate[0] <= 180 && coordinate[1] >= -90 && coordinate[1] <= 90) {
            $9c4744460e43e41b$var$showCoordinateWarning = false;
            (0, $c3kwQ.warn)('Call useGeographic() from ol/proj once to work with [longitude, latitude] coordinates.');
        }
        return coordinate;
    }
    return $9c4744460e43e41b$export$51186ad6e864892a(coordinate, $9c4744460e43e41b$var$userProjection, destProjection);
}
function $9c4744460e43e41b$export$96bfd09e2cffb006(extent, sourceProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return extent;
    return $9c4744460e43e41b$export$751c68e0e0efff79(extent, sourceProjection, $9c4744460e43e41b$var$userProjection);
}
function $9c4744460e43e41b$export$494be3a3a25689ca(extent, destProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return extent;
    return $9c4744460e43e41b$export$751c68e0e0efff79(extent, $9c4744460e43e41b$var$userProjection, destProjection);
}
function $9c4744460e43e41b$export$b56bb8ad8b3a00e9(resolution, sourceProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return resolution;
    const sourceMetersPerUnit = $9c4744460e43e41b$export$3988ae62b71be9a3(sourceProjection).getMetersPerUnit();
    const userMetersPerUnit = $9c4744460e43e41b$var$userProjection.getMetersPerUnit();
    return sourceMetersPerUnit && userMetersPerUnit ? resolution * sourceMetersPerUnit / userMetersPerUnit : resolution;
}
function $9c4744460e43e41b$export$bd1cd3b88140b906(resolution, destProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return resolution;
    const destMetersPerUnit = $9c4744460e43e41b$export$3988ae62b71be9a3(destProjection).getMetersPerUnit();
    const userMetersPerUnit = $9c4744460e43e41b$var$userProjection.getMetersPerUnit();
    return destMetersPerUnit && userMetersPerUnit ? resolution * userMetersPerUnit / destMetersPerUnit : resolution;
}
function $9c4744460e43e41b$export$1873f9cfeb8bd1d6(sourceProj, destProj, transform) {
    return function(coord) {
        let transformed, worldsAway;
        if (sourceProj.canWrapX()) {
            const sourceExtent = sourceProj.getExtent();
            const sourceExtentWidth = (0, $9pD6L.getWidth)(sourceExtent);
            coord = coord.slice(0);
            worldsAway = (0, $2o3CH.getWorldsAway)(coord, sourceProj, sourceExtentWidth);
            if (worldsAway) // Move x to the real world
            coord[0] = coord[0] - worldsAway * sourceExtentWidth;
            coord[0] = (0, $9byFX.clamp)(coord[0], sourceExtent[0], sourceExtent[2]);
            coord[1] = (0, $9byFX.clamp)(coord[1], sourceExtent[1], sourceExtent[3]);
            transformed = transform(coord);
        } else transformed = transform(coord);
        if (worldsAway && destProj.canWrapX()) // Move transformed coordinate back to the offset world
        transformed[0] += worldsAway * (0, $9pD6L.getWidth)(destProj.getExtent());
        return transformed;
    };
}
function $9c4744460e43e41b$export$86eed449eb2dcac4() {
    // Add transformations that don't alter coordinates to convert within set of
    // projections with equal meaning.
    $9c4744460e43e41b$export$eeb8392580a05a37((0, $bof21.PROJECTIONS));
    $9c4744460e43e41b$export$eeb8392580a05a37((0, $fAlut.PROJECTIONS));
    // Add transformations to convert EPSG:4326 like coordinates to EPSG:3857 like
    // coordinates and back.
    $9c4744460e43e41b$export$4856f21c2f184f24((0, $fAlut.PROJECTIONS), (0, $bof21.PROJECTIONS), (0, $bof21.fromEPSG4326), (0, $bof21.toEPSG4326));
}
$9c4744460e43e41b$export$86eed449eb2dcac4();

});
parcelRegister("c3kwQ", function(module, exports) {

$parcel$export(module.exports, "warn", () => $8c65b0699f3f3f8e$export$c106dd0671a0fc2d);
/**
 * @module ol/console
 */ /**
 * @typedef {'info'|'warn'|'error'|'none'} Level
 */ /**
 * @type {Object<Level, number>}
 */ const $8c65b0699f3f3f8e$var$levels = {
    info: 1,
    warn: 2,
    error: 3,
    none: 4
};
/**
 * @type {number}
 */ let $8c65b0699f3f3f8e$var$level = $8c65b0699f3f3f8e$var$levels.info;
function $8c65b0699f3f3f8e$export$2c97a59140dbf245(l) {
    $8c65b0699f3f3f8e$var$level = $8c65b0699f3f3f8e$var$levels[l];
}
function $8c65b0699f3f3f8e$export$bef1f36f5486a6a3(...args) {
    if ($8c65b0699f3f3f8e$var$level > $8c65b0699f3f3f8e$var$levels.info) return;
    console.log(...args); // eslint-disable-line no-console
}
function $8c65b0699f3f3f8e$export$c106dd0671a0fc2d(...args) {
    if ($8c65b0699f3f3f8e$var$level > $8c65b0699f3f3f8e$var$levels.warn) return;
    console.warn(...args); // eslint-disable-line no-console
}
function $8c65b0699f3f3f8e$export$a3bc9b8ed74fc(...args) {
    if ($8c65b0699f3f3f8e$var$level > $8c65b0699f3f3f8e$var$levels.error) return;
    console.error(...args); // eslint-disable-line no-console
}

});

parcelRegister("2o3CH", function(module, exports) {

$parcel$export(module.exports, "add", () => $1bd0a226f9a16141$export$e16d8520af44a096);
$parcel$export(module.exports, "createStringXY", () => $1bd0a226f9a16141$export$35ad6765fe262b6);
$parcel$export(module.exports, "equals", () => $1bd0a226f9a16141$export$e9bab7fafb253603);
$parcel$export(module.exports, "rotate", () => $1bd0a226f9a16141$export$bb628a54ab399bc9);
$parcel$export(module.exports, "scale", () => $1bd0a226f9a16141$export$dcdf75081b88279d);
$parcel$export(module.exports, "wrapX", () => $1bd0a226f9a16141$export$39a9ce3624977b84);
$parcel$export(module.exports, "getWorldsAway", () => $1bd0a226f9a16141$export$24e2b27d1ff0c1d5);
$parcel$export(module.exports, "angleBetween", () => $1bd0a226f9a16141$export$47cb7eb79666608a);
/**
 * @module ol/coordinate
 */ 
var $9pD6L = parcelRequire("9pD6L");

var $9byFX = parcelRequire("9byFX");

var $lVIA6 = parcelRequire("lVIA6");
function $1bd0a226f9a16141$export$e16d8520af44a096(coordinate, delta) {
    coordinate[0] += +delta[0];
    coordinate[1] += +delta[1];
    return coordinate;
}
function $1bd0a226f9a16141$export$cbe80a3fcd2b99b7(coordinate, circle) {
    const r = circle.getRadius();
    const center = circle.getCenter();
    const x0 = center[0];
    const y0 = center[1];
    const x1 = coordinate[0];
    const y1 = coordinate[1];
    let dx = x1 - x0;
    const dy = y1 - y0;
    if (dx === 0 && dy === 0) dx = 1;
    const d = Math.sqrt(dx * dx + dy * dy);
    const x = x0 + r * dx / d;
    const y = y0 + r * dy / d;
    return [
        x,
        y
    ];
}
function $1bd0a226f9a16141$export$18cdd31d17f97131(coordinate, segment) {
    const x0 = coordinate[0];
    const y0 = coordinate[1];
    const start = segment[0];
    const end = segment[1];
    const x1 = start[0];
    const y1 = start[1];
    const x2 = end[0];
    const y2 = end[1];
    const dx = x2 - x1;
    const dy = y2 - y1;
    const along = dx === 0 && dy === 0 ? 0 : (dx * (x0 - x1) + dy * (y0 - y1)) / (dx * dx + dy * dy || 0);
    let x, y;
    if (along <= 0) {
        x = x1;
        y = y1;
    } else if (along >= 1) {
        x = x2;
        y = y2;
    } else {
        x = x1 + along * dx;
        y = y1 + along * dy;
    }
    return [
        x,
        y
    ];
}
function $1bd0a226f9a16141$export$35ad6765fe262b6(fractionDigits) {
    return(/**
     * @param {Coordinate} coordinate Coordinate.
     * @return {string} String XY.
     */ function(coordinate) {
        return $1bd0a226f9a16141$export$9ff8f16060979e0a(coordinate, fractionDigits);
    });
}
function $1bd0a226f9a16141$export$6eb0ac5f024d8590(hemispheres, degrees, fractionDigits) {
    const normalizedDegrees = (0, $9byFX.modulo)(degrees + 180, 360) - 180;
    const x = Math.abs(3600 * normalizedDegrees);
    const decimals = fractionDigits || 0;
    let deg = Math.floor(x / 3600);
    let min = Math.floor((x - deg * 3600) / 60);
    let sec = (0, $9byFX.toFixed)(x - deg * 3600 - min * 60, decimals);
    if (sec >= 60) {
        sec = 0;
        min += 1;
    }
    if (min >= 60) {
        min = 0;
        deg += 1;
    }
    let hdms = deg + '\u00b0';
    if (min !== 0 || sec !== 0) hdms += ' ' + (0, $lVIA6.padNumber)(min, 2) + '\u2032';
    if (sec !== 0) hdms += ' ' + (0, $lVIA6.padNumber)(sec, 2, decimals) + '\u2033';
    if (normalizedDegrees !== 0) hdms += ' ' + hemispheres.charAt(normalizedDegrees < 0 ? 1 : 0);
    return hdms;
}
function $1bd0a226f9a16141$export$d9468344d3651243(coordinate, template, fractionDigits) {
    if (coordinate) return template.replace('{x}', coordinate[0].toFixed(fractionDigits)).replace('{y}', coordinate[1].toFixed(fractionDigits));
    return '';
}
function $1bd0a226f9a16141$export$e9bab7fafb253603(coordinate1, coordinate2) {
    let equals = true;
    for(let i = coordinate1.length - 1; i >= 0; --i)if (coordinate1[i] != coordinate2[i]) {
        equals = false;
        break;
    }
    return equals;
}
function $1bd0a226f9a16141$export$bb628a54ab399bc9(coordinate, angle) {
    const cosAngle = Math.cos(angle);
    const sinAngle = Math.sin(angle);
    const x = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    const y = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    coordinate[0] = x;
    coordinate[1] = y;
    return coordinate;
}
function $1bd0a226f9a16141$export$dcdf75081b88279d(coordinate, scale) {
    coordinate[0] *= scale;
    coordinate[1] *= scale;
    return coordinate;
}
function $1bd0a226f9a16141$export$88e6ebb4fe54f538(coord1, coord2) {
    const dx = coord1[0] - coord2[0];
    const dy = coord1[1] - coord2[1];
    return dx * dx + dy * dy;
}
function $1bd0a226f9a16141$export$9f17032d917177de(coord1, coord2) {
    return Math.sqrt($1bd0a226f9a16141$export$88e6ebb4fe54f538(coord1, coord2));
}
function $1bd0a226f9a16141$export$6985570514055196(coordinate, segment) {
    return $1bd0a226f9a16141$export$88e6ebb4fe54f538(coordinate, $1bd0a226f9a16141$export$18cdd31d17f97131(coordinate, segment));
}
function $1bd0a226f9a16141$export$c883fd238161f841(coordinate, fractionDigits) {
    if (coordinate) return $1bd0a226f9a16141$export$6eb0ac5f024d8590('NS', coordinate[1], fractionDigits) + ' ' + $1bd0a226f9a16141$export$6eb0ac5f024d8590('EW', coordinate[0], fractionDigits);
    return '';
}
function $1bd0a226f9a16141$export$9ff8f16060979e0a(coordinate, fractionDigits) {
    return $1bd0a226f9a16141$export$d9468344d3651243(coordinate, '{x}, {y}', fractionDigits);
}
function $1bd0a226f9a16141$export$39a9ce3624977b84(coordinate, projection) {
    if (projection.canWrapX()) {
        const worldWidth = (0, $9pD6L.getWidth)(projection.getExtent());
        const worldsAway = $1bd0a226f9a16141$export$24e2b27d1ff0c1d5(coordinate, projection, worldWidth);
        if (worldsAway) coordinate[0] -= worldsAway * worldWidth;
    }
    return coordinate;
}
function $1bd0a226f9a16141$export$24e2b27d1ff0c1d5(coordinate, projection, sourceExtentWidth) {
    const projectionExtent = projection.getExtent();
    let worldsAway = 0;
    if (projection.canWrapX() && (coordinate[0] < projectionExtent[0] || coordinate[0] > projectionExtent[2])) {
        sourceExtentWidth = sourceExtentWidth || (0, $9pD6L.getWidth)(projectionExtent);
        worldsAway = Math.floor((coordinate[0] - projectionExtent[0]) / sourceExtentWidth);
    }
    return worldsAway;
}
function $1bd0a226f9a16141$export$47cb7eb79666608a(p0, pA, pB) {
    const lenA = Math.sqrt((pA[0] - p0[0]) * (pA[0] - p0[0]) + (pA[1] - p0[1]) * (pA[1] - p0[1]));
    const tangentA = [
        (pA[0] - p0[0]) / lenA,
        (pA[1] - p0[1]) / lenA
    ];
    const orthoA = [
        -tangentA[1],
        tangentA[0]
    ];
    const lenB = Math.sqrt((pB[0] - p0[0]) * (pB[0] - p0[0]) + (pB[1] - p0[1]) * (pB[1] - p0[1]));
    const tangentB = [
        (pB[0] - p0[0]) / lenB,
        (pB[1] - p0[1]) / lenB
    ];
    // this angle can be clockwise or anticlockwise; hence the computation afterwards
    let angle = lenA === 0 || lenB === 0 ? 0 : Math.acos((0, $9byFX.clamp)(tangentB[0] * tangentA[0] + tangentB[1] * tangentA[1], -1, 1));
    angle = Math.max(angle, 0.00001); // avoid a zero angle otherwise this is detected as a line cap
    const isClockwise = tangentB[0] * orthoA[0] + tangentB[1] * orthoA[1] > 0;
    return !isClockwise ? Math.PI * 2 - angle : angle;
}

});
parcelRegister("9byFX", function(module, exports) {

$parcel$export(module.exports, "clamp", () => $6b000a049d919fe5$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "squaredSegmentDistance", () => $6b000a049d919fe5$export$251bb0a9cef172e6);
$parcel$export(module.exports, "squaredDistance", () => $6b000a049d919fe5$export$88e6ebb4fe54f538);
$parcel$export(module.exports, "solveLinearSystem", () => $6b000a049d919fe5$export$8240f01c446270e6);
$parcel$export(module.exports, "toDegrees", () => $6b000a049d919fe5$export$56cb859c01fa134d);
$parcel$export(module.exports, "toRadians", () => $6b000a049d919fe5$export$cba01ba138429a1d);
$parcel$export(module.exports, "modulo", () => $6b000a049d919fe5$export$ba467bec01d66def);
$parcel$export(module.exports, "lerp", () => $6b000a049d919fe5$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "toFixed", () => $6b000a049d919fe5$export$a81f732198733497);
$parcel$export(module.exports, "floor", () => $6b000a049d919fe5$export$a3fe094919f356fd);
$parcel$export(module.exports, "ceil", () => $6b000a049d919fe5$export$803ce6b71a0a94b2);
$parcel$export(module.exports, "wrap", () => $6b000a049d919fe5$export$4997ffc0176396a6);
/**
 * @module ol/math
 */ /**
 * Takes a number and clamps it to within the provided bounds.
 * @param {number} value The input number.
 * @param {number} min The minimum value to return.
 * @param {number} max The maximum value to return.
 * @return {number} The input number if it is within bounds, or the nearest
 *     number within the bounds.
 */ function $6b000a049d919fe5$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function $6b000a049d919fe5$export$251bb0a9cef172e6(x, y, x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    if (dx !== 0 || dy !== 0) {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return $6b000a049d919fe5$export$88e6ebb4fe54f538(x, y, x1, y1);
}
function $6b000a049d919fe5$export$88e6ebb4fe54f538(x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    return dx * dx + dy * dy;
}
function $6b000a049d919fe5$export$8240f01c446270e6(mat) {
    const n = mat.length;
    for(let i = 0; i < n; i++){
        // Find max in the i-th column (ignoring i - 1 first rows)
        let maxRow = i;
        let maxEl = Math.abs(mat[i][i]);
        for(let r = i + 1; r < n; r++){
            const absValue = Math.abs(mat[r][i]);
            if (absValue > maxEl) {
                maxEl = absValue;
                maxRow = r;
            }
        }
        if (maxEl === 0) return null; // matrix is singular
        // Swap max row with i-th (current) row
        const tmp = mat[maxRow];
        mat[maxRow] = mat[i];
        mat[i] = tmp;
        // Subtract the i-th row to make all the remaining rows 0 in the i-th column
        for(let j = i + 1; j < n; j++){
            const coef = -mat[j][i] / mat[i][i];
            for(let k = i; k < n + 1; k++)if (i == k) mat[j][k] = 0;
            else mat[j][k] += coef * mat[i][k];
        }
    }
    // Solve Ax=b for upper triangular matrix A (mat)
    const x = new Array(n);
    for(let l = n - 1; l >= 0; l--){
        x[l] = mat[l][n] / mat[l][l];
        for(let m = l - 1; m >= 0; m--)mat[m][n] -= mat[m][l] * x[l];
    }
    return x;
}
function $6b000a049d919fe5$export$56cb859c01fa134d(angleInRadians) {
    return angleInRadians * 180 / Math.PI;
}
function $6b000a049d919fe5$export$cba01ba138429a1d(angleInDegrees) {
    return angleInDegrees * Math.PI / 180;
}
function $6b000a049d919fe5$export$ba467bec01d66def(a, b) {
    const r = a % b;
    return r * b < 0 ? r + b : r;
}
function $6b000a049d919fe5$export$3a89f8d6f6bf6c9f(a, b, x) {
    return a + x * (b - a);
}
function $6b000a049d919fe5$export$a81f732198733497(n, decimals) {
    const factor = Math.pow(10, decimals);
    return Math.round(n * factor) / factor;
}
function $6b000a049d919fe5$export$2077e0241d6afd3c(n, decimals) {
    return Math.round($6b000a049d919fe5$export$a81f732198733497(n, decimals));
}
function $6b000a049d919fe5$export$a3fe094919f356fd(n, decimals) {
    return Math.floor($6b000a049d919fe5$export$a81f732198733497(n, decimals));
}
function $6b000a049d919fe5$export$803ce6b71a0a94b2(n, decimals) {
    return Math.ceil($6b000a049d919fe5$export$a81f732198733497(n, decimals));
}
function $6b000a049d919fe5$export$4997ffc0176396a6(n, min, max) {
    if (n >= min && n < max) return n;
    const range = max - min;
    return ((n - min) % range + range) % range + min;
}

});

parcelRegister("lVIA6", function(module, exports) {

$parcel$export(module.exports, "padNumber", () => $ff7180bdd45ebb19$export$24be126cb0a7bbeb);
/**
 * @module ol/string
 */ /**
 * @param {number} number Number to be formatted
 * @param {number} width The desired width
 * @param {number} [precision] Precision of the output string (i.e. number of decimal places)
 * @return {string} Formatted string
 */ function $ff7180bdd45ebb19$export$24be126cb0a7bbeb(number, width, precision) {
    const numberString = precision !== undefined ? number.toFixed(precision) : '' + number;
    let decimal = numberString.indexOf('.');
    decimal = decimal === -1 ? numberString.length : decimal;
    return decimal > width ? numberString : new Array(1 + width - decimal).join('0') + numberString;
}
function $ff7180bdd45ebb19$export$66e1c0999abad646(v1, v2) {
    const s1 = ('' + v1).split('.');
    const s2 = ('' + v2).split('.');
    for(let i = 0; i < Math.max(s1.length, s2.length); i++){
        const n1 = parseInt(s1[i] || '0', 10);
        const n2 = parseInt(s2[i] || '0', 10);
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
    }
    return 0;
}

});


parcelRegister("kUyy5", function(module, exports) {

$parcel$export(module.exports, "METERS_PER_UNIT", () => $03edbd434a9e6608$export$1482081eec883108);
/**
 * @module ol/proj/Units
 */ /**
 * @typedef {'radians' | 'degrees' | 'ft' | 'm' | 'pixels' | 'tile-pixels' | 'us-ft'} Units
 * Projection units.
 */ /**
 * See http://duff.ess.washington.edu/data/raster/drg/docs/geotiff.txt
 * @type {Object<number, Units>}
 */ const $03edbd434a9e6608$var$unitByCode = {
    '9001': 'm',
    '9002': 'ft',
    '9003': 'us-ft',
    '9101': 'radians',
    '9102': 'degrees'
};
function $03edbd434a9e6608$export$7f58726df3255edc(code) {
    return $03edbd434a9e6608$var$unitByCode[code];
}
const $03edbd434a9e6608$export$1482081eec883108 = {
    // use the radius of the Normal sphere
    'radians': 6370997 / (2 * Math.PI),
    'degrees': 2 * Math.PI * 6370997 / 360,
    'ft': 0.3048,
    'm': 1,
    'us-ft': 1200 / 3937
};

});

parcelRegister("bof21", function(module, exports) {

$parcel$export(module.exports, "PROJECTIONS", () => $84ad988f04807ab1$export$b508d7ad9a891c1b);
$parcel$export(module.exports, "fromEPSG4326", () => $84ad988f04807ab1$export$1ff8bb36c0983070);
$parcel$export(module.exports, "toEPSG4326", () => $84ad988f04807ab1$export$8c71322ec28ed6b4);
/**
 * @module ol/proj/epsg3857
 */ 
var $9qhtr = parcelRequire("9qhtr");
const $84ad988f04807ab1$export$2d2c9be8b5b863f = 6378137;
const $84ad988f04807ab1$export$f3928063e5e96d35 = Math.PI * $84ad988f04807ab1$export$2d2c9be8b5b863f;
const $84ad988f04807ab1$export$21e6da8a7375dfe8 = [
    -$84ad988f04807ab1$export$f3928063e5e96d35,
    -$84ad988f04807ab1$export$f3928063e5e96d35,
    $84ad988f04807ab1$export$f3928063e5e96d35,
    $84ad988f04807ab1$export$f3928063e5e96d35
];
const $84ad988f04807ab1$export$ae9d6ed80df710e5 = [
    -180,
    -85,
    180,
    85
];
const $84ad988f04807ab1$export$d26945d1ad52feeb = $84ad988f04807ab1$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI / 2));
/**
 * @classdesc
 * Projection object for web/spherical Mercator (EPSG:3857).
 */ class $84ad988f04807ab1$var$EPSG3857Projection extends (0, $9qhtr.default) {
    /**
   * @param {string} code Code.
   */ constructor(code){
        super({
            code: code,
            units: 'm',
            extent: $84ad988f04807ab1$export$21e6da8a7375dfe8,
            global: true,
            worldExtent: $84ad988f04807ab1$export$ae9d6ed80df710e5,
            getPointResolution: function(resolution, point) {
                return resolution / Math.cosh(point[1] / $84ad988f04807ab1$export$2d2c9be8b5b863f);
            }
        });
    }
}
const $84ad988f04807ab1$export$b508d7ad9a891c1b = [
    new $84ad988f04807ab1$var$EPSG3857Projection('EPSG:3857'),
    new $84ad988f04807ab1$var$EPSG3857Projection('EPSG:102100'),
    new $84ad988f04807ab1$var$EPSG3857Projection('EPSG:102113'),
    new $84ad988f04807ab1$var$EPSG3857Projection('EPSG:900913'),
    new $84ad988f04807ab1$var$EPSG3857Projection('http://www.opengis.net/def/crs/EPSG/0/3857'),
    new $84ad988f04807ab1$var$EPSG3857Projection('http://www.opengis.net/gml/srs/epsg.xml#3857')
];
function $84ad988f04807ab1$export$1ff8bb36c0983070(input, output, dimension, stride) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    stride = stride ?? dimension;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += stride){
        output[i] = $84ad988f04807ab1$export$f3928063e5e96d35 * input[i] / 180;
        let y = $84ad988f04807ab1$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI * (+input[i + 1] + 90) / 360));
        if (y > $84ad988f04807ab1$export$d26945d1ad52feeb) y = $84ad988f04807ab1$export$d26945d1ad52feeb;
        else if (y < -$84ad988f04807ab1$export$d26945d1ad52feeb) y = -$84ad988f04807ab1$export$d26945d1ad52feeb;
        output[i + 1] = y;
    }
    return output;
}
function $84ad988f04807ab1$export$8c71322ec28ed6b4(input, output, dimension, stride) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    stride = stride ?? dimension;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += stride){
        output[i] = 180 * input[i] / $84ad988f04807ab1$export$f3928063e5e96d35;
        output[i + 1] = 360 * Math.atan(Math.exp(input[i + 1] / $84ad988f04807ab1$export$2d2c9be8b5b863f)) / Math.PI - 90;
    }
    return output;
}

});
parcelRegister("9qhtr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dc418afeec7068a$export$2e2bcd8739ae039);
/**
 * @module ol/proj/Projection
 */ 
var $kUyy5 = parcelRequire("kUyy5");
/**
 * The function is called with a `number` view resolution and a
 * {@link module:ol/coordinate~Coordinate} as arguments, and returns the `number` resolution
 * in projection units at the passed coordinate.
 * @typedef {function(number, import("../coordinate.js").Coordinate):number} GetPointResolution
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {string} code The SRS identifier code, e.g. `EPSG:4326`.
 * @property {import("./Units.js").Units} [units] Units. Required unless a
 * proj4 projection is defined for `code`.
 * @property {import("../extent.js").Extent} [extent] The validity extent for the SRS.
 * @property {string} [axisOrientation='enu'] The axis orientation as specified in Proj4.
 * @property {boolean} [global=false] Whether the projection is valid for the whole globe.
 * @property {number} [metersPerUnit] The meters per unit for the SRS.
 * If not provided, the `units` are used to get the meters per unit from the {@link METERS_PER_UNIT}
 * lookup table.
 * @property {import("../extent.js").Extent} [worldExtent] The world extent for the SRS.
 * @property {GetPointResolution} [getPointResolution]
 * Function to determine resolution at a point. The function is called with a
 * `number` view resolution and a {@link module:ol/coordinate~Coordinate} as arguments, and returns
 * the `number` resolution in projection units at the passed coordinate. If this is `undefined`,
 * the default {@link module:ol/proj.getPointResolution} function will be used.
 */ /**
 * @classdesc
 * In most cases, you should not need to create instances of this class.
 * Instead, where projection information is required, you can use a string
 * projection code or identifier (e.g. `EPSG:4326`) instead of a projection
 * instance.
 *
 * The library includes support for transforming coordinates between the following
 * projections:
 *
 *  WGS 84 / Geographic - Using codes `EPSG:4326`, `CRS:84`, `urn:ogc:def:crs:EPSG:6.6:4326`,
 *    `urn:ogc:def:crs:OGC:1.3:CRS84`, `urn:ogc:def:crs:OGC:2:84`, `http://www.opengis.net/gml/srs/epsg.xml#4326`,
 *    or `urn:x-ogc:def:crs:EPSG:4326`
 *  WGS 84 / Spherical Mercator - Using codes `EPSG:3857`, `EPSG:102100`, `EPSG:102113`, `EPSG:900913`,
 *    `urn:ogc:def:crs:EPSG:6.18:3:3857`, or `http://www.opengis.net/gml/srs/epsg.xml#3857`
 *  WGS 84 / UTM zones - Using codes `EPSG:32601` through `EPSG:32660` for northern zones
 *    and `EPSG:32701` through `EPSG:32760` for southern zones. Note that the built-in UTM transforms
 *    are lower accuracy (with errors on the order of 0.1 m) than those that you might get in a
 *    library like [proj4js](https://github.com/proj4js/proj4js).
 *
 * For additional projection support, or to use higher accuracy transforms than the built-in ones, you can use
 * the [proj4js](https://github.com/proj4js/proj4js) library. With `proj4js`, after adding any new projection
 * definitions, call the {@link module:ol/proj/proj4.register} function.
 *
 * You can use the {@link module:ol/proj.get} function to retrieve a projection instance
 * for one of the registered projections.
 *
 * @api
 */ class $6dc418afeec7068a$var$Projection {
    /**
   * @param {Options} options Projection options.
   */ constructor(options){
        /**
     * @private
     * @type {string}
     */ this.code_ = options.code;
        /**
     * Units of projected coordinates. When set to `TILE_PIXELS`, a
     * `this.extent_` and `this.worldExtent_` must be configured properly for each
     * tile.
     * @private
     * @type {import("./Units.js").Units}
     */ this.units_ = /** @type {import("./Units.js").Units} */ options.units;
        /**
     * Validity extent of the projection in projected coordinates. For projections
     * with `TILE_PIXELS` units, this is the extent of the tile in
     * tile pixel space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = options.extent !== undefined ? options.extent : null;
        /**
     * Extent of the world in EPSG:4326. For projections with
     * `TILE_PIXELS` units, this is the extent of the tile in
     * projected coordinate space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.worldExtent_ = options.worldExtent !== undefined ? options.worldExtent : null;
        /**
     * @private
     * @type {string}
     */ this.axisOrientation_ = options.axisOrientation !== undefined ? options.axisOrientation : 'enu';
        /**
     * @private
     * @type {boolean}
     */ this.global_ = options.global !== undefined ? options.global : false;
        /**
     * @private
     * @type {boolean}
     */ this.canWrapX_ = !!(this.global_ && this.extent_);
        /**
     * @private
     * @type {GetPointResolution|undefined}
     */ this.getPointResolutionFunc_ = options.getPointResolution;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.defaultTileGrid_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.metersPerUnit_ = options.metersPerUnit;
    }
    /**
   * @return {boolean} The projection is suitable for wrapping the x-axis
   */ canWrapX() {
        return this.canWrapX_;
    }
    /**
   * Get the code for this projection, e.g. 'EPSG:4326'.
   * @return {string} Code.
   * @api
   */ getCode() {
        return this.code_;
    }
    /**
   * Get the validity extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the units of this projection.
   * @return {import("./Units.js").Units} Units.
   * @api
   */ getUnits() {
        return this.units_;
    }
    /**
   * Get the amount of meters per unit of this projection.  If the projection is
   * not configured with `metersPerUnit` or a units identifier, the return is
   * `undefined`.
   * @return {number|undefined} Meters.
   * @api
   */ getMetersPerUnit() {
        return this.metersPerUnit_ || (0, $kUyy5.METERS_PER_UNIT)[this.units_];
    }
    /**
   * Get the world extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getWorldExtent() {
        return this.worldExtent_;
    }
    /**
   * Get the axis orientation of this projection.
   * Example values are:
   * enu - the default easting, northing, elevation.
   * neu - northing, easting, up - useful for "lat/long" geographic coordinates,
   *     or south orientated transverse mercator.
   * wnu - westing, northing, up - some planetary coordinate systems have
   *     "west positive" coordinate systems
   * @return {string} Axis orientation.
   * @api
   */ getAxisOrientation() {
        return this.axisOrientation_;
    }
    /**
   * Is this projection a global projection which spans the whole world?
   * @return {boolean} Whether the projection is global.
   * @api
   */ isGlobal() {
        return this.global_;
    }
    /**
   * Set if the projection is a global projection which spans the whole world
   * @param {boolean} global Whether the projection is global.
   * @api
   */ setGlobal(global) {
        this.global_ = global;
        this.canWrapX_ = !!(global && this.extent_);
    }
    /**
   * @return {import("../tilegrid/TileGrid.js").default} The default tile grid.
   */ getDefaultTileGrid() {
        return this.defaultTileGrid_;
    }
    /**
   * @param {import("../tilegrid/TileGrid.js").default} tileGrid The default tile grid.
   */ setDefaultTileGrid(tileGrid) {
        this.defaultTileGrid_ = tileGrid;
    }
    /**
   * Set the validity extent for this projection.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ setExtent(extent) {
        this.extent_ = extent;
        this.canWrapX_ = !!(this.global_ && extent);
    }
    /**
   * Set the world extent for this projection.
   * @param {import("../extent.js").Extent} worldExtent World extent
   *     [minlon, minlat, maxlon, maxlat].
   * @api
   */ setWorldExtent(worldExtent) {
        this.worldExtent_ = worldExtent;
    }
    /**
   * Set the getPointResolution function (see {@link module:ol/proj.getPointResolution}
   * for this projection.
   * @param {function(number, import("../coordinate.js").Coordinate):number} func Function
   * @api
   */ setGetPointResolution(func) {
        this.getPointResolutionFunc_ = func;
    }
    /**
   * Get the custom point resolution function for this projection (if set).
   * @return {GetPointResolution|undefined} The custom point
   * resolution function (if set).
   */ getPointResolutionFunc() {
        return this.getPointResolutionFunc_;
    }
}
var $6dc418afeec7068a$export$2e2bcd8739ae039 = $6dc418afeec7068a$var$Projection;

});


parcelRegister("fAlut", function(module, exports) {

$parcel$export(module.exports, "PROJECTIONS", () => $b58ae362632b32c5$export$b508d7ad9a891c1b);
/**
 * @module ol/proj/epsg4326
 */ 
var $9qhtr = parcelRequire("9qhtr");
const $b58ae362632b32c5$export$2d2c9be8b5b863f = 6378137;
const $b58ae362632b32c5$export$21e6da8a7375dfe8 = [
    -180,
    -90,
    180,
    90
];
const $b58ae362632b32c5$export$1482081eec883108 = Math.PI * $b58ae362632b32c5$export$2d2c9be8b5b863f / 180;
/**
 * @classdesc
 * Projection object for WGS84 geographic coordinates (EPSG:4326).
 *
 * Note that OpenLayers does not strictly comply with the EPSG definition.
 * The EPSG registry defines 4326 as a CRS for Latitude,Longitude (y,x).
 * OpenLayers treats EPSG:4326 as a pseudo-projection, with x,y coordinates.
 */ class $b58ae362632b32c5$var$EPSG4326Projection extends (0, $9qhtr.default) {
    /**
   * @param {string} code Code.
   * @param {string} [axisOrientation] Axis orientation.
   */ constructor(code, axisOrientation){
        super({
            code: code,
            units: 'degrees',
            extent: $b58ae362632b32c5$export$21e6da8a7375dfe8,
            axisOrientation: axisOrientation,
            global: true,
            metersPerUnit: $b58ae362632b32c5$export$1482081eec883108,
            worldExtent: $b58ae362632b32c5$export$21e6da8a7375dfe8
        });
    }
}
const $b58ae362632b32c5$export$b508d7ad9a891c1b = [
    new $b58ae362632b32c5$var$EPSG4326Projection('CRS:84'),
    new $b58ae362632b32c5$var$EPSG4326Projection('EPSG:4326', 'neu'),
    new $b58ae362632b32c5$var$EPSG4326Projection('urn:ogc:def:crs:OGC:1.3:CRS84'),
    new $b58ae362632b32c5$var$EPSG4326Projection('urn:ogc:def:crs:OGC:2:84'),
    new $b58ae362632b32c5$var$EPSG4326Projection('http://www.opengis.net/def/crs/OGC/1.3/CRS84'),
    new $b58ae362632b32c5$var$EPSG4326Projection('http://www.opengis.net/gml/srs/epsg.xml#4326', 'neu'),
    new $b58ae362632b32c5$var$EPSG4326Projection('http://www.opengis.net/def/crs/EPSG/0/4326', 'neu')
];

});

parcelRegister("l72II", function(module, exports) {

$parcel$export(module.exports, "clear", () => $f5ec5c943d804ecb$export$42ffd38884aecdac);
$parcel$export(module.exports, "get", () => $f5ec5c943d804ecb$export$3988ae62b71be9a3);
$parcel$export(module.exports, "add", () => $f5ec5c943d804ecb$export$e16d8520af44a096);
/**
 * @module ol/proj/projections
 */ /**
 * @type {Object<string, import("./Projection.js").default>}
 */ let $f5ec5c943d804ecb$var$cache = {};
function $f5ec5c943d804ecb$export$42ffd38884aecdac() {
    $f5ec5c943d804ecb$var$cache = {};
}
function $f5ec5c943d804ecb$export$3988ae62b71be9a3(code) {
    return $f5ec5c943d804ecb$var$cache[code] || $f5ec5c943d804ecb$var$cache[code.replace(/urn:(x-)?ogc:def:crs:EPSG:(.*:)?(\w+)$/, 'EPSG:$3')] || null;
}
function $f5ec5c943d804ecb$export$e16d8520af44a096(code, projection) {
    $f5ec5c943d804ecb$var$cache[code] = projection;
}

});

parcelRegister("1wgRP", function(module, exports) {

$parcel$export(module.exports, "clear", () => $11b5dd198626e1de$export$42ffd38884aecdac);
$parcel$export(module.exports, "add", () => $11b5dd198626e1de$export$e16d8520af44a096);
$parcel$export(module.exports, "get", () => $11b5dd198626e1de$export$3988ae62b71be9a3);
/**
 * @module ol/proj/transforms
 */ 
var $gn0g3 = parcelRequire("gn0g3");
/**
 * @private
 * @type {!Object<string, Object<string, import("../proj.js").TransformFunction>>}
 */ let $11b5dd198626e1de$var$transforms = {};
function $11b5dd198626e1de$export$42ffd38884aecdac() {
    $11b5dd198626e1de$var$transforms = {};
}
function $11b5dd198626e1de$export$e16d8520af44a096(source, destination, transformFn) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    if (!(sourceCode in $11b5dd198626e1de$var$transforms)) $11b5dd198626e1de$var$transforms[sourceCode] = {};
    $11b5dd198626e1de$var$transforms[sourceCode][destinationCode] = transformFn;
}
function $11b5dd198626e1de$export$cd7f480d6b8286c3(source, destination) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    const transform = $11b5dd198626e1de$var$transforms[sourceCode][destinationCode];
    delete $11b5dd198626e1de$var$transforms[sourceCode][destinationCode];
    if ((0, $gn0g3.isEmpty)($11b5dd198626e1de$var$transforms[sourceCode])) delete $11b5dd198626e1de$var$transforms[sourceCode];
    return transform;
}
function $11b5dd198626e1de$export$3988ae62b71be9a3(sourceCode, destinationCode) {
    if (sourceCode in $11b5dd198626e1de$var$transforms && destinationCode in $11b5dd198626e1de$var$transforms[sourceCode]) return $11b5dd198626e1de$var$transforms[sourceCode][destinationCode];
    return null;
}

});
parcelRegister("gn0g3", function(module, exports) {

$parcel$export(module.exports, "clear", () => $beaefe87199bb537$export$42ffd38884aecdac);
$parcel$export(module.exports, "isEmpty", () => $beaefe87199bb537$export$dd1bc94b04021eeb);
/**
 * @module ol/obj
 */ /**
 * Removes all properties from an object.
 * @param {Object<string, unknown>} object The object to clear.
 */ function $beaefe87199bb537$export$42ffd38884aecdac(object) {
    for(const property in object)delete object[property];
}
function $beaefe87199bb537$export$dd1bc94b04021eeb(object) {
    let property;
    for(property in object)return false;
    return !property;
}

});


parcelRegister("8acUl", function(module, exports) {

$parcel$export(module.exports, "makeProjection", () => $5f19451ebc03a1eb$export$3277980d225b59be);
$parcel$export(module.exports, "makeTransforms", () => $5f19451ebc03a1eb$export$f94509e55523febf);
/**
 * @module ol/proj/utm
 */ /**
 * Adapted from https://github.com/Turbo87/utm
 * Copyright (c) 2012-2017 Tobias Bieniek
 *
 * The functions here provide approximate transforms to and from UTM.
 * They are not appropriate for use beyond the validity extend of a UTM
 * zone, and the accuracy of the transform decreases toward the zone
 * edges.
 */ 
var $9byFX = parcelRequire("9byFX");

var $9qhtr = parcelRequire("9qhtr");
/**
 * @typedef {Object} UTMZone
 * @property {number} number The zone number (1 - 60).
 * @property {boolean} north The northern hemisphere.
 */ const $5f19451ebc03a1eb$var$K0 = 0.9996;
const $5f19451ebc03a1eb$var$E = 0.00669438;
const $5f19451ebc03a1eb$var$E2 = $5f19451ebc03a1eb$var$E * $5f19451ebc03a1eb$var$E;
const $5f19451ebc03a1eb$var$E3 = $5f19451ebc03a1eb$var$E2 * $5f19451ebc03a1eb$var$E;
const $5f19451ebc03a1eb$var$E_P2 = $5f19451ebc03a1eb$var$E / (1 - $5f19451ebc03a1eb$var$E);
const $5f19451ebc03a1eb$var$SQRT_E = Math.sqrt(1 - $5f19451ebc03a1eb$var$E);
const $5f19451ebc03a1eb$var$_E = (1 - $5f19451ebc03a1eb$var$SQRT_E) / (1 + $5f19451ebc03a1eb$var$SQRT_E);
const $5f19451ebc03a1eb$var$_E2 = $5f19451ebc03a1eb$var$_E * $5f19451ebc03a1eb$var$_E;
const $5f19451ebc03a1eb$var$_E3 = $5f19451ebc03a1eb$var$_E2 * $5f19451ebc03a1eb$var$_E;
const $5f19451ebc03a1eb$var$_E4 = $5f19451ebc03a1eb$var$_E3 * $5f19451ebc03a1eb$var$_E;
const $5f19451ebc03a1eb$var$_E5 = $5f19451ebc03a1eb$var$_E4 * $5f19451ebc03a1eb$var$_E;
const $5f19451ebc03a1eb$var$M1 = 1 - $5f19451ebc03a1eb$var$E / 4 - 3 * $5f19451ebc03a1eb$var$E2 / 64 - 5 * $5f19451ebc03a1eb$var$E3 / 256;
const $5f19451ebc03a1eb$var$M2 = 3 * $5f19451ebc03a1eb$var$E / 8 + 3 * $5f19451ebc03a1eb$var$E2 / 32 + 45 * $5f19451ebc03a1eb$var$E3 / 1024;
const $5f19451ebc03a1eb$var$M3 = 15 * $5f19451ebc03a1eb$var$E2 / 256 + 45 * $5f19451ebc03a1eb$var$E3 / 1024;
const $5f19451ebc03a1eb$var$M4 = 35 * $5f19451ebc03a1eb$var$E3 / 3072;
const $5f19451ebc03a1eb$var$P2 = 1.5 * $5f19451ebc03a1eb$var$_E - 27 / 32 * $5f19451ebc03a1eb$var$_E3 + 269 / 512 * $5f19451ebc03a1eb$var$_E5;
const $5f19451ebc03a1eb$var$P3 = 21 / 16 * $5f19451ebc03a1eb$var$_E2 - 55 / 32 * $5f19451ebc03a1eb$var$_E4;
const $5f19451ebc03a1eb$var$P4 = 151 / 96 * $5f19451ebc03a1eb$var$_E3 - 417 / 128 * $5f19451ebc03a1eb$var$_E5;
const $5f19451ebc03a1eb$var$P5 = 1097 / 512 * $5f19451ebc03a1eb$var$_E4;
const $5f19451ebc03a1eb$var$R = 6378137;
/**
 * @param {number} easting Easting value of coordinate.
 * @param {number} northing Northing value of coordinate.
 * @param {UTMZone} zone The UTM zone.
 * @return {import("../coordinate.js").Coordinate} The transformed coordinate.
 */ function $5f19451ebc03a1eb$var$toLonLat(easting, northing, zone) {
    const x = easting - 500000;
    const y = zone.north ? northing : northing - 10000000;
    const m = y / $5f19451ebc03a1eb$var$K0;
    const mu = m / ($5f19451ebc03a1eb$var$R * $5f19451ebc03a1eb$var$M1);
    const pRad = mu + $5f19451ebc03a1eb$var$P2 * Math.sin(2 * mu) + $5f19451ebc03a1eb$var$P3 * Math.sin(4 * mu) + $5f19451ebc03a1eb$var$P4 * Math.sin(6 * mu) + $5f19451ebc03a1eb$var$P5 * Math.sin(8 * mu);
    const pSin = Math.sin(pRad);
    const pSin2 = pSin * pSin;
    const pCos = Math.cos(pRad);
    const pTan = pSin / pCos;
    const pTan2 = pTan * pTan;
    const pTan4 = pTan2 * pTan2;
    const epSin = 1 - $5f19451ebc03a1eb$var$E * pSin2;
    const epSinSqrt = Math.sqrt(1 - $5f19451ebc03a1eb$var$E * pSin2);
    const n = $5f19451ebc03a1eb$var$R / epSinSqrt;
    const r = (1 - $5f19451ebc03a1eb$var$E) / epSin;
    const c = $5f19451ebc03a1eb$var$E_P2 * pCos ** 2;
    const c2 = c * c;
    const d = x / (n * $5f19451ebc03a1eb$var$K0);
    const d2 = d * d;
    const d3 = d2 * d;
    const d4 = d3 * d;
    const d5 = d4 * d;
    const d6 = d5 * d;
    const latitude = pRad - pTan / r * (d2 / 2 - d4 / 24 * (5 + 3 * pTan2 + 10 * c - 4 * c2 - 9 * $5f19451ebc03a1eb$var$E_P2)) + d6 / 720 * (61 + 90 * pTan2 + 298 * c + 45 * pTan4 - 252 * $5f19451ebc03a1eb$var$E_P2 - 3 * c2);
    let longitude = (d - d3 / 6 * (1 + 2 * pTan2 + c) + d5 / 120 * (5 - 2 * c + 28 * pTan2 - 3 * c2 + 8 * $5f19451ebc03a1eb$var$E_P2 + 24 * pTan4)) / pCos;
    longitude = (0, $9byFX.wrap)(longitude + (0, $9byFX.toRadians)($5f19451ebc03a1eb$var$zoneToCentralLongitude(zone.number)), -Math.PI, Math.PI);
    return [
        (0, $9byFX.toDegrees)(longitude),
        (0, $9byFX.toDegrees)(latitude)
    ];
}
const $5f19451ebc03a1eb$var$MIN_LATITUDE = -80;
const $5f19451ebc03a1eb$var$MAX_LATITUDE = 84;
const $5f19451ebc03a1eb$var$MIN_LONGITUDE = -180;
const $5f19451ebc03a1eb$var$MAX_LONGITUDE = 180;
/**
 * @param {number} longitude The longitude.
 * @param {number} latitude The latitude.
 * @param {UTMZone} zone The UTM zone.
 * @return {import('../coordinate.js').Coordinate} The UTM coordinate.
 */ function $5f19451ebc03a1eb$var$fromLonLat(longitude, latitude, zone) {
    longitude = (0, $9byFX.wrap)(longitude, $5f19451ebc03a1eb$var$MIN_LONGITUDE, $5f19451ebc03a1eb$var$MAX_LONGITUDE);
    if (latitude < $5f19451ebc03a1eb$var$MIN_LATITUDE) latitude = $5f19451ebc03a1eb$var$MIN_LATITUDE;
    else if (latitude > $5f19451ebc03a1eb$var$MAX_LATITUDE) latitude = $5f19451ebc03a1eb$var$MAX_LATITUDE;
    const latRad = (0, $9byFX.toRadians)(latitude);
    const latSin = Math.sin(latRad);
    const latCos = Math.cos(latRad);
    const latTan = latSin / latCos;
    const latTan2 = latTan * latTan;
    const latTan4 = latTan2 * latTan2;
    const lonRad = (0, $9byFX.toRadians)(longitude);
    const centralLon = $5f19451ebc03a1eb$var$zoneToCentralLongitude(zone.number);
    const centralLonRad = (0, $9byFX.toRadians)(centralLon);
    const n = $5f19451ebc03a1eb$var$R / Math.sqrt(1 - $5f19451ebc03a1eb$var$E * latSin ** 2);
    const c = $5f19451ebc03a1eb$var$E_P2 * latCos ** 2;
    const a = latCos * (0, $9byFX.wrap)(lonRad - centralLonRad, -Math.PI, Math.PI);
    const a2 = a * a;
    const a3 = a2 * a;
    const a4 = a3 * a;
    const a5 = a4 * a;
    const a6 = a5 * a;
    const m = $5f19451ebc03a1eb$var$R * ($5f19451ebc03a1eb$var$M1 * latRad - $5f19451ebc03a1eb$var$M2 * Math.sin(2 * latRad) + $5f19451ebc03a1eb$var$M3 * Math.sin(4 * latRad) - $5f19451ebc03a1eb$var$M4 * Math.sin(6 * latRad));
    const easting = $5f19451ebc03a1eb$var$K0 * n * (a + a3 / 6 * (1 - latTan2 + c) + a5 / 120 * (5 - 18 * latTan2 + latTan4 + 72 * c - 58 * $5f19451ebc03a1eb$var$E_P2)) + 500000;
    let northing = $5f19451ebc03a1eb$var$K0 * (m + n * latTan * (a2 / 2 + a4 / 24 * (5 - latTan2 + 9 * c + 4 * c ** 2) + a6 / 720 * (61 - 58 * latTan2 + latTan4 + 600 * c - 330 * $5f19451ebc03a1eb$var$E_P2)));
    if (!zone.north) northing += 10000000;
    return [
        easting,
        northing
    ];
}
/**
 * @param {number} zone The zone number.
 * @return {number} The central longitude in degrees.
 */ function $5f19451ebc03a1eb$var$zoneToCentralLongitude(zone) {
    return (zone - 1) * 6 - 180 + 3;
}
/**
 * @type {Array<RegExp>}
 */ const $5f19451ebc03a1eb$var$epsgRegExes = [
    /^EPSG:(\d+)$/,
    /^urn:ogc:def:crs:EPSG::(\d+)$/,
    /^http:\/\/www\.opengis\.net\/def\/crs\/EPSG\/0\/(\d+)$/
];
function $5f19451ebc03a1eb$export$bb54dc52a08ed170(code) {
    let epsgId = 0;
    for (const re of $5f19451ebc03a1eb$var$epsgRegExes){
        const match = code.match(re);
        if (match) {
            epsgId = parseInt(match[1]);
            break;
        }
    }
    if (!epsgId) return null;
    let number = 0;
    let north = false;
    if (epsgId > 32700 && epsgId < 32761) number = epsgId - 32700;
    else if (epsgId > 32600 && epsgId < 32661) {
        north = true;
        number = epsgId - 32600;
    }
    if (!number) return null;
    return {
        number: number,
        north: north
    };
}
/**
 * @param {function(number, number, UTMZone): import('../coordinate.js').Coordinate} transformer The transformer.
 * @param {UTMZone} zone The UTM zone.
 * @return {import('../proj.js').TransformFunction} The transform function.
 */ function $5f19451ebc03a1eb$var$makeTransformFunction(transformer, zone) {
    return function(input, output, dimension, stride) {
        const length = input.length;
        dimension = dimension > 1 ? dimension : 2;
        stride = stride ?? dimension;
        if (!output) {
            if (dimension > 2) output = input.slice();
            else output = new Array(length);
        }
        for(let i = 0; i < length; i += stride){
            const x = input[i];
            const y = input[i + 1];
            const coord = transformer(x, y, zone);
            output[i] = coord[0];
            output[i + 1] = coord[1];
        }
        return output;
    };
}
function $5f19451ebc03a1eb$export$3277980d225b59be(code) {
    const zone = $5f19451ebc03a1eb$export$bb54dc52a08ed170(code);
    if (!zone) return null;
    return new (0, $9qhtr.default)({
        code: code,
        units: 'm'
    });
}
function $5f19451ebc03a1eb$export$f94509e55523febf(projection) {
    const zone = $5f19451ebc03a1eb$export$bb54dc52a08ed170(projection.getCode());
    if (!zone) return null;
    return {
        forward: $5f19451ebc03a1eb$var$makeTransformFunction($5f19451ebc03a1eb$var$fromLonLat, zone),
        inverse: $5f19451ebc03a1eb$var$makeTransformFunction($5f19451ebc03a1eb$var$toLonLat, zone)
    };
}

});

parcelRegister("lAvh5", function(module, exports) {

$parcel$export(module.exports, "getDistance", () => $fb75384508533d8f$export$79376507b09a66f);
$parcel$export(module.exports, "offset", () => $fb75384508533d8f$export$cc800923e997bb8);
/**
 * @module ol/sphere
 */ 
var $9byFX = parcelRequire("9byFX");
const $fb75384508533d8f$export$63f2df7bd7371262 = 6371008.8;
function $fb75384508533d8f$export$79376507b09a66f(c1, c2, radius) {
    radius = radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const lat1 = (0, $9byFX.toRadians)(c1[1]);
    const lat2 = (0, $9byFX.toRadians)(c2[1]);
    const deltaLatBy2 = (lat2 - lat1) / 2;
    const deltaLonBy2 = (0, $9byFX.toRadians)(c2[0] - c1[0]) / 2;
    const a = Math.sin(deltaLatBy2) * Math.sin(deltaLatBy2) + Math.sin(deltaLonBy2) * Math.sin(deltaLonBy2) * Math.cos(lat1) * Math.cos(lat2);
    return 2 * radius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
/**
 * Get the cumulative great circle length of linestring coordinates (geographic).
 * @param {Array} coordinates Linestring coordinates.
 * @param {number} radius The sphere radius to use.
 * @return {number} The length (in meters).
 */ function $fb75384508533d8f$var$getLengthInternal(coordinates, radius) {
    let length = 0;
    for(let i = 0, ii = coordinates.length; i < ii - 1; ++i)length += $fb75384508533d8f$export$79376507b09a66f(coordinates[i], coordinates[i + 1], radius);
    return length;
}
function $fb75384508533d8f$export$f0d11c074a923179(geometry, options) {
    options = options || {};
    const radius = options.radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const projection = options.projection || 'EPSG:3857';
    const type = geometry.getType();
    if (type !== 'GeometryCollection') geometry = geometry.clone().transform(projection, 'EPSG:4326');
    let length = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case 'Point':
        case 'MultiPoint':
            break;
        case 'LineString':
        case 'LinearRing':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            length = $fb75384508533d8f$var$getLengthInternal(coordinates, radius);
            break;
        case 'MultiLineString':
        case 'Polygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i)length += $fb75384508533d8f$var$getLengthInternal(coordinates[i], radius);
            break;
        case 'MultiPolygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                for(j = 0, jj = coords.length; j < jj; ++j)length += $fb75384508533d8f$var$getLengthInternal(coords[j], radius);
            }
            break;
        case 'GeometryCollection':
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)length += $fb75384508533d8f$export$f0d11c074a923179(geometries[i], options);
                break;
            }
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return length;
}
/**
 * Returns the spherical area for a list of coordinates.
 *
 * [Reference](https://trs.jpl.nasa.gov/handle/2014/40409)
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for
 * Polygons on a Sphere", JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007
 *
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates List of coordinates of a linear
 * ring. If the ring is oriented clockwise, the area will be positive,
 * otherwise it will be negative.
 * @param {number} radius The sphere radius.
 * @return {number} Area (in square meters).
 */ function $fb75384508533d8f$var$getAreaInternal(coordinates, radius) {
    let area = 0;
    const len = coordinates.length;
    let x1 = coordinates[len - 1][0];
    let y1 = coordinates[len - 1][1];
    for(let i = 0; i < len; i++){
        const x2 = coordinates[i][0];
        const y2 = coordinates[i][1];
        area += (0, $9byFX.toRadians)(x2 - x1) * (2 + Math.sin((0, $9byFX.toRadians)(y1)) + Math.sin((0, $9byFX.toRadians)(y2)));
        x1 = x2;
        y1 = y2;
    }
    return area * radius * radius / 2.0;
}
function $fb75384508533d8f$export$520c40045967cb15(geometry, options) {
    options = options || {};
    const radius = options.radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const projection = options.projection || 'EPSG:3857';
    const type = geometry.getType();
    if (type !== 'GeometryCollection') geometry = geometry.clone().transform(projection, 'EPSG:4326');
    let area = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case 'Point':
        case 'MultiPoint':
        case 'LineString':
        case 'MultiLineString':
        case 'LinearRing':
            break;
        case 'Polygon':
            coordinates = /** @type {import("./geom/Polygon.js").default} */ geometry.getCoordinates();
            area = Math.abs($fb75384508533d8f$var$getAreaInternal(coordinates[0], radius));
            for(i = 1, ii = coordinates.length; i < ii; ++i)area -= Math.abs($fb75384508533d8f$var$getAreaInternal(coordinates[i], radius));
            break;
        case 'MultiPolygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                area += Math.abs($fb75384508533d8f$var$getAreaInternal(coords[0], radius));
                for(j = 1, jj = coords.length; j < jj; ++j)area -= Math.abs($fb75384508533d8f$var$getAreaInternal(coords[j], radius));
            }
            break;
        case 'GeometryCollection':
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)area += $fb75384508533d8f$export$520c40045967cb15(geometries[i], options);
                break;
            }
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return area;
}
function $fb75384508533d8f$export$cc800923e997bb8(c1, distance, bearing, radius) {
    radius = radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const lat1 = (0, $9byFX.toRadians)(c1[1]);
    const lon1 = (0, $9byFX.toRadians)(c1[0]);
    const dByR = distance / radius;
    const lat = Math.asin(Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing));
    const lon = lon1 + Math.atan2(Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1), Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat));
    return [
        (0, $9byFX.toDegrees)(lon),
        (0, $9byFX.toDegrees)(lat)
    ];
}

});


parcelRegister("jpXrt", function(module, exports) {

$parcel$export(module.exports, "create", () => $e22e7611e69f42a9$export$185802fd694ee1f5);
$parcel$export(module.exports, "setFromArray", () => $e22e7611e69f42a9$export$42b4187a82d80ed0);
$parcel$export(module.exports, "apply", () => $e22e7611e69f42a9$export$5635d7ef4b8fee1c);
$parcel$export(module.exports, "compose", () => $e22e7611e69f42a9$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "toString", () => $e22e7611e69f42a9$export$f84e8e69fd4488a5);
$parcel$export(module.exports, "makeInverse", () => $e22e7611e69f42a9$export$bd70ea2a93c0fa4);
$parcel$export(module.exports, "fromString", () => $e22e7611e69f42a9$export$3004f64547af360e);
$parcel$export(module.exports, "equivalent", () => $e22e7611e69f42a9$export$fe091d73a555748b);
/**
 * @module ol/transform
 */ 
var $4Cz58 = parcelRequire("4Cz58");
/**
 * An array representing an affine 2d transformation for use with
 * {@link module:ol/transform} functions. The array has 6 elements.
 * @typedef {!Array<number>} Transform
 * @api
 */ /**
 * Collection of affine 2d transformation functions. The functions work on an
 * array of 6 elements. The element order is compatible with the [SVGMatrix
 * interface](https://developer.mozilla.org/en-US/docs/Web/API/SVGMatrix) and is
 * a subset (elements a to f) of a 3×3 matrix:
 * ```
 * [ a c e ]
 * [ b d f ]
 * [ 0 0 1 ]
 * ```
 */ /**
 * @private
 * @type {Transform}
 */ const $e22e7611e69f42a9$var$tmp_ = new Array(6);
function $e22e7611e69f42a9$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $e22e7611e69f42a9$export$aad8462122ac592b(transform) {
    return $e22e7611e69f42a9$export$adaa4cf7ef1b65be(transform, 1, 0, 0, 1, 0, 0);
}
function $e22e7611e69f42a9$export$2060d2db72cce88f(transform1, transform2) {
    const a1 = transform1[0];
    const b1 = transform1[1];
    const c1 = transform1[2];
    const d1 = transform1[3];
    const e1 = transform1[4];
    const f1 = transform1[5];
    const a2 = transform2[0];
    const b2 = transform2[1];
    const c2 = transform2[2];
    const d2 = transform2[3];
    const e2 = transform2[4];
    const f2 = transform2[5];
    transform1[0] = a1 * a2 + c1 * b2;
    transform1[1] = b1 * a2 + d1 * b2;
    transform1[2] = a1 * c2 + c1 * d2;
    transform1[3] = b1 * c2 + d1 * d2;
    transform1[4] = a1 * e2 + c1 * f2 + e1;
    transform1[5] = b1 * e2 + d1 * f2 + f1;
    return transform1;
}
function $e22e7611e69f42a9$export$adaa4cf7ef1b65be(transform, a, b, c, d, e, f) {
    transform[0] = a;
    transform[1] = b;
    transform[2] = c;
    transform[3] = d;
    transform[4] = e;
    transform[5] = f;
    return transform;
}
function $e22e7611e69f42a9$export$42b4187a82d80ed0(transform1, transform2) {
    transform1[0] = transform2[0];
    transform1[1] = transform2[1];
    transform1[2] = transform2[2];
    transform1[3] = transform2[3];
    transform1[4] = transform2[4];
    transform1[5] = transform2[5];
    return transform1;
}
function $e22e7611e69f42a9$export$5635d7ef4b8fee1c(transform, coordinate) {
    const x = coordinate[0];
    const y = coordinate[1];
    coordinate[0] = transform[0] * x + transform[2] * y + transform[4];
    coordinate[1] = transform[1] * x + transform[3] * y + transform[5];
    return coordinate;
}
function $e22e7611e69f42a9$export$bb628a54ab399bc9(transform, angle) {
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    return $e22e7611e69f42a9$export$2060d2db72cce88f(transform, $e22e7611e69f42a9$export$adaa4cf7ef1b65be($e22e7611e69f42a9$var$tmp_, cos, sin, -sin, cos, 0, 0));
}
function $e22e7611e69f42a9$export$dcdf75081b88279d(transform, x, y) {
    return $e22e7611e69f42a9$export$2060d2db72cce88f(transform, $e22e7611e69f42a9$export$adaa4cf7ef1b65be($e22e7611e69f42a9$var$tmp_, x, 0, 0, y, 0, 0));
}
function $e22e7611e69f42a9$export$3e4e33ea14aeb531(target, x, y) {
    return $e22e7611e69f42a9$export$adaa4cf7ef1b65be(target, x, 0, 0, y, 0, 0);
}
function $e22e7611e69f42a9$export$d73ee8ef04f5226a(transform, dx, dy) {
    return $e22e7611e69f42a9$export$2060d2db72cce88f(transform, $e22e7611e69f42a9$export$adaa4cf7ef1b65be($e22e7611e69f42a9$var$tmp_, 1, 0, 0, 1, dx, dy));
}
function $e22e7611e69f42a9$export$f672e0b6f7222cd7(transform, dx1, dy1, sx, sy, angle, dx2, dy2) {
    const sin = Math.sin(angle);
    const cos = Math.cos(angle);
    transform[0] = sx * cos;
    transform[1] = sy * sin;
    transform[2] = -sx * sin;
    transform[3] = sy * cos;
    transform[4] = dx2 * sx * cos - dy2 * sx * sin + dx1;
    transform[5] = dx2 * sy * sin + dy2 * sy * cos + dy1;
    return transform;
}
function $e22e7611e69f42a9$export$12a96a1aaf5558e3(dx1, dy1, sx, sy, angle, dx2, dy2) {
    return $e22e7611e69f42a9$export$f84e8e69fd4488a5($e22e7611e69f42a9$export$f672e0b6f7222cd7($e22e7611e69f42a9$export$185802fd694ee1f5(), dx1, dy1, sx, sy, angle, dx2, dy2));
}
function $e22e7611e69f42a9$export$6897c284b6f9f4dc(source) {
    return $e22e7611e69f42a9$export$bd70ea2a93c0fa4(source, source);
}
function $e22e7611e69f42a9$export$bd70ea2a93c0fa4(target, source) {
    const det = $e22e7611e69f42a9$export$a04698f914c55ed9(source);
    (0, $4Cz58.assert)(det !== 0, 'Transformation matrix cannot be inverted');
    const a = source[0];
    const b = source[1];
    const c = source[2];
    const d = source[3];
    const e = source[4];
    const f = source[5];
    target[0] = d / det;
    target[1] = -b / det;
    target[2] = -c / det;
    target[3] = a / det;
    target[4] = (c * f - d * e) / det;
    target[5] = -(a * f - b * e) / det;
    return target;
}
function $e22e7611e69f42a9$export$a04698f914c55ed9(mat) {
    return mat[0] * mat[3] - mat[1] * mat[2];
}
/**
 * @type {Array}
 */ const $e22e7611e69f42a9$var$matrixPrecision = [
    1e5,
    1e5,
    1e5,
    1e5,
    2,
    2
];
function $e22e7611e69f42a9$export$f84e8e69fd4488a5(mat) {
    const transformString = 'matrix(' + mat.join(', ') + ')';
    return transformString;
}
function $e22e7611e69f42a9$export$3004f64547af360e(cssTransform) {
    const values = cssTransform.substring(7, cssTransform.length - 1).split(',');
    return values.map(parseFloat);
}
function $e22e7611e69f42a9$export$fe091d73a555748b(cssTransform1, cssTransform2) {
    const mat1 = $e22e7611e69f42a9$export$3004f64547af360e(cssTransform1);
    const mat2 = $e22e7611e69f42a9$export$3004f64547af360e(cssTransform2);
    for(let i = 0; i < 6; ++i){
        if (Math.round((mat1[i] - mat2[i]) * $e22e7611e69f42a9$var$matrixPrecision[i]) !== 0) return false;
    }
    return true;
}

});
parcelRegister("4Cz58", function(module, exports) {

$parcel$export(module.exports, "assert", () => $35d5ec884318008e$export$a7a9523472993e97);
/**
 * @module ol/asserts
 */ /**
 * @param {*} assertion Assertion we expected to be truthy.
 * @param {string} errorMessage Error message.
 */ function $35d5ec884318008e$export$a7a9523472993e97(assertion, errorMessage) {
    if (!assertion) throw new Error(errorMessage);
}

});


parcelRegister("5FKVH", function(module, exports) {

$parcel$export(module.exports, "canvasPool", () => $42152f52b26b6ca7$export$a166f0857c555517);
$parcel$export(module.exports, "default", () => $42152f52b26b6ca7$export$2e2bcd8739ae039);
/**
 * @module ol/renderer/canvas/Layer
 */ 
var $fVVyM = parcelRequire("fVVyM");

var $4iSHH = parcelRequire("4iSHH");

var $DfnQm = parcelRequire("DfnQm");

var $9pD6L = parcelRequire("9pD6L");

var $8UoiJ = parcelRequire("8UoiJ");

var $fNIok = parcelRequire("fNIok");

var $l6YBe = parcelRequire("l6YBe");

var $gDySU = parcelRequire("gDySU");

var $jpXrt = parcelRequire("jpXrt");

var $hr4Xu = parcelRequire("hr4Xu");
const $42152f52b26b6ca7$export$a166f0857c555517 = [];
/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
 */ let $42152f52b26b6ca7$var$pixelContext = null;
function $42152f52b26b6ca7$var$createPixelContext() {
    $42152f52b26b6ca7$var$pixelContext = (0, $DfnQm.createCanvasContext2D)(1, 1, undefined, {
        willReadFrequently: true
    });
}
/**
 * @abstract
 * @template {import("../../layer/Layer.js").default} LayerType
 * @extends {LayerRenderer<LayerType>}
 */ class $42152f52b26b6ca7$var$CanvasLayerRenderer extends (0, $hr4Xu.default) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super(layer);
        /**
     * HTMLElement container for the layer to be rendered in.
     * @protected
     * @type {HTMLElement}
     */ this.container = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedResolution;
        /**
     * A temporary transform.  The values in this transform should only be used in a
     * function that sets the values.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.tempTransform = (0, $jpXrt.create)();
        /**
     * The transform for rendered pixels to viewport CSS pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.pixelTransform = (0, $jpXrt.create)();
        /**
     * The transform for viewport CSS pixels to rendered pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.inversePixelTransform = (0, $jpXrt.create)();
        /**
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.context = null;
        /**
     * @private
     * @type {ZIndexContext}
     */ this.deferredContext_ = null;
        /**
     * true if the container has been reused from the previous renderer
     * @type {boolean}
     */ this.containerReused = false;
        /**
     * @protected
     * @type {import("../../Map.js").FrameState|null}
     */ this.frameState = null;
    }
    /**
   * @param {import('../../DataTile.js').ImageLike} image Image.
   * @param {number} col The column index.
   * @param {number} row The row index.
   * @return {Uint8ClampedArray|null} The image data.
   */ getImageData(image, col, row) {
        if (!$42152f52b26b6ca7$var$pixelContext) $42152f52b26b6ca7$var$createPixelContext();
        $42152f52b26b6ca7$var$pixelContext.clearRect(0, 0, 1, 1);
        let data;
        try {
            $42152f52b26b6ca7$var$pixelContext.drawImage(image, col, row, 1, 1, 0, 0, 1, 1);
            data = $42152f52b26b6ca7$var$pixelContext.getImageData(0, 0, 1, 1).data;
        } catch  {
            $42152f52b26b6ca7$var$pixelContext = null;
            return null;
        }
        return data;
    }
    /**
   * @param {import('../../Map.js').FrameState} frameState Frame state.
   * @return {string} Background color.
   */ getBackground(frameState) {
        const layer = this.getLayer();
        let background = layer.getBackground();
        if (typeof background === 'function') background = background(frameState.viewState.resolution);
        return background || undefined;
    }
    /**
   * Get a rendering container from an existing target, if compatible.
   * @param {HTMLElement} target Potential render target.
   * @param {string} transform CSS transform matrix.
   * @param {string} [backgroundColor] Background color.
   */ useContainer(target, transform, backgroundColor) {
        // renderer canvas to target canvas
        const layerClassName = this.getLayer().getClassName();
        let container, context;
        if (target && target.className === layerClassName && (!backgroundColor || target && target.style.backgroundColor && (0, $fVVyM.equals)((0, $4iSHH.asArray)(target.style.backgroundColor), (0, $4iSHH.asArray)(backgroundColor)))) {
            const canvas = target.firstElementChild;
            if ((0, $DfnQm.isCanvas)(canvas)) context = canvas.getContext('2d');
        }
        if (context && (0, $jpXrt.equivalent)(context.canvas.style.transform, transform)) {
            // Container of the previous layer renderer can be used.
            this.container = target;
            this.context = context;
            this.containerReused = true;
        } else if (this.containerReused) {
            // Previously reused container cannot be used any more.
            this.container = null;
            this.context = null;
            this.containerReused = false;
        } else if (this.container) this.container.style.backgroundColor = null;
        if (!this.container) {
            container = (0, $8UoiJ.WORKER_OFFSCREEN_CANVAS) ? (0, $DfnQm.createMockDiv)() : document.createElement('div');
            container.className = layerClassName;
            let style = container.style;
            style.position = 'absolute';
            style.width = '100%';
            style.height = '100%';
            context = (0, $DfnQm.createCanvasContext2D)();
            const canvas = /** @type {HTMLCanvasElement} */ context.canvas;
            container.appendChild(canvas);
            style = canvas.style;
            style.position = 'absolute';
            style.left = '0';
            style.transformOrigin = 'top left';
            this.container = container;
            this.context = context;
        }
        if (!this.containerReused && backgroundColor && !this.container.style.backgroundColor) this.container.style.backgroundColor = backgroundColor;
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent Clip extent.
   * @protected
   */ clipUnrotated(context, frameState, extent) {
        const topLeft = (0, $9pD6L.getTopLeft)(extent);
        const topRight = (0, $9pD6L.getTopRight)(extent);
        const bottomRight = (0, $9pD6L.getBottomRight)(extent);
        const bottomLeft = (0, $9pD6L.getBottomLeft)(extent);
        (0, $jpXrt.apply)(frameState.coordinateToPixelTransform, topLeft);
        (0, $jpXrt.apply)(frameState.coordinateToPixelTransform, topRight);
        (0, $jpXrt.apply)(frameState.coordinateToPixelTransform, bottomRight);
        (0, $jpXrt.apply)(frameState.coordinateToPixelTransform, bottomLeft);
        const inverted = this.inversePixelTransform;
        (0, $jpXrt.apply)(inverted, topLeft);
        (0, $jpXrt.apply)(inverted, topRight);
        (0, $jpXrt.apply)(inverted, bottomRight);
        (0, $jpXrt.apply)(inverted, bottomLeft);
        context.save();
        context.beginPath();
        context.moveTo(Math.round(topLeft[0]), Math.round(topLeft[1]));
        context.lineTo(Math.round(topRight[0]), Math.round(topRight[1]));
        context.lineTo(Math.round(bottomRight[0]), Math.round(bottomRight[1]));
        context.lineTo(Math.round(bottomLeft[0]), Math.round(bottomLeft[1]));
        context.clip();
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @protected
   */ prepareContainer(frameState, target) {
        const extent = frameState.extent;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const pixelRatio = frameState.pixelRatio;
        const width = Math.round((0, $9pD6L.getWidth)(extent) / resolution * pixelRatio);
        const height = Math.round((0, $9pD6L.getHeight)(extent) / resolution * pixelRatio);
        // set forward and inverse pixel transforms
        (0, $jpXrt.compose)(this.pixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / pixelRatio, 1 / pixelRatio, rotation, -width / 2, -height / 2);
        (0, $jpXrt.makeInverse)(this.inversePixelTransform, this.pixelTransform);
        const canvasTransform = (0, $jpXrt.toString)(this.pixelTransform);
        this.useContainer(target, canvasTransform, this.getBackground(frameState));
        if (!this.containerReused) {
            const canvas = this.context.canvas;
            if (canvas.width != width || canvas.height != height) {
                canvas.width = width;
                canvas.height = height;
            } else this.context.clearRect(0, 0, width, height);
            if (canvasTransform !== /** @type {HTMLCanvasElement} */ canvas.style.transform) /** @type {HTMLCanvasElement} */ canvas.style.transform = canvasTransform;
        }
    }
    /**
   * @param {import("../../render/EventType.js").default} type Event type.
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @private
   */ dispatchRenderEvent_(type, context, frameState) {
        const layer = this.getLayer();
        if (layer.hasListener(type)) {
            const event = new (0, $fNIok.default)(type, this.inversePixelTransform, frameState, context);
            layer.dispatchEvent(event);
        }
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ preRender(context, frameState) {
        this.frameState = frameState;
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, $l6YBe.default).PRERENDER, context, frameState);
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ postRender(context, frameState) {
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, $l6YBe.default).POSTRENDER, context, frameState);
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeferredInternal(frameState) {}
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import('../../render/canvas/ZIndexContext.js').ZIndexContextProxy} Context.
   */ getRenderContext(frameState) {
        if (frameState.declutter && !this.deferredContext_) this.deferredContext_ = new (0, $gDySU.default)();
        return frameState.declutter ? this.deferredContext_.getContext() : this.context;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferred(frameState) {
        if (!frameState.declutter) return;
        this.dispatchRenderEvent_((0, $l6YBe.default).PRERENDER, this.context, frameState);
        if (frameState.declutter && this.deferredContext_) {
            this.deferredContext_.draw(this.context);
            this.deferredContext_.clear();
        }
        this.renderDeferredInternal(frameState);
        this.dispatchRenderEvent_((0, $l6YBe.default).POSTRENDER, this.context, frameState);
    }
    /**
   * Creates a transform for rendering to an element that will be rotated after rendering.
   * @param {import("../../coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} width Width of the rendered element (in pixels).
   * @param {number} height Height of the rendered element (in pixels).
   * @param {number} offsetX Offset on the x-axis in view coordinates.
   * @protected
   * @return {!import("../../transform.js").Transform} Transform.
   */ getRenderTransform(center, resolution, rotation, pixelRatio, width, height, offsetX) {
        const dx1 = width / 2;
        const dy1 = height / 2;
        const sx = pixelRatio / resolution;
        const sy = -sx;
        const dx2 = -center[0] + offsetX;
        const dy2 = -center[1];
        return (0, $jpXrt.compose)(this.tempTransform, dx1, dy1, sx, sy, -rotation, dx2, dy2);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        delete this.frameState;
        super.disposeInternal();
    }
}
var $42152f52b26b6ca7$export$2e2bcd8739ae039 = $42152f52b26b6ca7$var$CanvasLayerRenderer;

});
parcelRegister("fVVyM", function(module, exports) {

$parcel$export(module.exports, "binarySearch", () => $b998d41b678ed5d1$export$2e0ae67339d5f1ac);
$parcel$export(module.exports, "ascending", () => $b998d41b678ed5d1$export$fcb633242ef15540);
$parcel$export(module.exports, "descending", () => $b998d41b678ed5d1$export$4fa3190a997c3d8f);
$parcel$export(module.exports, "linearFindNearest", () => $b998d41b678ed5d1$export$8a3786cc03fdb777);
$parcel$export(module.exports, "reverseSubArray", () => $b998d41b678ed5d1$export$292cfa960964f0e0);
$parcel$export(module.exports, "extend", () => $b998d41b678ed5d1$export$8b58be045bf06082);
$parcel$export(module.exports, "equals", () => $b998d41b678ed5d1$export$e9bab7fafb253603);
$parcel$export(module.exports, "isSorted", () => $b998d41b678ed5d1$export$efa610630f9e181);
/**
 * @module ol/array
 */ /**
 * Performs a binary search on the provided sorted list and returns the index of the item if found. If it can't be found it'll return -1.
 * https://github.com/darkskyapp/binary-search
 *
 * @param {Array<*>} haystack Items to search through.
 * @param {*} needle The item to look for.
 * @param {Function} [comparator] Comparator function.
 * @return {number} The index of the item if found, -1 if not.
 */ function $b998d41b678ed5d1$export$2e0ae67339d5f1ac(haystack, needle, comparator) {
    let mid, cmp;
    comparator = comparator || $b998d41b678ed5d1$export$fcb633242ef15540;
    let low = 0;
    let high = haystack.length;
    let found = false;
    while(low < high){
        /* Note that "(low + high) >>> 1" may overflow, and results in a typecast
     * to double (which gives the wrong results). */ mid = low + (high - low >> 1);
        cmp = +comparator(haystack[mid], needle);
        if (cmp < 0.0) /* Too low. */ low = mid + 1;
        else {
            /* Key found or too high */ high = mid;
            found = !cmp;
        }
    }
    /* Key not found. */ return found ? low : ~low;
}
function $b998d41b678ed5d1$export$fcb633242ef15540(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $b998d41b678ed5d1$export$4fa3190a997c3d8f(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function $b998d41b678ed5d1$export$8a3786cc03fdb777(arr, target, direction) {
    if (arr[0] <= target) return 0;
    const n = arr.length;
    if (target <= arr[n - 1]) return n - 1;
    if (typeof direction === 'function') {
        for(let i = 1; i < n; ++i){
            const candidate = arr[i];
            if (candidate === target) return i;
            if (candidate < target) {
                if (direction(target, arr[i - 1], candidate) > 0) return i - 1;
                return i;
            }
        }
        return n - 1;
    }
    if (direction > 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] < target) return i - 1;
        }
        return n - 1;
    }
    if (direction < 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] <= target) return i;
        }
        return n - 1;
    }
    for(let i = 1; i < n; ++i){
        if (arr[i] == target) return i;
        if (arr[i] < target) {
            if (arr[i - 1] - target < target - arr[i]) return i - 1;
            return i;
        }
    }
    return n - 1;
}
function $b998d41b678ed5d1$export$292cfa960964f0e0(arr, begin, end) {
    while(begin < end){
        const tmp = arr[begin];
        arr[begin] = arr[end];
        arr[end] = tmp;
        ++begin;
        --end;
    }
}
function $b998d41b678ed5d1$export$8b58be045bf06082(arr, data) {
    const extension = Array.isArray(data) ? data : [
        data
    ];
    const length = extension.length;
    for(let i = 0; i < length; i++)arr[arr.length] = extension[i];
}
function $b998d41b678ed5d1$export$cd7f480d6b8286c3(arr, obj) {
    const i = arr.indexOf(obj);
    const found = i > -1;
    if (found) arr.splice(i, 1);
    return found;
}
function $b998d41b678ed5d1$export$e9bab7fafb253603(arr1, arr2) {
    const len1 = arr1.length;
    if (len1 !== arr2.length) return false;
    for(let i = 0; i < len1; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $b998d41b678ed5d1$export$c7d3d1f96a700512(arr, compareFnc) {
    const length = arr.length;
    const tmp = Array(arr.length);
    let i;
    for(i = 0; i < length; i++)tmp[i] = {
        index: i,
        value: arr[i]
    };
    tmp.sort(function(a, b) {
        return compareFnc(a.value, b.value) || a.index - b.index;
    });
    for(i = 0; i < arr.length; i++)arr[i] = tmp[i].value;
}
function $b998d41b678ed5d1$export$efa610630f9e181(arr, func, strict) {
    const compare = func || $b998d41b678ed5d1$export$fcb633242ef15540;
    return arr.every(function(currentVal, index) {
        if (index === 0) return true;
        const res = compare(arr[index - 1], currentVal);
        return !(res > 0 || strict && res === 0);
    });
}

});

parcelRegister("4iSHH", function(module, exports) {

$parcel$export(module.exports, "NO_COLOR", () => $322346e1ff7894ca$export$6c844c64a5efe1ee);
$parcel$export(module.exports, "asString", () => $322346e1ff7894ca$export$590567be997858b6);
$parcel$export(module.exports, "toString", () => $322346e1ff7894ca$export$f84e8e69fd4488a5);
$parcel$export(module.exports, "withAlpha", () => $322346e1ff7894ca$export$138c09bdd6bd797c);
$parcel$export(module.exports, "rgbaToLcha", () => $322346e1ff7894ca$export$44fb54fa2e0c0d4);
$parcel$export(module.exports, "lchaToRgba", () => $322346e1ff7894ca$export$27cc94530c050f00);
$parcel$export(module.exports, "fromString", () => $322346e1ff7894ca$export$3004f64547af360e);
$parcel$export(module.exports, "asArray", () => $322346e1ff7894ca$export$75093a47a9fa838d);
/**
 * @module ol/color
 */ 
var $DfnQm = parcelRequire("DfnQm");

var $9byFX = parcelRequire("9byFX");
const $322346e1ff7894ca$export$6c844c64a5efe1ee = [
    NaN,
    NaN,
    NaN,
    0
];
let $322346e1ff7894ca$var$colorParseContext;
/**
 * @return {CanvasRenderingContext2D} The color parse context
 */ function $322346e1ff7894ca$var$getColorParseContext() {
    if (!$322346e1ff7894ca$var$colorParseContext) $322346e1ff7894ca$var$colorParseContext = (0, $DfnQm.createCanvasContext2D)(1, 1, undefined, {
        willReadFrequently: true,
        desynchronized: true
    });
    return $322346e1ff7894ca$var$colorParseContext;
}
const $322346e1ff7894ca$var$rgbModernRegEx = /^rgba?\(\s*(\d+%?)\s+(\d+%?)\s+(\d+%?)(?:\s*\/\s*(\d+%|\d*\.\d+|[01]))?\s*\)$/i;
const $322346e1ff7894ca$var$rgbLegacyAbsoluteRegEx = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*(\d+%|\d*\.\d+|[01]))?\s*\)$/i;
const $322346e1ff7894ca$var$rgbLegacyPercentageRegEx = /^rgba?\(\s*(\d+%)\s*,\s*(\d+%)\s*,\s*(\d+%)(?:\s*,\s*(\d+%|\d*\.\d+|[01]))?\s*\)$/i;
const $322346e1ff7894ca$var$hexRegEx = /^#([\da-f]{3,4}|[\da-f]{6}|[\da-f]{8})$/i;
/**
 * @param {string} s Color component as number or percentage.
 * @param {number} divider Divider for percentage.
 * @return {number} Color component.
 */ function $322346e1ff7894ca$var$toColorComponent(s, divider) {
    return s.endsWith('%') ? Number(s.substring(0, s.length - 1)) / divider : Number(s);
}
/**
 * @param {string} color Color string.
 */ function $322346e1ff7894ca$var$throwInvalidColor(color) {
    throw new Error('failed to parse "' + color + '" as color');
}
/**
 * @param {string} color Color string.
 * @return {Color} RGBa color array.
 */ function $322346e1ff7894ca$var$parseRgba(color) {
    // Fast lane for rgb(a) colors
    if (color.toLowerCase().startsWith('rgb')) {
        const rgb = color.match($322346e1ff7894ca$var$rgbLegacyAbsoluteRegEx) || color.match($322346e1ff7894ca$var$rgbModernRegEx) || color.match($322346e1ff7894ca$var$rgbLegacyPercentageRegEx);
        if (rgb) {
            const alpha = rgb[4];
            const rgbDivider = 100 / 255;
            return [
                (0, $9byFX.clamp)($322346e1ff7894ca$var$toColorComponent(rgb[1], rgbDivider) + 0.5 | 0, 0, 255),
                (0, $9byFX.clamp)($322346e1ff7894ca$var$toColorComponent(rgb[2], rgbDivider) + 0.5 | 0, 0, 255),
                (0, $9byFX.clamp)($322346e1ff7894ca$var$toColorComponent(rgb[3], rgbDivider) + 0.5 | 0, 0, 255),
                alpha !== undefined ? (0, $9byFX.clamp)($322346e1ff7894ca$var$toColorComponent(alpha, 100), 0, 1) : 1
            ];
        }
        $322346e1ff7894ca$var$throwInvalidColor(color);
    }
    // Fast lane for hex colors (also with alpha)
    if (color.startsWith('#')) {
        if ($322346e1ff7894ca$var$hexRegEx.test(color)) {
            const hex = color.substring(1);
            const step = hex.length <= 4 ? 1 : 2;
            const colorFromHex = [
                0,
                0,
                0,
                255
            ];
            for(let i = 0, ii = hex.length; i < ii; i += step){
                let colorComponent = parseInt(hex.substring(i, i + step), 16);
                if (step === 1) colorComponent += colorComponent << 4;
                colorFromHex[i / step] = colorComponent;
            }
            colorFromHex[3] = colorFromHex[3] / 255;
            return colorFromHex;
        }
        $322346e1ff7894ca$var$throwInvalidColor(color);
    }
    // Use canvas color serialization to parse the color into hex or rgba
    // See https://www.w3.org/TR/2021/SPSD-2dcontext-20210128/#serialization-of-a-color
    const context = $322346e1ff7894ca$var$getColorParseContext();
    context.fillStyle = '#abcdef';
    let invalidCheckFillStyle = context.fillStyle;
    context.fillStyle = color;
    if (context.fillStyle === invalidCheckFillStyle) {
        context.fillStyle = '#fedcba';
        invalidCheckFillStyle = context.fillStyle;
        context.fillStyle = color;
        if (context.fillStyle === invalidCheckFillStyle) $322346e1ff7894ca$var$throwInvalidColor(color);
    }
    const colorString = context.fillStyle;
    if (colorString.startsWith('#') || colorString.startsWith('rgba')) return $322346e1ff7894ca$var$parseRgba(colorString);
    context.clearRect(0, 0, 1, 1);
    context.fillRect(0, 0, 1, 1);
    const colorFromImage = Array.from(context.getImageData(0, 0, 1, 1).data);
    colorFromImage[3] = (0, $9byFX.toFixed)(colorFromImage[3] / 255, 3);
    return colorFromImage;
}
function $322346e1ff7894ca$export$590567be997858b6(color) {
    if (typeof color === 'string') return color;
    return $322346e1ff7894ca$export$f84e8e69fd4488a5(color);
}
/**
 * @type {number}
 */ const $322346e1ff7894ca$var$MAX_CACHE_SIZE = 1024;
/**
 * We maintain a small cache of parsed strings.  Whenever the cache grows too large,
 * we delete an arbitrary set of the entries.
 *
 * @type {Object<string, Color>}
 */ const $322346e1ff7894ca$var$cache = {};
/**
 * @type {number}
 */ let $322346e1ff7894ca$var$cacheSize = 0;
function $322346e1ff7894ca$export$138c09bdd6bd797c(color) {
    if (color.length === 4) return color;
    const output = color.slice();
    output[3] = 1;
    return output;
}
// The functions b1, b2, a1, a2, rgbaToLcha and lchaToRgba below are adapted from
// https://stackoverflow.com/a/67219995/2389327
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $322346e1ff7894ca$var$b1(v) {
    return v > 0.0031308 ? Math.pow(v, 1 / 2.4) * 269.025 - 14.025 : v * 3294.6;
}
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $322346e1ff7894ca$var$b2(v) {
    return v > 0.2068965 ? Math.pow(v, 3) : (v - 4 / 29) * (108 / 841);
}
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $322346e1ff7894ca$var$a1(v) {
    return v > 10.314724 ? Math.pow((v + 14.025) / 269.025, 2.4) : v / 3294.6;
}
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $322346e1ff7894ca$var$a2(v) {
    return v > 0.0088564 ? Math.pow(v, 1 / 3) : v / (108 / 841) + 4 / 29;
}
function $322346e1ff7894ca$export$44fb54fa2e0c0d4(color) {
    const r = $322346e1ff7894ca$var$a1(color[0]);
    const g = $322346e1ff7894ca$var$a1(color[1]);
    const b = $322346e1ff7894ca$var$a1(color[2]);
    const y = $322346e1ff7894ca$var$a2(r * 0.222488403 + g * 0.716873169 + b * 0.06060791);
    const l = 500 * ($322346e1ff7894ca$var$a2(r * 0.452247074 + g * 0.399439023 + b * 0.148375274) - y);
    const q = 200 * (y - $322346e1ff7894ca$var$a2(r * 0.016863605 + g * 0.117638439 + b * 0.865350722));
    const h = Math.atan2(q, l) * (180 / Math.PI);
    return [
        116 * y - 16,
        Math.sqrt(l * l + q * q),
        h < 0 ? h + 360 : h,
        color[3]
    ];
}
function $322346e1ff7894ca$export$27cc94530c050f00(color) {
    const l = (color[0] + 16) / 116;
    const c = color[1];
    const h = color[2] * Math.PI / 180;
    const y = $322346e1ff7894ca$var$b2(l);
    const x = $322346e1ff7894ca$var$b2(l + c / 500 * Math.cos(h));
    const z = $322346e1ff7894ca$var$b2(l - c / 200 * Math.sin(h));
    const r = $322346e1ff7894ca$var$b1(x * 3.021973625 - y * 1.617392459 - z * 0.404875592);
    const g = $322346e1ff7894ca$var$b1(x * -0.943766287 + y * 1.916279586 + z * 0.027607165);
    const b = $322346e1ff7894ca$var$b1(x * 0.069407491 - y * 0.22898585 + z * 1.159737864);
    return [
        (0, $9byFX.clamp)(r + 0.5 | 0, 0, 255),
        (0, $9byFX.clamp)(g + 0.5 | 0, 0, 255),
        (0, $9byFX.clamp)(b + 0.5 | 0, 0, 255),
        color[3]
    ];
}
function $322346e1ff7894ca$export$3004f64547af360e(s) {
    if (s === 'none') return $322346e1ff7894ca$export$6c844c64a5efe1ee;
    if ($322346e1ff7894ca$var$cache.hasOwnProperty(s)) return $322346e1ff7894ca$var$cache[s];
    if ($322346e1ff7894ca$var$cacheSize >= $322346e1ff7894ca$var$MAX_CACHE_SIZE) {
        let i = 0;
        for(const key in $322346e1ff7894ca$var$cache)if ((i++ & 3) === 0) {
            delete $322346e1ff7894ca$var$cache[key];
            --$322346e1ff7894ca$var$cacheSize;
        }
    }
    const color = $322346e1ff7894ca$var$parseRgba(s);
    if (color.length !== 4) $322346e1ff7894ca$var$throwInvalidColor(s);
    for (const c of color)if (isNaN(c)) $322346e1ff7894ca$var$throwInvalidColor(s);
    $322346e1ff7894ca$var$cache[s] = color;
    ++$322346e1ff7894ca$var$cacheSize;
    return color;
}
function $322346e1ff7894ca$export$75093a47a9fa838d(color) {
    if (Array.isArray(color)) return color;
    return $322346e1ff7894ca$export$3004f64547af360e(color);
}
function $322346e1ff7894ca$export$f84e8e69fd4488a5(color) {
    let r = color[0];
    if (r != (r | 0)) r = r + 0.5 | 0;
    let g = color[1];
    if (g != (g | 0)) g = g + 0.5 | 0;
    let b = color[2];
    if (b != (b | 0)) b = b + 0.5 | 0;
    const a = color[3] === undefined ? 1 : Math.round(color[3] * 1000) / 1000;
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
}
function $322346e1ff7894ca$export$40dd713d7775a0b1(s) {
    try {
        $322346e1ff7894ca$export$3004f64547af360e(s);
        return true;
    } catch  {
        return false;
    }
}

});
parcelRegister("DfnQm", function(module, exports) {

$parcel$export(module.exports, "createCanvasContext2D", () => $075f937d7366f1a2$export$9e05d10eae75c464);
$parcel$export(module.exports, "getSharedCanvasContext2D", () => $075f937d7366f1a2$export$fcb72ce088a6632c);
$parcel$export(module.exports, "releaseCanvas", () => $075f937d7366f1a2$export$e918ac6a1026a12a);
$parcel$export(module.exports, "replaceNode", () => $075f937d7366f1a2$export$5542201de9311ab2);
$parcel$export(module.exports, "removeChildren", () => $075f937d7366f1a2$export$1e1c9bf5a4ffe0d1);
$parcel$export(module.exports, "replaceChildren", () => $075f937d7366f1a2$export$caeacfe04f52533a);
$parcel$export(module.exports, "createMockDiv", () => $075f937d7366f1a2$export$45b7f73d625b5cde);
$parcel$export(module.exports, "isCanvas", () => $075f937d7366f1a2$export$4b05d74c82e4c4d2);

var $8UoiJ = parcelRequire("8UoiJ");
function $075f937d7366f1a2$export$9e05d10eae75c464(width, height, canvasPool, settings) {
    /** @type {HTMLCanvasElement|OffscreenCanvas} */ let canvas;
    if (canvasPool && canvasPool.length) canvas = /** @type {HTMLCanvasElement} */ canvasPool.shift();
    else if (0, $8UoiJ.WORKER_OFFSCREEN_CANVAS) canvas = new class extends OffscreenCanvas {
        style = {};
    }(width ?? 300, height ?? 150);
    else canvas = document.createElement('canvas');
    if (width) canvas.width = width;
    if (height) canvas.height = height;
    return /** @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} */ canvas.getContext('2d', settings);
}
/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
 */ let $075f937d7366f1a2$var$sharedCanvasContext;
function $075f937d7366f1a2$export$fcb72ce088a6632c() {
    if (!$075f937d7366f1a2$var$sharedCanvasContext) $075f937d7366f1a2$var$sharedCanvasContext = $075f937d7366f1a2$export$9e05d10eae75c464(1, 1);
    return $075f937d7366f1a2$var$sharedCanvasContext;
}
function $075f937d7366f1a2$export$e918ac6a1026a12a(context) {
    const canvas = context.canvas;
    canvas.width = 1;
    canvas.height = 1;
    context.clearRect(0, 0, 1, 1);
}
function $075f937d7366f1a2$export$e823f88e4111159a(element) {
    let width = element.offsetWidth;
    const style = getComputedStyle(element);
    width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    return width;
}
function $075f937d7366f1a2$export$fc5b8aac72846d1e(element) {
    let height = element.offsetHeight;
    const style = getComputedStyle(element);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
}
function $075f937d7366f1a2$export$5542201de9311ab2(newNode, oldNode) {
    const parent = oldNode.parentNode;
    if (parent) parent.replaceChild(newNode, oldNode);
}
function $075f937d7366f1a2$export$1e1c9bf5a4ffe0d1(node) {
    while(node.lastChild)node.lastChild.remove();
}
function $075f937d7366f1a2$export$caeacfe04f52533a(node, children) {
    const oldChildren = node.childNodes;
    for(let i = 0;; ++i){
        const oldChild = oldChildren[i];
        const newChild = children[i];
        // check if our work is done
        if (!oldChild && !newChild) break;
        // check if children match
        if (oldChild === newChild) continue;
        // check if a new child needs to be added
        if (!oldChild) {
            node.appendChild(newChild);
            continue;
        }
        // check if an old child needs to be removed
        if (!newChild) {
            node.removeChild(oldChild);
            --i;
            continue;
        }
        // reorder
        node.insertBefore(newChild, oldChild);
    }
}
function $075f937d7366f1a2$export$45b7f73d625b5cde() {
    const mockedDiv = new Proxy({
        /**
       * @type {Array<HTMLElement>}
       */ childNodes: [],
        /**
       * @param {HTMLElement} node html node.
       * @return {HTMLElement} html node.
       */ appendChild: function(node) {
            this.childNodes.push(node);
            return node;
        },
        /**
       * dummy function, as this structure is not supposed to have a parent.
       */ remove: function() {},
        /**
       * @param {HTMLElement} node html node.
       * @return {HTMLElement} html node.
       */ removeChild: function(node) {
            const index = this.childNodes.indexOf(node);
            if (index === -1) throw new Error('Node to remove was not found');
            this.childNodes.splice(index, 1);
            return node;
        },
        /**
       * @param {HTMLElement} newNode new html node.
       * @param {HTMLElement} referenceNode reference html node.
       * @return {HTMLElement} new html node.
       */ insertBefore: function(newNode, referenceNode) {
            const index = this.childNodes.indexOf(referenceNode);
            if (index === -1) throw new Error('Reference node not found');
            this.childNodes.splice(index, 0, newNode);
            return newNode;
        },
        style: {}
    }, {
        get (target, prop, receiver) {
            if (prop === 'firstElementChild') return target.childNodes.length > 0 ? target.childNodes[0] : null;
            return Reflect.get(target, prop, receiver);
        }
    });
    return /** @type {*} */ mockedDiv;
}
function $075f937d7366f1a2$export$4b05d74c82e4c4d2(obj) {
    return typeof HTMLCanvasElement !== 'undefined' && obj instanceof HTMLCanvasElement || typeof OffscreenCanvas !== 'undefined' && obj instanceof OffscreenCanvas;
}

});
parcelRegister("8UoiJ", function(module, exports) {

$parcel$export(module.exports, "WEBKIT", () => $67c66761d21428d0$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "MAC", () => $67c66761d21428d0$export$76c0a3b101d93136);
$parcel$export(module.exports, "DEVICE_PIXEL_RATIO", () => $67c66761d21428d0$export$6b83a0446fc26f94);
$parcel$export(module.exports, "WORKER_OFFSCREEN_CANVAS", () => $67c66761d21428d0$export$98fcef3dc9973292);
$parcel$export(module.exports, "IMAGE_DECODE", () => $67c66761d21428d0$export$716f8695eedb9bad);
$parcel$export(module.exports, "CREATE_IMAGE_BITMAP", () => $67c66761d21428d0$export$7478563940788376);
$parcel$export(module.exports, "PASSIVE_EVENT_LISTENERS", () => $67c66761d21428d0$export$f751ce96c6c4e4fc);
/**
 * @module ol/has
 */ const $67c66761d21428d0$var$ua = typeof navigator !== 'undefined' && typeof navigator.userAgent !== 'undefined' ? navigator.userAgent.toLowerCase() : '';
const $67c66761d21428d0$export$3227bfbdaa9275de = $67c66761d21428d0$var$ua.includes('safari') && !$67c66761d21428d0$var$ua.includes('chrom');
const $67c66761d21428d0$export$b23eed0e325a206a = $67c66761d21428d0$export$3227bfbdaa9275de && ($67c66761d21428d0$var$ua.includes('version/15.4') || /cpu (os|iphone os) 15_4 like mac os x/.test($67c66761d21428d0$var$ua));
const $67c66761d21428d0$export$39dfd62a25e0fe93 = $67c66761d21428d0$var$ua.includes('webkit') && !$67c66761d21428d0$var$ua.includes('edge');
const $67c66761d21428d0$export$76c0a3b101d93136 = $67c66761d21428d0$var$ua.includes('macintosh');
const $67c66761d21428d0$export$6b83a0446fc26f94 = typeof devicePixelRatio !== 'undefined' ? devicePixelRatio : 1;
const $67c66761d21428d0$export$98fcef3dc9973292 = typeof WorkerGlobalScope !== 'undefined' && typeof OffscreenCanvas !== 'undefined' && self instanceof WorkerGlobalScope; //eslint-disable-line
const $67c66761d21428d0$export$716f8695eedb9bad = typeof Image !== 'undefined' && Image.prototype.decode;
const $67c66761d21428d0$export$7478563940788376 = typeof createImageBitmap === 'function';
const $67c66761d21428d0$export$f751ce96c6c4e4fc = function() {
    let passive = false;
    try {
        const options = Object.defineProperty({}, 'passive', {
            get: function() {
                passive = true;
            }
        });
        // @ts-ignore Ignore invalid event type '_'
        window.addEventListener('_', null, options);
        // @ts-ignore Ignore invalid event type '_'
        window.removeEventListener('_', null, options);
    } catch  {
    // passive not supported
    }
    return passive;
}();

});



parcelRegister("fNIok", function(module, exports) {

$parcel$export(module.exports, "default", () => $b80dddceb0c42ad4$export$2e2bcd8739ae039);
/**
 * @module ol/render/Event
 */ 
var $f18Q2 = parcelRequire("f18Q2");
class $b80dddceb0c42ad4$var$RenderEvent extends (0, $f18Q2.default) {
    /**
   * @param {import("./EventType.js").default} type Type.
   * @param {import("../transform.js").Transform} [inversePixelTransform] Transform for
   *     CSS pixels to rendered pixels.
   * @param {import("../Map.js").FrameState} [frameState] Frame state.
   * @param {?(CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D|WebGLRenderingContext)} [context] Context.
   */ constructor(type, inversePixelTransform, frameState, context){
        super(type);
        /**
     * Transform from CSS pixels (relative to the top-left corner of the map viewport)
     * to rendered pixels on this event's `context`. Only available when a Canvas renderer is used, null otherwise.
     * @type {import("../transform.js").Transform|undefined}
     * @api
     */ this.inversePixelTransform = inversePixelTransform;
        /**
     * An object representing the current render frame state.
     * @type {import("../Map.js").FrameState|undefined}
     * @api
     */ this.frameState = frameState;
        /**
     * Canvas context. Not available when the event is dispatched by the map. For Canvas 2D layers,
     * the context will be the 2D rendering context.  For WebGL layers, the context will be the WebGL
     * context.
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D|WebGLRenderingContext|undefined}
     * @api
     */ this.context = context;
    }
}
var $b80dddceb0c42ad4$export$2e2bcd8739ae039 = $b80dddceb0c42ad4$var$RenderEvent;

});
parcelRegister("f18Q2", function(module, exports) {

$parcel$export(module.exports, "default", () => $aeedce20e9577100$export$2e2bcd8739ae039);
/**
 * @module ol/events/Event
 */ /**
 * @classdesc
 * Stripped down implementation of the W3C DOM Level 2 Event interface.
 * See https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-interface.
 *
 * This implementation only provides `type` and `target` properties, and
 * `stopPropagation` and `preventDefault` methods. It is meant as base class
 * for higher level events defined in the library, and works with
 * {@link module:ol/events/Target~Target}.
 */ class $aeedce20e9577100$var$BaseEvent {
    /**
   * @param {string} type Type.
   */ constructor(type){
        /**
     * @type {boolean}
     */ this.propagationStopped;
        /**
     * @type {boolean}
     */ this.defaultPrevented;
        /**
     * The event type.
     * @type {string}
     * @api
     */ this.type = type;
        /**
     * The event target.
     * @type {Object}
     * @api
     */ this.target = null;
    }
    /**
   * Prevent default. This means that no emulated `click`, `singleclick` or `doubleclick` events
   * will be fired.
   * @api
   */ preventDefault() {
        this.defaultPrevented = true;
    }
    /**
   * Stop event propagation.
   * @api
   */ stopPropagation() {
        this.propagationStopped = true;
    }
}
function $aeedce20e9577100$export$51134cce184326b9(evt) {
    evt.stopPropagation();
}
function $aeedce20e9577100$export$fa3b29edae795ef4(evt) {
    evt.preventDefault();
}
var $aeedce20e9577100$export$2e2bcd8739ae039 = $aeedce20e9577100$var$BaseEvent;

});


parcelRegister("l6YBe", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5e92a4d985a2824$export$2e2bcd8739ae039);
/**
 * @module ol/render/EventType
 */ /**
 * @enum {string}
 */ var $f5e92a4d985a2824$export$2e2bcd8739ae039 /**
 * @typedef {'postrender'|'precompose'|'postcompose'|'rendercomplete'} MapRenderEventTypes
 */  /**
 * @typedef {'postrender'|'prerender'} LayerRenderEventTypes
 */  = {
    /**
   * Triggered before a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#prerender
   * @api
   */ PRERENDER: 'prerender',
    /**
   * Triggered after a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#postrender
   * @api
   */ POSTRENDER: 'postrender',
    /**
   * Triggered before layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#precompose
   * @api
   */ PRECOMPOSE: 'precompose',
    /**
   * Triggered after layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#postcompose
   * @api
   */ POSTCOMPOSE: 'postcompose',
    /**
   * Triggered when rendering is complete, i.e. all sources and tiles have
   * finished loading for the current viewport, and all tiles are faded in.
   * The event object will not have a `context` set.
   * @event module:ol/render/Event~RenderEvent#rendercomplete
   * @api
   */ RENDERCOMPLETE: 'rendercomplete'
};

});

parcelRegister("gDySU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1cb593c98d2cbd0$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/ZIndexContext
 */ 
var $DfnQm = parcelRequire("DfnQm");
/** @typedef {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D & {globalAlpha: any}} ZIndexContextProxy */ /**
 * @extends {CanvasRenderingContext2D}
 */ class $c1cb593c98d2cbd0$var$ZIndexContext {
    constructor(){
        /**
     * @private
     * @type {Array<Array<*>>}
     */ this.instructions_ = [];
        /**
     * @type {number}
     */ this.zIndex = 0;
        /**
     * @private
     * @type {number}
     */ this.offset_ = 0;
        /**
     * @private
     * @type {ZIndexContextProxy}
     */ this.context_ = /** @type {ZIndexContextProxy} */ new Proxy((0, $DfnQm.getSharedCanvasContext2D)(), {
            get: (target, property)=>{
                if (typeof /** @type {*} */ (0, $DfnQm.getSharedCanvasContext2D)()[property] !== 'function') // we only accept calling functions on the proxy, not accessing properties
                return undefined;
                this.push_(property);
                return this.pushMethodArgs_;
            },
            set: (target, property, value)=>{
                this.push_(property, value);
                return true;
            }
        });
    }
    /**
   * @param {...*} args Arguments to push to the instructions array.
   * @private
   */ push_(...args) {
        const instructions = this.instructions_;
        const index = this.zIndex + this.offset_;
        if (!instructions[index]) instructions[index] = [];
        instructions[index].push(...args);
    }
    /**
   * @private
   * @param {...*} args Args.
   * @return {ZIndexContext} This.
   */ pushMethodArgs_ = (...args)=>{
        this.push_(args);
        return this;
    };
    /**
   * Push a function that renders to the context directly.
   * @param {function(CanvasRenderingContext2D): void} render Function.
   */ pushFunction(render) {
        this.push_(render);
    }
    /**
   * Get a proxy for CanvasRenderingContext2D which does not support getting state
   * (e.g. `context.globalAlpha`, which will return `undefined`). To set state, if it relies on a
   * previous state (e.g. `context.globalAlpha = context.globalAlpha / 2`), set a function,
   * e.g. `context.globalAlpha = (context) => context.globalAlpha / 2`.
   * @return {ZIndexContextProxy} Context.
   */ getContext() {
        return this.context_;
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   */ draw(context) {
        this.instructions_.forEach((instructionsAtIndex)=>{
            for(let i = 0, ii = instructionsAtIndex.length; i < ii; ++i){
                const property = instructionsAtIndex[i];
                if (typeof property === 'function') {
                    property(context);
                    continue;
                }
                const instructionAtIndex = instructionsAtIndex[++i];
                if (typeof /** @type {*} */ context[property] === 'function') /** @type {*} */ context[property](...instructionAtIndex);
                else {
                    if (typeof instructionAtIndex === 'function') {
                        /** @type {*} */ context[property] = instructionAtIndex(context);
                        continue;
                    }
                    /** @type {*} */ context[property] = instructionAtIndex;
                }
            }
        });
    }
    clear() {
        this.instructions_.length = 0;
        this.zIndex = 0;
        this.offset_ = 0;
    }
    /**
   * Offsets the zIndex by the highest current zIndex. Useful for rendering multiple worlds or tiles, to
   * avoid conflicting context.clip() or context.save()/restore() calls.
   */ offset() {
        this.offset_ = this.instructions_.length;
        this.zIndex = 0;
    }
}
var $c1cb593c98d2cbd0$export$2e2bcd8739ae039 = $c1cb593c98d2cbd0$var$ZIndexContext;

});

parcelRegister("hr4Xu", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb18cdefd702a327$export$2e2bcd8739ae039);
/**
 * @module ol/renderer/Layer
 */ 
var $aSvtr = parcelRequire("aSvtr");

var $2FcER = parcelRequire("2FcER");

var $3xzSb = parcelRequire("3xzSb");

var $9iPUS = parcelRequire("9iPUS");
const $cb18cdefd702a327$var$maxStaleKeys = 5;
/**
 * @template {import("../layer/Layer.js").default} LayerType
 */ class $cb18cdefd702a327$var$LayerRenderer extends (0, $2FcER.default) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super();
        /**
     * The renderer is initialized and ready to render.
     * @type {boolean}
     */ this.ready = true;
        /** @private */ this.boundHandleImageChange_ = this.handleImageChange_.bind(this);
        /**
     * @private
     * @type {LayerType}
     */ this.layer_ = layer;
        /**
     * @type {Array<string>}
     * @private
     */ this.staleKeys_ = new Array();
        /**
     * @type {number}
     * @protected
     */ this.maxStaleKeys = $cb18cdefd702a327$var$maxStaleKeys;
    }
    /**
   * @return {Array<string>} Get the list of stale keys.
   */ getStaleKeys() {
        return this.staleKeys_;
    }
    /**
   * @param {string} key The new stale key.
   */ prependStaleKey(key) {
        this.staleKeys_.unshift(key);
        if (this.staleKeys_.length > this.maxStaleKeys) this.staleKeys_.length = this.maxStaleKeys;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        return null;
    }
    /**
   * Determine whether render should be called.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */ prepareFrame(frameState) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Render the layer.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   */ renderFrame(frameState, target) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * @abstract
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("./Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        return undefined;
    }
    /**
   * @return {LayerType} Layer.
   */ getLayer() {
        return this.layer_;
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @abstract
   */ handleFontsChanged() {}
    /**
   * Handle changes in image state.
   * @param {import("../events/Event.js").default} event Image change event.
   * @private
   */ handleImageChange_(event) {
        const image = /** @type {import("../Image.js").default} */ event.target;
        if (image.getState() === (0, $aSvtr.default).LOADED || image.getState() === (0, $aSvtr.default).ERROR) this.renderIfReadyAndVisible();
    }
    /**
   * Load the image if not already loaded, and register the image change
   * listener if needed.
   * @param {import("../Image.js").default} image Image.
   * @return {boolean} `true` if the image is already loaded, `false` otherwise.
   * @protected
   */ loadImage(image) {
        let imageState = image.getState();
        if (imageState != (0, $aSvtr.default).LOADED && imageState != (0, $aSvtr.default).ERROR) image.addEventListener((0, $3xzSb.default).CHANGE, this.boundHandleImageChange_);
        if (imageState == (0, $aSvtr.default).IDLE) {
            image.load();
            imageState = image.getState();
        }
        return imageState == (0, $aSvtr.default).LOADED;
    }
    /**
   * @protected
   */ renderIfReadyAndVisible() {
        const layer = this.getLayer();
        if (layer && layer.getVisible() && layer.getSourceState() === 'ready') layer.changed();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ renderDeferred(frameState) {}
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        delete this.layer_;
        super.disposeInternal();
    }
}
var $cb18cdefd702a327$export$2e2bcd8739ae039 = $cb18cdefd702a327$var$LayerRenderer;

});
parcelRegister("2FcER", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f093ab5083c8a1f$export$2e2bcd8739ae039);
/**
 * @module ol/Observable
 */ 
var $3xzSb = parcelRequire("3xzSb");

var $KD0eF = parcelRequire("KD0eF");

var $ilM9F = parcelRequire("ilM9F");
/***
 * @template {string} Type
 * @template {Event|import("./events/Event.js").default} EventClass
 * @template Return
 * @typedef {(type: Type, listener: (event: EventClass) => ?) => Return} OnSignature
 */ /***
 * @template {string} Type
 * @template Return
 * @typedef {(type: Type[], listener: (event: Event|import("./events/Event").default) => ?) => Return extends void ? void : Return[]} CombinedOnSignature
 */ /**
 * @typedef {'change'|'error'} EventTypes
 */ /***
 * @template Return
 * @typedef {OnSignature<EventTypes, import("./events/Event.js").default, Return> & CombinedOnSignature<EventTypes, Return>} ObservableOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * An event target providing convenient methods for listener registration
 * and unregistration. A generic `change` event is always available through
 * {@link module:ol/Observable~Observable#changed}.
 *
 * @fires import("./events/Event.js").default
 * @api
 */ class $1f093ab5083c8a1f$var$Observable extends (0, $KD0eF.default) {
    constructor(){
        super();
        this.on = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ this.onInternal;
        this.once = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ this.onceInternal;
        this.un = /** @type {ObservableOnSignature<void>} */ this.unInternal;
        /**
     * @private
     * @type {number}
     */ this.revision_ = 0;
    }
    /**
   * Increases the revision counter and dispatches a 'change' event.
   * @api
   */ changed() {
        ++this.revision_;
        this.dispatchEvent((0, $3xzSb.default).CHANGE);
    }
    /**
   * Get the version number for this object.  Each time the object is modified,
   * its version number will be incremented.
   * @return {number} Revision.
   * @api
   */ getRevision() {
        return this.revision_;
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onInternal(type, listener) {
        if (Array.isArray(type)) {
            const len = type.length;
            const keys = new Array(len);
            for(let i = 0; i < len; ++i)keys[i] = (0, $ilM9F.listen)(this, type[i], listener);
            return keys;
        }
        return (0, $ilM9F.listen)(this, /** @type {string} */ type, listener);
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onceInternal(type, listener) {
        let key;
        if (Array.isArray(type)) {
            const len = type.length;
            key = new Array(len);
            for(let i = 0; i < len; ++i)key[i] = (0, $ilM9F.listenOnce)(this, type[i], listener);
        } else key = (0, $ilM9F.listenOnce)(this, /** @type {string} */ type, listener);
        /** @type {Object} */ listener.ol_key = key;
        return key;
    }
    /**
   * Unlisten for a certain type of event.
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @protected
   */ unInternal(type, listener) {
        const key = /** @type {Object} */ listener.ol_key;
        if (key) $1f093ab5083c8a1f$export$b7ef3f8527533384(key);
        else if (Array.isArray(type)) for(let i = 0, ii = type.length; i < ii; ++i)this.removeEventListener(type[i], listener);
        else this.removeEventListener(type, listener);
    }
}
/**
 * Listen for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $1f093ab5083c8a1f$var$Observable.prototype.on;
/**
 * Listen once for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $1f093ab5083c8a1f$var$Observable.prototype.once;
/**
 * Unlisten for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @api
 */ $1f093ab5083c8a1f$var$Observable.prototype.un;
function $1f093ab5083c8a1f$export$b7ef3f8527533384(key) {
    if (Array.isArray(key)) for(let i = 0, ii = key.length; i < ii; ++i)(0, $ilM9F.unlistenByKey)(key[i]);
    else (0, $ilM9F.unlistenByKey)(/** @type {import("./events.js").EventsKey} */ key);
}
var $1f093ab5083c8a1f$export$2e2bcd8739ae039 = $1f093ab5083c8a1f$var$Observable;

});
parcelRegister("3xzSb", function(module, exports) {

$parcel$export(module.exports, "default", () => $294047c5e65f31a3$export$2e2bcd8739ae039);
/**
 * @module ol/events/EventType
 */ /**
 * @enum {string}
 * @const
 */ var $294047c5e65f31a3$export$2e2bcd8739ae039 = {
    /**
   * Generic change event. Triggered when the revision counter is increased.
   * @event module:ol/events/Event~BaseEvent#change
   * @api
   */ CHANGE: 'change',
    /**
   * Generic error event. Triggered when an error occurs.
   * @event module:ol/events/Event~BaseEvent#error
   * @api
   */ ERROR: 'error',
    BLUR: 'blur',
    CLEAR: 'clear',
    CONTEXTMENU: 'contextmenu',
    CLICK: 'click',
    DBLCLICK: 'dblclick',
    DRAGENTER: 'dragenter',
    DRAGOVER: 'dragover',
    DROP: 'drop',
    FOCUS: 'focus',
    KEYDOWN: 'keydown',
    KEYPRESS: 'keypress',
    LOAD: 'load',
    RESIZE: 'resize',
    TOUCHMOVE: 'touchmove',
    WHEEL: 'wheel'
};

});

parcelRegister("KD0eF", function(module, exports) {

$parcel$export(module.exports, "default", () => $08c28d22c0cb5a39$export$2e2bcd8739ae039);
/**
 * @module ol/events/Target
 */ 
var $4kyFN = parcelRequire("4kyFN");

var $6wUzV = parcelRequire("6wUzV");

var $gn0g3 = parcelRequire("gn0g3");

var $f18Q2 = parcelRequire("f18Q2");
/**
 * @typedef {EventTarget|Target} EventTargetLike
 */ /**
 * @classdesc
 * A simplified implementation of the W3C DOM Level 2 EventTarget interface.
 * See https://www.w3.org/TR/2000/REC-DOM-Level-2-Events-20001113/events.html#Events-EventTarget.
 *
 * There are two important simplifications compared to the specification:
 *
 * 1. The handling of `useCapture` in `addEventListener` and
 *    `removeEventListener`. There is no real capture model.
 * 2. The handling of `stopPropagation` and `preventDefault` on `dispatchEvent`.
 *    There is no event target hierarchy. When a listener calls
 *    `stopPropagation` or `preventDefault` on an event object, it means that no
 *    more listeners after this one will be called. Same as when the listener
 *    returns false.
 */ class $08c28d22c0cb5a39$var$Target extends (0, $4kyFN.default) {
    /**
   * @param {*} [target] Default event target for dispatched events.
   */ constructor(target){
        super();
        /**
     * @private
     * @type {*}
     */ this.eventTarget_ = target;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.pendingRemovals_ = null;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.dispatching_ = null;
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").Listener>>|null}
     */ this.listeners_ = null;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ addEventListener(type, listener) {
        if (!type || !listener) return;
        const listeners = this.listeners_ || (this.listeners_ = {});
        const listenersForType = listeners[type] || (listeners[type] = []);
        if (!listenersForType.includes(listener)) listenersForType.push(listener);
    }
    /**
   * Dispatches an event and calls all listeners listening for events
   * of this type. The event parameter can either be a string or an
   * Object with a `type` property.
   *
   * @param {import("./Event.js").default|string} event Event object.
   * @return {boolean|undefined} `false` if anyone called preventDefault on the
   *     event object or if any of the listeners returned false.
   * @api
   */ dispatchEvent(event) {
        const isString = typeof event === 'string';
        const type = isString ? event : event.type;
        const listeners = this.listeners_ && this.listeners_[type];
        if (!listeners) return;
        const evt = isString ? new (0, $f18Q2.default)(event) : /** @type {Event} */ event;
        if (!evt.target) evt.target = this.eventTarget_ || this;
        const dispatching = this.dispatching_ || (this.dispatching_ = {});
        const pendingRemovals = this.pendingRemovals_ || (this.pendingRemovals_ = {});
        if (!(type in dispatching)) {
            dispatching[type] = 0;
            pendingRemovals[type] = 0;
        }
        ++dispatching[type];
        let propagate;
        for(let i = 0, ii = listeners.length; i < ii; ++i){
            if ('handleEvent' in listeners[i]) propagate = /** @type {import("../events.js").ListenerObject} */ listeners[i].handleEvent(evt);
            else propagate = /** @type {import("../events.js").ListenerFunction} */ listeners[i].call(this, evt);
            if (propagate === false || evt.propagationStopped) {
                propagate = false;
                break;
            }
        }
        if (--dispatching[type] === 0) {
            let pr = pendingRemovals[type];
            delete pendingRemovals[type];
            while(pr--)this.removeEventListener(type, (0, $6wUzV.VOID));
            delete dispatching[type];
        }
        return propagate;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.listeners_ && (0, $gn0g3.clear)(this.listeners_);
    }
    /**
   * Get the listeners for a specified event type. Listeners are returned in the
   * order that they will be called in.
   *
   * @param {string} type Type.
   * @return {Array<import("../events.js").Listener>|undefined} Listeners.
   */ getListeners(type) {
        return this.listeners_ && this.listeners_[type] || undefined;
    }
    /**
   * @param {string} [type] Type. If not provided,
   *     `true` will be returned if this event target has any listeners.
   * @return {boolean} Has listeners.
   */ hasListener(type) {
        if (!this.listeners_) return false;
        return type ? type in this.listeners_ : Object.keys(this.listeners_).length > 0;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ removeEventListener(type, listener) {
        if (!this.listeners_) return;
        const listeners = this.listeners_[type];
        if (!listeners) return;
        const index = listeners.indexOf(listener);
        if (index !== -1) {
            if (this.pendingRemovals_ && type in this.pendingRemovals_) {
                // make listener a no-op, and remove later in #dispatchEvent()
                listeners[index] = (0, $6wUzV.VOID);
                ++this.pendingRemovals_[type];
            } else {
                listeners.splice(index, 1);
                if (listeners.length === 0) delete this.listeners_[type];
            }
        }
    }
}
var $08c28d22c0cb5a39$export$2e2bcd8739ae039 = $08c28d22c0cb5a39$var$Target;

});
parcelRegister("4kyFN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3273ed08087da3da$export$2e2bcd8739ae039);
/**
 * @module ol/Disposable
 */ /**
 * @classdesc
 * Objects that need to clean up after themselves.
 */ class $3273ed08087da3da$var$Disposable {
    constructor(){
        /**
     * The object has already been disposed.
     * @type {boolean}
     * @protected
     */ this.disposed = false;
    }
    /**
   * Clean up.
   */ dispose() {
        if (!this.disposed) {
            this.disposed = true;
            this.disposeInternal();
        }
    }
    /**
   * Extension point for disposable objects.
   * @protected
   */ disposeInternal() {}
}
var $3273ed08087da3da$export$2e2bcd8739ae039 = $3273ed08087da3da$var$Disposable;

});

parcelRegister("6wUzV", function(module, exports) {

$parcel$export(module.exports, "TRUE", () => $013a1733c226ec50$export$22e23a2304399231);
$parcel$export(module.exports, "FALSE", () => $013a1733c226ec50$export$8f11cee4bdc7e668);
$parcel$export(module.exports, "VOID", () => $013a1733c226ec50$export$1cd1943b3a73bbe8);
$parcel$export(module.exports, "memoizeOne", () => $013a1733c226ec50$export$ff83df6f9971435f);
$parcel$export(module.exports, "toPromise", () => $013a1733c226ec50$export$4dbaaf6c79705e6c);
/**
 * @module ol/functions
 */ 
var $fVVyM = parcelRequire("fVVyM");
function $013a1733c226ec50$export$22e23a2304399231() {
    return true;
}
function $013a1733c226ec50$export$8f11cee4bdc7e668() {
    return false;
}
function $013a1733c226ec50$export$1cd1943b3a73bbe8() {}
function $013a1733c226ec50$export$ff83df6f9971435f(fn) {
    /** @type {ReturnType} */ let lastResult;
    /** @type {Array<any>|undefined} */ let lastArgs;
    let lastThis;
    /**
   * @this {*} Only need to know if `this` changed, don't care what type
   * @return {ReturnType} Memoized value
   */ return function() {
        const nextArgs = Array.prototype.slice.call(arguments);
        if (!lastArgs || this !== lastThis || !(0, $fVVyM.equals)(nextArgs, lastArgs)) {
            lastThis = this;
            lastArgs = nextArgs;
            lastResult = fn.apply(this, arguments);
        }
        return lastResult;
    };
}
function $013a1733c226ec50$export$4dbaaf6c79705e6c(getter) {
    function promiseGetter() {
        let value;
        try {
            value = getter();
        } catch (err) {
            return Promise.reject(err);
        }
        if (value instanceof Promise) return value;
        return Promise.resolve(value);
    }
    return promiseGetter();
}

});


parcelRegister("ilM9F", function(module, exports) {

$parcel$export(module.exports, "listen", () => $d5bf8abd656a3cdc$export$63174c828edd6ff8);
$parcel$export(module.exports, "listenOnce", () => $d5bf8abd656a3cdc$export$8d2a95bc11b44725);
$parcel$export(module.exports, "unlistenByKey", () => $d5bf8abd656a3cdc$export$b0a21c8b3c1c921);
/**
 * @module ol/events
 */ 
var $gn0g3 = parcelRequire("gn0g3");
function $d5bf8abd656a3cdc$export$63174c828edd6ff8(target, type, listener, thisArg, once) {
    if (once) {
        const originalListener = listener;
        /**
     * @param {Event|import('./events/Event.js').default} event The event
     * @return {void|boolean} When the function returns `false`, event propagation will stop.
     * @this {typeof target}
     */ listener = function(event) {
            target.removeEventListener(type, listener);
            return originalListener.call(thisArg ?? this, event);
        };
    } else if (thisArg && thisArg !== target) listener = listener.bind(thisArg);
    const eventsKey = {
        target: target,
        type: type,
        listener: listener
    };
    target.addEventListener(type, listener);
    return eventsKey;
}
function $d5bf8abd656a3cdc$export$8d2a95bc11b44725(target, type, listener, thisArg) {
    return $d5bf8abd656a3cdc$export$63174c828edd6ff8(target, type, listener, thisArg, true);
}
function $d5bf8abd656a3cdc$export$b0a21c8b3c1c921(key) {
    if (key && key.target) {
        key.target.removeEventListener(key.type, key.listener);
        (0, $gn0g3.clear)(key);
    }
}

});


parcelRegister("9iPUS", function(module, exports) {

$parcel$export(module.exports, "abstract", () => $6c5e11070e371322$export$817eb92a8194bab0);
$parcel$export(module.exports, "getUid", () => $6c5e11070e371322$export$5e82334337e0f204);
/**
 * @module ol/util
 */ /**
 * @return {never} Any return.
 */ function $6c5e11070e371322$export$817eb92a8194bab0() {
    throw new Error('Unimplemented abstract method.');
}
/**
 * Counter for getUid.
 * @type {number}
 * @private
 */ let $6c5e11070e371322$var$uidCounter_ = 0;
function $6c5e11070e371322$export$5e82334337e0f204(obj) {
    return obj.ol_uid || (obj.ol_uid = String(++$6c5e11070e371322$var$uidCounter_));
}
const $6c5e11070e371322$export$a4ad2735b021c132 = '10.8.0';

});




parcelRegister("4yJW3", function(module, exports) {

$parcel$export(module.exports, "default", () => $351df830ee0a9d9c$export$2e2bcd8739ae039);
/**
 * @module ol/layer/BaseImage
 */ 
var $79s7T = parcelRequire("79s7T");
/**
 * @template {import("../source/Image.js").default} ImageSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../Map.js").default#addLayer map.addLayer()}.
 * @property {ImageSourceType} [source] Source for this layer.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Server-rendered images that are available for arbitrary extents and
 * resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Image.js").default} ImageSourceType
 * @template {import("../renderer/Layer.js").default} RendererType
 * @extends {Layer<ImageSourceType, RendererType>}
 * @api
 */ class $351df830ee0a9d9c$var$BaseImageLayer extends (0, $79s7T.default) {
    /**
   * @param {Options<ImageSourceType>} [options] Layer options.
   */ constructor(options){
        options = options ? options : {};
        super(options);
    }
}
var $351df830ee0a9d9c$export$2e2bcd8739ae039 = $351df830ee0a9d9c$var$BaseImageLayer;

});
parcelRegister("79s7T", function(module, exports) {

$parcel$export(module.exports, "inView", () => $534f30fce11effcd$export$acb1e9cb9ce4ca56);
$parcel$export(module.exports, "default", () => $534f30fce11effcd$export$2e2bcd8739ae039);
/**
 * @module ol/layer/Layer
 */ 
var $9DiKA = parcelRequire("9DiKA");

var $4Cz58 = parcelRequire("4Cz58");

var $3xzSb = parcelRequire("3xzSb");

var $ilM9F = parcelRequire("ilM9F");

var $9pD6L = parcelRequire("9pD6L");

var $l6YBe = parcelRequire("l6YBe");

var $7xdj9 = parcelRequire("7xdj9");

var $lbO8S = parcelRequire("lbO8S");
/**
 * @typedef {function(import("../Map.js").FrameState):HTMLElement} RenderFunction
 */ /**
 * @typedef {'sourceready'|'change:source'} LayerEventType
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     LayerEventType, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|LayerEventType|
 *     import("../render/EventType").LayerRenderEventTypes, Return>} LayerOnSignature
 */ /**
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {SourceType} [source] Source for this layer.  If not provided to the constructor,
 * the source can be set by calling {@link module:ol/layer/Layer~Layer#setSource layer.setSource(source)} after
 * construction.
 * @property {import("../Map.js").default|null} [map] Map.
 * @property {RenderFunction} [render] Render function. Takes the frame state as input and is expected to return an
 * HTML element. Will overwrite the default rendering for the layer.
 * @property {Properties} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @typedef {Object} State
 * @property {import("./Layer.js").default} layer Layer.
 * @property {number} opacity Opacity, the value is rounded to two digits to appear after the decimal point.
 * @property {boolean} visible Visible.
 * @property {boolean} managed Managed.
 * @property {import("../extent.js").Extent} [extent] Extent.
 * @property {number} zIndex ZIndex.
 * @property {number} maxResolution Maximum resolution.
 * @property {number} minResolution Minimum resolution.
 * @property {number} minZoom Minimum zoom.
 * @property {number} maxZoom Maximum zoom.
 */ /**
 * @classdesc
 * Base class from which all layer types are derived. This should only be instantiated
 * in the case where a custom layer is added to the map with a custom `render` function.
 * Such a function can be specified in the `options` object, and is expected to return an HTML element.
 *
 * A visual representation of raster or vector map data.
 * Layers group together those properties that pertain to how the data is to be
 * displayed, irrespective of the source of that data.
 *
 * Layers are usually added to a map with [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * Components like {@link module:ol/interaction/Draw~Draw} use unmanaged layers
 * internally. These unmanaged layers are associated with the map using
 * [layer.setMap()]{@link module:ol/layer/Layer~Layer#setMap} instead.
 *
 * A generic `change` event is fired when the state of the source changes.
 * A `sourceready` event is fired when the layer's source is ready.
 *
 * @fires import("../render/Event.js").RenderEvent#prerender
 * @fires import("../render/Event.js").RenderEvent#postrender
 * @fires import("../events/Event.js").BaseEvent#sourceready
 *
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @template {import("../renderer/Layer.js").default} [RendererType=import("../renderer/Layer.js").default]
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @extends {BaseLayer<NoInfer<Properties>>}
 * @api
 */ class $534f30fce11effcd$var$Layer extends (0, $7xdj9.default) {
    /**
   * @param {Options<SourceType, NoInfer<Properties>>} options Layer options.
   */ constructor(options){
        const baseOptions = Object.assign({}, options);
        delete baseOptions.source;
        super(baseOptions);
        /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {LayerOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapPrecomposeKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapRenderKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.sourceChangeKey_ = null;
        /**
     * @private
     * @type {RendererType}
     */ this.renderer_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.sourceReady_ = false;
        /**
     * @protected
     * @type {boolean}
     */ this.rendered = false;
        // Overwrite default render method with a custom one
        if (options.render) this.render = options.render;
        if (options.map) this.setMap(options.map);
        this.addChangeListener((0, $lbO8S.default).SOURCE, this.handleSourcePropertyChange_);
        const source = options.source ? /** @type {SourceType} */ options.source : null;
        this.setSource(source);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   * @override
   */ getLayersArray(array) {
        array = array ? array : [];
        array.push(this);
        return array;
    }
    /**
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   * @override
   */ getLayerStatesArray(states) {
        states = states ? states : [];
        states.push(this.getLayerState());
        return states;
    }
    /**
   * Get the layer source.
   * @return {SourceType|null} The layer source (or `null` if not yet set).
   * @observable
   * @api
   */ getSource() {
        return /** @type {SourceType} */ this.get((0, $lbO8S.default).SOURCE) || null;
    }
    /**
   * @return {SourceType|null} The source being rendered.
   */ getRenderSource() {
        return this.getSource();
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   * @override
   */ getSourceState() {
        const source = this.getSource();
        return !source ? 'undefined' : source.getState();
    }
    /**
   * @private
   */ handleSourceChange_() {
        this.changed();
        if (this.sourceReady_ || this.getSource().getState() !== 'ready') return;
        this.sourceReady_ = true;
        this.dispatchEvent('sourceready');
    }
    /**
   * @private
   */ handleSourcePropertyChange_() {
        if (this.sourceChangeKey_) {
            (0, $ilM9F.unlistenByKey)(this.sourceChangeKey_);
            this.sourceChangeKey_ = null;
        }
        this.sourceReady_ = false;
        const source = this.getSource();
        if (source) {
            this.sourceChangeKey_ = (0, $ilM9F.listen)(source, (0, $3xzSb.default).CHANGE, this.handleSourceChange_, this);
            if (source.getState() === 'ready') {
                this.sourceReady_ = true;
                setTimeout(()=>{
                    this.dispatchEvent('sourceready');
                }, 0);
            }
        }
        this.changed();
    }
    /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        if (!this.renderer_) return Promise.resolve([]);
        return this.renderer_.getFeatures(pixel);
    }
    /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        if (!this.renderer_ || !this.rendered) return null;
        return this.renderer_.getData(pixel);
    }
    /**
   * The layer is visible on the map view, i.e. within its min/max resolution or zoom and
   * extent, not set to `visible: false`, and not inside a layer group that is set
   * to `visible: false`.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {boolean} The layer is visible in the map view.
   * @api
   */ isVisible(view) {
        let frameState;
        const map = this.getMapInternal();
        if (!view && map) view = map.getView();
        if (view instanceof (0, $9DiKA.default)) frameState = {
            viewState: view.getState(),
            extent: view.calculateExtent()
        };
        else frameState = view;
        if (!frameState.layerStatesArray && map) frameState.layerStatesArray = map.getLayerGroup().getLayerStatesArray();
        let layerState;
        if (frameState.layerStatesArray) {
            layerState = frameState.layerStatesArray.find((layerState)=>layerState.layer === this);
            if (!layerState) return false;
        } else layerState = this.getLayerState();
        const layerExtent = this.getExtent();
        return $534f30fce11effcd$export$acb1e9cb9ce4ca56(layerState, frameState.viewState) && (!layerExtent || (0, $9pD6L.intersects)(layerExtent, frameState.extent));
    }
    /**
   * Get the attributions of the source of this layer for the given view.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {Array<string>} Attributions for this layer at the given view.
   * @api
   */ getAttributions(view) {
        if (!this.isVisible(view)) return [];
        const getAttributions = this.getSource()?.getAttributions();
        if (!getAttributions) return [];
        const frameState = view instanceof (0, $9DiKA.default) ? view.getViewStateAndExtent() : view;
        let attributions = getAttributions(frameState);
        if (!Array.isArray(attributions)) attributions = [
            attributions
        ];
        return attributions;
    }
    /**
   * In charge to manage the rendering of the layer. One layer type is
   * bounded with one layer renderer.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target which the renderer may (but need not) use
   * for rendering its content.
   * @return {HTMLElement|null} The rendered element.
   */ render(frameState, target) {
        const layerRenderer = this.getRenderer();
        if (layerRenderer.prepareFrame(frameState)) {
            this.rendered = true;
            return layerRenderer.renderFrame(frameState, target);
        }
        return null;
    }
    /**
   * Called when a layer is not visible during a map render.
   */ unrender() {
        this.rendered = false;
    }
    /** @return {string} Declutter */ getDeclutter() {
        return undefined;
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   */ renderDeclutter(frameState, layerState) {}
    /**
   * When the renderer follows a layout -> render approach, do the final rendering here.
   * @param {import('../Map.js').FrameState} frameState Frame state
   */ renderDeferred(frameState) {
        const layerRenderer = this.getRenderer();
        if (!layerRenderer) return;
        layerRenderer.renderDeferred(frameState);
    }
    /**
   * For use inside the library only.
   * @param {import("../Map.js").default|null} map Map.
   */ setMapInternal(map) {
        if (!map) this.unrender();
        this.set((0, $lbO8S.default).MAP, map);
    }
    /**
   * For use inside the library only.
   * @return {import("../Map.js").default|null} Map.
   */ getMapInternal() {
        return this.get((0, $lbO8S.default).MAP);
    }
    /**
   * Sets the layer to be rendered on top of other layers on a map. The map will
   * not manage this layer in its layers collection. This
   * is useful for temporary layers. To remove an unmanaged layer from the map,
   * use `#setMap(null)`.
   *
   * To add the layer to a map and have it managed by the map, use
   * {@link module:ol/Map~Map#addLayer} instead.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.mapPrecomposeKey_) {
            (0, $ilM9F.unlistenByKey)(this.mapPrecomposeKey_);
            this.mapPrecomposeKey_ = null;
        }
        if (!map) this.changed();
        if (this.mapRenderKey_) {
            (0, $ilM9F.unlistenByKey)(this.mapRenderKey_);
            this.mapRenderKey_ = null;
        }
        if (map) {
            this.mapPrecomposeKey_ = (0, $ilM9F.listen)(map, (0, $l6YBe.default).PRECOMPOSE, this.handlePrecompose_, this);
            this.mapRenderKey_ = (0, $ilM9F.listen)(this, (0, $3xzSb.default).CHANGE, map.render, map);
            this.changed();
        }
    }
    /**
   * @param {import("../events/Event.js").default} renderEvent Render event
   * @private
   */ handlePrecompose_(renderEvent) {
        const layerStatesArray = /** @type {import("../render/Event.js").default} */ renderEvent.frameState.layerStatesArray;
        const layerState = this.getLayerState(false);
        (0, $4Cz58.assert)(!layerStatesArray.some((arrayLayerState)=>arrayLayerState.layer === layerState.layer), 'A layer can only be added to the map once. Use either `layer.setMap()` or `map.addLayer()`, not both.');
        layerStatesArray.push(layerState);
    }
    /**
   * Set the layer source.
   * @param {SourceType|null} source The layer source.
   * @observable
   * @api
   */ setSource(source) {
        this.set((0, $lbO8S.default).SOURCE, source);
    }
    /**
   * Get the renderer for this layer.
   * @return {RendererType|null} The layer renderer.
   */ getRenderer() {
        if (!this.renderer_) this.renderer_ = this.createRenderer();
        return this.renderer_;
    }
    /**
   * @return {boolean} The layer has a renderer.
   */ hasRenderer() {
        return !!this.renderer_;
    }
    /**
   * Create a renderer for this layer.
   * @return {RendererType} A layer renderer.
   * @protected
   */ createRenderer() {
        return null;
    }
    /**
   * This will clear the renderer so that a new one can be created next time it is needed
   */ clearRenderer() {
        if (this.renderer_) {
            this.renderer_.dispose();
            delete this.renderer_;
        }
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.clearRenderer();
        this.setSource(null);
        super.disposeInternal();
    }
}
function $534f30fce11effcd$export$acb1e9cb9ce4ca56(layerState, viewState) {
    if (!layerState.visible) return false;
    const resolution = viewState.resolution;
    if (resolution < layerState.minResolution || resolution >= layerState.maxResolution) return false;
    const zoom = viewState.zoom;
    return zoom > layerState.minZoom && zoom <= layerState.maxZoom;
}
var $534f30fce11effcd$export$2e2bcd8739ae039 = $534f30fce11effcd$var$Layer;

});
parcelRegister("9DiKA", function(module, exports) {

$parcel$export(module.exports, "default", () => $70364d0195659942$export$2e2bcd8739ae039);
/**
 * @module ol/View
 */ 
var $fFFY7 = parcelRequire("fFFY7");

var $aKuSF = parcelRequire("aKuSF");

var $i93na = parcelRequire("i93na");

var $fVVyM = parcelRequire("fVVyM");

var $4Cz58 = parcelRequire("4Cz58");

var $fi2rl = parcelRequire("fi2rl");

var $2o3CH = parcelRequire("2o3CH");

var $h9x7v = parcelRequire("h9x7v");

var $9pD6L = parcelRequire("9pD6L");

var $6wUzV = parcelRequire("6wUzV");

var $5ydre = parcelRequire("5ydre");

var $9byFX = parcelRequire("9byFX");

var $dpRHA = parcelRequire("dpRHA");
var $kUyy5 = parcelRequire("kUyy5");

var $g29x3 = parcelRequire("g29x3");

var $ip5LZ = parcelRequire("ip5LZ");

var $7xn5x = parcelRequire("7xn5x");
/**
 * An animation configuration
 *
 * @typedef {Object} Animation
 * @property {import("./coordinate.js").Coordinate} [sourceCenter] Source center.
 * @property {import("./coordinate.js").Coordinate} [targetCenter] Target center.
 * @property {number} [sourceResolution] Source resolution.
 * @property {number} [targetResolution] Target resolution.
 * @property {number} [sourceRotation] Source rotation.
 * @property {number} [targetRotation] Target rotation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Anchor.
 * @property {number} start Start.
 * @property {number} duration Duration.
 * @property {boolean} complete Complete.
 * @property {function(number):number} easing Easing.
 * @property {function(boolean):void} callback Callback.
 */ /**
 * @typedef {Object} Constraints
 * @property {import("./centerconstraint.js").Type} center Center.
 * @property {import("./resolutionconstraint.js").Type} resolution Resolution.
 * @property {import("./rotationconstraint.js").Type} rotation Rotation.
 */ /**
 * @typedef {Object} FitOptions
 * @property {import("./size.js").Size} [size] The size in pixels of the box to
 * fit the extent into. Defaults to the size of the map the view is associated with.
 * If no map or multiple maps are connected to the view, provide the desired box size
 * (e.g. `map.getSize()`).
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in pixels) to be
 * cleared inside the view. Values in the array are top, right, bottom and left
 * padding.
 * @property {boolean} [nearest=false] If the view `constrainResolution` option is `true`,
 * get the nearest extent instead of the closest that actually fits the view.
 * @property {number} [minResolution=0] Minimum resolution that we zoom to.
 * @property {number} [maxZoom] Maximum zoom level that we zoom to. If
 * `minResolution` is given, this property is ignored.
 * @property {number} [duration] The duration of the animation in milliseconds.
 * By default, there is no animation to the target extent.
 * @property {function(number):number} [easing] The easing function used during
 * the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 * @property {function(boolean):void} [callback] Function called when the view is in
 * its final position. The callback will be called with `true` if the animation
 * series completed on its own or `false` if it was cancelled.
 */ /**
 * @typedef {Object} ViewOptions
 * @property {import("./coordinate.js").Coordinate} [center] The initial center for
 * the view. If a user projection is not set, the coordinate system for the center is
 * specified with the `projection` option. Layer sources will not be fetched if this
 * is not set, but the center can be set later with {@link #setCenter}.
 * @property {boolean|number} [constrainRotation=true] Rotation constraint.
 * `false` means no constraint. `true` means no constraint, but snap to zero
 * near zero. A number constrains the rotation to that number of values. For
 * example, `4` will constrain the rotation to 0, 90, 180, and 270 degrees.
 * @property {boolean} [enableRotation=true] Enable rotation.
 * If `false`, a rotation constraint that always sets the rotation to zero is
 * used. The `constrainRotation` option has no effect if `enableRotation` is
 * `false`.
 * @property {import("./extent.js").Extent} [extent] The extent that constrains the
 * view, in other words, nothing outside of this extent can be visible on the map.
 * @property {boolean} [constrainOnlyCenter=false] If true, the extent
 * constraint will only apply to the view center and not the whole extent.
 * @property {boolean} [smoothExtentConstraint=true] If true, the extent
 * constraint will be applied smoothly, i.e. allow the view to go slightly outside
 * of the given `extent`.
 * @property {number} [maxResolution] The maximum resolution used to determine
 * the resolution constraint. It is used together with `minResolution` (or
 * `maxZoom`) and `zoomFactor`. If unspecified it is calculated in such a way
 * that the projection's validity extent fits in a 256x256 px tile. If the
 * projection is Spherical Mercator (the default) then `maxResolution` defaults
 * to `40075016.68557849 / 256 = 156543.03392804097`.
 * @property {number} [minResolution] The minimum resolution used to determine
 * the resolution constraint.  It is used together with `maxResolution` (or
 * `minZoom`) and `zoomFactor`.  If unspecified it is calculated assuming 29
 * zoom levels (with a factor of 2). If the projection is Spherical Mercator
 * (the default) then `minResolution` defaults to
 * `40075016.68557849 / 256 / Math.pow(2, 28) = 0.0005831682455839253`.
 * @property {number} [maxZoom=28] The maximum zoom level used to determine the
 * resolution constraint. It is used together with `minZoom` (or
 * `maxResolution`) and `zoomFactor`.  Note that if `minResolution` is also
 * provided, it is given precedence over `maxZoom`.
 * @property {number} [minZoom=0] The minimum zoom level used to determine the
 * resolution constraint. It is used together with `maxZoom` (or
 * `minResolution`) and `zoomFactor`.  Note that if `maxResolution` is also
 * provided, it is given precedence over `minZoom`.
 * @property {boolean} [multiWorld=false] If `false` the view is constrained so
 * only one world is visible, and you cannot pan off the edge.  If `true` the map
 * may show multiple worlds at low zoom levels.  Only used if the `projection` is
 * global.  Note that if `extent` is also provided it is given precedence.
 * @property {boolean} [constrainResolution=false] If true, the view will always
 * animate to the closest zoom level after an interaction; false means
 * intermediary zoom levels are allowed.
 * @property {boolean} [smoothResolutionConstraint=true] If true, the resolution
 * min/max values will be applied smoothly, i. e. allow the view to exceed slightly
 * the given resolution or zoom bounds.
 * @property {boolean} [showFullExtent=false] Allow the view to be zoomed out to
 * show the full configured extent. By default, when a view is configured with an
 * extent, users will not be able to zoom out so the viewport exceeds the extent in
 * either dimension. This means the full extent may not be visible if the viewport
 * is taller or wider than the aspect ratio of the configured extent. If
 * showFullExtent is true, the user will be able to zoom out so that the viewport
 * exceeds the height or width of the configured extent, but not both, allowing the
 * full extent to be shown.
 * @property {import("./proj.js").ProjectionLike} [projection='EPSG:3857'] The
 * projection. The default is Spherical Mercator.
 * @property {number} [resolution] The initial resolution for the view. The
 * units are `projection` units per pixel (e.g. meters per pixel). An
 * alternative to setting this is to set `zoom`. Layer sources will not be
 * fetched if neither this nor `zoom` are defined, but they can be set later
 * with {@link #setZoom} or {@link #setResolution}.
 * @property {Array<number>} [resolutions] Resolutions that determine the
 * zoom levels if specified. The index in the array corresponds to the zoom level,
 * therefore the resolution values have to be in descending order. It also constrains
 * the resolution by the minimum and maximum value. If set the `maxResolution`,
 * `minResolution`, `minZoom`, `maxZoom`, and `zoomFactor` options are ignored.
 * @property {number} [rotation=0] The initial rotation for the view in radians
 * (positive rotation clockwise, 0 means North).
 * @property {number} [zoom] Only used if `resolution` is not defined. Zoom
 * level used to calculate the initial resolution for the view.
 * @property {number} [zoomFactor=2] The zoom factor used to compute the
 * corresponding resolution.
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in css pixels).
 * If the map viewport is partially covered with other content (overlays) along
 * its edges, this setting allows to shift the center of the viewport away from
 * that content. The order of the values is top, right, bottom, left.
 */ /**
 * @typedef {Object} AnimationOptions
 * @property {import("./coordinate.js").Coordinate} [center] The center of the view at the end of
 * the animation.
 * @property {number} [zoom] The zoom level of the view at the end of the
 * animation. This takes precedence over `resolution`.
 * @property {number} [resolution] The resolution of the view at the end
 * of the animation.  If `zoom` is also provided, this option will be ignored.
 * @property {number} [rotation] The rotation of the view at the end of
 * the animation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Optional anchor to remain fixed
 * during a rotation or resolution animation.
 * @property {number} [duration=1000] The duration of the animation in milliseconds.
 * @property {function(number):number} [easing] The easing function used
 * during the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 */ /**
 * @typedef {Object} State
 * @property {import("./coordinate.js").Coordinate} center Center (in view projection coordinates).
 * @property {import("./proj/Projection.js").default} projection Projection.
 * @property {number} resolution Resolution.
 * @property {import("./coordinate.js").Coordinate} [nextCenter] The next center during an animation series.
 * @property {number} [nextResolution] The next resolution during an animation series.
 * @property {number} [nextRotation] The next rotation during an animation series.
 * @property {number} rotation Rotation.
 * @property {number} zoom Zoom.
 */ /**
 * Like {@link import("./Map.js").FrameState}, but just `viewState` and `extent`.
 * @typedef {Object} ViewStateLayerStateExtent
 * @property {State} viewState View state.
 * @property {import("./extent.js").Extent} extent Extent (in user projection coordinates).
 * @property {Array<import("./layer/Layer.js").State>} [layerStatesArray] Layer states.
 */ /**
 * Default min zoom level for the map view.
 * @type {number}
 */ const $70364d0195659942$var$DEFAULT_MIN_ZOOM = 0;
/**
 * @typedef {import("./ObjectEventType").Types|'change:center'|'change:resolution'|'change:rotation'} ViewObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<ViewObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|ViewObjectEventTypes, Return>} ViewOnSignature
 */ /**
 * @classdesc
 * A View object represents a simple 2D view of the map.
 *
 * This is the object to act upon to change the center, resolution,
 * and rotation of the map.
 *
 * A View has a `projection`. The projection determines the
 * coordinate system of the center, and its units determine the units of the
 * resolution (projection units per pixel). The default projection is
 * Web Mercator (EPSG:3857).
 *
 * ### The view states
 *
 * A View is determined by three states: `center`, `resolution`,
 * and `rotation`. Each state has a corresponding getter and setter, e.g.
 * `getCenter` and `setCenter` for the `center` state.
 *
 * The `zoom` state is actually not saved on the view: all computations
 * internally use the `resolution` state. Still, the `setZoom` and `getZoom`
 * methods are available, as well as `getResolutionForZoom` and
 * `getZoomForResolution` to switch from one system to the other.
 *
 * ### The constraints
 *
 * `setCenter`, `setResolution` and `setRotation` can be used to change the
 * states of the view, but any constraint defined in the constructor will
 * be applied along the way.
 *
 * A View object can have a *resolution constraint*, a *rotation constraint*
 * and a *center constraint*.
 *
 * The *resolution constraint* typically restricts min/max values and
 * snaps to specific resolutions. It is determined by the following
 * options: `resolutions`, `maxResolution`, `maxZoom` and `zoomFactor`.
 * If `resolutions` is set, the other three options are ignored. See
 * documentation for each option for more information. By default, the view
 * only has a min/max restriction and allow intermediary zoom levels when
 * pinch-zooming for example.
 *
 * The *rotation constraint* snaps to specific angles. It is determined
 * by the following options: `enableRotation` and `constrainRotation`.
 * By default rotation is allowed and its value is snapped to zero when approaching the
 * horizontal.
 *
 * The *center constraint* is determined by the `extent` option. By
 * default the view center is not constrained at all.
 *
 * ### Changing the view state
 *
 * It is important to note that `setZoom`, `setResolution`, `setCenter` and
 * `setRotation` are subject to the above mentioned constraints. As such, it
 * may sometimes not be possible to know in advance the resulting state of the
 * View. For example, calling `setResolution(10)` does not guarantee that
 * `getResolution()` will return `10`.
 *
 * A consequence of this is that, when applying a delta on the view state, one
 * should use `adjustCenter`, `adjustRotation`, `adjustZoom` and `adjustResolution`
 * rather than the corresponding setters. This will let view do its internal
 * computations. Besides, the `adjust*` methods also take an `anchor`
 * argument which allows specifying an origin for the transformation.
 *
 * ### Interacting with the view
 *
 * View constraints are usually only applied when the view is *at rest*, meaning that
 * no interaction or animation is ongoing. As such, if the user puts the view in a
 * state that is not equivalent to a constrained one (e.g. rotating the view when
 * the snap angle is 0), an animation will be triggered at the interaction end to
 * put back the view to a stable state;
 *
 * @api
 * @extends {BaseObject<ViewOptions>}
 */ class $70364d0195659942$var$View extends (0, $fFFY7.default) {
    /**
   * @param {ViewOptions} [options] View options.
   */ constructor(options){
        super();
        /***
     * @type {ViewOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {ViewOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {ViewOnSignature<void>}
     */ this.un;
        options = Object.assign({}, options);
        /**
     * @private
     * @type {Array<number>}
     */ this.hints_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {Array<Array<Animation>>}
     */ this.animations_ = [];
        /**
     * @private
     * @type {number|undefined}
     */ this.updateAnimationKey_;
        /**
     * @private
     * @const
     * @type {import("./proj/Projection.js").default}
     */ this.projection_ = (0, $dpRHA.createProjection)(options.projection, 'EPSG:3857');
        /**
     * @private
     * @type {import("./size.js").Size}
     */ this.viewportSize_ = [
            100,
            100
        ];
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.targetCenter_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetResolution_;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate}
     */ this.nextCenter_ = null;
        /**
     * @private
     * @type {number}
     */ this.nextResolution_;
        /**
     * @private
     * @type {number}
     */ this.nextRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.cancelAnchor_ = undefined;
        if (options.projection) (0, $dpRHA.disableCoordinateWarning)();
        if (options.center) options.center = (0, $dpRHA.fromUserCoordinate)(options.center, this.projection_);
        if (options.extent) options.extent = (0, $dpRHA.fromUserExtent)(options.extent, this.projection_);
        this.applyOptions_(options);
    }
    /**
   * Set up the view with the given options.
   * @param {ViewOptions} options View options.
   */ applyOptions_(options) {
        const properties = Object.assign({}, options);
        for(const key in 0, $i93na.default)delete properties[key];
        this.setProperties(properties, true);
        const resolutionConstraintInfo = $70364d0195659942$export$c68d65f9148da196(options);
        /**
     * @private
     * @type {number}
     */ this.maxResolution_ = resolutionConstraintInfo.maxResolution;
        /**
     * @private
     * @type {number}
     */ this.minResolution_ = resolutionConstraintInfo.minResolution;
        /**
     * @private
     * @type {number}
     */ this.zoomFactor_ = resolutionConstraintInfo.zoomFactor;
        /**
     * @private
     * @type {Array<number>|undefined}
     */ this.resolutions_ = options.resolutions;
        /**
     * @type {Array<number>|undefined}
     * @private
     */ this.padding_ = options.padding;
        /**
     * @private
     * @type {number}
     */ this.minZoom_ = resolutionConstraintInfo.minZoom;
        const centerConstraint = $70364d0195659942$export$964345001ee9ac52(options);
        const resolutionConstraint = resolutionConstraintInfo.constraint;
        const rotationConstraint = $70364d0195659942$export$4eeaa08dd550e3c0(options);
        /**
     * @private
     * @type {Constraints}
     */ this.constraints_ = {
            center: centerConstraint,
            resolution: resolutionConstraint,
            rotation: rotationConstraint
        };
        this.setRotation(options.rotation !== undefined ? options.rotation : 0);
        this.setCenterInternal(options.center !== undefined ? options.center : null);
        if (options.resolution !== undefined) this.setResolution(options.resolution);
        else if (options.zoom !== undefined) this.setZoom(options.zoom);
    }
    /**
   * Padding (in css pixels).
   * If the map viewport is partially covered with other content (overlays) along
   * its edges, this setting allows to shift the center of the viewport away from that
   * content. The order of the values in the array is top, right, bottom, left.
   * The default is no padding, which is equivalent to `[0, 0, 0, 0]`.
   * @type {Array<number>|undefined}
   * @api
   */ get padding() {
        return this.padding_;
    }
    set padding(padding) {
        let oldPadding = this.padding_;
        this.padding_ = padding;
        const center = this.getCenterInternal();
        if (center) {
            const newPadding = padding || [
                0,
                0,
                0,
                0
            ];
            oldPadding = oldPadding || [
                0,
                0,
                0,
                0
            ];
            const resolution = this.getResolution();
            const offsetX = resolution / 2 * (newPadding[3] - oldPadding[3] + oldPadding[1] - newPadding[1]);
            const offsetY = resolution / 2 * (newPadding[0] - oldPadding[0] + oldPadding[2] - newPadding[2]);
            this.setCenterInternal([
                center[0] + offsetX,
                center[1] - offsetY
            ]);
        }
    }
    /**
   * Get an updated version of the view options used to construct the view.  The
   * current resolution (or zoom), center, and rotation are applied to any stored
   * options.  The provided options can be used to apply new min/max zoom or
   * resolution limits.
   * @param {ViewOptions} newOptions New options to be applied.
   * @return {ViewOptions} New options updated with the current view state.
   */ getUpdatedOptions_(newOptions) {
        const options = this.getProperties();
        // preserve resolution (or zoom)
        if (options.resolution !== undefined) options.resolution = this.getResolution();
        else options.zoom = this.getZoom();
        // preserve center
        options.center = this.getCenterInternal();
        // preserve rotation
        options.rotation = this.getRotation();
        return Object.assign({}, options, newOptions);
    }
    /**
   * Animate the view.  The view's center, zoom (or resolution), and rotation
   * can be animated for smooth transitions between view states.  For example,
   * to animate the view to a new zoom level:
   *
   *     view.animate({zoom: view.getZoom() + 1});
   *
   * By default, the animation lasts one second and uses in-and-out easing.  You
   * can customize this behavior by including `duration` (in milliseconds) and
   * `easing` options (see {@link module:ol/easing}).
   *
   * To chain together multiple animations, call the method with multiple
   * animation objects.  For example, to first zoom and then pan:
   *
   *     view.animate({zoom: 10}, {center: [0, 0]});
   *
   * If you provide a function as the last argument to the animate method, it
   * will get called at the end of an animation series.  The callback will be
   * called with `true` if the animation series completed on its own or `false`
   * if it was cancelled.
   *
   * Animations are cancelled by user interactions (e.g. dragging the map) or by
   * calling `view.setCenter()`, `view.setResolution()`, or `view.setRotation()`
   * (or another method that calls one of these).
   *
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation
   *     options.  Multiple animations can be run in series by passing multiple
   *     options objects.  To run multiple animations in parallel, call the method
   *     multiple times.  An optional callback can be provided as a final
   *     argument.  The callback will be called with a boolean indicating whether
   *     the animation completed without being cancelled.
   * @api
   */ animate(var_args) {
        if (this.isDef() && !this.getAnimating()) this.resolveConstraints(0);
        const args = new Array(arguments.length);
        for(let i = 0; i < args.length; ++i){
            let options = arguments[i];
            if (options.center) {
                options = Object.assign({}, options);
                options.center = (0, $dpRHA.fromUserCoordinate)(options.center, this.getProjection());
            }
            if (options.anchor) {
                options = Object.assign({}, options);
                options.anchor = (0, $dpRHA.fromUserCoordinate)(options.anchor, this.getProjection());
            }
            args[i] = options;
        }
        this.animateInternal.apply(this, args);
    }
    /**
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation options.
   */ animateInternal(var_args) {
        let animationCount = arguments.length;
        let callback;
        if (animationCount > 1 && typeof arguments[animationCount - 1] === 'function') {
            callback = arguments[animationCount - 1];
            --animationCount;
        }
        let i = 0;
        for(; i < animationCount && !this.isDef(); ++i){
            // if view properties are not yet set, shortcut to the final state
            const state = arguments[i];
            if (state.center) this.setCenterInternal(state.center);
            if (state.zoom !== undefined) this.setZoom(state.zoom);
            else if (state.resolution) this.setResolution(state.resolution);
            if (state.rotation !== undefined) this.setRotation(state.rotation);
        }
        if (i === animationCount) {
            if (callback) $70364d0195659942$var$animationCallback(callback, true);
            return;
        }
        let start = Date.now();
        let center = this.targetCenter_.slice();
        let resolution = this.targetResolution_;
        let rotation = this.targetRotation_;
        const series = [];
        for(; i < animationCount; ++i){
            const options = /** @type {AnimationOptions} */ arguments[i];
            const animation = {
                start: start,
                complete: false,
                anchor: options.anchor,
                duration: options.duration !== undefined ? options.duration : 1000,
                easing: options.easing || (0, $h9x7v.inAndOut),
                callback: callback
            };
            if (options.center) {
                animation.sourceCenter = center;
                animation.targetCenter = options.center.slice();
                center = animation.targetCenter;
            }
            if (options.zoom !== undefined) {
                animation.sourceResolution = resolution;
                animation.targetResolution = this.getResolutionForZoom(options.zoom);
                resolution = animation.targetResolution;
            } else if (options.resolution) {
                animation.sourceResolution = resolution;
                animation.targetResolution = options.resolution;
                resolution = animation.targetResolution;
            }
            if (options.rotation !== undefined) {
                animation.sourceRotation = rotation;
                const delta = (0, $9byFX.modulo)(options.rotation - rotation + Math.PI, 2 * Math.PI) - Math.PI;
                animation.targetRotation = rotation + delta;
                rotation = animation.targetRotation;
            }
            // check if animation is a no-op
            if ($70364d0195659942$export$ee75376562060184(animation)) animation.complete = true;
            else start += animation.duration;
            series.push(animation);
        }
        this.animations_.push(series);
        this.setHint((0, $aKuSF.default).ANIMATING, 1);
        this.updateAnimations_();
    }
    /**
   * Determine if the view is being animated.
   * @return {boolean} The view is being animated.
   * @api
   */ getAnimating() {
        return this.hints_[(0, $aKuSF.default).ANIMATING] > 0;
    }
    /**
   * Determine if the user is interacting with the view, such as panning or zooming.
   * @return {boolean} The view is being interacted with.
   * @api
   */ getInteracting() {
        return this.hints_[(0, $aKuSF.default).INTERACTING] > 0;
    }
    /**
   * Cancel any ongoing animations.
   * @api
   */ cancelAnimations() {
        this.setHint((0, $aKuSF.default).ANIMATING, -this.hints_[(0, $aKuSF.default).ANIMATING]);
        let anchor;
        for(let i = 0, ii = this.animations_.length; i < ii; ++i){
            const series = this.animations_[i];
            if (series[0].callback) $70364d0195659942$var$animationCallback(series[0].callback, false);
            if (!anchor) for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (!animation.complete) {
                    anchor = animation.anchor;
                    break;
                }
            }
        }
        this.animations_.length = 0;
        this.cancelAnchor_ = anchor;
        this.nextCenter_ = null;
        this.nextResolution_ = NaN;
        this.nextRotation_ = NaN;
    }
    /**
   * Update all animations.
   */ updateAnimations_() {
        if (this.updateAnimationKey_ !== undefined) {
            cancelAnimationFrame(this.updateAnimationKey_);
            this.updateAnimationKey_ = undefined;
        }
        if (!this.getAnimating()) return;
        const now = Date.now();
        let more = false;
        for(let i = this.animations_.length - 1; i >= 0; --i){
            const series = this.animations_[i];
            let seriesComplete = true;
            for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (animation.complete) continue;
                const elapsed = now - animation.start;
                let fraction = animation.duration > 0 ? elapsed / animation.duration : 1;
                if (fraction >= 1) {
                    animation.complete = true;
                    fraction = 1;
                } else seriesComplete = false;
                const progress = animation.easing(fraction);
                if (animation.sourceCenter) {
                    const x0 = animation.sourceCenter[0];
                    const y0 = animation.sourceCenter[1];
                    const x1 = animation.targetCenter[0];
                    const y1 = animation.targetCenter[1];
                    this.nextCenter_ = animation.targetCenter;
                    const x = x0 + progress * (x1 - x0);
                    const y = y0 + progress * (y1 - y0);
                    this.targetCenter_ = [
                        x,
                        y
                    ];
                }
                if (animation.sourceResolution && animation.targetResolution) {
                    const resolution = progress === 1 ? animation.targetResolution : animation.sourceResolution + progress * (animation.targetResolution - animation.sourceResolution);
                    if (animation.anchor) {
                        const size = this.getViewportSize_(this.getRotation());
                        const constrainedResolution = this.constraints_.resolution(resolution, 0, size, true);
                        this.targetCenter_ = this.calculateCenterZoom(constrainedResolution, animation.anchor);
                    }
                    this.nextResolution_ = animation.targetResolution;
                    this.targetResolution_ = resolution;
                    this.applyTargetState_(true);
                }
                if (animation.sourceRotation !== undefined && animation.targetRotation !== undefined) {
                    const rotation = progress === 1 ? (0, $9byFX.modulo)(animation.targetRotation + Math.PI, 2 * Math.PI) - Math.PI : animation.sourceRotation + progress * (animation.targetRotation - animation.sourceRotation);
                    if (animation.anchor) {
                        const constrainedRotation = this.constraints_.rotation(rotation, true);
                        this.targetCenter_ = this.calculateCenterRotate(constrainedRotation, animation.anchor);
                    }
                    this.nextRotation_ = animation.targetRotation;
                    this.targetRotation_ = rotation;
                }
                this.applyTargetState_(true);
                more = true;
                if (!animation.complete) break;
            }
            if (seriesComplete) {
                this.animations_[i] = null;
                this.setHint((0, $aKuSF.default).ANIMATING, -1);
                this.nextCenter_ = null;
                this.nextResolution_ = NaN;
                this.nextRotation_ = NaN;
                const callback = series[0].callback;
                if (callback) $70364d0195659942$var$animationCallback(callback, true);
            }
        }
        // prune completed series
        this.animations_ = this.animations_.filter(Boolean);
        if (more && this.updateAnimationKey_ === undefined) this.updateAnimationKey_ = requestAnimationFrame(this.updateAnimations_.bind(this));
    }
    /**
   * @param {number} rotation Target rotation.
   * @param {import("./coordinate.js").Coordinate} anchor Rotation anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for rotation and anchor.
   */ calculateCenterRotate(rotation, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        if (currentCenter !== undefined) {
            center = [
                currentCenter[0] - anchor[0],
                currentCenter[1] - anchor[1]
            ];
            (0, $2o3CH.rotate)(center, rotation - this.getRotation());
            (0, $2o3CH.add)(center, anchor);
        }
        return center;
    }
    /**
   * @param {number} resolution Target resolution.
   * @param {import("./coordinate.js").Coordinate} anchor Zoom anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for resolution and anchor.
   */ calculateCenterZoom(resolution, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        const currentResolution = this.getResolution();
        if (currentCenter !== undefined && currentResolution !== undefined) {
            const x = anchor[0] - resolution * (anchor[0] - currentCenter[0]) / currentResolution;
            const y = anchor[1] - resolution * (anchor[1] - currentCenter[1]) / currentResolution;
            center = [
                x,
                y
            ];
        }
        return center;
    }
    /**
   * Returns the current viewport size.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size or `[100, 100]` when no viewport is found.
   */ getViewportSize_(rotation) {
        const size = this.viewportSize_;
        if (rotation) {
            const w = size[0];
            const h = size[1];
            return [
                Math.abs(w * Math.cos(rotation)) + Math.abs(h * Math.sin(rotation)),
                Math.abs(w * Math.sin(rotation)) + Math.abs(h * Math.cos(rotation))
            ];
        }
        return size;
    }
    /**
   * Stores the viewport size on the view. The viewport size is not read every time from the DOM
   * to avoid performance hit and layout reflow.
   * This should be done on map size change.
   * Note: the constraints are not resolved during an animation to avoid stopping it
   * @param {import("./size.js").Size} [size] Viewport size; if undefined, [100, 100] is assumed
   */ setViewportSize(size) {
        this.viewportSize_ = Array.isArray(size) ? size.slice() : [
            100,
            100
        ];
        if (!this.getAnimating()) this.resolveConstraints(0);
    }
    /**
   * Get the view center.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   * @observable
   * @api
   */ getCenter() {
        const center = this.getCenterInternal();
        if (!center) return center;
        return (0, $dpRHA.toUserCoordinate)(center, this.getProjection());
    }
    /**
   * Get the view center without transforming to user projection.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   */ getCenterInternal() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get((0, $i93na.default).CENTER);
    }
    /**
   * @return {Constraints} Constraints.
   */ getConstraints() {
        return this.constraints_;
    }
    /**
   * @return {boolean} Resolution constraint is set
   */ getConstrainResolution() {
        return this.get('constrainResolution');
    }
    /**
   * @param {Array<number>} [hints] Destination array.
   * @return {Array<number>} Hint.
   */ getHints(hints) {
        if (hints !== undefined) {
            hints[0] = this.hints_[0];
            hints[1] = this.hints_[1];
            return hints;
        }
        return this.hints_.slice();
    }
    /**
   * Calculate the extent for the current view state and the passed box size.
   * @param {import("./size.js").Size} [size] The pixel dimensions of the box
   * into which the calculated extent should fit. Defaults to the size of the
   * map the view is associated with.
   * If no map or multiple maps are connected to the view, provide the desired
   * box size (e.g. `map.getSize()`).
   * @return {import("./extent.js").Extent} Extent.
   * @api
   */ calculateExtent(size) {
        const extent = this.calculateExtentInternal(size);
        return (0, $dpRHA.toUserExtent)(extent, this.getProjection());
    }
    /**
   * @param {import("./size.js").Size} [size] Box pixel size. If not provided,
   * the map's last known viewport size will be used.
   * @return {import("./extent.js").Extent} Extent.
   */ calculateExtentInternal(size) {
        size = size || this.getViewportSizeMinusPadding_();
        const center = /** @type {!import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        (0, $4Cz58.assert)(center, 'The view center is not defined');
        const resolution = /** @type {!number} */ this.getResolution();
        (0, $4Cz58.assert)(resolution !== undefined, 'The view resolution is not defined');
        const rotation = /** @type {!number} */ this.getRotation();
        (0, $4Cz58.assert)(rotation !== undefined, 'The view rotation is not defined');
        return (0, $9pD6L.getForViewAndSize)(center, resolution, rotation, size);
    }
    /**
   * Get the maximum resolution of the view.
   * @return {number} The maximum resolution of the view.
   * @api
   */ getMaxResolution() {
        return this.maxResolution_;
    }
    /**
   * Get the minimum resolution of the view.
   * @return {number} The minimum resolution of the view.
   * @api
   */ getMinResolution() {
        return this.minResolution_;
    }
    /**
   * Get the maximum zoom level for the view.
   * @return {number} The maximum zoom level.
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.minResolution_);
    }
    /**
   * Set a new maximum zoom level for the view.
   * @param {number} zoom The maximum zoom level.
   * @api
   */ setMaxZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            maxZoom: zoom
        }));
    }
    /**
   * Get the minimum zoom level for the view.
   * @return {number} The minimum zoom level.
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.maxResolution_);
    }
    /**
   * Set a new minimum zoom level for the view.
   * @param {number} zoom The minimum zoom level.
   * @api
   */ setMinZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            minZoom: zoom
        }));
    }
    /**
   * Set whether the view should allow intermediary zoom levels.
   * @param {boolean} enabled Whether the resolution is constrained.
   * @api
   */ setConstrainResolution(enabled) {
        this.applyOptions_(this.getUpdatedOptions_({
            constrainResolution: enabled
        }));
    }
    /**
   * Get the view projection.
   * @return {import("./proj/Projection.js").default} The projection of the view.
   * @api
   */ getProjection() {
        return this.projection_;
    }
    /**
   * Get the view resolution.
   * @return {number|undefined} The resolution of the view.
   * @observable
   * @api
   */ getResolution() {
        return /** @type {number|undefined} */ this.get((0, $i93na.default).RESOLUTION);
    }
    /**
   * Get the resolutions for the view. This returns the array of resolutions
   * passed to the constructor of the View, or undefined if none were given.
   * @return {Array<number>|undefined} The resolutions of the view.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   * @api
   */ getResolutionForExtent(extent, size) {
        return this.getResolutionForExtentInternal((0, $dpRHA.fromUserExtent)(extent, this.getProjection()), size);
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   */ getResolutionForExtentInternal(extent, size) {
        size = size || this.getViewportSizeMinusPadding_();
        const xResolution = (0, $9pD6L.getWidth)(extent) / size[0];
        const yResolution = (0, $9pD6L.getHeight)(extent) / size[1];
        return Math.max(xResolution, yResolution);
    }
    /**
   * Return a function that returns a value between 0 and 1 for a
   * resolution. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Resolution for value function.
   */ getResolutionForValueFunction(power) {
        power = power || 2;
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / Math.log(power);
        return(/**
       * @param {number} value Value.
       * @return {number} Resolution.
       */ function(value) {
            const resolution = maxResolution / Math.pow(power, value * max);
            return resolution;
        });
    }
    /**
   * Get the view rotation.
   * @return {number} The rotation of the view in radians.
   * @observable
   * @api
   */ getRotation() {
        return /** @type {number} */ this.get((0, $i93na.default).ROTATION);
    }
    /**
   * Return a function that returns a resolution for a value between
   * 0 and 1. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Value for resolution function.
   */ getValueForResolutionFunction(power) {
        const logPower = Math.log(power || 2);
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / logPower;
        return(/**
       * @param {number} resolution Resolution.
       * @return {number} Value.
       */ function(resolution) {
            const value = Math.log(maxResolution / resolution) / logPower / max;
            return value;
        });
    }
    /**
   * Returns the size of the viewport minus padding.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size reduced by the padding.
   */ getViewportSizeMinusPadding_(rotation) {
        let size = this.getViewportSize_(rotation);
        const padding = this.padding_;
        if (padding) size = [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ];
        return size;
    }
    /**
   * @return {State} View state.
   */ getState() {
        const projection = this.getProjection();
        const resolution = this.getResolution();
        const rotation = this.getRotation();
        let center = /** @type {import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        const padding = this.padding_;
        if (padding) {
            const reducedSize = this.getViewportSizeMinusPadding_();
            center = $70364d0195659942$var$calculateCenterOn(center, this.getViewportSize_(), [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
        }
        return {
            center: center.slice(0),
            projection: projection !== undefined ? projection : null,
            resolution: resolution,
            nextCenter: this.nextCenter_,
            nextResolution: this.nextResolution_,
            nextRotation: this.nextRotation_,
            rotation: rotation,
            zoom: this.getZoom()
        };
    }
    /**
   * @return {ViewStateLayerStateExtent} Like `FrameState`, but just `viewState` and `extent`.
   */ getViewStateAndExtent() {
        return {
            viewState: this.getState(),
            extent: this.calculateExtent()
        };
    }
    /**
   * Get the current zoom level. This method may return non-integer zoom levels
   * if the view does not constrain the resolution, or if an interaction or
   * animation is underway.
   * @return {number|undefined} Zoom.
   * @api
   */ getZoom() {
        let zoom;
        const resolution = this.getResolution();
        if (resolution !== undefined) zoom = this.getZoomForResolution(resolution);
        return zoom;
    }
    /**
   * Get the zoom level for a resolution.
   * @param {number} resolution The resolution.
   * @return {number|undefined} The zoom level for the provided resolution.
   * @api
   */ getZoomForResolution(resolution) {
        let offset = this.minZoom_ || 0;
        let max, zoomFactor;
        if (this.resolutions_) {
            const nearest = (0, $fVVyM.linearFindNearest)(this.resolutions_, resolution, 1);
            offset = nearest;
            max = this.resolutions_[nearest];
            if (nearest == this.resolutions_.length - 1) zoomFactor = 2;
            else zoomFactor = max / this.resolutions_[nearest + 1];
        } else {
            max = this.maxResolution_;
            zoomFactor = this.zoomFactor_;
        }
        return offset + Math.log(max / resolution) / Math.log(zoomFactor);
    }
    /**
   * Get the resolution for a zoom level.
   * @param {number} zoom Zoom level.
   * @return {number} The view resolution for the provided zoom level.
   * @api
   */ getResolutionForZoom(zoom) {
        if (this.resolutions_?.length) {
            if (this.resolutions_.length === 1) return this.resolutions_[0];
            const baseLevel = (0, $9byFX.clamp)(Math.floor(zoom), 0, this.resolutions_.length - 2);
            const zoomFactor = this.resolutions_[baseLevel] / this.resolutions_[baseLevel + 1];
            return this.resolutions_[baseLevel] / Math.pow(zoomFactor, (0, $9byFX.clamp)(zoom - baseLevel, 0, 1));
        }
        return this.maxResolution_ / Math.pow(this.zoomFactor_, zoom - this.minZoom_);
    }
    /**
   * Fit the given geometry or extent based on the given map size and border.
   * The size is pixel dimensions of the box to fit the extent into.
   * In most cases you will want to use the map size, that is `map.getSize()`.
   * Takes care of the map angle.
   * @param {import("./geom/SimpleGeometry.js").default|import("./extent.js").Extent} geometryOrExtent The geometry or
   *     extent to fit the view to.
   * @param {FitOptions} [options] Options.
   * @api
   */ fit(geometryOrExtent, options) {
        /** @type {import("./geom/SimpleGeometry.js").default} */ let geometry;
        (0, $4Cz58.assert)(Array.isArray(geometryOrExtent) || typeof /** @type {?} */ geometryOrExtent.getSimplifiedGeometry === 'function', 'Invalid extent or geometry provided as `geometry`');
        if (Array.isArray(geometryOrExtent)) {
            (0, $4Cz58.assert)(!(0, $9pD6L.isEmpty)(geometryOrExtent), 'Cannot fit empty extent provided as `geometry`');
            const extent = (0, $dpRHA.fromUserExtent)(geometryOrExtent, this.getProjection());
            geometry = (0, $5ydre.fromExtent)(extent);
        } else if (geometryOrExtent.getType() === 'Circle') {
            const extent = (0, $dpRHA.fromUserExtent)(geometryOrExtent.getExtent(), this.getProjection());
            geometry = (0, $5ydre.fromExtent)(extent);
            geometry.rotate(this.getRotation(), (0, $9pD6L.getCenter)(extent));
        } else {
            const userProjection = (0, $dpRHA.getUserProjection)();
            if (userProjection) geometry = /** @type {import("./geom/SimpleGeometry.js").default} */ geometryOrExtent.clone().transform(userProjection, this.getProjection());
            else geometry = geometryOrExtent;
        }
        this.fitInternal(geometry, options);
    }
    /**
   * Calculate rotated extent
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @return {import("./extent").Extent} The rotated extent for the geometry.
   */ rotatedExtentForGeometry(geometry) {
        const rotation = this.getRotation();
        const cosAngle = Math.cos(rotation);
        const sinAngle = Math.sin(-rotation);
        const coords = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        let minRotX = Infinity;
        let minRotY = Infinity;
        let maxRotX = -Infinity;
        let maxRotY = -Infinity;
        for(let i = 0, ii = coords.length; i < ii; i += stride){
            const rotX = coords[i] * cosAngle - coords[i + 1] * sinAngle;
            const rotY = coords[i] * sinAngle + coords[i + 1] * cosAngle;
            minRotX = Math.min(minRotX, rotX);
            minRotY = Math.min(minRotY, rotY);
            maxRotX = Math.max(maxRotX, rotX);
            maxRotY = Math.max(maxRotY, rotY);
        }
        return [
            minRotX,
            minRotY,
            maxRotX,
            maxRotY
        ];
    }
    /**
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @param {FitOptions} [options] Options.
   */ fitInternal(geometry, options) {
        options = options || {};
        let size = options.size;
        if (!size) size = this.getViewportSizeMinusPadding_();
        const padding = options.padding !== undefined ? options.padding : [
            0,
            0,
            0,
            0
        ];
        const nearest = options.nearest !== undefined ? options.nearest : false;
        let minResolution;
        if (options.minResolution !== undefined) minResolution = options.minResolution;
        else if (options.maxZoom !== undefined) minResolution = this.getResolutionForZoom(options.maxZoom);
        else minResolution = 0;
        const rotatedExtent = this.rotatedExtentForGeometry(geometry);
        // calculate resolution
        let resolution = this.getResolutionForExtentInternal(rotatedExtent, [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ]);
        resolution = isNaN(resolution) ? minResolution : Math.max(resolution, minResolution);
        resolution = this.getConstrainedResolution(resolution, nearest ? 0 : 1);
        // calculate center
        const rotation = this.getRotation();
        const sinAngle = Math.sin(rotation);
        const cosAngle = Math.cos(rotation);
        const centerRot = (0, $9pD6L.getCenter)(rotatedExtent);
        centerRot[0] += (padding[1] - padding[3]) / 2 * resolution;
        centerRot[1] += (padding[0] - padding[2]) / 2 * resolution;
        const centerX = centerRot[0] * cosAngle - centerRot[1] * sinAngle;
        const centerY = centerRot[1] * cosAngle + centerRot[0] * sinAngle;
        const center = this.getConstrainedCenter([
            centerX,
            centerY
        ], resolution);
        const callback = options.callback ? options.callback : (0, $6wUzV.VOID);
        if (options.duration !== undefined) this.animateInternal({
            resolution: resolution,
            center: center,
            duration: options.duration,
            easing: options.easing
        }, callback);
        else {
            this.targetResolution_ = resolution;
            this.targetCenter_ = center;
            this.applyTargetState_(false, true);
            $70364d0195659942$var$animationCallback(callback, true);
        }
    }
    /**
   * Center on coordinate and view position.
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   * @api
   */ centerOn(coordinate, size, position) {
        this.centerOnInternal((0, $dpRHA.fromUserCoordinate)(coordinate, this.getProjection()), size, position);
    }
    /**
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   */ centerOnInternal(coordinate, size, position) {
        this.setCenterInternal($70364d0195659942$var$calculateCenterOn(coordinate, size, position, this.getResolution(), this.getRotation()));
    }
    /**
   * Calculates the shift between map and viewport center.
   * @param {import("./coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {import("./size.js").Size} size Size.
   * @return {Array<number>|undefined} Center shift.
   */ calculateCenterShift(center, resolution, rotation, size) {
        let centerShift;
        const padding = this.padding_;
        if (padding && center) {
            const reducedSize = this.getViewportSizeMinusPadding_(-rotation);
            const shiftedCenter = $70364d0195659942$var$calculateCenterOn(center, size, [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
            centerShift = [
                center[0] - shiftedCenter[0],
                center[1] - shiftedCenter[1]
            ];
        }
        return centerShift;
    }
    /**
   * @return {boolean} Is defined.
   */ isDef() {
        return !!this.getCenterInternal() && this.getResolution() !== undefined;
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   * @api
   */ adjustCenter(deltaCoordinates) {
        const center = (0, $dpRHA.toUserCoordinate)(this.targetCenter_, this.getProjection());
        this.setCenter([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   */ adjustCenterInternal(deltaCoordinates) {
        const center = this.targetCenter_;
        this.setCenterInternal([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustResolution(ratio, anchor) {
        anchor = anchor && (0, $dpRHA.fromUserCoordinate)(anchor, this.getProjection());
        this.adjustResolutionInternal(ratio, anchor);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ adjustResolutionInternal(ratio, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const size = this.getViewportSize_(this.getRotation());
        const newResolution = this.constraints_.resolution(this.targetResolution_ * ratio, 0, size, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterZoom(newResolution, anchor);
        this.targetResolution_ *= ratio;
        this.applyTargetState_();
    }
    /**
   * Adds a value to the view zoom level, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom level.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustZoom(delta, anchor) {
        this.adjustResolution(Math.pow(this.zoomFactor_, -delta), anchor);
    }
    /**
   * Adds a value to the view rotation, optionally using an anchor. Any rotation
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   * @api
   */ adjustRotation(delta, anchor) {
        if (anchor) anchor = (0, $dpRHA.fromUserCoordinate)(anchor, this.getProjection());
        this.adjustRotationInternal(delta, anchor);
    }
    /**
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   */ adjustRotationInternal(delta, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const newRotation = this.constraints_.rotation(this.targetRotation_ + delta, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterRotate(newRotation, anchor);
        this.targetRotation_ += delta;
        this.applyTargetState_();
    }
    /**
   * Set the center of the current view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   * @observable
   * @api
   */ setCenter(center) {
        this.setCenterInternal(center ? (0, $dpRHA.fromUserCoordinate)(center, this.getProjection()) : center);
    }
    /**
   * Set the center using the view projection (not the user projection).
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   */ setCenterInternal(center) {
        this.targetCenter_ = center;
        this.applyTargetState_();
    }
    /**
   * @param {import("./ViewHint.js").default} hint Hint.
   * @param {number} delta Delta.
   * @return {number} New value.
   */ setHint(hint, delta) {
        this.hints_[hint] += delta;
        this.changed();
        return this.hints_[hint];
    }
    /**
   * Set the resolution for this view. Any resolution constraint will apply.
   * @param {number|undefined} resolution The resolution of the view.
   * @observable
   * @api
   */ setResolution(resolution) {
        this.targetResolution_ = resolution;
        this.applyTargetState_();
    }
    /**
   * Set the rotation for this view. Any rotation constraint will apply.
   * @param {number} rotation The rotation of the view in radians.
   * @observable
   * @api
   */ setRotation(rotation) {
        this.targetRotation_ = rotation;
        this.applyTargetState_();
    }
    /**
   * Zoom to a specific zoom level. Any resolution constrain will apply.
   * @param {number} zoom Zoom level.
   * @api
   */ setZoom(zoom) {
        this.setResolution(this.getResolutionForZoom(zoom));
    }
    /**
   * Recompute rotation/resolution/center based on target values.
   * Note: we have to compute rotation first, then resolution and center considering that
   * parameters can influence one another in case a view extent constraint is present.
   * @param {boolean} [doNotCancelAnims] Do not cancel animations.
   * @param {boolean} [forceMoving] Apply constraints as if the view is moving.
   * @private
   */ applyTargetState_(doNotCancelAnims, forceMoving) {
        const isMoving = this.getAnimating() || this.getInteracting() || forceMoving;
        // compute rotation
        const newRotation = this.constraints_.rotation(this.targetRotation_, isMoving);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, 0, size, isMoving);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, isMoving, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (this.get((0, $i93na.default).ROTATION) !== newRotation) this.set((0, $i93na.default).ROTATION, newRotation);
        if (this.get((0, $i93na.default).RESOLUTION) !== newResolution) {
            this.set((0, $i93na.default).RESOLUTION, newResolution);
            this.set('zoom', this.getZoom(), true);
        }
        if (!newCenter || !this.get((0, $i93na.default).CENTER) || !(0, $2o3CH.equals)(this.get((0, $i93na.default).CENTER), newCenter)) this.set((0, $i93na.default).CENTER, newCenter);
        if (this.getAnimating() && !doNotCancelAnims) this.cancelAnimations();
        this.cancelAnchor_ = undefined;
    }
    /**
   * If any constraints need to be applied, an animation will be triggered.
   * This is typically done on interaction end.
   * Note: calling this with a duration of 0 will apply the constrained values straight away,
   * without animation.
   * @param {number} [duration] The animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ resolveConstraints(duration, resolutionDirection, anchor) {
        duration = duration !== undefined ? duration : 200;
        const direction = resolutionDirection || 0;
        const newRotation = this.constraints_.rotation(this.targetRotation_);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, direction, size);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, false, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (duration === 0 && !this.cancelAnchor_) {
            this.targetResolution_ = newResolution;
            this.targetRotation_ = newRotation;
            this.targetCenter_ = newCenter;
            this.applyTargetState_();
            return;
        }
        anchor = anchor || (duration === 0 ? this.cancelAnchor_ : undefined);
        this.cancelAnchor_ = undefined;
        if (this.getResolution() !== newResolution || this.getRotation() !== newRotation || !this.getCenterInternal() || !(0, $2o3CH.equals)(this.getCenterInternal(), newCenter)) {
            if (this.getAnimating()) this.cancelAnimations();
            this.animateInternal({
                rotation: newRotation,
                center: newCenter,
                resolution: newResolution,
                duration: duration,
                easing: (0, $h9x7v.easeOut),
                anchor: anchor
            });
        }
    }
    /**
   * Notify the View that an interaction has started.
   * The view state will be resolved to a stable one if needed
   * (depending on its constraints).
   * @api
   */ beginInteraction() {
        this.resolveConstraints(0);
        this.setHint((0, $aKuSF.default).INTERACTING, 1);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ endInteraction(duration, resolutionDirection, anchor) {
        anchor = anchor && (0, $dpRHA.fromUserCoordinate)(anchor, this.getProjection());
        this.endInteractionInternal(duration, resolutionDirection, anchor);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ endInteractionInternal(duration, resolutionDirection, anchor) {
        if (!this.getInteracting()) return;
        this.setHint((0, $aKuSF.default).INTERACTING, -1);
        this.resolveConstraints(duration, resolutionDirection, anchor);
    }
    /**
   * Get a valid position for the view center according to the current constraints.
   * @param {import("./coordinate.js").Coordinate|undefined} targetCenter Target center position.
   * @param {number} [targetResolution] Target resolution. If not supplied, the current one will be used.
   * This is useful to guess a valid center position at a different zoom level.
   * @return {import("./coordinate.js").Coordinate|undefined} Valid center position.
   */ getConstrainedCenter(targetCenter, targetResolution) {
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.center(targetCenter, targetResolution || this.getResolution(), size);
    }
    /**
   * Get a valid zoom level according to the current view constraints.
   * @param {number|undefined} targetZoom Target zoom.
   * @param {number} [direction] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid zoom level.
   */ getConstrainedZoom(targetZoom, direction) {
        const targetRes = this.getResolutionForZoom(targetZoom);
        return this.getZoomForResolution(this.getConstrainedResolution(targetRes, direction));
    }
    /**
   * Get a valid resolution according to the current view constraints.
   * @param {number|undefined} targetResolution Target resolution.
   * @param {number} [direction] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid resolution.
   */ getConstrainedResolution(targetResolution, direction) {
        direction = direction || 0;
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.resolution(targetResolution, direction, size);
    }
}
/**
 * @param {Function} callback Callback.
 * @param {*} returnValue Return value.
 */ function $70364d0195659942$var$animationCallback(callback, returnValue) {
    setTimeout(function() {
        callback(returnValue);
    }, 0);
}
function $70364d0195659942$export$964345001ee9ac52(options) {
    if (options.extent !== undefined) {
        const smooth = options.smoothExtentConstraint !== undefined ? options.smoothExtentConstraint : true;
        return (0, $fi2rl.createExtent)(options.extent, options.constrainOnlyCenter, smooth);
    }
    const projection = (0, $dpRHA.createProjection)(options.projection, 'EPSG:3857');
    if (options.multiWorld !== true && projection.isGlobal()) {
        const extent = projection.getExtent().slice();
        extent[0] = -Infinity;
        extent[2] = Infinity;
        return (0, $fi2rl.createExtent)(extent, false, false);
    }
    return 0, $fi2rl.none;
}
function $70364d0195659942$export$c68d65f9148da196(options) {
    let resolutionConstraint;
    let maxResolution;
    let minResolution;
    // TODO: move these to be ol constants
    // see https://github.com/openlayers/openlayers/issues/2076
    const defaultMaxZoom = 28;
    const defaultZoomFactor = 2;
    let minZoom = options.minZoom !== undefined ? options.minZoom : $70364d0195659942$var$DEFAULT_MIN_ZOOM;
    let maxZoom = options.maxZoom !== undefined ? options.maxZoom : defaultMaxZoom;
    const zoomFactor = options.zoomFactor !== undefined ? options.zoomFactor : defaultZoomFactor;
    const multiWorld = options.multiWorld !== undefined ? options.multiWorld : false;
    const smooth = options.smoothResolutionConstraint !== undefined ? options.smoothResolutionConstraint : true;
    const showFullExtent = options.showFullExtent !== undefined ? options.showFullExtent : false;
    const projection = (0, $dpRHA.createProjection)(options.projection, 'EPSG:3857');
    const projExtent = projection.getExtent();
    let constrainOnlyCenter = options.constrainOnlyCenter;
    let extent = options.extent;
    if (!multiWorld && !extent && projection.isGlobal()) {
        constrainOnlyCenter = false;
        extent = projExtent;
    }
    if (options.resolutions !== undefined) {
        const resolutions = options.resolutions;
        maxResolution = resolutions[minZoom];
        minResolution = resolutions[maxZoom] !== undefined ? resolutions[maxZoom] : resolutions[resolutions.length - 1];
        if (options.constrainResolution) resolutionConstraint = (0, $g29x3.createSnapToResolutions)(resolutions, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $g29x3.createMinMaxResolution)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    } else {
        // calculate the default min and max resolution
        const size = !projExtent ? 360 * (0, $kUyy5.METERS_PER_UNIT).degrees / projection.getMetersPerUnit() : Math.max((0, $9pD6L.getWidth)(projExtent), (0, $9pD6L.getHeight)(projExtent));
        const defaultMaxResolution = size / (0, $7xn5x.DEFAULT_TILE_SIZE) / Math.pow(defaultZoomFactor, $70364d0195659942$var$DEFAULT_MIN_ZOOM);
        const defaultMinResolution = defaultMaxResolution / Math.pow(defaultZoomFactor, defaultMaxZoom - $70364d0195659942$var$DEFAULT_MIN_ZOOM);
        // user provided maxResolution takes precedence
        maxResolution = options.maxResolution;
        if (maxResolution !== undefined) minZoom = 0;
        else maxResolution = defaultMaxResolution / Math.pow(zoomFactor, minZoom);
        // user provided minResolution takes precedence
        minResolution = options.minResolution;
        if (minResolution === undefined) {
            if (options.maxZoom !== undefined) {
                if (options.maxResolution !== undefined) minResolution = maxResolution / Math.pow(zoomFactor, maxZoom);
                else minResolution = defaultMaxResolution / Math.pow(zoomFactor, maxZoom);
            } else minResolution = defaultMinResolution;
        }
        // given discrete zoom levels, minResolution may be different than provided
        maxZoom = minZoom + Math.floor(Math.log(maxResolution / minResolution) / Math.log(zoomFactor));
        minResolution = maxResolution / Math.pow(zoomFactor, maxZoom - minZoom);
        if (options.constrainResolution) resolutionConstraint = (0, $g29x3.createSnapToPower)(zoomFactor, maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $g29x3.createMinMaxResolution)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    }
    return {
        constraint: resolutionConstraint,
        maxResolution: maxResolution,
        minResolution: minResolution,
        minZoom: minZoom,
        zoomFactor: zoomFactor
    };
}
function $70364d0195659942$export$4eeaa08dd550e3c0(options) {
    const enableRotation = options.enableRotation !== undefined ? options.enableRotation : true;
    if (enableRotation) {
        const constrainRotation = options.constrainRotation;
        if (constrainRotation === undefined || constrainRotation === true) return (0, $ip5LZ.createSnapToZero)();
        if (constrainRotation === false) return 0, $ip5LZ.none;
        if (typeof constrainRotation === 'number') return (0, $ip5LZ.createSnapToN)(constrainRotation);
        return 0, $ip5LZ.none;
    }
    return 0, $ip5LZ.disable;
}
function $70364d0195659942$export$ee75376562060184(animation) {
    if (animation.sourceCenter && animation.targetCenter) {
        if (!(0, $2o3CH.equals)(animation.sourceCenter, animation.targetCenter)) return false;
    }
    if (animation.sourceResolution !== animation.targetResolution) return false;
    if (animation.sourceRotation !== animation.targetRotation) return false;
    return true;
}
/**
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {import("./size.js").Size} size Box pixel size.
 * @param {import("./pixel.js").Pixel} position Position on the view to center on.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @return {import("./coordinate.js").Coordinate} Shifted center.
 */ function $70364d0195659942$var$calculateCenterOn(coordinate, size, position, resolution, rotation) {
    // calculate rotated position
    const cosAngle = Math.cos(-rotation);
    let sinAngle = Math.sin(-rotation);
    let rotX = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    let rotY = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    rotX += (size[0] / 2 - position[0]) * resolution;
    rotY += (position[1] - size[1] / 2) * resolution;
    // go back to original angle
    sinAngle = -sinAngle; // go back to original rotation
    const centerX = rotX * cosAngle - rotY * sinAngle;
    const centerY = rotY * cosAngle + rotX * sinAngle;
    return [
        centerX,
        centerY
    ];
}
var $70364d0195659942$export$2e2bcd8739ae039 = $70364d0195659942$var$View;
function $70364d0195659942$export$c25fb981a0c5b500(num) {
    return function(options) {
        if (!options.resolutions) return options;
        const resolutions = [
            ...options.resolutions
        ];
        const highest = resolutions[resolutions.length - 1];
        for(let i = 0; i < num; ++i)resolutions.push(highest / Math.pow(2, i + 1));
        return {
            ...options,
            resolutions: resolutions
        };
    };
}
function $70364d0195659942$export$bd7c975990ce76fa(num) {
    return function(options) {
        if (!options.resolutions) return options;
        const resolutions = [
            ...options.resolutions
        ];
        const lowest = resolutions[0];
        for(let i = 0; i < num; ++i)resolutions.unshift(lowest * Math.pow(2, i + 1));
        return {
            ...options,
            resolutions: resolutions
        };
    };
}
function $70364d0195659942$export$fa18f70fef5f1fab() {
    return function(options) {
        if (!options.extent) return options;
        const center = (0, $9pD6L.getCenter)(options.extent);
        const newOptions = {
            ...options,
            center: center
        };
        delete newOptions.extent;
        return newOptions;
    };
}
function $70364d0195659942$export$c8cdb1d588f29e82(z) {
    return function(options) {
        return {
            ...options,
            zoom: z
        };
    };
}
async function $70364d0195659942$export$513f42987b822fd7(source, ...transforms) {
    let config = await source.getView();
    for (const transform of transforms)config = transform(config);
    return config;
}

});
parcelRegister("fFFY7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b68b3d6e32e3074a$export$2e2bcd8739ae039);
/**
 * @module ol/Object
 */ 
var $jXCUw = parcelRequire("jXCUw");

var $2FcER = parcelRequire("2FcER");

var $f18Q2 = parcelRequire("f18Q2");

var $gn0g3 = parcelRequire("gn0g3");

var $9iPUS = parcelRequire("9iPUS");
class $b68b3d6e32e3074a$export$cf395d7c4a2d5a17 extends (0, $f18Q2.default) {
    /**
   * @param {string} type The event type.
   * @param {string} key The property name.
   * @param {*} oldValue The old value for `key`.
   */ constructor(type, key, oldValue){
        super(type);
        /**
     * The name of the property whose value is changing.
     * @type {string}
     * @api
     */ this.key = key;
        /**
     * The old value. To get the new value use `e.target.get(e.key)` where
     * `e` is the event object.
     * @type {*}
     * @api
     */ this.oldValue = oldValue;
    }
}
/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<import("./ObjectEventType").Types, ObjectEvent, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types, Return>} ObjectOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Most non-trivial classes inherit from this.
 *
 * This extends {@link module:ol/Observable~Observable} with observable
 * properties, where each property is observable as well as the object as a
 * whole.
 *
 * Classes that inherit from this have pre-defined properties, to which you can
 * add your owns. The pre-defined properties are listed in this documentation as
 * 'Observable Properties', and have their own accessors; for example,
 * {@link module:ol/Map~Map} has a `target` property, accessed with
 * `getTarget()` and changed with `setTarget()`. Not all properties are however
 * settable. There are also general-purpose accessors `get()` and `set()`. For
 * example, `get('target')` is equivalent to `getTarget()`.
 *
 * The `set` accessors trigger a change event, and you can monitor this by
 * registering a listener. For example, {@link module:ol/View~View} has a
 * `center` property, so `view.on('change:center', function(evt) {...});` would
 * call the function whenever the value of the center property changes. Within
 * the function, `evt.target` would be the view, so `evt.target.getCenter()`
 * would return the new center.
 *
 * You can add your own observable properties with
 * `object.set('prop', 'value')`, and retrieve that with `object.get('prop')`.
 * You can listen for changes on that property value with
 * `object.on('change:prop', listener)`. You can get a list of all
 * properties with {@link module:ol/Object~BaseObject#getProperties}.
 *
 * Note that the observable properties are separate from standard JS properties.
 * You can, for example, give your map object a title with
 * `map.title='New title'` and with `map.set('title', 'Another title')`. The
 * first will be a `hasOwnProperty`; the second will appear in
 * `getProperties()`. Only the second is observable.
 *
 * Properties can be deleted by using the unset method. E.g.
 * object.unset('foo').
 *
 * @fires ObjectEvent
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @api
 */ class $b68b3d6e32e3074a$var$BaseObject extends (0, $2FcER.default) {
    /**
   * @param {NoInfer<Properties>} [values] An object with key-value pairs.
   */ constructor(values){
        super();
        /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {ObjectOnSignature<void>}
     */ this.un;
        // Call {@link module:ol/util.getUid} to ensure that the order of objects' ids is
        // the same as the order in which they were created.  This also helps to
        // ensure that object properties are always added in the same order, which
        // helps many JavaScript engines generate faster code.
        (0, $9iPUS.getUid)(this);
        /**
     * @private
     * @type {Partial<NoInfer<Properties>>|null}
     */ this.values_ = null;
        if (values !== undefined) this.setProperties(values);
    }
    /**
   * Gets a value.
   * @param {string} key Key name.
   * @return {*} Value.
   * @api
   */ get(key) {
        let value;
        if (this.values_ && this.values_.hasOwnProperty(key)) value = this.values_[key];
        return value;
    }
    /**
   * Get a list of object property names.
   * @return {Array<string>} List of property names.
   * @api
   */ getKeys() {
        return this.values_ && Object.keys(this.values_) || [];
    }
    /**
   * Get an object of all property names and values.
   * @return {NoInfer<Properties>} Object.
   * @api
   */ getProperties() {
        return /** @type {NoInfer<Properties>} */ this.values_ && Object.assign({}, this.values_) || {};
    }
    /**
   * Get an object of all property names and values.
   * @return {Partial<NoInfer<Properties>>?} Object.
   */ getPropertiesInternal() {
        return this.values_;
    }
    /**
   * @return {boolean} The object has properties.
   */ hasProperties() {
        return !!this.values_;
    }
    /**
   * @param {string} key Key name.
   * @param {*} oldValue Old value.
   */ notify(key, oldValue) {
        let eventType;
        eventType = `change:${key}`;
        if (this.hasListener(eventType)) this.dispatchEvent(new $b68b3d6e32e3074a$export$cf395d7c4a2d5a17(eventType, key, oldValue));
        eventType = (0, $jXCUw.default).PROPERTYCHANGE;
        if (this.hasListener(eventType)) this.dispatchEvent(new $b68b3d6e32e3074a$export$cf395d7c4a2d5a17(eventType, key, oldValue));
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ addChangeListener(key, listener) {
        this.addEventListener(`change:${key}`, listener);
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ removeChangeListener(key, listener) {
        this.removeEventListener(`change:${key}`, listener);
    }
    /**
   * Sets a value.
   * @param {string} key Key name.
   * @param {*} value Value.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ set(key, value, silent) {
        const values = this.values_ || (this.values_ = {});
        if (silent) values[key] = value;
        else {
            const oldValue = values[key];
            values[key] = value;
            if (oldValue !== value) this.notify(key, oldValue);
        }
    }
    /**
   * Sets a collection of key-value pairs.  Note that this changes any existing
   * properties and adds new ones (it does not remove any existing properties).
   * @param {Partial<NoInfer<Properties>>} values Values.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ setProperties(values, silent) {
        for(const key in values)this.set(key, values[key], silent);
    }
    /**
   * Apply any properties from another object without triggering events.
   * @param {BaseObject} source The source object.
   * @protected
   */ applyProperties(source) {
        if (!source.values_) return;
        Object.assign(this.values_ || (this.values_ = {}), source.values_);
    }
    /**
   * Unsets a property.
   * @param {string} key Key name.
   * @param {boolean} [silent] Unset without triggering an event.
   * @api
   */ unset(key, silent) {
        if (this.values_ && key in this.values_) {
            const oldValue = this.values_[key];
            delete this.values_[key];
            if ((0, $gn0g3.isEmpty)(this.values_)) this.values_ = null;
            if (!silent) this.notify(key, oldValue);
        }
    }
}
var $b68b3d6e32e3074a$export$2e2bcd8739ae039 = $b68b3d6e32e3074a$var$BaseObject;

});
parcelRegister("jXCUw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e881b5dca21eb5d4$export$2e2bcd8739ae039);
/**
 * @module ol/ObjectEventType
 */ /**
 * @enum {string}
 */ var $e881b5dca21eb5d4$export$2e2bcd8739ae039 /**
 * @typedef {'propertychange'} Types
 */  = {
    /**
   * Triggered when a property is changed.
   * @event module:ol/Object.ObjectEvent#propertychange
   * @api
   */ PROPERTYCHANGE: 'propertychange'
};

});


parcelRegister("i93na", function(module, exports) {

$parcel$export(module.exports, "default", () => $d35baefbe89be4c5$export$2e2bcd8739ae039);
/**
 * @module ol/ViewProperty
 */ /**
 * @enum {string}
 */ var $d35baefbe89be4c5$export$2e2bcd8739ae039 = {
    CENTER: 'center',
    RESOLUTION: 'resolution',
    ROTATION: 'rotation'
};

});

parcelRegister("fi2rl", function(module, exports) {

$parcel$export(module.exports, "createExtent", () => $b21a6e049949bb31$export$c2f0af2c946f6897);
$parcel$export(module.exports, "none", () => $b21a6e049949bb31$export$f883a24d5edde77c);
/**
 * @module ol/centerconstraint
 */ 
var $9byFX = parcelRequire("9byFX");
function $b21a6e049949bb31$export$c2f0af2c946f6897(extent, onlyCenter, smooth) {
    return(/**
     * @param {import("./coordinate.js").Coordinate|undefined} center Center.
     * @param {number|undefined} resolution Resolution.
     * @param {import("./size.js").Size} size Viewport size; unused if `onlyCenter` was specified.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @param {Array<number>} [centerShift] Shift between map center and viewport center.
     * @return {import("./coordinate.js").Coordinate|undefined} Center.
     */ function(center, resolution, size, isMoving, centerShift) {
        if (!center) return undefined;
        if (!resolution && !onlyCenter) return center;
        const viewWidth = onlyCenter ? 0 : size[0] * resolution;
        const viewHeight = onlyCenter ? 0 : size[1] * resolution;
        const shiftX = centerShift ? centerShift[0] : 0;
        const shiftY = centerShift ? centerShift[1] : 0;
        let minX = extent[0] + viewWidth / 2 + shiftX;
        let maxX = extent[2] - viewWidth / 2 + shiftX;
        let minY = extent[1] + viewHeight / 2 + shiftY;
        let maxY = extent[3] - viewHeight / 2 + shiftY;
        // note: when zooming out of bounds, min and max values for x and y may
        // end up inverted (min > max); this has to be accounted for
        if (minX > maxX) {
            minX = (maxX + minX) / 2;
            maxX = minX;
        }
        if (minY > maxY) {
            minY = (maxY + minY) / 2;
            maxY = minY;
        }
        let x = (0, $9byFX.clamp)(center[0], minX, maxX);
        let y = (0, $9byFX.clamp)(center[1], minY, maxY);
        // during an interaction, allow some overscroll
        if (isMoving && smooth && resolution) {
            const ratio = 30 * resolution;
            x += -ratio * Math.log(1 + Math.max(0, minX - center[0]) / ratio) + ratio * Math.log(1 + Math.max(0, center[0] - maxX) / ratio);
            y += -ratio * Math.log(1 + Math.max(0, minY - center[1]) / ratio) + ratio * Math.log(1 + Math.max(0, center[1] - maxY) / ratio);
        }
        return [
            x,
            y
        ];
    });
}
function $b21a6e049949bb31$export$f883a24d5edde77c(center) {
    return center;
}

});

parcelRegister("h9x7v", function(module, exports) {

$parcel$export(module.exports, "easeIn", () => $c7ccf7e681a9b333$export$929e5a82286172a6);
$parcel$export(module.exports, "easeOut", () => $c7ccf7e681a9b333$export$57636bb43b1ccbb0);
$parcel$export(module.exports, "inAndOut", () => $c7ccf7e681a9b333$export$9b47139b511b56e4);
$parcel$export(module.exports, "linear", () => $c7ccf7e681a9b333$export$45db2fc2f15997e7);
/**
 * @module ol/easing
 */ /**
 * Start slow and speed up.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */ function $c7ccf7e681a9b333$export$929e5a82286172a6(t) {
    return Math.pow(t, 3);
}
function $c7ccf7e681a9b333$export$57636bb43b1ccbb0(t) {
    return 1 - $c7ccf7e681a9b333$export$929e5a82286172a6(1 - t);
}
function $c7ccf7e681a9b333$export$9b47139b511b56e4(t) {
    return 3 * t * t - 2 * t * t * t;
}
function $c7ccf7e681a9b333$export$45db2fc2f15997e7(t) {
    return t;
}
function $c7ccf7e681a9b333$export$7f4472f6708afaf3(t) {
    if (t < 0.5) return $c7ccf7e681a9b333$export$9b47139b511b56e4(2 * t);
    return 1 - $c7ccf7e681a9b333$export$9b47139b511b56e4(2 * (t - 0.5));
}

});

parcelRegister("5ydre", function(module, exports) {

$parcel$export(module.exports, "default", () => $40aa8d43bbe572bf$export$2e2bcd8739ae039);
$parcel$export(module.exports, "fromExtent", () => $40aa8d43bbe572bf$export$c16b671815801c75);
/**
 * @module ol/geom/Polygon
 */ 
var $fVVyM = parcelRequire("fVVyM");

var $9pD6L = parcelRequire("9pD6L");

var $9byFX = parcelRequire("9byFX");

var $lAvh5 = parcelRequire("lAvh5");

var $7fV57 = parcelRequire("7fV57");

var $9vPkX = parcelRequire("9vPkX");

var $h7zsK = parcelRequire("h7zsK");

var $aCXb5 = parcelRequire("aCXb5");

var $gqtzW = parcelRequire("gqtzW");

var $33weL = parcelRequire("33weL");

var $9bJty = parcelRequire("9bJty");

var $7eSHW = parcelRequire("7eSHW");

var $2RNwh = parcelRequire("2RNwh");

var $eQvue = parcelRequire("eQvue");

var $alOgM = parcelRequire("alOgM");

var $bDhby = parcelRequire("bDhby");
/**
 * @classdesc
 * Polygon geometry.
 *
 * @api
 */ class $40aa8d43bbe572bf$var$Polygon extends (0, $h7zsK.default) {
    /**
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>|!Array<number>} coordinates
   *     Array of linear rings that define the polygon. The first linear ring of the
   *     array defines the outer-boundary or surface of the polygon. Each subsequent
   *     linear ring defines a hole in the surface of the polygon. A linear ring is
   *     an array of vertices' coordinates where the first coordinate and the last are
   *     equivalent. (For internal use, flat coordinates in combination with
   *     `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Ends (for internal use with flat coordinates).
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointRevision_ = -1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatInteriorPoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
    }
    /**
   * Append the passed linear ring to this polygon.
   * @param {LinearRing} linearRing Linear ring.
   * @api
   */ appendLinearRing(linearRing) {
        if (!this.flatCoordinates) this.flatCoordinates = linearRing.getFlatCoordinates().slice();
        else (0, $fVVyM.extend)(this.flatCoordinates, linearRing.getFlatCoordinates());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Polygon} Clone.
   * @api
   * @override
   */ clone() {
        const polygon = new $40aa8d43bbe572bf$var$Polygon(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        polygon.applyProperties(this);
        return polygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $9pD6L.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $gqtzW.arrayMaxSquaredDelta)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $gqtzW.assignClosestArrayPoint)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        return (0, $33weL.linearRingsContainsXY)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, x, y);
    }
    /**
   * Return the area of the polygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $aCXb5.linearRings)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   * @override
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $alOgM.orientLinearRings)(flatCoordinates, 0, this.ends_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $7eSHW.inflateCoordinatesArray)(flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * @return {Array<number>} Interior point.
   */ getFlatInteriorPoint() {
        if (this.flatInteriorPointRevision_ != this.getRevision()) {
            const flatCenter = (0, $9pD6L.getCenter)(this.getExtent());
            this.flatInteriorPoint_ = (0, $2RNwh.getInteriorPointOfArray)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, flatCenter, 0);
            this.flatInteriorPointRevision_ = this.getRevision();
        }
        return /** @type {import("../coordinate.js").Coordinate} */ this.flatInteriorPoint_;
    }
    /**
   * Return an interior point of the polygon.
   * @return {Point} Interior point as XYM coordinate, where M is the
   * length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoint() {
        return new (0, $9vPkX.default)(this.getFlatInteriorPoint(), 'XYM');
    }
    /**
   * Return the number of rings of the polygon,  this includes the exterior
   * ring and any interior rings.
   *
   * @return {number} Number of rings.
   * @api
   */ getLinearRingCount() {
        return this.ends_.length;
    }
    /**
   * Return the Nth linear ring of the polygon geometry. Return `null` if the
   * given index is out of range.
   * The exterior linear ring is available at index `0` and the interior rings
   * at index `1` and beyond.
   *
   * @param {number} index Index.
   * @return {LinearRing|null} Linear ring.
   * @api
   */ getLinearRing(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $7fV57.default)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linear rings of the polygon.
   * @return {Array<LinearRing>} Linear rings.
   * @api
   */ getLinearRings() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const linearRings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const linearRing = new (0, $7fV57.default)(flatCoordinates.slice(offset, end), layout);
            linearRings.push(linearRing);
            offset = end;
        }
        return linearRings;
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, $alOgM.linearRingsAreOriented)(flatCoordinates, 0, this.ends_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $alOgM.orientLinearRings)(this.orientedFlatCoordinates_, 0, this.ends_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Polygon} Simplified Polygon.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $bDhby.quantizeArray)(this.flatCoordinates, 0, this.ends_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new $40aa8d43bbe572bf$var$Polygon(simplifiedFlatCoordinates, 'XY', simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Polygon';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $eQvue.intersectsLinearRingArray)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the polygon.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, $9bJty.deflateCoordinatesArray)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
var $40aa8d43bbe572bf$export$2e2bcd8739ae039 = $40aa8d43bbe572bf$var$Polygon;
function $40aa8d43bbe572bf$export$f99d756c6d81ae3f(center, radius, n, sphereRadius) {
    n = n ? n : 32;
    /** @type {Array<number>} */ const flatCoordinates = [];
    for(let i = 0; i < n; ++i)(0, $fVVyM.extend)(flatCoordinates, (0, $lAvh5.offset)(center, radius, 2 * Math.PI * i / n, sphereRadius));
    flatCoordinates.push(flatCoordinates[0], flatCoordinates[1]);
    return new $40aa8d43bbe572bf$var$Polygon(flatCoordinates, 'XY', [
        flatCoordinates.length
    ]);
}
function $40aa8d43bbe572bf$export$c16b671815801c75(extent) {
    if ((0, $9pD6L.isEmpty)(extent)) throw new Error('Cannot create polygon from empty extent');
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const flatCoordinates = [
        minX,
        minY,
        minX,
        maxY,
        maxX,
        maxY,
        maxX,
        minY,
        minX,
        minY
    ];
    return new $40aa8d43bbe572bf$var$Polygon(flatCoordinates, 'XY', [
        flatCoordinates.length
    ]);
}
function $40aa8d43bbe572bf$export$2451009d645fb8c2(circle, sides, angle) {
    sides = sides ? sides : 32;
    const stride = circle.getStride();
    const layout = circle.getLayout();
    const center = circle.getCenter();
    const arrayLength = stride * (sides + 1);
    const flatCoordinates = new Array(arrayLength);
    for(let i = 0; i < arrayLength; i += stride){
        flatCoordinates[i] = 0;
        flatCoordinates[i + 1] = 0;
        for(let j = 2; j < stride; j++)flatCoordinates[i + j] = center[j];
    }
    const ends = [
        flatCoordinates.length
    ];
    const polygon = new $40aa8d43bbe572bf$var$Polygon(flatCoordinates, layout, ends);
    $40aa8d43bbe572bf$export$87d6a1539a56e47f(polygon, center, circle.getRadius(), angle);
    return polygon;
}
function $40aa8d43bbe572bf$export$87d6a1539a56e47f(polygon, center, radius, angle) {
    const flatCoordinates = polygon.getFlatCoordinates();
    const stride = polygon.getStride();
    const sides = flatCoordinates.length / stride - 1;
    const startAngle = angle ? angle : 0;
    for(let i = 0; i <= sides; ++i){
        const offset = i * stride;
        const angle = startAngle + (0, $9byFX.modulo)(i, sides) * 2 * Math.PI / sides;
        flatCoordinates[offset] = center[0] + radius * Math.cos(angle);
        flatCoordinates[offset + 1] = center[1] + radius * Math.sin(angle);
    }
    polygon.changed();
}

});
parcelRegister("7fV57", function(module, exports) {

$parcel$export(module.exports, "default", () => $548636579b4087f2$export$2e2bcd8739ae039);
/**
 * @module ol/geom/LinearRing
 */ 
var $9pD6L = parcelRequire("9pD6L");

var $h7zsK = parcelRequire("h7zsK");

var $aCXb5 = parcelRequire("aCXb5");

var $gqtzW = parcelRequire("gqtzW");

var $9bJty = parcelRequire("9bJty");

var $7eSHW = parcelRequire("7eSHW");

var $bDhby = parcelRequire("bDhby");
/**
 * @classdesc
 * Linear ring geometry. Only used as part of polygon; cannot be rendered
 * on its own.
 *
 * @api
 */ class $548636579b4087f2$var$LinearRing extends (0, $h7zsK.default) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LinearRing} Clone.
   * @api
   * @override
   */ clone() {
        return new $548636579b4087f2$var$LinearRing(this.flatCoordinates.slice(), this.layout);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $9pD6L.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $gqtzW.maxSquaredDelta)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $gqtzW.assignClosestPoint)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Return the area of the linear ring on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $aCXb5.linearRing)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinates of the linear ring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $7eSHW.inflateCoordinates)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LinearRing} Simplified LinearRing.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $bDhby.douglasPeucker)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new $548636579b4087f2$var$LinearRing(simplifiedFlatCoordinates, 'XY');
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'LinearRing';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return false;
    }
    /**
   * Set the coordinates of the linear ring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $9bJty.deflateCoordinates)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $548636579b4087f2$export$2e2bcd8739ae039 = $548636579b4087f2$var$LinearRing;

});
parcelRegister("h7zsK", function(module, exports) {

$parcel$export(module.exports, "transformGeom2D", () => $c76e993e57efc8c4$export$a3767472617c7861);
$parcel$export(module.exports, "default", () => $c76e993e57efc8c4$export$2e2bcd8739ae039);
/**
 * @module ol/geom/SimpleGeometry
 */ 
var $9pD6L = parcelRequire("9pD6L");

var $9iPUS = parcelRequire("9iPUS");

var $6WoYU = parcelRequire("6WoYU");

var $1MAUi = parcelRequire("1MAUi");
/**
 * @classdesc
 * Abstract base class; only used for creating subclasses; do not instantiate
 * in apps, as cannot be rendered.
 *
 * @abstract
 * @api
 */ class $c76e993e57efc8c4$var$SimpleGeometry extends (0, $6WoYU.default) {
    constructor(){
        super();
        /**
     * @protected
     * @type {import("./Geometry.js").GeometryLayout}
     */ this.layout = 'XY';
        /**
     * @protected
     * @type {number}
     */ this.stride = 2;
        /**
     * @protected
     * @type {Array<number>}
     */ this.flatCoordinates;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        return (0, $9pD6L.createOrUpdateFromFlatCoordinates)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    }
    /**
   * @abstract
   * @return {Array<*> | null} Coordinates.
   */ getCoordinates() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Return the first coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} First coordinate.
   * @api
   */ getFirstCoordinate() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getFlatCoordinates() {
        return this.flatCoordinates;
    }
    /**
   * Return the last coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} Last point.
   * @api
   */ getLastCoordinate() {
        return this.flatCoordinates.slice(this.flatCoordinates.length - this.stride);
    }
    /**
   * Return the {@link import("./Geometry.js").GeometryLayout layout} of the geometry.
   * @return {import("./Geometry.js").GeometryLayout} Layout.
   * @api
   */ getLayout() {
        return this.layout;
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @override
   */ getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        // If squaredTolerance is negative or if we know that simplification will not
        // have any effect then just return this.
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance <= this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        const simplifiedGeometry = this.getSimplifiedGeometryInternal(squaredTolerance);
        const simplifiedFlatCoordinates = simplifiedGeometry.getFlatCoordinates();
        if (simplifiedFlatCoordinates.length < this.flatCoordinates.length) return simplifiedGeometry;
        // Simplification did not actually remove any coordinates.  We now know
        // that any calls to getSimplifiedGeometry with a squaredTolerance less
        // than or equal to the current squaredTolerance will also not have any
        // effect.  This allows us to short circuit simplification (saving CPU
        // cycles) and prevents the cache of simplified geometries from filling
        // up with useless identical copies of this geometry (saving memory).
        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        return this;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride;
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout} layout Layout.
   * @param {Array<number>} flatCoordinates Flat coordinates.
   */ setFlatCoordinates(layout, flatCoordinates) {
        this.stride = $c76e993e57efc8c4$export$6af0c1b4a8549a43(layout);
        this.layout = layout;
        this.flatCoordinates = flatCoordinates;
    }
    /**
   * @abstract
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ setCoordinates(coordinates, layout) {
        (0, $9iPUS.abstract)();
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout|undefined} layout Layout.
   * @param {Array<*>} coordinates Coordinates.
   * @param {number} nesting Nesting.
   * @protected
   */ setLayout(layout, coordinates, nesting) {
        let stride;
        if (layout) stride = $c76e993e57efc8c4$export$6af0c1b4a8549a43(layout);
        else {
            for(let i = 0; i < nesting; ++i){
                if (coordinates.length === 0) {
                    this.layout = 'XY';
                    this.stride = 2;
                    return;
                }
                coordinates = /** @type {Array<unknown>} */ coordinates[0];
            }
            stride = coordinates.length;
            layout = $c76e993e57efc8c4$export$61bb6938093db2c8(stride);
        }
        this.layout = layout;
        this.stride = stride;
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   * @override
   */ applyTransform(transformFn) {
        if (this.flatCoordinates) {
            transformFn(this.flatCoordinates, this.flatCoordinates, this.layout.startsWith('XYZ') ? 3 : 2, this.stride);
            this.changed();
        }
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $1MAUi.rotate)(flatCoordinates, 0, flatCoordinates.length, stride, angle, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   * @override
   */ scale(sx, sy, anchor) {
        if (sy === undefined) sy = sx;
        if (!anchor) anchor = (0, $9pD6L.getCenter)(this.getExtent());
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $1MAUi.scale)(flatCoordinates, 0, flatCoordinates.length, stride, sx, sy, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   * @override
   */ translate(deltaX, deltaY) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $1MAUi.translate)(flatCoordinates, 0, flatCoordinates.length, stride, deltaX, deltaY, flatCoordinates);
            this.changed();
        }
    }
}
function $c76e993e57efc8c4$export$61bb6938093db2c8(stride) {
    let layout;
    if (stride == 2) layout = 'XY';
    else if (stride == 3) layout = 'XYZ';
    else if (stride == 4) layout = 'XYZM';
    return /** @type {import("./Geometry.js").GeometryLayout} */ layout;
}
function $c76e993e57efc8c4$export$6af0c1b4a8549a43(layout) {
    let stride;
    if (layout == 'XY') stride = 2;
    else if (layout == 'XYZ' || layout == 'XYM') stride = 3;
    else if (layout == 'XYZM') stride = 4;
    return /** @type {number} */ stride;
}
function $c76e993e57efc8c4$export$a3767472617c7861(simpleGeometry, transform, dest) {
    const flatCoordinates = simpleGeometry.getFlatCoordinates();
    if (!flatCoordinates) return null;
    const stride = simpleGeometry.getStride();
    return (0, $1MAUi.transform2D)(flatCoordinates, 0, flatCoordinates.length, stride, transform, dest);
}
var $c76e993e57efc8c4$export$2e2bcd8739ae039 = $c76e993e57efc8c4$var$SimpleGeometry;

});
parcelRegister("6WoYU", function(module, exports) {

$parcel$export(module.exports, "default", () => $50db89a00eb954f6$export$2e2bcd8739ae039);
/**
 * @module ol/geom/Geometry
 */ 
var $fFFY7 = parcelRequire("fFFY7");

var $9pD6L = parcelRequire("9pD6L");

var $6wUzV = parcelRequire("6wUzV");

var $dpRHA = parcelRequire("dpRHA");

var $jpXrt = parcelRequire("jpXrt");

var $9iPUS = parcelRequire("9iPUS");

var $1MAUi = parcelRequire("1MAUi");
/**
 * @typedef {'XY' | 'XYZ' | 'XYM' | 'XYZM'} GeometryLayout
 * The coordinate layout for geometries, indicating whether a 3rd or 4th z ('Z')
 * or measure ('M') coordinate is available.
 */ /**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString' | 'MultiPolygon' | 'GeometryCollection' | 'Circle'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'`, `'MultiLineString'`, `'MultiPolygon'`,
 * `'GeometryCollection'`, or `'Circle'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const $50db89a00eb954f6$var$tmpTransform = (0, $jpXrt.create)();
/** @type {import('../coordinate.js').Coordinate} */ const $50db89a00eb954f6$var$tmpPoint = [
    NaN,
    NaN
];
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for vector geometries.
 *
 * To get notified of changes to the geometry, register a listener for the
 * generic `change` event on your geometry instance.
 *
 * @abstract
 * @api
 */ class $50db89a00eb954f6$var$Geometry extends (0, $fFFY7.default) {
    constructor(){
        super();
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = (0, $9pD6L.createEmpty)();
        /**
     * @private
     * @type {number}
     */ this.extentRevision_ = -1;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryMaxMinSquaredTolerance = 0;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryRevision = 0;
        /**
     * Get a transformed and simplified version of the geometry.
     * @abstract
     * @param {number} revision The geometry revision.
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
     * @return {Geometry} Simplified geometry.
     */ this.simplifyTransformedInternal = (0, $6wUzV.memoizeOne)((revision, squaredTolerance, transform)=>{
            if (!transform) return this.getSimplifiedGeometry(squaredTolerance);
            const clone = this.clone();
            clone.applyTransform(transform);
            return clone.getSimplifiedGeometry(squaredTolerance);
        });
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {Geometry} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this.simplifyTransformedInternal(this.getRevision(), squaredTolerance, transform);
    }
    /**
   * Make a complete copy of the geometry.
   * @abstract
   * @return {!Geometry} Clone.
   */ clone() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * @abstract
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ containsXY(x, y) {
        return this.closestPointXY(x, y, $50db89a00eb954f6$var$tmpPoint, Number.MIN_VALUE) === 0;
    }
    /**
   * Return the closest point of the geometry to the passed point as
   * {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} point Point.
   * @param {import("../coordinate.js").Coordinate} [closestPoint] Closest point.
   * @return {import("../coordinate.js").Coordinate} Closest point.
   * @api
   */ getClosestPoint(point, closestPoint) {
        closestPoint = closestPoint ? closestPoint : [
            NaN,
            NaN
        ];
        this.closestPointXY(point[0], point[1], closestPoint, Infinity);
        return closestPoint;
    }
    /**
   * Returns true if this geometry includes the specified coordinate. If the
   * coordinate is on the boundary of the geometry, returns false.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {boolean} Contains coordinate.
   * @api
   */ intersectsCoordinate(coordinate) {
        return this.containsXY(coordinate[0], coordinate[1]);
    }
    /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ computeExtent(extent) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Get the extent of the geometry.
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} extent Extent.
   * @api
   */ getExtent(extent) {
        if (this.extentRevision_ != this.getRevision()) {
            const extent = this.computeExtent(this.extent_);
            if (isNaN(extent[0]) || isNaN(extent[1])) (0, $9pD6L.createOrUpdateEmpty)(extent);
            this.extentRevision_ = this.getRevision();
        }
        return (0, $9pD6L.returnOrUpdate)(this.extent_, extent);
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */ rotate(angle, anchor) {
        (0, $9iPUS.abstract)();
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */ scale(sx, sy, anchor) {
        (0, $9iPUS.abstract)();
    }
    /**
   * Create a simplified version of this geometry.  For linestrings, this uses
   * the [Douglas Peucker](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm)
   * algorithm.  For polygons, a quantization-based
   * simplification is used to preserve topology.
   * @param {number} tolerance The tolerance distance for simplification.
   * @return {Geometry} A new, simplified version of the original geometry.
   * @api
   */ simplify(tolerance) {
        return this.getSimplifiedGeometry(tolerance * tolerance);
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker
   * algorithm.
   * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Geometry} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Get the type of this geometry.
   * @abstract
   * @return {Type} Geometry type.
   */ getType() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @abstract
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   */ applyTransform(transformFn) {
        (0, $9iPUS.abstract)();
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   */ intersectsExtent(extent) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @abstract
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */ translate(deltaX, deltaY) {
        (0, $9iPUS.abstract)();
    }
    /**
   * Transform each coordinate of the geometry from one coordinate reference
   * system to another. The geometry is modified in place.
   * For example, a line will be transformed to a line and a circle to a circle.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   *
   * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @return {this} This geometry.  Note that original geometry is
   *     modified in place.
   * @api
   */ transform(source, destination) {
        /** @type {import("../proj/Projection.js").default} */ const sourceProj = (0, $dpRHA.get)(source);
        const transformFn = sourceProj.getUnits() == 'tile-pixels' ? function(inCoordinates, outCoordinates, stride) {
            const pixelExtent = sourceProj.getExtent();
            const projectedExtent = sourceProj.getWorldExtent();
            const scale = (0, $9pD6L.getHeight)(projectedExtent) / (0, $9pD6L.getHeight)(pixelExtent);
            (0, $jpXrt.compose)($50db89a00eb954f6$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            const transformed = (0, $1MAUi.transform2D)(inCoordinates, 0, inCoordinates.length, stride, $50db89a00eb954f6$var$tmpTransform, outCoordinates);
            const projTransform = (0, $dpRHA.getTransform)(sourceProj, destination);
            if (projTransform) return projTransform(transformed, transformed, stride);
            return transformed;
        } : (0, $dpRHA.getTransform)(sourceProj, destination);
        this.applyTransform(transformFn);
        return this;
    }
}
var $50db89a00eb954f6$export$2e2bcd8739ae039 = $50db89a00eb954f6$var$Geometry;

});
parcelRegister("1MAUi", function(module, exports) {

$parcel$export(module.exports, "transform2D", () => $14c6e714516e527b$export$b92b2dedcfff79de);
$parcel$export(module.exports, "rotate", () => $14c6e714516e527b$export$bb628a54ab399bc9);
$parcel$export(module.exports, "scale", () => $14c6e714516e527b$export$dcdf75081b88279d);
$parcel$export(module.exports, "translate", () => $14c6e714516e527b$export$d73ee8ef04f5226a);
/**
 * @module ol/geom/flat/transform
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../transform.js").Transform} transform Transform.
 * @param {Array<number>} [dest] Destination.
 * @param {number} [destinationStride] Stride of destination coordinates; if unspecified, assumed to be 2.
 * @return {Array<number>} Transformed coordinates.
 */ function $14c6e714516e527b$export$b92b2dedcfff79de(flatCoordinates, offset, end, stride, transform, dest, destinationStride) {
    dest = dest ? dest : [];
    destinationStride = destinationStride ? destinationStride : 2;
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const x = flatCoordinates[j];
        const y = flatCoordinates[j + 1];
        dest[i++] = transform[0] * x + transform[2] * y + transform[4];
        dest[i++] = transform[1] * x + transform[3] * y + transform[5];
        for(let k = 2; k < destinationStride; k++)dest[i++] = flatCoordinates[j + k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $14c6e714516e527b$export$bb628a54ab399bc9(flatCoordinates, offset, end, stride, angle, anchor, dest) {
    dest = dest ? dest : [];
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + deltaX * cos - deltaY * sin;
        dest[i++] = anchorY + deltaX * sin + deltaY * cos;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $14c6e714516e527b$export$dcdf75081b88279d(flatCoordinates, offset, end, stride, sx, sy, anchor, dest) {
    dest = dest ? dest : [];
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + sx * deltaX;
        dest[i++] = anchorY + sy * deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $14c6e714516e527b$export$d73ee8ef04f5226a(flatCoordinates, offset, end, stride, deltaX, deltaY, dest) {
    dest = dest ? dest : [];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        dest[i++] = flatCoordinates[j] + deltaX;
        dest[i++] = flatCoordinates[j + 1] + deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}

});



parcelRegister("aCXb5", function(module, exports) {

$parcel$export(module.exports, "linearRing", () => $01ff26a2f986a1d0$export$3c5e1905f889266e);
$parcel$export(module.exports, "linearRings", () => $01ff26a2f986a1d0$export$7a8ee541dfdf2ed5);
$parcel$export(module.exports, "linearRingss", () => $01ff26a2f986a1d0$export$78e139679ca7205);
/**
 * @module ol/geom/flat/area
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Area.
 */ function $01ff26a2f986a1d0$export$3c5e1905f889266e(flatCoordinates, offset, end, stride) {
    let twiceArea = 0;
    const x0 = flatCoordinates[end - stride];
    const y0 = flatCoordinates[end - stride + 1];
    let dx1 = 0;
    let dy1 = 0;
    for(; offset < end; offset += stride){
        const dx2 = flatCoordinates[offset] - x0;
        const dy2 = flatCoordinates[offset + 1] - y0;
        twiceArea += dy1 * dx2 - dx1 * dy2;
        dx1 = dx2;
        dy1 = dy2;
    }
    return twiceArea / 2;
}
function $01ff26a2f986a1d0$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride) {
    let area = 0;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        area += $01ff26a2f986a1d0$export$3c5e1905f889266e(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return area;
}
function $01ff26a2f986a1d0$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    let area = 0;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        area += $01ff26a2f986a1d0$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride);
        offset = ends[ends.length - 1];
    }
    return area;
}

});

parcelRegister("gqtzW", function(module, exports) {

$parcel$export(module.exports, "maxSquaredDelta", () => $bf5604c1b8258b71$export$bc2eb611ddf80103);
$parcel$export(module.exports, "arrayMaxSquaredDelta", () => $bf5604c1b8258b71$export$fbf31c8f2668ed5a);
$parcel$export(module.exports, "multiArrayMaxSquaredDelta", () => $bf5604c1b8258b71$export$37c18e6e7d50501a);
$parcel$export(module.exports, "assignClosestPoint", () => $bf5604c1b8258b71$export$4adc8e5135fb44c);
$parcel$export(module.exports, "assignClosestArrayPoint", () => $bf5604c1b8258b71$export$5a48a0eefcf14992);
$parcel$export(module.exports, "assignClosestMultiArrayPoint", () => $bf5604c1b8258b71$export$60e067685eb8f9c4);
/**
 * @module ol/geom/flat/closest
 */ 
var $9byFX = parcelRequire("9byFX");
/**
 * Returns the point on the 2D line segment flatCoordinates[offset1] to
 * flatCoordinates[offset2] that is closest to the point (x, y).  Extra
 * dimensions are linearly interpolated.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset1 Offset 1.
 * @param {number} offset2 Offset 2.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 */ function $bf5604c1b8258b71$var$assignClosest(flatCoordinates, offset1, offset2, stride, x, y, closestPoint) {
    const x1 = flatCoordinates[offset1];
    const y1 = flatCoordinates[offset1 + 1];
    const dx = flatCoordinates[offset2] - x1;
    const dy = flatCoordinates[offset2 + 1] - y1;
    let offset;
    if (dx === 0 && dy === 0) offset = offset1;
    else {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) offset = offset2;
        else if (t > 0) {
            for(let i = 0; i < stride; ++i)closestPoint[i] = (0, $9byFX.lerp)(flatCoordinates[offset1 + i], flatCoordinates[offset2 + i], t);
            closestPoint.length = stride;
            return;
        } else offset = offset1;
    }
    for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
    closestPoint.length = stride;
}
function $bf5604c1b8258b71$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    for(offset += stride; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        const squaredDelta = (0, $9byFX.squaredDistance)(x1, y1, x2, y2);
        if (squaredDelta > max) max = squaredDelta;
        x1 = x2;
        y1 = y2;
    }
    return max;
}
function $bf5604c1b8258b71$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        max = $bf5604c1b8258b71$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max);
        offset = end;
    }
    return max;
}
function $bf5604c1b8258b71$export$37c18e6e7d50501a(flatCoordinates, offset, endss, stride, max) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        max = $bf5604c1b8258b71$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max);
        offset = ends[ends.length - 1];
    }
    return max;
}
function $bf5604c1b8258b71$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    if (offset == end) return minSquaredDistance;
    let i, squaredDistance;
    if (maxDelta === 0) {
        // All points are identical, so just test the first point.
        squaredDistance = (0, $9byFX.squaredDistance)(x, y, flatCoordinates[offset], flatCoordinates[offset + 1]);
        if (squaredDistance < minSquaredDistance) {
            for(i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    let index = offset + stride;
    while(index < end){
        $bf5604c1b8258b71$var$assignClosest(flatCoordinates, index - stride, index, stride, x, y, tmpPoint);
        squaredDistance = (0, $9byFX.squaredDistance)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
            index += stride;
        } else // Skip ahead multiple points, because we know that all the skipped
        // points cannot be any closer than the closest point we have found so
        // far.  We know this because we know how close the current point is, how
        // close the closest point we have found so far is, and the maximum
        // distance between consecutive points.  For example, if we're currently
        // at distance 10, the best we've found so far is 3, and that the maximum
        // distance between consecutive points is 2, then we'll need to skip at
        // least (10 - 3) / 2 == 3 (rounded down) points to have any chance of
        // finding a closer point.  We use Math.max(..., 1) to ensure that we
        // always advance at least one point, to avoid an infinite loop.
        index += stride * Math.max((Math.sqrt(squaredDistance) - Math.sqrt(minSquaredDistance)) / maxDelta | 0, 1);
    }
    if (isRing) {
        // Check the closing segment.
        $bf5604c1b8258b71$var$assignClosest(flatCoordinates, end - stride, offset, stride, x, y, tmpPoint);
        squaredDistance = (0, $9byFX.squaredDistance)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
        }
    }
    return minSquaredDistance;
}
function $bf5604c1b8258b71$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        minSquaredDistance = $bf5604c1b8258b71$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = end;
    }
    return minSquaredDistance;
}
function $bf5604c1b8258b71$export$60e067685eb8f9c4(flatCoordinates, offset, endss, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        minSquaredDistance = $bf5604c1b8258b71$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = ends[ends.length - 1];
    }
    return minSquaredDistance;
}

});

parcelRegister("9bJty", function(module, exports) {

$parcel$export(module.exports, "deflateCoordinate", () => $6b086aa46281540d$export$60815ead40ec79ab);
$parcel$export(module.exports, "deflateCoordinates", () => $6b086aa46281540d$export$5c4daf67e03c190f);
$parcel$export(module.exports, "deflateCoordinatesArray", () => $6b086aa46281540d$export$47c3746a74384d45);
$parcel$export(module.exports, "deflateMultiCoordinatesArray", () => $6b086aa46281540d$export$f9f2bb59da4accd3);
/**
 * @module ol/geom/flat/deflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */ function $6b086aa46281540d$export$60815ead40ec79ab(flatCoordinates, offset, coordinate, stride) {
    for(let i = 0, ii = coordinate.length; i < ii; ++i)flatCoordinates[offset++] = coordinate[i];
    return offset;
}
function $6b086aa46281540d$export$5c4daf67e03c190f(flatCoordinates, offset, coordinates, stride) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i){
        const coordinate = coordinates[i];
        for(let j = 0; j < stride; ++j)flatCoordinates[offset++] = coordinate[j];
    }
    return offset;
}
function $6b086aa46281540d$export$47c3746a74384d45(flatCoordinates, offset, coordinatess, stride, ends) {
    ends = ends ? ends : [];
    let i = 0;
    for(let j = 0, jj = coordinatess.length; j < jj; ++j){
        const end = $6b086aa46281540d$export$5c4daf67e03c190f(flatCoordinates, offset, coordinatess[j], stride);
        ends[i++] = end;
        offset = end;
    }
    ends.length = i;
    return ends;
}
function $6b086aa46281540d$export$f9f2bb59da4accd3(flatCoordinates, offset, coordinatesss, stride, endss) {
    endss = endss ? endss : [];
    let i = 0;
    for(let j = 0, jj = coordinatesss.length; j < jj; ++j){
        const ends = $6b086aa46281540d$export$47c3746a74384d45(flatCoordinates, offset, coordinatesss[j], stride, endss[i]);
        if (ends.length === 0) ends[0] = offset;
        endss[i++] = ends;
        offset = ends[ends.length - 1];
    }
    endss.length = i;
    return endss;
}

});

parcelRegister("7eSHW", function(module, exports) {

$parcel$export(module.exports, "inflateCoordinates", () => $5454470599558ddd$export$9c0934e4e9c3f61e);
$parcel$export(module.exports, "inflateCoordinatesArray", () => $5454470599558ddd$export$cbb9596fc0f40db2);
$parcel$export(module.exports, "inflateMultiCoordinatesArray", () => $5454470599558ddd$export$915c7058aeb4dfeb);
/**
 * @module ol/geom/flat/inflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Array<import("../../coordinate.js").Coordinate>} [coordinates] Coordinates.
 * @return {Array<import("../../coordinate.js").Coordinate>} Coordinates.
 */ function $5454470599558ddd$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinates) {
    coordinates = coordinates !== undefined ? coordinates : [];
    let i = 0;
    for(let j = offset; j < end; j += stride)coordinates[i++] = flatCoordinates.slice(j, j + stride);
    coordinates.length = i;
    return coordinates;
}
function $5454470599558ddd$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatess) {
    coordinatess = coordinatess !== undefined ? coordinatess : [];
    let i = 0;
    for(let j = 0, jj = ends.length; j < jj; ++j){
        const end = ends[j];
        coordinatess[i++] = $5454470599558ddd$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinatess[i]);
        offset = end;
    }
    coordinatess.length = i;
    return coordinatess;
}
function $5454470599558ddd$export$915c7058aeb4dfeb(flatCoordinates, offset, endss, stride, coordinatesss) {
    coordinatesss = coordinatesss !== undefined ? coordinatesss : [];
    let i = 0;
    for(let j = 0, jj = endss.length; j < jj; ++j){
        const ends = endss[j];
        coordinatesss[i++] = ends.length === 1 && ends[0] === offset ? [] : $5454470599558ddd$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatesss[i]);
        offset = ends[ends.length - 1];
    }
    coordinatesss.length = i;
    return coordinatesss;
}

});

parcelRegister("bDhby", function(module, exports) {

$parcel$export(module.exports, "douglasPeucker", () => $8780aae6970f5f65$export$ef693d1572e64fb8);
$parcel$export(module.exports, "douglasPeuckerArray", () => $8780aae6970f5f65$export$cedb9900c0b225c2);
$parcel$export(module.exports, "snap", () => $8780aae6970f5f65$export$51a0620f7a28532b);
$parcel$export(module.exports, "quantizeArray", () => $8780aae6970f5f65$export$60a9904b67f8d51b);
$parcel$export(module.exports, "quantizeMultiArray", () => $8780aae6970f5f65$export$b9acf67ef05cd17c);
/**
 * @module ol/geom/flat/simplify
 */ // Based on simplify-js https://github.com/mourner/simplify-js
// Copyright (c) 2012, Vladimir Agafonkin
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//    1. Redistributions of source code must retain the above copyright notice,
//       this list of conditions and the following disclaimer.
//
//    2. Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.

var $9byFX = parcelRequire("9byFX");
function $8780aae6970f5f65$export$2cbbcce9030b8734(flatCoordinates, offset, end, stride, squaredTolerance, highQuality, simplifiedFlatCoordinates) {
    simplifiedFlatCoordinates = simplifiedFlatCoordinates !== undefined ? simplifiedFlatCoordinates : [];
    if (!highQuality) {
        end = $8780aae6970f5f65$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        flatCoordinates = simplifiedFlatCoordinates;
        offset = 0;
        stride = 2;
    }
    simplifiedFlatCoordinates.length = $8780aae6970f5f65$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
    return simplifiedFlatCoordinates;
}
function $8780aae6970f5f65$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    const n = (end - offset) / stride;
    if (n < 3) {
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    /** @type {Array<number>} */ const markers = new Array(n);
    markers[0] = 1;
    markers[n - 1] = 1;
    /** @type {Array<number>} */ const stack = [
        offset,
        end - stride
    ];
    let index = 0;
    while(stack.length > 0){
        const last = stack.pop();
        const first = stack.pop();
        let maxSquaredDistance = 0;
        const x1 = flatCoordinates[first];
        const y1 = flatCoordinates[first + 1];
        const x2 = flatCoordinates[last];
        const y2 = flatCoordinates[last + 1];
        for(let i = first + stride; i < last; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            const squaredDistance = (0, $9byFX.squaredSegmentDistance)(x, y, x1, y1, x2, y2);
            if (squaredDistance > maxSquaredDistance) {
                index = i;
                maxSquaredDistance = squaredDistance;
            }
        }
        if (maxSquaredDistance > squaredTolerance) {
            markers[(index - offset) / stride] = 1;
            if (first + stride < index) stack.push(first, index);
            if (index + stride < last) stack.push(index, last);
        }
    }
    for(let i = 0; i < n; ++i)if (markers[i]) {
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride];
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride + 1];
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = $8780aae6970f5f65$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$5d74fb54bb752ea0(flatCoordinates, offset, endss, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = $8780aae6970f5f65$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    if (end <= offset + stride) {
        // zero or one point, no simplification possible, so copy and return
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    // copy first point
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    let x2 = x1;
    let y2 = y1;
    for(offset += stride; offset < end; offset += stride){
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        if ((0, $9byFX.squaredDistance)(x1, y1, x2, y2) > squaredTolerance) {
            // copy point at offset
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            x1 = x2;
            y1 = y2;
        }
    }
    if (x2 != x1 || y2 != y1) {
        // copy last point
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$51a0620f7a28532b(value, tolerance) {
    return tolerance * Math.round(value / tolerance);
}
function $8780aae6970f5f65$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    // do nothing if the line is empty
    if (offset == end) return simplifiedOffset;
    // snap the first coordinate (P1)
    let x1 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
    let y1 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
    offset += stride;
    // add the first coordinate to the output
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    // find the next coordinate that does not snap to the same value as the first
    // coordinate (P2)
    let x2, y2;
    do {
        x2 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        y2 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        if (offset == end) {
            // all coordinates snap to the same value, the line collapses to a point
            // push the last snapped value anyway to ensure that the output contains
            // at least two points
            // FIXME should we really return at least two points anyway?
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            return simplifiedOffset;
        }
    }while (x2 == x1 && y2 == y1);
    while(offset < end){
        // snap the next coordinate (P3)
        const x3 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        const y3 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        // skip P3 if it is equal to P2
        if (x3 == x2 && y3 == y2) continue;
        // calculate the delta between P1 and P2
        const dx1 = x2 - x1;
        const dy1 = y2 - y1;
        // calculate the delta between P3 and P1
        const dx2 = x3 - x1;
        const dy2 = y3 - y1;
        // if P1, P2, and P3 are colinear and P3 is further from P1 than P2 is from
        // P1 in the same direction then P2 is on the straight line between P1 and
        // P3
        if (dx1 * dy2 == dy1 * dx2 && (dx1 < 0 && dx2 < dx1 || dx1 == dx2 || dx1 > 0 && dx2 > dx1) && (dy1 < 0 && dy2 < dy1 || dy1 == dy2 || dy1 > 0 && dy2 > dy1)) {
            // discard P2 and set P2 = P3
            x2 = x3;
            y2 = y3;
            continue;
        }
        // either P1, P2, and P3 are not colinear, or they are colinear but P3 is
        // between P3 and P1 or on the opposite half of the line to P2.  add P2,
        // and continue with P1 = P2 and P2 = P3
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
        x1 = x2;
        y1 = y2;
        x2 = x3;
        y2 = y3;
    }
    // add the last point (P2)
    simplifiedFlatCoordinates[simplifiedOffset++] = x2;
    simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = $8780aae6970f5f65$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$b9acf67ef05cd17c(flatCoordinates, offset, endss, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = $8780aae6970f5f65$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}

});


parcelRegister("9vPkX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eced4c969949f6b$export$2e2bcd8739ae039);
/**
 * @module ol/geom/Point
 */ 
var $9pD6L = parcelRequire("9pD6L");

var $9byFX = parcelRequire("9byFX");

var $h7zsK = parcelRequire("h7zsK");

var $9bJty = parcelRequire("9bJty");
/**
 * @classdesc
 * Point geometry.
 *
 * @api
 */ class $6eced4c969949f6b$var$Point extends (0, $h7zsK.default) {
    /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        this.setCoordinates(coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Point} Clone.
   * @api
   * @override
   */ clone() {
        const point = new $6eced4c969949f6b$var$Point(this.flatCoordinates.slice(), this.layout);
        point.applyProperties(this);
        return point;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const squaredDistance = (0, $9byFX.squaredDistance)(x, y, flatCoordinates[0], flatCoordinates[1]);
        if (squaredDistance < minSquaredDistance) {
            const stride = this.stride;
            for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinate of the point.
   * @return {import("../coordinate.js").Coordinate} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return this.flatCoordinates.slice();
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        return (0, $9pD6L.createOrUpdateFromCoordinate)(this.flatCoordinates, extent);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Point';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $9pD6L.containsXY)(extent, this.flatCoordinates[0], this.flatCoordinates[1]);
    }
    /**
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $9bJty.deflateCoordinate)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $6eced4c969949f6b$export$2e2bcd8739ae039 = $6eced4c969949f6b$var$Point;

});

parcelRegister("33weL", function(module, exports) {

$parcel$export(module.exports, "linearRingContainsExtent", () => $239aa88e7a573859$export$cedabedc7ac0e138);
$parcel$export(module.exports, "linearRingContainsXY", () => $239aa88e7a573859$export$949a7a3a4b6f34fa);
$parcel$export(module.exports, "linearRingsContainsXY", () => $239aa88e7a573859$export$ae868c0f6acc3355);
$parcel$export(module.exports, "linearRingssContainsXY", () => $239aa88e7a573859$export$c760d9d16cf92043);
/**
 * @module ol/geom/flat/contains
 */ 
var $9pD6L = parcelRequire("9pD6L");
function $239aa88e7a573859$export$cedabedc7ac0e138(flatCoordinates, offset, end, stride, extent) {
    const outside = (0, $9pD6L.forEachCorner)(extent, /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains (x, y).
     */ function(coordinate) {
        return !$239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, coordinate[0], coordinate[1]);
    });
    return !outside;
}
function $239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, x, y) {
    // https://web.archive.org/web/20210504233957/http://geomalgorithms.com/a03-_inclusion.html
    // Copyright 2000 softSurfer, 2012 Dan Sunday
    // This code may be freely used and modified for any purpose
    // providing that this copyright notice is included with it.
    // SoftSurfer makes no warranty for this code, and cannot be held
    // liable for any real or imagined damage resulting from its use.
    // Users of this code must verify correctness for their application.
    let wn = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        if (y1 <= y) {
            if (y2 > y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) > 0) wn++;
        } else if (y2 <= y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) < 0) wn--;
        x1 = x2;
        y1 = y2;
    }
    return wn !== 0;
}
function $239aa88e7a573859$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y) {
    if (ends.length === 0) return false;
    if (!$239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, offset, ends[0], stride, x, y)) return false;
    for(let i = 1, ii = ends.length; i < ii; ++i){
        if ($239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, ends[i - 1], ends[i], stride, x, y)) return false;
    }
    return true;
}
function $239aa88e7a573859$export$c760d9d16cf92043(flatCoordinates, offset, endss, stride, x, y) {
    if (endss.length === 0) return false;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if ($239aa88e7a573859$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}

});

parcelRegister("2RNwh", function(module, exports) {

$parcel$export(module.exports, "getInteriorPointOfArray", () => $2166f19777f69377$export$50e3b25928a5e892);
$parcel$export(module.exports, "getInteriorPointsOfMultiArray", () => $2166f19777f69377$export$11463803eda8a372);
/**
 * @module ol/geom/flat/interiorpoint
 */ 
var $fVVyM = parcelRequire("fVVyM");

var $33weL = parcelRequire("33weL");
function $2166f19777f69377$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, flatCentersOffset, dest) {
    let i, ii, x, x1, x2, y1, y2;
    const y = flatCenters[flatCentersOffset + 1];
    /** @type {Array<number>} */ const intersections = [];
    // Calculate intersections with the horizontal line
    for(let r = 0, rr = ends.length; r < rr; ++r){
        const end = ends[r];
        x1 = flatCoordinates[end - stride];
        y1 = flatCoordinates[end - stride + 1];
        for(i = offset; i < end; i += stride){
            x2 = flatCoordinates[i];
            y2 = flatCoordinates[i + 1];
            if (y <= y1 && y2 <= y || y1 <= y && y <= y2) {
                x = (y - y1) / (y2 - y1) * (x2 - x1) + x1;
                intersections.push(x);
            }
            x1 = x2;
            y1 = y2;
        }
    }
    // Find the longest segment of the horizontal line that has its center point
    // inside the linear ring.
    let pointX = NaN;
    let maxSegmentLength = -Infinity;
    intersections.sort((0, $fVVyM.ascending));
    x1 = intersections[0];
    for(i = 1, ii = intersections.length; i < ii; ++i){
        x2 = intersections[i];
        const segmentLength = Math.abs(x2 - x1);
        if (segmentLength > maxSegmentLength) {
            x = (x1 + x2) / 2;
            if ((0, $33weL.linearRingsContainsXY)(flatCoordinates, offset, ends, stride, x, y)) {
                pointX = x;
                maxSegmentLength = segmentLength;
            }
        }
        x1 = x2;
    }
    if (isNaN(pointX)) // There is no horizontal line that has its center point inside the linear
    // ring.  Use the center of the the linear ring's extent.
    pointX = flatCenters[flatCentersOffset];
    if (dest) {
        dest.push(pointX, y, maxSegmentLength);
        return dest;
    }
    return [
        pointX,
        y,
        maxSegmentLength
    ];
}
function $2166f19777f69377$export$11463803eda8a372(flatCoordinates, offset, endss, stride, flatCenters) {
    /** @type {Array<number>} */ let interiorPoints = [];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        interiorPoints = $2166f19777f69377$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, 2 * i, interiorPoints);
        offset = ends[ends.length - 1];
    }
    return interiorPoints;
}

});

parcelRegister("eQvue", function(module, exports) {

$parcel$export(module.exports, "intersectsLineString", () => $acee589e5b390c5c$export$40d8d71841a3d779);
$parcel$export(module.exports, "intersectsLineStringArray", () => $acee589e5b390c5c$export$fdb1d8e850bf7937);
$parcel$export(module.exports, "intersectsLinearRing", () => $acee589e5b390c5c$export$830a0dafbb2ef1c5);
$parcel$export(module.exports, "intersectsLinearRingArray", () => $acee589e5b390c5c$export$76dcd8f8f83b6ddb);
$parcel$export(module.exports, "intersectsLinearRingMultiArray", () => $acee589e5b390c5c$export$77b72fa3792f5bf0);
/**
 * @module ol/geom/flat/intersectsextent
 */ 
var $9pD6L = parcelRequire("9pD6L");

var $33weL = parcelRequire("33weL");

var $5m6tu = parcelRequire("5m6tu");
function $acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent, coordinatesExtent) {
    coordinatesExtent = coordinatesExtent ?? (0, $9pD6L.extendFlatCoordinates)((0, $9pD6L.createEmpty)(), flatCoordinates, offset, end, stride);
    if (!(0, $9pD6L.intersects)(extent, coordinatesExtent)) return false;
    if (coordinatesExtent[0] >= extent[0] && coordinatesExtent[2] <= extent[2] || coordinatesExtent[1] >= extent[1] && coordinatesExtent[3] <= extent[3]) return true;
    return (0, $5m6tu.forEach)(flatCoordinates, offset, end, stride, /**
     * @param {import("../../coordinate.js").Coordinate} point1 Start point.
     * @param {import("../../coordinate.js").Coordinate} point2 End point.
     * @return {boolean} `true` if the segment and the extent intersect,
     *     `false` otherwise.
     */ function(point1, point2) {
        return (0, $9pD6L.intersectsSegment)(extent, point1, point2);
    });
}
function $acee589e5b390c5c$export$fdb1d8e850bf7937(flatCoordinates, offset, ends, stride, extent) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        if ($acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, offset, ends[i], stride, extent)) return true;
        offset = ends[i];
    }
    return false;
}
function $acee589e5b390c5c$export$830a0dafbb2ef1c5(flatCoordinates, offset, end, stride, extent) {
    if ($acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent)) return true;
    if ((0, $33weL.linearRingContainsXY)(flatCoordinates, offset, end, stride, extent[0], extent[1])) return true;
    if ((0, $33weL.linearRingContainsXY)(flatCoordinates, offset, end, stride, extent[0], extent[3])) return true;
    if ((0, $33weL.linearRingContainsXY)(flatCoordinates, offset, end, stride, extent[2], extent[1])) return true;
    if ((0, $33weL.linearRingContainsXY)(flatCoordinates, offset, end, stride, extent[2], extent[3])) return true;
    return false;
}
function $acee589e5b390c5c$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent) {
    if (!$acee589e5b390c5c$export$830a0dafbb2ef1c5(flatCoordinates, offset, ends[0], stride, extent)) return false;
    if (ends.length === 1) return true;
    for(let i = 1, ii = ends.length; i < ii; ++i)if ((0, $33weL.linearRingContainsExtent)(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
        if (!$acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, ends[i - 1], ends[i], stride, extent)) return false;
    }
    return true;
}
function $acee589e5b390c5c$export$77b72fa3792f5bf0(flatCoordinates, offset, endss, stride, extent) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if ($acee589e5b390c5c$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}

});
parcelRegister("5m6tu", function(module, exports) {

$parcel$export(module.exports, "forEach", () => $3e64078bffae1cbd$export$4b80e395e36b5a56);
/**
 * @module ol/geom/flat/segments
 */ /**
 * This function calls `callback` for each segment of the flat coordinates
 * array. If the callback returns a truthy value the function returns that
 * value immediately. Otherwise the function returns `false`.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {function(import("../../coordinate.js").Coordinate, import("../../coordinate.js").Coordinate): T} callback Function
 *     called for each segment.
 * @return {T|boolean} Value.
 * @template T
 */ function $3e64078bffae1cbd$export$4b80e395e36b5a56(flatCoordinates, offset, end, stride, callback) {
    let ret;
    offset += stride;
    for(; offset < end; offset += stride){
        ret = callback(flatCoordinates.slice(offset - stride, offset), flatCoordinates.slice(offset, offset + stride));
        if (ret) return ret;
    }
    return false;
}
function $3e64078bffae1cbd$export$3f024338373820dc(segment1, segment2) {
    const [a, b] = segment1;
    const [c, d] = segment2;
    const t = ((a[0] - c[0]) * (c[1] - d[1]) - (a[1] - c[1]) * (c[0] - d[0])) / ((a[0] - b[0]) * (c[1] - d[1]) - (a[1] - b[1]) * (c[0] - d[0]));
    const u = ((a[0] - c[0]) * (a[1] - b[1]) - (a[1] - c[1]) * (a[0] - b[0])) / ((a[0] - b[0]) * (c[1] - d[1]) - (a[1] - b[1]) * (c[0] - d[0]));
    // Check if lines actually intersect
    if (0 <= t && t <= 1 && 0 <= u && u <= 1) return [
        a[0] + t * (b[0] - a[0]),
        a[1] + t * (b[1] - a[1])
    ];
    return undefined;
}

});


parcelRegister("alOgM", function(module, exports) {

$parcel$export(module.exports, "linearRingsAreOriented", () => $7892dc06ffd23218$export$f27cd06e85f4ba28);
$parcel$export(module.exports, "linearRingssAreOriented", () => $7892dc06ffd23218$export$a1d138f4bd85f4b4);
$parcel$export(module.exports, "orientLinearRings", () => $7892dc06ffd23218$export$b71b604ddfc778c7);
$parcel$export(module.exports, "orientLinearRingsArray", () => $7892dc06ffd23218$export$ea9ed55fc2a85010);
$parcel$export(module.exports, "inflateEnds", () => $7892dc06ffd23218$export$cb72ae403d6e78e6);
/**
 * @module ol/geom/flat/orient
 */ 
var $1PJpx = parcelRequire("1PJpx");
function $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, stride) {
    // https://stackoverflow.com/q/1165647/clockwise-method#1165943
    // https://github.com/OSGeo/gdal/blob/master/gdal/ogr/ogrlinearring.cpp
    let edge = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        edge += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    return edge === 0 ? undefined : edge > 0;
}
function $7892dc06ffd23218$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        if (i === 0) {
            if (right && isClockwise || !right && !isClockwise) return false;
        } else {
            if (right && !isClockwise || !right && isClockwise) return false;
        }
        offset = end;
    }
    return true;
}
function $7892dc06ffd23218$export$a1d138f4bd85f4b4(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if (!$7892dc06ffd23218$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right)) return false;
        if (ends.length) offset = ends[ends.length - 1];
    }
    return true;
}
function $7892dc06ffd23218$export$b71b604ddfc778c7(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        const reverse = i === 0 ? right && isClockwise || !right && !isClockwise : right && !isClockwise || !right && isClockwise;
        if (reverse) (0, $1PJpx.coordinates)(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return offset;
}
function $7892dc06ffd23218$export$ea9ed55fc2a85010(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i)offset = $7892dc06ffd23218$export$b71b604ddfc778c7(flatCoordinates, offset, endss[i], stride, right);
    return offset;
}
function $7892dc06ffd23218$export$cb72ae403d6e78e6(flatCoordinates, ends) {
    const endss = [];
    let offset = 0;
    let prevEndIndex = 0;
    let startOrientation;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        // classifies an array of rings into polygons with outer rings and holes
        const orientation = $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, 2);
        if (startOrientation === undefined) startOrientation = orientation;
        if (orientation === startOrientation) endss.push(ends.slice(prevEndIndex, i + 1));
        else {
            if (endss.length === 0) continue;
            endss[endss.length - 1].push(ends[prevEndIndex]);
        }
        prevEndIndex = i + 1;
        offset = end;
    }
    return endss;
}

});
parcelRegister("1PJpx", function(module, exports) {

$parcel$export(module.exports, "coordinates", () => $155dc783a4ec227e$export$741858880c96b18c);
/**
 * @module ol/geom/flat/reverse
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 */ function $155dc783a4ec227e$export$741858880c96b18c(flatCoordinates, offset, end, stride) {
    while(offset < end - stride){
        for(let i = 0; i < stride; ++i){
            const tmp = flatCoordinates[offset + i];
            flatCoordinates[offset + i] = flatCoordinates[end - stride + i];
            flatCoordinates[end - stride + i] = tmp;
        }
        offset += stride;
        end -= stride;
    }
}

});



parcelRegister("g29x3", function(module, exports) {

$parcel$export(module.exports, "createSnapToResolutions", () => $bac43a1f4a628548$export$d65a517690fc4385);
$parcel$export(module.exports, "createSnapToPower", () => $bac43a1f4a628548$export$22ac0f6b219de91a);
$parcel$export(module.exports, "createMinMaxResolution", () => $bac43a1f4a628548$export$1c4e6da9b4b066fe);
/**
 * @module ol/resolutionconstraint
 */ 
var $fVVyM = parcelRequire("fVVyM");

var $9pD6L = parcelRequire("9pD6L");

var $9byFX = parcelRequire("9byFX");
/**
 * @typedef {function((number|undefined), number, import("./size.js").Size, boolean=): (number|undefined)} Type
 */ /**
 * Returns a modified resolution taking into account the viewport size and maximum
 * allowed extent.
 * @param {number} resolution Resolution
 * @param {import("./extent.js").Extent} maxExtent Maximum allowed extent.
 * @param {import("./size.js").Size} viewportSize Viewport size.
 * @param {boolean} showFullExtent Whether to show the full extent.
 * @return {number} Capped resolution.
 */ function $bac43a1f4a628548$var$getViewportClampedResolution(resolution, maxExtent, viewportSize, showFullExtent) {
    const xResolution = (0, $9pD6L.getWidth)(maxExtent) / viewportSize[0];
    const yResolution = (0, $9pD6L.getHeight)(maxExtent) / viewportSize[1];
    if (showFullExtent) return Math.min(resolution, Math.max(xResolution, yResolution));
    return Math.min(resolution, Math.min(xResolution, yResolution));
}
/**
 * Returns a modified resolution to be between maxResolution and minResolution while
 * still allowing the value to be slightly out of bounds.
 * Note: the computation is based on the logarithm function (ln):
 *  - at 1, ln(x) is 0
 *  - above 1, ln(x) keeps increasing but at a much slower pace than x
 * The final result is clamped to prevent getting too far away from bounds.
 * @param {number} resolution Resolution.
 * @param {number} maxResolution Max resolution.
 * @param {number} minResolution Min resolution.
 * @return {number} Smoothed resolution.
 */ function $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, maxResolution, minResolution) {
    let result = Math.min(resolution, maxResolution);
    const ratio = 50;
    result *= Math.log(1 + ratio * Math.max(0, resolution / maxResolution - 1)) / ratio + 1;
    if (minResolution) {
        result = Math.max(result, minResolution);
        result /= Math.log(1 + ratio * Math.max(0, minResolution / resolution - 1)) / ratio + 1;
    }
    return (0, $9byFX.clamp)(result, minResolution / 2, maxResolution * 2);
}
function $bac43a1f4a628548$export$d65a517690fc4385(resolutions, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const maxResolution = resolutions[0];
            const minResolution = resolutions[resolutions.length - 1];
            const cappedMaxRes = maxExtent ? $bac43a1f4a628548$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $9byFX.clamp)(resolution, minResolution, cappedMaxRes);
                return $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const capped = Math.min(cappedMaxRes, resolution);
            const z = Math.floor((0, $fVVyM.linearFindNearest)(resolutions, capped, direction));
            if (resolutions[z] > cappedMaxRes && z < resolutions.length - 1) return resolutions[z + 1];
            return resolutions[z];
        }
        return undefined;
    });
}
function $bac43a1f4a628548$export$22ac0f6b219de91a(power, maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    minResolution = minResolution !== undefined ? minResolution : 0;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? $bac43a1f4a628548$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $9byFX.clamp)(resolution, minResolution, cappedMaxRes);
                return $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const tolerance = 1e-9;
            const minZoomLevel = Math.ceil(Math.log(maxResolution / cappedMaxRes) / Math.log(power) - tolerance);
            const offset = -direction * (0.5 - tolerance) + 0.5;
            const capped = Math.min(cappedMaxRes, resolution);
            const cappedZoomLevel = Math.floor(Math.log(maxResolution / capped) / Math.log(power) + offset);
            const zoomLevel = Math.max(minZoomLevel, cappedZoomLevel);
            const newResolution = maxResolution / Math.pow(power, zoomLevel);
            return (0, $9byFX.clamp)(newResolution, minResolution, cappedMaxRes);
        }
        return undefined;
    });
}
function $bac43a1f4a628548$export$1c4e6da9b4b066fe(maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? $bac43a1f4a628548$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            if (!smooth || !isMoving) return (0, $9byFX.clamp)(resolution, minResolution, cappedMaxRes);
            return $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
        }
        return undefined;
    });
}

});

parcelRegister("ip5LZ", function(module, exports) {

$parcel$export(module.exports, "disable", () => $d65f0a322291d127$export$e20fbacbb41798b);
$parcel$export(module.exports, "none", () => $d65f0a322291d127$export$f883a24d5edde77c);
$parcel$export(module.exports, "createSnapToN", () => $d65f0a322291d127$export$9ba78806de831083);
$parcel$export(module.exports, "createSnapToZero", () => $d65f0a322291d127$export$17a6e6f3448b17e8);
/**
 * @module ol/rotationconstraint
 */ 
var $9byFX = parcelRequire("9byFX");
function $d65f0a322291d127$export$e20fbacbb41798b(rotation) {
    if (rotation !== undefined) return 0;
    return undefined;
}
function $d65f0a322291d127$export$f883a24d5edde77c(rotation) {
    if (rotation !== undefined) return rotation;
    return undefined;
}
function $d65f0a322291d127$export$9ba78806de831083(n) {
    const theta = 2 * Math.PI / n;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving) return rotation;
        if (rotation !== undefined) {
            rotation = Math.floor(rotation / theta + 0.5) * theta;
            return rotation;
        }
        return undefined;
    });
}
function $d65f0a322291d127$export$17a6e6f3448b17e8(tolerance) {
    const t = tolerance === undefined ? (0, $9byFX.toRadians)(5) : tolerance;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving || rotation === undefined) return rotation;
        if (Math.abs(rotation) <= t) return 0;
        return rotation;
    });
}

});

parcelRegister("7xn5x", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MAX_ZOOM", () => $57cd8651d88957a0$export$e98a216cdcc847dc);
$parcel$export(module.exports, "DEFAULT_TILE_SIZE", () => $57cd8651d88957a0$export$6b8cb5cd370bd90c);
/**
 * @module ol/tilegrid/common
 */ /**
 * Default maximum zoom for default tile grids.
 * @type {number}
 */ const $57cd8651d88957a0$export$e98a216cdcc847dc = 42;
const $57cd8651d88957a0$export$6b8cb5cd370bd90c = 256;

});


parcelRegister("7xdj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $57c5f0299cb9b82f$export$2e2bcd8739ae039);
/**
 * @module ol/layer/Base
 */ 
var $fFFY7 = parcelRequire("fFFY7");

var $4Cz58 = parcelRequire("4Cz58");

var $9byFX = parcelRequire("9byFX");

var $9iPUS = parcelRequire("9iPUS");

var $lbO8S = parcelRequire("lbO8S");
/**
 * A css color, or a function called with a view resolution returning a css color.
 *
 * @typedef {string|function(number):string} BackgroundColor
 * @api
 */ /**
 * @typedef {import("../ObjectEventType").Types|'change:extent'|'change:maxResolution'|'change:maxZoom'|
 *    'change:minResolution'|'change:minZoom'|'change:opacity'|'change:visible'|'change:zIndex'} BaseLayerObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<BaseLayerObjectEventTypes, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|BaseLayerObjectEventTypes, Return>} BaseLayerOnSignature
 */ /**
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number | undefined} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {Properties} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Note that with {@link module:ol/layer/Base~BaseLayer} and all its subclasses, any property set in
 * the options is set as a {@link module:ol/Object~BaseObject} property on the layer object, so
 * is observable, and has get/set accessors.
 *
 * @api
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @extends {BaseObject<NoInfer<Properties> & Object<string, *>>}
 */ class $57c5f0299cb9b82f$var$BaseLayer extends (0, $fFFY7.default) {
    /**
   * @param {Options<NoInfer<Properties>>} options Layer options.
   */ constructor(options){
        super();
        /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {BaseLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {BackgroundColor|false}
     * @private
     */ this.background_ = options.background;
        /**
     * @type {?}
     */ const properties = Object.assign({}, options);
        if (typeof options.properties === 'object') {
            delete properties.properties;
            Object.assign(properties, options.properties);
        }
        properties[(0, $lbO8S.default).OPACITY] = options.opacity !== undefined ? options.opacity : 1;
        (0, $4Cz58.assert)(typeof properties[(0, $lbO8S.default).OPACITY] === 'number', 'Layer opacity must be a number');
        properties[(0, $lbO8S.default).VISIBLE] = options.visible !== undefined ? options.visible : true;
        properties[(0, $lbO8S.default).Z_INDEX] = options.zIndex;
        properties[(0, $lbO8S.default).MAX_RESOLUTION] = options.maxResolution !== undefined ? options.maxResolution : Infinity;
        properties[(0, $lbO8S.default).MIN_RESOLUTION] = options.minResolution !== undefined ? options.minResolution : 0;
        properties[(0, $lbO8S.default).MIN_ZOOM] = options.minZoom !== undefined ? options.minZoom : -Infinity;
        properties[(0, $lbO8S.default).MAX_ZOOM] = options.maxZoom !== undefined ? options.maxZoom : Infinity;
        /**
     * @type {string}
     * @private
     */ this.className_ = properties.className !== undefined ? properties.className : 'ol-layer';
        delete properties.className;
        this.setProperties(properties);
        /**
     * @type {import("./Layer.js").State}
     * @private
     */ this.state_ = null;
    }
    /**
   * Get the background for this layer.
   * @return {BackgroundColor|false} Layer background.
   */ getBackground() {
        return this.background_;
    }
    /**
   * @return {string} CSS class name.
   */ getClassName() {
        return this.className_;
    }
    /**
   * This method is not meant to be called by layers or layer renderers because the state
   * is incorrect if the layer is included in a layer group.
   *
   * @param {boolean} [managed] Layer is managed.
   * @return {import("./Layer.js").State} Layer state.
   */ getLayerState(managed) {
        /** @type {import("./Layer.js").State} */ const state = this.state_ || /** @type {?} */ {
            layer: this,
            managed: managed === undefined ? true : managed
        };
        const zIndex = this.getZIndex();
        state.opacity = (0, $9byFX.clamp)(Math.round(this.getOpacity() * 100) / 100, 0, 1);
        state.visible = this.getVisible();
        state.extent = this.getExtent();
        state.zIndex = zIndex === undefined && !state.managed ? Infinity : zIndex;
        state.maxResolution = this.getMaxResolution();
        state.minResolution = Math.max(this.getMinResolution(), 0);
        state.minZoom = this.getMinZoom();
        state.maxZoom = this.getMaxZoom();
        this.state_ = state;
        return state;
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be
   *     modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */ getLayersArray(array) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer
   *     states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */ getLayerStatesArray(states) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
   * will be visible regardless of extent.
   * @return {import("../extent.js").Extent|undefined} The layer extent.
   * @observable
   * @api
   */ getExtent() {
        return /** @type {import("../extent.js").Extent|undefined} */ this.get((0, $lbO8S.default).EXTENT);
    }
    /**
   * Return the maximum resolution of the layer. Returns Infinity if
   * the layer has no maximum resolution set.
   * @return {number} The maximum resolution of the layer.
   * @observable
   * @api
   */ getMaxResolution() {
        return /** @type {number} */ this.get((0, $lbO8S.default).MAX_RESOLUTION);
    }
    /**
   * Return the minimum resolution of the layer. Returns 0 if
   * the layer has no minimum resolution set.
   * @return {number} The minimum resolution of the layer.
   * @observable
   * @api
   */ getMinResolution() {
        return /** @type {number} */ this.get((0, $lbO8S.default).MIN_RESOLUTION);
    }
    /**
   * Return the minimum zoom level of the layer. Returns -Infinity if
   * the layer has no minimum zoom set.
   * @return {number} The minimum zoom level of the layer.
   * @observable
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.get((0, $lbO8S.default).MIN_ZOOM);
    }
    /**
   * Return the maximum zoom level of the layer. Returns Infinity if
   * the layer has no maximum zoom set.
   * @return {number} The maximum zoom level of the layer.
   * @observable
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.get((0, $lbO8S.default).MAX_ZOOM);
    }
    /**
   * Return the opacity of the layer (between 0 and 1).
   * @return {number} The opacity of the layer.
   * @observable
   * @api
   */ getOpacity() {
        return /** @type {number} */ this.get((0, $lbO8S.default).OPACITY);
    }
    /**
   * @abstract
   * @return {import("../source/Source.js").State} Source state.
   */ getSourceState() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Return the value of this layer's `visible` property. To find out whether the layer
   * is visible on a map, use `isVisible()` instead.
   * @return {boolean} The value of the `visible` property of the layer.
   * @observable
   * @api
   */ getVisible() {
        return /** @type {boolean} */ this.get((0, $lbO8S.default).VISIBLE);
    }
    /**
   * Return the Z-index of the layer, which is used to order layers before
   * rendering. Returns undefined if the layer is unmanaged.
   * @return {number|undefined} The Z-index of the layer.
   * @observable
   * @api
   */ getZIndex() {
        return /** @type {number|undefined} */ this.get((0, $lbO8S.default).Z_INDEX);
    }
    /**
   * Sets the background color.
   * @param {BackgroundColor} [background] Background color.
   */ setBackground(background) {
        this.background_ = background;
        this.changed();
    }
    /**
   * Set the extent at which the layer is visible.  If `undefined`, the layer
   * will be visible at all extents.
   * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
   * @observable
   * @api
   */ setExtent(extent) {
        this.set((0, $lbO8S.default).EXTENT, extent);
    }
    /**
   * Set the maximum resolution at which the layer is visible.
   * @param {number} maxResolution The maximum resolution of the layer.
   * @observable
   * @api
   */ setMaxResolution(maxResolution) {
        this.set((0, $lbO8S.default).MAX_RESOLUTION, maxResolution);
    }
    /**
   * Set the minimum resolution at which the layer is visible.
   * @param {number} minResolution The minimum resolution of the layer.
   * @observable
   * @api
   */ setMinResolution(minResolution) {
        this.set((0, $lbO8S.default).MIN_RESOLUTION, minResolution);
    }
    /**
   * Set the maximum zoom (exclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} maxZoom The maximum zoom of the layer.
   * @observable
   * @api
   */ setMaxZoom(maxZoom) {
        this.set((0, $lbO8S.default).MAX_ZOOM, maxZoom);
    }
    /**
   * Set the minimum zoom (inclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} minZoom The minimum zoom of the layer.
   * @observable
   * @api
   */ setMinZoom(minZoom) {
        this.set((0, $lbO8S.default).MIN_ZOOM, minZoom);
    }
    /**
   * Set the opacity of the layer, allowed values range from 0 to 1.
   * @param {number} opacity The opacity of the layer.
   * @observable
   * @api
   */ setOpacity(opacity) {
        (0, $4Cz58.assert)(typeof opacity === 'number', 'Layer opacity must be a number');
        this.set((0, $lbO8S.default).OPACITY, opacity);
    }
    /**
   * Set the visibility of the layer (`true` or `false`).
   * @param {boolean} visible The visibility of the layer.
   * @observable
   * @api
   */ setVisible(visible) {
        this.set((0, $lbO8S.default).VISIBLE, visible);
    }
    /**
   * Set Z-index of the layer, which is used to order layers before rendering.
   * The default Z-index is 0.
   * @param {number} zindex The z-index of the layer.
   * @observable
   * @api
   */ setZIndex(zindex) {
        this.set((0, $lbO8S.default).Z_INDEX, zindex);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.state_) {
            this.state_.layer = null;
            this.state_ = null;
        }
        super.disposeInternal();
    }
}
var $57c5f0299cb9b82f$export$2e2bcd8739ae039 = $57c5f0299cb9b82f$var$BaseLayer;

});
parcelRegister("lbO8S", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6d1853b3fcae320$export$2e2bcd8739ae039);
/**
 * @module ol/layer/Property
 */ /**
 * @enum {string}
 */ var $f6d1853b3fcae320$export$2e2bcd8739ae039 = {
    OPACITY: 'opacity',
    VISIBLE: 'visible',
    EXTENT: 'extent',
    Z_INDEX: 'zIndex',
    MAX_RESOLUTION: 'maxResolution',
    MIN_RESOLUTION: 'minResolution',
    MAX_ZOOM: 'maxZoom',
    MIN_ZOOM: 'minZoom',
    SOURCE: 'source',
    MAP: 'map'
};

});





parcelRegister("cmeSF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ff3151db4300ef9$export$2e2bcd8739ae039);
/**
 * @module ol/source/ImageStatic
 */ 
var $fySoz = parcelRequire("fySoz");

var $3xzSb = parcelRequire("3xzSb");

var $9pD6L = parcelRequire("9pD6L");

var $dpRHA = parcelRequire("dpRHA");

var $lV5T9 = parcelRequire("lV5T9");

var $4yZwx = parcelRequire("4yZwx");
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {import("../extent.js").Extent} imageExtent Extent of the image in map coordinates.
 * This is the [left, bottom, right, top] map coordinates of your image.
 * @property {import("../Image.js").LoadFunction} [imageLoadFunction] Optional function to load an image given a URL.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {string} url Image URL.
 */ /**
 * @classdesc
 * A layer source for displaying a single, static image.
 * @api
 */ class $8ff3151db4300ef9$var$Static extends (0, $lV5T9.default) {
    /**
   * @param {Options} options ImageStatic options.
   */ constructor(options){
        const crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : null;
        const /** @type {import("../Image.js").LoadFunction} */ imageLoadFunction = options.imageLoadFunction !== undefined ? options.imageLoadFunction : (0, $lV5T9.defaultImageLoadFunction);
        super({
            attributions: options.attributions,
            interpolate: options.interpolate,
            projection: (0, $dpRHA.get)(options.projection)
        });
        /**
     * @private
     * @type {string}
     */ this.url_ = options.url;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.imageExtent_ = options.imageExtent;
        /**
     * @private
     * @type {import("../Image.js").default}
     */ this.image = null;
        this.image = new (0, $fySoz.default)(this.imageExtent_, undefined, 1, (0, $4yZwx.createLoader)({
            url: options.url,
            imageExtent: options.imageExtent,
            crossOrigin: crossOrigin,
            referrerPolicy: options.referrerPolicy,
            load: (image, src)=>{
                this.image.setImage(image);
                imageLoadFunction(this.image, src);
                return (0, $fySoz.decode)(image);
            }
        }));
        this.image.addEventListener((0, $3xzSb.default).CHANGE, this.handleImageChange.bind(this));
    }
    /**
   * Returns the image extent
   * @return {import("../extent.js").Extent} image extent.
   * @api
   */ getImageExtent() {
        return this.imageExtent_;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default} Single image.
   * @override
   */ getImageInternal(extent, resolution, pixelRatio, projection) {
        if ((0, $9pD6L.intersects)(extent, this.image.getExtent())) return this.image;
        return null;
    }
    /**
   * Return the URL used for this image source.
   * @return {string} URL.
   * @api
   */ getUrl() {
        return this.url_;
    }
}
var $8ff3151db4300ef9$export$2e2bcd8739ae039 = $8ff3151db4300ef9$var$Static;

});
parcelRegister("fySoz", function(module, exports) {

$parcel$export(module.exports, "listenImage", () => $b54439be79d4619a$export$bc96ecc7c2a50764);
$parcel$export(module.exports, "decodeFallback", () => $b54439be79d4619a$export$a9e5af241c1bd389);
$parcel$export(module.exports, "decode", () => $b54439be79d4619a$export$2f872c0f2117be69);
$parcel$export(module.exports, "default", () => $b54439be79d4619a$export$2e2bcd8739ae039);
/**
 * @module ol/Image
 */ 
var $aSvtr = parcelRequire("aSvtr");

var $3xzSb = parcelRequire("3xzSb");

var $KD0eF = parcelRequire("KD0eF");

var $ilM9F = parcelRequire("ilM9F");

var $6wUzV = parcelRequire("6wUzV");

var $8UoiJ = parcelRequire("8UoiJ");
/**
 * A function that takes an {@link module:ol/Image~ImageWrapper} for the image and a
 * `{string}` for the src as arguments. It is supposed to make it so the
 * underlying image {@link module:ol/Image~ImageWrapper#getImage} is assigned the
 * content specified by the src. If not specified, the default is
 *
 *     function(image, src) {
 *       image.getImage().src = src;
 *     }
 *
 * Providing a custom `imageLoadFunction` can be useful to load images with
 * post requests or - in general - through XHR requests, where the src of the
 * image element would be set to a data URI when the content is loaded.
 *
 * @typedef {function(import("./Image.js").default, string): void} LoadFunction
 * @api
 */ /**
 * @typedef {Object} ImageObject
 * @property {import("./extent.js").Extent} [extent] Extent, if different from the requested one.
 * @property {import("./resolution.js").ResolutionLike} [resolution] Resolution, if different from the requested one.
 * When x and y resolution are different, use the array type (`[xResolution, yResolution]`).
 * @property {number} [pixelRatio] Pixel ratio, if different from the requested one.
 * @property {import('./DataTile.js').ImageLike} image Image.
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * For images that cover any extent and resolution (static images), the loader function should not accept
 * any arguments. The function returns an {@link import("./DataTile.js").ImageLike image}, an
 * {@link import("./Image.js").ImageObject image object}, or a promise for the same.
 * For loaders that generate images, the promise should not resolve until the image is loaded.
 * If the returned image does not match the extent, resolution or pixel ratio passed to the loader,
 * it has to return an {@link import("./Image.js").ImageObject image object} with the `image` and the
 * correct `extent`, `resolution` and `pixelRatio`.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): import("./DataTile.js").ImageLike|ImageObject|Promise<import("./DataTile.js").ImageLike|ImageObject>} Loader
 * @api
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * The function returns a promise for an  {@link import("./Image.js").ImageObject image object}.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): Promise<import("./DataTile.js").ImageLike|ImageObject>} ImageObjectPromiseLoader
 */ class $b54439be79d4619a$var$ImageWrapper extends (0, $KD0eF.default) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number|Array<number>|undefined} resolution Resolution. If provided as array, x and y
   * resolution will be assumed.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("./ImageState.js").default|Loader} stateOrLoader State.
   */ constructor(extent, resolution, pixelRatio, stateOrLoader){
        super();
        /**
     * @protected
     * @type {import("./extent.js").Extent}
     */ this.extent = extent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @protected
     * @type {number|Array<number>|undefined}
     */ this.resolution = resolution;
        /**
     * @protected
     * @type {import("./ImageState.js").default}
     */ this.state = typeof stateOrLoader === 'function' ? (0, $aSvtr.default).IDLE : stateOrLoader;
        /**
     * @private
     * @type {import('./DataTile.js').ImageLike|null}
     */ this.image_ = null;
        /**
     * @protected
     * @type {Loader|null}
     */ this.loader = typeof stateOrLoader === 'function' ? stateOrLoader : null;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, $3xzSb.default).CHANGE);
    }
    /**
   * @return {import("./extent.js").Extent} Extent.
   */ getExtent() {
        return this.extent;
    }
    /**
   * @return {import('./DataTile.js').ImageLike} Image.
   */ getImage() {
        return this.image_;
    }
    /**
   * @return {number} PixelRatio.
   */ getPixelRatio() {
        return this.pixelRatio_;
    }
    /**
   * @return {number|Array<number>} Resolution.
   */ getResolution() {
        return /** @type {number} */ this.resolution;
    }
    /**
   * @return {import("./ImageState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.state == (0, $aSvtr.default).IDLE) {
            if (this.loader) {
                this.state = (0, $aSvtr.default).LOADING;
                this.changed();
                const resolution = this.getResolution();
                const requestResolution = Array.isArray(resolution) ? resolution[0] : resolution;
                (0, $6wUzV.toPromise)(()=>this.loader(this.getExtent(), requestResolution, this.getPixelRatio())).then((image)=>{
                    if ('image' in image) this.image_ = image.image;
                    if ('extent' in image) this.extent = image.extent;
                    if ('resolution' in image) this.resolution = image.resolution;
                    if ('pixelRatio' in image) this.pixelRatio_ = image.pixelRatio;
                    if (image instanceof HTMLImageElement || (0, $8UoiJ.CREATE_IMAGE_BITMAP) && image instanceof ImageBitmap || image instanceof HTMLCanvasElement || image instanceof HTMLVideoElement) this.image_ = image;
                    this.state = (0, $aSvtr.default).LOADED;
                }).catch((error)=>{
                    this.state = (0, $aSvtr.default).ERROR;
                    console.error(error); // eslint-disable-line no-console
                }).finally(()=>this.changed());
            }
        }
    }
    /**
   * @param {import('./DataTile.js').ImageLike} image The image.
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * @param {number|Array<number>} resolution Resolution.
   */ setResolution(resolution) {
        this.resolution = resolution;
    }
}
function $b54439be79d4619a$export$bc96ecc7c2a50764(image, loadHandler, errorHandler) {
    const img = /** @type {HTMLImageElement} */ image;
    let listening = true;
    let decoding = false;
    let loaded = false;
    const listenerKeys = [
        (0, $ilM9F.listenOnce)(img, (0, $3xzSb.default).LOAD, function() {
            loaded = true;
            if (!decoding) loadHandler();
        })
    ];
    if (img.src && (0, $8UoiJ.IMAGE_DECODE)) {
        decoding = true;
        img.decode().then(function() {
            if (listening) loadHandler();
        }).catch(function(error) {
            if (listening) {
                if (loaded) loadHandler();
                else errorHandler();
            }
        });
    } else listenerKeys.push((0, $ilM9F.listenOnce)(img, (0, $3xzSb.default).ERROR, errorHandler));
    return function unlisten() {
        listening = false;
        listenerKeys.forEach((0, $ilM9F.unlistenByKey));
    };
}
function $b54439be79d4619a$export$11e63f7b0f3d9900(image, src) {
    return new Promise((resolve, reject)=>{
        function handleLoad() {
            unlisten();
            resolve(image);
        }
        function handleError() {
            unlisten();
            reject(new Error('Image load error'));
        }
        function unlisten() {
            image.removeEventListener('load', handleLoad);
            image.removeEventListener('error', handleError);
        }
        image.addEventListener('load', handleLoad);
        image.addEventListener('error', handleError);
        if (src) image.src = src;
    });
}
function $b54439be79d4619a$export$a9e5af241c1bd389(image, src) {
    if (src) image.src = src;
    return image.src && (0, $8UoiJ.IMAGE_DECODE) ? new Promise((resolve, reject)=>image.decode().then(()=>resolve(image)).catch((e)=>image.complete && image.width ? resolve(image) : reject(e))) : $b54439be79d4619a$export$11e63f7b0f3d9900(image);
}
function $b54439be79d4619a$export$2f872c0f2117be69(image, src) {
    if (src) image.src = src;
    return image.src && (0, $8UoiJ.IMAGE_DECODE) && (0, $8UoiJ.CREATE_IMAGE_BITMAP) ? image.decode().then(()=>createImageBitmap(image)).catch((e)=>{
        if (image.complete && image.width) return image;
        throw e;
    }) : $b54439be79d4619a$export$a9e5af241c1bd389(image);
}
var $b54439be79d4619a$export$2e2bcd8739ae039 = $b54439be79d4619a$var$ImageWrapper;

});

parcelRegister("lV5T9", function(module, exports) {

$parcel$export(module.exports, "defaultImageLoadFunction", () => $ff537d321d4e1584$export$584f102f75ff44b3);
$parcel$export(module.exports, "default", () => $ff537d321d4e1584$export$2e2bcd8739ae039);
/**
 * @module ol/source/Image
 */ 
var $fySoz = parcelRequire("fySoz");

var $aSvtr = parcelRequire("aSvtr");

var $fVVyM = parcelRequire("fVVyM");

var $f18Q2 = parcelRequire("f18Q2");

var $3xzSb = parcelRequire("3xzSb");

var $9pD6L = parcelRequire("9pD6L");

var $9byFX = parcelRequire("9byFX");

var $dpRHA = parcelRequire("dpRHA");

var $2X6Sz = parcelRequire("2X6Sz");

var $3xAgz = parcelRequire("3xAgz");

var $knPlK = parcelRequire("knPlK");

var $2yHbn = parcelRequire("2yHbn");
const $ff537d321d4e1584$export$4e0f6da20e5dcc4f = {
    /**
   * Triggered when an image starts loading.
   * @event module:ol/source/Image.ImageSourceEvent#imageloadstart
   * @api
   */ IMAGELOADSTART: 'imageloadstart',
    /**
   * Triggered when an image finishes loading.
   * @event module:ol/source/Image.ImageSourceEvent#imageloadend
   * @api
   */ IMAGELOADEND: 'imageloadend',
    /**
   * Triggered if image loading results in an error.
   * @event module:ol/source/Image.ImageSourceEvent#imageloaderror
   * @api
   */ IMAGELOADERROR: 'imageloaderror'
};
class $ff537d321d4e1584$export$58d3276cd83daede extends (0, $f18Q2.default) {
    /**
   * @param {string} type Type.
   * @param {import("../Image.js").default} image The image.
   */ constructor(type, image){
        super(type);
        /**
     * The image related to the event.
     * @type {import("../Image.js").default}
     * @api
     */ this.image = image;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<ImageSourceEventTypes, ImageSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types
 *     |ImageSourceEventTypes, Return>} ImageSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../Image.js").Loader} [loader] Loader. Can either be a custom loader, or one of the
 * loaders created with a `createLoader()` function ({@link module:ol/source/wms.createLoader wms},
 * {@link module:ol/source/arcgisRest.createLoader arcgisRest}, {@link module:ol/source/mapguide.createLoader mapguide},
 * {@link module:ol/source/static.createLoader static}).
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {Array<number>} [resolutions] Resolutions.
 * @property {import("./Source.js").State} [state] State.
 */ /**
 * @classdesc
 * Base class for sources providing a single image.
 * @fires module:ol/source/Image.ImageSourceEvent
 * @api
 */ class $ff537d321d4e1584$var$ImageSource extends (0, $knPlK.default) {
    /**
   * @param {Options} options Single image source options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            projection: options.projection,
            state: options.state,
            interpolate: options.interpolate !== undefined ? options.interpolate : true
        });
        /***
     * @type {ImageSourceOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {ImageSourceOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {ImageSourceOnSignature<void>}
     */ this.un;
        /**
     * @protected
     * @type {import("../Image.js").Loader}
     */ this.loader = options.loader || null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.resolutions_ = options.resolutions !== undefined ? options.resolutions : null;
        /**
     * @private
     * @type {import("../reproj/Image.js").default}
     */ this.reprojectedImage_ = null;
        /**
     * @private
     * @type {number}
     */ this.reprojectedRevision_ = 0;
        /**
     * @protected
     * @type {import("../Image.js").default}
     */ this.image = null;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.wantedExtent_;
        /**
     * @private
     * @type {number}
     */ this.wantedResolution_;
        /**
     * @private
     * @type {boolean}
     */ this.static_ = options.loader ? options.loader.length === 0 : false;
        /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */ this.wantedProjection_ = null;
    }
    /**
   * @return {Array<number>|null} Resolutions.
   * @override
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * @param {Array<number>|null} resolutions Resolutions.
   */ setResolutions(resolutions) {
        this.resolutions_ = resolutions;
    }
    /**
   * @protected
   * @param {number} resolution Resolution.
   * @return {number} Resolution.
   */ findNearestResolution(resolution) {
        const resolutions = this.getResolutions();
        if (resolutions) {
            const idx = (0, $fVVyM.linearFindNearest)(resolutions, resolution, 0);
            resolution = resolutions[idx];
        }
        return resolution;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default} Single image.
   */ getImage(extent, resolution, pixelRatio, projection) {
        const sourceProjection = this.getProjection();
        if (!sourceProjection || !projection || (0, $dpRHA.equivalent)(sourceProjection, projection)) {
            if (sourceProjection) projection = sourceProjection;
            return this.getImageInternal(extent, resolution, pixelRatio, projection);
        }
        if (this.reprojectedImage_) {
            if (this.reprojectedRevision_ == this.getRevision() && (0, $dpRHA.equivalent)(this.reprojectedImage_.getProjection(), projection) && this.reprojectedImage_.getResolution() == resolution && (0, $9pD6L.equals)(this.reprojectedImage_.getExtent(), extent)) return this.reprojectedImage_;
            this.reprojectedImage_.dispose();
            this.reprojectedImage_ = null;
        }
        this.reprojectedImage_ = new (0, $2X6Sz.default)(sourceProjection, projection, extent, resolution, pixelRatio, (extent, resolution, pixelRatio)=>this.getImageInternal(extent, resolution, pixelRatio, sourceProjection), this.getInterpolate());
        this.reprojectedRevision_ = this.getRevision();
        return this.reprojectedImage_;
    }
    /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default} Single image.
   * @protected
   */ getImageInternal(extent, resolution, pixelRatio, projection) {
        if (this.loader) {
            const requestExtent = $ff537d321d4e1584$export$2a9dcc8f63da1787(extent, resolution, pixelRatio, 1);
            const requestResolution = this.findNearestResolution(resolution);
            if (this.image && (this.static_ || this.wantedProjection_ === projection && (this.wantedExtent_ && (0, $9pD6L.containsExtent)(this.wantedExtent_, requestExtent) || (0, $9pD6L.containsExtent)(this.image.getExtent(), requestExtent)) && (this.wantedResolution_ && (0, $3xAgz.fromResolutionLike)(this.wantedResolution_) === requestResolution || (0, $3xAgz.fromResolutionLike)(this.image.getResolution()) === requestResolution))) return this.image;
            this.wantedProjection_ = projection;
            this.wantedExtent_ = requestExtent;
            this.wantedResolution_ = requestResolution;
            this.image = new (0, $fySoz.default)(requestExtent, requestResolution, pixelRatio, this.loader);
            this.image.addEventListener((0, $3xzSb.default).CHANGE, this.handleImageChange.bind(this));
        }
        return this.image;
    }
    /**
   * Handle image change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ handleImageChange(event) {
        const image = /** @type {import("../Image.js").default} */ event.target;
        let type;
        switch(image.getState()){
            case (0, $aSvtr.default).LOADING:
                this.loading = true;
                type = $ff537d321d4e1584$export$4e0f6da20e5dcc4f.IMAGELOADSTART;
                break;
            case (0, $aSvtr.default).LOADED:
                this.loading = false;
                type = $ff537d321d4e1584$export$4e0f6da20e5dcc4f.IMAGELOADEND;
                break;
            case (0, $aSvtr.default).ERROR:
                this.loading = false;
                type = $ff537d321d4e1584$export$4e0f6da20e5dcc4f.IMAGELOADERROR;
                break;
            default:
                return;
        }
        if (this.hasListener(type)) this.dispatchEvent(new $ff537d321d4e1584$export$58d3276cd83daede(type, image));
    }
}
function $ff537d321d4e1584$export$584f102f75ff44b3(image, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ image.getImage().src = src;
}
function $ff537d321d4e1584$export$2a9dcc8f63da1787(extent, resolution, pixelRatio, ratio) {
    const imageResolution = resolution / pixelRatio;
    const center = (0, $9pD6L.getCenter)(extent);
    const viewWidth = (0, $9byFX.ceil)((0, $9pD6L.getWidth)(extent) / imageResolution, (0, $2yHbn.DECIMALS));
    const viewHeight = (0, $9byFX.ceil)((0, $9pD6L.getHeight)(extent) / imageResolution, (0, $2yHbn.DECIMALS));
    const marginWidth = (0, $9byFX.ceil)((ratio - 1) * viewWidth / 2, (0, $2yHbn.DECIMALS));
    const requestWidth = viewWidth + 2 * marginWidth;
    const marginHeight = (0, $9byFX.ceil)((ratio - 1) * viewHeight / 2, (0, $2yHbn.DECIMALS));
    const requestHeight = viewHeight + 2 * marginHeight;
    return (0, $9pD6L.getForViewAndSize)(center, imageResolution, 0, [
        requestWidth,
        requestHeight
    ]);
}
var $ff537d321d4e1584$export$2e2bcd8739ae039 = $ff537d321d4e1584$var$ImageSource;

});
parcelRegister("2X6Sz", function(module, exports) {

$parcel$export(module.exports, "default", () => $22666d8766dd8ace$export$2e2bcd8739ae039);
/**
 * @module ol/reproj/Image
 */ 
var $fySoz = parcelRequire("fySoz");

var $aSvtr = parcelRequire("aSvtr");

var $3xzSb = parcelRequire("3xzSb");

var $ilM9F = parcelRequire("ilM9F");

var $9pD6L = parcelRequire("9pD6L");

var $3H62b = parcelRequire("3H62b");

var $3xAgz = parcelRequire("3xAgz");

var $9gka6 = parcelRequire("9gka6");

var $cfilv = parcelRequire("cfilv");
/**
 * @typedef {function(import("../extent.js").Extent, number, number) : import("../Image.js").default} FunctionType
 */ /**
 * @classdesc
 * Class encapsulating single reprojected image.
 * See {@link module:ol/source/Image~ImageSource}.
 */ class $22666d8766dd8ace$var$ReprojImage extends (0, $fySoz.default) {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection (of the data).
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent.
   * @param {number} targetResolution Target resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {FunctionType} getImageFunction
   *     Function returning source images (extent, resolution, pixelRatio).
   * @param {boolean} interpolate Use linear interpolation when resampling.
   */ constructor(sourceProj, targetProj, targetExtent, targetResolution, pixelRatio, getImageFunction, interpolate){
        let maxSourceExtent = sourceProj.getExtent();
        if (maxSourceExtent && sourceProj.canWrapX()) {
            maxSourceExtent = maxSourceExtent.slice();
            maxSourceExtent[0] = -Infinity;
            maxSourceExtent[2] = Infinity;
        }
        let maxTargetExtent = targetProj.getExtent();
        if (maxTargetExtent && targetProj.canWrapX()) {
            maxTargetExtent = maxTargetExtent.slice();
            maxTargetExtent[0] = -Infinity;
            maxTargetExtent[2] = Infinity;
        }
        const limitedTargetExtent = maxTargetExtent ? (0, $9pD6L.getIntersection)(targetExtent, maxTargetExtent) : targetExtent;
        const targetCenter = (0, $9pD6L.getCenter)(limitedTargetExtent);
        const sourceResolution = (0, $3H62b.calculateSourceResolution)(sourceProj, targetProj, targetCenter, targetResolution);
        const errorThresholdInPixels = (0, $cfilv.ERROR_THRESHOLD);
        const triangulation = new (0, $9gka6.default)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        const sourceExtent = triangulation.calculateSourceExtent();
        const sourceImage = (0, $9pD6L.isEmpty)(sourceExtent) ? null : getImageFunction(sourceExtent, sourceResolution, pixelRatio);
        const state = sourceImage ? (0, $aSvtr.default).IDLE : (0, $aSvtr.default).EMPTY;
        const sourcePixelRatio = sourceImage ? sourceImage.getPixelRatio() : 1;
        super(targetExtent, targetResolution, sourcePixelRatio, state);
        /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */ this.targetProj_ = targetProj;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.maxSourceExtent_ = maxSourceExtent;
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = triangulation;
        /**
     * @private
     * @type {number}
     */ this.targetResolution_ = targetResolution;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.targetExtent_ = targetExtent;
        /**
     * @private
     * @type {import("../Image.js").default}
     */ this.sourceImage_ = sourceImage;
        /**
     * @private
     * @type {number}
     */ this.sourcePixelRatio_ = sourcePixelRatio;
        /**
     * @private
     * @type {boolean}
     */ this.interpolate_ = interpolate;
        /**
     * @private
     * @type {HTMLCanvasElement|OffscreenCanvas}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.sourceListenerKey_ = null;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.state == (0, $aSvtr.default).LOADING) this.unlistenSource_();
        super.disposeInternal();
    }
    /**
   * @return {HTMLCanvasElement|OffscreenCanvas} Image.
   * @override
   */ getImage() {
        return this.canvas_;
    }
    /**
   * @return {import("../proj/Projection.js").default} Projection.
   */ getProjection() {
        return this.targetProj_;
    }
    /**
   * @private
   */ reproject_() {
        const sourceState = this.sourceImage_.getState();
        if (sourceState == (0, $aSvtr.default).LOADED) {
            const width = (0, $9pD6L.getWidth)(this.targetExtent_) / this.targetResolution_;
            const height = (0, $9pD6L.getHeight)(this.targetExtent_) / this.targetResolution_;
            this.canvas_ = (0, $3H62b.render)(width, height, this.sourcePixelRatio_, (0, $3xAgz.fromResolutionLike)(this.sourceImage_.getResolution()), this.maxSourceExtent_, this.targetResolution_, this.targetExtent_, this.triangulation_, [
                {
                    extent: this.sourceImage_.getExtent(),
                    image: this.sourceImage_.getImage()
                }
            ], 0, undefined, this.interpolate_, true);
        }
        this.state = sourceState;
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {
        if (this.state == (0, $aSvtr.default).IDLE) {
            this.state = (0, $aSvtr.default).LOADING;
            this.changed();
            const sourceState = this.sourceImage_.getState();
            if (sourceState == (0, $aSvtr.default).LOADED || sourceState == (0, $aSvtr.default).ERROR) this.reproject_();
            else {
                this.sourceListenerKey_ = (0, $ilM9F.listen)(this.sourceImage_, (0, $3xzSb.default).CHANGE, (e)=>{
                    const sourceState = this.sourceImage_.getState();
                    if (sourceState == (0, $aSvtr.default).LOADED || sourceState == (0, $aSvtr.default).ERROR) {
                        this.unlistenSource_();
                        this.reproject_();
                    }
                });
                this.sourceImage_.load();
            }
        }
    }
    /**
   * @private
   */ unlistenSource_() {
        (0, $ilM9F.unlistenByKey)(/** @type {!import("../events.js").EventsKey} */ this.sourceListenerKey_);
        this.sourceListenerKey_ = null;
    }
}
var $22666d8766dd8ace$export$2e2bcd8739ae039 = $22666d8766dd8ace$var$ReprojImage;

});
parcelRegister("3H62b", function(module, exports) {

$parcel$export(module.exports, "canvasPool", () => $2b0a118af78fb031$export$a166f0857c555517);
$parcel$export(module.exports, "calculateSourceResolution", () => $2b0a118af78fb031$export$5fbb958059b7e71f);
$parcel$export(module.exports, "calculateSourceExtentResolution", () => $2b0a118af78fb031$export$16d356211d01f1cc);
$parcel$export(module.exports, "render", () => $2b0a118af78fb031$export$b3890eb0ae9dca99);
/**
 * @module ol/reproj
 */ 
var $DfnQm = parcelRequire("DfnQm");

var $9pD6L = parcelRequire("9pD6L");

var $9byFX = parcelRequire("9byFX");

var $dpRHA = parcelRequire("dpRHA");
let $2b0a118af78fb031$var$brokenDiagonalRendering_;
const $2b0a118af78fb031$export$a166f0857c555517 = [];
/**
 * This draws a small triangle into a canvas by setting the triangle as the clip region
 * and then drawing a (too large) rectangle
 *
 * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} ctx The context in which to draw the triangle
 * @param {number} u1 The x-coordinate of the second point. The first point is 0,0.
 * @param {number} v1 The y-coordinate of the second point.
 * @param {number} u2 The x-coordinate of the third point.
 * @param {number} v2 The y-coordinate of the third point.
 */ function $2b0a118af78fb031$var$drawTestTriangle(ctx, u1, v1, u2, v2) {
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(u1, v1);
    ctx.lineTo(u2, v2);
    ctx.closePath();
    ctx.save();
    ctx.clip();
    ctx.fillRect(0, 0, Math.max(u1, u2) + 1, Math.max(v1, v2));
    ctx.restore();
}
/**
 * Given the data from getImageData, see if the right values appear at the provided offset.
 * Returns true if either the color or transparency is off
 *
 * @param {Uint8ClampedArray} data The data returned from getImageData
 * @param {number} offset The pixel offset from the start of data.
 * @return {boolean} true if the diagonal rendering is broken
 */ function $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, offset) {
    // the values ought to be close to the rgba(210, 0, 0, 0.75)
    return Math.abs(data[offset * 4] - 210) > 2 || Math.abs(data[offset * 4 + 3] - 191.25) > 2;
}
/**
 * Determines if the current browser configuration can render triangular clip regions correctly.
 * This value is cached so the function is only expensive the first time called.
 * Firefox on Windows (as of now) does not if HWA is enabled. See https://bugzilla.mozilla.org/show_bug.cgi?id=1606976
 * Chrome works, and everything seems to work on OSX and Android. This function caches the
 * result. I suppose that it is conceivably possible that a browser might flip modes while the app is
 * running, but lets hope not.
 *
 * @return {boolean} true if the Diagonal Rendering is broken.
 */ function $2b0a118af78fb031$var$isBrokenDiagonalRendering() {
    if ($2b0a118af78fb031$var$brokenDiagonalRendering_ === undefined) {
        const ctx = (0, $DfnQm.createCanvasContext2D)(6, 6, $2b0a118af78fb031$export$a166f0857c555517);
        ctx.globalCompositeOperation = 'lighter';
        ctx.fillStyle = 'rgba(210, 0, 0, 0.75)';
        $2b0a118af78fb031$var$drawTestTriangle(ctx, 4, 5, 4, 0);
        $2b0a118af78fb031$var$drawTestTriangle(ctx, 4, 5, 0, 5);
        const data = ctx.getImageData(0, 0, 3, 3).data;
        $2b0a118af78fb031$var$brokenDiagonalRendering_ = $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, 0) || $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, 4) || $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, 8);
        (0, $DfnQm.releaseCanvas)(ctx);
        $2b0a118af78fb031$export$a166f0857c555517.push(ctx.canvas);
    }
    return $2b0a118af78fb031$var$brokenDiagonalRendering_;
}
function $2b0a118af78fb031$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution) {
    const sourceCenter = (0, $dpRHA.transform)(targetCenter, targetProj, sourceProj);
    // calculate the ideal resolution of the source data
    let sourceResolution = (0, $dpRHA.getPointResolution)(targetProj, targetResolution, targetCenter);
    const targetMetersPerUnit = targetProj.getMetersPerUnit();
    if (targetMetersPerUnit !== undefined) sourceResolution *= targetMetersPerUnit;
    const sourceMetersPerUnit = sourceProj.getMetersPerUnit();
    if (sourceMetersPerUnit !== undefined) sourceResolution /= sourceMetersPerUnit;
    // Based on the projection properties, the point resolution at the specified
    // coordinates may be slightly different. We need to reverse-compensate this
    // in order to achieve optimal results.
    const sourceExtent = sourceProj.getExtent();
    if (!sourceExtent || (0, $9pD6L.containsCoordinate)(sourceExtent, sourceCenter)) {
        const compensationFactor = (0, $dpRHA.getPointResolution)(sourceProj, sourceResolution, sourceCenter) / sourceResolution;
        if (isFinite(compensationFactor) && compensationFactor > 0) sourceResolution /= compensationFactor;
    }
    return sourceResolution;
}
function $2b0a118af78fb031$export$16d356211d01f1cc(sourceProj, targetProj, targetExtent, targetResolution) {
    const targetCenter = (0, $9pD6L.getCenter)(targetExtent);
    let sourceResolution = $2b0a118af78fb031$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution);
    if (!isFinite(sourceResolution) || sourceResolution <= 0) (0, $9pD6L.forEachCorner)(targetExtent, function(corner) {
        sourceResolution = $2b0a118af78fb031$export$5fbb958059b7e71f(sourceProj, targetProj, corner, targetResolution);
        return isFinite(sourceResolution) && sourceResolution > 0;
    });
    return sourceResolution;
}
function $2b0a118af78fb031$export$b3890eb0ae9dca99(width, height, pixelRatio, sourceResolution, sourceExtent, targetResolution, targetExtent, triangulation, sources, gutter, renderEdges, interpolate, drawSingle, clipExtent) {
    const context = (0, $DfnQm.createCanvasContext2D)(Math.round(pixelRatio * width), Math.round(pixelRatio * height), $2b0a118af78fb031$export$a166f0857c555517);
    if (!interpolate) context.imageSmoothingEnabled = false;
    if (sources.length === 0) return context.canvas;
    context.scale(pixelRatio, pixelRatio);
    function pixelRound(value) {
        return Math.round(value * pixelRatio) / pixelRatio;
    }
    context.globalCompositeOperation = 'lighter';
    const sourceDataExtent = (0, $9pD6L.createEmpty)();
    sources.forEach(function(src, i, arr) {
        (0, $9pD6L.extend)(sourceDataExtent, src.extent);
    });
    let stitchContext;
    const stitchScale = pixelRatio / sourceResolution;
    // Round up Float32 scale values to prevent interpolation in Firefox.
    const inverseScale = (interpolate ? 1 : 1 + Math.pow(2, -24)) / stitchScale;
    if (!drawSingle || sources.length !== 1 || gutter !== 0) {
        stitchContext = (0, $DfnQm.createCanvasContext2D)(Math.round((0, $9pD6L.getWidth)(sourceDataExtent) * stitchScale), Math.round((0, $9pD6L.getHeight)(sourceDataExtent) * stitchScale), $2b0a118af78fb031$export$a166f0857c555517);
        if (!interpolate) stitchContext.imageSmoothingEnabled = false;
        if (sourceExtent && clipExtent) {
            const xPos = (sourceExtent[0] - sourceDataExtent[0]) * stitchScale;
            const yPos = -(sourceExtent[3] - sourceDataExtent[3]) * stitchScale;
            const width = (0, $9pD6L.getWidth)(sourceExtent) * stitchScale;
            const height = (0, $9pD6L.getHeight)(sourceExtent) * stitchScale;
            stitchContext.rect(xPos, yPos, width, height);
            stitchContext.clip();
        }
        sources.forEach(function(src, i, arr) {
            // This test should never fail -- but it does. Need to find a fix the upstream condition
            if (src.image.width > 0 && src.image.height > 0) {
                if (src.clipExtent) {
                    stitchContext.save();
                    const xPos = (src.clipExtent[0] - sourceDataExtent[0]) * stitchScale;
                    const yPos = -(src.clipExtent[3] - sourceDataExtent[3]) * stitchScale;
                    const width = (0, $9pD6L.getWidth)(src.clipExtent) * stitchScale;
                    const height = (0, $9pD6L.getHeight)(src.clipExtent) * stitchScale;
                    stitchContext.rect(interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? width : Math.round(xPos + width) - Math.round(xPos), interpolate ? height : Math.round(yPos + height) - Math.round(yPos));
                    stitchContext.clip();
                }
                const xPos = (src.extent[0] - sourceDataExtent[0]) * stitchScale;
                const yPos = -(src.extent[3] - sourceDataExtent[3]) * stitchScale;
                const srcWidth = (0, $9pD6L.getWidth)(src.extent) * stitchScale;
                const srcHeight = (0, $9pD6L.getHeight)(src.extent) * stitchScale;
                stitchContext.drawImage(src.image, gutter, gutter, src.image.width - 2 * gutter, src.image.height - 2 * gutter, interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? srcWidth : Math.round(xPos + srcWidth) - Math.round(xPos), interpolate ? srcHeight : Math.round(yPos + srcHeight) - Math.round(yPos));
                if (src.clipExtent) stitchContext.restore();
            }
        });
    }
    const targetTopLeft = (0, $9pD6L.getTopLeft)(targetExtent);
    triangulation.getTriangles().forEach(function(triangle, i, arr) {
        /* Calculate affine transform (src -> dst)
     * Resulting matrix can be used to transform coordinate
     * from `sourceProjection` to destination pixels.
     *
     * To optimize number of context calls and increase numerical stability,
     * we also do the following operations:
     * trans(-topLeftExtentCorner), scale(1 / targetResolution), scale(1, -1)
     * here before solving the linear system so [ui, vi] are pixel coordinates.
     *
     * Src points: xi, yi
     * Dst points: ui, vi
     * Affine coefficients: aij
     *
     * | x0 y0 1  0  0 0 |   |a00|   |u0|
     * | x1 y1 1  0  0 0 |   |a01|   |u1|
     * | x2 y2 1  0  0 0 | x |a02| = |u2|
     * |  0  0 0 x0 y0 1 |   |a10|   |v0|
     * |  0  0 0 x1 y1 1 |   |a11|   |v1|
     * |  0  0 0 x2 y2 1 |   |a12|   |v2|
     */ const source = triangle.source;
        const target = triangle.target;
        let x0 = source[0][0], y0 = source[0][1];
        let x1 = source[1][0], y1 = source[1][1];
        let x2 = source[2][0], y2 = source[2][1];
        // Make sure that everything is on pixel boundaries
        const u0 = pixelRound((target[0][0] - targetTopLeft[0]) / targetResolution);
        const v0 = pixelRound(-(target[0][1] - targetTopLeft[1]) / targetResolution);
        const u1 = pixelRound((target[1][0] - targetTopLeft[0]) / targetResolution);
        const v1 = pixelRound(-(target[1][1] - targetTopLeft[1]) / targetResolution);
        const u2 = pixelRound((target[2][0] - targetTopLeft[0]) / targetResolution);
        const v2 = pixelRound(-(target[2][1] - targetTopLeft[1]) / targetResolution);
        // Shift all the source points to improve numerical stability
        // of all the subsequent calculations. The [x0, y0] is used here.
        // This is also used to simplify the linear system.
        const sourceNumericalShiftX = x0;
        const sourceNumericalShiftY = y0;
        x0 = 0;
        y0 = 0;
        x1 -= sourceNumericalShiftX;
        y1 -= sourceNumericalShiftY;
        x2 -= sourceNumericalShiftX;
        y2 -= sourceNumericalShiftY;
        const augmentedMatrix = [
            [
                x1,
                y1,
                0,
                0,
                u1 - u0
            ],
            [
                x2,
                y2,
                0,
                0,
                u2 - u0
            ],
            [
                0,
                0,
                x1,
                y1,
                v1 - v0
            ],
            [
                0,
                0,
                x2,
                y2,
                v2 - v0
            ]
        ];
        const affineCoefs = (0, $9byFX.solveLinearSystem)(augmentedMatrix);
        if (!affineCoefs) return;
        context.save();
        context.beginPath();
        if ($2b0a118af78fb031$var$isBrokenDiagonalRendering() || !interpolate) {
            // Make sure that all lines are horizontal or vertical
            context.moveTo(u1, v1);
            // This is the diagonal line. Do it in 4 steps
            const steps = 4;
            const ud = u0 - u1;
            const vd = v0 - v1;
            for(let step = 0; step < steps; step++){
                // Go horizontally
                context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound(step * vd / (steps - 1)));
                // Go vertically
                if (step != steps - 1) context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound((step + 1) * vd / (steps - 1)));
            }
            // We are almost at u0r, v0r
            context.lineTo(u2, v2);
        } else {
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
        }
        context.clip();
        context.transform(affineCoefs[0], affineCoefs[2], affineCoefs[1], affineCoefs[3], u0, v0);
        context.translate(sourceDataExtent[0] - sourceNumericalShiftX, sourceDataExtent[3] - sourceNumericalShiftY);
        let image;
        if (stitchContext) {
            image = stitchContext.canvas;
            context.scale(inverseScale, -inverseScale);
        } else {
            const source = sources[0];
            const extent = source.extent;
            image = source.image;
            context.scale((0, $9pD6L.getWidth)(extent) / image.width, -(0, $9pD6L.getHeight)(extent) / image.height);
        }
        context.drawImage(image, 0, 0);
        context.restore();
    });
    if (stitchContext) {
        (0, $DfnQm.releaseCanvas)(stitchContext);
        $2b0a118af78fb031$export$a166f0857c555517.push(stitchContext.canvas);
    }
    if (renderEdges) {
        context.save();
        context.globalCompositeOperation = 'source-over';
        context.strokeStyle = 'black';
        context.lineWidth = 1;
        triangulation.getTriangles().forEach(function(triangle, i, arr) {
            const target = triangle.target;
            const u0 = (target[0][0] - targetTopLeft[0]) / targetResolution;
            const v0 = -(target[0][1] - targetTopLeft[1]) / targetResolution;
            const u1 = (target[1][0] - targetTopLeft[0]) / targetResolution;
            const v1 = -(target[1][1] - targetTopLeft[1]) / targetResolution;
            const u2 = (target[2][0] - targetTopLeft[0]) / targetResolution;
            const v2 = -(target[2][1] - targetTopLeft[1]) / targetResolution;
            context.beginPath();
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
            context.closePath();
            context.stroke();
        });
        context.restore();
    }
    return context.canvas;
}

});

parcelRegister("3xAgz", function(module, exports) {

$parcel$export(module.exports, "fromResolutionLike", () => $294095e38e30fd4e$export$bc4231bf34bfa9ad);
/**
 * @module ol/resolution
 */ /**
 * @typedef {number|Array<number>} ResolutionLike
 */ /**
 * @param {ResolutionLike} resolution Resolution.
 * @return {number} Resolution.
 */ function $294095e38e30fd4e$export$bc4231bf34bfa9ad(resolution) {
    if (Array.isArray(resolution)) return Math.min(...resolution);
    return resolution;
}

});

parcelRegister("9gka6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6be53f6edfbf1854$export$2e2bcd8739ae039);
/**
 * @module ol/reproj/Triangulation
 */ 
var $9pD6L = parcelRequire("9pD6L");

var $9byFX = parcelRequire("9byFX");

var $dpRHA = parcelRequire("dpRHA");

var $jpXrt = parcelRequire("jpXrt");
/**
 * Single triangle; consists of 3 source points and 3 target points.
 * @typedef {Object} Triangle
 * @property {Array<import("../coordinate.js").Coordinate>} source Source.
 * @property {Array<import("../coordinate.js").Coordinate>} target Target.
 */ /**
 * Maximum number of subdivision steps during raster reprojection triangulation.
 * Prevents high memory usage and large number of proj4 calls (for certain
 * transformations and areas). At most `2*(2^this)` triangles are created for
 * each triangulated extent (tile/image).
 * @type {number}
 */ const $6be53f6edfbf1854$var$MAX_SUBDIVISION = 10;
/**
 * Maximum allowed size of triangle relative to world width. When transforming
 * corners of world extent between certain projections, the resulting
 * triangulation seems to have zero error and no subdivision is performed. If
 * the triangle width is more than this (relative to world width; 0-1),
 * subdivison is forced (up to `MAX_SUBDIVISION`). Default is `0.25`.
 * @type {number}
 */ const $6be53f6edfbf1854$var$MAX_TRIANGLE_WIDTH = 0.25;
/**
 * @classdesc
 * Class containing triangulation of the given target extent.
 * Used for determining source data and the reprojection itself.
 */ class $6be53f6edfbf1854$var$Triangulation {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent to triangulate.
   * @param {import("../extent.js").Extent} maxSourceExtent Maximal source extent that can be used.
   * @param {number} errorThreshold Acceptable error (in source units).
   * @param {?number} destinationResolution The (optional) resolution of the destination.
   * @param {import("../transform.js").Transform} [sourceMatrix] Source transform matrix.
   */ constructor(sourceProj, targetProj, targetExtent, maxSourceExtent, errorThreshold, destinationResolution, sourceMatrix){
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.sourceProj_ = sourceProj;
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.targetProj_ = targetProj;
        /** @type {!Object<string, import("../coordinate.js").Coordinate>} */ let transformInvCache = {};
        const transformInv = sourceMatrix ? (0, $dpRHA.createTransformFromCoordinateTransform)((input)=>(0, $jpXrt.apply)(sourceMatrix, (0, $dpRHA.transform)(input, this.targetProj_, this.sourceProj_))) : (0, $dpRHA.getTransform)(this.targetProj_, this.sourceProj_);
        /**
     * @param {import("../coordinate.js").Coordinate} c A coordinate.
     * @return {import("../coordinate.js").Coordinate} Transformed coordinate.
     * @private
     */ this.transformInv_ = function(c) {
            const key = c[0] + '/' + c[1];
            if (!transformInvCache[key]) transformInvCache[key] = transformInv(c);
            return transformInvCache[key];
        };
        /**
     * @type {import("../extent.js").Extent}
     * @private
     */ this.maxSourceExtent_ = maxSourceExtent;
        /**
     * @type {number}
     * @private
     */ this.errorThresholdSquared_ = errorThreshold * errorThreshold;
        /**
     * @type {Array<Triangle>}
     * @private
     */ this.triangles_ = [];
        /**
     * Indicates that the triangulation crosses edge of the source projection.
     * @type {boolean}
     * @private
     */ this.wrapsXInSource_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.canWrapXInSource_ = this.sourceProj_.canWrapX() && !!maxSourceExtent && !!this.sourceProj_.getExtent() && (0, $9pD6L.getWidth)(maxSourceExtent) >= (0, $9pD6L.getWidth)(this.sourceProj_.getExtent());
        /**
     * @type {?number}
     * @private
     */ this.sourceWorldWidth_ = this.sourceProj_.getExtent() ? (0, $9pD6L.getWidth)(this.sourceProj_.getExtent()) : null;
        /**
     * @type {?number}
     * @private
     */ this.targetWorldWidth_ = this.targetProj_.getExtent() ? (0, $9pD6L.getWidth)(this.targetProj_.getExtent()) : null;
        const destinationTopLeft = (0, $9pD6L.getTopLeft)(targetExtent);
        const destinationTopRight = (0, $9pD6L.getTopRight)(targetExtent);
        const destinationBottomRight = (0, $9pD6L.getBottomRight)(targetExtent);
        const destinationBottomLeft = (0, $9pD6L.getBottomLeft)(targetExtent);
        const sourceTopLeft = this.transformInv_(destinationTopLeft);
        const sourceTopRight = this.transformInv_(destinationTopRight);
        const sourceBottomRight = this.transformInv_(destinationBottomRight);
        const sourceBottomLeft = this.transformInv_(destinationBottomLeft);
        /*
     * The maxSubdivision controls how many splittings of the target area can
     * be done. The idea here is to do a linear mapping of the target areas
     * but the actual overall reprojection (can be) extremely non-linear. The
     * default value of MAX_SUBDIVISION was chosen based on mapping a 256x256
     * tile size. However this function is also called to remap canvas rendered
     * layers which can be much larger. This calculation increases the maxSubdivision
     * value by the right factor so that each 256x256 pixel area has
     * MAX_SUBDIVISION divisions.
     */ const maxSubdivision = $6be53f6edfbf1854$var$MAX_SUBDIVISION + (destinationResolution ? Math.max(0, Math.ceil(Math.log2((0, $9pD6L.getArea)(targetExtent) / (destinationResolution * destinationResolution * 65536)))) : 0);
        this.addQuad_(destinationTopLeft, destinationTopRight, destinationBottomRight, destinationBottomLeft, sourceTopLeft, sourceTopRight, sourceBottomRight, sourceBottomLeft, maxSubdivision);
        if (this.wrapsXInSource_) {
            let leftBound = Infinity;
            this.triangles_.forEach(function(triangle, i, arr) {
                leftBound = Math.min(leftBound, triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]);
            });
            // Shift triangles to be as close to `leftBound` as possible
            // (if the distance is more than `worldWidth / 2` it can be closer.
            this.triangles_.forEach((triangle)=>{
                if (Math.max(triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]) - leftBound > this.sourceWorldWidth_ / 2) {
                    const newTriangle = [
                        [
                            triangle.source[0][0],
                            triangle.source[0][1]
                        ],
                        [
                            triangle.source[1][0],
                            triangle.source[1][1]
                        ],
                        [
                            triangle.source[2][0],
                            triangle.source[2][1]
                        ]
                    ];
                    if (newTriangle[0][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[0][0] -= this.sourceWorldWidth_;
                    if (newTriangle[1][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[1][0] -= this.sourceWorldWidth_;
                    if (newTriangle[2][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[2][0] -= this.sourceWorldWidth_;
                    // Rarely (if the extent contains both the dateline and prime meridian)
                    // the shift can in turn break some triangles.
                    // Detect this here and don't shift in such cases.
                    const minX = Math.min(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    const maxX = Math.max(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    if (maxX - minX < this.sourceWorldWidth_ / 2) triangle.source = newTriangle;
                }
            });
        }
        transformInvCache = {};
    }
    /**
   * Adds triangle to the triangulation.
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @private
   */ addTriangle_(a, b, c, aSrc, bSrc, cSrc) {
        this.triangles_.push({
            source: [
                aSrc,
                bSrc,
                cSrc
            ],
            target: [
                a,
                b,
                c
            ]
        });
    }
    /**
   * Adds quad (points in clock-wise order) to the triangulation
   * (and reprojects the vertices) if valid.
   * Performs quad subdivision if needed to increase precision.
   *
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} d The target d coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @param {import("../coordinate.js").Coordinate} dSrc The source d coordinate.
   * @param {number} maxSubdivision Maximal allowed subdivision of the quad.
   * @private
   */ addQuad_(a, b, c, d, aSrc, bSrc, cSrc, dSrc, maxSubdivision) {
        const sourceQuadExtent = (0, $9pD6L.boundingExtent)([
            aSrc,
            bSrc,
            cSrc,
            dSrc
        ]);
        const sourceCoverageX = this.sourceWorldWidth_ ? (0, $9pD6L.getWidth)(sourceQuadExtent) / this.sourceWorldWidth_ : null;
        const sourceWorldWidth = /** @type {number} */ this.sourceWorldWidth_;
        // when the quad is wrapped in the source projection
        // it covers most of the projection extent, but not fully
        const wrapsX = this.sourceProj_.canWrapX() && sourceCoverageX > 0.5 && sourceCoverageX < 1;
        let needsSubdivision = false;
        if (maxSubdivision > 0) {
            if (this.targetProj_.isGlobal() && this.targetWorldWidth_) {
                const targetQuadExtent = (0, $9pD6L.boundingExtent)([
                    a,
                    b,
                    c,
                    d
                ]);
                const targetCoverageX = (0, $9pD6L.getWidth)(targetQuadExtent) / this.targetWorldWidth_;
                needsSubdivision = targetCoverageX > $6be53f6edfbf1854$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
            }
            if (!wrapsX && this.sourceProj_.isGlobal() && sourceCoverageX) needsSubdivision = sourceCoverageX > $6be53f6edfbf1854$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
        }
        if (!needsSubdivision && this.maxSourceExtent_) {
            if (isFinite(sourceQuadExtent[0]) && isFinite(sourceQuadExtent[1]) && isFinite(sourceQuadExtent[2]) && isFinite(sourceQuadExtent[3])) {
                if (!(0, $9pD6L.intersects)(sourceQuadExtent, this.maxSourceExtent_)) // whole quad outside source projection extent -> ignore
                return;
            }
        }
        let isNotFinite = 0;
        if (!needsSubdivision) {
            if (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) || !isFinite(bSrc[0]) || !isFinite(bSrc[1]) || !isFinite(cSrc[0]) || !isFinite(cSrc[1]) || !isFinite(dSrc[0]) || !isFinite(dSrc[1])) {
                if (maxSubdivision > 0) needsSubdivision = true;
                else {
                    // It might be the case that only 1 of the points is infinite. In this case
                    // we can draw a single triangle with the other three points
                    isNotFinite = (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) ? 8 : 0) + (!isFinite(bSrc[0]) || !isFinite(bSrc[1]) ? 4 : 0) + (!isFinite(cSrc[0]) || !isFinite(cSrc[1]) ? 2 : 0) + (!isFinite(dSrc[0]) || !isFinite(dSrc[1]) ? 1 : 0);
                    if (isNotFinite != 1 && isNotFinite != 2 && isNotFinite != 4 && isNotFinite != 8) return;
                }
            }
        }
        if (maxSubdivision > 0) {
            if (!needsSubdivision) {
                const center = [
                    (a[0] + c[0]) / 2,
                    (a[1] + c[1]) / 2
                ];
                const centerSrc = this.transformInv_(center);
                let dx;
                if (wrapsX) {
                    const centerSrcEstimX = ((0, $9byFX.modulo)(aSrc[0], sourceWorldWidth) + (0, $9byFX.modulo)(cSrc[0], sourceWorldWidth)) / 2;
                    dx = centerSrcEstimX - (0, $9byFX.modulo)(centerSrc[0], sourceWorldWidth);
                } else dx = (aSrc[0] + cSrc[0]) / 2 - centerSrc[0];
                const dy = (aSrc[1] + cSrc[1]) / 2 - centerSrc[1];
                const centerSrcErrorSquared = dx * dx + dy * dy;
                needsSubdivision = centerSrcErrorSquared > this.errorThresholdSquared_;
            }
            if (needsSubdivision) {
                if (Math.abs(a[0] - c[0]) <= Math.abs(a[1] - c[1])) {
                    // split horizontally (top & bottom)
                    const bc = [
                        (b[0] + c[0]) / 2,
                        (b[1] + c[1]) / 2
                    ];
                    const bcSrc = this.transformInv_(bc);
                    const da = [
                        (d[0] + a[0]) / 2,
                        (d[1] + a[1]) / 2
                    ];
                    const daSrc = this.transformInv_(da);
                    this.addQuad_(a, b, bc, da, aSrc, bSrc, bcSrc, daSrc, maxSubdivision - 1);
                    this.addQuad_(da, bc, c, d, daSrc, bcSrc, cSrc, dSrc, maxSubdivision - 1);
                } else {
                    // split vertically (left & right)
                    const ab = [
                        (a[0] + b[0]) / 2,
                        (a[1] + b[1]) / 2
                    ];
                    const abSrc = this.transformInv_(ab);
                    const cd = [
                        (c[0] + d[0]) / 2,
                        (c[1] + d[1]) / 2
                    ];
                    const cdSrc = this.transformInv_(cd);
                    this.addQuad_(a, ab, cd, d, aSrc, abSrc, cdSrc, dSrc, maxSubdivision - 1);
                    this.addQuad_(ab, b, c, cd, abSrc, bSrc, cSrc, cdSrc, maxSubdivision - 1);
                }
                return;
            }
        }
        if (wrapsX) {
            if (!this.canWrapXInSource_) return;
            this.wrapsXInSource_ = true;
        }
        // Exactly zero or one of *Src is not finite
        // The triangles must have the diagonal line as the first side
        // This is to allow easy code in reproj.s to make it straight for broken
        // browsers that can't handle diagonal clipping
        if ((isNotFinite & 0xb) == 0) this.addTriangle_(a, c, d, aSrc, cSrc, dSrc);
        if ((isNotFinite & 0xe) == 0) this.addTriangle_(a, c, b, aSrc, cSrc, bSrc);
        if (isNotFinite) {
            // Try the other two triangles
            if ((isNotFinite & 0xd) == 0) this.addTriangle_(b, d, a, bSrc, dSrc, aSrc);
            if ((isNotFinite & 0x7) == 0) this.addTriangle_(b, d, c, bSrc, dSrc, cSrc);
        }
    }
    /**
   * Calculates extent of the `source` coordinates from all the triangles.
   *
   * @return {import("../extent.js").Extent} Calculated extent.
   */ calculateSourceExtent() {
        const extent = (0, $9pD6L.createEmpty)();
        this.triangles_.forEach(function(triangle, i, arr) {
            const src = triangle.source;
            (0, $9pD6L.extendCoordinate)(extent, src[0]);
            (0, $9pD6L.extendCoordinate)(extent, src[1]);
            (0, $9pD6L.extendCoordinate)(extent, src[2]);
        });
        return extent;
    }
    /**
   * @return {Array<Triangle>} Array of the calculated triangles.
   */ getTriangles() {
        return this.triangles_;
    }
}
var $6be53f6edfbf1854$export$2e2bcd8739ae039 = $6be53f6edfbf1854$var$Triangulation;

});

parcelRegister("cfilv", function(module, exports) {

$parcel$export(module.exports, "ERROR_THRESHOLD", () => $8ea51dd7be3ba5e2$export$3ecb4bcfa5aae855);
/**
 * @module ol/reproj/common
 */ /**
 * Default maximum allowed threshold  (in pixels) for reprojection
 * triangulation.
 * @type {number}
 */ const $8ea51dd7be3ba5e2$export$3ecb4bcfa5aae855 = 0.5;

});


parcelRegister("knPlK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed6dc99f268f3882$export$2e2bcd8739ae039);
/**
 * @module ol/source/Source
 */ 
var $fFFY7 = parcelRequire("fFFY7");

var $dpRHA = parcelRequire("dpRHA");
/**
 * @typedef {'undefined' | 'loading' | 'ready' | 'error'} State
 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
 */ /**
 * A function that takes a {@link import("../View.js").ViewStateLayerStateExtent} and returns a string or
 * an array of strings representing source attributions.
 *
 * @typedef {function(import("../View.js").ViewStateLayerStateExtent): (string|Array<string>)} Attribution
 */ /**
 * A type that can be used to provide attribution information for data sources.
 *
 * It represents either
 * a simple string (e.g. `'© Acme Inc.'`)
 * an array of simple strings (e.g. `['© Acme Inc.', '© Bacme Inc.']`)
 * a function that returns a string or array of strings ({@link module:ol/source/Source~Attribution})
 *
 * @typedef {string|Array<string>|Attribution} AttributionLike
 */ /**
 * @typedef {Object} Options
 * @property {AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {import("./Source.js").State} [state='ready'] State.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for {@link module:ol/layer/Layer~Layer} sources.
 *
 * A generic `change` event is triggered when the state of the source changes.
 * @abstract
 * @api
 */ class $ed6dc99f268f3882$var$Source extends (0, $fFFY7.default) {
    /**
   * @param {Options} options Source options.
   */ constructor(options){
        super();
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|null}
     */ this.projection = (0, $dpRHA.get)(options.projection);
        /**
     * @private
     * @type {?Attribution}
     */ this.attributions_ = $ed6dc99f268f3882$var$adaptAttributions(options.attributions);
        /**
     * @private
     * @type {boolean}
     */ this.attributionsCollapsible_ = options.attributionsCollapsible ?? true;
        /**
     * This source is currently loading data. Sources that defer loading to the
     * map's tile queue never set this to `true`.
     * @type {boolean}
     */ this.loading = false;
        /**
     * @private
     * @type {import("./Source.js").State}
     */ this.state_ = options.state !== undefined ? options.state : 'ready';
        /**
     * @private
     * @type {boolean}
     */ this.wrapX_ = options.wrapX !== undefined ? options.wrapX : false;
        /**
     * @private
     * @type {boolean}
     */ this.interpolate_ = !!options.interpolate;
        /**
     * @protected
     * @type {function(import("../View.js").ViewOptions):void}
     */ this.viewResolver = null;
        /**
     * @protected
     * @type {function(Error):void}
     */ this.viewRejector = null;
        const self = this;
        /**
     * @private
     * @type {Promise<import("../View.js").ViewOptions>}
     */ this.viewPromise_ = new Promise(function(resolve, reject) {
            self.viewResolver = resolve;
            self.viewRejector = reject;
        });
    }
    /**
   * Get the attribution function for the source.
   * @return {?Attribution} Attribution function.
   * @api
   */ getAttributions() {
        return this.attributions_;
    }
    /**
   * @return {boolean} Attributions are collapsible.
   * @api
   */ getAttributionsCollapsible() {
        return this.attributionsCollapsible_;
    }
    /**
   * Get the projection of the source.
   * @return {import("../proj/Projection.js").default|null} Projection.
   * @api
   */ getProjection() {
        return this.projection;
    }
    /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   */ getResolutions(projection) {
        return null;
    }
    /**
   * @return {Promise<import("../View.js").ViewOptions>} A promise for view-related properties.
   */ getView() {
        return this.viewPromise_;
    }
    /**
   * Get the state of the source, see {@link import("./Source.js").State} for possible states.
   * @return {import("./Source.js").State} State.
   * @api
   */ getState() {
        return this.state_;
    }
    /**
   * @return {boolean|undefined} Wrap X.
   */ getWrapX() {
        return this.wrapX_;
    }
    /**
   * @return {boolean} Use linear interpolation when resampling.
   */ getInterpolate() {
        return this.interpolate_;
    }
    /**
   * Refreshes the source. The source will be cleared, and data from the server will be reloaded.
   * @api
   */ refresh() {
        this.changed();
    }
    /**
   * Set the attributions of the source.
   * @param {AttributionLike|undefined} attributions Attributions.
   *     Can be passed as `string`, `Array<string>`, {@link module:ol/source/Source~Attribution},
   *     or `undefined`.
   * @api
   */ setAttributions(attributions) {
        this.attributions_ = $ed6dc99f268f3882$var$adaptAttributions(attributions);
        this.changed();
    }
    /**
   * Set the state of the source.
   * @param {import("./Source.js").State} state State.
   */ setState(state) {
        this.state_ = state;
        this.changed();
    }
}
/**
 * Turns the attributions option into an attributions function.
 * @param {AttributionLike|undefined} attributionLike The attribution option.
 * @return {Attribution|null} An attribution function (or null).
 */ function $ed6dc99f268f3882$var$adaptAttributions(attributionLike) {
    if (!attributionLike) return null;
    if (typeof attributionLike === 'function') return attributionLike;
    if (!Array.isArray(attributionLike)) attributionLike = [
        attributionLike
    ];
    return (frameState)=>attributionLike;
}
var $ed6dc99f268f3882$export$2e2bcd8739ae039 = $ed6dc99f268f3882$var$Source;

});

parcelRegister("2yHbn", function(module, exports) {

$parcel$export(module.exports, "DECIMALS", () => $1dd040dde677fb20$export$48fbc15abf52505f);
/**
 * @module ol/source/common
 */ /**
 * Default WMS version.
 * @type {string}
 */ const $1dd040dde677fb20$export$8c33e4eedb20eeb5 = '1.3.0';
const $1dd040dde677fb20$export$48fbc15abf52505f = 4;

});


parcelRegister("4yZwx", function(module, exports) {

$parcel$export(module.exports, "createLoader", () => $352a0fc5a3a8ed43$export$8e84ca9bef6adc3a);
/**
 * @module ol/source/static
 */ 
var $fySoz = parcelRequire("fySoz");

var $9pD6L = parcelRequire("9pD6L");
function $352a0fc5a3a8ed43$export$8e84ca9bef6adc3a(options) {
    const load = options.load || (0, $fySoz.decode);
    const extent = options.imageExtent;
    const crossOrigin = options.crossOrigin ?? null;
    return ()=>{
        const image = new Image();
        image.crossOrigin = crossOrigin;
        if (options.referrerPolicy !== undefined) image.referrerPolicy = options.referrerPolicy;
        return load(image, options.url).then((image)=>{
            const resolutionX = (0, $9pD6L.getWidth)(extent) / image.width;
            const resolutionY = (0, $9pD6L.getHeight)(extent) / image.height;
            const resolution = resolutionX !== resolutionY ? [
                resolutionX,
                resolutionY
            ] : resolutionY;
            return {
                image: image,
                extent: extent,
                resolution: resolution,
                pixelRatio: 1
            };
        });
    };
}

});


parcelRegister("dIG9p", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd014ab6df63665$export$2e2bcd8739ae039);
/**
 * @module ol/Feature
 */ 
var $fFFY7 = parcelRequire("fFFY7");

var $4Cz58 = parcelRequire("4Cz58");

var $3xzSb = parcelRequire("3xzSb");

var $ilM9F = parcelRequire("ilM9F");
/**
 * @typedef {typeof Feature|typeof import("./render/Feature.js").default} FeatureClass
 */ /**
 * @typedef {Feature|import("./render/Feature.js").default} FeatureLike
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:geometry', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types
 *     |'change:geometry', Return>} FeatureOnSignature
 */ /***
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @typedef {Properties & { geometry?: Geometry }} ObjectWithGeometry
 */ /**
 * @classdesc
 * A vector object for geographic features with a geometry and other
 * attribute properties, similar to the features in vector file formats like
 * GeoJSON.
 *
 * Features can be styled individually with `setStyle`; otherwise they use the
 * style of their vector layer.
 *
 * Note that attribute properties are set as {@link module:ol/Object~BaseObject} properties on
 * the feature object, so they are observable, and have get/set accessors.
 *
 * Typically, a feature has a single geometry property. You can set the
 * geometry using the `setGeometry` method and get it with `getGeometry`.
 * It is possible to store more than one geometry on a feature using attribute
 * properties. By default, the geometry used for rendering is identified by
 * the property name `geometry`. If you want to use another geometry property
 * for rendering, use the `setGeometryName` method to change the attribute
 * property associated with the geometry for the feature.  For example:
 *
 * ```js
 *
 * import Feature from 'ol/Feature.js';
 * import Polygon from 'ol/geom/Polygon.js';
 * import Point from 'ol/geom/Point.js';
 *
 * const feature = new Feature({
 *   geometry: new Polygon(polyCoords),
 *   labelPoint: new Point(labelCoords),
 *   name: 'My Polygon',
 * });
 *
 * // get the polygon geometry
 * const poly = feature.getGeometry();
 *
 * // Render the feature as a point using the coordinates from labelPoint
 * feature.setGeometryName('labelPoint');
 *
 * // get the point geometry
 * const point = feature.getGeometry();
 * ```
 *
 * @api
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @extends {BaseObject<NoInfer<Properties>>}
 */ class $9fd014ab6df63665$var$Feature extends (0, $fFFY7.default) {
    /**
   * @param {Geometry|ObjectWithGeometry<Geometry, NoInfer<Properties>>} [geometryOrProperties]
   *     You may pass a Geometry object directly, or an object literal containing
   *     properties. If you pass an object literal, you may include a Geometry
   *     associated with a `geometry` key.
   */ constructor(geometryOrProperties){
        super();
        /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {FeatureOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = undefined;
        /**
     * @type {string}
     * @private
     */ this.geometryName_ = 'geometry';
        /**
     * User provided style.
     * @private
     * @type {import("./style/Style.js").StyleLike}
     */ this.style_ = null;
        /**
     * @private
     * @type {import("./style/Style.js").StyleFunction|undefined}
     */ this.styleFunction_ = undefined;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.geometryChangeKey_ = null;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        if (geometryOrProperties) {
            if (typeof /** @type {?} */ geometryOrProperties.getSimplifiedGeometry === 'function') {
                const geometry = /** @type {Geometry} */ geometryOrProperties;
                this.setGeometry(geometry);
            } else {
                /** @type {?} */ const properties = geometryOrProperties;
                this.setProperties(properties);
            }
        }
    }
    /**
   * Clone this feature. If the original feature has a geometry it
   * is also cloned. The feature id is not set in the clone.
   * @return {Feature<Geometry>} The clone.
   * @api
   */ clone() {
        const clone = /** @type {Feature<Geometry>} */ new $9fd014ab6df63665$var$Feature(this.hasProperties() ? this.getProperties() : null);
        clone.setGeometryName(this.getGeometryName());
        const geometry = this.getGeometry();
        if (geometry) clone.setGeometry(/** @type {Geometry} */ geometry.clone());
        const style = this.getStyle();
        if (style) clone.setStyle(style);
        return clone;
    }
    /**
   * Get the feature's default geometry.  A feature may have any number of named
   * geometries.  The "default" geometry (the one that is rendered by default) is
   * set when calling {@link module:ol/Feature~Feature#setGeometry}.
   * @return {Geometry|undefined} The default geometry for the feature.
   * @api
   * @observable
   */ getGeometry() {
        return /** @type {Geometry|undefined} */ this.get(this.geometryName_);
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is either set when reading data from a remote source or set explicitly by
   * calling {@link module:ol/Feature~Feature#setId}.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * Get the name of the feature's default geometry.  By default, the default
   * geometry is named `geometry`.
   * @return {string} Get the property name associated with the default geometry
   *     for this feature.
   * @api
   */ getGeometryName() {
        return this.geometryName_;
    }
    /**
   * Get the feature's style. Will return what was provided to the
   * {@link module:ol/Feature~Feature#setStyle} method.
   * @return {import("./style/Style.js").StyleLike|undefined} The feature style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the feature's style function.
   * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
   * representing the current style of this feature.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @private
   */ handleGeometryChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleGeometryChanged_() {
        if (this.geometryChangeKey_) {
            (0, $ilM9F.unlistenByKey)(this.geometryChangeKey_);
            this.geometryChangeKey_ = null;
        }
        const geometry = this.getGeometry();
        if (geometry) this.geometryChangeKey_ = (0, $ilM9F.listen)(geometry, (0, $3xzSb.default).CHANGE, this.handleGeometryChange_, this);
        this.changed();
    }
    /**
   * Set the default geometry for the feature.  This will update the property
   * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
   * @param {Geometry|undefined} geometry The new geometry.
   * @api
   * @observable
   */ setGeometry(geometry) {
        this.set(this.geometryName_, geometry);
    }
    /**
   * Set the style for the feature to override the layer style.  This can be a
   * single style object, an array of styles, or a function that takes a
   * resolution and returns an array of styles. To unset the feature style, call
   * `setStyle()` without arguments or a falsey value.
   * @param {import("./style/Style.js").StyleLike} [style] Style for this feature.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setStyle(style) {
        this.style_ = style;
        this.styleFunction_ = !style ? undefined : $9fd014ab6df63665$export$bb06ddfd5d66e02e(style);
        this.changed();
    }
    /**
   * Set the feature id.  The feature id is considered stable and may be used when
   * requesting features or comparing identifiers returned from a remote source.
   * The feature id can be used with the
   * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
   * @param {number|string|undefined} id The feature id.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setId(id) {
        this.id_ = id;
        this.changed();
    }
    /**
   * Set the property name to be used when getting the feature's default geometry.
   * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
   * this name will be returned.
   * @param {string} name The property name of the default geometry.
   * @api
   */ setGeometryName(name) {
        this.removeChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.geometryName_ = name;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.handleGeometryChanged_();
    }
}
function $9fd014ab6df63665$export$bb06ddfd5d66e02e(obj) {
    if (typeof obj === 'function') return obj;
    /**
   * @type {Array<import("./style/Style.js").default>}
   */ let styles;
    if (Array.isArray(obj)) styles = obj;
    else {
        (0, $4Cz58.assert)(typeof /** @type {?} */ obj.getZIndex === 'function', 'Expected an `ol/style/Style` or an array of `ol/style/Style.js`');
        const style = /** @type {import("./style/Style.js").default} */ obj;
        styles = [
            style
        ];
    }
    return function() {
        return styles;
    };
}
var $9fd014ab6df63665$export$2e2bcd8739ae039 = $9fd014ab6df63665$var$Feature;

});

parcelRegister("5DwXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $41aa29ae0c4b607a$export$2e2bcd8739ae039);
/**
 * @module ol/Map
 */ 
var $cD8Qe = parcelRequire("cD8Qe");

var $1TIYs = parcelRequire("1TIYs");

var $dSQBl = parcelRequire("dSQBl");

var $8hMRr = parcelRequire("8hMRr");

var $1O6bd = parcelRequire("1O6bd");

var $4Zdcs = parcelRequire("4Zdcs");

var $jDfdj = parcelRequire("jDfdj");

var $GsIjZ = parcelRequire("GsIjZ");

var $fFFY7 = parcelRequire("fFFY7");

var $jXCUw = parcelRequire("jXCUw");

var $6yfyT = parcelRequire("6yfyT");

var $9DiKA = parcelRequire("9DiKA");

var $aKuSF = parcelRequire("aKuSF");

var $fVVyM = parcelRequire("fVVyM");

var $4Cz58 = parcelRequire("4Cz58");

var $c3kwQ = parcelRequire("c3kwQ");

var $f3WAG = parcelRequire("f3WAG");

var $DfnQm = parcelRequire("DfnQm");

var $3xzSb = parcelRequire("3xzSb");

var $ilM9F = parcelRequire("ilM9F");

var $9pD6L = parcelRequire("9pD6L");

var $6wUzV = parcelRequire("6wUzV");

var $8UoiJ = parcelRequire("8UoiJ");

var $jzydl = parcelRequire("jzydl");

var $YSU3I = parcelRequire("YSU3I");

var $79s7T = parcelRequire("79s7T");

var $ijSzV = parcelRequire("ijSzV");

var $dpRHA = parcelRequire("dpRHA");

var $l6YBe = parcelRequire("l6YBe");

var $lvfQG = parcelRequire("lvfQG");

var $hxhPO = parcelRequire("hxhPO");

var $jpXrt = parcelRequire("jpXrt");

var $9iPUS = parcelRequire("9iPUS");
/**
 * State of the current frame. Only `pixelRatio`, `time` and `viewState` should
 * be used in applications.
 * @typedef {Object} FrameState
 * @property {number} pixelRatio The pixel ratio of the frame.
 * @property {number} time The time when rendering of the frame was requested.
 * @property {import("./View.js").State} viewState The state of the current view.
 * @property {boolean} animate Animate.
 * @property {import("./transform.js").Transform} coordinateToPixelTransform CoordinateToPixelTransform.
 * @property {Object<string, import("rbush").default<import('./render/canvas/Executor.js').DeclutterEntry>>|null} declutter
 * Declutter trees by declutter group.
 * When null, no decluttering is needed because no layers have decluttering enabled.
 * @property {null|import("./extent.js").Extent} extent Extent (in view projection coordinates).
 * @property {import("./extent.js").Extent} [nextExtent] Next extent during an animation series.
 * @property {number} index Index.
 * @property {Array<import("./layer/Layer.js").State>} layerStatesArray LayerStatesArray.
 * @property {number} layerIndex LayerIndex.
 * @property {import("./transform.js").Transform} pixelToCoordinateTransform PixelToCoordinateTransform.
 * @property {Array<PostRenderFunction>} postRenderFunctions PostRenderFunctions.
 * @property {import("./size.js").Size} size Size.
 * @property {TileQueue} tileQueue TileQueue.
 * @property {!Object<string, Object<string, boolean>>} usedTiles UsedTiles.
 * @property {Array<number>} viewHints ViewHints.
 * @property {!Object<string, Object<string, boolean>>} wantedTiles WantedTiles.
 * @property {string} mapId The id of the map.
 * @property {Object<string, boolean>} renderTargets Identifiers of previously rendered elements.
 */ /**
 * @typedef {function(Map, FrameState): any} PostRenderFunction
 */ /**
 * @typedef {Object} AtPixelOptions
 * @property {undefined|function(import("./layer/Layer.js").default<import("./source/Source").default>): boolean} [layerFilter] Layer filter
 * function. The filter function will receive one argument, the
 * {@link module:ol/layer/Layer~Layer layer-candidate} and it should return a boolean value.
 * Only layers which are visible and for which this function returns `true`
 * will be tested for features. By default, all visible layers will be tested.
 * @property {number} [hitTolerance=0] Hit-detection tolerance in css pixels. Pixels
 * inside the radius around the given position will be checked for features.
 * @property {boolean} [checkWrapped=true] Check-Wrapped Will check for wrapped geometries inside the range of
 *   +/- 1 world width. Works only if a projection is used that can be wrapped.
 */ /**
 * @typedef {Object} MapOptionsInternal
 * @property {Collection<import("./control/Control.js").default>} [controls] Controls.
 * @property {Collection<import("./interaction/Interaction.js").default>} [interactions] Interactions.
 * @property {HTMLElement|Document} keyboardEventTarget KeyboardEventTarget.
 * @property {Collection<import("./Overlay.js").default>} overlays Overlays.
 * @property {Object<string, *>} values Values.
 */ /**
 * @typedef {import("./ObjectEventType").Types|'change:layergroup'|'change:size'|'change:target'|'change:view'} MapObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<MapObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *    import("./Observable").OnSignature<import("./MapBrowserEventType").Types, import("./MapBrowserEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./MapEventType").Types, import("./MapEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./render/EventType").MapRenderEventTypes, import("./render/Event").default, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|MapObjectEventTypes|
 *      import("./MapBrowserEventType").Types|import("./MapEventType").Types|
 *      import("./render/EventType").MapRenderEventTypes, Return>} MapEventHandler
 */ /**
 * Object literal with config options for the map.
 * @typedef {Object} MapOptions
 * @property {Collection<import("./control/Control.js").default>|Array<import("./control/Control.js").default>} [controls]
 * Controls initially added to the map. If not specified,
 * {@link module:ol/control/defaults.defaults} is used. In a worker, no controls are added by default.
 * @property {number} [pixelRatio=window.devicePixelRatio] The ratio between
 * physical pixels and device-independent pixels (dips) on the device.
 * @property {Collection<import("./interaction/Interaction.js").default>|Array<import("./interaction/Interaction.js").default>} [interactions]
 * Interactions that are initially added to the map. If not specified,
 * {@link module:ol/interaction/defaults.defaults} is used. In a worker, no interactions are added by default.
 * @property {HTMLElement|Document|string} [keyboardEventTarget] The element to
 * listen to keyboard events on. This determines when the `KeyboardPan` and
 * `KeyboardZoom` interactions trigger. For example, if this option is set to
 * `document` the keyboard interactions will always trigger. If this option is
 * not specified, the element the library listens to keyboard events on is the
 * map target (i.e. the user-provided div for the map). If this is not
 * `document`, the target element needs to be focused for key events to be
 * emitted, requiring that the target element has a `tabindex` attribute.
 * @property {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>|LayerGroup} [layers]
 * Layers. If this is not defined, a map with no layers will be rendered. Note
 * that layers are rendered in the order supplied, so if you want, for example,
 * a vector layer to appear on top of a tile layer, it must come after the tile
 * layer.
 * @property {number} [maxTilesLoading=16] Maximum number tiles to load
 * simultaneously.
 * @property {number} [moveTolerance=1] The minimum distance in pixels the
 * cursor must move to be detected as a map move event instead of a click.
 * Increasing this value can make it easier to click on the map.
 * @property {Collection<import("./Overlay.js").default>|Array<import("./Overlay.js").default>} [overlays]
 * Overlays initially added to the map. By default, no overlays are added.
 * @property {HTMLElement|string|HTMLCanvasElement|OffscreenCanvas} [target] The container for the map, either the
 * element itself or the `id` of the element. If not specified at construction
 * time, {@link module:ol/Map~Map#setTarget} must be called for the map to be
 * rendered. If passed by element, the container can be in a secondary document.
 * For use in workers or when exporting a map, use an `OffscreenCanvas` or `HTMLCanvasElement` as target,
 * with a width and height in physical pixels, optionally multiplied by and a scale transform matching
 * the map's pixel ratio.
 * For accessibility (focus and keyboard events for map navigation), the `target` element must have a
 *  properly configured `tabindex` attribute. If the `target` element is inside a Shadow DOM, the
 *  `tabindex` atribute must be set on the custom element's host element.
 * **Note:** CSS `transform` support for the target element is limited to `scale`.
 * @property {View|Promise<import("./View.js").ViewOptions>} [view] The map's view.  No layer sources will be
 * fetched unless this is specified at construction time or through
 * {@link module:ol/Map~Map#setView}.
 */ /**
 * @param {import("./layer/Base.js").default} layer Layer.
 */ function $41aa29ae0c4b607a$var$removeLayerMapProperty(layer) {
    if (layer instanceof (0, $79s7T.default)) {
        layer.setMapInternal(null);
        return;
    }
    if (layer instanceof (0, $YSU3I.default)) layer.getLayers().forEach($41aa29ae0c4b607a$var$removeLayerMapProperty);
}
/**
 * @param {import("./layer/Base.js").default} layer Layer.
 * @param {Map} map Map.
 */ function $41aa29ae0c4b607a$var$setLayerMapProperty(layer, map) {
    if (layer instanceof (0, $79s7T.default)) {
        layer.setMapInternal(map);
        return;
    }
    if (layer instanceof (0, $YSU3I.default)) {
        const layers = layer.getLayers().getArray();
        for(let i = 0, ii = layers.length; i < ii; ++i)$41aa29ae0c4b607a$var$setLayerMapProperty(layers[i], map);
    }
}
/**
 * @classdesc
 * The map is the core component of OpenLayers. For a map to render, a view,
 * one or more layers, and a target container are needed:
 *
 *     import Map from 'ol/Map.js';
 *     import View from 'ol/View.js';
 *     import TileLayer from 'ol/layer/Tile.js';
 *     import OSM from 'ol/source/OSM.js';
 *
 *     const map = new Map({
 *       view: new View({
 *         center: [0, 0],
 *         zoom: 1,
 *       }),
 *       layers: [
 *         new TileLayer({
 *           source: new OSM(),
 *         }),
 *       ],
 *       target: 'map',
 *     });
 *
 * The above snippet creates a map using a {@link module:ol/layer/Tile~TileLayer} to
 * display {@link module:ol/source/OSM~OSM} OSM data and render it to a DOM
 * element with the id `map`.
 *
 * The constructor places a viewport container (with CSS class name
 * `ol-viewport`) in the target element (see `getViewport()`), and then two
 * further elements within the viewport: one with CSS class name
 * `ol-overlaycontainer-stopevent` for controls and some overlays, and one with
 * CSS class name `ol-overlaycontainer` for other overlays (see the `stopEvent`
 * option of {@link module:ol/Overlay~Overlay} for the difference). The map
 * itself is placed in a further element within the viewport.
 *
 * Layers are stored as a {@link module:ol/Collection~Collection} in
 * layerGroups. A top-level group is provided by the library. This is what is
 * accessed by `getLayerGroup` and `setLayerGroup`. Layers entered in the
 * options are added to this group, and `addLayer` and `removeLayer` change the
 * layer collection in the group. `getLayers` is a convenience function for
 * `getLayerGroup().getLayers()`. Note that {@link module:ol/layer/Group~LayerGroup}
 * is a subclass of {@link module:ol/layer/Base~BaseLayer}, so layers entered in the
 * options or added with `addLayer` can be groups, which can contain further
 * groups, and so on.
 *
 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
 * @fires import("./MapEvent.js").MapEvent
 * @fires import("./render/Event.js").default#precompose
 * @fires import("./render/Event.js").default#postcompose
 * @fires import("./render/Event.js").default#rendercomplete
 * @api
 */ class $41aa29ae0c4b607a$var$Map extends (0, $fFFY7.default) {
    /**
   * @param {MapOptions} [options] Map options.
   */ constructor(options){
        super();
        options = options || {};
        /***
     * @type {MapEventHandler<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {MapEventHandler<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {MapEventHandler<void>}
     */ this.un;
        const optionsInternal = $41aa29ae0c4b607a$var$createOptionsInternal(options);
        /**
     * @private
     * @type {boolean}
     */ this.renderComplete_ = false;
        /**
     * @private
     * @type {boolean}
     */ this.loaded_ = true;
        /** @private */ this.boundHandleBrowserEvent_ = this.handleBrowserEvent.bind(this);
        /**
     * @type {number}
     * @private
     */ this.maxTilesLoading_ = options.maxTilesLoading !== undefined ? options.maxTilesLoading : 16;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = options.pixelRatio !== undefined ? options.pixelRatio : (0, $8UoiJ.DEVICE_PIXEL_RATIO);
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.postRenderTimeoutHandle_;
        /**
     * @private
     * @type {number|undefined}
     */ this.animationDelayKey_;
        /**
     * @private
     */ this.animationDelay_ = this.animationDelay_.bind(this);
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.coordinateToPixelTransform_ = (0, $jpXrt.create)();
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.pixelToCoordinateTransform_ = (0, $jpXrt.create)();
        /**
     * @private
     * @type {number}
     */ this.frameIndex_ = 0;
        /**
     * @private
     * @type {?FrameState}
     */ this.frameState_ = null;
        /**
     * The extent at the previous 'moveend' event.
     * @private
     * @type {import("./extent.js").Extent}
     */ this.previousExtent_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewPropertyListenerKey_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewChangeListenerKey_ = null;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.layerGroupPropertyListenerKeys_ = null;
        /**
     * @private
     * @type {!HTMLElement}
     */ if (!(0, $8UoiJ.WORKER_OFFSCREEN_CANVAS)) {
            this.viewport_ = document.createElement('div');
            this.viewport_.className = 'ol-viewport' + ('ontouchstart' in window ? ' ol-touch' : '');
            this.viewport_.style.position = 'relative';
            this.viewport_.style.overflow = 'hidden';
            this.viewport_.style.width = '100%';
            this.viewport_.style.height = '100%';
            /**
       * @private
       * @type {!HTMLElement}
       */ this.overlayContainer_ = document.createElement('div');
            this.overlayContainer_.style.position = 'absolute';
            this.overlayContainer_.style.zIndex = '0';
            this.overlayContainer_.style.width = '100%';
            this.overlayContainer_.style.height = '100%';
            this.overlayContainer_.style.pointerEvents = 'none';
            this.overlayContainer_.className = 'ol-overlaycontainer';
            this.viewport_.appendChild(this.overlayContainer_);
            /**
       * @private
       * @type {!HTMLElement}
       */ this.overlayContainerStopEvent_ = document.createElement('div');
            this.overlayContainerStopEvent_.style.position = 'absolute';
            this.overlayContainerStopEvent_.style.zIndex = '0';
            this.overlayContainerStopEvent_.style.width = '100%';
            this.overlayContainerStopEvent_.style.height = '100%';
            this.overlayContainerStopEvent_.style.pointerEvents = 'none';
            this.overlayContainerStopEvent_.className = 'ol-overlaycontainer-stopevent';
            this.viewport_.appendChild(this.overlayContainerStopEvent_);
        }
        /**
     * @private
     * @type {MapBrowserEventHandler}
     */ this.mapBrowserEventHandler_ = null;
        /**
     * @private
     * @type {number}
     */ this.moveTolerance_ = options.moveTolerance;
        /**
     * @private
     * @type {HTMLElement|Document}
     */ this.keyboardEventTarget_ = optionsInternal.keyboardEventTarget;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.targetChangeHandlerKeys_ = null;
        /**
     * @private
     * @type {HTMLElement|null}
     */ this.targetElement_ = null;
        if (!(0, $8UoiJ.WORKER_OFFSCREEN_CANVAS)) /**
       * @private
       * @type {ResizeObserver}
       */ this.resizeObserver_ = new ResizeObserver(()=>this.updateSize());
        /**
     * @type {Collection<import("./control/Control.js").default>}
     * @protected
     */ this.controls = optionsInternal.controls || ((0, $8UoiJ.WORKER_OFFSCREEN_CANVAS) ? new (0, $cD8Qe.default)() : (0, $f3WAG.defaults)());
        /**
     * @type {Collection<import("./interaction/Interaction.js").default>}
     * @protected
     */ this.interactions = optionsInternal.interactions || ((0, $8UoiJ.WORKER_OFFSCREEN_CANVAS) ? new (0, $cD8Qe.default)() : (0, $jzydl.defaults)({
            onFocusOnly: true
        }));
        /**
     * @type {Collection<import("./Overlay.js").default>}
     * @private
     */ this.overlays_ = optionsInternal.overlays;
        /**
     * A lookup of overlays by id.
     * @private
     * @type {Object<string, import("./Overlay.js").default>}
     */ this.overlayIdIndex_ = {};
        /**
     * @type {import("./renderer/Map.js").default|null}
     * @private
     */ this.renderer_ = null;
        /**
     * @private
     * @type {!Array<PostRenderFunction>}
     */ this.postRenderFunctions_ = [];
        /**
     * @private
     * @type {TileQueue}
     */ this.tileQueue_ = new (0, $6yfyT.default)(this.getTilePriority.bind(this), this.handleTileChange_.bind(this));
        this.addChangeListener((0, $GsIjZ.default).LAYERGROUP, this.handleLayerGroupChanged_);
        this.addChangeListener((0, $GsIjZ.default).VIEW, this.handleViewChanged_);
        this.addChangeListener((0, $GsIjZ.default).SIZE, this.handleSizeChanged_);
        this.addChangeListener((0, $GsIjZ.default).TARGET, this.handleTargetChanged_);
        // setProperties will trigger the rendering of the map if the map
        // is "defined" already.
        this.setProperties(optionsInternal.values);
        const map = this;
        if (options.view && !(options.view instanceof (0, $9DiKA.default))) options.view.then(function(viewOptions) {
            map.setView(new (0, $9DiKA.default)(viewOptions));
        });
        this.controls.addEventListener((0, $1TIYs.default).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent
       */ (event)=>{
            event.element.setMap(this);
        });
        this.controls.addEventListener((0, $1TIYs.default).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.interactions.addEventListener((0, $1TIYs.default).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(this);
        });
        this.interactions.addEventListener((0, $1TIYs.default).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.overlays_.addEventListener((0, $1TIYs.default).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            this.addOverlayInternal_(event.element);
        });
        this.overlays_.addEventListener((0, $1TIYs.default).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            const id = event.element.getId();
            if (id !== undefined) delete this.overlayIdIndex_[id.toString()];
            event.element.setMap(null);
        });
        this.controls.forEach(/**
       * @param {import("./control/Control.js").default} control Control.
       */ (control)=>{
            control.setMap(this);
        });
        this.interactions.forEach(/**
       * @param {import("./interaction/Interaction.js").default} interaction Interaction.
       */ (interaction)=>{
            interaction.setMap(this);
        });
        this.overlays_.forEach(this.addOverlayInternal_.bind(this));
    }
    /**
   * Add the given control to the map.
   * @param {import("./control/Control.js").default} control Control.
   * @api
   */ addControl(control) {
        this.getControls().push(control);
    }
    /**
   * Add the given interaction to the map. If you want to add an interaction
   * at another point of the collection use `getInteractions()` and the methods
   * available on {@link module:ol/Collection~Collection}. This can be used to
   * stop the event propagation from the handleEvent function. The interactions
   * get to handle the events in the reverse order of this collection.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
   * @api
   */ addInteraction(interaction) {
        this.getInteractions().push(interaction);
    }
    /**
   * Adds the given layer to the top of this map. If you want to add a layer
   * elsewhere in the stack, use `getLayers()` and the methods available on
   * {@link module:ol/Collection~Collection}.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @api
   */ addLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        layers.push(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer add event.
   * @private
   */ handleLayerAdd_(event) {
        $41aa29ae0c4b607a$var$setLayerMapProperty(event.layer, this);
    }
    /**
   * Add the given overlay to the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @api
   */ addOverlay(overlay) {
        this.getOverlays().push(overlay);
    }
    /**
   * This deals with map's overlay collection changes.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @private
   */ addOverlayInternal_(overlay) {
        const id = overlay.getId();
        if (id !== undefined) this.overlayIdIndex_[id.toString()] = overlay;
        overlay.setMap(this);
    }
    /**
   *
   * Clean up.
   * @override
   */ disposeInternal() {
        this.controls.clear();
        this.interactions.clear();
        this.overlays_.clear();
        this.resizeObserver_?.disconnect();
        this.setTarget(null);
        super.disposeInternal();
    }
    /**
   * Detect features that intersect a pixel on the viewport, and execute a
   * callback with each intersecting feature. Layers included in the detection can
   * be configured through the `layerFilter` option in `options`.
   * For polygons without a fill, only the stroke will be used for hit detection.
   * Polygons must have a fill style applied to ensure that pixels inside a polygon are detected.
   * The fill can be transparent.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {function(import("./Feature.js").FeatureLike, import("./layer/Layer.js").default<import("./source/Source").default>, import("./geom/SimpleGeometry.js").default): T} callback Feature callback. The callback will be
   *     called with two arguments. The first argument is one
   *     {@link module:ol/Feature~Feature feature} or
   *     {@link module:ol/render/Feature~RenderFeature render feature} at the pixel, the second is
   *     the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
   *     unmanaged layers. To stop detection, callback functions can return a
   *     truthy value.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {T|undefined} Callback result, i.e. the return value of last
   * callback execution, or the first truthy callback return value.
   * @template T
   * @api
   */ forEachFeatureAtPixel(pixel, callback, options) {
        if (!this.frameState_ || !this.renderer_) return;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $6wUzV.TRUE);
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.forEachFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, callback, null, layerFilter, null);
    }
    /**
   * Get all features that intersect a pixel on the viewport.
   * For polygons without a fill, only the stroke will be used for hit detection.
   * Polygons must have a fill style applied to ensure that pixels inside a polygon are detected.
   * The fill can be transparent.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
   * an empty array if none were found.
   * @api
   */ getFeaturesAtPixel(pixel, options) {
        const features = [];
        this.forEachFeatureAtPixel(pixel, function(feature) {
            features.push(feature);
        }, options);
        return features;
    }
    /**
   * Get all layers from all layer groups.
   * @return {Array<import("./layer/Layer.js").default>} Layers.
   * @api
   */ getAllLayers() {
        const layers = [];
        function addLayersFrom(layerGroup) {
            layerGroup.forEach(function(layer) {
                if (layer instanceof (0, $YSU3I.default)) addLayersFrom(layer.getLayers());
                else layers.push(layer);
            });
        }
        addLayersFrom(this.getLayers());
        return layers;
    }
    /**
   * Detect if features intersect a pixel on the viewport. Layers included in the
   * detection can be configured through the `layerFilter` option.
   * For polygons without a fill, only the stroke will be used for hit detection.
   * Polygons must have a fill style applied to ensure that pixels inside a polygon are detected.
   * The fill can be transparent.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {boolean} Is there a feature at the given pixel?
   * @api
   */ hasFeatureAtPixel(pixel, options) {
        if (!this.frameState_ || !this.renderer_) return false;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $6wUzV.TRUE);
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.hasFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, layerFilter, null);
    }
    /**
   * Returns the coordinate in user projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   * @api
   */ getEventCoordinate(event) {
        return this.getCoordinateFromPixel(this.getEventPixel(event));
    }
    /**
   * Returns the coordinate in view projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   */ getEventCoordinateInternal(event) {
        return this.getCoordinateFromPixelInternal(this.getEventPixel(event));
    }
    /**
   * Returns the map pixel position for a browser event relative to the viewport.
   * @param {UIEvent|{clientX: number, clientY: number}} event Event.
   * @return {import("./pixel.js").Pixel} Pixel.
   * @api
   */ getEventPixel(event) {
        const viewport = this.viewport_;
        const viewportPosition = viewport.getBoundingClientRect();
        const viewportSize = this.getSize();
        const scaleX = viewportPosition.width / viewportSize[0];
        const scaleY = viewportPosition.height / viewportSize[1];
        const eventPosition = //FIXME Are we really calling this with a TouchEvent anywhere?
        'changedTouches' in event ? /** @type {TouchEvent} */ event.changedTouches[0] : /** @type {MouseEvent} */ event;
        return [
            (eventPosition.clientX - viewportPosition.left) / scaleX,
            (eventPosition.clientY - viewportPosition.top) / scaleY
        ];
    }
    /**
   * Get the target in which this map is rendered.
   * Note that this returns what is entered as an option or in setTarget:
   * if that was an element, it returns an element; if a string, it returns that.
   * @return {HTMLElement|string|undefined} The Element or id of the Element that the
   *     map is rendered in.
   * @observable
   * @api
   */ getTarget() {
        return /** @type {HTMLElement|string|undefined} */ this.get((0, $GsIjZ.default).TARGET);
    }
    /**
   * Get the DOM element into which this map is rendered. In contrast to
   * `getTarget` this method always return an `Element`, or `null` if the
   * map has no target.
   * @return {HTMLElement} The element that the map is rendered in.
   * @api
   */ getTargetElement() {
        return this.targetElement_;
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * user projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   * @api
   */ getCoordinateFromPixel(pixel) {
        return (0, $dpRHA.toUserCoordinate)(this.getCoordinateFromPixelInternal(pixel), this.getView().getProjection());
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * map view projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   */ getCoordinateFromPixelInternal(pixel) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, $jpXrt.apply)(frameState.pixelToCoordinateTransform, pixel.slice());
    }
    /**
   * Get the map controls. Modifying this collection changes the controls
   * associated with the map.
   * @return {Collection<import("./control/Control.js").default>} Controls.
   * @api
   */ getControls() {
        return this.controls;
    }
    /**
   * Get the map overlays. Modifying this collection changes the overlays
   * associated with the map.
   * @return {Collection<import("./Overlay.js").default>} Overlays.
   * @api
   */ getOverlays() {
        return this.overlays_;
    }
    /**
   * Get an overlay by its identifier (the value returned by overlay.getId()).
   * Note that the index treats string and numeric identifiers as the same. So
   * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
   * @param {string|number} id Overlay identifier.
   * @return {import("./Overlay.js").default|null} Overlay.
   * @api
   */ getOverlayById(id) {
        const overlay = this.overlayIdIndex_[id.toString()];
        return overlay !== undefined ? overlay : null;
    }
    /**
   * Get the map interactions. Modifying this collection changes the interactions
   * associated with the map.
   *
   * Interactions are used for e.g. pan, zoom and rotate.
   * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
   * @api
   */ getInteractions() {
        return this.interactions;
    }
    /**
   * Get the layergroup associated with this map.
   * @return {LayerGroup} A layer group containing the layers in this map.
   * @observable
   * @api
   */ getLayerGroup() {
        return /** @type {LayerGroup} */ this.get((0, $GsIjZ.default).LAYERGROUP);
    }
    /**
   * Clear any existing layers and add layers to the map.
   * @param {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>} layers The layers to be added to the map.
   * @api
   */ setLayers(layers) {
        const group = this.getLayerGroup();
        if (layers instanceof (0, $cD8Qe.default)) {
            group.setLayers(layers);
            return;
        }
        const collection = group.getLayers();
        collection.clear();
        collection.extend(layers);
    }
    /**
   * Get the collection of layers associated with this map.
   * @return {!Collection<import("./layer/Base.js").default>} Layers.
   * @api
   */ getLayers() {
        const layers = this.getLayerGroup().getLayers();
        return layers;
    }
    /**
   * @return {boolean} Layers have sources that are still loading.
   */ getLoadingOrNotReady() {
        const layerStatesArray = this.getLayerGroup().getLayerStatesArray();
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const state = layerStatesArray[i];
            if (!state.visible) continue;
            const renderer = state.layer.getRenderer();
            if (renderer && !renderer.ready) return true;
            const source = state.layer.getSource();
            if (source && source.loading) return true;
        }
        return false;
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the user
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   * @api
   */ getPixelFromCoordinate(coordinate) {
        const viewCoordinate = (0, $dpRHA.fromUserCoordinate)(coordinate, this.getView().getProjection());
        return this.getPixelFromCoordinateInternal(viewCoordinate);
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the map view
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   */ getPixelFromCoordinateInternal(coordinate) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, $jpXrt.apply)(frameState.coordinateToPixelTransform, coordinate.slice(0, 2));
    }
    /**
   * Get the pixel ratio of the rendered map.
   * @return {number} Pixel ratio.
   * @api
   */ getPixelRatio() {
        return this.pixelRatio_;
    }
    /**
   * Set the pixel ratio of the rendered map.
   * @param {number} pixelRatio Pixel ratio.
   * @api
   */ setPixelRatio(pixelRatio) {
        if (this.pixelRatio_ === pixelRatio) return;
        this.pixelRatio_ = pixelRatio;
        this.render();
    }
    /**
   * Get the map renderer.
   * @return {import("./renderer/Map.js").default|null} Renderer
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Get the size of this map.
   * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ getSize() {
        return /** @type {import("./size.js").Size|undefined} */ this.get((0, $GsIjZ.default).SIZE);
    }
    /**
   * Get the view associated with this map. A view manages properties such as
   * center and resolution.
   * @return {View} The view that controls this map.
   * @observable
   * @api
   */ getView() {
        return /** @type {View} */ this.get((0, $GsIjZ.default).VIEW);
    }
    /**
   * Get the element that serves as the map viewport.
   * @return {HTMLElement} Viewport.
   * @api
   */ getViewport() {
        return this.viewport_;
    }
    /**
   * Get the element that serves as the container for overlays.  Elements added to
   * this container will let mousedown and touchstart events through to the map,
   * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
   * events.
   * @return {!HTMLElement} The map's overlay container.
   */ getOverlayContainer() {
        return this.overlayContainer_;
    }
    /**
   * Get the element that serves as a container for overlays that don't allow
   * event propagation. Elements added to this container won't let mousedown and
   * touchstart events through to the map, so clicks and gestures on an overlay
   * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   * @return {!HTMLElement} The map's overlay container that stops events.
   */ getOverlayContainerStopEvent() {
        return this.overlayContainerStopEvent_;
    }
    /**
   * @return {!Document} The document where the map is displayed.
   */ getOwnerDocument() {
        const targetElement = this.getTargetElement();
        return targetElement ? targetElement.ownerDocument : document;
    }
    /**
   * @param {import("./Tile.js").default} tile Tile.
   * @param {string} tileSourceKey Tile source key.
   * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
   * @param {number} tileResolution Tile resolution.
   * @return {number} Tile priority.
   */ getTilePriority(tile, tileSourceKey, tileCenter, tileResolution) {
        return (0, $6yfyT.getTilePriority)(this.frameState_, tile, tileSourceKey, tileCenter, tileResolution);
    }
    /**
   * @param {PointerEvent|KeyboardEvent|WheelEvent} browserEvent Browser event.
   * @param {string} [type] Type.
   */ handleBrowserEvent(browserEvent, type) {
        type = type || browserEvent.type;
        const mapBrowserEvent = new (0, $dSQBl.default)(type, this, browserEvent);
        this.handleMapBrowserEvent(mapBrowserEvent);
    }
    /**
   * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
   */ handleMapBrowserEvent(mapBrowserEvent) {
        if (!this.frameState_) // With no view defined, we cannot translate pixels into geographical
        // coordinates so interactions cannot be used.
        return;
        const originalEvent = mapBrowserEvent.originalEvent;
        const eventType = originalEvent.type;
        if (eventType === (0, $ijSzV.default).POINTERDOWN || eventType === (0, $3xzSb.default).WHEEL || eventType === (0, $3xzSb.default).KEYDOWN) {
            const doc = this.getOwnerDocument();
            const rootNode = this.viewport_.getRootNode ? this.viewport_.getRootNode() : doc;
            const target = /** @type {Node} */ originalEvent.target;
            const currentDoc = rootNode instanceof ShadowRoot ? rootNode.host === target ? rootNode.host.ownerDocument : rootNode : rootNode === doc ? doc.documentElement : rootNode;
            if (// Abort if the target is a child of the container for elements whose events are not meant
            // to be handled by map interactions.
            this.overlayContainerStopEvent_.contains(target) || // Abort if the event target is a child of the container that is no longer in the page.
            // It's possible for the target to no longer be in the page if it has been removed in an
            // event listener, this might happen in a Control that recreates it's content based on
            // user interaction either manually or via a render in something like https://reactjs.org/
            !currentDoc.contains(target)) return;
        }
        mapBrowserEvent.frameState = this.frameState_;
        if (this.dispatchEvent(mapBrowserEvent) !== false) {
            const interactionsArray = this.getInteractions().getArray().slice();
            for(let i = interactionsArray.length - 1; i >= 0; i--){
                const interaction = interactionsArray[i];
                if (interaction.getMap() !== this || !interaction.getActive() || !this.getTargetElement()) continue;
                const cont = interaction.handleEvent(mapBrowserEvent);
                if (!cont || mapBrowserEvent.propagationStopped) break;
            }
        }
    }
    /**
   * @protected
   */ handlePostRender() {
        const frameState = this.frameState_;
        // Manage the tile queue
        // Image loads are expensive and a limited resource, so try to use them
        // efficiently:
        // * When the view is static we allow a large number of parallel tile loads
        //   to complete the frame as quickly as possible.
        // * When animating or interacting, image loads can cause janks, so we reduce
        //   the maximum number of loads per frame and limit the number of parallel
        //   tile loads to remain reactive to view changes and to reduce the chance of
        //   loading tiles that will quickly disappear from view.
        const tileQueue = this.tileQueue_;
        if (!tileQueue.isEmpty()) {
            let maxTotalLoading = this.maxTilesLoading_;
            let maxNewLoads = maxTotalLoading;
            if (frameState) {
                const hints = frameState.viewHints;
                if (hints[(0, $aKuSF.default).ANIMATING] || hints[(0, $aKuSF.default).INTERACTING]) {
                    const lowOnFrameBudget = Date.now() - frameState.time > 8;
                    maxTotalLoading = lowOnFrameBudget ? 0 : 8;
                    maxNewLoads = lowOnFrameBudget ? 0 : 2;
                }
            }
            if (tileQueue.getTilesLoading() < maxTotalLoading) {
                tileQueue.reprioritize(); // FIXME only call if view has changed
                tileQueue.loadMoreTiles(maxTotalLoading, maxNewLoads);
            }
        }
        if (frameState && this.renderer_ && !frameState.animate) {
            if (this.renderComplete_) {
                if (this.hasListener((0, $l6YBe.default).RENDERCOMPLETE)) this.renderer_.dispatchRenderEvent((0, $l6YBe.default).RENDERCOMPLETE, frameState);
                if (this.loaded_ === false) {
                    this.loaded_ = true;
                    this.dispatchEvent(new (0, $4Zdcs.default)((0, $jDfdj.default).LOADEND, this, frameState));
                }
            } else if (this.loaded_ === true) {
                this.loaded_ = false;
                this.dispatchEvent(new (0, $4Zdcs.default)((0, $jDfdj.default).LOADSTART, this, frameState));
            }
        }
        const postRenderFunctions = this.postRenderFunctions_;
        if (frameState) for(let i = 0, ii = postRenderFunctions.length; i < ii; ++i)postRenderFunctions[i](this, frameState);
        postRenderFunctions.length = 0;
    }
    /**
   * @private
   */ handleSizeChanged_() {
        if (this.getView() && !this.getView().getAnimating()) this.getView().resolveConstraints(0);
        this.render();
    }
    /**
   * @private
   */ handleTargetChanged_() {
        if (this.mapBrowserEventHandler_) {
            for(let i = 0, ii = this.targetChangeHandlerKeys_.length; i < ii; ++i)(0, $ilM9F.unlistenByKey)(this.targetChangeHandlerKeys_[i]);
            this.targetChangeHandlerKeys_ = null;
            this.viewport_.removeEventListener((0, $3xzSb.default).CONTEXTMENU, this.boundHandleBrowserEvent_);
            this.viewport_.removeEventListener((0, $3xzSb.default).WHEEL, this.boundHandleBrowserEvent_);
            this.mapBrowserEventHandler_.dispose();
            this.mapBrowserEventHandler_ = null;
            this.viewport_.remove();
        }
        if (this.targetElement_ && !(0, $DfnQm.isCanvas)(this.targetElement_)) {
            this.resizeObserver_?.unobserve(this.targetElement_);
            const rootNode = this.targetElement_.getRootNode();
            if (rootNode instanceof ShadowRoot) this.resizeObserver_.unobserve(rootNode.host);
            this.setSize(undefined);
        }
        // target may be undefined, null, a string or an Element.
        // If it's a string we convert it to an Element before proceeding.
        // If it's not now an Element we remove the viewport from the DOM.
        // If it's an Element we append the viewport element to it.
        const target = this.getTarget();
        const targetElement = typeof target === 'string' ? document.getElementById(target) : target;
        this.targetElement_ = targetElement;
        if (!targetElement) {
            if (this.renderer_) {
                clearTimeout(this.postRenderTimeoutHandle_);
                this.postRenderTimeoutHandle_ = undefined;
                this.postRenderFunctions_.length = 0;
                this.renderer_.dispose();
                this.renderer_ = null;
            }
            if (this.animationDelayKey_) {
                cancelAnimationFrame(this.animationDelayKey_);
                this.animationDelayKey_ = undefined;
            }
        } else {
            if (!(0, $DfnQm.isCanvas)(targetElement)) targetElement.appendChild(this.viewport_);
            if (!this.renderer_) this.renderer_ = new (0, $lvfQG.default)(this);
            if (!(0, $DfnQm.isCanvas)(targetElement)) {
                this.mapBrowserEventHandler_ = new (0, $8hMRr.default)(this, this.moveTolerance_);
                for(const key in 0, $1O6bd.default)this.mapBrowserEventHandler_.addEventListener((0, $1O6bd.default)[key], this.handleMapBrowserEvent.bind(this));
                this.viewport_.addEventListener((0, $3xzSb.default).CONTEXTMENU, this.boundHandleBrowserEvent_, false);
                this.viewport_.addEventListener((0, $3xzSb.default).WHEEL, this.boundHandleBrowserEvent_, (0, $8UoiJ.PASSIVE_EVENT_LISTENERS) ? {
                    passive: false
                } : false);
                let keyboardEventTarget;
                if (!this.keyboardEventTarget_) {
                    // check if map target is in shadowDOM, if yes use host element as target
                    const targetRoot = targetElement.getRootNode();
                    const targetCandidate = targetRoot instanceof ShadowRoot ? targetRoot.host : targetElement;
                    keyboardEventTarget = targetCandidate;
                } else keyboardEventTarget = this.keyboardEventTarget_;
                this.targetChangeHandlerKeys_ = [
                    (0, $ilM9F.listen)(keyboardEventTarget, (0, $3xzSb.default).KEYDOWN, this.handleBrowserEvent, this),
                    (0, $ilM9F.listen)(keyboardEventTarget, (0, $3xzSb.default).KEYPRESS, this.handleBrowserEvent, this)
                ];
                if (targetElement instanceof HTMLElement) {
                    const rootNode = targetElement.getRootNode();
                    if (rootNode instanceof ShadowRoot) this.resizeObserver_.observe(rootNode.host);
                    this.resizeObserver_?.observe(targetElement);
                }
            }
            this.updateSize();
        }
    // updateSize calls setSize, so no need to call this.render
    // ourselves here.
    }
    /**
   * @private
   */ handleTileChange_() {
        this.render();
    }
    /**
   * @private
   */ handleViewPropertyChanged_() {
        this.render();
    }
    /**
   * @private
   */ handleViewChanged_() {
        if (this.viewPropertyListenerKey_) {
            (0, $ilM9F.unlistenByKey)(this.viewPropertyListenerKey_);
            this.viewPropertyListenerKey_ = null;
        }
        if (this.viewChangeListenerKey_) {
            (0, $ilM9F.unlistenByKey)(this.viewChangeListenerKey_);
            this.viewChangeListenerKey_ = null;
        }
        const view = this.getView();
        if (view) {
            this.updateViewportSize_(this.getSize());
            this.viewPropertyListenerKey_ = (0, $ilM9F.listen)(view, (0, $jXCUw.default).PROPERTYCHANGE, this.handleViewPropertyChanged_, this);
            this.viewChangeListenerKey_ = (0, $ilM9F.listen)(view, (0, $3xzSb.default).CHANGE, this.handleViewPropertyChanged_, this);
            view.resolveConstraints(0);
        }
        this.render();
    }
    /**
   * @private
   */ handleLayerGroupChanged_() {
        if (this.layerGroupPropertyListenerKeys_) {
            this.layerGroupPropertyListenerKeys_.forEach((0, $ilM9F.unlistenByKey));
            this.layerGroupPropertyListenerKeys_ = null;
        }
        const layerGroup = this.getLayerGroup();
        if (layerGroup) {
            this.handleLayerAdd_(new (0, $YSU3I.GroupEvent)('addlayer', layerGroup));
            this.layerGroupPropertyListenerKeys_ = [
                (0, $ilM9F.listen)(layerGroup, (0, $jXCUw.default).PROPERTYCHANGE, this.render, this),
                (0, $ilM9F.listen)(layerGroup, (0, $3xzSb.default).CHANGE, this.render, this),
                (0, $ilM9F.listen)(layerGroup, 'addlayer', this.handleLayerAdd_, this),
                (0, $ilM9F.listen)(layerGroup, 'removelayer', this.handleLayerRemove_, this)
            ];
        }
        this.render();
    }
    /**
   * @return {boolean} Is rendered.
   */ isRendered() {
        return !!this.frameState_;
    }
    /**
   * @private
   */ animationDelay_() {
        this.animationDelayKey_ = undefined;
        this.renderFrame_(Date.now());
    }
    /**
   * Requests an immediate render in a synchronous manner.
   * @api
   */ renderSync() {
        if (this.animationDelayKey_) cancelAnimationFrame(this.animationDelayKey_);
        this.animationDelay_();
    }
    /**
   * Redraws all text after new fonts have loaded
   */ redrawText() {
        if (!this.frameState_) return;
        const layerStates = this.frameState_.layerStatesArray;
        for(let i = 0, ii = layerStates.length; i < ii; ++i){
            const layer = layerStates[i].layer;
            if (layer.hasRenderer()) layer.getRenderer().handleFontsChanged();
        }
    }
    /**
   * Request a map rendering (at the next animation frame).
   * @api
   */ render() {
        if (this.renderer_ && this.animationDelayKey_ === undefined) this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_);
    }
    /**
   * Remove the given control from the map.
   * @param {import("./control/Control.js").default} control Control.
   * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
   *     if the control was not found).
   * @api
   */ removeControl(control) {
        return this.getControls().remove(control);
    }
    /**
   * Remove the given interaction from the map.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
   * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
   *     undefined if the interaction was not found).
   * @api
   */ removeInteraction(interaction) {
        return this.getInteractions().remove(interaction);
    }
    /**
   * Removes the given layer from the map.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
   *     layer was not found).
   * @api
   */ removeLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        return layers.remove(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer remove event.
   * @private
   */ handleLayerRemove_(event) {
        $41aa29ae0c4b607a$var$removeLayerMapProperty(event.layer);
    }
    /**
   * Remove the given overlay from the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
   *     if the overlay was not found).
   * @api
   */ removeOverlay(overlay) {
        return this.getOverlays().remove(overlay);
    }
    /**
   * @param {number} time Time.
   * @private
   */ renderFrame_(time) {
        const size = this.getSize();
        const view = this.getView();
        const previousFrameState = this.frameState_;
        /** @type {?FrameState} */ let frameState = null;
        if (size !== undefined && (0, $hxhPO.hasArea)(size) && view && view.isDef()) {
            const viewHints = view.getHints(this.frameState_ ? this.frameState_.viewHints : undefined);
            const viewState = view.getState();
            frameState = {
                animate: false,
                coordinateToPixelTransform: this.coordinateToPixelTransform_,
                declutter: null,
                extent: (0, $9pD6L.getForViewAndSize)(viewState.center, viewState.resolution, viewState.rotation, size),
                index: this.frameIndex_++,
                layerIndex: 0,
                layerStatesArray: this.getLayerGroup().getLayerStatesArray(),
                pixelRatio: this.pixelRatio_,
                pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
                postRenderFunctions: [],
                size: size,
                tileQueue: this.tileQueue_,
                time: time,
                usedTiles: {},
                viewState: viewState,
                viewHints: viewHints,
                wantedTiles: {},
                mapId: (0, $9iPUS.getUid)(this),
                renderTargets: {}
            };
            if (viewState.nextCenter && viewState.nextResolution) {
                const rotation = isNaN(viewState.nextRotation) ? viewState.rotation : viewState.nextRotation;
                frameState.nextExtent = (0, $9pD6L.getForViewAndSize)(viewState.nextCenter, viewState.nextResolution, rotation, size);
            }
        }
        this.frameState_ = frameState;
        this.renderer_.renderFrame(frameState);
        if (frameState) {
            if (frameState.animate) this.render();
            Array.prototype.push.apply(this.postRenderFunctions_, frameState.postRenderFunctions);
            if (previousFrameState) {
                const moveStart = !this.previousExtent_ || !(0, $9pD6L.isEmpty)(this.previousExtent_) && !(0, $9pD6L.equals)(frameState.extent, this.previousExtent_);
                if (moveStart) {
                    this.dispatchEvent(new (0, $4Zdcs.default)((0, $jDfdj.default).MOVESTART, this, previousFrameState));
                    this.previousExtent_ = (0, $9pD6L.createOrUpdateEmpty)(this.previousExtent_);
                }
            }
            const idle = this.previousExtent_ && !frameState.viewHints[(0, $aKuSF.default).ANIMATING] && !frameState.viewHints[(0, $aKuSF.default).INTERACTING] && !(0, $9pD6L.equals)(frameState.extent, this.previousExtent_);
            if (idle) {
                this.dispatchEvent(new (0, $4Zdcs.default)((0, $jDfdj.default).MOVEEND, this, frameState));
                (0, $9pD6L.clone)(frameState.extent, this.previousExtent_);
            }
        }
        this.dispatchEvent(new (0, $4Zdcs.default)((0, $jDfdj.default).POSTRENDER, this, frameState));
        this.renderComplete_ = (this.hasListener((0, $jDfdj.default).LOADSTART) || this.hasListener((0, $jDfdj.default).LOADEND) || this.hasListener((0, $l6YBe.default).RENDERCOMPLETE)) && !this.tileQueue_.getTilesLoading() && !this.tileQueue_.getCount() && !this.getLoadingOrNotReady();
        if (!this.postRenderTimeoutHandle_) this.postRenderTimeoutHandle_ = setTimeout(()=>{
            this.postRenderTimeoutHandle_ = undefined;
            this.handlePostRender();
        }, 0);
    }
    /**
   * Sets the layergroup of this map.
   * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
   * @observable
   * @api
   */ setLayerGroup(layerGroup) {
        const oldLayerGroup = this.getLayerGroup();
        if (oldLayerGroup) this.handleLayerRemove_(new (0, $YSU3I.GroupEvent)('removelayer', oldLayerGroup));
        this.set((0, $GsIjZ.default).LAYERGROUP, layerGroup);
    }
    /**
   * Set the size of this map.
   * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ setSize(size) {
        this.set((0, $GsIjZ.default).SIZE, size);
    }
    /**
   * Set the target element to render this map into.
   * For accessibility (focus and keyboard events for map navigation), the `target` element must have a
   *  properly configured `tabindex` attribute. If the `target` element is inside a Shadow DOM, the
   *  `tabindex` atribute must be set on the custom element's host element.
   * @param {HTMLElement|string} [target] The Element or id of the Element
   *     that the map is rendered in.
   * @observable
   * @api
   */ setTarget(target) {
        this.set((0, $GsIjZ.default).TARGET, target);
    }
    /**
   * Set the view for this map.
   * @param {View|Promise<import("./View.js").ViewOptions>|null} view The view that controls this map.
   * It is also possible to pass a promise that resolves to options for constructing a view.  This
   * alternative allows view properties to be resolved by sources or other components that load
   * view-related metadata.
   * @observable
   * @api
   */ setView(view) {
        if (!view || view instanceof (0, $9DiKA.default)) {
            this.set((0, $GsIjZ.default).VIEW, view);
            return;
        }
        this.set((0, $GsIjZ.default).VIEW, new (0, $9DiKA.default)());
        const map = this;
        view.then(function(viewOptions) {
            map.setView(new (0, $9DiKA.default)(viewOptions));
        });
    }
    /**
   * Force a recalculation of the map viewport size.  This should be called when
   * third-party code changes the size of the map viewport.
   * @api
   */ updateSize() {
        const targetElement = this.getTargetElement();
        let size = undefined;
        if (targetElement) {
            let width, height;
            if ((0, $DfnQm.isCanvas)(targetElement)) {
                const transform = targetElement.getContext('2d').getTransform();
                // Use scale components of the transform to calculate the size in CSS pixels
                width = targetElement.width / transform.a;
                height = targetElement.height / transform.d;
            } else {
                const computedStyle = getComputedStyle(targetElement);
                width = targetElement.offsetWidth - parseFloat(computedStyle['borderLeftWidth']) - parseFloat(computedStyle['paddingLeft']) - parseFloat(computedStyle['paddingRight']) - parseFloat(computedStyle['borderRightWidth']);
                height = targetElement.offsetHeight - parseFloat(computedStyle['borderTopWidth']) - parseFloat(computedStyle['paddingTop']) - parseFloat(computedStyle['paddingBottom']) - parseFloat(computedStyle['borderBottomWidth']);
            }
            if (!isNaN(width) && !isNaN(height)) {
                size = [
                    Math.max(0, width),
                    Math.max(0, height)
                ];
                if (!(0, $hxhPO.hasArea)(size) && !!(targetElement.offsetWidth || targetElement.offsetHeight || targetElement.getClientRects().length)) (0, $c3kwQ.warn)("No map visible because the map container's width or height are 0.");
            }
        }
        const oldSize = this.getSize();
        if (size && (!oldSize || !(0, $fVVyM.equals)(size, oldSize))) {
            this.setSize(size);
            this.updateViewportSize_(size);
        }
    }
    /**
   * Recomputes the viewport size and save it on the view object (if any)
   * @param {import("./size.js").Size|undefined} size The size.
   * @private
   */ updateViewportSize_(size) {
        const view = this.getView();
        if (view) view.setViewportSize(size);
    }
}
/**
 * @param {MapOptions} options Map options.
 * @return {MapOptionsInternal} Internal map options.
 */ function $41aa29ae0c4b607a$var$createOptionsInternal(options) {
    /**
   * @type {HTMLElement|Document}
   */ let keyboardEventTarget = null;
    if (options.keyboardEventTarget !== undefined) keyboardEventTarget = typeof options.keyboardEventTarget === 'string' ? document.getElementById(options.keyboardEventTarget) : options.keyboardEventTarget;
    /**
   * @type {Object<string, *>}
   */ const values = {};
    const layerGroup = options.layers && typeof /** @type {?} */ options.layers.getLayers === 'function' ? /** @type {LayerGroup} */ options.layers : new (0, $YSU3I.default)({
        layers: /** @type {Collection<import("./layer/Base.js").default>|Array<import("./layer/Base.js").default>} */ options.layers
    });
    values[(0, $GsIjZ.default).LAYERGROUP] = layerGroup;
    values[(0, $GsIjZ.default).TARGET] = options.target;
    values[(0, $GsIjZ.default).VIEW] = options.view instanceof (0, $9DiKA.default) ? options.view : new (0, $9DiKA.default)();
    /** @type {Collection<import("./control/Control.js").default>} */ let controls;
    if (options.controls !== undefined) {
        if (Array.isArray(options.controls)) controls = new (0, $cD8Qe.default)(options.controls.slice());
        else {
            (0, $4Cz58.assert)(typeof /** @type {?} */ options.controls.getArray === 'function', 'Expected `controls` to be an array or an `ol/Collection.js`');
            controls = options.controls;
        }
    }
    /** @type {Collection<import("./interaction/Interaction").default>} */ let interactions;
    if (options.interactions !== undefined) {
        if (Array.isArray(options.interactions)) interactions = new (0, $cD8Qe.default)(options.interactions.slice());
        else {
            (0, $4Cz58.assert)(typeof /** @type {?} */ options.interactions.getArray === 'function', 'Expected `interactions` to be an array or an `ol/Collection.js`');
            interactions = options.interactions;
        }
    }
    /** @type {Collection<import("./Overlay.js").default>} */ let overlays;
    if (options.overlays !== undefined) {
        if (Array.isArray(options.overlays)) overlays = new (0, $cD8Qe.default)(options.overlays.slice());
        else {
            (0, $4Cz58.assert)(typeof /** @type {?} */ options.overlays.getArray === 'function', 'Expected `overlays` to be an array or an `ol/Collection.js`');
            overlays = options.overlays;
        }
    } else overlays = new (0, $cD8Qe.default)();
    return {
        controls: controls,
        interactions: interactions,
        keyboardEventTarget: keyboardEventTarget,
        overlays: overlays,
        values: values
    };
}
var $41aa29ae0c4b607a$export$2e2bcd8739ae039 = $41aa29ae0c4b607a$var$Map;

});
parcelRegister("cD8Qe", function(module, exports) {

$parcel$export(module.exports, "default", () => $931ffc4e747c14db$export$2e2bcd8739ae039);
/**
 * @module ol/Collection
 */ 
var $1TIYs = parcelRequire("1TIYs");

var $fFFY7 = parcelRequire("fFFY7");

var $f18Q2 = parcelRequire("f18Q2");
/**
 * @enum {string}
 * @private
 */ const $931ffc4e747c14db$var$Property = {
    LENGTH: 'length'
};
class $931ffc4e747c14db$export$a87ae6eb2761ec6d extends (0, $f18Q2.default) {
    /**
   * @param {import("./CollectionEventType.js").default} type Type.
   * @param {T} element Element.
   * @param {number} index The index of the added or removed element.
   */ constructor(type, element, index){
        super(type);
        /**
     * The element that is added to or removed from the collection.
     * @type {T}
     * @api
     */ this.element = element;
        /**
     * The index of the added or removed element.
     * @type {number}
     * @api
     */ this.index = index;
    }
}
/***
 * @template T
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:length', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").OnSignature<'add'|'remove', CollectionEvent<T>, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types|
 *     'change:length'|'add'|'remove',Return>} CollectionOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {boolean} [unique=false] Disallow the same item from being added to
 * the collection twice.
 */ /**
 * @classdesc
 * An expanded version of standard JS Array, adding convenience methods for
 * manipulation. Add and remove changes to the Collection trigger a Collection
 * event. Note that this does not cover changes to the objects _within_ the
 * Collection; they trigger events on the appropriate object, not on the
 * Collection as a whole.
 *
 * @fires CollectionEvent
 *
 * @template T
 * @api
 */ class $931ffc4e747c14db$var$Collection extends (0, $fFFY7.default) {
    /**
   * @param {Array<T>} [array] Array.
   * @param {Options} [options] Collection options.
   */ constructor(array, options){
        super();
        /***
     * @type {CollectionOnSignature<T, import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {CollectionOnSignature<T, import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {CollectionOnSignature<T, void>}
     */ this.un;
        options = options || {};
        /**
     * @private
     * @type {boolean}
     */ this.unique_ = !!options.unique;
        /**
     * @private
     * @type {!Array<T>}
     */ this.array_ = array ?? [];
        if (this.unique_) for(let i = 1, ii = this.array_.length; i < ii; ++i)this.assertUnique_(this.array_[i], i);
        this.updateLength_();
    }
    /**
   * Remove all elements from the collection.
   * @api
   */ clear() {
        while(this.getLength() > 0)this.pop();
    }
    /**
   * Add elements to the collection.  This pushes each item in the provided array
   * to the end of the collection.
   * @param {!Array<T>} arr Array.
   * @return {Collection<T>} This collection.
   * @api
   */ extend(arr) {
        for(let i = 0, ii = arr.length; i < ii; ++i)this.push(arr[i]);
        return this;
    }
    /**
   * Iterate over each element, calling the provided callback.
   * @param {function(T, number, Array<T>): *} f The function to call
   *     for every element. This function takes 3 arguments (the element, the
   *     index and the array). The return value is ignored.
   * @api
   */ forEach(f) {
        const array = this.array_;
        for(let i = 0, ii = array.length; i < ii; ++i)f(array[i], i, array);
    }
    /**
   * Get a reference to the underlying Array object. Warning: if the array
   * is mutated, no events will be dispatched by the collection, and the
   * collection's "length" property won't be in sync with the actual length
   * of the array.
   * @return {!Array<T>} Array.
   * @api
   */ getArray() {
        return this.array_;
    }
    /**
   * Get the element at the provided index.
   * @param {number} index Index.
   * @return {T} Element.
   * @api
   */ item(index) {
        return this.array_[index];
    }
    /**
   * Get the length of this collection.
   * @return {number} The length of the array.
   * @observable
   * @api
   */ getLength() {
        return this.get($931ffc4e747c14db$var$Property.LENGTH);
    }
    /**
   * Insert an element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ insertAt(index, elem) {
        if (index < 0 || index > this.getLength()) throw new Error('Index out of bounds: ' + index);
        if (this.unique_) this.assertUnique_(elem);
        this.array_.splice(index, 0, elem);
        this.updateLength_();
        this.dispatchEvent(new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $1TIYs.default).ADD, elem, index));
    }
    /**
   * Remove the last element of the collection and return it.
   * Return `undefined` if the collection is empty.
   * @return {T|undefined} Element.
   * @api
   */ pop() {
        return this.removeAt(this.getLength() - 1);
    }
    /**
   * Insert the provided element at the end of the collection.
   * @param {T} elem Element.
   * @return {number} New length of the collection.
   * @api
   */ push(elem) {
        const n = this.getLength();
        this.insertAt(n, elem);
        return this.getLength();
    }
    /**
   * Remove the first occurrence of an element from the collection.
   * @param {T} elem Element.
   * @return {T|undefined} The removed element or undefined if none found.
   * @api
   */ remove(elem) {
        const arr = this.array_;
        for(let i = 0, ii = arr.length; i < ii; ++i){
            if (arr[i] === elem) return this.removeAt(i);
        }
        return undefined;
    }
    /**
   * Remove the element at the provided index and return it.
   * Return `undefined` if the collection does not contain this index.
   * @param {number} index Index.
   * @return {T|undefined} Value.
   * @api
   */ removeAt(index) {
        if (index < 0 || index >= this.getLength()) return undefined;
        const prev = this.array_[index];
        this.array_.splice(index, 1);
        this.updateLength_();
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $1TIYs.default).REMOVE, prev, index));
        return prev;
    }
    /**
   * Set the element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ setAt(index, elem) {
        const n = this.getLength();
        if (index >= n) {
            this.insertAt(index, elem);
            return;
        }
        if (index < 0) throw new Error('Index out of bounds: ' + index);
        if (this.unique_) this.assertUnique_(elem, index);
        const prev = this.array_[index];
        this.array_[index] = elem;
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $1TIYs.default).REMOVE, prev, index));
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $1TIYs.default).ADD, elem, index));
    }
    /**
   * @private
   */ updateLength_() {
        this.set($931ffc4e747c14db$var$Property.LENGTH, this.array_.length);
    }
    /**
   * @private
   * @param {T} elem Element.
   * @param {number} [except] Optional index to ignore.
   */ assertUnique_(elem, except) {
        const array = this.array_;
        for(let i = 0, ii = array.length; i < ii; ++i){
            if (array[i] === elem && i !== except) throw new Error('Duplicate item added to a unique collection');
        }
    }
}
var $931ffc4e747c14db$export$2e2bcd8739ae039 = $931ffc4e747c14db$var$Collection;

});
parcelRegister("1TIYs", function(module, exports) {

$parcel$export(module.exports, "default", () => $161dd067fe2d672c$export$2e2bcd8739ae039);
/**
 * @module ol/CollectionEventType
 */ /**
 * @enum {string}
 */ var $161dd067fe2d672c$export$2e2bcd8739ae039 = {
    /**
   * Triggered when an item is added to the collection.
   * @event module:ol/Collection.CollectionEvent#add
   * @api
   */ ADD: 'add',
    /**
   * Triggered when an item is removed from the collection.
   * @event module:ol/Collection.CollectionEvent#remove
   * @api
   */ REMOVE: 'remove'
};

});


parcelRegister("dSQBl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1b91f073c6a6c43$export$2e2bcd8739ae039);
/**
 * @module ol/MapBrowserEvent
 */ 
var $4Zdcs = parcelRequire("4Zdcs");
/**
 * @classdesc
 * Events emitted as map browser events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map browser event.
 * @template {PointerEvent|KeyboardEvent|WheelEvent} [EVENT=PointerEvent|KeyboardEvent|WheelEvent]
 */ class $a1b91f073c6a6c43$var$MapBrowserEvent extends (0, $4Zdcs.default) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {EVENT} originalEvent Original event.
   * @param {boolean} [dragging] Is the map currently being dragged?
   * @param {import("./Map.js").FrameState} [frameState] Frame state.
   * @param {Array<PointerEvent>} [activePointers] Active pointers.
   */ constructor(type, map, originalEvent, dragging, frameState, activePointers){
        super(type, map, frameState);
        /**
     * The original browser event.
     * @const
     * @type {EVENT}
     * @api
     */ this.originalEvent = originalEvent;
        /**
     * The map pixel relative to the viewport corresponding to the original browser event.
     * @type {?import("./pixel.js").Pixel}
     * @private
     */ this.pixel_ = null;
        /**
     * The coordinate in the user projection corresponding to the original browser event.
     * @type {?import("./coordinate.js").Coordinate}
     * @private
     */ this.coordinate_ = null;
        /**
     * Indicates if the map is currently being dragged. Only set for
     * `POINTERDRAG` and `POINTERMOVE` events. Default is `false`.
     *
     * @type {boolean}
     * @api
     */ this.dragging = dragging !== undefined ? dragging : false;
        /**
     * @type {Array<PointerEvent>|undefined}
     */ this.activePointers = activePointers;
    }
    /**
   * The map pixel relative to the viewport corresponding to the original event.
   * @type {import("./pixel.js").Pixel}
   * @api
   */ get pixel() {
        if (!this.pixel_) this.pixel_ = this.map.getEventPixel(this.originalEvent);
        return this.pixel_;
    }
    set pixel(pixel) {
        this.pixel_ = pixel;
    }
    /**
   * The coordinate corresponding to the original browser event.  This will be in the user
   * projection if one is set.  Otherwise it will be in the view projection.
   * @type {import("./coordinate.js").Coordinate}
   * @api
   */ get coordinate() {
        if (!this.coordinate_) this.coordinate_ = this.map.getCoordinateFromPixel(this.pixel);
        return this.coordinate_;
    }
    set coordinate(coordinate) {
        this.coordinate_ = coordinate;
    }
    /**
   * Prevents the default browser action.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
   * @api
   * @override
   */ preventDefault() {
        super.preventDefault();
        if ('preventDefault' in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.preventDefault();
    }
    /**
   * Prevents further propagation of the current event.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
   * @api
   * @override
   */ stopPropagation() {
        super.stopPropagation();
        if ('stopPropagation' in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.stopPropagation();
    }
}
var $a1b91f073c6a6c43$export$2e2bcd8739ae039 = $a1b91f073c6a6c43$var$MapBrowserEvent;

});
parcelRegister("4Zdcs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a171922c3a0c5ed$export$2e2bcd8739ae039);
/**
 * @module ol/MapEvent
 */ 
var $f18Q2 = parcelRequire("f18Q2");
/**
 * @classdesc
 * Events emitted as map events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map event.
 */ class $3a171922c3a0c5ed$var$MapEvent extends (0, $f18Q2.default) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {?import("./Map.js").FrameState} [frameState] Frame state.
   */ constructor(type, map, frameState){
        super(type);
        /**
     * The map where the event occurred.
     * @type {import("./Map.js").default}
     * @api
     */ this.map = map;
        /**
     * The frame state at the time of the event.
     * @type {?import("./Map.js").FrameState}
     * @api
     */ this.frameState = frameState !== undefined ? frameState : null;
    }
}
var $3a171922c3a0c5ed$export$2e2bcd8739ae039 = $3a171922c3a0c5ed$var$MapEvent;

});


parcelRegister("8hMRr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6085d006f9d0efe2$export$2e2bcd8739ae039);
/**
 * @module ol/MapBrowserEventHandler
 */ 
var $dSQBl = parcelRequire("dSQBl");

var $1O6bd = parcelRequire("1O6bd");

var $3xzSb = parcelRequire("3xzSb");

var $KD0eF = parcelRequire("KD0eF");

var $ilM9F = parcelRequire("ilM9F");

var $8UoiJ = parcelRequire("8UoiJ");

var $ijSzV = parcelRequire("ijSzV");
class $6085d006f9d0efe2$var$MapBrowserEventHandler extends (0, $KD0eF.default) {
    /**
   * @param {import("./Map.js").default} map The map with the viewport to listen to events on.
   * @param {number} [moveTolerance] The minimal distance the pointer must travel to trigger a move.
   */ constructor(map, moveTolerance){
        super(map);
        /**
     * This is the element that we will listen to the real events on.
     * @type {import("./Map.js").default}
     * @private
     */ this.map_ = map;
        /**
     * @type {ReturnType<typeof setTimeout>}
     * @private
     */ this.clickTimeoutId_;
        /**
     * Emulate dblclick and singleclick. Will be true when only one pointer is active.
     * @type {boolean}
     */ this.emulateClicks_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.dragging_ = false;
        /**
     * @type {!Array<import("./events.js").EventsKey>}
     * @private
     */ this.dragListenerKeys_ = [];
        /**
     * @type {number}
     * @private
     */ this.moveTolerance_ = moveTolerance === undefined ? 1 : moveTolerance;
        /**
     * The most recent "down" type event (or null if none have occurred).
     * Set on pointerdown.
     * @type {PointerEvent|null}
     * @private
     */ this.down_ = null;
        const element = this.map_.getViewport();
        /**
     * @type {Array<PointerEvent>}
     * @private
     */ this.activePointers_ = [];
        /**
     * @type {!Object<number, Event>}
     * @private
     */ this.trackedTouches_ = {};
        /**
     * @private
     */ this.element_ = element;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.pointerdownListenerKey_ = (0, $ilM9F.listen)(element, (0, $ijSzV.default).POINTERDOWN, this.handlePointerDown_, this);
        /**
     * @type {PointerEvent}
     * @private
     */ this.originalPointerMoveEvent_;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.relayedListenerKey_ = (0, $ilM9F.listen)(element, (0, $ijSzV.default).POINTERMOVE, this.relayMoveEvent_, this);
        /**
     * @private
     */ this.boundHandleTouchMove_ = this.handleTouchMove_.bind(this);
        this.element_.addEventListener((0, $3xzSb.default).TOUCHMOVE, this.boundHandleTouchMove_, (0, $8UoiJ.PASSIVE_EVENT_LISTENERS) ? {
            passive: false
        } : false);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ emulateClick_(pointerEvent) {
        let newEvent = new (0, $dSQBl.default)((0, $1O6bd.default).CLICK, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        if (this.clickTimeoutId_ !== undefined) {
            // double-click
            clearTimeout(this.clickTimeoutId_);
            this.clickTimeoutId_ = undefined;
            newEvent = new (0, $dSQBl.default)((0, $1O6bd.default).DBLCLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        } else // click
        this.clickTimeoutId_ = setTimeout(()=>{
            this.clickTimeoutId_ = undefined;
            const newEvent = new (0, $dSQBl.default)((0, $1O6bd.default).SINGLECLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        }, 250);
    }
    /**
   * Keeps track on how many pointers are currently active.
   *
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ updateActivePointers_(pointerEvent) {
        const event = pointerEvent;
        const id = event.pointerId;
        if (event.type == (0, $1O6bd.default).POINTERUP || event.type == (0, $1O6bd.default).POINTERCANCEL) {
            delete this.trackedTouches_[id];
            for(const pointerId in this.trackedTouches_)if (this.trackedTouches_[pointerId].target !== event.target) {
                // Some platforms assign a new pointerId when the target changes.
                // If this happens, delete one tracked pointer. If there is more
                // than one tracked pointer for the old target, it will be cleared
                // by subsequent POINTERUP events from other pointers.
                delete this.trackedTouches_[pointerId];
                break;
            }
        } else if (event.type == (0, $1O6bd.default).POINTERDOWN || event.type == (0, $1O6bd.default).POINTERMOVE) this.trackedTouches_[id] = event;
        this.activePointers_ = Object.values(this.trackedTouches_);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerUp_(pointerEvent) {
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, $dSQBl.default)((0, $1O6bd.default).POINTERUP, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        // We emulate click events on left mouse button click, touch contact, and pen
        // contact. isMouseActionButton returns true in these cases (evt.button is set
        // to 0).
        // See http://www.w3.org/TR/pointerevents/#button-states
        // We only fire click, singleclick, and doubleclick if nobody has called
        // event.preventDefault().
        if (this.emulateClicks_ && !newEvent.defaultPrevented && !this.dragging_ && this.isMouseActionButton_(pointerEvent)) this.emulateClick_(this.down_);
        if (this.activePointers_.length === 0) {
            this.dragListenerKeys_.forEach((0, $ilM9F.unlistenByKey));
            this.dragListenerKeys_.length = 0;
            this.dragging_ = false;
            this.down_ = null;
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} If the left mouse button was pressed.
   * @private
   */ isMouseActionButton_(pointerEvent) {
        return pointerEvent.button === 0;
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerDown_(pointerEvent) {
        this.emulateClicks_ = this.activePointers_.length === 0;
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, $dSQBl.default)((0, $1O6bd.default).POINTERDOWN, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        this.down_ = new PointerEvent(pointerEvent.type, pointerEvent);
        Object.defineProperty(this.down_, 'target', {
            writable: false,
            value: pointerEvent.target
        });
        if (this.dragListenerKeys_.length === 0) {
            const doc = this.map_.getOwnerDocument();
            this.dragListenerKeys_.push((0, $ilM9F.listen)(doc, (0, $1O6bd.default).POINTERMOVE, this.handlePointerMove_, this), (0, $ilM9F.listen)(doc, (0, $1O6bd.default).POINTERUP, this.handlePointerUp_, this), /* Note that the listener for `pointercancel is set up on
         * `pointerEventHandler_` and not `documentPointerEventHandler_` like
         * the `pointerup` and `pointermove` listeners.
         *
         * The reason for this is the following: `TouchSource.vacuumTouches_()`
         * issues `pointercancel` events, when there was no `touchend` for a
         * `touchstart`. Now, let's say a first `touchstart` is registered on
         * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
         * But `documentPointerEventHandler_` doesn't know about the first
         * `touchstart`. If there is no `touchend` for the `touchstart`, we can
         * only receive a `touchcancel` from `pointerEventHandler_`, because it is
         * only registered there.
         */ (0, $ilM9F.listen)(this.element_, (0, $1O6bd.default).POINTERCANCEL, this.handlePointerUp_, this));
            if (this.element_.getRootNode && this.element_.getRootNode() !== doc) this.dragListenerKeys_.push((0, $ilM9F.listen)(this.element_.getRootNode(), (0, $1O6bd.default).POINTERUP, this.handlePointerUp_, this));
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerMove_(pointerEvent) {
        // Between pointerdown and pointerup, pointermove events are triggered.
        // To avoid a 'false' touchmove event to be dispatched, we test if the pointer
        // moved a significant distance.
        if (this.isMoving_(pointerEvent)) {
            this.updateActivePointers_(pointerEvent);
            this.dragging_ = true;
            const newEvent = new (0, $dSQBl.default)((0, $1O6bd.default).POINTERDRAG, this.map_, pointerEvent, this.dragging_, undefined, this.activePointers_);
            this.dispatchEvent(newEvent);
        }
    }
    /**
   * Wrap and relay a pointermove event.
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ relayMoveEvent_(pointerEvent) {
        this.originalPointerMoveEvent_ = pointerEvent;
        const dragging = !!(this.down_ && this.isMoving_(pointerEvent));
        this.dispatchEvent(new (0, $dSQBl.default)((0, $1O6bd.default).POINTERMOVE, this.map_, pointerEvent, dragging));
    }
    /**
   * Flexible handling of a `touch-action: none` css equivalent: because calling
   * `preventDefault()` on a `pointermove` event does not stop native page scrolling
   * and zooming, we also listen for `touchmove` and call `preventDefault()` on it
   * when an interaction (currently `DragPan` handles the event.
   * @param {TouchEvent} event Event.
   * @private
   */ handleTouchMove_(event) {
        // Due to https://github.com/mpizenberg/elm-pep/issues/2, `this.originalPointerMoveEvent_`
        // may not be initialized yet when we get here on a platform without native pointer events,
        // when elm-pep is used as pointer events polyfill.
        const originalEvent = this.originalPointerMoveEvent_;
        if ((!originalEvent || originalEvent.defaultPrevented) && (typeof event.cancelable !== 'boolean' || event.cancelable === true)) event.preventDefault();
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} Is moving.
   * @private
   */ isMoving_(pointerEvent) {
        return this.dragging_ || Math.abs(pointerEvent.clientX - this.down_.clientX) > this.moveTolerance_ || Math.abs(pointerEvent.clientY - this.down_.clientY) > this.moveTolerance_;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.relayedListenerKey_) {
            (0, $ilM9F.unlistenByKey)(this.relayedListenerKey_);
            this.relayedListenerKey_ = null;
        }
        this.element_.removeEventListener((0, $3xzSb.default).TOUCHMOVE, this.boundHandleTouchMove_);
        if (this.pointerdownListenerKey_) {
            (0, $ilM9F.unlistenByKey)(this.pointerdownListenerKey_);
            this.pointerdownListenerKey_ = null;
        }
        this.dragListenerKeys_.forEach((0, $ilM9F.unlistenByKey));
        this.dragListenerKeys_.length = 0;
        this.element_ = null;
        super.disposeInternal();
    }
}
var $6085d006f9d0efe2$export$2e2bcd8739ae039 = $6085d006f9d0efe2$var$MapBrowserEventHandler;

});
parcelRegister("1O6bd", function(module, exports) {

$parcel$export(module.exports, "default", () => $150f412a4a7fa263$export$2e2bcd8739ae039);
/**
 * @module ol/MapBrowserEventType
 */ 
var $3xzSb = parcelRequire("3xzSb");
var /**
 * Constants for event names.
 * @enum {string}
 */ $150f412a4a7fa263$export$2e2bcd8739ae039 /***
 * @typedef {'singleclick'|'click'|'dblclick'|'pointerdrag'|'pointermove'} Types
 */  = {
    /**
   * A true single click with no dragging and no double click. Note that this
   * event is delayed by 250 ms to ensure that it is not a double click.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
   * @api
   */ SINGLECLICK: 'singleclick',
    /**
   * A click with no dragging. A double click will fire two of this.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
   * @api
   */ CLICK: (0, $3xzSb.default).CLICK,
    /**
   * A true double click, with no dragging.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
   * @api
   */ DBLCLICK: (0, $3xzSb.default).DBLCLICK,
    /**
   * Triggered when a pointer is dragged.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
   * @api
   */ POINTERDRAG: 'pointerdrag',
    /**
   * Triggered when a pointer is moved. Note that on touch devices this is
   * triggered when the map is panned, so is not the same as mousemove.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
   * @api
   */ POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel'
};

});

parcelRegister("ijSzV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d564567e31203d44$export$2e2bcd8739ae039);
/**
 * @module ol/pointer/EventType
 */ /**
 * Constants for event names.
 * @enum {string}
 */ var $d564567e31203d44$export$2e2bcd8739ae039 = {
    POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel'
};

});


parcelRegister("jDfdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4ad75f913b6f7ff$export$2e2bcd8739ae039);
/**
 * @module ol/MapEventType
 */ /**
 * @enum {string}
 */ var $e4ad75f913b6f7ff$export$2e2bcd8739ae039 /***
 * @typedef {'postrender'|'movestart'|'moveend'|'loadstart'|'loadend'} Types
 */  = {
    /**
   * Triggered after a map frame is rendered.
   * @event module:ol/MapEvent~MapEvent#postrender
   * @api
   */ POSTRENDER: 'postrender',
    /**
   * Triggered when the map starts moving.
   * @event module:ol/MapEvent~MapEvent#movestart
   * @api
   */ MOVESTART: 'movestart',
    /**
   * Triggered after the map is moved.
   * @event module:ol/MapEvent~MapEvent#moveend
   * @api
   */ MOVEEND: 'moveend',
    /**
   * Triggered when loading of additional map data (tiles, images, features) starts.
   * @event module:ol/MapEvent~MapEvent#loadstart
   * @api
   */ LOADSTART: 'loadstart',
    /**
   * Triggered when loading of additional map data has completed.
   * @event module:ol/MapEvent~MapEvent#loadend
   * @api
   */ LOADEND: 'loadend'
};

});

parcelRegister("GsIjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $07fa325567004bb7$export$2e2bcd8739ae039);
/**
 * @module ol/MapProperty
 */ /**
 * @enum {string}
 */ var $07fa325567004bb7$export$2e2bcd8739ae039 = {
    LAYERGROUP: 'layergroup',
    SIZE: 'size',
    TARGET: 'target',
    VIEW: 'view'
};

});

parcelRegister("6yfyT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c51fd53052a6bbc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getTilePriority", () => $4c51fd53052a6bbc$export$f08ad5eceeff5d45);
/**
 * @module ol/TileQueue
 */ 
var $fOhwi = parcelRequire("fOhwi");

var $3xzSb = parcelRequire("3xzSb");

var $9JKwD = parcelRequire("9JKwD");
/**
 * @typedef {function(import("./Tile.js").default, string, import('./tilecoord.js').TileCoord, number): number} PriorityFunction
 */ /**
 * @typedef {[import('./Tile.js').default, string, import('./tilecoord.js').TileCoord, number]} TileQueueElement
 */ /**
 * @extends PriorityQueue<TileQueueElement>}
 */ class $4c51fd53052a6bbc$var$TileQueue extends (0, $9JKwD.default) {
    /**
   * @param {PriorityFunction} tilePriorityFunction Tile priority function.
   * @param {function(): ?} tileChangeCallback Function called on each tile change event.
   */ constructor(tilePriorityFunction, tileChangeCallback){
        super((element)=>tilePriorityFunction.apply(null, element), (element)=>element[0].getKey());
        /** @private */ this.boundHandleTileChange_ = this.handleTileChange.bind(this);
        /**
     * @private
     * @type {function(): ?}
     */ this.tileChangeCallback_ = tileChangeCallback;
        /**
     * @private
     * @type {number}
     */ this.tilesLoading_ = 0;
        /**
     * @private
     * @type {!Object<string,boolean>}
     */ this.tilesLoadingKeys_ = {};
    }
    /**
   * @param {TileQueueElement} element Element.
   * @return {boolean} The element was added to the queue.
   * @override
   */ enqueue(element) {
        const added = super.enqueue(element);
        if (added) {
            const tile = element[0];
            tile.addEventListener((0, $3xzSb.default).CHANGE, this.boundHandleTileChange_);
        }
        return added;
    }
    /**
   * @return {number} Number of tiles loading.
   */ getTilesLoading() {
        return this.tilesLoading_;
    }
    /**
   * @param {import("./events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("./Tile.js").default} */ event.target;
        const state = tile.getState();
        if (state === (0, $fOhwi.default).LOADED || state === (0, $fOhwi.default).ERROR || state === (0, $fOhwi.default).EMPTY) {
            if (state !== (0, $fOhwi.default).ERROR) tile.removeEventListener((0, $3xzSb.default).CHANGE, this.boundHandleTileChange_);
            const tileKey = tile.getKey();
            if (tileKey in this.tilesLoadingKeys_) {
                delete this.tilesLoadingKeys_[tileKey];
                --this.tilesLoading_;
            }
            this.tileChangeCallback_();
        }
    }
    /**
   * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
   * @param {number} maxNewLoads Maximum number of new tiles to load.
   */ loadMoreTiles(maxTotalLoading, maxNewLoads) {
        let newLoads = 0;
        while(this.tilesLoading_ < maxTotalLoading && newLoads < maxNewLoads && this.getCount() > 0){
            const tile = this.dequeue()[0];
            const tileKey = tile.getKey();
            const state = tile.getState();
            if (state === (0, $fOhwi.default).IDLE && !(tileKey in this.tilesLoadingKeys_)) {
                this.tilesLoadingKeys_[tileKey] = true;
                ++this.tilesLoading_;
                ++newLoads;
                tile.load();
            }
        }
    }
}
var $4c51fd53052a6bbc$export$2e2bcd8739ae039 = $4c51fd53052a6bbc$var$TileQueue;
function $4c51fd53052a6bbc$export$f08ad5eceeff5d45(frameState, tile, tileSourceKey, tileCenter, tileResolution) {
    // Filter out tiles at higher zoom levels than the current zoom level, or that
    // are outside the visible extent.
    if (!frameState || !(tileSourceKey in frameState.wantedTiles)) return 0, $9JKwD.DROP;
    if (!frameState.wantedTiles[tileSourceKey][tile.getKey()]) return 0, $9JKwD.DROP;
    // Prioritize the highest zoom level tiles closest to the focus.
    // Tiles at higher zoom levels are prioritized using Math.log(tileResolution).
    // Within a zoom level, tiles are prioritized by the distance in pixels between
    // the center of the tile and the center of the viewport.  The factor of 65536
    // means that the prioritization should behave as desired for tiles up to
    // 65536 * Math.log(2) = 45426 pixels from the focus.
    const center = frameState.viewState.center;
    const deltaX = tileCenter[0] - center[0];
    const deltaY = tileCenter[1] - center[1];
    return 65536 * Math.log(tileResolution) + Math.sqrt(deltaX * deltaX + deltaY * deltaY) / tileResolution;
}

});
parcelRegister("fOhwi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8291d9739c3c64e$export$2e2bcd8739ae039);
/**
 * @module ol/TileState
 */ /**
 * @enum {number}
 */ var $b8291d9739c3c64e$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    /**
   * Indicates that tile loading failed
   * @type {number}
   */ ERROR: 3,
    EMPTY: 4
};

});

parcelRegister("9JKwD", function(module, exports) {

$parcel$export(module.exports, "DROP", () => $716c6804ea170b71$export$b4af72c40fd57063);
$parcel$export(module.exports, "default", () => $716c6804ea170b71$export$2e2bcd8739ae039);
/**
 * @module ol/structs/PriorityQueue
 */ 
var $4Cz58 = parcelRequire("4Cz58");

var $gn0g3 = parcelRequire("gn0g3");
const $716c6804ea170b71$export$b4af72c40fd57063 = Infinity;
/**
 * @classdesc
 * Priority queue.
 *
 * The implementation is inspired from the Closure Library's Heap class and
 * Python's heapq module.
 *
 * See https://github.com/google/closure-library/blob/master/closure/goog/structs/heap.js
 * and https://hg.python.org/cpython/file/2.7/Lib/heapq.py.
 *
 * @template T
 */ class $716c6804ea170b71$var$PriorityQueue {
    /**
   * @param {function(T): number} priorityFunction Priority function.
   * @param {function(T): string} keyFunction Key function.
   */ constructor(priorityFunction, keyFunction){
        /**
     * @type {function(T): number}
     * @private
     */ this.priorityFunction_ = priorityFunction;
        /**
     * @type {function(T): string}
     * @private
     */ this.keyFunction_ = keyFunction;
        /**
     * @type {Array<T>}
     * @private
     */ this.elements_ = [];
        /**
     * @type {Array<number>}
     * @private
     */ this.priorities_ = [];
        /**
     * @type {!Object<string, boolean>}
     * @private
     */ this.queuedElements_ = {};
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.elements_.length = 0;
        this.priorities_.length = 0;
        (0, $gn0g3.clear)(this.queuedElements_);
    }
    /**
   * Remove and return the highest-priority element. O(log N).
   * @return {T} Element.
   */ dequeue() {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[0];
        if (elements.length == 1) {
            elements.length = 0;
            priorities.length = 0;
        } else {
            elements[0] = /** @type {T} */ elements.pop();
            priorities[0] = /** @type {number} */ priorities.pop();
            this.siftUp_(0);
        }
        const elementKey = this.keyFunction_(element);
        delete this.queuedElements_[elementKey];
        return element;
    }
    /**
   * Enqueue an element. O(log N).
   * @param {T} element Element.
   * @return {boolean} The element was added to the queue.
   */ enqueue(element) {
        (0, $4Cz58.assert)(!(this.keyFunction_(element) in this.queuedElements_), 'Tried to enqueue an `element` that was already added to the queue');
        const priority = this.priorityFunction_(element);
        if (priority != $716c6804ea170b71$export$b4af72c40fd57063) {
            this.elements_.push(element);
            this.priorities_.push(priority);
            this.queuedElements_[this.keyFunction_(element)] = true;
            this.siftDown_(0, this.elements_.length - 1);
            return true;
        }
        return false;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.elements_.length;
    }
    /**
   * Gets the index of the left child of the node at the given index.
   * @param {number} index The index of the node to get the left child for.
   * @return {number} The index of the left child.
   * @private
   */ getLeftChildIndex_(index) {
        return index * 2 + 1;
    }
    /**
   * Gets the index of the right child of the node at the given index.
   * @param {number} index The index of the node to get the right child for.
   * @return {number} The index of the right child.
   * @private
   */ getRightChildIndex_(index) {
        return index * 2 + 2;
    }
    /**
   * Gets the index of the parent of the node at the given index.
   * @param {number} index The index of the node to get the parent for.
   * @return {number} The index of the parent.
   * @private
   */ getParentIndex_(index) {
        return index - 1 >> 1;
    }
    /**
   * Make this a heap. O(N).
   * @private
   */ heapify_() {
        let i;
        for(i = (this.elements_.length >> 1) - 1; i >= 0; i--)this.siftUp_(i);
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return this.elements_.length === 0;
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Is key queued.
   */ isKeyQueued(key) {
        return key in this.queuedElements_;
    }
    /**
   * @param {T} element Element.
   * @return {boolean} Is queued.
   */ isQueued(element) {
        return this.isKeyQueued(this.keyFunction_(element));
    }
    /**
   * @param {number} index The index of the node to move down.
   * @private
   */ siftUp_(index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const count = elements.length;
        const element = elements[index];
        const priority = priorities[index];
        const startIndex = index;
        while(index < count >> 1){
            const lIndex = this.getLeftChildIndex_(index);
            const rIndex = this.getRightChildIndex_(index);
            const smallerChildIndex = rIndex < count && priorities[rIndex] < priorities[lIndex] ? rIndex : lIndex;
            elements[index] = elements[smallerChildIndex];
            priorities[index] = priorities[smallerChildIndex];
            index = smallerChildIndex;
        }
        elements[index] = element;
        priorities[index] = priority;
        this.siftDown_(startIndex, index);
    }
    /**
   * @param {number} startIndex The index of the root.
   * @param {number} index The index of the node to move up.
   * @private
   */ siftDown_(startIndex, index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[index];
        const priority = priorities[index];
        while(index > startIndex){
            const parentIndex = this.getParentIndex_(index);
            if (priorities[parentIndex] > priority) {
                elements[index] = elements[parentIndex];
                priorities[index] = priorities[parentIndex];
                index = parentIndex;
            } else break;
        }
        elements[index] = element;
        priorities[index] = priority;
    }
    /**
   * FIXME empty description for jsdoc
   */ reprioritize() {
        const priorityFunction = this.priorityFunction_;
        const elements = this.elements_;
        const priorities = this.priorities_;
        let index = 0;
        const n = elements.length;
        let element, i, priority;
        for(i = 0; i < n; ++i){
            element = elements[i];
            priority = priorityFunction(element);
            if (priority == $716c6804ea170b71$export$b4af72c40fd57063) delete this.queuedElements_[this.keyFunction_(element)];
            else {
                priorities[index] = priority;
                elements[index++] = element;
            }
        }
        elements.length = index;
        priorities.length = index;
        this.heapify_();
    }
}
var $716c6804ea170b71$export$2e2bcd8739ae039 = $716c6804ea170b71$var$PriorityQueue;

});


parcelRegister("f3WAG", function(module, exports) {

$parcel$export(module.exports, "defaults", () => $af7495b2f822d5e9$export$ebe90cb607ad99e);
/**
 * @module ol/control/defaults
 */ 
var $cD8Qe = parcelRequire("cD8Qe");

var $972rY = parcelRequire("972rY");

var $dZLuC = parcelRequire("dZLuC");

var $6gCea = parcelRequire("6gCea");
function $af7495b2f822d5e9$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Control.js").default>} */ const controls = new (0, $cD8Qe.default)();
    const zoomControl = options.zoom !== undefined ? options.zoom : true;
    if (zoomControl) controls.push(new (0, $6gCea.default)(options.zoomOptions));
    const rotateControl = options.rotate !== undefined ? options.rotate : true;
    if (rotateControl) controls.push(new (0, $dZLuC.default)(options.rotateOptions));
    const attributionControl = options.attribution !== undefined ? options.attribution : true;
    if (attributionControl) controls.push(new (0, $972rY.default)(options.attributionOptions));
    return controls;
}

});
parcelRegister("972rY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a26ab11104d2c24$export$2e2bcd8739ae039);
/**
 * @module ol/control/Attribution
 */ 
var $fVVyM = parcelRequire("fVVyM");

var $hGHcK = parcelRequire("hGHcK");

var $DfnQm = parcelRequire("DfnQm");

var $3xzSb = parcelRequire("3xzSb");

var $6wUzV = parcelRequire("6wUzV");

var $fVglf = parcelRequire("fVglf");
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-attribution'] CSS class name.
 * @property {HTMLElement|string} [target] Specify a target if you
 * want the control to be rendered outside of the map's
 * viewport.
 * @property {boolean} [collapsible] Specify if attributions can
 * be collapsed. If not specified, sources control this behavior with their
 * `attributionsCollapsible` setting.
 * @property {boolean} [collapsed=true] Specify if attributions should
 * be collapsed at startup.
 * @property {string} [tipLabel='Attributions'] Text label to use for the button tip.
 * @property {string|HTMLElement} [label='i'] Text label to use for the
 * collapsed attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [expandClassName=className + '-expand'] CSS class name for the
 * collapsed attributions button.
 * @property {string|HTMLElement} [collapseLabel='›'] Text label to use
 * for the expanded attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [collapseClassName=className + '-collapse'] CSS class name for the
 * expanded attributions button.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {string|Array<string>|undefined} [attributions] Optional attribution(s) that will always be
 * displayed regardless of the layers rendered.
 * **Caution:** Attributions are rendered dynamically using `innerHTML`, which can lead to potential
 * [**XSS (Cross-Site Scripting)**](https://en.wikipedia.org/wiki/Cross-site_scripting) vulnerabilities.
 * Use this feature only for trusted content
 * or ensure that the content is properly sanitized before inserting it.
 */ /**
 * @classdesc
 * Control to show all the attributions associated with the layer sources
 * in the map. This control is one of the default controls included in maps.
 * By default it will show in the bottom right portion of the map, but this can
 * be changed by using a css selector for `.ol-attribution`.
 *
 * @api
 */ class $6a26ab11104d2c24$var$Attribution extends (0, $fVglf.default) {
    /**
   * @param {Options} [options] Attribution options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        });
        /**
     * @private
     * @type {HTMLElement}
     */ this.ulElement_ = document.createElement('ul');
        /**
     * @private
     * @type {boolean}
     */ this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
        /**
     * @private
     * @type {boolean}
     */ this.userCollapsed_ = this.collapsed_;
        /**
     * @private
     * @type {boolean}
     */ this.overrideCollapsible_ = options.collapsible !== undefined;
        /**
     * @private
     * @type {boolean}
     */ this.collapsible_ = options.collapsible !== undefined ? options.collapsible : true;
        if (!this.collapsible_) this.collapsed_ = false;
        /**
     * @private
     * @type {string | Array<string> | undefined}
     */ this.attributions_ = options.attributions;
        const className = options.className !== undefined ? options.className : 'ol-attribution';
        const tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Attributions';
        const expandClassName = options.expandClassName !== undefined ? options.expandClassName : className + '-expand';
        const collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : '\u203A';
        const collapseClassName = options.collapseClassName !== undefined ? options.collapseClassName : className + '-collapse';
        if (typeof collapseLabel === 'string') {
            /**
       * @private
       * @type {HTMLElement}
       */ this.collapseLabel_ = document.createElement('span');
            this.collapseLabel_.textContent = collapseLabel;
            this.collapseLabel_.className = collapseClassName;
        } else this.collapseLabel_ = collapseLabel;
        const label = options.label !== undefined ? options.label : 'i';
        if (typeof label === 'string') {
            /**
       * @private
       * @type {HTMLElement}
       */ this.label_ = document.createElement('span');
            this.label_.textContent = label;
            this.label_.className = expandClassName;
        } else this.label_ = label;
        const activeLabel = this.collapsible_ && !this.collapsed_ ? this.collapseLabel_ : this.label_;
        /**
     * @private
     * @type {HTMLElement}
     */ this.toggleButton_ = document.createElement('button');
        this.toggleButton_.setAttribute('type', 'button');
        this.toggleButton_.setAttribute('aria-expanded', String(!this.collapsed_));
        this.toggleButton_.title = tipLabel;
        this.toggleButton_.appendChild(activeLabel);
        this.toggleButton_.addEventListener((0, $3xzSb.default).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + ' ' + (0, $hGHcK.CLASS_UNSELECTABLE) + ' ' + (0, $hGHcK.CLASS_CONTROL) + (this.collapsed_ && this.collapsible_ ? ' ' + (0, $hGHcK.CLASS_COLLAPSED) : '') + (this.collapsible_ ? '' : ' ol-uncollapsible');
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(this.toggleButton_);
        element.appendChild(this.ulElement_);
        /**
     * A list of currently rendered resolutions.
     * @type {Array<string>}
     * @private
     */ this.renderedAttributions_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * Collect a list of visible attributions and set the collapsible state.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {Array<string>} Attributions.
   * @private
   */ collectSourceAttributions_(frameState) {
        const layers = this.getMap().getAllLayers();
        const visibleAttributions = new Set(layers.flatMap((layer)=>layer.getAttributions(frameState)));
        if (this.attributions_ !== undefined) Array.isArray(this.attributions_) ? this.attributions_.forEach((item)=>visibleAttributions.add(item)) : visibleAttributions.add(this.attributions_);
        if (!this.overrideCollapsible_) {
            const collapsible = !layers.some((layer)=>layer.getSource()?.getAttributionsCollapsible() === false);
            this.setCollapsible(collapsible);
        }
        return Array.from(visibleAttributions);
    }
    /**
   * @private
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ async updateElement_(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        const attributions = await Promise.all(this.collectSourceAttributions_(frameState).map((attribution)=>(0, $6wUzV.toPromise)(()=>attribution)));
        const visible = attributions.length > 0;
        if (this.renderedVisible_ != visible) {
            this.element.style.display = visible ? '' : 'none';
            this.renderedVisible_ = visible;
        }
        if ((0, $fVVyM.equals)(attributions, this.renderedAttributions_)) return;
        (0, $DfnQm.removeChildren)(this.ulElement_);
        // append the attributions
        for(let i = 0, ii = attributions.length; i < ii; ++i){
            const element = document.createElement('li');
            element.innerHTML = attributions[i];
            this.ulElement_.appendChild(element);
        }
        this.renderedAttributions_ = attributions;
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        this.handleToggle_();
        this.userCollapsed_ = this.collapsed_;
    }
    /**
   * @private
   */ handleToggle_() {
        this.element.classList.toggle((0, $hGHcK.CLASS_COLLAPSED));
        if (this.collapsed_) (0, $DfnQm.replaceNode)(this.collapseLabel_, this.label_);
        else (0, $DfnQm.replaceNode)(this.label_, this.collapseLabel_);
        this.collapsed_ = !this.collapsed_;
        this.toggleButton_.setAttribute('aria-expanded', String(!this.collapsed_));
    }
    /**
   * Return `true` if the attribution is collapsible, `false` otherwise.
   * @return {boolean} True if the widget is collapsible.
   * @api
   */ getCollapsible() {
        return this.collapsible_;
    }
    /**
   * Set whether the attribution should be collapsible.
   * @param {boolean} collapsible True if the widget is collapsible.
   * @api
   */ setCollapsible(collapsible) {
        if (this.collapsible_ === collapsible) return;
        this.collapsible_ = collapsible;
        this.element.classList.toggle('ol-uncollapsible');
        if (this.userCollapsed_) this.handleToggle_();
    }
    /**
   * Collapse or expand the attribution according to the passed parameter. Will
   * not do anything if the attribution isn't collapsible or if the current
   * collapsed state is already the one requested.
   * @param {boolean} collapsed True if the widget is collapsed.
   * @api
   */ setCollapsed(collapsed) {
        this.userCollapsed_ = collapsed;
        if (!this.collapsible_ || this.collapsed_ === collapsed) return;
        this.handleToggle_();
    }
    /**
   * Return `true` when the attribution is currently collapsed or `false`
   * otherwise.
   * @return {boolean} True if the widget is collapsed.
   * @api
   */ getCollapsed() {
        return this.collapsed_;
    }
    /**
   * Update the attribution element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        this.updateElement_(mapEvent.frameState);
    }
}
var $6a26ab11104d2c24$export$2e2bcd8739ae039 = $6a26ab11104d2c24$var$Attribution;

});
parcelRegister("hGHcK", function(module, exports) {

$parcel$export(module.exports, "CLASS_HIDDEN", () => $ce07df6d5d4656f1$export$981241db82723ce2);
$parcel$export(module.exports, "CLASS_UNSELECTABLE", () => $ce07df6d5d4656f1$export$1afde3d6e16a7b29);
$parcel$export(module.exports, "CLASS_CONTROL", () => $ce07df6d5d4656f1$export$4d4f8be70b656192);
$parcel$export(module.exports, "CLASS_COLLAPSED", () => $ce07df6d5d4656f1$export$e16017ac68d14492);
$parcel$export(module.exports, "fontWeights", () => $ce07df6d5d4656f1$export$59230918eb9bd861);
$parcel$export(module.exports, "getFontParameters", () => $ce07df6d5d4656f1$export$5abde8a6aec4a131);
/**
 * @module ol/css
 */ /**
 * @typedef {Object} FontParameters
 * @property {string} style Style.
 * @property {string} variant Variant.
 * @property {string} weight Weight.
 * @property {string} size Size.
 * @property {string} lineHeight LineHeight.
 * @property {string} family Family.
 * @property {Array<string>} families Families.
 */ /**
 * The CSS class for hidden feature.
 *
 * @const
 * @type {string}
 */ const $ce07df6d5d4656f1$export$981241db82723ce2 = 'ol-hidden';
const $ce07df6d5d4656f1$export$99b49471b0394319 = 'ol-selectable';
const $ce07df6d5d4656f1$export$1afde3d6e16a7b29 = 'ol-unselectable';
const $ce07df6d5d4656f1$export$68eede0dd8c6c1da = 'ol-unsupported';
const $ce07df6d5d4656f1$export$4d4f8be70b656192 = 'ol-control';
const $ce07df6d5d4656f1$export$e16017ac68d14492 = 'ol-collapsed';
/**
 * From https://stackoverflow.com/questions/10135697/regex-to-parse-any-css-font
 * @type {RegExp}
 */ const $ce07df6d5d4656f1$var$fontRegEx = new RegExp([
    '^\\s*(?=(?:(?:[-a-z]+\\s*){0,2}(italic|oblique))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(small-caps))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(bold(?:er)?|lighter|[1-9]00 ))?)',
    '(?:(?:normal|\\1|\\2|\\3)\\s*){0,3}((?:xx?-)?',
    '(?:small|large)|medium|smaller|larger|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx]))',
    '(?:\\s*\\/\\s*(normal|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx])?))',
    '?\\s*([-,\\"\\\'\\sa-z0-9]+?)\\s*$'
].join(''), 'i');
/** @type {Array<'style'|'variant'|'weight'|'size'|'lineHeight'|'family'>} */ const $ce07df6d5d4656f1$var$fontRegExMatchIndex = [
    'style',
    'variant',
    'weight',
    'size',
    'lineHeight',
    'family'
];
const $ce07df6d5d4656f1$export$59230918eb9bd861 = {
    normal: 400,
    bold: 700
};
const $ce07df6d5d4656f1$export$5abde8a6aec4a131 = function(fontSpec) {
    const match = fontSpec.match($ce07df6d5d4656f1$var$fontRegEx);
    if (!match) return null;
    const style = /** @type {FontParameters} */ {
        lineHeight: 'normal',
        size: '1.2em',
        style: 'normal',
        weight: '400',
        variant: 'normal'
    };
    for(let i = 0, ii = $ce07df6d5d4656f1$var$fontRegExMatchIndex.length; i < ii; ++i){
        const value = match[i + 1];
        if (value !== undefined) style[$ce07df6d5d4656f1$var$fontRegExMatchIndex[i]] = typeof value === 'string' ? value.trim() : value;
    }
    if (isNaN(Number(style.weight)) && style.weight in $ce07df6d5d4656f1$export$59230918eb9bd861) style.weight = $ce07df6d5d4656f1$export$59230918eb9bd861[style.weight];
    style.families = style.family.split(/,\s?/).map((f)=>f.trim().replace(/^['"]|['"]$/g, ''));
    return style;
};

});

parcelRegister("fVglf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b978dafe8f7d27ff$export$2e2bcd8739ae039);
/**
 * @module ol/control/Control
 */ 
var $jDfdj = parcelRequire("jDfdj");

var $fFFY7 = parcelRequire("fFFY7");

var $ilM9F = parcelRequire("ilM9F");

var $6wUzV = parcelRequire("6wUzV");
/**
 * @typedef {Object} Options
 * @property {HTMLElement} [element] The element is the control's
 * container element. This only needs to be specified if you're developing
 * a custom control.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want
 * the control to be rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control is a visible widget with a DOM element in a fixed position on the
 * screen. They can involve user input (buttons), or be informational only;
 * the position is determined using CSS. By default these are placed in the
 * container with CSS class name `ol-overlaycontainer-stopevent`, but can use
 * any outside DOM element.
 *
 * This is the base class for controls. You can use it for simple custom
 * controls by creating the element with listeners, creating an instance:
 * ```js
 * const myControl = new Control({element: myElement});
 * ```
 * and then adding this to the map.
 *
 * The main advantage of having this as a control rather than a simple separate
 * DOM element is that preventing propagation is handled for you. Controls
 * will also be objects in a {@link module:ol/Collection~Collection}, so you can use their methods.
 *
 * You can also extend this base for your own control class. See
 * examples/custom-controls for an example of how to do this.
 *
 * @api
 */ class $b978dafe8f7d27ff$var$Control extends (0, $fFFY7.default) {
    /**
   * @param {Options} options Control options.
   */ constructor(options){
        super();
        const element = options.element;
        if (element && !options.target && !element.style.pointerEvents) element.style.pointerEvents = 'auto';
        /**
     * @protected
     * @type {HTMLElement}
     */ this.element = element ? element : null;
        /**
     * @private
     * @type {HTMLElement}
     */ this.target_ = null;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @protected
     * @type {!Array<import("../events.js").EventsKey>}
     */ this.listenerKeys = [];
        if (options.render) this.render = options.render;
        if (options.target) this.setTarget(options.target);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.element?.remove();
        super.disposeInternal();
    }
    /**
   * Get the map associated with this control.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.map_) this.element?.remove();
        for(let i = 0, ii = this.listenerKeys.length; i < ii; ++i)(0, $ilM9F.unlistenByKey)(this.listenerKeys[i]);
        this.listenerKeys.length = 0;
        this.map_ = map;
        if (map) {
            const target = this.target_ ?? map.getOverlayContainerStopEvent();
            if (this.element) target.appendChild(this.element);
            if (this.render !== (0, $6wUzV.VOID)) this.listenerKeys.push((0, $ilM9F.listen)(map, (0, $jDfdj.default).POSTRENDER, this.render, this));
            map.render();
        }
    }
    /**
   * Renders the control.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @api
   */ render(mapEvent) {}
    /**
   * This function is used to set a target element for the control. It has no
   * effect if it is called after the control has been added to the map (i.e.
   * after `setMap` is called on the control). If no `target` is set in the
   * options passed to the control constructor and if `setTarget` is not called
   * then the control is added to the map's overlay container.
   * @param {HTMLElement|string} target Target.
   * @api
   */ setTarget(target) {
        this.target_ = typeof target === 'string' ? document.getElementById(target) : target;
    }
}
var $b978dafe8f7d27ff$export$2e2bcd8739ae039 = $b978dafe8f7d27ff$var$Control;

});


parcelRegister("dZLuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a305cff1f91b3b86$export$2e2bcd8739ae039);
/**
 * @module ol/control/Rotate
 */ 
var $hGHcK = parcelRequire("hGHcK");

var $h9x7v = parcelRequire("h9x7v");

var $3xzSb = parcelRequire("3xzSb");

var $fVglf = parcelRequire("fVglf");
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-rotate'] CSS class name.
 * @property {string|HTMLElement} [label='⇧'] Text label to use for the rotate button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Reset rotation'] Text label to use for the rotate tip.
 * @property {string} [compassClassName='ol-compass'] CSS class name for the compass.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {boolean} [autoHide=true] Hide the control when rotation is 0.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control should
 * be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {function():void} [resetNorth] Function called when the control is clicked.
 * This will override the default `resetNorth`.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A button control to reset rotation to 0.
 * To style this control use css selector `.ol-rotate`. A `.ol-hidden` css
 * selector is added to the button when the rotation is 0.
 *
 * @api
 */ class $a305cff1f91b3b86$var$Rotate extends (0, $fVglf.default) {
    /**
   * @param {Options} [options] Rotate options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        });
        const className = options.className !== undefined ? options.className : 'ol-rotate';
        const label = options.label !== undefined ? options.label : '\u21E7';
        const compassClassName = options.compassClassName !== undefined ? options.compassClassName : 'ol-compass';
        /**
     * @type {HTMLElement}
     * @private
     */ this.label_ = null;
        if (typeof label === 'string') {
            this.label_ = document.createElement('span');
            this.label_.className = compassClassName;
            this.label_.textContent = label;
        } else {
            this.label_ = label;
            this.label_.classList.add(compassClassName);
        }
        const tipLabel = options.tipLabel ? options.tipLabel : 'Reset rotation';
        const button = document.createElement('button');
        button.className = className + '-reset';
        button.setAttribute('type', 'button');
        button.title = tipLabel;
        button.appendChild(this.label_);
        button.addEventListener((0, $3xzSb.default).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + ' ' + (0, $hGHcK.CLASS_UNSELECTABLE) + ' ' + (0, $hGHcK.CLASS_CONTROL);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(button);
        /**
     * @private
     */ this.callResetNorth_ = options.resetNorth ? options.resetNorth : undefined;
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @type {boolean}
     * @private
     */ this.autoHide_ = options.autoHide !== undefined ? options.autoHide : true;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        if (this.autoHide_) this.element.classList.add((0, $hGHcK.CLASS_HIDDEN));
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        if (this.callResetNorth_ !== undefined) this.callResetNorth_();
        else this.resetNorth_();
    }
    /**
   * @private
   */ resetNorth_() {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const rotation = view.getRotation();
        if (rotation !== undefined) {
            if (this.duration_ > 0 && rotation % (2 * Math.PI) !== 0) view.animate({
                rotation: 0,
                duration: this.duration_,
                easing: (0, $h9x7v.easeOut)
            });
            else view.setRotation(0);
        }
    }
    /**
   * Update the rotate control element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        const frameState = mapEvent.frameState;
        if (!frameState) return;
        const rotation = frameState.viewState.rotation;
        if (rotation != this.rotation_) {
            const transform = 'rotate(' + rotation + 'rad)';
            if (this.autoHide_) {
                const contains = this.element.classList.contains((0, $hGHcK.CLASS_HIDDEN));
                if (!contains && rotation === 0) this.element.classList.add((0, $hGHcK.CLASS_HIDDEN));
                else if (contains && rotation !== 0) this.element.classList.remove((0, $hGHcK.CLASS_HIDDEN));
            }
            this.label_.style.transform = transform;
        }
        this.rotation_ = rotation;
    }
}
var $a305cff1f91b3b86$export$2e2bcd8739ae039 = $a305cff1f91b3b86$var$Rotate;

});

parcelRegister("6gCea", function(module, exports) {

$parcel$export(module.exports, "default", () => $4901e3e27e30416a$export$2e2bcd8739ae039);
/**
 * @module ol/control/Zoom
 */ 
var $hGHcK = parcelRequire("hGHcK");

var $h9x7v = parcelRequire("h9x7v");

var $3xzSb = parcelRequire("3xzSb");

var $fVglf = parcelRequire("fVglf");
/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {string} [className='ol-zoom'] CSS class name.
 * @property {string} [zoomInClassName=className + '-in'] CSS class name for the zoom-in button.
 * @property {string} [zoomOutClassName=className + '-out'] CSS class name for the zoom-out button.
 * @property {string|HTMLElement} [zoomInLabel='+'] Text label to use for the zoom-in
 * button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|HTMLElement} [zoomOutLabel='–'] Text label to use for the zoom-out button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [zoomInTipLabel='Zoom in'] Text label to use for the button tip.
 * @property {string} [zoomOutTipLabel='Zoom out'] Text label to use for the button tip.
 * @property {number} [delta=1] The zoom delta applied on each click.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control with 2 buttons, one for zoom in and one for zoom out.
 * This control is one of the default controls of a map. To style this control
 * use css selectors `.ol-zoom-in` and `.ol-zoom-out`.
 *
 * @api
 */ class $4901e3e27e30416a$var$Zoom extends (0, $fVglf.default) {
    /**
   * @param {Options} [options] Zoom options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            target: options.target
        });
        const className = options.className !== undefined ? options.className : 'ol-zoom';
        const delta = options.delta !== undefined ? options.delta : 1;
        const zoomInClassName = options.zoomInClassName !== undefined ? options.zoomInClassName : className + '-in';
        const zoomOutClassName = options.zoomOutClassName !== undefined ? options.zoomOutClassName : className + '-out';
        const zoomInLabel = options.zoomInLabel !== undefined ? options.zoomInLabel : '+';
        const zoomOutLabel = options.zoomOutLabel !== undefined ? options.zoomOutLabel : '\u2013';
        const zoomInTipLabel = options.zoomInTipLabel !== undefined ? options.zoomInTipLabel : 'Zoom in';
        const zoomOutTipLabel = options.zoomOutTipLabel !== undefined ? options.zoomOutTipLabel : 'Zoom out';
        const inElement = document.createElement('button');
        inElement.className = zoomInClassName;
        inElement.setAttribute('type', 'button');
        inElement.title = zoomInTipLabel;
        inElement.appendChild(typeof zoomInLabel === 'string' ? document.createTextNode(zoomInLabel) : zoomInLabel);
        inElement.addEventListener((0, $3xzSb.default).CLICK, this.handleClick_.bind(this, delta), false);
        const outElement = document.createElement('button');
        outElement.className = zoomOutClassName;
        outElement.setAttribute('type', 'button');
        outElement.title = zoomOutTipLabel;
        outElement.appendChild(typeof zoomOutLabel === 'string' ? document.createTextNode(zoomOutLabel) : zoomOutLabel);
        outElement.addEventListener((0, $3xzSb.default).CLICK, this.handleClick_.bind(this, -delta), false);
        const cssClasses = className + ' ' + (0, $hGHcK.CLASS_UNSELECTABLE) + ' ' + (0, $hGHcK.CLASS_CONTROL);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(inElement);
        element.appendChild(outElement);
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * @param {number} delta Zoom delta.
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(delta, event) {
        event.preventDefault();
        this.zoomByDelta_(delta);
    }
    /**
   * @param {number} delta Zoom delta.
   * @private
   */ zoomByDelta_(delta) {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const currentZoom = view.getZoom();
        if (currentZoom !== undefined) {
            const newZoom = view.getConstrainedZoom(currentZoom + delta);
            if (this.duration_ > 0) {
                if (view.getAnimating()) view.cancelAnimations();
                view.animate({
                    zoom: newZoom,
                    duration: this.duration_,
                    easing: (0, $h9x7v.easeOut)
                });
            } else view.setZoom(newZoom);
        }
    }
}
var $4901e3e27e30416a$export$2e2bcd8739ae039 = $4901e3e27e30416a$var$Zoom;

});


parcelRegister("jzydl", function(module, exports) {

$parcel$export(module.exports, "defaults", () => $e3fbd36d629ecc04$export$ebe90cb607ad99e);
/**
 * @module ol/interaction/defaults
 */ 
var $cD8Qe = parcelRequire("cD8Qe");

var $dfvfw = parcelRequire("dfvfw");

var $fxxCd = parcelRequire("fxxCd");

var $gzMtY = parcelRequire("gzMtY");

var $2bF2e = parcelRequire("2bF2e");

var $f5G4s = parcelRequire("f5G4s");

var $21kEk = parcelRequire("21kEk");

var $2W903 = parcelRequire("2W903");

var $eEiUy = parcelRequire("eEiUy");

var $cYAky = parcelRequire("cYAky");

var $asgrH = parcelRequire("asgrH");
function $e3fbd36d629ecc04$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Interaction.js").default>} */ const interactions = new (0, $cD8Qe.default)();
    const kinetic = new (0, $dfvfw.default)(-0.005, 0.05, 100);
    const altShiftDragRotate = options.altShiftDragRotate !== undefined ? options.altShiftDragRotate : true;
    if (altShiftDragRotate) interactions.push(new (0, $2bF2e.default)());
    const doubleClickZoom = options.doubleClickZoom !== undefined ? options.doubleClickZoom : true;
    if (doubleClickZoom) interactions.push(new (0, $fxxCd.default)({
        delta: options.zoomDelta,
        duration: options.zoomDuration
    }));
    const dragPan = options.dragPan !== undefined ? options.dragPan : true;
    if (dragPan) interactions.push(new (0, $gzMtY.default)({
        onFocusOnly: options.onFocusOnly,
        kinetic: kinetic
    }));
    const pinchRotate = options.pinchRotate !== undefined ? options.pinchRotate : true;
    if (pinchRotate) interactions.push(new (0, $cYAky.default)());
    const pinchZoom = options.pinchZoom !== undefined ? options.pinchZoom : true;
    if (pinchZoom) interactions.push(new (0, $asgrH.default)({
        duration: options.zoomDuration
    }));
    const keyboard = options.keyboard !== undefined ? options.keyboard : true;
    if (keyboard) {
        interactions.push(new (0, $21kEk.default)());
        interactions.push(new (0, $2W903.default)({
            delta: options.zoomDelta,
            duration: options.zoomDuration
        }));
    }
    const mouseWheelZoom = options.mouseWheelZoom !== undefined ? options.mouseWheelZoom : true;
    if (mouseWheelZoom) interactions.push(new (0, $eEiUy.default)({
        onFocusOnly: options.onFocusOnly,
        duration: options.zoomDuration
    }));
    const shiftDragZoom = options.shiftDragZoom !== undefined ? options.shiftDragZoom : true;
    if (shiftDragZoom) interactions.push(new (0, $f5G4s.default)({
        duration: options.zoomDuration
    }));
    return interactions;
}

});
parcelRegister("dfvfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a54ea8d5f7a49ee$export$2e2bcd8739ae039);
/**
 * @module ol/Kinetic
 */ /**
 * @classdesc
 * Implementation of inertial deceleration for map movement.
 *
 * @api
 */ class $9a54ea8d5f7a49ee$var$Kinetic {
    /**
   * @param {number} decay Rate of decay (must be negative).
   * @param {number} minVelocity Minimum velocity (pixels/millisecond).
   * @param {number} delay Delay to consider to calculate the kinetic
   *     initial values (milliseconds).
   */ constructor(decay, minVelocity, delay){
        /**
     * @private
     * @type {number}
     */ this.decay_ = decay;
        /**
     * @private
     * @type {number}
     */ this.minVelocity_ = minVelocity;
        /**
     * @private
     * @type {number}
     */ this.delay_ = delay;
        /**
     * @private
     * @type {Array<number>}
     */ this.points_ = [];
        /**
     * @private
     * @type {number}
     */ this.angle_ = 0;
        /**
     * @private
     * @type {number}
     */ this.initialVelocity_ = 0;
    }
    /**
   * FIXME empty description for jsdoc
   */ begin() {
        this.points_.length = 0;
        this.angle_ = 0;
        this.initialVelocity_ = 0;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   */ update(x, y) {
        this.points_.push(x, y, Date.now());
    }
    /**
   * @return {boolean} Whether we should do kinetic animation.
   */ end() {
        if (this.points_.length < 6) // at least 2 points are required (i.e. there must be at least 6 elements
        // in the array)
        return false;
        const delay = Date.now() - this.delay_;
        const lastIndex = this.points_.length - 3;
        if (this.points_[lastIndex + 2] < delay) // the last tracked point is too old, which means that the user stopped
        // panning before releasing the map
        return false;
        // get the first point which still falls into the delay time
        let firstIndex = lastIndex - 3;
        while(firstIndex > 0 && this.points_[firstIndex + 2] > delay)firstIndex -= 3;
        const duration = this.points_[lastIndex + 2] - this.points_[firstIndex + 2];
        // we don't want a duration of 0 (divide by zero)
        // we also make sure the user panned for a duration of at least one frame
        // (1/60s) to compute sane displacement values
        if (duration < 1000 / 60) return false;
        const dx = this.points_[lastIndex] - this.points_[firstIndex];
        const dy = this.points_[lastIndex + 1] - this.points_[firstIndex + 1];
        this.angle_ = Math.atan2(dy, dx);
        this.initialVelocity_ = Math.sqrt(dx * dx + dy * dy) / duration;
        return this.initialVelocity_ > this.minVelocity_;
    }
    /**
   * @return {number} Total distance travelled (pixels).
   */ getDistance() {
        return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
    }
    /**
   * @return {number} Angle of the kinetic panning animation (radians).
   */ getAngle() {
        return this.angle_;
    }
}
var $9a54ea8d5f7a49ee$export$2e2bcd8739ae039 = $9a54ea8d5f7a49ee$var$Kinetic;

});

parcelRegister("fxxCd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b50403621294a654$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/DoubleClickZoom
 */ 
var $1O6bd = parcelRequire("1O6bd");

var $4U60I = parcelRequire("4U60I");
/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [delta=1] The zoom delta applied on each double click.
 */ /**
 * @classdesc
 * Allows the user to zoom by double-clicking on the map.
 * @api
 */ class $b50403621294a654$var$DoubleClickZoom extends (0, $4U60I.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a
   * doubleclick) and eventually zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $1O6bd.default).DBLCLICK) {
            const browserEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
            const map = mapBrowserEvent.map;
            const anchor = mapBrowserEvent.coordinate;
            const delta = browserEvent.shiftKey ? -this.delta_ : this.delta_;
            const view = map.getView();
            (0, $4U60I.zoomByDelta)(view, delta, anchor, this.duration_);
            browserEvent.preventDefault();
            stopEvent = true;
        }
        return !stopEvent;
    }
}
var $b50403621294a654$export$2e2bcd8739ae039 = $b50403621294a654$var$DoubleClickZoom;

});
parcelRegister("4U60I", function(module, exports) {

$parcel$export(module.exports, "pan", () => $39210df8527e63e5$export$4c486572e961a974);
$parcel$export(module.exports, "zoomByDelta", () => $39210df8527e63e5$export$ace321ff2a8016ef);
$parcel$export(module.exports, "default", () => $39210df8527e63e5$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/Interaction
 */ 
var $fFFY7 = parcelRequire("fFFY7");

var $h9x7v = parcelRequire("h9x7v");

var $3Pv6i = parcelRequire("3Pv6i");
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active', Return>} InteractionOnSignature
 */ /**
 * Object literal with config options for interactions.
 * @typedef {Object} InteractionOptions
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. If the function returns a falsy value, propagation of
 * the event to other interactions in the map's interactions chain will be
 * prevented (this includes functions with no explicit return). The interactions
 * are traversed in reverse order of the interactions collection of the map.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * User actions that change the state of the map. Some are similar to controls,
 * but are not associated with a DOM element.
 * For example, {@link module:ol/interaction/KeyboardZoom~KeyboardZoom} is
 * functionally the same as {@link module:ol/control/Zoom~Zoom}, but triggered
 * by a keyboard event not a button element event.
 * Although interactions do not have a DOM element, some of them do render
 * vectors and so are visible on the screen.
 * @api
 */ class $39210df8527e63e5$var$Interaction extends (0, $fFFY7.default) {
    /**
   * @param {InteractionOptions} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {InteractionOnSignature<void>}
     */ this.un;
        if (options && options.handleEvent) this.handleEvent = options.handleEvent;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        this.setActive(true);
    }
    /**
   * Return whether the interaction is currently active.
   * @return {boolean} `true` if the interaction is active, `false` otherwise.
   * @observable
   * @api
   */ getActive() {
        return /** @type {boolean} */ this.get((0, $3Pv6i.default).ACTIVE);
    }
    /**
   * Get the map associated with this interaction.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event}.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */ handleEvent(mapBrowserEvent) {
        return true;
    }
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */ setActive(active) {
        this.set((0, $3Pv6i.default).ACTIVE, active);
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        this.map_ = map;
    }
}
function $39210df8527e63e5$export$4c486572e961a974(view, delta, duration) {
    const currentCenter = view.getCenterInternal();
    if (currentCenter) {
        const center = [
            currentCenter[0] + delta[0],
            currentCenter[1] + delta[1]
        ];
        view.animateInternal({
            duration: duration !== undefined ? duration : 250,
            easing: (0, $h9x7v.linear),
            center: view.getConstrainedCenter(center)
        });
    }
}
function $39210df8527e63e5$export$ace321ff2a8016ef(view, delta, anchor, duration) {
    const currentZoom = view.getZoom();
    if (currentZoom === undefined) return;
    const newZoom = view.getConstrainedZoom(currentZoom + delta);
    const newResolution = view.getResolutionForZoom(newZoom);
    if (view.getAnimating()) view.cancelAnimations();
    view.animate({
        resolution: newResolution,
        anchor: anchor,
        duration: duration !== undefined ? duration : 250,
        easing: (0, $h9x7v.easeOut)
    });
}
var $39210df8527e63e5$export$2e2bcd8739ae039 = $39210df8527e63e5$var$Interaction;

});
parcelRegister("3Pv6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c9e42723ccf2bfb$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/Property
 */ /**
 * @enum {string}
 */ var $2c9e42723ccf2bfb$export$2e2bcd8739ae039 = {
    ACTIVE: 'active'
};

});



parcelRegister("gzMtY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c11585da26a016db$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/DragPan
 */ 
var $2o3CH = parcelRequire("2o3CH");

var $h9x7v = parcelRequire("h9x7v");

var $kqI9g = parcelRequire("kqI9g");

var $6wUzV = parcelRequire("6wUzV");

var $hMuFm = parcelRequire("hMuFm");
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.noModifierKeys} and {@link module:ol/events/condition.primaryAction}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {import("../Kinetic.js").default} [kinetic] Kinetic inertia to apply to the pan.
 */ /**
 * @classdesc
 * Allows the user to pan the map by dragging the map.
 * @api
 */ class $c11585da26a016db$var$DragPan extends (0, $hMuFm.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super({
            stopDown: (0, $6wUzV.FALSE)
        });
        options = options ? options : {};
        /**
     * @private
     * @type {import("../Kinetic.js").default|undefined}
     */ this.kinetic_ = options.kinetic;
        /**
     * @type {import("../pixel.js").Pixel}
     */ this.lastCentroid = null;
        /**
     * @type {number}
     * @private
     */ this.lastPointersCount_;
        /**
     * @type {boolean}
     * @private
     */ this.panning_ = false;
        const condition = options.condition ? options.condition : (0, $kqI9g.all)((0, $kqI9g.noModifierKeys), (0, $kqI9g.primaryAction));
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, $kqI9g.all)((0, $kqI9g.focusWithTabindex), condition) : condition;
        /**
     * @private
     * @type {boolean}
     */ this.noKinetic_ = false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        if (!this.panning_) {
            this.panning_ = true;
            map.getView().beginInteraction();
        }
        const targetPointers = this.targetPointers;
        const centroid = map.getEventPixel((0, $hMuFm.centroid)(targetPointers));
        if (targetPointers.length == this.lastPointersCount_) {
            if (this.kinetic_) this.kinetic_.update(centroid[0], centroid[1]);
            if (this.lastCentroid) {
                const delta = [
                    this.lastCentroid[0] - centroid[0],
                    centroid[1] - this.lastCentroid[1]
                ];
                const map = mapBrowserEvent.map;
                const view = map.getView();
                (0, $2o3CH.scale)(delta, view.getResolution());
                (0, $2o3CH.rotate)(delta, view.getRotation());
                view.adjustCenterInternal(delta);
            }
        } else if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger down, tiny drag, second finger down
        this.kinetic_.begin();
        this.lastCentroid = centroid;
        this.lastPointersCount_ = targetPointers.length;
        mapBrowserEvent.originalEvent.preventDefault();
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (this.targetPointers.length === 0) {
            if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
                const distance = this.kinetic_.getDistance();
                const angle = this.kinetic_.getAngle();
                const center = view.getCenterInternal();
                const centerpx = map.getPixelFromCoordinateInternal(center);
                const dest = map.getCoordinateFromPixelInternal([
                    centerpx[0] - distance * Math.cos(angle),
                    centerpx[1] - distance * Math.sin(angle)
                ]);
                view.animateInternal({
                    center: view.getConstrainedCenter(dest),
                    duration: 500,
                    easing: (0, $h9x7v.easeOut)
                });
            }
            if (this.panning_) {
                this.panning_ = false;
                view.endInteraction();
            }
            return false;
        }
        if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger up, tiny drag, second finger up
        this.kinetic_.begin();
        this.lastCentroid = null;
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            this.lastCentroid = null;
            // stop any current animation
            if (view.getAnimating()) view.cancelAnimations();
            if (this.kinetic_) this.kinetic_.begin();
            // No kinetic as soon as more than one pointer on the screen is
            // detected. This is to prevent nasty pans after pinch.
            this.noKinetic_ = this.targetPointers.length > 1;
            return true;
        }
        return false;
    }
}
var $c11585da26a016db$export$2e2bcd8739ae039 = $c11585da26a016db$var$DragPan;

});
parcelRegister("kqI9g", function(module, exports) {

$parcel$export(module.exports, "all", () => $edf87b50170125f7$export$84bf76cd7afc7469);
$parcel$export(module.exports, "altShiftKeysOnly", () => $edf87b50170125f7$export$4e5f01653f9f1f82);
$parcel$export(module.exports, "focusWithTabindex", () => $edf87b50170125f7$export$ae2cdf064e3b0c55);
$parcel$export(module.exports, "always", () => $edf87b50170125f7$export$ba9e5d519bc326ca);
$parcel$export(module.exports, "mouseActionButton", () => $edf87b50170125f7$export$1238ad6b5e7fff70);
$parcel$export(module.exports, "noModifierKeys", () => $edf87b50170125f7$export$fdc892d0d8fe3bfb);
$parcel$export(module.exports, "platformModifierKey", () => $edf87b50170125f7$export$32603ad571dd22b5);
$parcel$export(module.exports, "shiftKeyOnly", () => $edf87b50170125f7$export$5d31fe68a477cfbb);
$parcel$export(module.exports, "targetNotEditable", () => $edf87b50170125f7$export$e5570ca80cd8fd54);
$parcel$export(module.exports, "mouseOnly", () => $edf87b50170125f7$export$abb7acbfa76bf3c4);
$parcel$export(module.exports, "primaryAction", () => $edf87b50170125f7$export$189f0d593022b199);
/**
 * @module ol/events/condition
 */ 
var $1O6bd = parcelRequire("1O6bd");

var $6wUzV = parcelRequire("6wUzV");

var $8UoiJ = parcelRequire("8UoiJ");
function $edf87b50170125f7$export$84bf76cd7afc7469(var_args) {
    const conditions = arguments;
    /**
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} All conditions passed.
   */ return function(event) {
        let pass = true;
        for(let i = 0, ii = conditions.length; i < ii; ++i){
            pass = pass && conditions[i](event);
            if (!pass) break;
        }
        return pass;
    };
}
const $edf87b50170125f7$export$573409992e89967e = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $edf87b50170125f7$export$4e5f01653f9f1f82 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const $edf87b50170125f7$export$d7ddd398f22d79ef = function(event) {
    const targetElement = event.map.getTargetElement();
    const rootNode = targetElement.getRootNode();
    const activeElement = event.map.getOwnerDocument().activeElement;
    return rootNode instanceof ShadowRoot ? rootNode.host.contains(activeElement) : targetElement.contains(activeElement);
};
const $edf87b50170125f7$export$ae2cdf064e3b0c55 = function(event) {
    const targetElement = event.map.getTargetElement();
    const rootNode = targetElement.getRootNode();
    const tabIndexCandidate = rootNode instanceof ShadowRoot ? rootNode.host : targetElement;
    return tabIndexCandidate.hasAttribute('tabindex') ? $edf87b50170125f7$export$d7ddd398f22d79ef(event) : true;
};
const $edf87b50170125f7$export$ba9e5d519bc326ca = (0, $6wUzV.TRUE);
const $edf87b50170125f7$export$64ef1bee2b9504c1 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $1O6bd.default).CLICK;
};
const $edf87b50170125f7$export$1238ad6b5e7fff70 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return 'pointerId' in originalEvent && originalEvent.button == 0 && !((0, $8UoiJ.WEBKIT) && (0, $8UoiJ.MAC) && originalEvent.ctrlKey);
};
const $edf87b50170125f7$export$b3e22bcfd64c1022 = (0, $6wUzV.FALSE);
const $edf87b50170125f7$export$71eac0963f2c2f01 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == 'pointermove';
};
const $edf87b50170125f7$export$194df8bad091b401 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $1O6bd.default).SINGLECLICK;
};
const $edf87b50170125f7$export$c59d944dd10b3dc7 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $1O6bd.default).DBLCLICK;
};
const $edf87b50170125f7$export$fdc892d0d8fe3bfb = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $edf87b50170125f7$export$f3100d8d6292d638 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && ((0, $8UoiJ.MAC) ? originalEvent.metaKey : originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $edf87b50170125f7$export$32603ad571dd22b5 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return (0, $8UoiJ.MAC) ? originalEvent.metaKey : originalEvent.ctrlKey;
};
const $edf87b50170125f7$export$5d31fe68a477cfbb = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const $edf87b50170125f7$export$e5570ca80cd8fd54 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    const tagName = /** @type {Element} */ originalEvent.target.tagName;
    return tagName !== 'INPUT' && tagName !== 'SELECT' && tagName !== 'TEXTAREA' && // `isContentEditable` is only available on `HTMLElement`, but it may also be a
    // different type like `SVGElement`.
    // @ts-ignore
    !originalEvent.target.isContentEditable;
};
const $edf87b50170125f7$export$abb7acbfa76bf3c4 = function(mapBrowserEvent) {
    const pointerEvent = mapBrowserEvent.originalEvent;
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return 'pointerId' in pointerEvent && pointerEvent.pointerType == 'mouse';
};
const $edf87b50170125f7$export$e74de664a571d084 = function(mapBrowserEvent) {
    const pointerEvt = mapBrowserEvent.originalEvent;
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return 'pointerId' in pointerEvt && pointerEvt.pointerType === 'touch';
};
const $edf87b50170125f7$export$cd1707283a23f059 = function(mapBrowserEvent) {
    const pointerEvt = mapBrowserEvent.originalEvent;
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return 'pointerId' in pointerEvt && pointerEvt.pointerType === 'pen';
};
const $edf87b50170125f7$export$189f0d593022b199 = function(mapBrowserEvent) {
    const pointerEvent = mapBrowserEvent.originalEvent;
    return 'pointerId' in pointerEvent && pointerEvent.isPrimary && pointerEvent.button === 0;
};

});

parcelRegister("hMuFm", function(module, exports) {

$parcel$export(module.exports, "centroid", () => $cf1eb502962d87a8$export$e2a20c553f6c85ce);
$parcel$export(module.exports, "default", () => $cf1eb502962d87a8$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/Pointer
 */ 
var $1O6bd = parcelRequire("1O6bd");

var $4U60I = parcelRequire("4U60I");
/**
 * @typedef {Object} Options
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleDownEvent]
 * Function handling "down" events. If the function returns `true` then a drag
 * sequence is started.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleDragEvent]
 * Function handling "drag" events. This function is called on "move" events
 * during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. The function may return `false` to prevent the
 * propagation of the event to other interactions in the map's interactions
 * chain.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleMoveEvent]
 * Function handling "move" events. This function is called on "move" events.
 * This functions is also called during a drag sequence, so during a drag
 * sequence both the `handleDragEvent` function and this function are called.
 * If `handleDownEvent` is defined and it returns true this function will not
 * be called during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleUpEvent]
 *  Function handling "up" events. If the function returns `false` then the
 * current drag sequence is stopped.
 * @property {function(boolean):boolean} [stopDown]
 * Should the down event be propagated to other interactions, or should be
 * stopped?
 */ /**
 * @classdesc
 * Base class that calls user-defined functions on `down`, `move` and `up`
 * events. This class also manages "drag sequences".
 *
 * When the `handleDownEvent` user function returns `true` a drag sequence is
 * started. During a drag sequence the `handleDragEvent` user function is
 * called on `move` events. The drag sequence ends when the `handleUpEvent`
 * user function is called and returns `false`.
 * @api
 */ class $cf1eb502962d87a8$var$PointerInteraction extends (0, $4U60I.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        if (options.handleDownEvent) this.handleDownEvent = options.handleDownEvent;
        if (options.handleDragEvent) this.handleDragEvent = options.handleDragEvent;
        if (options.handleMoveEvent) this.handleMoveEvent = options.handleMoveEvent;
        if (options.handleUpEvent) this.handleUpEvent = options.handleUpEvent;
        if (options.stopDown) this.stopDown = options.stopDown;
        /**
     * @type {boolean}
     * @protected
     */ this.handlingDownUpSequence = false;
        /**
     * @type {Array<PointerEvent>}
     * @protected
     */ this.targetPointers = [];
    }
    /**
   * Returns the current number of pointers involved in the interaction,
   * e.g. `2` when two fingers are used.
   * @return {number} The number of pointers.
   * @api
   */ getPointerCount() {
        return this.targetPointers.length;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleDownEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleDragEvent(mapBrowserEvent) {}
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may call into
   * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
   * detected.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent) return true;
        let stopEvent = false;
        this.updateTrackedPointers_(mapBrowserEvent);
        if (this.handlingDownUpSequence) {
            if (mapBrowserEvent.type == (0, $1O6bd.default).POINTERDRAG) {
                this.handleDragEvent(mapBrowserEvent);
                // prevent page scrolling during dragging
                mapBrowserEvent.originalEvent.preventDefault();
            } else if (mapBrowserEvent.type == (0, $1O6bd.default).POINTERUP) {
                const handledUp = this.handleUpEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handledUp && this.targetPointers.length > 0;
            }
        } else {
            if (mapBrowserEvent.type == (0, $1O6bd.default).POINTERDOWN) {
                const handled = this.handleDownEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handled;
                stopEvent = this.stopDown(handled);
            } else if (mapBrowserEvent.type == (0, $1O6bd.default).POINTERMOVE) this.handleMoveEvent(mapBrowserEvent);
        }
        return !stopEvent;
    }
    /**
   * Handle pointer move events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleMoveEvent(mapBrowserEvent) {}
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleUpEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * This function is used to determine if "down" events should be propagated
   * to other interactions or should be stopped.
   * @param {boolean} handled Was the event handled by the interaction?
   * @return {boolean} Should the `down` event be stopped?
   */ stopDown(handled) {
        return handled;
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @private
   */ updateTrackedPointers_(mapBrowserEvent) {
        if (mapBrowserEvent.activePointers) this.targetPointers = mapBrowserEvent.activePointers;
    }
}
function $cf1eb502962d87a8$export$e2a20c553f6c85ce(pointerEvents) {
    const length = pointerEvents.length;
    let clientX = 0;
    let clientY = 0;
    for(let i = 0; i < length; i++){
        clientX += pointerEvents[i].clientX;
        clientY += pointerEvents[i].clientY;
    }
    return {
        clientX: clientX / length,
        clientY: clientY / length
    };
}
var $cf1eb502962d87a8$export$2e2bcd8739ae039 = $cf1eb502962d87a8$var$PointerInteraction;

});


parcelRegister("2bF2e", function(module, exports) {

$parcel$export(module.exports, "default", () => $197c7092261b2aa0$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/DragRotate
 */ 
var $kqI9g = parcelRequire("kqI9g");

var $6wUzV = parcelRequire("6wUzV");

var $ip5LZ = parcelRequire("ip5LZ");

var $hMuFm = parcelRequire("hMuFm");
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a
 * {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.altShiftKeysOnly}.
 * @property {number} [duration=250] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when the alt and shift keys are held down.
 *
 * This interaction is only supported for mouse devices.
 * @api
 */ class $197c7092261b2aa0$var$DragRotate extends (0, $hMuFm.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super({
            stopDown: (0, $6wUzV.FALSE)
        });
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $kqI9g.altShiftKeysOnly);
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        if (!(0, $kqI9g.mouseOnly)(mapBrowserEvent)) return;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, $ip5LZ.disable)) return;
        const size = map.getSize();
        const offset = mapBrowserEvent.pixel;
        const theta = Math.atan2(size[1] / 2 - offset[1], offset[0] - size[0] / 2);
        if (this.lastAngle_ !== undefined) {
            const delta = theta - this.lastAngle_;
            view.adjustRotationInternal(-delta);
        }
        this.lastAngle_ = theta;
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (!(0, $kqI9g.mouseOnly)(mapBrowserEvent)) return true;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        view.endInteraction(this.duration_);
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (!(0, $kqI9g.mouseOnly)(mapBrowserEvent)) return false;
        if ((0, $kqI9g.mouseActionButton)(mapBrowserEvent) && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            map.getView().beginInteraction();
            this.lastAngle_ = undefined;
            return true;
        }
        return false;
    }
}
var $197c7092261b2aa0$export$2e2bcd8739ae039 = $197c7092261b2aa0$var$DragRotate;

});

parcelRegister("f5G4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $afc7f51010a5b660$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/DragZoom
 */ 
var $h9x7v = parcelRequire("h9x7v");

var $kqI9g = parcelRequire("kqI9g");

var $jgkip = parcelRequire("jgkip");
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragzoom'] CSS class name for styling the
 * box.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.shiftKeyOnly}.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {boolean} [out=false] Use interaction for zooming out.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the parent default
 * `boxEndCondition` function.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when a key, shift by default, is held down.
 *
 * To change the style of the box, use CSS and the `.ol-dragzoom` selector, or
 * your custom one configured with `className`.
 * @api
 */ class $afc7f51010a5b660$var$DragZoom extends (0, $jgkip.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const condition = options.condition ? options.condition : (0, $kqI9g.shiftKeyOnly);
        super({
            condition: condition,
            className: options.className || 'ol-dragzoom',
            minArea: options.minArea
        });
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 200;
        /**
     * @private
     * @type {boolean}
     */ this.out_ = options.out !== undefined ? options.out : false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @override
   */ onBoxEnd(event) {
        const map = this.getMap();
        const view = /** @type {!import("../View.js").default} */ map.getView();
        let geometry = this.getGeometry();
        if (this.out_) {
            const rotatedExtent = view.rotatedExtentForGeometry(geometry);
            const resolution = view.getResolutionForExtentInternal(rotatedExtent);
            const factor = view.getResolution() / resolution;
            geometry = geometry.clone();
            geometry.scale(factor * factor);
        }
        view.fitInternal(geometry, {
            duration: this.duration_,
            easing: (0, $h9x7v.easeOut)
        });
    }
}
var $afc7f51010a5b660$export$2e2bcd8739ae039 = $afc7f51010a5b660$var$DragZoom;

});
parcelRegister("jgkip", function(module, exports) {

$parcel$export(module.exports, "default", () => $e05f414bc3918235$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/DragBox
 */ // FIXME draw drag box

var $f18Q2 = parcelRequire("f18Q2");

var $kqI9g = parcelRequire("kqI9g");

var $gRRde = parcelRequire("gRRde");

var $hMuFm = parcelRequire("hMuFm");
/**
 * A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s and returns a `{boolean}`. If the condition is met,
 * true should be returned.
 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default, import("../pixel.js").Pixel, import("../pixel.js").Pixel):boolean} EndCondition
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragbox'] CSS class name for styling the box.
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link ol/events/condition~mouseActionButton}.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the default
 * `boxEndCondition` function.
 * @property {EndCondition} [boxEndCondition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s to indicate whether a `boxend` event should be fired.
 * Default is `true` if the area of the box is bigger than the `minArea` option.
 * @property {function(this:DragBox, import("../MapBrowserEvent.js").default):void} [onBoxEnd] Code to execute just
 * before `boxend` is fired.
 */ /**
 * @enum {string}
 */ const $e05f414bc3918235$var$DragBoxEventType = {
    /**
   * Triggered upon drag box start.
   * @event DragBoxEvent#boxstart
   * @api
   */ BOXSTART: 'boxstart',
    /**
   * Triggered on drag when box is active.
   * @event DragBoxEvent#boxdrag
   * @api
   */ BOXDRAG: 'boxdrag',
    /**
   * Triggered upon drag box end.
   * @event DragBoxEvent#boxend
   * @api
   */ BOXEND: 'boxend',
    /**
   * Triggered upon drag box canceled.
   * @event DragBoxEvent#boxcancel
   * @api
   */ BOXCANCEL: 'boxcancel'
};
class $e05f414bc3918235$export$7053c33c051365ea extends (0, $f18Q2.default) {
    /**
   * @param {string} type The event type.
   * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Originating event.
   */ constructor(type, coordinate, mapBrowserEvent){
        super(type);
        /**
     * The coordinate of the drag event.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ this.coordinate = coordinate;
        /**
     * @const
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'boxcancel'|'boxdrag'|'boxend'|'boxstart', DragBoxEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'boxcancel'|'boxdrag'|'boxend', Return>} DragBoxOnSignature
 */ /**
 * @classdesc
 * Allows the user to draw a vector box by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when the shift or other key is held down. This is used, for example,
 * for zooming to a specific area of the map
 * (see {@link module:ol/interaction/DragZoom~DragZoom} and
 * {@link module:ol/interaction/DragRotateAndZoom~DragRotateAndZoom}).
 *
 * @fires DragBoxEvent
 * @api
 */ class $e05f414bc3918235$var$DragBox extends (0, $hMuFm.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {DragBoxOnSignature<void>}
     */ this.un;
        options = options ?? {};
        /**
     * @type {import("../render/Box.js").default}
     * @private
     */ this.box_ = new (0, $gRRde.default)(options.className || 'ol-dragbox');
        /**
     * @type {number}
     * @private
     */ this.minArea_ = options.minArea ?? 64;
        if (options.onBoxEnd) this.onBoxEnd = options.onBoxEnd;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ?? (0, $kqI9g.mouseActionButton);
        /**
     * @private
     * @type {EndCondition}
     */ this.boxEndCondition_ = options.boxEndCondition ?? this.defaultBoxEndCondition;
    }
    /**
   * The default condition for determining whether the boxend event
   * should fire.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
   *     leading to the box end.
   * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
   * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
   * @return {boolean} Whether or not the boxend condition should be fired.
   */ defaultBoxEndCondition(mapBrowserEvent, startPixel, endPixel) {
        const width = endPixel[0] - startPixel[0];
        const height = endPixel[1] - startPixel[1];
        return width * width + height * height >= this.minArea_;
    }
    /**
   * Returns geometry of last drawn box.
   * @return {import("../geom/Polygon.js").default} Geometry.
   * @api
   */ getGeometry() {
        return this.box_.getGeometry();
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        if (!this.startPixel_) return;
        this.box_.setPixels(this.startPixel_, mapBrowserEvent.pixel);
        this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXDRAG, mapBrowserEvent.coordinate, mapBrowserEvent));
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (!this.startPixel_) return false;
        const completeBox = this.boxEndCondition_(mapBrowserEvent, this.startPixel_, mapBrowserEvent.pixel);
        if (completeBox) this.onBoxEnd(mapBrowserEvent);
        this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea(completeBox ? $e05f414bc3918235$var$DragBoxEventType.BOXEND : $e05f414bc3918235$var$DragBoxEventType.BOXCANCEL, mapBrowserEvent.coordinate, mapBrowserEvent));
        this.box_.setMap(null);
        this.startPixel_ = null;
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.condition_(mapBrowserEvent)) {
            this.startPixel_ = mapBrowserEvent.pixel;
            this.box_.setMap(mapBrowserEvent.map);
            this.box_.setPixels(this.startPixel_, this.startPixel_);
            this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXSTART, mapBrowserEvent.coordinate, mapBrowserEvent));
            return true;
        }
        return false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */ onBoxEnd(event) {}
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   * @override
   */ setActive(active) {
        if (!active) {
            this.box_.setMap(null);
            if (this.startPixel_) {
                this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXCANCEL, this.startPixel_, null));
                this.startPixel_ = null;
            }
        }
        super.setActive(active);
    }
    /**
   * @param {import("../Map.js").default|null} map Map.
   * @override
   */ setMap(map) {
        const oldMap = this.getMap();
        if (oldMap) {
            this.box_.setMap(null);
            if (this.startPixel_) {
                this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXCANCEL, this.startPixel_, null));
                this.startPixel_ = null;
            }
        }
        super.setMap(map);
    }
}
var $e05f414bc3918235$export$2e2bcd8739ae039 = $e05f414bc3918235$var$DragBox;

});
parcelRegister("gRRde", function(module, exports) {

$parcel$export(module.exports, "default", () => $c47adf75308683a6$export$2e2bcd8739ae039);
/**
 * @module ol/render/Box
 */ 
var $4kyFN = parcelRequire("4kyFN");

var $5ydre = parcelRequire("5ydre");
class $c47adf75308683a6$var$RenderBox extends (0, $4kyFN.default) {
    /**
   * @param {string} className CSS class name.
   */ constructor(className){
        super();
        /**
     * @type {import("../geom/Polygon.js").default}
     * @private
     */ this.geometry_ = null;
        /**
     * @type {HTMLDivElement}
     * @private
     */ this.element_ = document.createElement('div');
        this.element_.style.position = 'absolute';
        this.element_.style.pointerEvents = 'auto';
        this.element_.className = 'ol-box ' + className;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.endPixel_ = null;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.setMap(null);
    }
    /**
   * @private
   */ render_() {
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const px = 'px';
        const style = this.element_.style;
        style.left = Math.min(startPixel[0], endPixel[0]) + px;
        style.top = Math.min(startPixel[1], endPixel[1]) + px;
        style.width = Math.abs(endPixel[0] - startPixel[0]) + px;
        style.height = Math.abs(endPixel[1] - startPixel[1]) + px;
    }
    /**
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        if (this.map_) {
            this.map_.getOverlayContainer().removeChild(this.element_);
            const style = this.element_.style;
            style.left = 'inherit';
            style.top = 'inherit';
            style.width = 'inherit';
            style.height = 'inherit';
        }
        this.map_ = map;
        if (this.map_) this.map_.getOverlayContainer().appendChild(this.element_);
    }
    /**
   * @param {import("../pixel.js").Pixel} startPixel Start pixel.
   * @param {import("../pixel.js").Pixel} endPixel End pixel.
   */ setPixels(startPixel, endPixel) {
        this.startPixel_ = startPixel;
        this.endPixel_ = endPixel;
        this.createOrUpdateGeometry();
        this.render_();
    }
    /**
   * Creates or updates the cached geometry.
   */ createOrUpdateGeometry() {
        if (!this.map_) return;
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const pixels = [
            startPixel,
            [
                startPixel[0],
                endPixel[1]
            ],
            endPixel,
            [
                endPixel[0],
                startPixel[1]
            ]
        ];
        const coordinates = pixels.map(this.map_.getCoordinateFromPixelInternal, this.map_);
        // close the polygon
        coordinates[4] = coordinates[0].slice();
        if (!this.geometry_) this.geometry_ = new (0, $5ydre.default)([
            coordinates
        ]);
        else this.geometry_.setCoordinates([
            coordinates
        ]);
    }
    /**
   * @return {import("../geom/Polygon.js").default} Geometry.
   */ getGeometry() {
        return this.geometry_;
    }
}
var $c47adf75308683a6$export$2e2bcd8739ae039 = $c47adf75308683a6$var$RenderBox;

});



parcelRegister("21kEk", function(module, exports) {

$parcel$export(module.exports, "default", () => $178bb1517d626802$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/KeyboardPan
 */ 
var $2o3CH = parcelRequire("2o3CH");

var $3xzSb = parcelRequire("3xzSb");

var $4GopZ = parcelRequire("4GopZ");

var $kqI9g = parcelRequire("kqI9g");

var $4U60I = parcelRequire("4U60I");
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.noModifierKeys} and
 * {@link module:ol/events/condition.targetNotEditable}.
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {number} [pixelDelta=128] The amount of pixels to pan on each key
 * press.
 */ /**
 * @classdesc
 * Allows the user to pan the map using keyboard arrows.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}.
 * @api
 */ class $178bb1517d626802$var$KeyboardPan extends (0, $4U60I.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options || {};
        /**
     * @private
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
     * @return {boolean} Combined condition result.
     */ this.defaultCondition_ = function(mapBrowserEvent) {
            return (0, $kqI9g.noModifierKeys)(mapBrowserEvent) && (0, $kqI9g.targetNotEditable)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition !== undefined ? options.condition : this.defaultCondition_;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
        /**
     * @private
     * @type {number}
     */ this.pixelDelta_ = options.pixelDelta !== undefined ? options.pixelDelta : 128;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides the direction to pan to (if an arrow key was
   * pressed).
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $3xzSb.default).KEYDOWN) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key == (0, $4GopZ.default).DOWN || key == (0, $4GopZ.default).LEFT || key == (0, $4GopZ.default).RIGHT || key == (0, $4GopZ.default).UP)) {
                const map = mapBrowserEvent.map;
                const view = map.getView();
                const mapUnitsDelta = view.getResolution() * this.pixelDelta_;
                let deltaX = 0, deltaY = 0;
                if (key == (0, $4GopZ.default).DOWN) deltaY = -mapUnitsDelta;
                else if (key == (0, $4GopZ.default).LEFT) deltaX = -mapUnitsDelta;
                else if (key == (0, $4GopZ.default).RIGHT) deltaX = mapUnitsDelta;
                else deltaY = mapUnitsDelta;
                const delta = [
                    deltaX,
                    deltaY
                ];
                (0, $2o3CH.rotate)(delta, view.getRotation());
                (0, $4U60I.pan)(view, delta, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
var $178bb1517d626802$export$2e2bcd8739ae039 = $178bb1517d626802$var$KeyboardPan;

});
parcelRegister("4GopZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $368e06a3031941b5$export$2e2bcd8739ae039);
/**
 * @module ol/events/Key
 */ /**
 * @enum {string}
 * @const
 */ var $368e06a3031941b5$export$2e2bcd8739ae039 = {
    LEFT: 'ArrowLeft',
    UP: 'ArrowUp',
    RIGHT: 'ArrowRight',
    DOWN: 'ArrowDown'
};

});


parcelRegister("2W903", function(module, exports) {

$parcel$export(module.exports, "default", () => $2237fabfa170eefc$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/KeyboardZoom
 */ 
var $3xzSb = parcelRequire("3xzSb");

var $kqI9g = parcelRequire("kqI9g");

var $4U60I = parcelRequire("4U60I");
/**
 * @typedef {Object} Options
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. The default condition is
 * that {@link module:ol/events/condition.targetNotEditable} is fulfilled and that
 * the platform modifier key isn't pressed
 * (!{@link module:ol/events/condition.platformModifierKey}).
 * @property {number} [delta=1] The zoom level delta on each key press.
 */ /**
 * @classdesc
 * Allows the user to zoom the map using keyboard + and -.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardPan~KeyboardPan}.
 * @api
 */ class $2237fabfa170eefc$var$KeyboardZoom extends (0, $4U60I.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : function(mapBrowserEvent) {
            return !(0, $kqI9g.platformModifierKey)(mapBrowserEvent) && (0, $kqI9g.targetNotEditable)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
   * key pressed was '+' or '-').
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $3xzSb.default).KEYDOWN || mapBrowserEvent.type == (0, $3xzSb.default).KEYPRESS) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key === '+' || key === '-')) {
                const map = mapBrowserEvent.map;
                const delta = key === '+' ? this.delta_ : -this.delta_;
                const view = map.getView();
                (0, $4U60I.zoomByDelta)(view, delta, undefined, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
var $2237fabfa170eefc$export$2e2bcd8739ae039 = $2237fabfa170eefc$var$KeyboardZoom;

});

parcelRegister("eEiUy", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaa378764710d71e$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/MouseWheelZoom
 */ 
var $3xzSb = parcelRequire("3xzSb");

var $kqI9g = parcelRequire("kqI9g");

var $9byFX = parcelRequire("9byFX");

var $4U60I = parcelRequire("4U60I");
/**
 * @typedef {'trackpad' | 'wheel'} Mode
 */ /**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.always}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {number} [maxDelta=1] Maximum mouse wheel delta.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [timeout=80] Mouse wheel timeout duration in milliseconds.
 * @property {boolean} [useAnchor=true] Enable zooming using the mouse's
 * location as the anchor. When set to `false`, zooming in and out will zoom to
 * the center of the screen instead of zooming on the mouse's location.
 * @property {boolean} [constrainResolution=false] If true, the mouse wheel zoom
 * event will always animate to the closest zoom level after an interaction;
 * false means intermediary zoom levels are allowed.
 */ /**
 * Mutliplier for the DOM_DELTA_LINE delta value.
 * @type {number}
 */ const $aaa378764710d71e$var$DELTA_LINE_MULTIPLIER = 40;
/**
 * Mutliplier for the DOM_DELTA_PAGE delta value.
 * @type {number}
 */ const $aaa378764710d71e$var$DELTA_PAGE_MULTIPLIER = 300;
/**
 * @classdesc
 * Allows the user to zoom the map by scrolling the mouse wheel.
 * @api
 */ class $aaa378764710d71e$var$MouseWheelZoom extends (0, $4U60I.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        /**
     * @private
     * @type {number}
     */ this.totalDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.lastDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = options.maxDelta !== undefined ? options.maxDelta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @private
     * @type {number}
     */ this.timeout_ = options.timeout !== undefined ? options.timeout : 80;
        /**
     * @private
     * @type {boolean}
     */ this.useAnchor_ = options.useAnchor !== undefined ? options.useAnchor : true;
        /**
     * @private
     * @type {boolean}
     */ this.constrainResolution_ = options.constrainResolution !== undefined ? options.constrainResolution : false;
        const condition = options.condition ? options.condition : (0, $kqI9g.always);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, $kqI9g.all)((0, $kqI9g.focusWithTabindex), condition) : condition;
        /**
     * @private
     * @type {?import("../pixel.js").Pixel}
     */ this.lastAnchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.startTime_ = undefined;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.timeoutId_;
        /**
     * @private
     * @type {Mode|undefined}
     */ this.mode_ = undefined;
        /**
     * Trackpad events separated by this delay will be considered separate
     * interactions.
     * @private
     * @type {number}
     */ this.trackpadEventGap_ = 400;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.trackpadTimeoutId_;
        /**
     * The number of delta values per zoom level
     * @private
     * @type {number}
     */ this.deltaPerZoom_ = 300;
    }
    /**
   * @private
   */ endInteraction_() {
        this.trackpadTimeoutId_ = undefined;
        const map = this.getMap();
        if (!map) return;
        const view = map.getView();
        view.endInteraction(undefined, this.lastDelta_ ? this.lastDelta_ > 0 ? 1 : -1 : 0, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null);
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
   * zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) return true;
        const type = mapBrowserEvent.type;
        if (type !== (0, $3xzSb.default).WHEEL) return true;
        const map = mapBrowserEvent.map;
        const wheelEvent = /** @type {WheelEvent} */ mapBrowserEvent.originalEvent;
        wheelEvent.preventDefault();
        if (this.useAnchor_) this.lastAnchor_ = mapBrowserEvent.pixel;
        // Delta normalisation inspired by
        // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js
        let delta = wheelEvent.deltaY;
        switch(wheelEvent.deltaMode){
            case WheelEvent.DOM_DELTA_LINE:
                delta *= $aaa378764710d71e$var$DELTA_LINE_MULTIPLIER;
                break;
            case WheelEvent.DOM_DELTA_PAGE:
                delta *= $aaa378764710d71e$var$DELTA_PAGE_MULTIPLIER;
                break;
            default:
        }
        if (delta === 0) return false;
        this.lastDelta_ = delta;
        const now = Date.now();
        if (this.startTime_ === undefined) this.startTime_ = now;
        if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) this.mode_ = Math.abs(delta) < 4 ? 'trackpad' : 'wheel';
        const view = map.getView();
        if (this.mode_ === 'trackpad' && !(view.getConstrainResolution() || this.constrainResolution_)) {
            if (this.trackpadTimeoutId_) clearTimeout(this.trackpadTimeoutId_);
            else {
                if (view.getAnimating()) view.cancelAnimations();
                view.beginInteraction();
            }
            this.trackpadTimeoutId_ = setTimeout(this.endInteraction_.bind(this), this.timeout_);
            view.adjustZoom(-delta / this.deltaPerZoom_, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null);
            this.startTime_ = now;
            return false;
        }
        this.totalDelta_ += delta;
        const timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);
        clearTimeout(this.timeoutId_);
        this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);
        return false;
    }
    /**
   * @private
   * @param {import("../Map.js").default} map Map.
   */ handleWheelZoom_(map) {
        const view = map.getView();
        if (view.getAnimating()) view.cancelAnimations();
        let delta = -(0, $9byFX.clamp)(this.totalDelta_, -this.maxDelta_ * this.deltaPerZoom_, this.maxDelta_ * this.deltaPerZoom_) / this.deltaPerZoom_;
        if (view.getConstrainResolution() || this.constrainResolution_) // view has a zoom constraint, zoom by 1
        delta = delta ? delta > 0 ? 1 : -1 : 0;
        (0, $4U60I.zoomByDelta)(view, delta, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null, this.duration_);
        this.mode_ = undefined;
        this.totalDelta_ = 0;
        this.lastAnchor_ = null;
        this.startTime_ = undefined;
        this.timeoutId_ = undefined;
    }
    /**
   * Enable or disable using the mouse's location as an anchor when zooming
   * @param {boolean} useAnchor true to zoom to the mouse's location, false
   * to zoom to the center of the map
   * @api
   */ setMouseAnchor(useAnchor) {
        this.useAnchor_ = useAnchor;
        if (!useAnchor) this.lastAnchor_ = null;
    }
}
var $aaa378764710d71e$export$2e2bcd8739ae039 = $aaa378764710d71e$var$MouseWheelZoom;

});

parcelRegister("cYAky", function(module, exports) {

$parcel$export(module.exports, "default", () => $9727451f2459496c$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/PinchRotate
 */ 
var $6wUzV = parcelRequire("6wUzV");

var $ip5LZ = parcelRequire("ip5LZ");

var $hMuFm = parcelRequire("hMuFm");
/**
 * @typedef {Object} Options
 * @property {number} [duration=250] The duration of the animation in
 * milliseconds.
 * @property {number} [threshold=0.3] Minimal angle in radians to start a rotation.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by twisting with two fingers
 * on a touch screen.
 * @api
 */ class $9727451f2459496c$var$PinchRotate extends (0, $hMuFm.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $6wUzV.FALSE);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {boolean}
     */ this.rotating_ = false;
        /**
     * @private
     * @type {number}
     */ this.rotationDelta_ = 0.0;
        /**
     * @private
     * @type {number}
     */ this.threshold_ = options.threshold !== undefined ? options.threshold : 0.3;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        let rotationDelta = 0.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        // angle between touches
        const angle = Math.atan2(touch1.clientY - touch0.clientY, touch1.clientX - touch0.clientX);
        if (this.lastAngle_ !== undefined) {
            const delta = angle - this.lastAngle_;
            this.rotationDelta_ += delta;
            if (!this.rotating_ && Math.abs(this.rotationDelta_) > this.threshold_) this.rotating_ = true;
            rotationDelta = delta;
        }
        this.lastAngle_ = angle;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, $ip5LZ.disable)) return;
        // rotate anchor point.
        // FIXME: should be the intersection point between the lines:
        //     touch0,touch1 and previousTouch0,previousTouch1
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $hMuFm.centroid)(this.targetPointers)));
        // rotate
        if (this.rotating_) {
            map.render();
            view.adjustRotationInternal(rotationDelta, this.anchor_);
        }
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            view.endInteraction(this.duration_);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastAngle_ = undefined;
            this.rotating_ = false;
            this.rotationDelta_ = 0.0;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
var $9727451f2459496c$export$2e2bcd8739ae039 = $9727451f2459496c$var$PinchRotate;

});

parcelRegister("asgrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $79c946b60b88d4a6$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/PinchZoom
 */ 
var $6wUzV = parcelRequire("6wUzV");

var $hMuFm = parcelRequire("hMuFm");
/**
 * @typedef {Object} Options
 * @property {number} [duration=400] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by pinching with two fingers
 * on a touch screen.
 * @api
 */ class $79c946b60b88d4a6$var$PinchZoom extends (0, $hMuFm.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $6wUzV.FALSE);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 400;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastDistance_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.lastScaleDelta_ = 1;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        let scaleDelta = 1.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        const dx = touch0.clientX - touch1.clientX;
        const dy = touch0.clientY - touch1.clientY;
        // distance between touches
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (this.lastDistance_ !== undefined) scaleDelta = this.lastDistance_ / distance;
        this.lastDistance_ = distance;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (scaleDelta != 1.0) this.lastScaleDelta_ = scaleDelta;
        // scale anchor point.
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $hMuFm.centroid)(this.targetPointers)));
        // scale, bypass the resolution constraint
        map.render();
        view.adjustResolutionInternal(scaleDelta, this.anchor_);
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            const direction = this.lastScaleDelta_ > 1 ? 1 : -1;
            view.endInteraction(this.duration_, direction);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastDistance_ = undefined;
            this.lastScaleDelta_ = 1;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
var $79c946b60b88d4a6$export$2e2bcd8739ae039 = $79c946b60b88d4a6$var$PinchZoom;

});


parcelRegister("YSU3I", function(module, exports) {

$parcel$export(module.exports, "GroupEvent", () => $0b703156bb914e6f$export$2f5ff21d758d25a7);
$parcel$export(module.exports, "default", () => $0b703156bb914e6f$export$2e2bcd8739ae039);
/**
 * @module ol/layer/Group
 */ 
var $cD8Qe = parcelRequire("cD8Qe");

var $1TIYs = parcelRequire("1TIYs");

var $jXCUw = parcelRequire("jXCUw");

var $4Cz58 = parcelRequire("4Cz58");

var $f18Q2 = parcelRequire("f18Q2");

var $3xzSb = parcelRequire("3xzSb");

var $ilM9F = parcelRequire("ilM9F");

var $9pD6L = parcelRequire("9pD6L");

var $gn0g3 = parcelRequire("gn0g3");

var $9iPUS = parcelRequire("9iPUS");

var $7xdj9 = parcelRequire("7xdj9");
/**
 * @enum {string}
 */ const $0b703156bb914e6f$var$GroupEventType = {
    /**
   * Triggered when a layer is added
   * @event GroupEvent#addlayer
   * @api
   */ ADDLAYER: 'addlayer',
    /**
   * Triggered when a layer is removed
   * @event GroupEvent#removelayer
   * @api
   */ REMOVELAYER: 'removelayer'
};
class $0b703156bb914e6f$export$2f5ff21d758d25a7 extends (0, $f18Q2.default) {
    /**
   * @param {GroupEventType} type The event type.
   * @param {BaseLayer} layer The layer.
   */ constructor(type, layer){
        super(type);
        /**
     * The added or removed layer.
     * @type {BaseLayer}
     * @api
     */ this.layer = layer;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     'change:layers', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'addlayer'|'removelayer', GroupEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|'addlayer'|'removelayer'|'change:layers', Return>} GroupOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {Array<import("./Base.js").default>|Collection<import("./Base.js").default>} [layers] Child layers.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const $0b703156bb914e6f$var$Property = {
    LAYERS: 'layers'
};
/**
 * @classdesc
 * A {@link module:ol/Collection~Collection} of layers that are handled together.
 *
 * A generic `change` event is triggered when the group/Collection changes.
 *
 * @fires GroupEvent
 * @api
 */ class $0b703156bb914e6f$var$LayerGroup extends (0, $7xdj9.default) {
    /**
   * @param {Options} [options] Layer options.
   */ constructor(options){
        options = options || {};
        const baseOptions = /** @type {Options} */ Object.assign({}, options);
        delete baseOptions.layers;
        let layers = options.layers;
        super(baseOptions);
        /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {GroupOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.layersListenerKeys_ = [];
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.listenerKeys_ = {};
        this.addChangeListener($0b703156bb914e6f$var$Property.LAYERS, this.handleLayersChanged_);
        if (layers) {
            if (Array.isArray(layers)) layers = new (0, $cD8Qe.default)(layers.slice(), {
                unique: true
            });
            else (0, $4Cz58.assert)(typeof /** @type {?} */ layers.getArray === 'function', 'Expected `layers` to be an array or a `Collection`');
        } else layers = new (0, $cD8Qe.default)(undefined, {
            unique: true
        });
        this.setLayers(layers);
    }
    /**
   * @private
   */ handleLayerChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleLayersChanged_() {
        this.layersListenerKeys_.forEach((0, $ilM9F.unlistenByKey));
        this.layersListenerKeys_.length = 0;
        const layers = this.getLayers();
        this.layersListenerKeys_.push((0, $ilM9F.listen)(layers, (0, $1TIYs.default).ADD, this.handleLayersAdd_, this), (0, $ilM9F.listen)(layers, (0, $1TIYs.default).REMOVE, this.handleLayersRemove_, this));
        for(const id in this.listenerKeys_)this.listenerKeys_[id].forEach((0, $ilM9F.unlistenByKey));
        (0, $gn0g3.clear)(this.listenerKeys_);
        const layersArray = layers.getArray();
        for(let i = 0, ii = layersArray.length; i < ii; i++){
            const layer = layersArray[i];
            this.registerLayerListeners_(layer);
            this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7($0b703156bb914e6f$var$GroupEventType.ADDLAYER, layer));
        }
        this.changed();
    }
    /**
   * @param {BaseLayer} layer The layer.
   */ registerLayerListeners_(layer) {
        const listenerKeys = [
            (0, $ilM9F.listen)(layer, (0, $jXCUw.default).PROPERTYCHANGE, this.handleLayerChange_, this),
            (0, $ilM9F.listen)(layer, (0, $3xzSb.default).CHANGE, this.handleLayerChange_, this)
        ];
        if (layer instanceof $0b703156bb914e6f$var$LayerGroup) listenerKeys.push((0, $ilM9F.listen)(layer, $0b703156bb914e6f$var$GroupEventType.ADDLAYER, this.handleLayerGroupAdd_, this), (0, $ilM9F.listen)(layer, $0b703156bb914e6f$var$GroupEventType.REMOVELAYER, this.handleLayerGroupRemove_, this));
        this.listenerKeys_[(0, $9iPUS.getUid)(layer)] = listenerKeys;
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupAdd_(event) {
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7($0b703156bb914e6f$var$GroupEventType.ADDLAYER, event.layer));
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupRemove_(event) {
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7($0b703156bb914e6f$var$GroupEventType.REMOVELAYER, event.layer));
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersAdd_(collectionEvent) {
        const layer = collectionEvent.element;
        this.registerLayerListeners_(layer);
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7($0b703156bb914e6f$var$GroupEventType.ADDLAYER, layer));
        this.changed();
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersRemove_(collectionEvent) {
        const layer = collectionEvent.element;
        const key = (0, $9iPUS.getUid)(layer);
        this.listenerKeys_[key].forEach((0, $ilM9F.unlistenByKey));
        delete this.listenerKeys_[key];
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7($0b703156bb914e6f$var$GroupEventType.REMOVELAYER, layer));
        this.changed();
    }
    /**
   * Returns the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @return {!Collection<import("./Base.js").default>} Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ getLayers() {
        return /** @type {!Collection<import("./Base.js").default>} */ this.get($0b703156bb914e6f$var$Property.LAYERS);
    }
    /**
   * Set the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @param {!Collection<import("./Base.js").default>} layers Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ setLayers(layers) {
        const collection = this.getLayers();
        if (collection) {
            const currentLayers = collection.getArray();
            for(let i = 0, ii = currentLayers.length; i < ii; ++i)this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7($0b703156bb914e6f$var$GroupEventType.REMOVELAYER, currentLayers[i]));
        }
        this.set($0b703156bb914e6f$var$Property.LAYERS, layers);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   * @override
   */ getLayersArray(array) {
        array = array !== undefined ? array : [];
        this.getLayers().forEach(function(layer) {
            layer.getLayersArray(array);
        });
        return array;
    }
    /**
   * Get the layer states list and use this groups z-index as the default
   * for all layers in this and nested groups, if it is unset at this point.
   * If dest is not provided and this group's z-index is undefined
   * 0 is used a the default z-index.
   * @param {Array<import("./Layer.js").State>} [dest] Optional list
   * of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   * @override
   */ getLayerStatesArray(dest) {
        const states = dest !== undefined ? dest : [];
        const pos = states.length;
        this.getLayers().forEach(function(layer) {
            layer.getLayerStatesArray(states);
        });
        const ownLayerState = this.getLayerState();
        let defaultZIndex = ownLayerState.zIndex;
        if (!dest && ownLayerState.zIndex === undefined) defaultZIndex = 0;
        for(let i = pos, ii = states.length; i < ii; i++){
            const layerState = states[i];
            layerState.opacity *= ownLayerState.opacity;
            layerState.visible = layerState.visible && ownLayerState.visible;
            layerState.maxResolution = Math.min(layerState.maxResolution, ownLayerState.maxResolution);
            layerState.minResolution = Math.max(layerState.minResolution, ownLayerState.minResolution);
            layerState.minZoom = Math.max(layerState.minZoom, ownLayerState.minZoom);
            layerState.maxZoom = Math.min(layerState.maxZoom, ownLayerState.maxZoom);
            if (ownLayerState.extent !== undefined) {
                if (layerState.extent !== undefined) layerState.extent = (0, $9pD6L.getIntersection)(layerState.extent, ownLayerState.extent);
                else layerState.extent = ownLayerState.extent;
            }
            if (layerState.zIndex === undefined) layerState.zIndex = defaultZIndex;
        }
        return states;
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   * @override
   */ getSourceState() {
        return 'ready';
    }
}
var $0b703156bb914e6f$export$2e2bcd8739ae039 = $0b703156bb914e6f$var$LayerGroup;

});

parcelRegister("lvfQG", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa78c97693b12120$export$2e2bcd8739ae039);
/**
 * @module ol/renderer/Composite
 */ 
var $jXCUw = parcelRequire("jXCUw");

var $hGHcK = parcelRequire("hGHcK");

var $DfnQm = parcelRequire("DfnQm");

var $ilM9F = parcelRequire("ilM9F");

var $8UoiJ = parcelRequire("8UoiJ");

var $hf3TH = parcelRequire("hf3TH");

var $79s7T = parcelRequire("79s7T");

var $fNIok = parcelRequire("fNIok");

var $l6YBe = parcelRequire("l6YBe");

var $ig1j9 = parcelRequire("ig1j9");

var $jpXrt = parcelRequire("jpXrt");

var $fp9DL = parcelRequire("fp9DL");
/**
 * @classdesc
 * Canvas map renderer.
 * @api
 */ class $fa78c97693b12120$var$CompositeMapRenderer extends (0, $fp9DL.default) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super(map);
        /**
     * @private
     * @type {import("../events.js").EventsKey}
     */ this.fontChangeListenerKey_ = (0, $ilM9F.listen)((0, $ig1j9.checkedFonts), (0, $jXCUw.default).PROPERTYCHANGE, map.redrawText, map);
        /**
     * @private
     * @type {HTMLDivElement}
     */ this.element_ = (0, $8UoiJ.WORKER_OFFSCREEN_CANVAS) ? (0, $DfnQm.createMockDiv)() : document.createElement('div');
        const style = this.element_.style;
        style.position = 'absolute';
        style.width = '100%';
        style.height = '100%';
        style.zIndex = '0';
        this.element_.className = (0, $hGHcK.CLASS_UNSELECTABLE) + ' ol-layers';
        const container = map.getViewport();
        if (container) // maps in a worker do not have a viewport.
        container.insertBefore(this.element_, container.firstChild || null);
        /**
     * @private
     * @type {Array<HTMLElement>}
     */ this.children_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @override
   */ dispatchRenderEvent(type, frameState) {
        const map = this.getMap();
        if (map.hasListener(type)) {
            const event = new (0, $fNIok.default)(type, undefined, frameState);
            map.dispatchEvent(event);
        }
    }
    /**
   * @override
   */ disposeInternal() {
        (0, $ilM9F.unlistenByKey)(this.fontChangeListenerKey_);
        this.element_.remove();
        super.disposeInternal();
    }
    /**
   * Render.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderFrame(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element_.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        this.calculateMatrices2D(frameState);
        this.dispatchRenderEvent((0, $l6YBe.default).PRECOMPOSE, frameState);
        const layerStatesArray = frameState.layerStatesArray.sort((a, b)=>a.zIndex - b.zIndex);
        const declutter = layerStatesArray.some((layerState)=>layerState.layer instanceof (0, $hf3TH.default) && layerState.layer.getDeclutter());
        if (declutter) // Some layers need decluttering, turn on deferred rendering hint
        frameState.declutter = {};
        const viewState = frameState.viewState;
        this.children_.length = 0;
        const renderedLayerStates = [];
        let previousElement = null;
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const layerState = layerStatesArray[i];
            frameState.layerIndex = i;
            const layer = layerState.layer;
            const sourceState = layer.getSourceState();
            if (!(0, $79s7T.inView)(layerState, viewState) || sourceState != 'ready' && sourceState != 'undefined') {
                layer.unrender();
                continue;
            }
            const element = layer.render(frameState, previousElement);
            if (!element) continue;
            if (element !== previousElement) {
                this.children_.push(element);
                previousElement = element;
            }
            renderedLayerStates.push(layerState);
        }
        this.declutter(frameState, renderedLayerStates);
        (0, $DfnQm.replaceChildren)(this.element_, this.children_);
        const map = this.getMap();
        const mapCanvas = map.getTargetElement();
        if ((0, $DfnQm.isCanvas)(mapCanvas)) {
            // Canvas composition when container is a canvas
            const mapContext = mapCanvas.getContext('2d');
            for (const container of this.children_){
                const canvas = container.firstElementChild || container;
                const backgroundColor = container.style.backgroundColor;
                if (backgroundColor && (!(0, $DfnQm.isCanvas)(canvas) || canvas.width > 0)) {
                    mapContext.fillStyle = backgroundColor;
                    mapContext.fillRect(0, 0, mapCanvas.width, mapCanvas.height);
                }
                if ((0, $DfnQm.isCanvas)(canvas) && canvas.width > 0) {
                    mapContext.save();
                    const opacity = container.style.opacity || canvas.style.opacity;
                    mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
                    const transform = canvas.style.transform;
                    if (transform) // Get the transform parameters from the style's transform matrix
                    mapContext.transform(.../** @type {[number, number, number, number, number, number]} */ (0, $jpXrt.fromString)(transform));
                    else {
                        const w = parseFloat(canvas.style.width) / canvas.width;
                        const h = parseFloat(canvas.style.height) / canvas.height;
                        mapContext.transform(w, 0, 0, h, 0, 0);
                    }
                    mapContext.drawImage(canvas, 0, 0);
                    mapContext.restore();
                }
            }
        }
        this.dispatchRenderEvent((0, $l6YBe.default).POSTCOMPOSE, frameState);
        if (!this.renderedVisible_) {
            this.element_.style.display = '';
            this.renderedVisible_ = true;
        }
        this.scheduleExpireIconCache(frameState);
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {Array<import('../layer/Layer.js').State>} layerStates Layers.
   */ declutter(frameState, layerStates) {
        if (!frameState.declutter) return;
        for(let i = layerStates.length - 1; i >= 0; --i){
            const layerState = layerStates[i];
            const layer = layerState.layer;
            if (layer.getDeclutter()) layer.renderDeclutter(frameState, layerState);
        }
        layerStates.forEach((layerState)=>layerState.layer.renderDeferred(frameState));
    }
}
var $fa78c97693b12120$export$2e2bcd8739ae039 = $fa78c97693b12120$var$CompositeMapRenderer;

});
parcelRegister("hf3TH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8d6dc4c09ed9916$export$2e2bcd8739ae039);
/**
 * @module ol/layer/BaseVector
 */ 
var $20GDs = parcelRequire("20GDs");

var $8f0Mc = parcelRequire("8f0Mc");

var $c3RIb = parcelRequire("c3RIb");

var $79s7T = parcelRequire("79s7T");
/***
 * @template T
 * @typedef {T extends import("../source/Vector.js").default<infer U extends import("../Feature.js").FeatureLike> ? U : never} ExtractedFeatureType
 */ /**
 * @template {import('../Feature').FeatureLike} FeatureType
 * @template {import("../source/Vector.js").default<FeatureType>|import("../source/VectorTile.js").default<FeatureType>} VectorSourceType<FeatureType>
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const $c8d6dc4c09ed9916$var$Property = {
    RENDER_ORDER: 'renderOrder'
};
/**
 * @classdesc
 * Vector data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import('../Feature').FeatureLike} FeatureType
 * @template {import("../source/Vector.js").default<FeatureType>|import("../source/VectorTile.js").default<FeatureType>} VectorSourceType<FeatureType>
 * @extends {Layer<VectorSourceType, RendererType>}
 * @template {import("../renderer/canvas/VectorLayer.js").default|import("../renderer/canvas/VectorTileLayer.js").default|import("../renderer/canvas/VectorImageLayer.js").default|import("../renderer/webgl/VectorLayer.js").default|import("../renderer/webgl/PointsLayer.js").default} RendererType
 * @api
 */ class $c8d6dc4c09ed9916$var$BaseVectorLayer extends (0, $79s7T.default) {
    /**
   * @param {Options<FeatureType, VectorSourceType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        delete baseOptions.style;
        delete baseOptions.renderBuffer;
        delete baseOptions.updateWhileAnimating;
        delete baseOptions.updateWhileInteracting;
        super(baseOptions);
        /**
     * @private
     * @type {string}
     */ this.declutter_ = options.declutter ? String(options.declutter) : undefined;
        /**
     * @type {number}
     * @private
     */ this.renderBuffer_ = options.renderBuffer !== undefined ? options.renderBuffer : 100;
        /**
     * User provided style.
     * @type {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike}
     * @private
     */ this.style_ = null;
        /**
     * Style function for use within the library.
     * @type {import("../style/Style.js").StyleFunction|undefined}
     * @private
     */ this.styleFunction_ = undefined;
        this.setStyle(options.style);
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileAnimating_ = options.updateWhileAnimating !== undefined ? options.updateWhileAnimating : false;
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileInteracting_ = options.updateWhileInteracting !== undefined ? options.updateWhileInteracting : false;
    }
    /**
   * @return {string} Declutter group.
   * @override
   */ getDeclutter() {
        return this.declutter_;
    }
    /**
   * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
   * that resolves with an array of features. The array will either contain the topmost feature
   * when a hit was detected, or it will be empty.
   *
   * The hit detection algorithm used for this method is optimized for performance, but is less
   * accurate than the one used in [map.getFeaturesAtPixel()]{@link import("../Map.js").default#getFeaturesAtPixel}.
   * Text is not considered, and icons are only represented by their bounding box instead of the exact
   * image.
   *
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with an array of features.
   * @api
   * @override
   */ getFeatures(pixel) {
        return super.getFeatures(pixel);
    }
    /**
   * @return {number|undefined} Render buffer.
   */ getRenderBuffer() {
        return this.renderBuffer_;
    }
    /**
   * @return {import("../render.js").OrderFunction|null|undefined} Render order.
   */ getRenderOrder() {
        return /** @type {import("../render.js").OrderFunction|null|undefined} */ this.get($c8d6dc4c09ed9916$var$Property.RENDER_ORDER);
    }
    /**
   * Get the style for features.  This returns whatever was passed to the `style`
   * option at construction or to the `setStyle` method.
   * @return {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null|undefined} Layer style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the style function.
   * @return {import("../style/Style.js").StyleFunction|undefined} Layer style function.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     animating.
   */ getUpdateWhileAnimating() {
        return this.updateWhileAnimating_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     interacting.
   */ getUpdateWhileInteracting() {
        return this.updateWhileInteracting_;
    }
    /**
   * Render declutter items for this layer
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   * @override
   */ renderDeclutter(frameState, layerState) {
        const declutterGroup = this.getDeclutter();
        if (declutterGroup in frameState.declutter === false) frameState.declutter[declutterGroup] = new (0, (/*@__PURE__*/$parcel$interopDefault($20GDs)))(9);
        this.getRenderer().renderDeclutter(frameState, layerState);
    }
    /**
   * @param {import("../render.js").OrderFunction|null|undefined} renderOrder
   *     Render order.
   */ setRenderOrder(renderOrder) {
        this.set($c8d6dc4c09ed9916$var$Property.RENDER_ORDER, renderOrder);
    }
    /**
   * Set the style for features.  This can be a single style object, an array
   * of styles, or a function that takes a feature and resolution and returns
   * an array of styles. If set to `null`, the layer has no style (a `null` style),
   * so only features that have their own styles will be rendered in the layer. Call
   * `setStyle()` without arguments to reset to the default style. See
   * [the ol/style/Style module]{@link module:ol/style/Style~Style} for information on the default style.
   *
   * If your layer has a static style, you can use [flat style]{@link module:ol/style/flat~FlatStyle} object
   * literals instead of using the `Style` and symbolizer constructors (`Fill`, `Stroke`, etc.):
   * ```js
   * vectorLayer.setStyle({
   *   "fill-color": "yellow",
   *   "stroke-color": "black",
   *   "stroke-width": 4
   * })
   * ```
   *
   * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
   * @api
   */ setStyle(style) {
        this.style_ = style === undefined ? (0, $c3RIb.createDefaultStyle) : style;
        const styleLike = $c8d6dc4c09ed9916$var$toStyleLike(style);
        this.styleFunction_ = style === null ? undefined : (0, $c3RIb.toFunction)(styleLike);
        this.changed();
    }
    /**
   * @param {boolean|string|number} declutter Declutter images and text.
   * @api
   */ setDeclutter(declutter) {
        this.declutter_ = declutter ? String(declutter) : undefined;
        this.changed();
    }
}
/**
 * Coerce the allowed style types into a shorter list of types.  Flat styles, arrays of flat
 * styles, and arrays of rules are converted into style functions.
 *
 * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
 * @return {import("../style/Style.js").StyleLike|null} The style.
 */ function $c8d6dc4c09ed9916$var$toStyleLike(style) {
    if (style === undefined) return 0, $c3RIb.createDefaultStyle;
    if (!style) return null;
    if (typeof style === 'function') return style;
    if (style instanceof (0, $c3RIb.default)) return style;
    if (!Array.isArray(style)) return (0, $8f0Mc.flatStylesToStyleFunction)([
        style
    ]);
    if (style.length === 0) return [];
    const length = style.length;
    const first = style[0];
    if (first instanceof (0, $c3RIb.default)) {
        /**
     * @type {Array<Style>}
     */ const styles = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!(candidate instanceof (0, $c3RIb.default))) throw new Error('Expected a list of style instances');
            styles[i] = candidate;
        }
        return styles;
    }
    if ('style' in first) {
        /**
     * @type {Array<import("../style/flat.js").Rule>}
     */ const rules = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!('style' in candidate)) throw new Error('Expected a list of rules with a style property');
            rules[i] = candidate;
        }
        return (0, $8f0Mc.rulesToStyleFunction)(rules);
    }
    const flatStyles = /** @type {Array<import("../style/flat.js").FlatStyle>} */ style;
    return (0, $8f0Mc.flatStylesToStyleFunction)(flatStyles);
}
var $c8d6dc4c09ed9916$export$2e2bcd8739ae039 = $c8d6dc4c09ed9916$var$BaseVectorLayer;

});
parcelRegister("20GDs", function(module, exports) {
!function(t, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    function t(e, h, r = 0, s = e.length - 1, a = n) {
        for(; s > r;){
            if (s - r > 600) {
                const i = s - r + 1, n = h - r + 1, o = Math.log(i), l = .5 * Math.exp(2 * o / 3), c = .5 * Math.sqrt(o * l * (i - l) / i) * (n - i / 2 < 0 ? -1 : 1);
                t(e, h, Math.max(r, Math.floor(h - n * l / i + c)), Math.min(s, Math.floor(h + (i - n) * l / i + c)), a);
            }
            const n = e[h];
            let o = r, l = s;
            for(i(e, r, h), a(e[s], n) > 0 && i(e, r, s); o < l;){
                for(i(e, o, l), o++, l--; a(e[o], n) < 0;)o++;
                for(; a(e[l], n) > 0;)l--;
            }
            0 === a(e[r], n) ? i(e, r, l) : (l++, i(e, l, s)), l <= h && (r = l + 1), h <= l && (s = l - 1);
        }
    }
    function i(t, i, n) {
        const e = t[i];
        t[i] = t[n], t[n] = e;
    }
    function n(t, i) {
        return t < i ? -1 : t > i ? 1 : 0;
    }
    function e(t, i, n) {
        if (!n) return i.indexOf(t);
        for(let e = 0; e < i.length; e++)if (n(t, i[e])) return e;
        return -1;
    }
    function h(t, i) {
        r(t, 0, t.children.length, i, t);
    }
    function r(t, i, n, e, h) {
        h || (h = d(null)), h.minX = 1 / 0, h.minY = 1 / 0, h.maxX = -1 / 0, h.maxY = -1 / 0;
        for(let r = i; r < n; r++){
            const i = t.children[r];
            s(h, t.leaf ? e(i) : i);
        }
        return h;
    }
    function s(t, i) {
        return t.minX = Math.min(t.minX, i.minX), t.minY = Math.min(t.minY, i.minY), t.maxX = Math.max(t.maxX, i.maxX), t.maxY = Math.max(t.maxY, i.maxY), t;
    }
    function a(t, i) {
        return t.minX - i.minX;
    }
    function o(t, i) {
        return t.minY - i.minY;
    }
    function l(t) {
        return (t.maxX - t.minX) * (t.maxY - t.minY);
    }
    function c(t) {
        return t.maxX - t.minX + (t.maxY - t.minY);
    }
    function m(t, i) {
        const n = Math.max(t.minX, i.minX), e = Math.max(t.minY, i.minY), h = Math.min(t.maxX, i.maxX), r = Math.min(t.maxY, i.maxY);
        return Math.max(0, h - n) * Math.max(0, r - e);
    }
    function f(t, i) {
        return t.minX <= i.minX && t.minY <= i.minY && i.maxX <= t.maxX && i.maxY <= t.maxY;
    }
    function u(t, i) {
        return i.minX <= t.maxX && i.minY <= t.maxY && i.maxX >= t.minX && i.maxY >= t.minY;
    }
    function d(t) {
        return {
            children: t,
            height: 1,
            leaf: !0,
            minX: 1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            maxY: -1 / 0
        };
    }
    function x(i, n, e, h, r) {
        const s = [
            n,
            e
        ];
        for(; s.length;){
            if ((e = s.pop()) - (n = s.pop()) <= h) continue;
            const a = n + Math.ceil((e - n) / h / 2) * h;
            t(i, a, n, e, r), s.push(n, a, a, e);
        }
    }
    return class {
        constructor(t = 9){
            this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
        }
        all() {
            return this._all(this.data, []);
        }
        search(t) {
            let i = this.data;
            const n = [];
            if (!u(t, i)) return n;
            const e = this.toBBox, h = [];
            for(; i;){
                for(let r = 0; r < i.children.length; r++){
                    const s = i.children[r], a = i.leaf ? e(s) : s;
                    u(t, a) && (i.leaf ? n.push(s) : f(t, a) ? this._all(s, n) : h.push(s));
                }
                i = h.pop();
            }
            return n;
        }
        collides(t) {
            let i = this.data;
            if (!u(t, i)) return !1;
            const n = [];
            for(; i;){
                for(let e = 0; e < i.children.length; e++){
                    const h = i.children[e], r = i.leaf ? this.toBBox(h) : h;
                    if (u(t, r)) {
                        if (i.leaf || f(t, r)) return !0;
                        n.push(h);
                    }
                }
                i = n.pop();
            }
            return !1;
        }
        load(t) {
            if (!t || !t.length) return this;
            if (t.length < this._minEntries) {
                for(let i = 0; i < t.length; i++)this.insert(t[i]);
                return this;
            }
            let i = this._build(t.slice(), 0, t.length - 1, 0);
            if (this.data.children.length) {
                if (this.data.height === i.height) this._splitRoot(this.data, i);
                else {
                    if (this.data.height < i.height) {
                        const t = this.data;
                        this.data = i, i = t;
                    }
                    this._insert(i, this.data.height - i.height - 1, !0);
                }
            } else this.data = i;
            return this;
        }
        insert(t) {
            return t && this._insert(t, this.data.height - 1), this;
        }
        clear() {
            return this.data = d([]), this;
        }
        remove(t, i) {
            if (!t) return this;
            let n = this.data;
            const h = this.toBBox(t), r = [], s = [];
            let a, o, l;
            for(; n || r.length;){
                if (n || (n = r.pop(), o = r[r.length - 1], a = s.pop(), l = !0), n.leaf) {
                    const h = e(t, n.children, i);
                    if (-1 !== h) return n.children.splice(h, 1), r.push(n), this._condense(r), this;
                }
                l || n.leaf || !f(n, h) ? o ? (a++, n = o.children[a], l = !1) : n = null : (r.push(n), s.push(a), a = 0, o = n, n = n.children[0]);
            }
            return this;
        }
        toBBox(t) {
            return t;
        }
        compareMinX(t, i) {
            return t.minX - i.minX;
        }
        compareMinY(t, i) {
            return t.minY - i.minY;
        }
        toJSON() {
            return this.data;
        }
        fromJSON(t) {
            return this.data = t, this;
        }
        _all(t, i) {
            const n = [];
            for(; t;)t.leaf ? i.push(...t.children) : n.push(...t.children), t = n.pop();
            return i;
        }
        _build(t, i, n, e) {
            const r = n - i + 1;
            let s, a = this._maxEntries;
            if (r <= a) return s = d(t.slice(i, n + 1)), h(s, this.toBBox), s;
            e || (e = Math.ceil(Math.log(r) / Math.log(a)), a = Math.ceil(r / Math.pow(a, e - 1))), s = d([]), s.leaf = !1, s.height = e;
            const o = Math.ceil(r / a), l = o * Math.ceil(Math.sqrt(a));
            x(t, i, n, l, this.compareMinX);
            for(let h = i; h <= n; h += l){
                const i = Math.min(h + l - 1, n);
                x(t, h, i, o, this.compareMinY);
                for(let n = h; n <= i; n += o){
                    const h = Math.min(n + o - 1, i);
                    s.children.push(this._build(t, n, h, e - 1));
                }
            }
            return h(s, this.toBBox), s;
        }
        _chooseSubtree(t, i, n, e) {
            for(; e.push(i), !i.leaf && e.length - 1 !== n;){
                let n, e = 1 / 0, s = 1 / 0;
                for(let a = 0; a < i.children.length; a++){
                    const o = i.children[a], c = l(o), m = (h = t, r = o, (Math.max(r.maxX, h.maxX) - Math.min(r.minX, h.minX)) * (Math.max(r.maxY, h.maxY) - Math.min(r.minY, h.minY)) - c);
                    m < s ? (s = m, e = c < e ? c : e, n = o) : m === s && c < e && (e = c, n = o);
                }
                i = n || i.children[0];
            }
            var h, r;
            return i;
        }
        _insert(t, i, n) {
            const e = n ? t : this.toBBox(t), h = [], r = this._chooseSubtree(e, this.data, i, h);
            for(r.children.push(t), s(r, e); i >= 0 && h[i].children.length > this._maxEntries;)this._split(h, i), i--;
            this._adjustParentBBoxes(e, h, i);
        }
        _split(t, i) {
            const n = t[i], e = n.children.length, r = this._minEntries;
            this._chooseSplitAxis(n, r, e);
            const s = this._chooseSplitIndex(n, r, e), a = d(n.children.splice(s, n.children.length - s));
            a.height = n.height, a.leaf = n.leaf, h(n, this.toBBox), h(a, this.toBBox), i ? t[i - 1].children.push(a) : this._splitRoot(n, a);
        }
        _splitRoot(t, i) {
            this.data = d([
                t,
                i
            ]), this.data.height = t.height + 1, this.data.leaf = !1, h(this.data, this.toBBox);
        }
        _chooseSplitIndex(t, i, n) {
            let e, h = 1 / 0, s = 1 / 0;
            for(let a = i; a <= n - i; a++){
                const i = r(t, 0, a, this.toBBox), o = r(t, a, n, this.toBBox), c = m(i, o), f = l(i) + l(o);
                c < h ? (h = c, e = a, s = f < s ? f : s) : c === h && f < s && (s = f, e = a);
            }
            return e || n - i;
        }
        _chooseSplitAxis(t, i, n) {
            const e = t.leaf ? this.compareMinX : a, h = t.leaf ? this.compareMinY : o;
            this._allDistMargin(t, i, n, e) < this._allDistMargin(t, i, n, h) && t.children.sort(e);
        }
        _allDistMargin(t, i, n, e) {
            t.children.sort(e);
            const h = this.toBBox, a = r(t, 0, i, h), o = r(t, n - i, n, h);
            let l = c(a) + c(o);
            for(let e = i; e < n - i; e++){
                const i = t.children[e];
                s(a, t.leaf ? h(i) : i), l += c(a);
            }
            for(let e = n - i - 1; e >= i; e--){
                const i = t.children[e];
                s(o, t.leaf ? h(i) : i), l += c(o);
            }
            return l;
        }
        _adjustParentBBoxes(t, i, n) {
            for(let e = n; e >= 0; e--)s(i[e], t);
        }
        _condense(t) {
            for(let i, n = t.length - 1; n >= 0; n--)0 === t[n].children.length ? n > 0 ? (i = t[n - 1].children, i.splice(i.indexOf(t[n]), 1)) : this.clear() : h(t[n], this.toBBox);
        }
    };
});

});

parcelRegister("8f0Mc", function(module, exports) {

$parcel$export(module.exports, "rulesToStyleFunction", () => $6000539d86fde80c$export$fc6a94152b1b05a8);
$parcel$export(module.exports, "flatStylesToStyleFunction", () => $6000539d86fde80c$export$5a130bc4f0a0420b);
/**
 * @module ol/render/canvas/style
 */ 
var $4iSHH = parcelRequire("4iSHH");

var $ikW69 = parcelRequire("ikW69");

var $aghSp = parcelRequire("aghSp");

var $gn0g3 = parcelRequire("gn0g3");

var $hxhPO = parcelRequire("hxhPO");

var $wnhPR = parcelRequire("wnhPR");

var $inIMS = parcelRequire("inIMS");

var $bmHVE = parcelRequire("bmHVE");

var $5ndKB = parcelRequire("5ndKB");

var $lrKvI = parcelRequire("lrKvI");

var $c3RIb = parcelRequire("c3RIb");

var $cJntk = parcelRequire("cJntk");
/**
 * @fileoverview This module includes functions to build styles for the canvas renderer.  Building
 * is composed of two steps: parsing and compiling.  The parsing step takes an encoded expression
 * and returns an instance of one of the expression classes.  The compiling step takes the
 * expression instance and returns a function that can be evaluated to return a literal value.  The
 * evaluator function should do as little allocation and work as possible.
 */ /**
 * @typedef {import("../../style/flat.js").FlatStyle} FlatStyle
 */ /**
 * @typedef {import("../../expr/expression.js").EncodedExpression} EncodedExpression
 */ /**
 * @typedef {import("../../expr/expression.js").ParsingContext} ParsingContext
 */ /**
 * @typedef {import("../../expr/expression.js").CallExpression} CallExpression
 */ /**
 * @typedef {import("../../expr/cpu.js").EvaluationContext} EvaluationContext
 */ /**
 * @typedef {import("../../expr/cpu.js").ExpressionEvaluator} ExpressionEvaluator
 */ /**
 * @param {EvaluationContext} context The evaluation context.
 * @return {boolean} Always true.
 */ function $6000539d86fde80c$var$always(context) {
    return true;
}
function $6000539d86fde80c$export$fc6a94152b1b05a8(rules) {
    const parsingContext = (0, $aghSp.newParsingContext)();
    const evaluator = $6000539d86fde80c$export$d6ae6a4799989976(rules, parsingContext);
    const evaluationContext = (0, $ikW69.newEvaluationContext)();
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        if (parsingContext.geometryType) evaluationContext.geometryType = (0, $aghSp.computeGeometryType)(feature.getGeometry());
        return evaluator(evaluationContext);
    };
}
function $6000539d86fde80c$export$5a130bc4f0a0420b(flatStyles) {
    const parsingContext = (0, $aghSp.newParsingContext)();
    const length = flatStyles.length;
    /**
   * @type {Array<StyleEvaluator>}
   */ const evaluators = new Array(length);
    for(let i = 0; i < length; ++i)evaluators[i] = $6000539d86fde80c$export$a6e5f510497b7388(flatStyles[i], parsingContext);
    const evaluationContext = (0, $ikW69.newEvaluationContext)();
    /**
   * @type {Array<Style>}
   */ const styles = new Array(length);
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        let nonNullCount = 0;
        for(let i = 0; i < length; ++i){
            const style = evaluators[i](evaluationContext);
            if (style) {
                styles[nonNullCount] = style;
                nonNullCount += 1;
            }
        }
        styles.length = nonNullCount;
        return styles;
    };
}
function $6000539d86fde80c$export$d6ae6a4799989976(rules, context) {
    const length = rules.length;
    /**
   * @type {Array<CompiledRule>}
   */ const compiledRules = new Array(length);
    for(let i = 0; i < length; ++i){
        const rule = rules[i];
        const filter = 'filter' in rule ? (0, $ikW69.buildExpression)(rule.filter, (0, $aghSp.BooleanType), context) : $6000539d86fde80c$var$always;
        /**
     * @type {Array<StyleEvaluator>}
     */ let styles;
        if (Array.isArray(rule.style)) {
            const styleLength = rule.style.length;
            styles = new Array(styleLength);
            for(let j = 0; j < styleLength; ++j)styles[j] = $6000539d86fde80c$export$a6e5f510497b7388(rule.style[j], context);
        } else styles = [
            $6000539d86fde80c$export$a6e5f510497b7388(rule.style, context)
        ];
        compiledRules[i] = {
            filter: filter,
            styles: styles
        };
    }
    return function(context) {
        /**
     * @type {Array<Style>}
     */ const styles = [];
        let someMatched = false;
        for(let i = 0; i < length; ++i){
            const filterEvaluator = compiledRules[i].filter;
            if (!filterEvaluator(context)) continue;
            if (rules[i].else && someMatched) continue;
            someMatched = true;
            for (const styleEvaluator of compiledRules[i].styles){
                const style = styleEvaluator(context);
                if (!style) continue;
                styles.push(style);
            }
        }
        return styles;
    };
}
function $6000539d86fde80c$export$a6e5f510497b7388(flatStyle, context) {
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, '', context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, '', context);
    const evaluateText = $6000539d86fde80c$var$buildText(flatStyle, context);
    const evaluateImage = $6000539d86fde80c$var$buildImage(flatStyle, context);
    const evaluateZIndex = $6000539d86fde80c$var$numberEvaluator(flatStyle, 'z-index', context);
    if (!evaluateFill && !evaluateStroke && !evaluateText && !evaluateImage && !(0, $gn0g3.isEmpty)(flatStyle)) // assume this is a user error
    // would be nice to check the properties and suggest "did you mean..."
    throw new Error('No fill, stroke, point, or text symbolizer properties in style: ' + JSON.stringify(flatStyle));
    const style = new (0, $c3RIb.default)();
    return function(context) {
        let empty = true;
        if (evaluateFill) {
            const fill = evaluateFill(context);
            if (fill) empty = false;
            style.setFill(fill);
        }
        if (evaluateStroke) {
            const stroke = evaluateStroke(context);
            if (stroke) empty = false;
            style.setStroke(stroke);
        }
        if (evaluateText) {
            const text = evaluateText(context);
            if (text) empty = false;
            style.setText(text);
        }
        if (evaluateImage) {
            const image = evaluateImage(context);
            if (image) empty = false;
            style.setImage(image);
        }
        if (evaluateZIndex) style.setZIndex(evaluateZIndex(context));
        if (empty) return null;
        return style;
    };
}
/**
 * @typedef {function(EvaluationContext):Fill|null} FillEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {FillEvaluator?} A function that evaluates to a fill.
 */ function $6000539d86fde80c$var$buildFill(flatStyle, prefix, context) {
    let evaluateColor;
    if (prefix + 'fill-pattern-src' in flatStyle) evaluateColor = $6000539d86fde80c$var$patternEvaluator(flatStyle, prefix + 'fill-', context);
    else {
        if (flatStyle[prefix + 'fill-color'] === 'none') // avoids hit detection
        return (context)=>null;
        evaluateColor = $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, prefix + 'fill-color', context);
    }
    if (!evaluateColor) return null;
    const fill = new (0, $inIMS.default)();
    return function(context) {
        const color = evaluateColor(context);
        if (color === (0, $4iSHH.NO_COLOR)) return null;
        fill.setColor(color);
        return fill;
    };
}
/**
 * @typedef {function(EvaluationContext):Stroke|null} StrokeEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {StrokeEvaluator?} A function the evaluates to a stroke.
 */ function $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context) {
    const evaluateWidth = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'stroke-width', context);
    const evaluateColor = $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, prefix + 'stroke-color', context);
    if (!evaluateWidth && !evaluateColor) return null;
    const evaluateLineCap = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + 'stroke-line-cap', context);
    const evaluateLineJoin = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + 'stroke-line-join', context);
    const evaluateLineDash = $6000539d86fde80c$var$numberArrayEvaluator(flatStyle, prefix + 'stroke-line-dash', context);
    const evaluateLineDashOffset = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'stroke-line-dash-offset', context);
    const evaluateMiterLimit = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'stroke-miter-limit', context);
    const evaluateOffset = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'stroke-offset', context);
    const stroke = new (0, $lrKvI.default)();
    return function(context) {
        if (evaluateColor) {
            const color = evaluateColor(context);
            if (color === (0, $4iSHH.NO_COLOR)) return null;
            stroke.setColor(color);
        }
        if (evaluateWidth) stroke.setWidth(evaluateWidth(context));
        if (evaluateLineCap) {
            const lineCap = evaluateLineCap(context);
            if (lineCap !== 'butt' && lineCap !== 'round' && lineCap !== 'square') throw new Error('Expected butt, round, or square line cap');
            stroke.setLineCap(lineCap);
        }
        if (evaluateLineJoin) {
            const lineJoin = evaluateLineJoin(context);
            if (lineJoin !== 'bevel' && lineJoin !== 'round' && lineJoin !== 'miter') throw new Error('Expected bevel, round, or miter line join');
            stroke.setLineJoin(lineJoin);
        }
        if (evaluateLineDash) stroke.setLineDash(evaluateLineDash(context));
        if (evaluateLineDashOffset) stroke.setLineDashOffset(evaluateLineDashOffset(context));
        if (evaluateMiterLimit) stroke.setMiterLimit(evaluateMiterLimit(context));
        if (evaluateOffset) stroke.setOffset(evaluateOffset(context));
        return stroke;
    };
}
/**
 * @typedef {function(EvaluationContext):Text} TextEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {TextEvaluator?} A function that evaluates to a text symbolizer.
 */ function $6000539d86fde80c$var$buildText(flatStyle, context) {
    const prefix = 'text-';
    // Currently, an Array<string> may be used for rich text support.  This doesn't
    // work with our expression syntax where arrays of strings are interpreted as
    // call expressions.  To support rich text, we could add a 'strings' operator
    // where all the following arguments would be string values.
    const evaluateValue = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + 'value', context);
    if (!evaluateValue) return null;
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix, context);
    const evaluateBackgroundFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix + 'background-', context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context);
    const evaluateBackgroundStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix + 'background-', context);
    const evaluateFont = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + 'font', context);
    const evaluateMaxAngle = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'max-angle', context);
    const evaluateOffsetX = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'offset-x', context);
    const evaluateOffsetY = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'offset-y', context);
    const evaluateOverflow = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + 'overflow', context);
    const evaluatePlacement = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + 'placement', context);
    const evaluateRepeat = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'repeat', context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateAlign = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + 'align', context);
    const evaluateJustify = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + 'justify', context);
    const evaluateBaseline = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + 'baseline', context);
    const evaluateKeepUpright = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + 'keep-upright', context);
    const evaluatePadding = $6000539d86fde80c$var$numberArrayEvaluator(flatStyle, prefix + 'padding', context);
    // The following properties are not currently settable
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const text = new (0, $cJntk.default)({
        declutterMode: declutterMode
    });
    return function(context) {
        text.setText(evaluateValue(context));
        if (evaluateFill) text.setFill(evaluateFill(context));
        if (evaluateBackgroundFill) text.setBackgroundFill(evaluateBackgroundFill(context));
        if (evaluateStroke) text.setStroke(evaluateStroke(context));
        if (evaluateBackgroundStroke) text.setBackgroundStroke(evaluateBackgroundStroke(context));
        if (evaluateFont) text.setFont(evaluateFont(context));
        if (evaluateMaxAngle) text.setMaxAngle(evaluateMaxAngle(context));
        if (evaluateOffsetX) text.setOffsetX(evaluateOffsetX(context));
        if (evaluateOffsetY) text.setOffsetY(evaluateOffsetY(context));
        if (evaluateOverflow) text.setOverflow(evaluateOverflow(context));
        if (evaluatePlacement) {
            const placement = evaluatePlacement(context);
            if (placement !== 'point' && placement !== 'line') throw new Error('Expected point or line for text-placement');
            text.setPlacement(placement);
        }
        if (evaluateRepeat) text.setRepeat(evaluateRepeat(context));
        if (evaluateScale) text.setScale(evaluateScale(context));
        if (evaluateRotateWithView) text.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateRotation) text.setRotation(evaluateRotation(context));
        if (evaluateAlign) {
            const textAlign = evaluateAlign(context);
            if (textAlign !== 'left' && textAlign !== 'center' && textAlign !== 'right' && textAlign !== 'end' && textAlign !== 'start') throw new Error('Expected left, right, center, start, or end for text-align');
            text.setTextAlign(textAlign);
        }
        if (evaluateJustify) {
            const justify = evaluateJustify(context);
            if (justify !== 'left' && justify !== 'right' && justify !== 'center') throw new Error('Expected left, right, or center for text-justify');
            text.setJustify(justify);
        }
        if (evaluateBaseline) {
            const textBaseline = evaluateBaseline(context);
            if (textBaseline !== 'bottom' && textBaseline !== 'top' && textBaseline !== 'middle' && textBaseline !== 'alphabetic' && textBaseline !== 'hanging') throw new Error('Expected bottom, top, middle, alphabetic, or hanging for text-baseline');
            text.setTextBaseline(textBaseline);
        }
        if (evaluatePadding) text.setPadding(evaluatePadding(context));
        if (evaluateKeepUpright) text.setKeepUpright(evaluateKeepUpright(context));
        return text;
    };
}
/**
 * @typedef {function(EvaluationContext):import("../../style/Image.js").default} ImageEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator?} A function that evaluates to an image symbolizer.
 */ function $6000539d86fde80c$var$buildImage(flatStyle, context) {
    if ('icon-src' in flatStyle) return $6000539d86fde80c$var$buildIcon(flatStyle, context);
    if ('shape-points' in flatStyle) return $6000539d86fde80c$var$buildShape(flatStyle, context);
    if ('circle-radius' in flatStyle) return $6000539d86fde80c$var$buildCircle(flatStyle, context);
    return null;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an image symbolizer.
 */ function $6000539d86fde80c$var$buildIcon(flatStyle, context) {
    const prefix = 'icon-';
    // required property
    const srcName = prefix + 'src';
    const src = $6000539d86fde80c$var$requireString(flatStyle[srcName], srcName);
    // settable properties
    const evaluateAnchor = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + 'anchor', context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateOpacity = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'opacity', context);
    const evaluateDisplacement = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining symbolizer properties are not currently settable
    const anchorOrigin = $6000539d86fde80c$var$optionalIconOrigin(flatStyle, prefix + 'anchor-origin');
    const anchorXUnits = $6000539d86fde80c$var$optionalIconAnchorUnits(flatStyle, prefix + 'anchor-x-units');
    const anchorYUnits = $6000539d86fde80c$var$optionalIconAnchorUnits(flatStyle, prefix + 'anchor-y-units');
    const colorValue = $6000539d86fde80c$var$getExpressionValue(flatStyle, prefix + 'color');
    let color;
    let evaluateColor = null;
    if (colorValue !== undefined) {
        const isColorExpression = Array.isArray(colorValue) && colorValue.length > 0 && typeof colorValue[0] === 'string';
        if (isColorExpression) evaluateColor = $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, prefix + 'color', context);
        else color = $6000539d86fde80c$var$requireColorLike(colorValue, prefix + 'color');
    }
    const crossOrigin = $6000539d86fde80c$var$optionalString(flatStyle, prefix + 'cross-origin');
    const offset = $6000539d86fde80c$var$optionalNumberArray(flatStyle, prefix + 'offset');
    const offsetOrigin = $6000539d86fde80c$var$optionalIconOrigin(flatStyle, prefix + 'offset-origin');
    const width = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + 'width');
    const height = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + 'height');
    const size = $6000539d86fde80c$var$optionalSize(flatStyle, prefix + 'size');
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const iconOptions = {
        src: src,
        anchorOrigin: anchorOrigin,
        anchorXUnits: anchorXUnits,
        anchorYUnits: anchorYUnits,
        crossOrigin: crossOrigin,
        offset: offset,
        offsetOrigin: offsetOrigin,
        height: height,
        width: width,
        size: size,
        declutterMode: declutterMode
    };
    let icon = null;
    return function(context) {
        if (!icon) {
            // lazily create the icon to allow for expression evaluation
            const initialColor = evaluateColor ? evaluateColor(context) : color;
            icon = new (0, $bmHVE.default)(initialColor !== undefined ? Object.assign({}, iconOptions, {
                color: initialColor
            }) : Object.assign({}, iconOptions));
        } else if (evaluateColor) icon.setColor(evaluateColor(context));
        if (evaluateOpacity) icon.setOpacity(evaluateOpacity(context));
        if (evaluateDisplacement) icon.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) icon.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) icon.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) icon.setScale(evaluateScale(context));
        if (evaluateAnchor) icon.setAnchor(evaluateAnchor(context));
        return icon;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an icon symbolizer.
 */ function $6000539d86fde80c$var$buildShape(flatStyle, context) {
    const prefix = 'shape-';
    // required property
    const pointsName = prefix + 'points';
    const radiusName = prefix + 'radius';
    const points = $6000539d86fde80c$var$requireNumber(flatStyle[pointsName], pointsName);
    if (!(radiusName in flatStyle)) throw new Error(`Expected a number for ${radiusName}`);
    const evaluateRadius = $6000539d86fde80c$var$numberEvaluator(flatStyle, radiusName, context);
    const initialRadius = typeof flatStyle[radiusName] === 'number' ? flatStyle[radiusName] : 5;
    const radius2Name = prefix + 'radius2';
    const evaluateRadius2 = $6000539d86fde80c$var$numberEvaluator(flatStyle, radius2Name, context);
    const initialRadius2 = typeof flatStyle[radius2Name] === 'number' ? flatStyle[radius2Name] : undefined;
    // settable properties
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix, context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateDisplacement = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining properties are not currently settable
    const angle = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + 'angle');
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const shape = new (0, $5ndKB.default)({
        points: points,
        radius: initialRadius,
        radius2: initialRadius2,
        angle: angle,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateRadius) shape.setRadius(evaluateRadius(context));
        if (evaluateRadius2) shape.setRadius2(evaluateRadius2(context));
        if (evaluateFill) shape.setFill(evaluateFill(context));
        if (evaluateStroke) shape.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) shape.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) shape.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) shape.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) shape.setScale(evaluateScale(context));
        return shape;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to a circle symbolizer.
 */ function $6000539d86fde80c$var$buildCircle(flatStyle, context) {
    const prefix = 'circle-';
    // settable properties
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix, context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context);
    const evaluateRadius = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'radius', context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateDisplacement = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining properties are not currently settable
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const circle = new (0, $wnhPR.default)({
        radius: 5,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateRadius) circle.setRadius(evaluateRadius(context));
        if (evaluateFill) circle.setFill(evaluateFill(context));
        if (evaluateStroke) circle.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) circle.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) circle.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) circle.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) circle.setScale(evaluateScale(context));
        return circle;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @return {any|undefined} The encoded value, or undefined if not provided.
 */ function $6000539d86fde80c$var$getExpressionValue(flatStyle, name) {
    if (!(name in flatStyle)) return undefined;
    const value = flatStyle[name];
    return value === undefined ? undefined : value;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberEvaluator|undefined} The expression evaluator or undefined.
 */ function $6000539d86fde80c$var$numberEvaluator(flatStyle, name, context) {
    const encoded = $6000539d86fde80c$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return undefined;
    const evaluator = (0, $ikW69.buildExpression)(encoded, (0, $aghSp.NumberType), context);
    return function(context) {
        return $6000539d86fde80c$var$requireNumber(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').StringEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$stringEvaluator(flatStyle, name, context) {
    const encoded = $6000539d86fde80c$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, $ikW69.buildExpression)(encoded, (0, $aghSp.StringType), context);
    return function(context) {
        return $6000539d86fde80c$var$requireString(evaluator(context), name);
    };
}
function $6000539d86fde80c$var$patternEvaluator(flatStyle, prefix, context) {
    const srcEvaluator = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + 'pattern-src', context);
    const offsetEvaluator = $6000539d86fde80c$var$sizeEvaluator(flatStyle, prefix + 'pattern-offset', context);
    const patternSizeEvaluator = $6000539d86fde80c$var$sizeEvaluator(flatStyle, prefix + 'pattern-size', context);
    const colorEvaluator = $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, prefix + 'color', context);
    return function(context) {
        return {
            src: srcEvaluator(context),
            offset: offsetEvaluator && offsetEvaluator(context),
            size: patternSizeEvaluator && patternSizeEvaluator(context),
            color: colorEvaluator && colorEvaluator(context)
        };
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').BooleanEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$booleanEvaluator(flatStyle, name, context) {
    const encoded = $6000539d86fde80c$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, $ikW69.buildExpression)(encoded, (0, $aghSp.BooleanType), context);
    return function(context) {
        const value = evaluator(context);
        if (typeof value !== 'boolean') throw new Error(`Expected a boolean for ${name}`);
        return value;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').ColorLikeEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, name, context) {
    const encoded = $6000539d86fde80c$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, $ikW69.buildExpression)(encoded, (0, $aghSp.ColorType), context);
    return function(context) {
        return $6000539d86fde80c$var$requireColorLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberArrayEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$numberArrayEvaluator(flatStyle, name, context) {
    const encoded = $6000539d86fde80c$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    if (Array.isArray(encoded) && (encoded.length === 0 || typeof encoded[0] !== 'string')) {
        /** @type {Array<import('../../expr/cpu.js').NumberEvaluator>} */ const evaluators = encoded.map((value, index)=>{
            if (typeof value === 'number') return ()=>value;
            const evaluator = (0, $ikW69.buildExpression)(value, (0, $aghSp.NumberType), context);
            return function(context) {
                return $6000539d86fde80c$var$requireNumber(evaluator(context), `${name}[${index}]`);
            };
        });
        return function(context) {
            const array = new Array(evaluators.length);
            for(let i = 0; i < evaluators.length; ++i)array[i] = evaluators[i](context);
            return array;
        };
    }
    const evaluator = (0, $ikW69.buildExpression)(encoded, (0, $aghSp.NumberArrayType), context);
    return function(context) {
        return $6000539d86fde80c$var$requireNumberArray(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').CoordinateEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$coordinateEvaluator(flatStyle, name, context) {
    const encoded = $6000539d86fde80c$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, $ikW69.buildExpression)(encoded, (0, $aghSp.NumberArrayType), context);
    return function(context) {
        const array = $6000539d86fde80c$var$requireNumberArray(evaluator(context), name);
        if (array.length !== 2) throw new Error(`Expected two numbers for ${name}`);
        return array;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$sizeEvaluator(flatStyle, name, context) {
    const encoded = $6000539d86fde80c$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, $ikW69.buildExpression)(encoded, (0, $aghSp.NumberArrayType), context);
    return function(context) {
        return $6000539d86fde80c$var$requireSize(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeLikeEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, name, context) {
    const encoded = $6000539d86fde80c$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, $ikW69.buildExpression)(encoded, (0, $aghSp.NumberArrayType) | (0, $aghSp.NumberType), context);
    return function(context) {
        return $6000539d86fde80c$var$requireSizeLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {number|undefined} A number or undefined.
 */ function $6000539d86fde80c$var$optionalNumber(flatStyle, property) {
    const value = flatStyle[property];
    if (value === undefined) return undefined;
    if (typeof value !== 'number') throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../size.js").Size|undefined} A size or undefined.
 */ function $6000539d86fde80c$var$optionalSize(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded === 'number') return (0, $hxhPO.toSize)(encoded);
    if (!Array.isArray(encoded)) throw new Error(`Expected a number or size array for ${property}`);
    if (encoded.length !== 2 || typeof encoded[0] !== 'number' || typeof encoded[1] !== 'number') throw new Error(`Expected a number or size array for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {string|undefined} A string or undefined.
 */ function $6000539d86fde80c$var$optionalString(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== 'string') throw new Error(`Expected a string for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconOrigin|undefined} An icon origin or undefined.
 */ function $6000539d86fde80c$var$optionalIconOrigin(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== 'bottom-left' && encoded !== 'bottom-right' && encoded !== 'top-left' && encoded !== 'top-right') throw new Error(`Expected bottom-left, bottom-right, top-left, or top-right for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconAnchorUnits|undefined} Icon anchor units or undefined.
 */ function $6000539d86fde80c$var$optionalIconAnchorUnits(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== 'pixels' && encoded !== 'fraction') throw new Error(`Expected pixels or fraction for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {Array<number>|undefined} An array of numbers or undefined.
 */ function $6000539d86fde80c$var$optionalNumberArray(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    return $6000539d86fde80c$var$requireNumberArray(encoded, property);
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import('../../style/Style.js').DeclutterMode} Icon declutter mode.
 */ function $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== 'string') throw new Error(`Expected a string for ${property}`);
    if (encoded !== 'declutter' && encoded !== 'obstacle' && encoded !== 'none') throw new Error(`Expected declutter, obstacle, or none for ${property}`);
    return encoded;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} An array of numbers.
 */ function $6000539d86fde80c$var$requireNumberArray(value, property) {
    if (!Array.isArray(value)) throw new Error(`Expected an array for ${property}`);
    const length = value.length;
    for(let i = 0; i < length; ++i){
        if (typeof value[i] !== 'number') throw new Error(`Expected an array of numbers for ${property}`);
    }
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {string} A string.
 */ function $6000539d86fde80c$var$requireString(value, property) {
    if (typeof value !== 'string') throw new Error(`Expected a string for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number} A number.
 */ function $6000539d86fde80c$var$requireNumber(value, property) {
    if (typeof value !== 'number') throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>|string} A color.
 */ function $6000539d86fde80c$var$requireColorLike(value, property) {
    if (typeof value === 'string') return value;
    const array = $6000539d86fde80c$var$requireNumberArray(value, property);
    const length = array.length;
    if (length < 3 || length > 4) throw new Error(`Expected a color with 3 or 4 values for ${property}`);
    return array;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} A number or an array of two numbers.
 */ function $6000539d86fde80c$var$requireSize(value, property) {
    const size = $6000539d86fde80c$var$requireNumberArray(value, property);
    if (size.length !== 2) throw new Error(`Expected an array of two numbers for ${property}`);
    return size;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number|Array<number>} A number or an array of two numbers.
 */ function $6000539d86fde80c$var$requireSizeLike(value, property) {
    if (typeof value === 'number') return value;
    return $6000539d86fde80c$var$requireSize(value, property);
}

});
parcelRegister("ikW69", function(module, exports) {

$parcel$export(module.exports, "newEvaluationContext", () => $d597295b1f166e98$export$c18f39f0e136c26);
$parcel$export(module.exports, "buildExpression", () => $d597295b1f166e98$export$b5f535122a9211f0);
/**
 * @module ol/expr/cpu
 */ 
var $4iSHH = parcelRequire("4iSHH");

var $aghSp = parcelRequire("aghSp");
function $d597295b1f166e98$export$c18f39f0e136c26() {
    return {
        variables: {},
        properties: {},
        resolution: NaN,
        featureId: null,
        geometryType: ''
    };
}
function $d597295b1f166e98$export$b5f535122a9211f0(encoded, type, context) {
    const expression = (0, $aghSp.parse)(encoded, type, context);
    return $d597295b1f166e98$var$compileExpression(expression, context);
}
/**
 * @param {import("./expression.js").Expression} expression The expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileExpression(expression, context) {
    if (expression instanceof (0, $aghSp.LiteralExpression)) {
        // convert colors to array if possible
        if (expression.type === (0, $aghSp.ColorType) && typeof expression.value === 'string') {
            const colorValue = (0, $4iSHH.fromString)(expression.value);
            return function() {
                return colorValue;
            };
        }
        return function() {
            return expression.value;
        };
    }
    const operator = expression.operator;
    switch(operator){
        case (0, $aghSp.Ops).Number:
        case (0, $aghSp.Ops).String:
        case (0, $aghSp.Ops).Coalesce:
            return $d597295b1f166e98$var$compileAssertionExpression(expression, context);
        case (0, $aghSp.Ops).Get:
        case (0, $aghSp.Ops).Var:
        case (0, $aghSp.Ops).Has:
            return $d597295b1f166e98$var$compileAccessorExpression(expression, context);
        case (0, $aghSp.Ops).Id:
            return (context)=>context.featureId;
        case (0, $aghSp.Ops).GeometryType:
            return (context)=>context.geometryType;
        case (0, $aghSp.Ops).Concat:
            {
                const args = expression.args.map((e)=>$d597295b1f166e98$var$compileExpression(e, context));
                return (context)=>''.concat(...args.map((arg)=>arg(context).toString()));
            }
        case (0, $aghSp.Ops).Resolution:
            return (context)=>context.resolution;
        case (0, $aghSp.Ops).Any:
        case (0, $aghSp.Ops).All:
        case (0, $aghSp.Ops).Between:
        case (0, $aghSp.Ops).In:
        case (0, $aghSp.Ops).Not:
            return $d597295b1f166e98$var$compileLogicalExpression(expression, context);
        case (0, $aghSp.Ops).Equal:
        case (0, $aghSp.Ops).NotEqual:
        case (0, $aghSp.Ops).LessThan:
        case (0, $aghSp.Ops).LessThanOrEqualTo:
        case (0, $aghSp.Ops).GreaterThan:
        case (0, $aghSp.Ops).GreaterThanOrEqualTo:
            return $d597295b1f166e98$var$compileComparisonExpression(expression, context);
        case (0, $aghSp.Ops).Multiply:
        case (0, $aghSp.Ops).Divide:
        case (0, $aghSp.Ops).Add:
        case (0, $aghSp.Ops).Subtract:
        case (0, $aghSp.Ops).Clamp:
        case (0, $aghSp.Ops).Mod:
        case (0, $aghSp.Ops).Pow:
        case (0, $aghSp.Ops).Abs:
        case (0, $aghSp.Ops).Floor:
        case (0, $aghSp.Ops).Ceil:
        case (0, $aghSp.Ops).Round:
        case (0, $aghSp.Ops).Sin:
        case (0, $aghSp.Ops).Cos:
        case (0, $aghSp.Ops).Atan:
        case (0, $aghSp.Ops).Sqrt:
            return $d597295b1f166e98$var$compileNumericExpression(expression, context);
        case (0, $aghSp.Ops).Case:
            return $d597295b1f166e98$var$compileCaseExpression(expression, context);
        case (0, $aghSp.Ops).Match:
            return $d597295b1f166e98$var$compileMatchExpression(expression, context);
        case (0, $aghSp.Ops).Interpolate:
            return $d597295b1f166e98$var$compileInterpolateExpression(expression, context);
        case (0, $aghSp.Ops).ToString:
            return $d597295b1f166e98$var$compileConvertExpression(expression, context);
        default:
            throw new Error(`Unsupported operator ${operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileAssertionExpression(expression, context) {
    const type = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(type){
        case (0, $aghSp.Ops).Coalesce:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value !== 'undefined' && value !== null) return value;
                }
                throw new Error('Expected one of the values to be non-null');
            };
        case (0, $aghSp.Ops).Number:
        case (0, $aghSp.Ops).String:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value === type) return value;
                }
                throw new Error(`Expected one of the values to be a ${type}`);
            };
        default:
            throw new Error(`Unsupported assertion operator ${type}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileAccessorExpression(expression, context) {
    const nameExpression = /** @type {LiteralExpression} */ expression.args[0];
    const name = /** @type {string} */ nameExpression.value;
    switch(expression.operator){
        case (0, $aghSp.Ops).Get:
            return (context)=>{
                const args = expression.args;
                let value = context.properties[name];
                for(let i = 1, ii = args.length; i < ii; ++i){
                    const keyExpression = /** @type {LiteralExpression} */ args[i];
                    const key = /** @type {string|number} */ keyExpression.value;
                    value = value[key];
                }
                return value;
            };
        case (0, $aghSp.Ops).Var:
            return (context)=>context.variables[name];
        case (0, $aghSp.Ops).Has:
            return (context)=>{
                const args = expression.args;
                if (!(name in context.properties)) return false;
                let value = context.properties[name];
                for(let i = 1, ii = args.length; i < ii; ++i){
                    const keyExpression = /** @type {LiteralExpression} */ args[i];
                    const key = /** @type {string|number} */ keyExpression.value;
                    if (!value || !Object.hasOwn(value, key)) return false;
                    value = value[key];
                }
                return true;
            };
        default:
            throw new Error(`Unsupported accessor operator ${expression.operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileComparisonExpression(expression, context) {
    const op = expression.operator;
    const left = $d597295b1f166e98$var$compileExpression(expression.args[0], context);
    const right = $d597295b1f166e98$var$compileExpression(expression.args[1], context);
    switch(op){
        case (0, $aghSp.Ops).Equal:
            return (context)=>left(context) === right(context);
        case (0, $aghSp.Ops).NotEqual:
            return (context)=>left(context) !== right(context);
        case (0, $aghSp.Ops).LessThan:
            return (context)=>left(context) < right(context);
        case (0, $aghSp.Ops).LessThanOrEqualTo:
            return (context)=>left(context) <= right(context);
        case (0, $aghSp.Ops).GreaterThan:
            return (context)=>left(context) > right(context);
        case (0, $aghSp.Ops).GreaterThanOrEqualTo:
            return (context)=>left(context) >= right(context);
        default:
            throw new Error(`Unsupported comparison operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileLogicalExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $aghSp.Ops).Any:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (args[i](context)) return true;
                }
                return false;
            };
        case (0, $aghSp.Ops).All:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (!args[i](context)) return false;
                }
                return true;
            };
        case (0, $aghSp.Ops).Between:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                const max = args[2](context);
                return value >= min && value <= max;
            };
        case (0, $aghSp.Ops).In:
            return (context)=>{
                const value = args[0](context);
                for(let i = 1; i < length; ++i){
                    if (value === args[i](context)) return true;
                }
                return false;
            };
        case (0, $aghSp.Ops).Not:
            return (context)=>!args[0](context);
        default:
            throw new Error(`Unsupported logical operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {NumberEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileNumericExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $aghSp.Ops).Multiply:
            return (context)=>{
                let value = 1;
                for(let i = 0; i < length; ++i)value *= args[i](context);
                return value;
            };
        case (0, $aghSp.Ops).Divide:
            return (context)=>args[0](context) / args[1](context);
        case (0, $aghSp.Ops).Add:
            return (context)=>{
                let value = 0;
                for(let i = 0; i < length; ++i)value += args[i](context);
                return value;
            };
        case (0, $aghSp.Ops).Subtract:
            return (context)=>args[0](context) - args[1](context);
        case (0, $aghSp.Ops).Clamp:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                if (value < min) return min;
                const max = args[2](context);
                if (value > max) return max;
                return value;
            };
        case (0, $aghSp.Ops).Mod:
            return (context)=>args[0](context) % args[1](context);
        case (0, $aghSp.Ops).Pow:
            return (context)=>Math.pow(args[0](context), args[1](context));
        case (0, $aghSp.Ops).Abs:
            return (context)=>Math.abs(args[0](context));
        case (0, $aghSp.Ops).Floor:
            return (context)=>Math.floor(args[0](context));
        case (0, $aghSp.Ops).Ceil:
            return (context)=>Math.ceil(args[0](context));
        case (0, $aghSp.Ops).Round:
            return (context)=>Math.round(args[0](context));
        case (0, $aghSp.Ops).Sin:
            return (context)=>Math.sin(args[0](context));
        case (0, $aghSp.Ops).Cos:
            return (context)=>Math.cos(args[0](context));
        case (0, $aghSp.Ops).Atan:
            if (length === 2) return (context)=>Math.atan2(args[0](context), args[1](context));
            return (context)=>Math.atan(args[0](context));
        case (0, $aghSp.Ops).Sqrt:
            return (context)=>Math.sqrt(args[0](context));
        default:
            throw new Error(`Unsupported numeric operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileCaseExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    return (context)=>{
        for(let i = 0; i < length - 1; i += 2){
            const condition = args[i](context);
            if (condition) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileMatchExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    return (context)=>{
        const value = args[0](context);
        for(let i = 1; i < length - 1; i += 2){
            if (value === args[i](context)) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileInterpolateExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    return (context)=>{
        const base = args[0](context);
        const value = args[1](context);
        let previousInput;
        let previousOutput;
        for(let i = 2; i < length; i += 2){
            const input = args[i](context);
            let output = args[i + 1](context);
            const isColor = Array.isArray(output);
            if (isColor) output = (0, $4iSHH.withAlpha)(output);
            if (input >= value) {
                if (i === 2) return output;
                if (isColor) return $d597295b1f166e98$var$interpolateColor(base, value, previousInput, previousOutput, input, output);
                return $d597295b1f166e98$var$interpolateNumber(base, value, previousInput, previousOutput, input, output);
            }
            previousInput = input;
            previousOutput = output;
        }
        return previousOutput;
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileConvertExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $aghSp.Ops).ToString:
            return (context)=>{
                const value = args[0](context);
                if (expression.args[0].type === (0, $aghSp.ColorType)) return (0, $4iSHH.toString)(value);
                return value.toString();
            };
        default:
            throw new Error(`Unsupported convert operator ${op}`);
    }
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {number} output1 The first output value.
 * @param {number} input2 The second input value.
 * @param {number} output2 The second output value.
 * @return {number} The interpolated value.
 */ function $d597295b1f166e98$var$interpolateNumber(base, value, input1, output1, input2, output2) {
    const delta = input2 - input1;
    if (delta === 0) return output1;
    const along = value - input1;
    const factor = base === 1 ? along / delta : (Math.pow(base, along) - 1) / (Math.pow(base, delta) - 1);
    return output1 + factor * (output2 - output1);
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {import('../color.js').Color} rgba1 The first output value.
 * @param {number} input2 The second input value.
 * @param {import('../color.js').Color} rgba2 The second output value.
 * @return {import('../color.js').Color} The interpolated color.
 */ function $d597295b1f166e98$var$interpolateColor(base, value, input1, rgba1, input2, rgba2) {
    const delta = input2 - input1;
    if (delta === 0) return rgba1;
    const lcha1 = (0, $4iSHH.rgbaToLcha)(rgba1);
    const lcha2 = (0, $4iSHH.rgbaToLcha)(rgba2);
    let deltaHue = lcha2[2] - lcha1[2];
    if (deltaHue > 180) deltaHue -= 360;
    else if (deltaHue < -180) deltaHue += 360;
    const lcha = [
        $d597295b1f166e98$var$interpolateNumber(base, value, input1, lcha1[0], input2, lcha2[0]),
        $d597295b1f166e98$var$interpolateNumber(base, value, input1, lcha1[1], input2, lcha2[1]),
        lcha1[2] + $d597295b1f166e98$var$interpolateNumber(base, value, input1, 0, input2, deltaHue),
        $d597295b1f166e98$var$interpolateNumber(base, value, input1, rgba1[3], input2, rgba2[3])
    ];
    return (0, $4iSHH.lchaToRgba)(lcha);
}

});
parcelRegister("aghSp", function(module, exports) {

$parcel$export(module.exports, "BooleanType", () => $778943ec39690f8e$export$240f7fffab1b25a0);
$parcel$export(module.exports, "NumberType", () => $778943ec39690f8e$export$86a7aca748b1e260);
$parcel$export(module.exports, "StringType", () => $778943ec39690f8e$export$2b93044cbf134323);
$parcel$export(module.exports, "ColorType", () => $778943ec39690f8e$export$2cd82751acc0e609);
$parcel$export(module.exports, "NumberArrayType", () => $778943ec39690f8e$export$d701d0e49f4bcb39);
$parcel$export(module.exports, "LiteralExpression", () => $778943ec39690f8e$export$eb63e96e0913dda4);
$parcel$export(module.exports, "newParsingContext", () => $778943ec39690f8e$export$1c8b4c1584800354);
$parcel$export(module.exports, "parse", () => $778943ec39690f8e$export$98e6a39c04603d36);
$parcel$export(module.exports, "Ops", () => $778943ec39690f8e$export$2655e45458bc48f3);
$parcel$export(module.exports, "computeGeometryType", () => $778943ec39690f8e$export$8da88d86d10c1295);
/**
 * @module ol/expr/expression
 */ 
var $fVVyM = parcelRequire("fVVyM");

var $4iSHH = parcelRequire("4iSHH");

var $hxhPO = parcelRequire("hxhPO");
/**
 * @fileoverview This module includes types and functions for parsing array encoded expressions.
 * The result of parsing an encoded expression is one of the specific expression classes.
 * During parsing, information is added to the parsing context about the data accessed by the
 * expression.
 */ /**
 * Base type used for literal style parameters; can be a number literal or the output of an operator,
 * which in turns takes {@link import("./expression.js").ExpressionValue} arguments.
 *
 * See below for details on the available operators (with notes for those that are WebGL or Canvas only).
 *
 * Reading operators:
 *   * `['band', bandIndex, xOffset, yOffset]` For tile layers only. Fetches pixel values from band
 *     `bandIndex` of the source's data. The first `bandIndex` of the source data is `1`. Fetched values
 *     are in the 0..1 range. {@link import("../source/TileImage.js").default} sources have 4 bands: red,
 *     green, blue and alpha. {@link import("../source/DataTile.js").default} sources can have any number
 *     of bands, depending on the underlying data source and
 *     {@link import("../source/GeoTIFF.js").Options configuration}. `xOffset` and `yOffset` are optional
 *     and allow specifying pixel offsets for x and y. This is used for sampling data from neighboring pixels (WebGL only).
 *   * `['get', attributeName]` fetches a feature property value, similar to `feature.get('attributeName')`.
 *   * `['get', attributeName, keyOrArrayIndex, ...]` (Canvas only) Access nested properties and array items of a
 *     feature property. The result is `undefined` when there is nothing at the specified key or index.
 *   * `['geometry-type']` returns a feature's geometry type as string, either: 'LineString', 'Point' or 'Polygon'
 *     `Multi*` values are returned as their singular equivalent
 *     `Circle` geometries are returned as 'Polygon'
 *     `GeometryCollection` geometries are returned as the type of the first geometry found in the collection (WebGL only).
 *   * `['resolution']` returns the current resolution
 *   * `['time']` The time in seconds since the creation of the layer (WebGL only).
 *   * `['var', 'varName']` fetches a value from the style variables; will throw an error if that variable is undefined
 *   * `['zoom']` The current zoom level (WebGL only).
 *   * `['line-metric']` returns the M component of the current point on a line (WebGL only); in case where the geometry layout of the line
 *      does not contain an M component (e.g. XY or XYZ), 0 is returned; 0 is also returned for geometries other than lines.
 *      Please note that the M component will be linearly interpolated between the two points composing a segment.
 *
 * Math operators:
 *   * `['*', value1, value2, ...]` multiplies the values (either numbers or colors)
 *   * `['/', value1, value2]` divides `value1` by `value2`
 *   * `['+', value1, value2, ...]` adds the values
 *   * `['-', value1, value2]` subtracts `value2` from `value1`
 *   * `['clamp', value, low, high]` clamps `value` between `low` and `high`
 *   * `['%', value1, value2]` returns the result of `value1 % value2` (modulo)
 *   * `['^', value1, value2]` returns the value of `value1` raised to the `value2` power
 *   * `['abs', value1]` returns the absolute value of `value1`
 *   * `['floor', value1]` returns the nearest integer less than or equal to `value1`
 *   * `['round', value1]` returns the nearest integer to `value1`
 *   * `['ceil', value1]` returns the nearest integer greater than or equal to `value1`
 *   * `['sin', value1]` returns the sine of `value1`
 *   * `['cos', value1]` returns the cosine of `value1`
 *   * `['atan', value1, value2]` returns `atan2(value1, value2)`. If `value2` is not provided, returns `atan(value1)`
 *   * `['sqrt', value1]` returns the square root of `value1`
 *
 * * Transform operators:
 *   * `['case', condition1, output1, ...conditionN, outputN, fallback]` selects the first output whose corresponding
 *     condition evaluates to `true`. If no match is found, returns the `fallback` value.
 *     All conditions should be `boolean`, output and fallback can be any kind.
 *   * `['match', input, match1, output1, ...matchN, outputN, fallback]` compares the `input` value against all
 *     provided `matchX` values, returning the output associated with the first valid match. If no match is found,
 *     returns the `fallback` value.
 *     `input` and `matchX` values must all be of the same type, and can be `number` or `string`. `outputX` and
 *     `fallback` values must be of the same type, and can be of any kind.
 *   * `['interpolate', interpolation, input, stop1, output1, ...stopN, outputN]` returns a value by interpolating between
 *     pairs of inputs and outputs; `interpolation` can either be `['linear']` or `['exponential', base]` where `base` is
 *     the rate of increase from stop A to stop B (i.e. power to which the interpolation ratio is raised); a value
 *     of 1 is equivalent to `['linear']`.
 *     `input` and `stopX` values must all be of type `number`. `outputX` values can be `number` or `color` values.
 *     Note: `input` will be clamped between `stop1` and `stopN`, meaning that all output values will be comprised
 *     between `output1` and `outputN`.
 *   * `['string', value1, value2, ...]` returns the first value in the list that evaluates to a string.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 'default value']]`
 *     (Canvas only).
 *   * `['number', value1, value2, ...]` returns the first value in the list that evaluates to a number.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 42]]`
 *     (Canvas only).
 *   * `['coalesce', value1, value2, ...]` returns the first value in the list which is not null or undefined.
 *     An example would be to provide a default value for get: `['coalesce', ['get','propertyname'], 'default value']]`
 *     (Canvas only).
 *
 * * Logical operators:
 *   * `['<', value1, value2]` returns `true` if `value1` is strictly lower than `value2`, or `false` otherwise.
 *   * `['<=', value1, value2]` returns `true` if `value1` is lower than or equals `value2`, or `false` otherwise.
 *   * `['>', value1, value2]` returns `true` if `value1` is strictly greater than `value2`, or `false` otherwise.
 *   * `['>=', value1, value2]` returns `true` if `value1` is greater than or equals `value2`, or `false` otherwise.
 *   * `['==', value1, value2]` returns `true` if `value1` equals `value2`, or `false` otherwise.
 *   * `['!=', value1, value2]` returns `true` if `value1` does not equal `value2`, or `false` otherwise.
 *   * `['!', value1]` returns `false` if `value1` is `true` or greater than `0`, or `true` otherwise.
 *   * `['all', value1, value2, ...]` returns `true` if all the inputs are `true`, `false` otherwise.
 *   * `['any', value1, value2, ...]` returns `true` if any of the inputs are `true`, `false` otherwise.
 *   * `['has', attributeName, keyOrArrayIndex, ...]` returns `true` if feature properties include the (nested) key `attributeName`,
 *     `false` otherwise.
 *     Note that for WebGL layers, the hardcoded value `-9999999` is used to distinguish when a property is not defined.
 *   * `['between', value1, value2, value3]` returns `true` if `value1` is contained between `value2` and `value3`
 *     (inclusively), or `false` otherwise.
 *   * `['in', needle, haystack]` returns `true` if `needle` is found in `haystack`, and
 *     `false` otherwise.
 *     This operator has the following limitations:
 *     * `haystack` has to be an array of numbers or strings (searching for a substring in a string is not supported yet)
 *     * Only literal arrays are supported as `haystack` for now; this means that `haystack` cannot be the result of an
 *     expression. If `haystack` is an array of strings, use the `literal` operator to disambiguate from an expression:
 *     `['literal', ['abc', 'def', 'ghi']]`
 *
 * * Conversion operators:
 *   * `['array', value1, ...valueN]` creates a numerical array from `number` values; please note that the amount of
 *     values can currently only be 2, 3 or 4 (WebGL only).
 *   * `['color', red, green, blue, alpha]` or `['color', shade, alpha]` creates a `color` value from `number` values;
 *     the `alpha` parameter is optional; if not specified, it will be set to 1 (WebGL only).
 *     Note: `red`, `green` and `blue` or `shade` components must be values between 0 and 255; `alpha` between 0 and 1.
 *   * `['palette', index, colors]` picks a `color` value from an array of colors using the given index; the `index`
 *     expression must evaluate to a number; the items in the `colors` array must be strings with hex colors
 *     (e.g. `'#86A136'`), colors using the rgba[a] functional notation (e.g. `'rgb(134, 161, 54)'` or `'rgba(134, 161, 54, 1)'`),
 *     named colors (e.g. `'red'`), or array literals with 3 ([r, g, b]) or 4 ([r, g, b, a]) values (with r, g, and b
 *     in the 0-255 range and a in the 0-1 range) (WebGL only).
 *   * `['to-string', value]` converts the input value to a string. If the input is a boolean, the result is "true" or "false".
 *     If the input is a number, it is converted to a string as specified by the "NumberToString" algorithm of the ECMAScript
 *     Language Specification. If the input is a color, it is converted to a string of the form "rgba(r,g,b,a)". (Canvas only)
 *
 * Values can either be literals or another operator, as they will be evaluated recursively.
 * Literal values can be of the following types:
 * * `boolean`
 * * `number`
 * * `number[]` (number arrays can only have a length of 2, 3 or 4)
 * * `string`
 * * {@link module:ol/color~Color}
 *
 * @typedef {Array<*>|import("../color.js").Color|string|number|boolean} ExpressionValue
 * @api
 */ let $778943ec39690f8e$var$numTypes = 0;
const $778943ec39690f8e$export$267d7ad6fa96ffaf = 0;
const $778943ec39690f8e$export$240f7fffab1b25a0 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$86a7aca748b1e260 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$2b93044cbf134323 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$2cd82751acc0e609 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$d701d0e49f4bcb39 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$52725c8a6d4c61d1 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$ec4c9a150bae86cd = Math.pow(2, $778943ec39690f8e$var$numTypes) - 1;
const $778943ec39690f8e$var$typeNames = {
    [$778943ec39690f8e$export$240f7fffab1b25a0]: 'boolean',
    [$778943ec39690f8e$export$86a7aca748b1e260]: 'number',
    [$778943ec39690f8e$export$2b93044cbf134323]: 'string',
    [$778943ec39690f8e$export$2cd82751acc0e609]: 'color',
    [$778943ec39690f8e$export$d701d0e49f4bcb39]: 'number[]',
    [$778943ec39690f8e$export$52725c8a6d4c61d1]: 'size'
};
const $778943ec39690f8e$var$namedTypes = Object.keys($778943ec39690f8e$var$typeNames).map(Number).sort((0, $fVVyM.ascending));
/**
 * @param {number} type The type.
 * @return {boolean} The type is one of the specific types (not any or a union type).
 */ function $778943ec39690f8e$var$isSpecific(type) {
    return type in $778943ec39690f8e$var$typeNames;
}
function $778943ec39690f8e$export$b2afc7c96b2b4a45(type) {
    const names = [];
    for (const namedType of $778943ec39690f8e$var$namedTypes)if ($778943ec39690f8e$export$9fdcb8b441c4f2b4(type, namedType)) names.push($778943ec39690f8e$var$typeNames[namedType]);
    if (names.length === 0) return 'untyped';
    if (names.length < 3) return names.join(' or ');
    return names.slice(0, -1).join(', ') + ', or ' + names[names.length - 1];
}
function $778943ec39690f8e$export$9fdcb8b441c4f2b4(broad, specific) {
    return (broad & specific) === specific;
}
function $778943ec39690f8e$export$3252d368d784c970(oneType, otherType) {
    return !!(oneType & otherType);
}
function $778943ec39690f8e$export$26b9f946b448f23e(type, expected) {
    return type === expected;
}
class $778943ec39690f8e$export$eb63e96e0913dda4 {
    /**
   * @param {number} type The value type.
   * @param {LiteralValue} value The literal value.
   */ constructor(type, value){
        if (!$778943ec39690f8e$var$isSpecific(type)) throw new Error(`literal expressions must have a specific type, got ${$778943ec39690f8e$export$b2afc7c96b2b4a45(type)}`);
        this.type = type;
        this.value = value;
    }
}
class $778943ec39690f8e$export$6f3d80189eb72cd4 {
    /**
   * @param {number} type The return type.
   * @param {string} operator The operator.
   * @param {...Expression} args The arguments.
   */ constructor(type, operator, ...args){
        this.type = type;
        this.operator = operator;
        this.args = args;
    }
}
function $778943ec39690f8e$export$1c8b4c1584800354() {
    return {
        variables: new Set(),
        properties: new Set(),
        featureId: false,
        geometryType: false,
        mapState: false
    };
}
function $778943ec39690f8e$export$98e6a39c04603d36(encoded, expectedType, context) {
    switch(typeof encoded){
        case 'boolean':
            if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$2b93044cbf134323)) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2b93044cbf134323, encoded ? 'true' : 'false');
            if (!$778943ec39690f8e$export$9fdcb8b441c4f2b4(expectedType, $778943ec39690f8e$export$240f7fffab1b25a0)) throw new Error(`got a boolean, but expected ${$778943ec39690f8e$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$240f7fffab1b25a0, encoded);
        case 'number':
            if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$52725c8a6d4c61d1)) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$52725c8a6d4c61d1, (0, $hxhPO.toSize)(encoded));
            if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$240f7fffab1b25a0)) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$240f7fffab1b25a0, !!encoded);
            if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$2b93044cbf134323)) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2b93044cbf134323, encoded.toString());
            if (!$778943ec39690f8e$export$9fdcb8b441c4f2b4(expectedType, $778943ec39690f8e$export$86a7aca748b1e260)) throw new Error(`got a number, but expected ${$778943ec39690f8e$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$86a7aca748b1e260, encoded);
        case 'string':
            if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$2cd82751acc0e609)) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2cd82751acc0e609, (0, $4iSHH.fromString)(encoded));
            if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$240f7fffab1b25a0)) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$240f7fffab1b25a0, !!encoded);
            if (!$778943ec39690f8e$export$9fdcb8b441c4f2b4(expectedType, $778943ec39690f8e$export$2b93044cbf134323)) throw new Error(`got a string, but expected ${$778943ec39690f8e$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2b93044cbf134323, encoded);
        default:
    }
    if (!Array.isArray(encoded)) throw new Error('expression must be an array or a primitive value');
    if (encoded.length === 0) throw new Error('empty expression');
    if (typeof encoded[0] === 'string') return $778943ec39690f8e$var$parseCallExpression(encoded, expectedType, context);
    for (const item of encoded){
        if (typeof item !== 'number') throw new Error('expected an array of numbers');
    }
    if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$52725c8a6d4c61d1)) {
        if (encoded.length !== 2) throw new Error(`expected an array of two values for a size, got ${encoded.length}`);
        return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$52725c8a6d4c61d1, encoded);
    }
    if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$2cd82751acc0e609)) {
        if (encoded.length === 3) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2cd82751acc0e609, [
            ...encoded,
            1
        ]);
        if (encoded.length === 4) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2cd82751acc0e609, encoded);
        throw new Error(`expected an array of 3 or 4 values for a color, got ${encoded.length}`);
    }
    if (!$778943ec39690f8e$export$9fdcb8b441c4f2b4(expectedType, $778943ec39690f8e$export$d701d0e49f4bcb39)) throw new Error(`got an array of numbers, but expected ${$778943ec39690f8e$export$b2afc7c96b2b4a45(expectedType)}`);
    return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$d701d0e49f4bcb39, encoded);
}
const $778943ec39690f8e$export$2655e45458bc48f3 = {
    Get: 'get',
    Var: 'var',
    Concat: 'concat',
    GeometryType: 'geometry-type',
    LineMetric: 'line-metric',
    Any: 'any',
    All: 'all',
    Not: '!',
    Resolution: 'resolution',
    Zoom: 'zoom',
    Time: 'time',
    Equal: '==',
    NotEqual: '!=',
    GreaterThan: '>',
    GreaterThanOrEqualTo: '>=',
    LessThan: '<',
    LessThanOrEqualTo: '<=',
    Multiply: '*',
    Divide: '/',
    Add: '+',
    Subtract: '-',
    Clamp: 'clamp',
    Mod: '%',
    Pow: '^',
    Abs: 'abs',
    Floor: 'floor',
    Ceil: 'ceil',
    Round: 'round',
    Sin: 'sin',
    Cos: 'cos',
    Atan: 'atan',
    Sqrt: 'sqrt',
    Match: 'match',
    Between: 'between',
    Interpolate: 'interpolate',
    Coalesce: 'coalesce',
    Case: 'case',
    In: 'in',
    Number: 'number',
    String: 'string',
    Array: 'array',
    Color: 'color',
    Id: 'id',
    Band: 'band',
    Palette: 'palette',
    ToString: 'to-string',
    Has: 'has'
};
/**
 * @typedef {function(Array, number, ParsingContext):Expression} Parser
 *
 * Second argument is the expected type.
 */ /**
 * @type {Object<string, Parser>}
 */ const $778943ec39690f8e$var$parsers = {
    [$778943ec39690f8e$export$2655e45458bc48f3.Get]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, Infinity), $778943ec39690f8e$var$withGetArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Var]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withVarArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Has]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, Infinity), $778943ec39690f8e$var$withGetArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Id]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$usesFeatureId, $778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Concat]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$2b93044cbf134323)),
    [$778943ec39690f8e$export$2655e45458bc48f3.GeometryType]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$usesGeometryType, $778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.LineMetric]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Resolution]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$usesMapState, $778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Zoom]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$usesMapState, $778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Time]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$usesMapState, $778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Any]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0)),
    [$778943ec39690f8e$export$2655e45458bc48f3.All]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Not]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Equal]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd)),
    [$778943ec39690f8e$export$2655e45458bc48f3.NotEqual]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd)),
    [$778943ec39690f8e$export$2655e45458bc48f3.GreaterThan]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.GreaterThanOrEqualTo]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.LessThan]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.LessThanOrEqualTo]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Multiply]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, Infinity), $778943ec39690f8e$var$withArgsOfReturnType),
    [$778943ec39690f8e$export$2655e45458bc48f3.Coalesce]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, Infinity), $778943ec39690f8e$var$withArgsOfReturnType),
    [$778943ec39690f8e$export$2655e45458bc48f3.Divide]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Add]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Subtract]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Clamp]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(3, 3), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Mod]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Pow]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Abs]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Floor]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Ceil]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Round]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Sin]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Cos]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Atan]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Sqrt]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Match]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(4, Infinity), $778943ec39690f8e$var$hasEvenArgs, $778943ec39690f8e$var$withMatchArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Between]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(3, 3), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Interpolate]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(6, Infinity), $778943ec39690f8e$var$hasEvenArgs, $778943ec39690f8e$var$withInterpolateArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Case]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(3, Infinity), $778943ec39690f8e$var$hasOddArgs, $778943ec39690f8e$var$withCaseArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.In]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withInArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Number]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd)),
    [$778943ec39690f8e$export$2655e45458bc48f3.String]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Array]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Color]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 4), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Band]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 3), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Palette]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withPaletteArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.ToString]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0 | $778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$2b93044cbf134323 | $778943ec39690f8e$export$2cd82751acc0e609))
};
/**
 * @typedef {function(Array<EncodedExpression>, number, ParsingContext):Array<Expression>|void} ArgValidator
 *
 * An argument validator applies various checks to an encoded expression arguments and
 * returns the parsed arguments if any.  The second argument is the return type of the call expression.
 */ /**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withGetArgs(encoded, returnType, context) {
    const argsCount = encoded.length - 1;
    const args = new Array(argsCount);
    for(let i = 0; i < argsCount; ++i){
        const key = encoded[i + 1];
        switch(typeof key){
            case 'number':
                args[i] = new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$86a7aca748b1e260, key);
                break;
            case 'string':
                args[i] = new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2b93044cbf134323, key);
                break;
            default:
                throw new Error(`expected a string key or numeric array index for a get operation, got ${key}`);
        }
        if (i === 0) context.properties.add(String(key));
    }
    return args;
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withVarArgs(encoded, returnType, context) {
    const name = encoded[1];
    if (typeof name !== 'string') throw new Error('expected a string argument for var operation');
    context.variables.add(name);
    return [
        new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2b93044cbf134323, name)
    ];
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$usesFeatureId(encoded, returnType, context) {
    context.featureId = true;
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$usesGeometryType(encoded, returnType, context) {
    context.geometryType = true;
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$usesMapState(encoded, returnType, context) {
    context.mapState = true;
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withNoArgs(encoded, returnType, context) {
    const operation = encoded[0];
    if (encoded.length !== 1) throw new Error(`expected no arguments for ${operation} operation`);
    return [];
}
/**
 * @param {number} minArgs The minimum number of arguments.
 * @param {number} maxArgs The maximum number of arguments.
 * @return {ArgValidator} The argument validator
 */ function $778943ec39690f8e$var$hasArgsCount(minArgs, maxArgs) {
    return function(encoded, returnType, context) {
        const operation = encoded[0];
        const argCount = encoded.length - 1;
        if (minArgs === maxArgs) {
            if (argCount !== minArgs) {
                const plural = minArgs === 1 ? '' : 's';
                throw new Error(`expected ${minArgs} argument${plural} for ${operation}, got ${argCount}`);
            }
        } else if (argCount < minArgs || argCount > maxArgs) {
            const range = maxArgs === Infinity ? `${minArgs} or more` : `${minArgs} to ${maxArgs}`;
            throw new Error(`expected ${range} arguments for ${operation}, got ${argCount}`);
        }
    };
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withArgsOfReturnType(encoded, returnType, context) {
    const argCount = encoded.length - 1;
    /**
   * @type {Array<Expression>}
   */ const args = new Array(argCount);
    for(let i = 0; i < argCount; ++i){
        const expression = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 1], returnType, context);
        args[i] = expression;
    }
    return args;
}
/**
 * @param {number} argType The argument type.
 * @return {ArgValidator} The argument validator
 */ function $778943ec39690f8e$var$withArgsOfType(argType) {
    return function(encoded, returnType, context) {
        const argCount = encoded.length - 1;
        /**
     * @type {Array<Expression>}
     */ const args = new Array(argCount);
        for(let i = 0; i < argCount; ++i){
            const expression = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 1], argType, context);
            args[i] = expression;
        }
        return args;
    };
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$hasOddArgs(encoded, returnType, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 0) throw new Error(`expected an odd number of arguments for ${operation}, got ${argCount} instead`);
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$hasEvenArgs(encoded, returnType, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 1) throw new Error(`expected an even number of arguments for operation ${operation}, got ${argCount} instead`);
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withMatchArgs(encoded, returnType, context) {
    const argsCount = encoded.length - 1;
    const inputType = $778943ec39690f8e$export$2b93044cbf134323 | $778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$240f7fffab1b25a0;
    const input = $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], inputType, context);
    const fallback = $778943ec39690f8e$export$98e6a39c04603d36(encoded[encoded.length - 1], returnType, context);
    const args = new Array(argsCount - 2);
    for(let i = 0; i < argsCount - 2; i += 2){
        try {
            const match = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 2], input.type, context);
            args[i] = match;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 1} of match expression: ${err.message}`);
        }
        try {
            const output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 3], fallback.type, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 2} of match expression: ${err.message}`);
        }
    }
    return [
        input,
        ...args,
        fallback
    ];
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withInterpolateArgs(encoded, returnType, context) {
    const interpolationType = encoded[1];
    /**
   * @type {number}
   */ let base;
    switch(interpolationType[0]){
        case 'linear':
            base = 1;
            break;
        case 'exponential':
            const b = interpolationType[1];
            if (typeof b !== 'number' || b <= 0) throw new Error(`expected a number base for exponential interpolation` + `, got ${JSON.stringify(b)} instead`);
            base = b;
            break;
        default:
            throw new Error(`invalid interpolation type: ${JSON.stringify(interpolationType)}`);
    }
    const interpolation = new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$86a7aca748b1e260, base);
    let input;
    try {
        input = $778943ec39690f8e$export$98e6a39c04603d36(encoded[2], $778943ec39690f8e$export$86a7aca748b1e260, context);
    } catch (err) {
        throw new Error(`failed to parse argument 1 in interpolate expression: ${err.message}`);
    }
    const args = new Array(encoded.length - 3);
    for(let i = 0; i < args.length; i += 2){
        try {
            const stop = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 3], $778943ec39690f8e$export$86a7aca748b1e260, context);
            args[i] = stop;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 2} for interpolate expression: ${err.message}`);
        }
        try {
            const output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 4], returnType, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 3} for interpolate expression: ${err.message}`);
        }
    }
    return [
        interpolation,
        input,
        ...args
    ];
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withCaseArgs(encoded, returnType, context) {
    const fallback = $778943ec39690f8e$export$98e6a39c04603d36(encoded[encoded.length - 1], returnType, context);
    const args = new Array(encoded.length - 1);
    for(let i = 0; i < args.length - 1; i += 2){
        try {
            const condition = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 1], $778943ec39690f8e$export$240f7fffab1b25a0, context);
            args[i] = condition;
        } catch (err) {
            throw new Error(`failed to parse argument ${i} of case expression: ${err.message}`);
        }
        try {
            const output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 2], fallback.type, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 1} of case expression: ${err.message}`);
        }
    }
    args[args.length - 1] = fallback;
    return args;
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withInArgs(encoded, returnType, context) {
    let haystack = encoded[2];
    if (!Array.isArray(haystack)) throw new Error(`the second argument for the "in" operator must be an array`);
    /**
   * @type {number}
   */ let needleType;
    if (typeof haystack[0] === 'string') {
        if (haystack[0] !== 'literal') throw new Error(`for the "in" operator, a string array should be wrapped in a "literal" operator to disambiguate from expressions`);
        if (!Array.isArray(haystack[1])) throw new Error(`failed to parse "in" expression: the literal operator must be followed by an array`);
        haystack = haystack[1];
        needleType = $778943ec39690f8e$export$2b93044cbf134323;
    } else needleType = $778943ec39690f8e$export$86a7aca748b1e260;
    const args = new Array(haystack.length);
    for(let i = 0; i < args.length; i++)try {
        const arg = $778943ec39690f8e$export$98e6a39c04603d36(haystack[i], needleType, context);
        args[i] = arg;
    } catch (err) {
        throw new Error(`failed to parse haystack item ${i} for "in" expression: ${err.message}`);
    }
    const needle = $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], needleType, context);
    return [
        needle,
        ...args
    ];
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withPaletteArgs(encoded, returnType, context) {
    let index;
    try {
        index = $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], $778943ec39690f8e$export$86a7aca748b1e260, context);
    } catch (err) {
        throw new Error(`failed to parse first argument in palette expression: ${err.message}`);
    }
    const colors = encoded[2];
    if (!Array.isArray(colors)) throw new Error('the second argument of palette must be an array');
    const parsedColors = new Array(colors.length);
    for(let i = 0; i < parsedColors.length; i++){
        let color;
        try {
            color = $778943ec39690f8e$export$98e6a39c04603d36(colors[i], $778943ec39690f8e$export$2cd82751acc0e609, context);
        } catch (err) {
            throw new Error(`failed to parse color at index ${i} in palette expression: ${err.message}`);
        }
        if (!(color instanceof $778943ec39690f8e$export$eb63e96e0913dda4)) throw new Error(`the palette color at index ${i} must be a literal value`);
        parsedColors[i] = color;
    }
    return [
        index,
        ...parsedColors
    ];
}
/**
 * @param {Array<ArgValidator>} validators A chain of argument validators.  The last validator is expected
 * to return the parsed arguments.
 * @return {Parser} The parser.
 */ function $778943ec39690f8e$var$createCallExpressionParser(...validators) {
    return function(encoded, returnType, context) {
        const operator = encoded[0];
        /**
     * @type {Array<Expression>}
     */ let args;
        for(let i = 0; i < validators.length; i++){
            const parsed = validators[i](encoded, returnType, context);
            if (i == validators.length - 1) {
                if (!parsed) throw new Error('expected last argument validator to return the parsed args');
                args = parsed;
            }
        }
        return new $778943ec39690f8e$export$6f3d80189eb72cd4(returnType, operator, ...args);
    };
}
/**
 * @param {Array} encoded The encoded expression.
 * @param {number} returnType The expected return type of the call expression.
 * @param {ParsingContext} context The parsing context.
 * @return {Expression} The parsed expression.
 */ function $778943ec39690f8e$var$parseCallExpression(encoded, returnType, context) {
    const operator = encoded[0];
    const parser = $778943ec39690f8e$var$parsers[operator];
    if (!parser) throw new Error(`unknown operator: ${operator}`);
    return parser(encoded, returnType, context);
}
function $778943ec39690f8e$export$8da88d86d10c1295(geometry) {
    if (!geometry) return '';
    const type = geometry.getType();
    switch(type){
        case 'Point':
        case 'LineString':
        case 'Polygon':
            return type;
        case 'MultiPoint':
        case 'MultiLineString':
        case 'MultiPolygon':
            return /** @type {'Point'|'LineString'|'Polygon'} */ type.substring(5);
        case 'Circle':
            return 'Polygon';
        case 'GeometryCollection':
            return $778943ec39690f8e$export$8da88d86d10c1295(/** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries()[0]);
        default:
            return '';
    }
}

});
parcelRegister("hxhPO", function(module, exports) {

$parcel$export(module.exports, "hasArea", () => $cc435a5409103773$export$622c471beb1693c7);
$parcel$export(module.exports, "scale", () => $cc435a5409103773$export$dcdf75081b88279d);
$parcel$export(module.exports, "toSize", () => $cc435a5409103773$export$a71a825ff42fb8e1);
/**
 * @module ol/size
 */ /**
 * An array of numbers representing a size: `[width, height]`.
 * @typedef {Array<number>} Size
 * @api
 */ /**
 * Returns a buffered size.
 * @param {Size} size Size.
 * @param {number} num The amount by which to buffer.
 * @param {Size} [dest] Optional reusable size array.
 * @return {Size} The buffered size.
 */ function $cc435a5409103773$export$ab1029bcae9ddb4a(size, num, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] + 2 * num;
    dest[1] = size[1] + 2 * num;
    return dest;
}
function $cc435a5409103773$export$622c471beb1693c7(size) {
    return size[0] > 0 && size[1] > 0;
}
function $cc435a5409103773$export$dcdf75081b88279d(size, ratio, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] * ratio + 0.5 | 0;
    dest[1] = size[1] * ratio + 0.5 | 0;
    return dest;
}
function $cc435a5409103773$export$a71a825ff42fb8e1(size, dest) {
    if (Array.isArray(size)) return size;
    if (dest === undefined) dest = [
        size,
        size
    ];
    else {
        dest[0] = size;
        dest[1] = size;
    }
    return dest;
}

});



parcelRegister("wnhPR", function(module, exports) {

$parcel$export(module.exports, "default", () => $06150d8570b7481b$export$2e2bcd8739ae039);
/**
 * @module ol/style/Circle
 */ 
var $5ndKB = parcelRequire("5ndKB");
/**
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} radius Circle radius.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {Array<number>} [displacement=[0,0]] displacement
 * @property {number|import("../size.js").Size} [scale=1] Scale. A two dimensional scale will produce an ellipse.
 * Unless two dimensional scaling is required a better result may be obtained with an appropriate setting for `radius`.
 * @property {number} [rotation=0] Rotation in radians
 * (positive rotation clockwise, meaningful only when used in conjunction with a two dimensional scale).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view
 * (meaningful only when used in conjunction with a two dimensional scale).
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode
 */ /**
 * @classdesc
 * Set circle style for vector features.
 * @api
 */ class $06150d8570b7481b$var$CircleStyle extends (0, $5ndKB.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {
            radius: 5
        };
        super({
            points: Infinity,
            fill: options.fill,
            radius: options.radius,
            stroke: options.stroke,
            scale: options.scale !== undefined ? options.scale : 1,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
    }
    /**
   * Clones the style.
   * @return {CircleStyle} The cloned style.
   * @api
   * @override
   */ clone() {
        const scale = this.getScale();
        const style = new $06150d8570b7481b$var$CircleStyle({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            radius: this.getRadius(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
}
var $06150d8570b7481b$export$2e2bcd8739ae039 = $06150d8570b7481b$var$CircleStyle;

});
parcelRegister("5ndKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e99c452138b2224$export$2e2bcd8739ae039);
/**
 * @module ol/style/RegularShape
 */ 
var $aSvtr = parcelRequire("aSvtr");

var $4iSHH = parcelRequire("4iSHH");

var $jh19n = parcelRequire("jh19n");

var $DfnQm = parcelRequire("DfnQm");

var $ig1j9 = parcelRequire("ig1j9");

var $1epqj = parcelRequire("1epqj");

var $kTbud = parcelRequire("kTbud");

var $jKhJx = parcelRequire("jKhJx");
/**
 * Specify radius for regular polygons, or both radius and radius2 for stars.
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} points Number of points for stars and regular polygons. In case of a polygon, the number of points
 * is the number of sides.
 * @property {number} radius Radius of a regular polygon.
 * @property {number} [radius2] Second radius to make a star instead of a regular polygon.
 * @property {number} [angle=0] Shape's angle in radians. A value of 0 will have one of the shape's points facing up.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the shape in pixels.
 * Positive values will shift the shape right and up.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view.
 * @property {number|import("../size.js").Size} [scale=1] Scale. Unless two dimensional scaling is required a better
 * result may be obtained with appropriate settings for `radius` and `radius2`.
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @typedef {Object} RenderOptions
 * @property {import("../colorlike.js").ColorLike|undefined} strokeStyle StrokeStyle.
 * @property {number} strokeWidth StrokeWidth.
 * @property {number} size Size.
 * @property {CanvasLineCap} lineCap LineCap.
 * @property {Array<number>|null} lineDash LineDash.
 * @property {number} lineDashOffset LineDashOffset.
 * @property {CanvasLineJoin} lineJoin LineJoin.
 * @property {number} miterLimit MiterLimit.
 */ /**
 * @classdesc
 * Set regular shape style for vector features. The resulting shape will be
 * a regular polygon when `radius` is provided, or a star when both `radius` and
 * `radius2` are provided.
 * @api
 */ class $3e99c452138b2224$var$RegularShape extends (0, $jKhJx.default) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        super({
            opacity: 1,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            scale: options.scale !== undefined ? options.scale : 1,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {HTMLCanvasElement|OffscreenCanvas|null}
     */ this.hitDetectionCanvas_ = null;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.points_ = options.points;
        /**
     * @protected
     * @type {number}
     */ this.radius = options.radius;
        /**
     * @private
     * @type {number|undefined}
     */ this.radius2_ = options.radius2;
        /**
     * @private
     * @type {number}
     */ this.angle_ = options.angle !== undefined ? options.angle : 0;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_;
        /**
     * @private
     * @type {RenderOptions}
     */ this.renderOptions_;
        /**
     * @private
     */ this.imageState_ = this.fill_ && this.fill_.loading() ? (0, $aSvtr.default).LOADING : (0, $aSvtr.default).LOADED;
        if (this.imageState_ === (0, $aSvtr.default).LOADING) this.ready().then(()=>this.imageState_ = (0, $aSvtr.default).LOADED);
        this.render();
    }
    /**
   * Clones the style.
   * @return {RegularShape} The cloned style.
   * @api
   * @override
   */ clone() {
        const scale = this.getScale();
        const style = new $3e99c452138b2224$var$RegularShape({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            points: this.getPoints(),
            radius: this.getRadius(),
            radius2: this.getRadius2(),
            angle: this.getAngle(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   * @override
   */ getAnchor() {
        const size = this.size_;
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            size[0] / 2 - displacement[0] / scale[0],
            size[1] / 2 + displacement[1] / scale[1]
        ];
    }
    /**
   * Get the angle used in generating the shape.
   * @return {number} Shape's rotation in radians.
   * @api
   */ getAngle() {
        return this.angle_;
    }
    /**
   * Get the fill style for the shape.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
        this.render();
    }
    /**
   * @return {HTMLCanvasElement|OffscreenCanvas} Image element.
   * @override
   */ getHitDetectionImage() {
        if (!this.hitDetectionCanvas_) this.hitDetectionCanvas_ = this.createHitDetectionCanvas_(this.renderOptions_);
        return this.hitDetectionCanvas_;
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLCanvasElement|OffscreenCanvas} Image or Canvas element.
   * @api
   * @override
   */ getImage(pixelRatio) {
        const fillKey = this.fill_?.getKey();
        const cacheKey = `${pixelRatio},${this.angle_},${this.radius},${this.radius2_},${this.points_},${fillKey}` + Object.values(this.renderOptions_).join(',');
        let image = /** @type {HTMLCanvasElement|OffscreenCanvas} */ (0, $kTbud.shared).get(cacheKey, null)?.getImage(1);
        if (!image) {
            const renderOptions = this.renderOptions_;
            const size = Math.ceil(renderOptions.size * pixelRatio);
            const context = (0, $DfnQm.createCanvasContext2D)(size, size);
            this.draw_(renderOptions, context, pixelRatio);
            image = context.canvas;
            const iconImage = new (0, $1epqj.default)(image, undefined, null, (0, $aSvtr.default).LOADED, null);
            (0, $kTbud.shared).set(cacheKey, null, iconImage);
            // Update the image in place to an ImageBitmap for better performance and lower memory usage
            createImageBitmap(image).then((imageBitmap)=>{
                iconImage.setImage(imageBitmap);
            });
        }
        return image;
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   * @override
   */ getPixelRatio(pixelRatio) {
        return pixelRatio;
    }
    /**
   * @return {import("../size.js").Size} Image size.
   * @override
   */ getImageSize() {
        return this.size_;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   * @override
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   * @override
   */ getOrigin() {
        return this.origin_;
    }
    /**
   * Get the number of points for generating the shape.
   * @return {number} Number of points for stars and regular polygons.
   * @api
   */ getPoints() {
        return this.points_;
    }
    /**
   * Get the (primary) radius for the shape.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return this.radius;
    }
    /**
   * Set the (primary) radius for the shape.
   * @param {number} radius Radius.
   * @api
   */ setRadius(radius) {
        if (this.radius === radius) return;
        this.radius = radius;
        this.render();
    }
    /**
   * Get the secondary radius for the shape.
   * @return {number|undefined} Radius2.
   * @api
   */ getRadius2() {
        return this.radius2_;
    }
    /**
   * Set the secondary radius for the shape.
   * @param {number|undefined} radius2 Radius2.
   * @api
   */ setRadius2(radius2) {
        if (this.radius2_ === radius2) return;
        this.radius2_ = radius2;
        this.render();
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @return {import("../size.js").Size} Size.
   * @api
   * @override
   */ getSize() {
        return this.size_;
    }
    /**
   * Get the stroke style for the shape.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
        this.render();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ listenImageChange(listener) {}
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {}
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ unlistenImageChange(listener) {}
    /**
   * Calculate additional canvas size needed for the miter.
   * @param {string} lineJoin Line join
   * @param {number} strokeWidth Stroke width
   * @param {number} miterLimit Miter limit
   * @return {number} Additional canvas size needed
   * @private
   */ calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit) {
        if (strokeWidth === 0 || this.points_ === Infinity || lineJoin !== 'bevel' && lineJoin !== 'miter') return strokeWidth;
        // m  | ^
        // i  | |\                  .
        // t >|  #\
        // e  | |\ \              .
        // r      \s\
        //      |  \t\          .                 .
        //          \r\                      .   .
        //      |    \o\      .          .  . . .
        //          e \k\            .  .    . .
        //      |      \e\  .    .  .       . .
        //       d      \ \  .  .          . .
        //      | _ _a_ _\#  .            . .
        //   r1          / `             . .
        //      |                       . .
        //       b     /               . .
        //      |                     . .
        //           / r2            . .
        //      |                        .   .
        //         /                           .   .
        //      |α                                   .   .
        //       /                                         .   .
        //      ° center
        let r1 = this.radius;
        let r2 = this.radius2_ === undefined ? r1 : this.radius2_;
        if (r1 < r2) {
            const tmp = r1;
            r1 = r2;
            r2 = tmp;
        }
        const points = this.radius2_ === undefined ? this.points_ : this.points_ * 2;
        const alpha = 2 * Math.PI / points;
        const a = r2 * Math.sin(alpha);
        const b = Math.sqrt(r2 * r2 - a * a);
        const d = r1 - b;
        const e = Math.sqrt(a * a + d * d);
        const miterRatio = e / a;
        if (lineJoin === 'miter' && miterRatio <= miterLimit) return miterRatio * strokeWidth;
        // Calculate the distance from center to the stroke corner where
        // it was cut short because of the miter limit.
        //              l
        //        ----+---- <= distance from center to here is maxr
        //       /####|k ##\
        //      /#####^#####\
        //     /#### /+\# s #\
        //    /### h/+++\# t #\
        //   /### t/+++++\# r #\
        //  /### a/+++++++\# o #\
        // /### p/++ fill +\# k #\
        ///#### /+++++^+++++\# e #\
        //#####/+++++/+\+++++\#####\
        const k = strokeWidth / 2 / miterRatio;
        const l = strokeWidth / 2 * (d / e);
        const maxr = Math.sqrt((r1 + k) * (r1 + k) + l * l);
        const bevelAdd = maxr - r1;
        if (this.radius2_ === undefined || lineJoin === 'bevel') return bevelAdd * 2;
        // If outer miter is over the miter limit the inner miter may reach through the
        // center and be longer than the bevel, same calculation as above but swap r1 / r2.
        const aa = r1 * Math.sin(alpha);
        const bb = Math.sqrt(r1 * r1 - aa * aa);
        const dd = r2 - bb;
        const ee = Math.sqrt(aa * aa + dd * dd);
        const innerMiterRatio = ee / aa;
        if (innerMiterRatio <= miterLimit) {
            const innerLength = innerMiterRatio * strokeWidth / 2 - r2 - r1;
            return 2 * Math.max(bevelAdd, innerLength);
        }
        return bevelAdd * 2;
    }
    /**
   * @return {RenderOptions}  The render options
   * @protected
   */ createRenderOptions() {
        let lineCap = (0, $ig1j9.defaultLineCap);
        let lineJoin = (0, $ig1j9.defaultLineJoin);
        let miterLimit = 0;
        let lineDash = null;
        let lineDashOffset = 0;
        let strokeStyle;
        let strokeWidth = 0;
        if (this.stroke_) {
            strokeStyle = (0, $jh19n.asColorLike)(this.stroke_.getColor() ?? (0, $ig1j9.defaultStrokeStyle));
            strokeWidth = this.stroke_.getWidth() ?? (0, $ig1j9.defaultLineWidth);
            lineDash = this.stroke_.getLineDash();
            lineDashOffset = this.stroke_.getLineDashOffset() ?? 0;
            lineJoin = this.stroke_.getLineJoin() ?? (0, $ig1j9.defaultLineJoin);
            lineCap = this.stroke_.getLineCap() ?? (0, $ig1j9.defaultLineCap);
            miterLimit = this.stroke_.getMiterLimit() ?? (0, $ig1j9.defaultMiterLimit);
        }
        const add = this.calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit);
        const maxRadius = Math.max(this.radius, this.radius2_ || 0);
        const size = Math.ceil(2 * maxRadius + add);
        return {
            strokeStyle: strokeStyle,
            strokeWidth: strokeWidth,
            size: size,
            lineCap: lineCap,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            lineJoin: lineJoin,
            miterLimit: miterLimit
        };
    }
    /**
   * @protected
   */ render() {
        this.renderOptions_ = this.createRenderOptions();
        const size = this.renderOptions_.size;
        this.hitDetectionCanvas_ = null;
        this.size_ = [
            size,
            size
        ];
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context The rendering context.
   * @param {number} pixelRatio The pixel ratio.
   */ draw_(renderOptions, context, pixelRatio) {
        context.scale(pixelRatio, pixelRatio);
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        if (this.fill_) {
            let color = this.fill_.getColor();
            if (color === null) color = (0, $ig1j9.defaultFillStyle);
            context.fillStyle = (0, $jh19n.asColorLike)(color);
            context.fill();
        }
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineCap = renderOptions.lineCap;
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @return {HTMLCanvasElement|OffscreenCanvas} Canvas containing the icon
   */ createHitDetectionCanvas_(renderOptions) {
        let context;
        if (this.fill_) {
            let color = this.fill_.getColor();
            // determine if fill is transparent (or pattern or gradient)
            let opacity = 0;
            if (typeof color === 'string') color = (0, $4iSHH.asArray)(color);
            if (color === null) opacity = 1;
            else if (Array.isArray(color)) opacity = color.length === 4 ? color[3] : 1;
            if (opacity === 0) {
                // if a transparent fill style is set, create an extra hit-detection image
                // with a default fill style
                context = (0, $DfnQm.createCanvasContext2D)(renderOptions.size, renderOptions.size);
                this.drawHitDetectionCanvas_(renderOptions, context);
            }
        }
        return context ? context.canvas : this.getImage(1);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context The context to draw in.
   */ createPath_(context) {
        let points = this.points_;
        const radius = this.radius;
        if (points === Infinity) context.arc(0, 0, radius, 0, 2 * Math.PI);
        else {
            const radius2 = this.radius2_ === undefined ? radius : this.radius2_;
            if (this.radius2_ !== undefined) points *= 2;
            const startAngle = this.angle_ - Math.PI / 2;
            const step = 2 * Math.PI / points;
            for(let i = 0; i < points; i++){
                const angle0 = startAngle + i * step;
                const radiusC = i % 2 === 0 ? radius : radius2;
                context.lineTo(radiusC * Math.cos(angle0), radiusC * Math.sin(angle0));
            }
            context.closePath();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context The context.
   */ drawHitDetectionCanvas_(renderOptions, context) {
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        context.fillStyle = (0, $ig1j9.defaultFillStyle);
        context.fill();
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    /**
   * @override
   */ ready() {
        return this.fill_ ? this.fill_.ready() : Promise.resolve();
    }
}
var $3e99c452138b2224$export$2e2bcd8739ae039 = $3e99c452138b2224$var$RegularShape;

});
parcelRegister("jh19n", function(module, exports) {

$parcel$export(module.exports, "asColorLike", () => $e0807f400ec9a0a9$export$dc5b1400ac3a10a8);
/**
 * @module ol/colorlike
 */ 
var $aSvtr = parcelRequire("aSvtr");

var $4iSHH = parcelRequire("4iSHH");

var $DfnQm = parcelRequire("DfnQm");

var $1epqj = parcelRequire("1epqj");

var $kTbud = parcelRequire("kTbud");
function $e0807f400ec9a0a9$export$dc5b1400ac3a10a8(color) {
    if (!color) return null;
    if (Array.isArray(color)) return (0, $4iSHH.toString)(color);
    if (typeof color === 'object' && 'src' in color) return $e0807f400ec9a0a9$var$asCanvasPattern(color);
    return color;
}
/**
 * @param {PatternDescriptor} pattern Pattern descriptor.
 * @return {CanvasPattern|null} Canvas pattern or null if the pattern referenced in the
 * PatternDescriptor was not found in the icon image cache.
 */ function $e0807f400ec9a0a9$var$asCanvasPattern(pattern) {
    if (!pattern.offset || !pattern.size) return (0, $kTbud.shared).getPattern(pattern.src, pattern.color);
    const cacheKey = pattern.src + ':' + pattern.offset;
    const canvasPattern = (0, $kTbud.shared).getPattern(cacheKey, pattern.color);
    if (canvasPattern) return canvasPattern;
    const iconImage = (0, $kTbud.shared).get(pattern.src, null);
    if (iconImage.getImageState() !== (0, $aSvtr.default).LOADED) return null;
    const patternCanvasContext = (0, $DfnQm.createCanvasContext2D)(pattern.size[0], pattern.size[1]);
    patternCanvasContext.drawImage(iconImage.getImage(1), pattern.offset[0], pattern.offset[1], pattern.size[0], pattern.size[1], 0, 0, pattern.size[0], pattern.size[1]);
    (0, $1epqj.get)(patternCanvasContext.canvas, cacheKey, undefined, (0, $aSvtr.default).LOADED, pattern.color, true);
    return (0, $kTbud.shared).getPattern(cacheKey, pattern.color);
}

});
parcelRegister("1epqj", function(module, exports) {

$parcel$export(module.exports, "get", () => $0e5ad1d3b638689e$export$3988ae62b71be9a3);
$parcel$export(module.exports, "default", () => $0e5ad1d3b638689e$export$2e2bcd8739ae039);
/**
 * @module ol/style/IconImage
 */ 
var $fySoz = parcelRequire("fySoz");

var $aSvtr = parcelRequire("aSvtr");

var $4iSHH = parcelRequire("4iSHH");

var $DfnQm = parcelRequire("DfnQm");

var $3xzSb = parcelRequire("3xzSb");

var $KD0eF = parcelRequire("KD0eF");

var $kTbud = parcelRequire("kTbud");
/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
 */ let $0e5ad1d3b638689e$var$taintedTestContext = null;
class $0e5ad1d3b638689e$var$IconImage extends (0, $KD0eF.default) {
    /**
   * @param {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap|null} image Image.
   * @param {string|undefined} src Src.
   * @param {import('../dom').ImageAttributes} imageAttributes Image attributes options.
   * @param {import("../ImageState.js").default|undefined} imageState Image state.
   * @param {import("../color.js").Color|string|null} color Color.
   */ constructor(image, src, imageAttributes, imageState, color){
        super();
        /**
     * @private
     * @type {HTMLImageElement|OffscreenCanvas|HTMLCanvasElement|ImageBitmap}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap|null}
     */ this.image_ = image;
        /**
     * @private
     * @type {string|null}
     */ this.crossOrigin_ = imageAttributes?.crossOrigin;
        /**
     * @private
     * @type {ReferrerPolicy}
     */ this.referrerPolicy_ = imageAttributes?.referrerPolicy;
        /**
     * @private
     * @type {Object<number, HTMLCanvasElement|OffscreenCanvas>}
     */ this.canvas_ = {};
        /**
     * @private
     * @type {import("../color.js").Color|string|null}
     */ this.color_ = color;
        /**
     * @private
     * @type {import("../ImageState.js").default}
     */ this.imageState_ = imageState === undefined ? (0, $aSvtr.default).IDLE : imageState;
        /**
     * @private
     * @type {import("../size.js").Size|null}
     */ this.size_ = image && image.width && image.height ? [
            image.width,
            image.height
        ] : null;
        /**
     * @private
     * @type {string|undefined}
     */ this.src_ = src;
        /**
     * @private
     */ this.tainted_;
        /**
     * @private
     * @type {Promise<void>|null}
     */ this.ready_ = null;
    }
    /**
   * @private
   */ initializeImage_() {
        this.image_ = new Image();
        if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
        if (this.referrerPolicy_ !== undefined) this.image_.referrerPolicy = this.referrerPolicy_;
    }
    /**
   * @private
   * @return {boolean} The image canvas is tainted.
   */ isTainted_() {
        if (this.tainted_ === undefined && this.imageState_ === (0, $aSvtr.default).LOADED) {
            if (!$0e5ad1d3b638689e$var$taintedTestContext) $0e5ad1d3b638689e$var$taintedTestContext = (0, $DfnQm.createCanvasContext2D)(1, 1, undefined, {
                willReadFrequently: true
            });
            $0e5ad1d3b638689e$var$taintedTestContext.drawImage(this.image_, 0, 0);
            try {
                $0e5ad1d3b638689e$var$taintedTestContext.getImageData(0, 0, 1, 1);
                this.tainted_ = false;
            } catch  {
                $0e5ad1d3b638689e$var$taintedTestContext = null;
                this.tainted_ = true;
            }
        }
        return this.tainted_ === true;
    }
    /**
   * @private
   */ dispatchChangeEvent_() {
        this.dispatchEvent((0, $3xzSb.default).CHANGE);
    }
    /**
   * @private
   */ handleImageError_() {
        this.imageState_ = (0, $aSvtr.default).ERROR;
        this.dispatchChangeEvent_();
    }
    /**
   * @private
   */ handleImageLoad_() {
        this.imageState_ = (0, $aSvtr.default).LOADED;
        this.size_ = [
            this.image_.width,
            this.image_.height
        ];
        this.dispatchChangeEvent_();
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} Image or Canvas element or image bitmap.
   */ getImage(pixelRatio) {
        if (!this.image_) this.initializeImage_();
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? this.canvas_[pixelRatio] : this.image_;
    }
    /**
   * @param {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} image Image.
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Image or Canvas element.
   */ getPixelRatio(pixelRatio) {
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? pixelRatio : 1;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} Image element.
   */ getHitDetectionImage() {
        if (!this.image_) this.initializeImage_();
        if (!this.hitDetectionImage_) {
            if (this.isTainted_()) {
                const width = this.size_[0];
                const height = this.size_[1];
                const context = (0, $DfnQm.createCanvasContext2D)(width, height);
                context.fillRect(0, 0, width, height);
                this.hitDetectionImage_ = context.canvas;
            } else this.hitDetectionImage_ = this.image_;
        }
        return this.hitDetectionImage_;
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   */ getSize() {
        return this.size_;
    }
    /**
   * @return {string|undefined} Image src.
   */ getSrc() {
        return this.src_;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.imageState_ !== (0, $aSvtr.default).IDLE) return;
        if (!this.image_) this.initializeImage_();
        this.imageState_ = (0, $aSvtr.default).LOADING;
        try {
            if (this.src_ !== undefined) /** @type {HTMLImageElement} */ this.image_.src = this.src_;
        } catch  {
            this.handleImageError_();
        }
        if (this.image_ instanceof HTMLImageElement) (0, $fySoz.decodeFallback)(this.image_, this.src_).then((image)=>{
            this.image_ = image;
            this.handleImageLoad_();
        }).catch(this.handleImageError_.bind(this));
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @private
   */ replaceColor_(pixelRatio) {
        if (!this.color_ || this.canvas_[pixelRatio] || this.imageState_ !== (0, $aSvtr.default).LOADED) return;
        const image = this.image_;
        const ctx = (0, $DfnQm.createCanvasContext2D)(Math.ceil(image.width * pixelRatio), Math.ceil(image.height * pixelRatio));
        const canvas = ctx.canvas;
        ctx.scale(pixelRatio, pixelRatio);
        ctx.drawImage(image, 0, 0);
        ctx.globalCompositeOperation = 'multiply';
        ctx.fillStyle = (0, $4iSHH.asString)(this.color_);
        ctx.fillRect(0, 0, canvas.width / pixelRatio, canvas.height / pixelRatio);
        ctx.globalCompositeOperation = 'destination-in';
        ctx.drawImage(image, 0, 0);
        this.canvas_[pixelRatio] = canvas;
    }
    /**
   * @return {Promise<void>} Promise that resolves when the image is loaded.
   */ ready() {
        if (!this.ready_) this.ready_ = new Promise((resolve)=>{
            if (this.imageState_ === (0, $aSvtr.default).LOADED || this.imageState_ === (0, $aSvtr.default).ERROR) resolve();
            else {
                const onChange = ()=>{
                    if (this.imageState_ === (0, $aSvtr.default).LOADED || this.imageState_ === (0, $aSvtr.default).ERROR) {
                        this.removeEventListener((0, $3xzSb.default).CHANGE, onChange);
                        resolve();
                    }
                };
                this.addEventListener((0, $3xzSb.default).CHANGE, onChange);
            }
        });
        return this.ready_;
    }
}
function $0e5ad1d3b638689e$export$3988ae62b71be9a3(image, src, imageAttributes, imageState, color, pattern) {
    let iconImage = src === undefined ? undefined : (0, $kTbud.shared).get(src, color);
    if (!iconImage) {
        iconImage = new $0e5ad1d3b638689e$var$IconImage(image, image && 'src' in image ? image.src || undefined : src, imageAttributes, imageState, color);
        (0, $kTbud.shared).set(src, color, iconImage, pattern);
    }
    if (pattern && iconImage && !(0, $kTbud.shared).getPattern(src, color)) (0, $kTbud.shared).set(src, color, iconImage, pattern);
    return iconImage;
}
var $0e5ad1d3b638689e$export$2e2bcd8739ae039 = $0e5ad1d3b638689e$var$IconImage;

});
parcelRegister("kTbud", function(module, exports) {

$parcel$export(module.exports, "shared", () => $f351daabfe6e2d22$export$747ccdf771a87ab8);
/**
 * @module ol/style/IconImageCache
 */ 
var $aSvtr = parcelRequire("aSvtr");

var $4iSHH = parcelRequire("4iSHH");

var $DfnQm = parcelRequire("DfnQm");
/**
 * @classdesc
 * Singleton class. Available through {@link module:ol/style/IconImageCache.shared}.
 */ class $f351daabfe6e2d22$var$IconImageCache {
    constructor(){
        /**
     * @type {!Object<string, import("./IconImage.js").default>}
     * @private
     */ this.cache_ = {};
        /**
     * @type {!Object<string, CanvasPattern>}
     * @private
     */ this.patternCache_ = {};
        /**
     * @type {number}
     * @private
     */ this.cacheSize_ = 0;
        /**
     * @type {number}
     * @private
     */ this.maxCacheSize_ = 1024;
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.cache_ = {};
        this.patternCache_ = {};
        this.cacheSize_ = 0;
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.cacheSize_ > this.maxCacheSize_;
    }
    /**
   * FIXME empty description for jsdoc
   */ expire() {
        if (this.canExpireCache()) {
            let i = 0;
            for(const key in this.cache_){
                const iconImage = this.cache_[key];
                if ((i++ & 3) === 0 && !iconImage.hasListener()) {
                    delete this.cache_[key];
                    delete this.patternCache_[key];
                    --this.cacheSize_;
                }
            }
        }
    }
    /**
   * @param {string} src Src.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {import("./IconImage.js").default} Icon image.
   */ get(src, color) {
        const key = $f351daabfe6e2d22$export$611736262b635f8d(src, color);
        const icon = key in this.cache_ ? this.cache_[key] : null;
        return icon;
    }
    /**
   * @param {string} src Src.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {CanvasPattern} Icon image.
   */ getPattern(src, color) {
        const key = $f351daabfe6e2d22$export$611736262b635f8d(src, color);
        return key in this.patternCache_ ? this.patternCache_[key] : null;
    }
    /**
   * @param {string} src Src.
   * @param {import("../color.js").Color|string|null} color Color.
   * @param {import("./IconImage.js").default|null} iconImage Icon image.
   * @param {boolean} [pattern] Also cache a `'repeat'` pattern with this `iconImage`.
   */ set(src, color, iconImage, pattern) {
        const key = $f351daabfe6e2d22$export$611736262b635f8d(src, color);
        const update = key in this.cache_;
        this.cache_[key] = iconImage;
        if (pattern) {
            if (iconImage.getImageState() === (0, $aSvtr.default).IDLE) iconImage.load();
            if (iconImage.getImageState() === (0, $aSvtr.default).LOADING) iconImage.ready().then(()=>{
                this.patternCache_[key] = (0, $DfnQm.getSharedCanvasContext2D)().createPattern(iconImage.getImage(1), 'repeat');
            });
            else this.patternCache_[key] = (0, $DfnQm.getSharedCanvasContext2D)().createPattern(iconImage.getImage(1), 'repeat');
        }
        if (!update) ++this.cacheSize_;
    }
    /**
   * Set the cache size of the icon cache. Default is `1024`. Change this value when
   * your map uses more than 1024 different icon images and you are not caching icon
   * styles on the application level.
   * @param {number} maxCacheSize Cache max size.
   * @api
   */ setSize(maxCacheSize) {
        this.maxCacheSize_ = maxCacheSize;
        this.expire();
    }
}
function $f351daabfe6e2d22$export$611736262b635f8d(src, color) {
    const colorString = color ? (0, $4iSHH.asArray)(color) : 'null';
    return src + ':' + colorString;
}
var $f351daabfe6e2d22$export$2e2bcd8739ae039 = $f351daabfe6e2d22$var$IconImageCache;
const $f351daabfe6e2d22$export$747ccdf771a87ab8 = new $f351daabfe6e2d22$var$IconImageCache();

});



parcelRegister("ig1j9", function(module, exports) {

$parcel$export(module.exports, "defaultFont", () => $d4aabc5c971073f1$export$3847dfea4f8d4dfa);
$parcel$export(module.exports, "defaultFillStyle", () => $d4aabc5c971073f1$export$c495d52ee3fd74b2);
$parcel$export(module.exports, "defaultLineCap", () => $d4aabc5c971073f1$export$17bd0c38d6ae694e);
$parcel$export(module.exports, "defaultLineDash", () => $d4aabc5c971073f1$export$e21b4112fdc612fc);
$parcel$export(module.exports, "defaultLineDashOffset", () => $d4aabc5c971073f1$export$e06efc2409049f76);
$parcel$export(module.exports, "defaultLineJoin", () => $d4aabc5c971073f1$export$365eb9648cf19bd0);
$parcel$export(module.exports, "defaultMiterLimit", () => $d4aabc5c971073f1$export$80c1c01844597b7b);
$parcel$export(module.exports, "defaultStrokeOffset", () => $d4aabc5c971073f1$export$e010c2b9c075c7a1);
$parcel$export(module.exports, "defaultStrokeStyle", () => $d4aabc5c971073f1$export$1eb2eaecacf2031e);
$parcel$export(module.exports, "defaultTextAlign", () => $d4aabc5c971073f1$export$94d53b95641b5766);
$parcel$export(module.exports, "defaultTextBaseline", () => $d4aabc5c971073f1$export$cf2279a1bff62eb);
$parcel$export(module.exports, "defaultPadding", () => $d4aabc5c971073f1$export$40a9eeef55665a40);
$parcel$export(module.exports, "defaultLineWidth", () => $d4aabc5c971073f1$export$79661f132c62010e);
$parcel$export(module.exports, "checkedFonts", () => $d4aabc5c971073f1$export$1d36981fcadac93b);
$parcel$export(module.exports, "registerFont", () => $d4aabc5c971073f1$export$a534074a28fa87ff);
$parcel$export(module.exports, "measureAndCacheTextWidth", () => $d4aabc5c971073f1$export$915c7ba51467308f);
$parcel$export(module.exports, "getTextDimensions", () => $d4aabc5c971073f1$export$7d7c13020df1e791);
$parcel$export(module.exports, "drawImageOrLabel", () => $d4aabc5c971073f1$export$3cb6f3a6e49cc0ee);
/**
 * @module ol/render/canvas
 */ 
var $fFFY7 = parcelRequire("fFFY7");

var $hGHcK = parcelRequire("hGHcK");

var $DfnQm = parcelRequire("DfnQm");

var $8UoiJ = parcelRequire("8UoiJ");

var $gn0g3 = parcelRequire("gn0g3");
const $d4aabc5c971073f1$export$3847dfea4f8d4dfa = '10px sans-serif';
const $d4aabc5c971073f1$export$c495d52ee3fd74b2 = '#000';
const $d4aabc5c971073f1$export$17bd0c38d6ae694e = 'round';
const $d4aabc5c971073f1$export$e21b4112fdc612fc = [];
const $d4aabc5c971073f1$export$e06efc2409049f76 = 0;
const $d4aabc5c971073f1$export$365eb9648cf19bd0 = 'round';
const $d4aabc5c971073f1$export$80c1c01844597b7b = 10;
const $d4aabc5c971073f1$export$e010c2b9c075c7a1 = 0;
const $d4aabc5c971073f1$export$1eb2eaecacf2031e = '#000';
const $d4aabc5c971073f1$export$94d53b95641b5766 = 'center';
const $d4aabc5c971073f1$export$cf2279a1bff62eb = 'middle';
const $d4aabc5c971073f1$export$40a9eeef55665a40 = [
    0,
    0,
    0,
    0
];
const $d4aabc5c971073f1$export$79661f132c62010e = 1;
const $d4aabc5c971073f1$export$1d36981fcadac93b = new (0, $fFFY7.default)();
/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
 */ let $d4aabc5c971073f1$var$measureContext = null;
/**
 * @type {string}
 */ let $d4aabc5c971073f1$var$measureFont;
const $d4aabc5c971073f1$export$7fdcec604f0b1fa7 = {};
const $d4aabc5c971073f1$var$genericFontFamilies = new Set([
    'serif',
    'sans-serif',
    'monospace',
    'cursive',
    'fantasy',
    'system-ui',
    'ui-serif',
    'ui-sans-serif',
    'ui-monospace',
    'ui-rounded',
    'emoji',
    'math',
    'fangsong'
]);
/**
 * @param {string} style Css font-style
 * @param {string} weight Css font-weight
 * @param {string} family Css font-family
 * @return {string} Font key.
 */ function $d4aabc5c971073f1$var$getFontKey(style, weight, family) {
    return `${style} ${weight} 16px "${family}"`;
}
const $d4aabc5c971073f1$export$a534074a28fa87ff = function() {
    const retries = 100;
    let timeout, fontFaceSet;
    /**
   * @param {string} fontSpec Css font spec
   * @return {Promise<boolean>} Font with style and weight is available
   */ async function isAvailable(fontSpec) {
        await fontFaceSet.ready;
        const fontFaces = await fontFaceSet.load(fontSpec);
        if (fontFaces.length === 0) return false;
        const font = (0, $hGHcK.getFontParameters)(fontSpec);
        const checkFamily = font.families[0].toLowerCase();
        const checkWeight = font.weight;
        return fontFaces.some(/**
       * @param {import('../css.js').FontParameters} f Font.
       * @return {boolean} Font matches.
       */ (f)=>{
            const family = f.family.replace(/^['"]|['"]$/g, '').toLowerCase();
            const weight = (0, $hGHcK.fontWeights)[f.weight] || f.weight;
            return family === checkFamily && f.style === font.style && weight == checkWeight;
        });
    }
    async function check() {
        await fontFaceSet.ready;
        let done = true;
        const checkedFontsProperties = $d4aabc5c971073f1$export$1d36981fcadac93b.getProperties();
        const fonts = Object.keys(checkedFontsProperties).filter((key)=>checkedFontsProperties[key] < retries);
        for(let i = fonts.length - 1; i >= 0; --i){
            const font = fonts[i];
            let currentRetries = checkedFontsProperties[font];
            if (currentRetries < retries) {
                if (await isAvailable(font)) {
                    (0, $gn0g3.clear)($d4aabc5c971073f1$export$7fdcec604f0b1fa7);
                    $d4aabc5c971073f1$export$1d36981fcadac93b.set(font, retries);
                } else {
                    currentRetries += 10;
                    $d4aabc5c971073f1$export$1d36981fcadac93b.set(font, currentRetries, true);
                    if (currentRetries < retries) done = false;
                }
            }
        }
        timeout = undefined;
        if (!done) timeout = setTimeout(check, 100);
    }
    return async function(fontSpec) {
        if (!fontFaceSet) fontFaceSet = (0, $8UoiJ.WORKER_OFFSCREEN_CANVAS) ? self.fonts : document.fonts;
        const font = (0, $hGHcK.getFontParameters)(fontSpec);
        if (!font) return;
        const families = font.families;
        let needCheck = false;
        for (const family of families){
            if ($d4aabc5c971073f1$var$genericFontFamilies.has(family)) continue;
            const key = $d4aabc5c971073f1$var$getFontKey(font.style, font.weight, family);
            if ($d4aabc5c971073f1$export$1d36981fcadac93b.get(key) !== undefined) continue;
            $d4aabc5c971073f1$export$1d36981fcadac93b.set(key, 0, true);
            needCheck = true;
        }
        if (needCheck) {
            clearTimeout(timeout);
            timeout = setTimeout(check, 100);
        }
    };
}();
const $d4aabc5c971073f1$export$4feaf6852ff92513 = function() {
    /**
   * @type {HTMLDivElement}
   */ let measureElement;
    return function(fontSpec) {
        let height = $d4aabc5c971073f1$export$7fdcec604f0b1fa7[fontSpec];
        if (height == undefined) {
            if (0, $8UoiJ.WORKER_OFFSCREEN_CANVAS) {
                const font = (0, $hGHcK.getFontParameters)(fontSpec);
                const metrics = $d4aabc5c971073f1$var$measureText(fontSpec, "\u017Dg");
                const lineHeight = isNaN(Number(font.lineHeight)) ? 1.2 : Number(font.lineHeight);
                height = lineHeight * (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent);
            } else {
                if (!measureElement) {
                    measureElement = document.createElement('div');
                    measureElement.innerHTML = 'M';
                    measureElement.style.minHeight = '0';
                    measureElement.style.maxHeight = 'none';
                    measureElement.style.height = 'auto';
                    measureElement.style.padding = '0';
                    measureElement.style.border = 'none';
                    measureElement.style.position = 'absolute';
                    measureElement.style.display = 'block';
                    measureElement.style.left = '-99999px';
                }
                measureElement.style.font = fontSpec;
                document.body.appendChild(measureElement);
                height = measureElement.offsetHeight;
                document.body.removeChild(measureElement);
            }
            $d4aabc5c971073f1$export$7fdcec604f0b1fa7[fontSpec] = height;
        }
        return height;
    };
}();
/**
 * @param {string} font Font.
 * @param {string} text Text.
 * @return {TextMetrics} Text metrics.
 */ function $d4aabc5c971073f1$var$measureText(font, text) {
    if (!$d4aabc5c971073f1$var$measureContext) $d4aabc5c971073f1$var$measureContext = (0, $DfnQm.createCanvasContext2D)(1, 1);
    if (font != $d4aabc5c971073f1$var$measureFont) {
        $d4aabc5c971073f1$var$measureContext.font = font;
        $d4aabc5c971073f1$var$measureFont = $d4aabc5c971073f1$var$measureContext.font;
    }
    return $d4aabc5c971073f1$var$measureContext.measureText(text);
}
function $d4aabc5c971073f1$export$4ea92329b673abd1(font, text) {
    return $d4aabc5c971073f1$var$measureText(font, text).width;
}
function $d4aabc5c971073f1$export$915c7ba51467308f(font, text, cache) {
    if (text in cache) return cache[text];
    const width = text.split('\n').reduce((prev, curr)=>Math.max(prev, $d4aabc5c971073f1$export$4ea92329b673abd1(font, curr)), 0);
    cache[text] = width;
    return width;
}
function $d4aabc5c971073f1$export$7d7c13020df1e791(baseStyle, chunks) {
    const widths = [];
    const heights = [];
    const lineWidths = [];
    let width = 0;
    let lineWidth = 0;
    let height = 0;
    let lineHeight = 0;
    for(let i = 0, ii = chunks.length; i <= ii; i += 2){
        const text = chunks[i];
        if (text === '\n' || i === ii) {
            width = Math.max(width, lineWidth);
            lineWidths.push(lineWidth);
            lineWidth = 0;
            height += lineHeight;
            lineHeight = 0;
            continue;
        }
        const font = chunks[i + 1] || baseStyle.font;
        const currentWidth = $d4aabc5c971073f1$export$4ea92329b673abd1(font, text);
        widths.push(currentWidth);
        lineWidth += currentWidth;
        const currentHeight = $d4aabc5c971073f1$export$4feaf6852ff92513(font);
        heights.push(currentHeight);
        lineHeight = Math.max(lineHeight, currentHeight);
    }
    return {
        width: width,
        height: height,
        widths: widths,
        heights: heights,
        lineWidths: lineWidths
    };
}
function $d4aabc5c971073f1$export$8ac4d72be78047e6(context, rotation, offsetX, offsetY) {
    if (rotation !== 0) {
        context.translate(offsetX, offsetY);
        context.rotate(rotation);
        context.translate(-offsetX, -offsetY);
    }
}
function $d4aabc5c971073f1$export$3cb6f3a6e49cc0ee(context, transform, opacity, labelOrImage, originX, originY, w, h, x, y, scale) {
    context.save();
    if (opacity !== 1) {
        if (context.globalAlpha === undefined) context.globalAlpha = (context)=>context.globalAlpha *= opacity;
        else context.globalAlpha *= opacity;
    }
    if (transform) context.transform.apply(context, transform);
    if (/** @type {*} */ labelOrImage.contextInstructions) {
        // label
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        $d4aabc5c971073f1$var$executeLabelInstructions(/** @type {Label} */ labelOrImage, context);
    } else if (scale[0] < 0 || scale[1] < 0) {
        // flipped image
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, 0, 0, w, h);
    } else // if image not flipped translate and scale can be avoided
    context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, x, y, w * scale[0], h * scale[1]);
    context.restore();
}
/**
 * @param {Label} label Label.
 * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
 */ function $d4aabc5c971073f1$var$executeLabelInstructions(label, context) {
    const contextInstructions = label.contextInstructions;
    for(let i = 0, ii = contextInstructions.length; i < ii; i += 2)if (Array.isArray(contextInstructions[i + 1])) context[contextInstructions[i]].apply(context, contextInstructions[i + 1]);
    else context[contextInstructions[i]] = contextInstructions[i + 1];
}

});

parcelRegister("jKhJx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e60011aea38e6239$export$2e2bcd8739ae039);
/**
 * @module ol/style/Image
 */ 
var $hxhPO = parcelRequire("hxhPO");

var $9iPUS = parcelRequire("9iPUS");
/**
 * @typedef {Object} Options
 * @property {number} opacity Opacity.
 * @property {boolean} rotateWithView If the image should get rotated with the view.
 * @property {number} rotation Rotation.
 * @property {number|import("../size.js").Size} scale Scale.
 * @property {Array<number>} displacement Displacement.
 * @property {import('../style/Style.js').DeclutterMode} declutterMode Declutter mode: `declutter`, `obstacle`, `none`.
 */ /**
 * @classdesc
 * A base class used for creating subclasses and not instantiated in
 * apps. Base class for {@link module:ol/style/Icon~Icon}, {@link module:ol/style/Circle~CircleStyle} and
 * {@link module:ol/style/RegularShape~RegularShape}.
 * @abstract
 * @api
 */ class $e60011aea38e6239$var$ImageStyle {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        /**
     * @private
     * @type {number}
     */ this.opacity_ = options.opacity;
        /**
     * @private
     * @type {boolean}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {number}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $hxhPO.toSize)(options.scale);
        /**
     * @private
     * @type {Array<number>}
     */ this.displacement_ = options.displacement;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {ImageStyle} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new $e60011aea38e6239$var$ImageStyle({
            opacity: this.getOpacity(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the symbolizer opacity.
   * @return {number} Opacity.
   * @api
   */ getOpacity() {
        return this.opacity_;
    }
    /**
   * Determine whether the symbolizer rotates with the map.
   * @return {boolean} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Get the symoblizer rotation.
   * @return {number} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the symbolizer scale.
   * @return {number|import("../size.js").Size} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the displacement of the shape
   * @return {Array<number>} Shape's center displacement
   * @api
   */ getDisplacement() {
        return this.displacement_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @abstract
   * @return {Array<number>} Anchor.
   */ getAnchor() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Get the image element for the symbolizer.
   * @abstract
   * @param {number} pixelRatio Pixel ratio.
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getImage(pixelRatio) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * @abstract
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getHitDetectionImage() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   */ getPixelRatio(pixelRatio) {
        return 1;
    }
    /**
   * @abstract
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * @abstract
   * @return {import("../size.js").Size} Image size.
   */ getImageSize() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Get the origin of the symbolizer.
   * @abstract
   * @return {Array<number>} Origin.
   */ getOrigin() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @abstract
   * @return {import("../size.js").Size} Size.
   */ getSize() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Set the displacement.
   *
   * @param {Array<number>} displacement Displacement.
   * @api
   */ setDisplacement(displacement) {
        this.displacement_ = displacement;
    }
    /**
   * Set the opacity.
   *
   * @param {number} opacity Opacity.
   * @api
   */ setOpacity(opacity) {
        this.opacity_ = opacity;
    }
    /**
   * Set whether to rotate the style with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set the rotation.
   *
   * @param {number} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $hxhPO.toSize)(scale);
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ listenImageChange(listener) {
        (0, $9iPUS.abstract)();
    }
    /**
   * Load not yet loaded URI.
   * @abstract
   */ load() {
        (0, $9iPUS.abstract)();
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ unlistenImageChange(listener) {
        (0, $9iPUS.abstract)();
    }
    /**
   * @return {Promise<void>} `false` or Promise that resolves when the style is ready to use.
   */ ready() {
        return Promise.resolve();
    }
}
var $e60011aea38e6239$export$2e2bcd8739ae039 = $e60011aea38e6239$var$ImageStyle;

});



parcelRegister("inIMS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d61d1dcaf3c44610$export$2e2bcd8739ae039);
/**
 * @module ol/style/Fill
 */ 
var $aSvtr = parcelRequire("aSvtr");

var $4iSHH = parcelRequire("4iSHH");

var $9iPUS = parcelRequire("9iPUS");

var $1epqj = parcelRequire("1epqj");
/**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} [color=null] A color,
 * gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats. For polygon fills (not for {@link import("./RegularShape.js").default} fills),
 * a pattern can also be provided as {@link module:ol/colorlike~PatternDescriptor}.
 * Default null; if null, the Canvas/renderer default black will be used.
 */ /**
 * @classdesc
 * Set fill style for vector features.
 * @api
 */ class $d61d1dcaf3c44610$var$Fill {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("./IconImage.js").default|null}
     */ this.patternImage_ = null;
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null}
     */ this.color_ = null;
        if (options.color !== undefined) this.setColor(options.color);
    }
    /**
   * Clones the style. The color is not cloned if it is a {@link module:ol/colorlike~ColorLike}.
   * @return {Fill} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new $d61d1dcaf3c44610$var$Fill({
            color: Array.isArray(color) ? color.slice() : color || undefined
        });
    }
    /**
   * Get the fill color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} color Color.
   * @api
   */ setColor(color) {
        if (color !== null && typeof color === 'object' && 'src' in color) {
            const patternImage = (0, $1epqj.get)(null, color.src, {
                crossOrigin: 'anonymous'
            }, undefined, color.offset ? null : color.color ? color.color : null, !(color.offset && color.size));
            patternImage.ready().then(()=>{
                this.patternImage_ = null;
            });
            if (patternImage.getImageState() === (0, $aSvtr.default).IDLE) patternImage.load();
            if (patternImage.getImageState() === (0, $aSvtr.default).LOADING) this.patternImage_ = patternImage;
        }
        this.color_ = color;
    }
    /**
   * @return {string} Key of the fill for cache lookup.
   */ getKey() {
        const fill = this.getColor();
        if (!fill) return '';
        return fill instanceof CanvasPattern || fill instanceof CanvasGradient ? (0, $9iPUS.getUid)(fill) : typeof fill === 'object' && 'src' in fill ? fill.src + ':' + fill.offset : (0, $4iSHH.asArray)(fill).toString();
    }
    /**
   * @return {boolean} The fill style is loading an image pattern.
   */ loading() {
        return !!this.patternImage_;
    }
    /**
   * @return {Promise<void>} `false` or a promise that resolves when the style is ready to use.
   */ ready() {
        return this.patternImage_ ? this.patternImage_.ready() : Promise.resolve();
    }
}
var $d61d1dcaf3c44610$export$2e2bcd8739ae039 = $d61d1dcaf3c44610$var$Fill;

});

parcelRegister("bmHVE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8463d325b53eeb0c$export$2e2bcd8739ae039);
/**
 * @module ol/style/Icon
 */ 
var $aSvtr = parcelRequire("aSvtr");

var $4Cz58 = parcelRequire("4Cz58");

var $4iSHH = parcelRequire("4iSHH");

var $3xzSb = parcelRequire("3xzSb");

var $9iPUS = parcelRequire("9iPUS");

var $1epqj = parcelRequire("1epqj");

var $jKhJx = parcelRequire("jKhJx");
/**
 * @typedef {'fraction' | 'pixels'} IconAnchorUnits
 * Anchor unit can be either a fraction of the icon size or in pixels.
 */ /**
 * @typedef {'bottom-left' | 'bottom-right' | 'top-left' | 'top-right'} IconOrigin
 * Icon origin. One of 'bottom-left', 'bottom-right', 'top-left', 'top-right'.
 */ /**
 * @typedef {Object} Options
 * @property {Array<number>} [anchor=[0.5, 0.5]] Anchor. Default value is the icon center.
 * @property {IconOrigin} [anchorOrigin='top-left'] Origin of the anchor: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {IconAnchorUnits} [anchorXUnits='fraction'] Units in which the anchor x value is
 * specified. A value of `'fraction'` indicates the x value is a fraction of the icon. A value of `'pixels'` indicates
 * the x value in pixels.
 * @property {IconAnchorUnits} [anchorYUnits='fraction'] Units in which the anchor y value is
 * specified. A value of `'fraction'` indicates the y value is a fraction of the icon. A value of `'pixels'` indicates
 * the y value in pixels.
 * @property {import("../color.js").Color|string} [color] Color to tint the icon. If not specified,
 * the icon will be left as is.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} [img] Image object for the icon.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the icon in pixels.
 * Positive values will shift the icon right and up.
 * @property {number} [opacity=1] Opacity of the icon.
 * @property {number} [width] The width of the icon in pixels. This can't be used together with `scale`.
 * @property {number} [height] The height of the icon in pixels. This can't be used together with `scale`.
 * @property {number|import("../size.js").Size} [scale=1] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the icon with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {Array<number>} [offset=[0, 0]] Offset which, together with `size` and `offsetOrigin`, defines the
 * sub-rectangle to use from the original (sprite) image.
 * @property {IconOrigin} [offsetOrigin='top-left'] Origin of the offset: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {import("../size.js").Size} [size] Icon size in pixels. Used together with `offset` to define the
 * sub-rectangle to use from the original (sprite) image.
 * @property {string} [src] Image source URI.
 * @property {import("./Style.js").DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @param {number} width The width.
 * @param {number} height The height.
 * @param {number|undefined} wantedWidth The wanted width.
 * @param {number|undefined} wantedHeight The wanted height.
 * @return {number|Array<number>} The scale.
 */ function $8463d325b53eeb0c$var$calculateScale(width, height, wantedWidth, wantedHeight) {
    if (wantedWidth !== undefined && wantedHeight !== undefined) return [
        wantedWidth / width,
        wantedHeight / height
    ];
    if (wantedWidth !== undefined) return wantedWidth / width;
    if (wantedHeight !== undefined) return wantedHeight / height;
    return 1;
}
/**
 * @classdesc
 * Set icon style for vector features.
 * @api
 */ class $8463d325b53eeb0c$var$Icon extends (0, $jKhJx.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @type {number}
     */ const opacity = options.opacity !== undefined ? options.opacity : 1;
        /**
     * @type {number}
     */ const rotation = options.rotation !== undefined ? options.rotation : 0;
        /**
     * @type {number|import("../size.js").Size}
     */ const scale = options.scale !== undefined ? options.scale : 1;
        /**
     * @type {boolean}
     */ const rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        super({
            opacity: opacity,
            rotation: rotation,
            scale: scale,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            rotateWithView: rotateWithView,
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {Array<number>}
     */ this.anchor_ = options.anchor !== undefined ? options.anchor : [
            0.5,
            0.5
        ];
        /**
     * @private
     * @type {Array<number>}
     */ this.normalizedAnchor_ = null;
        /**
     * @private
     * @type {IconOrigin}
     */ this.anchorOrigin_ = options.anchorOrigin !== undefined ? options.anchorOrigin : 'top-left';
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorXUnits_ = options.anchorXUnits !== undefined ? options.anchorXUnits : 'fraction';
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorYUnits_ = options.anchorYUnits !== undefined ? options.anchorYUnits : 'fraction';
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @private
     * @type {ReferrerPolicy}
     */ this.referrerPolicy_ = options.referrerPolicy;
        const image = options.img !== undefined ? options.img : null;
        let cacheKey = options.src;
        (0, $4Cz58.assert)(!(cacheKey !== undefined && image), '`image` and `src` cannot be provided at the same time');
        if ((cacheKey === undefined || cacheKey.length === 0) && image) cacheKey = /** @type {HTMLImageElement} */ image.src || (0, $9iPUS.getUid)(image);
        (0, $4Cz58.assert)(cacheKey !== undefined && cacheKey.length > 0, 'A defined and non-empty `src` or `image` must be provided');
        (0, $4Cz58.assert)(!((options.width !== undefined || options.height !== undefined) && options.scale !== undefined), '`width` or `height` cannot be provided together with `scale`');
        let imageState;
        if (options.src !== undefined) imageState = (0, $aSvtr.default).IDLE;
        else if (image !== undefined) {
            if ('complete' in image) {
                if (image.complete) imageState = image.src ? (0, $aSvtr.default).LOADED : (0, $aSvtr.default).IDLE;
                else imageState = (0, $aSvtr.default).LOADING;
            } else imageState = (0, $aSvtr.default).LOADED;
        }
        /**
     * @private
     * @type {import("../color.js").Color}
     */ this.color_ = options.color !== undefined ? (0, $4iSHH.asArray)(options.color) : null;
        /**
     * @private
     * @type {import("./IconImage.js").default}
     */ this.iconImage_ = (0, $1epqj.get)(image, /** @type {string} */ cacheKey, {
            crossOrigin: this.crossOrigin_,
            referrerPolicy: this.referrerPolicy_
        }, imageState, this.color_);
        /**
     * @private
     * @type {Array<number>}
     */ this.offset_ = options.offset !== undefined ? options.offset : [
            0,
            0
        ];
        /**
     * @private
     * @type {IconOrigin}
     */ this.offsetOrigin_ = options.offsetOrigin !== undefined ? options.offsetOrigin : 'top-left';
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_ = options.size !== undefined ? options.size : null;
        /**
     * @private
     */ this.initialOptions_;
        /**
     * Calculate the scale if width or height were given.
     */ if (options.width !== undefined || options.height !== undefined) {
            let width, height;
            if (options.size) [width, height] = options.size;
            else {
                const image = this.getImage(1);
                if (image.width && image.height) {
                    width = image.width;
                    height = image.height;
                } else if (image instanceof HTMLImageElement) {
                    this.initialOptions_ = options;
                    const onload = ()=>{
                        this.unlistenImageChange(onload);
                        if (!this.initialOptions_) return;
                        const imageSize = this.iconImage_.getSize();
                        this.setScale($8463d325b53eeb0c$var$calculateScale(imageSize[0], imageSize[1], options.width, options.height));
                    };
                    this.listenImageChange(onload);
                    return;
                }
            }
            if (width !== undefined) this.setScale($8463d325b53eeb0c$var$calculateScale(width, height, options.width, options.height));
        }
    }
    /**
   * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
   * @return {Icon} The cloned style.
   * @api
   * @override
   */ clone() {
        let scale, width, height;
        if (this.initialOptions_) {
            width = this.initialOptions_.width;
            height = this.initialOptions_.height;
        } else {
            scale = this.getScale();
            scale = Array.isArray(scale) ? scale.slice() : scale;
        }
        return new $8463d325b53eeb0c$var$Icon({
            anchor: this.anchor_.slice(),
            anchorOrigin: this.anchorOrigin_,
            anchorXUnits: this.anchorXUnits_,
            anchorYUnits: this.anchorYUnits_,
            color: this.color_ && this.color_.slice ? this.color_.slice() : this.color_ || undefined,
            crossOrigin: this.crossOrigin_,
            referrerPolicy: this.referrerPolicy_,
            offset: this.offset_.slice(),
            offsetOrigin: this.offsetOrigin_,
            opacity: this.getOpacity(),
            rotateWithView: this.getRotateWithView(),
            rotation: this.getRotation(),
            scale: scale,
            width: width,
            height: height,
            size: this.size_ !== null ? this.size_.slice() : undefined,
            src: this.getSrc(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   * @override
   */ getAnchor() {
        let anchor = this.normalizedAnchor_;
        if (!anchor) {
            anchor = this.anchor_;
            const size = this.getSize();
            if (this.anchorXUnits_ == 'fraction' || this.anchorYUnits_ == 'fraction') {
                if (!size) return null;
                anchor = this.anchor_.slice();
                if (this.anchorXUnits_ == 'fraction') anchor[0] *= size[0];
                if (this.anchorYUnits_ == 'fraction') anchor[1] *= size[1];
            }
            if (this.anchorOrigin_ != 'top-left') {
                if (!size) return null;
                if (anchor === this.anchor_) anchor = this.anchor_.slice();
                if (this.anchorOrigin_ == 'top-right' || this.anchorOrigin_ == 'bottom-right') anchor[0] = -anchor[0] + size[0];
                if (this.anchorOrigin_ == 'bottom-left' || this.anchorOrigin_ == 'bottom-right') anchor[1] = -anchor[1] + size[1];
            }
            this.normalizedAnchor_ = anchor;
        }
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            anchor[0] - displacement[0] / scale[0],
            anchor[1] + displacement[1] / scale[1]
        ];
    }
    /**
   * Set the anchor point. The anchor determines the center point for the
   * symbolizer.
   *
   * @param {Array<number>} anchor Anchor.
   * @api
   */ setAnchor(anchor) {
        this.anchor_ = anchor;
        this.normalizedAnchor_ = null;
    }
    /**
   * Get the icon color.
   * @return {import("../color.js").Color} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Set the icon color.
   *
   * Warning: Repeatedly setting the color on an icon style
   * causes the icon image to be re-created each time. This can have a
   * severe performance impact.
   *
   * @param {import("../color.js").Color|string|null|undefined} color Color.
   */ setColor(color) {
        const nextColor = color ? (0, $4iSHH.asArray)(color) : null;
        if (this.color_ === nextColor || this.color_ && nextColor && this.color_.length === nextColor.length && this.color_.every((value, index)=>value === nextColor[index])) // Discard if the color hasn't changed.
        return;
        this.color_ = nextColor;
        const src = this.getSrc();
        const image = src !== undefined ? null : this.getHitDetectionImage();
        const imageState = src !== undefined ? (0, $aSvtr.default).IDLE : this.iconImage_.getImageState();
        this.iconImage_ = (0, $1epqj.get)(image, src, {
            crossOrigin: this.crossOrigin_,
            referrerPolicy: this.referrerPolicy_
        }, imageState, this.color_);
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} Image or Canvas element. If the Icon
   * style was configured with `src` or with a not let loaded `img`, an `ImageBitmap` will be returned.
   * @api
   * @override
   */ getImage(pixelRatio) {
        return this.iconImage_.getImage(pixelRatio);
    }
    /**
   * Get the pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} The pixel ratio of the image.
   * @api
   * @override
   */ getPixelRatio(pixelRatio) {
        return this.iconImage_.getPixelRatio(pixelRatio);
    }
    /**
   * @return {import("../size.js").Size} Image size.
   * @override
   */ getImageSize() {
        return this.iconImage_.getSize();
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   * @override
   */ getImageState() {
        return this.iconImage_.getImageState();
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} Image element.
   * @override
   */ getHitDetectionImage() {
        return this.iconImage_.getHitDetectionImage();
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   * @override
   */ getOrigin() {
        if (this.origin_) return this.origin_;
        let offset = this.offset_;
        if (this.offsetOrigin_ != 'top-left') {
            const size = this.getSize();
            const iconImageSize = this.iconImage_.getSize();
            if (!size || !iconImageSize) return null;
            offset = offset.slice();
            if (this.offsetOrigin_ == 'top-right' || this.offsetOrigin_ == 'bottom-right') offset[0] = iconImageSize[0] - size[0] - offset[0];
            if (this.offsetOrigin_ == 'bottom-left' || this.offsetOrigin_ == 'bottom-right') offset[1] = iconImageSize[1] - size[1] - offset[1];
        }
        this.origin_ = offset;
        return this.origin_;
    }
    /**
   * Get the image URL.
   * @return {string|undefined} Image src.
   * @api
   */ getSrc() {
        return this.iconImage_.getSrc();
    }
    /**
   * Set the image URI
   * @param {string} src Image source URI
   * @api
   */ setSrc(src) {
        this.iconImage_ = (0, $1epqj.get)(null, src, {
            crossOrigin: this.crossOrigin_,
            referrerPolicy: this.referrerPolicy_
        }, (0, $aSvtr.default).IDLE, this.color_);
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   * @api
   * @override
   */ getSize() {
        return !this.size_ ? this.iconImage_.getSize() : this.size_;
    }
    /**
   * Get the width of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon width (in pixels).
   * @api
   */ getWidth() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[0] * scale[0];
        if (this.iconImage_.getImageState() == (0, $aSvtr.default).LOADED) return this.iconImage_.getSize()[0] * scale[0];
        return undefined;
    }
    /**
   * Get the height of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon height (in pixels).
   * @api
   */ getHeight() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[1] * scale[1];
        if (this.iconImage_.getImageState() == (0, $aSvtr.default).LOADED) return this.iconImage_.getSize()[1] * scale[1];
        return undefined;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   * @override
   */ setScale(scale) {
        delete this.initialOptions_;
        super.setScale(scale);
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ listenImageChange(listener) {
        this.iconImage_.addEventListener((0, $3xzSb.default).CHANGE, listener);
    }
    /**
   * Load not yet loaded URI.
   * When rendering a feature with an icon style, the vector renderer will
   * automatically call this method. However, you might want to call this
   * method yourself for preloading or other purposes.
   * @api
   * @override
   */ load() {
        this.iconImage_.load();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ unlistenImageChange(listener) {
        this.iconImage_.removeEventListener((0, $3xzSb.default).CHANGE, listener);
    }
    /**
   * @override
   */ ready() {
        return this.iconImage_.ready();
    }
}
var $8463d325b53eeb0c$export$2e2bcd8739ae039 = $8463d325b53eeb0c$var$Icon;

});

parcelRegister("lrKvI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9d0329c5c745263$export$2e2bcd8739ae039);
/**
 * @module ol/style/Stroke
 */ /**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 * @property {CanvasLineCap} [lineCap='round'] Line cap style: `butt`, `round`, or `square`.
 * @property {CanvasLineJoin} [lineJoin='round'] Line join style: `bevel`, `round`, or `miter`.
 * @property {Array<number>} [lineDash] Line dash pattern. Default is `null` (no dash).
 * @property {number} [lineDashOffset=0] Line dash offset.
 * @property {number} [miterLimit=10] Miter limit.
 * @property {number} [offset] Line offset in pixels along the normal. A positive value offsets the line to the right,
 * relative to the direction of the line. Default is `null` (no offset).
 * @property {number} [width] Width.
 */ /**
 * @classdesc
 * Set stroke style for vector features.
 * Note that the defaults given are the Canvas defaults, which will be used if
 * option is not defined. The `get` functions return whatever was entered in
 * the options; they will not return the default.
 * @api
 */ class $f9d0329c5c745263$var$Stroke {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
     */ this.color_ = options.color !== undefined ? options.color : null;
        /**
     * @private
     * @type {CanvasLineCap|undefined}
     */ this.lineCap_ = options.lineCap;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.lineDash_ = options.lineDash !== undefined ? options.lineDash : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lineDashOffset_ = options.lineDashOffset;
        /**
     * @private
     * @type {CanvasLineJoin|undefined}
     */ this.lineJoin_ = options.lineJoin;
        /**
     * @private
     * @type {number|undefined}
     */ this.miterLimit_ = options.miterLimit;
        /**
     * @private
     * @type {number|undefined}
     */ this.offset_ = options.offset;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = options.width;
    }
    /**
   * Clones the style.
   * @return {Stroke} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new $f9d0329c5c745263$var$Stroke({
            color: Array.isArray(color) ? color.slice() : color || undefined,
            lineCap: this.getLineCap(),
            lineDash: this.getLineDash() ? this.getLineDash().slice() : undefined,
            lineDashOffset: this.getLineDashOffset(),
            lineJoin: this.getLineJoin(),
            miterLimit: this.getMiterLimit(),
            offset: this.getOffset(),
            width: this.getWidth()
        });
    }
    /**
   * Get the stroke color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Get the line cap type for the stroke.
   * @return {CanvasLineCap|undefined} Line cap.
   * @api
   */ getLineCap() {
        return this.lineCap_;
    }
    /**
   * Get the line dash style for the stroke.
   * @return {Array<number>|null} Line dash.
   * @api
   */ getLineDash() {
        return this.lineDash_;
    }
    /**
   * Get the line dash offset for the stroke.
   * @return {number|undefined} Line dash offset.
   * @api
   */ getLineDashOffset() {
        return this.lineDashOffset_;
    }
    /**
   * Get the line join type for the stroke.
   * @return {CanvasLineJoin|undefined} Line join.
   * @api
   */ getLineJoin() {
        return this.lineJoin_;
    }
    /**
   * Get the miter limit for the stroke.
   * @return {number|undefined} Miter limit.
   * @api
   */ getMiterLimit() {
        return this.miterLimit_;
    }
    /**
   * Get the line offset in pixels.
   * @return {number|undefined} Offset.
   * @api
   */ getOffset() {
        return this.offset_;
    }
    /**
   * Get the stroke width.
   * @return {number|undefined} Width.
   * @api
   */ getWidth() {
        return this.width_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
   * @api
   */ setColor(color) {
        this.color_ = color;
    }
    /**
   * Set the line cap.
   *
   * @param {CanvasLineCap|undefined} lineCap Line cap.
   * @api
   */ setLineCap(lineCap) {
        this.lineCap_ = lineCap;
    }
    /**
   * Set the line dash.
   *
   * @param {Array<number>|null} lineDash Line dash.
   * @api
   */ setLineDash(lineDash) {
        this.lineDash_ = lineDash;
    }
    /**
   * Set the line dash offset.
   *
   * @param {number|undefined} lineDashOffset Line dash offset.
   * @api
   */ setLineDashOffset(lineDashOffset) {
        this.lineDashOffset_ = lineDashOffset;
    }
    /**
   * Set the line join.
   *
   * @param {CanvasLineJoin|undefined} lineJoin Line join.
   * @api
   */ setLineJoin(lineJoin) {
        this.lineJoin_ = lineJoin;
    }
    /**
   * Set the miter limit.
   *
   * @param {number|undefined} miterLimit Miter limit.
   * @api
   */ setMiterLimit(miterLimit) {
        this.miterLimit_ = miterLimit;
    }
    /**
   * Set the line offset in pixels.
   *
   * @param {number|undefined} offset Offset.
   * @api
   */ setOffset(offset) {
        this.offset_ = offset;
    }
    /**
   * Set the width.
   *
   * @param {number|undefined} width Width.
   * @api
   */ setWidth(width) {
        this.width_ = width;
    }
}
var $f9d0329c5c745263$export$2e2bcd8739ae039 = $f9d0329c5c745263$var$Stroke;

});

parcelRegister("c3RIb", function(module, exports) {

$parcel$export(module.exports, "toFunction", () => $8c7f6dda98e8cb9c$export$c314ea3f6b164147);
$parcel$export(module.exports, "createDefaultStyle", () => $8c7f6dda98e8cb9c$export$6865c5ac2f5ce8b6);
$parcel$export(module.exports, "default", () => $8c7f6dda98e8cb9c$export$2e2bcd8739ae039);
/**
 * @module ol/style/Style
 */ 
var $4Cz58 = parcelRequire("4Cz58");

var $wnhPR = parcelRequire("wnhPR");

var $inIMS = parcelRequire("inIMS");

var $lrKvI = parcelRequire("lrKvI");
/**
 * Defines how symbols and text are decluttered on layers ith `declutter` set to `true`
 * **declutter**: Overlapping symbols and text are decluttered.
 * **obstacle**: Symbols and text are rendered, but serve as obstacle for subsequent attempts
 *   to place a symbol or text at the same location.
 * **none**: No decluttering is done.
 *
 * @typedef {"declutter"|"obstacle"|"none"} DeclutterMode
 */ /**
 * A function that takes a {@link module:ol/Feature~Feature} and a `{number}`
 * representing the view's resolution. The function should return a
 * {@link module:ol/style/Style~Style} or an array of them. This way e.g. a
 * vector layer can be styled. If the function returns `undefined`, the
 * feature will not be rendered.
 *
 * @typedef {function(import("../Feature.js").FeatureLike, number):(Style|Array<Style>|void)} StyleFunction
 */ /**
 * A {@link Style}, an array of {@link Style}, or a {@link StyleFunction}.
 * @typedef {Style|Array<Style>|StyleFunction} StyleLike
 */ /**
 * A function that takes a {@link module:ol/Feature~Feature} as argument and returns an
 * {@link module:ol/geom/Geometry~Geometry} that will be rendered and styled for the feature.
 *
 * @typedef {function(import("../Feature.js").FeatureLike):
 *     (import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined)} GeometryFunction
 */ /**
 * Custom renderer function. Takes two arguments:
 *
 * 1. The pixel coordinates of the geometry in GeoJSON notation.
 * 2. The {@link module:ol/render~State} of the layer renderer.
 *
 * @typedef {function((import("../coordinate.js").Coordinate|Array<import("../coordinate.js").Coordinate>|Array<Array<import("../coordinate.js").Coordinate>>|Array<Array<Array<import("../coordinate.js").Coordinate>>>),import("../render.js").State): void} RenderFunction
 */ /**
 * @typedef {Object} Options
 * @property {string|import("../geom/Geometry.js").default|GeometryFunction} [geometry] Feature property or geometry
 * or function returning a geometry to render for this style.
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {import("./Image.js").default} [image] Image style.
 * @property {RenderFunction} [renderer] Custom renderer. When configured, `fill`, `stroke` and `image` will be
 * ignored, and the provided function will be called with each render frame for each geometry.
 * @property {RenderFunction} [hitDetectionRenderer] Custom renderer for hit detection. If provided will be used
 * in hit detection rendering.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Text.js").default} [text] Text style.
 * @property {number} [zIndex] Z index.
 */ /**
 * @classdesc
 * Container for vector feature rendering styles. Any changes made to the style
 * or its children through `set*()` methods will not take effect until the
 * feature or layer that uses the style is re-rendered.
 *
 * ## Feature styles
 *
 * If no style is defined, the following default style is used:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const fill = new Fill({
 *    color: 'rgba(255,255,255,0.4)',
 *  });
 *  const stroke = new Stroke({
 *    color: '#3399CC',
 *    width: 1.25,
 *  });
 *  const styles = [
 *    new Style({
 *      image: new Circle({
 *        fill: fill,
 *        stroke: stroke,
 *        radius: 5,
 *      }),
 *      fill: fill,
 *      stroke: stroke,
 *    }),
 *  ];
 * ```
 *
 * A separate editing style has the following defaults:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const styles = {};
 *  const white = [255, 255, 255, 1];
 *  const blue = [0, 153, 255, 1];
 *  const width = 3;
 *  styles['Polygon'] = [
 *    new Style({
 *      fill: new Fill({
 *        color: [255, 255, 255, 0.5],
 *      }),
 *    }),
 *  ];
 *  styles['MultiPolygon'] =
 *      styles['Polygon'];
 *  styles['LineString'] = [
 *    new Style({
 *      stroke: new Stroke({
 *        color: white,
 *        width: width + 2,
 *      }),
 *    }),
 *    new Style({
 *      stroke: new Stroke({
 *        color: blue,
 *        width: width,
 *      }),
 *    }),
 *  ];
 *  styles['MultiLineString'] = styles['LineString'];
 *
 *  styles['Circle'] = styles['Polygon'].concat(
 *    styles['LineString']
 *  );
 *
 *  styles['Point'] = [
 *    new Style({
 *      image: new Circle({
 *        radius: width * 2,
 *        fill: new Fill({
 *          color: blue,
 *        }),
 *        stroke: new Stroke({
 *          color: white,
 *          width: width / 2,
 *        }),
 *      }),
 *      zIndex: Infinity,
 *    }),
 *  ];
 *  styles['MultiPoint'] =
 *      styles['Point'];
 *  styles['GeometryCollection'] =
 *      styles['Polygon'].concat(
 *          styles['LineString'],
 *          styles['Point']
 *      );
 * ```
 *
 * @api
 */ class $8c7f6dda98e8cb9c$var$Style {
    /**
   * @param {Options} [options] Style options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|import("../geom/Geometry.js").default|GeometryFunction|null}
     */ this.geometry_ = null;
        /**
     * @private
     * @type {!GeometryFunction}
     */ this.geometryFunction_ = $8c7f6dda98e8cb9c$var$defaultGeometryFunction;
        if (options.geometry !== undefined) this.setGeometry(options.geometry);
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {import("./Image.js").default|null}
     */ this.image_ = options.image !== undefined ? options.image : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.renderer_ = options.renderer !== undefined ? options.renderer : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.hitDetectionRenderer_ = options.hitDetectionRenderer !== undefined ? options.hitDetectionRenderer : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("./Text.js").default|null}
     */ this.text_ = options.text !== undefined ? options.text : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.zIndex_ = options.zIndex;
    }
    /**
   * Clones the style.
   * @return {Style} The cloned style.
   * @api
   */ clone() {
        let geometry = this.getGeometry();
        if (geometry && typeof geometry === 'object') geometry = /** @type {import("../geom/Geometry.js").default} */ geometry.clone();
        return new $8c7f6dda98e8cb9c$var$Style({
            geometry: geometry ?? undefined,
            fill: this.getFill() ? this.getFill().clone() : undefined,
            image: this.getImage() ? this.getImage().clone() : undefined,
            renderer: this.getRenderer() ?? undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            text: this.getText() ? this.getText().clone() : undefined,
            zIndex: this.getZIndex()
        });
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setRenderer} or the `renderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Sets a custom renderer function for this style. When set, `fill`, `stroke`
   * and `image` options of the style will be ignored.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setRenderer(renderer) {
        this.renderer_ = renderer;
    }
    /**
   * Sets a custom renderer function for this style used
   * in hit detection.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setHitDetectionRenderer(renderer) {
        this.hitDetectionRenderer_ = renderer;
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setHitDetectionRenderer} or the `hitDetectionRenderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getHitDetectionRenderer() {
        return this.hitDetectionRenderer_;
    }
    /**
   * Get the geometry to be rendered.
   * @return {string|import("../geom/Geometry.js").default|GeometryFunction|null}
   * Feature property or geometry or function that returns the geometry that will
   * be rendered with this style.
   * @api
   */ getGeometry() {
        return this.geometry_;
    }
    /**
   * Get the function used to generate a geometry for rendering.
   * @return {!GeometryFunction} Function that is called with a feature
   * and returns the geometry to render instead of the feature's geometry.
   * @api
   */ getGeometryFunction() {
        return this.geometryFunction_;
    }
    /**
   * Get the fill style.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Get the image style.
   * @return {import("./Image.js").default|null} Image style.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Set the image style.
   * @param {import("./Image.js").default} image Image style.
   * @api
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * Get the stroke style.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Get the text style.
   * @return {import("./Text.js").default|null} Text style.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Set the text style.
   * @param {import("./Text.js").default} text Text style.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Get the z-index for the style.
   * @return {number|undefined} ZIndex.
   * @api
   */ getZIndex() {
        return this.zIndex_;
    }
    /**
   * Set a geometry that is rendered instead of the feature's geometry.
   *
   * @param {string|import("../geom/Geometry.js").default|GeometryFunction|null} geometry
   *     Feature property or geometry or function returning a geometry to render
   *     for this style.
   * @api
   */ setGeometry(geometry) {
        if (typeof geometry === 'function') this.geometryFunction_ = geometry;
        else if (typeof geometry === 'string') this.geometryFunction_ = function(feature) {
            return /** @type {import("../geom/Geometry.js").default} */ feature.get(geometry);
        };
        else if (!geometry) this.geometryFunction_ = $8c7f6dda98e8cb9c$var$defaultGeometryFunction;
        else if (geometry !== undefined) this.geometryFunction_ = function() {
            return /** @type {import("../geom/Geometry.js").default} */ geometry;
        };
        this.geometry_ = geometry;
    }
    /**
   * Set the z-index.
   *
   * @param {number|undefined} zIndex ZIndex.
   * @api
   */ setZIndex(zIndex) {
        this.zIndex_ = zIndex;
    }
}
function $8c7f6dda98e8cb9c$export$c314ea3f6b164147(obj) {
    let styleFunction;
    if (typeof obj === 'function') styleFunction = obj;
    else {
        /**
     * @type {Array<Style>}
     */ let styles;
        if (Array.isArray(obj)) styles = obj;
        else {
            (0, $4Cz58.assert)(typeof /** @type {?} */ obj.getZIndex === 'function', 'Expected an `Style` or an array of `Style`');
            const style = /** @type {Style} */ obj;
            styles = [
                style
            ];
        }
        styleFunction = function() {
            return styles;
        };
    }
    return styleFunction;
}
/**
 * @type {Array<Style>|null}
 */ let $8c7f6dda98e8cb9c$var$defaultStyles = null;
function $8c7f6dda98e8cb9c$export$6865c5ac2f5ce8b6(feature, resolution) {
    // We don't use an immediately-invoked function
    // and a closure so we don't get an error at script evaluation time in
    // browsers that do not support Canvas. (import("./Circle.js").CircleStyle does
    // canvas.getContext('2d') at construction time, which will cause an.error
    // in such browsers.)
    if (!$8c7f6dda98e8cb9c$var$defaultStyles) {
        const fill = new (0, $inIMS.default)({
            color: 'rgba(255,255,255,0.4)'
        });
        const stroke = new (0, $lrKvI.default)({
            color: '#3399CC',
            width: 1.25
        });
        $8c7f6dda98e8cb9c$var$defaultStyles = [
            new $8c7f6dda98e8cb9c$var$Style({
                image: new (0, $wnhPR.default)({
                    fill: fill,
                    stroke: stroke,
                    radius: 5
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    return $8c7f6dda98e8cb9c$var$defaultStyles;
}
function $8c7f6dda98e8cb9c$export$ed1eaede5d0e77ac() {
    /** @type {Object<import("../geom/Geometry.js").Type, Array<Style>>} */ const styles = {};
    const white = [
        255,
        255,
        255,
        1
    ];
    const blue = [
        0,
        153,
        255,
        1
    ];
    const width = 3;
    styles['Polygon'] = [
        new $8c7f6dda98e8cb9c$var$Style({
            fill: new (0, $inIMS.default)({
                color: [
                    255,
                    255,
                    255,
                    0.5
                ]
            })
        })
    ];
    styles['MultiPolygon'] = styles['Polygon'];
    styles['LineString'] = [
        new $8c7f6dda98e8cb9c$var$Style({
            stroke: new (0, $lrKvI.default)({
                color: white,
                width: width + 2
            })
        }),
        new $8c7f6dda98e8cb9c$var$Style({
            stroke: new (0, $lrKvI.default)({
                color: blue,
                width: width
            })
        })
    ];
    styles['MultiLineString'] = styles['LineString'];
    styles['Circle'] = styles['Polygon'].concat(styles['LineString']);
    styles['Point'] = [
        new $8c7f6dda98e8cb9c$var$Style({
            image: new (0, $wnhPR.default)({
                radius: width * 2,
                fill: new (0, $inIMS.default)({
                    color: blue
                }),
                stroke: new (0, $lrKvI.default)({
                    color: white,
                    width: width / 2
                })
            }),
            zIndex: Infinity
        })
    ];
    styles['MultiPoint'] = styles['Point'];
    styles['GeometryCollection'] = styles['Polygon'].concat(styles['LineString'], styles['Point']);
    return styles;
}
/**
 * Function that is called with a feature and returns its default geometry.
 * @param {import("../Feature.js").FeatureLike} feature Feature to get the geometry for.
 * @return {import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined} Geometry to render.
 */ function $8c7f6dda98e8cb9c$var$defaultGeometryFunction(feature) {
    return feature.getGeometry();
}
var $8c7f6dda98e8cb9c$export$2e2bcd8739ae039 = $8c7f6dda98e8cb9c$var$Style;

});

parcelRegister("cJntk", function(module, exports) {

$parcel$export(module.exports, "default", () => $944be50faeff5321$export$2e2bcd8739ae039);
/**
 * @module ol/style/Text
 */ 
var $hxhPO = parcelRequire("hxhPO");

var $inIMS = parcelRequire("inIMS");
/**
 * @typedef {'point' | 'line'} TextPlacement
 * Default text placement is `'point'`. Note that
 * `'line'` requires the underlying geometry to be a {@link module:ol/geom/LineString~LineString},
 * {@link module:ol/geom/Polygon~Polygon}, {@link module:ol/geom/MultiLineString~MultiLineString} or
 * {@link module:ol/geom/MultiPolygon~MultiPolygon}.
 */ /**
 * @typedef {'left' | 'center' | 'right'} TextJustify
 */ /**
 * The default fill color to use if no fill was set at construction time; a
 * blackish `#333`.
 *
 * @const {string}
 */ const $944be50faeff5321$var$DEFAULT_FILL_COLOR = '#333';
/**
 * @typedef {Object} Options
 * @property {string} [font] Font style as CSS `font` value, see:
 * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/font. Default is `'10px sans-serif'`
 * @property {number} [maxAngle=Math.PI/4] When `placement` is set to `'line'`, allow a maximum angle between adjacent characters.
 * The expected value is in radians, and the default is 45° (`Math.PI / 4`).
 * @property {number} [offsetX=0] Horizontal text offset in pixels. A positive will shift the text right.
 * @property {number} [offsetY=0] Vertical text offset in pixels. A positive will shift the text down.
 * @property {boolean} [overflow=false] For polygon labels or when `placement` is set to `'line'`, allow text to exceed
 * the width of the polygon at the label position or the length of the path that it follows.
 * @property {TextPlacement} [placement='point'] Text placement.
 * @property {number} [repeat] Repeat interval. When set, the text will be repeated at this interval, which specifies
 * the distance between two text anchors in pixels. Only available when `placement` is set to `'line'`. Overrides 'textAlign'.
 * @property {number|import("../size.js").Size} [scale] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the text with the view.
 * @property {boolean} [keepUpright=true] Whether the text can be rotated 180° to prevent being rendered upside down.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {string|Array<string>} [text] Text content or rich text content. For plain text provide a string, which can
 * contain line breaks (`\n`). For rich text provide an array of text/font tuples. A tuple consists of the text to
 * render and the font to use (or `''` to use the text style's font). A line break has to be a separate tuple (i.e. `'\n', ''`).
 * **Example:** `['foo', 'bold 10px sans-serif', ' bar', 'italic 10px sans-serif', ' baz', '']` will yield "**foo** *bar* baz".
 * **Note:** Rich text is not supported for `placement: 'line'` or the immediate rendering API.
 * @property {CanvasTextAlign} [textAlign] Text alignment. Possible values: `'left'`, `'right'`, `'center'`, `'end'` or `'start'`.
 * Default is `'center'` for `placement: 'point'`. For `placement: 'line'`, the default is to let the renderer choose a
 * placement where `maxAngle` is not exceeded.
 * @property {TextJustify} [justify] Text justification within the text box.
 * If not set, text is justified towards the `textAlign` anchor.
 * Otherwise, use options `'left'`, `'center'`, or `'right'` to justify the text within the text box.
 * **Note:** `justify` is ignored for immediate rendering and also for `placement: 'line'`.
 * @property {CanvasTextBaseline} [textBaseline='middle'] Text base line. Possible values: `'bottom'`, `'top'`, `'middle'`, `'alphabetic'`,
 * `'hanging'`, `'ideographic'`.
 * @property {import("./Fill.js").default|null} [fill] Fill style. If none is provided, we'll use a dark fill-style (#333). Specify `null` for no fill.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Fill.js").default} [backgroundFill] Fill style for the text background when `placement` is
 * `'point'`. Default is no fill.
 * @property {import("./Stroke.js").default} [backgroundStroke] Stroke style for the text background  when `placement`
 * is `'point'`. Default is no stroke.
 * @property {Array<number>} [padding=[0, 0, 0, 0]] Padding in pixels around the text for decluttering and background. The order of
 * values in the array is `[top, right, bottom, left]`.
 * @property {import('../style/Style.js').DeclutterMode} [declutterMode] Declutter mode: `declutter`, `obstacle`, `none`
 */ /**
 * @classdesc
 * Set text style for vector features.
 * @api
 */ class $944be50faeff5321$var$Text {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|undefined}
     */ this.font_ = options.font;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.keepUpright_ = options.keepUpright;
        /**
     * @private
     * @type {number|import("../size.js").Size|undefined}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $hxhPO.toSize)(options.scale !== undefined ? options.scale : 1);
        /**
     * @private
     * @type {string|Array<string>|undefined}
     */ this.text_ = options.text;
        /**
     * @private
     * @type {CanvasTextAlign|undefined}
     */ this.textAlign_ = options.textAlign;
        /**
     * @private
     * @type {TextJustify|undefined}
     */ this.justify_ = options.justify;
        /**
     * @private
     * @type {number|undefined}
     */ this.repeat_ = options.repeat;
        /**
     * @private
     * @type {CanvasTextBaseline|undefined}
     */ this.textBaseline_ = options.textBaseline;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : new (0, $inIMS.default)({
            color: $944be50faeff5321$var$DEFAULT_FILL_COLOR
        });
        /**
     * @private
     * @type {number}
     */ this.maxAngle_ = options.maxAngle !== undefined ? options.maxAngle : Math.PI / 4;
        /**
     * @private
     * @type {TextPlacement}
     */ this.placement_ = options.placement !== undefined ? options.placement : 'point';
        /**
     * @private
     * @type {boolean}
     */ this.overflow_ = !!options.overflow;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {number}
     */ this.offsetX_ = options.offsetX !== undefined ? options.offsetX : 0;
        /**
     * @private
     * @type {number}
     */ this.offsetY_ = options.offsetY !== undefined ? options.offsetY : 0;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.backgroundFill_ = options.backgroundFill ? options.backgroundFill : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.backgroundStroke_ = options.backgroundStroke ? options.backgroundStroke : null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.padding_ = options.padding === undefined ? null : options.padding;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {Text} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new $944be50faeff5321$var$Text({
            font: this.getFont(),
            placement: this.getPlacement(),
            repeat: this.getRepeat(),
            maxAngle: this.getMaxAngle(),
            overflow: this.getOverflow(),
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            keepUpright: this.getKeepUpright(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            text: this.getText(),
            textAlign: this.getTextAlign(),
            justify: this.getJustify(),
            textBaseline: this.getTextBaseline(),
            fill: this.getFill() instanceof (0, $inIMS.default) ? this.getFill().clone() : this.getFill(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            offsetX: this.getOffsetX(),
            offsetY: this.getOffsetY(),
            backgroundFill: this.getBackgroundFill() ? this.getBackgroundFill().clone() : undefined,
            backgroundStroke: this.getBackgroundStroke() ? this.getBackgroundStroke().clone() : undefined,
            padding: this.getPadding() || undefined,
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the `overflow` configuration.
   * @return {boolean} Let text overflow the length of the path they follow.
   * @api
   */ getOverflow() {
        return this.overflow_;
    }
    /**
   * Get the font name.
   * @return {string|undefined} Font.
   * @api
   */ getFont() {
        return this.font_;
    }
    /**
   * Get the maximum angle between adjacent characters.
   * @return {number} Angle in radians.
   * @api
   */ getMaxAngle() {
        return this.maxAngle_;
    }
    /**
   * Get the label placement.
   * @return {TextPlacement} Text placement.
   * @api
   */ getPlacement() {
        return this.placement_;
    }
    /**
   * Get the repeat interval of the text.
   * @return {number|undefined} Repeat interval in pixels.
   * @api
   */ getRepeat() {
        return this.repeat_;
    }
    /**
   * Get the x-offset for the text.
   * @return {number} Horizontal text offset.
   * @api
   */ getOffsetX() {
        return this.offsetX_;
    }
    /**
   * Get the y-offset for the text.
   * @return {number} Vertical text offset.
   * @api
   */ getOffsetY() {
        return this.offsetY_;
    }
    /**
   * Get the fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Determine whether the text rotates with the map.
   * @return {boolean|undefined} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Determine whether the text can be rendered upside down.
   * @return {boolean|undefined} Keep text upright.
   * @api
   */ getKeepUpright() {
        return this.keepUpright_;
    }
    /**
   * Get the text rotation.
   * @return {number|undefined} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the text scale.
   * @return {number|import("../size.js").Size|undefined} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Get the text to be rendered.
   * @return {string|Array<string>|undefined} Text.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Get the text alignment.
   * @return {CanvasTextAlign|undefined} Text align.
   * @api
   */ getTextAlign() {
        return this.textAlign_;
    }
    /**
   * Get the justification.
   * @return {TextJustify|undefined} Justification.
   * @api
   */ getJustify() {
        return this.justify_;
    }
    /**
   * Get the text baseline.
   * @return {CanvasTextBaseline|undefined} Text baseline.
   * @api
   */ getTextBaseline() {
        return this.textBaseline_;
    }
    /**
   * Get the background fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getBackgroundFill() {
        return this.backgroundFill_;
    }
    /**
   * Get the background stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getBackgroundStroke() {
        return this.backgroundStroke_;
    }
    /**
   * Get the padding for the text.
   * @return {Array<number>|null} Padding.
   * @api
   */ getPadding() {
        return this.padding_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Set the `overflow` property.
   *
   * @param {boolean} overflow Let text overflow the path that it follows.
   * @api
   */ setOverflow(overflow) {
        this.overflow_ = overflow;
    }
    /**
   * Set the font.
   *
   * @param {string|undefined} font Font.
   * @api
   */ setFont(font) {
        this.font_ = font;
    }
    /**
   * Set the maximum angle between adjacent characters.
   *
   * @param {number} maxAngle Angle in radians.
   * @api
   */ setMaxAngle(maxAngle) {
        this.maxAngle_ = maxAngle;
    }
    /**
   * Set the x offset.
   *
   * @param {number} offsetX Horizontal text offset.
   * @api
   */ setOffsetX(offsetX) {
        this.offsetX_ = offsetX;
    }
    /**
   * Set the y offset.
   *
   * @param {number} offsetY Vertical text offset.
   * @api
   */ setOffsetY(offsetY) {
        this.offsetY_ = offsetY;
    }
    /**
   * Set the text placement.
   *
   * @param {TextPlacement} placement Placement.
   * @api
   */ setPlacement(placement) {
        this.placement_ = placement;
    }
    /**
   * Set the repeat interval of the text.
   * @param {number|undefined} [repeat] Repeat interval in pixels.
   * @api
   */ setRepeat(repeat) {
        this.repeat_ = repeat;
    }
    /**
   * Set whether to rotate the text with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set whether the text can be rendered upside down.
   *
   * @param {boolean} keepUpright Keep text upright.
   * @api
   */ setKeepUpright(keepUpright) {
        this.keepUpright_ = keepUpright;
    }
    /**
   * Set the fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Set the rotation.
   *
   * @param {number|undefined} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size|undefined} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $hxhPO.toSize)(scale !== undefined ? scale : 1);
    }
    /**
   * Set the stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Set the text.
   *
   * @param {string|Array<string>|undefined} text Text.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Set the text alignment.
   *
   * @param {CanvasTextAlign|undefined} textAlign Text align.
   * @api
   */ setTextAlign(textAlign) {
        this.textAlign_ = textAlign;
    }
    /**
   * Set the justification.
   *
   * @param {TextJustify|undefined} justify Justification.
   * @api
   */ setJustify(justify) {
        this.justify_ = justify;
    }
    /**
   * Set the text baseline.
   *
   * @param {CanvasTextBaseline|undefined} textBaseline Text baseline.
   * @api
   */ setTextBaseline(textBaseline) {
        this.textBaseline_ = textBaseline;
    }
    /**
   * Set the background fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setBackgroundFill(fill) {
        this.backgroundFill_ = fill;
    }
    /**
   * Set the background stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setBackgroundStroke(stroke) {
        this.backgroundStroke_ = stroke;
    }
    /**
   * Set the padding (`[top, right, bottom, left]`).
   *
   * @param {Array<number>|null} padding Padding.
   * @api
   */ setPadding(padding) {
        this.padding_ = padding;
    }
}
var $944be50faeff5321$export$2e2bcd8739ae039 = $944be50faeff5321$var$Text;

});



parcelRegister("fp9DL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b370ab32454a96fd$export$2e2bcd8739ae039);
/**
 * @module ol/renderer/Map
 */ 
var $4kyFN = parcelRequire("4kyFN");

var $2o3CH = parcelRequire("2o3CH");

var $9pD6L = parcelRequire("9pD6L");

var $6wUzV = parcelRequire("6wUzV");

var $79s7T = parcelRequire("79s7T");

var $kTbud = parcelRequire("kTbud");

var $jpXrt = parcelRequire("jpXrt");

var $9iPUS = parcelRequire("9iPUS");
/**
 * @template T
 * @typedef HitMatch
 * @property {import("../Feature.js").FeatureLike} feature Feature.
 * @property {import("../layer/Layer.js").default} layer Layer.
 * @property {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} distanceSq Squared distance.
 * @property {import("./vector.js").FeatureCallback<T>} callback Callback.
 */ /**
 * @abstract
 */ class $b370ab32454a96fd$var$MapRenderer extends (0, $4kyFN.default) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super();
        /**
     * @private
     * @type {import("../Map.js").default}
     */ this.map_ = map;
    }
    /**
   * @abstract
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ dispatchRenderEvent(type, frameState) {
        (0, $9iPUS.abstract)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @protected
   */ calculateMatrices2D(frameState) {
        const viewState = frameState.viewState;
        const coordinateToPixelTransform = frameState.coordinateToPixelTransform;
        const pixelToCoordinateTransform = frameState.pixelToCoordinateTransform;
        (0, $jpXrt.compose)(coordinateToPixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / viewState.resolution, -1 / viewState.resolution, -viewState.rotation, -viewState.center[0], -viewState.center[1]);
        (0, $jpXrt.makeInverse)(pixelToCoordinateTransform, coordinateToPixelTransform);
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {S} thisArg Value to use as `this` when executing `callback`.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
   * @return {T|undefined} Callback result.
   * @template S,T,U
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, callback, thisArg, layerFilter, thisArg2) {
        let result;
        const viewState = frameState.viewState;
        /**
     * @param {boolean} managed Managed layer.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @param {import("../layer/Layer.js").default} layer Layer.
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @return {T|undefined} Callback result.
     */ function forEachFeatureAtCoordinate(managed, feature, layer, geometry) {
            return callback.call(thisArg, feature, managed ? layer : null, geometry);
        }
        const projection = viewState.projection;
        const translatedCoordinate = (0, $2o3CH.wrapX)(coordinate.slice(), projection);
        const offsets = [
            [
                0,
                0
            ]
        ];
        if (projection.canWrapX() && checkWrapped) {
            const projectionExtent = projection.getExtent();
            const worldWidth = (0, $9pD6L.getWidth)(projectionExtent);
            offsets.push([
                -worldWidth,
                0
            ], [
                worldWidth,
                0
            ]);
        }
        const layerStates = frameState.layerStatesArray;
        const numLayers = layerStates.length;
        const matches = /** @type {Array<HitMatch<T>>} */ [];
        const tmpCoord = [];
        for(let i = 0; i < offsets.length; i++)for(let j = numLayers - 1; j >= 0; --j){
            const layerState = layerStates[j];
            const layer = layerState.layer;
            if (layer.hasRenderer() && (0, $79s7T.inView)(layerState, viewState) && layerFilter.call(thisArg2, layer)) {
                const layerRenderer = layer.getRenderer();
                const source = layer.getSource();
                if (layerRenderer && source) {
                    const coordinates = source.getWrapX() ? translatedCoordinate : coordinate;
                    const callback = forEachFeatureAtCoordinate.bind(null, layerState.managed);
                    tmpCoord[0] = coordinates[0] + offsets[i][0];
                    tmpCoord[1] = coordinates[1] + offsets[i][1];
                    result = layerRenderer.forEachFeatureAtCoordinate(tmpCoord, frameState, hitTolerance, callback, matches);
                }
                if (result) return result;
            }
        }
        if (matches.length === 0) return undefined;
        const order = 1 / matches.length;
        matches.forEach((m, i)=>m.distanceSq += i * order);
        matches.sort((a, b)=>a.distanceSq - b.distanceSq);
        matches.some((m)=>{
            return result = m.callback(m.feature, m.layer, m.geometry);
        });
        return result;
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
   * @return {boolean} Is there a feature at the given coordinate?
   * @template U
   */ hasFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, layerFilter, thisArg) {
        const hasFeature = this.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, (0, $6wUzV.TRUE), this, layerFilter, thisArg);
        return hasFeature !== undefined;
    }
    /**
   * @return {import("../Map.js").default} Map.
   */ getMap() {
        return this.map_;
    }
    /**
   * Render.
   * @abstract
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ renderFrame(frameState) {
        (0, $9iPUS.abstract)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @protected
   */ scheduleExpireIconCache(frameState) {
        if ((0, $kTbud.shared).canExpireCache()) frameState.postRenderFunctions.push($b370ab32454a96fd$var$expireIconCache);
    }
}
/**
 * @param {import("../Map.js").default} map Map.
 * @param {import("../Map.js").FrameState} frameState Frame state.
 */ function $b370ab32454a96fd$var$expireIconCache(map, frameState) {
    (0, $kTbud.shared).expire();
}
var $b370ab32454a96fd$export$2e2bcd8739ae039 = $b370ab32454a96fd$var$MapRenderer;

});



parcelRegister("4mWlF", function(module, exports) {

$parcel$export(module.exports, "default", () => $32e67a4d3559554a$export$2e2bcd8739ae039);
/**
 * @module ol/layer/Tile
 */ 
var $fY4eB = parcelRequire("fY4eB");

var $cGqMj = parcelRequire("cGqMj");
/**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} [TileSourceType=import("../source/Tile.js").default]
 * @extends BaseTileLayer<TileSourceType, CanvasTileLayerRenderer>
 * @api
 */ class $32e67a4d3559554a$var$TileLayer extends (0, $cGqMj.default) {
    /**
   * @param {import("./BaseTile.js").Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $fY4eB.default)(this, {
            cacheSize: this.getCacheSize()
        });
    }
}
var $32e67a4d3559554a$export$2e2bcd8739ae039 = $32e67a4d3559554a$var$TileLayer;

});
parcelRegister("fY4eB", function(module, exports) {

$parcel$export(module.exports, "default", () => $02fffef185f4339b$export$2e2bcd8739ae039);
/**
 * @module ol/renderer/canvas/TileLayer
 */ 
var $lKpkL = parcelRequire("lKpkL");

var $hCs6p = parcelRequire("hCs6p");

var $7iKy2 = parcelRequire("7iKy2");

var $fOhwi = parcelRequire("fOhwi");

var $fVVyM = parcelRequire("fVVyM");

var $9pD6L = parcelRequire("9pD6L");

var $dpRHA = parcelRequire("dpRHA");

var $4WmJ3 = parcelRequire("4WmJ3");

var $hxhPO = parcelRequire("hxhPO");

var $btbc6 = parcelRequire("btbc6");

var $gpyQY = parcelRequire("gpyQY");

var $jpXrt = parcelRequire("jpXrt");

var $9iPUS = parcelRequire("9iPUS");

var $5FKVH = parcelRequire("5FKVH");
/**
 * @typedef {Object<number, Set<import("../../Tile.js").default>>} TileLookup
 */ /**
 * Add a tile to the lookup.
 * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
 * @param {import("../../Tile.js").default} tile A tile.
 * @param {number} z The zoom level.
 * @return {boolean} The tile was added to the lookup.
 */ function $02fffef185f4339b$var$addTileToLookup(tilesByZ, tile, z) {
    if (!(z in tilesByZ)) {
        tilesByZ[z] = new Set([
            tile
        ]);
        return true;
    }
    const set = tilesByZ[z];
    const existing = set.has(tile);
    if (!existing) set.add(tile);
    return !existing;
}
/**
 * Remove a tile from the lookup.
 * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
 * @param {import("../../Tile.js").default} tile A tile.
 * @param {number} z The zoom level.
 * @return {boolean} The tile was removed from the lookup.
 */ function $02fffef185f4339b$var$removeTileFromLookup(tilesByZ, tile, z) {
    const set = tilesByZ[z];
    if (set) return set.delete(tile);
    return false;
}
/**
 * @param {import("../../Map.js").FrameState} frameState Frame state.
 * @param {import("../../extent.js").Extent} extent The frame extent.
 * @return {import("../../extent.js").Extent} Frame extent intersected with layer extents.
 */ function $02fffef185f4339b$var$getRenderExtent(frameState, extent) {
    const layerState = frameState.layerStatesArray[frameState.layerIndex];
    if (layerState.extent) extent = (0, $9pD6L.getIntersection)(extent, (0, $dpRHA.fromUserExtent)(layerState.extent, frameState.viewState.projection));
    const source = /** @type {import("../../source/Tile.js").default} */ layerState.layer.getRenderSource();
    if (!source.getWrapX()) {
        const gridExtent = source.getTileGridForProjection(frameState.viewState.projection).getExtent();
        if (gridExtent) extent = (0, $9pD6L.getIntersection)(extent, gridExtent);
    }
    return extent;
}
/**
 * @typedef {Object} Options
 * @property {number} [cacheSize=512] The cache size.
 */ /**
 * @classdesc
 * Canvas renderer for tile layers.
 * @api
 * @template {import("../../layer/Tile.js").default|import("../../layer/VectorTile.js").default} [LayerType=import("../../layer/Tile.js").default<import("../../source/Tile.js").default>|import("../../layer/VectorTile.js").default]
 * @extends {CanvasLayerRenderer<LayerType>}
 */ class $02fffef185f4339b$var$CanvasTileLayerRenderer extends (0, $5FKVH.default) {
    /**
   * @param {LayerType} tileLayer Tile layer.
   * @param {Options} [options] Options.
   */ constructor(tileLayer, options){
        super(tileLayer);
        options = options || {};
        /**
     * Rendered extent has changed since the previous `renderFrame()` call
     * @type {boolean}
     */ this.extentChanged = true;
        /**
     * The last call to `renderFrame` was completed with all tiles loaded
     * @type {boolean}
     */ this.renderComplete = false;
        /**
     * @private
     * @type {?import("../../extent.js").Extent}
     */ this.renderedExtent_ = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedPixelRatio;
        /**
     * @protected
     * @type {import("../../proj/Projection.js").default|null}
     */ this.renderedProjection = null;
        /**
     * @protected
     * @type {!Array<import("../../Tile.js").default>}
     */ this.renderedTiles = [];
        /**
     * @private
     * @type {string}
     */ this.renderedSourceKey_;
        /**
     * @private
     * @type {number}
     */ this.renderedSourceRevision_;
        /**
     * @protected
     * @type {import("../../extent.js").Extent}
     */ this.tempExtent = (0, $9pD6L.createEmpty)();
        /**
     * @private
     * @type {import("../../TileRange.js").default}
     */ this.tempTileRange_ = new (0, $7iKy2.default)(0, 0, 0, 0);
        /**
     * @type {import("../../tilecoord.js").TileCoord}
     * @private
     */ this.tempTileCoord_ = (0, $gpyQY.createOrUpdate)(0, 0, 0);
        const cacheSize = options.cacheSize !== undefined ? options.cacheSize : 512;
        /**
     * @type {import("../../structs/LRUCache.js").default<import("../../Tile.js").default>}
     * @private
     */ this.tileCache_ = new (0, $btbc6.default)(cacheSize);
        /**
     * @type {import("../../structs/LRUCache.js").default<import("../../Tile.js").default|null>}
     * @private
     */ this.sourceTileCache_ = null;
        this.maxStaleKeys = cacheSize * 0.5;
    }
    /**
   * @return {LRUCache} Tile cache.
   */ getTileCache() {
        return this.tileCache_;
    }
    /**
   * @return {LRUCache} Tile cache.
   */ getSourceTileCache() {
        if (!this.sourceTileCache_) this.sourceTileCache_ = new (0, $btbc6.default)(512);
        return this.sourceTileCache_;
    }
    /**
   * Get a tile from the cache or create one if needed.
   *
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @protected
   */ getOrCreateTile(z, x, y, frameState) {
        const tileCache = this.tileCache_;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        const cacheKey = (0, $gpyQY.getCacheKey)(tileSource, tileSource.getKey(), z, x, y);
        /** @type {import("../../Tile.js").default} */ let tile;
        if (tileCache.containsKey(cacheKey)) tile = tileCache.get(cacheKey);
        else {
            const projection = frameState.viewState.projection;
            const sourceProjection = tileSource.getProjection();
            tile = tileSource.getTile(z, x, y, frameState.pixelRatio, projection, !sourceProjection || (0, $dpRHA.equivalent)(sourceProjection, projection) ? undefined : this.getSourceTileCache());
            if (!tile) return null;
            tileCache.set(cacheKey, tile);
        }
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @protected
   */ getTile(z, x, y, frameState) {
        const tile = this.getOrCreateTile(z, x, y, frameState);
        if (!tile) return null;
        return tile;
    }
    /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray} Data at the pixel location.
   * @override
   */ getData(pixel) {
        const frameState = this.frameState;
        if (!frameState) return null;
        const layer = this.getLayer();
        const coordinate = (0, $jpXrt.apply)(frameState.pixelToCoordinateTransform, pixel.slice());
        const layerExtent = layer.getExtent();
        if (layerExtent) {
            if (!(0, $9pD6L.containsCoordinate)(layerExtent, coordinate)) return null;
        }
        const viewState = frameState.viewState;
        const source = layer.getRenderSource();
        const tileGrid = source.getTileGridForProjection(viewState.projection);
        const tilePixelRatio = source.getTilePixelRatio(frameState.pixelRatio);
        for(let z = tileGrid.getZForResolution(viewState.resolution); z >= tileGrid.getMinZoom(); --z){
            const tileCoord = tileGrid.getTileCoordForCoordAndZ(coordinate, z);
            const tile = this.getTile(z, tileCoord[1], tileCoord[2], frameState);
            if (!tile || tile.getState() !== (0, $fOhwi.default).LOADED) continue;
            const tileOrigin = tileGrid.getOrigin(z);
            const tileSize = (0, $hxhPO.toSize)(tileGrid.getTileSize(z));
            const tileResolution = tileGrid.getResolution(z);
            /**
       * @type {import('../../DataTile.js').ImageLike}
       */ let image;
            if (tile instanceof (0, $hCs6p.default) || tile instanceof (0, $4WmJ3.default)) image = tile.getImage();
            else if (tile instanceof (0, $lKpkL.default)) {
                image = (0, $lKpkL.asImageLike)(tile.getData());
                if (!image) continue;
            } else continue;
            const col = Math.floor(tilePixelRatio * ((coordinate[0] - tileOrigin[0]) / tileResolution - tileCoord[1] * tileSize[0]));
            const row = Math.floor(tilePixelRatio * ((tileOrigin[1] - coordinate[1]) / tileResolution - tileCoord[2] * tileSize[1]));
            const gutter = Math.round(tilePixelRatio * source.getGutterForProjection(viewState.projection));
            return this.getImageData(image, col + gutter, row + gutter);
        }
        return null;
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        if (!this.renderedProjection) this.renderedProjection = frameState.viewState.projection;
        else if (frameState.viewState.projection !== this.renderedProjection) {
            this.tileCache_.clear();
            this.renderedProjection = frameState.viewState.projection;
        }
        const source = this.getLayer().getSource();
        if (!source) return false;
        const sourceRevision = source.getRevision();
        if (!this.renderedSourceRevision_) this.renderedSourceRevision_ = sourceRevision;
        else if (this.renderedSourceRevision_ !== sourceRevision) {
            this.renderedSourceRevision_ = sourceRevision;
            if (this.renderedSourceKey_ === source.getKey()) {
                this.tileCache_.clear();
                this.sourceTileCache_?.clear();
            }
        }
        return true;
    }
    /**
   * Determine whether tiles for next extent should be enqueued for rendering.
   * @return {boolean} Rendering tiles for next extent is supported.
   * @protected
   */ enqueueTilesForNextExtent() {
        return true;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent The extent to be rendered.
   * @param {number} initialZ The zoom level.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @param {number} preload Number of additional levels to load.
   */ enqueueTiles(frameState, extent, initialZ, tilesByZ, preload) {
        const viewState = frameState.viewState;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getRenderSource();
        const tileGrid = tileSource.getTileGridForProjection(viewState.projection);
        const tileSourceKey = (0, $9iPUS.getUid)(tileSource);
        if (!(tileSourceKey in frameState.wantedTiles)) frameState.wantedTiles[tileSourceKey] = {};
        const wantedTiles = frameState.wantedTiles[tileSourceKey];
        const map = tileLayer.getMapInternal();
        const minZ = Math.max(initialZ - preload, tileGrid.getMinZoom(), tileGrid.getZForResolution(Math.min(tileLayer.getMaxResolution(), map ? map.getView().getResolutionForZoom(Math.max(tileLayer.getMinZoom(), 0)) : tileGrid.getResolution(0)), tileSource.zDirection));
        const rotation = viewState.rotation;
        const viewport = rotation ? (0, $9pD6L.getRotatedViewport)(viewState.center, viewState.resolution, rotation, frameState.size) : undefined;
        for(let z = initialZ; z >= minZ; --z){
            const tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, this.tempTileRange_);
            const tileResolution = tileGrid.getResolution(z);
            for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
                if (rotation && !tileGrid.tileCoordIntersectsViewport([
                    z,
                    x,
                    y
                ], viewport)) continue;
                const tile = this.getTile(z, x, y, frameState);
                if (!tile) continue;
                const added = $02fffef185f4339b$var$addTileToLookup(tilesByZ, tile, z);
                if (!added) continue;
                const tileQueueKey = tile.getKey();
                wantedTiles[tileQueueKey] = true;
                if (tile.getState() === (0, $fOhwi.default).IDLE) {
                    if (!frameState.tileQueue.isKeyQueued(tileQueueKey)) {
                        const tileCoord = (0, $gpyQY.createOrUpdate)(z, x, y, this.tempTileCoord_);
                        frameState.tileQueue.enqueue([
                            tile,
                            tileSourceKey,
                            tileGrid.getTileCoordCenter(tileCoord),
                            tileResolution
                        ]);
                    }
                }
            }
        }
    }
    /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */ findStaleTile_(tileCoord, tilesByZ) {
        const tileCache = this.tileCache_;
        const z = tileCoord[0];
        const x = tileCoord[1];
        const y = tileCoord[2];
        const staleKeys = this.getStaleKeys();
        for(let i = 0; i < staleKeys.length; ++i){
            const cacheKey = (0, $gpyQY.getCacheKey)(this.getLayer().getSource(), staleKeys[i], z, x, y);
            if (tileCache.containsKey(cacheKey)) {
                const tile = tileCache.peek(cacheKey);
                if (tile.getState() === (0, $fOhwi.default).LOADED) {
                    tile.endTransition((0, $9iPUS.getUid)(this));
                    $02fffef185f4339b$var$addTileToLookup(tilesByZ, tile, z);
                    return true;
                }
            }
        }
        return false;
    }
    /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
   * @param {import("../../tilegrid/TileGrid.js").default} tileGrid The tile grid.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {number} altZ The alternate zoom level.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */ findAltTiles_(tileGrid, tileCoord, altZ, tilesByZ) {
        const tileRange = tileGrid.getTileRangeForTileCoordAndZ(tileCoord, altZ, this.tempTileRange_);
        if (!tileRange) return false;
        let covered = true;
        const tileCache = this.tileCache_;
        const source = this.getLayer().getRenderSource();
        const sourceKey = source.getKey();
        for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
            const cacheKey = (0, $gpyQY.getCacheKey)(source, sourceKey, altZ, x, y);
            let loaded = false;
            if (tileCache.containsKey(cacheKey)) {
                const tile = tileCache.peek(cacheKey);
                if (tile.getState() === (0, $fOhwi.default).LOADED) {
                    $02fffef185f4339b$var$addTileToLookup(tilesByZ, tile, altZ);
                    loaded = true;
                }
            }
            if (!loaded) covered = false;
        }
        return covered;
    }
    /**
   * Render the layer.
   *
   * The frame rendering logic has three parts:
   *
   *  1. Enqueue tiles
   *  2. Find alt tiles for those that are not yet loaded
   *  3. Render loaded tiles
   *
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        this.renderComplete = true;
        /**
     * TODO:
     *  maybe skip transition when not fully opaque
     *  decide if this.renderComplete is useful
     */ const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const viewResolution = viewState.resolution;
        const viewCenter = viewState.center;
        const pixelRatio = frameState.pixelRatio;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        const tileGrid = tileSource.getTileGridForProjection(projection);
        const z = tileGrid.getZForResolution(viewResolution, tileSource.zDirection);
        const tileResolution = tileGrid.getResolution(z);
        const sourceKey = tileSource.getKey();
        if (!this.renderedSourceKey_) this.renderedSourceKey_ = sourceKey;
        else if (this.renderedSourceKey_ !== sourceKey) {
            this.prependStaleKey(this.renderedSourceKey_);
            this.renderedSourceKey_ = sourceKey;
        }
        let frameExtent = frameState.extent;
        const tilePixelRatio = tileSource.getTilePixelRatio(pixelRatio);
        this.prepareContainer(frameState, target);
        // desired dimensions of the canvas in pixels
        const width = this.context.canvas.width;
        const height = this.context.canvas.height;
        const layerExtent = layerState.extent && (0, $dpRHA.fromUserExtent)(layerState.extent, projection);
        if (layerExtent) frameExtent = (0, $9pD6L.getIntersection)(frameExtent, (0, $dpRHA.fromUserExtent)(layerState.extent, projection));
        const dx = tileResolution * width / 2 / tilePixelRatio;
        const dy = tileResolution * height / 2 / tilePixelRatio;
        const canvasExtent = [
            viewCenter[0] - dx,
            viewCenter[1] - dy,
            viewCenter[0] + dx,
            viewCenter[1] + dy
        ];
        /**
     * @type {TileLookup}
     */ const tilesByZ = {};
        this.renderedTiles.length = 0;
        /**
     * Part 1: Enqueue tiles
     */ const preload = tileLayer.getPreload();
        if (frameState.nextExtent && this.enqueueTilesForNextExtent()) {
            const targetZ = tileGrid.getZForResolution(viewState.nextResolution, tileSource.zDirection);
            const nextExtent = $02fffef185f4339b$var$getRenderExtent(frameState, frameState.nextExtent);
            this.enqueueTiles(frameState, nextExtent, targetZ, tilesByZ, preload);
        }
        const renderExtent = $02fffef185f4339b$var$getRenderExtent(frameState, frameExtent);
        this.enqueueTiles(frameState, renderExtent, z, tilesByZ, 0);
        if (preload > 0) setTimeout(()=>{
            this.enqueueTiles(frameState, renderExtent, z - 1, tilesByZ, preload - 1);
        }, 0);
        if (!(z in tilesByZ)) return this.container;
        /**
     * Part 2: Find alt tiles for those that are not yet loaded
     */ const uid = (0, $9iPUS.getUid)(this);
        const time = frameState.time;
        // look for cached tiles to use if a target tile is not ready
        for (const tile of tilesByZ[z]){
            const tileState = tile.getState();
            if (tileState === (0, $fOhwi.default).EMPTY) continue;
            const tileCoord = tile.tileCoord;
            if (tileState === (0, $fOhwi.default).LOADED) {
                const alpha = tile.getAlpha(uid, time);
                if (alpha === 1) {
                    // no need to look for alt tiles
                    tile.endTransition(uid);
                    continue;
                }
            }
            if (tileState !== (0, $fOhwi.default).ERROR) this.renderComplete = false;
            const hasStaleTile = this.findStaleTile_(tileCoord, tilesByZ);
            if (hasStaleTile) {
                // use the stale tile before the new tile's transition has completed
                $02fffef185f4339b$var$removeTileFromLookup(tilesByZ, tile, z);
                frameState.animate = true;
                continue;
            }
            // first look for child tiles (at z + 1)
            const coveredByChildren = this.findAltTiles_(tileGrid, tileCoord, z + 1, tilesByZ);
            if (coveredByChildren) continue;
            // next look for parent tiles
            const minZoom = tileGrid.getMinZoom();
            for(let parentZ = z - 1; parentZ >= minZoom; --parentZ){
                const coveredByParent = this.findAltTiles_(tileGrid, tileCoord, parentZ, tilesByZ);
                if (coveredByParent) break;
            }
        }
        /**
     * Part 3: Render loaded tiles
     */ const canvasScale = tileResolution / viewResolution * pixelRatio / tilePixelRatio;
        const context = this.getRenderContext(frameState);
        // set scale transform for calculating tile positions on the canvas
        (0, $jpXrt.compose)(this.tempTransform, width / 2, height / 2, canvasScale, canvasScale, 0, -width / 2, -height / 2);
        if (layerState.extent) this.clipUnrotated(context, frameState, layerExtent);
        if (!tileSource.getInterpolate()) context.imageSmoothingEnabled = false;
        this.preRender(context, frameState);
        /** @type {Array<number>} */ const zs = Object.keys(tilesByZ).map(Number);
        zs.sort((0, $fVVyM.ascending));
        let currentClip;
        const clips = [];
        const clipZs = [];
        for(let i = zs.length - 1; i >= 0; --i){
            const currentZ = zs[i];
            const currentTilePixelSize = tileSource.getTilePixelSize(currentZ, pixelRatio, projection);
            const currentResolution = tileGrid.getResolution(currentZ);
            const currentScale = currentResolution / tileResolution;
            const dx = currentTilePixelSize[0] * currentScale * canvasScale;
            const dy = currentTilePixelSize[1] * currentScale * canvasScale;
            const originTileCoord = tileGrid.getTileCoordForCoordAndZ((0, $9pD6L.getTopLeft)(canvasExtent), currentZ);
            const originTileExtent = tileGrid.getTileCoordExtent(originTileCoord);
            const origin = (0, $jpXrt.apply)(this.tempTransform, [
                tilePixelRatio * (originTileExtent[0] - canvasExtent[0]) / tileResolution,
                tilePixelRatio * (canvasExtent[3] - originTileExtent[3]) / tileResolution
            ]);
            const tileGutter = tilePixelRatio * tileSource.getGutterForProjection(projection);
            for (const tile of tilesByZ[currentZ]){
                if (tile.getState() !== (0, $fOhwi.default).LOADED) continue;
                const tileCoord = tile.tileCoord;
                // Calculate integer positions and sizes so that tiles align
                const xIndex = originTileCoord[1] - tileCoord[1];
                const nextX = Math.round(origin[0] - (xIndex - 1) * dx);
                const yIndex = originTileCoord[2] - tileCoord[2];
                const nextY = Math.round(origin[1] - (yIndex - 1) * dy);
                const x = Math.round(origin[0] - xIndex * dx);
                const y = Math.round(origin[1] - yIndex * dy);
                const w = nextX - x;
                const h = nextY - y;
                const transition = zs.length === 1;
                let contextSaved = false;
                // Clip mask for regions in this tile that already filled by a higher z tile
                currentClip = [
                    x,
                    y,
                    x + w,
                    y,
                    x + w,
                    y + h,
                    x,
                    y + h
                ];
                for(let i = 0, ii = clips.length; i < ii; ++i)if (!transition && currentZ < clipZs[i]) {
                    const clip = clips[i];
                    if ((0, $9pD6L.intersects)([
                        x,
                        y,
                        x + w,
                        y + h
                    ], [
                        clip[0],
                        clip[3],
                        clip[4],
                        clip[7]
                    ])) {
                        if (!contextSaved) {
                            context.save();
                            contextSaved = true;
                        }
                        context.beginPath();
                        // counter-clockwise (outer ring) for current tile
                        context.moveTo(currentClip[0], currentClip[1]);
                        context.lineTo(currentClip[2], currentClip[3]);
                        context.lineTo(currentClip[4], currentClip[5]);
                        context.lineTo(currentClip[6], currentClip[7]);
                        // clockwise (inner ring) for higher z tile
                        context.moveTo(clip[6], clip[7]);
                        context.lineTo(clip[4], clip[5]);
                        context.lineTo(clip[2], clip[3]);
                        context.lineTo(clip[0], clip[1]);
                        context.clip();
                    }
                }
                clips.push(currentClip);
                clipZs.push(currentZ);
                this.drawTile(tile, frameState, x, y, w, h, tileGutter, transition);
                if (contextSaved) context.restore();
                this.renderedTiles.unshift(tile);
                // TODO: decide if this is necessary
                this.updateUsedTiles(frameState.usedTiles, tileSource, tile);
            }
        }
        this.renderedResolution = tileResolution;
        this.extentChanged = !this.renderedExtent_ || !(0, $9pD6L.equals)(this.renderedExtent_, canvasExtent);
        this.renderedExtent_ = canvasExtent;
        this.renderedPixelRatio = pixelRatio;
        this.postRender(this.context, frameState);
        if (layerState.extent) context.restore();
        context.imageSmoothingEnabled = true;
        if (this.renderComplete) {
            /**
       * @param {import("../../Map.js").default} map Map.
       * @param {import("../../Map.js").FrameState} frameState Frame state.
       */ const postRenderFunction = (map, frameState)=>{
                const tileSourceKey = (0, $9iPUS.getUid)(tileSource);
                const wantedTiles = frameState.wantedTiles[tileSourceKey];
                const tilesCount = wantedTiles ? Object.keys(wantedTiles).length : 0;
                this.updateCacheSize(tilesCount);
                this.tileCache_.expireCache();
                this.sourceTileCache_?.expireCache();
            };
            frameState.postRenderFunctions.push(postRenderFunction);
        }
        // this normally is `div.ol-layer` and is a mocked div in worker
        return this.container;
    }
    /**
   * Increases the cache size if needed
   * @param {number} tileCount Minimum number of tiles needed.
   */ updateCacheSize(tileCount) {
        this.tileCache_.highWaterMark = Math.max(this.tileCache_.highWaterMark, tileCount * 2);
    }
    /**
   * @param {import("../../Tile.js").default} tile Tile.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} x Left of the tile.
   * @param {number} y Top of the tile.
   * @param {number} w Width of the tile.
   * @param {number} h Height of the tile.
   * @param {number} gutter Tile gutter.
   * @param {boolean} transition Apply an alpha transition.
   * @protected
   */ drawTile(tile, frameState, x, y, w, h, gutter, transition) {
        let image;
        if (tile instanceof (0, $lKpkL.default)) {
            image = (0, $lKpkL.asImageLike)(tile.getData());
            if (!image) throw new Error('Rendering array data is not yet supported');
        } else image = this.getTileImage(/** @type {import("../../ImageTile.js").default} */ tile);
        if (!image) return;
        const context = this.getRenderContext(frameState);
        const uid = (0, $9iPUS.getUid)(this);
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const alpha = layerState.opacity * (transition ? tile.getAlpha(uid, frameState.time) : 1);
        const alphaChanged = alpha !== context.globalAlpha;
        if (alphaChanged) {
            context.save();
            context.globalAlpha = alpha;
        }
        context.drawImage(image, gutter, gutter, image.width - 2 * gutter, image.height - 2 * gutter, x, y, w, h);
        if (alphaChanged) context.restore();
        if (alpha !== layerState.opacity) frameState.animate = true;
        else if (transition) tile.endTransition(uid);
    }
    /**
   * @return {HTMLCanvasElement|OffscreenCanvas} Image
   */ getImage() {
        const context = this.context;
        return context ? context.canvas : null;
    }
    /**
   * Get the image from a tile.
   * @param {import("../../ImageTile.js").default} tile Tile.
   * @return {HTMLCanvasElement|OffscreenCanvas|HTMLImageElement|HTMLVideoElement} Image.
   * @protected
   */ getTileImage(tile) {
        return tile.getImage();
    }
    /**
   * @param {!Object<string, !Object<string, boolean>>} usedTiles Used tiles.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @param {import('../../Tile.js').default} tile Tile.
   * @protected
   */ updateUsedTiles(usedTiles, tileSource, tile) {
        // FIXME should we use tilesToDrawByZ instead?
        const tileSourceKey = (0, $9iPUS.getUid)(tileSource);
        if (!(tileSourceKey in usedTiles)) usedTiles[tileSourceKey] = {};
        usedTiles[tileSourceKey][tile.getKey()] = true;
    }
}
var $02fffef185f4339b$export$2e2bcd8739ae039 = $02fffef185f4339b$var$CanvasTileLayerRenderer;

});
parcelRegister("lKpkL", function(module, exports) {

$parcel$export(module.exports, "asImageLike", () => $fd518ba473015b27$export$3a7c913cb40dcb7d);
$parcel$export(module.exports, "default", () => $fd518ba473015b27$export$2e2bcd8739ae039);
/**
 * @module ol/DataTile
 */ 
var $1izXo = parcelRequire("1izXo");

var $fOhwi = parcelRequire("fOhwi");

var $DfnQm = parcelRequire("DfnQm");
function $fd518ba473015b27$export$3a7c913cb40dcb7d(data) {
    return data instanceof Image || data instanceof HTMLCanvasElement || data instanceof HTMLVideoElement || data instanceof ImageBitmap ? data : null;
}
function $fd518ba473015b27$export$7386cb0413f6b283(data) {
    return data instanceof Uint8Array || data instanceof Uint8ClampedArray || data instanceof Float32Array || data instanceof DataView ? data : null;
}
const $fd518ba473015b27$export$df4c617b86128e3e = new Error('disposed');
/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D|null}
 */ let $fd518ba473015b27$var$sharedContext = null;
function $fd518ba473015b27$export$45b10814cc054894(image) {
    if (!$fd518ba473015b27$var$sharedContext) $fd518ba473015b27$var$sharedContext = (0, $DfnQm.createCanvasContext2D)(image.width, image.height, undefined, {
        willReadFrequently: true
    });
    const canvas = $fd518ba473015b27$var$sharedContext.canvas;
    const width = image.width;
    if (canvas.width !== width) canvas.width = width;
    const height = image.height;
    if (canvas.height !== height) canvas.height = height;
    $fd518ba473015b27$var$sharedContext.clearRect(0, 0, width, height);
    $fd518ba473015b27$var$sharedContext.drawImage(image, 0, 0);
    return $fd518ba473015b27$var$sharedContext.getImageData(0, 0, width, height).data;
}
/**
 * @type {import('./size.js').Size}
 */ const $fd518ba473015b27$var$defaultSize = [
    256,
    256
];
/**
 * @typedef {Object} Options
 * @property {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
 * @property {function(): Promise<Data>} loader Data loader.  For loaders that generate images,
 * the promise should not resolve until the image is loaded.
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @property {import('./size.js').Size} [size=[256, 256]] Tile size.
 * @property {AbortController} [controller] An abort controller.
 * @api
 */ class $fd518ba473015b27$var$DataTile extends (0, $1izXo.default) {
    /**
   * @param {Options} options Tile options.
   */ constructor(options){
        const state = (0, $fOhwi.default).IDLE;
        super(options.tileCoord, state, {
            transition: options.transition,
            interpolate: options.interpolate
        });
        /**
     * @type {function(): Promise<Data>}
     * @private
     */ this.loader_ = options.loader;
        /**
     * @type {Data}
     * @private
     */ this.data_ = null;
        /**
     * @type {Error}
     * @private
     */ this.error_ = null;
        /**
     * @type {import('./size.js').Size|null}
     * @private
     */ this.size_ = options.size || null;
        /**
     * @type {AbortController|null}
     * @private
     */ this.controller_ = options.controller || null;
    }
    /**
   * Get the tile size.
   * @return {import('./size.js').Size} Tile size.
   */ getSize() {
        if (this.size_) return this.size_;
        const imageData = $fd518ba473015b27$export$3a7c913cb40dcb7d(this.data_);
        if (imageData) return [
            imageData.width,
            imageData.height
        ];
        return $fd518ba473015b27$var$defaultSize;
    }
    /**
   * Get the data for the tile.
   * @return {Data} Tile data.
   * @api
   */ getData() {
        return this.data_;
    }
    /**
   * Get any loading error.
   * @return {Error} Loading error.
   * @api
   */ getError() {
        return this.error_;
    }
    /**
   * Load the tile data.
   * @api
   * @override
   */ load() {
        if (this.state !== (0, $fOhwi.default).IDLE && this.state !== (0, $fOhwi.default).ERROR) return;
        this.state = (0, $fOhwi.default).LOADING;
        this.changed();
        const self = this;
        this.loader_().then(function(data) {
            self.data_ = data;
            self.state = (0, $fOhwi.default).LOADED;
            self.changed();
        }).catch(function(error) {
            self.error_ = error;
            self.state = (0, $fOhwi.default).ERROR;
            self.changed();
        });
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.controller_) {
            this.controller_.abort($fd518ba473015b27$export$df4c617b86128e3e);
            this.controller_ = null;
        }
        super.disposeInternal();
    }
}
var $fd518ba473015b27$export$2e2bcd8739ae039 = $fd518ba473015b27$var$DataTile;

});
parcelRegister("1izXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f235d2d04095c6e$export$2e2bcd8739ae039);
/**
 * @module ol/Tile
 */ 
var $fOhwi = parcelRequire("fOhwi");

var $h9x7v = parcelRequire("h9x7v");

var $3xzSb = parcelRequire("3xzSb");

var $KD0eF = parcelRequire("KD0eF");

var $9iPUS = parcelRequire("9iPUS");
/**
 * A function that takes a {@link module:ol/Tile~Tile} for the tile and a
 * `{string}` for the url as arguments. The default is
 * ```js
 * source.setTileLoadFunction(function(tile, src) {
 *   tile.getImage().src = src;
 * });
 * ```
 * For more fine grained control, the load function can use fetch or XMLHttpRequest and involve
 * error handling:
 *
 * ```js
 * import TileState from 'ol/TileState.js';
 *
 * source.setTileLoadFunction(function(tile, src) {
 *   const xhr = new XMLHttpRequest();
 *   xhr.responseType = 'blob';
 *   xhr.addEventListener('loadend', function (evt) {
 *     const data = this.response;
 *     if (data !== undefined) {
 *       tile.getImage().src = URL.createObjectURL(data);
 *     } else {
 *       tile.setState(TileState.ERROR);
 *     }
 *   });
 *   xhr.addEventListener('error', function () {
 *     tile.setState(TileState.ERROR);
 *   });
 *   xhr.open('GET', src);
 *   xhr.send();
 * });
 * ```
 *
 * @typedef {function(Tile, string): void} LoadFunction
 * @api
 */ /**
 * {@link module:ol/source/Tile~TileSource} sources use a function of this type to get
 * the url that provides a tile for a given tile coordinate.
 *
 * This function takes a {@link module:ol/tilecoord~TileCoord} for the tile
 * coordinate, a `{number}` representing the pixel ratio and a
 * {@link module:ol/proj/Projection~Projection} for the projection  as arguments
 * and returns a `{string}` representing the tile URL, or undefined if no tile
 * should be requested for the passed tile coordinate.
 *
 * @typedef {function(import("./tilecoord.js").TileCoord, number,
 *           import("./proj/Projection.js").default): (string|undefined)} UrlFunction
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @api
 */ /**
 * @classdesc
 * Base class for tiles.
 *
 * @abstract
 */ class $0f235d2d04095c6e$var$Tile extends (0, $KD0eF.default) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {Options} [options] Tile options.
   */ constructor(tileCoord, state, options){
        super();
        options = options ? options : {};
        /**
     * @type {import("./tilecoord.js").TileCoord}
     */ this.tileCoord = tileCoord;
        /**
     * @protected
     * @type {import("./TileState.js").default}
     */ this.state = state;
        /**
     * A key assigned to the tile. This is used in conjunction with a source key
     * to determine if a cached version of this tile may be used by the renderer.
     * @type {string}
     */ this.key = '';
        /**
     * The duration for the opacity transition.
     * @private
     * @type {number}
     */ this.transition_ = options.transition === undefined ? 250 : options.transition;
        /**
     * Lookup of start times for rendering transitions.  If the start time is
     * equal to -1, the transition is complete.
     * @private
     * @type {Object<string, number>}
     */ this.transitionStarts_ = {};
        /**
     * @type {boolean}
     */ this.interpolate = !!options.interpolate;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, $3xzSb.default).CHANGE);
    }
    /**
   * Called by the tile cache when the tile is removed from the cache due to expiry
   */ release() {
        // to remove the `change` listener on this tile in `ol/TileQueue#handleTileChange`
        this.setState((0, $fOhwi.default).EMPTY);
    }
    /**
   * @return {string} Key.
   */ getKey() {
        return this.key + '/' + this.tileCoord;
    }
    /**
   * Get the tile coordinate for this tile.
   * @return {import("./tilecoord.js").TileCoord} The tile coordinate.
   * @api
   */ getTileCoord() {
        return this.tileCoord;
    }
    /**
   * @return {import("./TileState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Sets the state of this tile. If you write your own {@link module:ol/Tile~LoadFunction tileLoadFunction} ,
   * it is important to set the state correctly to {@link module:ol/TileState~ERROR}
   * when the tile cannot be loaded. Otherwise the tile cannot be removed from
   * the tile queue and will block other requests.
   * @param {import("./TileState.js").default} state State.
   * @api
   */ setState(state) {
        if (this.state === (0, $fOhwi.default).EMPTY) // no more state changes
        return;
        if (this.state !== (0, $fOhwi.default).ERROR && this.state > state) throw new Error('Tile load sequence violation');
        this.state = state;
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   * @abstract
   * @api
   */ load() {
        (0, $9iPUS.abstract)();
    }
    /**
   * Get the alpha value for rendering.
   * @param {string} id An id for the renderer.
   * @param {number} time The render frame time.
   * @return {number} A number between 0 and 1.
   */ getAlpha(id, time) {
        if (!this.transition_) return 1;
        let start = this.transitionStarts_[id];
        if (!start) {
            start = time;
            this.transitionStarts_[id] = start;
        } else if (start === -1) return 1;
        const delta = time - start + 1000 / 60; // avoid rendering at 0
        if (delta >= this.transition_) return 1;
        return (0, $h9x7v.easeIn)(delta / this.transition_);
    }
    /**
   * Determine if a tile is in an alpha transition.  A tile is considered in
   * transition if tile.getAlpha() has not yet been called or has been called
   * and returned 1.
   * @param {string} id An id for the renderer.
   * @return {boolean} The tile is in transition.
   */ inTransition(id) {
        if (!this.transition_) return false;
        return this.transitionStarts_[id] !== -1;
    }
    /**
   * Mark a transition as complete.
   * @param {string} id An id for the renderer.
   */ endTransition(id) {
        if (this.transition_) this.transitionStarts_[id] = -1;
    }
    /**
   * @override
   */ disposeInternal() {
        this.release();
        super.disposeInternal();
    }
}
var $0f235d2d04095c6e$export$2e2bcd8739ae039 = $0f235d2d04095c6e$var$Tile;

});


parcelRegister("hCs6p", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd3bc8d185522361$export$2e2bcd8739ae039);
/**
 * @module ol/ImageTile
 */ 
var $fySoz = parcelRequire("fySoz");

var $1izXo = parcelRequire("1izXo");

var $fOhwi = parcelRequire("fOhwi");

var $DfnQm = parcelRequire("DfnQm");

var $8UoiJ = parcelRequire("8UoiJ");
class $cd3bc8d185522361$var$ImageTile extends (0, $1izXo.default) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {string} src Image source URI.
   * @param {import('./dom.js').ImageAttributes} imageAttributes Image attributes options.
   * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @param {import("./Tile.js").Options} [options] Tile options.
   */ constructor(tileCoord, state, src, imageAttributes, tileLoadFunction, options){
        super(tileCoord, state, options);
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = imageAttributes?.crossOrigin;
        /**
     * @private
     * @type {ReferrerPolicy}
     */ this.referrerPolicy_ = imageAttributes?.referrerPolicy;
        /**
     * Image URI
     *
     * @private
     * @type {string}
     */ this.src_ = src;
        this.key = src;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas}
     */ this.image_;
        if (0, $8UoiJ.WORKER_OFFSCREEN_CANVAS) this.image_ = new OffscreenCanvas(1, 1);
        else {
            this.image_ = new Image();
            if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
            if (this.referrerPolicy_ !== undefined) this.image_.referrerPolicy = this.referrerPolicy_;
        }
        /**
     * @private
     * @type {?function():void}
     */ this.unlisten_ = null;
        /**
     * @private
     * @type {import("./Tile.js").LoadFunction}
     */ this.tileLoadFunction_ = tileLoadFunction;
    }
    /**
   * Get the HTML image element for this tile (may be a Canvas, OffscreenCanvas, Image, or Video).
   * @return {HTMLCanvasElement|OffscreenCanvas|HTMLImageElement|HTMLVideoElement} Image.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Sets an HTML image element for this tile (may be a Canvas or preloaded Image).
   * @param {HTMLCanvasElement|OffscreenCanvas|HTMLImageElement} element Element.
   */ setImage(element) {
        this.image_ = element;
        this.state = (0, $fOhwi.default).LOADED;
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Get the cross origin of the ImageTile.
   * @return {string} Cross origin.
   */ getCrossOrigin() {
        return this.crossOrigin_;
    }
    /**
   * Get the referrer policy of the ImageTile.
   * @return {ReferrerPolicy} Referrer policy.
   */ getReferrerPolicy() {
        return this.referrerPolicy_;
    }
    /**
   * Tracks loading or read errors.
   *
   * @private
   */ handleImageError_() {
        this.state = (0, $fOhwi.default).ERROR;
        this.unlistenImage_();
        this.image_ = $cd3bc8d185522361$var$getBlankImage();
        this.changed();
    }
    /**
   * Tracks successful image load.
   *
   * @private
   */ handleImageLoad_() {
        if (0, $8UoiJ.WORKER_OFFSCREEN_CANVAS) // OffscreenCanvas does not have naturalWidth and naturalHeight
        this.state = (0, $fOhwi.default).LOADED;
        else {
            const image = /** @type {HTMLImageElement} */ this.image_;
            if (image.naturalWidth && image.naturalHeight) this.state = (0, $fOhwi.default).LOADED;
            else this.state = (0, $fOhwi.default).EMPTY;
        }
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   *
   * To retry loading tiles on failed requests, use a custom `tileLoadFunction`
   * that checks for error status codes and reloads only when the status code is
   * 408, 429, 500, 502, 503 and 504, and only when not too many retries have been
   * made already:
   *
   * ```js
   * const retryCodes = [408, 429, 500, 502, 503, 504];
   * const retries = {};
   * source.setTileLoadFunction((tile, src) => {
   *   const image = tile.getImage();
   *   fetch(src)
   *     .then((response) => {
   *       if (retryCodes.includes(response.status)) {
   *         retries[src] = (retries[src] || 0) + 1;
   *         if (retries[src] <= 3) {
   *           setTimeout(() => tile.load(), retries[src] * 1000);
   *         }
   *         return Promise.reject();
   *       }
   *       return response.blob();
   *     })
   *     .then((blob) => {
   *       const imageUrl = URL.createObjectURL(blob);
   *       image.src = imageUrl;
   *       setTimeout(() => URL.revokeObjectURL(imageUrl), 5000);
   *     })
   *     .catch(() => tile.setState(3)); // error
   * });
   * ```
   * @api
   * @override
   */ load() {
        if (this.state == (0, $fOhwi.default).ERROR) {
            this.state = (0, $fOhwi.default).IDLE;
            this.image_ = new Image();
            if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
            if (this.referrerPolicy_ !== undefined) this.image_.referrerPolicy = this.referrerPolicy_;
        }
        if (this.state == (0, $fOhwi.default).IDLE) {
            this.state = (0, $fOhwi.default).LOADING;
            this.changed();
            this.tileLoadFunction_(this, this.src_);
            this.unlisten_ = (0, $fySoz.listenImage)(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    }
    /**
   * Discards event handlers which listen for load completion or errors.
   *
   * @private
   */ unlistenImage_() {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    }
    /**
   * @override
   */ disposeInternal() {
        this.unlistenImage_();
        this.image_ = null;
        super.disposeInternal();
    }
}
/**
 * Get a 1-pixel blank image.
 * @return {HTMLCanvasElement|OffscreenCanvas} Blank image.
 */ function $cd3bc8d185522361$var$getBlankImage() {
    const ctx = (0, $DfnQm.createCanvasContext2D)(1, 1);
    ctx.fillStyle = 'rgba(0,0,0,0)';
    ctx.fillRect(0, 0, 1, 1);
    return ctx.canvas;
}
var $cd3bc8d185522361$export$2e2bcd8739ae039 = $cd3bc8d185522361$var$ImageTile;

});

parcelRegister("7iKy2", function(module, exports) {

$parcel$export(module.exports, "createOrUpdate", () => $550e524b0d1b61d4$export$958e3e1a02eac4b6);
$parcel$export(module.exports, "default", () => $550e524b0d1b61d4$export$2e2bcd8739ae039);
/**
 * @module ol/TileRange
 */ /**
 * A representation of a contiguous block of tiles.  A tile range is specified
 * by its min/max tile coordinates and is inclusive of coordinates.
 */ class $550e524b0d1b61d4$var$TileRange {
    /**
   * @param {number} minX Minimum X.
   * @param {number} maxX Maximum X.
   * @param {number} minY Minimum Y.
   * @param {number} maxY Maximum Y.
   */ constructor(minX, maxX, minY, maxY){
        /**
     * @type {number}
     */ this.minX = minX;
        /**
     * @type {number}
     */ this.maxX = maxX;
        /**
     * @type {number}
     */ this.minY = minY;
        /**
     * @type {number}
     */ this.maxY = maxY;
    }
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {boolean} Contains tile coordinate.
   */ contains(tileCoord) {
        return this.containsXY(tileCoord[1], tileCoord[2]);
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Contains.
   */ containsTileRange(tileRange) {
        return this.minX <= tileRange.minX && tileRange.maxX <= this.maxX && this.minY <= tileRange.minY && tileRange.maxY <= this.maxY;
    }
    /**
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @return {boolean} Contains coordinate.
   */ containsXY(x, y) {
        return this.minX <= x && x <= this.maxX && this.minY <= y && y <= this.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Equals.
   */ equals(tileRange) {
        return this.minX == tileRange.minX && this.minY == tileRange.minY && this.maxX == tileRange.maxX && this.maxY == tileRange.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   */ extend(tileRange) {
        if (tileRange.minX < this.minX) this.minX = tileRange.minX;
        if (tileRange.maxX > this.maxX) this.maxX = tileRange.maxX;
        if (tileRange.minY < this.minY) this.minY = tileRange.minY;
        if (tileRange.maxY > this.maxY) this.maxY = tileRange.maxY;
    }
    /**
   * @return {number} Height.
   */ getHeight() {
        return this.maxY - this.minY + 1;
    }
    /**
   * @return {import("./size.js").Size} Size.
   */ getSize() {
        return [
            this.getWidth(),
            this.getHeight()
        ];
    }
    /**
   * @return {number} Width.
   */ getWidth() {
        return this.maxX - this.minX + 1;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Intersects.
   */ intersects(tileRange) {
        return this.minX <= tileRange.maxX && this.maxX >= tileRange.minX && this.minY <= tileRange.maxY && this.maxY >= tileRange.minY;
    }
}
function $550e524b0d1b61d4$export$958e3e1a02eac4b6(minX, maxX, minY, maxY, tileRange) {
    if (tileRange !== undefined) {
        tileRange.minX = minX;
        tileRange.maxX = maxX;
        tileRange.minY = minY;
        tileRange.maxY = maxY;
        return tileRange;
    }
    return new $550e524b0d1b61d4$var$TileRange(minX, maxX, minY, maxY);
}
var $550e524b0d1b61d4$export$2e2bcd8739ae039 = $550e524b0d1b61d4$var$TileRange;

});

parcelRegister("4WmJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $398e350e33050c07$export$2e2bcd8739ae039);
/**
 * @module ol/reproj/Tile
 */ 
var $1izXo = parcelRequire("1izXo");

var $fOhwi = parcelRequire("fOhwi");

var $DfnQm = parcelRequire("DfnQm");

var $3xzSb = parcelRequire("3xzSb");

var $ilM9F = parcelRequire("ilM9F");

var $9pD6L = parcelRequire("9pD6L");

var $9byFX = parcelRequire("9byFX");

var $3H62b = parcelRequire("3H62b");

var $9gka6 = parcelRequire("9gka6");

var $cfilv = parcelRequire("cfilv");
/**
 * @typedef {function(number, number, number, number) : (import("../ImageTile.js").default)} FunctionType
 */ /**
 * @typedef {Object} TileOffset
 * @property {import("../ImageTile.js").default} [tile] Tile.
 * @property {function(): import("../ImageTile.js").default} getTile Tile getter.
 * @property {number} offset Offset.
 */ /**
 * @classdesc
 * Class encapsulating single reprojected tile.
 * See {@link module:ol/source/TileImage~TileImage}.
 *
 */ class $398e350e33050c07$var$ReprojTile extends (0, $1izXo.default) {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../tilegrid/TileGrid.js").default} sourceTileGrid Source tile grid.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../tilegrid/TileGrid.js").default} targetTileGrid Target tile grid.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Coordinate of the tile.
   * @param {import("../tilecoord.js").TileCoord} wrappedTileCoord Coordinate of the tile wrapped in X.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} gutter Gutter of the source tiles.
   * @param {FunctionType} getTileFunction
   *     Function returning source tiles (z, x, y, pixelRatio).
   * @param {number} [errorThreshold] Acceptable reprojection error (in px).
   * @param {boolean} [renderEdges] Render reprojection edges.
   * @param {import("../Tile.js").Options} [options] Tile options.
   */ constructor(sourceProj, sourceTileGrid, targetProj, targetTileGrid, tileCoord, wrappedTileCoord, pixelRatio, gutter, getTileFunction, errorThreshold, renderEdges, options){
        super(tileCoord, (0, $fOhwi.default).IDLE, options);
        /**
     * @private
     * @type {boolean}
     */ this.renderEdges_ = renderEdges !== undefined ? renderEdges : false;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.gutter_ = gutter;
        /**
     * @private
     * @type {HTMLCanvasElement|OffscreenCanvas}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.sourceTileGrid_ = sourceTileGrid;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.targetTileGrid_ = targetTileGrid;
        /**
     * @private
     * @type {import("../tilecoord.js").TileCoord}
     */ this.wrappedTileCoord_ = wrappedTileCoord ? wrappedTileCoord : tileCoord;
        /**
     * @private
     * @type {!Array<TileOffset>}
     */ this.sourceTiles_ = [];
        /**
     * @private
     * @type {?Array<import("../events.js").EventsKey>}
     */ this.sourcesListenerKeys_ = null;
        /**
     * @private
     * @type {number}
     */ this.sourceZ_ = 0;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.clipExtent_ = sourceProj.canWrapX() ? sourceProj.getExtent() : undefined;
        const targetExtent = targetTileGrid.getTileCoordExtent(this.wrappedTileCoord_);
        const maxTargetExtent = this.targetTileGrid_.getExtent();
        let maxSourceExtent = this.sourceTileGrid_.getExtent();
        const limitedTargetExtent = maxTargetExtent ? (0, $9pD6L.getIntersection)(targetExtent, maxTargetExtent) : targetExtent;
        if ((0, $9pD6L.getArea)(limitedTargetExtent) === 0) {
            // Tile is completely outside range -> EMPTY
            // TODO: is it actually correct that the source even creates the tile ?
            this.state = (0, $fOhwi.default).EMPTY;
            return;
        }
        const sourceProjExtent = sourceProj.getExtent();
        if (sourceProjExtent) {
            if (!maxSourceExtent) maxSourceExtent = sourceProjExtent;
            else maxSourceExtent = (0, $9pD6L.getIntersection)(maxSourceExtent, sourceProjExtent);
        }
        const targetResolution = targetTileGrid.getResolution(this.wrappedTileCoord_[0]);
        const sourceResolution = (0, $3H62b.calculateSourceExtentResolution)(sourceProj, targetProj, limitedTargetExtent, targetResolution);
        if (!isFinite(sourceResolution) || sourceResolution <= 0) {
            // invalid sourceResolution -> EMPTY
            // probably edges of the projections when no extent is defined
            this.state = (0, $fOhwi.default).EMPTY;
            return;
        }
        const errorThresholdInPixels = errorThreshold !== undefined ? errorThreshold : (0, $cfilv.ERROR_THRESHOLD);
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = new (0, $9gka6.default)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        if (this.triangulation_.getTriangles().length === 0) {
            // no valid triangles -> EMPTY
            this.state = (0, $fOhwi.default).EMPTY;
            return;
        }
        this.sourceZ_ = sourceTileGrid.getZForResolution(sourceResolution);
        let sourceExtent = this.triangulation_.calculateSourceExtent();
        if (maxSourceExtent) {
            if (sourceProj.canWrapX()) {
                sourceExtent[1] = (0, $9byFX.clamp)(sourceExtent[1], maxSourceExtent[1], maxSourceExtent[3]);
                sourceExtent[3] = (0, $9byFX.clamp)(sourceExtent[3], maxSourceExtent[1], maxSourceExtent[3]);
            } else sourceExtent = (0, $9pD6L.getIntersection)(sourceExtent, maxSourceExtent);
        }
        if (!(0, $9pD6L.getArea)(sourceExtent)) this.state = (0, $fOhwi.default).EMPTY;
        else {
            let worldWidth = 0;
            let worldsAway = 0;
            if (sourceProj.canWrapX()) {
                worldWidth = (0, $9pD6L.getWidth)(sourceProjExtent);
                worldsAway = Math.floor((sourceExtent[0] - sourceProjExtent[0]) / worldWidth);
            }
            const sourceExtents = (0, $9pD6L.wrapAndSliceX)(sourceExtent.slice(), sourceProj, true);
            sourceExtents.forEach((extent)=>{
                const sourceRange = sourceTileGrid.getTileRangeForExtentAndZ(extent, this.sourceZ_);
                for(let srcX = sourceRange.minX; srcX <= sourceRange.maxX; srcX++)for(let srcY = sourceRange.minY; srcY <= sourceRange.maxY; srcY++){
                    const offset = worldsAway * worldWidth;
                    this.sourceTiles_.push({
                        getTile: ()=>getTileFunction(this.sourceZ_, srcX, srcY, pixelRatio),
                        offset: offset
                    });
                }
                ++worldsAway;
            });
            if (this.sourceTiles_.length === 0) this.state = (0, $fOhwi.default).EMPTY;
        }
    }
    /**
   * Get the HTML Canvas element for this tile.
   * @return {HTMLCanvasElement|OffscreenCanvas} Canvas.
   */ getImage() {
        return this.canvas_;
    }
    /**
   * @private
   */ reproject_() {
        const sources = [];
        this.sourceTiles_.forEach((source)=>{
            const tile = source.tile;
            if (tile && tile.getState() == (0, $fOhwi.default).LOADED) {
                const extent = this.sourceTileGrid_.getTileCoordExtent(tile.tileCoord);
                extent[0] += source.offset;
                extent[2] += source.offset;
                const clipExtent = this.clipExtent_?.slice();
                if (clipExtent) {
                    clipExtent[0] += source.offset;
                    clipExtent[2] += source.offset;
                }
                sources.push({
                    extent: extent,
                    clipExtent: clipExtent,
                    image: tile.getImage()
                });
            }
        });
        this.sourceTiles_.length = 0;
        if (sources.length === 0) this.state = (0, $fOhwi.default).ERROR;
        else {
            const z = this.wrappedTileCoord_[0];
            const size = this.targetTileGrid_.getTileSize(z);
            const width = typeof size === 'number' ? size : size[0];
            const height = typeof size === 'number' ? size : size[1];
            const targetResolution = this.targetTileGrid_.getResolution(z);
            const sourceResolution = this.sourceTileGrid_.getResolution(this.sourceZ_);
            const targetExtent = this.targetTileGrid_.getTileCoordExtent(this.wrappedTileCoord_);
            this.canvas_ = (0, $3H62b.render)(width, height, this.pixelRatio_, sourceResolution, this.sourceTileGrid_.getExtent(), targetResolution, targetExtent, this.triangulation_, sources, this.gutter_, this.renderEdges_, this.interpolate);
            this.state = (0, $fOhwi.default).LOADED;
        }
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {
        for (const sourceTile of this.sourceTiles_)sourceTile.tile = sourceTile.getTile();
        if (this.state == (0, $fOhwi.default).IDLE) {
            this.state = (0, $fOhwi.default).LOADING;
            this.changed();
            let leftToLoad = 0;
            this.sourcesListenerKeys_ = [];
            this.sourceTiles_.forEach(({ tile: tile })=>{
                const state = tile.getState();
                if (state == (0, $fOhwi.default).IDLE || state == (0, $fOhwi.default).LOADING) {
                    leftToLoad++;
                    const sourceListenKey = (0, $ilM9F.listen)(tile, (0, $3xzSb.default).CHANGE, (e)=>{
                        const state = tile.getState();
                        if (state == (0, $fOhwi.default).LOADED || state == (0, $fOhwi.default).ERROR || state == (0, $fOhwi.default).EMPTY) {
                            (0, $ilM9F.unlistenByKey)(sourceListenKey);
                            leftToLoad--;
                            if (leftToLoad === 0) {
                                this.unlistenSources_();
                                this.reproject_();
                            }
                        }
                    });
                    this.sourcesListenerKeys_.push(sourceListenKey);
                }
            });
            if (leftToLoad === 0) setTimeout(this.reproject_.bind(this), 0);
            else this.sourceTiles_.forEach(function({ tile: tile }, i, arr) {
                const state = tile.getState();
                if (state == (0, $fOhwi.default).IDLE) tile.load();
            });
        }
    }
    /**
   * @private
   */ unlistenSources_() {
        this.sourcesListenerKeys_.forEach((0, $ilM9F.unlistenByKey));
        this.sourcesListenerKeys_ = null;
    }
    /**
   * Remove from the cache due to expiry
   * @override
   */ release() {
        if (this.canvas_) {
            (0, $DfnQm.releaseCanvas)(/** @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} */ this.canvas_.getContext('2d'));
            (0, $3H62b.canvasPool).push(this.canvas_);
            this.canvas_ = null;
        }
        this.sourceTiles_.length = 0;
        super.release();
    }
}
var $398e350e33050c07$export$2e2bcd8739ae039 = $398e350e33050c07$var$ReprojTile;

});

parcelRegister("btbc6", function(module, exports) {

$parcel$export(module.exports, "default", () => $859b1614288c6316$export$2e2bcd8739ae039);
/**
 * @module ol/structs/LRUCache
 */ 
var $4kyFN = parcelRequire("4kyFN");

var $4Cz58 = parcelRequire("4Cz58");
/**
 * @typedef {Object} Entry
 * @property {string} key_ Key.
 * @property {Entry|null} newer Newer.
 * @property {Entry|null} older Older.
 * @property {*} value_ Value.
 */ /**
 * @classdesc
 * Implements a Least-Recently-Used cache where the keys do not conflict with
 * Object's properties (e.g. 'hasOwnProperty' is not allowed as a key). Expiring
 * items from the cache is the responsibility of the user.
 *
 * @fires import("../events/Event.js").default
 * @template T
 */ class $859b1614288c6316$var$LRUCache {
    /**
   * @param {number} [highWaterMark] High water mark.
   */ constructor(highWaterMark){
        /**
     * Desired max cache size after expireCache(). If set to 0, no cache entries
     * will be pruned at all.
     * @type {number}
     */ this.highWaterMark = highWaterMark !== undefined ? highWaterMark : 2048;
        /**
     * @private
     * @type {number}
     */ this.count_ = 0;
        /**
     * @private
     * @type {!Object<string, Entry>}
     */ this.entries_ = {};
        /**
     * @private
     * @type {?Entry}
     */ this.oldest_ = null;
        /**
     * @private
     * @type {?Entry}
     */ this.newest_ = null;
    }
    deleteOldest() {
        const entry = this.pop();
        if (entry instanceof (0, $4kyFN.default)) entry.dispose();
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.highWaterMark > 0 && this.getCount() > this.highWaterMark;
    }
    /**
   * Expire the cache. When the cache entry is a {@link module:ol/Disposable~Disposable},
   * the entry will be disposed.
   * @param {!Object<string, boolean>} [keep] Keys to keep. To be implemented by subclasses.
   */ expireCache(keep) {
        while(this.canExpireCache())this.deleteOldest();
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        while(this.oldest_)this.deleteOldest();
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Contains key.
   */ containsKey(key) {
        return this.entries_.hasOwnProperty(key);
    }
    /**
   * @param {function(T, string, LRUCache<T>): ?} f The function
   *     to call for every entry from the oldest to the newer. This function takes
   *     3 arguments (the entry value, the entry key and the LRUCache object).
   *     The return value is ignored.
   */ forEach(f) {
        let entry = this.oldest_;
        while(entry){
            f(entry.value_, entry.key_, this);
            entry = entry.newer;
        }
    }
    /**
   * @param {string} key Key.
   * @param {*} [options] Options (reserved for subclasses).
   * @return {T} Value.
   */ get(key, options) {
        const entry = this.entries_[key];
        (0, $4Cz58.assert)(entry !== undefined, 'Tried to get a value for a key that does not exist in the cache');
        if (entry === this.newest_) return entry.value_;
        if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ this.oldest_.newer;
            this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        entry.newer = null;
        entry.older = this.newest_;
        this.newest_.newer = entry;
        this.newest_ = entry;
        return entry.value_;
    }
    /**
   * Remove an entry from the cache.
   * @param {string} key The entry key.
   * @return {T} The removed entry.
   */ remove(key) {
        const entry = this.entries_[key];
        (0, $4Cz58.assert)(entry !== undefined, 'Tried to get a value for a key that does not exist in the cache');
        if (entry === this.newest_) {
            this.newest_ = /** @type {Entry} */ entry.older;
            if (this.newest_) this.newest_.newer = null;
        } else if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ entry.newer;
            if (this.oldest_) this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        delete this.entries_[key];
        --this.count_;
        return entry.value_;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.count_;
    }
    /**
   * @return {Array<string>} Keys.
   */ getKeys() {
        const keys = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)keys[i++] = entry.key_;
        return keys;
    }
    /**
   * @return {Array<T>} Values.
   */ getValues() {
        const values = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)values[i++] = entry.value_;
        return values;
    }
    /**
   * @return {T} Last value.
   */ peekLast() {
        return this.oldest_.value_;
    }
    /**
   * @return {string} Last key.
   */ peekLastKey() {
        return this.oldest_.key_;
    }
    /**
   * Get the key of the newest item in the cache.  Throws if the cache is empty.
   * @return {string} The newest key.
   */ peekFirstKey() {
        return this.newest_.key_;
    }
    /**
   * Return an entry without updating least recently used time.
   * @param {string} key Key.
   * @return {T|undefined} Value.
   */ peek(key) {
        return this.entries_[key]?.value_;
    }
    /**
   * @return {T} value Value.
   */ pop() {
        const entry = this.oldest_;
        delete this.entries_[entry.key_];
        if (entry.newer) entry.newer.older = null;
        this.oldest_ = /** @type {Entry} */ entry.newer;
        if (!this.oldest_) this.newest_ = null;
        --this.count_;
        return entry.value_;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ replace(key, value) {
        this.get(key); // update `newest_`
        this.entries_[key].value_ = value;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ set(key, value) {
        (0, $4Cz58.assert)(!(key in this.entries_), 'Tried to set a value for a key that is used already');
        const entry = {
            key_: key,
            newer: null,
            older: this.newest_,
            value_: value
        };
        if (!this.newest_) this.oldest_ = entry;
        else this.newest_.newer = entry;
        this.newest_ = entry;
        this.entries_[key] = entry;
        ++this.count_;
    }
    /**
   * Set a maximum number of entries for the cache.
   * @param {number} size Cache size.
   * @api
   */ setSize(size) {
        this.highWaterMark = size;
    }
}
var $859b1614288c6316$export$2e2bcd8739ae039 = $859b1614288c6316$var$LRUCache;

});

parcelRegister("gpyQY", function(module, exports) {

$parcel$export(module.exports, "createOrUpdate", () => $bf2a04496fadabc6$export$958e3e1a02eac4b6);
$parcel$export(module.exports, "getCacheKey", () => $bf2a04496fadabc6$export$611736262b635f8d);
$parcel$export(module.exports, "hash", () => $bf2a04496fadabc6$export$d6af199866bfb566);
$parcel$export(module.exports, "hashZXY", () => $bf2a04496fadabc6$export$731f79419750ccf7);
$parcel$export(module.exports, "withinExtentAndZ", () => $bf2a04496fadabc6$export$60bedf8e3e3c3dbe);
/**
 * @module ol/tilecoord
 */ 
var $9iPUS = parcelRequire("9iPUS");
function $bf2a04496fadabc6$export$958e3e1a02eac4b6(z, x, y, tileCoord) {
    if (tileCoord !== undefined) {
        tileCoord[0] = z;
        tileCoord[1] = x;
        tileCoord[2] = y;
        return tileCoord;
    }
    return [
        z,
        x,
        y
    ];
}
function $bf2a04496fadabc6$export$92d0df0f1d25c63c(z, x, y) {
    return z + '/' + x + '/' + y;
}
function $bf2a04496fadabc6$export$a47fb462a08de82f(tileCoord) {
    return $bf2a04496fadabc6$export$92d0df0f1d25c63c(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $bf2a04496fadabc6$export$7f760414a8e3d2b5(tileKey) {
    const [z, x, y] = tileKey.substring(tileKey.lastIndexOf('/') + 1, tileKey.length).split(',').map(Number);
    return $bf2a04496fadabc6$export$92d0df0f1d25c63c(z, x, y);
}
function $bf2a04496fadabc6$export$611736262b635f8d(source, sourceKey, z, x, y) {
    return `${(0, $9iPUS.getUid)(source)},${sourceKey},${$bf2a04496fadabc6$export$92d0df0f1d25c63c(z, x, y)}`;
}
function $bf2a04496fadabc6$export$a807b7874eb66454(key) {
    return key.split('/').map(Number);
}
function $bf2a04496fadabc6$export$d6af199866bfb566(tileCoord) {
    return $bf2a04496fadabc6$export$731f79419750ccf7(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $bf2a04496fadabc6$export$731f79419750ccf7(z, x, y) {
    return (x << z) + y;
}
function $bf2a04496fadabc6$export$60bedf8e3e3c3dbe(tileCoord, tileGrid) {
    const z = tileCoord[0];
    const x = tileCoord[1];
    const y = tileCoord[2];
    if (tileGrid.getMinZoom() > z || z > tileGrid.getMaxZoom()) return false;
    const tileRange = tileGrid.getFullTileRange(z);
    if (!tileRange) return true;
    return tileRange.containsXY(x, y);
}

});


parcelRegister("cGqMj", function(module, exports) {

$parcel$export(module.exports, "default", () => $93be2de6a052f587$export$2e2bcd8739ae039);
/**
 * @module ol/layer/BaseTile
 */ 
var $79s7T = parcelRequire("79s7T");

var $jDKXi = parcelRequire("jDKXi");
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|
 *   import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError'|import("../render/EventType").LayerRenderEventTypes, Return>} BaseTileLayerOnSignature
 */ /**
 * @template {import("../source/Tile.js").default} TileSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {TileSourceType} [source] Source for this layer.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../Map.js").default#addLayer map.addLayer()}.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [useInterimTilesOnError=true] Deprecated.  Use interim tiles on error.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 * @property {number} [cacheSize=512] The internal tile cache size.  This needs to be large enough to render
 * two zoom levels worth of tiles.
 */ /**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @template {import("../renderer/Layer.js").default} RendererType
 * @extends {Layer<TileSourceType, RendererType>}
 * @api
 */ class $93be2de6a052f587$var$BaseTileLayer extends (0, $79s7T.default) {
    /**
   * @param {Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        const cacheSize = options.cacheSize;
        delete options.cacheSize;
        delete baseOptions.preload;
        delete baseOptions.useInterimTilesOnError;
        super(baseOptions);
        /***
     * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {BaseTileLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {number|undefined}
     * @private
     */ this.cacheSize_ = cacheSize;
        this.setPreload(options.preload !== undefined ? options.preload : 0);
        this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined ? options.useInterimTilesOnError : true);
    }
    /**
   * @return {number|undefined} The suggested cache size
   * @protected
   */ getCacheSize() {
        return this.cacheSize_;
    }
    /**
   * Return the level as number to which we will preload tiles up to.
   * @return {number} The level to preload tiles up to.
   * @observable
   * @api
   */ getPreload() {
        return /** @type {number} */ this.get((0, $jDKXi.default).PRELOAD);
    }
    /**
   * Set the level as number to which we will preload tiles up to.
   * @param {number} preload The level to preload tiles up to.
   * @observable
   * @api
   */ setPreload(preload) {
        this.set((0, $jDKXi.default).PRELOAD, preload);
    }
    /**
   * Deprecated.  Whether we use interim tiles on error.
   * @return {boolean} Use interim tiles on error.
   * @observable
   * @api
   */ getUseInterimTilesOnError() {
        return /** @type {boolean} */ this.get((0, $jDKXi.default).USE_INTERIM_TILES_ON_ERROR);
    }
    /**
   * Deprecated.  Set whether we use interim tiles on error.
   * @param {boolean} useInterimTilesOnError Use interim tiles on error.
   * @observable
   * @api
   */ setUseInterimTilesOnError(useInterimTilesOnError) {
        this.set((0, $jDKXi.default).USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
    }
    /**
   * Get data for a pixel location.  The return type depends on the source data.  For image tiles,
   * a four element RGBA array will be returned.  For data tiles, the array length will match the
   * number of bands in the dataset.  For requests outside the layer extent, `null` will be returned.
   * Data for a image tiles can only be retrieved if the source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   * @override
   */ getData(pixel) {
        return super.getData(pixel);
    }
}
var $93be2de6a052f587$export$2e2bcd8739ae039 = $93be2de6a052f587$var$BaseTileLayer;

});
parcelRegister("jDKXi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c61536de922b84$export$2e2bcd8739ae039);
/**
 * @module ol/layer/TileProperty
 */ /**
 * @enum {string}
 */ var $e4c61536de922b84$export$2e2bcd8739ae039 = {
    PRELOAD: 'preload',
    USE_INTERIM_TILES_ON_ERROR: 'useInterimTilesOnError'
};

});



parcelRegister("9jDAx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c8498cc816f2362$export$2e2bcd8739ae039);
/**
 * @module ol/source/OSM
 */ 
var $cTF5I = parcelRequire("cTF5I");
const $6c8498cc816f2362$export$4de8a5e77eb994ad = '&#169; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors.';
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin='anonymous'] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy='origin-when-cross-origin'] The `referrerPolicy` property for loaded images.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {number} [maxZoom=19] Max zoom.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [url='https://tile.openstreetmap.org/{z}/{x}/{y}.png'] URL template.
 * Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for the OpenStreetMap tile server.
 * @api
 */ class $6c8498cc816f2362$var$OSM extends (0, $cTF5I.default) {
    /**
   * @param {Options} [options] Open Street Map options.
   */ constructor(options){
        options = options || {};
        let attributions;
        if (options.attributions !== undefined) attributions = options.attributions;
        else attributions = [
            $6c8498cc816f2362$export$4de8a5e77eb994ad
        ];
        const url = options.url !== undefined ? options.url : 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
        super({
            attributions: attributions,
            attributionsCollapsible: false,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin !== undefined ? options.crossOrigin : 'anonymous',
            referrerPolicy: options.referrerPolicy || 'origin-when-cross-origin',
            interpolate: options.interpolate,
            maxZoom: options.maxZoom !== undefined ? options.maxZoom : 19,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileLoadFunction: options.tileLoadFunction,
            transition: options.transition,
            url: url,
            wrapX: options.wrapX,
            zDirection: options.zDirection
        });
    }
}
var $6c8498cc816f2362$export$2e2bcd8739ae039 = $6c8498cc816f2362$var$OSM;

});
parcelRegister("cTF5I", function(module, exports) {

$parcel$export(module.exports, "default", () => $963a7ef65488964c$export$2e2bcd8739ae039);
/**
 * @module ol/source/XYZ
 */ 
var $7vCDj = parcelRequire("7vCDj");

var $71uyY = parcelRequire("71uyY");
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {number} [maxZoom=42] Optional max zoom level. Not used if `tileGrid` is provided.
 * @property {number} [minZoom=0] Optional min zoom level. Not used if `tileGrid` is provided.
 * @property {number} [maxResolution] Optional tile grid resolution at level zero. Not used if `tileGrid` is provided.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Deprecated.  Use an ImageTile source with a loader
 * instead.  Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service.
 * For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {number|import("../size.js").Size} [tileSize=[256, 256]] The tile size used by the tile service.
 * Not used if `tileGrid` is provided.
 * @property {number} [gutter=0] The size in pixels of the gutter around image tiles to ignore.
 * This allows artifacts of rendering at tile edges to be ignored.
 * Supported images should be wider and taller than the tile size by a value of `2 x gutter`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`,
 * and `{z}` placeholders. A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`,
 * may be used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] Deprecated.  Use an ImageTile source and provide an array of URLs for the
 * url option instead.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data with URLs in a set XYZ format that are
 * defined in a URL template. By default, this follows the widely-used
 * Google grid where `x` 0 and `y` 0 are in the top left. Grids like
 * TMS where `x` 0 and `y` 0 are in the bottom left can be used by
 * using the `{-y}` placeholder in the URL template, so long as the
 * source does not have a custom tile grid. In this case
 * a `tileUrlFunction` can be used, such as:
 * ```js
 *  tileUrlFunction: function(coordinate) {
 *    return 'http://mapserver.com/' + coordinate[0] + '/' +
 *      coordinate[1] + '/' + (-coordinate[2] - 1) + '.png';
 *  }
 * ```
 * @api
 */ class $963a7ef65488964c$var$XYZ extends (0, $71uyY.default) {
    /**
   * @param {Options} [options] XYZ options.
   */ constructor(options){
        options = options || {};
        const projection = options.projection !== undefined ? options.projection : 'EPSG:3857';
        const tileGrid = options.tileGrid !== undefined ? options.tileGrid : (0, $7vCDj.createXYZ)({
            extent: (0, $7vCDj.extentFromProjection)(projection),
            maxResolution: options.maxResolution,
            maxZoom: options.maxZoom,
            minZoom: options.minZoom,
            tileSize: options.tileSize
        });
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            referrerPolicy: options.referrerPolicy,
            interpolate: options.interpolate,
            projection: projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {number}
     */ this.gutter_ = options.gutter !== undefined ? options.gutter : 0;
    }
    /**
   * @return {number} Gutter.
   * @override
   */ getGutter() {
        return this.gutter_;
    }
}
var $963a7ef65488964c$export$2e2bcd8739ae039 = $963a7ef65488964c$var$XYZ;

});
parcelRegister("7vCDj", function(module, exports) {

$parcel$export(module.exports, "getForProjection", () => $5779655d81caea04$export$1f4812384df8a9c5);
$parcel$export(module.exports, "wrapX", () => $5779655d81caea04$export$39a9ce3624977b84);
$parcel$export(module.exports, "extentFromProjection", () => $5779655d81caea04$export$7b5b6ef8fd55fac4);
$parcel$export(module.exports, "createXYZ", () => $5779655d81caea04$export$38500bbeccc864ff);
/**
 * @module ol/tilegrid
 */ 
var $9pD6L = parcelRequire("9pD6L");

var $dpRHA = parcelRequire("dpRHA");
var $kUyy5 = parcelRequire("kUyy5");

var $hxhPO = parcelRequire("hxhPO");

var $g5oyO = parcelRequire("g5oyO");

var $7xn5x = parcelRequire("7xn5x");

function $5779655d81caea04$export$1f4812384df8a9c5(projection) {
    let tileGrid = projection.getDefaultTileGrid();
    if (!tileGrid) {
        tileGrid = $5779655d81caea04$export$a251b12f5601c16f(projection);
        projection.setDefaultTileGrid(tileGrid);
    }
    return tileGrid;
}
function $5779655d81caea04$export$39a9ce3624977b84(tileGrid, tileCoord, projection) {
    const z = tileCoord[0];
    const center = tileGrid.getTileCoordCenter(tileCoord);
    const projectionExtent = $5779655d81caea04$export$7b5b6ef8fd55fac4(projection);
    if (!(0, $9pD6L.containsCoordinate)(projectionExtent, center)) {
        const worldWidth = (0, $9pD6L.getWidth)(projectionExtent);
        const worldsAway = Math.ceil((projectionExtent[0] - center[0]) / worldWidth);
        center[0] += worldWidth * worldsAway;
        return tileGrid.getTileCoordForCoordAndZ(center, z);
    }
    return tileCoord;
}
function $5779655d81caea04$export$ce88871416242df8(extent, maxZoom, tileSize, corner) {
    corner = corner !== undefined ? corner : 'top-left';
    const resolutions = $5779655d81caea04$var$resolutionsFromExtent(extent, maxZoom, tileSize);
    return new (0, $g5oyO.default)({
        extent: extent,
        origin: (0, $9pD6L.getCorner)(extent, corner),
        resolutions: resolutions,
        tileSize: tileSize
    });
}
function $5779655d81caea04$export$38500bbeccc864ff(options) {
    const xyzOptions = options || {};
    const extent = xyzOptions.extent || (0, $dpRHA.get)('EPSG:3857').getExtent();
    const gridOptions = {
        extent: extent,
        minZoom: xyzOptions.minZoom,
        tileSize: xyzOptions.tileSize,
        resolutions: $5779655d81caea04$var$resolutionsFromExtent(extent, xyzOptions.maxZoom, xyzOptions.tileSize, xyzOptions.maxResolution)
    };
    return new (0, $g5oyO.default)(gridOptions);
}
/**
 * Create a resolutions array from an extent.  A zoom factor of 2 is assumed.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} [maxZoom] Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size} [tileSize] Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @param {number} [maxResolution] Resolution at level zero.
 * @return {!Array<number>} Resolutions array.
 */ function $5779655d81caea04$var$resolutionsFromExtent(extent, maxZoom, tileSize, maxResolution) {
    maxZoom = maxZoom !== undefined ? maxZoom : (0, $7xn5x.DEFAULT_MAX_ZOOM);
    tileSize = (0, $hxhPO.toSize)(tileSize !== undefined ? tileSize : (0, $7xn5x.DEFAULT_TILE_SIZE));
    const height = (0, $9pD6L.getHeight)(extent);
    const width = (0, $9pD6L.getWidth)(extent);
    maxResolution = maxResolution > 0 ? maxResolution : Math.max(width / tileSize[0], height / tileSize[1]);
    const length = maxZoom + 1;
    const resolutions = new Array(length);
    for(let z = 0; z < length; ++z)resolutions[z] = maxResolution / Math.pow(2, z);
    return resolutions;
}
function $5779655d81caea04$export$a251b12f5601c16f(projection, maxZoom, tileSize, corner) {
    const extent = $5779655d81caea04$export$7b5b6ef8fd55fac4(projection);
    return $5779655d81caea04$export$ce88871416242df8(extent, maxZoom, tileSize, corner);
}
function $5779655d81caea04$export$7b5b6ef8fd55fac4(projection) {
    projection = (0, $dpRHA.get)(projection);
    let extent = projection.getExtent();
    if (!extent) {
        const half = 180 * (0, $kUyy5.METERS_PER_UNIT).degrees / projection.getMetersPerUnit();
        extent = (0, $9pD6L.createOrUpdate)(-half, -half, half, half);
    }
    return extent;
}

});
parcelRegister("g5oyO", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb602a307ef98bb5$export$2e2bcd8739ae039);
/**
 * @module ol/tilegrid/TileGrid
 */ 
var $7iKy2 = parcelRequire("7iKy2");

var $fVVyM = parcelRequire("fVVyM");

var $4Cz58 = parcelRequire("4Cz58");

var $9pD6L = parcelRequire("9pD6L");

var $eQvue = parcelRequire("eQvue");

var $9byFX = parcelRequire("9byFX");

var $hxhPO = parcelRequire("hxhPO");

var $gpyQY = parcelRequire("gpyQY");

var $7xn5x = parcelRequire("7xn5x");
/**
 * @private
 * @type {import("../tilecoord.js").TileCoord}
 */ const $bb602a307ef98bb5$var$tmpTileCoord = [
    0,
    0,
    0
];
/**
 * Number of decimal digits to consider in integer values when rounding.
 * @type {number}
 */ const $bb602a307ef98bb5$var$DECIMALS = 5;
/**
 * @typedef {Object} Options
 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles outside this
 * extent will be requested by {@link module:ol/source/Tile~TileSource} sources. When no `origin` or
 * `origins` are configured, the `origin` will be set to the top-left corner of the extent.
 * @property {number} [minZoom=0] Minimum zoom.
 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e. where the `x`
 * and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left to right and downwards. If not
 * specified, `extent` or `origins` must be provided.
 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins, i.e. where
 * the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * origin. Tile coordinates increase left to right and downwards. If not specified, `extent` or
 * `origin` must be provided.
 * @property {!Array<number>} resolutions Resolutions. The array index of each resolution needs
 * to match the zoom level. This means that even if a `minZoom` is configured, the resolutions
 * array will have a length of `maxZoom + 1`.
 * @property {Array<import("../size.js").Size>} [sizes] Number of tile rows and columns
 * of the grid for each zoom level. If specified the values
 * define each zoom level's extent together with the `origin` or `origins`.
 * A grid `extent` can be configured in addition, and will further limit the extent
 * for which tile requests are made by sources. If the bottom-left corner of
 * an extent is used as `origin` or `origins`, then the `y` value must be
 * negative because OpenLayers tile coordinates use the top left as the origin.
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * Default is `[256, 256]`.
 * @property {Array<number|import("../size.js").Size>} [tileSizes] Tile sizes. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * tile size.
 */ /**
 * @classdesc
 * Base class for setting the grid pattern for sources accessing tiled-image
 * servers.
 * @api
 */ class $bb602a307ef98bb5$var$TileGrid {
    /**
   * @param {Options} options Tile grid options.
   */ constructor(options){
        /**
     * @protected
     * @type {number}
     */ this.minZoom = options.minZoom !== undefined ? options.minZoom : 0;
        /**
     * @private
     * @type {!Array<number>}
     */ this.resolutions_ = options.resolutions;
        (0, $4Cz58.assert)((0, $fVVyM.isSorted)(this.resolutions_, /**
         * @param {number} a First resolution
         * @param {number} b Second resolution
         * @return {number} Comparison result
         */ (a, b)=>b - a, true), '`resolutions` must be sorted in descending order');
        // check if we've got a consistent zoom factor and origin
        let zoomFactor;
        if (!options.origins) for(let i = 0, ii = this.resolutions_.length - 1; i < ii; ++i){
            if (!zoomFactor) zoomFactor = this.resolutions_[i] / this.resolutions_[i + 1];
            else if (this.resolutions_[i] / this.resolutions_[i + 1] !== zoomFactor) {
                zoomFactor = undefined;
                break;
            }
        }
        /**
     * @private
     * @type {number|undefined}
     */ this.zoomFactor_ = zoomFactor;
        /**
     * @protected
     * @type {number}
     */ this.maxZoom = this.resolutions_.length - 1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.origin_ = options.origin !== undefined ? options.origin : null;
        /**
     * @private
     * @type {Array<import("../coordinate.js").Coordinate>}
     */ this.origins_ = null;
        if (options.origins !== undefined) {
            this.origins_ = options.origins;
            (0, $4Cz58.assert)(this.origins_.length == this.resolutions_.length, 'Number of `origins` and `resolutions` must be equal');
        }
        const extent = options.extent;
        if (extent !== undefined && !this.origin_ && !this.origins_) this.origin_ = (0, $9pD6L.getTopLeft)(extent);
        (0, $4Cz58.assert)(!this.origin_ && this.origins_ || this.origin_ && !this.origins_, 'Either `origin` or `origins` must be configured, never both');
        /**
     * @private
     * @type {Array<number|import("../size.js").Size>}
     */ this.tileSizes_ = null;
        if (options.tileSizes !== undefined) {
            this.tileSizes_ = options.tileSizes;
            (0, $4Cz58.assert)(this.tileSizes_.length == this.resolutions_.length, 'Number of `tileSizes` and `resolutions` must be equal');
        }
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.tileSize_ = options.tileSize !== undefined ? options.tileSize : !this.tileSizes_ ? (0, $7xn5x.DEFAULT_TILE_SIZE) : null;
        (0, $4Cz58.assert)(!this.tileSize_ && this.tileSizes_ || this.tileSize_ && !this.tileSizes_, 'Either `tileSize` or `tileSizes` must be configured, never both');
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = extent !== undefined ? extent : null;
        /**
     * @private
     * @type {Array<import("../TileRange.js").default>}
     */ this.fullTileRanges_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.tmpSize_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.tmpExtent_ = [
            0,
            0,
            0,
            0
        ];
        if (options.sizes !== undefined) this.fullTileRanges_ = options.sizes.map((size, z)=>{
            const tileRange = new (0, $7iKy2.default)(Math.min(0, size[0]), Math.max(size[0] - 1, -1), Math.min(0, size[1]), Math.max(size[1] - 1, -1));
            if (extent) {
                const restrictedTileRange = this.getTileRangeForExtentAndZ(extent, z);
                tileRange.minX = Math.max(restrictedTileRange.minX, tileRange.minX);
                tileRange.maxX = Math.min(restrictedTileRange.maxX, tileRange.maxX);
                tileRange.minY = Math.max(restrictedTileRange.minY, tileRange.minY);
                tileRange.maxY = Math.min(restrictedTileRange.maxY, tileRange.maxY);
            }
            return tileRange;
        });
        else if (extent) this.calculateTileRanges_(extent);
    }
    /**
   * Call a function with each tile coordinate for a given extent and zoom level.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} zoom Integer zoom level.
   * @param {function(import("../tilecoord.js").TileCoord): void} callback Function called with each tile coordinate.
   * @api
   */ forEachTileCoord(extent, zoom, callback) {
        const tileRange = this.getTileRangeForExtentAndZ(extent, zoom);
        for(let i = tileRange.minX, ii = tileRange.maxX; i <= ii; ++i)for(let j = tileRange.minY, jj = tileRange.maxY; j <= jj; ++j)callback([
            zoom,
            i,
            j
        ]);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {function(number, import("../TileRange.js").default): boolean} callback Callback.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {boolean} Callback succeeded.
   */ forEachTileCoordParentTileRange(tileCoord, callback, tempTileRange, tempExtent) {
        let tileRange, x, y;
        let tileCoordExtent = null;
        let z = tileCoord[0] - 1;
        if (this.zoomFactor_ === 2) {
            x = tileCoord[1];
            y = tileCoord[2];
        } else tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent);
        while(z >= this.minZoom){
            if (x !== undefined && y !== undefined) {
                x = Math.floor(x / 2);
                y = Math.floor(y / 2);
                tileRange = (0, $7iKy2.createOrUpdate)(x, x, y, y, tempTileRange);
            } else tileRange = this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
            if (callback(z, tileRange)) return true;
            --z;
        }
        return false;
    }
    /**
   * Get the extent for this tile grid, if it was configured.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the maximum zoom level for the grid.
   * @return {number} Max zoom.
   * @api
   */ getMaxZoom() {
        return this.maxZoom;
    }
    /**
   * Get the minimum zoom level for the grid.
   * @return {number} Min zoom.
   * @api
   */ getMinZoom() {
        return this.minZoom;
    }
    /**
   * Get the origin for the grid at the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {import("../coordinate.js").Coordinate} Origin.
   * @api
   */ getOrigin(z) {
        if (this.origin_) return this.origin_;
        return this.origins_[z];
    }
    /**
   * Get the list of origins for the grid.
   * @return {Array<import("../coordinate.js").Coordinate>|null} Origin.
   */ getOrigins() {
        return this.origins_;
    }
    /**
   * Get the resolution for the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {number} Resolution.
   * @api
   */ getResolution(z) {
        return this.resolutions_[z];
    }
    /**
   * Get the list of resolutions for the tile grid.
   * @return {Array<number>} Resolutions.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileCoordChildTileRange(tileCoord, tempTileRange, tempExtent) {
        if (tileCoord[0] < this.maxZoom) {
            if (this.zoomFactor_ === 2) {
                const minX = tileCoord[1] * 2;
                const minY = tileCoord[2] * 2;
                return (0, $7iKy2.createOrUpdate)(minX, minX + 1, minY, minY + 1, tempTileRange);
            }
            const tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent || this.tmpExtent_);
            return this.getTileRangeForExtentAndZ(tileCoordExtent, tileCoord[0] + 1, tempTileRange);
        }
        return null;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileRangeForTileCoordAndZ(tileCoord, z, tempTileRange) {
        if (z > this.maxZoom || z < this.minZoom) return null;
        const tileCoordZ = tileCoord[0];
        const tileCoordX = tileCoord[1];
        const tileCoordY = tileCoord[2];
        if (z === tileCoordZ) return (0, $7iKy2.createOrUpdate)(tileCoordX, tileCoordY, tileCoordX, tileCoordY, tempTileRange);
        if (this.zoomFactor_) {
            const factor = Math.pow(this.zoomFactor_, z - tileCoordZ);
            const minX = Math.floor(tileCoordX * factor);
            const minY = Math.floor(tileCoordY * factor);
            if (z < tileCoordZ) return (0, $7iKy2.createOrUpdate)(minX, minX, minY, minY, tempTileRange);
            const maxX = Math.floor(factor * (tileCoordX + 1)) - 1;
            const maxY = Math.floor(factor * (tileCoordY + 1)) - 1;
            return (0, $7iKy2.createOrUpdate)(minX, maxX, minY, maxY, tempTileRange);
        }
        const tileCoordExtent = this.getTileCoordExtent(tileCoord, this.tmpExtent_);
        return this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
    }
    /**
   * Get a tile range for the given extent and integer zoom level.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary tile range object.
   * @return {import("../TileRange.js").default} Tile range.
   */ getTileRangeForExtentAndZ(extent, z, tempTileRange) {
        this.getTileCoordForXYAndZ_(extent[0], extent[3], z, false, $bb602a307ef98bb5$var$tmpTileCoord);
        const minX = $bb602a307ef98bb5$var$tmpTileCoord[1];
        const minY = $bb602a307ef98bb5$var$tmpTileCoord[2];
        this.getTileCoordForXYAndZ_(extent[2], extent[1], z, true, $bb602a307ef98bb5$var$tmpTileCoord);
        const maxX = $bb602a307ef98bb5$var$tmpTileCoord[1];
        const maxY = $bb602a307ef98bb5$var$tmpTileCoord[2];
        return (0, $7iKy2.createOrUpdate)(minX, maxX, minY, maxY, tempTileRange);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {import("../coordinate.js").Coordinate} Tile center.
   */ getTileCoordCenter(tileCoord) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, $hxhPO.toSize)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        return [
            origin[0] + (tileCoord[1] + 0.5) * tileSize[0] * resolution,
            origin[1] - (tileCoord[2] + 0.5) * tileSize[1] * resolution
        ];
    }
    /**
   * Get the extent of a tile coordinate.
   *
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary extent object.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getTileCoordExtent(tileCoord, tempExtent) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, $hxhPO.toSize)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        const minX = origin[0] + tileCoord[1] * tileSize[0] * resolution;
        const minY = origin[1] - (tileCoord[2] + 1) * tileSize[1] * resolution;
        const maxX = minX + tileSize[0] * resolution;
        const maxY = minY + tileSize[1] * resolution;
        return (0, $9pD6L.createOrUpdate)(minX, minY, maxX, maxY, tempExtent);
    }
    /**
   * Get the tile coordinate for the given map coordinate and resolution.  This
   * method considers that coordinates that intersect tile boundaries should be
   * assigned the higher tile coordinate.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndResolution(coordinate, resolution, opt_tileCoord) {
        return this.getTileCoordForXYAndResolution_(coordinate[0], coordinate[1], resolution, false, opt_tileCoord);
    }
    /**
   * Note that this method should not be called for resolutions that correspond
   * to an integer zoom level.  Instead call the `getTileCoordForXYAndZ_` method.
   * @param {number} x X.
   * @param {number} y Y.
   * @param {number} resolution Resolution (for a non-integer zoom level).
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndResolution_(x, y, resolution, reverseIntersectionPolicy, opt_tileCoord) {
        const z = this.getZForResolution(resolution);
        const scale = resolution / this.getResolution(z);
        const origin = this.getOrigin(z);
        const tileSize = (0, $hxhPO.toSize)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = scale * (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = scale * (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $9byFX.ceil)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS) - 1;
            tileCoordY = (0, $9byFX.ceil)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $9byFX.floor)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS);
            tileCoordY = (0, $9byFX.floor)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS);
        }
        return (0, $gpyQY.createOrUpdate)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Although there is repetition between this method and `getTileCoordForXYAndResolution_`,
   * they should have separate implementations.  This method is for integer zoom
   * levels.  The other method should only be called for resolutions corresponding
   * to non-integer zoom levels.
   * @param {number} x Map x coordinate.
   * @param {number} y Map y coordinate.
   * @param {number} z Integer zoom level.
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndZ_(x, y, z, reverseIntersectionPolicy, opt_tileCoord) {
        const origin = this.getOrigin(z);
        const resolution = this.getResolution(z);
        const tileSize = (0, $hxhPO.toSize)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $9byFX.ceil)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS) - 1;
            tileCoordY = (0, $9byFX.ceil)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $9byFX.floor)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS);
            tileCoordY = (0, $9byFX.floor)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS);
        }
        return (0, $gpyQY.createOrUpdate)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Get a tile coordinate given a map coordinate and zoom level.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} z Integer zoom level, e.g. the result of a `getZForResolution()` method call
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndZ(coordinate, z, opt_tileCoord) {
        return this.getTileCoordForXYAndZ_(coordinate[0], coordinate[1], z, false, opt_tileCoord);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {number} Tile resolution.
   */ getTileCoordResolution(tileCoord) {
        return this.resolutions_[tileCoord[0]];
    }
    /**
   * Get the tile size for a zoom level. The type of the return value matches the
   * `tileSize` or `tileSizes` that the tile grid was configured with. To always
   * get an {@link import("../size.js").Size}, run the result through {@link module:ol/size.toSize}.
   * @param {number} z Z.
   * @return {number|import("../size.js").Size} Tile size.
   * @api
   */ getTileSize(z) {
        if (this.tileSize_) return this.tileSize_;
        return this.tileSizes_[z];
    }
    /**
   * @param {number} z Zoom level.
   * @return {import("../TileRange.js").default|null} Extent tile range for the specified zoom level.
   */ getFullTileRange(z) {
        if (!this.fullTileRanges_) return this.extent_ ? this.getTileRangeForExtentAndZ(this.extent_, z) : null;
        return this.fullTileRanges_[z];
    }
    /**
   * @param {number} resolution Resolution.
   * @param {number|import("../array.js").NearestDirectionFunction} [opt_direction]
   *     If 0, the nearest resolution will be used.
   *     If 1, the nearest higher resolution (lower Z) will be used. If -1, the
   *     nearest lower resolution (higher Z) will be used. Default is 0.
   *     Use a {@link module:ol/array~NearestDirectionFunction} for more precise control.
   *
   * For example to change tile Z at the midpoint of zoom levels
   * ```js
   * function(value, high, low) {
   *   return value - low * Math.sqrt(high / low);
   * }
   * ```
   * @return {number} Z.
   * @api
   */ getZForResolution(resolution, opt_direction) {
        const z = (0, $fVVyM.linearFindNearest)(this.resolutions_, resolution, opt_direction || 0);
        return (0, $9byFX.clamp)(z, this.minZoom, this.maxZoom);
    }
    /**
   * The tile with the provided tile coordinate intersects the given viewport.
   * @param {import('../tilecoord.js').TileCoord} tileCoord Tile coordinate.
   * @param {Array<number>} viewport Viewport as returned from {@link module:ol/extent.getRotatedViewport}.
   * @return {boolean} The tile with the provided tile coordinate intersects the given viewport.
   */ tileCoordIntersectsViewport(tileCoord, viewport) {
        return (0, $eQvue.intersectsLinearRing)(viewport, 0, viewport.length, 2, this.getTileCoordExtent(tileCoord));
    }
    /**
   * @param {!import("../extent.js").Extent} extent Extent for this tile grid.
   * @private
   */ calculateTileRanges_(extent) {
        const length = this.resolutions_.length;
        const fullTileRanges = new Array(length);
        for(let z = this.minZoom; z < length; ++z)fullTileRanges[z] = this.getTileRangeForExtentAndZ(extent, z);
        this.fullTileRanges_ = fullTileRanges;
    }
}
var $bb602a307ef98bb5$export$2e2bcd8739ae039 = $bb602a307ef98bb5$var$TileGrid;

});


parcelRegister("71uyY", function(module, exports) {

$parcel$export(module.exports, "default", () => $51d055913ca55b5e$export$2e2bcd8739ae039);
/**
 * @module ol/source/TileImage
 */ 
var $hCs6p = parcelRequire("hCs6p");

var $fOhwi = parcelRequire("fOhwi");

var $3xzSb = parcelRequire("3xzSb");

var $8UoiJ = parcelRequire("8UoiJ");

var $dpRHA = parcelRequire("dpRHA");

var $4WmJ3 = parcelRequire("4WmJ3");

var $gpyQY = parcelRequire("gpyQY");

var $7vCDj = parcelRequire("7vCDj");

var $9iPUS = parcelRequire("9iPUS");

var $jLCO3 = parcelRequire("jLCO3");
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("./Source.js").State} [state] Source state.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service. For example, if the tile
 * service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX] Whether to wrap the world horizontally. The default, is to
 * request out-of-bounds tiles from the server. When set to `false`, only one
 * world will be rendered. When set to `true`, tiles will be requested for one
 * world only, but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [key] Optional tile key for proper cache fetching
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @deprecated Use the ol/source/ImageTile.js instead.
 *
 * @fires import("./Tile.js").TileSourceEvent
 * @api
 */ class $51d055913ca55b5e$var$TileImage extends (0, $jLCO3.default) {
    /**
   * @param {!Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction ? options.tileLoadFunction : $51d055913ca55b5e$export$bf0e2e44d1d59b25,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate !== undefined ? options.interpolate : true,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @protected
     * @type {?string}
     */ this.crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @protected
     * @type {ReferrerPolicy}
     */ this.referrerPolicy = options.referrerPolicy;
        /**
     * @protected
     * @type {typeof ImageTile}
     */ this.tileClass = options.tileClass !== undefined ? options.tileClass : (0, $hCs6p.default);
        /**
     * @protected
     * @type {!Object<string, import("../tilegrid/TileGrid.js").default>}
     */ this.tileGridForProjection = {};
        /**
     * @private
     * @type {number|undefined}
     */ this.reprojectionErrorThreshold_ = options.reprojectionErrorThreshold;
        /**
     * @private
     * @type {boolean}
     */ this.renderReprojectionEdges_ = false;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   * @override
   */ getGutterForProjection(projection) {
        if (this.getProjection() && projection && !(0, $dpRHA.equivalent)(this.getProjection(), projection)) return 0;
        return this.getGutter();
    }
    /**
   * @return {number} Gutter.
   */ getGutter() {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   * @override
   */ getKey() {
        let key = super.getKey();
        if (!this.getInterpolate()) key += ':disable-interpolation';
        return key;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   * @override
   */ getTileGridForProjection(projection) {
        const thisProj = this.getProjection();
        if (this.tileGrid && (!thisProj || (0, $dpRHA.equivalent)(thisProj, projection))) return this.tileGrid;
        const projKey = (0, $9iPUS.getUid)(projection);
        if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = (0, $7vCDj.getForProjection)(projection);
        return this.tileGridForProjection[projKey];
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {string} key The key set on the tile.
   * @return {!ImageTile} Tile.
   * @private
   */ createTile_(z, x, y, pixelRatio, projection, key) {
        const tileCoord = [
            z,
            x,
            y
        ];
        const urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const tileUrl = urlTileCoord ? this.tileUrlFunction(urlTileCoord, pixelRatio, projection) : undefined;
        const tile = new this.tileClass(tileCoord, tileUrl !== undefined ? (0, $fOhwi.default).IDLE : (0, $fOhwi.default).EMPTY, tileUrl !== undefined ? tileUrl : '', {
            crossOrigin: this.crossOrigin,
            referrerPolicy: this.referrerPolicy
        }, this.tileLoadFunction, this.tileOptions);
        tile.key = key;
        tile.addEventListener((0, $3xzSb.default).CHANGE, this.handleTileChange.bind(this));
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {import("../structs/LRUCache.js").default<import("../Tile.js").default>} [tileCache] Tile cache.
   * @return {!(ImageTile|ReprojTile)} Tile.
   * @override
   */ getTile(z, x, y, pixelRatio, projection, tileCache) {
        const sourceProjection = this.getProjection();
        if (!sourceProjection || !projection || (0, $dpRHA.equivalent)(sourceProjection, projection)) return this.getTileInternal(z, x, y, pixelRatio, sourceProjection || projection);
        const tileCoord = [
            z,
            x,
            y
        ];
        const key = this.getKey();
        const sourceTileGrid = this.getTileGridForProjection(sourceProjection);
        const targetTileGrid = this.getTileGridForProjection(projection);
        const wrappedTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const tile = new (0, $4WmJ3.default)(sourceProjection, sourceTileGrid, projection, targetTileGrid, tileCoord, wrappedTileCoord, this.getTilePixelRatio(pixelRatio), this.getGutter(), (z, x, y, pixelRatio)=>this.getTileInternal(z, x, y, pixelRatio, sourceProjection, tileCache), this.reprojectionErrorThreshold_, this.renderReprojectionEdges_, this.tileOptions);
        tile.key = key;
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {!import("../proj/Projection.js").default} projection Projection.
   * @param {import("../structs/LRUCache.js").default<import("../Tile.js").default>} [tileCache] Tile cache.
   * @return {!ImageTile} Tile.
   * @protected
   */ getTileInternal(z, x, y, pixelRatio, projection, tileCache) {
        const key = this.getKey();
        const cacheKey = (0, $gpyQY.getCacheKey)(this, key, z, x, y);
        if (tileCache && tileCache.containsKey(cacheKey)) {
            const tile = /** @type {!ImageTile} */ tileCache.get(cacheKey);
            return tile;
        }
        const tile = this.createTile_(z, x, y, pixelRatio, projection, key);
        tileCache?.set(cacheKey, tile);
        return tile;
    }
    /**
   * Sets whether to render reprojection edges or not (usually for debugging).
   * @param {boolean} render Render the edges.
   * @api
   */ setRenderReprojectionEdges(render) {
        if (this.renderReprojectionEdges_ == render) return;
        this.renderReprojectionEdges_ = render;
        this.changed();
    }
    /**
   * Sets the tile grid to use when reprojecting the tiles to the given
   * projection instead of the default tile grid for the projection.
   *
   * This can be useful when the default tile grid cannot be created
   * (e.g. projection has no extent defined) or
   * for optimization reasons (custom tile size, resolutions, ...).
   *
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
   * @api
   */ setTileGridForProjection(projection, tilegrid) {
        const proj = (0, $dpRHA.get)(projection);
        if (proj) {
            const projKey = (0, $9iPUS.getUid)(proj);
            if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = tilegrid;
        }
    }
}
function $51d055913ca55b5e$export$bf0e2e44d1d59b25(imageTile, src) {
    if (0, $8UoiJ.WORKER_OFFSCREEN_CANVAS) {
        // special treatment for offscreen canvas
        const crossOrigin = imageTile.getCrossOrigin();
        /** @type {RequestMode} */ let mode = 'same-origin';
        /** @type {RequestCredentials} */ let credentials = 'same-origin';
        if (crossOrigin === 'anonymous' || crossOrigin === '') {
            mode = 'cors';
            credentials = 'omit';
        } else if (crossOrigin === 'use-credentials') {
            mode = 'cors';
            credentials = 'include';
        }
        const options = {
            mode: mode,
            credentials: credentials,
            referrerPolicy: imageTile.getReferrerPolicy()
        };
        fetch(src, options).then((response)=>{
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.blob();
        }).then((blob)=>{
            return createImageBitmap(blob);
        }).then((imageBitmap)=>{
            const canvas = imageTile.getImage();
            canvas.width = imageBitmap.width;
            canvas.height = imageBitmap.height;
            const ctx = /** @type {OffscreenCanvas} */ canvas.getContext('2d');
            ctx.drawImage(imageBitmap, 0, 0);
            imageBitmap.close?.();
            // mock the image 'load' event
            canvas.dispatchEvent(new Event('load'));
        }).catch(()=>{
            const canvas = imageTile.getImage();
            canvas.dispatchEvent(new Event('error'));
        });
        return;
    }
    /** @type {HTMLImageElement|HTMLVideoElement} */ imageTile.getImage().src = src;
}
var $51d055913ca55b5e$export$2e2bcd8739ae039 = $51d055913ca55b5e$var$TileImage;

});
parcelRegister("jLCO3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6408236331c2614$export$2e2bcd8739ae039);
/**
 * @module ol/source/UrlTile
 */ 
var $fOhwi = parcelRequire("fOhwi");

var $cwqvp = parcelRequire("cwqvp");

var $8jyNP = parcelRequire("8jyNP");

var $9iPUS = parcelRequire("9iPUS");

var $d5XIU = parcelRequire("d5XIU");

var $aPYls = parcelRequire("aPYls");
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {import("../Tile.js").LoadFunction} tileLoadFunction TileLoadFunction.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] Url.
 * @property {Array<string>} [urls] Urls.
 * @property {boolean} [wrapX=true] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @deprecated Use the ol/source/ImageTile.js instead.
 *
 * @fires import("./Tile.js").TileSourceEvent
 */ class $e6408236331c2614$var$UrlTile extends (0, $d5XIU.default) {
    /**
   * @param {Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tilePixelRatio: options.tilePixelRatio,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {boolean}
     */ this.generateTileUrlFunction_ = this.tileUrlFunction === $e6408236331c2614$var$UrlTile.prototype.tileUrlFunction;
        /**
     * @protected
     * @type {import("../Tile.js").LoadFunction}
     */ this.tileLoadFunction = options.tileLoadFunction;
        if (options.tileUrlFunction) this.tileUrlFunction = options.tileUrlFunction;
        /**
     * @protected
     * @type {!Array<string>|null}
     */ this.urls = null;
        if (options.urls) this.setUrls(options.urls);
        else if (options.url) this.setUrl(options.url);
        /**
     * @private
     * @type {!Object<string, boolean>}
     */ this.tileLoadingKeys_ = {};
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the tile load function of the source.
   * @return {import("../Tile.js").LoadFunction} TileLoadFunction
   * @api
   */ getTileLoadFunction() {
        return this.tileLoadFunction;
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the tile URL function of the source.
   * @return {import("../Tile.js").UrlFunction} TileUrlFunction
   * @api
   */ getTileUrlFunction() {
        return Object.getPrototypeOf(this).tileUrlFunction === this.tileUrlFunction ? this.tileUrlFunction.bind(this) : this.tileUrlFunction;
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the URLs used for this source.
   * When a tileUrlFunction is used instead of url or urls,
   * null will be returned.
   * @return {!Array<string>|null} URLs.
   * @api
   */ getUrls() {
        return this.urls;
    }
    /**
   * Handle tile change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("../Tile.js").default} */ event.target;
        const uid = (0, $9iPUS.getUid)(tile);
        const tileState = tile.getState();
        let type;
        if (tileState == (0, $fOhwi.default).LOADING) {
            this.tileLoadingKeys_[uid] = true;
            type = (0, $aPYls.default).TILELOADSTART;
        } else if (uid in this.tileLoadingKeys_) {
            delete this.tileLoadingKeys_[uid];
            type = tileState == (0, $fOhwi.default).ERROR ? (0, $aPYls.default).TILELOADERROR : tileState == (0, $fOhwi.default).LOADED ? (0, $aPYls.default).TILELOADEND : undefined;
        }
        if (type != undefined) this.dispatchEvent(new (0, $d5XIU.TileSourceEvent)(type, tile));
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the tile load function of the source.
   * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @api
   */ setTileLoadFunction(tileLoadFunction) {
        this.tileLoadFunction = tileLoadFunction;
        this.changed();
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the tile URL function of the source.
   * @param {import("../Tile.js").UrlFunction} tileUrlFunction Tile URL function.
   * @param {string} [key] Optional new tile key for the source.
   * @api
   */ setTileUrlFunction(tileUrlFunction, key) {
        this.tileUrlFunction = tileUrlFunction;
        if (typeof key !== 'undefined') this.setKey(key);
        else this.changed();
    }
    /**
   * Set the URL to use for requests.
   * @param {string} url URL.
   * @api
   */ setUrl(url) {
        const urls = (0, $8jyNP.expandUrl)(url);
        this.urls = urls;
        this.setUrls(urls);
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the URLs to use for requests.
   * @param {Array<string>} urls URLs.
   * @api
   */ setUrls(urls) {
        this.urls = urls;
        const key = urls.join('\n');
        if (this.generateTileUrlFunction_) this.setTileUrlFunction((0, $cwqvp.createFromTemplates)(urls, this.tileGrid), key);
        else this.setKey(key);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {string|undefined} Tile URL.
   */ tileUrlFunction(tileCoord, pixelRatio, projection) {
        return undefined;
    }
}
var $e6408236331c2614$export$2e2bcd8739ae039 = $e6408236331c2614$var$UrlTile;

});
parcelRegister("cwqvp", function(module, exports) {

$parcel$export(module.exports, "createFromTemplates", () => $91dd08a0f5859882$export$436f44dbcc31fea3);
/**
 * @module ol/tileurlfunction
 */ 
var $9byFX = parcelRequire("9byFX");

var $gpyQY = parcelRequire("gpyQY");

var $8jyNP = parcelRequire("8jyNP");
function $91dd08a0f5859882$export$f0ecb46e90798741(template, tileGrid) {
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        let maxY;
        const z = tileCoord[0];
        if (tileGrid) {
            // The `{-y}` placeholder only works for sources that have a tile grid at construction
            const range = tileGrid.getFullTileRange(z);
            if (range) maxY = range.getHeight() - 1;
        }
        return (0, $8jyNP.renderXYZTemplate)(template, z, tileCoord[1], tileCoord[2], maxY);
    });
}
function $91dd08a0f5859882$export$436f44dbcc31fea3(templates, tileGrid) {
    const len = templates.length;
    const tileUrlFunctions = new Array(len);
    for(let i = 0; i < len; ++i)tileUrlFunctions[i] = $91dd08a0f5859882$export$f0ecb46e90798741(templates[i], tileGrid);
    return $91dd08a0f5859882$export$4229b1d9af69b3be(tileUrlFunctions);
}
function $91dd08a0f5859882$export$4229b1d9af69b3be(tileUrlFunctions) {
    if (tileUrlFunctions.length === 1) return tileUrlFunctions[0];
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        const h = (0, $gpyQY.hash)(tileCoord);
        const index = (0, $9byFX.modulo)(h, tileUrlFunctions.length);
        return tileUrlFunctions[index](tileCoord, pixelRatio, projection);
    });
}
function $91dd08a0f5859882$export$fab585f002f634a1(tileCoord, pixelRatio, projection) {
    return undefined;
}

});
parcelRegister("8jyNP", function(module, exports) {

$parcel$export(module.exports, "renderXYZTemplate", () => $60db182c0252e220$export$df1e52f1b5b1c86f);
$parcel$export(module.exports, "expandUrl", () => $60db182c0252e220$export$2a1fa079bfd73dde);
/**
 * @module ol/uri
 */ 
var $9byFX = parcelRequire("9byFX");

var $gpyQY = parcelRequire("gpyQY");
function $60db182c0252e220$export$c202e3cb8db99a95(uri, params) {
    /** @type {Array<string>} */ const keyParams = [];
    // Skip any null or undefined parameter values
    Object.keys(params).forEach(function(k) {
        if (params[k] !== null && params[k] !== undefined) keyParams.push(k + '=' + encodeURIComponent(params[k]));
    });
    const qs = keyParams.join('&');
    // remove any trailing ? or &
    uri = uri.replace(/[?&]$/, '');
    // append ? or & depending on whether uri has existing parameters
    uri += uri.includes('?') ? '&' : '?';
    return uri + qs;
}
const $60db182c0252e220$var$zRegEx = /\{z\}/g;
const $60db182c0252e220$var$xRegEx = /\{x\}/g;
const $60db182c0252e220$var$yRegEx = /\{y\}/g;
const $60db182c0252e220$var$dashYRegEx = /\{-y\}/g;
function $60db182c0252e220$export$df1e52f1b5b1c86f(template, z, x, y, maxY) {
    return template.replace($60db182c0252e220$var$zRegEx, z.toString()).replace($60db182c0252e220$var$xRegEx, x.toString()).replace($60db182c0252e220$var$yRegEx, y.toString()).replace($60db182c0252e220$var$dashYRegEx, function() {
        if (maxY === undefined) throw new Error('If the URL template has a {-y} placeholder, the grid extent must be known');
        return (maxY - y).toString();
    });
}
function $60db182c0252e220$export$83e87e683240b2e8(urls, z, x, y) {
    const hash = (0, $gpyQY.hashZXY)(z, x, y);
    const index = (0, $9byFX.modulo)(hash, urls.length);
    return urls[index];
}
function $60db182c0252e220$export$2a1fa079bfd73dde(url) {
    const urls = [];
    let match = /\{([a-z])-([a-z])\}/.exec(url);
    if (match) {
        // char range
        const startCharCode = match[1].charCodeAt(0);
        const stopCharCode = match[2].charCodeAt(0);
        let charCode;
        for(charCode = startCharCode; charCode <= stopCharCode; ++charCode)urls.push(url.replace(match[0], String.fromCharCode(charCode)));
        return urls;
    }
    match = /\{(\d+)-(\d+)\}/.exec(url);
    if (match) {
        // number range
        const stop = parseInt(match[2], 10);
        for(let i = parseInt(match[1], 10); i <= stop; i++)urls.push(url.replace(match[0], i.toString()));
        return urls;
    }
    urls.push(url);
    return urls;
}

});


parcelRegister("d5XIU", function(module, exports) {

$parcel$export(module.exports, "TileSourceEvent", () => $988a11d09320f6a8$export$c571855c51e6c4b6);
$parcel$export(module.exports, "default", () => $988a11d09320f6a8$export$2e2bcd8739ae039);
/**
 * @module ol/source/Tile
 */ 
var $f18Q2 = parcelRequire("f18Q2");

var $hxhPO = parcelRequire("hxhPO");

var $gpyQY = parcelRequire("gpyQY");

var $7vCDj = parcelRequire("7vCDj");

var $9iPUS = parcelRequire("9iPUS");

var $knPlK = parcelRequire("knPlK");
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./TileEventType").TileSourceEventTypes, TileSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./TileEventType").TileSourceEventTypes, Return>} TileSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for sources providing images divided into a tile grid.
 *
 * @template {import("../Tile.js").default} [TileType=import("../Tile.js").default]
 * @abstract
 * @api
 */ class $988a11d09320f6a8$var$TileSource extends (0, $knPlK.default) {
    /**
   * @param {Options} options SourceTile source options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            projection: options.projection,
            state: options.state,
            wrapX: options.wrapX,
            interpolate: options.interpolate
        });
        /***
     * @type {TileSourceOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {TileSourceOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {TileSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {number}
     */ this.tilePixelRatio_ = options.tilePixelRatio !== undefined ? options.tilePixelRatio : 1;
        /**
     * @type {import("../tilegrid/TileGrid.js").default|null}
     * @protected
     */ this.tileGrid = options.tileGrid !== undefined ? options.tileGrid : null;
        const tileSize = [
            256,
            256
        ];
        if (this.tileGrid) (0, $hxhPO.toSize)(this.tileGrid.getTileSize(this.tileGrid.getMinZoom()), tileSize);
        /**
     * @protected
     * @type {import("../size.js").Size}
     */ this.tmpSize = [
            0,
            0
        ];
        /**
     * @private
     * @type {string}
     */ this.key_ = options.key || (0, $9iPUS.getUid)(this);
        /**
     * @protected
     * @type {import("../Tile.js").Options}
     */ this.tileOptions = {
            transition: options.transition,
            interpolate: options.interpolate
        };
        /**
     * zDirection hint, read by the renderer. Indicates which resolution should be used
     * by a renderer if the views resolution does not match any resolution of the tile source.
     * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
     * will be used. If -1, the nearest higher resolution will be used.
     * @type {number|import("../array.js").NearestDirectionFunction}
     */ this.zDirection = options.zDirection ? options.zDirection : 0;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */ getGutterForProjection(projection) {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   */ getKey() {
        return this.key_;
    }
    /**
   * Set the value to be used as the key for all tiles in the source.
   * @param {string} key The key for tiles.
   * @protected
   */ setKey(key) {
        if (this.key_ !== key) {
            this.key_ = key;
            this.changed();
        }
    }
    /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   * @override
   */ getResolutions(projection) {
        const tileGrid = projection ? this.getTileGridForProjection(projection) : this.tileGrid;
        if (!tileGrid) return null;
        return tileGrid.getResolutions();
    }
    /**
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {import("../structs/LRUCache.js").default<import("../Tile.js").default>} [tileCache] Tile cache.
   * @return {TileType|null} Tile.
   */ getTile(z, x, y, pixelRatio, projection, tileCache) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Return the tile grid of the tile source.
   * @return {import("../tilegrid/TileGrid.js").default|null} Tile grid.
   * @api
   */ getTileGrid() {
        return this.tileGrid;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */ getTileGridForProjection(projection) {
        if (!this.tileGrid) return (0, $7vCDj.getForProjection)(projection);
        return this.tileGrid;
    }
    /**
   * Get the tile pixel ratio for this source. Subclasses may override this
   * method, which is meant to return a supported pixel ratio that matches the
   * provided `pixelRatio` as close as possible.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   */ getTilePixelRatio(pixelRatio) {
        return this.tilePixelRatio_;
    }
    /**
   * @param {number} z Z.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../size.js").Size} Tile size.
   */ getTilePixelSize(z, pixelRatio, projection) {
        const tileGrid = this.getTileGridForProjection(projection);
        const tilePixelRatio = this.getTilePixelRatio(pixelRatio);
        const tileSize = (0, $hxhPO.toSize)(tileGrid.getTileSize(z), this.tmpSize);
        if (tilePixelRatio == 1) return tileSize;
        return (0, $hxhPO.scale)(tileSize, tilePixelRatio, this.tmpSize);
    }
    /**
   * Returns a tile coordinate wrapped around the x-axis. When the tile coordinate
   * is outside the resolution and extent range of the tile grid, `null` will be
   * returned.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate to be passed to the tileUrlFunction or
   *     null if no tile URL should be created for the passed `tileCoord`.
   */ getTileCoordForTileUrlFunction(tileCoord, projection) {
        const gridProjection = projection !== undefined ? projection : this.getProjection();
        const tileGrid = projection !== undefined ? this.getTileGridForProjection(gridProjection) : this.tileGrid || this.getTileGridForProjection(gridProjection);
        if (this.getWrapX() && gridProjection.isGlobal()) tileCoord = (0, $7vCDj.wrapX)(tileGrid, tileCoord, gridProjection);
        return (0, $gpyQY.withinExtentAndZ)(tileCoord, tileGrid) ? tileCoord : null;
    }
    /**
   * Remove all cached reprojected tiles from the source. The next render cycle will create new tiles.
   * @api
   */ clear() {}
    /**
   * @override
   */ refresh() {
        this.clear();
        super.refresh();
    }
}
class $988a11d09320f6a8$export$c571855c51e6c4b6 extends (0, $f18Q2.default) {
    /**
   * @param {string} type Type.
   * @param {import("../Tile.js").default} tile The tile.
   */ constructor(type, tile){
        super(type);
        /**
     * The tile related to the event.
     * @type {import("../Tile.js").default}
     * @api
     */ this.tile = tile;
    }
}
var $988a11d09320f6a8$export$2e2bcd8739ae039 = $988a11d09320f6a8$var$TileSource;

});

parcelRegister("aPYls", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e3d7a0f8b272861$export$2e2bcd8739ae039);
/**
 * @module ol/source/TileEventType
 */ /**
 * @enum {string}
 */ var $7e3d7a0f8b272861$export$2e2bcd8739ae039 /**
 * @typedef {'tileloadstart'|'tileloadend'|'tileloaderror'} TileSourceEventTypes
 */  = {
    /**
   * Triggered when a tile starts loading.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadstart
   * @api
   */ TILELOADSTART: 'tileloadstart',
    /**
   * Triggered when a tile finishes loading, either when its data is loaded,
   * or when loading was aborted because the tile is no longer needed.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadend
   * @api
   */ TILELOADEND: 'tileloadend',
    /**
   * Triggered if tile loading results in an error. Note that this is not the
   * right place to re-fetch tiles. See {@link module:ol/ImageTile~ImageTile#load}
   * for details.
   * @event module:ol/source/Tile.TileSourceEvent#tileloaderror
   * @api
   */ TILELOADERROR: 'tileloaderror'
};

});





parcelRegister("hi5Ai", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9687314c91cf896$export$2e2bcd8739ae039);
/**
 * @module ol/control/MousePosition
 */ 
var $2o3CH = parcelRequire("2o3CH");

var $ilM9F = parcelRequire("ilM9F");

var $ijSzV = parcelRequire("ijSzV");

var $dpRHA = parcelRequire("dpRHA");

var $fVglf = parcelRequire("fVglf");
/**
 * @type {string}
 */ const $c9687314c91cf896$var$PROJECTION = 'projection';
/**
 * @type {string}
 */ const $c9687314c91cf896$var$COORDINATE_FORMAT = 'coordinateFormat';
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:coordinateFormat'|'change:projection', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:coordinateFormat'|'change:projection', Return>} MousePositionOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-mouse-position'] CSS class name.
 * @property {import("../coordinate.js").CoordinateFormat} [coordinateFormat] Coordinate format.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the
 * control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want the
 * control to be rendered outside of the map's viewport.
 * @property {string} [placeholder] Markup to show when the mouse position is not
 * available (e.g. when the pointer leaves the map viewport).  By default, a non-breaking space is rendered
 * initially and the last position is retained when the mouse leaves the viewport.
 * When a string is provided (e.g. `'no position'` or `''` for an empty string) it is used as a
 * placeholder.
 * @property {boolean} [wrapX=true] Wrap the world horizontally on the projection's antimeridian, if it
 * is a global projection.
 */ /**
 * @classdesc
 * A control to show the 2D coordinates of the mouse cursor. By default, these
 * are in the view projection, but can be in any supported projection.
 * By default the control is shown in the top right corner of the map, but this
 * can be changed by using the css selector `.ol-mouse-position`.
 *
 * On touch devices, which usually do not have a mouse cursor, the coordinates
 * of the currently touched position are shown.
 *
 * @api
 */ class $c9687314c91cf896$var$MousePosition extends (0, $fVglf.default) {
    /**
   * @param {Options} [options] Mouse position options.
   */ constructor(options){
        options = options ? options : {};
        const element = document.createElement('div');
        element.className = options.className !== undefined ? options.className : 'ol-mouse-position';
        super({
            element: element,
            render: options.render,
            target: options.target
        });
        /***
     * @type {MousePositionOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {MousePositionOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {MousePositionOnSignature<void>}
     */ this.un;
        this.addChangeListener($c9687314c91cf896$var$PROJECTION, this.handleProjectionChanged_);
        if (options.coordinateFormat) this.setCoordinateFormat(options.coordinateFormat);
        if (options.projection) this.setProjection(options.projection);
        /**
     * @private
     * @type {boolean}
     */ this.renderOnMouseOut_ = options.placeholder !== undefined;
        /**
     * @private
     * @type {string}
     */ this.placeholder_ = this.renderOnMouseOut_ ? options.placeholder : '&#160;';
        /**
     * @private
     * @type {string}
     */ this.renderedHTML_ = element.innerHTML;
        /**
     * @private
     * @type {?import("../proj/Projection.js").default}
     */ this.mapProjection_ = null;
        /**
     * @private
     * @type {?import("../proj.js").TransformFunction}
     */ this.transform_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.wrapX_ = options.wrapX === false ? false : true;
    }
    /**
   * @private
   */ handleProjectionChanged_() {
        this.transform_ = null;
    }
    /**
   * Return the coordinate format type used to render the current position or
   * undefined.
   * @return {import("../coordinate.js").CoordinateFormat|undefined} The format to render the current
   *     position in.
   * @observable
   * @api
   */ getCoordinateFormat() {
        return /** @type {import("../coordinate.js").CoordinateFormat|undefined} */ this.get($c9687314c91cf896$var$COORDINATE_FORMAT);
    }
    /**
   * Return the projection that is used to report the mouse position.
   * @return {import("../proj/Projection.js").default|undefined} The projection to report mouse
   *     position in.
   * @observable
   * @api
   */ getProjection() {
        return /** @type {import("../proj/Projection.js").default|undefined} */ this.get($c9687314c91cf896$var$PROJECTION);
    }
    /**
   * @param {MouseEvent} event Browser event.
   * @protected
   */ handleMouseMove(event) {
        const map = this.getMap();
        this.updateHTML_(map.getEventPixel(event));
    }
    /**
   * @param {Event} event Browser event.
   * @protected
   */ handleMouseOut(event) {
        this.updateHTML_(null);
    }
    /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   * @override
   */ setMap(map) {
        super.setMap(map);
        if (map) {
            const viewport = map.getViewport();
            this.listenerKeys.push((0, $ilM9F.listen)(viewport, (0, $ijSzV.default).POINTERMOVE, this.handleMouseMove, this));
            if (this.renderOnMouseOut_) this.listenerKeys.push((0, $ilM9F.listen)(viewport, (0, $ijSzV.default).POINTEROUT, this.handleMouseOut, this));
            this.updateHTML_(null);
        }
    }
    /**
   * Set the coordinate format type used to render the current position.
   * @param {import("../coordinate.js").CoordinateFormat} format The format to render the current
   *     position in.
   * @observable
   * @api
   */ setCoordinateFormat(format) {
        this.set($c9687314c91cf896$var$COORDINATE_FORMAT, format);
    }
    /**
   * Set the projection that is used to report the mouse position.
   * @param {import("../proj.js").ProjectionLike} projection The projection to report mouse
   *     position in.
   * @observable
   * @api
   */ setProjection(projection) {
        this.set($c9687314c91cf896$var$PROJECTION, (0, $dpRHA.get)(projection));
    }
    /**
   * @param {?import("../pixel.js").Pixel} pixel Pixel.
   * @private
   */ updateHTML_(pixel) {
        let html = this.placeholder_;
        if (pixel && this.mapProjection_) {
            if (!this.transform_) {
                const projection = this.getProjection();
                if (projection) this.transform_ = (0, $dpRHA.getTransformFromProjections)(this.mapProjection_, projection);
                else this.transform_ = (0, $dpRHA.identityTransform);
            }
            const map = this.getMap();
            const coordinate = map.getCoordinateFromPixelInternal(pixel);
            if (coordinate) {
                const userProjection = (0, $dpRHA.getUserProjection)();
                if (userProjection) this.transform_ = (0, $dpRHA.getTransformFromProjections)(this.mapProjection_, userProjection);
                this.transform_(coordinate, coordinate);
                if (this.wrapX_) {
                    const projection = userProjection || this.getProjection() || this.mapProjection_;
                    (0, $2o3CH.wrapX)(coordinate, projection);
                }
                const coordinateFormat = this.getCoordinateFormat();
                if (coordinateFormat) html = coordinateFormat(coordinate);
                else html = coordinate.toString();
            }
        }
        if (!this.renderedHTML_ || html !== this.renderedHTML_) {
            this.element.innerHTML = html;
            this.renderedHTML_ = html;
        }
    }
    /**
   * Update the projection. Rendering of the coordinates is done in
   * `handleMouseMove` and `handleMouseUp`.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        const frameState = mapEvent.frameState;
        if (!frameState) this.mapProjection_ = null;
        else if (this.mapProjection_ != frameState.viewState.projection) {
            this.mapProjection_ = frameState.viewState.projection;
            this.transform_ = null;
        }
    }
}
var $c9687314c91cf896$export$2e2bcd8739ae039 = $c9687314c91cf896$var$MousePosition;

});

parcelRegister("bnthu", function(module, exports) {

$parcel$export(module.exports, "default", () => $84888e4daf3fdf44$export$2e2bcd8739ae039);
/**
 * @module ol/source/Vector
 */ 
var $cD8Qe = parcelRequire("cD8Qe");

var $1TIYs = parcelRequire("1TIYs");

var $jXCUw = parcelRequire("jXCUw");

var $fVVyM = parcelRequire("fVVyM");

var $4Cz58 = parcelRequire("4Cz58");

var $f18Q2 = parcelRequire("f18Q2");

var $3xzSb = parcelRequire("3xzSb");

var $ilM9F = parcelRequire("ilM9F");

var $9pD6L = parcelRequire("9pD6L");

var $7BfFg = parcelRequire("7BfFg");

var $6wUzV = parcelRequire("6wUzV");

var $kcBeU = parcelRequire("kcBeU");

var $gn0g3 = parcelRequire("gn0g3");

var $4HUbK = parcelRequire("4HUbK");

var $4wW9x = parcelRequire("4wW9x");

var $9iPUS = parcelRequire("9iPUS");

var $knPlK = parcelRequire("knPlK");

var $hzYQp = parcelRequire("hzYQp");
class $84888e4daf3fdf44$export$d402fd02dc2b661c extends (0, $f18Q2.default) {
    /**
   * @param {string} type Type.
   * @param {FeatureType} [feature] Feature.
   * @param {Array<FeatureType>} [features] Features.
   */ constructor(type, feature, features){
        super(type);
        /**
     * The added or removed feature for the `ADDFEATURE` and `REMOVEFEATURE` events, `undefined` otherwise.
     * @type {FeatureType|undefined}
     * @api
     */ this.feature = feature;
        /**
     * The loaded features for the `FEATURESLOADED` event, `undefined` otherwise.
     * @type {Array<FeatureType>|undefined}
     * @api
     */ this.features = features;
    }
}
/***
 * @template {import("../Feature.js").FeatureLike} [T=import("../Feature.js").default]
 * @typedef {T extends RenderFeature ? T|Array<T> : T} FeatureClassOrArrayOfRenderFeatures
 */ /***
 * @template Return
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./VectorEventType").VectorSourceEventTypes, VectorSourceEvent<FeatureType>, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./VectorEventType").VectorSourceEventTypes, Return>} VectorSourceOnSignature
 */ /**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {Array<FeatureType>|Collection<FeatureType>} [features]
 * Features. If provided as {@link module:ol/Collection~Collection}, the features in the source
 * and the collection will stay in sync.
 * @property {import("../format/Feature.js").default<FeatureType>} [format] The feature format used by the XHR
 * feature loader when `url` is set. Required if `url` is set, otherwise ignored.
 * @property {import("../featureloader.js").FeatureLoader<FeatureType>} [loader]
 * The loader function used to load features, from a remote source for example.
 * If this is not set and `url` is set, the source will create and use an XHR
 * feature loader. The `'featuresloadend'` and `'featuresloaderror'` events
 * will only fire if the `success` and `failure` callbacks are used.
 *
 * Example:
 *
 * ```js
 * import Vector from 'ol/source/Vector.js';
 * import GeoJSON from 'ol/format/GeoJSON.js';
 * import {bbox} from 'ol/loadingstrategy.js';
 *
 * const vectorSource = new Vector({
 *   format: new GeoJSON(),
 *   loader: function(extent, resolution, projection, success, failure) {
 *      const proj = projection.getCode();
 *      const url = 'https://ahocevar.com/geoserver/wfs?service=WFS&' +
 *          'version=1.1.0&request=GetFeature&typename=osm:water_areas&' +
 *          'outputFormat=application/json&srsname=' + proj + '&' +
 *          'bbox=' + extent.join(',') + ',' + proj;
 *      const xhr = new XMLHttpRequest();
 *      xhr.open('GET', url);
 *      const onError = function() {
 *        vectorSource.removeLoadedExtent(extent);
 *        failure();
 *      }
 *      xhr.onerror = onError;
 *      xhr.onload = function() {
 *        if (xhr.status == 200) {
 *          const features = vectorSource.getFormat().readFeatures(xhr.responseText);
 *          vectorSource.addFeatures(features);
 *          success(features);
 *        } else {
 *          onError();
 *        }
 *      }
 *      xhr.send();
 *    },
 *    strategy: bbox,
 *  });
 * ```
 * @property {boolean} [overlaps=true] This source may have overlapping geometries.
 * Setting this to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {LoadingStrategy} [strategy] The loading strategy to use.
 * By default an {@link module:ol/loadingstrategy.all}
 * strategy is used, a one-off strategy which loads all features at once.
 * @property {string|import("../featureloader.js").FeatureUrlFunction} [url]
 * Setting this option instructs the source to load features using an XHR loader
 * (see {@link module:ol/featureloader.xhr}). Use a `string` and an
 * {@link module:ol/loadingstrategy.all} for a one-off download of all features from
 * the given URL. Use a {@link module:ol/featureloader~FeatureUrlFunction} to generate the url with
 * other loading strategies.
 * Requires `format` to be set as well.
 * When default XHR feature loader is provided, the features will
 * be transformed from the data projection to the view projection
 * during parsing. If your remote data source does not advertise its projection
 * properly, this transformation will be incorrect. For some formats, the
 * default projection (usually EPSG:4326) can be overridden by setting the
 * dataProjection constructor option on the format.
 * Note that if a source contains non-feature data, such as a GeoJSON geometry
 * or a KML NetworkLink, these will be ignored. Use a custom loader to load these.
 * @property {boolean} [useSpatialIndex=true]
 * By default, an RTree is used as spatial index. When features are removed and
 * added frequently, and the total number of features is low, setting this to
 * `false` may improve performance.
 *
 * Note that
 * {@link module:ol/source/Vector~VectorSource#getFeaturesInExtent},
 * {@link module:ol/source/Vector~VectorSource#getClosestFeatureToCoordinate} and
 * {@link module:ol/source/Vector~VectorSource#getExtent} cannot be used when `useSpatialIndex` is
 * set to `false`, and {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent} will loop
 * through all features.
 *
 * When set to `false`, the features will be maintained in an
 * {@link module:ol/Collection~Collection}, which can be retrieved through
 * {@link module:ol/source/Vector~VectorSource#getFeaturesCollection}.
 * @property {boolean} [wrapX=true] Wrap the world horizontally. For vector editing across the
 * -180° and 180° meridians to work properly, this should be set to `false`. The
 * resulting geometry coordinates will then exceed the world bounds.
 */ /**
 * @classdesc
 * Provides a source of features for vector layers. Vector features provided
 * by this source are suitable for editing. See {@link module:ol/source/VectorTile~VectorTile} for
 * vector data that is optimized for rendering.
 *
 * @fires VectorSourceEvent
 * @api
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 */ class $84888e4daf3fdf44$var$VectorSource extends (0, $knPlK.default) {
    /**
   * @param {Options<FeatureType>} [options] Vector source options.
   */ constructor(options){
        options = options || {};
        super({
            attributions: options.attributions,
            interpolate: true,
            projection: undefined,
            state: 'ready',
            wrapX: options.wrapX !== undefined ? options.wrapX : true
        });
        /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey, FeatureType>}
     */ this.on;
        /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey, FeatureType>}
     */ this.once;
        /***
     * @type {VectorSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {import("../featureloader.js").FeatureLoader<import("../Feature.js").FeatureLike>}
     */ this.loader_ = (0, $6wUzV.VOID);
        /**
     * @private
     * @type {import("../format/Feature.js").default<FeatureType>|null}
     */ this.format_ = options.format || null;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = options.overlaps === undefined ? true : options.overlaps;
        /**
     * @private
     * @type {string|import("../featureloader.js").FeatureUrlFunction|undefined}
     */ this.url_ = options.url;
        if (options.loader !== undefined) this.loader_ = options.loader;
        else if (this.url_ !== undefined) {
            (0, $4Cz58.assert)(this.format_, '`format` must be set when `url` is set');
            // create a XHR feature loader for "url" and "format"
            this.loader_ = (0, $7BfFg.xhr)(this.url_, this.format_);
        }
        /**
     * @private
     * @type {LoadingStrategy}
     */ this.strategy_ = options.strategy !== undefined ? options.strategy : (0, $kcBeU.all);
        const useSpatialIndex = options.useSpatialIndex !== undefined ? options.useSpatialIndex : true;
        /**
     * @private
     * @type {RBush<FeatureType>}
     */ this.featuresRtree_ = useSpatialIndex ? new (0, $4wW9x.default)() : null;
        /**
     * @private
     * @type {RBush<{extent: import("../extent.js").Extent}>}
     */ this.loadedExtentsRtree_ = new (0, $4wW9x.default)();
        /**
     * @type {number}
     * @private
     */ this.loadingExtentsCount_ = 0;
        /**
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.nullGeometryFeatures_ = {};
        /**
     * A lookup of features by id (the return from feature.getId()).
     * @private
     * @type {!Object<string, import('../Feature.js').FeatureLike|Array<import('../Feature.js').FeatureLike>>}
     */ this.idIndex_ = {};
        /**
     * A lookup of features by uid (using getUid(feature)).
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.uidIndex_ = {};
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.featureChangeKeys_ = {};
        /**
     * @private
     * @type {Collection<FeatureType>|null}
     */ this.featuresCollection_ = null;
        /** @type {Collection<FeatureType>} */ let collection;
        /** @type {Array<FeatureType>} */ let features;
        if (Array.isArray(options.features)) features = options.features;
        else if (options.features) {
            collection = options.features;
            features = collection.getArray();
        }
        if (!useSpatialIndex && collection === undefined) collection = new (0, $cD8Qe.default)(features);
        if (features !== undefined) this.addFeaturesInternal(features);
        if (collection !== undefined) this.bindFeaturesCollection_(collection);
    }
    /**
   * Add a single feature to the source.  If you want to add a batch of features
   * at once, call {@link module:ol/source/Vector~VectorSource#addFeatures #addFeatures()}
   * instead. A feature will not be added to the source if feature with
   * the same id is already there. The reason for this behavior is to avoid
   * feature duplication when using bbox or tile loading strategies.
   * Note: this also applies if a {@link module:ol/Collection~Collection} is used for features,
   * meaning that if a feature with a duplicate id is added in the collection, it will
   * be removed from it right away.
   * @param {FeatureType} feature Feature to add.
   * @api
   */ addFeature(feature) {
        this.addFeatureInternal(feature);
        this.changed();
    }
    /**
   * Add a feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @protected
   */ addFeatureInternal(feature) {
        const featureKey = (0, $9iPUS.getUid)(feature);
        if (!this.addToIndex_(featureKey, feature)) {
            if (this.featuresCollection_) this.featuresCollection_.remove(feature);
            return;
        }
        this.setupChangeEvents_(featureKey, feature);
        const geometry = feature.getGeometry();
        if (geometry) {
            const extent = geometry.getExtent();
            if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
        } else this.nullGeometryFeatures_[featureKey] = feature;
        this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $hzYQp.default).ADDFEATURE, feature));
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @private
   */ setupChangeEvents_(featureKey, feature) {
        if (feature instanceof (0, $4HUbK.default)) return;
        this.featureChangeKeys_[featureKey] = [
            (0, $ilM9F.listen)(feature, (0, $3xzSb.default).CHANGE, this.handleFeatureChange_, this),
            (0, $ilM9F.listen)(feature, (0, $jXCUw.default).PROPERTYCHANGE, this.handleFeatureChange_, this)
        ];
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @return {boolean} The feature is "valid", in the sense that it is also a
   *     candidate for insertion into the Rtree.
   * @private
   */ addToIndex_(featureKey, feature) {
        let valid = true;
        if (feature.getId() !== undefined) {
            const id = String(feature.getId());
            if (!(id in this.idIndex_)) this.idIndex_[id] = feature;
            else if (feature instanceof (0, $4HUbK.default)) {
                const indexedFeature = this.idIndex_[id];
                if (!(indexedFeature instanceof (0, $4HUbK.default))) valid = false;
                else if (!Array.isArray(indexedFeature)) this.idIndex_[id] = [
                    indexedFeature,
                    feature
                ];
                else indexedFeature.push(feature);
            } else valid = false;
        }
        if (valid) {
            (0, $4Cz58.assert)(!(featureKey in this.uidIndex_), 'The passed `feature` was already added to the source');
            this.uidIndex_[featureKey] = feature;
        }
        return valid;
    }
    /**
   * Add a batch of features to the source.
   * @param {Array<FeatureType>} features Features to add.
   * @api
   */ addFeatures(features) {
        this.addFeaturesInternal(features);
        this.changed();
    }
    /**
   * Add features without firing a `change` event.
   * @param {Array<FeatureType>} features Features.
   * @protected
   */ addFeaturesInternal(features) {
        const extents = [];
        /** @type {Array<FeatureType>} */ const newFeatures = [];
        /** @type {Array<FeatureType>} */ const geometryFeatures = [];
        for(let i = 0, length = features.length; i < length; i++){
            const feature = features[i];
            const featureKey = (0, $9iPUS.getUid)(feature);
            if (this.addToIndex_(featureKey, feature)) newFeatures.push(feature);
        }
        for(let i = 0, length = newFeatures.length; i < length; i++){
            const feature = newFeatures[i];
            const featureKey = (0, $9iPUS.getUid)(feature);
            this.setupChangeEvents_(featureKey, feature);
            const geometry = feature.getGeometry();
            if (geometry) {
                const extent = geometry.getExtent();
                extents.push(extent);
                geometryFeatures.push(feature);
            } else this.nullGeometryFeatures_[featureKey] = feature;
        }
        if (this.featuresRtree_) this.featuresRtree_.load(extents, geometryFeatures);
        if (this.hasListener((0, $hzYQp.default).ADDFEATURE)) for(let i = 0, length = newFeatures.length; i < length; i++)this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $hzYQp.default).ADDFEATURE, newFeatures[i]));
    }
    /**
   * @param {!Collection<FeatureType>} collection Collection.
   * @private
   */ bindFeaturesCollection_(collection) {
        let modifyingCollection = false;
        this.addEventListener((0, $hzYQp.default).ADDFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.push(evt.feature);
                modifyingCollection = false;
            }
        });
        this.addEventListener((0, $hzYQp.default).REMOVEFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.remove(evt.feature);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $1TIYs.default).ADD, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.addFeature(evt.element);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $1TIYs.default).REMOVE, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.removeFeature(evt.element);
                modifyingCollection = false;
            }
        });
        this.featuresCollection_ = collection;
    }
    /**
   * Remove all features from the source.
   * @param {boolean} [fast] Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#event:removefeature} events.
   * @api
   */ clear(fast) {
        if (fast) {
            for(const featureId in this.featureChangeKeys_){
                const keys = this.featureChangeKeys_[featureId];
                keys.forEach((0, $ilM9F.unlistenByKey));
            }
            if (!this.featuresCollection_) {
                this.featureChangeKeys_ = {};
                this.idIndex_ = {};
                this.uidIndex_ = {};
            }
        } else if (this.featuresRtree_) {
            this.featuresRtree_.forEach((feature)=>{
                this.removeFeatureInternal(feature);
            });
            for(const id in this.nullGeometryFeatures_)this.removeFeatureInternal(this.nullGeometryFeatures_[id]);
        }
        if (this.featuresCollection_) this.featuresCollection_.clear();
        if (this.featuresRtree_) this.featuresRtree_.clear();
        this.nullGeometryFeatures_ = {};
        const clearEvent = new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $hzYQp.default).CLEAR);
        this.dispatchEvent(clearEvent);
        this.changed();
    }
    /**
   * Iterate through all features on the source, calling the provided callback
   * with each one.  If the callback returns any "truthy" value, iteration will
   * stop and the function will return the same value.
   * Note: this function only iterate through the feature that have a defined geometry.
   *
   * @param {function(FeatureType): T} callback Called with each feature
   *     on the source.  Return a truthy value to stop iteration.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeature(callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEach(callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometries contain the provided
   * coordinate, calling the callback with each feature.  If the callback returns
   * a "truthy" value, iteration will stop and the function will return the same
   * value.
   *
   * For {@link module:ol/render/Feature~RenderFeature} features, the callback will be
   * called for all features.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose goemetry contains the provided coordinate.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   */ forEachFeatureAtCoordinateDirect(coordinate, callback) {
        const extent = [
            coordinate[0],
            coordinate[1],
            coordinate[0],
            coordinate[1]
        ];
        return this.forEachFeatureInExtent(extent, function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $4HUbK.default) || geometry.intersectsCoordinate(coordinate)) return callback(feature);
            return undefined;
        });
    }
    /**
   * Iterate through all features whose bounding box intersects the provided
   * extent (note that the feature's geometry may not intersect the extent),
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you are interested in features whose geometry intersects an extent, call
   * the {@link module:ol/source/Vector~VectorSource#forEachFeatureIntersectingExtent #forEachFeatureIntersectingExtent()} method instead.
   *
   * When `useSpatialIndex` is set to false, this method will loop through all
   * features, equivalent to {@link module:ol/source/Vector~VectorSource#forEachFeature #forEachFeature()}.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose bounding box intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureInExtent(extent, callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEachInExtent(extent, callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometry intersects the provided extent,
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you only want to test for bounding box intersection, call the
   * {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent #forEachFeatureInExtent()} method instead.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose geometry intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureIntersectingExtent(extent, callback) {
        return this.forEachFeatureInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       * @return {T|undefined} The return value from the last call to the callback.
       */ function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $4HUbK.default) || geometry.intersectsExtent(extent)) {
                const result = callback(feature);
                if (result) return result;
            }
        });
    }
    /**
   * Get the features collection associated with this source. Will be `null`
   * unless the source was configured with `useSpatialIndex` set to `false`, or
   * with a {@link module:ol/Collection~Collection} as `features`.
   * @return {Collection<FeatureType>|null} The collection of features.
   * @api
   */ getFeaturesCollection() {
        return this.featuresCollection_;
    }
    /**
   * Get a snapshot of the features currently on the source in random order. The returned array
   * is a copy, the features are references to the features in the source.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeatures() {
        let features;
        if (this.featuresCollection_) features = this.featuresCollection_.getArray().slice(0);
        else if (this.featuresRtree_) {
            features = this.featuresRtree_.getAll();
            if (!(0, $gn0g3.isEmpty)(this.nullGeometryFeatures_)) (0, $fVVyM.extend)(features, Object.values(this.nullGeometryFeatures_));
        }
        return features;
    }
    /**
   * Get all features whose geometry intersects the provided coordinate.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesAtCoordinate(coordinate) {
        /** @type {Array<FeatureType>} */ const features = [];
        this.forEachFeatureAtCoordinateDirect(coordinate, function(feature) {
            features.push(feature);
        });
        return features;
    }
    /**
   * Get all features whose bounding box intersects the provided extent.  Note that this returns an array of
   * all features intersecting the given extent in random order (so it may include
   * features whose geometries do not intersect the extent).
   *
   * When `useSpatialIndex` is set to false, this method will return all
   * features.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {import("../proj/Projection.js").default} [projection] Include features
   * where `extent` exceeds the x-axis bounds of `projection` and wraps around the world.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesInExtent(extent, projection) {
        if (this.featuresRtree_) {
            const multiWorld = projection && projection.canWrapX() && this.getWrapX();
            if (!multiWorld) return this.featuresRtree_.getInExtent(extent);
            const extents = (0, $9pD6L.wrapAndSliceX)(extent, projection);
            return [].concat(...extents.map((anExtent)=>this.featuresRtree_.getInExtent(anExtent)));
        }
        if (this.featuresCollection_) return this.featuresCollection_.getArray().slice(0);
        return [];
    }
    /**
   * Get the closest feature to the provided coordinate.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false` and the features in this source are of type
   * {@link module:ol/Feature~Feature}.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType):boolean} [filter] Feature filter function.
   *     The filter function will receive one argument, the {@link module:ol/Feature~Feature feature}
   *     and it should return a boolean value. By default, no filtering is made.
   * @return {FeatureType|null} Closest feature (or `null` if none found).
   * @api
   */ getClosestFeatureToCoordinate(coordinate, filter) {
        // Find the closest feature using branch and bound.  We start searching an
        // infinite extent, and find the distance from the first feature found.  This
        // becomes the closest feature.  We then compute a smaller extent which any
        // closer feature must intersect.  We continue searching with this smaller
        // extent, trying to find a closer feature.  Every time we find a closer
        // feature, we update the extent being searched so that any even closer
        // feature must intersect it.  We continue until we run out of features.
        const x = coordinate[0];
        const y = coordinate[1];
        let closestFeature = null;
        const closestPoint = [
            NaN,
            NaN
        ];
        let minSquaredDistance = Infinity;
        const extent = [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ];
        filter = filter ? filter : (0, $6wUzV.TRUE);
        this.featuresRtree_.forEachInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       */ function(feature) {
            if (filter(feature)) {
                const geometry = feature.getGeometry();
                const previousMinSquaredDistance = minSquaredDistance;
                minSquaredDistance = geometry instanceof (0, $4HUbK.default) ? 0 : geometry.closestPointXY(x, y, closestPoint, minSquaredDistance);
                if (minSquaredDistance < previousMinSquaredDistance) {
                    closestFeature = feature;
                    // This is sneaky.  Reduce the extent that it is currently being
                    // searched while the R-Tree traversal using this same extent object
                    // is still in progress.  This is safe because the new extent is
                    // strictly contained by the old extent.
                    const minDistance = Math.sqrt(minSquaredDistance);
                    extent[0] = x - minDistance;
                    extent[1] = y - minDistance;
                    extent[2] = x + minDistance;
                    extent[3] = y + minDistance;
                }
            }
        });
        return closestFeature;
    }
    /**
   * Get the extent of the features currently in the source.
   *
   * This will return `null` when the source is configured with
   * `useSpatialIndex` set to `false`.
   * @param {import("../extent.js").Extent} [extent] Destination extent. If provided, no new extent
   *     will be created. Instead, that extent's coordinates will be overwritten.
   * @return {import("../extent.js").Extent | null} Extent.
   * @api
   */ getExtent(extent) {
        return this.featuresRtree_?.getExtent(extent) ?? null;
    }
    /**
   * Get a feature by its identifier (the value returned by feature.getId()). When `RenderFeature`s
   * are used, `getFeatureById()` can return an array of `RenderFeature`s. This allows for handling
   * of `GeometryCollection` geometries, where format readers create one `RenderFeature` per
   * `GeometryCollection` member.
   * Note that the index treats string and numeric identifiers as the same.  So
   * `source.getFeatureById(2)` will return a feature with id `'2'` or `2`.
   *
   * @param {string|number} id Feature identifier.
   * @return {FeatureClassOrArrayOfRenderFeatures<FeatureType>|null} The feature (or `null` if not found).
   * @api
   */ getFeatureById(id) {
        const feature = this.idIndex_[id.toString()];
        return feature !== undefined ? /** @type {FeatureClassOrArrayOfRenderFeatures<FeatureType>} */ feature : null;
    }
    /**
   * Get a feature by its internal unique identifier (using `getUid`).
   *
   * @param {string} uid Feature identifier.
   * @return {FeatureType|null} The feature (or `null` if not found).
   */ getFeatureByUid(uid) {
        const feature = this.uidIndex_[uid];
        return feature !== undefined ? feature : null;
    }
    /**
   * Get the format associated with this source.
   *
   * @return {import("../format/Feature.js").default<FeatureType>|null}} The feature format.
   * @api
   */ getFormat() {
        return this.format_;
    }
    /**
   * @return {boolean} The source can have overlapping geometries.
   */ getOverlaps() {
        return this.overlaps_;
    }
    /**
   * Get the url associated with this source.
   *
   * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
   * @api
   */ getUrl() {
        return this.url_;
    }
    /**
   * @param {Event} event Event.
   * @private
   */ handleFeatureChange_(event) {
        const feature = /** @type {FeatureType} */ event.target;
        const featureKey = (0, $9iPUS.getUid)(feature);
        const geometry = feature.getGeometry();
        if (!geometry) {
            if (!(featureKey in this.nullGeometryFeatures_)) {
                if (this.featuresRtree_) this.featuresRtree_.remove(feature);
                this.nullGeometryFeatures_[featureKey] = feature;
            }
        } else {
            const extent = geometry.getExtent();
            if (featureKey in this.nullGeometryFeatures_) {
                delete this.nullGeometryFeatures_[featureKey];
                if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
            } else if (this.featuresRtree_) this.featuresRtree_.update(extent, feature);
        }
        const id = feature.getId();
        if (id !== undefined) {
            const sid = id.toString();
            if (this.idIndex_[sid] !== feature) {
                this.removeFromIdIndex_(feature);
                this.idIndex_[sid] = feature;
            }
        } else {
            this.removeFromIdIndex_(feature);
            this.uidIndex_[featureKey] = feature;
        }
        this.changed();
        this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $hzYQp.default).CHANGEFEATURE, feature));
    }
    /**
   * Returns true if the feature is contained within the source.
   * @param {FeatureType} feature Feature.
   * @return {boolean} Has feature.
   * @api
   */ hasFeature(feature) {
        const id = feature.getId();
        if (id !== undefined) return id in this.idIndex_;
        return (0, $9iPUS.getUid)(feature) in this.uidIndex_;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        if (this.featuresRtree_) return this.featuresRtree_.isEmpty() && (0, $gn0g3.isEmpty)(this.nullGeometryFeatures_);
        if (this.featuresCollection_) return this.featuresCollection_.getLength() === 0;
        return true;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ loadFeatures(extent, resolution, projection) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        const extentsToLoad = this.strategy_(extent, resolution, projection);
        for(let i = 0, ii = extentsToLoad.length; i < ii; ++i){
            const extentToLoad = extentsToLoad[i];
            const alreadyLoaded = loadedExtentsRtree.forEachInExtent(extentToLoad, /**
         * @param {{extent: import("../extent.js").Extent}} object Object.
         * @return {boolean} Contains.
         */ function(object) {
                return (0, $9pD6L.containsExtent)(object.extent, extentToLoad);
            });
            if (!alreadyLoaded) {
                ++this.loadingExtentsCount_;
                this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $hzYQp.default).FEATURESLOADSTART));
                this.loader_.call(this, extentToLoad, resolution, projection, /**
           * @param {Array<FeatureType>} features Loaded features
           */ (features)=>{
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $hzYQp.default).FEATURESLOADEND, undefined, features));
                }, ()=>{
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $hzYQp.default).FEATURESLOADERROR));
                });
                loadedExtentsRtree.insert(extentToLoad, {
                    extent: extentToLoad.slice()
                });
            }
        }
        this.loading = this.loader_.length < 4 ? false : this.loadingExtentsCount_ > 0;
    }
    /**
   * @override
   */ refresh() {
        this.clear(true);
        this.loadedExtentsRtree_.clear();
        super.refresh();
    }
    /**
   * Remove an extent from the list of loaded extents.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ removeLoadedExtent(extent) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        const obj = loadedExtentsRtree.forEachInExtent(extent, function(object) {
            if ((0, $9pD6L.equals)(object.extent, extent)) return object;
        });
        if (obj) loadedExtentsRtree.remove(obj);
    }
    /**
   * Batch remove features from the source.  If you want to remove all features
   * at once, use the {@link module:ol/source/Vector~VectorSource#clear #clear()} method
   * instead.
   * @param {Array<FeatureType>} features Features to remove.
   * @api
   */ removeFeatures(features) {
        let removed = false;
        for(let i = 0, ii = features.length; i < ii; ++i)removed = this.removeFeatureInternal(features[i]) || removed;
        if (removed) this.changed();
    }
    /**
   * Remove a single feature from the source. If you want to batch remove
   * features, use the {@link module:ol/source/Vector~VectorSource#removeFeatures #removeFeatures()} method
   * instead.
   * @param {FeatureType} feature Feature to remove.
   * @api
   */ removeFeature(feature) {
        if (!feature) return;
        const removed = this.removeFeatureInternal(feature);
        if (removed) this.changed();
    }
    /**
   * Remove feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @return {boolean} True if the feature was removed, false if it was not found.
   * @protected
   */ removeFeatureInternal(feature) {
        const featureKey = (0, $9iPUS.getUid)(feature);
        if (!(featureKey in this.uidIndex_)) return false;
        if (featureKey in this.nullGeometryFeatures_) delete this.nullGeometryFeatures_[featureKey];
        else if (this.featuresRtree_) this.featuresRtree_.remove(feature);
        const featureChangeKeys = this.featureChangeKeys_[featureKey];
        featureChangeKeys?.forEach((0, $ilM9F.unlistenByKey));
        delete this.featureChangeKeys_[featureKey];
        const id = feature.getId();
        if (id !== undefined) {
            const idString = id.toString();
            const indexedFeature = this.idIndex_[idString];
            if (indexedFeature === feature) delete this.idIndex_[idString];
            else if (Array.isArray(indexedFeature)) {
                indexedFeature.splice(indexedFeature.indexOf(feature), 1);
                if (indexedFeature.length === 1) this.idIndex_[idString] = indexedFeature[0];
            }
        }
        delete this.uidIndex_[featureKey];
        if (this.hasListener((0, $hzYQp.default).REMOVEFEATURE)) this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $hzYQp.default).REMOVEFEATURE, feature));
        return true;
    }
    /**
   * Remove a feature from the id index.  Called internally when the feature id
   * may have changed.
   * @param {FeatureType} feature The feature.
   * @private
   */ removeFromIdIndex_(feature) {
        for(const id in this.idIndex_)if (this.idIndex_[id] === feature) {
            delete this.idIndex_[id];
            break;
        }
    }
    /**
   * Set the new loader of the source. The next render cycle will use the
   * new loader.
   * @param {import("../featureloader.js").FeatureLoader} loader The loader to set.
   * @api
   */ setLoader(loader) {
        this.loader_ = loader;
    }
    /**
   * Points the source to a new url. The next render cycle will use the new url.
   * @param {string|import("../featureloader.js").FeatureUrlFunction} url Url.
   * @api
   */ setUrl(url) {
        (0, $4Cz58.assert)(this.format_, '`format` must be set when `url` is set');
        this.url_ = url;
        this.setLoader((0, $7BfFg.xhr)(url, this.format_));
    }
    /**
   * @param {boolean} overlaps The source can have overlapping geometries.
   */ setOverlaps(overlaps) {
        this.overlaps_ = overlaps;
        this.changed();
    }
}
var $84888e4daf3fdf44$export$2e2bcd8739ae039 = $84888e4daf3fdf44$var$VectorSource;

});
parcelRegister("7BfFg", function(module, exports) {

$parcel$export(module.exports, "xhr", () => $588823c001569193$export$14cc81df70b6707e);
/**
 * @module ol/featureloader
 */ /**
 *
 * @type {boolean}
 * @private
 */ let $588823c001569193$var$withCredentials = false;
function $588823c001569193$export$441d7b57adab24d0(url, format, extent, resolution, projection, success, failure) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', typeof url === 'function' ? url(extent, resolution, projection) : url, true);
    if (format.getType() == 'arraybuffer') xhr.responseType = 'arraybuffer';
    xhr.withCredentials = $588823c001569193$var$withCredentials;
    /**
   * @param {Event} event Event.
   * @private
   */ xhr.onload = function(event) {
        // status will be 0 for file:// urls
        if (!xhr.status || xhr.status >= 200 && xhr.status < 300) {
            const type = format.getType();
            try {
                /** @type {Document|Node|Object|string|undefined} */ let source;
                if (type == 'text' || type == 'json') source = xhr.responseText;
                else if (type == 'xml') source = xhr.responseXML || xhr.responseText;
                else if (type == 'arraybuffer') source = /** @type {ArrayBuffer} */ xhr.response;
                if (source) success(/** @type {Array<FeatureType>} */ format.readFeatures(source, {
                    extent: extent,
                    featureProjection: projection
                }), format.readProjection(source));
                else failure();
            } catch  {
                failure();
            }
        } else failure();
    };
    /**
   * @private
   */ xhr.onerror = failure;
    xhr.send();
}
function $588823c001569193$export$14cc81df70b6707e(url, format) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("./proj/Projection.js").default} projection Projection.
   * @param {function(Array<FeatureType>): void} [success] Success
   *      Function called when loading succeeded.
   * @param {function(): void} [failure] Failure
   *      Function called when loading failed.
   * @this {import("./source/Vector.js").default<FeatureType>}
   */ return function(extent, resolution, projection, success, failure) {
        $588823c001569193$export$441d7b57adab24d0(url, format, extent, resolution, projection, /**
       * @param {Array<FeatureType>} features The loaded features.
       * @param {import("./proj/Projection.js").default} dataProjection Data
       * projection.
       */ (features, dataProjection)=>{
            this.addFeatures(features);
            if (success !== undefined) success(features);
        }, ()=>{
            this.changed();
            if (failure !== undefined) failure();
        });
    };
}
function $588823c001569193$export$36fa6977a6d0d8fe(xhrWithCredentials) {
    $588823c001569193$var$withCredentials = xhrWithCredentials;
}

});

parcelRegister("kcBeU", function(module, exports) {

$parcel$export(module.exports, "all", () => $eb51d0a16123ee90$export$84bf76cd7afc7469);
/**
 * @module ol/loadingstrategy
 */ 
var $dpRHA = parcelRequire("dpRHA");
function $eb51d0a16123ee90$export$84bf76cd7afc7469(extent, resolution) {
    return [
        [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ]
    ];
}
function $eb51d0a16123ee90$export$bf67010aacbe66fa(extent, resolution) {
    return [
        extent
    ];
}
function $eb51d0a16123ee90$export$3c17558da18e4d75(tileGrid) {
    return(/**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("./proj.js").Projection} projection Projection.
     * @return {Array<import("./extent.js").Extent>} Extents.
     */ function(extent, resolution, projection) {
        const z = tileGrid.getZForResolution((0, $dpRHA.fromUserResolution)(resolution, projection));
        const tileRange = tileGrid.getTileRangeForExtentAndZ((0, $dpRHA.fromUserExtent)(extent, projection), z);
        /** @type {Array<import("./extent.js").Extent>} */ const extents = [];
        /** @type {import("./tilecoord.js").TileCoord} */ const tileCoord = [
            z,
            0,
            0
        ];
        for(tileCoord[1] = tileRange.minX; tileCoord[1] <= tileRange.maxX; ++tileCoord[1])for(tileCoord[2] = tileRange.minY; tileCoord[2] <= tileRange.maxY; ++tileCoord[2])extents.push((0, $dpRHA.toUserExtent)(tileGrid.getTileCoordExtent(tileCoord), projection));
        return extents;
    });
}

});

parcelRegister("4HUbK", function(module, exports) {

$parcel$export(module.exports, "default", () => $36d6c36c1f9ad5d9$export$2e2bcd8739ae039);
/**
 * @module ol/render/Feature
 */ 
var $dIG9p = parcelRequire("dIG9p");

var $fVVyM = parcelRequire("fVVyM");

var $9pD6L = parcelRequire("9pD6L");

var $6wUzV = parcelRequire("6wUzV");

var $d3SGX = parcelRequire("d3SGX");

var $2RNwh = parcelRequire("2RNwh");

var $5PzBf = parcelRequire("5PzBf");

var $alOgM = parcelRequire("alOgM");

var $bDhby = parcelRequire("bDhby");

var $1MAUi = parcelRequire("1MAUi");

var $3xcD3 = parcelRequire("3xcD3");
var $fw94T = parcelRequire("fw94T");
var $jKs1i = parcelRequire("jKs1i");
var $le5ya = parcelRequire("le5ya");
var $9vPkX = parcelRequire("9vPkX");
var $5ydre = parcelRequire("5ydre");

var $dpRHA = parcelRequire("dpRHA");

var $jpXrt = parcelRequire("jpXrt");
/**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'` or 'MultiLineString'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const $36d6c36c1f9ad5d9$var$tmpTransform = (0, $jpXrt.create)();
/**
 * Lightweight, read-only, {@link module:ol/Feature~Feature} and {@link module:ol/geom/Geometry~Geometry} like
 * structure, optimized for vector tile rendering and styling. Geometry access
 * through the API is limited to getting the type and extent of the geometry.
 */ class $36d6c36c1f9ad5d9$var$RenderFeature {
    /**
   * @param {Type} type Geometry type.
   * @param {Array<number>} flatCoordinates Flat coordinates. These always need
   *     to be right-handed for polygons.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Object<string, *>} properties Properties.
   * @param {number|string|undefined} id Feature id.
   */ constructor(type, flatCoordinates, ends, stride, properties, id){
        /**
     * @type {import("../style/Style.js").StyleFunction|undefined}
     */ this.styleFunction;
        /**
     * @private
     * @type {import("../extent.js").Extent|undefined}
     */ this.extent_;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = id;
        /**
     * @private
     * @type {Type}
     */ this.type_ = type;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatCoordinates_ = flatCoordinates;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatMidpoints_ = null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.ends_ = ends || null;
        /**
     * @private
     * @type {Object<string, *>}
     */ this.properties_ = properties;
        /**
     * @private
     * @type {number}
     */ this.squaredTolerance_;
        /**
     * @private
     * @type {number}
     */ this.stride_ = stride;
        /**
     * @private
     * @type {RenderFeature}
     */ this.simplifiedGeometry_;
    }
    /**
   * Get a feature property by its key.
   * @param {string} key Key
   * @return {*} Value for the requested key.
   * @api
   */ get(key) {
        return this.properties_[key];
    }
    /**
   * Get the extent of this feature's geometry.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        if (!this.extent_) this.extent_ = this.type_ === 'Point' ? (0, $9pD6L.createOrUpdateFromCoordinate)(this.flatCoordinates_) : (0, $9pD6L.createOrUpdateFromFlatCoordinates)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2);
        return this.extent_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoint() {
        if (!this.flatInteriorPoints_) {
            const flatCenter = (0, $9pD6L.getCenter)(this.getExtent());
            this.flatInteriorPoints_ = (0, $2RNwh.getInteriorPointOfArray)(this.flatCoordinates_, 0, this.ends_, 2, flatCenter, 0);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (!this.flatInteriorPoints_) {
            const ends = (0, $alOgM.inflateEnds)(this.flatCoordinates_, this.ends_);
            const flatCenters = (0, $d3SGX.linearRingss)(this.flatCoordinates_, 0, ends, 2);
            this.flatInteriorPoints_ = (0, $2RNwh.getInteriorPointsOfMultiArray)(this.flatCoordinates_, 0, ends, 2, flatCenters);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (!this.flatMidpoints_) this.flatMidpoints_ = (0, $5PzBf.interpolatePoint)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, 0.5);
        return this.flatMidpoints_;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        if (!this.flatMidpoints_) {
            this.flatMidpoints_ = [];
            const flatCoordinates = this.flatCoordinates_;
            let offset = 0;
            const ends = /** @type {Array<number>} */ this.ends_;
            for(let i = 0, ii = ends.length; i < ii; ++i){
                const end = ends[i];
                const midpoint = (0, $5PzBf.interpolatePoint)(flatCoordinates, offset, end, 2, 0.5);
                (0, $fVVyM.extend)(this.flatMidpoints_, midpoint);
                offset = end;
            }
        }
        return this.flatMidpoints_;
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is set when reading data from a remote source.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getOrientedFlatCoordinates() {
        return this.flatCoordinates_;
    }
    /**
   * For API compatibility with {@link module:ol/Feature~Feature}, this method is useful when
   * determining the geometry type in style function (see {@link #getType}).
   * @return {RenderFeature} Feature.
   * @api
   */ getGeometry() {
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {RenderFeature} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return this;
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {RenderFeature} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this;
    }
    /**
   * Get the feature properties.
   * @return {Object<string, *>} Feature properties.
   * @api
   */ getProperties() {
        return this.properties_;
    }
    /**
   * Get an object of all property names and values.  This has the same behavior as getProperties,
   * but is here to conform with the {@link module:ol/Feature~Feature} interface.
   * @return {Object<string, *>?} Object.
   */ getPropertiesInternal() {
        return this.properties_;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride_;
    }
    /**
   * @return {import('../style/Style.js').StyleFunction|undefined} Style
   */ getStyleFunction() {
        return this.styleFunction;
    }
    /**
   * Get the type of this feature's geometry.
   * @return {Type} Geometry type.
   * @api
   */ getType() {
        return this.type_;
    }
    /**
   * Transform geometry coordinates from tile pixel space to projected.
   *
   * @param {import("../proj.js").ProjectionLike} projection The data projection
   */ transform(projection) {
        projection = (0, $dpRHA.get)(projection);
        const pixelExtent = projection.getExtent();
        const projectedExtent = projection.getWorldExtent();
        if (pixelExtent && projectedExtent) {
            const scale = (0, $9pD6L.getHeight)(projectedExtent) / (0, $9pD6L.getHeight)(pixelExtent);
            (0, $jpXrt.compose)($36d6c36c1f9ad5d9$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            (0, $1MAUi.transform2D)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, $36d6c36c1f9ad5d9$var$tmpTransform, this.flatCoordinates_);
        }
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   */ applyTransform(transformFn) {
        transformFn(this.flatCoordinates_, this.flatCoordinates_, this.stride_);
    }
    /**
   * @return {RenderFeature} A cloned render feature.
   */ clone() {
        return new $36d6c36c1f9ad5d9$var$RenderFeature(this.type_, this.flatCoordinates_.slice(), this.ends_?.slice(), this.stride_, Object.assign({}, this.properties_), this.id_);
    }
    /**
   * @return {Array<number>|null} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Add transform and resolution based geometry simplification to this instance.
   * @return {RenderFeature} This render feature.
   */ enableSimplifyTransformed() {
        this.simplifyTransformed = (0, $6wUzV.memoizeOne)((squaredTolerance, transform)=>{
            if (squaredTolerance === this.squaredTolerance_) return this.simplifiedGeometry_;
            this.simplifiedGeometry_ = this.clone();
            if (transform) this.simplifiedGeometry_.applyTransform(transform);
            const simplifiedFlatCoordinates = this.simplifiedGeometry_.getFlatCoordinates();
            let simplifiedEnds;
            switch(this.type_){
                case 'LineString':
                    simplifiedFlatCoordinates.length = (0, $bDhby.douglasPeucker)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.flatCoordinates_.length, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0);
                    simplifiedEnds = [
                        simplifiedFlatCoordinates.length
                    ];
                    break;
                case 'MultiLineString':
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, $bDhby.douglasPeuckerArray)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                case 'Polygon':
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, $bDhby.quantizeArray)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                default:
            }
            if (simplifiedEnds) this.simplifiedGeometry_ = new $36d6c36c1f9ad5d9$var$RenderFeature(this.type_, simplifiedFlatCoordinates, simplifiedEnds, 2, this.properties_, this.id_);
            this.squaredTolerance_ = squaredTolerance;
            return this.simplifiedGeometry_;
        });
        return this;
    }
}
/**
 * @return {Array<number>} Flat coordinates.
 */ $36d6c36c1f9ad5d9$var$RenderFeature.prototype.getFlatCoordinates = $36d6c36c1f9ad5d9$var$RenderFeature.prototype.getOrientedFlatCoordinates;
function $36d6c36c1f9ad5d9$export$b89ab3d1d30dec84(renderFeature) {
    const geometryType = renderFeature.getType();
    switch(geometryType){
        case 'Point':
            return new (0, $9vPkX.default)(renderFeature.getFlatCoordinates());
        case 'MultiPoint':
            return new (0, $jKs1i.default)(renderFeature.getFlatCoordinates(), 'XY');
        case 'LineString':
            return new (0, $3xcD3.default)(renderFeature.getFlatCoordinates(), 'XY');
        case 'MultiLineString':
            return new (0, $fw94T.default)(renderFeature.getFlatCoordinates(), 'XY', /** @type {Array<number>} */ renderFeature.getEnds());
        case 'Polygon':
            const flatCoordinates = renderFeature.getFlatCoordinates();
            const ends = renderFeature.getEnds();
            const endss = (0, $alOgM.inflateEnds)(flatCoordinates, ends);
            return endss.length > 1 ? new (0, $le5ya.default)(flatCoordinates, 'XY', endss) : new (0, $5ydre.default)(flatCoordinates, 'XY', ends);
        default:
            throw new Error('Invalid geometry type:' + geometryType);
    }
}
function $36d6c36c1f9ad5d9$export$ab19ba60efd1c4b5(renderFeature, geometryName) {
    const id = renderFeature.getId();
    const geometry = $36d6c36c1f9ad5d9$export$b89ab3d1d30dec84(renderFeature);
    const properties = renderFeature.getProperties();
    const feature = new (0, $dIG9p.default)();
    if (geometryName !== undefined) feature.setGeometryName(geometryName);
    feature.setGeometry(geometry);
    if (id !== undefined) feature.setId(id);
    feature.setProperties(properties, true);
    return feature;
}
var $36d6c36c1f9ad5d9$export$2e2bcd8739ae039 = $36d6c36c1f9ad5d9$var$RenderFeature;

});
parcelRegister("d3SGX", function(module, exports) {

$parcel$export(module.exports, "linearRingss", () => $9825fadaf3b68c4e$export$78e139679ca7205);
/**
 * @module ol/geom/flat/center
 */ 
var $9pD6L = parcelRequire("9pD6L");
function $9825fadaf3b68c4e$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    const flatCenters = [];
    let extent = (0, $9pD6L.createEmpty)();
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        extent = (0, $9pD6L.createOrUpdateFromFlatCoordinates)(flatCoordinates, offset, ends[0], stride);
        flatCenters.push((extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2);
        offset = ends[ends.length - 1];
    }
    return flatCenters;
}

});

parcelRegister("5PzBf", function(module, exports) {

$parcel$export(module.exports, "interpolatePoint", () => $43ed5485a1d0c509$export$687ff82efd78795b);
$parcel$export(module.exports, "lineStringCoordinateAtM", () => $43ed5485a1d0c509$export$8f44c3c220ef6f09);
$parcel$export(module.exports, "lineStringsCoordinateAtM", () => $43ed5485a1d0c509$export$6a3300857e9ef453);
/**
 * @module ol/geom/flat/interpolate
 */ 
var $fVVyM = parcelRequire("fVVyM");

var $9byFX = parcelRequire("9byFX");
function $43ed5485a1d0c509$export$687ff82efd78795b(flatCoordinates, offset, end, stride, fraction, dest, dimension) {
    let o, t;
    const n = (end - offset) / stride;
    if (n === 1) o = offset;
    else if (n === 2) {
        o = offset;
        t = fraction;
    } else if (n !== 0) {
        let x1 = flatCoordinates[offset];
        let y1 = flatCoordinates[offset + 1];
        let length = 0;
        const cumulativeLengths = [
            0
        ];
        for(let i = offset + stride; i < end; i += stride){
            const x2 = flatCoordinates[i];
            const y2 = flatCoordinates[i + 1];
            length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
            cumulativeLengths.push(length);
            x1 = x2;
            y1 = y2;
        }
        const target = fraction * length;
        const index = (0, $fVVyM.binarySearch)(cumulativeLengths, target);
        if (index < 0) {
            t = (target - cumulativeLengths[-index - 2]) / (cumulativeLengths[-index - 1] - cumulativeLengths[-index - 2]);
            o = offset + (-index - 2) * stride;
        } else o = offset + index * stride;
    }
    dimension = dimension > 1 ? dimension : 2;
    dest = dest ? dest : new Array(dimension);
    for(let i = 0; i < dimension; ++i)dest[i] = o === undefined ? NaN : t === undefined ? flatCoordinates[o + i] : (0, $9byFX.lerp)(flatCoordinates[o + i], flatCoordinates[o + stride + i], t);
    return dest;
}
function $43ed5485a1d0c509$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, extrapolate) {
    if (end == offset) return null;
    let coordinate;
    if (m < flatCoordinates[offset + stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(offset, offset + stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[end - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(end - stride, end);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    // FIXME use O(1) search
    if (m == flatCoordinates[offset + stride - 1]) return flatCoordinates.slice(offset, offset + stride);
    let lo = offset / stride;
    let hi = end / stride;
    while(lo < hi){
        const mid = lo + hi >> 1;
        if (m < flatCoordinates[(mid + 1) * stride - 1]) hi = mid;
        else lo = mid + 1;
    }
    const m0 = flatCoordinates[lo * stride - 1];
    if (m == m0) return flatCoordinates.slice((lo - 1) * stride, (lo - 1) * stride + stride);
    const m1 = flatCoordinates[(lo + 1) * stride - 1];
    const t = (m - m0) / (m1 - m0);
    coordinate = [];
    for(let i = 0; i < stride - 1; ++i)coordinate.push((0, $9byFX.lerp)(flatCoordinates[(lo - 1) * stride + i], flatCoordinates[lo * stride + i], t));
    coordinate.push(m);
    return coordinate;
}
function $43ed5485a1d0c509$export$6a3300857e9ef453(flatCoordinates, offset, ends, stride, m, extrapolate, interpolate) {
    if (interpolate) return $43ed5485a1d0c509$export$8f44c3c220ef6f09(flatCoordinates, offset, ends[ends.length - 1], stride, m, extrapolate);
    let coordinate;
    if (m < flatCoordinates[stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(0, stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[flatCoordinates.length - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(flatCoordinates.length - stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        if (offset == end) continue;
        if (m < flatCoordinates[offset + stride - 1]) return null;
        if (m <= flatCoordinates[end - 1]) return $43ed5485a1d0c509$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, false);
        offset = end;
    }
    return null;
}

});

parcelRegister("3xcD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $292e4002746c8223$export$2e2bcd8739ae039);
/**
 * @module ol/geom/LineString
 */ 
var $fVVyM = parcelRequire("fVVyM");

var $9pD6L = parcelRequire("9pD6L");

var $h7zsK = parcelRequire("h7zsK");

var $gqtzW = parcelRequire("gqtzW");

var $9bJty = parcelRequire("9bJty");

var $7eSHW = parcelRequire("7eSHW");

var $5PzBf = parcelRequire("5PzBf");

var $eQvue = parcelRequire("eQvue");

var $goM6N = parcelRequire("goM6N");

var $5m6tu = parcelRequire("5m6tu");

var $bDhby = parcelRequire("bDhby");
/**
 * @classdesc
 * Linestring geometry.
 *
 * @api
 */ class $292e4002746c8223$var$LineString extends (0, $h7zsK.default) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatMidpoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.flatMidpointRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed coordinate to the coordinates of the linestring.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @api
   */ appendCoordinate(coordinate) {
        (0, $fVVyM.extend)(this.flatCoordinates, coordinate);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LineString} Clone.
   * @api
   * @override
   */ clone() {
        const lineString = new $292e4002746c8223$var$LineString(this.flatCoordinates.slice(), this.layout);
        lineString.applyProperties(this);
        return lineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $9pD6L.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $gqtzW.maxSquaredDelta)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $gqtzW.assignClosestPoint)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Iterate over each segment, calling the provided callback.
   * If the callback returns a truthy value the function returns that
   * value immediately. Otherwise the function returns `false`.
   *
   * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
   *     called for each segment. The function will receive two arguments, the start and end coordinates of the segment.
   * @return {T|boolean} Value.
   * @template T,S
   * @api
   */ forEachSegment(callback) {
        return (0, $5m6tu.forEach)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, callback);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate) {
        if (this.layout != 'XYM' && this.layout != 'XYZM') return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        return (0, $5PzBf.lineStringCoordinateAtM)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, m, extrapolate);
    }
    /**
   * Return the coordinates of the linestring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $7eSHW.inflateCoordinates)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinate at the provided fraction along the linestring.
   * The `fraction` is a number between 0 and 1, where 0 is the start of the
   * linestring and 1 is the end.
   * @param {number} fraction Fraction.
   * @param {import("../coordinate.js").Coordinate} [dest] Optional coordinate whose values will
   *     be modified. If not provided, a new coordinate will be returned.
   * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
   * @api
   */ getCoordinateAt(fraction, dest) {
        return (0, $5PzBf.interpolatePoint)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, fraction, dest, this.stride);
    }
    /**
   * Return the length of the linestring on projected plane.
   * @return {number} Length (on projected plane).
   * @api
   */ getLength() {
        return (0, $goM6N.lineStringLength)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (this.flatMidpointRevision_ != this.getRevision()) {
            this.flatMidpoint_ = this.getCoordinateAt(0.5, this.flatMidpoint_ ?? undefined);
            this.flatMidpointRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatMidpoint_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LineString} Simplified LineString.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $bDhby.douglasPeucker)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new $292e4002746c8223$var$LineString(simplifiedFlatCoordinates, 'XY');
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'LineString';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $eQvue.intersectsLineString)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent, this.getExtent());
    }
    /**
   * Set the coordinates of the linestring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $9bJty.deflateCoordinates)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $292e4002746c8223$export$2e2bcd8739ae039 = $292e4002746c8223$var$LineString;

});
parcelRegister("goM6N", function(module, exports) {

$parcel$export(module.exports, "lineStringLength", () => $bf04349d827c1d16$export$153f8c6b4d8caebc);
/**
 * @module ol/geom/flat/length
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Length.
 */ function $bf04349d827c1d16$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    let length = 0;
    for(let i = offset + stride; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        x1 = x2;
        y1 = y2;
    }
    return length;
}
function $bf04349d827c1d16$export$2bbb4f6f727a75c2(flatCoordinates, offset, end, stride) {
    let perimeter = $bf04349d827c1d16$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride);
    const dx = flatCoordinates[end - stride] - flatCoordinates[offset];
    const dy = flatCoordinates[end - stride + 1] - flatCoordinates[offset + 1];
    perimeter += Math.sqrt(dx * dx + dy * dy);
    return perimeter;
}

});


parcelRegister("fw94T", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4c0e2e13beea46e$export$2e2bcd8739ae039);
/**
 * @module ol/geom/MultiLineString
 */ 
var $fVVyM = parcelRequire("fVVyM");

var $9pD6L = parcelRequire("9pD6L");

var $3xcD3 = parcelRequire("3xcD3");

var $h7zsK = parcelRequire("h7zsK");

var $gqtzW = parcelRequire("gqtzW");

var $9bJty = parcelRequire("9bJty");

var $7eSHW = parcelRequire("7eSHW");

var $5PzBf = parcelRequire("5PzBf");

var $eQvue = parcelRequire("eQvue");

var $goM6N = parcelRequire("goM6N");

var $bDhby = parcelRequire("bDhby");
/**
 * @classdesc
 * Multi-linestring geometry.
 *
 * @api
 */ class $b4c0e2e13beea46e$var$MultiLineString extends (0, $h7zsK.default) {
    /**
   * @param {Array<Array<import("../coordinate.js").Coordinate>|LineString>|Array<number>} coordinates
   *     Coordinates or LineString geometries. (For internal use, flat coordinates in
   *     combination with `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Flat coordinate ends for internal use.
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (Array.isArray(coordinates[0])) this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
        else if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else {
            const lineStrings = /** @type {Array<LineString>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const ends = [];
            for(let i = 0, ii = lineStrings.length; i < ii; ++i){
                const lineString = lineStrings[i];
                (0, $fVVyM.extend)(flatCoordinates, lineString.getFlatCoordinates());
                ends.push(flatCoordinates.length);
            }
            const layout = lineStrings.length === 0 ? this.getLayout() : lineStrings[0].getLayout();
            this.setFlatCoordinates(layout, flatCoordinates);
            this.ends_ = ends;
        }
    }
    /**
   * Append the passed linestring to the multilinestring.
   * @param {LineString} lineString LineString.
   * @api
   */ appendLineString(lineString) {
        (0, $fVVyM.extend)(this.flatCoordinates, lineString.getFlatCoordinates().slice());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiLineString} Clone.
   * @api
   * @override
   */ clone() {
        const multiLineString = new $b4c0e2e13beea46e$var$MultiLineString(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        multiLineString.applyProperties(this);
        return multiLineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $9pD6L.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $gqtzW.arrayMaxSquaredDelta)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $gqtzW.assignClosestArrayPoint)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * `interpolate` controls interpolation between consecutive LineStrings
   * within the MultiLineString. If `interpolate` is `true` the coordinates
   * will be linearly interpolated between the last coordinate of one LineString
   * and the first coordinate of the next LineString.  If `interpolate` is
   * `false` then the function will return `null` for Ms falling between
   * LineStrings.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @param {boolean} [interpolate] Interpolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate, interpolate) {
        if (this.layout != 'XYM' && this.layout != 'XYZM' || this.flatCoordinates.length === 0) return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        interpolate = interpolate !== undefined ? interpolate : false;
        return (0, $5PzBf.lineStringsCoordinateAtM)(this.flatCoordinates, 0, this.ends_, this.stride, m, extrapolate, interpolate);
    }
    /**
   * Return the coordinates of the multilinestring.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $7eSHW.inflateCoordinatesArray)(this.flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Return the linestring at the specified index.
   * @param {number} index Index.
   * @return {LineString} LineString.
   * @api
   */ getLineString(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $3xcD3.default)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linestrings of this multilinestring.
   * @return {Array<LineString>} LineStrings.
   * @api
   */ getLineStrings() {
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const layout = this.layout;
        /** @type {Array<LineString>} */ const lineStrings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const lineString = new (0, $3xcD3.default)(flatCoordinates.slice(offset, end), layout);
            lineStrings.push(lineString);
            offset = end;
        }
        return lineStrings;
    }
    /**
   * Return the sum of all line string lengths
   * @return {number} Length (on projected plane).
   * @api
   */ getLength() {
        const ends = this.ends_;
        let start = 0;
        let length = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            length += (0, $goM6N.lineStringLength)(this.flatCoordinates, start, ends[i], this.stride);
            start = ends[i];
        }
        return length;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        /** @type {Array<number>} */ const midpoints = [];
        const flatCoordinates = this.flatCoordinates;
        let offset = 0;
        const ends = this.ends_;
        const stride = this.stride;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const midpoint = (0, $5PzBf.interpolatePoint)(flatCoordinates, offset, end, stride, 0.5);
            (0, $fVVyM.extend)(midpoints, midpoint);
            offset = end;
        }
        return midpoints;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiLineString} Simplified MultiLineString.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $bDhby.douglasPeuckerArray)(this.flatCoordinates, 0, this.ends_, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new $b4c0e2e13beea46e$var$MultiLineString(simplifiedFlatCoordinates, 'XY', simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiLineString';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $eQvue.intersectsLineStringArray)(this.flatCoordinates, 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multilinestring.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, $9bJty.deflateCoordinatesArray)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
var $b4c0e2e13beea46e$export$2e2bcd8739ae039 = $b4c0e2e13beea46e$var$MultiLineString;

});

parcelRegister("jKs1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6080c63a9451eda$export$2e2bcd8739ae039);
/**
 * @module ol/geom/MultiPoint
 */ 
var $fVVyM = parcelRequire("fVVyM");

var $9pD6L = parcelRequire("9pD6L");

var $9byFX = parcelRequire("9byFX");

var $9vPkX = parcelRequire("9vPkX");

var $h7zsK = parcelRequire("h7zsK");

var $9bJty = parcelRequire("9bJty");

var $7eSHW = parcelRequire("7eSHW");
/**
 * @classdesc
 * Multi-point geometry.
 *
 * @api
 */ class $e6080c63a9451eda$var$MultiPoint extends (0, $h7zsK.default) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        if (layout && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed point to this multipoint.
   * @param {Point} point Point.
   * @api
   */ appendPoint(point) {
        (0, $fVVyM.extend)(this.flatCoordinates, point.getFlatCoordinates());
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPoint} Clone.
   * @api
   * @override
   */ clone() {
        const multiPoint = new $e6080c63a9451eda$var$MultiPoint(this.flatCoordinates.slice(), this.layout);
        multiPoint.applyProperties(this);
        return multiPoint;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $9pD6L.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const squaredDistance = (0, $9byFX.squaredDistance)(x, y, flatCoordinates[i], flatCoordinates[i + 1]);
            if (squaredDistance < minSquaredDistance) {
                minSquaredDistance = squaredDistance;
                for(let j = 0; j < stride; ++j)closestPoint[j] = flatCoordinates[i + j];
                closestPoint.length = stride;
            }
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinates of the multipoint.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $7eSHW.inflateCoordinates)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the point at the specified index.
   * @param {number} index Index.
   * @return {Point} Point.
   * @api
   */ getPoint(index) {
        const n = this.flatCoordinates.length / this.stride;
        if (index < 0 || n <= index) return null;
        return new (0, $9vPkX.default)(this.flatCoordinates.slice(index * this.stride, (index + 1) * this.stride), this.layout);
    }
    /**
   * Return the points of this multipoint.
   * @return {Array<Point>} Points.
   * @api
   */ getPoints() {
        const flatCoordinates = this.flatCoordinates;
        const layout = this.layout;
        const stride = this.stride;
        /** @type {Array<Point>} */ const points = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const point = new (0, $9vPkX.default)(flatCoordinates.slice(i, i + stride), layout);
            points.push(point);
        }
        return points;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiPoint';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            if ((0, $9pD6L.containsXY)(extent, x, y)) return true;
        }
        return false;
    }
    /**
   * Set the coordinates of the multipoint.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $9bJty.deflateCoordinates)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $e6080c63a9451eda$export$2e2bcd8739ae039 = $e6080c63a9451eda$var$MultiPoint;

});

parcelRegister("le5ya", function(module, exports) {

$parcel$export(module.exports, "default", () => $f73f35eb6af8b987$export$2e2bcd8739ae039);
/**
 * @module ol/geom/MultiPolygon
 */ 
var $fVVyM = parcelRequire("fVVyM");

var $9pD6L = parcelRequire("9pD6L");

var $jKs1i = parcelRequire("jKs1i");

var $5ydre = parcelRequire("5ydre");

var $h7zsK = parcelRequire("h7zsK");

var $aCXb5 = parcelRequire("aCXb5");

var $d3SGX = parcelRequire("d3SGX");

var $gqtzW = parcelRequire("gqtzW");

var $33weL = parcelRequire("33weL");

var $9bJty = parcelRequire("9bJty");

var $7eSHW = parcelRequire("7eSHW");

var $2RNwh = parcelRequire("2RNwh");

var $eQvue = parcelRequire("eQvue");

var $alOgM = parcelRequire("alOgM");

var $bDhby = parcelRequire("bDhby");
/**
 * @classdesc
 * Multi-polygon geometry.
 *
 * @api
 */ class $f73f35eb6af8b987$var$MultiPolygon extends (0, $h7zsK.default) {
    /**
   * @param {Array<Array<Array<import("../coordinate.js").Coordinate>>|Polygon>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` and `endss` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<Array<number>>} [endss] Array of ends for internal use with flat coordinates.
   */ constructor(coordinates, layout, endss){
        super();
        /**
     * @type {Array<Array<number>>}
     * @private
     */ this.endss_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointsRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (!endss && !Array.isArray(coordinates[0])) {
            const polygons = /** @type {Array<Polygon>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const thisEndss = [];
            for(let i = 0, ii = polygons.length; i < ii; ++i){
                const polygon = polygons[i];
                const offset = flatCoordinates.length;
                const ends = polygon.getEnds();
                for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] += offset;
                (0, $fVVyM.extend)(flatCoordinates, polygon.getFlatCoordinates());
                thisEndss.push(ends);
            }
            layout = polygons.length === 0 ? this.getLayout() : polygons[0].getLayout();
            coordinates = flatCoordinates;
            endss = thisEndss;
        }
        if (layout !== undefined && endss) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.endss_ = endss;
        } else this.setCoordinates(/** @type {Array<Array<Array<import("../coordinate.js").Coordinate>>>} */ coordinates, layout);
    }
    /**
   * Append the passed polygon to this multipolygon.
   * @param {Polygon} polygon Polygon.
   * @api
   */ appendPolygon(polygon) {
        /** @type {Array<number>} */ let ends;
        if (!this.flatCoordinates) {
            this.flatCoordinates = polygon.getFlatCoordinates().slice();
            ends = polygon.getEnds().slice();
            this.endss_.push();
        } else {
            const offset = this.flatCoordinates.length;
            (0, $fVVyM.extend)(this.flatCoordinates, polygon.getFlatCoordinates());
            ends = polygon.getEnds().slice();
            for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] += offset;
        }
        this.endss_.push(ends);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPolygon} Clone.
   * @api
   * @override
   */ clone() {
        const len = this.endss_.length;
        const newEndss = new Array(len);
        for(let i = 0; i < len; ++i)newEndss[i] = this.endss_[i].slice();
        const multiPolygon = new $f73f35eb6af8b987$var$MultiPolygon(this.flatCoordinates.slice(), this.layout, newEndss);
        multiPolygon.applyProperties(this);
        return multiPolygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $9pD6L.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $gqtzW.multiArrayMaxSquaredDelta)(this.flatCoordinates, 0, this.endss_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $gqtzW.assignClosestMultiArrayPoint)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        return (0, $33weL.linearRingssContainsXY)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, x, y);
    }
    /**
   * Return the area of the multipolygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $aCXb5.linearRingss)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for multi-polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<Array<import("../coordinate.js").Coordinate>>>} Coordinates.
   * @api
   * @override
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $alOgM.orientLinearRingsArray)(flatCoordinates, 0, this.endss_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $7eSHW.inflateMultiCoordinatesArray)(flatCoordinates, 0, this.endss_, this.stride);
    }
    /**
   * @return {Array<Array<number>>} Endss.
   */ getEndss() {
        return this.endss_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (this.flatInteriorPointsRevision_ != this.getRevision()) {
            const flatCenters = (0, $d3SGX.linearRingss)(this.flatCoordinates, 0, this.endss_, this.stride);
            this.flatInteriorPoints_ = (0, $2RNwh.getInteriorPointsOfMultiArray)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, flatCenters);
            this.flatInteriorPointsRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatInteriorPoints_;
    }
    /**
   * Return the interior points as {@link module:ol/geom/MultiPoint~MultiPoint multipoint}.
   * @return {MultiPoint} Interior points as XYM coordinates, where M is
   * the length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoints() {
        return new (0, $jKs1i.default)(this.getFlatInteriorPoints().slice(), 'XYM');
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, $alOgM.linearRingssAreOriented)(flatCoordinates, 0, this.endss_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $alOgM.orientLinearRingsArray)(this.orientedFlatCoordinates_, 0, this.endss_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiPolygon} Simplified MultiPolygon.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<Array<number>>} */ const simplifiedEndss = [];
        simplifiedFlatCoordinates.length = (0, $bDhby.quantizeMultiArray)(this.flatCoordinates, 0, this.endss_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEndss);
        return new $f73f35eb6af8b987$var$MultiPolygon(simplifiedFlatCoordinates, 'XY', simplifiedEndss);
    }
    /**
   * Return the polygon at the specified index.
   * @param {number} index Index.
   * @return {Polygon} Polygon.
   * @api
   */ getPolygon(index) {
        if (index < 0 || this.endss_.length <= index) return null;
        let offset;
        if (index === 0) offset = 0;
        else {
            const prevEnds = this.endss_[index - 1];
            offset = prevEnds[prevEnds.length - 1];
        }
        const ends = this.endss_[index].slice();
        const end = ends[ends.length - 1];
        if (offset !== 0) for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] -= offset;
        return new (0, $5ydre.default)(this.flatCoordinates.slice(offset, end), this.layout, ends);
    }
    /**
   * Return the polygons of this multipolygon.
   * @return {Array<Polygon>} Polygons.
   * @api
   */ getPolygons() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const endss = this.endss_;
        const polygons = [];
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i){
            const ends = endss[i].slice();
            const end = ends[ends.length - 1];
            if (offset !== 0) for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] -= offset;
            const polygon = new (0, $5ydre.default)(flatCoordinates.slice(offset, end), layout, ends);
            polygons.push(polygon);
            offset = end;
        }
        return polygons;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiPolygon';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $eQvue.intersectsLinearRingMultiArray)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multipolygon.
   * @param {!Array<Array<Array<import("../coordinate.js").Coordinate>>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 3);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const endss = (0, $9bJty.deflateMultiCoordinatesArray)(this.flatCoordinates, 0, coordinates, this.stride, this.endss_);
        if (endss.length === 0) this.flatCoordinates.length = 0;
        else {
            const lastEnds = endss[endss.length - 1];
            this.flatCoordinates.length = lastEnds.length === 0 ? 0 : lastEnds[lastEnds.length - 1];
        }
        this.changed();
    }
}
var $f73f35eb6af8b987$export$2e2bcd8739ae039 = $f73f35eb6af8b987$var$MultiPolygon;

});


parcelRegister("4wW9x", function(module, exports) {

$parcel$export(module.exports, "default", () => $34c742891733e7a4$export$2e2bcd8739ae039);
/**
 * @module ol/structs/RBush
 */ 
var $20GDs = parcelRequire("20GDs");

var $9pD6L = parcelRequire("9pD6L");

var $gn0g3 = parcelRequire("gn0g3");

var $9iPUS = parcelRequire("9iPUS");
/**
 * @typedef {import("rbush").BBox & {value: T}} Entry
 * @template T
 */ /**
 * @classdesc
 * Wrapper around the RBush by Vladimir Agafonkin.
 * See https://github.com/mourner/rbush.
 *
 * @template {Object} T
 */ class $34c742891733e7a4$var$RBush {
    /**
   * @param {number} [maxEntries] Max entries.
   */ constructor(maxEntries){
        /**
     * @private
     * @type {RBush_<Entry<T>>}
     */ this.rbush_ = new (0, (/*@__PURE__*/$parcel$interopDefault($20GDs)))(maxEntries);
        /**
     * A mapping between the objects added to this rbush wrapper
     * and the objects that are actually added to the internal rbush.
     * @private
     * @type {Object<string, Entry<T>>}
     */ this.items_ = {};
    }
    /**
   * Insert a value into the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ insert(extent, value) {
        /** @type {Entry<T>} */ const item = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3],
            value: value
        };
        this.rbush_.insert(item);
        this.items_[(0, $9iPUS.getUid)(value)] = item;
    }
    /**
   * Bulk-insert values into the RBush.
   * @param {Array<import("../extent.js").Extent>} extents Extents.
   * @param {Array<T>} values Values.
   */ load(extents, values) {
        const items = new Array(values.length);
        for(let i = 0, l = values.length; i < l; i++){
            const extent = extents[i];
            const value = values[i];
            /** @type {Entry<T>} */ const item = {
                minX: extent[0],
                minY: extent[1],
                maxX: extent[2],
                maxY: extent[3],
                value: value
            };
            items[i] = item;
            this.items_[(0, $9iPUS.getUid)(value)] = item;
        }
        this.rbush_.load(items);
    }
    /**
   * Remove a value from the RBush.
   * @param {T} value Value.
   * @return {boolean} Removed.
   */ remove(value) {
        const uid = (0, $9iPUS.getUid)(value);
        // get the object in which the value was wrapped when adding to the
        // internal rbush. then use that object to do the removal.
        const item = this.items_[uid];
        delete this.items_[uid];
        return this.rbush_.remove(item) !== null;
    }
    /**
   * Update the extent of a value in the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ update(extent, value) {
        const item = this.items_[(0, $9iPUS.getUid)(value)];
        const bbox = [
            item.minX,
            item.minY,
            item.maxX,
            item.maxY
        ];
        if (!(0, $9pD6L.equals)(bbox, extent)) {
            this.remove(value);
            this.insert(extent, value);
        }
    }
    /**
   * Return all values in the RBush.
   * @return {Array<T>} All.
   */ getAll() {
        const items = this.rbush_.all();
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Return all values in the given extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {Array<T>} All in extent.
   */ getInExtent(extent) {
        /** @type {import("rbush").BBox} */ const bbox = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3]
        };
        const items = this.rbush_.search(bbox);
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Calls a callback function with each value in the tree.
   * If the callback returns a truthy value, this value is returned without
   * checking the rest of the tree.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   */ forEach(callback) {
        return this.forEach_(this.getAll(), callback);
    }
    /**
   * Calls a callback function with each value in the provided extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   */ forEachInExtent(extent, callback) {
        return this.forEach_(this.getInExtent(extent), callback);
    }
    /**
   * @param {Array<T>} values Values.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   * @private
   */ forEach_(values, callback) {
        let result;
        for(let i = 0, l = values.length; i < l; i++){
            result = callback(values[i]);
            if (result) return result;
        }
        return result;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, $gn0g3.isEmpty)(this.items_);
    }
    /**
   * Remove all values from the RBush.
   */ clear() {
        this.rbush_.clear();
        this.items_ = {};
    }
    /**
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} Extent.
   */ getExtent(extent) {
        const data = this.rbush_.toJSON();
        return (0, $9pD6L.createOrUpdate)(data.minX, data.minY, data.maxX, data.maxY, extent);
    }
    /**
   * @param {RBush<T>} rbush R-Tree.
   */ concat(rbush) {
        this.rbush_.load(rbush.rbush_.all());
        for(const i in rbush.items_)this.items_[i] = rbush.items_[i];
    }
}
var $34c742891733e7a4$export$2e2bcd8739ae039 = $34c742891733e7a4$var$RBush;

});

parcelRegister("hzYQp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc4e6f11f11978f$export$2e2bcd8739ae039);
/**
 * @module ol/source/VectorEventType
 */ /**
 * @enum {string}
 */ var $ccc4e6f11f11978f$export$2e2bcd8739ae039 /**
 * @typedef {'addfeature'|'changefeature'|'clear'|'removefeature'|'featuresloadstart'|'featuresloadend'|'featuresloaderror'} VectorSourceEventTypes
 */  = {
    /**
   * Triggered when a feature is added to the source.
   * @event module:ol/source/Vector.VectorSourceEvent#addfeature
   * @api
   */ ADDFEATURE: 'addfeature',
    /**
   * Triggered when a feature is updated.
   * @event module:ol/source/Vector.VectorSourceEvent#changefeature
   * @api
   */ CHANGEFEATURE: 'changefeature',
    /**
   * Triggered when the clear method is called on the source.
   * @event module:ol/source/Vector.VectorSourceEvent#clear
   * @api
   */ CLEAR: 'clear',
    /**
   * Triggered when a feature is removed from the source.
   * See {@link module:ol/source/Vector~VectorSource#clear source.clear()} for exceptions.
   * @event module:ol/source/Vector.VectorSourceEvent#removefeature
   * @api
   */ REMOVEFEATURE: 'removefeature',
    /**
   * Triggered when features starts loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadstart
   * @api
   */ FEATURESLOADSTART: 'featuresloadstart',
    /**
   * Triggered when features finishes loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadend
   * @api
   */ FEATURESLOADEND: 'featuresloadend',
    /**
   * Triggered if feature loading results in an error.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloaderror
   * @api
   */ FEATURESLOADERROR: 'featuresloaderror'
};

});


parcelRegister("bdrRp", function(module, exports) {

$parcel$export(module.exports, "default", () => $82a68515bd6ef378$export$2e2bcd8739ae039);
/**
 * @module ol/layer/Vector
 */ 
var $8IUeQ = parcelRequire("8IUeQ");

var $hf3TH = parcelRequire("hf3TH");
/**
 * @template {import("../source/Vector.js").default<FeatureType>} [VectorSourceType=import("../source/Vector.js").default<*>]
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("./BaseVector.js").ExtractedFeatureType<VectorSourceType>]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Vector data is rendered client-side, as vectors. This layer type provides most accurate rendering
 * even during animations. Points and labels stay upright on rotated views. For very large
 * amounts of vector data, performance may suffer during pan and zoom animations. In this case,
 * try {@link module:ol/layer/VectorImage~VectorImageLayer}.
 *
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default<FeatureType>} [VectorSourceType=import("../source/Vector.js").default<*>]
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("./BaseVector.js").ExtractedFeatureType<VectorSourceType>]
 * @extends {BaseVectorLayer<FeatureType, VectorSourceType, CanvasVectorLayerRenderer>}
 * @api
 */ class $82a68515bd6ef378$var$VectorLayer extends (0, $hf3TH.default) {
    /**
   * @param {Options<VectorSourceType, FeatureType>} [options] Options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $8IUeQ.default)(this);
    }
}
var $82a68515bd6ef378$export$2e2bcd8739ae039 = $82a68515bd6ef378$var$VectorLayer;

});
parcelRegister("8IUeQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $659e0e97392a5f5e$export$2e2bcd8739ae039);
/**
 * @module ol/renderer/canvas/VectorLayer
 */ 
var $aKuSF = parcelRequire("aKuSF");

var $fVVyM = parcelRequire("fVVyM");

var $2o3CH = parcelRequire("2o3CH");

var $DfnQm = parcelRequire("DfnQm");

var $9pD6L = parcelRequire("9pD6L");

var $dpRHA = parcelRequire("dpRHA");

var $l6YBe = parcelRequire("l6YBe");

var $jpMYX = parcelRequire("jpMYX");

var $e1c3o = parcelRequire("e1c3o");

var $1HMKO = parcelRequire("1HMKO");

var $9iPUS = parcelRequire("9iPUS");

var $6urmj = parcelRequire("6urmj");

var $5FKVH = parcelRequire("5FKVH");
/**
 * @classdesc
 * Canvas renderer for vector layers.
 * @api
 */ class $659e0e97392a5f5e$var$CanvasVectorLayerRenderer extends (0, $5FKVH.default) {
    /**
   * @param {import("../../layer/BaseVector.js").default} vectorLayer Vector layer.
   */ constructor(vectorLayer){
        super(vectorLayer);
        /** @private */ this.boundHandleStyleImageChange_ = this.handleStyleImageChange_.bind(this);
        /**
     * @private
     * @type {boolean}
     */ this.animatingOrInteracting_;
        /**
     * @private
     * @type {ImageData|null}
     */ this.hitDetectionImageData_ = null;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.clipExtent_ = null;
        /**
     * Do we need to extend the rendered area on the x-axis to handle
     * features that cross the antimeridian?
     * @private
     * @type {boolean}
     */ this.extendX_ = false;
        /**
     * @private
     * @type {Array<import("../../Feature.js").default>}
     */ this.renderedFeatures_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.renderedResolution_ = NaN;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.renderedExtent_ = (0, $9pD6L.createEmpty)();
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.wrappedRenderedExtent_ = (0, $9pD6L.createEmpty)();
        /**
     * @private
     * @type {number}
     */ this.renderedRotation_;
        /**
     * @private
     * @type {import("../../coordinate").Coordinate}
     */ this.renderedCenter_ = null;
        /**
     * @private
     * @type {import("../../proj/Projection").default}
     */ this.renderedProjection_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedPixelRatio_ = 1;
        /**
     * @private
     * @type {import("../../render.js").OrderFunction|null}
     */ this.renderedRenderOrder_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.renderedFrameDeclutter_;
        /**
     * @private
     * @type {import("../../render/canvas/ExecutorGroup").default}
     */ this.replayGroup_ = null;
        /**
     * A new replay group had to be created by `prepareFrame()`
     * @type {boolean}
     */ this.replayGroupChanged = true;
        /**
     * Clipping to be performed by `renderFrame()`
     * @type {boolean}
     */ this.clipping = true;
        /**
     * @private
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.targetContext_ = null;
        /**
     * @private
     * @type {number}
     */ this.opacity_ = 1;
    }
    /**
   * @param {ExecutorGroup} executorGroup Executor group.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {boolean} [declutterable] `true` to only render declutterable items,
   *     `false` to only render non-declutterable items, `undefined` to render all.
   */ renderWorlds(executorGroup, frameState, declutterable) {
        const extent = frameState.extent;
        const viewState = frameState.viewState;
        const center = viewState.center;
        const resolution = viewState.resolution;
        const projection = viewState.projection;
        const rotation = viewState.rotation;
        const projectionExtent = projection.getExtent();
        const vectorSource = this.getLayer().getSource();
        const declutter = this.getLayer().getDeclutter();
        const pixelRatio = frameState.pixelRatio;
        const viewHints = frameState.viewHints;
        const snapToPixel = !(viewHints[(0, $aKuSF.default).ANIMATING] || viewHints[(0, $aKuSF.default).INTERACTING]);
        const context = this.context;
        const width = Math.round((0, $9pD6L.getWidth)(extent) / resolution * pixelRatio);
        const height = Math.round((0, $9pD6L.getHeight)(extent) / resolution * pixelRatio);
        const multiWorld = vectorSource.getWrapX() && projection.canWrapX();
        const worldWidth = multiWorld ? (0, $9pD6L.getWidth)(projectionExtent) : null;
        const endWorld = multiWorld ? Math.ceil((extent[2] - projectionExtent[2]) / worldWidth) + (this.extendX_ ? 2 : 1) : 1;
        let world = multiWorld ? Math.floor((extent[0] - projectionExtent[0]) / worldWidth) - (this.extendX_ ? 1 : 0) : 0;
        do {
            let transform = this.getRenderTransform(center, resolution, 0, pixelRatio, width, height, world * worldWidth);
            if (frameState.declutter) transform = transform.slice(0);
            executorGroup.execute(context, [
                context.canvas.width,
                context.canvas.height
            ], transform, rotation, snapToPixel, declutterable === undefined ? (0, $e1c3o.ALL) : declutterable ? (0, $e1c3o.DECLUTTER) : (0, $e1c3o.NON_DECLUTTER), declutterable ? declutter && frameState.declutter[declutter] : undefined);
        }while (++world < endWorld);
    }
    /**
   * @private
   */ setDrawContext_() {
        if (this.opacity_ !== 1) {
            this.targetContext_ = this.context;
            this.context = (0, $DfnQm.createCanvasContext2D)(this.context.canvas.width, this.context.canvas.height, (0, $5FKVH.canvasPool));
        }
    }
    /**
   * @private
   */ resetDrawContext_() {
        if (this.opacity_ !== 1 && this.targetContext_) {
            const alpha = this.targetContext_.globalAlpha;
            this.targetContext_.globalAlpha = this.opacity_;
            this.targetContext_.drawImage(this.context.canvas, 0, 0);
            this.targetContext_.globalAlpha = alpha;
            (0, $DfnQm.releaseCanvas)(this.context);
            (0, $5FKVH.canvasPool).push(this.context.canvas);
            this.context = this.targetContext_;
            this.targetContext_ = null;
        }
    }
    /**
   * Render declutter items for this layer
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeclutter(frameState) {
        if (!this.replayGroup_ || !this.getLayer().getDeclutter()) return;
        this.renderWorlds(this.replayGroup_, frameState, true);
    }
    /**
   * Render deferred instructions.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferredInternal(frameState) {
        if (!this.replayGroup_) return;
        if (this.clipExtent_) this.clipUnrotated(this.context, frameState, this.clipExtent_);
        this.replayGroup_.renderDeferred();
        if (this.clipExtent_) {
            this.context.restore();
            this.clipExtent_ = null;
        }
        this.resetDrawContext_();
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        this.opacity_ = layerState.opacity;
        const viewState = frameState.viewState;
        this.prepareContainer(frameState, target);
        const context = this.context;
        const replayGroup = this.replayGroup_;
        let render = replayGroup && !replayGroup.isEmpty();
        if (!render) {
            const hasRenderListeners = this.getLayer().hasListener((0, $l6YBe.default).PRERENDER) || this.getLayer().hasListener((0, $l6YBe.default).POSTRENDER);
            if (!hasRenderListeners) return this.container;
        }
        this.setDrawContext_();
        this.preRender(context, frameState);
        const projection = viewState.projection;
        // clipped rendering if layer extent is set
        this.clipExtent_ = null;
        let clipped = false;
        if (render && layerState.extent && this.clipping) {
            const layerExtent = (0, $dpRHA.fromUserExtent)(layerState.extent, projection);
            render = (0, $9pD6L.intersects)(layerExtent, frameState.extent);
            const needsClip = render && !(0, $9pD6L.containsExtent)(layerExtent, frameState.extent);
            if (needsClip) {
                if (frameState.declutter) // Store extent for deferred clipping
                this.clipExtent_ = layerExtent;
                else {
                    // Apply clipping immediately for non-declutter rendering
                    this.clipUnrotated(context, frameState, layerExtent);
                    clipped = true;
                }
            }
        }
        if (render) this.renderWorlds(replayGroup, frameState, this.getLayer().getDeclutter() ? false : undefined);
        if (clipped) context.restore();
        this.postRender(context, frameState);
        if (this.renderedRotation_ !== viewState.rotation) {
            this.renderedRotation_ = viewState.rotation;
            this.hitDetectionImageData_ = null;
        }
        if (!frameState.declutter) this.resetDrawContext_();
        return this.container;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../../Feature").default>>} Promise
   * that resolves with an array of features.
   * @override
   */ getFeatures(pixel) {
        return new Promise((resolve)=>{
            if (this.frameState && !this.hitDetectionImageData_ && !this.animatingOrInteracting_) {
                const size = this.frameState.size.slice();
                const center = this.renderedCenter_;
                const resolution = this.renderedResolution_;
                const rotation = this.renderedRotation_;
                const projection = this.renderedProjection_;
                const extent = this.wrappedRenderedExtent_;
                const layer = this.getLayer();
                const transforms = [];
                const width = size[0] * (0, $1HMKO.HIT_DETECT_RESOLUTION);
                const height = size[1] * (0, $1HMKO.HIT_DETECT_RESOLUTION);
                transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $1HMKO.HIT_DETECT_RESOLUTION), width, height, 0).slice());
                const source = layer.getSource();
                const projectionExtent = projection.getExtent();
                if (source.getWrapX() && projection.canWrapX() && !(0, $9pD6L.containsExtent)(projectionExtent, extent)) {
                    let startX = extent[0];
                    const worldWidth = (0, $9pD6L.getWidth)(projectionExtent);
                    let world = 0;
                    let offsetX;
                    while(startX < projectionExtent[0]){
                        --world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $1HMKO.HIT_DETECT_RESOLUTION), width, height, offsetX).slice());
                        startX += worldWidth;
                    }
                    world = 0;
                    startX = extent[2];
                    while(startX > projectionExtent[2]){
                        ++world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $1HMKO.HIT_DETECT_RESOLUTION), width, height, offsetX).slice());
                        startX -= worldWidth;
                    }
                }
                const userProjection = (0, $dpRHA.getUserProjection)();
                this.hitDetectionImageData_ = (0, $1HMKO.createHitDetectionImageData)(size, transforms, this.renderedFeatures_, layer.getStyleFunction(), extent, resolution, rotation, (0, $6urmj.getSquaredTolerance)(resolution, this.renderedPixelRatio_), userProjection ? projection : null);
            }
            resolve((0, $1HMKO.hitDetect)(pixel, this.renderedFeatures_, this.hitDetectionImageData_));
        });
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   * @override
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        if (!this.replayGroup_) return undefined;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const layer = this.getLayer();
        /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */ const features = {};
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {number} distanceSq The squared distance to the click position
     * @return {T|undefined} Callback result.
     */ const featureCallback = function(feature, geometry, distanceSq) {
            const key = (0, $9iPUS.getUid)(feature);
            const match = features[key];
            if (!match) {
                if (distanceSq === 0) {
                    features[key] = true;
                    return callback(feature, layer, geometry);
                }
                matches.push(features[key] = {
                    feature: feature,
                    layer: layer,
                    geometry: geometry,
                    distanceSq: distanceSq,
                    callback: callback
                });
            } else if (match !== true && distanceSq < match.distanceSq) {
                if (distanceSq === 0) {
                    features[key] = true;
                    matches.splice(matches.lastIndexOf(match), 1);
                    return callback(feature, layer, geometry);
                }
                match.geometry = geometry;
                match.distanceSq = distanceSq;
            }
            return undefined;
        };
        const declutter = this.getLayer().getDeclutter();
        return this.replayGroup_.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, declutter ? frameState.declutter?.[declutter]?.all().map((item)=>item.value) : null);
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @override
   */ handleFontsChanged() {
        const layer = this.getLayer();
        if (layer.getVisible() && this.replayGroup_) layer.changed();
    }
    /**
   * Handle changes in image style state.
   * @param {import("../../events/Event.js").default} event Image style change event.
   * @private
   */ handleStyleImageChange_(event) {
        this.renderIfReadyAndVisible();
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        const vectorLayer = this.getLayer();
        const vectorSource = vectorLayer.getSource();
        if (!vectorSource) return false;
        const animating = frameState.viewHints[(0, $aKuSF.default).ANIMATING];
        const interacting = frameState.viewHints[(0, $aKuSF.default).INTERACTING];
        const updateWhileAnimating = vectorLayer.getUpdateWhileAnimating();
        const updateWhileInteracting = vectorLayer.getUpdateWhileInteracting();
        if (this.ready && !updateWhileAnimating && animating || !updateWhileInteracting && interacting) {
            this.animatingOrInteracting_ = true;
            return true;
        }
        this.animatingOrInteracting_ = false;
        const frameStateExtent = frameState.extent;
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const resolution = viewState.resolution;
        const pixelRatio = frameState.pixelRatio;
        const vectorLayerRevision = vectorLayer.getRevision();
        const vectorLayerRenderBuffer = vectorLayer.getRenderBuffer();
        let vectorLayerRenderOrder = vectorLayer.getRenderOrder();
        if (vectorLayerRenderOrder === undefined) vectorLayerRenderOrder = (0, $6urmj.defaultOrder);
        const center = viewState.center.slice();
        const extent = (0, $9pD6L.buffer)(frameStateExtent, vectorLayerRenderBuffer * resolution);
        const renderedExtent = extent.slice();
        const loadExtents = [
            extent.slice()
        ];
        const projectionExtent = projection.getExtent();
        const canWrapX = vectorSource.getWrapX() && projection.canWrapX();
        this.extendX_ = false;
        if (canWrapX) {
            const sourceExtent = vectorSource.getExtent();
            if (sourceExtent && !(0, $9pD6L.isEmpty)(sourceExtent)) this.extendX_ = sourceExtent[0] < projectionExtent[0] || sourceExtent[2] > projectionExtent[2];
        }
        if (canWrapX && (!(0, $9pD6L.containsExtent)(projectionExtent, frameState.extent) || this.extendX_)) {
            // For the replay group, we need an extent that intersects the real world
            // (-180° to +180°). To support geometries in a coordinate range from -540°
            // to +540°, we add at least 1 world width on each side of the projection
            // extent. If the viewport is wider than the world, we need to add half of
            // the viewport width to make sure we cover the whole viewport.
            const worldWidth = (0, $9pD6L.getWidth)(projectionExtent);
            const gutter = Math.max((0, $9pD6L.getWidth)(extent) / 2, worldWidth);
            let projMinX = projectionExtent[0];
            let projMaxX = projectionExtent[2];
            if (this.extendX_) {
                projMinX -= worldWidth;
                projMaxX += worldWidth;
            }
            extent[0] = projMinX - gutter;
            extent[2] = projMaxX + gutter;
            (0, $2o3CH.wrapX)(center, projection);
            const loadExtent = (0, $9pD6L.wrapX)(loadExtents[0], projection);
            // If the extent crosses the date line, we load data for both edges of the worlds
            if (loadExtent[0] < projectionExtent[0] && loadExtent[2] < projectionExtent[2]) loadExtents.push([
                loadExtent[0] + worldWidth,
                loadExtent[1],
                loadExtent[2] + worldWidth,
                loadExtent[3]
            ]);
            else if (loadExtent[0] > projectionExtent[0] && loadExtent[2] > projectionExtent[2]) loadExtents.push([
                loadExtent[0] - worldWidth,
                loadExtent[1],
                loadExtent[2] - worldWidth,
                loadExtent[3]
            ]);
        }
        if (this.ready && this.renderedResolution_ == resolution && this.renderedPixelRatio_ === pixelRatio && this.renderedRevision_ == vectorLayerRevision && this.renderedRenderOrder_ == vectorLayerRenderOrder && this.renderedFrameDeclutter_ === !!frameState.declutter && (0, $9pD6L.containsExtent)(this.wrappedRenderedExtent_, extent)) {
            if (!(0, $fVVyM.equals)(this.renderedExtent_, renderedExtent)) {
                this.hitDetectionImageData_ = null;
                this.renderedExtent_ = renderedExtent;
            }
            this.renderedCenter_ = center;
            this.replayGroupChanged = false;
            return true;
        }
        this.replayGroup_ = null;
        const replayGroup = new (0, $jpMYX.default)((0, $6urmj.getTolerance)(resolution, pixelRatio), extent, resolution, pixelRatio);
        const userProjection = (0, $dpRHA.getUserProjection)();
        let userTransform;
        if (userProjection) {
            for(let i = 0, ii = loadExtents.length; i < ii; ++i){
                const extent = loadExtents[i];
                const userExtent = (0, $dpRHA.toUserExtent)(extent, projection);
                vectorSource.loadFeatures(userExtent, (0, $dpRHA.toUserResolution)(resolution, projection), userProjection);
            }
            userTransform = (0, $dpRHA.getTransformFromProjections)(userProjection, projection);
        } else for(let i = 0, ii = loadExtents.length; i < ii; ++i)vectorSource.loadFeatures(loadExtents[i], resolution, projection);
        const squaredTolerance = (0, $6urmj.getSquaredTolerance)(resolution, pixelRatio);
        let ready = true;
        const render = /**
       * @param {import("../../Feature.js").default} feature Feature.
       * @param {number} index Index.
       */ (feature, index)=>{
            let styles;
            const styleFunction = feature.getStyleFunction() || vectorLayer.getStyleFunction();
            if (styleFunction) styles = styleFunction(feature, resolution);
            if (styles) {
                const dirty = this.renderFeature(feature, squaredTolerance, styles, replayGroup, userTransform, this.getLayer().getDeclutter(), index);
                ready = ready && !dirty;
            }
        };
        const userExtent = (0, $dpRHA.toUserExtent)(extent, projection);
        /** @type {Array<import("../../Feature.js").default>} */ const features = vectorSource.getFeaturesInExtent(userExtent);
        if (vectorLayerRenderOrder) features.sort(vectorLayerRenderOrder);
        for(let i = 0, ii = features.length; i < ii; ++i)render(features[i], i);
        this.renderedFeatures_ = features;
        this.ready = ready;
        const replayGroupInstructions = replayGroup.finish();
        const executorGroup = new (0, $e1c3o.default)(extent, resolution, pixelRatio, vectorSource.getOverlaps(), replayGroupInstructions, vectorLayer.getRenderBuffer(), !!frameState.declutter);
        this.renderedResolution_ = resolution;
        this.renderedRevision_ = vectorLayerRevision;
        this.renderedRenderOrder_ = vectorLayerRenderOrder;
        this.renderedFrameDeclutter_ = !!frameState.declutter;
        this.renderedExtent_ = renderedExtent;
        this.wrappedRenderedExtent_ = extent;
        this.renderedCenter_ = center;
        this.renderedProjection_ = projection;
        this.renderedPixelRatio_ = pixelRatio;
        this.replayGroup_ = executorGroup;
        this.hitDetectionImageData_ = null;
        this.replayGroupChanged = true;
        return true;
    }
    /**
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} squaredTolerance Squared render tolerance.
   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
   * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
   * @param {import("../../proj.js").TransformFunction} [transform] Transform from user to view projection.
   * @param {boolean} [declutter] Enable decluttering.
   * @param {number} [index] Render order index.
   * @return {boolean} `true` if an image is loading.
   */ renderFeature(feature, squaredTolerance, styles, builderGroup, transform, declutter, index) {
        if (!styles) return false;
        let loading = false;
        if (Array.isArray(styles)) for(let i = 0, ii = styles.length; i < ii; ++i)loading = (0, $6urmj.renderFeature)(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index) || loading;
        else loading = (0, $6urmj.renderFeature)(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index);
        return loading;
    }
}
var $659e0e97392a5f5e$export$2e2bcd8739ae039 = $659e0e97392a5f5e$var$CanvasVectorLayerRenderer;

});
parcelRegister("jpMYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e22658f4b743550b$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/BuilderGroup
 */ 
var $3KABr = parcelRequire("3KABr");

var $fEvr3 = parcelRequire("fEvr3");

var $dUudE = parcelRequire("dUudE");

var $aKl4u = parcelRequire("aKl4u");

var $bboJK = parcelRequire("bboJK");
/**
 * @type {Object<import("../canvas.js").BuilderType, typeof Builder>}
 */ const $e22658f4b743550b$var$BATCH_CONSTRUCTORS = {
    'Circle': (0, $aKl4u.default),
    'Default': (0, $3KABr.default),
    'Image': (0, $fEvr3.default),
    'LineString': (0, $dUudE.default),
    'Polygon': (0, $aKl4u.default),
    'Text': (0, $bboJK.default)
};
class $e22658f4b743550b$var$BuilderGroup {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Max extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        /**
     * @private
     * @type {number}
     */ this.tolerance_ = tolerance;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {!Object<string, !Object<import("../canvas.js").BuilderType, Builder>>}
     */ this.buildersByZIndex_ = {};
    }
    /**
   * @return {!Object<string, !Object<import("../canvas.js").BuilderType, import("./Builder.js").SerializableInstructions>>} The serializable instructions
   */ finish() {
        const builderInstructions = {};
        for(const zKey in this.buildersByZIndex_){
            builderInstructions[zKey] = builderInstructions[zKey] || {};
            const builders = this.buildersByZIndex_[zKey];
            for(const builderKey in builders){
                const builderInstruction = builders[builderKey].finish();
                builderInstructions[zKey][builderKey] = builderInstruction;
            }
        }
        return builderInstructions;
    }
    /**
   * @param {number|undefined} zIndex Z index.
   * @param {import("../canvas.js").BuilderType} builderType Replay type.
   * @return {import("../VectorContext.js").default} Replay.
   */ getBuilder(zIndex, builderType) {
        const zIndexKey = zIndex !== undefined ? zIndex.toString() : '0';
        let replays = this.buildersByZIndex_[zIndexKey];
        if (replays === undefined) {
            replays = {};
            this.buildersByZIndex_[zIndexKey] = replays;
        }
        let replay = replays[builderType];
        if (replay === undefined) {
            const Constructor = $e22658f4b743550b$var$BATCH_CONSTRUCTORS[builderType];
            replay = new Constructor(this.tolerance_, this.maxExtent_, this.resolution_, this.pixelRatio_);
            replays[builderType] = replay;
        }
        return replay;
    }
}
var $e22658f4b743550b$export$2e2bcd8739ae039 = $e22658f4b743550b$var$BuilderGroup;

});
parcelRegister("3KABr", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bb20f8873deb436$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/Builder
 */ 
var $fVVyM = parcelRequire("fVVyM");

var $jh19n = parcelRequire("jh19n");

var $iM9A6 = parcelRequire("iM9A6");

var $9pD6L = parcelRequire("9pD6L");

var $7eSHW = parcelRequire("7eSHW");

var $kbchp = parcelRequire("kbchp");

var $ig1j9 = parcelRequire("ig1j9");

var $hNBYx = parcelRequire("hNBYx");
class $2bb20f8873deb436$var$CanvasBuilder extends (0, $kbchp.default) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super();
        /**
     * @protected
     * @type {number}
     */ this.tolerance = tolerance;
        /**
     * @protected
     * @const
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent = maxExtent;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @type {number}
     */ this.maxLineWidth = 0;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction1_ = null;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction2_ = null;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.bufferedMaxExtent_ = null;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = [];
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = [];
        /**
     * @private
     * @type {import("../../coordinate.js").Coordinate}
     */ this.tmpCoordinate_ = [];
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = [];
        /**
     * @protected
     * @type {import("../canvas.js").FillStrokeState}
     */ this.state = /** @type {import("../canvas.js").FillStrokeState} */ {};
    }
    /**
   * @protected
   * @param {Array<number>} dashArray Dash array.
   * @return {Array<number>} Dash array with pixel ratio applied
   */ applyPixelRatio(dashArray) {
        const pixelRatio = this.pixelRatio;
        return pixelRatio == 1 ? dashArray : dashArray.map(function(dash) {
            return dash * pixelRatio;
        });
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} stride Stride.
   * @protected
   * @return {number} My end
   */ appendFlatPointCoordinates(flatCoordinates, stride) {
        const extent = this.getBufferedMaxExtent();
        const tmpCoord = this.tmpCoordinate_;
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            tmpCoord[0] = flatCoordinates[i];
            tmpCoord[1] = flatCoordinates[i + 1];
            if ((0, $9pD6L.containsCoordinate)(extent, tmpCoord)) {
                coordinates[myEnd++] = tmpCoord[0];
                coordinates[myEnd++] = tmpCoord[1];
            }
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} closed Last input coordinate equals first.
   * @param {boolean} skipFirst Skip first coordinate.
   * @protected
   * @return {number} My end.
   */ appendFlatLineCoordinates(flatCoordinates, offset, end, stride, closed, skipFirst) {
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        const extent = this.getBufferedMaxExtent();
        if (skipFirst) offset += stride;
        let lastXCoord = flatCoordinates[offset];
        let lastYCoord = flatCoordinates[offset + 1];
        const nextCoord = this.tmpCoordinate_;
        let skipped = true;
        let i, lastRel, nextRel;
        for(i = offset + stride; i < end; i += stride){
            nextCoord[0] = flatCoordinates[i];
            nextCoord[1] = flatCoordinates[i + 1];
            nextRel = (0, $9pD6L.coordinateRelationship)(extent, nextCoord);
            if (nextRel !== lastRel) {
                if (skipped) {
                    coordinates[myEnd++] = lastXCoord;
                    coordinates[myEnd++] = lastYCoord;
                    skipped = false;
                }
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
            } else if (nextRel === (0, $iM9A6.default).INTERSECTING) {
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
                skipped = false;
            } else skipped = true;
            lastXCoord = nextCoord[0];
            lastYCoord = nextCoord[1];
            lastRel = nextRel;
        }
        // Last coordinate equals first or only one point to append:
        if (closed && skipped || i === offset + stride) {
            coordinates[myEnd++] = lastXCoord;
            coordinates[myEnd++] = lastYCoord;
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Array<number>} builderEnds Builder ends.
   * @return {number} Offset.
   */ drawCustomCoordinates_(flatCoordinates, offset, ends, stride, builderEnds) {
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const builderEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
            builderEnds.push(builderEnd);
            offset = end;
        }
        return offset;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   * @override
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {
        this.beginGeometry(geometry, feature, index);
        const type = geometry.getType();
        const stride = geometry.getStride();
        const builderBegin = this.coordinates.length;
        let flatCoordinates, builderEnd, builderEnds, builderEndss;
        let offset;
        switch(type){
            case 'MultiPolygon':
                flatCoordinates = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getOrientedFlatCoordinates();
                builderEndss = [];
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                offset = 0;
                for(let i = 0, ii = endss.length; i < ii; ++i){
                    const myEnds = [];
                    offset = this.drawCustomCoordinates_(flatCoordinates, offset, endss[i], stride, myEnds);
                    builderEndss.push(myEnds);
                }
                this.instructions.push([
                    (0, $hNBYx.default).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    renderer,
                    (0, $7eSHW.inflateMultiCoordinatesArray),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $hNBYx.default).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $7eSHW.inflateMultiCoordinatesArray),
                    index
                ]);
                break;
            case 'Polygon':
            case 'MultiLineString':
                builderEnds = [];
                flatCoordinates = type == 'Polygon' ? /** @type {import("../../geom/Polygon.js").default} */ geometry.getOrientedFlatCoordinates() : geometry.getFlatCoordinates();
                offset = this.drawCustomCoordinates_(flatCoordinates, 0, /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */ geometry.getEnds(), stride, builderEnds);
                this.instructions.push([
                    (0, $hNBYx.default).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    renderer,
                    (0, $7eSHW.inflateCoordinatesArray),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $hNBYx.default).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $7eSHW.inflateCoordinatesArray),
                    index
                ]);
                break;
            case 'LineString':
            case 'Circle':
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
                this.instructions.push([
                    (0, $hNBYx.default).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    (0, $7eSHW.inflateCoordinates),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $hNBYx.default).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $7eSHW.inflateCoordinates),
                    index
                ]);
                break;
            case 'MultiPoint':
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
                if (builderEnd > builderBegin) {
                    this.instructions.push([
                        (0, $hNBYx.default).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        renderer,
                        (0, $7eSHW.inflateCoordinates),
                        index
                    ]);
                    this.hitDetectionInstructions.push([
                        (0, $hNBYx.default).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        hitDetectionRenderer || renderer,
                        (0, $7eSHW.inflateCoordinates),
                        index
                    ]);
                }
                break;
            case 'Point':
                flatCoordinates = geometry.getFlatCoordinates();
                this.coordinates.push(flatCoordinates[0], flatCoordinates[1]);
                builderEnd = this.coordinates.length;
                this.instructions.push([
                    (0, $hNBYx.default).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    undefined,
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $hNBYx.default).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    undefined,
                    index
                ]);
                break;
            default:
        }
        this.endGeometry(feature);
    }
    /**
   * @protected
   * @param {import("../../geom/Geometry").default|import("../Feature.js").default} geometry The geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} index Render order index
   */ beginGeometry(geometry, feature, index) {
        this.beginGeometryInstruction1_ = [
            (0, $hNBYx.default).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.instructions.push(this.beginGeometryInstruction1_);
        this.beginGeometryInstruction2_ = [
            (0, $hNBYx.default).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ finish() {
        return {
            instructions: this.instructions,
            hitDetectionInstructions: this.hitDetectionInstructions,
            coordinates: this.coordinates
        };
    }
    /**
   * Reverse the hit detection instructions.
   */ reverseHitDetectionInstructions() {
        const hitDetectionInstructions = this.hitDetectionInstructions;
        // step 1 - reverse array
        hitDetectionInstructions.reverse();
        // step 2 - reverse instructions within geometry blocks
        let i;
        const n = hitDetectionInstructions.length;
        let instruction;
        let type;
        let begin = -1;
        for(i = 0; i < n; ++i){
            instruction = hitDetectionInstructions[i];
            type = /** @type {import("./Instruction.js").default} */ instruction[0];
            if (type == (0, $hNBYx.default).END_GEOMETRY) begin = i;
            else if (type == (0, $hNBYx.default).BEGIN_GEOMETRY) {
                instruction[2] = i;
                (0, $fVVyM.reverseSubArray)(this.hitDetectionInstructions, begin, i);
                begin = -1;
            }
        }
    }
    /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import('../canvas.js').FillStrokeState} [state] State.
   * @return {import('../canvas.js').FillStrokeState} State.
   */ fillStyleToState(fillStyle, state = /** @type {import('../canvas.js').FillStrokeState} */ {}) {
        if (fillStyle) {
            const fillStyleColor = fillStyle.getColor();
            state.fillPatternScale = fillStyleColor && typeof fillStyleColor === 'object' && 'src' in fillStyleColor ? this.pixelRatio : 1;
            state.fillStyle = (0, $jh19n.asColorLike)(fillStyleColor ? fillStyleColor : (0, $ig1j9.defaultFillStyle));
        } else state.fillStyle = undefined;
        return state;
    }
    /**
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {import("../canvas.js").FillStrokeState} State.
   */ strokeStyleToState(strokeStyle, state = /** @type {import('../canvas.js').FillStrokeState} */ {}) {
        if (strokeStyle) {
            const strokeStyleColor = strokeStyle.getColor();
            state.strokeStyle = (0, $jh19n.asColorLike)(strokeStyleColor ? strokeStyleColor : (0, $ig1j9.defaultStrokeStyle));
            const strokeStyleLineCap = strokeStyle.getLineCap();
            state.lineCap = strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $ig1j9.defaultLineCap);
            const strokeStyleLineDash = strokeStyle.getLineDash();
            state.lineDash = strokeStyleLineDash ? strokeStyleLineDash.slice() : (0, $ig1j9.defaultLineDash);
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            state.lineDashOffset = strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $ig1j9.defaultLineDashOffset);
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            state.lineJoin = strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $ig1j9.defaultLineJoin);
            const strokeStyleWidth = strokeStyle.getWidth();
            state.lineWidth = strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $ig1j9.defaultLineWidth);
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            state.miterLimit = strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $ig1j9.defaultMiterLimit);
            const strokeStyleOffset = strokeStyle.getOffset();
            state.strokeOffset = strokeStyleOffset ?? (0, $ig1j9.defaultStrokeOffset);
            if (state.lineWidth > this.maxLineWidth) {
                this.maxLineWidth = state.lineWidth;
                // invalidate the buffered max extent cache
                this.bufferedMaxExtent_ = null;
            }
        } else {
            state.strokeStyle = undefined;
            state.lineCap = undefined;
            state.lineDash = null;
            state.lineDashOffset = undefined;
            state.lineJoin = undefined;
            state.lineWidth = undefined;
            state.miterLimit = undefined;
            state.strokeOffset = undefined;
        }
        return state;
    }
    /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        const state = this.state;
        this.fillStyleToState(fillStyle, state);
        this.strokeStyleToState(strokeStyle, state);
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Fill instruction.
   */ createFill(state) {
        const fillStyle = state.fillStyle;
        /** @type {Array<*>} */ const fillInstruction = [
            (0, $hNBYx.default).SET_FILL_STYLE,
            fillStyle
        ];
        if (typeof fillStyle !== 'string') // Fill is a pattern or gradient - align and scale it!
        fillInstruction.push(state.fillPatternScale);
        return fillInstruction;
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */ applyStroke(state) {
        this.instructions.push(this.createStroke(state));
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Stroke instruction.
   */ createStroke(state) {
        return [
            (0, $hNBYx.default).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth * this.pixelRatio,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash ? this.applyPixelRatio(state.lineDash) : null,
            state.lineDashOffset * this.pixelRatio
        ];
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState):Array<*>} createFill Create fill.
   */ updateFillStyle(state, createFill) {
        const fillStyle = state.fillStyle;
        if (typeof fillStyle !== 'string' || state.currentFillStyle != fillStyle) {
            this.instructions.push(createFill.call(this, state));
            state.currentFillStyle = fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState): void} applyStroke Apply stroke.
   */ updateStrokeStyle(state, applyStroke) {
        const strokeStyle = state.strokeStyle;
        const lineCap = state.lineCap;
        const lineDash = state.lineDash;
        const lineDashOffset = state.lineDashOffset;
        const lineJoin = state.lineJoin;
        const lineWidth = state.lineWidth;
        const miterLimit = state.miterLimit;
        const strokeOffset = state.strokeOffset;
        if (state.currentStrokeStyle != strokeStyle || state.currentLineCap != lineCap || lineDash != state.currentLineDash && !(0, $fVVyM.equals)(state.currentLineDash, lineDash) || state.currentLineDashOffset != lineDashOffset || state.currentLineJoin != lineJoin || state.currentLineWidth != lineWidth || state.currentMiterLimit != miterLimit || state.currentStrokeOffset != strokeOffset) {
            applyStroke.call(this, state);
            state.currentStrokeStyle = strokeStyle;
            state.currentLineCap = lineCap;
            state.currentLineDash = lineDash;
            state.currentLineDashOffset = lineDashOffset;
            state.currentLineJoin = lineJoin;
            state.currentLineWidth = lineWidth;
            state.currentMiterLimit = miterLimit;
            state.currentStrokeOffset = strokeOffset;
        }
    }
    /**
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ endGeometry(feature) {
        this.beginGeometryInstruction1_[2] = this.instructions.length;
        this.beginGeometryInstruction1_ = null;
        this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length;
        this.beginGeometryInstruction2_ = null;
        const endGeometryInstruction = [
            (0, $hNBYx.default).END_GEOMETRY,
            feature
        ];
        this.instructions.push(endGeometryInstruction);
        this.hitDetectionInstructions.push(endGeometryInstruction);
    }
    /**
   * Get the buffered rendering extent.  Rendering will be clipped to the extent
   * provided to the constructor.  To account for symbolizers that may intersect
   * this extent, we calculate a buffered extent (e.g. based on stroke width).
   * @return {import("../../extent.js").Extent} The buffered rendering extent.
   * @protected
   */ getBufferedMaxExtent() {
        if (!this.bufferedMaxExtent_) {
            this.bufferedMaxExtent_ = (0, $9pD6L.clone)(this.maxExtent);
            if (this.maxLineWidth > 0) {
                const width = this.resolution * (this.maxLineWidth + 1) / 2;
                (0, $9pD6L.buffer)(this.bufferedMaxExtent_, width, this.bufferedMaxExtent_);
            }
        }
        return this.bufferedMaxExtent_;
    }
}
var $2bb20f8873deb436$export$2e2bcd8739ae039 = $2bb20f8873deb436$var$CanvasBuilder;

});
parcelRegister("kbchp", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb0e5c3938110b4c$export$2e2bcd8739ae039);
/**
 * @module ol/render/VectorContext
 */ /**
 * @classdesc
 * Context for drawing geometries.  A vector context is available on render
 * events and does not need to be constructed directly.
 * @api
 */ class $eb0e5c3938110b4c$var$VectorContext {
    /**
   * Render a geometry with a custom renderer.
   *
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {}
    /**
   * Render a geometry.
   *
   * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
   */ drawGeometry(geometry) {}
    /**
   * Set the rendering style.
   *
   * @param {import("../style/Style.js").default} style The rendering style.
   */ setStyle(style) {}
    /**
   * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawCircle(circleGeometry, feature, index) {}
    /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../style/Style.js").default} style Style.
   * @param {number} [index] Render order index.
   */ drawFeature(feature, style, index) {}
    /**
   * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawGeometryCollection(geometryCollectionGeometry, feature, index) {}
    /**
   * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawLineString(lineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPoint(multiPointGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPoint(pointGeometry, feature, index) {}
    /**
   * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPolygon(polygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/SimpleGeometry.js").default|import("./Feature.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawText(geometry, feature, index) {}
    /**
   * @param {import("../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
   */ setFillStrokeStyle(fillStyle, strokeStyle) {}
    /**
   * @param {import("../style/Image.js").default} imageStyle Image style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with a text style.
   */ setImageStyle(imageStyle, declutterImageWithText) {}
    /**
   * @param {import("../style/Text.js").default} textStyle Text style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with an image style.
   */ setTextStyle(textStyle, declutterImageWithText) {}
}
var $eb0e5c3938110b4c$export$2e2bcd8739ae039 = $eb0e5c3938110b4c$var$VectorContext;

});

parcelRegister("hNBYx", function(module, exports) {

$parcel$export(module.exports, "fillInstruction", () => $cf547866e052f25b$export$f21891651e408226);
$parcel$export(module.exports, "strokeInstruction", () => $cf547866e052f25b$export$7a98aa5364d62ba8);
$parcel$export(module.exports, "beginPathInstruction", () => $cf547866e052f25b$export$9f746cc58a899a00);
$parcel$export(module.exports, "closePathInstruction", () => $cf547866e052f25b$export$89b10f327e413e71);
$parcel$export(module.exports, "default", () => $cf547866e052f25b$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/Instruction
 */ /**
 * @enum {number}
 */ const $cf547866e052f25b$var$Instruction = {
    BEGIN_GEOMETRY: 0,
    BEGIN_PATH: 1,
    CIRCLE: 2,
    CLOSE_PATH: 3,
    CUSTOM: 4,
    DRAW_CHARS: 5,
    DRAW_IMAGE: 6,
    END_GEOMETRY: 7,
    FILL: 8,
    MOVE_TO_LINE_TO: 9,
    SET_FILL_STYLE: 10,
    SET_STROKE_STYLE: 11,
    STROKE: 12
};
const $cf547866e052f25b$export$f21891651e408226 = [
    $cf547866e052f25b$var$Instruction.FILL
];
const $cf547866e052f25b$export$7a98aa5364d62ba8 = [
    $cf547866e052f25b$var$Instruction.STROKE
];
const $cf547866e052f25b$export$9f746cc58a899a00 = [
    $cf547866e052f25b$var$Instruction.BEGIN_PATH
];
const $cf547866e052f25b$export$89b10f327e413e71 = [
    $cf547866e052f25b$var$Instruction.CLOSE_PATH
];
var $cf547866e052f25b$export$2e2bcd8739ae039 = $cf547866e052f25b$var$Instruction;

});


parcelRegister("fEvr3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b652f9dd73b29cfe$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/ImageBuilder
 */ 
var $9pD6L = parcelRequire("9pD6L");

var $3KABr = parcelRequire("3KABr");

var $hNBYx = parcelRequire("hNBYx");
class $b652f9dd73b29cfe$var$CanvasImageBuilder extends (0, $3KABr.default) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.imagePixelRatio_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorY_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.height_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.opacity_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originY_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        /**
     * @private
     * @type {import("../../size.js").Size|undefined}
     */ this.scale_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = undefined;
        /**
     * @private
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with a text builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} pointGeometry Point geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawPoint(pointGeometry, feature, index) {
        if (!this.image_ || this.maxExtent && !(0, $9pD6L.containsCoordinate)(this.maxExtent, pointGeometry.getFlatCoordinates())) return;
        this.beginGeometry(pointGeometry, feature, index);
        const flatCoordinates = pointGeometry.getFlatCoordinates();
        const stride = pointGeometry.getStride();
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
        this.instructions.push([
            (0, $hNBYx.default).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $hNBYx.default).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiPoint(multiPointGeometry, feature, index) {
        if (!this.image_) return;
        this.beginGeometry(multiPointGeometry, feature, index);
        const flatCoordinates = multiPointGeometry.getFlatCoordinates();
        const filteredFlatCoordinates = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += multiPointGeometry.getStride())if (!this.maxExtent || (0, $9pD6L.containsCoordinate)(this.maxExtent, flatCoordinates.slice(i, i + 2))) filteredFlatCoordinates.push(flatCoordinates[i], flatCoordinates[i + 1]);
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(filteredFlatCoordinates, 2);
        this.instructions.push([
            (0, $hNBYx.default).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $hNBYx.default).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        this.reverseHitDetectionInstructions();
        // FIXME this doesn't really protect us against further calls to draw*Geometry
        this.anchorX_ = undefined;
        this.anchorY_ = undefined;
        this.hitDetectionImage_ = null;
        this.image_ = null;
        this.imagePixelRatio_ = undefined;
        this.height_ = undefined;
        this.scale_ = undefined;
        this.opacity_ = undefined;
        this.originX_ = undefined;
        this.originY_ = undefined;
        this.rotateWithView_ = undefined;
        this.rotation_ = undefined;
        this.width_ = undefined;
        return super.finish();
    }
    /**
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @param {Object} [sharedData] Shared data.
   * @override
   */ setImageStyle(imageStyle, sharedData) {
        const anchor = imageStyle.getAnchor();
        const size = imageStyle.getSize();
        const origin = imageStyle.getOrigin();
        this.imagePixelRatio_ = imageStyle.getPixelRatio(this.pixelRatio);
        this.anchorX_ = anchor[0];
        this.anchorY_ = anchor[1];
        this.hitDetectionImage_ = imageStyle.getHitDetectionImage();
        this.image_ = imageStyle.getImage(this.pixelRatio);
        this.height_ = size[1];
        this.opacity_ = imageStyle.getOpacity();
        this.originX_ = origin[0];
        this.originY_ = origin[1];
        this.rotateWithView_ = imageStyle.getRotateWithView();
        this.rotation_ = imageStyle.getRotation();
        this.scale_ = imageStyle.getScaleArray();
        this.width_ = size[0];
        this.declutterMode_ = imageStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
var $b652f9dd73b29cfe$export$2e2bcd8739ae039 = $b652f9dd73b29cfe$var$CanvasImageBuilder;

});

parcelRegister("dUudE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a207f23baa5aa2c5$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/LineStringBuilder
 */ 
var $ig1j9 = parcelRequire("ig1j9");

var $3KABr = parcelRequire("3KABr");

var $hNBYx = parcelRequire("hNBYx");
class $a207f23baa5aa2c5$var$CanvasLineStringBuilder extends (0, $3KABr.default) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {number} [strokeOffset] Stroke Offset in pixels.
   * @private
   * @return {number} end.
   */ drawFlatCoordinates_(flatCoordinates, offset, end, stride, strokeOffset) {
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
        this.instructions.push([
            (0, $hNBYx.default).MOVE_TO_LINE_TO,
            myBegin,
            myEnd,
            strokeOffset * this.pixelRatio
        ]);
        this.hitDetectionInstructions.push([
            (0, $hNBYx.default).MOVE_TO_LINE_TO,
            myBegin,
            myEnd,
            strokeOffset
        ]);
        return end;
    }
    /**
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawLineString(lineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        const strokeOffset = state.strokeOffset;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(lineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, $hNBYx.default).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $ig1j9.defaultLineDash),
            (0, $ig1j9.defaultLineDashOffset)
        ], (0, $hNBYx.beginPathInstruction));
        const flatCoordinates = lineStringGeometry.getFlatCoordinates();
        const stride = lineStringGeometry.getStride();
        this.drawFlatCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride, strokeOffset);
        this.hitDetectionInstructions.push((0, $hNBYx.strokeInstruction));
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        const strokeOffset = state.strokeOffset;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(multiLineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, $hNBYx.default).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $ig1j9.defaultLineDash),
            (0, $ig1j9.defaultLineDashOffset)
        ], (0, $hNBYx.beginPathInstruction));
        const ends = multiLineStringGeometry.getEnds();
        const flatCoordinates = multiLineStringGeometry.getFlatCoordinates();
        const stride = multiLineStringGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.drawFlatCoordinates_(flatCoordinates, offset, /** @type {number} */ ends[i], stride, strokeOffset);
        this.hitDetectionInstructions.push((0, $hNBYx.strokeInstruction));
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        const state = this.state;
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) this.instructions.push((0, $hNBYx.strokeInstruction));
        this.reverseHitDetectionInstructions();
        this.state = null;
        return super.finish();
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @override
   */ applyStroke(state) {
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) {
            this.instructions.push((0, $hNBYx.strokeInstruction));
            state.lastStroke = this.coordinates.length;
        }
        state.lastStroke = 0;
        super.applyStroke(state);
        this.instructions.push((0, $hNBYx.beginPathInstruction));
    }
}
var $a207f23baa5aa2c5$export$2e2bcd8739ae039 = $a207f23baa5aa2c5$var$CanvasLineStringBuilder;

});

parcelRegister("aKl4u", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d2e8ba11a45ae8a$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/PolygonBuilder
 */ 
var $bDhby = parcelRequire("bDhby");

var $ig1j9 = parcelRequire("ig1j9");

var $3KABr = parcelRequire("3KABr");

var $hNBYx = parcelRequire("hNBYx");
class $7d2e8ba11a45ae8a$var$CanvasPolygonBuilder extends (0, $3KABr.default) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {number} [strokeOffset] Stroke Offset in pixels.
   * @private
   * @return {number} End.
   */ drawFlatCoordinatess_(flatCoordinates, offset, ends, stride, strokeOffset) {
        const state = this.state;
        const fill = state.fillStyle !== undefined;
        const stroke = state.strokeStyle !== undefined;
        const numEnds = ends.length;
        this.instructions.push((0, $hNBYx.beginPathInstruction));
        this.hitDetectionInstructions.push((0, $hNBYx.beginPathInstruction));
        for(let i = 0; i < numEnds; ++i){
            const end = ends[i];
            const myBegin = this.coordinates.length;
            const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, true, !stroke);
            this.instructions.push([
                (0, $hNBYx.default).MOVE_TO_LINE_TO,
                myBegin,
                myEnd,
                strokeOffset * this.pixelRatio,
                true
            ]);
            this.hitDetectionInstructions.push([
                (0, $hNBYx.default).MOVE_TO_LINE_TO,
                myBegin,
                myEnd,
                strokeOffset,
                true
            ]);
            if (stroke) {
                // Performance optimization: only call closePath() when we have a stroke.
                // Otherwise the ring is closed already (see appendFlatLineCoordinates above).
                this.instructions.push((0, $hNBYx.closePathInstruction));
                this.hitDetectionInstructions.push((0, $hNBYx.closePathInstruction));
            }
            offset = end;
        }
        if (fill) {
            this.instructions.push((0, $hNBYx.fillInstruction));
            this.hitDetectionInstructions.push((0, $hNBYx.fillInstruction));
        }
        if (stroke) {
            this.instructions.push((0, $hNBYx.strokeInstruction));
            this.hitDetectionInstructions.push((0, $hNBYx.strokeInstruction));
        }
        return offset;
    }
    /**
   * @param {import("../../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawCircle(circleGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        const strokeOffset = state.strokeOffset;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        if (this.handleStrokeOffset_(()=>this.drawCircle(circleGeometry, feature, index))) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(circleGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $hNBYx.default).SET_FILL_STYLE,
            (0, $ig1j9.defaultFillStyle)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $hNBYx.default).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $ig1j9.defaultLineDash),
            (0, $ig1j9.defaultLineDashOffset)
        ]);
        const flatCoordinates = circleGeometry.getFlatCoordinates();
        const stride = circleGeometry.getStride();
        const myBegin = this.coordinates.length;
        this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
        const circleInstruction = [
            (0, $hNBYx.default).CIRCLE,
            myBegin,
            strokeOffset
        ];
        this.instructions.push((0, $hNBYx.beginPathInstruction), circleInstruction);
        this.hitDetectionInstructions.push((0, $hNBYx.beginPathInstruction), circleInstruction);
        if (state.fillStyle !== undefined) {
            this.instructions.push((0, $hNBYx.fillInstruction));
            this.hitDetectionInstructions.push((0, $hNBYx.fillInstruction));
        }
        if (state.strokeStyle !== undefined) {
            this.instructions.push((0, $hNBYx.strokeInstruction));
            this.hitDetectionInstructions.push((0, $hNBYx.strokeInstruction));
        }
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawPolygon(polygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        const strokeOffset = state.strokeOffset;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        if (this.handleStrokeOffset_(()=>this.drawPolygon(polygonGeometry, feature, index))) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(polygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $hNBYx.default).SET_FILL_STYLE,
            (0, $ig1j9.defaultFillStyle)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $hNBYx.default).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $ig1j9.defaultLineDash),
            (0, $ig1j9.defaultLineDashOffset)
        ]);
        const ends = polygonGeometry.getEnds();
        const flatCoordinates = polygonGeometry.getOrientedFlatCoordinates();
        const stride = polygonGeometry.getStride();
        this.drawFlatCoordinatess_(flatCoordinates, 0, /** @type {Array<number>} */ ends, stride, strokeOffset);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        const strokeOffset = state.strokeOffset;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        if (this.handleStrokeOffset_(()=>this.drawMultiPolygon(multiPolygonGeometry, feature, index))) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(multiPolygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $hNBYx.default).SET_FILL_STYLE,
            (0, $ig1j9.defaultFillStyle)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $hNBYx.default).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $ig1j9.defaultLineDash),
            (0, $ig1j9.defaultLineDashOffset)
        ]);
        const endss = multiPolygonGeometry.getEndss();
        const flatCoordinates = multiPolygonGeometry.getOrientedFlatCoordinates();
        const stride = multiPolygonGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i)offset = this.drawFlatCoordinatess_(flatCoordinates, offset, endss[i], stride, strokeOffset);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        this.reverseHitDetectionInstructions();
        this.state = null;
        // We want to preserve topology when drawing polygons.  Polygons are
        // simplified using quantization and point elimination. However, we might
        // have received a mix of quantized and non-quantized geometries, so ensure
        // that all are quantized by quantizing all coordinates in the batch.
        const tolerance = this.tolerance;
        if (tolerance !== 0) {
            const coordinates = this.coordinates;
            for(let i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = (0, $bDhby.snap)(coordinates[i], tolerance);
        }
        return super.finish();
    }
    /**
   * @private
   */ setFillStrokeStyles_() {
        const state = this.state;
        this.updateFillStyle(state, this.createFill);
        this.updateStrokeStyle(state, this.applyStroke);
    }
    handleStrokeOffset_(drawGeometryCallback) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        const strokeOffset = state.strokeOffset;
        // In case both fill style and stroke style are defined and the stroke style has an offset,
        // the stroke and fill should be done in separate steps, because offset stroke shape will
        // be different from the original shape used for the fill.
        if (Math.abs(strokeOffset) > 0 && fillStyle !== undefined && strokeStyle !== undefined) {
            // First do only fill
            state.strokeStyle = undefined;
            state.strokeOffset = 0;
            drawGeometryCallback();
            // Now separately do the stroke
            state.fillStyle = undefined;
            state.strokeStyle = strokeStyle;
            state.strokeOffset = strokeOffset;
            drawGeometryCallback();
            // Reset the state to the original
            state.fillStyle = fillStyle;
            return true;
        }
        return false;
    }
}
var $7d2e8ba11a45ae8a$export$2e2bcd8739ae039 = $7d2e8ba11a45ae8a$var$CanvasPolygonBuilder;

});

parcelRegister("bboJK", function(module, exports) {

$parcel$export(module.exports, "TEXT_ALIGN", () => $8243e906fae47bbe$export$91a016276e4aee96);
$parcel$export(module.exports, "default", () => $8243e906fae47bbe$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/TextBuilder
 */ 
var $jh19n = parcelRequire("jh19n");

var $9pD6L = parcelRequire("9pD6L");

var $adx6x = parcelRequire("adx6x");

var $apNsw = parcelRequire("apNsw");

var $9iPUS = parcelRequire("9iPUS");

var $ig1j9 = parcelRequire("ig1j9");

var $3KABr = parcelRequire("3KABr");

var $hNBYx = parcelRequire("hNBYx");
const $8243e906fae47bbe$export$91a016276e4aee96 = {
    'left': 0,
    'center': 0.5,
    'right': 1,
    'top': 0,
    'middle': 0.5,
    'hanging': 0.2,
    'alphabetic': 0.8,
    'ideographic': 0.8,
    'bottom': 1
};
class $8243e906fae47bbe$var$CanvasTextBuilder extends (0, $3KABr.default) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {Array<HTMLCanvasElement>}
     */ this.labels_ = null;
        /**
     * @private
     * @type {string|Array<string>}
     */ this.text_ = '';
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.textRotateWithView_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.textKeepUpright_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = {};
        this.fillStates[0, $ig1j9.defaultFillStyle] = {
            fillStyle: (0, $ig1j9.defaultFillStyle)
        };
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = {};
        /**
     * @private
     * @type {import("../canvas.js").TextState}
     */ this.textState_ = /** @type {import("../canvas.js").TextState} */ {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = {};
        /**
     * @private
     * @type {string}
     */ this.textKey_ = '';
        /**
     * @private
     * @type {string}
     */ this.fillKey_ = '';
        /**
     * @private
     * @type {string}
     */ this.strokeKey_ = '';
        /**
     * @private
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with an image builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        const instructions = super.finish();
        instructions.textStates = this.textStates;
        instructions.fillStates = this.fillStates;
        instructions.strokeStates = this.strokeStates;
        return instructions;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default|import("../Feature.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawText(geometry, feature, index) {
        const fillState = this.textFillState_;
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        if (this.text_ === '' || !textState || !fillState && !strokeState) return;
        const coordinates = this.coordinates;
        let begin = coordinates.length;
        const geometryType = geometry.getType();
        let flatCoordinates = null;
        let stride = geometry.getStride();
        if (textState.placement === 'line' && (geometryType == 'LineString' || geometryType == 'MultiLineString' || geometryType == 'Polygon' || geometryType == 'MultiPolygon')) {
            if (!(0, $9pD6L.intersects)(this.maxExtent, geometry.getExtent())) return;
            let ends;
            flatCoordinates = geometry.getFlatCoordinates();
            if (geometryType == 'LineString') ends = [
                flatCoordinates.length
            ];
            else if (geometryType == 'MultiLineString') ends = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getEnds();
            else if (geometryType == 'Polygon') ends = /** @type {import("../../geom/Polygon.js").default} */ geometry.getEnds().slice(0, 1);
            else if (geometryType == 'MultiPolygon') {
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                ends = [];
                for(let i = 0, ii = endss.length; i < ii; ++i)ends.push(endss[i][0]);
            }
            this.beginGeometry(geometry, feature, index);
            const repeat = textState.repeat;
            const textAlign = repeat ? undefined : textState.textAlign;
            // No `justify` support for line placement.
            let flatOffset = 0;
            for(let o = 0, oo = ends.length; o < oo; ++o){
                let chunks;
                if (repeat) chunks = (0, $adx6x.lineChunk)(repeat * this.resolution, flatCoordinates, flatOffset, ends[o], stride);
                else chunks = [
                    flatCoordinates.slice(flatOffset, ends[o])
                ];
                for(let c = 0, cc = chunks.length; c < cc; ++c){
                    const chunk = chunks[c];
                    let chunkBegin = 0;
                    let chunkEnd = chunk.length;
                    if (textAlign == undefined) {
                        const range = (0, $apNsw.matchingChunk)(textState.maxAngle, chunk, 0, chunk.length, 2);
                        chunkBegin = range[0];
                        chunkEnd = range[1];
                    }
                    for(let i = chunkBegin; i < chunkEnd; i += stride)coordinates.push(chunk[i], chunk[i + 1]);
                    const end = coordinates.length;
                    flatOffset = ends[o];
                    this.drawChars_(begin, end);
                    begin = end;
                }
            }
            this.endGeometry(feature);
        } else {
            let geometryWidths = textState.overflow ? null : [];
            switch(geometryType){
                case 'Point':
                case 'MultiPoint':
                    flatCoordinates = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.getFlatCoordinates();
                    break;
                case 'LineString':
                    flatCoordinates = /** @type {import("../../geom/LineString.js").default} */ geometry.getFlatMidpoint();
                    break;
                case 'Circle':
                    flatCoordinates = /** @type {import("../../geom/Circle.js").default} */ geometry.getCenter();
                    break;
                case 'MultiLineString':
                    flatCoordinates = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getFlatMidpoints();
                    stride = 2;
                    break;
                case 'Polygon':
                    flatCoordinates = /** @type {import("../../geom/Polygon.js").default} */ geometry.getFlatInteriorPoint();
                    if (!textState.overflow) geometryWidths.push(flatCoordinates[2] / this.resolution);
                    stride = 3;
                    break;
                case 'MultiPolygon':
                    const interiorPoints = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getFlatInteriorPoints();
                    flatCoordinates = [];
                    for(let i = 0, ii = interiorPoints.length; i < ii; i += 3){
                        if (!textState.overflow) geometryWidths.push(interiorPoints[i + 2] / this.resolution);
                        flatCoordinates.push(interiorPoints[i], interiorPoints[i + 1]);
                    }
                    if (flatCoordinates.length === 0) return;
                    stride = 2;
                    break;
                default:
            }
            const end = this.appendFlatPointCoordinates(flatCoordinates, stride);
            if (end === begin) return;
            if (geometryWidths && (end - begin) / 2 !== flatCoordinates.length / stride) {
                let beg = begin / 2;
                geometryWidths = geometryWidths.filter((w, i)=>{
                    const keep = coordinates[(beg + i) * 2] === flatCoordinates[i * stride] && coordinates[(beg + i) * 2 + 1] === flatCoordinates[i * stride + 1];
                    if (!keep) --beg;
                    return keep;
                });
            }
            this.saveTextStates_();
            const backgroundFill = textState.backgroundFill ? this.createFill(this.fillStyleToState(textState.backgroundFill)) : null;
            const backgroundStroke = textState.backgroundStroke ? this.createStroke(this.strokeStyleToState(textState.backgroundStroke)) : null;
            this.beginGeometry(geometry, feature, index);
            // adjust padding for negative scale
            let padding = textState.padding;
            if (padding != (0, $ig1j9.defaultPadding) && (textState.scale[0] < 0 || textState.scale[1] < 0)) {
                let p0 = textState.padding[0];
                let p1 = textState.padding[1];
                let p2 = textState.padding[2];
                let p3 = textState.padding[3];
                if (textState.scale[0] < 0) {
                    p1 = -p1;
                    p3 = -p3;
                }
                if (textState.scale[1] < 0) {
                    p0 = -p0;
                    p2 = -p2;
                }
                padding = [
                    p0,
                    p1,
                    p2,
                    p3
                ];
            }
            // The image is unknown at this stage so we pass null; it will be computed at render time.
            // For clarity, we pass NaN for offsetX, offsetY, width and height, which will be computed at
            // render time.
            const pixelRatio = this.pixelRatio;
            this.instructions.push([
                (0, $hNBYx.default).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    1,
                    1
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding == (0, $ig1j9.defaultPadding) ? (0, $ig1j9.defaultPadding) : padding.map(function(p) {
                    return p * pixelRatio;
                }),
                backgroundFill,
                backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            const scale = 1 / pixelRatio;
            // Set default fill for hit detection background
            const hitDetectionBackgroundFill = backgroundFill ? backgroundFill.slice(0) : null;
            if (hitDetectionBackgroundFill) hitDetectionBackgroundFill[1] = (0, $ig1j9.defaultFillStyle);
            this.hitDetectionInstructions.push([
                (0, $hNBYx.default).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    scale,
                    scale
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding,
                hitDetectionBackgroundFill,
                backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_ ? (0, $ig1j9.defaultFillStyle) : this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            this.endGeometry(feature);
        }
    }
    /**
   * @private
   */ saveTextStates_() {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const fillState = this.textFillState_;
        const strokeKey = this.strokeKey_;
        if (strokeState) {
            if (!(strokeKey in this.strokeStates)) this.strokeStates[strokeKey] = {
                strokeStyle: strokeState.strokeStyle,
                lineCap: strokeState.lineCap,
                lineDashOffset: strokeState.lineDashOffset,
                lineWidth: strokeState.lineWidth,
                lineJoin: strokeState.lineJoin,
                miterLimit: strokeState.miterLimit,
                lineDash: strokeState.lineDash
            };
        }
        const textKey = this.textKey_;
        if (!(textKey in this.textStates)) this.textStates[textKey] = {
            font: textState.font,
            textAlign: textState.textAlign || (0, $ig1j9.defaultTextAlign),
            justify: textState.justify,
            textBaseline: textState.textBaseline || (0, $ig1j9.defaultTextBaseline),
            scale: textState.scale
        };
        const fillKey = this.fillKey_;
        if (fillState) {
            if (!(fillKey in this.fillStates)) this.fillStates[fillKey] = {
                fillStyle: fillState.fillStyle
            };
        }
    }
    /**
   * @private
   * @param {number} begin Begin.
   * @param {number} end End.
   */ drawChars_(begin, end) {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const strokeKey = this.strokeKey_;
        const textKey = this.textKey_;
        const fillKey = this.fillKey_;
        this.saveTextStates_();
        const pixelRatio = this.pixelRatio;
        const baseline = $8243e906fae47bbe$export$91a016276e4aee96[textState.textBaseline];
        const offsetY = this.textOffsetY_ * pixelRatio;
        const text = this.text_;
        const strokeWidth = strokeState ? strokeState.lineWidth * Math.abs(textState.scale[0]) / 2 : 0;
        this.instructions.push([
            (0, $hNBYx.default).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1,
            this.declutterMode_,
            this.textKeepUpright_
        ]);
        this.hitDetectionInstructions.push([
            (0, $hNBYx.default).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey ? (0, $ig1j9.defaultFillStyle) : fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1 / pixelRatio,
            this.declutterMode_,
            this.textKeepUpright_
        ]);
    }
    /**
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @param {Object} [sharedData] Shared data.
   * @override
   */ setTextStyle(textStyle, sharedData) {
        let textState, fillState, strokeState;
        if (!textStyle) this.text_ = '';
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) {
                fillState = null;
                this.textFillState_ = fillState;
            } else {
                fillState = this.textFillState_;
                if (!fillState) {
                    fillState = /** @type {import("../canvas.js").FillState} */ {};
                    this.textFillState_ = fillState;
                }
                fillState.fillStyle = (0, $jh19n.asColorLike)(textFillStyle.getColor() || (0, $ig1j9.defaultFillStyle));
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) {
                strokeState = null;
                this.textStrokeState_ = strokeState;
            } else {
                strokeState = this.textStrokeState_;
                if (!strokeState) {
                    strokeState = /** @type {import("../canvas.js").StrokeState} */ {};
                    this.textStrokeState_ = strokeState;
                }
                const lineDash = textStrokeStyle.getLineDash();
                const lineDashOffset = textStrokeStyle.getLineDashOffset();
                const lineWidth = textStrokeStyle.getWidth();
                const miterLimit = textStrokeStyle.getMiterLimit();
                strokeState.lineCap = textStrokeStyle.getLineCap() || (0, $ig1j9.defaultLineCap);
                strokeState.lineDash = lineDash ? lineDash.slice() : (0, $ig1j9.defaultLineDash);
                strokeState.lineDashOffset = lineDashOffset === undefined ? (0, $ig1j9.defaultLineDashOffset) : lineDashOffset;
                strokeState.lineJoin = textStrokeStyle.getLineJoin() || (0, $ig1j9.defaultLineJoin);
                strokeState.lineWidth = lineWidth === undefined ? (0, $ig1j9.defaultLineWidth) : lineWidth;
                strokeState.miterLimit = miterLimit === undefined ? (0, $ig1j9.defaultMiterLimit) : miterLimit;
                strokeState.strokeStyle = (0, $jh19n.asColorLike)(textStrokeStyle.getColor() || (0, $ig1j9.defaultStrokeStyle));
            }
            textState = this.textState_;
            const font = textStyle.getFont() || (0, $ig1j9.defaultFont);
            (0, $ig1j9.registerFont)(font);
            const textScale = textStyle.getScaleArray();
            textState.overflow = textStyle.getOverflow();
            textState.font = font;
            textState.maxAngle = textStyle.getMaxAngle();
            textState.placement = textStyle.getPlacement();
            textState.textAlign = textStyle.getTextAlign();
            textState.repeat = textStyle.getRepeat();
            textState.justify = textStyle.getJustify();
            textState.textBaseline = textStyle.getTextBaseline() || (0, $ig1j9.defaultTextBaseline);
            textState.backgroundFill = textStyle.getBackgroundFill();
            textState.backgroundStroke = textStyle.getBackgroundStroke();
            textState.padding = textStyle.getPadding() || (0, $ig1j9.defaultPadding);
            textState.scale = textScale === undefined ? [
                1,
                1
            ] : textScale;
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textKeepUpright = textStyle.getKeepUpright();
            const textRotation = textStyle.getRotation();
            this.text_ = textStyle.getText() || '';
            this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
            this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
            this.textRotateWithView_ = textRotateWithView === undefined ? false : textRotateWithView;
            this.textKeepUpright_ = textKeepUpright === undefined ? true : textKeepUpright;
            this.textRotation_ = textRotation === undefined ? 0 : textRotation;
            this.strokeKey_ = strokeState ? (typeof strokeState.strokeStyle == 'string' ? strokeState.strokeStyle : (0, $9iPUS.getUid)(strokeState.strokeStyle)) + strokeState.lineCap + strokeState.lineDashOffset + '|' + strokeState.lineWidth + strokeState.lineJoin + strokeState.miterLimit + '[' + strokeState.lineDash.join() + ']' : '';
            this.textKey_ = textState.font + textState.scale + (textState.textAlign || '?') + (textState.repeat || '?') + (textState.justify || '?') + (textState.textBaseline || '?');
            this.fillKey_ = fillState && fillState.fillStyle ? typeof fillState.fillStyle == 'string' ? fillState.fillStyle : '|' + (0, $9iPUS.getUid)(fillState.fillStyle) : '';
        }
        this.declutterMode_ = textStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
var $8243e906fae47bbe$export$2e2bcd8739ae039 = $8243e906fae47bbe$var$CanvasTextBuilder;

});
parcelRegister("adx6x", function(module, exports) {

$parcel$export(module.exports, "lineChunk", () => $7704cc1df2ddb619$export$f08272c6ff321e57);

var $9byFX = parcelRequire("9byFX");
function $7704cc1df2ddb619$export$f08272c6ff321e57(chunkLength, flatCoordinates, offset, end, stride) {
    const chunks = [];
    let cursor = offset;
    let chunkM = 0;
    let currentChunk = flatCoordinates.slice(offset, 2);
    while(chunkM < chunkLength && cursor + stride < end){
        const [x1, y1] = currentChunk.slice(-2);
        const x2 = flatCoordinates[cursor + stride];
        const y2 = flatCoordinates[cursor + stride + 1];
        const segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        chunkM += segmentLength;
        if (chunkM >= chunkLength) {
            const m = (chunkLength - chunkM + segmentLength) / segmentLength;
            const x = (0, $9byFX.lerp)(x1, x2, m);
            const y = (0, $9byFX.lerp)(y1, y2, m);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            if (chunkM == chunkLength) cursor += stride;
            chunkM = 0;
        } else if (chunkM < chunkLength) {
            currentChunk.push(flatCoordinates[cursor + stride], flatCoordinates[cursor + stride + 1]);
            cursor += stride;
        } else {
            const missing = segmentLength - chunkM;
            const x = (0, $9byFX.lerp)(x1, x2, missing / segmentLength);
            const y = (0, $9byFX.lerp)(y1, y2, missing / segmentLength);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            chunkM = 0;
            cursor += stride;
        }
    }
    if (chunkM > 0) chunks.push(currentChunk);
    return chunks;
}

});

parcelRegister("apNsw", function(module, exports) {

$parcel$export(module.exports, "matchingChunk", () => $79529ab61b92f869$export$ed6c897eea07a254);
/**
 * @module ol/geom/flat/straightchunk
 */ /**
 * @param {number} maxAngle Maximum acceptable angle delta between segments.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {Array<number>} Start and end of the first suitable chunk of the
 * given `flatCoordinates`.
 */ function $79529ab61b92f869$export$ed6c897eea07a254(maxAngle, flatCoordinates, offset, end, stride) {
    let chunkStart = offset;
    let chunkEnd = offset;
    let chunkM = 0;
    let m = 0;
    let start = offset;
    let acos, i, m12, m23, x1, y1, x12, y12, x23, y23;
    for(i = offset; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        if (x1 !== undefined) {
            x23 = x2 - x1;
            y23 = y2 - y1;
            m23 = Math.sqrt(x23 * x23 + y23 * y23);
            if (x12 !== undefined) {
                m += m12;
                acos = Math.acos((x12 * x23 + y12 * y23) / (m12 * m23));
                if (acos > maxAngle) {
                    if (m > chunkM) {
                        chunkM = m;
                        chunkStart = start;
                        chunkEnd = i;
                    }
                    m = 0;
                    start = i - stride;
                }
            }
            m12 = m23;
            x12 = x23;
            y12 = y23;
        }
        x1 = x2;
        y1 = y2;
    }
    m += m23;
    return m > chunkM ? [
        start,
        i
    ] : [
        chunkStart,
        chunkEnd
    ];
}

});



parcelRegister("e1c3o", function(module, exports) {

$parcel$export(module.exports, "ALL", () => $a34a824d875e4ea1$export$61b49a5ae59d663);
$parcel$export(module.exports, "DECLUTTER", () => $a34a824d875e4ea1$export$6195a93a6c97ce02);
$parcel$export(module.exports, "NON_DECLUTTER", () => $a34a824d875e4ea1$export$d0fe61ccfaa1ca87);
$parcel$export(module.exports, "default", () => $a34a824d875e4ea1$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/ExecutorGroup
 */ 
var $fVVyM = parcelRequire("fVVyM");

var $DfnQm = parcelRequire("DfnQm");

var $9pD6L = parcelRequire("9pD6L");

var $1MAUi = parcelRequire("1MAUi");

var $gn0g3 = parcelRequire("gn0g3");

var $jpXrt = parcelRequire("jpXrt");

var $8GqJ6 = parcelRequire("8GqJ6");
const $a34a824d875e4ea1$export$61b49a5ae59d663 = [
    'Polygon',
    'Circle',
    'LineString',
    'Image',
    'Text',
    'Default'
];
const $a34a824d875e4ea1$export$6195a93a6c97ce02 = [
    'Image',
    'Text'
];
const $a34a824d875e4ea1$export$d0fe61ccfaa1ca87 = $a34a824d875e4ea1$export$61b49a5ae59d663.filter((builderType)=>!$a34a824d875e4ea1$export$6195a93a6c97ce02.includes(builderType));
/** @type {boolean|undefined} */ let $a34a824d875e4ea1$var$willReadFrequently = false;
/** @type {boolean|undefined} */ let $a34a824d875e4ea1$var$canvasReadsBenchmarked = false;
/** Determine if canvas read operations are faster with willReadFrequently set to true or false */ function $a34a824d875e4ea1$var$benchmarkCanvasReads() {
    let bestResult = 0;
    /**
   * @param {boolean} willReadFrequently Will read frequently.
   * @return {number} Operation count.
   */ const measure = (willReadFrequently)=>{
        const context = (0, $DfnQm.createCanvasContext2D)(1, 1, null, {
            willReadFrequently: willReadFrequently
        });
        let count = 0;
        const start = performance.now();
        for(; performance.now() - start < 50; ++count){
            context.fillStyle = `rgba(255,0,${count % 256},1)`;
            context.fillRect(0, 0, 1, 1);
            context.getImageData(0, 0, 1, 1);
        }
        bestResult = count > bestResult ? count : bestResult;
        return count;
    };
    const measures = {
        [measure(true)]: true,
        [measure(false)]: false,
        [measure(undefined)]: undefined
    };
    $a34a824d875e4ea1$var$willReadFrequently = measures[bestResult];
    $a34a824d875e4ea1$var$canvasReadsBenchmarked = true;
}
class $a34a824d875e4ea1$var$ExecutorGroup {
    /**
   * @param {import("../../extent.js").Extent} maxExtent Max extent for clipping. When a
   * `maxExtent` was set on the Builder for this executor group, the same `maxExtent`
   * should be set here, unless the target context does not exceed that extent (which
   * can be the case when rendering to tiles).
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The executor group can have overlapping geometries.
   * @param {!Object<string, !Object<import("../canvas.js").BuilderType, import("../canvas.js").SerializableInstructions>>} allInstructions
   * The serializable instructions.
   * @param {number} [renderBuffer] Optional rendering buffer.
   * @param {boolean} [deferredRendering] Enable deferred rendering with renderDeferred().
   */ constructor(maxExtent, resolution, pixelRatio, overlaps, allInstructions, renderBuffer, deferredRendering){
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = overlaps;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {number|undefined}
     */ this.renderBuffer_ = renderBuffer;
        /**
     * @private
     * @type {!Object<string, !Object<string, import("./Executor").default>>}
     */ this.executorsByZIndex_ = {};
        /**
     * @private
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.hitDetectionContext_ = null;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.hitDetectionTransform_ = (0, $jpXrt.create)();
        /**
     * @private
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.renderedContext_ = null;
        /**
     * @private
     * @type {Object<number, Array<import("./ZIndexContext.js").default>>}
     */ this.deferredZIndexContexts_ = {};
        this.createExecutors_(allInstructions, deferredRendering);
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   */ clip(context, transform) {
        const flatClipCoords = this.getClipCoords(transform);
        context.beginPath();
        context.moveTo(flatClipCoords[0], flatClipCoords[1]);
        context.lineTo(flatClipCoords[2], flatClipCoords[3]);
        context.lineTo(flatClipCoords[4], flatClipCoords[5]);
        context.lineTo(flatClipCoords[6], flatClipCoords[7]);
        context.clip();
    }
    /**
   * Create executors and populate them using the provided instructions.
   * @private
   * @param {!Object<string, !Object<string, import("../canvas.js").SerializableInstructions>>} allInstructions The serializable instructions
   * @param {boolean} deferredRendering Enable deferred rendering.
   */ createExecutors_(allInstructions, deferredRendering) {
        for(const zIndex in allInstructions){
            let executors = this.executorsByZIndex_[zIndex];
            if (executors === undefined) {
                executors = {};
                this.executorsByZIndex_[zIndex] = executors;
            }
            const instructionByZindex = allInstructions[zIndex];
            for(const builderType in instructionByZindex){
                const instructions = instructionByZindex[builderType];
                executors[builderType] = new (0, $8GqJ6.default)(this.resolution_, this.pixelRatio_, this.overlaps_, instructions, deferredRendering);
            }
        }
    }
    /**
   * @param {Array<import("../canvas.js").BuilderType>} executors Executors.
   * @return {boolean} Has executors of the provided types.
   */ hasExecutors(executors) {
        for(const zIndex in this.executorsByZIndex_){
            const candidates = this.executorsByZIndex_[zIndex];
            for(let i = 0, ii = executors.length; i < ii; ++i){
                if (executors[i] in candidates) return true;
            }
        }
        return false;
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, number): T} callback Feature callback.
   * @param {Array<import("../../Feature.js").FeatureLike>} declutteredFeatures Decluttered features.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, callback, declutteredFeatures) {
        if ($a34a824d875e4ea1$var$canvasReadsBenchmarked === false) $a34a824d875e4ea1$var$benchmarkCanvasReads();
        hitTolerance = Math.round(hitTolerance);
        const contextSize = hitTolerance * 2 + 1;
        const transform = (0, $jpXrt.compose)(this.hitDetectionTransform_, hitTolerance + 0.5, hitTolerance + 0.5, 1 / resolution, -1 / resolution, -rotation, -coordinate[0], -coordinate[1]);
        const newContext = !this.hitDetectionContext_;
        if (newContext) this.hitDetectionContext_ = (0, $DfnQm.createCanvasContext2D)(contextSize, contextSize, null, {
            willReadFrequently: $a34a824d875e4ea1$var$willReadFrequently
        });
        const context = this.hitDetectionContext_;
        if (context.canvas.width !== contextSize || context.canvas.height !== contextSize) {
            context.canvas.width = contextSize;
            context.canvas.height = contextSize;
        } else if (!newContext) context.clearRect(0, 0, contextSize, contextSize);
        /** @type {import("../../extent.js").Extent|undefined} */ let hitExtent;
        if (this.renderBuffer_ !== undefined) {
            hitExtent = (0, $9pD6L.createEmpty)();
            (0, $9pD6L.extendCoordinate)(hitExtent, coordinate);
            (0, $9pD6L.buffer)(hitExtent, resolution * (this.renderBuffer_ + hitTolerance), hitExtent);
        }
        const indexes = $a34a824d875e4ea1$export$96fc84ea21b8269f(hitTolerance);
        /** @type {import("../canvas.js").BuilderType} */ let builderType;
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {import('../../style/Style.js').DeclutterMode} declutterMode Declutter mode.
     * @return {T|undefined} Callback result.
     */ function featureCallback(feature, geometry, declutterMode) {
            const imageData = context.getImageData(0, 0, contextSize, contextSize).data;
            for(let i = 0, ii = indexes.length; i < ii; i++)if (imageData[indexes[i]] > 0) {
                if (!declutteredFeatures || declutterMode === 'none' || builderType !== 'Image' && builderType !== 'Text' || declutteredFeatures.includes(feature)) {
                    const idx = (indexes[i] - 3) / 4;
                    const x = hitTolerance - idx % contextSize;
                    const y = hitTolerance - (idx / contextSize | 0);
                    const result = callback(feature, geometry, x * x + y * y);
                    if (result) return result;
                }
                context.clearRect(0, 0, contextSize, contextSize);
                break;
            }
            return undefined;
        }
        /** @type {Array<number>} */ const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort((0, $fVVyM.ascending));
        let i, j, executors, executor, result;
        for(i = zs.length - 1; i >= 0; --i){
            const zIndexKey = zs[i].toString();
            executors = this.executorsByZIndex_[zIndexKey];
            for(j = $a34a824d875e4ea1$export$61b49a5ae59d663.length - 1; j >= 0; --j){
                builderType = $a34a824d875e4ea1$export$61b49a5ae59d663[j];
                executor = executors[builderType];
                if (executor !== undefined) {
                    result = executor.executeHitDetection(context, transform, rotation, featureCallback, hitExtent);
                    if (result) return result;
                }
            }
        }
        return undefined;
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   * @return {Array<number>|null} Clip coordinates.
   */ getClipCoords(transform) {
        const maxExtent = this.maxExtent_;
        if (!maxExtent) return null;
        const minX = maxExtent[0];
        const minY = maxExtent[1];
        const maxX = maxExtent[2];
        const maxY = maxExtent[3];
        const flatClipCoords = [
            minX,
            minY,
            minX,
            maxY,
            maxX,
            maxY,
            maxX,
            minY
        ];
        (0, $1MAUi.transform2D)(flatClipCoords, 0, 8, 2, transform, flatClipCoords);
        return flatClipCoords;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, $gn0g3.isEmpty)(this.executorsByZIndex_);
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} targetContext Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scale of the context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and test to integer pixel.
   * @param {Array<import("../canvas.js").BuilderType>} [builderTypes] Ordered replay types to replay.
   *     Default is {@link module:ol/render/replay~ALL}
   * @param {import("rbush").default<import('./Executor.js').DeclutterEntry>|null} [declutterTree] Declutter tree.
   *     When set to null, no decluttering is done, even when the executor group has a `ZIndexContext`.
   */ execute(targetContext, scaledCanvasSize, transform, viewRotation, snapToPixel, builderTypes, declutterTree) {
        const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort(declutterTree ? (0, $fVVyM.descending) : (0, $fVVyM.ascending));
        builderTypes = builderTypes ? builderTypes : $a34a824d875e4ea1$export$61b49a5ae59d663;
        const maxBuilderTypes = $a34a824d875e4ea1$export$61b49a5ae59d663.length;
        for(let i = 0, ii = zs.length; i < ii; ++i){
            const zIndexKey = zs[i].toString();
            const replays = this.executorsByZIndex_[zIndexKey];
            for(let j = 0, jj = builderTypes.length; j < jj; ++j){
                const builderType = builderTypes[j];
                const replay = replays[builderType];
                if (replay !== undefined) {
                    const zIndexContext = declutterTree === null ? undefined : replay.getZIndexContext();
                    const context = zIndexContext ? zIndexContext.getContext() : targetContext;
                    const requireClip = this.maxExtent_ && builderType !== 'Image' && builderType !== 'Text';
                    if (requireClip) {
                        context.save();
                        // setup clipping so that the parts of over-simplified geometries are not
                        // visible outside the current extent when panning
                        this.clip(context, transform);
                    }
                    if (!zIndexContext || builderType === 'Text' || builderType === 'Image') replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree);
                    else zIndexContext.pushFunction((context)=>replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree));
                    if (requireClip) context.restore();
                    if (zIndexContext) {
                        zIndexContext.offset();
                        const index = zs[i] * maxBuilderTypes + $a34a824d875e4ea1$export$61b49a5ae59d663.indexOf(builderType);
                        if (!this.deferredZIndexContexts_[index]) this.deferredZIndexContexts_[index] = [];
                        this.deferredZIndexContexts_[index].push(zIndexContext);
                    }
                }
            }
        }
        this.renderedContext_ = targetContext;
    }
    getDeferredZIndexContexts() {
        return this.deferredZIndexContexts_;
    }
    getRenderedContext() {
        return this.renderedContext_;
    }
    renderDeferred() {
        const deferredZIndexContexts = this.deferredZIndexContexts_;
        const zs = Object.keys(deferredZIndexContexts).map(Number).sort((0, $fVVyM.ascending));
        for(let i = 0, ii = zs.length; i < ii; ++i){
            deferredZIndexContexts[zs[i]].forEach((zIndexContext)=>{
                zIndexContext.draw(this.renderedContext_); // FIXME Pass clip to replay for temporarily enabling clip
                zIndexContext.clear();
            });
            deferredZIndexContexts[zs[i]].length = 0;
        }
    }
}
/**
 * This cache is used to store arrays of indexes for calculated pixel circles
 * to increase performance.
 * It is a static property to allow each Replaygroup to access it.
 * @type {Object<number, Array<number>>}
 */ const $a34a824d875e4ea1$var$circlePixelIndexArrayCache = {};
function $a34a824d875e4ea1$export$96fc84ea21b8269f(radius) {
    if ($a34a824d875e4ea1$var$circlePixelIndexArrayCache[radius] !== undefined) return $a34a824d875e4ea1$var$circlePixelIndexArrayCache[radius];
    const size = radius * 2 + 1;
    const maxDistanceSq = radius * radius;
    const distances = new Array(maxDistanceSq + 1);
    for(let i = 0; i <= radius; ++i)for(let j = 0; j <= radius; ++j){
        const distanceSq = i * i + j * j;
        if (distanceSq > maxDistanceSq) break;
        let distance = distances[distanceSq];
        if (!distance) {
            distance = [];
            distances[distanceSq] = distance;
        }
        distance.push(((radius + i) * size + (radius + j)) * 4 + 3);
        if (i > 0) distance.push(((radius - i) * size + (radius + j)) * 4 + 3);
        if (j > 0) {
            distance.push(((radius + i) * size + (radius - j)) * 4 + 3);
            if (i > 0) distance.push(((radius - i) * size + (radius - j)) * 4 + 3);
        }
    }
    const pixelIndex = [];
    for(let i = 0, ii = distances.length; i < ii; ++i)if (distances[i]) pixelIndex.push(...distances[i]);
    $a34a824d875e4ea1$var$circlePixelIndexArrayCache[radius] = pixelIndex;
    return pixelIndex;
}
var $a34a824d875e4ea1$export$2e2bcd8739ae039 = $a34a824d875e4ea1$var$ExecutorGroup;

});
parcelRegister("8GqJ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6526fa4ee42dc39d$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/Executor
 */ 
var $fVVyM = parcelRequire("fVVyM");

var $9pD6L = parcelRequire("9pD6L");

var $goM6N = parcelRequire("goM6N");

var $58naT = parcelRequire("58naT");

var $l8Phk = parcelRequire("l8Phk");

var $1MAUi = parcelRequire("1MAUi");

var $jpXrt = parcelRequire("jpXrt");

var $gDySU = parcelRequire("gDySU");

var $ig1j9 = parcelRequire("ig1j9");

var $hNBYx = parcelRequire("hNBYx");

var $bboJK = parcelRequire("bboJK");
/**
 * @typedef {import('../../structs/RBush.js').Entry<import('../../Feature.js').FeatureLike>} DeclutterEntry
 */ /**
 * @typedef {Object} ImageOrLabelDimensions
 * @property {number} drawImageX DrawImageX.
 * @property {number} drawImageY DrawImageY.
 * @property {number} drawImageW DrawImageW.
 * @property {number} drawImageH DrawImageH.
 * @property {number} originX OriginX.
 * @property {number} originY OriginY.
 * @property {Array<number>} scale Scale.
 * @property {DeclutterEntry} declutterBox DeclutterBox.
 * @property {import("../../transform.js").Transform} canvasTransform CanvasTransform.
 */ /**
 * @typedef {{0: CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D, 1: import('../../size.js').Size, 2: import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement, 3: ImageOrLabelDimensions, 4: number, 5: Array<*>, 6: Array<*>}} ReplayImageOrLabelArgs
 */ /**
 * @template T
 * @typedef {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, import("../../style/Style.js").DeclutterMode): T} FeatureCallback
 */ /**
 * @type {import("../../extent.js").Extent}
 */ const $6526fa4ee42dc39d$var$tmpExtent = (0, $9pD6L.createEmpty)();
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p1 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p2 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p3 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p4 = [];
/**
 * @param {ReplayImageOrLabelArgs} replayImageOrLabelArgs Arguments to replayImageOrLabel
 * @return {DeclutterEntry} Declutter rbush entry.
 */ function $6526fa4ee42dc39d$var$getDeclutterBox(replayImageOrLabelArgs) {
    return replayImageOrLabelArgs[3].declutterBox;
}
const $6526fa4ee42dc39d$var$rtlRegEx = new RegExp(/* eslint-disable prettier/prettier */ '[' + String.fromCharCode(0x00591) + '-' + String.fromCharCode(0x008ff) + String.fromCharCode(0x0fb1d) + '-' + String.fromCharCode(0x0fdff) + String.fromCharCode(0x0fe70) + '-' + String.fromCharCode(0x0fefc) + String.fromCharCode(0x10800) + '-' + String.fromCharCode(0x10fff) + String.fromCharCode(0x1e800) + '-' + String.fromCharCode(0x1efff) + ']');
/**
 * @param {string} text Text.
 * @param {CanvasTextAlign} align Alignment.
 * @return {number} Text alignment.
 */ function $6526fa4ee42dc39d$var$horizontalTextAlign(text, align) {
    if (align === 'start') align = $6526fa4ee42dc39d$var$rtlRegEx.test(text) ? 'right' : 'left';
    else if (align === 'end') align = $6526fa4ee42dc39d$var$rtlRegEx.test(text) ? 'left' : 'right';
    return (0, $bboJK.TEXT_ALIGN)[align];
}
/**
 * @param {Array<string>} acc Accumulator.
 * @param {string} line Line of text.
 * @param {number} i Index
 * @return {Array<string>} Accumulator.
 */ function $6526fa4ee42dc39d$var$createTextChunks(acc, line, i) {
    if (i > 0) acc.push('\n', '');
    acc.push(line, '');
    return acc;
}
/**
 * Converts rich text to plain text for text along lines.
 * @param {string} result The resulting plain text.
 * @param {string} part Item of the rich text array.
 * @param {number} index Index of the item in the rich text array.
 * @return {string} The resulting plain text.
 */ function $6526fa4ee42dc39d$var$richTextToPlainText(result, part, index) {
    if (index % 2 === 0) result += part;
    return result;
}
class $6526fa4ee42dc39d$var$Executor {
    /**
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The replay can have overlapping geometries.
   * @param {import("../canvas.js").SerializableInstructions} instructions The serializable instructions.
   * @param {boolean} [deferredRendering] Enable deferred rendering.
   */ constructor(resolution, pixelRatio, overlaps, instructions, deferredRendering){
        /**
     * @protected
     * @type {boolean}
     */ this.overlaps = overlaps;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {number}
     */ this.alignAndScaleFill_;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = instructions.instructions;
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = instructions.coordinates;
        /**
     * @private
     * @type {!Object<number,import("../../coordinate.js").Coordinate|Array<import("../../coordinate.js").Coordinate>|Array<Array<import("../../coordinate.js").Coordinate>>>}
     */ this.coordinateCache_ = {};
        /**
     * @private
     * @type {!import("../../transform.js").Transform}
     */ this.renderedTransform_ = (0, $jpXrt.create)();
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = instructions.hitDetectionInstructions;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = null;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = 0;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = instructions.fillStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = instructions.strokeStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = instructions.textStates || {};
        /**
     * @private
     * @type {Object<string, Object<string, number>>}
     */ this.widths_ = {};
        /**
     * @private
     * @type {Object<string, import("../canvas.js").Label>}
     */ this.labels_ = {};
        /**
     * @private
     * @type {import("../canvas/ZIndexContext.js").default}
     */ this.zIndexContext_ = deferredRendering ? new (0, $gDySU.default)() : null;
    }
    /**
   * @return {ZIndexContext} ZIndex context.
   */ getZIndexContext() {
        return this.zIndexContext_;
    }
    /**
   * @param {string|Array<string>} text Text.
   * @param {string} textKey Text style key.
   * @param {string} fillKey Fill style key.
   * @param {string} strokeKey Stroke style key.
   * @return {import("../canvas.js").Label} Label.
   */ createLabel(text, textKey, fillKey, strokeKey) {
        const key = text + textKey + fillKey + strokeKey;
        if (this.labels_[key]) return this.labels_[key];
        const strokeState = strokeKey ? this.strokeStates[strokeKey] : null;
        const fillState = fillKey ? this.fillStates[fillKey] : null;
        const textState = this.textStates[textKey];
        const pixelRatio = this.pixelRatio;
        const scale = [
            textState.scale[0] * pixelRatio,
            textState.scale[1] * pixelRatio
        ];
        const align = textState.justify ? (0, $bboJK.TEXT_ALIGN)[textState.justify] : $6526fa4ee42dc39d$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $ig1j9.defaultTextAlign));
        const strokeWidth = strokeKey && strokeState.lineWidth ? strokeState.lineWidth : 0;
        const chunks = Array.isArray(text) ? text : String(text).split('\n').reduce($6526fa4ee42dc39d$var$createTextChunks, []);
        const { width: width, height: height, widths: widths, heights: heights, lineWidths: lineWidths } = (0, $ig1j9.getTextDimensions)(textState, chunks);
        const renderWidth = width + strokeWidth;
        const contextInstructions = [];
        // make canvas 2 pixels wider to account for italic text width measurement errors
        const w = (renderWidth + 2) * scale[0];
        const h = (height + strokeWidth) * scale[1];
        /** @type {import("../canvas.js").Label} */ const label = {
            width: w < 0 ? Math.floor(w) : Math.ceil(w),
            height: h < 0 ? Math.floor(h) : Math.ceil(h),
            contextInstructions: contextInstructions
        };
        if (scale[0] != 1 || scale[1] != 1) contextInstructions.push('scale', scale);
        if (strokeKey) {
            contextInstructions.push('strokeStyle', strokeState.strokeStyle);
            contextInstructions.push('lineWidth', strokeWidth);
            contextInstructions.push('lineCap', strokeState.lineCap);
            contextInstructions.push('lineJoin', strokeState.lineJoin);
            contextInstructions.push('miterLimit', strokeState.miterLimit);
            contextInstructions.push('setLineDash', [
                strokeState.lineDash
            ]);
            contextInstructions.push('lineDashOffset', strokeState.lineDashOffset);
        }
        if (fillKey) contextInstructions.push('fillStyle', fillState.fillStyle);
        contextInstructions.push('textBaseline', 'middle');
        contextInstructions.push('textAlign', 'center');
        const leftRight = 0.5 - align;
        let x = align * renderWidth + leftRight * strokeWidth;
        const strokeInstructions = [];
        const fillInstructions = [];
        let lineHeight = 0;
        let lineOffset = 0;
        let widthHeightIndex = 0;
        let lineWidthIndex = 0;
        let previousFont;
        for(let i = 0, ii = chunks.length; i < ii; i += 2){
            const text = chunks[i];
            if (text === '\n') {
                lineOffset += lineHeight;
                lineHeight = 0;
                x = align * renderWidth + leftRight * strokeWidth;
                ++lineWidthIndex;
                continue;
            }
            const font = chunks[i + 1] || textState.font;
            if (font !== previousFont) {
                if (strokeKey) strokeInstructions.push('font', font);
                if (fillKey) fillInstructions.push('font', font);
                previousFont = font;
            }
            lineHeight = Math.max(lineHeight, heights[widthHeightIndex]);
            const fillStrokeArgs = [
                text,
                x + leftRight * widths[widthHeightIndex] + align * (widths[widthHeightIndex] - lineWidths[lineWidthIndex]),
                0.5 * (strokeWidth + lineHeight) + lineOffset
            ];
            x += widths[widthHeightIndex];
            if (strokeKey) strokeInstructions.push('strokeText', fillStrokeArgs);
            if (fillKey) fillInstructions.push('fillText', fillStrokeArgs);
            ++widthHeightIndex;
        }
        Array.prototype.push.apply(contextInstructions, strokeInstructions);
        Array.prototype.push.apply(contextInstructions, fillInstructions);
        this.labels_[key] = label;
        return label;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../coordinate.js").Coordinate} p1 1st point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p2 2nd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p3 3rd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p4 4th point of the background box.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   */ replayTextBackground_(context, p1, p2, p3, p4, fillInstruction, strokeInstruction) {
        context.beginPath();
        context.moveTo.apply(context, p1);
        context.lineTo.apply(context, p2);
        context.lineTo.apply(context, p3);
        context.lineTo.apply(context, p4);
        context.lineTo.apply(context, p1);
        if (fillInstruction) {
            this.alignAndScaleFill_ = /** @type {number} */ fillInstruction[2];
            context.fillStyle = /** @type {string} */ fillInstruction[1];
            this.fill_(context);
        }
        if (strokeInstruction) {
            this.setStrokeStyle_(context, /** @type {Array<*>} */ strokeInstruction);
            context.stroke();
        }
    }
    /**
   * @private
   * @param {number} sheetWidth Width of the sprite sheet.
   * @param {number} sheetHeight Height of the sprite sheet.
   * @param {number} centerX X.
   * @param {number} centerY Y.
   * @param {number} width Width.
   * @param {number} height Height.
   * @param {number} anchorX Anchor X.
   * @param {number} anchorY Anchor Y.
   * @param {number} originX Origin X.
   * @param {number} originY Origin Y.
   * @param {number} rotation Rotation.
   * @param {import("../../size.js").Size} scale Scale.
   * @param {boolean} snapToPixel Snap to pixel.
   * @param {Array<number>} padding Padding.
   * @param {boolean} fillStroke Background fill or stroke.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @return {ImageOrLabelDimensions} Dimensions for positioning and decluttering the image or label.
   */ calculateImageOrLabelDimensions_(sheetWidth, sheetHeight, centerX, centerY, width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, fillStroke, feature) {
        anchorX *= scale[0];
        anchorY *= scale[1];
        let x = centerX - anchorX;
        let y = centerY - anchorY;
        const w = width + originX > sheetWidth ? sheetWidth - originX : width;
        const h = height + originY > sheetHeight ? sheetHeight - originY : height;
        const boxW = padding[3] + w * scale[0] + padding[1];
        const boxH = padding[0] + h * scale[1] + padding[2];
        const boxX = x - padding[3];
        const boxY = y - padding[0];
        if (fillStroke || rotation !== 0) {
            $6526fa4ee42dc39d$var$p1[0] = boxX;
            $6526fa4ee42dc39d$var$p4[0] = boxX;
            $6526fa4ee42dc39d$var$p1[1] = boxY;
            $6526fa4ee42dc39d$var$p2[1] = boxY;
            $6526fa4ee42dc39d$var$p2[0] = boxX + boxW;
            $6526fa4ee42dc39d$var$p3[0] = $6526fa4ee42dc39d$var$p2[0];
            $6526fa4ee42dc39d$var$p3[1] = boxY + boxH;
            $6526fa4ee42dc39d$var$p4[1] = $6526fa4ee42dc39d$var$p3[1];
        }
        let transform;
        if (rotation !== 0) {
            transform = (0, $jpXrt.compose)((0, $jpXrt.create)(), centerX, centerY, 1, 1, rotation, -centerX, -centerY);
            (0, $jpXrt.apply)(transform, $6526fa4ee42dc39d$var$p1);
            (0, $jpXrt.apply)(transform, $6526fa4ee42dc39d$var$p2);
            (0, $jpXrt.apply)(transform, $6526fa4ee42dc39d$var$p3);
            (0, $jpXrt.apply)(transform, $6526fa4ee42dc39d$var$p4);
            (0, $9pD6L.createOrUpdate)(Math.min($6526fa4ee42dc39d$var$p1[0], $6526fa4ee42dc39d$var$p2[0], $6526fa4ee42dc39d$var$p3[0], $6526fa4ee42dc39d$var$p4[0]), Math.min($6526fa4ee42dc39d$var$p1[1], $6526fa4ee42dc39d$var$p2[1], $6526fa4ee42dc39d$var$p3[1], $6526fa4ee42dc39d$var$p4[1]), Math.max($6526fa4ee42dc39d$var$p1[0], $6526fa4ee42dc39d$var$p2[0], $6526fa4ee42dc39d$var$p3[0], $6526fa4ee42dc39d$var$p4[0]), Math.max($6526fa4ee42dc39d$var$p1[1], $6526fa4ee42dc39d$var$p2[1], $6526fa4ee42dc39d$var$p3[1], $6526fa4ee42dc39d$var$p4[1]), $6526fa4ee42dc39d$var$tmpExtent);
        } else (0, $9pD6L.createOrUpdate)(Math.min(boxX, boxX + boxW), Math.min(boxY, boxY + boxH), Math.max(boxX, boxX + boxW), Math.max(boxY, boxY + boxH), $6526fa4ee42dc39d$var$tmpExtent);
        if (snapToPixel) {
            x = Math.round(x);
            y = Math.round(y);
        }
        return {
            drawImageX: x,
            drawImageY: y,
            drawImageW: w,
            drawImageH: h,
            originX: originX,
            originY: originY,
            declutterBox: {
                minX: $6526fa4ee42dc39d$var$tmpExtent[0],
                minY: $6526fa4ee42dc39d$var$tmpExtent[1],
                maxX: $6526fa4ee42dc39d$var$tmpExtent[2],
                maxY: $6526fa4ee42dc39d$var$tmpExtent[3],
                value: feature
            },
            canvasTransform: transform,
            scale: scale
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} imageOrLabel Image.
   * @param {ImageOrLabelDimensions} dimensions Dimensions.
   * @param {number} opacity Opacity.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   * @return {boolean} The image or label was rendered.
   */ replayImageOrLabel_(context, scaledCanvasSize, imageOrLabel, dimensions, opacity, fillInstruction, strokeInstruction) {
        const fillStroke = !!(fillInstruction || strokeInstruction);
        const box = dimensions.declutterBox;
        const strokePadding = strokeInstruction ? strokeInstruction[2] * dimensions.scale[0] / 2 : 0;
        const intersects = box.minX - strokePadding <= scaledCanvasSize[0] && box.maxX + strokePadding >= 0 && box.minY - strokePadding <= scaledCanvasSize[1] && box.maxY + strokePadding >= 0;
        if (intersects) {
            if (fillStroke) this.replayTextBackground_(context, $6526fa4ee42dc39d$var$p1, $6526fa4ee42dc39d$var$p2, $6526fa4ee42dc39d$var$p3, $6526fa4ee42dc39d$var$p4, /** @type {Array<*>} */ fillInstruction, /** @type {Array<*>} */ strokeInstruction);
            (0, $ig1j9.drawImageOrLabel)(context, dimensions.canvasTransform, opacity, imageOrLabel, dimensions.originX, dimensions.originY, dimensions.drawImageW, dimensions.drawImageH, dimensions.drawImageX, dimensions.drawImageY, dimensions.scale);
        }
        return true;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   */ fill_(context) {
        const alignAndScale = this.alignAndScaleFill_;
        if (alignAndScale) {
            const origin = (0, $jpXrt.apply)(this.renderedTransform_, [
                0,
                0
            ]);
            const repeatSize = 512 * this.pixelRatio;
            context.save();
            context.translate(origin[0] % repeatSize, origin[1] % repeatSize);
            if (alignAndScale !== 1) context.scale(alignAndScale, alignAndScale);
        }
        context.fill();
        if (alignAndScale) context.restore();
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {Array<*>} instruction Instruction.
   */ setStrokeStyle_(context, instruction) {
        context.strokeStyle = /** @type {import("../../colorlike.js").ColorLike} */ instruction[1];
        if (!instruction[1]) return;
        context.lineWidth = /** @type {number} */ instruction[2];
        context.lineCap = /** @type {CanvasLineCap} */ instruction[3];
        context.lineJoin = /** @type {CanvasLineJoin} */ instruction[4];
        context.miterLimit = /** @type {number} */ instruction[5];
        context.lineDashOffset = /** @type {number} */ instruction[7];
        context.setLineDash(/** @type {Array<number>} */ instruction[6]);
    }
    /**
   * @private
   * @param {string|Array<string>} text The text to draw.
   * @param {string} textKey The key of the text state.
   * @param {string} strokeKey The key for the stroke state.
   * @param {string} fillKey The key for the fill state.
   * @return {{label: import("../canvas.js").Label, anchorX: number, anchorY: number}} The text image and its anchor.
   */ drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey) {
        const textState = this.textStates[textKey];
        const label = this.createLabel(text, textKey, fillKey, strokeKey);
        const strokeState = this.strokeStates[strokeKey];
        const pixelRatio = this.pixelRatio;
        const align = $6526fa4ee42dc39d$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $ig1j9.defaultTextAlign));
        const baseline = (0, $bboJK.TEXT_ALIGN)[textState.textBaseline || (0, $ig1j9.defaultTextBaseline)];
        const strokeWidth = strokeState && strokeState.lineWidth ? strokeState.lineWidth : 0;
        // Remove the 2 pixels we added in createLabel() for the anchor
        const width = label.width / pixelRatio - 2 * textState.scale[0];
        const anchorX = align * width + 2 * (0.5 - align) * strokeWidth;
        const anchorY = baseline * label.height / pixelRatio + 2 * (0.5 - baseline) * strokeWidth;
        return {
            label: label,
            anchorX: anchorX,
            anchorY: anchorY
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {Array<*>} instructions Instructions array.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @param {import("rbush").default<DeclutterEntry>} [declutterTree] Declutter tree.
   * @return {T|undefined} Callback result.
   * @template T
   */ execute_(context, scaledCanvasSize, transform, instructions, snapToPixel, featureCallback, hitExtent, declutterTree) {
        const zIndexContext = this.zIndexContext_;
        /** @type {Array<number>} */ let pixelCoordinates;
        if (this.pixelCoordinates_ && (0, $fVVyM.equals)(transform, this.renderedTransform_)) pixelCoordinates = this.pixelCoordinates_;
        else {
            if (!this.pixelCoordinates_) this.pixelCoordinates_ = [];
            pixelCoordinates = (0, $1MAUi.transform2D)(this.coordinates, 0, this.coordinates.length, 2, transform, this.pixelCoordinates_);
            (0, $jpXrt.setFromArray)(this.renderedTransform_, transform);
        }
        let i = 0; // instruction index
        const ii = instructions.length; // end of instructions
        let d = 0; // data index
        let dd; // end of per-instruction data
        let anchorX, anchorY, lineOffsetPx, /** @type {boolean} */ isClosedRing, /** @type {number} */ dStart, /** @type {import('../../style/Style.js').DeclutterMode} */ declutterMode, prevX, prevY, roundX, roundY, image, text, textKey, strokeKey, fillKey;
        let pendingFill = 0;
        let pendingStroke = 0;
        const coordinateCache = this.coordinateCache_;
        const viewRotation = this.viewRotation_;
        const viewRotationFromTransform = Math.round(Math.atan2(-transform[1], transform[0]) * 1e12) / 1e12;
        const state = /** @type {import("../../render.js").State} */ {
            context: context,
            pixelRatio: this.pixelRatio,
            resolution: this.resolution,
            rotation: viewRotation
        };
        // When the batch size gets too big, performance decreases. 200 is a good
        // balance between batch size and number of fill/stroke instructions.
        const batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
        let /** @type {import("../../Feature.js").FeatureLike} */ feature;
        let x, y, currentGeometry;
        while(i < ii){
            const instruction = instructions[i];
            const type = /** @type {import("./Instruction.js").default} */ instruction[0];
            switch(type){
                case (0, $hNBYx.default).BEGIN_GEOMETRY:
                    feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                    currentGeometry = instruction[3];
                    if (!feature.getGeometry()) i = /** @type {number} */ instruction[2];
                    else if (hitExtent !== undefined && !(0, $9pD6L.intersects)(hitExtent, currentGeometry.getExtent())) i = /** @type {number} */ instruction[2] + 1;
                    else ++i;
                    if (zIndexContext) zIndexContext.zIndex = instruction[4];
                    break;
                case (0, $hNBYx.default).BEGIN_PATH:
                    if (pendingFill > batchSize) {
                        this.fill_(context);
                        pendingFill = 0;
                    }
                    if (pendingStroke > batchSize) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    if (!pendingFill && !pendingStroke) {
                        context.beginPath();
                        prevX = NaN;
                        prevY = NaN;
                    }
                    ++i;
                    break;
                case (0, $hNBYx.default).CIRCLE:
                    d = /** @type {number} */ instruction[1];
                    lineOffsetPx = /** @type {number} */ instruction[2] ?? 0;
                    const x1 = pixelCoordinates[d];
                    const y1 = pixelCoordinates[d + 1];
                    const x2 = pixelCoordinates[d + 2] - lineOffsetPx;
                    const y2 = pixelCoordinates[d + 3] - lineOffsetPx;
                    const dx = x2 - x1;
                    const dy = y2 - y1;
                    const r = Math.sqrt(dx * dx + dy * dy);
                    context.moveTo(x1 + r, y1);
                    context.arc(x1, y1, r, 0, 2 * Math.PI, true);
                    ++i;
                    break;
                case (0, $hNBYx.default).CLOSE_PATH:
                    context.closePath();
                    ++i;
                    break;
                case (0, $hNBYx.default).CUSTOM:
                    d = /** @type {number} */ instruction[1];
                    dd = instruction[2];
                    const geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ instruction[3];
                    const renderer = instruction[4];
                    const fn = instruction[5];
                    state.geometry = geometry;
                    state.feature = feature;
                    if (!(i in coordinateCache)) coordinateCache[i] = [];
                    const coords = coordinateCache[i];
                    if (fn) fn(pixelCoordinates, d, dd, 2, coords);
                    else {
                        coords[0] = pixelCoordinates[d];
                        coords[1] = pixelCoordinates[d + 1];
                        coords.length = 2;
                    }
                    if (zIndexContext) zIndexContext.zIndex = instruction[6];
                    renderer(coords, state);
                    ++i;
                    break;
                case (0, $hNBYx.default).DRAW_IMAGE:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */ instruction[3];
                    // Remaining arguments in DRAW_IMAGE are in alphabetical order
                    anchorX = /** @type {number} */ instruction[4];
                    anchorY = /** @type {number} */ instruction[5];
                    let height = /** @type {number} */ instruction[6];
                    const opacity = /** @type {number} */ instruction[7];
                    const originX = /** @type {number} */ instruction[8];
                    const originY = /** @type {number} */ instruction[9];
                    const rotateWithView = /** @type {boolean} */ instruction[10];
                    let rotation = /** @type {number} */ instruction[11];
                    const scale = /** @type {import("../../size.js").Size} */ instruction[12];
                    let width = /** @type {number} */ instruction[13];
                    declutterMode = instruction[14] || 'declutter';
                    const declutterImageWithText = /** @type {{args: import("../canvas.js").DeclutterImageWithText, declutterMode: import('../../style/Style.js').DeclutterMode}} */ instruction[15];
                    if (!image && instruction.length >= 20) {
                        // create label images
                        text = /** @type {string} */ instruction[19];
                        textKey = /** @type {string} */ instruction[20];
                        strokeKey = /** @type {string} */ instruction[21];
                        fillKey = /** @type {string} */ instruction[22];
                        const labelWithAnchor = this.drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey);
                        image = labelWithAnchor.label;
                        instruction[3] = image;
                        const textOffsetX = /** @type {number} */ instruction[23];
                        anchorX = (labelWithAnchor.anchorX - textOffsetX) * this.pixelRatio;
                        instruction[4] = anchorX;
                        const textOffsetY = /** @type {number} */ instruction[24];
                        anchorY = (labelWithAnchor.anchorY - textOffsetY) * this.pixelRatio;
                        instruction[5] = anchorY;
                        height = image.height;
                        instruction[6] = height;
                        width = image.width;
                        instruction[13] = width;
                    }
                    let geometryWidths;
                    if (instruction.length > 25) geometryWidths = /** @type {number} */ instruction[25];
                    let padding, backgroundFillInstruction, backgroundStrokeInstruction;
                    if (instruction.length > 17) {
                        padding = /** @type {Array<number>} */ instruction[16];
                        backgroundFillInstruction = /** @type {Array<*>} */ instruction[17];
                        backgroundStrokeInstruction = /** @type {Array<*>} */ instruction[18];
                    } else {
                        padding = (0, $ig1j9.defaultPadding);
                        backgroundFillInstruction = null;
                        backgroundStrokeInstruction = null;
                    }
                    if (rotateWithView && viewRotationFromTransform) // Canvas is expected to be rotated to reverse view rotation.
                    rotation += viewRotation;
                    else if (!rotateWithView && !viewRotationFromTransform) // Canvas is not rotated, images need to be rotated back to be north-up.
                    rotation -= viewRotation;
                    let widthIndex = 0;
                    for(; d < dd; d += 2){
                        if (geometryWidths && geometryWidths[widthIndex++] < width / this.pixelRatio) continue;
                        const dimensions = this.calculateImageOrLabelDimensions_(image.width, image.height, pixelCoordinates[d], pixelCoordinates[d + 1], width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, !!backgroundFillInstruction || !!backgroundStrokeInstruction, feature);
                        /** @type {ReplayImageOrLabelArgs} */ const args = [
                            context,
                            scaledCanvasSize,
                            image,
                            dimensions,
                            opacity,
                            backgroundFillInstruction,
                            backgroundStrokeInstruction
                        ];
                        if (declutterTree) {
                            let imageArgs, imageDeclutterMode, imageDeclutterBox;
                            if (declutterImageWithText) {
                                const index = dd - d;
                                if (!declutterImageWithText[index]) {
                                    // We now have the image for an image+text combination.
                                    declutterImageWithText[index] = {
                                        args: args,
                                        declutterMode: declutterMode
                                    };
                                    continue;
                                }
                                const imageDeclutter = declutterImageWithText[index];
                                imageArgs = imageDeclutter.args;
                                imageDeclutterMode = imageDeclutter.declutterMode;
                                delete declutterImageWithText[index];
                                imageDeclutterBox = $6526fa4ee42dc39d$var$getDeclutterBox(imageArgs);
                            }
                            // We now have image and text for an image+text combination.
                            let renderImage, renderText;
                            if (imageArgs && (imageDeclutterMode !== 'declutter' || !declutterTree.collides(imageDeclutterBox))) renderImage = true;
                            if (declutterMode !== 'declutter' || !declutterTree.collides(dimensions.declutterBox)) renderText = true;
                            if (imageDeclutterMode === 'declutter' && declutterMode === 'declutter') {
                                const render = renderImage && renderText;
                                renderImage = render;
                                renderText = render;
                            }
                            if (renderImage) {
                                if (imageDeclutterMode !== 'none') declutterTree.insert(imageDeclutterBox);
                                this.replayImageOrLabel_.apply(this, imageArgs);
                            }
                            if (renderText) {
                                if (declutterMode !== 'none') declutterTree.insert(dimensions.declutterBox);
                                this.replayImageOrLabel_.apply(this, args);
                            }
                        } else this.replayImageOrLabel_.apply(this, args);
                    }
                    ++i;
                    break;
                case (0, $hNBYx.default).DRAW_CHARS:
                    const begin = /** @type {number} */ instruction[1];
                    const end = /** @type {number} */ instruction[2];
                    const baseline = /** @type {number} */ instruction[3];
                    const overflow = /** @type {number} */ instruction[4];
                    fillKey = /** @type {string} */ instruction[5];
                    const maxAngle = /** @type {number} */ instruction[6];
                    const measurePixelRatio = /** @type {number} */ instruction[7];
                    const offsetY = /** @type {number} */ instruction[8];
                    strokeKey = /** @type {string} */ instruction[9];
                    const strokeWidth = /** @type {number} */ instruction[10];
                    text = /** @type {string|Array<string>} */ instruction[11];
                    if (Array.isArray(text)) //FIXME Add support for rich text along lines
                    text = text.reduce($6526fa4ee42dc39d$var$richTextToPlainText, '');
                    textKey = /** @type {string} */ instruction[12];
                    const pixelRatioScale = [
                        /** @type {number} */ instruction[13],
                        /** @type {number} */ instruction[13]
                    ];
                    declutterMode = instruction[14] || 'declutter';
                    const textKeepUpright = /** @type {boolean} */ instruction[15];
                    const textState = this.textStates[textKey];
                    const font = textState.font;
                    const textScale = [
                        textState.scale[0] * measurePixelRatio,
                        textState.scale[1] * measurePixelRatio
                    ];
                    let cachedWidths;
                    if (font in this.widths_) cachedWidths = this.widths_[font];
                    else {
                        cachedWidths = {};
                        this.widths_[font] = cachedWidths;
                    }
                    const pathLength = (0, $goM6N.lineStringLength)(pixelCoordinates, begin, end, 2);
                    const textLength = Math.abs(textScale[0]) * (0, $ig1j9.measureAndCacheTextWidth)(font, text, cachedWidths);
                    if (overflow || textLength <= pathLength) {
                        const textAlign = this.textStates[textKey].textAlign;
                        const startM = (pathLength - textLength) * $6526fa4ee42dc39d$var$horizontalTextAlign(text, textAlign);
                        const parts = (0, $l8Phk.drawTextOnPath)(pixelCoordinates, begin, end, 2, text, startM, maxAngle, Math.abs(textScale[0]), (0, $ig1j9.measureAndCacheTextWidth), font, cachedWidths, viewRotationFromTransform ? 0 : this.viewRotation_, textKeepUpright);
                        drawChars: if (parts) {
                            /** @type {Array<ReplayImageOrLabelArgs>} */ const replayImageOrLabelArgs = [];
                            let c, cc, chars, label, part;
                            if (strokeKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, '', strokeKey);
                                anchorX = /** @type {number} */ part[2] + (textScale[0] < 0 ? -strokeWidth : strokeWidth);
                                anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth * textScale[1] / textScale[0] - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $ig1j9.defaultPadding), false, feature);
                                if (declutterTree && declutterMode === 'declutter' && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (fillKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, fillKey, '');
                                anchorX = /** @type {number} */ part[2];
                                anchorY = baseline * label.height - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $ig1j9.defaultPadding), false, feature);
                                if (declutterTree && declutterMode === 'declutter' && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (declutterTree && declutterMode !== 'none') declutterTree.load(replayImageOrLabelArgs.map($6526fa4ee42dc39d$var$getDeclutterBox));
                            for(let i = 0, ii = replayImageOrLabelArgs.length; i < ii; ++i)this.replayImageOrLabel_.apply(this, replayImageOrLabelArgs[i]);
                        }
                    }
                    ++i;
                    break;
                case (0, $hNBYx.default).END_GEOMETRY:
                    if (featureCallback !== undefined) {
                        feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                        const result = featureCallback(feature, currentGeometry, declutterMode);
                        if (result) return result;
                    }
                    ++i;
                    break;
                case (0, $hNBYx.default).FILL:
                    if (batchSize) pendingFill++;
                    else this.fill_(context);
                    ++i;
                    break;
                case (0, $hNBYx.default).MOVE_TO_LINE_TO:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    lineOffsetPx = /** @type {number|undefined} */ instruction[3];
                    isClosedRing = /** @type {boolean|undefined} */ instruction[4] ?? false;
                    x = pixelCoordinates[d];
                    y = pixelCoordinates[d + 1];
                    if (lineOffsetPx) {
                        dStart = d;
                        [x, y] = (0, $58naT.offsetLineVertex)(x, y, isClosedRing ? pixelCoordinates[dd - 4] : undefined, isClosedRing ? pixelCoordinates[dd - 3] : undefined, pixelCoordinates[d + 2], pixelCoordinates[d + 3], lineOffsetPx);
                    }
                    context.moveTo(x, y);
                    prevX = x + 0.5 | 0;
                    prevY = y + 0.5 | 0;
                    for(d += 2; d < dd; d += 2){
                        x = pixelCoordinates[d];
                        y = pixelCoordinates[d + 1];
                        roundX = x + 0.5 | 0;
                        roundY = y + 0.5 | 0;
                        if (d == dd - 2 || roundX !== prevX || roundY !== prevY) {
                            if (lineOffsetPx) {
                                if (d == dd - 2) // last coordinate
                                [x, y] = (0, $58naT.offsetLineVertex)(x, y, pixelCoordinates[d - 2], pixelCoordinates[d - 1], isClosedRing ? pixelCoordinates[dStart + 2] : undefined, isClosedRing ? pixelCoordinates[dStart + 3] : undefined, lineOffsetPx);
                                else [x, y] = (0, $58naT.offsetLineVertex)(x, y, pixelCoordinates[d - 2], pixelCoordinates[d - 1], pixelCoordinates[d + 2], pixelCoordinates[d + 3], lineOffsetPx);
                            }
                            context.lineTo(x, y);
                            prevX = roundX;
                            prevY = roundY;
                        }
                    }
                    ++i;
                    break;
                case (0, $hNBYx.default).SET_FILL_STYLE:
                    this.alignAndScaleFill_ = instruction[2];
                    if (pendingFill) {
                        this.fill_(context);
                        pendingFill = 0;
                        if (pendingStroke) {
                            context.stroke();
                            pendingStroke = 0;
                        }
                    }
                    /** @type {import("../../colorlike.js").ColorLike} */ context.fillStyle = instruction[1];
                    ++i;
                    break;
                case (0, $hNBYx.default).SET_STROKE_STYLE:
                    if (pendingStroke) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    this.setStrokeStyle_(context, /** @type {Array<*>} */ instruction);
                    ++i;
                    break;
                case (0, $hNBYx.default).STROKE:
                    if (batchSize) pendingStroke++;
                    else context.stroke();
                    ++i;
                    break;
                default:
                    ++i;
                    break;
            }
        }
        if (pendingFill) this.fill_(context);
        if (pendingStroke) context.stroke();
        return undefined;
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {import("rbush").default<DeclutterEntry>} [declutterTree] Declutter tree.
   */ execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree) {
        this.viewRotation_ = viewRotation;
        this.execute_(context, scaledCanvasSize, transform, this.instructions, snapToPixel, undefined, undefined, declutterTree);
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @return {T|undefined} Callback result.
   * @template T
   */ executeHitDetection(context, transform, viewRotation, featureCallback, hitExtent) {
        this.viewRotation_ = viewRotation;
        return this.execute_(context, [
            context.canvas.width,
            context.canvas.height
        ], transform, this.hitDetectionInstructions, true, featureCallback, hitExtent);
    }
}
var $6526fa4ee42dc39d$export$2e2bcd8739ae039 = $6526fa4ee42dc39d$var$Executor;

});
parcelRegister("58naT", function(module, exports) {

$parcel$export(module.exports, "offsetLineString", () => $3bcfad17cf4aa97e$export$a6b2441cc3fe7033);
$parcel$export(module.exports, "offsetLineVertex", () => $3bcfad17cf4aa97e$export$1d816e12adb721de);

var $2o3CH = parcelRequire("2o3CH");
function $3bcfad17cf4aa97e$export$a6b2441cc3fe7033(flatCoordinates, stride, offset, isClosedRing, dest, destinationStride) {
    dest = dest ?? [];
    destinationStride = destinationStride ?? stride;
    const firstPointX = flatCoordinates[0];
    const firstPointY = flatCoordinates[1];
    const secondToLastPointX = flatCoordinates[flatCoordinates.length - 4];
    const secondToLastPointY = flatCoordinates[flatCoordinates.length - 3];
    let x, y, prevX, prevY, nextX, nextY, offsetX, offsetY;
    let i = 0;
    for(let j = 0; j < flatCoordinates.length; j += stride){
        // 1. Detect previous and next coordinates of a current vertex
        prevX = x;
        prevY = y;
        nextX = undefined;
        nextY = undefined;
        if (j + stride < flatCoordinates.length) {
            nextX = flatCoordinates[j + stride];
            nextY = flatCoordinates[j + stride + 1];
        }
        // First coordinate of a closed ring -> previous coordinate is the second to last one
        if (isClosedRing && j === 0) {
            prevX = secondToLastPointX;
            prevY = secondToLastPointY;
        }
        // Last coordinate of a closed ring -> next coordinate is the first vertex of a line string
        if (isClosedRing && j === flatCoordinates.length - 2) {
            // last coordinate
            nextX = firstPointX;
            nextY = firstPointY;
        }
        // 2. Current vertex to offset
        x = flatCoordinates[j];
        y = flatCoordinates[j + 1];
        // 3. Offset the vertex
        [offsetX, offsetY] = $3bcfad17cf4aa97e$export$1d816e12adb721de(x, y, prevX, prevY, nextX, nextY, offset);
        dest[i++] = offsetX;
        dest[i++] = offsetY;
        // 4. Copy over other dimension values if any
        for(let k = 2; k < destinationStride; k++)dest[i++] = flatCoordinates[j + k];
    }
    if (dest.length != i) dest.length = i;
    return dest;
}
function $3bcfad17cf4aa97e$export$1d816e12adb721de(x, y, prevX, prevY, nextX, nextY, offset) {
    // Compute segment direction
    let nx, ny;
    if (prevX !== undefined && prevY !== undefined) {
        nx = x - prevX;
        ny = y - prevY;
    } else if (nextX !== undefined && nextY !== undefined) {
        nx = nextX - x;
        ny = nextY - y;
    } else {
        // no next, no previous point given -> just assume some default (horizontal) direction
        nx = 1;
        ny = 0;
    }
    // Normalize -> tangent
    const len = Math.hypot(nx, ny);
    const tx = nx / len;
    const ty = ny / len;
    // Rotate tangent 90° -> normal
    nx = -ty;
    ny = tx;
    // First / last vertex -> offset the point in the direction of the normal vector
    if (prevX === undefined || prevY === undefined) return [
        x + nx * offset,
        y + ny * offset
    ];
    if (nextX === undefined || nextY === undefined) return [
        x + nx * offset,
        y + ny * offset
    ];
    // Compute join angle - angle between 2 segments of the vertex.
    const joinAngle = (0, $2o3CH.angleBetween)([
        x,
        y
    ], [
        prevX,
        prevY
    ], [
        nextX,
        nextY
    ]);
    // Avoid huge or infinite miter joins for very sharp angles, offset in the segment direction in this case.
    if (Math.cos(joinAngle) > 0.998) return [
        x + tx * offset,
        y + ty * offset
    ];
    // Compute join offset direction.
    // We rotate the normal vector by half of the join angle.
    // This gives the direction of the miter at the vertex.
    const cos = Math.cos(joinAngle / 2);
    const sin = Math.sin(joinAngle / 2);
    // Rotate the normal vector (nx, ny) by half of the join angle.
    // bx/by = bisector direction before normalization
    const bx = sin * nx + cos * ny;
    const by = -cos * nx + sin * ny;
    // Scale the bisector so that moving along it preserves the correct offset distance.
    // Dividing by sin(half of angle) converts the bisector into the true miter vector.
    // (This expands the miter for sharp angles and shortens it for wide ones.)
    const dx = bx * (1 / sin);
    const dy = by * (1 / sin);
    // Offset final vertex along miter direction
    return [
        x + dx * offset,
        y + dy * offset
    ];
}

});

parcelRegister("l8Phk", function(module, exports) {

$parcel$export(module.exports, "drawTextOnPath", () => $f6421f31729929e6$export$153a9a17ab3e949f);
/**
 * @module ol/geom/flat/textpath
 */ 
var $9byFX = parcelRequire("9byFX");

var $1MAUi = parcelRequire("1MAUi");
function $f6421f31729929e6$export$153a9a17ab3e949f(flatCoordinates, offset, end, stride, text, startM, maxAngle, scale, measureAndCacheTextWidth, font, cache, rotation, keepUpright = true) {
    let x2 = flatCoordinates[offset];
    let y2 = flatCoordinates[offset + 1];
    let x1 = 0;
    let y1 = 0;
    let segmentLength = 0;
    let segmentM = 0;
    function advance() {
        x1 = x2;
        y1 = y2;
        offset += stride;
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        segmentM += segmentLength;
        segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    do advance();
    while (offset < end - stride && segmentM + segmentLength < startM);
    let interpolate = segmentLength === 0 ? 0 : (startM - segmentM) / segmentLength;
    const beginX = (0, $9byFX.lerp)(x1, x2, interpolate);
    const beginY = (0, $9byFX.lerp)(y1, y2, interpolate);
    const startOffset = offset - stride;
    const startLength = segmentM;
    const endM = startM + scale * measureAndCacheTextWidth(font, text, cache);
    while(offset < end - stride && segmentM + segmentLength < endM)advance();
    interpolate = segmentLength === 0 ? 0 : (endM - segmentM) / segmentLength;
    const endX = (0, $9byFX.lerp)(x1, x2, interpolate);
    const endY = (0, $9byFX.lerp)(y1, y2, interpolate);
    // Keep text upright if the option is selected
    let reverse = false;
    if (keepUpright) {
        if (rotation) {
            const flat = [
                beginX,
                beginY,
                endX,
                endY
            ];
            (0, $1MAUi.rotate)(flat, 0, 4, 2, rotation, flat, flat);
            reverse = flat[0] > flat[2];
        } else reverse = beginX > endX;
    }
    const PI = Math.PI;
    const result = [];
    const singleSegment = startOffset + stride === offset;
    offset = startOffset;
    segmentLength = 0;
    segmentM = startLength;
    x2 = flatCoordinates[offset];
    y2 = flatCoordinates[offset + 1];
    let previousAngle;
    // All on the same segment
    if (singleSegment) {
        advance();
        previousAngle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) previousAngle += previousAngle > 0 ? -PI : PI;
        const x = (endX + beginX) / 2;
        const y = (endY + beginY) / 2;
        result[0] = [
            x,
            y,
            (endM - startM) / 2,
            previousAngle,
            text
        ];
        return result;
    }
    // rendering across line segments
    text = text.replace(/\n/g, ' '); // ensure rendering in single-line as all calculations below don't handle multi-lines
    for(let i = 0, ii = text.length; i < ii;){
        advance();
        let angle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) angle += angle > 0 ? -PI : PI;
        if (previousAngle !== undefined) {
            let delta = angle - previousAngle;
            delta += delta > PI ? -2 * PI : delta < -PI ? 2 * PI : 0;
            if (Math.abs(delta) > maxAngle) return null;
        }
        previousAngle = angle;
        const iStart = i;
        let charLength = 0;
        for(; i < ii; ++i){
            const index = reverse ? ii - i - 1 : i;
            const len = scale * measureAndCacheTextWidth(font, text[index], cache);
            if (offset + stride < end && segmentM + segmentLength < startM + charLength + len / 2) break;
            charLength += len;
        }
        if (i === iStart) continue;
        const chars = reverse ? text.substring(ii - iStart, ii - i) : text.substring(iStart, i);
        interpolate = segmentLength === 0 ? 0 : (startM + charLength / 2 - segmentM) / segmentLength;
        const x = (0, $9byFX.lerp)(x1, x2, interpolate);
        const y = (0, $9byFX.lerp)(y1, y2, interpolate);
        result.push([
            x,
            y,
            charLength / 2,
            angle,
            chars
        ]);
        startM += charLength;
    }
    return result;
}

});



parcelRegister("1HMKO", function(module, exports) {

$parcel$export(module.exports, "HIT_DETECT_RESOLUTION", () => $13dfa0283bf5c35f$export$ab51038298418f25);
$parcel$export(module.exports, "createHitDetectionImageData", () => $13dfa0283bf5c35f$export$bd05e394339d469);
$parcel$export(module.exports, "hitDetect", () => $13dfa0283bf5c35f$export$6d4d555ddbfffa32);
/**
 * @module ol/render/canvas/hitdetect
 */ 
var $fVVyM = parcelRequire("fVVyM");

var $DfnQm = parcelRequire("DfnQm");

var $9pD6L = parcelRequire("9pD6L");

var $9byFX = parcelRequire("9byFX");

var $dpRHA = parcelRequire("dpRHA");

var $bmHVE = parcelRequire("bmHVE");

var $ayYEF = parcelRequire("ayYEF");
const $13dfa0283bf5c35f$export$ab51038298418f25 = 0.5;
function $13dfa0283bf5c35f$export$bd05e394339d469(size, transforms, features, styleFunction, extent, resolution, rotation, squaredTolerance, projection) {
    const userExtent = projection ? (0, $dpRHA.toUserExtent)(extent, projection) : extent;
    const width = size[0] * $13dfa0283bf5c35f$export$ab51038298418f25;
    const height = size[1] * $13dfa0283bf5c35f$export$ab51038298418f25;
    const context = (0, $DfnQm.createCanvasContext2D)(width, height);
    context.imageSmoothingEnabled = false;
    const canvas = context.canvas;
    const renderer = new (0, $ayYEF.default)(context, $13dfa0283bf5c35f$export$ab51038298418f25, extent, null, rotation, squaredTolerance, projection ? (0, $dpRHA.getTransformFromProjections)((0, $dpRHA.getUserProjection)(), projection) : null);
    const featureCount = features.length;
    // Stretch hit detection index to use the whole available color range
    const indexFactor = Math.floor(16777215 / featureCount);
    const featuresByZIndex = {};
    for(let i = 1; i <= featureCount; ++i){
        const feature = features[i - 1];
        const featureStyleFunction = feature.getStyleFunction() || styleFunction;
        if (!featureStyleFunction) continue;
        let styles = featureStyleFunction(feature, resolution);
        if (!styles) continue;
        if (!Array.isArray(styles)) styles = [
            styles
        ];
        const index = i * indexFactor;
        const color = index.toString(16).padStart(7, '#00000');
        for(let j = 0, jj = styles.length; j < jj; ++j){
            const originalStyle = styles[j];
            const geometry = originalStyle.getGeometryFunction()(feature);
            if (!geometry || !(0, $9pD6L.intersects)(userExtent, geometry.getExtent())) continue;
            const style = originalStyle.clone();
            const fill = style.getFill();
            if (fill) fill.setColor(color);
            const stroke = style.getStroke();
            if (stroke) {
                stroke.setColor(color);
                stroke.setLineDash(null);
            }
            style.setText(undefined);
            const image = originalStyle.getImage();
            if (image) {
                const imgSize = image.getImageSize();
                if (!imgSize) continue;
                const imgContext = (0, $DfnQm.createCanvasContext2D)(imgSize[0], imgSize[1], undefined, {
                    alpha: false
                });
                const img = imgContext.canvas;
                imgContext.fillStyle = color;
                imgContext.fillRect(0, 0, img.width, img.height);
                style.setImage(new (0, $bmHVE.default)({
                    img: img,
                    anchor: image.getAnchor(),
                    anchorXUnits: 'pixels',
                    anchorYUnits: 'pixels',
                    offset: image.getOrigin(),
                    opacity: 1,
                    size: image.getSize(),
                    scale: image.getScale(),
                    rotation: image.getRotation(),
                    rotateWithView: image.getRotateWithView()
                }));
            }
            const zIndex = style.getZIndex() || 0;
            let byGeometryType = featuresByZIndex[zIndex];
            if (!byGeometryType) {
                byGeometryType = {};
                featuresByZIndex[zIndex] = byGeometryType;
                byGeometryType['Polygon'] = [];
                byGeometryType['Circle'] = [];
                byGeometryType['LineString'] = [];
                byGeometryType['Point'] = [];
            }
            const type = geometry.getType();
            if (type === 'GeometryCollection') {
                const geometries = /** @type {import("../../geom/GeometryCollection.js").default} */ geometry.getGeometriesArrayRecursive();
                for(let i = 0, ii = geometries.length; i < ii; ++i){
                    const geometry = geometries[i];
                    byGeometryType[geometry.getType().replace('Multi', '')].push(geometry, style);
                }
            } else byGeometryType[type.replace('Multi', '')].push(geometry, style);
        }
    }
    const zIndexKeys = Object.keys(featuresByZIndex).map(Number).sort((0, $fVVyM.ascending));
    for(let i = 0, ii = zIndexKeys.length; i < ii; ++i){
        const byGeometryType = featuresByZIndex[zIndexKeys[i]];
        for(const type in byGeometryType){
            const geomAndStyle = byGeometryType[type];
            for(let j = 0, jj = geomAndStyle.length; j < jj; j += 2){
                renderer.setStyle(geomAndStyle[j + 1]);
                for(let k = 0, kk = transforms.length; k < kk; ++k){
                    renderer.setTransform(transforms[k]);
                    renderer.drawGeometry(geomAndStyle[j]);
                }
            }
        }
    }
    return context.getImageData(0, 0, canvas.width, canvas.height);
}
function $13dfa0283bf5c35f$export$6d4d555ddbfffa32(pixel, features, imageData) {
    /** @type {Array<F>} */ const resultFeatures = [];
    if (imageData) {
        const x = Math.floor(Math.round(pixel[0]) * $13dfa0283bf5c35f$export$ab51038298418f25);
        const y = Math.floor(Math.round(pixel[1]) * $13dfa0283bf5c35f$export$ab51038298418f25);
        // The pixel coordinate is clamped down to the hit-detect canvas' size to account
        // for browsers returning coordinates slightly larger than the actual canvas size
        // due to a non-integer pixel ratio.
        const index = ((0, $9byFX.clamp)(x, 0, imageData.width - 1) + (0, $9byFX.clamp)(y, 0, imageData.height - 1) * imageData.width) * 4;
        const r = imageData.data[index];
        const g = imageData.data[index + 1];
        const b = imageData.data[index + 2];
        const i = b + 256 * (g + 256 * r);
        const indexFactor = Math.floor(16777215 / features.length);
        if (i && i % indexFactor === 0) resultFeatures.push(features[i / indexFactor - 1]);
    }
    return resultFeatures;
}

});
parcelRegister("ayYEF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b0c2128a27f5020$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/Immediate
 */ // FIXME test, especially polygons with holes and multipolygons
// FIXME need to handle large thick features (where pixel size matters)
// FIXME add offset and end to ol/geom/flat/transform~transform2D?

var $fVVyM = parcelRequire("fVVyM");

var $jh19n = parcelRequire("jh19n");

var $9pD6L = parcelRequire("9pD6L");

var $h7zsK = parcelRequire("h7zsK");

var $58naT = parcelRequire("58naT");

var $1MAUi = parcelRequire("1MAUi");

var $9byFX = parcelRequire("9byFX");

var $jpXrt = parcelRequire("jpXrt");

var $kbchp = parcelRequire("kbchp");

var $ig1j9 = parcelRequire("ig1j9");
/**
 * @classdesc
 * A concrete subclass of {@link module:ol/render/VectorContext~VectorContext} that implements
 * direct rendering of features and geometries to an HTML5 Canvas context.
 * Instances of this class are created internally by the library and
 * provided to application code as vectorContext member of the
 * {@link module:ol/render/Event~RenderEvent} object associated with postcompose, precompose and
 * render events emitted by layers and maps.
 */ class $7b0c2128a27f5020$var$CanvasImmediateRenderer extends (0, $kbchp.default) {
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../extent.js").Extent} extent Extent.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {number} [squaredTolerance] Optional squared tolerance for simplification.
   * @param {import("../../proj.js").TransformFunction} [userTransform] Transform from user to view projection.
   */ constructor(context, pixelRatio, extent, transform, viewRotation, squaredTolerance, userTransform){
        super();
        /**
     * @private
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.context_ = context;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.extent_ = extent;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.transform_ = transform;
        /**
     * @private
     * @type {number}
     */ this.transformRotation_ = transform ? (0, $9byFX.toFixed)(Math.atan2(transform[1], transform[0]), 10) : 0;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = viewRotation;
        /**
     * @private
     * @type {number}
     */ this.squaredTolerance_ = squaredTolerance;
        /**
     * @private
     * @type {import("../../proj.js").TransformFunction}
     */ this.userTransform_ = userTransform;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.contextFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.contextStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.contextTextState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.fillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.strokeState_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorY_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageHeight_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOpacity_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.imageRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.imageRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.imageScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.imageWidth_ = 0;
        /**
     * @private
     * @type {string}
     */ this.text_ = '';
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.textRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.textScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.textState_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = [];
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.tmpLocalTransform_ = (0, $jpXrt.create)();
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawImages_(flatCoordinates, offset, end, stride) {
        if (!this.image_) return;
        const pixelCoordinates = (0, $1MAUi.transform2D)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        const localTransform = this.tmpLocalTransform_;
        const alpha = context.globalAlpha;
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha * this.imageOpacity_;
        let rotation = this.imageRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.imageRotateWithView_) rotation += this.viewRotation_;
        for(let i = 0, ii = pixelCoordinates.length; i < ii; i += 2){
            const x = pixelCoordinates[i] - this.imageAnchorX_;
            const y = pixelCoordinates[i + 1] - this.imageAnchorY_;
            if (rotation !== 0 || this.imageScale_[0] != 1 || this.imageScale_[1] != 1) {
                const centerX = x + this.imageAnchorX_;
                const centerY = y + this.imageAnchorY_;
                (0, $jpXrt.compose)(localTransform, centerX, centerY, 1, 1, rotation, -centerX, -centerY);
                context.save();
                context.transform.apply(context, localTransform);
                context.translate(centerX, centerY);
                context.scale(this.imageScale_[0], this.imageScale_[1]);
                context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, -this.imageAnchorX_, -this.imageAnchorY_, this.imageWidth_, this.imageHeight_);
                context.restore();
            } else context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, x, y, this.imageWidth_, this.imageHeight_);
        }
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawText_(flatCoordinates, offset, end, stride) {
        if (!this.textState_ || this.text_ === '') return;
        if (this.textFillState_) this.setContextFillState_(this.textFillState_);
        if (this.textStrokeState_) this.setContextStrokeState_(this.textStrokeState_);
        this.setContextTextState_(this.textState_);
        const pixelCoordinates = (0, $1MAUi.transform2D)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        let rotation = this.textRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.textRotateWithView_) rotation += this.viewRotation_;
        for(; offset < end; offset += stride){
            const x = pixelCoordinates[offset] + this.textOffsetX_;
            const y = pixelCoordinates[offset + 1] + this.textOffsetY_;
            if (rotation !== 0 || this.textScale_[0] != 1 || this.textScale_[1] != 1) {
                context.save();
                context.translate(x - this.textOffsetX_, y - this.textOffsetY_);
                context.rotate(rotation);
                context.translate(this.textOffsetX_, this.textOffsetY_);
                context.scale(this.textScale_[0], this.textScale_[1]);
                if (this.textStrokeState_) context.strokeText(this.text_, 0, 0);
                if (this.textFillState_) context.fillText(this.text_, 0, 0);
                context.restore();
            } else {
                if (this.textStrokeState_) context.strokeText(this.text_, x, y);
                if (this.textFillState_) context.fillText(this.text_, x, y);
            }
        }
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} close Close.
   * @param {number} [strokeOffset] Stroke Offset.
   * @private
   * @return {number} end End.
   */ moveToLineTo_(flatCoordinates, offset, end, stride, close, strokeOffset) {
        const context = this.context_;
        let pixelCoordinates = (0, $1MAUi.transform2D)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        if (Math.abs(strokeOffset) > 0) pixelCoordinates = (0, $58naT.offsetLineString)(pixelCoordinates, stride, strokeOffset, close, pixelCoordinates);
        context.moveTo(pixelCoordinates[0], pixelCoordinates[1]);
        let length = pixelCoordinates.length;
        if (close) length -= 2;
        for(let i = 2; i < length; i += 2)context.lineTo(pixelCoordinates[i], pixelCoordinates[i + 1]);
        if (close) context.closePath();
        return end;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {number} [strokeOffset] Stroke Offset.
   * @private
   * @return {number} End.
   */ drawRings_(flatCoordinates, offset, ends, stride, strokeOffset) {
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, true, strokeOffset);
        return offset;
    }
    /**
   * Render a circle geometry into the canvas.  Rendering is immediate and uses
   * the current fill and stroke styles.
   *
   * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
   * @api
   * @override
   */ drawCircle(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Circle.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $9pD6L.intersects)(this.extent_, geometry.getExtent())) return;
        if (this.fillState_ || this.strokeState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const pixelCoordinates = (0, $h7zsK.transformGeom2D)(geometry, this.transform_, this.pixelCoordinates_);
            const dx = pixelCoordinates[2] - pixelCoordinates[0];
            const dy = pixelCoordinates[3] - pixelCoordinates[1];
            const radius = Math.sqrt(dx * dx + dy * dy);
            const context = this.context_;
            context.beginPath();
            context.arc(pixelCoordinates[0], pixelCoordinates[1], radius, 0, 2 * Math.PI);
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') this.drawText_(geometry.getCenter(), 0, 2, 2);
    }
    /**
   * Set the rendering style.  Note that since this is an immediate rendering API,
   * any `zIndex` on the provided style will be ignored.
   *
   * @param {import("../../style/Style.js").default} style The rendering style.
   * @api
   * @override
   */ setStyle(style) {
        this.setFillStrokeStyle(style.getFill(), style.getStroke());
        this.setImageStyle(style.getImage());
        this.setTextStyle(style.getText());
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   */ setTransform(transform) {
        this.transform_ = transform;
    }
    /**
   * Render a geometry into the canvas.  Call
   * {@link module:ol/render/canvas/Immediate~CanvasImmediateRenderer#setStyle renderer.setStyle()} first to set the rendering style.
   *
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
   * @api
   * @override
   */ drawGeometry(geometry) {
        const type = geometry.getType();
        switch(type){
            case 'Point':
                this.drawPoint(/** @type {import("../../geom/Point.js").default} */ geometry);
                break;
            case 'LineString':
                this.drawLineString(/** @type {import("../../geom/LineString.js").default} */ geometry);
                break;
            case 'Polygon':
                this.drawPolygon(/** @type {import("../../geom/Polygon.js").default} */ geometry);
                break;
            case 'MultiPoint':
                this.drawMultiPoint(/** @type {import("../../geom/MultiPoint.js").default} */ geometry);
                break;
            case 'MultiLineString':
                this.drawMultiLineString(/** @type {import("../../geom/MultiLineString.js").default} */ geometry);
                break;
            case 'MultiPolygon':
                this.drawMultiPolygon(/** @type {import("../../geom/MultiPolygon.js").default} */ geometry);
                break;
            case 'GeometryCollection':
                this.drawGeometryCollection(/** @type {import("../../geom/GeometryCollection.js").default} */ geometry);
                break;
            case 'Circle':
                this.drawCircle(/** @type {import("../../geom/Circle.js").default} */ geometry);
                break;
            default:
        }
    }
    /**
   * Render a feature into the canvas.  Note that any `zIndex` on the provided
   * style will be ignored - features are rendered immediately in the order that
   * this method is called.  If you need `zIndex` support, you should be using an
   * {@link module:ol/layer/Vector~VectorLayer} instead.
   *
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {import("../../style/Style.js").default} style Style.
   * @api
   * @override
   */ drawFeature(feature, style) {
        const geometry = style.getGeometryFunction()(feature);
        if (!geometry) return;
        this.setStyle(style);
        this.drawGeometry(geometry);
    }
    /**
   * Render a GeometryCollection to the canvas.  Rendering is immediate and
   * uses the current styles appropriate for each geometry in the collection.
   *
   * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
   * @override
   */ drawGeometryCollection(geometry) {
        const geometries = geometry.getGeometriesArray();
        for(let i = 0, ii = geometries.length; i < ii; ++i)this.drawGeometry(geometries[i]);
    }
    /**
   * Render a Point geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
   * @override
   */ drawPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Point.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== '') this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
   * uses the current style.
   *
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
   * @override
   */ drawMultiPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== '') this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a LineString into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
   * @override
   */ drawLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/LineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $9pD6L.intersects)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            context.beginPath();
            this.moveToLineTo_(flatCoordinates, 0, flatCoordinates.length, geometry.getStride(), false, this.strokeState_.strokeOffset);
            context.stroke();
        }
        if (this.text_ !== '') {
            const flatMidpoint = geometry.getFlatMidpoint();
            this.drawText_(flatMidpoint, 0, 2, 2);
        }
    }
    /**
   * Render a MultiLineString geometry into the canvas.  Rendering is immediate
   * and uses the current style.
   *
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
   * @override
   */ drawMultiLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const geometryExtent = geometry.getExtent();
        if (!(0, $9pD6L.intersects)(this.extent_, geometryExtent)) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            let offset = 0;
            const ends = /** @type {Array<number>} */ geometry.getEnds();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, false, this.strokeState_.strokeOffset);
            context.stroke();
        }
        if (this.text_ !== '') {
            const flatMidpoints = geometry.getFlatMidpoints();
            this.drawText_(flatMidpoints, 0, flatMidpoints.length, 2);
        }
    }
    /**
   * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
   * @override
   */ drawPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Polygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $9pD6L.intersects)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            context.beginPath();
            this.drawRings_(geometry.getOrientedFlatCoordinates(), 0, /** @type {Array<number>} */ geometry.getEnds(), geometry.getStride(), this.strokeState_?.strokeOffset);
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') {
            const flatInteriorPoint = geometry.getFlatInteriorPoint();
            this.drawText_(flatInteriorPoint, 0, 2, 2);
        }
    }
    /**
   * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
   * uses the current style.
   * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
   * @override
   */ drawMultiPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $9pD6L.intersects)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getOrientedFlatCoordinates();
            let offset = 0;
            const endss = geometry.getEndss();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = endss.length; i < ii; ++i){
                const ends = endss[i];
                offset = this.drawRings_(flatCoordinates, offset, ends, stride, this.strokeState_?.strokeOffset);
            }
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') {
            const flatInteriorPoints = geometry.getFlatInteriorPoints();
            this.drawText_(flatInteriorPoints, 0, flatInteriorPoints.length, 2);
        }
    }
    /**
   * @param {import("../canvas.js").FillState} fillState Fill state.
   * @private
   */ setContextFillState_(fillState) {
        const context = this.context_;
        const contextFillState = this.contextFillState_;
        if (!contextFillState) {
            context.fillStyle = fillState.fillStyle;
            this.contextFillState_ = {
                fillStyle: fillState.fillStyle
            };
        } else if (contextFillState.fillStyle != fillState.fillStyle) {
            contextFillState.fillStyle = fillState.fillStyle;
            context.fillStyle = fillState.fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
   * @private
   */ setContextStrokeState_(strokeState) {
        const context = this.context_;
        const contextStrokeState = this.contextStrokeState_;
        if (!contextStrokeState) {
            context.lineCap = strokeState.lineCap;
            context.setLineDash(strokeState.lineDash);
            context.lineDashOffset = strokeState.lineDashOffset;
            context.lineJoin = strokeState.lineJoin;
            context.lineWidth = strokeState.lineWidth;
            context.miterLimit = strokeState.miterLimit;
            context.strokeStyle = strokeState.strokeStyle;
            this.contextStrokeState_ = {
                lineCap: strokeState.lineCap,
                lineDash: strokeState.lineDash,
                lineDashOffset: strokeState.lineDashOffset,
                lineJoin: strokeState.lineJoin,
                lineWidth: strokeState.lineWidth,
                miterLimit: strokeState.miterLimit,
                strokeStyle: strokeState.strokeStyle
            };
        } else {
            if (contextStrokeState.lineCap != strokeState.lineCap) {
                contextStrokeState.lineCap = strokeState.lineCap;
                context.lineCap = strokeState.lineCap;
            }
            if (!(0, $fVVyM.equals)(contextStrokeState.lineDash, strokeState.lineDash)) context.setLineDash(contextStrokeState.lineDash = strokeState.lineDash);
            if (contextStrokeState.lineDashOffset != strokeState.lineDashOffset) {
                contextStrokeState.lineDashOffset = strokeState.lineDashOffset;
                context.lineDashOffset = strokeState.lineDashOffset;
            }
            if (contextStrokeState.lineJoin != strokeState.lineJoin) {
                contextStrokeState.lineJoin = strokeState.lineJoin;
                context.lineJoin = strokeState.lineJoin;
            }
            if (contextStrokeState.lineWidth != strokeState.lineWidth) {
                contextStrokeState.lineWidth = strokeState.lineWidth;
                context.lineWidth = strokeState.lineWidth;
            }
            if (contextStrokeState.miterLimit != strokeState.miterLimit) {
                contextStrokeState.miterLimit = strokeState.miterLimit;
                context.miterLimit = strokeState.miterLimit;
            }
            if (contextStrokeState.strokeStyle != strokeState.strokeStyle) {
                contextStrokeState.strokeStyle = strokeState.strokeStyle;
                context.strokeStyle = strokeState.strokeStyle;
            }
        }
    }
    /**
   * @param {import("../canvas.js").TextState} textState Text state.
   * @private
   */ setContextTextState_(textState) {
        const context = this.context_;
        const contextTextState = this.contextTextState_;
        const textAlign = textState.textAlign ? textState.textAlign : (0, $ig1j9.defaultTextAlign);
        if (!contextTextState) {
            context.font = textState.font;
            context.textAlign = textAlign;
            context.textBaseline = textState.textBaseline;
            this.contextTextState_ = {
                font: textState.font,
                textAlign: textAlign,
                textBaseline: textState.textBaseline
            };
        } else {
            if (contextTextState.font != textState.font) {
                contextTextState.font = textState.font;
                context.font = textState.font;
            }
            if (contextTextState.textAlign != textAlign) {
                contextTextState.textAlign = textAlign;
                context.textAlign = textAlign;
            }
            if (contextTextState.textBaseline != textState.textBaseline) {
                contextTextState.textBaseline = textState.textBaseline;
                context.textBaseline = textState.textBaseline;
            }
        }
    }
    /**
   * Set the fill and stroke style for subsequent draw operations.  To clear
   * either fill or stroke styles, pass null for the appropriate parameter.
   *
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        if (!fillStyle) this.fillState_ = null;
        else {
            const fillStyleColor = fillStyle.getColor();
            this.fillState_ = {
                fillStyle: (0, $jh19n.asColorLike)(fillStyleColor ? fillStyleColor : (0, $ig1j9.defaultFillStyle))
            };
        }
        if (!strokeStyle) this.strokeState_ = null;
        else {
            const strokeStyleColor = strokeStyle.getColor();
            const strokeStyleLineCap = strokeStyle.getLineCap();
            const strokeStyleLineDash = strokeStyle.getLineDash();
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            const strokeStyleWidth = strokeStyle.getWidth();
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            const lineDash = strokeStyleLineDash ? strokeStyleLineDash : (0, $ig1j9.defaultLineDash);
            const strokeOffset = strokeStyle.getOffset();
            this.strokeState_ = {
                lineCap: strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $ig1j9.defaultLineCap),
                lineDash: this.pixelRatio_ === 1 ? lineDash : lineDash.map((n)=>n * this.pixelRatio_),
                lineDashOffset: (strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $ig1j9.defaultLineDashOffset)) * this.pixelRatio_,
                lineJoin: strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $ig1j9.defaultLineJoin),
                lineWidth: (strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $ig1j9.defaultLineWidth)) * this.pixelRatio_,
                miterLimit: strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $ig1j9.defaultMiterLimit),
                strokeStyle: (0, $jh19n.asColorLike)(strokeStyleColor ? strokeStyleColor : (0, $ig1j9.defaultStrokeStyle)),
                strokeOffset: (strokeOffset ?? 0) * this.pixelRatio_
            };
        }
    }
    /**
   * Set the image style for subsequent draw operations.  Pass null to remove
   * the image style.
   *
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @override
   */ setImageStyle(imageStyle) {
        let imageSize;
        if (!imageStyle || !(imageSize = imageStyle.getSize())) {
            this.image_ = null;
            return;
        }
        const imagePixelRatio = imageStyle.getPixelRatio(this.pixelRatio_);
        const imageAnchor = imageStyle.getAnchor();
        const imageOrigin = imageStyle.getOrigin();
        this.image_ = imageStyle.getImage(this.pixelRatio_);
        this.imageAnchorX_ = imageAnchor[0] * imagePixelRatio;
        this.imageAnchorY_ = imageAnchor[1] * imagePixelRatio;
        this.imageHeight_ = imageSize[1] * imagePixelRatio;
        this.imageOpacity_ = imageStyle.getOpacity();
        this.imageOriginX_ = imageOrigin[0];
        this.imageOriginY_ = imageOrigin[1];
        this.imageRotateWithView_ = imageStyle.getRotateWithView();
        this.imageRotation_ = imageStyle.getRotation();
        const imageScale = imageStyle.getScaleArray();
        this.imageScale_ = [
            imageScale[0] * this.pixelRatio_ / imagePixelRatio,
            imageScale[1] * this.pixelRatio_ / imagePixelRatio
        ];
        this.imageWidth_ = imageSize[0] * imagePixelRatio;
    }
    /**
   * Set the text style for subsequent draw operations.  Pass null to
   * remove the text style.
   *
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @override
   */ setTextStyle(textStyle) {
        if (!textStyle) this.text_ = '';
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) this.textFillState_ = null;
            else {
                const textFillStyleColor = textFillStyle.getColor();
                this.textFillState_ = {
                    fillStyle: (0, $jh19n.asColorLike)(textFillStyleColor ? textFillStyleColor : (0, $ig1j9.defaultFillStyle))
                };
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) this.textStrokeState_ = null;
            else {
                const textStrokeStyleColor = textStrokeStyle.getColor();
                const textStrokeStyleLineCap = textStrokeStyle.getLineCap();
                const textStrokeStyleLineDash = textStrokeStyle.getLineDash();
                const textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
                const textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
                const textStrokeStyleWidth = textStrokeStyle.getWidth();
                const textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
                this.textStrokeState_ = {
                    lineCap: textStrokeStyleLineCap !== undefined ? textStrokeStyleLineCap : (0, $ig1j9.defaultLineCap),
                    lineDash: textStrokeStyleLineDash ? textStrokeStyleLineDash : (0, $ig1j9.defaultLineDash),
                    lineDashOffset: textStrokeStyleLineDashOffset ? textStrokeStyleLineDashOffset : (0, $ig1j9.defaultLineDashOffset),
                    lineJoin: textStrokeStyleLineJoin !== undefined ? textStrokeStyleLineJoin : (0, $ig1j9.defaultLineJoin),
                    lineWidth: textStrokeStyleWidth !== undefined ? textStrokeStyleWidth : (0, $ig1j9.defaultLineWidth),
                    miterLimit: textStrokeStyleMiterLimit !== undefined ? textStrokeStyleMiterLimit : (0, $ig1j9.defaultMiterLimit),
                    strokeStyle: (0, $jh19n.asColorLike)(textStrokeStyleColor ? textStrokeStyleColor : (0, $ig1j9.defaultStrokeStyle))
                };
            }
            const textFont = textStyle.getFont();
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textRotation = textStyle.getRotation();
            const textScale = textStyle.getScaleArray();
            const textText = textStyle.getText();
            const textTextAlign = textStyle.getTextAlign();
            const textTextBaseline = textStyle.getTextBaseline();
            this.textState_ = {
                font: textFont !== undefined ? textFont : (0, $ig1j9.defaultFont),
                textAlign: textTextAlign !== undefined ? textTextAlign : (0, $ig1j9.defaultTextAlign),
                textBaseline: textTextBaseline !== undefined ? textTextBaseline : (0, $ig1j9.defaultTextBaseline)
            };
            this.text_ = textText !== undefined ? Array.isArray(textText) ? textText.reduce((acc, t, i)=>acc += i % 2 ? ' ' : t, '') : textText : '';
            this.textOffsetX_ = textOffsetX !== undefined ? this.pixelRatio_ * textOffsetX : 0;
            this.textOffsetY_ = textOffsetY !== undefined ? this.pixelRatio_ * textOffsetY : 0;
            this.textRotateWithView_ = textRotateWithView !== undefined ? textRotateWithView : false;
            this.textRotation_ = textRotation !== undefined ? textRotation : 0;
            this.textScale_ = [
                this.pixelRatio_ * textScale[0],
                this.pixelRatio_ * textScale[1]
            ];
        }
    }
}
var $7b0c2128a27f5020$export$2e2bcd8739ae039 = $7b0c2128a27f5020$var$CanvasImmediateRenderer;

});


parcelRegister("6urmj", function(module, exports) {

$parcel$export(module.exports, "defaultOrder", () => $4b9ac454600c05d2$export$531ddd8416d52dfc);
$parcel$export(module.exports, "getSquaredTolerance", () => $4b9ac454600c05d2$export$75084a70d324c1e6);
$parcel$export(module.exports, "getTolerance", () => $4b9ac454600c05d2$export$bdacc5b475012edb);
$parcel$export(module.exports, "renderFeature", () => $4b9ac454600c05d2$export$36f470a33a42f413);
/**
 * @module ol/renderer/vector
 */ 
var $aSvtr = parcelRequire("aSvtr");

var $9iPUS = parcelRequire("9iPUS");
/**
 * Feature callback. The callback will be called with three arguments. The first
 * argument is one {@link module:ol/Feature~Feature feature} or {@link module:ol/render/Feature~RenderFeature render feature}
 * at the pixel, the second is the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
 * unmanaged layers. The third is the {@link module:ol/geom/SimpleGeometry~SimpleGeometry} of the feature. For features
 * with a GeometryCollection geometry, it will be the first detected geometry from the collection.
 * @template T
 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default<import("../source/Source").default>, import("../geom/SimpleGeometry.js").default): T} FeatureCallback
 */ /**
 * Tolerance for geometry simplification in device pixels.
 * @type {number}
 */ const $4b9ac454600c05d2$var$SIMPLIFY_TOLERANCE = 0.5;
/**
 * @const
 * @type {Object<import("../geom/Geometry.js").Type,
 *                function(import("../render/canvas/BuilderGroup.js").default, import("../geom/Geometry.js").default,
 *                         import("../style/Style.js").default, Object): void>}
 */ const $4b9ac454600c05d2$var$GEOMETRY_RENDERERS = {
    'Point': $4b9ac454600c05d2$var$renderPointGeometry,
    'LineString': $4b9ac454600c05d2$var$renderLineStringGeometry,
    'Polygon': $4b9ac454600c05d2$var$renderPolygonGeometry,
    'MultiPoint': $4b9ac454600c05d2$var$renderMultiPointGeometry,
    'MultiLineString': $4b9ac454600c05d2$var$renderMultiLineStringGeometry,
    'MultiPolygon': $4b9ac454600c05d2$var$renderMultiPolygonGeometry,
    'GeometryCollection': $4b9ac454600c05d2$var$renderGeometryCollectionGeometry,
    'Circle': $4b9ac454600c05d2$var$renderCircleGeometry
};
function $4b9ac454600c05d2$export$531ddd8416d52dfc(feature1, feature2) {
    return parseInt((0, $9iPUS.getUid)(feature1), 10) - parseInt((0, $9iPUS.getUid)(feature2), 10);
}
function $4b9ac454600c05d2$export$75084a70d324c1e6(resolution, pixelRatio) {
    const tolerance = $4b9ac454600c05d2$export$bdacc5b475012edb(resolution, pixelRatio);
    return tolerance * tolerance;
}
function $4b9ac454600c05d2$export$bdacc5b475012edb(resolution, pixelRatio) {
    return $4b9ac454600c05d2$var$SIMPLIFY_TOLERANCE * resolution / pixelRatio;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
 * @param {import("../geom/Circle.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderCircleGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const circleReplay = builderGroup.getBuilder(style.getZIndex(), 'Circle');
        circleReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        circleReplay.drawCircle(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
function $4b9ac454600c05d2$export$36f470a33a42f413(replayGroup, feature, style, squaredTolerance, listener, transform, declutter, index) {
    const loadingPromises = [];
    const imageStyle = style.getImage();
    if (imageStyle) {
        let loading = true;
        const imageState = imageStyle.getImageState();
        if (imageState == (0, $aSvtr.default).LOADED || imageState == (0, $aSvtr.default).ERROR) loading = false;
        else if (imageState == (0, $aSvtr.default).IDLE) imageStyle.load();
        if (loading) loadingPromises.push(imageStyle.ready());
    }
    const fillStyle = style.getFill();
    if (fillStyle && fillStyle.loading()) loadingPromises.push(fillStyle.ready());
    const loading = loadingPromises.length > 0;
    if (loading) Promise.all(loadingPromises).then(()=>listener(null));
    $4b9ac454600c05d2$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index);
    return loading;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../style/Style.js").default} style Style.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
 * @param {boolean} [declutter] Enable decluttering.
 * @param {number} [index] Render order index..
 */ function $4b9ac454600c05d2$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index) {
    const geometry = style.getGeometryFunction()(feature);
    if (!geometry) return;
    const simplifiedGeometry = geometry.simplifyTransformed(squaredTolerance, transform);
    const renderer = style.getRenderer();
    if (renderer) $4b9ac454600c05d2$var$renderGeometry(replayGroup, simplifiedGeometry, style, feature, index);
    else {
        const geometryRenderer = $4b9ac454600c05d2$var$GEOMETRY_RENDERERS[simplifiedGeometry.getType()];
        geometryRenderer(replayGroup, simplifiedGeometry, style, feature, index, declutter);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/Geometry.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderGeometry(replayGroup, geometry, style, feature, index) {
    if (geometry.getType() == 'GeometryCollection') {
        const geometries = /** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries();
        for(let i = 0, ii = geometries.length; i < ii; ++i)$4b9ac454600c05d2$var$renderGeometry(replayGroup, geometries[i], style, feature, index);
        return;
    }
    const replay = replayGroup.getBuilder(style.getZIndex(), 'Default');
    replay.drawCustom(/** @type {import("../geom/SimpleGeometry.js").default} */ geometry, feature, style.getRenderer(), style.getHitDetectionRenderer(), index);
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderGeometryCollectionGeometry(replayGroup, geometry, style, feature, declutterBuilderGroup, index) {
    const geometries = geometry.getGeometriesArray();
    let i, ii;
    for(i = 0, ii = geometries.length; i < ii; ++i){
        const geometryRenderer = $4b9ac454600c05d2$var$GEOMETRY_RENDERERS[geometries[i].getType()];
        geometryRenderer(replayGroup, geometries[i], style, feature, declutterBuilderGroup, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/LineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), 'LineString');
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiLineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderMultiLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), 'LineString');
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawMultiLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderMultiPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (strokeStyle || fillStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), 'Polygon');
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawMultiPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Point.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function $4b9ac454600c05d2$var$renderPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && imageStyle && hasText ? {} : undefined;
    if (imageStyle) {
        if (imageStyle.getImageState() != (0, $aSvtr.default).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), 'Image');
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPoint.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function $4b9ac454600c05d2$var$renderMultiPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const hasImage = imageStyle && imageStyle.getOpacity() !== 0;
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && hasImage && hasText ? {} : undefined;
    if (hasImage) {
        if (imageStyle.getImageState() != (0, $aSvtr.default).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), 'Image');
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawMultiPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Polygon.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), 'Polygon');
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}

});



parcelRegister("l7VLp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6170f1a08d72585$export$2e2bcd8739ae039);
/**
 * @module ol/geom/Circle
 */ 
var $9pD6L = parcelRequire("9pD6L");

var $h7zsK = parcelRequire("h7zsK");

var $9bJty = parcelRequire("9bJty");

var $1MAUi = parcelRequire("1MAUi");
/**
 * @classdesc
 * Circle geometry.
 *
 * @api
 */ class $f6170f1a08d72585$var$Circle extends (0, $h7zsK.default) {
    /**
   * @param {!import("../coordinate.js").Coordinate} center Center.
   *     For internal use, flat coordinates in combination with `layout` and no
   *     `radius` are also accepted.
   * @param {number} [radius] Radius in units of the projection.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(center, radius, layout){
        super();
        if (layout !== undefined && radius === undefined) this.setFlatCoordinates(layout, center);
        else {
            radius = radius ? radius : 0;
            this.setCenterAndRadius(center, radius, layout);
        }
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Circle} Clone.
   * @api
   * @override
   */ clone() {
        const circle = new $f6170f1a08d72585$var$Circle(this.flatCoordinates.slice(), undefined, this.layout);
        circle.applyProperties(this);
        return circle;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const dx = x - flatCoordinates[0];
        const dy = y - flatCoordinates[1];
        const squaredDistance = dx * dx + dy * dy;
        if (squaredDistance < minSquaredDistance) {
            if (squaredDistance === 0) for(let i = 0; i < this.stride; ++i)closestPoint[i] = flatCoordinates[i];
            else {
                const delta = this.getRadius() / Math.sqrt(squaredDistance);
                closestPoint[0] = flatCoordinates[0] + delta * dx;
                closestPoint[1] = flatCoordinates[1] + delta * dy;
                for(let i = 2; i < this.stride; ++i)closestPoint[i] = flatCoordinates[i];
            }
            closestPoint.length = this.stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        const flatCoordinates = this.flatCoordinates;
        const dx = x - flatCoordinates[0];
        const dy = y - flatCoordinates[1];
        return dx * dx + dy * dy <= this.getRadiusSquared_();
    }
    /**
   * Return the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @return {import("../coordinate.js").Coordinate} Center.
   * @api
   */ getCenter() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const radius = flatCoordinates[this.stride] - flatCoordinates[0];
        return (0, $9pD6L.createOrUpdate)(flatCoordinates[0] - radius, flatCoordinates[1] - radius, flatCoordinates[0] + radius, flatCoordinates[1] + radius, extent);
    }
    /**
   * Return the radius of the circle.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return Math.sqrt(this.getRadiusSquared_());
    }
    /**
   * @private
   * @return {number} Radius squared.
   */ getRadiusSquared_() {
        const dx = this.flatCoordinates[this.stride] - this.flatCoordinates[0];
        const dy = this.flatCoordinates[this.stride + 1] - this.flatCoordinates[1];
        return dx * dx + dy * dy;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Circle';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const circleExtent = this.getExtent();
        if ((0, $9pD6L.intersects)(extent, circleExtent)) {
            const center = this.getCenter();
            if (extent[0] <= center[0] && extent[2] >= center[0]) return true;
            if (extent[1] <= center[1] && extent[3] >= center[1]) return true;
            return (0, $9pD6L.forEachCorner)(extent, this.intersectsCoordinate.bind(this));
        }
        return false;
    }
    /**
   * Set the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} center Center.
   * @api
   */ setCenter(center) {
        const stride = this.stride;
        const radius = this.flatCoordinates[stride] - this.flatCoordinates[0];
        const flatCoordinates = center.slice();
        flatCoordinates[stride] = flatCoordinates[0] + radius;
        for(let i = 1; i < stride; ++i)flatCoordinates[stride + i] = center[i];
        this.setFlatCoordinates(this.layout, flatCoordinates);
        this.changed();
    }
    /**
   * Set the center (as {@link module:ol/coordinate~Coordinate coordinate}) and the radius (as
   * number) of the circle.
   * @param {!import("../coordinate.js").Coordinate} center Center.
   * @param {number} radius Radius.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCenterAndRadius(center, radius, layout) {
        this.setLayout(layout, center, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        /** @type {Array<number>} */ const flatCoordinates = this.flatCoordinates;
        let offset = (0, $9bJty.deflateCoordinate)(flatCoordinates, 0, center, this.stride);
        flatCoordinates[offset++] = flatCoordinates[0] + radius;
        for(let i = 1, ii = this.stride; i < ii; ++i)flatCoordinates[offset++] = flatCoordinates[i];
        flatCoordinates.length = offset;
        this.changed();
    }
    /**
   * @override
   */ getCoordinates() {
        return null;
    }
    /**
   * @override
   */ setCoordinates(coordinates, layout) {}
    /**
   * Set the radius of the circle. The radius is in the units of the projection.
   * @param {number} radius Radius.
   * @api
   */ setRadius(radius) {
        this.flatCoordinates[this.stride] = this.flatCoordinates[0] + radius;
        this.changed();
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const center = this.getCenter();
        const stride = this.getStride();
        this.setCenter((0, $1MAUi.rotate)(center, 0, center.length, stride, angle, anchor, center));
        this.changed();
    }
}
/**
 * Transform each coordinate of the circle from one coordinate reference system
 * to another. The geometry is modified in place.
 * If you do not want the geometry modified in place, first clone() it and
 * then use this function on the clone.
 *
 * Internally a circle is currently represented by two points: the center of
 * the circle `[cx, cy]`, and the point to the right of the circle
 * `[cx + r, cy]`. This `transform` function just transforms these two points.
 * So the resulting geometry is also a circle, and that circle does not
 * correspond to the shape that would be obtained by transforming every point
 * of the original circle.
 *
 * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @return {Circle} This geometry.  Note that original geometry is
 *     modified in place.
 * @function
 * @api
 */ $f6170f1a08d72585$var$Circle.prototype.transform;
var $f6170f1a08d72585$export$2e2bcd8739ae039 = $f6170f1a08d72585$var$Circle;

});

parcelRegister("kAvwT", function(module, exports) {

$parcel$export(module.exports, "pi", () => $efcfa08a35aad322$export$18c7bea995a110f);
$parcel$export(module.exports, "abs", () => $efcfa08a35aad322$export$2335f513bbd82c6d);
$parcel$export(module.exports, "cos", () => $efcfa08a35aad322$export$50d414a77b60d802);
$parcel$export(module.exports, "sin", () => $efcfa08a35aad322$export$5de3937cb4b592ed);
$parcel$export(module.exports, "round", () => $efcfa08a35aad322$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $efcfa08a35aad322$export$a3fe094919f356fd);
$parcel$export(module.exports, "log", () => $efcfa08a35aad322$export$bef1f36f5486a6a3);
$parcel$export(module.exports, "pow", () => $efcfa08a35aad322$export$9c297f60e22e3389);
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */ 
var $abFWd = parcelRequire("abFWd");

var $jPu3R = parcelRequire("jPu3R");
var $9CLAB = parcelRequire("9CLAB");
var $3SvYq = parcelRequire("3SvYq");
var $g8Ji1 = parcelRequire("g8Ji1");
var $hHwiU = parcelRequire("hHwiU");
var $2ZacS = parcelRequire("2ZacS");
var $4snD5 = parcelRequire("4snD5");
var $4aGuX = parcelRequire("4aGuX");
var $jWAkx = parcelRequire("jWAkx");
var $j1g72 = parcelRequire("j1g72");
var $bhAyB = parcelRequire("bhAyB");
var $55tlG = parcelRequire("55tlG");
var $gZeft = parcelRequire("gZeft");
var $1yWBt = parcelRequire("1yWBt");
var $aFf6p = parcelRequire("aFf6p");
var $ia9EJ = parcelRequire("ia9EJ");
var $cTBWT = parcelRequire("cTBWT");
var $8EWrX = parcelRequire("8EWrX");
var $bbddX = parcelRequire("bbddX");
var $15OuE = parcelRequire("15OuE");
var $5S20K = parcelRequire("5S20K");
var $ITdLZ = parcelRequire("ITdLZ");
var $56hXf = parcelRequire("56hXf");
var $jNK3n = parcelRequire("jNK3n");
var $1CMBB = parcelRequire("1CMBB");
var $j3IMX = parcelRequire("j3IMX");
var $5Rpez = parcelRequire("5Rpez");
var $69jKF = parcelRequire("69jKF");
var $llr5W = parcelRequire("llr5W");
var $cTfT6 = parcelRequire("cTfT6");
var $aEgNP = parcelRequire("aEgNP");
var $6M43M = parcelRequire("6M43M");
var $bZorp = parcelRequire("bZorp");
var $dPWNw = parcelRequire("dPWNw");
var $fqPNj = parcelRequire("fqPNj");
var $ikYTC = parcelRequire("ikYTC");
var $lq51c = parcelRequire("lq51c");
var $i65lC = parcelRequire("i65lC");
var $cZxdP = parcelRequire("cZxdP");
var $iytB4 = parcelRequire("iytB4");
var $aQab8 = parcelRequire("aQab8");
var $9go81 = parcelRequire("9go81");
var $dm79W = parcelRequire("dm79W");
var $AGy3Q = parcelRequire("AGy3Q");
var $gOUuL = parcelRequire("gOUuL");
var $6WgOo = parcelRequire("6WgOo");
var $9Hj4h = parcelRequire("9Hj4h");
var $7GLTI = parcelRequire("7GLTI");
var $jHfjA = parcelRequire("jHfjA");
var $abvhy = parcelRequire("abvhy");
var $hCsVF = parcelRequire("hCsVF");
var $lEGQX = parcelRequire("lEGQX");
var $2vKgl = parcelRequire("2vKgl");
var $5ZypV = parcelRequire("5ZypV");
var $cwL5l = parcelRequire("cwL5l");
var $80OuO = parcelRequire("80OuO");
var $evEiW = parcelRequire("evEiW");
var $20nO0 = parcelRequire("20nO0");
var $d6VMl = parcelRequire("d6VMl");
var $m5mef = parcelRequire("m5mef");
var $egJXN = parcelRequire("egJXN");
var $g8GEJ = parcelRequire("g8GEJ");
var $3DWZO = parcelRequire("3DWZO");
var $2y6AI = parcelRequire("2y6AI");
var $iTHHP = parcelRequire("iTHHP");
var $5jhpz = parcelRequire("5jhpz");
var $b9Fwh = parcelRequire("b9Fwh");
var $9KPav = parcelRequire("9KPav");
var $laeVF = parcelRequire("laeVF");
var $eQPyM = parcelRequire("eQPyM");
var $52vmX = parcelRequire("52vmX");
var $cuTl9 = parcelRequire("cuTl9");
var $lv59z = parcelRequire("lv59z");
var $30GbH = parcelRequire("30GbH");
var $gYCvX = parcelRequire("gYCvX");
var $fx5Am = parcelRequire("fx5Am");
var $lTpfe = parcelRequire("lTpfe");
var $7ptwt = parcelRequire("7ptwt");
var $DY4K7 = parcelRequire("DY4K7");
var $049dG = parcelRequire("049dG");
var $a5JMQ = parcelRequire("a5JMQ");
var $fAKD1 = parcelRequire("fAKD1");
var $ld1cu = parcelRequire("ld1cu");
var $3i4Xw = parcelRequire("3i4Xw");
var $ajXgF = parcelRequire("ajXgF");
var $fekL0 = parcelRequire("fekL0");
var $2QvDu = parcelRequire("2QvDu");
var $deqLg = parcelRequire("deqLg");
var $1u8WW = parcelRequire("1u8WW");
var $pU8n9 = parcelRequire("pU8n9");
var $7cnsm = parcelRequire("7cnsm");
var $ikPQi = parcelRequire("ikPQi");
var $lGDl3 = parcelRequire("lGDl3");
var $cfvpF = parcelRequire("cfvpF");
var $f0Knz = parcelRequire("f0Knz");
var $lFuZG = parcelRequire("lFuZG");
var $9miC1 = parcelRequire("9miC1");
var $cUfFC = parcelRequire("cUfFC");
var $6Fyp7 = parcelRequire("6Fyp7");
var $lyohe = parcelRequire("lyohe");
var $koapm = parcelRequire("koapm");
var $oF4VA = parcelRequire("oF4VA");
var $hqZT1 = parcelRequire("hqZT1");
var $eTWlp = parcelRequire("eTWlp");
var $dbSwX = parcelRequire("dbSwX");
var $5Cgkm = parcelRequire("5Cgkm");
var $grleJ = parcelRequire("grleJ");
var $9euwE = parcelRequire("9euwE");
var $gAq4N = parcelRequire("gAq4N");
var $4Be3K = parcelRequire("4Be3K");
var $gSK9t = parcelRequire("gSK9t");
var $5Wtra = parcelRequire("5Wtra");
var $5Q7md = parcelRequire("5Q7md");
var $5S0bI = parcelRequire("5S0bI");
var $3guGi = parcelRequire("3guGi");
var $2hOpX = parcelRequire("2hOpX");
var $6vrDt = parcelRequire("6vrDt");
var $95PTL = parcelRequire("95PTL");
var $6cHYx = parcelRequire("6cHYx");
var $b01JM = parcelRequire("b01JM");
var $flkHO = parcelRequire("flkHO");
var $itpcA = parcelRequire("itpcA");
var $ctw1A = parcelRequire("ctw1A");
var $eydoy = parcelRequire("eydoy");
var $gE9Dr = parcelRequire("gE9Dr");
var $jgcqf = parcelRequire("jgcqf");
var $2uHPV = parcelRequire("2uHPV");
var $jq3Rf = parcelRequire("jq3Rf");
var $cWSx6 = parcelRequire("cWSx6");
var $upCur = parcelRequire("upCur");
var $6d0If = parcelRequire("6d0If");
var $61kHv = parcelRequire("61kHv");
var $iL64T = parcelRequire("iL64T");
var $cyMSJ = parcelRequire("cyMSJ");
var $7ARxL = parcelRequire("7ARxL");
var $63Mc1 = parcelRequire("63Mc1");
var $h2Yyg = parcelRequire("h2Yyg");
var $dthUd = parcelRequire("dthUd");
var $5KUxv = parcelRequire("5KUxv");
var $ejjoZ = parcelRequire("ejjoZ");
var $c6uf2 = parcelRequire("c6uf2");
var $86wQA = parcelRequire("86wQA");
var $cA8qu = parcelRequire("cA8qu");
var $1VBfJ = parcelRequire("1VBfJ");
var $6MVKQ = parcelRequire("6MVKQ");
var $jA7Yu = parcelRequire("jA7Yu");
var $j4eto = parcelRequire("j4eto");
var $e2sjL = parcelRequire("e2sjL");
var $hjhCJ = parcelRequire("hjhCJ");
var $1v1Vi = parcelRequire("1v1Vi");
var $dXF1L = parcelRequire("dXF1L");
var $hALmx = parcelRequire("hALmx");
var $esLfW = parcelRequire("esLfW");
var $lR7IP = parcelRequire("lR7IP");
var $jAxTW = parcelRequire("jAxTW");
var $5TCV2 = parcelRequire("5TCV2");
var $7neEi = parcelRequire("7neEi");
var $ewJkG = parcelRequire("ewJkG");
var $dC6r9 = parcelRequire("dC6r9");
var $e9HIC = parcelRequire("e9HIC");
var $aQvJl = parcelRequire("aQvJl");
var $70UPj = parcelRequire("70UPj");
var $64EEP = parcelRequire("64EEP");
var $fEbH9 = parcelRequire("fEbH9");
var $6uMAY = parcelRequire("6uMAY");
var $bL0LQ = parcelRequire("bL0LQ");
var $fdZDy = parcelRequire("fdZDy");
var $76UYg = parcelRequire("76UYg");
var $dOu7E = parcelRequire("dOu7E");
var $bQS9i = parcelRequire("bQS9i");
var $9prS4 = parcelRequire("9prS4");
var $5eonE = parcelRequire("5eonE");
var $iGaPH = parcelRequire("iGaPH");
var $3yS4h = parcelRequire("3yS4h");
var $5rj3t = parcelRequire("5rj3t");
var $1yReL = parcelRequire("1yReL");
var $k4T9A = parcelRequire("k4T9A");
var $cYdow = parcelRequire("cYdow");
var $dvZbE = parcelRequire("dvZbE");
var $46BSz = parcelRequire("46BSz");
var $bPh4z = parcelRequire("bPh4z");
var $cJ0Yl = parcelRequire("cJ0Yl");
var $1KDoF = parcelRequire("1KDoF");
var $axDaN = parcelRequire("axDaN");
var $l9m9S = parcelRequire("l9m9S");
var $dUzaX = parcelRequire("dUzaX");
var $5h2xd = parcelRequire("5h2xd");
var $hRxKF = parcelRequire("hRxKF");
var $gBiOl = parcelRequire("gBiOl");
var $jEsS4 = parcelRequire("jEsS4");
var $aVxPF = parcelRequire("aVxPF");
var $aej5W = parcelRequire("aej5W");
var $9j3eN = parcelRequire("9j3eN");
var $l9Qc7 = parcelRequire("l9Qc7");
var $gNIfT = parcelRequire("gNIfT");
var $acZ3d = parcelRequire("acZ3d");
var $ito8c = parcelRequire("ito8c");
var $8wvrW = parcelRequire("8wvrW");
var $6bhZk = parcelRequire("6bhZk");
var $dxgXU = parcelRequire("dxgXU");
var $ioEKX = parcelRequire("ioEKX");
var $cJr7t = parcelRequire("cJr7t");
var $g9W86 = parcelRequire("g9W86");
var $3Nmmf = parcelRequire("3Nmmf");
var $cwciU = parcelRequire("cwciU");
var $l9iNl = parcelRequire("l9iNl");
var $i4vJd = parcelRequire("i4vJd");
var $OrxWM = parcelRequire("OrxWM");
var $1gF0a = parcelRequire("1gF0a");
var $d54fn = parcelRequire("d54fn");
var $6V7sZ = parcelRequire("6V7sZ");
var $hzajK = parcelRequire("hzajK");
var $2qrbI = parcelRequire("2qrbI");
var $itxOD = parcelRequire("itxOD");
var $jDUs5 = parcelRequire("jDUs5");
var $g06cf = parcelRequire("g06cf");
var $5t5dw = parcelRequire("5t5dw");
var $3vNp3 = parcelRequire("3vNp3");
var $0192i = parcelRequire("0192i");
var $hUTLZ = parcelRequire("hUTLZ");
var $iskkf = parcelRequire("iskkf");
var $xK9o8 = parcelRequire("xK9o8");
var $6Hcsa = parcelRequire("6Hcsa");
var $gFmi9 = parcelRequire("gFmi9");
var $jy02X = parcelRequire("jy02X");
var $1Yj4a = parcelRequire("1Yj4a");
var $e0BUK = parcelRequire("e0BUK");
var $8YyM3 = parcelRequire("8YyM3");
var $f7FJr = parcelRequire("f7FJr");
var $i9Uex = parcelRequire("i9Uex");
var $dr4WD = parcelRequire("dr4WD");
var $2M1iS = parcelRequire("2M1iS");
var $gCCMo = parcelRequire("gCCMo");
var $aW39D = parcelRequire("aW39D");
var $e2ZuL = parcelRequire("e2ZuL");
var $1qcgB = parcelRequire("1qcgB");
var $3XggM = parcelRequire("3XggM");
var $81RTn = parcelRequire("81RTn");
var $7gJ0l = parcelRequire("7gJ0l");
var $efcfa08a35aad322$export$d97aa349ed20696 = /* #__PURE__ */ (0, $56hXf.createBigNumberClass)({
    config: $abFWd.config
});
var $efcfa08a35aad322$export$50ceb3fb9926e63e = /* #__PURE__ */ (0, $aQab8.createComplexClass)({});
var $efcfa08a35aad322$export$f1e1789686576879 = /* #__PURE__ */ (0, $eQPyM.createE)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$f650004d56f90c2a = /* #__PURE__ */ (0, $eQPyM.createFalse)({});
var $efcfa08a35aad322$export$5c15dd8d2782cbd0 = /* #__PURE__ */ (0, $bbddX.createFineStructure)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$b336c2702c498be5 = /* #__PURE__ */ (0, $1u8WW.createFractionClass)({});
var $efcfa08a35aad322$export$23f2a1d2818174ef = /* #__PURE__ */ (0, $eQPyM.createI)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e
});
var $efcfa08a35aad322$export$20607595d292e7d3 = /* #__PURE__ */ (0, $eQPyM.createInfinity)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$c44341d65988fdd6 = /* #__PURE__ */ (0, $eQPyM.createLN10)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$5ed2c057bd191c66 = /* #__PURE__ */ (0, $eQPyM.createLOG10E)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$5b12bf1653c0dd85 = /* #__PURE__ */ (0, $iL64T.createMatrixClass)({});
var $efcfa08a35aad322$export$14edd9ca775dcd61 = /* #__PURE__ */ (0, $eQPyM.createNaN)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$a2cbb38cda512d16 = /* #__PURE__ */ (0, $eQPyM.createNull)({});
var $efcfa08a35aad322$export$324943737027944a = /* #__PURE__ */ (0, $eQPyM.createPhi)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$9a58ef0d7ad3278c = /* #__PURE__ */ (0, $dOu7E.createRangeClass)({});
var $efcfa08a35aad322$export$aebd5179ff543a90 = /* #__PURE__ */ (0, $3yS4h.createResultSet)({});
var $efcfa08a35aad322$export$83247d8be11c091e = /* #__PURE__ */ (0, $eQPyM.createSQRT1_2)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$a7100dcd4c5af6d4 = /* #__PURE__ */ (0, $bbddX.createSackurTetrode)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$a4b4b4d4d776fe92 = /* #__PURE__ */ (0, $eQPyM.createTau)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$93f71dfe5e50cd3e = /* #__PURE__ */ (0, $eQPyM.createTrue)({});
var $efcfa08a35aad322$export$83d89fbfd8236492 = /* #__PURE__ */ (0, $eQPyM.createVersion)({});
var $efcfa08a35aad322$export$97f0d27b48f120e8 = /* #__PURE__ */ (0, $d6VMl.createDenseMatrixClass)({
    Matrix: $efcfa08a35aad322$export$5b12bf1653c0dd85
});
var $efcfa08a35aad322$export$9ea6550edaaee998 = /* #__PURE__ */ (0, $bbddX.createEfimovFactor)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$578b45ddcdefa518 = /* #__PURE__ */ (0, $eQPyM.createLN2)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$18c7bea995a110f = /* #__PURE__ */ (0, $eQPyM.createPi)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$b644b65666fe0c18 = /* #__PURE__ */ (0, $9prS4.createReplacer)({});
var $efcfa08a35aad322$export$3681641e15b6e2c3 = /* #__PURE__ */ (0, $eQPyM.createSQRT2)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$519f616c41a1c711 = /* #__PURE__ */ (0, $jy02X.createTyped)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    Fraction: $efcfa08a35aad322$export$b336c2702c498be5
});
var $efcfa08a35aad322$export$857d2e3e2bc524d0 = /* #__PURE__ */ (0, $bbddX.createWeakMixingAngle)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$2335f513bbd82c6d = /* #__PURE__ */ (0, $jPu3R.createAbs)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$fd6306be3fde5b04 = /* #__PURE__ */ (0, $9CLAB.createAcos)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    config: $abFWd.config,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$4919a578c4aafd3 = /* #__PURE__ */ (0, $g8Ji1.createAcot)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$43298db932064b4a = /* #__PURE__ */ (0, $2ZacS.createAcsc)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    config: $abFWd.config,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$2b7b095c4f443355 = /* #__PURE__ */ (0, $jWAkx.createAddScalar)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$d8da458ed75e15b = /* #__PURE__ */ (0, $bhAyB.createArg)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$3aaf4e522be48075 = /* #__PURE__ */ (0, $gZeft.createAsech)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    config: $abFWd.config,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$839d8a01b6af4fc0 = /* #__PURE__ */ (0, $aFf6p.createAsinh)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$628dc4eed22b0fbd = /* #__PURE__ */ (0, $ia9EJ.createAtan)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$21ea955025ceb08b = /* #__PURE__ */ (0, $8EWrX.createAtanh)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    config: $abFWd.config,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$a0f65b52274bcc00 = /* #__PURE__ */ (0, $5S20K.createBigint)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$aabc449fa5b5f4c0 = /* #__PURE__ */ (0, $j3IMX.createBitNot)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$4a21f16c33752377 = /* #__PURE__ */ (0, $llr5W.createBoolean)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$9cd59f9826255e47 = /* #__PURE__ */ (0, $bZorp.createClone)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$bdfcf4c6b5766439 = /* #__PURE__ */ (0, $fqPNj.createCombinations)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$83a0e34f1302825b = /* #__PURE__ */ (0, $iytB4.createComplex)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$fb254c661fe9c0db = /* #__PURE__ */ (0, $AGy3Q.createConj)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$50d414a77b60d802 = /* #__PURE__ */ (0, $6WgOo.createCos)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$ef569ec50496610c = /* #__PURE__ */ (0, $7GLTI.createCot)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$a830b5ed334924be = /* #__PURE__ */ (0, $2vKgl.createCsc)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$2b0340f6c7dec49a = /* #__PURE__ */ (0, $80OuO.createCube)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$943761f5c9c3f156 = /* #__PURE__ */ (0, $lv59z.createEqualScalar)({
    config: $abFWd.config,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$d3896f355fc09423 = /* #__PURE__ */ (0, $gYCvX.createErf)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$b310ec824aaee37f = /* #__PURE__ */ (0, $fx5Am.createExp)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$b6c0a80d46d3391d = /* #__PURE__ */ (0, $7ptwt.createExpm1)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$3dea766d36a8935f = /* #__PURE__ */ (0, $fAKD1.createFilter)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$bffa455ba8c619a6 = /* #__PURE__ */ (0, $3i4Xw.createFlatten)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$4b80e395e36b5a56 = /* #__PURE__ */ (0, $fekL0.createForEach)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$d9468344d3651243 = /* #__PURE__ */ (0, $2QvDu.createFormat)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$42c7d1d712906e32 = /* #__PURE__ */ (0, $lGDl3.createGetMatrixDataType)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$834dfc94dde4b3d8 = /* #__PURE__ */ (0, $f0Knz.createHex)({
    format: $efcfa08a35aad322$export$d9468344d3651243,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$5fc500b917996661 = /* #__PURE__ */ (0, $6Fyp7.createIm)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$a287f47fed4544b8 = /* #__PURE__ */ (0, $5Cgkm.createIsInteger)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$d0909a4f38b5c4d0 = /* #__PURE__ */ (0, $9euwE.createIsNegative)({
    config: $abFWd.config,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$7e69d4236fcc3b19 = /* #__PURE__ */ (0, $4Be3K.createIsPositive)({
    config: $abFWd.config,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$c46ec7d82fb1f602 = /* #__PURE__ */ (0, $5Wtra.createIsZero)({
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$8c2c65adacba8d14 = /* #__PURE__ */ (0, $eQPyM.createLOG2E)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$3daae2744d8ce460 = /* #__PURE__ */ (0, $6cHYx.createLgamma)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$75e08744a3ff8516 = /* #__PURE__ */ (0, $flkHO.createLog10)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    config: $abFWd.config,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$b9fae0bba9d9094d = /* #__PURE__ */ (0, $ctw1A.createLog2)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    config: $abFWd.config,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$871de8747c9eaa88 = /* #__PURE__ */ (0, $upCur.createMap)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$c697bed75648cdb7 = /* #__PURE__ */ (0, $6MVKQ.createMultiplyScalar)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$6003a5f097c73977 = /* #__PURE__ */ (0, $j4eto.createNot)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$98e628dec113755e = /* #__PURE__ */ (0, $dXF1L.createNumber)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$8d9f5ae1af806929 = /* #__PURE__ */ (0, $esLfW.createOct)({
    format: $efcfa08a35aad322$export$d9468344d3651243,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$2e015b6955893291 = /* #__PURE__ */ (0, $ewJkG.createPickRandom)({
    config: $abFWd.config,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$c2d084dc44961371 = /* #__PURE__ */ (0, $70UPj.createPrint)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$4385e60b38654f68 = /* #__PURE__ */ (0, $bL0LQ.createRandom)({
    config: $abFWd.config,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$b1f1627d659a651 = /* #__PURE__ */ (0, $bQS9i.createRe)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$e17a63917e2ebf0f = /* #__PURE__ */ (0, $cJ0Yl.createSec)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$c5552dfdbc7cec71 = /* #__PURE__ */ (0, $l9Qc7.createSign)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Fraction: $efcfa08a35aad322$export$b336c2702c498be5,
    complex: $efcfa08a35aad322$export$83a0e34f1302825b,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$5de3937cb4b592ed = /* #__PURE__ */ (0, $gNIfT.createSin)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$de9b2b7556879848 = /* #__PURE__ */ (0, $cwciU.createSparseMatrixClass)({
    Matrix: $efcfa08a35aad322$export$5b12bf1653c0dd85,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$dd67294014106b35 = /* #__PURE__ */ (0, $l9iNl.createSplitUnit)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$dd4f28cef696bc7d = /* #__PURE__ */ (0, $1gF0a.createSquare)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$22b082955e083ec3 = /* #__PURE__ */ (0, $2qrbI.createString)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$fdebd7f5d4c6e658 = /* #__PURE__ */ (0, $g06cf.createSubtractScalar)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$fcdd3b0b3246a325 = /* #__PURE__ */ (0, $0192i.createTan)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$7582d07c9009e223 = /* #__PURE__ */ (0, $xK9o8.createToBest)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$f5bbd400c2f4426f = /* #__PURE__ */ (0, $1Yj4a.createTypeOf)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$b26caf0f29211d08 = /* #__PURE__ */ (0, $3SvYq.createAcosh)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    config: $abFWd.config,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$eafdb403a25900df = /* #__PURE__ */ (0, $4snD5.createAcsch)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$ec42f46098b24bb4 = /* #__PURE__ */ (0, $55tlG.createAsec)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    config: $abFWd.config,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$8576f72eb7f14a7e = /* #__PURE__ */ (0, $ITdLZ.createBignumber)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$f297162cf5d656b2 = /* #__PURE__ */ (0, $ikYTC.createCombinationsWithRep)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$2e2fd1ad24e4d350 = /* #__PURE__ */ (0, $9Hj4h.createCosh)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$ca7427e8bf42a21b = /* #__PURE__ */ (0, $5ZypV.createCsch)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$c9f5652083b8129d = /* #__PURE__ */ (0, $grleJ.createIsNaN)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$8676dd5fabd5ee34 = /* #__PURE__ */ (0, $gSK9t.createIsPrime)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$68ed7ff4ab083a8b = /* #__PURE__ */ (0, $6d0If.createMapSlices)({
    isInteger: $efcfa08a35aad322$export$a287f47fed4544b8,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$5635d7ef4b8fee1c = $efcfa08a35aad322$export$68ed7ff4ab083a8b;
var $efcfa08a35aad322$export$9bdad1ae37d738e0 = /* #__PURE__ */ (0, $61kHv.createMatrix)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    Matrix: $efcfa08a35aad322$export$5b12bf1653c0dd85,
    SparseMatrix: $efcfa08a35aad322$export$de9b2b7556879848,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$7860df605315d572 = /* #__PURE__ */ (0, $7ARxL.createMatrixFromFunction)({
    isZero: $efcfa08a35aad322$export$c46ec7d82fb1f602,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$21041dee6b8001b0 = /* #__PURE__ */ (0, $lR7IP.createOnes)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$3c5f89dae98e900b = /* #__PURE__ */ (0, $fdZDy.createRandomInt)({
    config: $abFWd.config,
    log2: $efcfa08a35aad322$export$b9fae0bba9d9094d,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$9eaad88cf88cee2b = /* #__PURE__ */ (0, $5eonE.createReshape)({
    isInteger: $efcfa08a35aad322$export$a287f47fed4544b8,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$becbc39f348ea65e = /* #__PURE__ */ (0, $1KDoF.createSech)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$545004b505d7c555 = /* #__PURE__ */ (0, $acZ3d.createSinh)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$b6b7e189aa5d134c = /* #__PURE__ */ (0, $3Nmmf.createSparse)({
    SparseMatrix: $efcfa08a35aad322$export$de9b2b7556879848,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$eba8049fb5020b81 = /* #__PURE__ */ (0, $i4vJd.createSqrt)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    config: $abFWd.config,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$889c931173b77c2f = /* #__PURE__ */ (0, $d54fn.createSqueeze)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$7128670e45beef9a = /* #__PURE__ */ (0, $hUTLZ.createTanh)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$9cb09a71b7d66923 = /* #__PURE__ */ (0, $gFmi9.createTranspose)({
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$6ba103b0465fe6cc = /* #__PURE__ */ (0, $e2ZuL.createXgcd)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$4445a00dafa2633b = /* #__PURE__ */ (0, $3XggM.createZeros)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    config: $abFWd.config,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$6faaac9ab79fd3a4 = /* #__PURE__ */ (0, $hHwiU.createAcoth)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    config: $abFWd.config,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$41726bdb1fc63f = /* #__PURE__ */ (0, $1yWBt.createAsin)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    config: $abFWd.config,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$f03e751d9cddb7a = /* #__PURE__ */ (0, $jNK3n.createBin)({
    format: $efcfa08a35aad322$export$d9468344d3651243,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$ee1b3e54f0441b22 = /* #__PURE__ */ (0, $dm79W.createConcat)({
    isInteger: $efcfa08a35aad322$export$a287f47fed4544b8,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$fe7b8a3b046ac25b = /* #__PURE__ */ (0, $jHfjA.createCoth)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$eb6ad7870b1d0b0b = /* #__PURE__ */ (0, $cwL5l.createCtranspose)({
    conj: $efcfa08a35aad322$export$fb254c661fe9c0db,
    transpose: $efcfa08a35aad322$export$9cb09a71b7d66923,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$c042e7c2f59bc046 = /* #__PURE__ */ (0, $egJXN.createDiag)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    SparseMatrix: $efcfa08a35aad322$export$de9b2b7556879848,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$c6d93afbf4ee8afc = /* #__PURE__ */ (0, $9KPav.createDotMultiply)({
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$411ce8e5a71e3069 = /* #__PURE__ */ (0, $cuTl9.createEqual)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    SparseMatrix: $efcfa08a35aad322$export$de9b2b7556879848,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$7f34ce79760854f7 = /* #__PURE__ */ (0, $deqLg.createFraction)({
    Fraction: $efcfa08a35aad322$export$b336c2702c498be5,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$f0954fd7d5368655 = /* #__PURE__ */ (0, $9miC1.createIdentity)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    SparseMatrix: $efcfa08a35aad322$export$de9b2b7556879848,
    config: $abFWd.config,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$e90fb89750dba83f = /* #__PURE__ */ (0, $gAq4N.createIsNumeric)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$44f32dfde3d58545 = /* #__PURE__ */ (0, $5S0bI.createKron)({
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$72693dfc692346df = /* #__PURE__ */ (0, $2hOpX.createLargerEq)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    SparseMatrix: $efcfa08a35aad322$export$de9b2b7556879848,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    config: $abFWd.config,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$48901d58d322262f = /* #__PURE__ */ (0, $95PTL.createLeftShift)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    zeros: $efcfa08a35aad322$export$4445a00dafa2633b
});
var $efcfa08a35aad322$export$549ff81930776885 = /* #__PURE__ */ (0, $86wQA.createMode)({
    isNaN: $efcfa08a35aad322$export$c9f5652083b8129d,
    isNumeric: $efcfa08a35aad322$export$e90fb89750dba83f,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$cc5da69d359d7991 = /* #__PURE__ */ (0, $e2sjL.createNthRoot)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$b7a508fa8dae59fc = /* #__PURE__ */ (0, $hALmx.createNumeric)({
    bignumber: $efcfa08a35aad322$export$8576f72eb7f14a7e,
    fraction: $efcfa08a35aad322$export$7f34ce79760854f7,
    number: $efcfa08a35aad322$export$98e628dec113755e
});
var $efcfa08a35aad322$export$5e143010dea16c85 = /* #__PURE__ */ (0, $64EEP.createProd)({
    config: $abFWd.config,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    numeric: $efcfa08a35aad322$export$b7a508fa8dae59fc,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$4380c87abf28fdf = /* #__PURE__ */ (0, $iGaPH.createResize)({
    config: $abFWd.config,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0
});
var $efcfa08a35aad322$export$a1da16976d3a5f68 = /* #__PURE__ */ (0, $5rj3t.createRightArithShift)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    zeros: $efcfa08a35aad322$export$4445a00dafa2633b
});
var $efcfa08a35aad322$export$2077e0241d6afd3c = /* #__PURE__ */ (0, $dvZbE.createRound)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    config: $abFWd.config,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    zeros: $efcfa08a35aad322$export$4445a00dafa2633b
});
var $efcfa08a35aad322$export$346677f925de839c = /* #__PURE__ */ (0, $ito8c.createSize)({
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    config: $abFWd.config,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$3f732695c1493aec = /* #__PURE__ */ (0, $6bhZk.createSmaller)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    SparseMatrix: $efcfa08a35aad322$export$de9b2b7556879848,
    bignumber: $efcfa08a35aad322$export$8576f72eb7f14a7e,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    config: $abFWd.config,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$2c618a4308a30424 = /* #__PURE__ */ (0, $iskkf.createTo)({
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$6cd304851a69e08 = /* #__PURE__ */ (0, $e0BUK.createUnaryMinus)({
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$b20c1c5fa0c7dd75 = /* #__PURE__ */ (0, $f7FJr.createUnequal)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    SparseMatrix: $efcfa08a35aad322$export$de9b2b7556879848,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    config: $abFWd.config,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$6444ef5cd411280c = /* #__PURE__ */ (0, $1qcgB.createXor)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    SparseMatrix: $efcfa08a35aad322$export$de9b2b7556879848,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$e16d8520af44a096 = /* #__PURE__ */ (0, $4aGuX.createAdd)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    SparseMatrix: $efcfa08a35aad322$export$de9b2b7556879848,
    addScalar: $efcfa08a35aad322$export$2b7b095c4f443355,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$b8b770ee6a0d9760 = /* #__PURE__ */ (0, $cTBWT.createAtan2)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$a74ff8d3fdef72fc = /* #__PURE__ */ (0, $1CMBB.createBitAnd)({
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$361eb278cc70bacf = /* #__PURE__ */ (0, $5Rpez.createBitOr)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$bfcff4501301c191 = /* #__PURE__ */ (0, $69jKF.createBitXor)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    SparseMatrix: $efcfa08a35aad322$export$de9b2b7556879848,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$841fc4d5a1480b85 = /* #__PURE__ */ (0, $aEgNP.createCbrt)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    Fraction: $efcfa08a35aad322$export$b336c2702c498be5,
    config: $abFWd.config,
    isNegative: $efcfa08a35aad322$export$d0909a4f38b5c4d0,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    unaryMinus: $efcfa08a35aad322$export$6cd304851a69e08
});
var $efcfa08a35aad322$export$398604a469f7de9a = /* #__PURE__ */ (0, $lq51c.createCompare)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    Fraction: $efcfa08a35aad322$export$b336c2702c498be5,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    config: $abFWd.config,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$2da9287da10b19e2 = /* #__PURE__ */ (0, $cZxdP.createCompareText)({
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$85b9a36db797e02b = /* #__PURE__ */ (0, $abvhy.createCount)({
    prod: $efcfa08a35aad322$export$5e143010dea16c85,
    size: $efcfa08a35aad322$export$346677f925de839c,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$9cb4719e2e525b7a = /* #__PURE__ */ (0, $20nO0.createDeepEqual)({
    equal: $efcfa08a35aad322$export$411ce8e5a71e3069,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$67275f837d70084d = /* #__PURE__ */ (0, $iTHHP.createDivideScalar)({
    numeric: $efcfa08a35aad322$export$b7a508fa8dae59fc,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$c74f132961c51406 = /* #__PURE__ */ (0, $b9Fwh.createDotDivide)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    SparseMatrix: $efcfa08a35aad322$export$de9b2b7556879848,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$5bc21f656fb5d284 = /* #__PURE__ */ (0, $30GbH.createEqualText)({
    compareText: $efcfa08a35aad322$export$2da9287da10b19e2,
    isZero: $efcfa08a35aad322$export$c46ec7d82fb1f602,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$a3fe094919f356fd = /* #__PURE__ */ (0, $ajXgF.createFloor)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    config: $abFWd.config,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    round: $efcfa08a35aad322$export$2077e0241d6afd3c,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    zeros: $efcfa08a35aad322$export$4445a00dafa2633b
});
var $efcfa08a35aad322$export$f81847884871263e = /* #__PURE__ */ (0, $ikPQi.createGcd)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    config: $abFWd.config,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    round: $efcfa08a35aad322$export$2077e0241d6afd3c,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    zeros: $efcfa08a35aad322$export$4445a00dafa2633b
});
var $efcfa08a35aad322$export$f6fc628e09f3ff5d = /* #__PURE__ */ (0, $cfvpF.createHasNumericValue)({
    isNumeric: $efcfa08a35aad322$export$e90fb89750dba83f,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$f95c7888b62f8e9a = /* #__PURE__ */ (0, $lFuZG.createHypot)({
    abs: $efcfa08a35aad322$export$2335f513bbd82c6d,
    addScalar: $efcfa08a35aad322$export$2b7b095c4f443355,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    isPositive: $efcfa08a35aad322$export$7e69d4236fcc3b19,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    smaller: $efcfa08a35aad322$export$3f732695c1493aec,
    sqrt: $efcfa08a35aad322$export$eba8049fb5020b81,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$66fe727d7ec8c7b9 = /* #__PURE__ */ (0, $lyohe.createImmutableDenseMatrixClass)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    smaller: $efcfa08a35aad322$export$3f732695c1493aec
});
var $efcfa08a35aad322$export$cf17b003b6192af3 = /* #__PURE__ */ (0, $oF4VA.createIndexClass)({
    ImmutableDenseMatrix: $efcfa08a35aad322$export$66fe727d7ec8c7b9,
    getMatrixDataType: $efcfa08a35aad322$export$42c7d1d712906e32
});
var $efcfa08a35aad322$export$a94a7414fa942aea = /* #__PURE__ */ (0, $3guGi.createLarger)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    SparseMatrix: $efcfa08a35aad322$export$de9b2b7556879848,
    bignumber: $efcfa08a35aad322$export$8576f72eb7f14a7e,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    config: $abFWd.config,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$bef1f36f5486a6a3 = /* #__PURE__ */ (0, $b01JM.createLog)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    config: $abFWd.config,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    typeOf: $efcfa08a35aad322$export$f5bbd400c2f4426f,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$be3b83cc1aa539e4 = /* #__PURE__ */ (0, $eydoy.createLsolve)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    subtractScalar: $efcfa08a35aad322$export$fdebd7f5d4c6e658,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$e8999e227859a482 = /* #__PURE__ */ (0, $cyMSJ.createMatrixFromColumns)({
    flatten: $efcfa08a35aad322$export$bffa455ba8c619a6,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    size: $efcfa08a35aad322$export$346677f925de839c,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$8960430cfd85939f = /* #__PURE__ */ (0, $h2Yyg.createMax)({
    config: $abFWd.config,
    isNaN: $efcfa08a35aad322$export$c9f5652083b8129d,
    larger: $efcfa08a35aad322$export$a94a7414fa942aea,
    numeric: $efcfa08a35aad322$export$b7a508fa8dae59fc,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$96ec731ed4dcb222 = /* #__PURE__ */ (0, $ejjoZ.createMin)({
    config: $abFWd.config,
    isNaN: $efcfa08a35aad322$export$c9f5652083b8129d,
    numeric: $efcfa08a35aad322$export$b7a508fa8dae59fc,
    smaller: $efcfa08a35aad322$export$3f732695c1493aec,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$842a2cf37af977e1 = /* #__PURE__ */ (0, $c6uf2.createMod)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    config: $abFWd.config,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    round: $efcfa08a35aad322$export$2077e0241d6afd3c,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    zeros: $efcfa08a35aad322$export$4445a00dafa2633b
});
var $efcfa08a35aad322$export$adb173527af10aca = /* #__PURE__ */ (0, $hjhCJ.createNthRoots)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    config: $abFWd.config,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$69fd1b70ebae5687 = /* #__PURE__ */ (0, $1v1Vi.createNullish)({
    deepEqual: $efcfa08a35aad322$export$9cb4719e2e525b7a,
    flatten: $efcfa08a35aad322$export$bffa455ba8c619a6,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    size: $efcfa08a35aad322$export$346677f925de839c,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$252bb8b3bbdf6749 = /* #__PURE__ */ (0, $jAxTW.createOr)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$54d1e322cf7aa273 = /* #__PURE__ */ (0, $5TCV2.createPartitionSelect)({
    compare: $efcfa08a35aad322$export$398604a469f7de9a,
    isNaN: $efcfa08a35aad322$export$c9f5652083b8129d,
    isNumeric: $efcfa08a35aad322$export$e90fb89750dba83f,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$7c27fb47516129d9 = /* #__PURE__ */ (0, $fEbH9.createQr)({
    addScalar: $efcfa08a35aad322$export$2b7b095c4f443355,
    complex: $efcfa08a35aad322$export$83a0e34f1302825b,
    conj: $efcfa08a35aad322$export$fb254c661fe9c0db,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    equal: $efcfa08a35aad322$export$411ce8e5a71e3069,
    identity: $efcfa08a35aad322$export$f0954fd7d5368655,
    isZero: $efcfa08a35aad322$export$c46ec7d82fb1f602,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    sign: $efcfa08a35aad322$export$c5552dfdbc7cec71,
    sqrt: $efcfa08a35aad322$export$eba8049fb5020b81,
    subtractScalar: $efcfa08a35aad322$export$fdebd7f5d4c6e658,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    unaryMinus: $efcfa08a35aad322$export$6cd304851a69e08,
    zeros: $efcfa08a35aad322$export$4445a00dafa2633b
});
var $efcfa08a35aad322$export$502f8a5a1147da = /* #__PURE__ */ (0, $1yReL.createRightLogShift)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    zeros: $efcfa08a35aad322$export$4445a00dafa2633b
});
var $efcfa08a35aad322$export$8d38c87f33a93d98 = /* #__PURE__ */ (0, $dxgXU.createSmallerEq)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    SparseMatrix: $efcfa08a35aad322$export$de9b2b7556879848,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    config: $abFWd.config,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$e06bd7b1ab877a71 = /* #__PURE__ */ (0, $itxOD.createSubset)({
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    zeros: $efcfa08a35aad322$export$4445a00dafa2633b
});
var $efcfa08a35aad322$export$4e2d2ead65e5f7e3 = /* #__PURE__ */ (0, $jDUs5.createSubtract)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    subtractScalar: $efcfa08a35aad322$export$fdebd7f5d4c6e658,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    unaryMinus: $efcfa08a35aad322$export$6cd304851a69e08
});
var $efcfa08a35aad322$export$357889f174732d38 = /* #__PURE__ */ (0, $6Hcsa.createTrace)({
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$41828460570e21eb = /* #__PURE__ */ (0, $2M1iS.createUsolve)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    subtractScalar: $efcfa08a35aad322$export$fdebd7f5d4c6e658,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$d8807a6c0487483a = /* #__PURE__ */ (0, $cTfT6.createCatalan)({
    addScalar: $efcfa08a35aad322$export$2b7b095c4f443355,
    combinations: $efcfa08a35aad322$export$bdfcf4c6b5766439,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    isInteger: $efcfa08a35aad322$export$a287f47fed4544b8,
    isNegative: $efcfa08a35aad322$export$d0909a4f38b5c4d0,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$762e84baec56595d = /* #__PURE__ */ (0, $i65lC.createCompareNatural)({
    compare: $efcfa08a35aad322$export$398604a469f7de9a,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$fd2cf6bce05a0b18 = /* #__PURE__ */ (0, $9go81.createComposition)({
    addScalar: $efcfa08a35aad322$export$2b7b095c4f443355,
    combinations: $efcfa08a35aad322$export$bdfcf4c6b5766439,
    isInteger: $efcfa08a35aad322$export$a287f47fed4544b8,
    isNegative: $efcfa08a35aad322$export$d0909a4f38b5c4d0,
    isPositive: $efcfa08a35aad322$export$7e69d4236fcc3b19,
    larger: $efcfa08a35aad322$export$a94a7414fa942aea,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$a37e3c603d7117e5 = /* #__PURE__ */ (0, $g8GEJ.createDiff)({
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    number: $efcfa08a35aad322$export$98e628dec113755e,
    subtract: $efcfa08a35aad322$export$4e2d2ead65e5f7e3,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$9f17032d917177de = /* #__PURE__ */ (0, $3DWZO.createDistance)({
    abs: $efcfa08a35aad322$export$2335f513bbd82c6d,
    addScalar: $efcfa08a35aad322$export$2b7b095c4f443355,
    deepEqual: $efcfa08a35aad322$export$9cb4719e2e525b7a,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    sqrt: $efcfa08a35aad322$export$eba8049fb5020b81,
    subtractScalar: $efcfa08a35aad322$export$fdebd7f5d4c6e658,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$94132a0e348806d4 = /* #__PURE__ */ (0, $5jhpz.createDot)({
    addScalar: $efcfa08a35aad322$export$2b7b095c4f443355,
    conj: $efcfa08a35aad322$export$fb254c661fe9c0db,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    size: $efcfa08a35aad322$export$346677f925de839c,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$dd5bb73729f20aa3 = /* #__PURE__ */ (0, $a5JMQ.createFibonacciHeapClass)({
    larger: $efcfa08a35aad322$export$a94a7414fa942aea,
    smaller: $efcfa08a35aad322$export$3f732695c1493aec
});
var $efcfa08a35aad322$export$b610b8812bbcded9 = /* #__PURE__ */ (0, $koapm.createIndex)({
    Index: $efcfa08a35aad322$export$cf17b003b6192af3,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$5c1ba7f73c917315 = /* #__PURE__ */ (0, $dbSwX.createInvmod)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    config: $abFWd.config,
    equal: $efcfa08a35aad322$export$411ce8e5a71e3069,
    isInteger: $efcfa08a35aad322$export$a287f47fed4544b8,
    mod: $efcfa08a35aad322$export$842a2cf37af977e1,
    smaller: $efcfa08a35aad322$export$3f732695c1493aec,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    xgcd: $efcfa08a35aad322$export$6ba103b0465fe6cc
});
var $efcfa08a35aad322$export$f686d97e407ec4ef = /* #__PURE__ */ (0, $6vrDt.createLcm)({
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$144dcf16adfb9698 = /* #__PURE__ */ (0, $itpcA.createLog1p)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    config: $abFWd.config,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    log: $efcfa08a35aad322$export$bef1f36f5486a6a3,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$de5c6af4003ef448 = /* #__PURE__ */ (0, $gE9Dr.createLsolveAll)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    subtractScalar: $efcfa08a35aad322$export$fdebd7f5d4c6e658,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$f4f4b934de52d430 = /* #__PURE__ */ (0, $63Mc1.createMatrixFromRows)({
    flatten: $efcfa08a35aad322$export$bffa455ba8c619a6,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    size: $efcfa08a35aad322$export$346677f925de839c,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$2060d2db72cce88f = /* #__PURE__ */ (0, $1VBfJ.createMultiply)({
    addScalar: $efcfa08a35aad322$export$2b7b095c4f443355,
    dot: $efcfa08a35aad322$export$94132a0e348806d4,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$d02631cccf789723 = /* #__PURE__ */ (0, $76UYg.createRange)({
    bignumber: $efcfa08a35aad322$export$8576f72eb7f14a7e,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    config: $abFWd.config,
    equal: $efcfa08a35aad322$export$411ce8e5a71e3069,
    isPositive: $efcfa08a35aad322$export$7e69d4236fcc3b19,
    isZero: $efcfa08a35aad322$export$c46ec7d82fb1f602,
    larger: $efcfa08a35aad322$export$a94a7414fa942aea,
    largerEq: $efcfa08a35aad322$export$72693dfc692346df,
    smaller: $efcfa08a35aad322$export$3f732695c1493aec,
    smallerEq: $efcfa08a35aad322$export$8d38c87f33a93d98,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$120ff0929b202a6d = /* #__PURE__ */ (0, $46BSz.createRow)({
    Index: $efcfa08a35aad322$export$cf17b003b6192af3,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    range: $efcfa08a35aad322$export$d02631cccf789723,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$dcac7a71ff10ad82 = /* #__PURE__ */ (0, $axDaN.createSetCartesian)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    Index: $efcfa08a35aad322$export$cf17b003b6192af3,
    compareNatural: $efcfa08a35aad322$export$762e84baec56595d,
    size: $efcfa08a35aad322$export$346677f925de839c,
    subset: $efcfa08a35aad322$export$e06bd7b1ab877a71,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$ec60221e756bab15 = /* #__PURE__ */ (0, $dUzaX.createSetDistinct)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    Index: $efcfa08a35aad322$export$cf17b003b6192af3,
    compareNatural: $efcfa08a35aad322$export$762e84baec56595d,
    size: $efcfa08a35aad322$export$346677f925de839c,
    subset: $efcfa08a35aad322$export$e06bd7b1ab877a71,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$ca5251f59a067f9a = /* #__PURE__ */ (0, $hRxKF.createSetIsSubset)({
    Index: $efcfa08a35aad322$export$cf17b003b6192af3,
    compareNatural: $efcfa08a35aad322$export$762e84baec56595d,
    size: $efcfa08a35aad322$export$346677f925de839c,
    subset: $efcfa08a35aad322$export$e06bd7b1ab877a71,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$f6ce4c11993e56f2 = /* #__PURE__ */ (0, $jEsS4.createSetPowerset)({
    Index: $efcfa08a35aad322$export$cf17b003b6192af3,
    compareNatural: $efcfa08a35aad322$export$762e84baec56595d,
    size: $efcfa08a35aad322$export$346677f925de839c,
    subset: $efcfa08a35aad322$export$e06bd7b1ab877a71,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$95c7459688ef4e3a = /* #__PURE__ */ (0, $8wvrW.createSlu)({
    SparseMatrix: $efcfa08a35aad322$export$de9b2b7556879848,
    abs: $efcfa08a35aad322$export$2335f513bbd82c6d,
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    larger: $efcfa08a35aad322$export$a94a7414fa942aea,
    largerEq: $efcfa08a35aad322$export$72693dfc692346df,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    subtract: $efcfa08a35aad322$export$4e2d2ead65e5f7e3,
    transpose: $efcfa08a35aad322$export$9cb09a71b7d66923,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$97db5808d8f88186 = /* #__PURE__ */ (0, $cJr7t.createSort)({
    compare: $efcfa08a35aad322$export$398604a469f7de9a,
    compareNatural: $efcfa08a35aad322$export$762e84baec56595d,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$df8c837ae5df4ce4 = /* #__PURE__ */ (0, $8YyM3.createUnaryPlus)({
    config: $abFWd.config,
    numeric: $efcfa08a35aad322$export$b7a508fa8dae59fc,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$c8a1cf0e83678d9 = /* #__PURE__ */ (0, $gCCMo.createUsolveAll)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    subtractScalar: $efcfa08a35aad322$export$fdebd7f5d4c6e658,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$e4d83a2347bfd199 = /* #__PURE__ */ (0, $7gJ0l.createZpk2tf)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    number: $efcfa08a35aad322$export$98e628dec113755e,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$21c0ac7fe1cef1b8 = /* #__PURE__ */ (0, $j1g72.createAnd)({
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    not: $efcfa08a35aad322$export$6003a5f097c73977,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    zeros: $efcfa08a35aad322$export$4445a00dafa2633b
});
var $efcfa08a35aad322$export$803ce6b71a0a94b2 = /* #__PURE__ */ (0, $6M43M.createCeil)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    config: $abFWd.config,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    round: $efcfa08a35aad322$export$2077e0241d6afd3c,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    zeros: $efcfa08a35aad322$export$4445a00dafa2633b
});
var $efcfa08a35aad322$export$4e0c71f277ca26b3 = /* #__PURE__ */ (0, $dPWNw.createColumn)({
    Index: $efcfa08a35aad322$export$cf17b003b6192af3,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    range: $efcfa08a35aad322$export$d02631cccf789723,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$bb646b20bb93d339 = /* #__PURE__ */ (0, $lEGQX.createCross)({
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    subtract: $efcfa08a35aad322$export$4e2d2ead65e5f7e3,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$d063d65fed97e7fa = /* #__PURE__ */ (0, $m5mef.createDet)({
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    isZero: $efcfa08a35aad322$export$c46ec7d82fb1f602,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    subtractScalar: $efcfa08a35aad322$export$fdebd7f5d4c6e658,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    unaryMinus: $efcfa08a35aad322$export$6cd304851a69e08
});
var $efcfa08a35aad322$export$d838837eb5b184e3 = /* #__PURE__ */ (0, $ld1cu.createFix)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    ceil: $efcfa08a35aad322$export$803ce6b71a0a94b2,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    floor: $efcfa08a35aad322$export$a3fe094919f356fd,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    zeros: $efcfa08a35aad322$export$4445a00dafa2633b
});
var $efcfa08a35aad322$export$c02accee9f2b6a8f = /* #__PURE__ */ (0, $eTWlp.createInv)({
    abs: $efcfa08a35aad322$export$2335f513bbd82c6d,
    addScalar: $efcfa08a35aad322$export$2b7b095c4f443355,
    det: $efcfa08a35aad322$export$d063d65fed97e7fa,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    identity: $efcfa08a35aad322$export$f0954fd7d5368655,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    unaryMinus: $efcfa08a35aad322$export$6cd304851a69e08
});
var $efcfa08a35aad322$export$5cde0f23b96c7c61 = /* #__PURE__ */ (0, $dC6r9.createPinv)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    ctranspose: $efcfa08a35aad322$export$eb6ad7870b1d0b0b,
    deepEqual: $efcfa08a35aad322$export$9cb4719e2e525b7a,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    dot: $efcfa08a35aad322$export$94132a0e348806d4,
    dotDivide: $efcfa08a35aad322$export$c74f132961c51406,
    equal: $efcfa08a35aad322$export$411ce8e5a71e3069,
    inv: $efcfa08a35aad322$export$c02accee9f2b6a8f,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$9c297f60e22e3389 = /* #__PURE__ */ (0, $aQvJl.createPow)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    config: $abFWd.config,
    fraction: $efcfa08a35aad322$export$7f34ce79760854f7,
    identity: $efcfa08a35aad322$export$f0954fd7d5368655,
    inv: $efcfa08a35aad322$export$c02accee9f2b6a8f,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    number: $efcfa08a35aad322$export$98e628dec113755e,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$8bd517cc5b3722f7 = /* #__PURE__ */ (0, $l9m9S.createSetDifference)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    Index: $efcfa08a35aad322$export$cf17b003b6192af3,
    compareNatural: $efcfa08a35aad322$export$762e84baec56595d,
    size: $efcfa08a35aad322$export$346677f925de839c,
    subset: $efcfa08a35aad322$export$e06bd7b1ab877a71,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$8bb4a52260216736 = /* #__PURE__ */ (0, $gBiOl.createSetMultiplicity)({
    Index: $efcfa08a35aad322$export$cf17b003b6192af3,
    compareNatural: $efcfa08a35aad322$export$762e84baec56595d,
    size: $efcfa08a35aad322$export$346677f925de839c,
    subset: $efcfa08a35aad322$export$e06bd7b1ab877a71,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$a7eac91d5496c35b = /* #__PURE__ */ (0, $aej5W.createSetSymDifference)({
    Index: $efcfa08a35aad322$export$cf17b003b6192af3,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    setDifference: $efcfa08a35aad322$export$8bd517cc5b3722f7,
    size: $efcfa08a35aad322$export$346677f925de839c,
    subset: $efcfa08a35aad322$export$e06bd7b1ab877a71,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$6d4069f4b64f7492 = /* #__PURE__ */ (0, $g9W86.createSpaClass)({
    FibonacciHeap: $efcfa08a35aad322$export$dd5bb73729f20aa3,
    addScalar: $efcfa08a35aad322$export$2b7b095c4f443355,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156
});
var $efcfa08a35aad322$export$17c7cd2216e18593 = /* #__PURE__ */ (0, $OrxWM.createSqrtm)({
    abs: $efcfa08a35aad322$export$2335f513bbd82c6d,
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    identity: $efcfa08a35aad322$export$f0954fd7d5368655,
    inv: $efcfa08a35aad322$export$c02accee9f2b6a8f,
    map: $efcfa08a35aad322$export$871de8747c9eaa88,
    max: $efcfa08a35aad322$export$8960430cfd85939f,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    size: $efcfa08a35aad322$export$346677f925de839c,
    sqrt: $efcfa08a35aad322$export$eba8049fb5020b81,
    subtract: $efcfa08a35aad322$export$4e2d2ead65e5f7e3,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$8a63f25cc62965f1 = /* #__PURE__ */ (0, $5t5dw.createSum)({
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    config: $abFWd.config,
    numeric: $efcfa08a35aad322$export$b7a508fa8dae59fc,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$1d8b9ae22d404866 = /* #__PURE__ */ (0, $i9Uex.createUnitClass)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    Fraction: $efcfa08a35aad322$export$b336c2702c498be5,
    abs: $efcfa08a35aad322$export$2335f513bbd82c6d,
    addScalar: $efcfa08a35aad322$export$2b7b095c4f443355,
    config: $abFWd.config,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    equal: $efcfa08a35aad322$export$411ce8e5a71e3069,
    fix: $efcfa08a35aad322$export$d838837eb5b184e3,
    format: $efcfa08a35aad322$export$d9468344d3651243,
    isNumeric: $efcfa08a35aad322$export$e90fb89750dba83f,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    number: $efcfa08a35aad322$export$98e628dec113755e,
    pow: $efcfa08a35aad322$export$9c297f60e22e3389,
    round: $efcfa08a35aad322$export$2077e0241d6afd3c,
    subtractScalar: $efcfa08a35aad322$export$fdebd7f5d4c6e658,
    toBest: $efcfa08a35aad322$export$7582d07c9009e223
});
var $efcfa08a35aad322$export$4b15dbe639ad9539 = /* #__PURE__ */ (0, $bbddX.createVacuumImpedance)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$2bcc1e96766dec50 = /* #__PURE__ */ (0, $bbddX.createWienDisplacement)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$11b531e5540c3ca4 = /* #__PURE__ */ (0, $bbddX.createAtomicMass)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$c779781d69f736e8 = /* #__PURE__ */ (0, $bbddX.createBohrMagneton)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$f727e86dcab4e2c6 = /* #__PURE__ */ (0, $bbddX.createBoltzmann)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$6eafe330bdda8c71 = /* #__PURE__ */ (0, $bbddX.createConductanceQuantum)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$2f2e110dac549211 = /* #__PURE__ */ (0, $bbddX.createCoulomb)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$aab44654646f3ccc = /* #__PURE__ */ (0, $hCsVF.createCreateUnit)({
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$80bf07f129ad1319 = /* #__PURE__ */ (0, $bbddX.createDeuteronMass)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$ef3b15136279c2ab = /* #__PURE__ */ (0, $laeVF.createDotPow)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    SparseMatrix: $efcfa08a35aad322$export$de9b2b7556879848,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    pow: $efcfa08a35aad322$export$9c297f60e22e3389,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$11ff82822f958f25 = /* #__PURE__ */ (0, $bbddX.createElectricConstant)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$199cdfec7f52c877 = /* #__PURE__ */ (0, $bbddX.createElementaryCharge)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$d9bacaa51f70e8e = /* #__PURE__ */ (0, $lTpfe.createExpm)({
    abs: $efcfa08a35aad322$export$2335f513bbd82c6d,
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    identity: $efcfa08a35aad322$export$f0954fd7d5368655,
    inv: $efcfa08a35aad322$export$c02accee9f2b6a8f,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$7130fbae042d5c0f = /* #__PURE__ */ (0, $bbddX.createFaraday)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$a535ef183b6128fa = /* #__PURE__ */ (0, $049dG.createFft)({
    addScalar: $efcfa08a35aad322$export$2b7b095c4f443355,
    ceil: $efcfa08a35aad322$export$803ce6b71a0a94b2,
    conj: $efcfa08a35aad322$export$fb254c661fe9c0db,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    dotDivide: $efcfa08a35aad322$export$c74f132961c51406,
    exp: $efcfa08a35aad322$export$b310ec824aaee37f,
    i: $efcfa08a35aad322$export$23f2a1d2818174ef,
    log2: $efcfa08a35aad322$export$b9fae0bba9d9094d,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    pow: $efcfa08a35aad322$export$9c297f60e22e3389,
    tau: $efcfa08a35aad322$export$a4b4b4d4d776fe92,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$a7ebe8cc6aaf8d37 = /* #__PURE__ */ (0, $7cnsm.createGamma)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    config: $abFWd.config,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    pow: $efcfa08a35aad322$export$9c297f60e22e3389,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$d9cccfa50756330b = /* #__PURE__ */ (0, $bbddX.createGravitationConstant)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$37b0dd3693d47685 = /* #__PURE__ */ (0, $bbddX.createHartreeEnergy)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$776649b0bf8ce1fd = /* #__PURE__ */ (0, $cUfFC.createIfft)({
    conj: $efcfa08a35aad322$export$fb254c661fe9c0db,
    dotDivide: $efcfa08a35aad322$export$c74f132961c51406,
    fft: $efcfa08a35aad322$export$a535ef183b6128fa,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$f060c4f0aa5bef89 = /* #__PURE__ */ (0, $bbddX.createInverseConductanceQuantum)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$10054c6b64de12f5 = /* #__PURE__ */ (0, $bbddX.createKlitzing)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$9eedba962d6a1c01 = /* #__PURE__ */ (0, $bbddX.createLoschmidt)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$ba3f3691dd1c5a7 = /* #__PURE__ */ (0, $bbddX.createMagneticConstant)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$6d4ff429f3f89356 = /* #__PURE__ */ (0, $bbddX.createMolarMass)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$dacf4a2cf8881dff = /* #__PURE__ */ (0, $bbddX.createMolarPlanckConstant)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$ba7a41eda790cc15 = /* #__PURE__ */ (0, $bbddX.createNeutronMass)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$7274fb1d27d1cd19 = /* #__PURE__ */ (0, $bbddX.createNuclearMagneton)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$9b1b4e5bc980cec6 = /* #__PURE__ */ (0, $bbddX.createPlanckCharge)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$c20ab336465d7d5e = /* #__PURE__ */ (0, $bbddX.createPlanckLength)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$5a85cd1a26c2cced = /* #__PURE__ */ (0, $bbddX.createPlanckTemperature)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$1c88a737209eb089 = /* #__PURE__ */ (0, $bbddX.createProtonMass)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$5d88bfa2004001d3 = /* #__PURE__ */ (0, $bbddX.createQuantumOfCirculation)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$963167ae5579ea00 = /* #__PURE__ */ (0, $bbddX.createReducedPlanckConstant)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$683732ab8f5759dc = /* #__PURE__ */ (0, $bbddX.createRydberg)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$1f7c42a78c01e4f9 = /* #__PURE__ */ (0, $bbddX.createSecondRadiation)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$1c70a6cc12bc0366 = /* #__PURE__ */ (0, $aVxPF.createSetSize)({
    compareNatural: $efcfa08a35aad322$export$762e84baec56595d,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$5d66ae3b3e8fce48 = /* #__PURE__ */ (0, $bbddX.createSpeedOfLight)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$f63e81544c3d56ef = /* #__PURE__ */ (0, $bbddX.createStefanBoltzmann)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$93039724ea765a8e = /* #__PURE__ */ (0, $bbddX.createThomsonCrossSection)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$1236f2451dbdfd63 = /* #__PURE__ */ (0, $bbddX.createAvogadro)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$5a57f82afcc3edeb = /* #__PURE__ */ (0, $bbddX.createBohrRadius)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$7b7673beb2999b0a = /* #__PURE__ */ (0, $bbddX.createCoulombConstant)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$cd007d971a5a2143 = /* #__PURE__ */ (0, $2y6AI.createDivide)({
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    inv: $efcfa08a35aad322$export$c02accee9f2b6a8f,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$c00fb43e712bef2c = /* #__PURE__ */ (0, $bbddX.createElectronMass)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$329ce89a99f0e343 = /* #__PURE__ */ (0, $DY4K7.createFactorial)({
    gamma: $efcfa08a35aad322$export$a7ebe8cc6aaf8d37,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$f83f3c3b84952e0b = /* #__PURE__ */ (0, $bbddX.createFirstRadiation)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$bfb00cec0048377d = /* #__PURE__ */ (0, $bbddX.createGravity)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$1f4807a235930d45 = /* #__PURE__ */ (0, $hqZT1.createIntersect)({
    abs: $efcfa08a35aad322$export$2335f513bbd82c6d,
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    addScalar: $efcfa08a35aad322$export$2b7b095c4f443355,
    config: $abFWd.config,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    flatten: $efcfa08a35aad322$export$bffa455ba8c619a6,
    isNumeric: $efcfa08a35aad322$export$e90fb89750dba83f,
    isZero: $efcfa08a35aad322$export$c46ec7d82fb1f602,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    smaller: $efcfa08a35aad322$export$3f732695c1493aec,
    subtract: $efcfa08a35aad322$export$4e2d2ead65e5f7e3,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$91d2d01a33a1e6f8 = /* #__PURE__ */ (0, $jgcqf.createLup)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    Spa: $efcfa08a35aad322$export$6d4069f4b64f7492,
    SparseMatrix: $efcfa08a35aad322$export$de9b2b7556879848,
    abs: $efcfa08a35aad322$export$2335f513bbd82c6d,
    addScalar: $efcfa08a35aad322$export$2b7b095c4f443355,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    larger: $efcfa08a35aad322$export$a94a7414fa942aea,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    subtractScalar: $efcfa08a35aad322$export$fdebd7f5d4c6e658,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    unaryMinus: $efcfa08a35aad322$export$6cd304851a69e08
});
var $efcfa08a35aad322$export$699e2a89b148c5ee = /* #__PURE__ */ (0, $bbddX.createMagneticFluxQuantum)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$9589ebe123df8f2e = /* #__PURE__ */ (0, $bbddX.createMolarMassC12)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$f4d580f3101a1c7e = /* #__PURE__ */ (0, $cA8qu.createMultinomial)({
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    divide: $efcfa08a35aad322$export$cd007d971a5a2143,
    factorial: $efcfa08a35aad322$export$329ce89a99f0e343,
    isInteger: $efcfa08a35aad322$export$a287f47fed4544b8,
    isPositive: $efcfa08a35aad322$export$7e69d4236fcc3b19,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$4567adbe5dd91621 = /* #__PURE__ */ (0, $7neEi.createPermutations)({
    factorial: $efcfa08a35aad322$export$329ce89a99f0e343,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$5ce790af25e5ac75 = /* #__PURE__ */ (0, $bbddX.createPlanckMass)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$a543de521896982d = /* #__PURE__ */ (0, $e9HIC.createPolynomialRoot)({
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    cbrt: $efcfa08a35aad322$export$841fc4d5a1480b85,
    divide: $efcfa08a35aad322$export$cd007d971a5a2143,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    im: $efcfa08a35aad322$export$5fc500b917996661,
    isZero: $efcfa08a35aad322$export$c46ec7d82fb1f602,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    re: $efcfa08a35aad322$export$b1f1627d659a651,
    sqrt: $efcfa08a35aad322$export$eba8049fb5020b81,
    subtract: $efcfa08a35aad322$export$4e2d2ead65e5f7e3,
    typeOf: $efcfa08a35aad322$export$f5bbd400c2f4426f,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    unaryMinus: $efcfa08a35aad322$export$6cd304851a69e08
});
var $efcfa08a35aad322$export$9404cfefeb010e68 = /* #__PURE__ */ (0, $5h2xd.createSetIntersect)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    Index: $efcfa08a35aad322$export$cf17b003b6192af3,
    compareNatural: $efcfa08a35aad322$export$762e84baec56595d,
    size: $efcfa08a35aad322$export$346677f925de839c,
    subset: $efcfa08a35aad322$export$e06bd7b1ab877a71,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$877a84c9618ec845 = /* #__PURE__ */ (0, $ioEKX.createSolveODE)({
    abs: $efcfa08a35aad322$export$2335f513bbd82c6d,
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    bignumber: $efcfa08a35aad322$export$8576f72eb7f14a7e,
    divide: $efcfa08a35aad322$export$cd007d971a5a2143,
    isNegative: $efcfa08a35aad322$export$d0909a4f38b5c4d0,
    isPositive: $efcfa08a35aad322$export$7e69d4236fcc3b19,
    larger: $efcfa08a35aad322$export$a94a7414fa942aea,
    map: $efcfa08a35aad322$export$871de8747c9eaa88,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    max: $efcfa08a35aad322$export$8960430cfd85939f,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    smaller: $efcfa08a35aad322$export$3f732695c1493aec,
    subtract: $efcfa08a35aad322$export$4e2d2ead65e5f7e3,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    unaryMinus: $efcfa08a35aad322$export$6cd304851a69e08
});
var $efcfa08a35aad322$export$a5abae3de3985f2f = /* #__PURE__ */ (0, $hzajK.createStirlingS2)({
    bignumber: $efcfa08a35aad322$export$8576f72eb7f14a7e,
    addScalar: $efcfa08a35aad322$export$2b7b095c4f443355,
    combinations: $efcfa08a35aad322$export$bdfcf4c6b5766439,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    factorial: $efcfa08a35aad322$export$329ce89a99f0e343,
    isInteger: $efcfa08a35aad322$export$a287f47fed4544b8,
    isNegative: $efcfa08a35aad322$export$d0909a4f38b5c4d0,
    larger: $efcfa08a35aad322$export$a94a7414fa942aea,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    number: $efcfa08a35aad322$export$98e628dec113755e,
    pow: $efcfa08a35aad322$export$9c297f60e22e3389,
    subtractScalar: $efcfa08a35aad322$export$fdebd7f5d4c6e658,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$523c0b569236b342 = /* #__PURE__ */ (0, $dr4WD.createUnitFunction)({
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$bb522a71cda46a13 = /* #__PURE__ */ (0, $15OuE.createBellNumbers)({
    addScalar: $efcfa08a35aad322$export$2b7b095c4f443355,
    isInteger: $efcfa08a35aad322$export$a287f47fed4544b8,
    isNegative: $efcfa08a35aad322$export$d0909a4f38b5c4d0,
    stirlingS2: $efcfa08a35aad322$export$a5abae3de3985f2f,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$71990b1e1c4912fe = /* #__PURE__ */ (0, $evEiW.createCumSum)({
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    unaryPlus: $efcfa08a35aad322$export$df8c837ae5df4ce4
});
var $efcfa08a35aad322$export$e822b38c59ee8a2a = /* #__PURE__ */ (0, $52vmX.createEigs)({
    abs: $efcfa08a35aad322$export$2335f513bbd82c6d,
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    addScalar: $efcfa08a35aad322$export$2b7b095c4f443355,
    atan: $efcfa08a35aad322$export$628dc4eed22b0fbd,
    bignumber: $efcfa08a35aad322$export$8576f72eb7f14a7e,
    column: $efcfa08a35aad322$export$4e0c71f277ca26b3,
    complex: $efcfa08a35aad322$export$83a0e34f1302825b,
    config: $abFWd.config,
    cos: $efcfa08a35aad322$export$50d414a77b60d802,
    diag: $efcfa08a35aad322$export$c042e7c2f59bc046,
    divideScalar: $efcfa08a35aad322$export$67275f837d70084d,
    dot: $efcfa08a35aad322$export$94132a0e348806d4,
    equal: $efcfa08a35aad322$export$411ce8e5a71e3069,
    flatten: $efcfa08a35aad322$export$bffa455ba8c619a6,
    im: $efcfa08a35aad322$export$5fc500b917996661,
    inv: $efcfa08a35aad322$export$c02accee9f2b6a8f,
    larger: $efcfa08a35aad322$export$a94a7414fa942aea,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    matrixFromColumns: $efcfa08a35aad322$export$e8999e227859a482,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    number: $efcfa08a35aad322$export$98e628dec113755e,
    qr: $efcfa08a35aad322$export$7c27fb47516129d9,
    re: $efcfa08a35aad322$export$b1f1627d659a651,
    reshape: $efcfa08a35aad322$export$9eaad88cf88cee2b,
    sin: $efcfa08a35aad322$export$5de3937cb4b592ed,
    size: $efcfa08a35aad322$export$346677f925de839c,
    smaller: $efcfa08a35aad322$export$3f732695c1493aec,
    sqrt: $efcfa08a35aad322$export$eba8049fb5020b81,
    subtract: $efcfa08a35aad322$export$4e2d2ead65e5f7e3,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    usolve: $efcfa08a35aad322$export$41828460570e21eb,
    usolveAll: $efcfa08a35aad322$export$c8a1cf0e83678d9
});
var $efcfa08a35aad322$export$84a9a66802fec40 = /* #__PURE__ */ (0, $bbddX.createFermiCoupling)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$a614e1ad972260a9 = /* #__PURE__ */ (0, $bbddX.createGasConstant)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$a9fffb6ae6e33dcc = /* #__PURE__ */ (0, $5Q7md.createKldivergence)({
    divide: $efcfa08a35aad322$export$cd007d971a5a2143,
    dotDivide: $efcfa08a35aad322$export$c74f132961c51406,
    isNumeric: $efcfa08a35aad322$export$e90fb89750dba83f,
    log: $efcfa08a35aad322$export$bef1f36f5486a6a3,
    map: $efcfa08a35aad322$export$871de8747c9eaa88,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    sum: $efcfa08a35aad322$export$8a63f25cc62965f1,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$fccc724a69f253a = /* #__PURE__ */ (0, $2uHPV.createLusolve)({
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    lsolve: $efcfa08a35aad322$export$be3b83cc1aa539e4,
    lup: $efcfa08a35aad322$export$91d2d01a33a1e6f8,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    slu: $efcfa08a35aad322$export$95c7459688ef4e3a,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    usolve: $efcfa08a35aad322$export$41828460570e21eb
});
var $efcfa08a35aad322$export$1ce691f85baaa52 = /* #__PURE__ */ (0, $dthUd.createMean)({
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    divide: $efcfa08a35aad322$export$cd007d971a5a2143,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$863459416408c428 = /* #__PURE__ */ (0, $bbddX.createMolarVolume)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$cbd33810258dab2e = /* #__PURE__ */ (0, $bbddX.createPlanckConstant)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$ff63ee916cadcfe = /* #__PURE__ */ (0, $6uMAY.createQuantileSeq)({
    bignumber: $efcfa08a35aad322$export$8576f72eb7f14a7e,
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    compare: $efcfa08a35aad322$export$398604a469f7de9a,
    divide: $efcfa08a35aad322$export$cd007d971a5a2143,
    isInteger: $efcfa08a35aad322$export$a287f47fed4544b8,
    larger: $efcfa08a35aad322$export$a94a7414fa942aea,
    mapSlices: $efcfa08a35aad322$export$68ed7ff4ab083a8b,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    partitionSelect: $efcfa08a35aad322$export$54d1e322cf7aa273,
    smaller: $efcfa08a35aad322$export$3f732695c1493aec,
    smallerEq: $efcfa08a35aad322$export$8d38c87f33a93d98,
    subtract: $efcfa08a35aad322$export$4e2d2ead65e5f7e3,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$667066422fa0af46 = /* #__PURE__ */ (0, $9j3eN.createSetUnion)({
    Index: $efcfa08a35aad322$export$cf17b003b6192af3,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    setIntersect: $efcfa08a35aad322$export$9404cfefeb010e68,
    setSymDifference: $efcfa08a35aad322$export$a7eac91d5496c35b,
    size: $efcfa08a35aad322$export$346677f925de839c,
    subset: $efcfa08a35aad322$export$e06bd7b1ab877a71,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$9b77da0927470c3d = /* #__PURE__ */ (0, $aW39D.createVariance)({
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    divide: $efcfa08a35aad322$export$cd007d971a5a2143,
    isNaN: $efcfa08a35aad322$export$c9f5652083b8129d,
    mapSlices: $efcfa08a35aad322$export$68ed7ff4ab083a8b,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    subtract: $efcfa08a35aad322$export$4e2d2ead65e5f7e3,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$f48a0c6b8cc21601 = /* #__PURE__ */ (0, $bbddX.createClassicalElectronRadius)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$9c490b34b2f16a34 = /* #__PURE__ */ (0, $5KUxv.createMedian)({
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    compare: $efcfa08a35aad322$export$398604a469f7de9a,
    divide: $efcfa08a35aad322$export$cd007d971a5a2143,
    partitionSelect: $efcfa08a35aad322$export$54d1e322cf7aa273,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$962a8812c08af262 = /* #__PURE__ */ (0, $gOUuL.createCorr)({
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    divide: $efcfa08a35aad322$export$cd007d971a5a2143,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    mean: $efcfa08a35aad322$export$1ce691f85baaa52,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    pow: $efcfa08a35aad322$export$9c297f60e22e3389,
    sqrt: $efcfa08a35aad322$export$eba8049fb5020b81,
    subtract: $efcfa08a35aad322$export$4e2d2ead65e5f7e3,
    sum: $efcfa08a35aad322$export$8a63f25cc62965f1,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$d343cdcf8054100e = /* #__PURE__ */ (0, $pU8n9.createFreqz)({
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    divide: $efcfa08a35aad322$export$cd007d971a5a2143,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$b14ea41a64d6efa6 = /* #__PURE__ */ (0, $cWSx6.createMad)({
    abs: $efcfa08a35aad322$export$2335f513bbd82c6d,
    map: $efcfa08a35aad322$export$871de8747c9eaa88,
    median: $efcfa08a35aad322$export$9c490b34b2f16a34,
    subtract: $efcfa08a35aad322$export$4e2d2ead65e5f7e3,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$b14c5e819cb6c927 = /* #__PURE__ */ (0, $6V7sZ.createStd)({
    map: $efcfa08a35aad322$export$871de8747c9eaa88,
    sqrt: $efcfa08a35aad322$export$eba8049fb5020b81,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    variance: $efcfa08a35aad322$export$9b77da0927470c3d
});
var $efcfa08a35aad322$export$327d565dd49bd5b0 = /* #__PURE__ */ (0, $81RTn.createZeta)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Complex: $efcfa08a35aad322$export$50ceb3fb9926e63e,
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    config: $abFWd.config,
    divide: $efcfa08a35aad322$export$cd007d971a5a2143,
    equal: $efcfa08a35aad322$export$411ce8e5a71e3069,
    factorial: $efcfa08a35aad322$export$329ce89a99f0e343,
    gamma: $efcfa08a35aad322$export$a7ebe8cc6aaf8d37,
    isNegative: $efcfa08a35aad322$export$d0909a4f38b5c4d0,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    pi: $efcfa08a35aad322$export$18c7bea995a110f,
    pow: $efcfa08a35aad322$export$9c297f60e22e3389,
    sin: $efcfa08a35aad322$export$5de3937cb4b592ed,
    smallerEq: $efcfa08a35aad322$export$8d38c87f33a93d98,
    subtract: $efcfa08a35aad322$export$4e2d2ead65e5f7e3,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$1991ecd29cc92c6b = /* #__PURE__ */ (0, $jA7Yu.createNorm)({
    abs: $efcfa08a35aad322$export$2335f513bbd82c6d,
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    conj: $efcfa08a35aad322$export$fb254c661fe9c0db,
    ctranspose: $efcfa08a35aad322$export$eb6ad7870b1d0b0b,
    eigs: $efcfa08a35aad322$export$e822b38c59ee8a2a,
    equalScalar: $efcfa08a35aad322$export$943761f5c9c3f156,
    larger: $efcfa08a35aad322$export$a94a7414fa942aea,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    pow: $efcfa08a35aad322$export$9c297f60e22e3389,
    smaller: $efcfa08a35aad322$export$3f732695c1493aec,
    sqrt: $efcfa08a35aad322$export$eba8049fb5020b81,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$52ded331ee8b28e8 = /* #__PURE__ */ (0, $cYdow.createRotationMatrix)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    DenseMatrix: $efcfa08a35aad322$export$97f0d27b48f120e8,
    SparseMatrix: $efcfa08a35aad322$export$de9b2b7556879848,
    addScalar: $efcfa08a35aad322$export$2b7b095c4f443355,
    config: $abFWd.config,
    cos: $efcfa08a35aad322$export$50d414a77b60d802,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiplyScalar: $efcfa08a35aad322$export$c697bed75648cdb7,
    norm: $efcfa08a35aad322$export$1991ecd29cc92c6b,
    sin: $efcfa08a35aad322$export$5de3937cb4b592ed,
    typed: $efcfa08a35aad322$export$519f616c41a1c711,
    unaryMinus: $efcfa08a35aad322$export$6cd304851a69e08
});
var $efcfa08a35aad322$export$85aaf319784a5b0 = /* #__PURE__ */ (0, $bbddX.createPlanckTime)({
    BigNumber: $efcfa08a35aad322$export$d97aa349ed20696,
    Unit: $efcfa08a35aad322$export$1d8b9ae22d404866,
    config: $abFWd.config
});
var $efcfa08a35aad322$export$c81e2c0e8b1065f5 = /* #__PURE__ */ (0, $bPh4z.createSchur)({
    identity: $efcfa08a35aad322$export$f0954fd7d5368655,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    norm: $efcfa08a35aad322$export$1991ecd29cc92c6b,
    qr: $efcfa08a35aad322$export$7c27fb47516129d9,
    subtract: $efcfa08a35aad322$export$4e2d2ead65e5f7e3,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$bb628a54ab399bc9 = /* #__PURE__ */ (0, $k4T9A.createRotate)({
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    rotationMatrix: $efcfa08a35aad322$export$52ded331ee8b28e8,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$7f6dd94c0096067a = /* #__PURE__ */ (0, $3vNp3.createSylvester)({
    abs: $efcfa08a35aad322$export$2335f513bbd82c6d,
    add: $efcfa08a35aad322$export$e16d8520af44a096,
    concat: $efcfa08a35aad322$export$ee1b3e54f0441b22,
    identity: $efcfa08a35aad322$export$f0954fd7d5368655,
    index: $efcfa08a35aad322$export$b610b8812bbcded9,
    lusolve: $efcfa08a35aad322$export$fccc724a69f253a,
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    matrixFromColumns: $efcfa08a35aad322$export$e8999e227859a482,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    range: $efcfa08a35aad322$export$d02631cccf789723,
    schur: $efcfa08a35aad322$export$c81e2c0e8b1065f5,
    subset: $efcfa08a35aad322$export$e06bd7b1ab877a71,
    subtract: $efcfa08a35aad322$export$4e2d2ead65e5f7e3,
    transpose: $efcfa08a35aad322$export$9cb09a71b7d66923,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});
var $efcfa08a35aad322$export$462de2f2fa40b84 = /* #__PURE__ */ (0, $jq3Rf.createLyap)({
    matrix: $efcfa08a35aad322$export$9bdad1ae37d738e0,
    multiply: $efcfa08a35aad322$export$2060d2db72cce88f,
    sylvester: $efcfa08a35aad322$export$7f6dd94c0096067a,
    transpose: $efcfa08a35aad322$export$9cb09a71b7d66923,
    typed: $efcfa08a35aad322$export$519f616c41a1c711
});

});
parcelRegister("abFWd", function(module, exports) {

$parcel$export(module.exports, "config", () => $76ab767e29b8e142$export$e506a1d27d1eaa20);

var $3p9rK = parcelRequire("3p9rK");

var $jlwMk = parcelRequire("jlwMk");

var $KLqZw = parcelRequire("KLqZw");
var $76ab767e29b8e142$export$e506a1d27d1eaa20 = function config(options) {
    if (options) throw new Error("The global config is readonly. \nPlease create a mathjs instance if you want to change the default configuration. \nExample:\n\n  import { create, all } from 'mathjs';\n  const mathjs = create(all);\n  mathjs.config({ number: 'BigNumber' });\n");
    return Object.freeze((0, $jlwMk.DEFAULT_CONFIG));
};
(0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))($76ab767e29b8e142$export$e506a1d27d1eaa20, (0, $jlwMk.DEFAULT_CONFIG), {
    MATRIX_OPTIONS: $KLqZw.MATRIX_OPTIONS,
    NUMBER_OPTIONS: $KLqZw.NUMBER_OPTIONS
});

});
parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jlwMk", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONFIG", () => $e15967a0a30ccc46$export$c2f8e0cc249a8d8f);
var $e15967a0a30ccc46$export$c2f8e0cc249a8d8f = {
    // minimum relative difference between two compared values,
    // used by all comparison functions
    relTol: 1e-12,
    // minimum absolute difference between two compared values,
    // used by all comparison functions
    absTol: 1e-15,
    // type of default matrix output. Choose 'matrix' (default) or 'array'
    matrix: 'Matrix',
    // type of default number output. Choose 'number' (default) 'BigNumber', 'bigint', or 'Fraction'
    number: 'number',
    // type of fallback used for config { number: 'bigint' } when a value cannot be represented
    // in the configured numeric type. Choose 'number' (default) or 'BigNumber'.
    numberFallback: 'number',
    // number of significant digits in BigNumbers
    precision: 64,
    // predictable output type of functions. When true, output type depends only
    // on the input types. When false (default), output type can vary depending
    // on input values. For example `math.sqrt(-4)` returns `complex('2i')` when
    // predictable is false, and returns `NaN` when true.
    predictable: false,
    // random seed for seeded pseudo random number generation
    // null = randomly seed
    randomSeed: null
};

});

parcelRegister("KLqZw", function(module, exports) {

$parcel$export(module.exports, "MATRIX_OPTIONS", () => $08c91777245f24f5$export$517ab898194ae9af);
$parcel$export(module.exports, "NUMBER_OPTIONS", () => $08c91777245f24f5$export$f4b0a2084fdf2177);

var $9v8q6 = parcelRequire("9v8q6");

var $jlwMk = parcelRequire("jlwMk");
var $08c91777245f24f5$export$517ab898194ae9af = [
    'Matrix',
    'Array'
]; // valid values for option matrix
var $08c91777245f24f5$export$f4b0a2084fdf2177 = [
    'number',
    'BigNumber',
    'bigint',
    'Fraction'
]; // valid values for option number
function $08c91777245f24f5$export$3984aa6f7f77f1ae(config, emit) {
    /**
   * Set configuration options for math.js, and get current options.
   * Will emit a 'config' event, with arguments (curr, prev, changes).
   *
   * This function is only available on a mathjs instance created using `create`.
   *
   * Syntax:
   *
   *     math.config(config: Object): Object
   *
   * Examples:
   *
   *     import { create, all } from 'mathjs'
   *
   *     // create a mathjs instance
   *     const math = create(all)
   *
   *     math.config().number                // outputs 'number'
   *     math.evaluate('0.4')                // outputs number 0.4
   *     math.config({number: 'Fraction'})
   *     math.evaluate('0.4')                // outputs Fraction 2/5
   *
   * @param {Object} [options] Available options:
   *                            {number} relTol
   *                              Minimum relative difference between two
   *                              compared values, used by all comparison functions.
   *                            {number} absTol
   *                              Minimum absolute difference between two
   *                              compared values, used by all comparison functions.
   *                            {string} matrix
   *                              A string 'Matrix' (default) or 'Array'.
   *                            {string} number
   *                              A string 'number' (default), 'BigNumber', 'bigint', or 'Fraction'
   *                            {number} precision
   *                              The number of significant digits for BigNumbers.
   *                              Not applicable for Numbers.
   *                            {string} parenthesis
   *                              How to display parentheses in LaTeX and string
   *                              output.
   *                            {string} randomSeed
   *                              Random seed for seeded pseudo random number generator.
   *                              Set to null to randomly seed.
   * @return {Object} Returns the current configuration
   */ function _config(options) {
        if (options) {
            if (options.epsilon !== undefined) {
                // this if is only for backwards compatibility, it can be removed in the future.
                console.warn('Warning: The configuration option "epsilon" is deprecated. Use "relTol" and "absTol" instead.');
                var optionsFix = (0, $9v8q6.clone)(options);
                optionsFix.relTol = options.epsilon;
                optionsFix.absTol = options.epsilon * 1e-3;
                delete optionsFix.epsilon;
                return _config(optionsFix);
            }
            var prev = (0, $9v8q6.clone)(config);
            // validate some of the options
            $08c91777245f24f5$var$validateOption(options, 'matrix', $08c91777245f24f5$export$517ab898194ae9af);
            $08c91777245f24f5$var$validateOption(options, 'number', $08c91777245f24f5$export$f4b0a2084fdf2177);
            // merge options
            (0, $9v8q6.deepExtend)(config, options);
            var curr = (0, $9v8q6.clone)(config);
            var changes = (0, $9v8q6.clone)(options);
            // emit 'config' event
            emit('config', curr, prev, changes);
            return curr;
        } else return (0, $9v8q6.clone)(config);
    }
    // attach the valid options to the function so they can be extended
    _config.MATRIX_OPTIONS = $08c91777245f24f5$export$517ab898194ae9af;
    _config.NUMBER_OPTIONS = $08c91777245f24f5$export$f4b0a2084fdf2177;
    // attach the config properties as readonly properties to the config function
    Object.keys((0, $jlwMk.DEFAULT_CONFIG)).forEach((key)=>{
        Object.defineProperty(_config, key, {
            get: ()=>config[key],
            enumerable: true,
            configurable: true
        });
    });
    return _config;
}
/**
 * Validate an option
 * @param {Object} options         Object with options
 * @param {string} name            Name of the option to validate
 * @param {Array.<string>} values  Array with valid values for this option
 */ function $08c91777245f24f5$var$validateOption(options, name, values) {
    if (options[name] !== undefined && !values.includes(options[name])) // unknown value
    console.warn('Warning: Unknown value "' + options[name] + '" for configuration option "' + name + '". ' + 'Available options: ' + values.map((value)=>JSON.stringify(value)).join(', ') + '.');
}

});
parcelRegister("9v8q6", function(module, exports) {

$parcel$export(module.exports, "clone", () => $6ead8a5e53031912$export$9cd59f9826255e47);
$parcel$export(module.exports, "hasOwnProperty", () => $6ead8a5e53031912$export$5a15a386532a5ea4);
$parcel$export(module.exports, "extend", () => $6ead8a5e53031912$export$8b58be045bf06082);
$parcel$export(module.exports, "deepExtend", () => $6ead8a5e53031912$export$54e9fb29908872fa);
$parcel$export(module.exports, "deepStrictEqual", () => $6ead8a5e53031912$export$6cc798251952180);
$parcel$export(module.exports, "pickShallow", () => $6ead8a5e53031912$export$8cea971c64639ea7);

var $edQYF = parcelRequire("edQYF");
function $6ead8a5e53031912$export$9cd59f9826255e47(x) {
    var type = typeof x;
    // immutable primitive types
    if (type === 'number' || type === 'bigint' || type === 'string' || type === 'boolean' || x === null || x === undefined) return x;
    // use clone function of the object when available
    if (typeof x.clone === 'function') return x.clone();
    // array
    if (Array.isArray(x)) return x.map(function(value) {
        return $6ead8a5e53031912$export$9cd59f9826255e47(value);
    });
    if (x instanceof Date) return new Date(x.valueOf());
    if ((0, $edQYF.isBigNumber)(x)) return x; // bignumbers are immutable
    // object
    if ((0, $edQYF.isObject)(x)) return $6ead8a5e53031912$export$d6051a0f7a227332(x, $6ead8a5e53031912$export$9cd59f9826255e47);
    if (type === 'function') // we assume that the function is immutable
    return x;
    throw new TypeError("Cannot clone: unknown type of value (value: ".concat(x, ")"));
}
function $6ead8a5e53031912$export$d6051a0f7a227332(object, callback) {
    var clone = {};
    for(var key in object)if ($6ead8a5e53031912$export$5a15a386532a5ea4(object, key)) clone[key] = callback(object[key]);
    return clone;
}
function $6ead8a5e53031912$export$8b58be045bf06082(a, b) {
    for(var prop in b)if ($6ead8a5e53031912$export$5a15a386532a5ea4(b, prop)) a[prop] = b[prop];
    return a;
}
function $6ead8a5e53031912$export$54e9fb29908872fa(a, b) {
    // TODO: add support for Arrays to deepExtend
    if (Array.isArray(b)) throw new TypeError('Arrays are not supported by deepExtend');
    for(var prop in b)// We check against prop not being in Object.prototype or Function.prototype
    // to prevent polluting for example Object.__proto__.
    if ($6ead8a5e53031912$export$5a15a386532a5ea4(b, prop) && !(prop in Object.prototype) && !(prop in Function.prototype)) {
        if (b[prop] && b[prop].constructor === Object) {
            if (a[prop] === undefined) a[prop] = {};
            if (a[prop] && a[prop].constructor === Object) $6ead8a5e53031912$export$54e9fb29908872fa(a[prop], b[prop]);
            else a[prop] = b[prop];
        } else if (Array.isArray(b[prop])) throw new TypeError('Arrays are not supported by deepExtend');
        else a[prop] = b[prop];
    }
    return a;
}
function $6ead8a5e53031912$export$6cc798251952180(a, b) {
    var prop, i, len;
    if (Array.isArray(a)) {
        if (!Array.isArray(b)) return false;
        if (a.length !== b.length) return false;
        for(i = 0, len = a.length; i < len; i++){
            if (!$6ead8a5e53031912$export$6cc798251952180(a[i], b[i])) return false;
        }
        return true;
    } else if (typeof a === 'function') return a === b;
    else if (a instanceof Object) {
        if (Array.isArray(b) || !(b instanceof Object)) return false;
        for(prop in a){
            // noinspection JSUnfilteredForInLoop
            if (!(prop in b) || !$6ead8a5e53031912$export$6cc798251952180(a[prop], b[prop])) return false;
        }
        for(prop in b){
            // noinspection JSUnfilteredForInLoop
            if (!(prop in a)) return false;
        }
        return true;
    } else return a === b;
}
function $6ead8a5e53031912$export$519b2d75cc54d03b(nestedObject) {
    var flattenedObject = {};
    $6ead8a5e53031912$var$_deepFlatten(nestedObject, flattenedObject);
    return flattenedObject;
}
// helper function used by deepFlatten
function $6ead8a5e53031912$var$_deepFlatten(nestedObject, flattenedObject) {
    for(var prop in nestedObject)if ($6ead8a5e53031912$export$5a15a386532a5ea4(nestedObject, prop)) {
        var value = nestedObject[prop];
        if (typeof value === 'object' && value !== null) $6ead8a5e53031912$var$_deepFlatten(value, flattenedObject);
        else flattenedObject[prop] = value;
    }
}
function $6ead8a5e53031912$export$a73e197d57374bd3() {
    // test needed for broken IE8 implementation
    try {
        if (Object.defineProperty) {
            Object.defineProperty({}, 'x', {
                get: function get() {
                    return null;
                }
            });
            return true;
        }
    } catch (e) {}
    return false;
}
function $6ead8a5e53031912$export$488013bae63b21da(object, prop, valueResolver) {
    var _uninitialized = true;
    var _value;
    Object.defineProperty(object, prop, {
        get: function get() {
            if (_uninitialized) {
                _value = valueResolver();
                _uninitialized = false;
            }
            return _value;
        },
        set: function set(value) {
            _value = value;
            _uninitialized = false;
        },
        configurable: true,
        enumerable: true
    });
}
function $6ead8a5e53031912$export$df3f009e3d155b20(object, path) {
    if (path && typeof path === 'string') return $6ead8a5e53031912$export$df3f009e3d155b20(object, path.split('.'));
    var obj = object;
    if (path) for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (!(key in obj)) obj[key] = {};
        obj = obj[key];
    }
    return obj;
}
function $6ead8a5e53031912$export$5a15a386532a5ea4(object, property) {
    return object && Object.hasOwnProperty.call(object, property);
}
function $6ead8a5e53031912$export$1bc2c269dfa97885(object) {
    return object && typeof object.factory === 'function';
}
function $6ead8a5e53031912$export$3988ae62b71be9a3(object, path) {
    if (typeof path === 'string') {
        if ($6ead8a5e53031912$var$isPath(path)) return $6ead8a5e53031912$export$3988ae62b71be9a3(object, path.split('.'));
        else return object[path];
    }
    var child = object;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        child = child ? child[key] : undefined;
    }
    return child;
}
function $6ead8a5e53031912$export$adaa4cf7ef1b65be(object, path, value) {
    if (typeof path === 'string') {
        if ($6ead8a5e53031912$var$isPath(path)) return $6ead8a5e53031912$export$adaa4cf7ef1b65be(object, path.split('.'), value);
        else {
            object[path] = value;
            return object;
        }
    }
    var child = object;
    for(var i = 0; i < path.length - 1; i++){
        var key = path[i];
        if (child[key] === undefined) child[key] = {};
        child = child[key];
    }
    if (path.length > 0) {
        var lastKey = path[path.length - 1];
        child[lastKey] = value;
    }
    return object;
}
function $6ead8a5e53031912$export$357523c63a2253b9(object, properties, transform) {
    var copy = {};
    for(var i = 0; i < properties.length; i++){
        var key = properties[i];
        var value = $6ead8a5e53031912$export$3988ae62b71be9a3(object, key);
        if (value !== undefined) $6ead8a5e53031912$export$adaa4cf7ef1b65be(copy, key, transform ? transform(value, key) : value);
    }
    return copy;
}
function $6ead8a5e53031912$export$8cea971c64639ea7(object, properties) {
    var copy = {};
    for(var i = 0; i < properties.length; i++){
        var key = properties[i];
        var value = object[key];
        if (value !== undefined) copy[key] = value;
    }
    return copy;
}
// helper function to test whether a string contains a path like 'user.name'
function $6ead8a5e53031912$var$isPath(str) {
    return str.includes('.');
}

});
parcelRegister("edQYF", function(module, exports) {

$parcel$export(module.exports, "isNumber", () => $a5ab5fced20f1bc1$export$7e4aa119212bc614);
$parcel$export(module.exports, "isBigNumber", () => $a5ab5fced20f1bc1$export$e51d0e7e5c4a03ab);
$parcel$export(module.exports, "isBigInt", () => $a5ab5fced20f1bc1$export$c4c1bdb0d1c7cfc7);
$parcel$export(module.exports, "isComplex", () => $a5ab5fced20f1bc1$export$8849a896711efe0c);
$parcel$export(module.exports, "isFraction", () => $a5ab5fced20f1bc1$export$e312cb8a8e5e7c34);
$parcel$export(module.exports, "isUnit", () => $a5ab5fced20f1bc1$export$8960dc335987b8da);
$parcel$export(module.exports, "isString", () => $a5ab5fced20f1bc1$export$844ec244b1367d54);
$parcel$export(module.exports, "isArray", () => $a5ab5fced20f1bc1$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMatrix", () => $a5ab5fced20f1bc1$export$b22160e0a14f87b7);
$parcel$export(module.exports, "isCollection", () => $a5ab5fced20f1bc1$export$cea7aa84e978eba5);
$parcel$export(module.exports, "isDenseMatrix", () => $a5ab5fced20f1bc1$export$eb44495df7ba11d);
$parcel$export(module.exports, "isSparseMatrix", () => $a5ab5fced20f1bc1$export$d508368d4da3c38a);
$parcel$export(module.exports, "isRange", () => $a5ab5fced20f1bc1$export$e331ccfa6f694c99);
$parcel$export(module.exports, "isIndex", () => $a5ab5fced20f1bc1$export$ba3dc792055c2f45);
$parcel$export(module.exports, "isBoolean", () => $a5ab5fced20f1bc1$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isResultSet", () => $a5ab5fced20f1bc1$export$381a1a20e6a63376);
$parcel$export(module.exports, "isHelp", () => $a5ab5fced20f1bc1$export$e5dec9a75b602d6c);
$parcel$export(module.exports, "isFunction", () => $a5ab5fced20f1bc1$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isDate", () => $a5ab5fced20f1bc1$export$871608497c498473);
$parcel$export(module.exports, "isRegExp", () => $a5ab5fced20f1bc1$export$49841c62b9eff15);
$parcel$export(module.exports, "isObject", () => $a5ab5fced20f1bc1$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isMap", () => $a5ab5fced20f1bc1$export$5c90113a285f2241);
$parcel$export(module.exports, "isNull", () => $a5ab5fced20f1bc1$export$630801d484da15df);
$parcel$export(module.exports, "isUndefined", () => $a5ab5fced20f1bc1$export$fce6876652108ab);
$parcel$export(module.exports, "isAccessorNode", () => $a5ab5fced20f1bc1$export$f88fb19d6b9ee5cb);
$parcel$export(module.exports, "isArrayNode", () => $a5ab5fced20f1bc1$export$440fa93dcf2757a3);
$parcel$export(module.exports, "isAssignmentNode", () => $a5ab5fced20f1bc1$export$64d7d515ec030d5e);
$parcel$export(module.exports, "isBlockNode", () => $a5ab5fced20f1bc1$export$1665e2275a3d717a);
$parcel$export(module.exports, "isConditionalNode", () => $a5ab5fced20f1bc1$export$e1babefe78c70737);
$parcel$export(module.exports, "isConstantNode", () => $a5ab5fced20f1bc1$export$fa9d80731fd8c54b);
$parcel$export(module.exports, "isOperatorNode", () => $a5ab5fced20f1bc1$export$7e624cbaab6cce94);
$parcel$export(module.exports, "isFunctionAssignmentNode", () => $a5ab5fced20f1bc1$export$27c05cfffd263d30);
$parcel$export(module.exports, "isFunctionNode", () => $a5ab5fced20f1bc1$export$6ae03b16e064e6c4);
$parcel$export(module.exports, "isIndexNode", () => $a5ab5fced20f1bc1$export$ff90979121a6cabc);
$parcel$export(module.exports, "isNode", () => $a5ab5fced20f1bc1$export$8ee0fc9ee280b4ee);
$parcel$export(module.exports, "isObjectNode", () => $a5ab5fced20f1bc1$export$3f18867a334658e9);
$parcel$export(module.exports, "isParenthesisNode", () => $a5ab5fced20f1bc1$export$c55e3736c5721220);
$parcel$export(module.exports, "isRangeNode", () => $a5ab5fced20f1bc1$export$92729c5c4ff6fc83);
$parcel$export(module.exports, "isRelationalNode", () => $a5ab5fced20f1bc1$export$51bc4e372ab35935);
$parcel$export(module.exports, "isSymbolNode", () => $a5ab5fced20f1bc1$export$87815d550facaed9);
$parcel$export(module.exports, "isChain", () => $a5ab5fced20f1bc1$export$dc36953d0b3a4f05);
$parcel$export(module.exports, "typeOf", () => $a5ab5fced20f1bc1$export$f5bbd400c2f4426f);
// type checks for all known types
//
// note that:
//
// - check by duck-typing on a property like `isUnit`, instead of checking instanceof.
//   instanceof cannot be used because that would not allow to pass data from
//   one instance of math.js to another since each has it's own instance of Unit.
// - check the `isUnit` property via the constructor, so there will be no
//   matches for "fake" instances like plain objects with a property `isUnit`.
//   That is important for security reasons.
// - It must not be possible to override the type checks used internally,
//   for security reasons, so these functions are not exposed in the expression
//   parser.

var $8ti5P = parcelRequire("8ti5P");
function $a5ab5fced20f1bc1$export$7e4aa119212bc614(x) {
    return typeof x === 'number';
}
function $a5ab5fced20f1bc1$export$e51d0e7e5c4a03ab(x) {
    if (!x || typeof x !== 'object' || typeof x.constructor !== 'function') return false;
    if (x.isBigNumber === true && typeof x.constructor.prototype === 'object' && x.constructor.prototype.isBigNumber === true) return true;
    if (typeof x.constructor.isDecimal === 'function' && x.constructor.isDecimal(x) === true) return true;
    return false;
}
function $a5ab5fced20f1bc1$export$c4c1bdb0d1c7cfc7(x) {
    return typeof x === 'bigint';
}
function $a5ab5fced20f1bc1$export$8849a896711efe0c(x) {
    return x && typeof x === 'object' && Object.getPrototypeOf(x).isComplex === true || false;
}
function $a5ab5fced20f1bc1$export$e312cb8a8e5e7c34(x) {
    return x && typeof x === 'object' && Object.getPrototypeOf(x).isFraction === true || false;
}
function $a5ab5fced20f1bc1$export$8960dc335987b8da(x) {
    return x && x.constructor.prototype.isUnit === true || false;
}
function $a5ab5fced20f1bc1$export$844ec244b1367d54(x) {
    return typeof x === 'string';
}
var $a5ab5fced20f1bc1$export$43bee75e5e14138e = Array.isArray;
function $a5ab5fced20f1bc1$export$b22160e0a14f87b7(x) {
    return x && x.constructor.prototype.isMatrix === true || false;
}
function $a5ab5fced20f1bc1$export$cea7aa84e978eba5(x) {
    return Array.isArray(x) || $a5ab5fced20f1bc1$export$b22160e0a14f87b7(x);
}
function $a5ab5fced20f1bc1$export$eb44495df7ba11d(x) {
    return x && x.isDenseMatrix && x.constructor.prototype.isMatrix === true || false;
}
function $a5ab5fced20f1bc1$export$d508368d4da3c38a(x) {
    return x && x.isSparseMatrix && x.constructor.prototype.isMatrix === true || false;
}
function $a5ab5fced20f1bc1$export$e331ccfa6f694c99(x) {
    return x && x.constructor.prototype.isRange === true || false;
}
function $a5ab5fced20f1bc1$export$ba3dc792055c2f45(x) {
    return x && x.constructor.prototype.isIndex === true || false;
}
function $a5ab5fced20f1bc1$export$f9ce7b637dfbe238(x) {
    return typeof x === 'boolean';
}
function $a5ab5fced20f1bc1$export$381a1a20e6a63376(x) {
    return x && x.constructor.prototype.isResultSet === true || false;
}
function $a5ab5fced20f1bc1$export$e5dec9a75b602d6c(x) {
    return x && x.constructor.prototype.isHelp === true || false;
}
function $a5ab5fced20f1bc1$export$f6e2535fb5126e54(x) {
    return typeof x === 'function';
}
function $a5ab5fced20f1bc1$export$871608497c498473(x) {
    return x instanceof Date;
}
function $a5ab5fced20f1bc1$export$49841c62b9eff15(x) {
    return x instanceof RegExp;
}
function $a5ab5fced20f1bc1$export$a6cdc56e425d0d0a(x) {
    return !!(x && typeof x === 'object' && x.constructor === Object && !$a5ab5fced20f1bc1$export$8849a896711efe0c(x) && !$a5ab5fced20f1bc1$export$e312cb8a8e5e7c34(x));
}
function $a5ab5fced20f1bc1$export$5c90113a285f2241(object) {
    // We can use the fast instanceof, or a slower duck typing check.
    // The duck typing method needs to cover enough methods to not be confused with DenseMatrix.
    if (!object) return false;
    return object instanceof Map || object instanceof (0, $8ti5P.ObjectWrappingMap) || typeof object.set === 'function' && typeof object.get === 'function' && typeof object.keys === 'function' && typeof object.has === 'function';
}
function $a5ab5fced20f1bc1$export$1677abdd52c92b9c(object) {
    return $a5ab5fced20f1bc1$export$5c90113a285f2241(object) && $a5ab5fced20f1bc1$export$5c90113a285f2241(object.a) && $a5ab5fced20f1bc1$export$5c90113a285f2241(object.b);
}
function $a5ab5fced20f1bc1$export$2415f7cdc54d91b7(object) {
    return $a5ab5fced20f1bc1$export$5c90113a285f2241(object) && $a5ab5fced20f1bc1$export$a6cdc56e425d0d0a(object.wrappedObject);
}
function $a5ab5fced20f1bc1$export$630801d484da15df(x) {
    return x === null;
}
function $a5ab5fced20f1bc1$export$fce6876652108ab(x) {
    return x === undefined;
}
function $a5ab5fced20f1bc1$export$f88fb19d6b9ee5cb(x) {
    return x && x.isAccessorNode === true && x.constructor.prototype.isNode === true || false;
}
function $a5ab5fced20f1bc1$export$440fa93dcf2757a3(x) {
    return x && x.isArrayNode === true && x.constructor.prototype.isNode === true || false;
}
function $a5ab5fced20f1bc1$export$64d7d515ec030d5e(x) {
    return x && x.isAssignmentNode === true && x.constructor.prototype.isNode === true || false;
}
function $a5ab5fced20f1bc1$export$1665e2275a3d717a(x) {
    return x && x.isBlockNode === true && x.constructor.prototype.isNode === true || false;
}
function $a5ab5fced20f1bc1$export$e1babefe78c70737(x) {
    return x && x.isConditionalNode === true && x.constructor.prototype.isNode === true || false;
}
function $a5ab5fced20f1bc1$export$fa9d80731fd8c54b(x) {
    return x && x.isConstantNode === true && x.constructor.prototype.isNode === true || false;
}
function $a5ab5fced20f1bc1$export$e6caeb7474dbdff3(node) {
    return $a5ab5fced20f1bc1$export$fa9d80731fd8c54b(node) || $a5ab5fced20f1bc1$export$7e624cbaab6cce94(node) && node.args.length === 1 && $a5ab5fced20f1bc1$export$fa9d80731fd8c54b(node.args[0]) && '-+~'.includes(node.op);
}
function $a5ab5fced20f1bc1$export$27c05cfffd263d30(x) {
    return x && x.isFunctionAssignmentNode === true && x.constructor.prototype.isNode === true || false;
}
function $a5ab5fced20f1bc1$export$6ae03b16e064e6c4(x) {
    return x && x.isFunctionNode === true && x.constructor.prototype.isNode === true || false;
}
function $a5ab5fced20f1bc1$export$ff90979121a6cabc(x) {
    return x && x.isIndexNode === true && x.constructor.prototype.isNode === true || false;
}
function $a5ab5fced20f1bc1$export$8ee0fc9ee280b4ee(x) {
    return x && x.isNode === true && x.constructor.prototype.isNode === true || false;
}
function $a5ab5fced20f1bc1$export$3f18867a334658e9(x) {
    return x && x.isObjectNode === true && x.constructor.prototype.isNode === true || false;
}
function $a5ab5fced20f1bc1$export$7e624cbaab6cce94(x) {
    return x && x.isOperatorNode === true && x.constructor.prototype.isNode === true || false;
}
function $a5ab5fced20f1bc1$export$c55e3736c5721220(x) {
    return x && x.isParenthesisNode === true && x.constructor.prototype.isNode === true || false;
}
function $a5ab5fced20f1bc1$export$92729c5c4ff6fc83(x) {
    return x && x.isRangeNode === true && x.constructor.prototype.isNode === true || false;
}
function $a5ab5fced20f1bc1$export$51bc4e372ab35935(x) {
    return x && x.isRelationalNode === true && x.constructor.prototype.isNode === true || false;
}
function $a5ab5fced20f1bc1$export$87815d550facaed9(x) {
    return x && x.isSymbolNode === true && x.constructor.prototype.isNode === true || false;
}
function $a5ab5fced20f1bc1$export$dc36953d0b3a4f05(x) {
    return x && x.constructor.prototype.isChain === true || false;
}
function $a5ab5fced20f1bc1$export$f5bbd400c2f4426f(x) {
    var t = typeof x;
    if (t === 'object') {
        if (x === null) return 'null';
        if ($a5ab5fced20f1bc1$export$e51d0e7e5c4a03ab(x)) return 'BigNumber'; // Special: weird mashup with Decimal
        if (x.constructor && x.constructor.name) return x.constructor.name;
        return 'Object'; // just in case
    }
    return t; // can be 'string', 'number', 'boolean', 'function', 'bigint', ...
}

});
parcelRegister("8ti5P", function(module, exports) {

$parcel$export(module.exports, "ObjectWrappingMap", () => $62af11125e7c002d$export$6f491f8f4fd27271);

var $1q0jW = parcelRequire("1q0jW");

var $edQYF = parcelRequire("edQYF");
class $62af11125e7c002d$export$6f491f8f4fd27271 {
    constructor(object){
        this.wrappedObject = object;
        this[Symbol.iterator] = this.entries;
    }
    keys() {
        return Object.keys(this.wrappedObject).filter((key)=>this.has(key)).values();
    }
    get(key) {
        return (0, $1q0jW.getSafeProperty)(this.wrappedObject, key);
    }
    set(key, value) {
        (0, $1q0jW.setSafeProperty)(this.wrappedObject, key, value);
        return this;
    }
    has(key) {
        return (0, $1q0jW.isSafeProperty)(this.wrappedObject, key) && key in this.wrappedObject;
    }
    entries() {
        return $62af11125e7c002d$var$mapIterator(this.keys(), (key)=>[
                key,
                this.get(key)
            ]);
    }
    forEach(callback) {
        for (var key of this.keys())callback(this.get(key), key, this);
    }
    delete(key) {
        if ((0, $1q0jW.isSafeProperty)(this.wrappedObject, key)) delete this.wrappedObject[key];
    }
    clear() {
        for (var key of this.keys())this.delete(key);
    }
    get size() {
        return Object.keys(this.wrappedObject).length;
    }
}
class $62af11125e7c002d$export$93f35497d1acacc3 {
    /**
   * @param {Map} a
   * @param {Map} b
   * @param {Set} bKeys
   */ constructor(a, b, bKeys){
        this.a = a;
        this.b = b;
        this.bKeys = bKeys;
        this[Symbol.iterator] = this.entries;
    }
    get(key) {
        return this.bKeys.has(key) ? this.b.get(key) : this.a.get(key);
    }
    set(key, value) {
        if (this.bKeys.has(key)) this.b.set(key, value);
        else this.a.set(key, value);
        return this;
    }
    has(key) {
        return this.b.has(key) || this.a.has(key);
    }
    keys() {
        return new Set([
            ...this.a.keys(),
            ...this.b.keys()
        ])[Symbol.iterator]();
    }
    entries() {
        return $62af11125e7c002d$var$mapIterator(this.keys(), (key)=>[
                key,
                this.get(key)
            ]);
    }
    forEach(callback) {
        for (var key of this.keys())callback(this.get(key), key, this);
    }
    delete(key) {
        return this.bKeys.has(key) ? this.b.delete(key) : this.a.delete(key);
    }
    clear() {
        this.a.clear();
        this.b.clear();
    }
    get size() {
        return [
            ...this.keys()
        ].length;
    }
}
/**
 * Create a new iterator that maps over the provided iterator, applying a mapping function to each item
 */ function $62af11125e7c002d$var$mapIterator(it, callback) {
    return {
        next: ()=>{
            var n = it.next();
            return n.done ? n : {
                value: callback(n.value),
                done: false
            };
        }
    };
}
function $62af11125e7c002d$export$89a4bcaf5b4d37d2() {
    return new Map();
}
function $62af11125e7c002d$export$d49c9aa30b771d59(mapOrObject) {
    if (!mapOrObject) return $62af11125e7c002d$export$89a4bcaf5b4d37d2();
    if ((0, $edQYF.isMap)(mapOrObject)) return mapOrObject;
    if ((0, $edQYF.isObject)(mapOrObject)) return new $62af11125e7c002d$export$6f491f8f4fd27271(mapOrObject);
    throw new Error('createMap can create maps from objects or Maps');
}
function $62af11125e7c002d$export$697e4a1b90752ce2(map) {
    if (map instanceof $62af11125e7c002d$export$6f491f8f4fd27271) return map.wrappedObject;
    var object = {};
    for (var key of map.keys()){
        var value = map.get(key);
        (0, $1q0jW.setSafeProperty)(object, key, value);
    }
    return object;
}
function $62af11125e7c002d$export$e6e34fd1f2686227(map) {
    for(var _len = arguments.length, objects = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)objects[_key - 1] = arguments[_key];
    for (var args of objects){
        if (!args) continue;
        if ((0, $edQYF.isMap)(args)) for (var key of args.keys())map.set(key, args.get(key));
        else if ((0, $edQYF.isObject)(args)) for (var _key2 of Object.keys(args))map.set(_key2, args[_key2]);
    }
    return map;
}

});
parcelRegister("1q0jW", function(module, exports) {

$parcel$export(module.exports, "getSafeProperty", () => $108877d934138252$export$87a87648a1961976);
$parcel$export(module.exports, "isSafeProperty", () => $108877d934138252$export$3039c640f3cfc12a);
$parcel$export(module.exports, "setSafeProperty", () => $108877d934138252$export$e99fe8700ee9f9cd);

var $9v8q6 = parcelRequire("9v8q6");
/**
 * Get a property of a plain object
 * Throws an error in case the object is not a plain object or the
 * property is not defined on the object itself
 * @param {Object} object
 * @param {string} prop
 * @return {*} Returns the property value when safe
 */ function $108877d934138252$export$87a87648a1961976(object, prop) {
    // only allow getting safe properties of a plain object
    if ($108877d934138252$export$3039c640f3cfc12a(object, prop)) return object[prop];
    if (typeof object[prop] === 'function' && $108877d934138252$export$2220a91638ab1d9e(object, prop)) throw new Error('Cannot access method "' + prop + '" as a property');
    throw new Error('No access to property "' + prop + '"');
}
/**
 * Set a property on a plain object.
 * Throws an error in case the object is not a plain object or the
 * property would override an inherited property like .constructor or .toString
 * @param {Object} object
 * @param {string} prop
 * @param {*} value
 * @return {*} Returns the value
 */ // TODO: merge this function into access.js?
function $108877d934138252$export$e99fe8700ee9f9cd(object, prop, value) {
    // only allow setting safe properties of a plain object
    if ($108877d934138252$export$3039c640f3cfc12a(object, prop)) {
        object[prop] = value;
        return value;
    }
    throw new Error('No access to property "' + prop + '"');
}
/**
 * Test whether a property is safe to use on an object or Array.
 * For example .toString and .constructor are not safe
 * @param {Object | Array} object
 * @param {string} prop
 * @return {boolean} Returns true when safe
 */ function $108877d934138252$export$3039c640f3cfc12a(object, prop) {
    if (!$108877d934138252$export$53b83ca8eaab0383(object) && !Array.isArray(object)) return false;
    // SAFE: whitelisted
    // e.g length
    if ((0, $9v8q6.hasOwnProperty)($108877d934138252$var$safeNativeProperties, prop)) return true;
    // UNSAFE: inherited from Object prototype
    // e.g constructor
    if (prop in Object.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Object.prototype is a root object
    return false;
    // UNSAFE: inherited from Function prototype
    // e.g call, apply
    if (prop in Function.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Function.prototype is a root object
    return false;
    return true;
}
/**
 * Validate whether a method is safe.
 * Throws an error when that's not the case.
 * @param {Object} object
 * @param {string} method
 * @return {function} Returns the method when valid
 */ function $108877d934138252$export$94fda296bbe7ba21(object, method) {
    if (!$108877d934138252$export$2220a91638ab1d9e(object, method)) throw new Error('No access to method "' + method + '"');
    return object[method];
}
/**
 * Check whether a method is safe.
 * Throws an error when that's not the case (for example for `constructor`).
 * @param {Object} object
 * @param {string} method
 * @return {boolean} Returns true when safe, false otherwise
 */ function $108877d934138252$export$2220a91638ab1d9e(object, method) {
    if (object === null || object === undefined || typeof object[method] !== 'function') return false;
    // UNSAFE: ghosted
    // e.g overridden toString
    // Note that IE10 doesn't support __proto__ and we can't do this check there.
    if ((0, $9v8q6.hasOwnProperty)(object, method) && Object.getPrototypeOf && method in Object.getPrototypeOf(object)) return false;
    // SAFE: whitelisted
    // e.g toString
    if ((0, $9v8q6.hasOwnProperty)($108877d934138252$var$safeNativeMethods, method)) return true;
    // UNSAFE: inherited from Object prototype
    // e.g constructor
    if (method in Object.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Object.prototype is a root object
    return false;
    // UNSAFE: inherited from Function prototype
    // e.g call, apply
    if (method in Function.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Function.prototype is a root object
    return false;
    return true;
}
function $108877d934138252$export$53b83ca8eaab0383(object) {
    return typeof object === 'object' && object && object.constructor === Object;
}
var $108877d934138252$var$safeNativeProperties = {
    length: true,
    name: true
};
var $108877d934138252$var$safeNativeMethods = {
    toString: true,
    valueOf: true,
    toLocaleString: true
};

});






parcelRegister("jPu3R", function(module, exports) {

$parcel$export(module.exports, "createAbs", () => $e6fa194a9c50e2e1$export$dd8a9b3843a4df95);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");

var $dmcGu = parcelRequire("dmcGu");
var $e6fa194a9c50e2e1$var$name = 'abs';
var $e6fa194a9c50e2e1$var$dependencies = [
    'typed'
];
var $e6fa194a9c50e2e1$export$dd8a9b3843a4df95 = /* #__PURE__ */ (0, $dsu7t.factory)($e6fa194a9c50e2e1$var$name, $e6fa194a9c50e2e1$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the absolute value of a number. For matrices, the function is
   * evaluated element wise.
   *
   * Syntax:
   *
   *    math.abs(x)
   *
   * Examples:
   *
   *    math.abs(3.5)                // returns number 3.5
   *    math.abs(-4.2)               // returns number 4.2
   *
   *    math.abs([3, -5, -1, 0, 2])  // returns Array [3, 5, 1, 0, 2]
   *
   * See also:
   *
   *    sign
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Array | Matrix | Unit} x
   *            A number or matrix for which to get the absolute value
   * @return {number | BigNumber | bigint | Fraction | Complex | Array | Matrix | Unit}
   *            Absolute value of `x`
   */ return typed($e6fa194a9c50e2e1$var$name, {
        number: (0, $dmcGu.absNumber),
        'Complex | BigNumber | Fraction | Unit': (x)=>x.abs(),
        bigint: (x)=>x < 0n ? -x : x,
        // deep map collection, skip zeros since abs(0) = 0
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self, true))
    });
});

});
parcelRegister("dsu7t", function(module, exports) {

$parcel$export(module.exports, "factory", () => $9cc540fb0f82ea75$export$e9008f2713103c6c);

var $9v8q6 = parcelRequire("9v8q6");
function $9cc540fb0f82ea75$export$e9008f2713103c6c(name, dependencies, create, meta) {
    function assertAndCreate(scope) {
        // we only pass the requested dependencies to the factory function
        // to prevent functions to rely on dependencies that are not explicitly
        // requested.
        var deps = (0, $9v8q6.pickShallow)(scope, dependencies.map($9cc540fb0f82ea75$export$2f4d32a1468e229c));
        $9cc540fb0f82ea75$export$19a2c26dad95d6e7(name, dependencies, scope);
        return create(deps);
    }
    assertAndCreate.isFactory = true;
    assertAndCreate.fn = name;
    assertAndCreate.dependencies = dependencies.slice().sort();
    if (meta) assertAndCreate.meta = meta;
    return assertAndCreate;
}
function $9cc540fb0f82ea75$export$883f1d394ed355c(factories) {
    var factoriesByName = {};
    factories.forEach((factory)=>{
        factoriesByName[factory.fn] = factory;
    });
    function containsDependency(factory, dependency) {
        // TODO: detect circular references
        if ($9cc540fb0f82ea75$export$34763cfbed1075c2(factory)) {
            if (factory.dependencies.includes(dependency.fn || dependency.name)) return true;
            if (factory.dependencies.some((d)=>containsDependency(factoriesByName[d], dependency))) return true;
        }
        return false;
    }
    var sorted = [];
    function addFactory(factory) {
        var index = 0;
        while(index < sorted.length && !containsDependency(sorted[index], factory))index++;
        sorted.splice(index, 0, factory);
    }
    // sort regular factory functions
    factories.filter($9cc540fb0f82ea75$export$34763cfbed1075c2).forEach(addFactory);
    // sort legacy factory functions AFTER the regular factory functions
    factories.filter((factory)=>!$9cc540fb0f82ea75$export$34763cfbed1075c2(factory)).forEach(addFactory);
    return sorted;
}
function $9cc540fb0f82ea75$export$185802fd694ee1f5(factories) {
    var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $9cc540fb0f82ea75$export$883f1d394ed355c(factories).forEach((factory)=>factory(scope));
    return scope;
}
function $9cc540fb0f82ea75$export$34763cfbed1075c2(obj) {
    return typeof obj === 'function' && typeof obj.fn === 'string' && Array.isArray(obj.dependencies);
}
function $9cc540fb0f82ea75$export$19a2c26dad95d6e7(name, dependencies, scope) {
    var allDefined = dependencies.filter((dependency)=>!$9cc540fb0f82ea75$export$1399ac7f45b04b5(dependency)) // filter optionals
    .every((dependency)=>scope[dependency] !== undefined);
    if (!allDefined) {
        var missingDependencies = dependencies.filter((dependency)=>scope[dependency] === undefined);
        // TODO: create a custom error class for this, a MathjsError or something like that
        throw new Error("Cannot create function \"".concat(name, "\", ") + "some dependencies are missing: ".concat(missingDependencies.map((d)=>"\"".concat(d, "\"")).join(', '), "."));
    }
}
function $9cc540fb0f82ea75$export$1399ac7f45b04b5(dependency) {
    return dependency && dependency[0] === '?';
}
function $9cc540fb0f82ea75$export$2f4d32a1468e229c(dependency) {
    return dependency && dependency[0] === '?' ? dependency.slice(1) : dependency;
}

});

parcelRegister("20mkw", function(module, exports) {

$parcel$export(module.exports, "containsCollections", () => $175ce7258a0800d7$export$4d8f6a27e2f5bcb2);
$parcel$export(module.exports, "deepForEach", () => $175ce7258a0800d7$export$519ada94592b97fc);
$parcel$export(module.exports, "deepMap", () => $175ce7258a0800d7$export$ce7eaaed37329a1b);
$parcel$export(module.exports, "reduce", () => $175ce7258a0800d7$export$533b26079ad0b4b);
$parcel$export(module.exports, "scatter", () => $175ce7258a0800d7$export$c97954fff4307550);

var $edQYF = parcelRequire("edQYF");

var $fFsPN = parcelRequire("fFsPN");

var $d80Xp = parcelRequire("d80Xp");

var $3Wq9u = parcelRequire("3Wq9u");
function $175ce7258a0800d7$export$4d8f6a27e2f5bcb2(array) {
    for(var i = 0; i < array.length; i++){
        if ((0, $edQYF.isCollection)(array[i])) return true;
    }
    return false;
}
function $175ce7258a0800d7$export$519ada94592b97fc(array, callback) {
    if ((0, $edQYF.isMatrix)(array)) array.forEach((x)=>callback(x), false, true);
    else (0, $d80Xp.deepForEach)(array, callback, true);
}
function $175ce7258a0800d7$export$ce7eaaed37329a1b(array, callback, skipZeros) {
    if (!skipZeros) {
        if ((0, $edQYF.isMatrix)(array)) return array.map((x)=>callback(x), false, true);
        else return (0, $d80Xp.deepMap)(array, callback, true);
    }
    var skipZerosCallback = (x)=>x === 0 ? x : callback(x);
    if ((0, $edQYF.isMatrix)(array)) return array.map((x)=>skipZerosCallback(x), false, true);
    else return (0, $d80Xp.deepMap)(array, skipZerosCallback, true);
}
function $175ce7258a0800d7$export$533b26079ad0b4b(mat, dim, callback) {
    var size = Array.isArray(mat) ? (0, $d80Xp.arraySize)(mat) : mat.size();
    if (dim < 0 || dim >= size.length) // TODO: would be more clear when throwing a DimensionError here
    throw new (0, $fFsPN.IndexError)(dim, size.length);
    if ((0, $edQYF.isMatrix)(mat)) return mat.create($175ce7258a0800d7$var$_reduce(mat.valueOf(), dim, callback), mat.datatype());
    else return $175ce7258a0800d7$var$_reduce(mat, dim, callback);
}
/**
 * Recursively reduce a matrix
 * @param {Array} mat
 * @param {number} dim
 * @param {Function} callback
 * @returns {Array} ret
 * @private
 */ function $175ce7258a0800d7$var$_reduce(mat, dim, callback) {
    var i, ret, val, tran;
    if (dim <= 0) {
        if (!Array.isArray(mat[0])) {
            val = mat[0];
            for(i = 1; i < mat.length; i++)val = callback(val, mat[i]);
            return val;
        } else {
            tran = (0, $3Wq9u._switch)(mat);
            ret = [];
            for(i = 0; i < tran.length; i++)ret[i] = $175ce7258a0800d7$var$_reduce(tran[i], dim - 1, callback);
            return ret;
        }
    } else {
        ret = [];
        for(i = 0; i < mat.length; i++)ret[i] = $175ce7258a0800d7$var$_reduce(mat[i], dim - 1, callback);
        return ret;
    }
}
function $175ce7258a0800d7$export$c97954fff4307550(a, j, w, x, u, mark, cindex, f, inverse, update, value) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr;
    // vars
    var k, k0, k1, i;
    // check we need to process values (pattern matrix)
    if (x) // values in j
    for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
        // row
        i = aindex[k];
        // check value exists in current j
        if (w[i] !== mark) {
            // i is new entry in j
            w[i] = mark;
            // add i to pattern of C
            cindex.push(i);
            // x(i) = A, check we need to call function this time
            if (update) {
                // copy value to workspace calling callback function
                x[i] = inverse ? f(avalues[k], value) : f(value, avalues[k]);
                // function was called on current row
                u[i] = mark;
            } else // copy value to workspace
            x[i] = avalues[k];
        } else {
            // i exists in C already
            x[i] = inverse ? f(avalues[k], x[i]) : f(x[i], avalues[k]);
            // function was called on current row
            u[i] = mark;
        }
    }
    else // values in j
    for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
        // row
        i = aindex[k];
        // check value exists in current j
        if (w[i] !== mark) {
            // i is new entry in j
            w[i] = mark;
            // add i to pattern of C
            cindex.push(i);
        } else // indicate function was called on current row
        u[i] = mark;
    }
}

});
parcelRegister("fFsPN", function(module, exports) {

$parcel$export(module.exports, "IndexError", () => $b6810d453159b1c6$export$efa5eacb1304c464);
/**
 * Create a range error with the message:
 *     'Index out of range (index < min)'
 *     'Index out of range (index < max)'
 *
 * @param {number} index     The actual index
 * @param {number} [min=0]   Minimum index (included)
 * @param {number} [max]     Maximum index (excluded)
 * @extends RangeError
 */ function $b6810d453159b1c6$export$efa5eacb1304c464(index, min, max) {
    if (!(this instanceof $b6810d453159b1c6$export$efa5eacb1304c464)) throw new SyntaxError('Constructor must be called with the new operator');
    this.index = index;
    if (arguments.length < 3) {
        this.min = 0;
        this.max = min;
    } else {
        this.min = min;
        this.max = max;
    }
    if (this.min !== undefined && this.index < this.min) this.message = 'Index out of range (' + this.index + ' < ' + this.min + ')';
    else if (this.max !== undefined && this.index >= this.max) this.message = 'Index out of range (' + this.index + ' > ' + (this.max - 1) + ')';
    else this.message = 'Index out of range (' + this.index + ')';
    this.stack = new Error().stack;
}
$b6810d453159b1c6$export$efa5eacb1304c464.prototype = new RangeError();
$b6810d453159b1c6$export$efa5eacb1304c464.prototype.constructor = RangeError;
$b6810d453159b1c6$export$efa5eacb1304c464.prototype.name = 'IndexError';
$b6810d453159b1c6$export$efa5eacb1304c464.prototype.isIndexError = true;

});

parcelRegister("d80Xp", function(module, exports) {

$parcel$export(module.exports, "arraySize", () => $98ecc3cdd88a122a$export$51ffaee4afb683a5);
$parcel$export(module.exports, "validate", () => $98ecc3cdd88a122a$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "validateIndexSourceSize", () => $98ecc3cdd88a122a$export$a406fce6a920be3c);
$parcel$export(module.exports, "validateIndex", () => $98ecc3cdd88a122a$export$3cfe3fbfec03f260);
$parcel$export(module.exports, "isEmptyIndex", () => $98ecc3cdd88a122a$export$1f3203c278bd022);
$parcel$export(module.exports, "resize", () => $98ecc3cdd88a122a$export$4380c87abf28fdf);
$parcel$export(module.exports, "reshape", () => $98ecc3cdd88a122a$export$9eaad88cf88cee2b);
$parcel$export(module.exports, "flatten", () => $98ecc3cdd88a122a$export$bffa455ba8c619a6);
$parcel$export(module.exports, "processSizesWildcard", () => $98ecc3cdd88a122a$export$d0efc868ac2c6822);
$parcel$export(module.exports, "squeeze", () => $98ecc3cdd88a122a$export$889c931173b77c2f);
$parcel$export(module.exports, "unsqueeze", () => $98ecc3cdd88a122a$export$5a07c5202d40a604);
$parcel$export(module.exports, "filter", () => $98ecc3cdd88a122a$export$3dea766d36a8935f);
$parcel$export(module.exports, "filterRegExp", () => $98ecc3cdd88a122a$export$322859471e81229d);
$parcel$export(module.exports, "identify", () => $98ecc3cdd88a122a$export$65e5b62a4c490288);
$parcel$export(module.exports, "generalize", () => $98ecc3cdd88a122a$export$d57ad8b840ad6a01);
$parcel$export(module.exports, "getArrayDataType", () => $98ecc3cdd88a122a$export$d31e00bf4359ea8b);
$parcel$export(module.exports, "concat", () => $98ecc3cdd88a122a$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "broadcastSizes", () => $98ecc3cdd88a122a$export$8b730531a4706abd);
$parcel$export(module.exports, "broadcastTo", () => $98ecc3cdd88a122a$export$ec9086aff2624eab);
$parcel$export(module.exports, "get", () => $98ecc3cdd88a122a$export$3988ae62b71be9a3);
$parcel$export(module.exports, "deepMap", () => $98ecc3cdd88a122a$export$ce7eaaed37329a1b);
$parcel$export(module.exports, "deepForEach", () => $98ecc3cdd88a122a$export$519ada94592b97fc);

var $3p9rK = parcelRequire("3p9rK");

var $6NnhX = parcelRequire("6NnhX");

var $edQYF = parcelRequire("edQYF");

var $j2hDb = parcelRequire("j2hDb");

var $7asMt = parcelRequire("7asMt");

var $fFsPN = parcelRequire("fFsPN");

var $9v8q6 = parcelRequire("9v8q6");
function $98ecc3cdd88a122a$export$51ffaee4afb683a5(x) {
    var s = [];
    while(Array.isArray(x)){
        s.push(x.length);
        x = x[0];
    }
    return s;
}
/**
 * Recursively validate whether each element in a multi dimensional array
 * has a size corresponding to the provided size array.
 * @param {Array} array    Array to be validated
 * @param {number[]} size  Array with the size of each dimension
 * @param {number} dim     Current dimension
 * @throws DimensionError
 * @private
 */ function $98ecc3cdd88a122a$var$_validate(array, size, dim) {
    var i;
    var len = array.length;
    if (len !== size[dim]) throw new (0, $7asMt.DimensionError)(len, size[dim]);
    if (dim < size.length - 1) {
        // recursively validate each child array
        var dimNext = dim + 1;
        for(i = 0; i < len; i++){
            var child = array[i];
            if (!Array.isArray(child)) throw new (0, $7asMt.DimensionError)(size.length - 1, size.length, '<');
            $98ecc3cdd88a122a$var$_validate(array[i], size, dimNext);
        }
    } else // last dimension. none of the children may be an array
    for(i = 0; i < len; i++){
        if (Array.isArray(array[i])) throw new (0, $7asMt.DimensionError)(size.length + 1, size.length, '>');
    }
}
function $98ecc3cdd88a122a$export$a22775fa5e2eebd9(array, size) {
    var isScalar = size.length === 0;
    if (isScalar) {
        // scalar
        if (Array.isArray(array)) throw new (0, $7asMt.DimensionError)(array.length, 0);
    } else // array
    $98ecc3cdd88a122a$var$_validate(array, size, 0);
}
function $98ecc3cdd88a122a$export$a406fce6a920be3c(value, index) {
    var valueSize = value.isMatrix ? value._size : $98ecc3cdd88a122a$export$51ffaee4afb683a5(value);
    var sourceSize = index._sourceSize;
    // checks if the source size is not null and matches the valueSize
    sourceSize.forEach((sourceDim, i)=>{
        if (sourceDim !== null && sourceDim !== valueSize[i]) throw new (0, $7asMt.DimensionError)(sourceDim, valueSize[i]);
    });
}
function $98ecc3cdd88a122a$export$3cfe3fbfec03f260(index, length) {
    if (index !== undefined) {
        if (!(0, $edQYF.isNumber)(index) || !(0, $6NnhX.isInteger)(index)) throw new TypeError('Index must be an integer (value: ' + index + ')');
        if (index < 0 || typeof length === 'number' && index >= length) throw new (0, $fFsPN.IndexError)(index, length);
    }
}
function $98ecc3cdd88a122a$export$1f3203c278bd022(index) {
    for(var i = 0; i < index._dimensions.length; ++i){
        var dimension = index._dimensions[i];
        if (dimension._data && (0, $edQYF.isArray)(dimension._data)) {
            if (dimension._size[0] === 0) return true;
        } else if (dimension.isRange) {
            if (dimension.start === dimension.end) return true;
        } else if ((0, $edQYF.isString)(dimension)) {
            if (dimension.length === 0) return true;
        }
    }
    return false;
}
function $98ecc3cdd88a122a$export$4380c87abf28fdf(array, size, defaultValue) {
    // check the type of the arguments
    if (!Array.isArray(size)) throw new TypeError('Array expected');
    if (size.length === 0) throw new Error('Resizing to scalar is not supported');
    // check whether size contains positive integers
    size.forEach(function(value) {
        if (!(0, $edQYF.isNumber)(value) || !(0, $6NnhX.isInteger)(value) || value < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $j2hDb.format)(size) + ')');
    });
    // convert number to an array
    if ((0, $edQYF.isNumber)(array) || (0, $edQYF.isBigNumber)(array)) array = [
        array
    ];
    // recursively resize the array
    var _defaultValue = defaultValue !== undefined ? defaultValue : 0;
    $98ecc3cdd88a122a$var$_resize(array, size, 0, _defaultValue);
    return array;
}
/**
 * Recursively resize a multi dimensional array
 * @param {Array} array         Array to be resized
 * @param {number[]} size       Array with the size of each dimension
 * @param {number} dim          Current dimension
 * @param {*} [defaultValue]    Value to be filled in new entries,
 *                              undefined by default.
 * @private
 */ function $98ecc3cdd88a122a$var$_resize(array, size, dim, defaultValue) {
    var i;
    var elem;
    var oldLen = array.length;
    var newLen = size[dim];
    var minLen = Math.min(oldLen, newLen);
    // apply new length
    array.length = newLen;
    if (dim < size.length - 1) {
        // non-last dimension
        var dimNext = dim + 1;
        // resize existing child arrays
        for(i = 0; i < minLen; i++){
            // resize child array
            elem = array[i];
            if (!Array.isArray(elem)) {
                elem = [
                    elem
                ]; // add a dimension
                array[i] = elem;
            }
            $98ecc3cdd88a122a$var$_resize(elem, size, dimNext, defaultValue);
        }
        // create new child arrays
        for(i = minLen; i < newLen; i++){
            // get child array
            elem = [];
            array[i] = elem;
            // resize new child array
            $98ecc3cdd88a122a$var$_resize(elem, size, dimNext, defaultValue);
        }
    } else {
        // last dimension
        // remove dimensions of existing values
        for(i = 0; i < minLen; i++)while(Array.isArray(array[i]))array[i] = array[i][0];
        // fill new elements with the default value
        for(i = minLen; i < newLen; i++)array[i] = defaultValue;
    }
}
function $98ecc3cdd88a122a$export$9eaad88cf88cee2b(array, sizes) {
    var flatArray = $98ecc3cdd88a122a$export$bffa455ba8c619a6(array, true); // since it has rectangular
    var currentLength = flatArray.length;
    if (!Array.isArray(array) || !Array.isArray(sizes)) throw new TypeError('Array expected');
    if (sizes.length === 0) throw new (0, $7asMt.DimensionError)(0, currentLength, '!=');
    sizes = $98ecc3cdd88a122a$export$d0efc868ac2c6822(sizes, currentLength);
    var newLength = $98ecc3cdd88a122a$var$product(sizes);
    if (currentLength !== newLength) throw new (0, $7asMt.DimensionError)(newLength, currentLength, '!=');
    try {
        return $98ecc3cdd88a122a$var$_reshape(flatArray, sizes);
    } catch (e) {
        if (e instanceof (0, $7asMt.DimensionError)) throw new (0, $7asMt.DimensionError)(newLength, currentLength, '!=');
        throw e;
    }
}
function $98ecc3cdd88a122a$export$d0efc868ac2c6822(sizes, currentLength) {
    var newLength = $98ecc3cdd88a122a$var$product(sizes);
    var processedSizes = sizes.slice();
    var WILDCARD = -1;
    var wildCardIndex = sizes.indexOf(WILDCARD);
    var isMoreThanOneWildcard = sizes.indexOf(WILDCARD, wildCardIndex + 1) >= 0;
    if (isMoreThanOneWildcard) throw new Error('More than one wildcard in sizes');
    var hasWildcard = wildCardIndex >= 0;
    var canReplaceWildcard = currentLength % newLength === 0;
    if (hasWildcard) {
        if (canReplaceWildcard) processedSizes[wildCardIndex] = -currentLength / newLength;
        else throw new Error('Could not replace wildcard, since ' + currentLength + ' is no multiple of ' + -newLength);
    }
    return processedSizes;
}
/**
 * Computes the product of all array elements.
 * @param {number[]} array Array of factors
 * @returns {number}            Product of all elements
 */ function $98ecc3cdd88a122a$var$product(array) {
    return array.reduce((prev, curr)=>prev * curr, 1);
}
/**
 * Iteratively re-shape a multi dimensional array to fit the specified dimensions
 * @param {Array} array           Array to be reshaped
 * @param {number[]} sizes  List of sizes for each dimension
 * @returns {Array}               Array whose data has been formatted to fit the
 *                                specified dimensions
 */ function $98ecc3cdd88a122a$var$_reshape(array, sizes) {
    // testing if there are enough elements for the requested shape
    var tmpArray = array;
    var tmpArray2;
    // for each dimension starting by the last one and ignoring the first one
    for(var sizeIndex = sizes.length - 1; sizeIndex > 0; sizeIndex--){
        var size = sizes[sizeIndex];
        tmpArray2 = [];
        // aggregate the elements of the current tmpArray in elements of the requested size
        var length = tmpArray.length / size;
        for(var i = 0; i < length; i++)tmpArray2.push(tmpArray.slice(i * size, (i + 1) * size));
        // set it as the new tmpArray for the next loop turn or for return
        tmpArray = tmpArray2;
    }
    return tmpArray;
}
function $98ecc3cdd88a122a$export$889c931173b77c2f(array, size) {
    var s = size || $98ecc3cdd88a122a$export$51ffaee4afb683a5(array);
    // squeeze outer dimensions
    while(Array.isArray(array) && array.length === 1){
        array = array[0];
        s.shift();
    }
    // find the first dimension to be squeezed
    var dims = s.length;
    while(s[dims - 1] === 1)dims--;
    // squeeze inner dimensions
    if (dims < s.length) {
        array = $98ecc3cdd88a122a$var$_squeeze(array, dims, 0);
        s.length = dims;
    }
    return array;
}
/**
 * Recursively squeeze a multi dimensional array
 * @param {Array} array
 * @param {number} dims Required number of dimensions
 * @param {number} dim  Current dimension
 * @returns {Array | *} Returns the squeezed array
 * @private
 */ function $98ecc3cdd88a122a$var$_squeeze(array, dims, dim) {
    var i, ii;
    if (dim < dims) {
        var next = dim + 1;
        for(i = 0, ii = array.length; i < ii; i++)array[i] = $98ecc3cdd88a122a$var$_squeeze(array[i], dims, next);
    } else while(Array.isArray(array))array = array[0];
    return array;
}
function $98ecc3cdd88a122a$export$5a07c5202d40a604(array, dims, outer, size) {
    var s = size || $98ecc3cdd88a122a$export$51ffaee4afb683a5(array);
    // unsqueeze outer dimensions
    if (outer) for(var i = 0; i < outer; i++){
        array = [
            array
        ];
        s.unshift(1);
    }
    // unsqueeze inner dimensions
    array = $98ecc3cdd88a122a$var$_unsqueeze(array, dims, 0);
    while(s.length < dims)s.push(1);
    return array;
}
/**
 * Recursively unsqueeze a multi dimensional array
 * @param {Array} array
 * @param {number} dims Required number of dimensions
 * @param {number} dim  Current dimension
 * @returns {Array | *} Returns the unsqueezed array
 * @private
 */ function $98ecc3cdd88a122a$var$_unsqueeze(array, dims, dim) {
    var i, ii;
    if (Array.isArray(array)) {
        var next = dim + 1;
        for(i = 0, ii = array.length; i < ii; i++)array[i] = $98ecc3cdd88a122a$var$_unsqueeze(array[i], dims, next);
    } else for(var d = dim; d < dims; d++)array = [
        array
    ];
    return array;
}
function $98ecc3cdd88a122a$export$bffa455ba8c619a6(array) {
    var isRectangular = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!Array.isArray(array)) // if not an array, return as is
    return array;
    if (typeof isRectangular !== 'boolean') throw new TypeError('Boolean expected for second argument of flatten');
    var flat = [];
    if (isRectangular) _flattenRectangular(array);
    else _flatten(array);
    return flat;
    function _flatten(array) {
        for(var i = 0; i < array.length; i++){
            var item = array[i];
            if (Array.isArray(item)) _flatten(item);
            else flat.push(item);
        }
    }
    function _flattenRectangular(array) {
        if (Array.isArray(array[0])) for(var i = 0; i < array.length; i++)_flattenRectangular(array[i]);
        else for(var _i = 0; _i < array.length; _i++)flat.push(array[_i]);
    }
}
function $98ecc3cdd88a122a$export$871de8747c9eaa88(array, callback) {
    return Array.prototype.map.call(array, callback);
}
function $98ecc3cdd88a122a$export$4b80e395e36b5a56(array, callback) {
    Array.prototype.forEach.call(array, callback);
}
function $98ecc3cdd88a122a$export$3dea766d36a8935f(array, callback) {
    if ($98ecc3cdd88a122a$export$51ffaee4afb683a5(array).length !== 1) throw new Error('Only one dimensional matrices supported');
    return Array.prototype.filter.call(array, callback);
}
function $98ecc3cdd88a122a$export$322859471e81229d(array, regexp) {
    if ($98ecc3cdd88a122a$export$51ffaee4afb683a5(array).length !== 1) throw new Error('Only one dimensional matrices supported');
    return Array.prototype.filter.call(array, (entry)=>regexp.test(entry));
}
function $98ecc3cdd88a122a$export$f7e2c8231c57a8bd(array, separator) {
    return Array.prototype.join.call(array, separator);
}
function $98ecc3cdd88a122a$export$65e5b62a4c490288(a) {
    if (!Array.isArray(a)) throw new TypeError('Array input expected');
    if (a.length === 0) return a;
    var b = [];
    var count = 0;
    b[0] = {
        value: a[0],
        identifier: 0
    };
    for(var i = 1; i < a.length; i++){
        if (a[i] === a[i - 1]) count++;
        else count = 0;
        b.push({
            value: a[i],
            identifier: count
        });
    }
    return b;
}
function $98ecc3cdd88a122a$export$d57ad8b840ad6a01(a) {
    if (!Array.isArray(a)) throw new TypeError('Array input expected');
    if (a.length === 0) return a;
    var b = [];
    for(var i = 0; i < a.length; i++)b.push(a[i].value);
    return b;
}
function $98ecc3cdd88a122a$export$d31e00bf4359ea8b(array, typeOf) {
    var type; // to hold type info
    var length = 0; // to hold length value to ensure it has consistent sizes
    for(var i = 0; i < array.length; i++){
        var item = array[i];
        var _isArray = Array.isArray(item);
        // Saving the target matrix row size
        if (i === 0 && _isArray) length = item.length;
        // If the current item is an array but the length does not equal the targetVectorSize
        if (_isArray && item.length !== length) return undefined;
        var itemType = _isArray ? $98ecc3cdd88a122a$export$d31e00bf4359ea8b(item, typeOf) // recurse into a nested array
         : typeOf(item);
        if (type === undefined) type = itemType; // first item
        else if (type !== itemType) return 'mixed';
    }
    return type;
}
function $98ecc3cdd88a122a$export$4c7897fafd92b108(array) {
    return array[array.length - 1];
}
function $98ecc3cdd88a122a$export$59ff82fc918bd7e3(array) {
    return array.slice(0, array.length - 1);
}
/**
 * Recursively concatenate two matrices.
 * The contents of the matrices are not cloned.
 * @param {Array} a             Multi dimensional array
 * @param {Array} b             Multi dimensional array
 * @param {number} concatDim    The dimension on which to concatenate (zero-based)
 * @param {number} dim          The current dim (zero-based)
 * @return {Array} c            The concatenated matrix
 * @private
 */ function $98ecc3cdd88a122a$var$concatRecursive(a, b, concatDim, dim) {
    if (dim < concatDim) {
        // recurse into next dimension
        if (a.length !== b.length) throw new (0, $7asMt.DimensionError)(a.length, b.length);
        var c = [];
        for(var i = 0; i < a.length; i++)c[i] = $98ecc3cdd88a122a$var$concatRecursive(a[i], b[i], concatDim, dim + 1);
        return c;
    } else // concatenate this dimension
    return a.concat(b);
}
function $98ecc3cdd88a122a$export$ee1b3e54f0441b22() {
    var arrays = Array.prototype.slice.call(arguments, 0, -1);
    var concatDim = Array.prototype.slice.call(arguments, -1);
    if (arrays.length === 1) return arrays[0];
    if (arrays.length > 1) return arrays.slice(1).reduce(function(A, B) {
        return $98ecc3cdd88a122a$var$concatRecursive(A, B, concatDim, 0);
    }, arrays[0]);
    else throw new Error('Wrong number of arguments in function concat');
}
function $98ecc3cdd88a122a$export$8b730531a4706abd() {
    for(var _len = arguments.length, sizes = new Array(_len), _key = 0; _key < _len; _key++)sizes[_key] = arguments[_key];
    var dimensions = sizes.map((s)=>s.length);
    var N = Math.max(...dimensions);
    var sizeMax = new Array(N).fill(null);
    // check for every size
    for(var i = 0; i < sizes.length; i++){
        var size = sizes[i];
        var dim = dimensions[i];
        for(var j = 0; j < dim; j++){
            var n = N - dim + j;
            if (size[j] > sizeMax[n]) sizeMax[n] = size[j];
        }
    }
    for(var _i2 = 0; _i2 < sizes.length; _i2++)$98ecc3cdd88a122a$export$9da4eac5423f8f77(sizes[_i2], sizeMax);
    return sizeMax;
}
function $98ecc3cdd88a122a$export$9da4eac5423f8f77(size, toSize) {
    var N = toSize.length;
    var dim = size.length;
    for(var j = 0; j < dim; j++){
        var n = N - dim + j;
        if (size[j] < toSize[n] && size[j] > 1 || size[j] > toSize[n]) throw new Error("shape mismatch: mismatch is found in arg with shape (".concat(size, ") not possible to broadcast dimension ").concat(dim, " with size ").concat(size[j], " to size ").concat(toSize[n]));
    }
}
function $98ecc3cdd88a122a$export$ec9086aff2624eab(array, toSize) {
    var Asize = $98ecc3cdd88a122a$export$51ffaee4afb683a5(array);
    if ((0, $9v8q6.deepStrictEqual)(Asize, toSize)) return array;
    $98ecc3cdd88a122a$export$9da4eac5423f8f77(Asize, toSize);
    var broadcastedSize = $98ecc3cdd88a122a$export$8b730531a4706abd(Asize, toSize);
    var N = broadcastedSize.length;
    var paddedSize = [
        ...Array(N - Asize.length).fill(1),
        ...Asize
    ];
    var A = $98ecc3cdd88a122a$export$9cd59f9826255e47(array);
    // reshape A if needed to make it ready for concat
    if (Asize.length < N) {
        A = $98ecc3cdd88a122a$export$9eaad88cf88cee2b(A, paddedSize);
        Asize = $98ecc3cdd88a122a$export$51ffaee4afb683a5(A);
    }
    // stretches the array on each dimension to make it the same size as index
    for(var dim = 0; dim < N; dim++)if (Asize[dim] < broadcastedSize[dim]) {
        A = $98ecc3cdd88a122a$export$1726ea10b1063b9f(A, broadcastedSize[dim], dim);
        Asize = $98ecc3cdd88a122a$export$51ffaee4afb683a5(A);
    }
    return A;
}
function $98ecc3cdd88a122a$export$fb727ea99e1eb85a() {
    for(var _len2 = arguments.length, arrays = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)arrays[_key2] = arguments[_key2];
    if (arrays.length === 0) throw new Error('Insufficient number of arguments in function broadcastArrays');
    if (arrays.length === 1) return arrays[0];
    var sizes = arrays.map(function(array) {
        return $98ecc3cdd88a122a$export$51ffaee4afb683a5(array);
    });
    var broadcastedSize = $98ecc3cdd88a122a$export$8b730531a4706abd(...sizes);
    var broadcastedArrays = [];
    arrays.forEach(function(array) {
        broadcastedArrays.push($98ecc3cdd88a122a$export$ec9086aff2624eab(array, broadcastedSize));
    });
    return broadcastedArrays;
}
function $98ecc3cdd88a122a$export$1726ea10b1063b9f(arrayToStretch, sizeToStretch, dimToStretch) {
    return $98ecc3cdd88a122a$export$ee1b3e54f0441b22(...Array(sizeToStretch).fill(arrayToStretch), dimToStretch);
}
function $98ecc3cdd88a122a$export$3988ae62b71be9a3(array, index) {
    if (!Array.isArray(array)) throw new Error('Array expected');
    var size = $98ecc3cdd88a122a$export$51ffaee4afb683a5(array);
    if (index.length !== size.length) throw new (0, $7asMt.DimensionError)(index.length, size.length);
    for(var x = 0; x < index.length; x++)$98ecc3cdd88a122a$export$3cfe3fbfec03f260(index[x], size[x]);
    return index.reduce((acc, curr)=>acc[curr], array);
}
function $98ecc3cdd88a122a$export$ce7eaaed37329a1b(array, callback) {
    var skipIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (array.length === 0) return [];
    if (skipIndex) return recursiveMap(array);
    var index = [];
    return recursiveMapWithIndex(array, 0);
    function recursiveMapWithIndex(value, depth) {
        if (Array.isArray(value)) {
            var N = value.length;
            var result = Array(N);
            for(var i = 0; i < N; i++){
                index[depth] = i;
                result[i] = recursiveMapWithIndex(value[i], depth + 1);
            }
            return result;
        } else return callback(value, index.slice(0, depth), array);
    }
    function recursiveMap(value) {
        if (Array.isArray(value)) {
            var N = value.length;
            var result = Array(N);
            for(var i = 0; i < N; i++)result[i] = recursiveMap(value[i]);
            return result;
        } else return callback(value);
    }
}
function $98ecc3cdd88a122a$export$519ada94592b97fc(array, callback) {
    var skipIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (array.length === 0) return;
    if (skipIndex) {
        recursiveForEach(array);
        return;
    }
    var index = [];
    recursiveForEachWithIndex(array, 0);
    function recursiveForEachWithIndex(value, depth) {
        if (Array.isArray(value)) {
            var N = value.length;
            for(var i = 0; i < N; i++){
                index[depth] = i;
                recursiveForEachWithIndex(value[i], depth + 1);
            }
        } else callback(value, index.slice(0, depth), array);
    }
    function recursiveForEach(value) {
        if (Array.isArray(value)) {
            var N = value.length;
            for(var i = 0; i < N; i++)recursiveForEach(value[i]);
        } else callback(value);
    }
}
function $98ecc3cdd88a122a$export$9cd59f9826255e47(array) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))([], array);
}

});
parcelRegister("6NnhX", function(module, exports) {

$parcel$export(module.exports, "isInteger", () => $4f296256da819758$export$a287f47fed4544b8);
$parcel$export(module.exports, "safeNumberType", () => $4f296256da819758$export$28199db5a610a1ee);
$parcel$export(module.exports, "sign", () => $4f296256da819758$export$c5552dfdbc7cec71);
$parcel$export(module.exports, "log2", () => $4f296256da819758$export$b9fae0bba9d9094d);
$parcel$export(module.exports, "log10", () => $4f296256da819758$export$75e08744a3ff8516);
$parcel$export(module.exports, "log1p", () => $4f296256da819758$export$144dcf16adfb9698);
$parcel$export(module.exports, "cbrt", () => $4f296256da819758$export$841fc4d5a1480b85);
$parcel$export(module.exports, "expm1", () => $4f296256da819758$export$b6c0a80d46d3391d);
$parcel$export(module.exports, "format", () => $4f296256da819758$export$d9468344d3651243);
$parcel$export(module.exports, "normalizeFormatOptions", () => $4f296256da819758$export$2f3e6f8e6b67bad4);
$parcel$export(module.exports, "toFixed", () => $4f296256da819758$export$a81f732198733497);
$parcel$export(module.exports, "splitNumber", () => $4f296256da819758$export$feb80e120a50087f);
$parcel$export(module.exports, "digits", () => $4f296256da819758$export$9c0987062f8f5d89);
$parcel$export(module.exports, "nearlyEqual", () => $4f296256da819758$export$6f3989c6ecc04081);
$parcel$export(module.exports, "acosh", () => $4f296256da819758$export$b26caf0f29211d08);
$parcel$export(module.exports, "asinh", () => $4f296256da819758$export$839d8a01b6af4fc0);
$parcel$export(module.exports, "atanh", () => $4f296256da819758$export$21ea955025ceb08b);
$parcel$export(module.exports, "cosh", () => $4f296256da819758$export$2e2fd1ad24e4d350);
$parcel$export(module.exports, "sinh", () => $4f296256da819758$export$545004b505d7c555);
$parcel$export(module.exports, "tanh", () => $4f296256da819758$export$7128670e45beef9a);
$parcel$export(module.exports, "copysign", () => $4f296256da819758$export$fe7b50dc6162f97e);

var $edQYF = parcelRequire("edQYF");
function $4f296256da819758$export$a287f47fed4544b8(value) {
    if (typeof value === 'boolean') return true;
    return isFinite(value) ? value === Math.round(value) : false;
}
function $4f296256da819758$export$28199db5a610a1ee(numberStr, config) {
    if (config.number === 'bigint') try {
        BigInt(numberStr);
    } catch (_unused) {
        return config.numberFallback;
    }
    return config.number;
}
var $4f296256da819758$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    if (x > 0) return 1;
    else if (x < 0) return -1;
    else return 0;
};
var $4f296256da819758$export$b9fae0bba9d9094d = Math.log2 || function log2(x) {
    return Math.log(x) / Math.LN2;
};
var $4f296256da819758$export$75e08744a3ff8516 = Math.log10 || function log10(x) {
    return Math.log(x) / Math.LN10;
};
var $4f296256da819758$export$144dcf16adfb9698 = Math.log1p || function(x) {
    return Math.log(x + 1);
};
var $4f296256da819758$export$841fc4d5a1480b85 = Math.cbrt || function cbrt(x) {
    if (x === 0) return x;
    var negate = x < 0;
    var result;
    if (negate) x = -x;
    if (isFinite(x)) {
        result = Math.exp(Math.log(x) / 3);
        // from https://en.wikipedia.org/wiki/Cube_root#Numerical_methods
        result = (x / (result * result) + 2 * result) / 3;
    } else result = x;
    return negate ? -result : result;
};
var $4f296256da819758$export$b6c0a80d46d3391d = Math.expm1 || function expm1(x) {
    return x >= 2e-4 || x <= -0.0002 ? Math.exp(x) - 1 : x + x * x / 2 + x * x * x / 6;
};
/**
 * Formats a number in a given base
 * @param {number} n
 * @param {number} base
 * @param {number} size
 * @returns {string}
 */ function $4f296256da819758$var$formatNumberToBase(n, base, size) {
    var prefixes = {
        2: '0b',
        8: '0o',
        16: '0x'
    };
    var prefix = prefixes[base];
    var suffix = '';
    if (size) {
        if (size < 1) throw new Error('size must be in greater than 0');
        if (!$4f296256da819758$export$a287f47fed4544b8(size)) throw new Error('size must be an integer');
        if (n > 2 ** (size - 1) - 1 || n < -(2 ** (size - 1))) throw new Error("Value must be in range [-2^".concat(size - 1, ", 2^").concat(size - 1, "-1]"));
        if (!$4f296256da819758$export$a287f47fed4544b8(n)) throw new Error('Value must be an integer');
        if (n < 0) n = n + 2 ** size;
        suffix = "i".concat(size);
    }
    var sign = '';
    if (n < 0) {
        n = -n;
        sign = '-';
    }
    return "".concat(sign).concat(prefix).concat(n.toString(base)).concat(suffix);
}
function $4f296256da819758$export$d9468344d3651243(value, options) {
    if (typeof options === 'function') // handle format(value, fn)
    return options(value);
    // handle special cases
    if (value === Infinity) return 'Infinity';
    else if (value === -Infinity) return '-Infinity';
    else if (isNaN(value)) return 'NaN';
    var { notation: notation, precision: precision, wordSize: wordSize } = $4f296256da819758$export$2f3e6f8e6b67bad4(options);
    // handle the various notations
    switch(notation){
        case 'fixed':
            return $4f296256da819758$export$a81f732198733497(value, precision);
        case 'exponential':
            return $4f296256da819758$export$888cb08ddc4765be(value, precision);
        case 'engineering':
            return $4f296256da819758$export$9299fe684ed0ee48(value, precision);
        case 'bin':
            return $4f296256da819758$var$formatNumberToBase(value, 2, wordSize);
        case 'oct':
            return $4f296256da819758$var$formatNumberToBase(value, 8, wordSize);
        case 'hex':
            return $4f296256da819758$var$formatNumberToBase(value, 16, wordSize);
        case 'auto':
            // remove trailing zeros after the decimal point
            return $4f296256da819758$export$3e91a10e66078270(value, precision, options).replace(/((\.\d*?)(0+))($|e)/, function() {
                var digits = arguments[2];
                var e = arguments[4];
                return digits !== '.' ? digits + e : e;
            });
        default:
            throw new Error('Unknown notation "' + notation + '". ' + 'Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
    }
}
function $4f296256da819758$export$2f3e6f8e6b67bad4(options) {
    // default values for options
    var notation = 'auto';
    var precision;
    var wordSize;
    if (options !== undefined) {
        if ((0, $edQYF.isNumber)(options)) precision = options;
        else if ((0, $edQYF.isBigNumber)(options)) precision = options.toNumber();
        else if ((0, $edQYF.isObject)(options)) {
            if (options.precision !== undefined) precision = $4f296256da819758$var$_toNumberOrThrow(options.precision, ()=>{
                throw new Error('Option "precision" must be a number or BigNumber');
            });
            if (options.wordSize !== undefined) wordSize = $4f296256da819758$var$_toNumberOrThrow(options.wordSize, ()=>{
                throw new Error('Option "wordSize" must be a number or BigNumber');
            });
            if (options.notation) notation = options.notation;
        } else throw new Error('Unsupported type of options, number, BigNumber, or object expected');
    }
    return {
        notation: notation,
        precision: precision,
        wordSize: wordSize
    };
}
function $4f296256da819758$export$feb80e120a50087f(value) {
    // parse the input value
    var match = String(value).toLowerCase().match(/^(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
    if (!match) throw new SyntaxError('Invalid number ' + value);
    var sign = match[1];
    var digits = match[2];
    var exponent = parseFloat(match[4] || '0');
    var dot = digits.indexOf('.');
    exponent += dot !== -1 ? dot - 1 : digits.length - 1;
    var coefficients = digits.replace('.', '') // remove the dot (must be removed before removing leading zeros)
    .replace(/^0*/, function(zeros) {
        // remove leading zeros, add their count to the exponent
        exponent -= zeros.length;
        return '';
    }).replace(/0*$/, '') // remove trailing zeros
    .split('').map(function(d) {
        return parseInt(d);
    });
    if (coefficients.length === 0) {
        coefficients.push(0);
        exponent++;
    }
    return {
        sign: sign,
        coefficients: coefficients,
        exponent: exponent
    };
}
function $4f296256da819758$export$9299fe684ed0ee48(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
    var split = $4f296256da819758$export$feb80e120a50087f(value);
    var rounded = $4f296256da819758$export$e5b32ced877afc7e(split, precision);
    var e = rounded.exponent;
    var c = rounded.coefficients;
    // find nearest lower multiple of 3 for exponent
    var newExp = e % 3 === 0 ? e : e < 0 ? e - 3 - e % 3 : e - e % 3;
    if ((0, $edQYF.isNumber)(precision)) // add zeroes to give correct sig figs
    while(precision > c.length || e - newExp + 1 > c.length)c.push(0);
    else {
        // concatenate coefficients with necessary zeros
        // add zeros if necessary (for example: 1e+8 -> 100e+6)
        var missingZeros = Math.abs(e - newExp) - (c.length - 1);
        for(var i = 0; i < missingZeros; i++)c.push(0);
    }
    // find difference in exponents
    var expDiff = Math.abs(e - newExp);
    var decimalIdx = 1;
    // push decimal index over by expDiff times
    while(expDiff > 0){
        decimalIdx++;
        expDiff--;
    }
    // if all coefficient values are zero after the decimal point and precision is unset, don't add a decimal value.
    // otherwise concat with the rest of the coefficients
    var decimals = c.slice(decimalIdx).join('');
    var decimalVal = (0, $edQYF.isNumber)(precision) && decimals.length || decimals.match(/[1-9]/) ? '.' + decimals : '';
    var str = c.slice(0, decimalIdx).join('') + decimalVal + 'e' + (e >= 0 ? '+' : '') + newExp.toString();
    return rounded.sign + str;
}
function $4f296256da819758$export$a81f732198733497(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
    var splitValue = $4f296256da819758$export$feb80e120a50087f(value);
    var rounded = typeof precision === 'number' ? $4f296256da819758$export$e5b32ced877afc7e(splitValue, splitValue.exponent + 1 + precision) : splitValue;
    var c = rounded.coefficients;
    var p = rounded.exponent + 1; // exponent may have changed
    // append zeros if needed
    var pp = p + (precision || 0);
    if (c.length < pp) c = c.concat($4f296256da819758$var$zeros(pp - c.length));
    // prepend zeros if needed
    if (p < 0) {
        c = $4f296256da819758$var$zeros(-p + 1).concat(c);
        p = 1;
    }
    // insert a dot if needed
    if (p < c.length) c.splice(p, 0, p === 0 ? '0.' : '.');
    return rounded.sign + c.join('');
}
function $4f296256da819758$export$888cb08ddc4765be(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
    // round if needed, else create a clone
    var split = $4f296256da819758$export$feb80e120a50087f(value);
    var rounded = precision ? $4f296256da819758$export$e5b32ced877afc7e(split, precision) : split;
    var c = rounded.coefficients;
    var e = rounded.exponent;
    // append zeros if needed
    if (c.length < precision) c = c.concat($4f296256da819758$var$zeros(precision - c.length));
    // format as `C.CCCe+EEE` or `C.CCCe-EEE`
    var first = c.shift();
    return rounded.sign + first + (c.length > 0 ? '.' + c.join('') : '') + 'e' + (e >= 0 ? '+' : '') + e;
}
function $4f296256da819758$export$3e91a10e66078270(value, precision, options) {
    if (isNaN(value) || !isFinite(value)) return String(value);
    // determine lower and upper bound for exponential notation.
    var lowerExp = $4f296256da819758$var$_toNumberOrDefault(options === null || options === void 0 ? void 0 : options.lowerExp, -3);
    var upperExp = $4f296256da819758$var$_toNumberOrDefault(options === null || options === void 0 ? void 0 : options.upperExp, 5);
    var split = $4f296256da819758$export$feb80e120a50087f(value);
    var rounded = precision ? $4f296256da819758$export$e5b32ced877afc7e(split, precision) : split;
    if (rounded.exponent < lowerExp || rounded.exponent >= upperExp) // exponential notation
    return $4f296256da819758$export$888cb08ddc4765be(value, precision);
    else {
        var c = rounded.coefficients;
        var e = rounded.exponent;
        // append trailing zeros
        if (c.length < precision) c = c.concat($4f296256da819758$var$zeros(precision - c.length));
        // append trailing zeros
        // TODO: simplify the next statement
        c = c.concat($4f296256da819758$var$zeros(e - c.length + 1 + (c.length < precision ? precision - c.length : 0)));
        // prepend zeros
        c = $4f296256da819758$var$zeros(-e).concat(c);
        var dot = e > 0 ? e : 0;
        if (dot < c.length - 1) c.splice(dot + 1, 0, '.');
        return rounded.sign + c.join('');
    }
}
function $4f296256da819758$export$e5b32ced877afc7e(split, precision) {
    // create a clone
    var rounded = {
        sign: split.sign,
        coefficients: split.coefficients,
        exponent: split.exponent
    };
    var c = rounded.coefficients;
    // prepend zeros if needed
    while(precision <= 0){
        c.unshift(0);
        rounded.exponent++;
        precision++;
    }
    if (c.length > precision) {
        var removed = c.splice(precision, c.length - precision);
        if (removed[0] >= 5) {
            var i = precision - 1;
            c[i]++;
            while(c[i] === 10){
                c.pop();
                if (i === 0) {
                    c.unshift(0);
                    rounded.exponent++;
                    i++;
                }
                i--;
                c[i]++;
            }
        }
    }
    return rounded;
}
/**
 * Create an array filled with zeros.
 * @param {number} length
 * @return {Array}
 */ function $4f296256da819758$var$zeros(length) {
    var arr = [];
    for(var i = 0; i < length; i++)arr.push(0);
    return arr;
}
function $4f296256da819758$export$9c0987062f8f5d89(value) {
    return value.toExponential().replace(/e.*$/, '') // remove exponential notation
    .replace(/^0\.?0*|\./, '') // remove decimal point and leading zeros
    .length;
}
function $4f296256da819758$export$6f3989c6ecc04081(a, b) {
    var relTol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e-8;
    var absTol = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    if (relTol <= 0) throw new Error('Relative tolerance must be greater than 0');
    if (absTol < 0) throw new Error('Absolute tolerance must be at least 0');
    // NaN
    if (isNaN(a) || isNaN(b)) return false;
    if (!isFinite(a) || !isFinite(b)) return a === b;
    if (a === b) return true;
    // abs(a-b) <= max(rel_tol * max(abs(a), abs(b)), abs_tol)
    return Math.abs(a - b) <= Math.max(relTol * Math.max(Math.abs(a), Math.abs(b)), absTol);
}
var $4f296256da819758$export$b26caf0f29211d08 = Math.acosh || function(x) {
    return Math.log(Math.sqrt(x * x - 1) + x);
};
var $4f296256da819758$export$839d8a01b6af4fc0 = Math.asinh || function(x) {
    return Math.log(Math.sqrt(x * x + 1) + x);
};
var $4f296256da819758$export$21ea955025ceb08b = Math.atanh || function(x) {
    return Math.log((1 + x) / (1 - x)) / 2;
};
var $4f296256da819758$export$2e2fd1ad24e4d350 = Math.cosh || function(x) {
    return (Math.exp(x) + Math.exp(-x)) / 2;
};
var $4f296256da819758$export$545004b505d7c555 = Math.sinh || function(x) {
    return (Math.exp(x) - Math.exp(-x)) / 2;
};
var $4f296256da819758$export$7128670e45beef9a = Math.tanh || function(x) {
    var e = Math.exp(2 * x);
    return (e - 1) / (e + 1);
};
function $4f296256da819758$export$fe7b50dc6162f97e(x, y) {
    var signx = x > 0 ? true : x < 0 ? false : 1 / x === Infinity;
    var signy = y > 0 ? true : y < 0 ? false : 1 / y === Infinity;
    return signx ^ signy ? -x : x;
}
function $4f296256da819758$var$_toNumberOrThrow(value, onError) {
    if ((0, $edQYF.isNumber)(value)) return value;
    else if ((0, $edQYF.isBigNumber)(value)) return value.toNumber();
    else onError();
}
function $4f296256da819758$var$_toNumberOrDefault(value, defaultValue) {
    if ((0, $edQYF.isNumber)(value)) return value;
    else if ((0, $edQYF.isBigNumber)(value)) return value.toNumber();
    else return defaultValue;
}

});

parcelRegister("j2hDb", function(module, exports) {

$parcel$export(module.exports, "endsWith", () => $ddbbe162748f42b8$export$10fdab3683b55b22);
$parcel$export(module.exports, "format", () => $ddbbe162748f42b8$export$d9468344d3651243);
$parcel$export(module.exports, "compareText", () => $ddbbe162748f42b8$export$2da9287da10b19e2);

var $edQYF = parcelRequire("edQYF");

var $6NnhX = parcelRequire("6NnhX");

var $bEbY9 = parcelRequire("bEbY9");
function $ddbbe162748f42b8$export$10fdab3683b55b22(text, search) {
    var start = text.length - search.length;
    var end = text.length;
    return text.substring(start, end) === search;
}
function $ddbbe162748f42b8$export$d9468344d3651243(value, options) {
    var result = $ddbbe162748f42b8$var$_format(value, options);
    if (options && typeof options === 'object' && 'truncate' in options && result.length > options.truncate) return result.substring(0, options.truncate - 3) + '...';
    return result;
}
function $ddbbe162748f42b8$var$_format(value, options) {
    if (typeof value === 'number') return (0, $6NnhX.format)(value, options);
    if ((0, $edQYF.isBigNumber)(value)) return (0, $bEbY9.format)(value, options);
    // note: we use unsafe duck-typing here to check for Fractions, this is
    // ok here since we're only invoking toString or concatenating its values
    if ($ddbbe162748f42b8$var$looksLikeFraction(value)) {
        if (!options || options.fraction !== 'decimal') // output as ratio, like '1/3'
        return "".concat(value.s * value.n, "/").concat(value.d);
        else // output as decimal, like '0.(3)'
        return value.toString();
    }
    if (Array.isArray(value)) return $ddbbe162748f42b8$var$formatArray(value, options);
    if ((0, $edQYF.isString)(value)) return $ddbbe162748f42b8$export$fac44ee5b035f737(value);
    if (typeof value === 'function') return value.syntax ? String(value.syntax) : 'function';
    if (value && typeof value === 'object') {
        if (typeof value.format === 'function') return value.format(options);
        else if (value && value.toString(options) !== ({}).toString()) // this object has a non-native toString method, use that one
        return value.toString(options);
        else {
            var entries = Object.keys(value).map((key)=>{
                return $ddbbe162748f42b8$export$fac44ee5b035f737(key) + ': ' + $ddbbe162748f42b8$export$d9468344d3651243(value[key], options);
            });
            return '{' + entries.join(', ') + '}';
        }
    }
    return String(value);
}
function $ddbbe162748f42b8$export$fac44ee5b035f737(value) {
    var text = String(value);
    var escaped = '';
    var i = 0;
    while(i < text.length){
        var c = text.charAt(i);
        escaped += c in $ddbbe162748f42b8$var$controlCharacters ? $ddbbe162748f42b8$var$controlCharacters[c] : c;
        i++;
    }
    return '"' + escaped + '"';
}
var $ddbbe162748f42b8$var$controlCharacters = {
    '"': '\\"',
    '\\': '\\\\',
    '\b': '\\b',
    '\f': '\\f',
    '\n': '\\n',
    '\r': '\\r',
    '\t': '\\t'
};
function $ddbbe162748f42b8$export$4e7f196112fea3c5(value) {
    var text = String(value);
    text = text.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return text;
}
/**
 * Recursively format an n-dimensional matrix
 * Example output: "[[1, 2], [3, 4]]"
 * @param {Array} array
 * @param {Object | number | Function} [options]  Formatting options. See
 *                                                lib/utils/number:format for a
 *                                                description of the available
 *                                                options.
 * @returns {string} str
 */ function $ddbbe162748f42b8$var$formatArray(array, options) {
    if (Array.isArray(array)) {
        var str = '[';
        var len = array.length;
        for(var i = 0; i < len; i++){
            if (i !== 0) str += ', ';
            str += $ddbbe162748f42b8$var$formatArray(array[i], options);
        }
        str += ']';
        return str;
    } else return $ddbbe162748f42b8$export$d9468344d3651243(array, options);
}
/**
 * Check whether a value looks like a Fraction (unsafe duck-type check)
 * @param {*} value
 * @return {boolean}
 */ function $ddbbe162748f42b8$var$looksLikeFraction(value) {
    return value && typeof value === 'object' && typeof value.s === 'bigint' && typeof value.n === 'bigint' && typeof value.d === 'bigint' || false;
}
function $ddbbe162748f42b8$export$2da9287da10b19e2(x, y) {
    // we don't want to convert numbers to string, only accept string input
    if (!(0, $edQYF.isString)(x)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + (0, $edQYF.typeOf)(x) + ', index: 0)');
    if (!(0, $edQYF.isString)(y)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + (0, $edQYF.typeOf)(y) + ', index: 1)');
    return x === y ? 0 : x > y ? 1 : -1;
}

});
parcelRegister("bEbY9", function(module, exports) {

$parcel$export(module.exports, "format", () => $87acb6f30844403c$export$d9468344d3651243);

var $edQYF = parcelRequire("edQYF");

var $6NnhX = parcelRequire("6NnhX");
/**
 * Formats a BigNumber in a given base
 * @param {BigNumber} n
 * @param {number} base
 * @param {number} size
 * @returns {string}
 */ function $87acb6f30844403c$var$formatBigNumberToBase(n, base, size) {
    var BigNumberCtor = n.constructor;
    var big2 = new BigNumberCtor(2);
    var suffix = '';
    if (size) {
        if (size < 1) throw new Error('size must be in greater than 0');
        if (!(0, $6NnhX.isInteger)(size)) throw new Error('size must be an integer');
        if (n.greaterThan(big2.pow(size - 1).sub(1)) || n.lessThan(big2.pow(size - 1).mul(-1))) throw new Error("Value must be in range [-2^".concat(size - 1, ", 2^").concat(size - 1, "-1]"));
        if (!n.isInteger()) throw new Error('Value must be an integer');
        if (n.lessThan(0)) n = n.add(big2.pow(size));
        suffix = "i".concat(size);
    }
    switch(base){
        case 2:
            return "".concat(n.toBinary()).concat(suffix);
        case 8:
            return "".concat(n.toOctal()).concat(suffix);
        case 16:
            return "".concat(n.toHexadecimal()).concat(suffix);
        default:
            throw new Error("Base ".concat(base, " not supported "));
    }
}
function $87acb6f30844403c$export$d9468344d3651243(value, options) {
    if (typeof options === 'function') // handle format(value, fn)
    return options(value);
    // handle special cases
    if (!value.isFinite()) return value.isNaN() ? 'NaN' : value.gt(0) ? 'Infinity' : '-Infinity';
    var { notation: notation, precision: precision, wordSize: wordSize } = (0, $6NnhX.normalizeFormatOptions)(options);
    // handle the various notations
    switch(notation){
        case 'fixed':
            return $87acb6f30844403c$export$a81f732198733497(value, precision);
        case 'exponential':
            return $87acb6f30844403c$export$888cb08ddc4765be(value, precision);
        case 'engineering':
            return $87acb6f30844403c$export$9299fe684ed0ee48(value, precision);
        case 'bin':
            return $87acb6f30844403c$var$formatBigNumberToBase(value, 2, wordSize);
        case 'oct':
            return $87acb6f30844403c$var$formatBigNumberToBase(value, 8, wordSize);
        case 'hex':
            return $87acb6f30844403c$var$formatBigNumberToBase(value, 16, wordSize);
        case 'auto':
            // determine lower and upper bound for exponential notation.
            // TODO: implement support for upper and lower to be BigNumbers themselves
            var lowerExp = $87acb6f30844403c$var$_toNumberOrDefault(options === null || options === void 0 ? void 0 : options.lowerExp, -3);
            var upperExp = $87acb6f30844403c$var$_toNumberOrDefault(options === null || options === void 0 ? void 0 : options.upperExp, 5);
            // handle special case zero
            if (value.isZero()) return '0';
            // determine whether or not to output exponential notation
            var str;
            var rounded = value.toSignificantDigits(precision);
            var exp = rounded.e;
            if (exp >= lowerExp && exp < upperExp) // normal number notation
            str = rounded.toFixed();
            else // exponential notation
            str = $87acb6f30844403c$export$888cb08ddc4765be(value, precision);
            // remove trailing zeros after the decimal point
            return str.replace(/((\.\d*?)(0+))($|e)/, function() {
                var digits = arguments[2];
                var e = arguments[4];
                return digits !== '.' ? digits + e : e;
            });
        default:
            throw new Error('Unknown notation "' + notation + '". ' + 'Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
    }
}
function $87acb6f30844403c$export$9299fe684ed0ee48(value, precision) {
    // find nearest lower multiple of 3 for exponent
    var e = value.e;
    var newExp = e % 3 === 0 ? e : e < 0 ? e - 3 - e % 3 : e - e % 3;
    // find difference in exponents, and calculate the value without exponent
    var valueWithoutExp = value.mul(Math.pow(10, -newExp));
    var valueStr = valueWithoutExp.toPrecision(precision);
    if (valueStr.includes('e')) {
        var BigNumber = value.constructor;
        valueStr = new BigNumber(valueStr).toFixed();
    }
    return valueStr + 'e' + (e >= 0 ? '+' : '') + newExp.toString();
}
function $87acb6f30844403c$export$888cb08ddc4765be(value, precision) {
    if (precision !== undefined) return value.toExponential(precision - 1); // Note the offset of one
    else return value.toExponential();
}
function $87acb6f30844403c$export$a81f732198733497(value, precision) {
    return value.toFixed(precision);
}
function $87acb6f30844403c$var$_toNumberOrDefault(value, defaultValue) {
    if ((0, $edQYF.isNumber)(value)) return value;
    else if ((0, $edQYF.isBigNumber)(value)) return value.toNumber();
    else return defaultValue;
}

});


parcelRegister("7asMt", function(module, exports) {

$parcel$export(module.exports, "DimensionError", () => $537fcad5be237661$export$ad1391ca020fdd96);
/**
 * Create a range error with the message:
 *     'Dimension mismatch (<actual size> != <expected size>)'
 * @param {number | number[]} actual        The actual size
 * @param {number | number[]} expected      The expected size
 * @param {string} [relation='!=']          Optional relation between actual
 *                                          and expected size: '!=', '<', etc.
 * @extends RangeError
 */ function $537fcad5be237661$export$ad1391ca020fdd96(actual, expected, relation) {
    if (!(this instanceof $537fcad5be237661$export$ad1391ca020fdd96)) throw new SyntaxError('Constructor must be called with the new operator');
    this.actual = actual;
    this.expected = expected;
    this.relation = relation;
    this.message = 'Dimension mismatch (' + (Array.isArray(actual) ? '[' + actual.join(', ') + ']' : actual) + ' ' + (this.relation || '!=') + ' ' + (Array.isArray(expected) ? '[' + expected.join(', ') + ']' : expected) + ')';
    this.stack = new Error().stack;
}
$537fcad5be237661$export$ad1391ca020fdd96.prototype = new RangeError();
$537fcad5be237661$export$ad1391ca020fdd96.prototype.constructor = RangeError;
$537fcad5be237661$export$ad1391ca020fdd96.prototype.name = 'DimensionError';
$537fcad5be237661$export$ad1391ca020fdd96.prototype.isDimensionError = true;

});


parcelRegister("3Wq9u", function(module, exports) {

$parcel$export(module.exports, "_switch", () => $2deb132627ba5c07$export$424b8b2ab9af2944);
/**
 * Transpose a matrix
 * @param {Array} mat
 * @returns {Array} ret
 * @private
 */ function $2deb132627ba5c07$export$424b8b2ab9af2944(mat) {
    var I = mat.length;
    var J = mat[0].length;
    var i, j;
    var ret = [];
    for(j = 0; j < J; j++){
        var tmp = [];
        for(i = 0; i < I; i++)tmp.push(mat[i][j]);
        ret.push(tmp);
    }
    return ret;
}

});


parcelRegister("dmcGu", function(module, exports) {

$parcel$export(module.exports, "absNumber", () => $9b972b442b934df6$export$59270f717756a93a);
$parcel$export(module.exports, "addNumber", () => $9b972b442b934df6$export$d6751d2a3b6da12a);
$parcel$export(module.exports, "subtractNumber", () => $9b972b442b934df6$export$fd8ce9cfca47ace5);
$parcel$export(module.exports, "multiplyNumber", () => $9b972b442b934df6$export$4ad41ac849e391ec);
$parcel$export(module.exports, "unaryMinusNumber", () => $9b972b442b934df6$export$339666dc881be46b);
$parcel$export(module.exports, "unaryPlusNumber", () => $9b972b442b934df6$export$da5b80d388a295fb);
$parcel$export(module.exports, "cbrtNumber", () => $9b972b442b934df6$export$95c2aecb85f70726);
$parcel$export(module.exports, "cubeNumber", () => $9b972b442b934df6$export$9505f0b39acd04c);
$parcel$export(module.exports, "expNumber", () => $9b972b442b934df6$export$a33b288b35672fe5);
$parcel$export(module.exports, "expm1Number", () => $9b972b442b934df6$export$756d0c010cecc6c3);
$parcel$export(module.exports, "lcmNumber", () => $9b972b442b934df6$export$b55f99ec1f4c5649);
$parcel$export(module.exports, "logNumber", () => $9b972b442b934df6$export$4df0e8fcdd5c0927);
$parcel$export(module.exports, "log10Number", () => $9b972b442b934df6$export$e3f8d49574d29dff);
$parcel$export(module.exports, "log2Number", () => $9b972b442b934df6$export$f9bc93220cfa3c59);
$parcel$export(module.exports, "nthRootNumber", () => $9b972b442b934df6$export$9f26f16bd796a7b3);
$parcel$export(module.exports, "signNumber", () => $9b972b442b934df6$export$af3d9fe43be78285);
$parcel$export(module.exports, "squareNumber", () => $9b972b442b934df6$export$c4094a156ed9ab35);
$parcel$export(module.exports, "xgcdNumber", () => $9b972b442b934df6$export$8cb756a23a623229);
$parcel$export(module.exports, "powNumber", () => $9b972b442b934df6$export$3f512e7fd4999e01);
$parcel$export(module.exports, "roundNumber", () => $9b972b442b934df6$export$a3992db8dd0fd9e6);

var $6NnhX = parcelRequire("6NnhX");
var $9b972b442b934df6$var$n1 = 'number';
var $9b972b442b934df6$var$n2 = 'number, number';
function $9b972b442b934df6$export$59270f717756a93a(a) {
    return Math.abs(a);
}
$9b972b442b934df6$export$59270f717756a93a.signature = $9b972b442b934df6$var$n1;
function $9b972b442b934df6$export$d6751d2a3b6da12a(a, b) {
    return a + b;
}
$9b972b442b934df6$export$d6751d2a3b6da12a.signature = $9b972b442b934df6$var$n2;
function $9b972b442b934df6$export$fd8ce9cfca47ace5(a, b) {
    return a - b;
}
$9b972b442b934df6$export$fd8ce9cfca47ace5.signature = $9b972b442b934df6$var$n2;
function $9b972b442b934df6$export$4ad41ac849e391ec(a, b) {
    return a * b;
}
$9b972b442b934df6$export$4ad41ac849e391ec.signature = $9b972b442b934df6$var$n2;
function $9b972b442b934df6$export$58c48a269ab4a155(a, b) {
    return a / b;
}
$9b972b442b934df6$export$58c48a269ab4a155.signature = $9b972b442b934df6$var$n2;
function $9b972b442b934df6$export$339666dc881be46b(x) {
    return -x;
}
$9b972b442b934df6$export$339666dc881be46b.signature = $9b972b442b934df6$var$n1;
function $9b972b442b934df6$export$da5b80d388a295fb(x) {
    return x;
}
$9b972b442b934df6$export$da5b80d388a295fb.signature = $9b972b442b934df6$var$n1;
function $9b972b442b934df6$export$95c2aecb85f70726(x) {
    return (0, $6NnhX.cbrt)(x);
}
$9b972b442b934df6$export$95c2aecb85f70726.signature = $9b972b442b934df6$var$n1;
function $9b972b442b934df6$export$9505f0b39acd04c(x) {
    return x * x * x;
}
$9b972b442b934df6$export$9505f0b39acd04c.signature = $9b972b442b934df6$var$n1;
function $9b972b442b934df6$export$a33b288b35672fe5(x) {
    return Math.exp(x);
}
$9b972b442b934df6$export$a33b288b35672fe5.signature = $9b972b442b934df6$var$n1;
function $9b972b442b934df6$export$756d0c010cecc6c3(x) {
    return (0, $6NnhX.expm1)(x);
}
$9b972b442b934df6$export$756d0c010cecc6c3.signature = $9b972b442b934df6$var$n1;
function $9b972b442b934df6$export$3a8d786b08b3a70c(a, b) {
    if (!(0, $6NnhX.isInteger)(a) || !(0, $6NnhX.isInteger)(b)) throw new Error('Parameters in function gcd must be integer numbers');
    // https://en.wikipedia.org/wiki/Euclidean_algorithm
    var r;
    while(b !== 0){
        r = a % b;
        a = b;
        b = r;
    }
    return a < 0 ? -a : a;
}
$9b972b442b934df6$export$3a8d786b08b3a70c.signature = $9b972b442b934df6$var$n2;
function $9b972b442b934df6$export$b55f99ec1f4c5649(a, b) {
    if (!(0, $6NnhX.isInteger)(a) || !(0, $6NnhX.isInteger)(b)) throw new Error('Parameters in function lcm must be integer numbers');
    if (a === 0 || b === 0) return 0;
    // https://en.wikipedia.org/wiki/Euclidean_algorithm
    // evaluate lcm here inline to reduce overhead
    var t;
    var prod = a * b;
    while(b !== 0){
        t = b;
        b = a % t;
        a = t;
    }
    return Math.abs(prod / a);
}
$9b972b442b934df6$export$b55f99ec1f4c5649.signature = $9b972b442b934df6$var$n2;
function $9b972b442b934df6$export$4df0e8fcdd5c0927(x, y) {
    if (y) return Math.log(x) / Math.log(y);
    return Math.log(x);
}
function $9b972b442b934df6$export$e3f8d49574d29dff(x) {
    return (0, $6NnhX.log10)(x);
}
$9b972b442b934df6$export$e3f8d49574d29dff.signature = $9b972b442b934df6$var$n1;
function $9b972b442b934df6$export$f9bc93220cfa3c59(x) {
    return (0, $6NnhX.log2)(x);
}
$9b972b442b934df6$export$f9bc93220cfa3c59.signature = $9b972b442b934df6$var$n1;
function $9b972b442b934df6$export$ae1f56e105ebe4a1(x) {
    return (0, $6NnhX.log1p)(x);
}
$9b972b442b934df6$export$ae1f56e105ebe4a1.signature = $9b972b442b934df6$var$n1;
function $9b972b442b934df6$export$64b58c5b0372ae95(x, y) {
    // We don't use JavaScript's % operator here as this doesn't work
    // correctly for x < 0 and x === 0
    // see https://en.wikipedia.org/wiki/Modulo_operation
    return y === 0 ? x : x - y * Math.floor(x / y);
}
$9b972b442b934df6$export$64b58c5b0372ae95.signature = $9b972b442b934df6$var$n2;
function $9b972b442b934df6$export$9f26f16bd796a7b3(a) {
    var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var inv = root < 0;
    if (inv) root = -root;
    if (root === 0) throw new Error('Root must be non-zero');
    if (a < 0 && Math.abs(root) % 2 !== 1) throw new Error('Root must be odd when a is negative.');
    // edge cases zero and infinity
    if (a === 0) return inv ? Infinity : 0;
    if (!isFinite(a)) return inv ? 0 : a;
    var x = Math.pow(Math.abs(a), 1 / root);
    // If a < 0, we require that root is an odd integer,
    // so (-1) ^ (1/root) = -1
    x = a < 0 ? -x : x;
    return inv ? 1 / x : x;
// Very nice algorithm, but fails with nthRoot(-2, 3).
// Newton's method has some well-known problems at times:
// https://en.wikipedia.org/wiki/Newton%27s_method#Failure_analysis
/*
  let x = 1 // Initial guess
  let xPrev = 1
  let i = 0
  const iMax = 10000
  do {
    const delta = (a / Math.pow(x, root - 1) - x) / root
    xPrev = x
    x = x + delta
    i++
  }
  while (xPrev !== x && i < iMax)
   if (xPrev !== x) {
    throw new Error('Function nthRoot failed to converge')
  }
   return inv ? 1 / x : x
  */ }
function $9b972b442b934df6$export$af3d9fe43be78285(x) {
    return (0, $6NnhX.sign)(x);
}
$9b972b442b934df6$export$af3d9fe43be78285.signature = $9b972b442b934df6$var$n1;
function $9b972b442b934df6$export$aacd0ed14e49886d(x) {
    return Math.sqrt(x);
}
$9b972b442b934df6$export$aacd0ed14e49886d.signature = $9b972b442b934df6$var$n1;
function $9b972b442b934df6$export$c4094a156ed9ab35(x) {
    return x * x;
}
$9b972b442b934df6$export$c4094a156ed9ab35.signature = $9b972b442b934df6$var$n1;
function $9b972b442b934df6$export$8cb756a23a623229(a, b) {
    // source: https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm
    var t; // used to swap two variables
    var q; // quotient
    var r; // remainder
    var x = 0;
    var lastx = 1;
    var y = 1;
    var lasty = 0;
    if (!(0, $6NnhX.isInteger)(a) || !(0, $6NnhX.isInteger)(b)) throw new Error('Parameters in function xgcd must be integer numbers');
    while(b){
        q = Math.floor(a / b);
        r = a - q * b;
        t = x;
        x = lastx - q * x;
        lastx = t;
        t = y;
        y = lasty - q * y;
        lasty = t;
        a = b;
        b = r;
    }
    var res;
    if (a < 0) res = [
        -a,
        -lastx,
        -lasty
    ];
    else res = [
        a,
        a ? lastx : 0,
        lasty
    ];
    return res;
}
$9b972b442b934df6$export$8cb756a23a623229.signature = $9b972b442b934df6$var$n2;
function $9b972b442b934df6$export$3f512e7fd4999e01(x, y) {
    // x^Infinity === 0 if -1 < x < 1
    // A real number 0 is returned instead of complex(0)
    if (x * x < 1 && y === Infinity || x * x > 1 && y === -Infinity) return 0;
    return Math.pow(x, y);
}
$9b972b442b934df6$export$3f512e7fd4999e01.signature = $9b972b442b934df6$var$n2;
function $9b972b442b934df6$export$a3992db8dd0fd9e6(value) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (!(0, $6NnhX.isInteger)(decimals) || decimals < 0 || decimals > 15) throw new Error('Number of decimals in function round must be an integer from 0 to 15 inclusive');
    return parseFloat((0, $6NnhX.toFixed)(value, decimals));
}
function $9b972b442b934df6$export$d78ecacee56245ec(x) {
    return Math.abs(x);
}
$9b972b442b934df6$export$d78ecacee56245ec.signature = $9b972b442b934df6$var$n1;

});


parcelRegister("9CLAB", function(module, exports) {

$parcel$export(module.exports, "createAcos", () => $701c93ea054d0b80$export$33da46c5ece67581);

var $dsu7t = parcelRequire("dsu7t");
var $701c93ea054d0b80$var$name = 'acos';
var $701c93ea054d0b80$var$dependencies = [
    'typed',
    'config',
    'Complex'
];
var $701c93ea054d0b80$export$33da46c5ece67581 = /* #__PURE__ */ (0, $dsu7t.factory)($701c93ea054d0b80$var$name, $701c93ea054d0b80$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the inverse cosine of a value.
   *
   * To avoid confusion with the matrix arccosine, this function does not
   * apply to matrices.
   *
   * Syntax:
   *
   *    math.acos(x)
   *
   * Examples:
   *
   *    math.acos(0.5)           // returns number 1.0471975511965979
   *    math.acos(math.cos(1.5)) // returns number 1.5
   *
   *    math.acos(2)             // returns Complex 0 + 1.3169578969248166 i
   *
   * See also:
   *
   *    cos, atan, asin
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} The arc cosine of x
   */ return typed($701c93ea054d0b80$var$name, {
        number: function number(x) {
            if (x >= -1 && x <= 1 || config.predictable) return Math.acos(x);
            else return new Complex(x, 0).acos();
        },
        Complex: function Complex(x) {
            return x.acos();
        },
        BigNumber: function BigNumber(x) {
            return x.acos();
        }
    });
});

});

parcelRegister("3SvYq", function(module, exports) {

$parcel$export(module.exports, "createAcosh", () => $2d2f3783ad19abbe$export$c634796792055579);

var $dsu7t = parcelRequire("dsu7t");

var $cOOcY = parcelRequire("cOOcY");
var $2d2f3783ad19abbe$var$name = 'acosh';
var $2d2f3783ad19abbe$var$dependencies = [
    'typed',
    'config',
    'Complex'
];
var $2d2f3783ad19abbe$export$c634796792055579 = /* #__PURE__ */ (0, $dsu7t.factory)($2d2f3783ad19abbe$var$name, $2d2f3783ad19abbe$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the hyperbolic arccos of a value,
   * defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acosh(x)
   *
   * Examples:
   *
   *    math.acosh(1.5)       // returns 0.9624236501192069
   *
   * See also:
   *
   *    cosh, asinh, atanh
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic arccosine of x
   */ return typed($2d2f3783ad19abbe$var$name, {
        number: function number(x) {
            if (x >= 1 || config.predictable) return (0, $cOOcY.acoshNumber)(x);
            if (x <= -1) return new Complex(Math.log(Math.sqrt(x * x - 1) - x), Math.PI);
            return new Complex(x, 0).acosh();
        },
        Complex: function Complex(x) {
            return x.acosh();
        },
        BigNumber: function BigNumber(x) {
            return x.acosh();
        }
    });
});

});
parcelRegister("cOOcY", function(module, exports) {

$parcel$export(module.exports, "acoshNumber", () => $955119db83da319d$export$84088556f7d2d0be);
$parcel$export(module.exports, "acotNumber", () => $955119db83da319d$export$ba80ccbf024897ef);
$parcel$export(module.exports, "acothNumber", () => $955119db83da319d$export$e2be1aa5d5a3f81);
$parcel$export(module.exports, "acscNumber", () => $955119db83da319d$export$e3b67a6e3df3fd81);
$parcel$export(module.exports, "acschNumber", () => $955119db83da319d$export$51cd224337b2c783);
$parcel$export(module.exports, "asecNumber", () => $955119db83da319d$export$5ec3930177455ade);
$parcel$export(module.exports, "asechNumber", () => $955119db83da319d$export$cf144300ea173362);
$parcel$export(module.exports, "asinhNumber", () => $955119db83da319d$export$3a027485d3336d8d);
$parcel$export(module.exports, "atanhNumber", () => $955119db83da319d$export$44a1f653c6513db8);
$parcel$export(module.exports, "cotNumber", () => $955119db83da319d$export$515b39f7fd07e09f);
$parcel$export(module.exports, "cothNumber", () => $955119db83da319d$export$925affe88b2512fc);
$parcel$export(module.exports, "cscNumber", () => $955119db83da319d$export$5a8409ad16e318b2);
$parcel$export(module.exports, "cschNumber", () => $955119db83da319d$export$143835b5c1db9790);
$parcel$export(module.exports, "secNumber", () => $955119db83da319d$export$ee1efc70bd8a6d93);
$parcel$export(module.exports, "sechNumber", () => $955119db83da319d$export$b83345d70fe4a871);
$parcel$export(module.exports, "sinhNumber", () => $955119db83da319d$export$89648c4ce0d79e70);

var $6NnhX = parcelRequire("6NnhX");
var $955119db83da319d$var$n1 = 'number';
var $955119db83da319d$var$n2 = 'number, number';
function $955119db83da319d$export$99a14685a3a2b607(x) {
    return Math.acos(x);
}
$955119db83da319d$export$99a14685a3a2b607.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$84088556f7d2d0be(x) {
    return (0, $6NnhX.acosh)(x);
}
$955119db83da319d$export$84088556f7d2d0be.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$ba80ccbf024897ef(x) {
    return Math.atan(1 / x);
}
$955119db83da319d$export$ba80ccbf024897ef.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$e2be1aa5d5a3f81(x) {
    return isFinite(x) ? (Math.log((x + 1) / x) + Math.log(x / (x - 1))) / 2 : 0;
}
$955119db83da319d$export$e2be1aa5d5a3f81.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$e3b67a6e3df3fd81(x) {
    return Math.asin(1 / x);
}
$955119db83da319d$export$e3b67a6e3df3fd81.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$51cd224337b2c783(x) {
    var xInv = 1 / x;
    return Math.log(xInv + Math.sqrt(xInv * xInv + 1));
}
$955119db83da319d$export$51cd224337b2c783.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$5ec3930177455ade(x) {
    return Math.acos(1 / x);
}
$955119db83da319d$export$5ec3930177455ade.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$cf144300ea173362(x) {
    var xInv = 1 / x;
    var ret = Math.sqrt(xInv * xInv - 1);
    return Math.log(ret + xInv);
}
$955119db83da319d$export$cf144300ea173362.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$444ef2855488a2d5(x) {
    return Math.asin(x);
}
$955119db83da319d$export$444ef2855488a2d5.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$3a027485d3336d8d(x) {
    return (0, $6NnhX.asinh)(x);
}
$955119db83da319d$export$3a027485d3336d8d.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$c38dcb11df4699c0(x) {
    return Math.atan(x);
}
$955119db83da319d$export$c38dcb11df4699c0.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$a97666a135b540f9(y, x) {
    return Math.atan2(y, x);
}
$955119db83da319d$export$a97666a135b540f9.signature = $955119db83da319d$var$n2;
function $955119db83da319d$export$44a1f653c6513db8(x) {
    return (0, $6NnhX.atanh)(x);
}
$955119db83da319d$export$44a1f653c6513db8.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$8d04496be3e647d4(x) {
    return Math.cos(x);
}
$955119db83da319d$export$8d04496be3e647d4.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$7cf8db0cff734545(x) {
    return (0, $6NnhX.cosh)(x);
}
$955119db83da319d$export$7cf8db0cff734545.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$515b39f7fd07e09f(x) {
    return 1 / Math.tan(x);
}
$955119db83da319d$export$515b39f7fd07e09f.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$925affe88b2512fc(x) {
    var e = Math.exp(2 * x);
    return (e + 1) / (e - 1);
}
$955119db83da319d$export$925affe88b2512fc.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$5a8409ad16e318b2(x) {
    return 1 / Math.sin(x);
}
$955119db83da319d$export$5a8409ad16e318b2.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$143835b5c1db9790(x) {
    // consider values close to zero (+/-)
    if (x === 0) return Number.POSITIVE_INFINITY;
    else return Math.abs(2 / (Math.exp(x) - Math.exp(-x))) * (0, $6NnhX.sign)(x);
}
$955119db83da319d$export$143835b5c1db9790.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$ee1efc70bd8a6d93(x) {
    return 1 / Math.cos(x);
}
$955119db83da319d$export$ee1efc70bd8a6d93.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$b83345d70fe4a871(x) {
    return 2 / (Math.exp(x) + Math.exp(-x));
}
$955119db83da319d$export$b83345d70fe4a871.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$b6e96f13f41c8816(x) {
    return Math.sin(x);
}
$955119db83da319d$export$b6e96f13f41c8816.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$89648c4ce0d79e70(x) {
    return (0, $6NnhX.sinh)(x);
}
$955119db83da319d$export$89648c4ce0d79e70.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$ecbd7b3271ebce16(x) {
    return Math.tan(x);
}
$955119db83da319d$export$ecbd7b3271ebce16.signature = $955119db83da319d$var$n1;
function $955119db83da319d$export$70e2e2cc9c2555e4(x) {
    return (0, $6NnhX.tanh)(x);
}
$955119db83da319d$export$70e2e2cc9c2555e4.signature = $955119db83da319d$var$n1;

});


parcelRegister("g8Ji1", function(module, exports) {

$parcel$export(module.exports, "createAcot", () => $bc0086494ac9d68e$export$8a6845771325148e);

var $dsu7t = parcelRequire("dsu7t");

var $cOOcY = parcelRequire("cOOcY");
var $bc0086494ac9d68e$var$name = 'acot';
var $bc0086494ac9d68e$var$dependencies = [
    'typed',
    'BigNumber'
];
var $bc0086494ac9d68e$export$8a6845771325148e = /* #__PURE__ */ (0, $dsu7t.factory)($bc0086494ac9d68e$var$name, $bc0086494ac9d68e$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the inverse cotangent of a value, defined as `acot(x) = atan(1/x)`.
   *
   * To avoid confusion with the matrix arccotanget, this function does not
   * apply to matrices.
   *
   * Syntax:
   *
   *    math.acot(x)
   *
   * Examples:
   *
   *    math.acot(0.5)           // returns number 1.1071487177940904
   *    math.acot(2)             // returns number 0.4636476090008061
   *    math.acot(math.cot(1.5)) // returns number 1.5
   *
   * See also:
   *
   *    cot, atan
   *
   * @param {number | BigNumber| Complex} x   Function input
   * @return {number | BigNumber| Complex} The arc cotangent of x
   */ return typed($bc0086494ac9d68e$var$name, {
        number: (0, $cOOcY.acotNumber),
        Complex: function Complex(x) {
            return x.acot();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).atan();
        }
    });
});

});

parcelRegister("hHwiU", function(module, exports) {

$parcel$export(module.exports, "createAcoth", () => $ce2f82bc41b20947$export$67e40c7fd8f5703a);

var $dsu7t = parcelRequire("dsu7t");

var $cOOcY = parcelRequire("cOOcY");
var $ce2f82bc41b20947$var$name = 'acoth';
var $ce2f82bc41b20947$var$dependencies = [
    'typed',
    'config',
    'Complex',
    'BigNumber'
];
var $ce2f82bc41b20947$export$67e40c7fd8f5703a = /* #__PURE__ */ (0, $dsu7t.factory)($ce2f82bc41b20947$var$name, $ce2f82bc41b20947$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the inverse hyperbolic tangent of a value,
   * defined as `acoth(x) = atanh(1/x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.
   *
   * To avoid confusion with the matrix inverse hyperbolic tangent, this
   * function does not apply to matrices.
   *
   * Syntax:
   *
   *    math.acoth(x)
   *
   * Examples:
   *
   *    math.acoth(0.5)     // returns 0.5493061443340548 - 1.5707963267948966i
   *
   * See also:
   *
   *    acsch, asech
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic arccotangent of x
   */ return typed($ce2f82bc41b20947$var$name, {
        number: function number(x) {
            if (x >= 1 || x <= -1 || config.predictable) return (0, $cOOcY.acothNumber)(x);
            return new Complex(x, 0).acoth();
        },
        Complex: function Complex(x) {
            return x.acoth();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).atanh();
        }
    });
});

});

parcelRegister("2ZacS", function(module, exports) {

$parcel$export(module.exports, "createAcsc", () => $22c932179dcd078a$export$95580581b134a5bd);

var $dsu7t = parcelRequire("dsu7t");

var $cOOcY = parcelRequire("cOOcY");
var $22c932179dcd078a$var$name = 'acsc';
var $22c932179dcd078a$var$dependencies = [
    'typed',
    'config',
    'Complex',
    'BigNumber'
];
var $22c932179dcd078a$export$95580581b134a5bd = /* #__PURE__ */ (0, $dsu7t.factory)($22c932179dcd078a$var$name, $22c932179dcd078a$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the inverse cosecant of a value, defined as `acsc(x) = asin(1/x)`.
   *
   * To avoid confusion with the matrix arccosecant, this function does not
   * apply to matrices.
   *
   * Syntax:
   *
   *    math.acsc(x)
   *
   * Examples:
   *
   *    math.acsc(2)             // returns 0.5235987755982989
   *    math.acsc(0.5)           // returns Complex 1.5707963267948966 -1.3169578969248166i
   *    math.acsc(math.csc(1.5)) // returns number 1.5
   *
   * See also:
   *
   *    csc, asin, asec
   *
   * @param {number | BigNumber | Complex} x   Function input
   * @return {number | BigNumber | Complex} The arc cosecant of x
   */ return typed($22c932179dcd078a$var$name, {
        number: function number(x) {
            if (x <= -1 || x >= 1 || config.predictable) return (0, $cOOcY.acscNumber)(x);
            return new Complex(x, 0).acsc();
        },
        Complex: function Complex(x) {
            return x.acsc();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).asin();
        }
    });
});

});

parcelRegister("4snD5", function(module, exports) {

$parcel$export(module.exports, "createAcsch", () => $33ec1b45f10155f7$export$d6534043a40dc59);

var $dsu7t = parcelRequire("dsu7t");

var $cOOcY = parcelRequire("cOOcY");
var $33ec1b45f10155f7$var$name = 'acsch';
var $33ec1b45f10155f7$var$dependencies = [
    'typed',
    'BigNumber'
];
var $33ec1b45f10155f7$export$d6534043a40dc59 = /* #__PURE__ */ (0, $dsu7t.factory)($33ec1b45f10155f7$var$name, $33ec1b45f10155f7$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the inverse hyperbolic cosecant of a value,
   * defined as `acsch(x) = asinh(1/x) = ln(1/x + sqrt(1/x^2 + 1))`.
   *
   * To avoid confusion with the matrix inverse hyperbolic cosecant, this function
   * does not apply to matrices.
   *
   * Syntax:
   *
   *    math.acsch(x)
   *
   * Examples:
   *
   *    math.acsch(0.5)       // returns 1.4436354751788103
   *
   * See also:
   *
   *    asech, acoth
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic arccosecant of x
   */ return typed($33ec1b45f10155f7$var$name, {
        number: (0, $cOOcY.acschNumber),
        Complex: function Complex(x) {
            return x.acsch();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).asinh();
        }
    });
});

});

parcelRegister("4aGuX", function(module, exports) {

$parcel$export(module.exports, "createAdd", () => $30990fe5e42684fe$export$c6b51545da64d82f);

var $dsu7t = parcelRequire("dsu7t");

var $ahu8B = parcelRequire("ahu8B");

var $ibvF5 = parcelRequire("ibvF5");

var $enjrI = parcelRequire("enjrI");

var $6SJnV = parcelRequire("6SJnV");
var $30990fe5e42684fe$var$name = 'add';
var $30990fe5e42684fe$var$dependencies = [
    'typed',
    'matrix',
    'addScalar',
    'equalScalar',
    'DenseMatrix',
    'SparseMatrix',
    'concat'
];
var $30990fe5e42684fe$export$c6b51545da64d82f = /* #__PURE__ */ (0, $dsu7t.factory)($30990fe5e42684fe$var$name, $30990fe5e42684fe$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, addScalar: addScalar, equalScalar: equalScalar, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix, concat: concat } = _ref;
    var matAlgo01xDSid = (0, $ahu8B.createMatAlgo01xDSid)({
        typed: typed
    });
    var matAlgo04xSidSid = (0, $ibvF5.createMatAlgo04xSidSid)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo10xSids = (0, $enjrI.createMatAlgo10xSids)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Add two or more values, `x + y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.add(x, y)
   *    math.add(x, y, z, ...)
   *
   * Examples:
   *
   *    math.add(2, 3)               // returns number 5
   *    math.add(2, 3, 4)            // returns number 9
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(-4, 1)
   *    math.add(a, b)               // returns Complex -2 + 4i
   *
   *    math.add([1, 2, 3], 4)       // returns Array [5, 6, 7]
   *
   *    const c = math.unit('5 cm')
   *    const d = math.unit('2.1 mm')
   *    math.add(c, d)               // returns Unit 52.1 mm
   *
   *    math.add("2.3", "4")         // returns number 6.3
   *
   * See also:
   *
   *    subtract, sum
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} x First value to add
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} y Second value to add
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} Sum of `x` and `y`
   */ return typed($30990fe5e42684fe$var$name, {
        'any, any': addScalar,
        'any, any, ...any': typed.referToSelf((self)=>(x, y, rest)=>{
                var result = self(x, y);
                for(var i = 0; i < rest.length; i++)result = self(result, rest[i]);
                return result;
            })
    }, matrixAlgorithmSuite({
        elop: addScalar,
        DS: matAlgo01xDSid,
        SS: matAlgo04xSidSid,
        Ss: matAlgo10xSids
    }));
});

});
parcelRegister("ahu8B", function(module, exports) {

$parcel$export(module.exports, "createMatAlgo01xDSid", () => $77c2dea9b8922018$export$727ab96f88a9e651);

var $dsu7t = parcelRequire("dsu7t");

var $7asMt = parcelRequire("7asMt");
var $77c2dea9b8922018$var$name = 'matAlgo01xDSid';
var $77c2dea9b8922018$var$dependencies = [
    'typed'
];
var $77c2dea9b8922018$export$727ab96f88a9e651 = /* #__PURE__ */ (0, $dsu7t.factory)($77c2dea9b8922018$var$name, $77c2dea9b8922018$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij).
   * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  Dij          ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function algorithm1(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype || denseMatrix.getDataType();
        // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype || sparseMatrix._data === undefined ? sparseMatrix._datatype : sparseMatrix.getDataType();
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $7asMt.DimensionError)(asize.length, bsize.length);
        // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
        // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error('Cannot perform operation on Dense Matrix and Pattern Sparse Matrix');
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // process data types
        var dt = typeof adt === 'string' && adt !== 'mixed' && adt === bdt ? adt : undefined;
        // callback function
        var cf = dt ? typed.find(callback, [
            dt,
            dt
        ]) : callback;
        // vars
        var i, j;
        // result (DenseMatrix)
        var cdata = [];
        // initialize c
        for(i = 0; i < rows; i++)cdata[i] = [];
        // workspace
        var x = [];
        // marks indicating we have a value in x for a given column
        var w = [];
        // loop columns in b
        for(j = 0; j < columns; j++){
            // column mark
            var mark = j + 1;
            // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k];
                // update workspace
                x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]);
                // mark i as updated
                w[i] = mark;
            }
            // loop rows
            for(i = 0; i < rows; i++)// check row is in workspace
            if (w[i] === mark) // c[i][j] was already calculated
            cdata[i][j] = x[i];
            else // item does not exist in S
            cdata[i][j] = adata[i][j];
        }
        // return dense matrix
        return denseMatrix.createDenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: adt === denseMatrix._datatype && bdt === sparseMatrix._datatype ? dt : undefined
        });
    };
});

});

parcelRegister("ibvF5", function(module, exports) {

$parcel$export(module.exports, "createMatAlgo04xSidSid", () => $d3d1d066a16af5de$export$1dd33d839e34f63c);

var $dsu7t = parcelRequire("dsu7t");

var $7asMt = parcelRequire("7asMt");
var $d3d1d066a16af5de$var$name = 'matAlgo04xSidSid';
var $d3d1d066a16af5de$var$dependencies = [
    'typed',
    'equalScalar'
];
var $d3d1d066a16af5de$export$1dd33d839e34f63c = /* #__PURE__ */ (0, $dsu7t.factory)($d3d1d066a16af5de$var$name, $d3d1d066a16af5de$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0 && B(i,j) === 0
   *          └  B(i,j)       ; A(i,j) === 0
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function matAlgo04xSidSid(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype || a._data === undefined ? a._datatype : a.getDataType();
        // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype || b._data === undefined ? b._datatype : b.getDataType();
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $7asMt.DimensionError)(asize.length, bsize.length);
        // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === 'string' && adt === bdt && adt !== 'mixed') {
            // datatype
            dt = adt;
            // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = [];
        // workspace
        var xa = avalues && bvalues ? [] : undefined;
        var xb = avalues && bvalues ? [] : undefined;
        // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = [];
        // vars
        var i, j, k, k0, k1;
        // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length;
            // columns mark
            var mark = j + 1;
            // loop A(:,j)
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k];
                // update c
                cindex.push(i);
                // update workspace
                wa[i] = mark;
                // check we need to process values
                if (xa) xa[i] = avalues[k];
            }
            // loop B(:,j)
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k];
                // check row exists in A
                if (wa[i] === mark) // update record in xa @ i
                {
                    if (xa) {
                        // invoke callback
                        var v = cf(xa[i], bvalues[k]);
                        // check for zero
                        if (!eq(v, zero)) // update workspace
                        xa[i] = v;
                        else // remove mark (index will be removed later)
                        wa[i] = null;
                    }
                } else {
                    // update c
                    cindex.push(i);
                    // update workspace
                    wb[i] = mark;
                    // check we need to process values
                    if (xb) xb[i] = bvalues[k];
                }
            }
            // check we need to process values (non pattern matrix)
            if (xa && xb) {
                // initialize first index in j
                k = cptr[j];
                // loop index in j
                while(k < cindex.length){
                    // row
                    i = cindex[k];
                    // check workspace has value @ i
                    if (wa[i] === mark) {
                        // push value (Aij != 0 || (Aij != 0 && Bij != 0))
                        cvalues[k] = xa[i];
                        // increment pointer
                        k++;
                    } else if (wb[i] === mark) {
                        // push value (bij != 0)
                        cvalues[k] = xb[i];
                        // increment pointer
                        k++;
                    } else // remove index @ k
                    cindex.splice(k, 1);
                }
            }
        }
        // update cptr
        cptr[columns] = cindex.length;
        // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    };
});

});

parcelRegister("enjrI", function(module, exports) {

$parcel$export(module.exports, "createMatAlgo10xSids", () => $a7724c3fc6ff42f9$export$5295edae9a41ff00);

var $dsu7t = parcelRequire("dsu7t");
var $a7724c3fc6ff42f9$var$name = 'matAlgo10xSids';
var $a7724c3fc6ff42f9$var$dependencies = [
    'typed',
    'DenseMatrix'
];
var $a7724c3fc6ff42f9$export$5295edae9a41ff00 = /* #__PURE__ */ (0, $dsu7t.factory)($a7724c3fc6ff42f9$var$name, $a7724c3fc6ff42f9$var$dependencies, (_ref)=>{
    var { typed: typed, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked NZ times (number of nonzero items in S).
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  b          ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function matAlgo10xSids(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype;
        // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error('Cannot perform operation on Pattern Sparse Matrix and Scalar value');
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === 'string') {
            // datatype
            dt = adt;
            // convert b to the same datatype
            b = typed.convert(b, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result arrays
        var cdata = [];
        // workspaces
        var x = [];
        // marks indicating we have a value in x for a given column
        var w = [];
        // loop columns
        for(var j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1;
            // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var r = aindex[k];
                // update workspace
                x[r] = avalues[k];
                w[r] = mark;
            }
            // loop rows
            for(var i = 0; i < rows; i++){
                // initialize C on first column
                if (j === 0) // create row array
                cdata[i] = [];
                // check sparse matrix has a value @ i,j
                if (w[i] === mark) // invoke callback, update C
                cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
                else // dense matrix value @ i, j
                cdata[i][j] = b;
            }
        }
        // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("6SJnV", function(module, exports) {

$parcel$export(module.exports, "createMatrixAlgorithmSuite", () => $502afdb8e146d5a7$export$16b92d4ea17760ac);

var $dsu7t = parcelRequire("dsu7t");

var $9v8q6 = parcelRequire("9v8q6");

var $bFZOG = parcelRequire("bFZOG");

var $dK2sh = parcelRequire("dK2sh");

var $ficQv = parcelRequire("ficQv");
var $502afdb8e146d5a7$var$name = 'matrixAlgorithmSuite';
var $502afdb8e146d5a7$var$dependencies = [
    'typed',
    'matrix'
];
var $502afdb8e146d5a7$export$16b92d4ea17760ac = /* #__PURE__ */ (0, $dsu7t.factory)($502afdb8e146d5a7$var$name, $502afdb8e146d5a7$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    var matAlgo13xDD = (0, $bFZOG.createMatAlgo13xDD)({
        typed: typed
    });
    var matAlgo14xDs = (0, $dK2sh.createMatAlgo14xDs)({
        typed: typed
    });
    /**
   * Return a signatures object with the usual boilerplate of
   * matrix algorithms, based on a plain options object with the
   * following properties:
   *   elop: function -- the elementwise operation to use, defaults to self
   *   SS: function -- the algorithm to apply for two sparse matrices
   *   DS: function -- the algorithm to apply for a dense and a sparse matrix
   *   SD: function -- algo for a sparse and a dense; defaults to SD flipped
   *   Ss: function -- the algorithm to apply for a sparse matrix and scalar
   *   sS: function -- algo for scalar and sparse; defaults to Ss flipped
   *   scalar: string -- typed-function type for scalars, defaults to 'any'
   *
   * If Ss is not specified, no matrix-scalar signatures are generated.
   *
   * @param {object} options
   * @return {Object<string, function>} signatures
   */ return function matrixAlgorithmSuite(options) {
        var elop = options.elop;
        var SD = options.SD || options.DS;
        var matrixSignatures;
        if (elop) {
            // First the dense ones
            matrixSignatures = {
                'DenseMatrix, DenseMatrix': (x, y)=>matAlgo13xDD(...(0, $ficQv.broadcast)(x, y), elop),
                'Array, Array': (x, y)=>matAlgo13xDD(...(0, $ficQv.broadcast)(matrix(x), matrix(y)), elop).valueOf(),
                'Array, DenseMatrix': (x, y)=>matAlgo13xDD(...(0, $ficQv.broadcast)(matrix(x), y), elop),
                'DenseMatrix, Array': (x, y)=>matAlgo13xDD(...(0, $ficQv.broadcast)(x, matrix(y)), elop)
            };
            // Now incorporate sparse matrices
            if (options.SS) matrixSignatures['SparseMatrix, SparseMatrix'] = (x, y)=>options.SS(...(0, $ficQv.broadcast)(x, y), elop, false);
            if (options.DS) {
                matrixSignatures['DenseMatrix, SparseMatrix'] = (x, y)=>options.DS(...(0, $ficQv.broadcast)(x, y), elop, false);
                matrixSignatures['Array, SparseMatrix'] = (x, y)=>options.DS(...(0, $ficQv.broadcast)(matrix(x), y), elop, false);
            }
            if (SD) {
                matrixSignatures['SparseMatrix, DenseMatrix'] = (x, y)=>SD(...(0, $ficQv.broadcast)(y, x), elop, true);
                matrixSignatures['SparseMatrix, Array'] = (x, y)=>SD(...(0, $ficQv.broadcast)(matrix(y), x), elop, true);
            }
        } else {
            // No elop, use this
            // First the dense ones
            matrixSignatures = {
                'DenseMatrix, DenseMatrix': typed.referToSelf((self)=>(x, y)=>{
                        return matAlgo13xDD(...(0, $ficQv.broadcast)(x, y), self);
                    }),
                'Array, Array': typed.referToSelf((self)=>(x, y)=>{
                        return matAlgo13xDD(...(0, $ficQv.broadcast)(matrix(x), matrix(y)), self).valueOf();
                    }),
                'Array, DenseMatrix': typed.referToSelf((self)=>(x, y)=>{
                        return matAlgo13xDD(...(0, $ficQv.broadcast)(matrix(x), y), self);
                    }),
                'DenseMatrix, Array': typed.referToSelf((self)=>(x, y)=>{
                        return matAlgo13xDD(...(0, $ficQv.broadcast)(x, matrix(y)), self);
                    })
            };
            // Now incorporate sparse matrices
            if (options.SS) matrixSignatures['SparseMatrix, SparseMatrix'] = typed.referToSelf((self)=>(x, y)=>{
                    return options.SS(...(0, $ficQv.broadcast)(x, y), self, false);
                });
            if (options.DS) {
                matrixSignatures['DenseMatrix, SparseMatrix'] = typed.referToSelf((self)=>(x, y)=>{
                        return options.DS(...(0, $ficQv.broadcast)(x, y), self, false);
                    });
                matrixSignatures['Array, SparseMatrix'] = typed.referToSelf((self)=>(x, y)=>{
                        return options.DS(...(0, $ficQv.broadcast)(matrix(x), y), self, false);
                    });
            }
            if (SD) {
                matrixSignatures['SparseMatrix, DenseMatrix'] = typed.referToSelf((self)=>(x, y)=>{
                        return SD(...(0, $ficQv.broadcast)(y, x), self, true);
                    });
                matrixSignatures['SparseMatrix, Array'] = typed.referToSelf((self)=>(x, y)=>{
                        return SD(...(0, $ficQv.broadcast)(matrix(y), x), self, true);
                    });
            }
        }
        // Now add the scalars
        var scalar = options.scalar || 'any';
        var Ds = options.Ds || options.Ss;
        if (Ds) {
            if (elop) {
                matrixSignatures['DenseMatrix,' + scalar] = (x, y)=>matAlgo14xDs(x, y, elop, false);
                matrixSignatures[scalar + ', DenseMatrix'] = (x, y)=>matAlgo14xDs(y, x, elop, true);
                matrixSignatures['Array,' + scalar] = (x, y)=>matAlgo14xDs(matrix(x), y, elop, false).valueOf();
                matrixSignatures[scalar + ', Array'] = (x, y)=>matAlgo14xDs(matrix(y), x, elop, true).valueOf();
            } else {
                matrixSignatures['DenseMatrix,' + scalar] = typed.referToSelf((self)=>(x, y)=>{
                        return matAlgo14xDs(x, y, self, false);
                    });
                matrixSignatures[scalar + ', DenseMatrix'] = typed.referToSelf((self)=>(x, y)=>{
                        return matAlgo14xDs(y, x, self, true);
                    });
                matrixSignatures['Array,' + scalar] = typed.referToSelf((self)=>(x, y)=>{
                        return matAlgo14xDs(matrix(x), y, self, false).valueOf();
                    });
                matrixSignatures[scalar + ', Array'] = typed.referToSelf((self)=>(x, y)=>{
                        return matAlgo14xDs(matrix(y), x, self, true).valueOf();
                    });
            }
        }
        var sS = options.sS !== undefined ? options.sS : options.Ss;
        if (elop) {
            if (options.Ss) matrixSignatures['SparseMatrix,' + scalar] = (x, y)=>options.Ss(x, y, elop, false);
            if (sS) matrixSignatures[scalar + ', SparseMatrix'] = (x, y)=>sS(y, x, elop, true);
        } else {
            if (options.Ss) matrixSignatures['SparseMatrix,' + scalar] = typed.referToSelf((self)=>(x, y)=>{
                    return options.Ss(x, y, self, false);
                });
            if (sS) matrixSignatures[scalar + ', SparseMatrix'] = typed.referToSelf((self)=>(x, y)=>{
                    return sS(y, x, self, true);
                });
        }
        // Also pull in the scalar signatures if the operator is a typed function
        if (elop && elop.signatures) (0, $9v8q6.extend)(matrixSignatures, elop.signatures);
        return matrixSignatures;
    };
});

});
parcelRegister("bFZOG", function(module, exports) {

$parcel$export(module.exports, "createMatAlgo13xDD", () => $8803797de6b492d7$export$bd1609c374d6d636);

var $dsu7t = parcelRequire("dsu7t");

var $7asMt = parcelRequire("7asMt");
var $8803797de6b492d7$var$name = 'matAlgo13xDD';
var $8803797de6b492d7$var$dependencies = [
    'typed'
];
var $8803797de6b492d7$export$bd1609c374d6d636 = /* #__PURE__ */ (0, $dsu7t.factory)($8803797de6b492d7$var$name, $8803797de6b492d7$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, Bij..z).
   * Callback function invoked MxN times.
   *
   * C(i,j,...z) = f(Aij..z, Bij..z)
   *
   * @param {Matrix}   a                 The DenseMatrix instance (A)
   * @param {Matrix}   b                 The DenseMatrix instance (B)
   * @param {Function} callback          The f(Aij..z,Bij..z) operation to invoke
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97658658
   */ return function matAlgo13xDD(a, b, callback) {
        // a arrays
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype;
        // b arrays
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype;
        // c arrays
        var csize = [];
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $7asMt.DimensionError)(asize.length, bsize.length);
        // validate each one of the dimension sizes
        for(var s = 0; s < asize.length; s++){
            // must match
            if (asize[s] !== bsize[s]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
            // update dimension in c
            csize[s] = asize[s];
        }
        // datatype
        var dt;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === 'string' && adt === bdt) {
            // datatype
            dt = adt;
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // populate cdata, iterate through dimensions
        var cdata = csize.length > 0 ? _iterate(cf, 0, csize, csize[0], adata, bdata) : [];
        // c matrix
        return a.createDenseMatrix({
            data: cdata,
            size: csize,
            datatype: dt
        });
    };
    // recursive function
    function _iterate(f, level, s, n, av, bv) {
        // initialize array for this level
        var cv = [];
        // check we reach the last level
        if (level === s.length - 1) // loop arrays in last level
        for(var i = 0; i < n; i++)// invoke callback and store value
        cv[i] = f(av[i], bv[i]);
        else // iterate current level
        for(var j = 0; j < n; j++)// iterate next level
        cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv[j]);
        return cv;
    }
});

});

parcelRegister("dK2sh", function(module, exports) {

$parcel$export(module.exports, "createMatAlgo14xDs", () => $a01179c4294ca680$export$4b07063314120f7c);

var $dsu7t = parcelRequire("dsu7t");

var $9v8q6 = parcelRequire("9v8q6");
var $a01179c4294ca680$var$name = 'matAlgo14xDs';
var $a01179c4294ca680$var$dependencies = [
    'typed'
];
var $a01179c4294ca680$export$4b07063314120f7c = /* #__PURE__ */ (0, $dsu7t.factory)($a01179c4294ca680$var$name, $a01179c4294ca680$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, b).
   * Callback function invoked MxN times.
   *
   * C(i,j,...z) = f(Aij..z, b)
   *
   * @param {Matrix}   a                 The DenseMatrix instance (A)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij..z,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Aij..z)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97659042
   */ return function matAlgo14xDs(a, b, callback, inverse) {
        // a arrays
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype;
        // datatype
        var dt;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === 'string') {
            // datatype
            dt = adt;
            // convert b to the same datatype
            b = typed.convert(b, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // populate cdata, iterate through dimensions
        var cdata = asize.length > 0 ? _iterate(cf, 0, asize, asize[0], adata, b, inverse) : [];
        // c matrix
        return a.createDenseMatrix({
            data: cdata,
            size: (0, $9v8q6.clone)(asize),
            datatype: dt
        });
    };
    // recursive function
    function _iterate(f, level, s, n, av, bv, inverse) {
        // initialize array for this level
        var cv = [];
        // check we reach the last level
        if (level === s.length - 1) // loop arrays in last level
        for(var i = 0; i < n; i++)// invoke callback and store value
        cv[i] = inverse ? f(bv, av[i]) : f(av[i], bv);
        else // iterate current level
        for(var j = 0; j < n; j++)// iterate next level
        cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv, inverse);
        return cv;
    }
});

});

parcelRegister("ficQv", function(module, exports) {

$parcel$export(module.exports, "broadcast", () => $b222805f95f5d982$export$24d33a6f4bffea69);

var $d80Xp = parcelRequire("d80Xp");

var $9v8q6 = parcelRequire("9v8q6");
function $b222805f95f5d982$export$24d33a6f4bffea69(A, B) {
    if ((0, $9v8q6.deepStrictEqual)(A.size(), B.size())) // If matrices have the same size return them
    return [
        A,
        B
    ];
    // calculate the broadcasted sizes
    var newSize = (0, $d80Xp.broadcastSizes)(A.size(), B.size());
    // return the array with the two broadcasted matrices
    return [
        A,
        B
    ].map((M)=>$b222805f95f5d982$var$_broadcastTo(M, newSize));
}
/**
 * Broadcasts a matrix to the given size.
 *
 * @param {Matrix} M - The matrix to be broadcasted.
 * @param {number[]} size - The desired size of the broadcasted matrix.
 * @returns {Matrix} The broadcasted matrix.
 * @throws {Error} If the size parameter is not an array of numbers.
 */ function $b222805f95f5d982$var$_broadcastTo(M, size) {
    if ((0, $9v8q6.deepStrictEqual)(M.size(), size)) return M;
    return M.create((0, $d80Xp.broadcastTo)(M.valueOf(), size), M.datatype());
}

});



parcelRegister("jWAkx", function(module, exports) {

$parcel$export(module.exports, "createAddScalar", () => $e84f9d834cc68220$export$bbebd809b9ccc50b);

var $dsu7t = parcelRequire("dsu7t");

var $dmcGu = parcelRequire("dmcGu");
var $e84f9d834cc68220$var$name = 'addScalar';
var $e84f9d834cc68220$var$dependencies = [
    'typed'
];
var $e84f9d834cc68220$export$bbebd809b9ccc50b = /* #__PURE__ */ (0, $dsu7t.factory)($e84f9d834cc68220$var$name, $e84f9d834cc68220$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Add two scalar values, `x + y`.
   * This function is meant for internal use: it is used by the public function
   * `add`
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit} x   First value to add
   * @param  {number | BigNumber | bigint | Fraction | Complex} y          Second value to add
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit}     Sum of `x` and `y`
   * @private
   */ return typed($e84f9d834cc68220$var$name, {
        'number, number': (0, $dmcGu.addNumber),
        'Complex, Complex': function Complex_Complex(x, y) {
            return x.add(y);
        },
        'BigNumber, BigNumber': function BigNumber_BigNumber(x, y) {
            return x.plus(y);
        },
        'bigint, bigint': function bigint_bigint(x, y) {
            return x + y;
        },
        'Fraction, Fraction': function Fraction_Fraction(x, y) {
            return x.add(y);
        },
        'Unit, Unit': typed.referToSelf((self)=>(x, y)=>{
                if (x.value === null || x.value === undefined) throw new Error('Parameter x contains a unit with undefined value');
                if (y.value === null || y.value === undefined) throw new Error('Parameter y contains a unit with undefined value');
                if (!x.equalBase(y)) throw new Error('Units do not match');
                var res = x.clone();
                res.value = typed.find(self, [
                    res.valueType(),
                    y.valueType()
                ])(res.value, y.value);
                res.fixPrefix = false;
                return res;
            })
    });
});

});

parcelRegister("j1g72", function(module, exports) {

$parcel$export(module.exports, "createAnd", () => $dd8a9bea4e90f6a8$export$15a698d88cae0eff);

var $kycT3 = parcelRequire("kycT3");

var $52JKA = parcelRequire("52JKA");

var $dK2sh = parcelRequire("dK2sh");

var $hF01R = parcelRequire("hF01R");

var $dsu7t = parcelRequire("dsu7t");

var $6SJnV = parcelRequire("6SJnV");

var $69vHM = parcelRequire("69vHM");
var $dd8a9bea4e90f6a8$var$name = 'and';
var $dd8a9bea4e90f6a8$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'zeros',
    'not',
    'concat'
];
var $dd8a9bea4e90f6a8$export$15a698d88cae0eff = /* #__PURE__ */ (0, $dsu7t.factory)($dd8a9bea4e90f6a8$var$name, $dd8a9bea4e90f6a8$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, not: not, concat: concat } = _ref;
    var matAlgo02xDS0 = (0, $kycT3.createMatAlgo02xDS0)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo06xS0S0 = (0, $hF01R.createMatAlgo06xS0S0)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo11xS0s = (0, $52JKA.createMatAlgo11xS0s)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo14xDs = (0, $dK2sh.createMatAlgo14xDs)({
        typed: typed
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Logical `and`. Test whether two values are both defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.and(x, y)
   *
   * Examples:
   *
   *    math.and(2, 4)   // returns true
   *
   *    a = [2, 0, 0]
   *    b = [3, 7, 0]
   *    c = 0
   *
   *    math.and(a, b)   // returns [true, false, false]
   *    math.and(a, c)   // returns [false, false, false]
   *
   * See also:
   *
   *    not, or, xor
   *
   * @param  {number | BigNumber | bigint | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | bigint | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when both inputs are defined with a nonzero/nonempty value.
   */ return typed($dd8a9bea4e90f6a8$var$name, {
        'number, number': (0, $69vHM.andNumber),
        'Complex, Complex': function Complex_Complex(x, y) {
            return (x.re !== 0 || x.im !== 0) && (y.re !== 0 || y.im !== 0);
        },
        'BigNumber, BigNumber': function BigNumber_BigNumber(x, y) {
            return !x.isZero() && !y.isZero() && !x.isNaN() && !y.isNaN();
        },
        'bigint, bigint': (0, $69vHM.andNumber),
        'Unit, Unit': typed.referToSelf((self)=>(x, y)=>self(x.value || 0, y.value || 0)),
        'SparseMatrix, any': typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (not(y)) // return zero matrix
                return zeros(x.size(), x.storage());
                return matAlgo11xS0s(x, y, self, false);
            }),
        'DenseMatrix, any': typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (not(y)) // return zero matrix
                return zeros(x.size(), x.storage());
                return matAlgo14xDs(x, y, self, false);
            }),
        'any, SparseMatrix': typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (not(x)) // return zero matrix
                return zeros(x.size(), x.storage());
                return matAlgo11xS0s(y, x, self, true);
            }),
        'any, DenseMatrix': typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (not(x)) // return zero matrix
                return zeros(x.size(), x.storage());
                return matAlgo14xDs(y, x, self, true);
            }),
        'Array, any': typed.referToSelf((self)=>(x, y)=>{
                // use matrix implementation
                return self(matrix(x), y).valueOf();
            }),
        'any, Array': typed.referToSelf((self)=>(x, y)=>{
                // use matrix implementation
                return self(x, matrix(y)).valueOf();
            })
    }, matrixAlgorithmSuite({
        SS: matAlgo06xS0S0,
        DS: matAlgo02xDS0
    }));
});

});
parcelRegister("kycT3", function(module, exports) {

$parcel$export(module.exports, "createMatAlgo02xDS0", () => $ef60fab45158946c$export$32ae34d6563cd126);

var $dsu7t = parcelRequire("dsu7t");

var $7asMt = parcelRequire("7asMt");
var $ef60fab45158946c$var$name = 'matAlgo02xDS0';
var $ef60fab45158946c$var$dependencies = [
    'typed',
    'equalScalar'
];
var $ef60fab45158946c$export$32ae34d6563cd126 = /* #__PURE__ */ (0, $dsu7t.factory)($ef60fab45158946c$var$name, $ef60fab45158946c$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij).
   * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function matAlgo02xDS0(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype || denseMatrix.getDataType();
        // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype || sparseMatrix._data === undefined ? sparseMatrix._datatype : sparseMatrix.getDataType();
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $7asMt.DimensionError)(asize.length, bsize.length);
        // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
        // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error('Cannot perform operation on Dense Matrix and Pattern Sparse Matrix');
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === 'string' && adt === bdt && adt !== 'mixed') {
            // datatype
            dt = adt;
            // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result (SparseMatrix)
        var cvalues = [];
        var cindex = [];
        var cptr = [];
        // loop columns in b
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length;
            // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = bindex[k];
                // update C(i,j)
                var cij = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]);
                // check for nonzero
                if (!eq(cij, zero)) {
                    // push i & v
                    cindex.push(i);
                    cvalues.push(cij);
                }
            }
        }
        // update cptr
        cptr[columns] = cindex.length;
        // return sparse matrix
        return sparseMatrix.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: adt === denseMatrix._datatype && bdt === sparseMatrix._datatype ? dt : undefined
        });
    };
});

});

parcelRegister("52JKA", function(module, exports) {

$parcel$export(module.exports, "createMatAlgo11xS0s", () => $3ac0a0c01f0b0843$export$b315efa10530691e);

var $dsu7t = parcelRequire("dsu7t");
var $3ac0a0c01f0b0843$var$name = 'matAlgo11xS0s';
var $3ac0a0c01f0b0843$var$dependencies = [
    'typed',
    'equalScalar'
];
var $3ac0a0c01f0b0843$export$b315efa10530691e = /* #__PURE__ */ (0, $dsu7t.factory)($3ac0a0c01f0b0843$var$name, $3ac0a0c01f0b0843$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked NZ times (number of nonzero items in S).
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  0          ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function matAlgo11xS0s(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype;
        // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error('Cannot perform operation on Pattern Sparse Matrix and Scalar value');
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === 'string') {
            // datatype
            dt = adt;
            // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
            // convert b to the same datatype
            b = typed.convert(b, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result arrays
        var cvalues = [];
        var cindex = [];
        var cptr = [];
        // loop columns
        for(var j = 0; j < columns; j++){
            // initialize ptr
            cptr[j] = cindex.length;
            // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = aindex[k];
                // invoke callback
                var v = inverse ? cf(b, avalues[k]) : cf(avalues[k], b);
                // check value is zero
                if (!eq(v, zero)) {
                    // push index & value
                    cindex.push(i);
                    cvalues.push(v);
                }
            }
        }
        // update ptr
        cptr[columns] = cindex.length;
        // return sparse matrix
        return s.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("hF01R", function(module, exports) {

$parcel$export(module.exports, "createMatAlgo06xS0S0", () => $cdb649c9c93c609e$export$7e944de5217ad25);

var $dsu7t = parcelRequire("dsu7t");

var $7asMt = parcelRequire("7asMt");

var $20mkw = parcelRequire("20mkw");
var $cdb649c9c93c609e$var$name = 'matAlgo06xS0S0';
var $cdb649c9c93c609e$var$dependencies = [
    'typed',
    'equalScalar'
];
var $cdb649c9c93c609e$export$7e944de5217ad25 = /* #__PURE__ */ (0, $dsu7t.factory)($cdb649c9c93c609e$var$name, $cdb649c9c93c609e$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked (Anz U Bnz) times, where Anz and Bnz are the nonzero elements in both matrices.
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function matAlgo06xS0S0(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var asize = a._size;
        var adt = a._datatype || a._data === undefined ? a._datatype : a.getDataType();
        // sparse matrix arrays
        var bvalues = b._values;
        var bsize = b._size;
        var bdt = b._datatype || b._data === undefined ? b._datatype : b.getDataType();
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $7asMt.DimensionError)(asize.length, bsize.length);
        // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === 'string' && adt === bdt && adt !== 'mixed') {
            // datatype
            dt = adt;
            // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = [];
        // workspaces
        var x = cvalues ? [] : undefined;
        // marks indicating we have a value in x for a given column
        var w = [];
        // marks indicating value in a given row has been updated
        var u = [];
        // loop columns
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length;
            // columns mark
            var mark = j + 1;
            // scatter the values of A(:,j) into workspace
            (0, $20mkw.scatter)(a, j, w, x, u, mark, cindex, cf);
            // scatter the values of B(:,j) into workspace
            (0, $20mkw.scatter)(b, j, w, x, u, mark, cindex, cf);
            // check we need to process values (non pattern matrix)
            if (x) {
                // initialize first index in j
                var k = cptr[j];
                // loop index in j
                while(k < cindex.length){
                    // row
                    var i = cindex[k];
                    // check function was invoked on current row (Aij !=0 && Bij != 0)
                    if (u[i] === mark) {
                        // value @ i
                        var v = x[i];
                        // check for zero value
                        if (!eq(v, zero)) {
                            // push value
                            cvalues.push(v);
                            // increment pointer
                            k++;
                        } else // remove value @ i, do not increment pointer
                        cindex.splice(k, 1);
                    } else // remove value @ i, do not increment pointer
                    cindex.splice(k, 1);
                }
            } else {
                // initialize first index in j
                var p = cptr[j];
                // loop index in j
                while(p < cindex.length){
                    // row
                    var r = cindex[p];
                    // check function was invoked on current row (Aij !=0 && Bij != 0)
                    if (u[r] !== mark) // remove value @ i, do not increment pointer
                    cindex.splice(p, 1);
                    else // increment pointer
                    p++;
                }
            }
        }
        // update cptr
        cptr[columns] = cindex.length;
        // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    };
});

});

parcelRegister("69vHM", function(module, exports) {

$parcel$export(module.exports, "notNumber", () => $47ac2d512e1085a7$export$5c3e9fce4e8f3d3a);
$parcel$export(module.exports, "orNumber", () => $47ac2d512e1085a7$export$cb9e31d07eec8012);
$parcel$export(module.exports, "xorNumber", () => $47ac2d512e1085a7$export$17cc7dc3a74df3af);
$parcel$export(module.exports, "andNumber", () => $47ac2d512e1085a7$export$11dffb061e00e795);
var $47ac2d512e1085a7$var$n1 = 'number';
var $47ac2d512e1085a7$var$n2 = 'number, number';
function $47ac2d512e1085a7$export$5c3e9fce4e8f3d3a(x) {
    return !x;
}
$47ac2d512e1085a7$export$5c3e9fce4e8f3d3a.signature = $47ac2d512e1085a7$var$n1;
function $47ac2d512e1085a7$export$cb9e31d07eec8012(x, y) {
    return !!(x || y);
}
$47ac2d512e1085a7$export$cb9e31d07eec8012.signature = $47ac2d512e1085a7$var$n2;
function $47ac2d512e1085a7$export$17cc7dc3a74df3af(x, y) {
    return !!x !== !!y;
}
$47ac2d512e1085a7$export$17cc7dc3a74df3af.signature = $47ac2d512e1085a7$var$n2;
function $47ac2d512e1085a7$export$11dffb061e00e795(x, y) {
    return !!(x && y);
}
$47ac2d512e1085a7$export$11dffb061e00e795.signature = $47ac2d512e1085a7$var$n2;

});


parcelRegister("bhAyB", function(module, exports) {

$parcel$export(module.exports, "createArg", () => $836da3bb7a731882$export$bde3dabbd4699a93);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");
var $836da3bb7a731882$var$name = 'arg';
var $836da3bb7a731882$var$dependencies = [
    'typed'
];
var $836da3bb7a731882$export$bde3dabbd4699a93 = /* #__PURE__ */ (0, $dsu7t.factory)($836da3bb7a731882$var$name, $836da3bb7a731882$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the argument of a complex value.
   * For a complex number `a + bi`, the argument is computed as `atan2(b, a)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.arg(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 2)
   *    math.arg(a) / math.pi          // returns number 0.25
   *
   *    const b = math.complex('2 + 3i')
   *    math.arg(b)                    // returns number 0.982793723247329
   *    math.atan2(3, 2)               // returns number 0.982793723247329
   *
   * See also:
   *
   *    re, im, conj, abs
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The argument of x
   */ return typed($836da3bb7a731882$var$name, {
        number: function number(x) {
            return Math.atan2(0, x);
        },
        BigNumber: function BigNumber(x) {
            return x.constructor.atan2(0, x);
        },
        Complex: function Complex(x) {
            return x.arg();
        },
        // TODO: implement BigNumber support for function arg
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});

parcelRegister("55tlG", function(module, exports) {

$parcel$export(module.exports, "createAsec", () => $3b442f671c7cd41c$export$e1f28fc7c94f90b0);

var $dsu7t = parcelRequire("dsu7t");

var $cOOcY = parcelRequire("cOOcY");
var $3b442f671c7cd41c$var$name = 'asec';
var $3b442f671c7cd41c$var$dependencies = [
    'typed',
    'config',
    'Complex',
    'BigNumber'
];
var $3b442f671c7cd41c$export$e1f28fc7c94f90b0 = /* #__PURE__ */ (0, $dsu7t.factory)($3b442f671c7cd41c$var$name, $3b442f671c7cd41c$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the inverse secant of a value. Defined as `asec(x) = acos(1/x)`.
   *
   * To avoid confusion with the matrix arcsecant, this function does not
   * apply to matrices.
   *
   * Syntax:
   *
   *    math.asec(x)
   *
   * Examples:
   *
   *    math.asec(2)             // returns 1.0471975511965979
   *    math.asec(math.sec(1.5)) // returns 1.5
   *
   *    math.asec(0.5)           // returns Complex 0 + 1.3169578969248166i
   *
   * See also:
   *
   *    acos, acot, acsc
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} The arc secant of x
   */ return typed($3b442f671c7cd41c$var$name, {
        number: function number(x) {
            if (x <= -1 || x >= 1 || config.predictable) return (0, $cOOcY.asecNumber)(x);
            return new Complex(x, 0).asec();
        },
        Complex: function Complex(x) {
            return x.asec();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).acos();
        }
    });
});

});

parcelRegister("gZeft", function(module, exports) {

$parcel$export(module.exports, "createAsech", () => $c5dd65513a2b12bd$export$8eeff5f09afe95bc);

var $dsu7t = parcelRequire("dsu7t");

var $cOOcY = parcelRequire("cOOcY");
var $c5dd65513a2b12bd$var$name = 'asech';
var $c5dd65513a2b12bd$var$dependencies = [
    'typed',
    'config',
    'Complex',
    'BigNumber'
];
var $c5dd65513a2b12bd$export$8eeff5f09afe95bc = /* #__PURE__ */ (0, $dsu7t.factory)($c5dd65513a2b12bd$var$name, $c5dd65513a2b12bd$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic arcsecant of a value,
   * defined as `asech(x) = acosh(1/x) = ln(sqrt(1/x^2 - 1) + 1/x)`.
   *
   * To avoid confusion with the matrix hyperbolic arcsecant, this function
   * does not apply to matrices.
   *
   * Syntax:
   *
   *    math.asech(x)
   *
   * Examples:
   *
   *    math.asech(0.5)       // returns 1.3169578969248166
   *
   * See also:
   *
   *    acsch, acoth
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic arcsecant of x
   */ return typed($c5dd65513a2b12bd$var$name, {
        number: function number(x) {
            if (x <= 1 && x >= -1 || config.predictable) {
                var xInv = 1 / x;
                if (xInv > 0 || config.predictable) return (0, $cOOcY.asechNumber)(x);
                var ret = Math.sqrt(xInv * xInv - 1);
                return new Complex(Math.log(ret - xInv), Math.PI);
            }
            return new Complex(x, 0).asech();
        },
        Complex: function Complex(x) {
            return x.asech();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).acosh();
        }
    });
});

});

parcelRegister("1yWBt", function(module, exports) {

$parcel$export(module.exports, "createAsin", () => $12366cd80c0e533f$export$5f05d91ddc56bc14);

var $dsu7t = parcelRequire("dsu7t");
var $12366cd80c0e533f$var$name = 'asin';
var $12366cd80c0e533f$var$dependencies = [
    'typed',
    'config',
    'Complex'
];
var $12366cd80c0e533f$export$5f05d91ddc56bc14 = /* #__PURE__ */ (0, $dsu7t.factory)($12366cd80c0e533f$var$name, $12366cd80c0e533f$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the inverse sine of a value.
   *
   * To avoid confusion with the matric arcsine, this function does not apply
   * to matrices.
   *
   * Syntax:
   *
   *    math.asin(x)
   *
   * Examples:
   *
   *    math.asin(0.5)           // returns number 0.5235987755982989
   *    math.asin(math.sin(1.5)) // returns number 1.5
   *
   *    math.asin(2)             // returns Complex 1.5707963267948966 -1.3169578969248166i
   *
   * See also:
   *
   *    sin, atan, acos
   *
   * @param {number | BigNumber | Complex} x   Function input
   * @return {number | BigNumber | Complex} The arc sine of x
   */ return typed($12366cd80c0e533f$var$name, {
        number: function number(x) {
            if (x >= -1 && x <= 1 || config.predictable) return Math.asin(x);
            else return new Complex(x, 0).asin();
        },
        Complex: function Complex(x) {
            return x.asin();
        },
        BigNumber: function BigNumber(x) {
            return x.asin();
        }
    });
});

});

parcelRegister("aFf6p", function(module, exports) {

$parcel$export(module.exports, "createAsinh", () => $7c3972b62b0322b8$export$7278bb4e3c84d46a);

var $dsu7t = parcelRequire("dsu7t");

var $cOOcY = parcelRequire("cOOcY");
var $7c3972b62b0322b8$var$name = 'asinh';
var $7c3972b62b0322b8$var$dependencies = [
    'typed'
];
var $7c3972b62b0322b8$export$7278bb4e3c84d46a = /* #__PURE__ */ (0, $dsu7t.factory)($7c3972b62b0322b8$var$name, $7c3972b62b0322b8$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic arcsine of a value,
   * defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.
   *
   * To avoid confusion with the matrix hyperbolic arcsine, this function
   * does not apply to matrices.
   *
   * Syntax:
   *
   *    math.asinh(x)
   *
   * Examples:
   *
   *    math.asinh(0.5)       // returns 0.48121182505960347
   *
   * See also:
   *
   *    acosh, atanh
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic arcsine of x
   */ return typed('asinh', {
        number: (0, $cOOcY.asinhNumber),
        Complex: function Complex(x) {
            return x.asinh();
        },
        BigNumber: function BigNumber(x) {
            return x.asinh();
        }
    });
});

});

parcelRegister("ia9EJ", function(module, exports) {

$parcel$export(module.exports, "createAtan", () => $d390a6a4365fe050$export$b87f3a3301a24256);

var $dsu7t = parcelRequire("dsu7t");
var $d390a6a4365fe050$var$name = 'atan';
var $d390a6a4365fe050$var$dependencies = [
    'typed'
];
var $d390a6a4365fe050$export$b87f3a3301a24256 = /* #__PURE__ */ (0, $dsu7t.factory)($d390a6a4365fe050$var$name, $d390a6a4365fe050$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the inverse tangent of a value.
   *
   * To avoid confusion with matrix arctangent, this function does not apply
   * to matrices.
   *
   * Syntax:
   *
   *    math.atan(x)
   *
   * Examples:
   *
   *    math.atan(0.5)           // returns number 0.4636476090008061
   *    math.atan(2)             // returns number 1.1071487177940904
   *    math.atan(math.tan(1.5)) // returns number 1.5
   *
   * See also:
   *
   *    tan, asin, acos
   *
   * @param {number | BigNumber | Complex} x   Function input
   * @return {number | BigNumber | Complex} The arc tangent of x
   */ return typed('atan', {
        number: function number(x) {
            return Math.atan(x);
        },
        Complex: function Complex(x) {
            return x.atan();
        },
        BigNumber: function BigNumber(x) {
            return x.atan();
        }
    });
});

});

parcelRegister("cTBWT", function(module, exports) {

$parcel$export(module.exports, "createAtan2", () => $96380ef2363ae79f$export$c56716e11a38354e);

var $dsu7t = parcelRequire("dsu7t");

var $kycT3 = parcelRequire("kycT3");

var $a8bto = parcelRequire("a8bto");

var $8xtiv = parcelRequire("8xtiv");

var $52JKA = parcelRequire("52JKA");

var $19L2p = parcelRequire("19L2p");

var $6SJnV = parcelRequire("6SJnV");
var $96380ef2363ae79f$var$name = 'atan2';
var $96380ef2363ae79f$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'BigNumber',
    'DenseMatrix',
    'concat'
];
var $96380ef2363ae79f$export$c56716e11a38354e = /* #__PURE__ */ (0, $dsu7t.factory)($96380ef2363ae79f$var$name, $96380ef2363ae79f$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, BigNumber: BigNumber, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo02xDS0 = (0, $kycT3.createMatAlgo02xDS0)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo03xDSf = (0, $a8bto.createMatAlgo03xDSf)({
        typed: typed
    });
    var matAlgo09xS0Sf = (0, $8xtiv.createMatAlgo09xS0Sf)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo11xS0s = (0, $52JKA.createMatAlgo11xS0s)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Calculate the inverse tangent function with two arguments, y/x.
   * By providing two arguments, the right quadrant of the computed angle can be
   * determined.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.atan2(y, x)
   *
   * Examples:
   *
   *    math.atan2(2, 2) / math.pi       // returns number 0.25
   *
   *    const angle = math.unit(60, 'deg')
   *    const x = math.cos(angle)
   *    const y = math.sin(angle)
   *    math.atan2(y, x) * 180 / math.pi  // returns 60
   *
   *    math.atan(2)             // returns number 1.1071487177940904
   *
   * See also:
   *
   *    tan, atan, sin, cos
   *
   * @param {number | Array | Matrix} y  Second dimension
   * @param {number | Array | Matrix} x  First dimension
   * @return {number | Array | Matrix} Four-quadrant inverse tangent
   */ return typed($96380ef2363ae79f$var$name, {
        'number, number': Math.atan2,
        // Complex numbers doesn't seem to have a reasonable implementation of
        // atan2(). Even Matlab removed the support, after they only calculated
        // the atan only on base of the real part of the numbers and ignored
        // the imaginary.
        'BigNumber, BigNumber': (y, x)=>BigNumber.atan2(y, x)
    }, matrixAlgorithmSuite({
        scalar: 'number | BigNumber',
        SS: matAlgo09xS0Sf,
        DS: matAlgo03xDSf,
        SD: matAlgo02xDS0,
        Ss: matAlgo11xS0s,
        sS: matAlgo12xSfs
    }));
});

});
parcelRegister("a8bto", function(module, exports) {

$parcel$export(module.exports, "createMatAlgo03xDSf", () => $76038d0ede55ab9f$export$6325e83173a86892);

var $dsu7t = parcelRequire("dsu7t");

var $7asMt = parcelRequire("7asMt");
var $76038d0ede55ab9f$var$name = 'matAlgo03xDSf';
var $76038d0ede55ab9f$var$dependencies = [
    'typed'
];
var $76038d0ede55ab9f$export$6325e83173a86892 = /* #__PURE__ */ (0, $dsu7t.factory)($76038d0ede55ab9f$var$name, $76038d0ede55ab9f$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over SparseMatrix items and invokes the callback function f(Dij, Sij).
   * Callback function invoked M*N times.
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  f(Dij, 0)    ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (C)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function matAlgo03xDSf(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype || denseMatrix.getDataType();
        // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype || sparseMatrix._data === undefined ? sparseMatrix._datatype : sparseMatrix.getDataType();
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $7asMt.DimensionError)(asize.length, bsize.length);
        // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
        // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error('Cannot perform operation on Dense Matrix and Pattern Sparse Matrix');
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // zero value
        var zero = 0;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === 'string' && adt === bdt && adt !== 'mixed') {
            // datatype
            dt = adt;
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result (DenseMatrix)
        var cdata = [];
        // initialize dense matrix
        for(var z = 0; z < rows; z++)// initialize row
        cdata[z] = [];
        // workspace
        var x = [];
        // marks indicating we have a value in x for a given column
        var w = [];
        // loop columns in b
        for(var j = 0; j < columns; j++){
            // column mark
            var mark = j + 1;
            // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = bindex[k];
                // update workspace
                x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]);
                w[i] = mark;
            }
            // process workspace
            for(var y = 0; y < rows; y++)// check we have a calculated value for current row
            if (w[y] === mark) // use calculated value
            cdata[y][j] = x[y];
            else // calculate value
            cdata[y][j] = inverse ? cf(zero, adata[y][j]) : cf(adata[y][j], zero);
        }
        // return dense matrix
        return denseMatrix.createDenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: adt === denseMatrix._datatype && bdt === sparseMatrix._datatype ? dt : undefined
        });
    };
});

});

parcelRegister("8xtiv", function(module, exports) {

$parcel$export(module.exports, "createMatAlgo09xS0Sf", () => $637821a49ffd6c5a$export$53a31b0bf876516);

var $dsu7t = parcelRequire("dsu7t");

var $7asMt = parcelRequire("7asMt");
var $637821a49ffd6c5a$var$name = 'matAlgo09xS0Sf';
var $637821a49ffd6c5a$var$dependencies = [
    'typed',
    'equalScalar'
];
var $637821a49ffd6c5a$export$53a31b0bf876516 = /* #__PURE__ */ (0, $dsu7t.factory)($637821a49ffd6c5a$var$name, $637821a49ffd6c5a$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and invokes the callback function f(Aij, Bij).
   * Callback function invoked NZA times, number of nonzero elements in A.
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function matAlgo09xS0Sf(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype || a._data === undefined ? a._datatype : a.getDataType();
        // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype || b._data === undefined ? b._datatype : b.getDataType();
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $7asMt.DimensionError)(asize.length, bsize.length);
        // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === 'string' && adt === bdt && adt !== 'mixed') {
            // datatype
            dt = adt;
            // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = [];
        // workspaces
        var x = cvalues ? [] : undefined;
        // marks indicating we have a value in x for a given column
        var w = [];
        // vars
        var i, j, k, k0, k1;
        // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length;
            // column mark
            var mark = j + 1;
            // check we need to process values
            if (x) // loop B(:,j)
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k];
                // update workspace
                w[i] = mark;
                x[i] = bvalues[k];
            }
            // loop A(:,j)
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k];
                // check we need to process values
                if (x) {
                    // b value @ i,j
                    var vb = w[i] === mark ? x[i] : zero;
                    // invoke f
                    var vc = cf(avalues[k], vb);
                    // check zero value
                    if (!eq(vc, zero)) {
                        // push index
                        cindex.push(i);
                        // push value
                        cvalues.push(vc);
                    }
                } else // push index
                cindex.push(i);
            }
        }
        // update cptr
        cptr[columns] = cindex.length;
        // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    };
});

});

parcelRegister("19L2p", function(module, exports) {

$parcel$export(module.exports, "createMatAlgo12xSfs", () => $0d7b1e734ee1c053$export$c966408e3ecf83ee);

var $dsu7t = parcelRequire("dsu7t");
var $0d7b1e734ee1c053$var$name = 'matAlgo12xSfs';
var $0d7b1e734ee1c053$var$dependencies = [
    'typed',
    'DenseMatrix'
];
var $0d7b1e734ee1c053$export$c966408e3ecf83ee = /* #__PURE__ */ (0, $dsu7t.factory)($0d7b1e734ee1c053$var$name, $0d7b1e734ee1c053$var$dependencies, (_ref)=>{
    var { typed: typed, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked MxN times.
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  f(0, b)    ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function matAlgo12xSfs(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype;
        // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error('Cannot perform operation on Pattern Sparse Matrix and Scalar value');
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === 'string') {
            // datatype
            dt = adt;
            // convert b to the same datatype
            b = typed.convert(b, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result arrays
        var cdata = [];
        // workspaces
        var x = [];
        // marks indicating we have a value in x for a given column
        var w = [];
        // loop columns
        for(var j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1;
            // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var r = aindex[k];
                // update workspace
                x[r] = avalues[k];
                w[r] = mark;
            }
            // loop rows
            for(var i = 0; i < rows; i++){
                // initialize C on first column
                if (j === 0) // create row array
                cdata[i] = [];
                // check sparse matrix has a value @ i,j
                if (w[i] === mark) // invoke callback, update C
                cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
                else // dense matrix value @ i, j
                cdata[i][j] = inverse ? cf(b, 0) : cf(0, b);
            }
        }
        // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});


parcelRegister("8EWrX", function(module, exports) {

$parcel$export(module.exports, "createAtanh", () => $64df6611fd0954fb$export$c2dbbeab1e5e6195);

var $dsu7t = parcelRequire("dsu7t");

var $cOOcY = parcelRequire("cOOcY");
var $64df6611fd0954fb$var$name = 'atanh';
var $64df6611fd0954fb$var$dependencies = [
    'typed',
    'config',
    'Complex'
];
var $64df6611fd0954fb$export$c2dbbeab1e5e6195 = /* #__PURE__ */ (0, $dsu7t.factory)($64df6611fd0954fb$var$name, $64df6611fd0954fb$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the hyperbolic arctangent of a value,
   * defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.
   *
   * To avoid confusion with the matrix hyperbolic arctangent, this function
   * does not apply to matrices.
   *
   * Syntax:
   *
   *    math.atanh(x)
   *
   * Examples:
   *
   *    math.atanh(0.5)       // returns 0.5493061443340549
   *
   * See also:
   *
   *    acosh, asinh
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic arctangent of x
   */ return typed($64df6611fd0954fb$var$name, {
        number: function number(x) {
            if (x <= 1 && x >= -1 || config.predictable) return (0, $cOOcY.atanhNumber)(x);
            return new Complex(x, 0).atanh();
        },
        Complex: function Complex(x) {
            return x.atanh();
        },
        BigNumber: function BigNumber(x) {
            return x.atanh();
        }
    });
});

});

parcelRegister("bbddX", function(module, exports) {

$parcel$export(module.exports, "createSpeedOfLight", () => $823afad432d7a13b$export$ace78258608300fc);
$parcel$export(module.exports, "createGravitationConstant", () => $823afad432d7a13b$export$157e78cb05354391);
$parcel$export(module.exports, "createPlanckConstant", () => $823afad432d7a13b$export$e58ff8150d83ea6a);
$parcel$export(module.exports, "createReducedPlanckConstant", () => $823afad432d7a13b$export$50bee65ab76b402);
$parcel$export(module.exports, "createMagneticConstant", () => $823afad432d7a13b$export$e7fcb8898ecb0703);
$parcel$export(module.exports, "createElectricConstant", () => $823afad432d7a13b$export$d69030cf93f04407);
$parcel$export(module.exports, "createVacuumImpedance", () => $823afad432d7a13b$export$c9ff08d282f03cf0);
$parcel$export(module.exports, "createCoulomb", () => $823afad432d7a13b$export$815f2029cd62d0d6);
$parcel$export(module.exports, "createCoulombConstant", () => $823afad432d7a13b$export$929c18823255d893);
$parcel$export(module.exports, "createElementaryCharge", () => $823afad432d7a13b$export$542715ad7e3a9798);
$parcel$export(module.exports, "createBohrMagneton", () => $823afad432d7a13b$export$f5851397fd1173db);
$parcel$export(module.exports, "createConductanceQuantum", () => $823afad432d7a13b$export$e26bbd27fc291ddf);
$parcel$export(module.exports, "createInverseConductanceQuantum", () => $823afad432d7a13b$export$f2f136373157165b);
$parcel$export(module.exports, "createMagneticFluxQuantum", () => $823afad432d7a13b$export$fd46b6c8680e4d01);
$parcel$export(module.exports, "createNuclearMagneton", () => $823afad432d7a13b$export$9670d94122b9a81b);
$parcel$export(module.exports, "createKlitzing", () => $823afad432d7a13b$export$e3f21ac13bee6a0f);
$parcel$export(module.exports, "createBohrRadius", () => $823afad432d7a13b$export$19b72356ad84e4ee);
$parcel$export(module.exports, "createClassicalElectronRadius", () => $823afad432d7a13b$export$68a9771dccce9a23);
$parcel$export(module.exports, "createElectronMass", () => $823afad432d7a13b$export$85362d2a7862e209);
$parcel$export(module.exports, "createFermiCoupling", () => $823afad432d7a13b$export$b6687a2f3911256b);
$parcel$export(module.exports, "createFineStructure", () => $823afad432d7a13b$export$aaddb59a993d3ac4);
$parcel$export(module.exports, "createHartreeEnergy", () => $823afad432d7a13b$export$8bb818baeaa40bd6);
$parcel$export(module.exports, "createProtonMass", () => $823afad432d7a13b$export$f357c1a8d4fccef6);
$parcel$export(module.exports, "createDeuteronMass", () => $823afad432d7a13b$export$a403f6c5bed71f22);
$parcel$export(module.exports, "createNeutronMass", () => $823afad432d7a13b$export$676d5ebe8fbeb250);
$parcel$export(module.exports, "createQuantumOfCirculation", () => $823afad432d7a13b$export$6840f334b8a5b6b1);
$parcel$export(module.exports, "createRydberg", () => $823afad432d7a13b$export$fd1b48ecb0d5c0ef);
$parcel$export(module.exports, "createThomsonCrossSection", () => $823afad432d7a13b$export$229739a879741f68);
$parcel$export(module.exports, "createWeakMixingAngle", () => $823afad432d7a13b$export$fa2d42c5c25c1883);
$parcel$export(module.exports, "createEfimovFactor", () => $823afad432d7a13b$export$55fc8769b037d266);
$parcel$export(module.exports, "createAtomicMass", () => $823afad432d7a13b$export$2f8d2da219209d0a);
$parcel$export(module.exports, "createAvogadro", () => $823afad432d7a13b$export$4924e3d8de6ad850);
$parcel$export(module.exports, "createBoltzmann", () => $823afad432d7a13b$export$221b7a8c9510b6cc);
$parcel$export(module.exports, "createFaraday", () => $823afad432d7a13b$export$17ef8d738c9b0091);
$parcel$export(module.exports, "createFirstRadiation", () => $823afad432d7a13b$export$266a9bae8a62fb6e);
$parcel$export(module.exports, "createLoschmidt", () => $823afad432d7a13b$export$c38bce537e0ffddb);
$parcel$export(module.exports, "createGasConstant", () => $823afad432d7a13b$export$85a77a0842c24f74);
$parcel$export(module.exports, "createMolarPlanckConstant", () => $823afad432d7a13b$export$12e2358797b853c9);
$parcel$export(module.exports, "createMolarVolume", () => $823afad432d7a13b$export$f5e8f56ebfacbaca);
$parcel$export(module.exports, "createSackurTetrode", () => $823afad432d7a13b$export$467c65d9dfc3d3a2);
$parcel$export(module.exports, "createSecondRadiation", () => $823afad432d7a13b$export$ea93a35a6f35e1b6);
$parcel$export(module.exports, "createStefanBoltzmann", () => $823afad432d7a13b$export$a943525a62f69cd2);
$parcel$export(module.exports, "createWienDisplacement", () => $823afad432d7a13b$export$3c74568e9574d168);
$parcel$export(module.exports, "createMolarMass", () => $823afad432d7a13b$export$85414d775c93e6de);
$parcel$export(module.exports, "createMolarMassC12", () => $823afad432d7a13b$export$d5045cf71611a462);
$parcel$export(module.exports, "createGravity", () => $823afad432d7a13b$export$42b5845f95e0feee);
$parcel$export(module.exports, "createPlanckLength", () => $823afad432d7a13b$export$675ebbcd6bdcebd7);
$parcel$export(module.exports, "createPlanckMass", () => $823afad432d7a13b$export$d44b96c94520b20e);
$parcel$export(module.exports, "createPlanckTime", () => $823afad432d7a13b$export$3bf63d7b96fd8541);
$parcel$export(module.exports, "createPlanckCharge", () => $823afad432d7a13b$export$43e139a6eec1ab59);
$parcel$export(module.exports, "createPlanckTemperature", () => $823afad432d7a13b$export$d21f20fc89fac8c0);

var $dsu7t = parcelRequire("dsu7t");
var $823afad432d7a13b$export$ace78258608300fc = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('speedOfLight', '299792458', 'm s^-1');
var $823afad432d7a13b$export$157e78cb05354391 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('gravitationConstant', '6.67430e-11', 'm^3 kg^-1 s^-2');
var $823afad432d7a13b$export$e58ff8150d83ea6a = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('planckConstant', '6.62607015e-34', 'J s');
var $823afad432d7a13b$export$50bee65ab76b402 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('reducedPlanckConstant', '1.0545718176461565e-34', 'J s');
var $823afad432d7a13b$export$e7fcb8898ecb0703 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('magneticConstant', '1.25663706212e-6', 'N A^-2');
var $823afad432d7a13b$export$d69030cf93f04407 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('electricConstant', '8.8541878128e-12', 'F m^-1');
var $823afad432d7a13b$export$c9ff08d282f03cf0 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('vacuumImpedance', '376.730313667', 'ohm');
var $823afad432d7a13b$export$815f2029cd62d0d6 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('coulomb', '8.987551792261171e9', 'N m^2 C^-2'); // Deprecated in favor of coulombConstant
var $823afad432d7a13b$export$929c18823255d893 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('coulombConstant', '8.987551792261171e9', 'N m^2 C^-2');
var $823afad432d7a13b$export$542715ad7e3a9798 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('elementaryCharge', '1.602176634e-19', 'C');
var $823afad432d7a13b$export$f5851397fd1173db = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('bohrMagneton', '9.2740100783e-24', 'J T^-1');
var $823afad432d7a13b$export$e26bbd27fc291ddf = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('conductanceQuantum', '7.748091729863649e-5', 'S');
var $823afad432d7a13b$export$f2f136373157165b = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('inverseConductanceQuantum', '12906.403729652257', 'ohm');
var $823afad432d7a13b$export$fd46b6c8680e4d01 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('magneticFluxQuantum', '2.0678338484619295e-15', 'Wb');
var $823afad432d7a13b$export$9670d94122b9a81b = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('nuclearMagneton', '5.0507837461e-27', 'J T^-1');
var $823afad432d7a13b$export$e3f21ac13bee6a0f = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('klitzing', '25812.807459304513', 'ohm');
var $823afad432d7a13b$export$c090909964c68de4 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('josephson', '4.835978484169836e14 Hz V', 'Hz V^-1'); // TODO: support for Hz needed
var $823afad432d7a13b$export$19b72356ad84e4ee = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('bohrRadius', '5.29177210903e-11', 'm');
var $823afad432d7a13b$export$68a9771dccce9a23 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('classicalElectronRadius', '2.8179403262e-15', 'm');
var $823afad432d7a13b$export$85362d2a7862e209 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('electronMass', '9.1093837015e-31', 'kg');
var $823afad432d7a13b$export$b6687a2f3911256b = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('fermiCoupling', '1.1663787e-5', 'GeV^-2');
var $823afad432d7a13b$export$aaddb59a993d3ac4 = $823afad432d7a13b$var$numberFactory('fineStructure', 7.2973525693e-3);
var $823afad432d7a13b$export$8bb818baeaa40bd6 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('hartreeEnergy', '4.3597447222071e-18', 'J');
var $823afad432d7a13b$export$f357c1a8d4fccef6 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('protonMass', '1.67262192369e-27', 'kg');
var $823afad432d7a13b$export$a403f6c5bed71f22 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('deuteronMass', '3.3435830926e-27', 'kg');
var $823afad432d7a13b$export$676d5ebe8fbeb250 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('neutronMass', '1.6749271613e-27', 'kg');
var $823afad432d7a13b$export$6840f334b8a5b6b1 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('quantumOfCirculation', '3.6369475516e-4', 'm^2 s^-1');
var $823afad432d7a13b$export$fd1b48ecb0d5c0ef = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('rydberg', '10973731.568160', 'm^-1');
var $823afad432d7a13b$export$229739a879741f68 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('thomsonCrossSection', '6.6524587321e-29', 'm^2');
var $823afad432d7a13b$export$fa2d42c5c25c1883 = $823afad432d7a13b$var$numberFactory('weakMixingAngle', 0.22290);
var $823afad432d7a13b$export$55fc8769b037d266 = $823afad432d7a13b$var$numberFactory('efimovFactor', 22.7);
var $823afad432d7a13b$export$2f8d2da219209d0a = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('atomicMass', '1.66053906660e-27', 'kg');
var $823afad432d7a13b$export$4924e3d8de6ad850 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('avogadro', '6.02214076e23', 'mol^-1');
var $823afad432d7a13b$export$221b7a8c9510b6cc = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('boltzmann', '1.380649e-23', 'J K^-1');
var $823afad432d7a13b$export$17ef8d738c9b0091 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('faraday', '96485.33212331001', 'C mol^-1');
var $823afad432d7a13b$export$266a9bae8a62fb6e = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('firstRadiation', '3.7417718521927573e-16', 'W m^2');
var $823afad432d7a13b$export$c38bce537e0ffddb = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('loschmidt', '2.686780111798444e25', 'm^-3');
var $823afad432d7a13b$export$85a77a0842c24f74 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('gasConstant', '8.31446261815324', 'J K^-1 mol^-1');
var $823afad432d7a13b$export$12e2358797b853c9 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('molarPlanckConstant', '3.990312712893431e-10', 'J s mol^-1');
var $823afad432d7a13b$export$f5e8f56ebfacbaca = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('molarVolume', '0.022413969545014137', 'm^3 mol^-1');
var $823afad432d7a13b$export$467c65d9dfc3d3a2 = $823afad432d7a13b$var$numberFactory('sackurTetrode', -1.16487052358);
var $823afad432d7a13b$export$ea93a35a6f35e1b6 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('secondRadiation', '0.014387768775039337', 'm K');
var $823afad432d7a13b$export$a943525a62f69cd2 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('stefanBoltzmann', '5.67037441918443e-8', 'W m^-2 K^-4');
var $823afad432d7a13b$export$3c74568e9574d168 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('wienDisplacement', '2.897771955e-3', 'm K');
var $823afad432d7a13b$export$85414d775c93e6de = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('molarMass', '0.99999999965e-3', 'kg mol^-1');
var $823afad432d7a13b$export$d5045cf71611a462 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('molarMassC12', '11.9999999958e-3', 'kg mol^-1');
var $823afad432d7a13b$export$42b5845f95e0feee = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('gravity', '9.80665', 'm s^-2');
var $823afad432d7a13b$export$675ebbcd6bdcebd7 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('planckLength', '1.616255e-35', 'm');
var $823afad432d7a13b$export$d44b96c94520b20e = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('planckMass', '2.176435e-8', 'kg');
var $823afad432d7a13b$export$3bf63d7b96fd8541 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('planckTime', '5.391245e-44', 's');
var $823afad432d7a13b$export$43e139a6eec1ab59 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('planckCharge', '1.87554603778e-18', 'C');
var $823afad432d7a13b$export$d21f20fc89fac8c0 = /* #__PURE__ */ $823afad432d7a13b$var$unitFactory('planckTemperature', '1.416785e+32', 'K');
// helper function to create a factory function which creates a physical constant,
// a Unit with either a number value or a BigNumber value depending on the configuration
function $823afad432d7a13b$var$unitFactory(name, valueStr, unitStr) {
    var dependencies = [
        'config',
        'Unit',
        'BigNumber'
    ];
    return (0, $dsu7t.factory)(name, dependencies, (_ref)=>{
        var { config: config, Unit: Unit, BigNumber: BigNumber } = _ref;
        // Note that we can parse into number or BigNumber.
        // We do not parse into Fractions as that doesn't make sense: we would lose precision of the values
        // Therefore we dont use Unit.parse()
        var value = config.number === 'BigNumber' ? new BigNumber(valueStr) : parseFloat(valueStr);
        var unit = new Unit(value, unitStr);
        unit.fixPrefix = true;
        return unit;
    });
}
// helper function to create a factory function which creates a numeric constant,
// either a number or BigNumber depending on the configuration
function $823afad432d7a13b$var$numberFactory(name, value) {
    var dependencies = [
        'config',
        'BigNumber'
    ];
    return (0, $dsu7t.factory)(name, dependencies, (_ref2)=>{
        var { config: config, BigNumber: BigNumber } = _ref2;
        return config.number === 'BigNumber' ? new BigNumber(value) : value;
    });
}

});

parcelRegister("15OuE", function(module, exports) {

$parcel$export(module.exports, "createBellNumbers", () => $0cbd6d06d9a95ba5$export$7b7dc3bd00d38afb);

var $dsu7t = parcelRequire("dsu7t");
var $0cbd6d06d9a95ba5$var$name = 'bellNumbers';
var $0cbd6d06d9a95ba5$var$dependencies = [
    'typed',
    'addScalar',
    'isNegative',
    'isInteger',
    'stirlingS2'
];
var $0cbd6d06d9a95ba5$export$7b7dc3bd00d38afb = /* #__PURE__ */ (0, $dsu7t.factory)($0cbd6d06d9a95ba5$var$name, $0cbd6d06d9a95ba5$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, isNegative: isNegative, isInteger: isInteger, stirlingS2: stirlingS2 } = _ref;
    /**
   * The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S.
   * bellNumbers only takes integer arguments.
   * The following condition must be enforced: n >= 0
   *
   * Syntax:
   *
   *   math.bellNumbers(n)
   *
   * Examples:
   *
   *    math.bellNumbers(3) // returns 5
   *    math.bellNumbers(8) // returns 4140
   *
   * See also:
   *
   *    stirlingS2
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @return {Number | BigNumber}     B(n)
   */ return typed($0cbd6d06d9a95ba5$var$name, {
        'number | BigNumber': function number__BigNumber(n) {
            if (!isInteger(n) || isNegative(n)) throw new TypeError('Non-negative integer value expected in function bellNumbers');
            // Sum (k=0, n) S(n,k).
            var result = 0;
            for(var i = 0; i <= n; i++)result = addScalar(result, stirlingS2(n, i));
            return result;
        }
    });
});

});

parcelRegister("5S20K", function(module, exports) {

$parcel$export(module.exports, "createBigint", () => $44638e3c38fdbf9c$export$bfbfca9aa02d908c);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");
var $44638e3c38fdbf9c$var$name = 'bigint';
var $44638e3c38fdbf9c$var$dependencies = [
    'typed'
];
var $44638e3c38fdbf9c$export$bfbfca9aa02d908c = /* #__PURE__ */ (0, $dsu7t.factory)($44638e3c38fdbf9c$var$name, $44638e3c38fdbf9c$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a bigint or convert a string, boolean, or unit to a bigint.
   * When value is a matrix, all elements will be converted to bigint.
   *
   * Syntax:
   *
   *    math.bigint(value)
   *
   * Examples:
   *
   *    math.bigint(2)                         // returns 2n
   *    math.bigint('123')                     // returns 123n
   *    math.bigint(true)                      // returns 1n
   *    math.bigint([true, false, true, true]) // returns [1n, 0n, 1n, 1n]
   *
   * See also:
   *
   *    number, bignumber, boolean, complex, index, matrix, string, unit
   *
   * @param {string | number | BigNumber | bigint | Fraction | boolean | Array | Matrix | null} [value]  Value to be converted
   * @return {bigint | Array | Matrix} The created bigint
   */ var bigint = typed('bigint', {
        '': function _() {
            return 0n;
        },
        bigint: function bigint(x) {
            return x;
        },
        number: function number(x) {
            return BigInt(x.toFixed());
        },
        BigNumber: function BigNumber(x) {
            return BigInt(x.round().toString());
        },
        Fraction: function Fraction(x) {
            return BigInt(x.valueOf().toFixed());
        },
        'string | boolean': function string__boolean(x) {
            return BigInt(x);
        },
        null: function _null(x) {
            return 0n;
        },
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
    // reviver function to parse a JSON object like:
    //
    //     {"mathjs":"bigint","value":"123"}
    //
    // into a bigint 123n
    bigint.fromJSON = function(json) {
        return BigInt(json.value);
    };
    return bigint;
});

});

parcelRegister("ITdLZ", function(module, exports) {

$parcel$export(module.exports, "createBignumber", () => $086ef1f1e4d85a4b$export$1c955ee1b8a97877);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");
var $086ef1f1e4d85a4b$var$name = 'bignumber';
var $086ef1f1e4d85a4b$var$dependencies = [
    'typed',
    'BigNumber'
];
var $086ef1f1e4d85a4b$export$1c955ee1b8a97877 = /* #__PURE__ */ (0, $dsu7t.factory)($086ef1f1e4d85a4b$var$name, $086ef1f1e4d85a4b$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: BigNumber } = _ref;
    /**
   * Create a BigNumber, which can store numbers with arbitrary precision.
   * When a matrix is provided, all elements will be converted to BigNumber.
   *
   * Syntax:
   *
   *    math.bignumber(x)
   *
   * Examples:
   *
   *    0.1 + 0.2                                  // returns number 0.30000000000000004
   *    math.bignumber(0.1) + math.bignumber(0.2)  // returns BigNumber 0.3
   *
   *
   *    7.2e500                                    // returns number Infinity
   *    math.bignumber('7.2e500')                  // returns BigNumber 7.2e500
   *
   * See also:
   *
   *    number, bigint, boolean, complex, index, matrix, string, unit
   *
   * @param {number | string | Fraction | BigNumber | bigint | Array | Matrix | boolean | null} [value]  Value for the big number,
   *                                                    0 by default.
   * @returns {BigNumber} The created bignumber
   */ return typed('bignumber', {
        '': function _() {
            return new BigNumber(0);
        },
        number: function number(x) {
            // convert to string to prevent errors in case of >15 digits
            return new BigNumber(x + '');
        },
        string: function string(x) {
            var wordSizeSuffixMatch = x.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
            if (wordSizeSuffixMatch) {
                // x has a word size suffix
                var size = wordSizeSuffixMatch[2];
                var n = BigNumber(wordSizeSuffixMatch[1]);
                var twoPowSize = new BigNumber(2).pow(Number(size));
                if (n.gt(twoPowSize.sub(1))) throw new SyntaxError("String \"".concat(x, "\" is out of range"));
                var twoPowSizeSubOne = new BigNumber(2).pow(Number(size) - 1);
                if (n.gte(twoPowSizeSubOne)) return n.sub(twoPowSize);
                else return n;
            }
            return new BigNumber(x);
        },
        BigNumber: function BigNumber(x) {
            // we assume a BigNumber is immutable
            return x;
        },
        bigint: function bigint(x) {
            return new BigNumber(x.toString());
        },
        Unit: typed.referToSelf((self)=>(x)=>{
                var clone = x.clone();
                clone.value = self(x.value);
                return clone;
            }),
        Fraction: function Fraction(x) {
            return new BigNumber(String(x.n)).div(String(x.d)).times(String(x.s));
        },
        null: function _null(_x) {
            return new BigNumber(0);
        },
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});

parcelRegister("56hXf", function(module, exports) {

$parcel$export(module.exports, "createBigNumberClass", () => $3b6b70b3d9bdf10e$export$234de8d4231bfea3);

var $cIZs1 = parcelRequire("cIZs1");

var $dsu7t = parcelRequire("dsu7t");
var $3b6b70b3d9bdf10e$var$name = 'BigNumber';
var $3b6b70b3d9bdf10e$var$dependencies = [
    '?on',
    'config'
];
var $3b6b70b3d9bdf10e$export$234de8d4231bfea3 = /* #__PURE__ */ (0, $dsu7t.factory)($3b6b70b3d9bdf10e$var$name, $3b6b70b3d9bdf10e$var$dependencies, (_ref)=>{
    var { on: on, config: config } = _ref;
    var BigNumber = (0, (/*@__PURE__*/$parcel$interopDefault($cIZs1))).clone({
        precision: config.precision,
        modulo: (0, (/*@__PURE__*/$parcel$interopDefault($cIZs1))).EUCLID
    });
    BigNumber.prototype = Object.create(BigNumber.prototype);
    /**
   * Attach type information
   */ BigNumber.prototype.type = 'BigNumber';
    BigNumber.prototype.isBigNumber = true;
    /**
   * Get a JSON representation of a BigNumber containing
   * type information
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "BigNumber", "value": "0.2"}`
   */ BigNumber.prototype.toJSON = function() {
        return {
            mathjs: 'BigNumber',
            value: this.toString()
        };
    };
    /**
   * Instantiate a BigNumber from a JSON object
   * @param {Object} json  a JSON object structured as:
   *                       `{"mathjs": "BigNumber", "value": "0.2"}`
   * @return {BigNumber}
   */ BigNumber.fromJSON = function(json) {
        return new BigNumber(json.value);
    };
    if (on) // listen for changed in the configuration, automatically apply changed precision
    on('config', function(curr, prev) {
        if (curr.precision !== prev.precision) BigNumber.config({
            precision: curr.precision
        });
    });
    return BigNumber;
}, {
    isClass: true
});

});
parcelRegister("cIZs1", function(module, exports) {
(function(globalScope) {
    'use strict';
    /*!
   *  decimal.js v10.6.0
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js
   *  Copyright (c) 2025 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The maximum exponent magnitude.
    // The limit on the value of `toExpNeg`, `toExpPos`, `minE` and `maxE`.
    var EXP_LIMIT = 9e15, // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    MAX_DIGITS = 1e9, // Base conversion alphabet.
    NUMERALS = '0123456789abcdef', // The natural logarithm of 10 (1025 digits).
    LN10 = '2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058', // Pi (1025 digits).
    PI = '3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789', // The initial configuration properties of the Decimal constructor.
    DEFAULTS = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed at run-time using the `Decimal.config` method.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used when rounding to `precision`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP         0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
        // FLOOR      3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN  6 The IEEE 754 remainder function.
        // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
        //
        // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
        // division (9) are commonly used for the modulus operation. The other rounding modes can also
        // be used, but they may not give useful results.
        modulo: 1,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The minimum exponent value, beneath which underflow to zero occurs.
        // JavaScript numbers: -324  (5e-324)
        minE: -EXP_LIMIT,
        // The maximum exponent value, above which overflow to Infinity occurs.
        // JavaScript numbers: 308  (1.7976931348623157e+308)
        maxE: EXP_LIMIT,
        // Whether to use cryptographically-secure random number generation, if available.
        crypto: false // true/false
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    Decimal, inexact, noConflict, quadrant, external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', precisionLimitExceeded = decimalError + 'Precision limit exceeded', cryptoUnavailable = decimalError + 'crypto unavailable', tag = '[object Decimal]', mathfloor = Math.floor, mathpow = Math.pow, isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, // Decimal.prototype object
    P = {
        toStringTag: tag
    };
    // Decimal prototype methods
    /*
   *  absoluteValue             abs
   *  ceil
   *  clampedTo                 clamp
   *  comparedTo                cmp
   *  cosine                    cos
   *  cubeRoot                  cbrt
   *  decimalPlaces             dp
   *  dividedBy                 div
   *  dividedToIntegerBy        divToInt
   *  equals                    eq
   *  floor
   *  greaterThan               gt
   *  greaterThanOrEqualTo      gte
   *  hyperbolicCosine          cosh
   *  hyperbolicSine            sinh
   *  hyperbolicTangent         tanh
   *  inverseCosine             acos
   *  inverseHyperbolicCosine   acosh
   *  inverseHyperbolicSine     asinh
   *  inverseHyperbolicTangent  atanh
   *  inverseSine               asin
   *  inverseTangent            atan
   *  isFinite
   *  isInteger                 isInt
   *  isNaN
   *  isNegative                isNeg
   *  isPositive                isPos
   *  isZero
   *  lessThan                  lt
   *  lessThanOrEqualTo         lte
   *  logarithm                 log
   *  [maximum]                 [max]
   *  [minimum]                 [min]
   *  minus                     sub
   *  modulo                    mod
   *  naturalExponential        exp
   *  naturalLogarithm          ln
   *  negated                   neg
   *  plus                      add
   *  precision                 sd
   *  round
   *  sine                      sin
   *  squareRoot                sqrt
   *  tangent                   tan
   *  times                     mul
   *  toBinary
   *  toDecimalPlaces           toDP
   *  toExponential
   *  toFixed
   *  toFraction
   *  toHexadecimal             toHex
   *  toNearest
   *  toNumber
   *  toOctal
   *  toPower                   pow
   *  toPrecision
   *  toSignificantDigits       toSD
   *  toString
   *  truncated                 trunc
   *  valueOf                   toJSON
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s < 0) x.s = 1;
        return finalise(x);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of positive Infinity.
   *
   */ P.ceil = function() {
        return finalise(new this.constructor(this), this.e + 1, 2);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal clamped to the range
   * delineated by `min` and `max`.
   *
   * min {number|string|bigint|Decimal}
   * max {number|string|bigint|Decimal}
   *
   */ P.clampedTo = P.clamp = function(min, max) {
        var k, x = this, Ctor = x.constructor;
        min = new Ctor(min);
        max = new Ctor(max);
        if (!min.s || !max.s) return new Ctor(NaN);
        if (min.gt(max)) throw Error(invalidArgument + max);
        k = x.cmp(min);
        return k < 0 ? min : x.cmp(max) > 0 ? max : new Ctor(x);
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value,
   *   NaN  if the value of either Decimal is NaN.
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this, xd = x.d, yd = (y = new x.constructor(y)).d, xs = x.s, ys = y.s;
        // Either NaN or ±Infinity?
        if (!xd || !yd) return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
        // Either zero?
        if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;
        // Signs differ?
        if (xs !== ys) return xs;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;
        xdL = xd.length;
        ydL = yd.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
    };
    /*
   * Return a new Decimal whose value is the cosine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * cos(0)         = 1
   * cos(-0)        = 1
   * cos(Infinity)  = NaN
   * cos(-Infinity) = NaN
   * cos(NaN)       = NaN
   *
   */ P.cosine = P.cos = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.d) return new Ctor(NaN);
        // cos(0) = cos(-0) = 1
        if (!x.d[0]) return new Ctor(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = cosine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 3 ? x.neg() : x, pr, rm, true);
    };
    /*
   *
   * Return a new Decimal whose value is the cube root of the value of this Decimal, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   *  cbrt(0)  =  0
   *  cbrt(-0) = -0
   *  cbrt(1)  =  1
   *  cbrt(-1) = -1
   *  cbrt(N)  =  N
   *  cbrt(-I) = -I
   *  cbrt(I)  =  I
   *
   * Math.cbrt(x) = (x < 0 ? -Math.pow(-x, 1/3) : Math.pow(x, 1/3))
   *
   */ P.cubeRoot = P.cbrt = function() {
        var e, m, n, r, rep, s, sd, t, t3, t3plusx, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        external = false;
        // Initial estimate.
        s = x.s * mathpow(x.s * x, 1 / 3);
        // Math.cbrt underflow/overflow?
        // Pass x to Math.pow as integer, then adjust the exponent of the result.
        if (!s || Math.abs(s) == 1 / 0) {
            n = digitsToString(x.d);
            e = x.e;
            // Adjust n exponent so it is a multiple of 3 away from x exponent.
            if (s = (e - n.length + 1) % 3) n += s == 1 || s == -2 ? '0' : '00';
            s = mathpow(n, 1 / 3);
            // Rarely, e may be one less than the result exponent value.
            e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
            r.s = x.s;
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Halley's method.
        // TODO? Compare Newton's method.
        for(;;){
            t = r;
            t3 = t.times(t).times(t);
            t3plusx = t3.plus(x);
            r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or 4999
                // , i.e. approaching a rounding boundary, continue the iteration.
                if (n == '9999' || !rep && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var w, d = this.d, n = NaN;
        if (d) {
            w = d.length - 1;
            n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last word.
            w = d[w];
            if (w) for(; w % 10 == 0; w /= 10)n--;
            if (n < 0) n = 0;
        }
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedToIntegerBy = P.divToInt = function(y) {
        var x = this, Ctor = x.constructor;
        return finalise(divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return this.cmp(y) === 0;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of negative Infinity.
   *
   */ P.floor = function() {
        return finalise(new this.constructor(this), this.e + 1, 3);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        var k = this.cmp(y);
        return k == 1 || k === 0;
    };
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [1, Infinity]
   *
   * cosh(x) = 1 + x^2/2! + x^4/4! + x^6/6! + ...
   *
   * cosh(0)         = 1
   * cosh(-0)        = 1
   * cosh(Infinity)  = Infinity
   * cosh(-Infinity) = Infinity
   * cosh(NaN)       = NaN
   *
   *  x        time taken (ms)   result
   * 1000      9                 9.8503555700852349694e+433
   * 10000     25                4.4034091128314607936e+4342
   * 100000    171               1.4033316802130615897e+43429
   * 1000000   3817              1.5166076984010437725e+434294
   * 10000000  abandoned after 2 minute wait
   *
   * TODO? Compare performance of cosh(x) = 0.5 * (exp(x) + exp(-x))
   *
   */ P.hyperbolicCosine = P.cosh = function() {
        var k, n, pr, rm, len, x = this, Ctor = x.constructor, one = new Ctor(1);
        if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
        if (x.isZero()) return one;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        // Argument reduction: cos(4x) = 1 - 8cos^2(x) + 8cos^4(x) + 1
        // i.e. cos(x) = 1 - cos^2(x/4)(8 - 8cos^2(x/4))
        // Estimate the optimum number of times to use the argument reduction.
        // TODO? Estimation reused from cosine() and may not be optimal here.
        if (len < 32) {
            k = Math.ceil(len / 3);
            n = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            n = '2.3283064365386962890625e-10';
        }
        x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);
        // Reverse argument reduction
        var cosh2_x, i = k, d8 = new Ctor(8);
        for(; i--;){
            cosh2_x = x.times(x);
            x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
        }
        return finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic sine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * sinh(x) = x + x^3/3! + x^5/5! + x^7/7! + ...
   *
   * sinh(0)         = 0
   * sinh(-0)        = -0
   * sinh(Infinity)  = Infinity
   * sinh(-Infinity) = -Infinity
   * sinh(NaN)       = NaN
   *
   * x        time taken (ms)
   * 10       2 ms
   * 100      5 ms
   * 1000     14 ms
   * 10000    82 ms
   * 100000   886 ms            1.4033316802130615897e+43429
   * 200000   2613 ms
   * 300000   5407 ms
   * 400000   8824 ms
   * 500000   13026 ms          8.7080643612718084129e+217146
   * 1000000  48543 ms
   *
   * TODO? Compare performance of sinh(x) = 0.5 * (exp(x) - exp(-x))
   *
   */ P.hyperbolicSine = P.sinh = function() {
        var k, pr, rm, len, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        if (len < 3) x = taylorSeries(Ctor, 2, x, x, true);
        else {
            // Alternative argument reduction: sinh(3x) = sinh(x)(3 + 4sinh^2(x))
            // i.e. sinh(x) = sinh(x/3)(3 + 4sinh^2(x/3))
            // 3 multiplications and 1 addition
            // Argument reduction: sinh(5x) = sinh(x)(5 + sinh^2(x)(20 + 16sinh^2(x)))
            // i.e. sinh(x) = sinh(x/5)(5 + sinh^2(x/5)(20 + 16sinh^2(x/5)))
            // 4 multiplications and 2 additions
            // Estimate the optimum number of times to use the argument reduction.
            k = 1.4 * Math.sqrt(len);
            k = k > 16 ? 16 : k | 0;
            x = x.times(1 / tinyPow(5, k));
            x = taylorSeries(Ctor, 2, x, x, true);
            // Reverse argument reduction
            var sinh2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
            for(; k--;){
                sinh2_x = x.times(x);
                x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
            }
        }
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * tanh(x) = sinh(x) / cosh(x)
   *
   * tanh(0)         = 0
   * tanh(-0)        = -0
   * tanh(Infinity)  = 1
   * tanh(-Infinity) = -1
   * tanh(NaN)       = NaN
   *
   */ P.hyperbolicTangent = P.tanh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(x.s);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 7;
        Ctor.rounding = 1;
        return divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
    };
    /*
   * Return a new Decimal whose value is the arccosine (inverse cosine) in radians of the value of
   * this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [0, pi]
   *
   * acos(x) = pi/2 - asin(x)
   *
   * acos(0)       = pi/2
   * acos(-0)      = pi/2
   * acos(1)       = 0
   * acos(-1)      = pi
   * acos(1/2)     = pi/3
   * acos(-1/2)    = 2*pi/3
   * acos(|x| > 1) = NaN
   * acos(NaN)     = NaN
   *
   */ P.inverseCosine = P.acos = function() {
        var x = this, Ctor = x.constructor, k = x.abs().cmp(1), pr = Ctor.precision, rm = Ctor.rounding;
        if (k !== -1) return k === 0 ? x.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0) : new Ctor(NaN);
        if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);
        // TODO? Special case acos(0.5) = pi/3 and acos(-0.5) = 2*pi/3
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        // See https://github.com/MikeMcl/decimal.js/pull/217
        x = new Ctor(1).minus(x).div(x.plus(1)).sqrt().atan();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(2);
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine in radians of the
   * value of this Decimal.
   *
   * Domain: [1, Infinity]
   * Range: [0, Infinity]
   *
   * acosh(x) = ln(x + sqrt(x^2 - 1))
   *
   * acosh(x < 1)     = NaN
   * acosh(NaN)       = NaN
   * acosh(Infinity)  = Infinity
   * acosh(-Infinity) = NaN
   * acosh(0)         = NaN
   * acosh(-0)        = NaN
   * acosh(1)         = 0
   * acosh(-1)        = NaN
   *
   */ P.inverseHyperbolicCosine = P.acosh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
        if (!x.isFinite()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).minus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * asinh(x) = ln(x + sqrt(x^2 + 1))
   *
   * asinh(NaN)       = NaN
   * asinh(Infinity)  = Infinity
   * asinh(-Infinity) = -Infinity
   * asinh(0)         = 0
   * asinh(-0)        = -0
   *
   */ P.inverseHyperbolicSine = P.asinh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).plus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent in radians of the
   * value of this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [-Infinity, Infinity]
   *
   * atanh(x) = 0.5 * ln((1 + x) / (1 - x))
   *
   * atanh(|x| > 1)   = NaN
   * atanh(NaN)       = NaN
   * atanh(Infinity)  = NaN
   * atanh(-Infinity) = NaN
   * atanh(0)         = 0
   * atanh(-0)        = -0
   * atanh(1)         = Infinity
   * atanh(-1)        = -Infinity
   *
   */ P.inverseHyperbolicTangent = P.atanh = function() {
        var pr, rm, wpr, xsd, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        xsd = x.sd();
        if (Math.max(xsd, pr) < 2 * -x.e - 1) return finalise(new Ctor(x), pr, rm, true);
        Ctor.precision = wpr = xsd - x.e;
        x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);
        Ctor.precision = pr + 4;
        Ctor.rounding = 1;
        x = x.ln();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(0.5);
    };
    /*
   * Return a new Decimal whose value is the arcsine (inverse sine) in radians of the value of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * asin(x) = 2*atan(x/(1 + sqrt(1 - x^2)))
   *
   * asin(0)       = 0
   * asin(-0)      = -0
   * asin(1/2)     = pi/6
   * asin(-1/2)    = -pi/6
   * asin(1)       = pi/2
   * asin(-1)      = -pi/2
   * asin(|x| > 1) = NaN
   * asin(NaN)     = NaN
   *
   * TODO? Compare performance of Taylor series.
   *
   */ P.inverseSine = P.asin = function() {
        var halfPi, k, pr, rm, x = this, Ctor = x.constructor;
        if (x.isZero()) return new Ctor(x);
        k = x.abs().cmp(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (k !== -1) {
            // |x| is 1
            if (k === 0) {
                halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
                halfPi.s = x.s;
                return halfPi;
            }
            // |x| > 1 or x is NaN
            return new Ctor(NaN);
        }
        // TODO? Special case asin(1/2) = pi/6 and asin(-1/2) = -pi/6
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(2);
    };
    /*
   * Return a new Decimal whose value is the arctangent (inverse tangent) in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
   *
   * atan(0)         = 0
   * atan(-0)        = -0
   * atan(1)         = pi/4
   * atan(-1)        = -pi/4
   * atan(Infinity)  = pi/2
   * atan(-Infinity) = -pi/2
   * atan(NaN)       = NaN
   *
   */ P.inverseTangent = P.atan = function() {
        var i, j, k, n, px, t, r, wpr, x2, x = this, Ctor = x.constructor, pr = Ctor.precision, rm = Ctor.rounding;
        if (!x.isFinite()) {
            if (!x.s) return new Ctor(NaN);
            if (pr + 4 <= PI_PRECISION) {
                r = getPi(Ctor, pr + 4, rm).times(0.5);
                r.s = x.s;
                return r;
            }
        } else if (x.isZero()) return new Ctor(x);
        else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
            r = getPi(Ctor, pr + 4, rm).times(0.25);
            r.s = x.s;
            return r;
        }
        Ctor.precision = wpr = pr + 10;
        Ctor.rounding = 1;
        // TODO? if (x >= 1 && pr <= PI_PRECISION) atan(x) = halfPi * x.s - atan(1 / x);
        // Argument reduction
        // Ensure |x| < 0.42
        // atan(x) = 2 * atan(x / (1 + sqrt(1 + x^2)))
        k = Math.min(28, wpr / LOG_BASE + 2 | 0);
        for(i = k; i; --i)x = x.div(x.times(x).plus(1).sqrt().plus(1));
        external = false;
        j = Math.ceil(wpr / LOG_BASE);
        n = 1;
        x2 = x.times(x);
        r = new Ctor(x);
        px = x;
        // atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
        for(; i !== -1;){
            px = px.times(x2);
            t = r.minus(px.div(n += 2));
            px = px.times(x2);
            r = t.plus(px.div(n += 2));
            if (r.d[j] !== void 0) for(i = j; r.d[i] === t.d[i] && i--;);
        }
        if (k) r = r.times(2 << k - 1);
        external = true;
        return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return true if the value of this Decimal is a finite number, otherwise return false.
   *
   */ P.isFinite = function() {
        return !!this.d;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isInt = function() {
        return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is NaN, otherwise return false.
   *
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isNeg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.isPos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0 or -0, otherwise return false.
   *
   */ P.isZero = function() {
        return !!this.d && this.d[0] === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * If no base is specified, return log[10](arg).
   *
   * log[base](arg) = ln(arg) / ln(base)
   *
   * The result will always be correctly rounded if the base of the log is 10, and 'almost always'
   * otherwise:
   *
   * Depending on the rounding mode, the result may be incorrectly rounded if the first fifteen
   * rounding digits are [49]99999999999999 or [50]00000000000000. In that case, the maximum error
   * between the result and the correctly rounded result will be one ulp (unit in the last place).
   *
   * log[-b](a)       = NaN
   * log[0](a)        = NaN
   * log[1](a)        = NaN
   * log[NaN](a)      = NaN
   * log[Infinity](a) = NaN
   * log[b](0)        = -Infinity
   * log[b](-0)       = -Infinity
   * log[b](-a)       = NaN
   * log[b](1)        = 0
   * log[b](Infinity) = Infinity
   * log[b](NaN)      = NaN
   *
   * [base] {number|string|bigint|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var isBase10, d, denominator, k, inf, num, sd, r, arg = this, Ctor = arg.constructor, pr = Ctor.precision, rm = Ctor.rounding, guard = 5;
        // Default base is 10.
        if (base == null) {
            base = new Ctor(10);
            isBase10 = true;
        } else {
            base = new Ctor(base);
            d = base.d;
            // Return NaN if base is negative, or non-finite, or is 0 or 1.
            if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);
            isBase10 = base.eq(10);
        }
        d = arg.d;
        // Is arg negative, non-finite, 0 or 1?
        if (arg.s < 0 || !d || !d[0] || arg.eq(1)) return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
        // The result will have a non-terminating decimal expansion if base is 10 and arg is not an
        // integer power of 10.
        if (isBase10) {
            if (d.length > 1) inf = true;
            else {
                for(k = d[0]; k % 10 === 0;)k /= 10;
                inf = k !== 1;
            }
        }
        external = false;
        sd = pr + guard;
        num = naturalLogarithm(arg, sd);
        denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
        // The result will have 5 rounding digits.
        r = divide(num, denominator, sd, 1);
        // If at a rounding boundary, i.e. the result's rounding digits are [49]9999 or [50]0000,
        // calculate 10 further digits.
        //
        // If the result is known to have an infinite decimal expansion, repeat this until it is clear
        // that the result is above or below the boundary. Otherwise, if after calculating the 10
        // further digits, the last 14 are nines, round up and assume the result is exact.
        // Also assume the result is exact if the last 14 are zero.
        //
        // Example of a result that will be incorrectly rounded:
        // log[1048576](4503599627370502) = 2.60000000000000009610279511444746...
        // The above result correctly rounded using ROUND_CEIL to 1 decimal place should be 2.7, but it
        // will be given as 2.6 as there are 15 zeros immediately after the requested decimal place, so
        // the exact result would be assumed to be 2.6, which rounded using ROUND_CEIL to 1 decimal
        // place is still 2.6.
        if (checkRoundingDigits(r.d, k = pr, rm)) do {
            sd += 10;
            num = naturalLogarithm(arg, sd);
            denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
            r = divide(num, denominator, sd, 1);
            if (!inf) {
                // Check for 14 nines from the 2nd rounding digit, as the first may be 4.
                if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
                break;
            }
        }while (checkRoundingDigits(r.d, k += 10, rm));
        external = true;
        return finalise(r, pr, rm);
    };
    /*
   * Return a new Decimal whose value is the maximum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|bigint|Decimal}
   *
  P.max = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, -1);
  };
   */ /*
   * Return a new Decimal whose value is the minimum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|bigint|Decimal}
   *
  P.min = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 1);
  };
   */ /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new Decimal whose value is the value of this Decimal minus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.minus = P.sub = function(y) {
        var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (x.d) y.s = -y.s;
            else y = new Ctor(y.d || x.s !== y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.plus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return y negated if x is zero and y is non-zero.
            if (yd[0]) y.s = -y.s;
            else if (xd[0]) y = new Ctor(x);
            else return new Ctor(rm === 3 ? -0 : 0);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        e = mathfloor(y.e / LOG_BASE);
        xe = mathfloor(x.e / LOG_BASE);
        xd = xd.slice();
        k = xe - e;
        // If base 1e7 exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of
            // zeros needing to be prepended, but this can be avoided while still ensuring correct
            // rounding by limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to `xd` if shorter.
        // Don't add zeros to `yd` if shorter as subtraction only needs to start at `yd` length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * The result depends on the modulo mode.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // Return NaN if x is ±Infinity or NaN, or y is NaN or ±0.
        if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);
        // Return x if y is ±Infinity or x is ±0.
        if (!y.d || x.d && !x.d[0]) return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
        // Prevent rounding of intermediate calculations.
        external = false;
        if (Ctor.modulo == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // result = x - q * y    where  0 <= result < abs(y)
            q = divide(x, y.abs(), 0, 3, 1);
            q.s *= y.s;
        } else q = divide(x, y, 0, Ctor.modulo, 1);
        q = q.times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.naturalExponential = P.exp = function() {
        return naturalExponential(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return naturalLogarithm(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s;
        return finalise(x);
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new Decimal whose value is the value of this Decimal plus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.plus = P.add = function(y) {
        var carry, d, e, i, k, len, pr, rm, xd, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.minus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!yd[0]) y = new Ctor(x);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        k = mathfloor(x.e / LOG_BASE);
        e = mathfloor(y.e / LOG_BASE);
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var k, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        if (x.d) {
            k = getPrecision(x.d);
            if (z && x.e + 1 > k) k = x.e + 1;
        } else k = NaN;
        return k;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.round = function() {
        var x = this, Ctor = x.constructor;
        return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
    };
    /*
   * Return a new Decimal whose value is the sine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * sin(x) = x - x^3/3! + x^5/5! - ...
   *
   * sin(0)         = 0
   * sin(-0)        = -0
   * sin(Infinity)  = NaN
   * sin(-Infinity) = NaN
   * sin(NaN)       = NaN
   *
   */ P.sine = P.sin = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = sine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   *  sqrt(-n) =  N
   *  sqrt(N)  =  N
   *  sqrt(-I) =  N
   *  sqrt(I)  =  I
   *  sqrt(0)  =  0
   *  sqrt(-0) = -0
   *
   */ P.squareRoot = P.sqrt = function() {
        var m, n, sd, r, rep, t, x = this, d = x.d, e = x.e, s = x.s, Ctor = x.constructor;
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !d || !d[0]) return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, sd + 2, 1)).times(0.5);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (n == '9999' || !rep && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return a new Decimal whose value is the tangent of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * tan(0)         = 0
   * tan(-0)        = -0
   * tan(Infinity)  = NaN
   * tan(-Infinity) = NaN
   * tan(NaN)       = NaN
   *
   */ P.tangent = P.tan = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 10;
        Ctor.rounding = 1;
        x = x.sin();
        x.s = 1;
        x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 4 ? x.neg() : x, pr, rm, true);
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new Decimal whose value is this Decimal times `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        y.s *= x.s;
        // If either is NaN, ±Infinity or ±0...
        if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd ? NaN : !xd || !yd ? y.s / 0 : y.s * 0);
        e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = getBase10Exponent(r, e);
        return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
    };
    /*
   * Return a string representing the value of this Decimal in base 2, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toBinary = function(sd, rm) {
        return toStringBinary(this, 2, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.toDP = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return finalise(x, dp + x.e + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), dp + 1, rm);
            str = finiteToString(x, true, dp + 1);
        }
        return x.isNeg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            y = finalise(new Ctor(x), dp + x.e + 1, rm);
            str = finiteToString(y, false, dp + y.e + 1);
        }
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isNeg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return an array representing the value of this Decimal as a simple fraction with an integer
   * numerator and an integer denominator.
   *
   * The denominator will be a positive non-zero value less than or equal to the specified maximum
   * denominator. If a maximum denominator is not specified, the denominator will be the lowest
   * value necessary to represent the number exactly.
   *
   * [maxD] {number|string|bigint|Decimal} Maximum denominator. Integer >= 1 and < Infinity.
   *
   */ P.toFraction = function(maxD) {
        var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r, x = this, xd = x.d, Ctor = x.constructor;
        if (!xd) return new Ctor(x);
        n1 = d0 = new Ctor(1);
        d1 = n0 = new Ctor(0);
        d = new Ctor(d1);
        e = d.e = getPrecision(xd) - x.e - 1;
        k = e % LOG_BASE;
        d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);
        if (maxD == null) // d is 10**e, the minimum max-denominator needed.
        maxD = e > 0 ? d : n1;
        else {
            n = new Ctor(maxD);
            if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
            maxD = n.gt(d) ? e > 0 ? d : n1 : n;
        }
        external = false;
        n = new Ctor(digitsToString(xd));
        pr = Ctor.precision;
        Ctor.precision = e = xd.length * LOG_BASE * 2;
        for(;;){
            q = divide(n, d, 0, 1, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.cmp(maxD) == 1) break;
            d0 = d1;
            d1 = d2;
            d2 = n1;
            n1 = n0.plus(q.times(d2));
            n0 = d2;
            d2 = d;
            d = n.minus(q.times(d2));
            n = d2;
        }
        d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        // Determine which fraction is closer to x, n0/d0 or n1/d1?
        r = divide(n1, d1, e, 1).minus(x).abs().cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        Ctor.precision = pr;
        external = true;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal in base 16, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toHexadecimal = P.toHex = function(sd, rm) {
        return toStringBinary(this, 16, sd, rm);
    };
    /*
   * Returns a new Decimal whose value is the nearest multiple of `y` in the direction of rounding
   * mode `rm`, or `Decimal.rounding` if `rm` is omitted, to the value of this Decimal.
   *
   * The return value will always have the same sign as this Decimal, unless either this Decimal
   * or `y` is NaN, in which case the return value will be also be NaN.
   *
   * The return value is not affected by the value of `precision`.
   *
   * y {number|string|bigint|Decimal} The magnitude to round to a multiple of.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toNearest() rounding mode not an integer: {rm}'
   * 'toNearest() rounding mode out of range: {rm}'
   *
   */ P.toNearest = function(y, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (y == null) {
            // If x is not finite, return x.
            if (!x.d) return x;
            y = new Ctor(1);
            rm = Ctor.rounding;
        } else {
            y = new Ctor(y);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            // If x is not finite, return x if y is not NaN, else NaN.
            if (!x.d) return y.s ? x : y;
            // If y is not finite, return Infinity with the sign of x if y is Infinity, else NaN.
            if (!y.d) {
                if (y.s) y.s = x.s;
                return y;
            }
        }
        // If y is not zero, calculate the nearest multiple of y to x.
        if (y.d[0]) {
            external = false;
            x = divide(x, y, 0, rm, 1).times(y);
            external = true;
            finalise(x);
        // If y is zero, return zero with the sign of x.
        } else {
            y.s = x.s;
            x = y;
        }
        return x;
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   * Zero keeps its sign.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a string representing the value of this Decimal in base 8, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toOctal = function(sd, rm) {
        return toStringBinary(this, 8, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`, rounded
   * to `precision` significant digits using rounding mode `rounding`.
   *
   * ECMAScript compliant.
   *
   *   pow(x, NaN)                           = NaN
   *   pow(x, ±0)                            = 1

   *   pow(NaN, non-zero)                    = NaN
   *   pow(abs(x) > 1, +Infinity)            = +Infinity
   *   pow(abs(x) > 1, -Infinity)            = +0
   *   pow(abs(x) == 1, ±Infinity)           = NaN
   *   pow(abs(x) < 1, +Infinity)            = +0
   *   pow(abs(x) < 1, -Infinity)            = +Infinity
   *   pow(+Infinity, y > 0)                 = +Infinity
   *   pow(+Infinity, y < 0)                 = +0
   *   pow(-Infinity, odd integer > 0)       = -Infinity
   *   pow(-Infinity, even integer > 0)      = +Infinity
   *   pow(-Infinity, odd integer < 0)       = -0
   *   pow(-Infinity, even integer < 0)      = +0
   *   pow(+0, y > 0)                        = +0
   *   pow(+0, y < 0)                        = +Infinity
   *   pow(-0, odd integer > 0)              = -0
   *   pow(-0, even integer > 0)             = +0
   *   pow(-0, odd integer < 0)              = -Infinity
   *   pow(-0, even integer < 0)             = +Infinity
   *   pow(finite x < 0, finite non-integer) = NaN
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * Assuming the first 15 rounding digits are each equally likely to be any digit 0-9, the
   * probability of an incorrectly rounded result
   * P([49]9{14} | [50]0{14}) = 2 * 0.2 * 10^-14 = 4e-15 = 1/2.5e+14
   * i.e. 1 in 250,000,000,000,000
   *
   * If a result is incorrectly rounded the maximum error will be 1 ulp (unit in last place).
   *
   * y {number|string|bigint|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, rm, s, x = this, Ctor = x.constructor, yn = +(y = new Ctor(y));
        // Either ±Infinity, NaN or ±0?
        if (!x.d || !y.d || !x.d[0] || !y.d[0]) return new Ctor(mathpow(+x, yn));
        x = new Ctor(x);
        if (x.eq(1)) return x;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (y.eq(1)) return finalise(x, pr, rm);
        // y exponent
        e = mathfloor(y.e / LOG_BASE);
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        if (e >= y.d.length - 1 && (k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = intPow(Ctor, x, k, pr);
            return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
        }
        s = x.s;
        // if x is negative
        if (s < 0) {
            // if y is not an integer
            if (e < y.d.length - 1) return new Ctor(NaN);
            // Result is positive if x is negative and the last digit of integer y is even.
            if ((y.d[e] & 1) == 0) s = 1;
            // if x.eq(-1)
            if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
                x.s = s;
                return x;
            }
        }
        // Estimate result exponent.
        // x^y = 10^e,  where e = y * log10(x)
        // log10(x) = log10(x_significand) + x_exponent
        // log10(x_significand) = ln(x_significand) / ln(10)
        k = mathpow(+x, yn);
        e = k == 0 || !isFinite(k) ? mathfloor(yn * (Math.log('0.' + digitsToString(x.d)) / Math.LN10 + x.e + 1)) : new Ctor(k + '').e;
        // Exponent estimate may be incorrect e.g. x: 0.999999999999999999, y: 2.29, e: 0, r.e: -1.
        // Overflow/underflow?
        if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? s / 0 : 0);
        external = false;
        Ctor.rounding = x.s = 1;
        // Estimate the extra guard digits needed to ensure five correct rounding digits from
        // naturalLogarithm(x). Example of failure without these extra digits (precision: 10):
        // new Decimal(2.32456).pow('2087987436534566.46411')
        // should be 1.162377823e+764914905173815, but is 1.162355823e+764914905173815
        k = Math.min(12, (e + '').length);
        // r = x^y = exp(y*ln(x))
        r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr);
        // r may be Infinity, e.g. (0.9999999999999999).pow(-1e+40)
        if (r.d) {
            // Truncate to the required precision plus five rounding digits.
            r = finalise(r, pr + 5, 1);
            // If the rounding digits are [49]9999 or [50]0000 increase the precision by 10 and recalculate
            // the result.
            if (checkRoundingDigits(r.d, pr, rm)) {
                e = pr + 10;
                // Truncate to the increased precision plus five rounding digits.
                r = finalise(naturalExponential(y.times(naturalLogarithm(x, e + k)), e), e + 5, 1);
                // Check for 14 nines from the 2nd rounding digit (the first rounding digit may be 4 or 9).
                if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
            }
        }
        r.s = s;
        external = true;
        Ctor.rounding = rm;
        return finalise(r, pr, rm);
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var str, x = this, Ctor = x.constructor;
        if (sd === void 0) str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), sd, rm);
            str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
        }
        return x.isNeg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toSD() digits out of range: {sd}'
   * 'toSD() digits not an integer: {sd}'
   * 'toSD() rounding mode not an integer: {rm}'
   * 'toSD() rounding mode out of range: {rm}'
   *
   */ P.toSignificantDigits = P.toSD = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return finalise(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal truncated to a whole number.
   *
   */ P.truncated = P.trunc = function() {
        return finalise(new this.constructor(this), this.e + 1, 1);
    };
    /*
   * Return a string representing the value of this Decimal.
   * Unlike `toString`, negative zero will include the minus sign.
   *
   */ P.valueOf = P.toJSON = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() ? '-' + str : str;
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  digitsToString           P.cubeRoot, P.logarithm, P.squareRoot, P.toFraction, P.toPower,
   *                           finiteToString, naturalExponential, naturalLogarithm
   *  checkInt32               P.toDecimalPlaces, P.toExponential, P.toFixed, P.toNearest,
   *                           P.toPrecision, P.toSignificantDigits, toStringBinary, random
   *  checkRoundingDigits      P.logarithm, P.toPower, naturalExponential, naturalLogarithm
   *  convertBase              toStringBinary, parseOther
   *  cos                      P.cos
   *  divide                   P.atanh, P.cubeRoot, P.dividedBy, P.dividedToIntegerBy,
   *                           P.logarithm, P.modulo, P.squareRoot, P.tan, P.tanh, P.toFraction,
   *                           P.toNearest, toStringBinary, naturalExponential, naturalLogarithm,
   *                           taylorSeries, atan2, parseOther
   *  finalise                 P.absoluteValue, P.atan, P.atanh, P.ceil, P.cos, P.cosh,
   *                           P.cubeRoot, P.dividedToIntegerBy, P.floor, P.logarithm, P.minus,
   *                           P.modulo, P.negated, P.plus, P.round, P.sin, P.sinh, P.squareRoot,
   *                           P.tan, P.times, P.toDecimalPlaces, P.toExponential, P.toFixed,
   *                           P.toNearest, P.toPower, P.toPrecision, P.toSignificantDigits,
   *                           P.truncated, divide, getLn10, getPi, naturalExponential,
   *                           naturalLogarithm, ceil, floor, round, trunc
   *  finiteToString           P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf,
   *                           toStringBinary
   *  getBase10Exponent        P.minus, P.plus, P.times, parseOther
   *  getLn10                  P.logarithm, naturalLogarithm
   *  getPi                    P.acos, P.asin, P.atan, toLessThanHalfPi, atan2
   *  getPrecision             P.precision, P.toFraction
   *  getZeroString            digitsToString, finiteToString
   *  intPow                   P.toPower, parseOther
   *  isOdd                    toLessThanHalfPi
   *  maxOrMin                 max, min
   *  naturalExponential       P.naturalExponential, P.toPower
   *  naturalLogarithm         P.acosh, P.asinh, P.atanh, P.logarithm, P.naturalLogarithm,
   *                           P.toPower, naturalExponential
   *  nonFiniteToString        finiteToString, toStringBinary
   *  parseDecimal             Decimal
   *  parseOther               Decimal
   *  sin                      P.sin
   *  taylorSeries             P.cosh, P.sinh, cos, sin
   *  toLessThanHalfPi         P.cos, P.sin
   *  toStringBinary           P.toBinary, P.toHexadecimal, P.toOctal
   *  truncate                 intPow
   *
   *  Throws:                  P.logarithm, P.precision, P.toFraction, checkInt32, getLn10, getPi,
   *                           naturalLogarithm, config, parseOther, random, Decimal
   */ function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    /*
   * Check 5 rounding digits if `repeating` is null, 4 otherwise.
   * `repeating == null` if caller is `log` or `pow`,
   * `repeating != null` if caller is `naturalLogarithm` or `naturalExponential`.
   */ function checkRoundingDigits(d, i, rm, repeating) {
        var di, k, r, rd;
        // Get the length of the first word of the array d.
        for(k = d[0]; k >= 10; k /= 10)--i;
        // Is the rounding digit in the first word of d?
        if (--i < 0) {
            i += LOG_BASE;
            di = 0;
        } else {
            di = Math.ceil((i + 1) / LOG_BASE);
            i %= LOG_BASE;
        }
        // i is the index (0 - 6) of the rounding digit.
        // E.g. if within the word 3487563 the first rounding digit is 5,
        // then i = 4, k = 1000, rd = 3487563 % 1000 = 563
        k = mathpow(10, LOG_BASE - i);
        rd = d[di] % k | 0;
        if (repeating == null) {
            if (i < 3) {
                if (i == 0) rd = rd / 100 | 0;
                else if (i == 1) rd = rd / 10 | 0;
                r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 50000 || rd == 0;
            } else r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 100 | 0) == mathpow(10, i - 2) - 1 || (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
        } else if (i < 4) {
            if (i == 0) rd = rd / 1000 | 0;
            else if (i == 1) rd = rd / 100 | 0;
            else if (i == 2) rd = rd / 10 | 0;
            r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
        } else r = ((repeating || rm < 4) && rd + 1 == k || !repeating && rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 1000 | 0) == mathpow(10, i - 3) - 1;
        return r;
    }
    // Convert string of `baseIn` to an array of numbers of `baseOut`.
    // Eg. convertBase('255', 10, 16) returns [15, 15].
    // Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
    function convertBase(str, baseIn, baseOut) {
        var j, arr = [
            0
        ], arrL, i = 0, strL = str.length;
        for(; i < strL;){
            for(arrL = arr.length; arrL--;)arr[arrL] *= baseIn;
            arr[0] += NUMERALS.indexOf(str.charAt(i++));
            for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                if (arr[j + 1] === void 0) arr[j + 1] = 0;
                arr[j + 1] += arr[j] / baseOut | 0;
                arr[j] %= baseOut;
            }
        }
        return arr.reverse();
    }
    /*
   * cos(x) = 1 - x^2/2! + x^4/4! - ...
   * |x| < pi/2
   *
   */ function cosine(Ctor, x) {
        var k, len, y;
        if (x.isZero()) return x;
        // Argument reduction: cos(4x) = 8*(cos^4(x) - cos^2(x)) + 1
        // i.e. cos(x) = 8*(cos^4(x/4) - cos^2(x/4)) + 1
        // Estimate the optimum number of times to use the argument reduction.
        len = x.d.length;
        if (len < 32) {
            k = Math.ceil(len / 3);
            y = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            y = '2.3283064365386962890625e-10';
        }
        Ctor.precision += k;
        x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1));
        // Reverse argument reduction
        for(var i = k; i--;){
            var cos2x = x.times(x);
            x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
        }
        Ctor.precision -= k;
        return x;
    }
    /*
   * Perform division in the specified base.
   */ var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k, base) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % base | 0;
                carry = temp / base | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, rm, dp, base) {
            var cmp, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either NaN, Infinity or 0?
            if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN : // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
            xd && xd[0] == 0 || !yd ? sign * 0 : sign / 0);
            if (base) {
                logBase = 1;
                e = x.e - y.e;
            } else {
                base = BASE;
                logBase = LOG_BASE;
                e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
            }
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            // The digit array of a Decimal from toStringBinary may have trailing zeros.
            for(i = 0; yd[i] == (xd[i] || 0); i++);
            if (yd[i] > (xd[i] || 0)) e--;
            if (pr == null) {
                sd = pr = Ctor.precision;
                rm = Ctor.rounding;
            } else if (dp) sd = pr + (x.e - y.e) + 1;
            else sd = pr;
            if (sd < 0) {
                qd.push(1);
                more = true;
            } else {
                // Convert precision in number of base 10 digits to base 1e7 digits.
                sd = sd / logBase + 2 | 0;
                i = 0;
                // divisor < 1e7
                if (yL == 1) {
                    k = 0;
                    yd = yd[0];
                    sd++;
                    // k is the carry.
                    for(; (i < xL || k) && sd--; i++){
                        t = k * base + (xd[i] || 0);
                        qd[i] = t / yd | 0;
                        k = t % yd | 0;
                    }
                    more = k || i < xL;
                // divisor >= 1e7
                } else {
                    // Normalise xd and yd so highest order digit of yd is >= base/2
                    k = base / (yd[0] + 1) | 0;
                    if (k > 1) {
                        yd = multiplyInteger(yd, k, base);
                        xd = multiplyInteger(xd, k, base);
                        yL = yd.length;
                        xL = xd.length;
                    }
                    xi = yL;
                    rem = xd.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL;)rem[remL++] = 0;
                    yz = yd.slice();
                    yz.unshift(0);
                    yd0 = yd[0];
                    if (yd[1] >= base / 2) ++yd0;
                    do {
                        k = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yd, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, k.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // k will be how many times the divisor goes into the current remainder.
                            k = rem0 / yd0 | 0;
                            //  Algorithm:
                            //  1. product = divisor * trial digit (k)
                            //  2. if product > remainder: product -= divisor, k--
                            //  3. remainder -= product
                            //  4. if product was < remainder at 2:
                            //    5. compare new remainder and divisor
                            //    6. If remainder > divisor: remainder -= divisor, k++
                            if (k > 1) {
                                if (k >= base) k = base - 1;
                                // product = divisor * trial digit.
                                prod = multiplyInteger(yd, k, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                cmp = compare(prod, rem, prodL, remL);
                                // product > remainder.
                                if (cmp == 1) {
                                    k--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yd, prodL, base);
                                }
                            } else {
                                // cmp is -1.
                                // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                                // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                                if (k == 0) cmp = k = 1;
                                prod = yd.slice();
                            }
                            prodL = prod.length;
                            if (prodL < remL) prod.unshift(0);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            // If product was < previous remainder.
                            if (cmp == -1) {
                                remL = rem.length;
                                // Compare divisor and new remainder.
                                cmp = compare(yd, rem, yL, remL);
                                // If divisor < new remainder, subtract divisor from remainder.
                                if (cmp < 1) {
                                    k++;
                                    // Subtract divisor from remainder.
                                    subtract(rem, yL < remL ? yz : yd, remL, base);
                                }
                            }
                            remL = rem.length;
                        } else if (cmp === 0) {
                            k++;
                            rem = [
                                0
                            ];
                        } // if cmp === 1, k will be 0
                        // Add the next digit, k, to the result array.
                        qd[i++] = k;
                        // Update the remainder.
                        if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                        else {
                            rem = [
                                xd[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] !== void 0) && sd--);
                    more = rem[0] !== void 0;
                }
                // Leading zero?
                if (!qd[0]) qd.shift();
            }
            // logBase is 1 when divide is being used for base conversion.
            if (logBase == 1) {
                q.e = e;
                inexact = more;
            } else {
                // To calculate q.e, first get the number of digits of qd[0].
                for(i = 1, k = qd[0]; k >= 10; k /= 10)i++;
                q.e = i + e * logBase - 1;
                finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
            }
            return q;
        };
    }();
    /*
   * Round `x` to `sd` significant digits using rounding mode `rm`.
   * Check for over/under-flow.
   */ function finalise(x, sd, rm, isTruncated) {
        var digits, i, j, k, rd, roundUp, w, xd, xdi, Ctor = x.constructor;
        // Don't round if sd is null or undefined.
        out: if (sd != null) {
            xd = x.d;
            // Infinity/NaN.
            if (!xd) return x;
            // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
            // w: the word of xd containing rd, a base 1e7 number.
            // xdi: the index of w within xd.
            // digits: the number of digits of w.
            // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
            // they had leading zeros)
            // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
            // Get the length of the first word of the digits array xd.
            for(digits = 1, k = xd[0]; k >= 10; k /= 10)digits++;
            i = sd - digits;
            // Is the rounding digit in the first word of xd?
            if (i < 0) {
                i += LOG_BASE;
                j = sd;
                w = xd[xdi = 0];
                // Get the rounding digit at index j of w.
                rd = w / mathpow(10, digits - j - 1) % 10 | 0;
            } else {
                xdi = Math.ceil((i + 1) / LOG_BASE);
                k = xd.length;
                if (xdi >= k) {
                    if (isTruncated) {
                        // Needed by `naturalExponential`, `naturalLogarithm` and `squareRoot`.
                        for(; k++ <= xdi;)xd.push(0);
                        w = rd = 0;
                        digits = 1;
                        i %= LOG_BASE;
                        j = i - LOG_BASE + 1;
                    } else break out;
                } else {
                    w = k = xd[xdi];
                    // Get the number of digits of w.
                    for(digits = 1; k >= 10; k /= 10)digits++;
                    // Get the index of rd within w.
                    i %= LOG_BASE;
                    // Get the index of rd within w, adjusted for leading zeros.
                    // The number of leading zeros of w is given by LOG_BASE - digits.
                    j = i - LOG_BASE + digits;
                    // Get the rounding digit at index j of w.
                    rd = j < 0 ? 0 : w / mathpow(10, digits - j - 1) % 10 | 0;
                }
            }
            // Are there any non-zero digits after the rounding digit?
            isTruncated = isTruncated || sd < 0 || xd[xdi + 1] !== void 0 || (j < 0 ? w : w % mathpow(10, digits - j - 1));
            // The expression `w % mathpow(10, digits - j - 1)` returns all the digits of w to the right
            // of the digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression
            // will give 714.
            roundUp = rm < 4 ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
            if (sd < 1 || !xd[0]) {
                xd.length = 0;
                if (roundUp) {
                    // Convert sd to decimal places.
                    sd -= x.e + 1;
                    // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                    xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                    x.e = -sd || 0;
                } else // Zero.
                xd[0] = x.e = 0;
                return x;
            }
            // Remove excess digits.
            if (i == 0) {
                xd.length = xdi;
                k = 1;
                xdi--;
            } else {
                xd.length = xdi + 1;
                k = mathpow(10, LOG_BASE - i);
                // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                // j > 0 means i > number of leading zeros of w.
                xd[xdi] = j > 0 ? (w / mathpow(10, digits - j) % mathpow(10, j) | 0) * k : 0;
            }
            if (roundUp) {
                for(;;)// Is the digit to be rounded up in the first word of xd?
                if (xdi == 0) {
                    // i will be the length of xd[0] before k is added.
                    for(i = 1, j = xd[0]; j >= 10; j /= 10)i++;
                    j = xd[0] += k;
                    for(k = 1; j >= 10; j /= 10)k++;
                    // if i != k the length has increased.
                    if (i != k) {
                        x.e++;
                        if (xd[0] == BASE) xd[0] = 1;
                    }
                    break;
                } else {
                    xd[xdi] += k;
                    if (xd[xdi] != BASE) break;
                    xd[xdi--] = 0;
                    k = 1;
                }
            }
            // Remove trailing zeros.
            for(i = xd.length; xd[--i] === 0;)xd.pop();
        }
        if (external) {
            // Overflow?
            if (x.e > Ctor.maxE) {
                // Infinity.
                x.d = null;
                x.e = NaN;
            // Underflow?
            } else if (x.e < Ctor.minE) {
                // Zero.
                x.e = 0;
                x.d = [
                    0
                ];
            // Ctor.underflow = true;
            } // else Ctor.underflow = false;
        }
        return x;
    }
    function finiteToString(x, isExp, sd) {
        if (!x.isFinite()) return nonFiniteToString(x);
        var k, e = x.e, str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (x.e < 0 ? 'e' : 'e+') + x.e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return str;
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(digits, e) {
        var w = digits[0];
        // Add the number of digits of the first word of the digits array.
        for(e *= LOG_BASE; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > LN10_PRECISION) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(precisionLimitExceeded);
        }
        return finalise(new Ctor(LN10), sd, 1, true);
    }
    function getPi(Ctor, sd, rm) {
        if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
        return finalise(new Ctor(PI), sd, rm, true);
    }
    function getPrecision(digits) {
        var w = digits.length - 1, len = w * LOG_BASE + 1;
        w = digits[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)len--;
            // Add the number of digits of the first word.
            for(w = digits[0]; w >= 10; w /= 10)len++;
        }
        return len;
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the value of Decimal `x` to the power `n`, where `n` is an
   * integer of type number.
   *
   * Implements 'exponentiation by squaring'. Called by `pow` and `parseOther`.
   *
   */ function intPow(Ctor, x, n, pr) {
        var isTruncated, r = new Ctor(1), // Max n of 9007199254740991 takes 53 loop iterations.
        // Maximum digits array length; leaves [28, 34] guard digits.
        k = Math.ceil(pr / LOG_BASE + 4);
        external = false;
        for(;;){
            if (n % 2) {
                r = r.times(x);
                if (truncate(r.d, k)) isTruncated = true;
            }
            n = mathfloor(n / 2);
            if (n === 0) {
                // To ensure correct rounding when r.d is truncated, increment the last word if it is zero.
                n = r.d.length - 1;
                if (isTruncated && r.d[n] === 0) ++r.d[n];
                break;
            }
            x = x.times(x);
            truncate(x.d, k);
        }
        external = true;
        return r;
    }
    function isOdd(n) {
        return n.d[n.d.length - 1] & 1;
    }
    /*
   * Handle `max` (`n` is -1) and `min` (`n` is 1).
   */ function maxOrMin(Ctor, args, n) {
        var k, y, x = new Ctor(args[0]), i = 0;
        for(; ++i < args.length;){
            y = new Ctor(args[i]);
            // NaN?
            if (!y.s) {
                x = y;
                break;
            }
            k = x.cmp(y);
            if (k === n || k === 0 && x.s === n) x = y;
        }
        return x;
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x` rounded to `sd` significant
   * digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * Max integer argument: exp('20723265836946413') = 6.3e+9000000000000000
   * Min integer argument: exp('-20723265836946411') = 1.2e-9000000000000000
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(Infinity)  = Infinity
   *  exp(-Infinity) = 0
   *  exp(NaN)       = NaN
   *  exp(±0)        = 1
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   *  The result will always be correctly rounded.
   *
   */ function naturalExponential(x, sd) {
        var denominator, guard, j, pow, sum, t, wpr, rep = 0, i = 0, k = 0, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // 0/NaN/Infinity?
        if (!x.d || !x.d[0] || x.e > 17) return new Ctor(x.d ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0 : x.s ? x.s < 0 ? 0 : x : 0 / 0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        // while abs(x) >= 0.1
        while(x.e > -2){
            // x = x / 2^5
            x = x.times(t);
            k += 5;
        }
        // Use 2 * log10(2^k) + 5 (empirically derived) to estimate the increase in precision
        // necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(1);
        Ctor.precision = wpr;
        for(;;){
            pow = finalise(pow.times(x), wpr, 1);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                j = k;
                while(j--)sum = finalise(sum.times(sum), wpr, 1);
                // Check to see if the first 4 rounding digits are [49]999.
                // If so, repeat the summation with a higher precision, otherwise
                // e.g. with precision: 18, rounding: 1
                // exp(18.404272462595034083567793919843761) = 98372560.1229999999 (should be 98372560.123)
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (rep < 3 && checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += 10;
                        denominator = pow = t = new Ctor(1);
                        i = 0;
                        rep++;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
        }
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` rounded to `sd` significant
   * digits.
   *
   *  ln(-n)        = NaN
   *  ln(0)         = -Infinity
   *  ln(-0)        = -Infinity
   *  ln(1)         = 0
   *  ln(Infinity)  = Infinity
   *  ln(-Infinity) = NaN
   *  ln(NaN)       = NaN
   *
   *  ln(n) (n != 1) is non-terminating.
   *
   */ function naturalLogarithm(y, sd) {
        var c, c0, denominator, e, numerator, rep, sum, t, wpr, x1, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // Is x negative or Infinity, NaN, 0 or 1?
        if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        Ctor.precision = wpr += guard;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        if (Math.abs(e = x.e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = x.e;
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = naturalLogarithm(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? finalise(x, pr, rm, external = true) : x;
        }
        // x1 is x reduced to a value near 1.
        x1 = x;
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
        x2 = finalise(x.times(x), wpr, 1);
        denominator = 3;
        for(;;){
            numerator = finalise(numerator.times(x2), wpr, 1);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction. Check that e is not 0 because, besides preventing an
                // unnecessary calculation, -0 + 0 = +0 and to ensure correct rounding -0 needs to stay -0.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr, 1);
                // Is rm > 3 and the first 4 rounding digits 4999, or rm < 4 (or the summation has
                // been repeated previously) and the first 4 rounding digits 9999?
                // If so, restart the summation with a higher precision, otherwise
                // e.g. with precision: 12, rounding: 1
                // ln(135520028.6126091714265381533) = 18.7246299999 when it should be 18.72463.
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += guard;
                        t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
                        x2 = finalise(x.times(x), wpr, 1);
                        denominator = rep = 1;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
            denominator += 2;
        }
    }
    // ±Infinity, NaN.
    function nonFiniteToString(x) {
        // Unsigned.
        return String(x.s * x.s / 0);
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // TODO BigInt str: no need to check for decimal point, exponential form or leading zeros.
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48; --len);
        str = str.slice(i, len);
        if (str) {
            len -= i;
            x.e = e = e - i - 1;
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external) {
                // Overflow?
                if (x.e > x.constructor.maxE) {
                    // Infinity.
                    x.d = null;
                    x.e = NaN;
                // Underflow?
                } else if (x.e < x.constructor.minE) {
                    // Zero.
                    x.e = 0;
                    x.d = [
                        0
                    ];
                // x.constructor.underflow = true;
                } // else x.constructor.underflow = false;
            }
        } else {
            // Zero.
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Parse the value of a new Decimal `x` from a string `str`, which is not a decimal value.
   */ function parseOther(x, str) {
        var base, Ctor, divisor, i, isFloat, len, p, xd, xe;
        if (str.indexOf('_') > -1) {
            str = str.replace(/(\d)_(?=\d)/g, '$1');
            if (isDecimal.test(str)) return parseDecimal(x, str);
        } else if (str === 'Infinity' || str === 'NaN') {
            if (!+str) x.s = NaN;
            x.e = NaN;
            x.d = null;
            return x;
        }
        if (isHex.test(str)) {
            base = 16;
            str = str.toLowerCase();
        } else if (isBinary.test(str)) base = 2;
        else if (isOctal.test(str)) base = 8;
        else throw Error(invalidArgument + str);
        // Is there a binary exponent part?
        i = str.search(/p/i);
        if (i > 0) {
            p = +str.slice(i + 1);
            str = str.substring(2, i);
        } else str = str.slice(2);
        // Convert `str` as an integer then divide the result by `base` raised to a power such that the
        // fraction part will be restored.
        i = str.indexOf('.');
        isFloat = i >= 0;
        Ctor = x.constructor;
        if (isFloat) {
            str = str.replace('.', '');
            len = str.length;
            i = len - i;
            // log[10](16) = 1.2041... , log[10](88) = 1.9444....
            divisor = intPow(Ctor, new Ctor(base), i, i * 2);
        }
        xd = convertBase(str, base, BASE);
        xe = xd.length - 1;
        // Remove trailing zeros.
        for(i = xe; xd[i] === 0; --i)xd.pop();
        if (i < 0) return new Ctor(x.s * 0);
        x.e = getBase10Exponent(xd, xe);
        x.d = xd;
        external = false;
        // At what precision to perform the division to ensure exact conversion?
        // maxDecimalIntegerPartDigitCount = ceil(log[10](b) * otherBaseIntegerPartDigitCount)
        // log[10](2) = 0.30103, log[10](8) = 0.90309, log[10](16) = 1.20412
        // E.g. ceil(1.2 * 3) = 4, so up to 4 decimal digits are needed to represent 3 hex int digits.
        // maxDecimalFractionPartDigitCount = {Hex:4|Oct:3|Bin:1} * otherBaseFractionPartDigitCount
        // Therefore using 4 * the number of digits of str will always be enough.
        if (isFloat) x = divide(x, divisor, len * 4);
        // Multiply by the binary exponent part if present.
        if (p) x = x.times(Math.abs(p) < 54 ? mathpow(2, p) : Decimal.pow(2, p));
        external = true;
        return x;
    }
    /*
   * sin(x) = x - x^3/3! + x^5/5! - ...
   * |x| < pi/2
   *
   */ function sine(Ctor, x) {
        var k, len = x.d.length;
        if (len < 3) return x.isZero() ? x : taylorSeries(Ctor, 2, x, x);
        // Argument reduction: sin(5x) = 16*sin^5(x) - 20*sin^3(x) + 5*sin(x)
        // i.e. sin(x) = 16*sin^5(x/5) - 20*sin^3(x/5) + 5*sin(x/5)
        // and  sin(x) = sin(x/5)(5 + sin^2(x/5)(16sin^2(x/5) - 20))
        // Estimate the optimum number of times to use the argument reduction.
        k = 1.4 * Math.sqrt(len);
        k = k > 16 ? 16 : k | 0;
        x = x.times(1 / tinyPow(5, k));
        x = taylorSeries(Ctor, 2, x, x);
        // Reverse argument reduction
        var sin2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
        for(; k--;){
            sin2_x = x.times(x);
            x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
        }
        return x;
    }
    // Calculate Taylor series for `cos`, `cosh`, `sin` and `sinh`.
    function taylorSeries(Ctor, n, x, y, isHyperbolic) {
        var j, t, u, x2, i = 1, pr = Ctor.precision, k = Math.ceil(pr / LOG_BASE);
        external = false;
        x2 = x.times(x);
        u = new Ctor(y);
        for(;;){
            t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
            u = isHyperbolic ? y.plus(t) : y.minus(t);
            y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
            t = u.plus(y);
            if (t.d[k] !== void 0) {
                for(j = k; t.d[j] === u.d[j] && j--;);
                if (j == -1) break;
            }
            j = u;
            u = y;
            y = t;
            t = j;
            i++;
        }
        external = true;
        t.d.length = k + 1;
        return t;
    }
    // Exponent e must be positive and non-zero.
    function tinyPow(b, e) {
        var n = b;
        while(--e)n *= b;
        return n;
    }
    // Return the absolute value of `x` reduced to less than or equal to half pi.
    function toLessThanHalfPi(Ctor, x) {
        var t, isNeg = x.s < 0, pi = getPi(Ctor, Ctor.precision, 1), halfPi = pi.times(0.5);
        x = x.abs();
        if (x.lte(halfPi)) {
            quadrant = isNeg ? 4 : 1;
            return x;
        }
        t = x.divToInt(pi);
        if (t.isZero()) quadrant = isNeg ? 3 : 2;
        else {
            x = x.minus(t.times(pi));
            // 0 <= x < pi
            if (x.lte(halfPi)) {
                quadrant = isOdd(t) ? isNeg ? 2 : 3 : isNeg ? 4 : 1;
                return x;
            }
            quadrant = isOdd(t) ? isNeg ? 1 : 4 : isNeg ? 3 : 2;
        }
        return x.minus(pi).abs();
    }
    /*
   * Return the value of Decimal `x` as a string in base `baseOut`.
   *
   * If the optional `sd` argument is present include a binary exponent suffix.
   */ function toStringBinary(x, baseOut, sd, rm) {
        var base, e, i, k, len, roundUp, str, xd, y, Ctor = x.constructor, isExp = sd !== void 0;
        if (isExp) {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        } else {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        }
        if (!x.isFinite()) str = nonFiniteToString(x);
        else {
            str = finiteToString(x);
            i = str.indexOf('.');
            // Use exponential notation according to `toExpPos` and `toExpNeg`? No, but if required:
            // maxBinaryExponent = floor((decimalExponent + 1) * log[2](10))
            // minBinaryExponent = floor(decimalExponent * log[2](10))
            // log[2](10) = 3.321928094887362347870319429489390175864
            if (isExp) {
                base = 2;
                if (baseOut == 16) sd = sd * 4 - 3;
                else if (baseOut == 8) sd = sd * 3 - 2;
            } else base = baseOut;
            // Convert the number as an integer then divide the result by its base raised to a power such
            // that the fraction part will be restored.
            // Non-integer.
            if (i >= 0) {
                str = str.replace('.', '');
                y = new Ctor(1);
                y.e = str.length - i;
                y.d = convertBase(finiteToString(y), 10, base);
                y.e = y.d.length;
            }
            xd = convertBase(str, 10, base);
            e = len = xd.length;
            // Remove trailing zeros.
            for(; xd[--len] == 0;)xd.pop();
            if (!xd[0]) str = isExp ? '0p+0' : '0';
            else {
                if (i < 0) e--;
                else {
                    x = new Ctor(x);
                    x.d = xd;
                    x.e = e;
                    x = divide(x, y, sd, rm, 0, base);
                    xd = x.d;
                    e = x.e;
                    roundUp = inexact;
                }
                // The rounding digit, i.e. the digit after the digit that may be rounded up.
                i = xd[sd];
                k = base / 2;
                roundUp = roundUp || xd[sd + 1] !== void 0;
                roundUp = rm < 4 ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2)) : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 || rm === (x.s < 0 ? 8 : 7));
                xd.length = sd;
                if (roundUp) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(; ++xd[--sd] > base - 1;){
                    xd[sd] = 0;
                    if (!sd) {
                        ++e;
                        xd.unshift(1);
                    }
                }
                // Determine trailing zeros.
                for(len = xd.length; !xd[len - 1]; --len);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ''; i < len; i++)str += NUMERALS.charAt(xd[i]);
                // Add binary exponent suffix?
                if (isExp) {
                    if (len > 1) {
                        if (baseOut == 16 || baseOut == 8) {
                            i = baseOut == 16 ? 4 : 3;
                            for(--len; len % i; len++)str += '0';
                            xd = convertBase(str, base, baseOut);
                            for(len = xd.length; !xd[len - 1]; --len);
                            // xd[0] will always be be 1
                            for(i = 1, str = '1.'; i < len; i++)str += NUMERALS.charAt(xd[i]);
                        } else str = str.charAt(0) + '.' + str.slice(1);
                    }
                    str = str + (e < 0 ? 'p' : 'p+') + e;
                } else if (e < 0) {
                    for(; ++e;)str = '0' + str;
                    str = '0.' + str;
                } else {
                    if (++e > len) for(e -= len; e--;)str += '0';
                    else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
                }
            }
            str = (baseOut == 16 ? '0x' : baseOut == 2 ? '0b' : baseOut == 8 ? '0o' : '') + str;
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  abs
   *  acos
   *  acosh
   *  add
   *  asin
   *  asinh
   *  atan
   *  atanh
   *  atan2
   *  cbrt
   *  ceil
   *  clamp
   *  clone
   *  config
   *  cos
   *  cosh
   *  div
   *  exp
   *  floor
   *  hypot
   *  ln
   *  log
   *  log2
   *  log10
   *  max
   *  min
   *  mod
   *  mul
   *  pow
   *  random
   *  round
   *  set
   *  sign
   *  sin
   *  sinh
   *  sqrt
   *  sub
   *  sum
   *  tan
   *  tanh
   *  trunc
   */ /*
   * Return a new Decimal whose value is the absolute value of `x`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function abs(x) {
        return new this(x).abs();
    }
    /*
   * Return a new Decimal whose value is the arccosine in radians of `x`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function acos(x) {
        return new this(x).acos();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function acosh(x) {
        return new this(x).acosh();
    }
    /*
   * Return a new Decimal whose value is the sum of `x` and `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   * y {number|string|bigint|Decimal}
   *
   */ function add(x, y) {
        return new this(x).plus(y);
    }
    /*
   * Return a new Decimal whose value is the arcsine in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function asin(x) {
        return new this(x).asin();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function asinh(x) {
        return new this(x).asinh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function atan(x) {
        return new this(x).atan();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function atanh(x) {
        return new this(x).atanh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `y/x` in the range -pi to pi
   * (inclusive), rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi, pi]
   *
   * y {number|string|bigint|Decimal} The y-coordinate.
   * x {number|string|bigint|Decimal} The x-coordinate.
   *
   * atan2(±0, -0)               = ±pi
   * atan2(±0, +0)               = ±0
   * atan2(±0, -x)               = ±pi for x > 0
   * atan2(±0, x)                = ±0 for x > 0
   * atan2(-y, ±0)               = -pi/2 for y > 0
   * atan2(y, ±0)                = pi/2 for y > 0
   * atan2(±y, -Infinity)        = ±pi for finite y > 0
   * atan2(±y, +Infinity)        = ±0 for finite y > 0
   * atan2(±Infinity, x)         = ±pi/2 for finite x
   * atan2(±Infinity, -Infinity) = ±3*pi/4
   * atan2(±Infinity, +Infinity) = ±pi/4
   * atan2(NaN, x) = NaN
   * atan2(y, NaN) = NaN
   *
   */ function atan2(y, x) {
        y = new this(y);
        x = new this(x);
        var r, pr = this.precision, rm = this.rounding, wpr = pr + 4;
        // Either NaN
        if (!y.s || !x.s) r = new this(NaN);
        else if (!y.d && !x.d) {
            r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
            r.s = y.s;
        // x is ±Infinity or y is ±0
        } else if (!x.d || y.isZero()) {
            r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
            r.s = y.s;
        // y is ±Infinity or x is ±0
        } else if (!y.d || x.isZero()) {
            r = getPi(this, wpr, 1).times(0.5);
            r.s = y.s;
        // Both non-zero and finite
        } else if (x.s < 0) {
            this.precision = wpr;
            this.rounding = 1;
            r = this.atan(divide(y, x, wpr, 1));
            x = getPi(this, wpr, 1);
            this.precision = pr;
            this.rounding = rm;
            r = y.s < 0 ? r.minus(x) : r.plus(x);
        } else r = this.atan(divide(y, x, wpr, 1));
        return r;
    }
    /*
   * Return a new Decimal whose value is the cube root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function cbrt(x) {
        return new this(x).cbrt();
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using `ROUND_CEIL`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function ceil(x) {
        return finalise(x = new this(x), x.e + 1, 2);
    }
    /*
   * Return a new Decimal whose value is `x` clamped to the range delineated by `min` and `max`.
   *
   * x {number|string|bigint|Decimal}
   * min {number|string|bigint|Decimal}
   * max {number|string|bigint|Decimal}
   *
   */ function clamp(x, min, max) {
        return new this(x).clamp(min, max);
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *   maxE       {number}
   *   minE       {number}
   *   modulo     {number}
   *   crypto     {boolean|number}
   *   defaults   {true}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, useDefaults = obj.defaults === true, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -EXP_LIMIT,
            0,
            'toExpPos',
            0,
            EXP_LIMIT,
            'maxE',
            0,
            EXP_LIMIT,
            'minE',
            -EXP_LIMIT,
            0,
            'modulo',
            0,
            9
        ];
        for(i = 0; i < ps.length; i += 3){
            if (p = ps[i], useDefaults) this[p] = DEFAULTS[p];
            if ((v = obj[p]) !== void 0) {
                if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
                else throw Error(invalidArgument + p + ': ' + v);
            }
        }
        if (p = 'crypto', useDefaults) this[p] = DEFAULTS[p];
        if ((v = obj[p]) !== void 0) {
            if (v === true || v === false || v === 0 || v === 1) {
                if (v) {
                    if (typeof crypto != 'undefined' && crypto && (crypto.getRandomValues || crypto.randomBytes)) this[p] = true;
                    else throw Error(cryptoUnavailable);
                } else this[p] = false;
            } else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    /*
   * Return a new Decimal whose value is the cosine of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function cos(x) {
        return new this(x).cos();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of `x`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function cosh(x) {
        return new this(x).cosh();
    }
    /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * v {number|string|bigint|Decimal} A numeric value.
     *
     */ function Decimal(v) {
            var e, i, t, x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(v);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            if (isDecimalInstance(v)) {
                x.s = v.s;
                if (external) {
                    if (!v.d || v.e > Decimal.maxE) {
                        // Infinity.
                        x.e = NaN;
                        x.d = null;
                    } else if (v.e < Decimal.minE) {
                        // Zero.
                        x.e = 0;
                        x.d = [
                            0
                        ];
                    } else {
                        x.e = v.e;
                        x.d = v.d.slice();
                    }
                } else {
                    x.e = v.e;
                    x.d = v.d ? v.d.slice() : v.d;
                }
                return;
            }
            t = typeof v;
            if (t === 'number') {
                if (v === 0) {
                    x.s = 1 / v < 0 ? -1 : 1;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                if (v < 0) {
                    v = -v;
                    x.s = -1;
                } else x.s = 1;
                // Fast path for small integers.
                if (v === ~~v && v < 1e7) {
                    for(e = 0, i = v; i >= 10; i /= 10)e++;
                    if (external) {
                        if (e > Decimal.maxE) {
                            x.e = NaN;
                            x.d = null;
                        } else if (e < Decimal.minE) {
                            x.e = 0;
                            x.d = [
                                0
                            ];
                        } else {
                            x.e = e;
                            x.d = [
                                v
                            ];
                        }
                    } else {
                        x.e = e;
                        x.d = [
                            v
                        ];
                    }
                    return;
                }
                // Infinity or NaN?
                if (v * 0 !== 0) {
                    if (!v) x.s = NaN;
                    x.e = NaN;
                    x.d = null;
                    return;
                }
                return parseDecimal(x, v.toString());
            }
            if (t === 'string') {
                if ((i = v.charCodeAt(0)) === 45) {
                    v = v.slice(1);
                    x.s = -1;
                } else {
                    if (i === 43) v = v.slice(1); // plus sign
                    x.s = 1;
                }
                return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
            }
            if (t === 'bigint') {
                if (v < 0) {
                    v = -v;
                    x.s = -1;
                } else x.s = 1;
                return parseDecimal(x, v.toString());
            }
            throw Error(invalidArgument + v);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.EUCLID = 9;
        Decimal.config = Decimal.set = config;
        Decimal.clone = clone;
        Decimal.isDecimal = isDecimalInstance;
        Decimal.abs = abs;
        Decimal.acos = acos;
        Decimal.acosh = acosh; // ES6
        Decimal.add = add;
        Decimal.asin = asin;
        Decimal.asinh = asinh; // ES6
        Decimal.atan = atan;
        Decimal.atanh = atanh; // ES6
        Decimal.atan2 = atan2;
        Decimal.cbrt = cbrt; // ES6
        Decimal.ceil = ceil;
        Decimal.clamp = clamp;
        Decimal.cos = cos;
        Decimal.cosh = cosh; // ES6
        Decimal.div = div;
        Decimal.exp = exp;
        Decimal.floor = floor;
        Decimal.hypot = hypot; // ES6
        Decimal.ln = ln;
        Decimal.log = log;
        Decimal.log10 = log10; // ES6
        Decimal.log2 = log2; // ES6
        Decimal.max = max;
        Decimal.min = min;
        Decimal.mod = mod;
        Decimal.mul = mul;
        Decimal.pow = pow;
        Decimal.random = random;
        Decimal.round = round;
        Decimal.sign = sign; // ES6
        Decimal.sin = sin;
        Decimal.sinh = sinh; // ES6
        Decimal.sqrt = sqrt;
        Decimal.sub = sub;
        Decimal.sum = sum;
        Decimal.tan = tan;
        Decimal.tanh = tanh; // ES6
        Decimal.trunc = trunc; // ES6
        if (obj === void 0) obj = {};
        if (obj) {
            if (obj.defaults !== true) {
                ps = [
                    'precision',
                    'rounding',
                    'toExpNeg',
                    'toExpPos',
                    'maxE',
                    'minE',
                    'modulo',
                    'crypto'
                ];
                for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
            }
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Return a new Decimal whose value is `x` divided by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   * y {number|string|bigint|Decimal}
   *
   */ function div(x, y) {
        return new this(x).div(y);
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} The power to which to raise the base of the natural log.
   *
   */ function exp(x) {
        return new this(x).exp();
    }
    /*
   * Return a new Decimal whose value is `x` round to an integer using `ROUND_FLOOR`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function floor(x) {
        return finalise(x = new this(x), x.e + 1, 3);
    }
    /*
   * Return a new Decimal whose value is the square root of the sum of the squares of the arguments,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * hypot(a, b, ...) = sqrt(a^2 + b^2 + ...)
   *
   * arguments {number|string|bigint|Decimal}
   *
   */ function hypot() {
        var i, n, t = new this(0);
        external = false;
        for(i = 0; i < arguments.length;){
            n = new this(arguments[i++]);
            if (!n.d) {
                if (n.s) {
                    external = true;
                    return new this(1 / 0);
                }
                t = n;
            } else if (t.d) t = t.plus(n.times(n));
        }
        external = true;
        return t.sqrt();
    }
    /*
   * Return true if object is a Decimal instance (where Decimal is any Decimal constructor),
   * otherwise return false.
   *
   */ function isDecimalInstance(obj) {
        return obj instanceof Decimal || obj && obj.toStringTag === tag || false;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function ln(x) {
        return new this(x).ln();
    }
    /*
   * Return a new Decimal whose value is the log of `x` to the base `y`, or to base 10 if no base
   * is specified, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * log[y](x)
   *
   * x {number|string|bigint|Decimal} The argument of the logarithm.
   * y {number|string|bigint|Decimal} The base of the logarithm.
   *
   */ function log(x, y) {
        return new this(x).log(y);
    }
    /*
   * Return a new Decimal whose value is the base 2 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function log2(x) {
        return new this(x).log(2);
    }
    /*
   * Return a new Decimal whose value is the base 10 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function log10(x) {
        return new this(x).log(10);
    }
    /*
   * Return a new Decimal whose value is the maximum of the arguments.
   *
   * arguments {number|string|bigint|Decimal}
   *
   */ function max() {
        return maxOrMin(this, arguments, -1);
    }
    /*
   * Return a new Decimal whose value is the minimum of the arguments.
   *
   * arguments {number|string|bigint|Decimal}
   *
   */ function min() {
        return maxOrMin(this, arguments, 1);
    }
    /*
   * Return a new Decimal whose value is `x` modulo `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   * y {number|string|bigint|Decimal}
   *
   */ function mod(x, y) {
        return new this(x).mod(y);
    }
    /*
   * Return a new Decimal whose value is `x` multiplied by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   * y {number|string|bigint|Decimal}
   *
   */ function mul(x, y) {
        return new this(x).mul(y);
    }
    /*
   * Return a new Decimal whose value is `x` raised to the power `y`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} The base.
   * y {number|string|bigint|Decimal} The exponent.
   *
   */ function pow(x, y) {
        return new this(x).pow(y);
    }
    /*
   * Returns a new Decimal with a random value equal to or greater than 0 and less than 1, and with
   * `sd`, or `Decimal.precision` if `sd` is omitted, significant digits (or less if trailing zeros
   * are produced).
   *
   * [sd] {number} Significant digits. Integer, 0 to MAX_DIGITS inclusive.
   *
   */ function random(sd) {
        var d, e, k, n, i = 0, r = new this(1), rd = [];
        if (sd === void 0) sd = this.precision;
        else checkInt32(sd, 1, MAX_DIGITS);
        k = Math.ceil(sd / LOG_BASE);
        if (!this.crypto) for(; i < k;)rd[i++] = Math.random() * 1e7 | 0;
        else if (crypto.getRandomValues) {
            d = crypto.getRandomValues(new Uint32Array(k));
            for(; i < k;){
                n = d[i];
                // 0 <= n < 4294967296
                // Probability n >= 4.29e9, is 4967296 / 4294967296 = 0.00116 (1 in 865).
                if (n >= 4.29e9) d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
                else // 0 <= n <= 4289999999
                // 0 <= (n % 1e7) <= 9999999
                rd[i++] = n % 1e7;
            }
        // Node.js supporting crypto.randomBytes.
        } else if (crypto.randomBytes) {
            // buffer
            d = crypto.randomBytes(k *= 4);
            for(; i < k;){
                // 0 <= n < 2147483648
                n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 0x7f) << 24);
                // Probability n >= 2.14e9, is 7483648 / 2147483648 = 0.0035 (1 in 286).
                if (n >= 2.14e9) crypto.randomBytes(4).copy(d, i);
                else {
                    // 0 <= n <= 2139999999
                    // 0 <= (n % 1e7) <= 9999999
                    rd.push(n % 1e7);
                    i += 4;
                }
            }
            i = k / 4;
        } else throw Error(cryptoUnavailable);
        k = rd[--i];
        sd %= LOG_BASE;
        // Convert trailing digits to zeros according to sd.
        if (k && sd) {
            n = mathpow(10, LOG_BASE - sd);
            rd[i] = (k / n | 0) * n;
        }
        // Remove trailing words which are zero.
        for(; rd[i] === 0; i--)rd.pop();
        // Zero?
        if (i < 0) {
            e = 0;
            rd = [
                0
            ];
        } else {
            e = -1;
            // Remove leading words which are zero and adjust exponent accordingly.
            for(; rd[0] === 0; e -= LOG_BASE)rd.shift();
            // Count the digits of the first word of rd to determine leading zeros.
            for(k = 1, n = rd[0]; n >= 10; n /= 10)k++;
            // Adjust the exponent for leading zeros of the first word of rd.
            if (k < LOG_BASE) e -= LOG_BASE - k;
        }
        r.e = e;
        r.d = rd;
        return r;
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using rounding mode `rounding`.
   *
   * To emulate `Math.round`, set rounding to 7 (ROUND_HALF_CEIL).
   *
   * x {number|string|bigint|Decimal}
   *
   */ function round(x) {
        return finalise(x = new this(x), x.e + 1, this.rounding);
    }
    /*
   * Return
   *   1    if x > 0,
   *  -1    if x < 0,
   *   0    if x is 0,
   *  -0    if x is -0,
   *   NaN  otherwise
   *
   * x {number|string|bigint|Decimal}
   *
   */ function sign(x) {
        x = new this(x);
        return x.d ? x.d[0] ? x.s : 0 * x.s : x.s || NaN;
    }
    /*
   * Return a new Decimal whose value is the sine of `x`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function sin(x) {
        return new this(x).sin();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic sine of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function sinh(x) {
        return new this(x).sinh();
    }
    /*
   * Return a new Decimal whose value is the square root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function sqrt(x) {
        return new this(x).sqrt();
    }
    /*
   * Return a new Decimal whose value is `x` minus `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   * y {number|string|bigint|Decimal}
   *
   */ function sub(x, y) {
        return new this(x).sub(y);
    }
    /*
   * Return a new Decimal whose value is the sum of the arguments, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * Only the result is rounded, not the intermediate calculations.
   *
   * arguments {number|string|bigint|Decimal}
   *
   */ function sum() {
        var i = 0, args = arguments, x = new this(args[i]);
        external = false;
        for(; x.s && ++i < args.length;)x = x.plus(args[i]);
        external = true;
        return finalise(x, this.precision, this.rounding);
    }
    /*
   * Return a new Decimal whose value is the tangent of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function tan(x) {
        return new this(x).tan();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function tanh(x) {
        return new this(x).tanh();
    }
    /*
   * Return a new Decimal whose value is `x` truncated to an integer.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function trunc(x) {
        return finalise(x = new this(x), x.e + 1, 1);
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(DEFAULTS);
    Decimal.prototype.constructor = Decimal;
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Create the internal constants from their string values.
    LN10 = new Decimal(LN10);
    PI = new Decimal(PI);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if (module.exports) {
        if (typeof Symbol == 'function' && typeof Symbol.iterator == 'symbol') {
            P[Symbol['for']('nodejs.util.inspect.custom')] = P.toString;
            P[Symbol.toStringTag] = 'Decimal';
        }
        module.exports = Decimal;
    // Browser.
    } else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : window;
        noConflict = globalScope.Decimal;
        Decimal.noConflict = function() {
            globalScope.Decimal = noConflict;
            return Decimal;
        };
        globalScope.Decimal = Decimal;
    }
})(module.exports);

});


parcelRegister("jNK3n", function(module, exports) {

$parcel$export(module.exports, "createBin", () => $e6a6512b5a05c5d5$export$a770ddfd7e536064);

var $dsu7t = parcelRequire("dsu7t");
var $e6a6512b5a05c5d5$var$name = 'bin';
var $e6a6512b5a05c5d5$var$dependencies = [
    'typed',
    'format'
];
var $e6a6512b5a05c5d5$export$a770ddfd7e536064 = (0, $dsu7t.factory)($e6a6512b5a05c5d5$var$name, $e6a6512b5a05c5d5$var$dependencies, (_ref)=>{
    var { typed: typed, format: format } = _ref;
    return typed($e6a6512b5a05c5d5$var$name, {
        'number | BigNumber': function number__BigNumber(n) {
            return format(n, {
                notation: 'bin'
            });
        },
        'number | BigNumber, number | BigNumber': function number__BigNumber_number__BigNumber(n, wordSize) {
            return format(n, {
                notation: 'bin',
                wordSize: wordSize
            });
        }
    });
});

});

parcelRegister("1CMBB", function(module, exports) {

$parcel$export(module.exports, "createBitAnd", () => $12ef0b197c05a2bc$export$bea4e06c5befec3b);

var $2704b = parcelRequire("2704b");

var $kycT3 = parcelRequire("kycT3");

var $52JKA = parcelRequire("52JKA");

var $hF01R = parcelRequire("hF01R");

var $dsu7t = parcelRequire("dsu7t");

var $6SJnV = parcelRequire("6SJnV");

var $jbibQ = parcelRequire("jbibQ");
var $12ef0b197c05a2bc$var$name = 'bitAnd';
var $12ef0b197c05a2bc$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'concat'
];
var $12ef0b197c05a2bc$export$bea4e06c5befec3b = /* #__PURE__ */ (0, $dsu7t.factory)($12ef0b197c05a2bc$var$name, $12ef0b197c05a2bc$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, concat: concat } = _ref;
    var matAlgo02xDS0 = (0, $kycT3.createMatAlgo02xDS0)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo06xS0S0 = (0, $hF01R.createMatAlgo06xS0S0)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo11xS0s = (0, $52JKA.createMatAlgo11xS0s)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Bitwise AND two values, `x & y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.bitAnd(x, y)
   *
   * Examples:
   *
   *    math.bitAnd(53, 131)               // returns number 1
   *
   *    math.bitAnd([1, 12, 31], 42)       // returns Array [0, 8, 10]
   *
   * See also:
   *
   *    bitNot, bitOr, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | bigint | Array | Matrix} x First value to and
   * @param  {number | BigNumber | bigint | Array | Matrix} y Second value to and
   * @return {number | BigNumber | bigint | Array | Matrix} AND of `x` and `y`
   */ return typed($12ef0b197c05a2bc$var$name, {
        'number, number': (0, $jbibQ.bitAndNumber),
        'BigNumber, BigNumber': (0, $2704b.bitAndBigNumber),
        'bigint, bigint': (x, y)=>x & y
    }, matrixAlgorithmSuite({
        SS: matAlgo06xS0S0,
        DS: matAlgo02xDS0,
        Ss: matAlgo11xS0s
    }));
});

});
parcelRegister("2704b", function(module, exports) {

$parcel$export(module.exports, "bitAndBigNumber", () => $189c497109cdf2d3$export$94757ce5cf54fec9);
$parcel$export(module.exports, "bitNotBigNumber", () => $189c497109cdf2d3$export$2ada53b3c51e9645);
$parcel$export(module.exports, "bitOrBigNumber", () => $189c497109cdf2d3$export$e43ec6c4cff46d2c);
$parcel$export(module.exports, "bitXor", () => $189c497109cdf2d3$export$bfcff4501301c191);
$parcel$export(module.exports, "leftShiftBigNumber", () => $189c497109cdf2d3$export$626dff8098a67b4c);
$parcel$export(module.exports, "rightArithShiftBigNumber", () => $189c497109cdf2d3$export$d489c03691bd4cd);
/**
 * Bitwise and for Bignumbers
 *
 * Special Cases:
 *   N &  n =  N
 *   n &  0 =  0
 *   n & -1 =  n
 *   n &  n =  n
 *   I &  I =  I
 *  -I & -I = -I
 *   I & -I =  0
 *   I &  n =  n
 *   I & -n =  I
 *  -I &  n =  0
 *  -I & -n = -I
 *
 * @param {BigNumber} x
 * @param {BigNumber} y
 * @return {BigNumber} Result of `x` & `y`, is fully precise
 * @private
 */ function $189c497109cdf2d3$export$94757ce5cf54fec9(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error('Integers expected in function bitAnd');
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    if (x.isZero() || y.eq(-1) || x.eq(y)) return x;
    if (y.isZero() || x.eq(-1)) return y;
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !y.isFinite()) {
            if (x.isNegative() === y.isNegative()) return x;
            return new BigNumber(0);
        }
        if (!x.isFinite()) {
            if (y.isNegative()) return x;
            if (x.isNegative()) return new BigNumber(0);
            return y;
        }
        if (!y.isFinite()) {
            if (x.isNegative()) return y;
            if (y.isNegative()) return new BigNumber(0);
            return x;
        }
    }
    return $189c497109cdf2d3$export$884842863a0853c4(x, y, function(a, b) {
        return a & b;
    });
}
function $189c497109cdf2d3$export$2ada53b3c51e9645(x) {
    if (x.isFinite() && !x.isInteger()) throw new Error('Integer expected in function bitNot');
    var BigNumber = x.constructor;
    var prevPrec = BigNumber.precision;
    BigNumber.config({
        precision: 1E9
    });
    var result = x.plus(new BigNumber(1));
    result.s = -result.s || null;
    BigNumber.config({
        precision: prevPrec
    });
    return result;
}
function $189c497109cdf2d3$export$e43ec6c4cff46d2c(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error('Integers expected in function bitOr');
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    var negOne = new BigNumber(-1);
    if (x.isZero() || y.eq(negOne) || x.eq(y)) return y;
    if (y.isZero() || x.eq(negOne)) return x;
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !x.isNegative() && y.isNegative() || x.isNegative() && !y.isNegative() && !y.isFinite()) return negOne;
        if (x.isNegative() && y.isNegative()) return x.isFinite() ? x : y;
        return x.isFinite() ? y : x;
    }
    return $189c497109cdf2d3$export$884842863a0853c4(x, y, function(a, b) {
        return a | b;
    });
}
function $189c497109cdf2d3$export$884842863a0853c4(x, y, func) {
    var BigNumber = x.constructor;
    var xBits, yBits;
    var xSign = +(x.s < 0);
    var ySign = +(y.s < 0);
    if (xSign) {
        xBits = $189c497109cdf2d3$var$decCoefficientToBinaryString($189c497109cdf2d3$export$2ada53b3c51e9645(x));
        for(var i = 0; i < xBits.length; ++i)xBits[i] ^= 1;
    } else xBits = $189c497109cdf2d3$var$decCoefficientToBinaryString(x);
    if (ySign) {
        yBits = $189c497109cdf2d3$var$decCoefficientToBinaryString($189c497109cdf2d3$export$2ada53b3c51e9645(y));
        for(var _i = 0; _i < yBits.length; ++_i)yBits[_i] ^= 1;
    } else yBits = $189c497109cdf2d3$var$decCoefficientToBinaryString(y);
    var minBits, maxBits, minSign;
    if (xBits.length <= yBits.length) {
        minBits = xBits;
        maxBits = yBits;
        minSign = xSign;
    } else {
        minBits = yBits;
        maxBits = xBits;
        minSign = ySign;
    }
    var shortLen = minBits.length;
    var longLen = maxBits.length;
    var expFuncVal = func(xSign, ySign) ^ 1;
    var outVal = new BigNumber(expFuncVal ^ 1);
    var twoPower = new BigNumber(1);
    var two = new BigNumber(2);
    var prevPrec = BigNumber.precision;
    BigNumber.config({
        precision: 1E9
    });
    while(shortLen > 0){
        if (func(minBits[--shortLen], maxBits[--longLen]) === expFuncVal) outVal = outVal.plus(twoPower);
        twoPower = twoPower.times(two);
    }
    while(longLen > 0){
        if (func(minSign, maxBits[--longLen]) === expFuncVal) outVal = outVal.plus(twoPower);
        twoPower = twoPower.times(two);
    }
    BigNumber.config({
        precision: prevPrec
    });
    if (expFuncVal === 0) outVal.s = -outVal.s;
    return outVal;
}
/* Extracted from decimal.js, and edited to specialize. */ function $189c497109cdf2d3$var$decCoefficientToBinaryString(x) {
    // Convert to string
    var a = x.d; // array with digits
    var r = a[0] + '';
    for(var i = 1; i < a.length; ++i){
        var s = a[i] + '';
        for(var z = 7 - s.length; z--;)s = '0' + s;
        r += s;
    }
    var j = r.length;
    while(r.charAt(j) === '0')j--;
    var xe = x.e;
    var str = r.slice(0, j + 1 || 1);
    var strL = str.length;
    if (xe > 0) {
        if (++xe > strL) {
            // Append zeros.
            xe -= strL;
            while(xe--)str += '0';
        } else if (xe < strL) str = str.slice(0, xe) + '.' + str.slice(xe);
    }
    // Convert from base 10 (decimal) to base 2
    var arr = [
        0
    ];
    for(var _i2 = 0; _i2 < str.length;){
        var arrL = arr.length;
        while(arrL--)arr[arrL] *= 10;
        arr[0] += parseInt(str.charAt(_i2++)); // convert to int
        for(var _j = 0; _j < arr.length; ++_j)if (arr[_j] > 1) {
            if (arr[_j + 1] === null || arr[_j + 1] === undefined) arr[_j + 1] = 0;
            arr[_j + 1] += arr[_j] >> 1;
            arr[_j] &= 1;
        }
    }
    return arr.reverse();
}
function $189c497109cdf2d3$export$bfcff4501301c191(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error('Integers expected in function bitXor');
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    if (x.isZero()) return y;
    if (y.isZero()) return x;
    if (x.eq(y)) return new BigNumber(0);
    var negOne = new BigNumber(-1);
    if (x.eq(negOne)) return $189c497109cdf2d3$export$2ada53b3c51e9645(y);
    if (y.eq(negOne)) return $189c497109cdf2d3$export$2ada53b3c51e9645(x);
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !y.isFinite()) return negOne;
        return new BigNumber(x.isNegative() === y.isNegative() ? Infinity : -Infinity);
    }
    return $189c497109cdf2d3$export$884842863a0853c4(x, y, function(a, b) {
        return a ^ b;
    });
}
function $189c497109cdf2d3$export$626dff8098a67b4c(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error('Integers expected in function leftShift');
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN() || y.isNegative() && !y.isZero()) return new BigNumber(NaN);
    if (x.isZero() || y.isZero()) return x;
    if (!x.isFinite() && !y.isFinite()) return new BigNumber(NaN);
    // Math.pow(2, y) is fully precise for y < 55, and fast
    if (y.lt(55)) return x.times(Math.pow(2, y.toNumber()) + '');
    return x.times(new BigNumber(2).pow(y));
}
function $189c497109cdf2d3$export$d489c03691bd4cd(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error('Integers expected in function rightArithShift');
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN() || y.isNegative() && !y.isZero()) return new BigNumber(NaN);
    if (x.isZero() || y.isZero()) return x;
    if (!y.isFinite()) {
        if (x.isNegative()) return new BigNumber(-1);
        if (!x.isFinite()) return new BigNumber(NaN);
        return new BigNumber(0);
    }
    // Math.pow(2, y) is fully precise for y < 55, and fast
    if (y.lt(55)) return x.div(Math.pow(2, y.toNumber()) + '').floor();
    return x.div(new BigNumber(2).pow(y)).floor();
}

});

parcelRegister("jbibQ", function(module, exports) {

$parcel$export(module.exports, "bitAndNumber", () => $df6d278cd2f0b570$export$e7607930867bd49a);
$parcel$export(module.exports, "bitNotNumber", () => $df6d278cd2f0b570$export$22a2b2a0351218e7);
$parcel$export(module.exports, "bitOrNumber", () => $df6d278cd2f0b570$export$9aecb772cb5ad1c7);
$parcel$export(module.exports, "bitXorNumber", () => $df6d278cd2f0b570$export$2260a44ec1c987dc);
$parcel$export(module.exports, "leftShiftNumber", () => $df6d278cd2f0b570$export$65c07a47901525ba);
$parcel$export(module.exports, "rightArithShiftNumber", () => $df6d278cd2f0b570$export$b6d96f775be90000);
$parcel$export(module.exports, "rightLogShiftNumber", () => $df6d278cd2f0b570$export$2a8d1e3dcede6e47);

var $6NnhX = parcelRequire("6NnhX");
var $df6d278cd2f0b570$var$n1 = 'number';
var $df6d278cd2f0b570$var$n2 = 'number, number';
function $df6d278cd2f0b570$export$e7607930867bd49a(x, y) {
    if (!(0, $6NnhX.isInteger)(x) || !(0, $6NnhX.isInteger)(y)) throw new Error('Integers expected in function bitAnd');
    return x & y;
}
$df6d278cd2f0b570$export$e7607930867bd49a.signature = $df6d278cd2f0b570$var$n2;
function $df6d278cd2f0b570$export$22a2b2a0351218e7(x) {
    if (!(0, $6NnhX.isInteger)(x)) throw new Error('Integer expected in function bitNot');
    return ~x;
}
$df6d278cd2f0b570$export$22a2b2a0351218e7.signature = $df6d278cd2f0b570$var$n1;
function $df6d278cd2f0b570$export$9aecb772cb5ad1c7(x, y) {
    if (!(0, $6NnhX.isInteger)(x) || !(0, $6NnhX.isInteger)(y)) throw new Error('Integers expected in function bitOr');
    return x | y;
}
$df6d278cd2f0b570$export$9aecb772cb5ad1c7.signature = $df6d278cd2f0b570$var$n2;
function $df6d278cd2f0b570$export$2260a44ec1c987dc(x, y) {
    if (!(0, $6NnhX.isInteger)(x) || !(0, $6NnhX.isInteger)(y)) throw new Error('Integers expected in function bitXor');
    return x ^ y;
}
$df6d278cd2f0b570$export$2260a44ec1c987dc.signature = $df6d278cd2f0b570$var$n2;
function $df6d278cd2f0b570$export$65c07a47901525ba(x, y) {
    if (!(0, $6NnhX.isInteger)(x) || !(0, $6NnhX.isInteger)(y)) throw new Error('Integers expected in function leftShift');
    return x << y;
}
$df6d278cd2f0b570$export$65c07a47901525ba.signature = $df6d278cd2f0b570$var$n2;
function $df6d278cd2f0b570$export$b6d96f775be90000(x, y) {
    if (!(0, $6NnhX.isInteger)(x) || !(0, $6NnhX.isInteger)(y)) throw new Error('Integers expected in function rightArithShift');
    return x >> y;
}
$df6d278cd2f0b570$export$b6d96f775be90000.signature = $df6d278cd2f0b570$var$n2;
function $df6d278cd2f0b570$export$2a8d1e3dcede6e47(x, y) {
    if (!(0, $6NnhX.isInteger)(x) || !(0, $6NnhX.isInteger)(y)) throw new Error('Integers expected in function rightLogShift');
    return x >>> y;
}
$df6d278cd2f0b570$export$2a8d1e3dcede6e47.signature = $df6d278cd2f0b570$var$n2;

});


parcelRegister("j3IMX", function(module, exports) {

$parcel$export(module.exports, "createBitNot", () => $de010a39c567edf8$export$9e7f3c72ca8b5aa);

var $2704b = parcelRequire("2704b");

var $20mkw = parcelRequire("20mkw");

var $dsu7t = parcelRequire("dsu7t");

var $jbibQ = parcelRequire("jbibQ");
var $de010a39c567edf8$var$name = 'bitNot';
var $de010a39c567edf8$var$dependencies = [
    'typed'
];
var $de010a39c567edf8$export$9e7f3c72ca8b5aa = /* #__PURE__ */ (0, $dsu7t.factory)($de010a39c567edf8$var$name, $de010a39c567edf8$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Bitwise NOT value, `~x`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.bitNot(x)
   *
   * Examples:
   *
   *    math.bitNot(1)               // returns number -2
   *
   *    math.bitNot([2, -3, 4])      // returns Array [-3, 2, -5]
   *
   * See also:
   *
   *    bitAnd, bitOr, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | bigint | Array | Matrix} x Value to not
   * @return {number | BigNumber | bigint | Array | Matrix} NOT of `x`
   */ return typed($de010a39c567edf8$var$name, {
        number: (0, $jbibQ.bitNotNumber),
        BigNumber: (0, $2704b.bitNotBigNumber),
        bigint: (x)=>~x,
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});

parcelRegister("5Rpez", function(module, exports) {

$parcel$export(module.exports, "createBitOr", () => $444579eaaa14e064$export$f45a7846535e9b07);

var $2704b = parcelRequire("2704b");

var $dsu7t = parcelRequire("dsu7t");

var $enjrI = parcelRequire("enjrI");

var $ibvF5 = parcelRequire("ibvF5");

var $ahu8B = parcelRequire("ahu8B");

var $6SJnV = parcelRequire("6SJnV");

var $jbibQ = parcelRequire("jbibQ");
var $444579eaaa14e064$var$name = 'bitOr';
var $444579eaaa14e064$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'DenseMatrix',
    'concat'
];
var $444579eaaa14e064$export$f45a7846535e9b07 = /* #__PURE__ */ (0, $dsu7t.factory)($444579eaaa14e064$var$name, $444579eaaa14e064$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo01xDSid = (0, $ahu8B.createMatAlgo01xDSid)({
        typed: typed
    });
    var matAlgo04xSidSid = (0, $ibvF5.createMatAlgo04xSidSid)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo10xSids = (0, $enjrI.createMatAlgo10xSids)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Bitwise OR two values, `x | y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the lowest print base.
   *
   * Syntax:
   *
   *    math.bitOr(x, y)
   *
   * Examples:
   *
   *    math.bitOr(1, 2)               // returns number 3
   *
   *    math.bitOr([1, 2, 3], 4)       // returns Array [5, 6, 7]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | bigint | Array | Matrix} x First value to or
   * @param  {number | BigNumber | bigint | Array | Matrix} y Second value to or
   * @return {number | BigNumber | bigint | Array | Matrix} OR of `x` and `y`
   */ return typed($444579eaaa14e064$var$name, {
        'number, number': (0, $jbibQ.bitOrNumber),
        'BigNumber, BigNumber': (0, $2704b.bitOrBigNumber),
        'bigint, bigint': (x, y)=>x | y
    }, matrixAlgorithmSuite({
        SS: matAlgo04xSidSid,
        DS: matAlgo01xDSid,
        Ss: matAlgo10xSids
    }));
});

});

parcelRegister("69jKF", function(module, exports) {

$parcel$export(module.exports, "createBitXor", () => $47a2e79aeb30277d$export$1cae728fa8e01928);

var $2704b = parcelRequire("2704b");

var $a8bto = parcelRequire("a8bto");

var $6RFQP = parcelRequire("6RFQP");

var $19L2p = parcelRequire("19L2p");

var $dsu7t = parcelRequire("dsu7t");

var $6SJnV = parcelRequire("6SJnV");

var $jbibQ = parcelRequire("jbibQ");
var $47a2e79aeb30277d$var$name = 'bitXor';
var $47a2e79aeb30277d$var$dependencies = [
    'typed',
    'matrix',
    'DenseMatrix',
    'concat',
    'SparseMatrix'
];
var $47a2e79aeb30277d$export$1cae728fa8e01928 = /* #__PURE__ */ (0, $dsu7t.factory)($47a2e79aeb30277d$var$name, $47a2e79aeb30277d$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, DenseMatrix: DenseMatrix, concat: concat, SparseMatrix: SparseMatrix } = _ref;
    var matAlgo03xDSf = (0, $a8bto.createMatAlgo03xDSf)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $6RFQP.createMatAlgo07xSSf)({
        typed: typed,
        SparseMatrix: SparseMatrix
    });
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Bitwise XOR two values, `x ^ y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.bitXor(x, y)
   *
   * Examples:
   *
   *    math.bitXor(1, 2)               // returns number 3
   *
   *    math.bitXor([2, 3, 4], 4)       // returns Array [6, 7, 0]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | bigint | Array | Matrix} x First value to xor
   * @param  {number | BigNumber | bigint | Array | Matrix} y Second value to xor
   * @return {number | BigNumber | bigint | Array | Matrix} XOR of `x` and `y`
   */ return typed($47a2e79aeb30277d$var$name, {
        'number, number': (0, $jbibQ.bitXorNumber),
        'BigNumber, BigNumber': (0, $2704b.bitXor),
        'bigint, bigint': (x, y)=>x ^ y
    }, matrixAlgorithmSuite({
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
});

});
parcelRegister("6RFQP", function(module, exports) {

$parcel$export(module.exports, "createMatAlgo07xSSf", () => $4ff828172dc04be9$export$439c4d7accd2a586);

var $dsu7t = parcelRequire("dsu7t");

var $7asMt = parcelRequire("7asMt");
var $4ff828172dc04be9$var$name = 'matAlgo07xSSf';
var $4ff828172dc04be9$var$dependencies = [
    'typed',
    'SparseMatrix'
];
var $4ff828172dc04be9$export$439c4d7accd2a586 = /* #__PURE__ */ (0, $dsu7t.factory)($4ff828172dc04be9$var$name, $4ff828172dc04be9$var$dependencies, (_ref)=>{
    var { typed: typed, SparseMatrix: SparseMatrix } = _ref;
    /**
  * Iterates over SparseMatrix A and SparseMatrix B items (zero and nonzero) and invokes the callback function f(Aij, Bij).
  * Callback function invoked MxN times.
  *
  * C(i,j) = f(Aij, Bij)
  *
  * @param {Matrix}   a                 The SparseMatrix instance (A)
  * @param {Matrix}   b                 The SparseMatrix instance (B)
  * @param {Function} callback          The f(Aij,Bij) operation to invoke
  *
  * @return {Matrix}                    SparseMatrix (C)
  *
  * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
  */ return function matAlgo07xSSf(a, b, callback) {
        // sparse matrix arrays
        var asize = a._size;
        var adt = a._datatype || a._data === undefined ? a._datatype : a.getDataType();
        var bsize = b._size;
        var bdt = b._datatype || b._data === undefined ? b._datatype : b.getDataType();
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $7asMt.DimensionError)(asize.length, bsize.length);
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        var zero = 0;
        var cf = callback;
        // process data types
        if (typeof adt === 'string' && adt === bdt && adt !== 'mixed') {
            dt = adt;
            zero = typed.convert(0, dt);
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result arrays for sparse format
        var cvalues = [];
        var cindex = [];
        var cptr = new Array(columns + 1).fill(0); // Start with column pointer array
        // workspaces
        var xa = [];
        var xb = [];
        var wa = [];
        var wb = [];
        // loop columns
        for(var j = 0; j < columns; j++){
            var mark = j + 1;
            var nonZeroCount = 0;
            _scatter(a, j, wa, xa, mark);
            _scatter(b, j, wb, xb, mark);
            // loop rows
            for(var i = 0; i < rows; i++){
                var va = wa[i] === mark ? xa[i] : zero;
                var vb = wb[i] === mark ? xb[i] : zero;
                // invoke callback
                var cij = cf(va, vb);
                // Store all non zero and true values
                if (cij !== 0 && cij !== false) {
                    cindex.push(i); // row index
                    cvalues.push(cij); // computed value
                    nonZeroCount++;
                }
            }
            // Update column pointer with cumulative count of non-zero values
            cptr[j + 1] = cptr[j] + nonZeroCount;
        }
        // Return the result as a sparse matrix
        return new SparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    };
    function _scatter(m, j, w, x, mark) {
        // a arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        // loop values in column j
        for(var k = ptr[j], k1 = ptr[j + 1]; k < k1; k++){
            // row
            var i = index[k];
            // update workspace
            w[i] = mark;
            x[i] = values[k];
        }
    }
});

});


parcelRegister("llr5W", function(module, exports) {

$parcel$export(module.exports, "createBoolean", () => $f8a0939789a2b41b$export$3c82aec2d86a5525);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");
var $f8a0939789a2b41b$var$name = 'boolean';
var $f8a0939789a2b41b$var$dependencies = [
    'typed'
];
var $f8a0939789a2b41b$export$3c82aec2d86a5525 = /* #__PURE__ */ (0, $dsu7t.factory)($f8a0939789a2b41b$var$name, $f8a0939789a2b41b$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a boolean or convert a string or number to a boolean.
   * In case of a number, `true` is returned for non-zero numbers, and `false` in
   * case of zero.
   * Strings can be `'true'` or `'false'`, or can contain a number.
   * When value is a matrix, all elements will be converted to boolean.
   *
   * Syntax:
   *
   *    math.boolean(x)
   *
   * Examples:
   *
   *    math.boolean(0)     // returns false
   *    math.boolean(1)     // returns true
   *    math.boolean(-3)     // returns true
   *    math.boolean('true')     // returns true
   *    math.boolean('false')     // returns false
   *    math.boolean([1, 0, 1, 1])     // returns [true, false, true, true]
   *
   * See also:
   *
   *    bignumber, complex, index, matrix, string, unit
   *
   * @param {string | number | boolean | Array | Matrix | null} value  A value of any type
   * @return {boolean | Array | Matrix} The boolean value
   */ return typed($f8a0939789a2b41b$var$name, {
        '': function _() {
            return false;
        },
        boolean: function boolean(x) {
            return x;
        },
        number: function number(x) {
            return !!x;
        },
        null: function _null(x) {
            return false;
        },
        BigNumber: function BigNumber(x) {
            return !x.isZero();
        },
        string: function string(x) {
            // try case insensitive
            var lcase = x.toLowerCase();
            if (lcase === 'true') return true;
            else if (lcase === 'false') return false;
            // test whether value is a valid number
            var num = Number(x);
            if (x !== '' && !isNaN(num)) return !!num;
            throw new Error('Cannot convert "' + x + '" to a boolean');
        },
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});

parcelRegister("cTfT6", function(module, exports) {

$parcel$export(module.exports, "createCatalan", () => $9626f2143873ffcc$export$5a3f7692f3d4dd50);

var $dsu7t = parcelRequire("dsu7t");
var $9626f2143873ffcc$var$name = 'catalan';
var $9626f2143873ffcc$var$dependencies = [
    'typed',
    'addScalar',
    'divideScalar',
    'multiplyScalar',
    'combinations',
    'isNegative',
    'isInteger'
];
var $9626f2143873ffcc$export$5a3f7692f3d4dd50 = /* #__PURE__ */ (0, $dsu7t.factory)($9626f2143873ffcc$var$name, $9626f2143873ffcc$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, combinations: combinations, isNegative: isNegative, isInteger: isInteger } = _ref;
    /**
   * The Catalan Numbers enumerate combinatorial structures of many different types.
   * catalan only takes integer arguments.
   * The following condition must be enforced: n >= 0
   *
   * Syntax:
   *
   *   math.catalan(n)
   *
   * Examples:
   *
   *    math.catalan(3) // returns 5
   *    math.catalan(8) // returns 1430
   *
   * See also:
   *
   *    bellNumbers
   *
   * @param {Number | BigNumber} n    nth Catalan number
   * @return {Number | BigNumber}     Cn(n)
   */ return typed($9626f2143873ffcc$var$name, {
        'number | BigNumber': function number__BigNumber(n) {
            if (!isInteger(n) || isNegative(n)) throw new TypeError('Non-negative integer value expected in function catalan');
            return divideScalar(combinations(multiplyScalar(n, 2), n), addScalar(n, 1));
        }
    });
});

});

parcelRegister("aEgNP", function(module, exports) {

$parcel$export(module.exports, "createCbrt", () => $7c0aac7cb6335b57$export$2103fed9c34b0004);

var $dsu7t = parcelRequire("dsu7t");

var $edQYF = parcelRequire("edQYF");

var $dmcGu = parcelRequire("dmcGu");
var $7c0aac7cb6335b57$var$name = 'cbrt';
var $7c0aac7cb6335b57$var$dependencies = [
    'config',
    'typed',
    'isNegative',
    'unaryMinus',
    'matrix',
    'Complex',
    'BigNumber',
    'Fraction'
];
var $7c0aac7cb6335b57$export$2103fed9c34b0004 = /* #__PURE__ */ (0, $dsu7t.factory)($7c0aac7cb6335b57$var$name, $7c0aac7cb6335b57$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, isNegative: isNegative, unaryMinus: unaryMinus, matrix: matrix, Complex: Complex, BigNumber: BigNumber, Fraction: Fraction } = _ref;
    /**
   * Calculate the cubic root of a value.
   *
   * To avoid confusion with the matrix cube root, this function does not
   * apply to matrices. For a matrix, to take the cube root elementwise,
   * see the examples.
   *
   * Syntax:
   *
   *    math.cbrt(x)
   *    math.cbrt(x, allRoots)
   *
   * Examples:
   *
   *    math.cbrt(27)                  // returns 3
   *    math.cube(3)                   // returns 27
   *    math.cbrt(-64)                 // returns -4
   *    math.cbrt(math.unit('27 m^3')) // returns Unit 3 m
   *    math.map([27, 64, 125], x => math.cbrt(x))       // returns [3, 4, 5]
   *
   *    const x = math.complex('8i')
   *    math.cbrt(x)                   // returns Complex 1.7320508075689 + i
   *    math.cbrt(x, true)             // returns Matrix [
   *                                    //    1.7320508075689 + i
   *                                    //   -1.7320508075689 + i
   *                                    //   -2i
   *                                    // ]
   *
   * See also:
   *
   *    square, sqrt, cube
   *
   * @param {number | BigNumber | Complex | Unit} x
   *            Value for which to calculate the cubic root.
   * @param {boolean} [allRoots]  Optional, false by default. Only applicable
   *            when `x` is a number or complex number. If true, all complex
   *            roots are returned, if false (default) the principal root is
   *            returned.
   * @return {number | BigNumber | Complex | Unit}
   *            Returns the cubic root of `x`
   */ return typed($7c0aac7cb6335b57$var$name, {
        number: (0, $dmcGu.cbrtNumber),
        // note: signature 'number, boolean' is also supported,
        //       created by typed as it knows how to convert number to Complex
        Complex: _cbrtComplex,
        'Complex, boolean': _cbrtComplex,
        BigNumber: function BigNumber(x) {
            return x.cbrt();
        },
        Unit: _cbrtUnit
    });
    /**
   * Calculate the cubic root for a complex number
   * @param {Complex} x
   * @param {boolean} [allRoots]   If true, the function will return an array
   *                               with all three roots. If false or undefined,
   *                               the principal root is returned.
   * @returns {Complex | Array.<Complex> | Matrix.<Complex>} Returns the cubic root(s) of x
   * @private
   */ function _cbrtComplex(x, allRoots) {
        // https://www.wikiwand.com/en/Cube_root#/Complex_numbers
        var arg3 = x.arg() / 3;
        var abs = x.abs();
        // principal root:
        var principal = new Complex((0, $dmcGu.cbrtNumber)(abs), 0).mul(new Complex(0, arg3).exp());
        if (allRoots) {
            var all = [
                principal,
                new Complex((0, $dmcGu.cbrtNumber)(abs), 0).mul(new Complex(0, arg3 + Math.PI * 2 / 3).exp()),
                new Complex((0, $dmcGu.cbrtNumber)(abs), 0).mul(new Complex(0, arg3 - Math.PI * 2 / 3).exp())
            ];
            return config.matrix === 'Array' ? all : matrix(all);
        } else return principal;
    }
    /**
   * Calculate the cubic root for a Unit
   * @param {Unit} x
   * @return {Unit} Returns the cubic root of x
   * @private
   */ function _cbrtUnit(x) {
        if (x.value && (0, $edQYF.isComplex)(x.value)) {
            var result = x.clone();
            result.value = 1.0;
            result = result.pow(1.0 / 3); // Compute the units
            result.value = _cbrtComplex(x.value); // Compute the value
            return result;
        } else {
            var negate = isNegative(x.value);
            if (negate) x.value = unaryMinus(x.value);
            // TODO: create a helper function for this
            var third;
            if ((0, $edQYF.isBigNumber)(x.value)) third = new BigNumber(1).div(3);
            else if ((0, $edQYF.isFraction)(x.value)) third = new Fraction(1, 3);
            else third = 1 / 3;
            var _result = x.pow(third);
            if (negate) _result.value = unaryMinus(_result.value);
            return _result;
        }
    }
});

});

parcelRegister("6M43M", function(module, exports) {

$parcel$export(module.exports, "createCeil", () => $4eea60005fd70d86$export$bab247d909829ddf);

var $cIZs1 = parcelRequire("cIZs1");

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");

var $6NnhX = parcelRequire("6NnhX");

var $i7dfO = parcelRequire("i7dfO");

var $52JKA = parcelRequire("52JKA");

var $19L2p = parcelRequire("19L2p");

var $dK2sh = parcelRequire("dK2sh");
var $4eea60005fd70d86$var$name = 'ceil';
var $4eea60005fd70d86$var$dependencies = [
    'typed',
    'config',
    'round',
    'matrix',
    'equalScalar',
    'zeros',
    'DenseMatrix'
];
var $4eea60005fd70d86$var$bigTen = new (0, (/*@__PURE__*/$parcel$interopDefault($cIZs1)))(10);
var $4eea60005fd70d86$export$7f32b339ed8a324b = /* #__PURE__ */ (0, $dsu7t.factory)($4eea60005fd70d86$var$name, [
    'typed',
    'config',
    'round'
], (_ref)=>{
    var { typed: typed, config: config, round: round } = _ref;
    function _ceilNumber(x) {
        // See ./floor.js _floorNumber for rationale here
        var c = Math.ceil(x);
        var r = round(x);
        if (c === r) return c;
        if ((0, $6NnhX.nearlyEqual)(x, r, config.relTol, config.absTol) && !(0, $6NnhX.nearlyEqual)(x, c, config.relTol, config.absTol)) return r;
        return c;
    }
    return typed($4eea60005fd70d86$var$name, {
        number: _ceilNumber,
        'number, number': function number_number(x, n) {
            if (!(0, $6NnhX.isInteger)(n)) throw new RangeError('number of decimals in function ceil must be an integer');
            if (n < 0 || n > 15) throw new RangeError('number of decimals in ceil number must be in range 0-15');
            var shift = 10 ** n;
            return _ceilNumber(x * shift) / shift;
        }
    });
});
var $4eea60005fd70d86$export$bab247d909829ddf = /* #__PURE__ */ (0, $dsu7t.factory)($4eea60005fd70d86$var$name, $4eea60005fd70d86$var$dependencies, (_ref2)=>{
    var { typed: typed, config: config, round: round, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref2;
    var matAlgo11xS0s = (0, $52JKA.createMatAlgo11xS0s)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo14xDs = (0, $dK2sh.createMatAlgo14xDs)({
        typed: typed
    });
    var ceilNumber = $4eea60005fd70d86$export$7f32b339ed8a324b({
        typed: typed,
        config: config,
        round: round
    });
    function _bigCeil(x) {
        // see ./floor.js _floorNumber for rationale
        var bne = (a, b)=>(0, $i7dfO.nearlyEqual)(a, b, config.relTol, config.absTol);
        var c = x.ceil();
        var r = round(x);
        if (c.eq(r)) return c;
        if (bne(x, r) && !bne(x, c)) return r;
        return c;
    }
    /**
   * Round a value towards plus infinity
   * If `x` is complex, both real and imaginary part are rounded towards plus infinity.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.ceil(x)
   *    math.ceil(x, n)
   *    math.ceil(unit, valuelessUnit)
   *    math.ceil(unit, n, valuelessUnit)
   *
   * Examples:
   *
   *    math.ceil(3.2)               // returns number 4
   *    math.ceil(3.8)               // returns number 4
   *    math.ceil(-4.2)              // returns number -4
   *    math.ceil(-4.7)              // returns number -4
   *
   *    math.ceil(3.212, 2)          // returns number 3.22
   *    math.ceil(3.288, 2)          // returns number 3.29
   *    math.ceil(-4.212, 2)         // returns number -4.21
   *    math.ceil(-4.782, 2)         // returns number -4.78
   *
   *    const c = math.complex(3.24, -2.71)
   *    math.ceil(c)                 // returns Complex 4 - 2i
   *    math.ceil(c, 1)              // returns Complex 3.3 - 2.7i
   *
   *    const unit = math.unit('3.241 cm')
   *    const cm = math.unit('cm')
   *    const mm = math.unit('mm')
   *    math.ceil(unit, 1, cm)      // returns Unit 3.3 cm
   *    math.ceil(unit, 1, mm)      // returns Unit 32.5 mm
   *
   *    math.ceil([3.2, 3.8, -4.7])  // returns Array [4, 4, -4]
   *    math.ceil([3.21, 3.82, -4.71], 1)  // returns Array [3.3, 3.9, -4.7]
   *
   * See also:
   *
   *    floor, fix, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x  Value to be rounded
   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
   * @param  {Unit} [valuelessUnit]                                        A valueless unit
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Rounded value
   */ return typed('ceil', {
        number: ceilNumber.signatures.number,
        'number,number': ceilNumber.signatures['number,number'],
        Complex: function Complex(x) {
            return x.ceil();
        },
        'Complex, number': function Complex_number(x, n) {
            return x.ceil(n);
        },
        'Complex, BigNumber': function Complex_BigNumber(x, n) {
            return x.ceil(n.toNumber());
        },
        BigNumber: _bigCeil,
        'BigNumber, BigNumber': function BigNumber_BigNumber(x, n) {
            var shift = $4eea60005fd70d86$var$bigTen.pow(n);
            return _bigCeil(x.mul(shift)).div(shift);
        },
        bigint: (b)=>b,
        'bigint, number': (b, _dummy)=>b,
        'bigint, BigNumber': (b, _dummy)=>b,
        Fraction: function Fraction(x) {
            return x.ceil();
        },
        'Fraction, number': function Fraction_number(x, n) {
            return x.ceil(n);
        },
        'Fraction, BigNumber': function Fraction_BigNumber(x, n) {
            return x.ceil(n.toNumber());
        },
        'Unit, number, Unit': typed.referToSelf((self)=>function(x, n, unit) {
                var valueless = x.toNumeric(unit);
                return unit.multiply(self(valueless, n));
            }),
        'Unit, BigNumber, Unit': typed.referToSelf((self)=>(x, n, unit)=>self(x, n.toNumber(), unit)),
        'Array | Matrix, number | BigNumber, Unit': typed.referToSelf((self)=>(x, n, unit)=>{
                // deep map collection, skip zeros since ceil(0) = 0
                return (0, $20mkw.deepMap)(x, (value)=>self(value, n, unit), true);
            }),
        'Array | Matrix | Unit, Unit': typed.referToSelf((self)=>(x, unit)=>self(x, 0, unit)),
        'Array | Matrix': typed.referToSelf((self)=>(x)=>{
                // deep map collection, skip zeros since ceil(0) = 0
                return (0, $20mkw.deepMap)(x, self, true);
            }),
        'Array, number | BigNumber': typed.referToSelf((self)=>(x, n)=>{
                // deep map collection, skip zeros since ceil(0) = 0
                return (0, $20mkw.deepMap)(x, (i)=>self(i, n), true);
            }),
        'SparseMatrix, number | BigNumber': typed.referToSelf((self)=>(x, y)=>{
                return matAlgo11xS0s(x, y, self, false);
            }),
        'DenseMatrix, number | BigNumber': typed.referToSelf((self)=>(x, y)=>{
                return matAlgo14xDs(x, y, self, false);
            }),
        'number | Complex | Fraction | BigNumber, Array': typed.referToSelf((self)=>(x, y)=>{
                // use matrix implementation
                return matAlgo14xDs(matrix(y), x, self, true).valueOf();
            }),
        'number | Complex | Fraction | BigNumber, Matrix': typed.referToSelf((self)=>(x, y)=>{
                if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
                if (y.storage() === 'dense') return matAlgo14xDs(y, x, self, true);
                return matAlgo12xSfs(y, x, self, true);
            })
    });
});

});
parcelRegister("i7dfO", function(module, exports) {

$parcel$export(module.exports, "nearlyEqual", () => $d30329701f429cee$export$6f3989c6ecc04081);
/**
 * Compares two BigNumbers.
 * @param {BigNumber} a - First value to compare
 * @param {BigNumber} b - Second value to compare
 * @param {number} [relTol=1e-09] - The relative tolerance, indicating the maximum allowed difference relative to the larger absolute value. Must be greater than 0.
 * @param {number} [absTol=0] - The minimum absolute tolerance, useful for comparisons near zero. Must be at least 0.
 * @returns {boolean} whether the two numbers are nearly equal
 * @throws {Error} If `relTol` is less than or equal to 0.
 * @throws {Error} If `absTol` is less than 0.
 *
 * @example
 * nearlyEqual(1.000000001, 1.0, 1e-9);            // true
 * nearlyEqual(1.000000002, 1.0, 0);            // false
 * nearlyEqual(1.0, 1.009, undefined, 0.02);       // true
 * nearlyEqual(0.000000001, 0.0, undefined, 1e-8); // true
 */ function $d30329701f429cee$export$6f3989c6ecc04081(a, b) {
    var relTol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e-9;
    var absTol = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    if (relTol <= 0) throw new Error('Relative tolerance must be greater than 0');
    if (absTol < 0) throw new Error('Absolute tolerance must be at least 0');
    // NaN
    if (a.isNaN() || b.isNaN()) return false;
    if (!a.isFinite() || !b.isFinite()) return a.eq(b);
    // use "==" operator, handles infinities
    if (a.eq(b)) return true;
    // abs(a-b) <= max(relTol * max(abs(a), abs(b)), absTol)
    return a.minus(b).abs().lte(a.constructor.max(a.constructor.max(a.abs(), b.abs()).mul(relTol), absTol));
}

});


parcelRegister("bZorp", function(module, exports) {

$parcel$export(module.exports, "createClone", () => $8ba859aea8d5c4a3$export$39ad70de4044028a);

var $9v8q6 = parcelRequire("9v8q6");

var $dsu7t = parcelRequire("dsu7t");
var $8ba859aea8d5c4a3$var$name = 'clone';
var $8ba859aea8d5c4a3$var$dependencies = [
    'typed'
];
var $8ba859aea8d5c4a3$export$39ad70de4044028a = /* #__PURE__ */ (0, $dsu7t.factory)($8ba859aea8d5c4a3$var$name, $8ba859aea8d5c4a3$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Clone an object. Will make a deep copy of the data.
   *
   * Syntax:
   *
   *     math.clone(x)
   *
   * Examples:
   *
   *    math.clone(3.5)                   // returns number 3.5
   *    math.clone(math.complex('2-4i'))  // returns Complex 2 - 4i
   *    math.clone(math.unit(45, 'deg'))  // returns Unit 45 deg
   *    math.clone([[1, 2], [3, 4]])      // returns Array [[1, 2], [3, 4]]
   *    math.clone("hello world")         // returns string "hello world"
   *
   * @param {*} x   Object to be cloned
   * @return {*} A clone of object x
   */ return typed($8ba859aea8d5c4a3$var$name, {
        any: (0, $9v8q6.clone)
    });
});

});

parcelRegister("dPWNw", function(module, exports) {

$parcel$export(module.exports, "createColumn", () => $029982ac8fd340eb$export$1bfa986e9c92c0b5);

var $dsu7t = parcelRequire("dsu7t");

var $edQYF = parcelRequire("edQYF");

var $9v8q6 = parcelRequire("9v8q6");

var $d80Xp = parcelRequire("d80Xp");
var $029982ac8fd340eb$var$name = 'column';
var $029982ac8fd340eb$var$dependencies = [
    'typed',
    'Index',
    'matrix',
    'range'
];
var $029982ac8fd340eb$export$1bfa986e9c92c0b5 = /* #__PURE__ */ (0, $dsu7t.factory)($029982ac8fd340eb$var$name, $029982ac8fd340eb$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index, matrix: matrix, range: range } = _ref;
    /**
   * Return a column from a Matrix.
   *
   * Syntax:
   *
   *     math.column(value, index)
   *
   * Example:
   *
   *     // get a column
   *     const d = [[1, 2], [3, 4]]
   *     math.column(d, 1) // returns [[2], [4]]
   *
   * See also:
   *
   *     row
   *
   * @param {Array | Matrix } value   An array or matrix
   * @param {number} column           The index of the column
   * @return {Array | Matrix}         The retrieved column
   */ return typed($029982ac8fd340eb$var$name, {
        'Matrix, number': _column,
        'Array, number': function Array_number(value, column) {
            return _column(matrix((0, $9v8q6.clone)(value)), column).valueOf();
        }
    });
    /**
   * Retrieve a column of a matrix
   * @param {Matrix } value  A matrix
   * @param {number} column  The index of the column
   * @return {Matrix}        The retrieved column
   */ function _column(value, column) {
        // check dimensions
        if (value.size().length !== 2) throw new Error('Only two dimensional matrix is supported');
        (0, $d80Xp.validateIndex)(column, value.size()[1]);
        var rowRange = range(0, value.size()[0]);
        var index = new Index(rowRange, column);
        var result = value.subset(index);
        return (0, $edQYF.isMatrix)(result) ? result : matrix([
            [
                result
            ]
        ]);
    }
});

});

parcelRegister("fqPNj", function(module, exports) {

$parcel$export(module.exports, "createCombinations", () => $b3c1760304de360c$export$63e3129a196da23d);

var $dsu7t = parcelRequire("dsu7t");

var $4tYXP = parcelRequire("4tYXP");
var $b3c1760304de360c$var$name = 'combinations';
var $b3c1760304de360c$var$dependencies = [
    'typed'
];
var $b3c1760304de360c$export$63e3129a196da23d = /* #__PURE__ */ (0, $dsu7t.factory)($b3c1760304de360c$var$name, $b3c1760304de360c$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the number of ways of picking `k` unordered outcomes from `n`
   * possibilities.
   *
   * Combinations only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *     math.combinations(n, k)
   *
   * Examples:
   *
   *    math.combinations(7, 5) // returns 21
   *
   * See also:
   *
   *    combinationsWithRep, permutations, factorial
   *
   * @param {number | BigNumber} n    Total number of objects in the set
   * @param {number | BigNumber} k    Number of objects in the subset
   * @return {number | BigNumber}     Number of possible combinations.
   */ return typed($b3c1760304de360c$var$name, {
        'number, number': (0, $4tYXP.combinationsNumber),
        'BigNumber, BigNumber': function BigNumber_BigNumber(n, k) {
            var BigNumber = n.constructor;
            var result, i;
            var nMinusk = n.minus(k);
            var one = new BigNumber(1);
            if (!$b3c1760304de360c$var$isPositiveInteger(n) || !$b3c1760304de360c$var$isPositiveInteger(k)) throw new TypeError('Positive integer value expected in function combinations');
            if (k.gt(n)) throw new TypeError('k must be less than n in function combinations');
            result = one;
            if (k.lt(nMinusk)) for(i = one; i.lte(nMinusk); i = i.plus(one))result = result.times(k.plus(i)).dividedBy(i);
            else for(i = one; i.lte(k); i = i.plus(one))result = result.times(nMinusk.plus(i)).dividedBy(i);
            return result;
        }
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $b3c1760304de360c$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}

});
parcelRegister("4tYXP", function(module, exports) {

$parcel$export(module.exports, "combinationsNumber", () => $3439290ce1d2987f$export$2a122d28e37477a2);

var $6NnhX = parcelRequire("6NnhX");

var $kfXQy = parcelRequire("kfXQy");
function $3439290ce1d2987f$export$2a122d28e37477a2(n, k) {
    if (!(0, $6NnhX.isInteger)(n) || n < 0) throw new TypeError('Positive integer value expected in function combinations');
    if (!(0, $6NnhX.isInteger)(k) || k < 0) throw new TypeError('Positive integer value expected in function combinations');
    if (k > n) throw new TypeError('k must be less than or equal to n');
    var nMinusk = n - k;
    var answer = 1;
    var firstnumerator = k < nMinusk ? nMinusk + 1 : k + 1;
    var nextdivisor = 2;
    var lastdivisor = k < nMinusk ? k : nMinusk;
    // balance multiplications and divisions to try to keep intermediate values
    // in exact-integer range as long as possible
    for(var nextnumerator = firstnumerator; nextnumerator <= n; ++nextnumerator){
        answer *= nextnumerator;
        while(nextdivisor <= lastdivisor && answer % nextdivisor === 0){
            answer /= nextdivisor;
            ++nextdivisor;
        }
    }
    // for big n, k, floating point may have caused weirdness in remainder
    if (nextdivisor <= lastdivisor) answer /= (0, $kfXQy.product)(nextdivisor, lastdivisor);
    return answer;
}
$3439290ce1d2987f$export$2a122d28e37477a2.signature = 'number, number';

});
parcelRegister("kfXQy", function(module, exports) {

$parcel$export(module.exports, "product", () => $ebf3a1a9acc200d8$export$dbd0f18357df1ddd);
/** @param {number} i
 *  @param {number} n
 *  @returns {number} product of i to n
 */ function $ebf3a1a9acc200d8$export$dbd0f18357df1ddd(i, n) {
    if (n < i) return 1;
    if (n === i) return n;
    var half = n + i >> 1; // divide (n + i) by 2 and truncate to integer
    return $ebf3a1a9acc200d8$export$dbd0f18357df1ddd(i, half) * $ebf3a1a9acc200d8$export$dbd0f18357df1ddd(half + 1, n);
}

});



parcelRegister("ikYTC", function(module, exports) {

$parcel$export(module.exports, "createCombinationsWithRep", () => $d59954f2e6055fe5$export$4bdc90311ec7c1dd);

var $dsu7t = parcelRequire("dsu7t");

var $6NnhX = parcelRequire("6NnhX");

var $kfXQy = parcelRequire("kfXQy");
var $d59954f2e6055fe5$var$name = 'combinationsWithRep';
var $d59954f2e6055fe5$var$dependencies = [
    'typed'
];
var $d59954f2e6055fe5$export$4bdc90311ec7c1dd = /* #__PURE__ */ (0, $dsu7t.factory)($d59954f2e6055fe5$var$name, $d59954f2e6055fe5$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the number of ways of picking `k` unordered outcomes from `n`
   * possibilities, allowing individual outcomes to be repeated more than once.
   *
   * CombinationsWithRep only takes integer arguments.
   * The following condition must be enforced: k <= n + k -1.
   *
   * Syntax:
   *
   *     math.combinationsWithRep(n, k)
   *
   * Examples:
   *
   *    math.combinationsWithRep(7, 5) // returns 462
   *
   * See also:
   *
   *    combinations, permutations, factorial
   *
   * @param {number | BigNumber} n    Total number of objects in the set
   * @param {number | BigNumber} k    Number of objects in the subset
   * @return {number | BigNumber}     Number of possible combinations with replacement.
   */ return typed($d59954f2e6055fe5$var$name, {
        'number, number': function number_number(n, k) {
            if (!(0, $6NnhX.isInteger)(n) || n < 0) throw new TypeError('Positive integer value expected in function combinationsWithRep');
            if (!(0, $6NnhX.isInteger)(k) || k < 0) throw new TypeError('Positive integer value expected in function combinationsWithRep');
            if (n < 1) throw new TypeError('k must be less than or equal to n + k - 1');
            if (k < n - 1) {
                var _prodrange = (0, $kfXQy.product)(n, n + k - 1);
                return _prodrange / (0, $kfXQy.product)(1, k);
            }
            var prodrange = (0, $kfXQy.product)(k + 1, n + k - 1);
            return prodrange / (0, $kfXQy.product)(1, n - 1);
        },
        'BigNumber, BigNumber': function BigNumber_BigNumber(n, k) {
            var BigNumber = n.constructor;
            var result, i;
            var one = new BigNumber(1);
            var nMinusOne = n.minus(one);
            if (!$d59954f2e6055fe5$var$isPositiveInteger(n) || !$d59954f2e6055fe5$var$isPositiveInteger(k)) throw new TypeError('Positive integer value expected in function combinationsWithRep');
            if (n.lt(one)) throw new TypeError('k must be less than or equal to n + k - 1 in function combinationsWithRep');
            result = one;
            if (k.lt(nMinusOne)) for(i = one; i.lte(nMinusOne); i = i.plus(one))result = result.times(k.plus(i)).dividedBy(i);
            else for(i = one; i.lte(k); i = i.plus(one))result = result.times(nMinusOne.plus(i)).dividedBy(i);
            return result;
        }
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $d59954f2e6055fe5$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}

});

parcelRegister("lq51c", function(module, exports) {

$parcel$export(module.exports, "createCompare", () => $f97feb3dfb0cf5e6$export$a6e723c0e3b918d4);

var $i7dfO = parcelRequire("i7dfO");

var $6NnhX = parcelRequire("6NnhX");

var $dsu7t = parcelRequire("dsu7t");

var $a8bto = parcelRequire("a8bto");

var $19L2p = parcelRequire("19L2p");

var $g1nxb = parcelRequire("g1nxb");

var $6SJnV = parcelRequire("6SJnV");

var $33RBM = parcelRequire("33RBM");
var $f97feb3dfb0cf5e6$var$name = 'compare';
var $f97feb3dfb0cf5e6$var$dependencies = [
    'typed',
    'config',
    'matrix',
    'equalScalar',
    'BigNumber',
    'Fraction',
    'DenseMatrix',
    'concat'
];
var $f97feb3dfb0cf5e6$export$a6e723c0e3b918d4 = /* #__PURE__ */ (0, $dsu7t.factory)($f97feb3dfb0cf5e6$var$name, $f97feb3dfb0cf5e6$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, equalScalar: equalScalar, matrix: matrix, BigNumber: BigNumber, Fraction: Fraction, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo03xDSf = (0, $a8bto.createMatAlgo03xDSf)({
        typed: typed
    });
    var matAlgo05xSfSf = (0, $g1nxb.createMatAlgo05xSfSf)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var compareUnits = (0, $33RBM.createCompareUnits)({
        typed: typed
    });
    /**
   * Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.
   *
   * x and y are considered equal when the relative difference between x and y
   * is smaller than the configured absTol and relTol. The function cannot be used to
   * compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.compare(x, y)
   *
   * Examples:
   *
   *    math.compare(6, 1)           // returns 1
   *    math.compare(2, 3)           // returns -1
   *    math.compare(7, 7)           // returns 0
   *    math.compare('10', '2')      // returns 1
   *    math.compare('1000', '1e3')  // returns 0
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('40 mm')
   *    math.compare(a, b)           // returns 1
   *
   *    math.compare(2, [1, 2, 3])   // returns [1, 0, -1]
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, larger, largerEq, compareNatural, compareText
   *
   * @param  {number | BigNumber | bigint | Fraction | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | bigint | Fraction | Unit | string | Array | Matrix} y Second value to compare
   * @return {number | BigNumber | bigint | Fraction | Array | Matrix} Returns the result of the comparison:
   *                                                          1 when x > y, -1 when x < y, and 0 when x == y.
   */ return typed($f97feb3dfb0cf5e6$var$name, $f97feb3dfb0cf5e6$export$e744cf3e2e3d6926({
        typed: typed,
        config: config
    }), {
        'boolean, boolean': function boolean_boolean(x, y) {
            return x === y ? 0 : x > y ? 1 : -1;
        },
        'BigNumber, BigNumber': function BigNumber_BigNumber(x, y) {
            return (0, $i7dfO.nearlyEqual)(x, y, config.relTol, config.absTol) ? new BigNumber(0) : new BigNumber(x.cmp(y));
        },
        'bigint, bigint': function bigint_bigint(x, y) {
            return x === y ? 0n : x > y ? 1n : -1n;
        },
        'Fraction, Fraction': function Fraction_Fraction(x, y) {
            return new Fraction(x.compare(y));
        },
        'Complex, Complex': function Complex_Complex() {
            throw new TypeError('No ordering relation is defined for complex numbers');
        }
    }, compareUnits, matrixAlgorithmSuite({
        SS: matAlgo05xSfSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
});
var $f97feb3dfb0cf5e6$export$e744cf3e2e3d6926 = /* #__PURE__ */ (0, $dsu7t.factory)($f97feb3dfb0cf5e6$var$name, [
    'typed',
    'config'
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($f97feb3dfb0cf5e6$var$name, {
        'number, number': function number_number(x, y) {
            return (0, $6NnhX.nearlyEqual)(x, y, config.relTol, config.absTol) ? 0 : x > y ? 1 : -1;
        }
    });
});

});
parcelRegister("g1nxb", function(module, exports) {

$parcel$export(module.exports, "createMatAlgo05xSfSf", () => $ba9efebb026a484d$export$a0ee15a3591ad1a);

var $dsu7t = parcelRequire("dsu7t");

var $7asMt = parcelRequire("7asMt");
var $ba9efebb026a484d$var$name = 'matAlgo05xSfSf';
var $ba9efebb026a484d$var$dependencies = [
    'typed',
    'equalScalar'
];
var $ba9efebb026a484d$export$a0ee15a3591ad1a = /* #__PURE__ */ (0, $dsu7t.factory)($ba9efebb026a484d$var$name, $ba9efebb026a484d$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 || B(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function matAlgo05xSfSf(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype || a._data === undefined ? a._datatype : a.getDataType();
        // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype || b._data === undefined ? b._datatype : b.getDataType();
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $7asMt.DimensionError)(asize.length, bsize.length);
        // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === 'string' && adt === bdt && adt !== 'mixed') {
            // datatype
            dt = adt;
            // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = [];
        // workspaces
        var xa = cvalues ? [] : undefined;
        var xb = cvalues ? [] : undefined;
        // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = [];
        // vars
        var i, j, k, k1;
        // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length;
            // columns mark
            var mark = j + 1;
            // loop values A(:,j)
            for(k = aptr[j], k1 = aptr[j + 1]; k < k1; k++){
                // row
                i = aindex[k];
                // push index
                cindex.push(i);
                // update workspace
                wa[i] = mark;
                // check we need to process values
                if (xa) xa[i] = avalues[k];
            }
            // loop values B(:,j)
            for(k = bptr[j], k1 = bptr[j + 1]; k < k1; k++){
                // row
                i = bindex[k];
                // check row existed in A
                if (wa[i] !== mark) // push index
                cindex.push(i);
                // update workspace
                wb[i] = mark;
                // check we need to process values
                if (xb) xb[i] = bvalues[k];
            }
            // check we need to process values (non pattern matrix)
            if (cvalues) {
                // initialize first index in j
                k = cptr[j];
                // loop index in j
                while(k < cindex.length){
                    // row
                    i = cindex[k];
                    // marks
                    var wai = wa[i];
                    var wbi = wb[i];
                    // check Aij or Bij are nonzero
                    if (wai === mark || wbi === mark) {
                        // matrix values @ i,j
                        var va = wai === mark ? xa[i] : zero;
                        var vb = wbi === mark ? xb[i] : zero;
                        // Cij
                        var vc = cf(va, vb);
                        // check for zero
                        if (!eq(vc, zero)) {
                            // push value
                            cvalues.push(vc);
                            // increment pointer
                            k++;
                        } else // remove value @ i, do not increment pointer
                        cindex.splice(k, 1);
                    }
                }
            }
        }
        // update cptr
        cptr[columns] = cindex.length;
        // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    };
});

});

parcelRegister("33RBM", function(module, exports) {

$parcel$export(module.exports, "createCompareUnits", () => $23ab3c6d0876794d$export$f15f03c51630bb25);

var $dsu7t = parcelRequire("dsu7t");
var $23ab3c6d0876794d$export$f15f03c51630bb25 = /* #__PURE__ */ (0, $dsu7t.factory)('compareUnits', [
    'typed'
], (_ref)=>{
    var { typed: typed } = _ref;
    return {
        'Unit, Unit': typed.referToSelf((self)=>(x, y)=>{
                if (!x.equalBase(y)) throw new Error('Cannot compare units with different base');
                return typed.find(self, [
                    x.valueType(),
                    y.valueType()
                ])(x.value, y.value);
            })
    };
});

});


parcelRegister("i65lC", function(module, exports) {

$parcel$export(module.exports, "createCompareNatural", () => $d2ccef7f0c3c0f4b$export$ac9dd39e43534605);

var $e0NnZ = parcelRequire("e0NnZ");

var $edQYF = parcelRequire("edQYF");

var $dsu7t = parcelRequire("dsu7t");
var $d2ccef7f0c3c0f4b$var$name = 'compareNatural';
var $d2ccef7f0c3c0f4b$var$dependencies = [
    'typed',
    'compare'
];
var $d2ccef7f0c3c0f4b$export$ac9dd39e43534605 = /* #__PURE__ */ (0, $dsu7t.factory)($d2ccef7f0c3c0f4b$var$name, $d2ccef7f0c3c0f4b$var$dependencies, (_ref)=>{
    var { typed: typed, compare: compare } = _ref;
    var compareBooleans = compare.signatures['boolean,boolean'];
    /**
   * Compare two values of any type in a deterministic, natural way.
   *
   * For numeric values, the function works the same as `math.compare`.
   * For types of values that can't be compared mathematically,
   * the function compares in a natural way.
   *
   * For numeric values, x and y are considered equal when the relative
   * difference between x and y is smaller than the configured relTol and absTol.
   * The function cannot be used to compare values smaller than
   * approximately 2.22e-16.
   *
   * For Complex numbers, first the real parts are compared. If equal,
   * the imaginary parts are compared.
   *
   * Strings are compared with a natural sorting algorithm, which
   * orders strings in a "logic" way following some heuristics.
   * This differs from the function `compare`, which converts the string
   * into a numeric value and compares that. The function `compareText`
   * on the other hand compares text lexically.
   *
   * Arrays and Matrices are compared value by value until there is an
   * unequal pair of values encountered. Objects are compared by sorted
   * keys until the keys or their values are unequal.
   *
   * Syntax:
   *
   *    math.compareNatural(x, y)
   *
   * Examples:
   *
   *    math.compareNatural(6, 1)              // returns 1
   *    math.compareNatural(2, 3)              // returns -1
   *    math.compareNatural(7, 7)              // returns 0
   *
   *    math.compareNatural('10', '2')         // returns 1
   *    math.compareText('10', '2')            // returns -1
   *    math.compare('10', '2')                // returns 1
   *
   *    math.compareNatural('Answer: 10', 'Answer: 2') // returns 1
   *    math.compareText('Answer: 10', 'Answer: 2')    // returns -1
   *    math.compare('Answer: 10', 'Answer: 2')
   *        // Error: Cannot convert "Answer: 10" to a number
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('40 mm')
   *    math.compareNatural(a, b)              // returns 1
   *
   *    const c = math.complex('2 + 3i')
   *    const d = math.complex('2 + 4i')
   *    math.compareNatural(c, d)              // returns -1
   *
   *    math.compareNatural([1, 2, 4], [1, 2, 3]) // returns 1
   *    math.compareNatural([1, 2, 3], [1, 2])    // returns 1
   *    math.compareNatural([1, 5], [1, 2, 3])    // returns 1
   *    math.compareNatural([1, 2], [1, 2])       // returns 0
   *
   *    math.compareNatural({a: 2}, {a: 4})       // returns -1
   *
   * See also:
   *
   *    compare, compareText
   *
   * @param  {*} x First value to compare
   * @param  {*} y Second value to compare
   * @return {number} Returns the result of the comparison:
   *                  1 when x > y, -1 when x < y, and 0 when x == y.
   */ return typed($d2ccef7f0c3c0f4b$var$name, {
        'any, any': _compareNatural
    }); // just to check # args
    function _compareNatural(x, y) {
        var typeX = (0, $edQYF.typeOf)(x);
        var typeY = (0, $edQYF.typeOf)(y);
        var c;
        // numeric types
        if ((typeX === 'number' || typeX === 'BigNumber' || typeX === 'Fraction') && (typeY === 'number' || typeY === 'BigNumber' || typeY === 'Fraction')) {
            c = compare(x, y);
            if (c.toString() !== '0') // c can be number, BigNumber, or Fraction
            return c > 0 ? 1 : -1; // return a number
            else return (0, (/*@__PURE__*/$parcel$interopDefault($e0NnZ)))(typeX, typeY);
        }
        // matrix types
        var matTypes = [
            'Array',
            'DenseMatrix',
            'SparseMatrix'
        ];
        if (matTypes.includes(typeX) || matTypes.includes(typeY)) {
            c = compareMatricesAndArrays(_compareNatural, x, y);
            if (c !== 0) return c;
            else return (0, (/*@__PURE__*/$parcel$interopDefault($e0NnZ)))(typeX, typeY);
        }
        // in case of different types, order by name of type, i.e. 'BigNumber' < 'Complex'
        if (typeX !== typeY) return (0, (/*@__PURE__*/$parcel$interopDefault($e0NnZ)))(typeX, typeY);
        if (typeX === 'Complex') return $d2ccef7f0c3c0f4b$var$compareComplexNumbers(x, y);
        if (typeX === 'Unit') {
            if (x.equalBase(y)) return _compareNatural(x.value, y.value);
            // compare by units
            return compareArrays(_compareNatural, x.formatUnits(), y.formatUnits());
        }
        if (typeX === 'boolean') return compareBooleans(x, y);
        if (typeX === 'string') return (0, (/*@__PURE__*/$parcel$interopDefault($e0NnZ)))(x, y);
        if (typeX === 'Object') return compareObjects(_compareNatural, x, y);
        if (typeX === 'null') return 0;
        if (typeX === 'undefined') return 0;
        // this should not occur...
        throw new TypeError('Unsupported type of value "' + typeX + '"');
    }
    /**
   * Compare mixed matrix/array types, by converting to same-shaped array.
   * This comparator is non-deterministic regarding input types.
   * @param {Array | SparseMatrix | DenseMatrix | *} x
   * @param {Array | SparseMatrix | DenseMatrix | *} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareMatricesAndArrays(compareNatural, x, y) {
        if ((0, $edQYF.isSparseMatrix)(x) && (0, $edQYF.isSparseMatrix)(y)) return compareArrays(compareNatural, x.toJSON().values, y.toJSON().values);
        if ((0, $edQYF.isSparseMatrix)(x)) // note: convert to array is expensive
        return compareMatricesAndArrays(compareNatural, x.toArray(), y);
        if ((0, $edQYF.isSparseMatrix)(y)) // note: convert to array is expensive
        return compareMatricesAndArrays(compareNatural, x, y.toArray());
        // convert DenseArray into Array
        if ((0, $edQYF.isDenseMatrix)(x)) return compareMatricesAndArrays(compareNatural, x.toJSON().data, y);
        if ((0, $edQYF.isDenseMatrix)(y)) return compareMatricesAndArrays(compareNatural, x, y.toJSON().data);
        // convert scalars to array
        if (!Array.isArray(x)) return compareMatricesAndArrays(compareNatural, [
            x
        ], y);
        if (!Array.isArray(y)) return compareMatricesAndArrays(compareNatural, x, [
            y
        ]);
        return compareArrays(compareNatural, x, y);
    }
    /**
   * Compare two Arrays
   *
   * - First, compares value by value
   * - Next, if all corresponding values are equal,
   *   look at the length: longest array will be considered largest
   *
   * @param {Array} x
   * @param {Array} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareArrays(compareNatural, x, y) {
        // compare each value
        for(var i = 0, ii = Math.min(x.length, y.length); i < ii; i++){
            var v = compareNatural(x[i], y[i]);
            if (v !== 0) return v;
        }
        // compare the size of the arrays
        if (x.length > y.length) return 1;
        if (x.length < y.length) return -1;
        // both Arrays have equal size and content
        return 0;
    }
    /**
   * Compare two objects
   *
   * - First, compare sorted property names
   * - Next, compare the property values
   *
   * @param {Object} x
   * @param {Object} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareObjects(compareNatural, x, y) {
        var keysX = Object.keys(x);
        var keysY = Object.keys(y);
        // compare keys
        keysX.sort((0, (/*@__PURE__*/$parcel$interopDefault($e0NnZ))));
        keysY.sort((0, (/*@__PURE__*/$parcel$interopDefault($e0NnZ))));
        var c = compareArrays(compareNatural, keysX, keysY);
        if (c !== 0) return c;
        // compare values
        for(var i = 0; i < keysX.length; i++){
            var v = compareNatural(x[keysX[i]], y[keysY[i]]);
            if (v !== 0) return v;
        }
        return 0;
    }
});
/**
 * Compare two complex numbers, `x` and `y`:
 *
 * - First, compare the real values of `x` and `y`
 * - If equal, compare the imaginary values of `x` and `y`
 *
 * @params {Complex} x
 * @params {Complex} y
 * @returns {number} Returns the comparison result: -1, 0, or 1
 */ function $d2ccef7f0c3c0f4b$var$compareComplexNumbers(x, y) {
    if (x.re > y.re) return 1;
    if (x.re < y.re) return -1;
    if (x.im > y.im) return 1;
    if (x.im < y.im) return -1;
    return 0;
}

});
parcelRegister("e0NnZ", function(module, exports) {
/*
 * Natural Sort algorithm for Javascript - Version 0.7 - Released under MIT license
 * Author: Jim Palmer (based on chunking idea from Dave Koelle)
 */ /*jshint unused:false */ module.exports = function naturalSort(a, b) {
    "use strict";
    var re = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, sre = /(^[ ]*|[ ]*$)/g, dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, hre = /^0x[0-9a-f]+$/i, ore = /^0/, i = function(s) {
        return naturalSort.insensitive && ('' + s).toLowerCase() || '' + s;
    }, // convert all to strings strip whitespace
    x = i(a).replace(sre, '') || '', y = i(b).replace(sre, '') || '', // chunk/tokenize
    xN = x.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'), yN = y.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'), // numeric, hex or date detection
    xD = parseInt(x.match(hre), 16) || xN.length !== 1 && x.match(dre) && Date.parse(x), yD = parseInt(y.match(hre), 16) || xD && y.match(dre) && Date.parse(y) || null, oFxNcL, oFyNcL;
    // first try and sort Hex codes or Dates
    if (yD) {
        if (xD < yD) return -1;
        else if (xD > yD) return 1;
    }
    // natural sorting through split numeric strings and default strings
    for(var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++){
        // find floats not starting with '0', string or 0 if not defined (Clint Priest)
        oFxNcL = !(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
        oFyNcL = !(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
        // handle numeric vs string comparison - number < string - (Kyle Adams)
        if (isNaN(oFxNcL) !== isNaN(oFyNcL)) return isNaN(oFxNcL) ? 1 : -1;
        else if (typeof oFxNcL !== typeof oFyNcL) {
            oFxNcL += '';
            oFyNcL += '';
        }
        if (oFxNcL < oFyNcL) return -1;
        if (oFxNcL > oFyNcL) return 1;
    }
    return 0;
};

});


parcelRegister("cZxdP", function(module, exports) {

$parcel$export(module.exports, "createCompareText", () => $9754f3c2de33e5fe$export$3e578d0534ab5935);

var $j2hDb = parcelRequire("j2hDb");

var $dsu7t = parcelRequire("dsu7t");

var $6SJnV = parcelRequire("6SJnV");
var $9754f3c2de33e5fe$var$name = 'compareText';
var $9754f3c2de33e5fe$var$dependencies = [
    'typed',
    'matrix',
    'concat'
];
(0, $j2hDb.compareText).signature = 'any, any';
var $9754f3c2de33e5fe$export$3e578d0534ab5935 = /* #__PURE__ */ (0, $dsu7t.factory)($9754f3c2de33e5fe$var$name, $9754f3c2de33e5fe$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, concat: concat } = _ref;
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Compare two strings lexically. Comparison is case sensitive.
   * Returns 1 when x > y, -1 when x < y, and 0 when x == y.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.compareText(x, y)
   *
   * Examples:
   *
   *    math.compareText('B', 'A')     // returns 1
   *    math.compareText('2', '10')    // returns 1
   *    math.compare('2', '10')        // returns -1
   *    math.compareNatural('2', '10') // returns -1
   *
   *    math.compareText('B', ['A', 'B', 'C']) // returns [1, 0, -1]
   *
   * See also:
   *
   *    equal, equalText, compare, compareNatural
   *
   * @param  {string | Array | DenseMatrix} x First string to compare
   * @param  {string | Array | DenseMatrix} y Second string to compare
   * @return {number | Array | DenseMatrix} Returns the result of the comparison:
   *                                        1 when x > y, -1 when x < y, and 0 when x == y.
   */ return typed($9754f3c2de33e5fe$var$name, (0, $j2hDb.compareText), matrixAlgorithmSuite({
        elop: (0, $j2hDb.compareText),
        Ds: true
    }));
});
var $9754f3c2de33e5fe$export$1d0ea0d151dafd85 = /* #__PURE__ */ (0, $dsu7t.factory)($9754f3c2de33e5fe$var$name, [
    'typed'
], (_ref2)=>{
    var { typed: typed } = _ref2;
    return typed($9754f3c2de33e5fe$var$name, (0, $j2hDb.compareText));
});

});

parcelRegister("iytB4", function(module, exports) {

$parcel$export(module.exports, "createComplex", () => $d8225c525ad4b2c7$export$82a905fb6826da0d);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");
var $d8225c525ad4b2c7$var$name = 'complex';
var $d8225c525ad4b2c7$var$dependencies = [
    'typed',
    'Complex'
];
var $d8225c525ad4b2c7$export$82a905fb6826da0d = /* #__PURE__ */ (0, $dsu7t.factory)($d8225c525ad4b2c7$var$name, $d8225c525ad4b2c7$var$dependencies, (_ref)=>{
    var { typed: typed, Complex: Complex } = _ref;
    /**
   * Create a complex value or convert a value to a complex value.
   *
   * Syntax:
   *
   *     math.complex()                           // creates a complex value with zero
   *                                              // as real and imaginary part.
   *     math.complex(re : number, im : string)   // creates a complex value with provided
   *                                              // values for real and imaginary part.
   *     math.complex(re : number)                // creates a complex value with provided
   *                                              // real value and zero imaginary part.
   *     math.complex(complex : Complex)          // clones the provided complex value.
   *     math.complex(arg : string)               // parses a string into a complex value.
   *     math.complex(array : Array)              // converts the elements of the array
   *                                              // or matrix element wise into a
   *                                              // complex value.
   *     math.complex({re: number, im: number})   // creates a complex value with provided
   *                                              // values for real an imaginary part.
   *     math.complex({r: number, phi: number})   // creates a complex value with provided
   *                                              // polar coordinates
   *
   * Examples:
   *
   *    const a = math.complex(3, -4)     // a = Complex 3 - 4i
   *    a.re = 5                          // a = Complex 5 - 4i
   *    const i = a.im                    // Number -4
   *    const b = math.complex('2 + 6i')  // Complex 2 + 6i
   *    const c = math.complex()          // Complex 0 + 0i
   *    const d = math.add(a, b)          // Complex 5 + 2i
   *
   * See also:
   *
   *    bignumber, boolean, index, matrix, number, string, unit
   *
   * @param {* | Array | Matrix} [args]
   *            Arguments specifying the real and imaginary part of the complex number
   * @return {Complex | Array | Matrix} Returns a complex value
   */ return typed('complex', {
        '': function _() {
            return Complex.ZERO;
        },
        number: function number(x) {
            return new Complex(x, 0);
        },
        'number, number': function number_number(re, im) {
            return new Complex(re, im);
        },
        // TODO: this signature should be redundant
        'BigNumber, BigNumber': function BigNumber_BigNumber(re, im) {
            return new Complex(re.toNumber(), im.toNumber());
        },
        Fraction: function Fraction(x) {
            return new Complex(x.valueOf(), 0);
        },
        Complex: function Complex(x) {
            return x.clone();
        },
        string: function string(x) {
            return Complex(x); // for example '2 + 3i'
        },
        null: function _null(x) {
            return Complex(0);
        },
        Object: function Object(x) {
            if ('re' in x && 'im' in x) return new Complex(x.re, x.im);
            if ('r' in x && 'phi' in x || 'abs' in x && 'arg' in x) return new Complex(x);
            throw new Error('Expected object with properties (re and im) or (r and phi) or (abs and arg)');
        },
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});

parcelRegister("aQab8", function(module, exports) {

$parcel$export(module.exports, "createComplexClass", () => $7e46a7f91f213b73$export$24a4be44fc8b6392);

var $3n7l7 = parcelRequire("3n7l7");

var $6NnhX = parcelRequire("6NnhX");

var $edQYF = parcelRequire("edQYF");

var $dsu7t = parcelRequire("dsu7t");
var $7e46a7f91f213b73$var$name = 'Complex';
var $7e46a7f91f213b73$var$dependencies = [];
var $7e46a7f91f213b73$export$24a4be44fc8b6392 = /* #__PURE__ */ (0, $dsu7t.factory)($7e46a7f91f213b73$var$name, $7e46a7f91f213b73$var$dependencies, ()=>{
    /**
   * Attach type information
   */ Object.defineProperty((0, (/*@__PURE__*/$parcel$interopDefault($3n7l7))), 'name', {
        value: 'Complex'
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($3n7l7))).prototype.constructor = (0, (/*@__PURE__*/$parcel$interopDefault($3n7l7)));
    (0, (/*@__PURE__*/$parcel$interopDefault($3n7l7))).prototype.type = 'Complex';
    (0, (/*@__PURE__*/$parcel$interopDefault($3n7l7))).prototype.isComplex = true;
    /**
   * Get a JSON representation of the complex number
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Complex", "re": 2, "im": 3}`
   */ (0, (/*@__PURE__*/$parcel$interopDefault($3n7l7))).prototype.toJSON = function() {
        return {
            mathjs: 'Complex',
            re: this.re,
            im: this.im
        };
    };
    /*
   * Return the value of the complex number in polar notation
   * The angle phi will be set in the interval of [-pi, pi].
   * @return {{r: number, phi: number}} Returns and object with properties r and phi.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($3n7l7))).prototype.toPolar = function() {
        return {
            r: this.abs(),
            phi: this.arg()
        };
    };
    /**
   * Get a string representation of the complex number,
   * with optional formatting options.
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @return {string} str
   */ (0, (/*@__PURE__*/$parcel$interopDefault($3n7l7))).prototype.format = function(options) {
        var str = '';
        var im = this.im;
        var re = this.re;
        var strRe = (0, $6NnhX.format)(this.re, options);
        var strIm = (0, $6NnhX.format)(this.im, options);
        // round either re or im when smaller than the configured precision
        var precision = (0, $edQYF.isNumber)(options) ? options : options ? options.precision : null;
        if (precision !== null) {
            var epsilon = Math.pow(10, -precision);
            if (Math.abs(re / im) < epsilon) re = 0;
            if (Math.abs(im / re) < epsilon) im = 0;
        }
        if (im === 0) // real value
        str = strRe;
        else if (re === 0) {
            // purely complex value
            if (im === 1) str = 'i';
            else if (im === -1) str = '-i';
            else str = strIm + 'i';
        } else {
            // complex value
            if (im < 0) {
                if (im === -1) str = strRe + ' - i';
                else str = strRe + ' - ' + strIm.substring(1) + 'i';
            } else if (im === 1) str = strRe + ' + i';
            else str = strRe + ' + ' + strIm + 'i';
        }
        return str;
    };
    /**
   * Create a complex number from polar coordinates
   *
   * Usage:
   *
   *     Complex.fromPolar(r: number, phi: number) : Complex
   *     Complex.fromPolar({r: number, phi: number}) : Complex
   *
   * @param {*} args...
   * @return {Complex}
   */ (0, (/*@__PURE__*/$parcel$interopDefault($3n7l7))).fromPolar = function(args) {
        switch(arguments.length){
            case 1:
                var arg = arguments[0];
                if (typeof arg === 'object') return (0, (/*@__PURE__*/$parcel$interopDefault($3n7l7)))(arg);
                else throw new TypeError('Input has to be an object with r and phi keys.');
            case 2:
                var r = arguments[0];
                var phi = arguments[1];
                if ((0, $edQYF.isNumber)(r)) {
                    if ((0, $edQYF.isUnit)(phi) && phi.hasBase('ANGLE')) // convert unit to a number in radians
                    phi = phi.toNumber('rad');
                    if ((0, $edQYF.isNumber)(phi)) return new (0, (/*@__PURE__*/$parcel$interopDefault($3n7l7)))({
                        r: r,
                        phi: phi
                    });
                    throw new TypeError('Phi is not a number nor an angle unit.');
                } else throw new TypeError('Radius r is not a number.');
            default:
                throw new SyntaxError('Wrong number of arguments in function fromPolar');
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($3n7l7))).prototype.valueOf = (0, (/*@__PURE__*/$parcel$interopDefault($3n7l7))).prototype.toString;
    /**
   * Create a Complex number from a JSON object
   * @param {Object} json  A JSON Object structured as
   *                       {"mathjs": "Complex", "re": 2, "im": 3}
   *                       All properties are optional, default values
   *                       for `re` and `im` are 0.
   * @return {Complex} Returns a new Complex number
   */ (0, (/*@__PURE__*/$parcel$interopDefault($3n7l7))).fromJSON = function(json) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($3n7l7)))(json);
    };
    /**
   * Compare two complex numbers, `a` and `b`:
   *
   * - Returns 1 when the real part of `a` is larger than the real part of `b`
   * - Returns -1 when the real part of `a` is smaller than the real part of `b`
   * - Returns 1 when the real parts are equal
   *   and the imaginary part of `a` is larger than the imaginary part of `b`
   * - Returns -1 when the real parts are equal
   *   and the imaginary part of `a` is smaller than the imaginary part of `b`
   * - Returns 0 when both real and imaginary parts are equal.
   *
   * @params {Complex} a
   * @params {Complex} b
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ (0, (/*@__PURE__*/$parcel$interopDefault($3n7l7))).compare = function(a, b) {
        if (a.re > b.re) return 1;
        if (a.re < b.re) return -1;
        if (a.im > b.im) return 1;
        if (a.im < b.im) return -1;
        return 0;
    };
    return 0, (/*@__PURE__*/$parcel$interopDefault($3n7l7));
}, {
    isClass: true
});

});
parcelRegister("3n7l7", function(module, exports) {
/*
Complex.js v2.4.3 11/13/2025
https://raw.org/article/complex-numbers-in-javascript/

Copyright (c) 2025, Robert Eisele (https://raw.org/)
Licensed under the MIT license.
*/ 'use strict';
(function(q) {
    function l(a, b) {
        if (a === void 0 || a === null) f.re = f.im = 0;
        else if (b !== void 0) f.re = a, f.im = b;
        else switch(typeof a){
            case "object":
                if ("im" in a && "re" in a) f.re = a.re, f.im = a.im;
                else if ("abs" in a && "arg" in a) {
                    if (!isFinite(a.abs) && isFinite(a.arg)) return c.INFINITY;
                    f.re = a.abs * Math.cos(a.arg);
                    f.im = a.abs * Math.sin(a.arg);
                } else if ("r" in a && "phi" in a) {
                    if (!isFinite(a.r) && isFinite(a.phi)) return c.INFINITY;
                    f.re = a.r * Math.cos(a.phi);
                    f.im = a.r * Math.sin(a.phi);
                } else a.length === 2 ? (f.re = a[0], f.im = a[1]) : m();
                break;
            case "string":
                f.im = f.re = 0;
                a = a.replace(/_/g, "").match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g);
                b = 1;
                let d = 0;
                a === null && m();
                for(let e = 0; e < a.length; e++){
                    const g = a[e];
                    g !== " " && g !== "\t" && g !== "\n" && (g === "+" ? b++ : g === "-" ? d++ : (g === "i" || g === "I" ? (b + d === 0 && m(), a[e + 1] === " " || isNaN(a[e + 1]) ? f.im += parseFloat((d % 2 ? "-" : "") + "1") : (f.im += parseFloat((d % 2 ? "-" : "") + a[e + 1]), e++)) : ((b + d === 0 || isNaN(g)) && m(), a[e + 1] === "i" || a[e + 1] === "I" ? (f.im += parseFloat((d % 2 ? "-" : "") + g), e++) : f.re += parseFloat((d % 2 ? "-" : "") + g)), b = d = 0));
                }
                b + d > 0 && m();
                break;
            case "number":
                f.im = 0;
                f.re = a;
                break;
            default:
                m();
        }
        return f;
    }
    function m() {
        throw SyntaxError("Invalid Param");
    }
    function n(a, b) {
        a = Math.abs(a);
        b = Math.abs(b);
        a < b && ([a, b] = [
            b,
            a
        ]);
        if (a < 1E8) return Math.sqrt(a * a + b * b);
        b /= a;
        return a * Math.sqrt(1 + b * b);
    }
    function p(a, b) {
        const d = Math.abs(a), e = Math.abs(b);
        if (a === 0) return Math.log(e);
        if (b === 0) return Math.log(d);
        if (d < 3E3 && e < 3E3) return Math.log(a * a + b * b) * .5;
        a *= .5;
        b *= .5;
        return .5 * Math.log(a * a + b * b) + Math.LN2;
    }
    function c(a, b) {
        if (!(this instanceof c)) return new c(a, b);
        a = l(a, b);
        this.re = a.re;
        this.im = a.im;
    }
    const h = Math.cosh || function(a) {
        return Math.abs(a) < 1E-9 ? 1 - a : (Math.exp(a) + Math.exp(-a)) * .5;
    }, k = Math.sinh || function(a) {
        return Math.abs(a) < 1E-9 ? a : (Math.exp(a) - Math.exp(-a)) * .5;
    }, f = {
        re: 0,
        im: 0
    };
    c.prototype = {
        re: 0,
        im: 0,
        sign: function() {
            const a = n(this.re, this.im);
            return new c(this.re / a, this.im / a);
        },
        add: function(a, b) {
            a = l(a, b);
            b = this.isInfinite();
            const d = !(isFinite(a.re) && isFinite(a.im));
            return b || d ? b && d ? c.NAN : c.INFINITY : new c(this.re + a.re, this.im + a.im);
        },
        sub: function(a, b) {
            a = l(a, b);
            b = this.isInfinite();
            const d = !(isFinite(a.re) && isFinite(a.im));
            return b || d ? b && d ? c.NAN : c.INFINITY : new c(this.re - a.re, this.im - a.im);
        },
        mul: function(a, b) {
            a = l(a, b);
            b = this.isInfinite();
            const d = !(isFinite(a.re) && isFinite(a.im)), e = this.re === 0 && this.im === 0, g = a.re === 0 && a.im === 0;
            return b && g || d && e ? c.NAN : b || d ? c.INFINITY : a.im === 0 && this.im === 0 ? new c(this.re * a.re, 0) : new c(this.re * a.re - this.im * a.im, this.re * a.im + this.im * a.re);
        },
        div: function(a, b) {
            a = l(a, b);
            b = this.isInfinite();
            const d = !(isFinite(a.re) && isFinite(a.im)), e = this.re === 0 && this.im === 0, g = a.re === 0 && a.im === 0;
            if (e && g || b && d) return c.NAN;
            if (g || b) return c.INFINITY;
            if (e || d) return c.ZERO;
            if (0 === a.im) return new c(this.re / a.re, this.im / a.re);
            if (Math.abs(a.re) < Math.abs(a.im)) return b = a.re / a.im, a = a.re * b + a.im, new c((this.re * b + this.im) / a, (this.im * b - this.re) / a);
            b = a.im / a.re;
            a = a.im * b + a.re;
            return new c((this.re + this.im * b) / a, (this.im - this.re * b) / a);
        },
        pow: function(a, b) {
            a = l(a, b);
            b = this.re === 0 && this.im === 0;
            if (a.re === 0 && a.im === 0) return c.ONE;
            if (a.im === 0) {
                if (this.im === 0 && this.re > 0) return new c(Math.pow(this.re, a.re), 0);
                if (this.re === 0) switch((a.re % 4 + 4) % 4){
                    case 0:
                        return new c(Math.pow(this.im, a.re), 0);
                    case 1:
                        return new c(0, Math.pow(this.im, a.re));
                    case 2:
                        return new c(-Math.pow(this.im, a.re), 0);
                    case 3:
                        return new c(0, -Math.pow(this.im, a.re));
                }
            }
            if (b && a.re > 0) return c.ZERO;
            const d = Math.atan2(this.im, this.re), e = p(this.re, this.im);
            b = Math.exp(a.re * e - a.im * d);
            a = a.im * e + a.re * d;
            return new c(b * Math.cos(a), b * Math.sin(a));
        },
        sqrt: function() {
            const a = this.re, b = this.im;
            if (b === 0) return a >= 0 ? new c(Math.sqrt(a), 0) : new c(0, Math.sqrt(-a));
            var d = n(a, b);
            d = Math.sqrt(.5 * (d + Math.abs(a)));
            let e = Math.abs(b) / (2 * d);
            return a >= 0 ? new c(d, b < 0 ? -e : e) : new c(e, b < 0 ? -d : d);
        },
        exp: function() {
            const a = Math.exp(this.re);
            return this.im === 0 ? new c(a, 0) : new c(a * Math.cos(this.im), a * Math.sin(this.im));
        },
        expm1: function() {
            const a = this.re, b = this.im, d = Math.sin(.5 * b);
            return new c(Math.expm1(a) * Math.cos(b) + -2 * d * d, Math.exp(a) * Math.sin(b));
        },
        log: function() {
            const a = this.re, b = this.im;
            return b === 0 && a > 0 ? new c(Math.log(a), 0) : new c(p(a, b), Math.atan2(b, a));
        },
        abs: function() {
            return n(this.re, this.im);
        },
        arg: function() {
            return Math.atan2(this.im, this.re);
        },
        sin: function() {
            const a = this.re, b = this.im;
            return new c(Math.sin(a) * h(b), Math.cos(a) * k(b));
        },
        cos: function() {
            const a = this.re, b = this.im;
            return new c(Math.cos(a) * h(b), -Math.sin(a) * k(b));
        },
        tan: function() {
            const a = 2 * this.re, b = 2 * this.im, d = Math.cos(a) + h(b);
            return new c(Math.sin(a) / d, k(b) / d);
        },
        cot: function() {
            const a = 2 * this.re, b = 2 * this.im, d = Math.cos(a) - h(b);
            return new c(-Math.sin(a) / d, k(b) / d);
        },
        sec: function() {
            const a = this.re, b = this.im, d = .5 * h(2 * b) + .5 * Math.cos(2 * a);
            return new c(Math.cos(a) * h(b) / d, Math.sin(a) * k(b) / d);
        },
        csc: function() {
            const a = this.re, b = this.im, d = .5 * h(2 * b) - .5 * Math.cos(2 * a);
            return new c(Math.sin(a) * h(b) / d, -Math.cos(a) * k(b) / d);
        },
        asin: function() {
            var a = this.re;
            const b = this.im, d = new c(b * b - a * a + 1, -2 * a * b).sqrt();
            a = new c(d.re - b, d.im + a).log();
            return new c(a.im, -a.re);
        },
        acos: function() {
            var a = this.re;
            const b = this.im, d = new c(b * b - a * a + 1, -2 * a * b).sqrt();
            a = new c(d.re - b, d.im + a).log();
            return new c(Math.PI / 2 - a.im, a.re);
        },
        atan: function() {
            var a = this.re;
            const b = this.im;
            if (a === 0) {
                if (b === 1) return new c(0, Infinity);
                if (b === -1) return new c(0, -Infinity);
            }
            const d = a * a + (1 - b) * (1 - b);
            a = new c((1 - b * b - a * a) / d, -2 * a / d).log();
            return new c(-0.5 * a.im, .5 * a.re);
        },
        acot: function() {
            const a = this.re, b = this.im;
            if (b === 0) return new c(Math.atan2(1, a), 0);
            const d = a * a + b * b;
            return d !== 0 ? new c(a / d, -b / d).atan() : new c(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).atan();
        },
        asec: function() {
            const a = this.re, b = this.im;
            if (a === 0 && b === 0) return new c(0, Infinity);
            const d = a * a + b * b;
            return d !== 0 ? new c(a / d, -b / d).acos() : new c(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).acos();
        },
        acsc: function() {
            const a = this.re, b = this.im;
            if (a === 0 && b === 0) return new c(Math.PI / 2, Infinity);
            const d = a * a + b * b;
            return d !== 0 ? new c(a / d, -b / d).asin() : new c(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).asin();
        },
        sinh: function() {
            const a = this.re, b = this.im;
            return new c(k(a) * Math.cos(b), h(a) * Math.sin(b));
        },
        cosh: function() {
            const a = this.re, b = this.im;
            return new c(h(a) * Math.cos(b), k(a) * Math.sin(b));
        },
        tanh: function() {
            const a = 2 * this.re, b = 2 * this.im, d = h(a) + Math.cos(b);
            return new c(k(a) / d, Math.sin(b) / d);
        },
        coth: function() {
            const a = 2 * this.re, b = 2 * this.im, d = h(a) - Math.cos(b);
            return new c(k(a) / d, -Math.sin(b) / d);
        },
        csch: function() {
            const a = this.re, b = this.im, d = Math.cos(2 * b) - h(2 * a);
            return new c(-2 * k(a) * Math.cos(b) / d, 2 * h(a) * Math.sin(b) / d);
        },
        sech: function() {
            const a = this.re, b = this.im, d = Math.cos(2 * b) + h(2 * a);
            return new c(2 * h(a) * Math.cos(b) / d, -2 * k(a) * Math.sin(b) / d);
        },
        asinh: function() {
            const a = this.re;
            var b = this.im;
            if (b === 0) {
                if (a === 0) return new c(0, 0);
                b = Math.abs(a);
                b = Math.log(b + Math.sqrt(b * b + 1));
                return new c(a < 0 ? -b : b, 0);
            }
            const d = new c(a * a - b * b + 1, 2 * a * b).sqrt();
            return new c(a + d.re, b + d.im).log();
        },
        acosh: function() {
            const a = this.re, b = this.im;
            if (b === 0) return a > 1 ? new c(Math.log(a + Math.sqrt(a - 1) * Math.sqrt(a + 1)), 0) : a < -1 ? new c(Math.log(-a + Math.sqrt(a * a - 1)), Math.PI) : new c(0, Math.acos(a));
            const d = new c(a - 1, b).sqrt(), e = new c(a + 1, b).sqrt();
            return new c(a + d.re * e.re - d.im * e.im, b + d.re * e.im + d.im * e.re).log();
        },
        atanh: function() {
            var a = this.re, b = this.im;
            if (b === 0) return a === 0 ? new c(0, 0) : a === 1 ? new c(Infinity, 0) : a === -1 ? new c(-Infinity, 0) : -1 < a && a < 1 ? new c(.5 * Math.log((1 + a) / (1 - a)), 0) : a > 1 ? new c(.5 * Math.log((a + 1) / (a - 1)), -Math.PI / 2) : new c(.5 * Math.log(-((1 + a) / (1 - a))), Math.PI / 2);
            const d = 1 - a, e = 1 + a, g = d * d + b * b;
            if (g === 0) return new c(a !== -1 ? a / 0 : 0, b !== 0 ? b / 0 : 0);
            a = (e * d - b * b) / g;
            b = (b * d + e * b) / g;
            return new c(p(a, b) / 2, Math.atan2(b, a) / 2);
        },
        acoth: function() {
            const a = this.re, b = this.im;
            if (a === 0 && b === 0) return new c(0, Math.PI / 2);
            const d = a * a + b * b;
            return d !== 0 ? new c(a / d, -b / d).atanh() : new c(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).atanh();
        },
        acsch: function() {
            var a = this.re;
            const b = this.im;
            if (b === 0) {
                if (a === 0) return new c(Infinity, 0);
                a = 1 / a;
                return new c(Math.log(a + Math.sqrt(a * a + 1)), 0);
            }
            const d = a * a + b * b;
            return d !== 0 ? new c(a / d, -b / d).asinh() : new c(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).asinh();
        },
        asech: function() {
            const a = this.re, b = this.im;
            if (this.isZero()) return c.INFINITY;
            const d = a * a + b * b;
            return d !== 0 ? new c(a / d, -b / d).acosh() : new c(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).acosh();
        },
        inverse: function() {
            if (this.isZero()) return c.INFINITY;
            if (this.isInfinite()) return c.ZERO;
            const a = this.re, b = this.im, d = a * a + b * b;
            return new c(a / d, -b / d);
        },
        conjugate: function() {
            return new c(this.re, -this.im);
        },
        neg: function() {
            return new c(-this.re, -this.im);
        },
        ceil: function(a) {
            a = Math.pow(10, a || 0);
            return new c(Math.ceil(this.re * a) / a, Math.ceil(this.im * a) / a);
        },
        floor: function(a) {
            a = Math.pow(10, a || 0);
            return new c(Math.floor(this.re * a) / a, Math.floor(this.im * a) / a);
        },
        round: function(a) {
            a = Math.pow(10, a || 0);
            return new c(Math.round(this.re * a) / a, Math.round(this.im * a) / a);
        },
        equals: function(a, b) {
            a = l(a, b);
            return Math.abs(a.re - this.re) <= c.EPSILON && Math.abs(a.im - this.im) <= c.EPSILON;
        },
        clone: function() {
            return new c(this.re, this.im);
        },
        toString: function() {
            let a = this.re, b = this.im, d = "";
            if (this.isNaN()) return "NaN";
            if (this.isInfinite()) return "Infinity";
            Math.abs(a) < c.EPSILON && (a = 0);
            Math.abs(b) < c.EPSILON && (b = 0);
            if (b === 0) return d + a;
            a !== 0 ? (d = d + a + " ", b < 0 ? (b = -b, d += "-") : d += "+", d += " ") : b < 0 && (b = -b, d += "-");
            1 !== b && (d += b);
            return d + "i";
        },
        toVector: function() {
            return [
                this.re,
                this.im
            ];
        },
        valueOf: function() {
            return this.im === 0 ? this.re : null;
        },
        isNaN: function() {
            return isNaN(this.re) || isNaN(this.im);
        },
        isZero: function() {
            return this.im === 0 && this.re === 0;
        },
        isFinite: function() {
            return isFinite(this.re) && isFinite(this.im);
        },
        isInfinite: function() {
            return !this.isFinite();
        }
    };
    c.ZERO = new c(0, 0);
    c.ONE = new c(1, 0);
    c.I = new c(0, 1);
    c.PI = new c(Math.PI, 0);
    c.E = new c(Math.E, 0);
    c.INFINITY = new c(Infinity, Infinity);
    c.NAN = new c(NaN, NaN);
    c.EPSILON = 1E-15;
    typeof define === "function" && define.amd ? define([], function() {
        return c;
    }) : (Object.defineProperty(c, "__esModule", {
        value: !0
    }), c["default"] = c, c.Complex = c, module.exports = c);
})(module.exports);

});


parcelRegister("9go81", function(module, exports) {

$parcel$export(module.exports, "createComposition", () => $6be853152185ddd9$export$1ddf9cbadd17315f);

var $dsu7t = parcelRequire("dsu7t");
var $6be853152185ddd9$var$name = 'composition';
var $6be853152185ddd9$var$dependencies = [
    'typed',
    'addScalar',
    'combinations',
    'isNegative',
    'isPositive',
    'isInteger',
    'larger'
];
var $6be853152185ddd9$export$1ddf9cbadd17315f = /* #__PURE__ */ (0, $dsu7t.factory)($6be853152185ddd9$var$name, $6be853152185ddd9$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, combinations: combinations, isPositive: isPositive, isNegative: isNegative, isInteger: isInteger, larger: larger } = _ref;
    /**
   * The composition counts of n into k parts.
   *
   * composition only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *   math.composition(n, k)
   *
   * Examples:
   *
   *    math.composition(5, 3) // returns 6
   *
   * See also:
   *
   *    combinations
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @param {Number | BigNumber} k    Number of objects in the subset
   * @return {Number | BigNumber}     Returns the composition counts of n into k parts.
   */ return typed($6be853152185ddd9$var$name, {
        'number | BigNumber, number | BigNumber': function number__BigNumber_number__BigNumber(n, k) {
            if (!isInteger(n) || !isPositive(n) || !isInteger(k) || !isPositive(k)) throw new TypeError('Positive integer value expected in function composition');
            else if (larger(k, n)) throw new TypeError('k must be less than or equal to n in function composition');
            return combinations(addScalar(n, -1), addScalar(k, -1));
        }
    });
});

});

parcelRegister("dm79W", function(module, exports) {

$parcel$export(module.exports, "createConcat", () => $9b92e22736983fd9$export$c36b5511b12560e8);

var $edQYF = parcelRequire("edQYF");

var $9v8q6 = parcelRequire("9v8q6");

var $d80Xp = parcelRequire("d80Xp");

var $fFsPN = parcelRequire("fFsPN");

var $7asMt = parcelRequire("7asMt");

var $dsu7t = parcelRequire("dsu7t");
var $9b92e22736983fd9$var$name = 'concat';
var $9b92e22736983fd9$var$dependencies = [
    'typed',
    'matrix',
    'isInteger'
];
var $9b92e22736983fd9$export$c36b5511b12560e8 = /* #__PURE__ */ (0, $dsu7t.factory)($9b92e22736983fd9$var$name, $9b92e22736983fd9$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, isInteger: isInteger } = _ref;
    /**
   * Concatenate two or more matrices.
   *
   * Syntax:
   *
   *     math.concat(A, B, C, ...)
   *     math.concat(A, B, C, ..., dim)
   *
   * Where:
   *
   * - `dim: number` is a zero-based dimension over which to concatenate the matrices.
   *   By default the last dimension of the matrices.
   *
   * Examples:
   *
   *    const A = [[1, 2], [5, 6]]
   *    const B = [[3, 4], [7, 8]]
   *
   *    math.concat(A, B)                  // returns [[1, 2, 3, 4], [5, 6, 7, 8]]
   *    math.concat(A, B, 0)               // returns [[1, 2], [5, 6], [3, 4], [7, 8]]
   *    math.concat('hello', ' ', 'world') // returns 'hello world'
   *
   * See also:
   *
   *    size, squeeze, subset, transpose
   *
   * @param {... Array | Matrix} args     Two or more matrices
   * @return {Array | Matrix} Concatenated matrix
   */ return typed($9b92e22736983fd9$var$name, {
        // TODO: change signature to '...Array | Matrix, dim?' when supported
        '...Array | Matrix | number | BigNumber': function Array__Matrix__number__BigNumber(args) {
            var i;
            var len = args.length;
            var dim = -1; // zero-based dimension
            var prevDim;
            var asMatrix = false;
            var matrices = []; // contains multi dimensional arrays
            for(i = 0; i < len; i++){
                var arg = args[i];
                // test whether we need to return a Matrix (if not we return an Array)
                if ((0, $edQYF.isMatrix)(arg)) asMatrix = true;
                if ((0, $edQYF.isNumber)(arg) || (0, $edQYF.isBigNumber)(arg)) {
                    if (i !== len - 1) throw new Error('Dimension must be specified as last argument');
                    // last argument contains the dimension on which to concatenate
                    prevDim = dim;
                    dim = arg.valueOf(); // change BigNumber to number
                    if (!isInteger(dim)) throw new TypeError('Integer number expected for dimension');
                    if (dim < 0 || i > 0 && dim > prevDim) // TODO: would be more clear when throwing a DimensionError here
                    throw new (0, $fFsPN.IndexError)(dim, prevDim + 1);
                } else {
                    // this is a matrix or array
                    var m = (0, $9v8q6.clone)(arg).valueOf();
                    var size = (0, $d80Xp.arraySize)(m);
                    matrices[i] = m;
                    prevDim = dim;
                    dim = size.length - 1;
                    // verify whether each of the matrices has the same number of dimensions
                    if (i > 0 && dim !== prevDim) throw new (0, $7asMt.DimensionError)(prevDim + 1, dim + 1);
                }
            }
            if (matrices.length === 0) throw new SyntaxError('At least one matrix expected');
            var res = matrices.shift();
            while(matrices.length)res = (0, $d80Xp.concat)(res, matrices.shift(), dim);
            return asMatrix ? matrix(res) : res;
        },
        '...string': function string(args) {
            return args.join('');
        }
    });
});

});

parcelRegister("AGy3Q", function(module, exports) {

$parcel$export(module.exports, "createConj", () => $06e45e20b61a7874$export$af5efe8ad97f01a2);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");
var $06e45e20b61a7874$var$name = 'conj';
var $06e45e20b61a7874$var$dependencies = [
    'typed'
];
var $06e45e20b61a7874$export$af5efe8ad97f01a2 = /* #__PURE__ */ (0, $dsu7t.factory)($06e45e20b61a7874$var$name, $06e45e20b61a7874$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the complex conjugate of a complex value.
   * If `x = a+bi`, the complex conjugate of `x` is `a - bi`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.conj(x)
   *
   * Examples:
   *
   *    math.conj(math.complex('2 + 3i'))  // returns Complex 2 - 3i
   *    math.conj(math.complex('2 - 3i'))  // returns Complex 2 + 3i
   *    math.conj(math.complex('-5.2i'))  // returns Complex 5.2i
   *
   * See also:
   *
   *    re, im, arg, abs
   *
   * @param {number | BigNumber | Complex | Array | Matrix | Unit} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Complex | Array | Matrix | Unit}
   *            The complex conjugate of x
   */ return typed($06e45e20b61a7874$var$name, {
        'number | BigNumber | Fraction': (x)=>x,
        Complex: (x)=>x.conjugate(),
        Unit: typed.referToSelf((self)=>(x)=>new x.constructor(self(x.toNumeric()), x.formatUnits())),
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});

parcelRegister("gOUuL", function(module, exports) {

$parcel$export(module.exports, "createCorr", () => $c3ed239f916a95ac$export$10240de9e69376f9);

var $dsu7t = parcelRequire("dsu7t");
var $c3ed239f916a95ac$var$name = 'corr';
var $c3ed239f916a95ac$var$dependencies = [
    'typed',
    'matrix',
    'mean',
    'sqrt',
    'sum',
    'add',
    'subtract',
    'multiply',
    'pow',
    'divide'
];
var $c3ed239f916a95ac$export$10240de9e69376f9 = /* #__PURE__ */ (0, $dsu7t.factory)($c3ed239f916a95ac$var$name, $c3ed239f916a95ac$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, sqrt: sqrt, sum: sum, add: add, subtract: subtract, multiply: multiply, pow: pow, divide: divide } = _ref;
    /**
   * Compute the correlation coefficient of a two list with values, For matrices, the matrix correlation coefficient is calculated.
   *
   * Syntax:
   *
   *     math.corr(A, B)
   *
   * Examples:
   *
   *     math.corr([1, 2, 3, 4, 5], [4, 5, 6, 7, 8])     // returns 1
   *     math.corr([1, 2.2, 3, 4.8, 5], [4, 5.3, 6.6, 7, 8])     //returns 0.9569941688503644
   *     math.corr([[1, 2.2, 3, 4.8, 5], [4, 5.3, 6.6, 7, 8]],[[1, 2.2, 3, 4.8, 5], [4, 5.3, 6.6, 7, 8]])   // returns [1,1]
   *
   * See also:
   *
   *     median, mean, min, max, sum, prod, std, variance
   *
   * @param {Array | Matrix} A The first array or matrix to compute correlation coefficient
   * @param {Array | Matrix} B The second array or matrix to compute correlation coefficient
   * @return {*} The correlation coefficient
   */ return typed($c3ed239f916a95ac$var$name, {
        'Array, Array': function Array_Array(A, B) {
            return _corr(A, B);
        },
        'Matrix, Matrix': function Matrix_Matrix(A, B) {
            var res = _corr(A.toArray(), B.toArray());
            return Array.isArray(res) ? matrix(res) : res;
        }
    });
    /**
   * Calculate the correlation coefficient between two arrays or matrices.
   * @param {Array | Matrix} A
   * @param {Array | Matrix} B
   * @return {*} correlation coefficient
   * @private
   */ function _corr(A, B) {
        var correlations = [];
        if (Array.isArray(A[0]) && Array.isArray(B[0])) {
            if (A.length !== B.length) throw new SyntaxError('Dimension mismatch. Array A and B must have the same length.');
            for(var i = 0; i < A.length; i++){
                if (A[i].length !== B[i].length) throw new SyntaxError('Dimension mismatch. Array A and B must have the same number of elements.');
                correlations.push(correlation(A[i], B[i]));
            }
            return correlations;
        } else {
            if (A.length !== B.length) throw new SyntaxError('Dimension mismatch. Array A and B must have the same number of elements.');
            return correlation(A, B);
        }
    }
    function correlation(A, B) {
        var n = A.length;
        var sumX = sum(A);
        var sumY = sum(B);
        var sumXY = A.reduce((acc, x, index)=>add(acc, multiply(x, B[index])), 0);
        var sumXSquare = sum(A.map((x)=>pow(x, 2)));
        var sumYSquare = sum(B.map((y)=>pow(y, 2)));
        var numerator = subtract(multiply(n, sumXY), multiply(sumX, sumY));
        var denominator = sqrt(multiply(subtract(multiply(n, sumXSquare), pow(sumX, 2)), subtract(multiply(n, sumYSquare), pow(sumY, 2))));
        return divide(numerator, denominator);
    }
});

});

parcelRegister("6WgOo", function(module, exports) {

$parcel$export(module.exports, "createCos", () => $50d533547a65ac59$export$923b60dfa791c630);

var $dsu7t = parcelRequire("dsu7t");

var $aS62J = parcelRequire("aS62J");
var $50d533547a65ac59$var$name = 'cos';
var $50d533547a65ac59$var$dependencies = [
    'typed'
];
var $50d533547a65ac59$export$923b60dfa791c630 = /* #__PURE__ */ (0, $dsu7t.factory)($50d533547a65ac59$var$name, $50d533547a65ac59$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    var trigUnit = (0, $aS62J.createTrigUnit)({
        typed: typed
    });
    /**
   * Calculate the cosine of a value.
   *
   * To avoid confusion with the matrix cosine, this function does not
   * apply to matrices.
   *
   * Syntax:
   *
   *    math.cos(x)
   *
   * Examples:
   *
   *    math.cos(2)                      // returns number -0.4161468365471422
   *    math.cos(math.pi / 4)            // returns number  0.7071067811865475
   *    math.cos(math.unit(180, 'deg'))  // returns number -1
   *    math.cos(math.unit(60, 'deg'))   // returns number  0.5
   *
   *    const angle = 0.2
   *    math.pow(math.sin(angle), 2) + math.pow(math.cos(angle), 2) // returns number 1
   *
   * See also:
   *
   *    cos, tan
   *
   * @param {number | BigNumber | Complex | Unit} x  Function input
   * @return {number | BigNumber | Complex} Cosine of x
   */ return typed($50d533547a65ac59$var$name, {
        number: Math.cos,
        'Complex | BigNumber': (x)=>x.cos()
    }, trigUnit);
});

});
parcelRegister("aS62J", function(module, exports) {

$parcel$export(module.exports, "createTrigUnit", () => $7ea3a28f1d24cea2$export$33129064a3329835);

var $dsu7t = parcelRequire("dsu7t");
var $7ea3a28f1d24cea2$export$33129064a3329835 = /* #__PURE__ */ (0, $dsu7t.factory)('trigUnit', [
    'typed'
], (_ref)=>{
    var { typed: typed } = _ref;
    return {
        Unit: typed.referToSelf((self)=>(x)=>{
                if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError('Unit in function cot is no angle');
                return typed.find(self, x.valueType())(x.value);
            })
    };
});

});


parcelRegister("9Hj4h", function(module, exports) {

$parcel$export(module.exports, "createCosh", () => $70f6ebb4846177ca$export$63d35097da636c02);

var $dsu7t = parcelRequire("dsu7t");

var $6NnhX = parcelRequire("6NnhX");
var $70f6ebb4846177ca$var$name = 'cosh';
var $70f6ebb4846177ca$var$dependencies = [
    'typed'
];
var $70f6ebb4846177ca$export$63d35097da636c02 = /* #__PURE__ */ (0, $dsu7t.factory)($70f6ebb4846177ca$var$name, $70f6ebb4846177ca$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic cosine of a value,
   * defined as `cosh(x) = 1/2 * (exp(x) + exp(-x))`.
   *
   * To avoid confusion with the matrix hyperbolic cosine, this function does
   * not apply to matrices.
   *
   * Syntax:
   *
   *    math.cosh(x)
   *
   * Examples:
   *
   *    math.cosh(0.5)       // returns number 1.1276259652063807
   *
   * See also:
   *
   *    sinh, tanh
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic cosine of x
   */ return typed($70f6ebb4846177ca$var$name, {
        number: (0, $6NnhX.cosh),
        'Complex | BigNumber': (x)=>x.cosh()
    });
});

});

parcelRegister("7GLTI", function(module, exports) {

$parcel$export(module.exports, "createCot", () => $59919c255b9a80c6$export$c5598f542ea1565c);

var $dsu7t = parcelRequire("dsu7t");

var $cOOcY = parcelRequire("cOOcY");

var $aS62J = parcelRequire("aS62J");
var $59919c255b9a80c6$var$name = 'cot';
var $59919c255b9a80c6$var$dependencies = [
    'typed',
    'BigNumber'
];
var $59919c255b9a80c6$export$c5598f542ea1565c = /* #__PURE__ */ (0, $dsu7t.factory)($59919c255b9a80c6$var$name, $59919c255b9a80c6$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    var trigUnit = (0, $aS62J.createTrigUnit)({
        typed: typed
    });
    /**
   * Calculate the cotangent of a value. Defined as `cot(x) = 1 / tan(x)`.
   *
   * To avoid confusion with the matrix cotangent, this function does not
   * apply to matrices.
   *
   * Syntax:
   *
   *    math.cot(x)
   *
   * Examples:
   *
   *    math.cot(2)      // returns number -0.45765755436028577
   *    1 / math.tan(2)  // returns number -0.45765755436028577
   *
   * See also:
   *
   *    tan, sec, csc
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Cotangent of x
   */ return typed($59919c255b9a80c6$var$name, {
        number: (0, $cOOcY.cotNumber),
        Complex: (x)=>x.cot(),
        BigNumber: (x)=>new _BigNumber(1).div(x.tan())
    }, trigUnit);
});

});

parcelRegister("jHfjA", function(module, exports) {

$parcel$export(module.exports, "createCoth", () => $e56de9b4d8ad7ff8$export$3f7f9b5400315e6a);

var $dsu7t = parcelRequire("dsu7t");

var $cOOcY = parcelRequire("cOOcY");
var $e56de9b4d8ad7ff8$var$name = 'coth';
var $e56de9b4d8ad7ff8$var$dependencies = [
    'typed',
    'BigNumber'
];
var $e56de9b4d8ad7ff8$export$3f7f9b5400315e6a = /* #__PURE__ */ (0, $dsu7t.factory)($e56de9b4d8ad7ff8$var$name, $e56de9b4d8ad7ff8$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic cotangent of a value,
   * defined as `coth(x) = 1 / tanh(x)`.
   *
   * To avoid confusion with the matrix hyperbolic cotangent, this function
   * does not apply to matrices.
   *
   * Syntax:
   *
   *    math.coth(x)
   *
   * Examples:
   *
   *    // coth(x) = 1 / tanh(x)
   *    math.coth(2)         // returns 1.0373147207275482
   *    1 / math.tanh(2)     // returns 1.0373147207275482
   *
   * See also:
   *
   *    sinh, tanh, cosh
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic cotangent of x
   */ return typed($e56de9b4d8ad7ff8$var$name, {
        number: (0, $cOOcY.cothNumber),
        Complex: (x)=>x.coth(),
        BigNumber: (x)=>new _BigNumber(1).div(x.tanh())
    });
});

});

parcelRegister("abvhy", function(module, exports) {

$parcel$export(module.exports, "createCount", () => $76a3326dd190eabd$export$decd32c762b504bc);

var $dsu7t = parcelRequire("dsu7t");
var $76a3326dd190eabd$var$name = 'count';
var $76a3326dd190eabd$var$dependencies = [
    'typed',
    'size',
    'prod'
];
var $76a3326dd190eabd$export$decd32c762b504bc = /* #__PURE__ */ (0, $dsu7t.factory)($76a3326dd190eabd$var$name, $76a3326dd190eabd$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, prod: prod } = _ref;
    /**
   * Count the number of elements of a matrix, array or string.
   *
   * Syntax:
   *
   *     math.count(x)
   *
   * Examples:
   *
   *     math.count('hello world')        // returns 11
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.count(A)                    // returns 6
   *     math.count(math.range(1,6))      // returns 5
   *
   * See also:
   *
   *     size
   *
   * @param {string | Array | Matrix} x  A matrix or string
   * @return {number} An integer with the elements in `x`.
   */ return typed($76a3326dd190eabd$var$name, {
        string: function string(x) {
            return x.length;
        },
        'Matrix | Array': function Matrix__Array(x) {
            return prod(size(x));
        }
    });
});

});

parcelRegister("hCsVF", function(module, exports) {

$parcel$export(module.exports, "createCreateUnit", () => $cd3c6cfc69228a61$export$27641941eb5cadbb);

var $dsu7t = parcelRequire("dsu7t");
var $cd3c6cfc69228a61$var$name = 'createUnit';
var $cd3c6cfc69228a61$var$dependencies = [
    'typed',
    'Unit'
];
var $cd3c6cfc69228a61$export$27641941eb5cadbb = /* #__PURE__ */ (0, $dsu7t.factory)($cd3c6cfc69228a61$var$name, $cd3c6cfc69228a61$var$dependencies, (_ref)=>{
    var { typed: typed, Unit: Unit } = _ref;
    /**
   * Create a user-defined unit and register it with the Unit type.
   *
   * Syntax:
   *
   *     math.createUnit({
   *       baseUnit1: {
   *         aliases: [string, ...]
   *         prefixes: object
   *       },
   *       unit2: {
   *         definition: string,
   *         aliases: [string, ...]
   *         prefixes: object,
   *         offset: number
   *       },
   *       unit3: string    // Shortcut
   *     })
   *
   *     // Another shortcut:
   *     math.createUnit(string, unit : string, [object])
   *
   * Examples:
   *
   *     math.createUnit('foo')
   *     math.createUnit('knot', {definition: '0.514444444 m/s', aliases: ['knots', 'kt', 'kts']})
   *     math.createUnit('mph', '1 mile/hour')
   *     math.createUnit('km', math.unit(1000, 'm'))
   *
   * @param {string} name      The name of the new unit. Must be unique. Example: 'knot'
   * @param {string, UnitDefinition, Unit} definition      Definition of the unit in terms of existing units. For example, '0.514444444 m / s'.
   * @param {Object} options   (optional) An object containing any of the following properties:
   *     - `prefixes {string}` "none", "short", "long", "binary_short", or "binary_long". The default is "none".
   *     - `aliases {Array}` Array of strings. Example: ['knots', 'kt', 'kts']
   *     - `offset {Numeric}` An offset to apply when converting from the unit. For example, the offset for celsius is 273.15. Default is 0.
   *
   * See also:
   *
   *     unit
   *
   * @return {Unit} The new unit
   */ return typed($cd3c6cfc69228a61$var$name, {
        // General function signature. First parameter is an object where each property is the definition of a new unit. The object keys are the unit names and the values are the definitions. The values can be objects, strings, or Units. If a property is an empty object or an empty string, a new base unit is created. The second parameter is the options.
        'Object, Object': function Object_Object(obj, options) {
            return Unit.createUnit(obj, options);
        },
        // Same as above but without the options.
        Object: function Object(obj) {
            return Unit.createUnit(obj, {});
        },
        // Shortcut method for creating one unit.
        'string, Unit | string | Object, Object': function string_Unit__string__Object_Object(name, def, options) {
            var obj = {};
            obj[name] = def;
            return Unit.createUnit(obj, options);
        },
        // Same as above but without the options.
        'string, Unit | string | Object': function string_Unit__string__Object(name, def) {
            var obj = {};
            obj[name] = def;
            return Unit.createUnit(obj, {});
        },
        // Without a definition, creates a base unit.
        string: function string(name) {
            var obj = {};
            obj[name] = {};
            return Unit.createUnit(obj, {});
        }
    });
});

});

parcelRegister("lEGQX", function(module, exports) {

$parcel$export(module.exports, "createCross", () => $fc3e9329f76d3366$export$bc2585c0ed744c0e);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $fc3e9329f76d3366$var$name = 'cross';
var $fc3e9329f76d3366$var$dependencies = [
    'typed',
    'matrix',
    'subtract',
    'multiply'
];
var $fc3e9329f76d3366$export$bc2585c0ed744c0e = /* #__PURE__ */ (0, $dsu7t.factory)($fc3e9329f76d3366$var$name, $fc3e9329f76d3366$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, subtract: subtract, multiply: multiply } = _ref;
    /**
   * Calculate the cross product for two vectors in three dimensional space.
   * The cross product of `A = [a1, a2, a3]` and `B = [b1, b2, b3]` is defined
   * as:
   *
   *    cross(A, B) = [
   *      a2 * b3 - a3 * b2,
   *      a3 * b1 - a1 * b3,
   *      a1 * b2 - a2 * b1
   *    ]
   *
   * If one of the input vectors has a dimension greater than 1, the output
   * vector will be a 1x3 (2-dimensional) matrix.
   *
   * Syntax:
   *
   *    math.cross(x, y)
   *
   * Examples:
   *
   *    math.cross([1, 1, 0],   [0, 1, 1])       // Returns [1, -1, 1]
   *    math.cross([3, -3, 1],  [4, 9, 2])       // Returns [-15, -2, 39]
   *    math.cross([2, 3, 4],   [5, 6, 7])       // Returns [-3, 6, -3]
   *    math.cross([[1, 2, 3]], [[4], [5], [6]]) // Returns [[-3, 6, -3]]
   *
   * See also:
   *
   *    dot, multiply
   *
   * @param  {Array | Matrix} x   First vector
   * @param  {Array | Matrix} y   Second vector
   * @return {Array | Matrix}     Returns the cross product of `x` and `y`
   */ return typed($fc3e9329f76d3366$var$name, {
        'Matrix, Matrix': function Matrix_Matrix(x, y) {
            return matrix(_cross(x.toArray(), y.toArray()));
        },
        'Matrix, Array': function Matrix_Array(x, y) {
            return matrix(_cross(x.toArray(), y));
        },
        'Array, Matrix': function Array_Matrix(x, y) {
            return matrix(_cross(x, y.toArray()));
        },
        'Array, Array': _cross
    });
    /**
   * Calculate the cross product for two arrays
   * @param {Array} x  First vector
   * @param {Array} y  Second vector
   * @returns {Array} Returns the cross product of x and y
   * @private
   */ function _cross(x, y) {
        var highestDimension = Math.max((0, $d80Xp.arraySize)(x).length, (0, $d80Xp.arraySize)(y).length);
        x = (0, $d80Xp.squeeze)(x);
        y = (0, $d80Xp.squeeze)(y);
        var xSize = (0, $d80Xp.arraySize)(x);
        var ySize = (0, $d80Xp.arraySize)(y);
        if (xSize.length !== 1 || ySize.length !== 1 || xSize[0] !== 3 || ySize[0] !== 3) throw new RangeError("Vectors with length 3 expected (Size A = [" + xSize.join(', ') + '], B = [' + ySize.join(', ') + '])');
        var product = [
            subtract(multiply(x[1], y[2]), multiply(x[2], y[1])),
            subtract(multiply(x[2], y[0]), multiply(x[0], y[2])),
            subtract(multiply(x[0], y[1]), multiply(x[1], y[0]))
        ];
        if (highestDimension > 1) return [
            product
        ];
        else return product;
    }
});

});

parcelRegister("2vKgl", function(module, exports) {

$parcel$export(module.exports, "createCsc", () => $1d425ccddac047c7$export$a0beb298aa7a2962);

var $dsu7t = parcelRequire("dsu7t");

var $cOOcY = parcelRequire("cOOcY");

var $aS62J = parcelRequire("aS62J");
var $1d425ccddac047c7$var$name = 'csc';
var $1d425ccddac047c7$var$dependencies = [
    'typed',
    'BigNumber'
];
var $1d425ccddac047c7$export$a0beb298aa7a2962 = /* #__PURE__ */ (0, $dsu7t.factory)($1d425ccddac047c7$var$name, $1d425ccddac047c7$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    var trigUnit = (0, $aS62J.createTrigUnit)({
        typed: typed
    });
    /**
   * Calculate the cosecant of a value, defined as `csc(x) = 1/sin(x)`.
   *
   * To avoid confusion with the matrix cosecant, this function does not
   * apply to matrices.
   *
   * Syntax:
   *
   *    math.csc(x)
   *
   * Examples:
   *
   *    math.csc(2)      // returns number 1.099750170294617
   *    1 / math.sin(2)  // returns number 1.099750170294617
   *
   * See also:
   *
   *    sin, sec, cot
   *
   * @param {number | BigNumber | Complex | Unit} x  Function input
   * @return {number | BigNumber | Complex} Cosecant of x
   */ return typed($1d425ccddac047c7$var$name, {
        number: (0, $cOOcY.cscNumber),
        Complex: (x)=>x.csc(),
        BigNumber: (x)=>new _BigNumber(1).div(x.sin())
    }, trigUnit);
});

});

parcelRegister("5ZypV", function(module, exports) {

$parcel$export(module.exports, "createCsch", () => $45cd58c62d2c7182$export$9160aa3a39425fc9);

var $dsu7t = parcelRequire("dsu7t");

var $cOOcY = parcelRequire("cOOcY");
var $45cd58c62d2c7182$var$name = 'csch';
var $45cd58c62d2c7182$var$dependencies = [
    'typed',
    'BigNumber'
];
var $45cd58c62d2c7182$export$9160aa3a39425fc9 = /* #__PURE__ */ (0, $dsu7t.factory)($45cd58c62d2c7182$var$name, $45cd58c62d2c7182$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic cosecant of a value,
   * defined as `csch(x) = 1 / sinh(x)`.
   *
   * To avoid confusion with the matrix hyperbolic cosecant, this function
   * does not apply to matrices.
   *
   * Syntax:
   *
   *    math.csch(x)
   *
   * Examples:
   *
   *    // csch(x) = 1/ sinh(x)
   *    math.csch(0.5)       // returns 1.9190347513349437
   *    1 / math.sinh(0.5)   // returns 1.9190347513349437
   *
   * See also:
   *
   *    sinh, sech, coth
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic cosecant of x
   */ return typed($45cd58c62d2c7182$var$name, {
        number: (0, $cOOcY.cschNumber),
        Complex: (x)=>x.csch(),
        BigNumber: (x)=>new _BigNumber(1).div(x.sinh())
    });
});

});

parcelRegister("cwL5l", function(module, exports) {

$parcel$export(module.exports, "createCtranspose", () => $91ecff59eccd7e2c$export$5d07146b3894f212);

var $dsu7t = parcelRequire("dsu7t");
var $91ecff59eccd7e2c$var$name = 'ctranspose';
var $91ecff59eccd7e2c$var$dependencies = [
    'typed',
    'transpose',
    'conj'
];
var $91ecff59eccd7e2c$export$5d07146b3894f212 = /* #__PURE__ */ (0, $dsu7t.factory)($91ecff59eccd7e2c$var$name, $91ecff59eccd7e2c$var$dependencies, (_ref)=>{
    var { typed: typed, transpose: transpose, conj: conj } = _ref;
    /**
   * Transpose and complex conjugate a matrix. All values of the matrix are
   * reflected over its main diagonal and then the complex conjugate is
   * taken. This is equivalent to complex conjugation for scalars and
   * vectors.
   *
   * Syntax:
   *
   *     math.ctranspose(x)
   *
   * Examples:
   *
   *     const A = [[1, 2, 3], [4, 5, math.complex(6,7)]]
   *     math.ctranspose(A)      // returns [[1, 4], [2, 5], [3, {re:6,im:-7}]]
   *
   * See also:
   *
   *     transpose, diag, inv, subset, squeeze
   *
   * @param {Array | Matrix} x  Matrix to be ctransposed
   * @return {Array | Matrix}   The ctransposed matrix
   */ return typed($91ecff59eccd7e2c$var$name, {
        any: function any(x) {
            return conj(transpose(x));
        }
    });
});

});

parcelRegister("80OuO", function(module, exports) {

$parcel$export(module.exports, "createCube", () => $5d557e49c6e36ef2$export$ce223d612b94804b);

var $dsu7t = parcelRequire("dsu7t");

var $dmcGu = parcelRequire("dmcGu");
var $5d557e49c6e36ef2$var$name = 'cube';
var $5d557e49c6e36ef2$var$dependencies = [
    'typed'
];
var $5d557e49c6e36ef2$export$ce223d612b94804b = /* #__PURE__ */ (0, $dsu7t.factory)($5d557e49c6e36ef2$var$name, $5d557e49c6e36ef2$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the cube of a value, `x * x * x`.
   * To avoid confusion with `pow(M,3)`, this function does not apply to matrices.
   * If you wish to cube every entry of a matrix, see the examples.
   *
   * Syntax:
   *
   *    math.cube(x)
   *
   * Examples:
   *
   *    math.cube(2)            // returns number 8
   *    math.pow(2, 3)          // returns number 8
   *    math.cube(4)            // returns number 64
   *    4 * 4 * 4               // returns number 64
   *
   *    math.map([1, 2, 3, 4], math.cube) // returns Array [1, 8, 27, 64]
   *
   * See also:
   *
   *    multiply, square, pow, cbrt
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit} x  Number for which to calculate the cube
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit} Cube of x
   */ return typed($5d557e49c6e36ef2$var$name, {
        number: (0, $dmcGu.cubeNumber),
        Complex: function Complex(x) {
            return x.mul(x).mul(x); // Is faster than pow(x, 3)
        },
        BigNumber: function BigNumber(x) {
            return x.times(x).times(x);
        },
        bigint: function bigint(x) {
            return x * x * x;
        },
        Fraction: function Fraction(x) {
            return x.pow(3); // Is faster than mul()mul()mul()
        },
        Unit: function Unit(x) {
            return x.pow(3);
        }
    });
});

});

parcelRegister("evEiW", function(module, exports) {

$parcel$export(module.exports, "createCumSum", () => $a90339910f411dd4$export$e11ffe2ce577c262);

var $20mkw = parcelRequire("20mkw");

var $dsu7t = parcelRequire("dsu7t");

var $3Wq9u = parcelRequire("3Wq9u");

var $a2CJg = parcelRequire("a2CJg");

var $d80Xp = parcelRequire("d80Xp");

var $fFsPN = parcelRequire("fFsPN");
var $a90339910f411dd4$var$name = 'cumsum';
var $a90339910f411dd4$var$dependencies = [
    'typed',
    'add',
    'unaryPlus'
];
var $a90339910f411dd4$export$e11ffe2ce577c262 = /* #__PURE__ */ (0, $dsu7t.factory)($a90339910f411dd4$var$name, $a90339910f411dd4$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, unaryPlus: unaryPlus } = _ref;
    /**
   * Compute the cumulative sum of a matrix or a list with values.
   * In case of a (multi dimensional) array or matrix, the cumulative sums
   * along a specified dimension (defaulting to the first) will be calculated.
   *
   * Syntax:
   *
   *     math.cumsum(a, b, c, ...)
   *     math.cumsum(A)
   *
   * Examples:
   *
   *     math.cumsum(2, 1, 4, 3)               // returns [2, 3, 7, 10]
   *     math.cumsum([2, 1, 4, 3])             // returns [2, 3, 7, 10]
   *     math.cumsum([[1, 2], [3, 4]])         // returns [[1, 2], [4, 6]]
   *     math.cumsum([[1, 2], [3, 4]], 0)      // returns [[1, 2], [4, 6]]
   *     math.cumsum([[1, 2], [3, 4]], 1)      // returns [[1, 3], [3, 7]]
   *     math.cumsum([[2, 5], [4, 3], [1, 7]]) // returns [[2, 5], [6, 8], [7, 15]]
   *
   * See also:
   *
   *    mean, median, min, max, prod, std, variance, sum
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The cumulative sum of all values
   */ return typed($a90339910f411dd4$var$name, {
        // sum([a, b, c, d, ...])
        Array: _cumsum,
        Matrix: function Matrix(matrix) {
            return matrix.create(_cumsum(matrix.valueOf(), matrix.datatype()));
        },
        // sum([a, b, c, d, ...], dim)
        'Array, number | BigNumber': _ncumSumDim,
        'Matrix, number | BigNumber': function Matrix_number__BigNumber(matrix, dim) {
            return matrix.create(_ncumSumDim(matrix.valueOf(), dim), matrix.datatype());
        },
        // cumsum(a, b, c, d, ...)
        '...': function _(args) {
            if ((0, $20mkw.containsCollections)(args)) throw new TypeError('All values expected to be scalar in function cumsum');
            return _cumsum(args);
        }
    });
    /**
     * Recursively calculate the cumulative sum of an n-dimensional array
     * @param {Array} array
     * @return {number} cumsum
     * @private
     */ function _cumsum(array) {
        try {
            return _cumsummap(array);
        } catch (err) {
            throw (0, $a2CJg.improveErrorMessage)(err, $a90339910f411dd4$var$name);
        }
    }
    function _cumsummap(array) {
        if (array.length === 0) return [];
        var sums = [
            unaryPlus(array[0])
        ]; // unaryPlus converts to number if need be
        for(var i = 1; i < array.length; ++i)// Must use add below and not addScalar for the case of summing a
        // 2+-dimensional array along the 0th dimension (the row vectors,
        // or higher-d analogues, are literally added to each other).
        sums.push(add(sums[i - 1], array[i]));
        return sums;
    }
    function _ncumSumDim(array, dim) {
        var size = (0, $d80Xp.arraySize)(array);
        if (dim < 0 || dim >= size.length) // TODO: would be more clear when throwing a DimensionError here
        throw new (0, $fFsPN.IndexError)(dim, size.length);
        try {
            return _cumsumDimensional(array, dim);
        } catch (err) {
            throw (0, $a2CJg.improveErrorMessage)(err, $a90339910f411dd4$var$name);
        }
    }
    /* Possible TODO: Refactor _reduce in collection.js to be able to work here as well */ function _cumsumDimensional(mat, dim) {
        var i, ret, tran;
        if (dim <= 0) {
            var initialValue = mat[0][0];
            if (!Array.isArray(initialValue)) return _cumsummap(mat);
            else {
                tran = (0, $3Wq9u._switch)(mat);
                ret = [];
                for(i = 0; i < tran.length; i++)ret[i] = _cumsumDimensional(tran[i], dim - 1);
                return ret;
            }
        } else {
            ret = [];
            for(i = 0; i < mat.length; i++)ret[i] = _cumsumDimensional(mat[i], dim - 1);
            return ret;
        }
    }
});

});
parcelRegister("a2CJg", function(module, exports) {

$parcel$export(module.exports, "improveErrorMessage", () => $74f82213ef833a93$export$c8994973cec629ae);

var $edQYF = parcelRequire("edQYF");
function $74f82213ef833a93$export$c8994973cec629ae(err, fnName, value) {
    // TODO: add information with the index (also needs transform in expression parser)
    var details;
    if (String(err).includes('Unexpected type')) {
        details = arguments.length > 2 ? ' (type: ' + (0, $edQYF.typeOf)(value) + ', value: ' + JSON.stringify(value) + ')' : ' (type: ' + err.data.actual + ')';
        return new TypeError('Cannot calculate ' + fnName + ', unexpected type of argument' + details);
    }
    if (String(err).includes('complex numbers')) {
        details = arguments.length > 2 ? ' (type: ' + (0, $edQYF.typeOf)(value) + ', value: ' + JSON.stringify(value) + ')' : '';
        return new TypeError('Cannot calculate ' + fnName + ', no ordering relation is defined for complex numbers' + details);
    }
    return err;
}

});


parcelRegister("20nO0", function(module, exports) {

$parcel$export(module.exports, "createDeepEqual", () => $175e0c20eeeefd6d$export$b1b11fc839367b58);

var $dsu7t = parcelRequire("dsu7t");
var $175e0c20eeeefd6d$var$name = 'deepEqual';
var $175e0c20eeeefd6d$var$dependencies = [
    'typed',
    'equal'
];
var $175e0c20eeeefd6d$export$b1b11fc839367b58 = /* #__PURE__ */ (0, $dsu7t.factory)($175e0c20eeeefd6d$var$name, $175e0c20eeeefd6d$var$dependencies, (_ref)=>{
    var { typed: typed, equal: equal } = _ref;
    /**
   * Test element wise whether two matrices are equal.
   * The function accepts both matrices and scalar values.
   *
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.deepEqual(x, y)
   *
   * Examples:
   *
   *    math.deepEqual(2, 4)   // returns false
   *
   *    a = [2, 5, 1]
   *    b = [2, 7, 1]
   *
   *    math.deepEqual(a, b)   // returns false
   *    math.equal(a, b)       // returns [true, false, true]
   *
   * See also:
   *
   *    equal, unequal
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First matrix to compare
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second matrix to compare
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
   *            Returns true when the input matrices have the same size and each of their elements is equal.
   */ return typed($175e0c20eeeefd6d$var$name, {
        'any, any': function any_any(x, y) {
            return _deepEqual(x.valueOf(), y.valueOf());
        }
    });
    /**
   * Test whether two arrays have the same size and all elements are equal
   * @param {Array | *} x
   * @param {Array | *} y
   * @return {boolean} Returns true if both arrays are deep equal
   */ function _deepEqual(x, y) {
        if (Array.isArray(x)) {
            if (Array.isArray(y)) {
                var len = x.length;
                if (len !== y.length) return false;
                for(var i = 0; i < len; i++){
                    if (!_deepEqual(x[i], y[i])) return false;
                }
                return true;
            } else return false;
        } else {
            if (Array.isArray(y)) return false;
            else return equal(x, y);
        }
    }
});

});

parcelRegister("d6VMl", function(module, exports) {

$parcel$export(module.exports, "createDenseMatrixClass", () => $98b8a78a5f91eb37$export$1a088ca8dd364cd1);
// deno-lint-ignore-file no-this-alias

var $edQYF = parcelRequire("edQYF");

var $d80Xp = parcelRequire("d80Xp");

var $j2hDb = parcelRequire("j2hDb");

var $6NnhX = parcelRequire("6NnhX");

var $9v8q6 = parcelRequire("9v8q6");

var $7asMt = parcelRequire("7asMt");

var $dsu7t = parcelRequire("dsu7t");

var $bLcpf = parcelRequire("bLcpf");
var $98b8a78a5f91eb37$var$name = 'DenseMatrix';
var $98b8a78a5f91eb37$var$dependencies = [
    'Matrix'
];
var $98b8a78a5f91eb37$export$1a088ca8dd364cd1 = /* #__PURE__ */ (0, $dsu7t.factory)($98b8a78a5f91eb37$var$name, $98b8a78a5f91eb37$var$dependencies, (_ref)=>{
    var { Matrix: Matrix } = _ref;
    /**
   * Dense Matrix implementation. A regular, dense matrix, supporting multi-dimensional matrices. This is the default matrix type.
   * @class DenseMatrix
   * @enum {{ value, index: number[] }}
   */ function DenseMatrix(data, datatype) {
        if (!(this instanceof DenseMatrix)) throw new SyntaxError('Constructor must be called with the new operator');
        if (datatype && !(0, $edQYF.isString)(datatype)) throw new Error('Invalid datatype: ' + datatype);
        if ((0, $edQYF.isMatrix)(data)) {
            // check data is a DenseMatrix
            if (data.type === 'DenseMatrix') {
                // clone data & size
                this._data = (0, $9v8q6.clone)(data._data);
                this._size = (0, $9v8q6.clone)(data._size);
                this._datatype = datatype || data._datatype;
            } else {
                // build data from existing matrix
                this._data = data.toArray();
                this._size = data.size();
                this._datatype = datatype || data._datatype;
            }
        } else if (data && (0, $edQYF.isArray)(data.data) && (0, $edQYF.isArray)(data.size)) {
            // initialize fields from JSON representation
            this._data = data.data;
            this._size = data.size;
            // verify the dimensions of the array
            (0, $d80Xp.validate)(this._data, this._size);
            this._datatype = datatype || data.datatype;
        } else if ((0, $edQYF.isArray)(data)) {
            // replace nested Matrices with Arrays
            this._data = preprocess(data);
            // get the dimensions of the array
            this._size = (0, $d80Xp.arraySize)(this._data);
            // verify the dimensions of the array, TODO: compute size while processing array
            (0, $d80Xp.validate)(this._data, this._size);
            // data type unknown
            this._datatype = datatype;
        } else if (data) // unsupported type
        throw new TypeError('Unsupported type of data (' + (0, $edQYF.typeOf)(data) + ')');
        else {
            // nothing provided
            this._data = [];
            this._size = [
                0
            ];
            this._datatype = datatype;
        }
    }
    DenseMatrix.prototype = new Matrix();
    /**
   * Create a new DenseMatrix
   */ DenseMatrix.prototype.createDenseMatrix = function(data, datatype) {
        return new DenseMatrix(data, datatype);
    };
    /**
   * Attach type information
   */ Object.defineProperty(DenseMatrix, 'name', {
        value: 'DenseMatrix'
    });
    DenseMatrix.prototype.constructor = DenseMatrix;
    DenseMatrix.prototype.type = 'DenseMatrix';
    DenseMatrix.prototype.isDenseMatrix = true;
    /**
   * Get the matrix type
   *
   * Usage:
   *    const matrixType = matrix.getDataType()  // retrieves the matrix type
   *
   * @memberOf DenseMatrix
   * @return {string}   type information; if multiple types are found from the Matrix, it will return "mixed"
   */ DenseMatrix.prototype.getDataType = function() {
        return (0, $d80Xp.getArrayDataType)(this._data, (0, $edQYF.typeOf));
    };
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()  // retrieve storage format
   *
   * @memberof DenseMatrix
   * @return {string}           The storage format.
   */ DenseMatrix.prototype.storage = function() {
        return 'dense';
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()   // retrieve matrix datatype
   *
   * @memberof DenseMatrix
   * @return {string}           The datatype.
   */ DenseMatrix.prototype.datatype = function() {
        return this._datatype;
    };
    /**
   * Create a new DenseMatrix
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {string} [datatype]
   */ DenseMatrix.prototype.create = function(data, datatype) {
        return new DenseMatrix(data, datatype);
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @memberof DenseMatrix
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ DenseMatrix.prototype.subset = function(index, replacement, defaultValue) {
        switch(arguments.length){
            case 1:
                return _get(this, index);
            // intentional fall through
            case 2:
            case 3:
                return _set(this, index, replacement, defaultValue);
            default:
                throw new SyntaxError('Wrong number of arguments');
        }
    };
    /**
   * Get a single element from the matrix.
   * @memberof DenseMatrix
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ DenseMatrix.prototype.get = function(index) {
        return (0, $d80Xp.get)(this._data, index);
    };
    /**
   * Replace a single element in the matrix.
   * @memberof DenseMatrix
   * @param {number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {DenseMatrix} self
   */ DenseMatrix.prototype.set = function(index, value, defaultValue) {
        if (!(0, $edQYF.isArray)(index)) throw new TypeError('Array expected');
        if (index.length < this._size.length) throw new (0, $7asMt.DimensionError)(index.length, this._size.length, '<');
        var i, ii, indexI;
        // enlarge matrix when needed
        var size = index.map(function(i) {
            return i + 1;
        });
        _fit(this, size, defaultValue);
        // traverse over the dimensions
        var data = this._data;
        for(i = 0, ii = index.length - 1; i < ii; i++){
            indexI = index[i];
            (0, $d80Xp.validateIndex)(indexI, data.length);
            data = data[indexI];
        }
        // set new value
        indexI = index[index.length - 1];
        (0, $d80Xp.validateIndex)(indexI, data.length);
        data[indexI] = value;
        return this;
    };
    /**
   * Get a submatrix of this matrix
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix
   * @param {Index} index   Zero-based index
   * @private
   */ function _get(matrix, index) {
        if (!(0, $edQYF.isIndex)(index)) throw new TypeError('Invalid index');
        var isScalar = index.isScalar();
        if (isScalar) // return a scalar
        return matrix.get(index.min());
        else {
            // validate dimensions
            var size = index.size();
            if (size.length !== matrix._size.length) throw new (0, $7asMt.DimensionError)(size.length, matrix._size.length);
            // validate if any of the ranges in the index is out of range
            var min = index.min();
            var max = index.max();
            for(var i = 0, ii = matrix._size.length; i < ii; i++){
                (0, $d80Xp.validateIndex)(min[i], matrix._size[i]);
                (0, $d80Xp.validateIndex)(max[i], matrix._size[i]);
            }
            // retrieve submatrix
            var returnMatrix = new DenseMatrix([]);
            var submatrix = _getSubmatrix(matrix._data, index);
            returnMatrix._size = submatrix.size;
            returnMatrix._datatype = matrix._datatype;
            returnMatrix._data = submatrix.data;
            return returnMatrix;
        }
    }
    /**
   * Get a submatrix of a multi dimensional matrix.
   * Index is not checked for correct number or length of dimensions.
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {Index} index
   * @return {Array} submatrix
   * @private
   */ function _getSubmatrix(data, index) {
        var maxDepth = index.size().length - 1;
        var size = Array(maxDepth);
        return {
            data: getSubmatrixRecursive(data),
            size: size
        };
        function getSubmatrixRecursive(data) {
            var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var ranges = index.dimension(depth);
            size[depth] = ranges.size()[0];
            if (depth < maxDepth) return ranges.map((rangeIndex)=>{
                (0, $d80Xp.validateIndex)(rangeIndex, data.length);
                return getSubmatrixRecursive(data[rangeIndex], depth + 1);
            }).valueOf();
            else return ranges.map((rangeIndex)=>{
                (0, $d80Xp.validateIndex)(rangeIndex, data.length);
                return data[rangeIndex];
            }).valueOf();
        }
    }
    /**
   * Replace a submatrix in this matrix
   * Indexes are zero-based.
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix
   * @param {Index} index
   * @param {DenseMatrix | Array | *} submatrix
   * @param {*} defaultValue          Default value, filled in on new entries when
   *                                  the matrix is resized.
   * @return {DenseMatrix} matrix
   * @private
   */ function _set(matrix, index, submatrix, defaultValue) {
        if (!index || index.isIndex !== true) throw new TypeError('Invalid index');
        // get index size and check whether the index contains a single value
        var iSize = index.size();
        var isScalar = index.isScalar();
        // calculate the size of the submatrix, and convert it into an Array if needed
        var sSize;
        if ((0, $edQYF.isMatrix)(submatrix)) {
            sSize = submatrix.size();
            submatrix = submatrix.valueOf();
        } else sSize = (0, $d80Xp.arraySize)(submatrix);
        if (isScalar) {
            // set a scalar
            // check whether submatrix is a scalar
            if (sSize.length !== 0) throw new TypeError('Scalar expected');
            matrix.set(index.min(), submatrix, defaultValue);
        } else {
            // set a submatrix
            // broadcast submatrix
            if (!(0, $9v8q6.deepStrictEqual)(sSize, iSize)) try {
                if (sSize.length === 0) submatrix = (0, $d80Xp.broadcastTo)([
                    submatrix
                ], iSize);
                else submatrix = (0, $d80Xp.broadcastTo)(submatrix, iSize);
                sSize = (0, $d80Xp.arraySize)(submatrix);
            } catch (_unused) {}
            // validate dimensions
            if (iSize.length < matrix._size.length) throw new (0, $7asMt.DimensionError)(iSize.length, matrix._size.length, '<');
            if (sSize.length < iSize.length) {
                // calculate number of missing outer dimensions
                var i = 0;
                var outer = 0;
                while(iSize[i] === 1 && sSize[i] === 1)i++;
                while(iSize[i] === 1){
                    outer++;
                    i++;
                }
                // unsqueeze both outer and inner dimensions
                submatrix = (0, $d80Xp.unsqueeze)(submatrix, iSize.length, outer, sSize);
            }
            // check whether the size of the submatrix matches the index size
            if (!(0, $9v8q6.deepStrictEqual)(iSize, sSize)) throw new (0, $7asMt.DimensionError)(iSize, sSize, '>');
            // enlarge matrix when needed
            var size = index.max().map(function(i) {
                return i + 1;
            });
            _fit(matrix, size, defaultValue);
            // insert the sub matrix
            _setSubmatrix(matrix._data, index, submatrix);
        }
        return matrix;
    }
    /**
   * Replace a submatrix of a multi dimensional matrix.
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {Index} index
   * @param {Array} submatrix
   * @private
   */ function _setSubmatrix(data, index, submatrix) {
        var maxDepth = index.size().length - 1;
        setSubmatrixRecursive(data, submatrix);
        function setSubmatrixRecursive(data, submatrix) {
            var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var range = index.dimension(depth);
            if (depth < maxDepth) range.forEach((rangeIndex, i)=>{
                (0, $d80Xp.validateIndex)(rangeIndex, data.length);
                setSubmatrixRecursive(data[rangeIndex], submatrix[i[0]], depth + 1);
            });
            else range.forEach((rangeIndex, i)=>{
                (0, $d80Xp.validateIndex)(rangeIndex, data.length);
                data[rangeIndex] = submatrix[i[0]];
            });
        }
    }
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @memberof DenseMatrix
   * @param {number[] || Matrix} size The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ DenseMatrix.prototype.resize = function(size, defaultValue, copy) {
        // validate arguments
        if (!(0, $edQYF.isCollection)(size)) throw new TypeError('Array or Matrix expected');
        // SparseMatrix input is always 2d, flatten this into 1d if it's indeed a vector
        var sizeArray = size.valueOf().map((value)=>{
            return Array.isArray(value) && value.length === 1 ? value[0] : value;
        });
        // matrix to resize
        var m = copy ? this.clone() : this;
        // resize matrix
        return _resize(m, sizeArray, defaultValue);
    };
    function _resize(matrix, size, defaultValue) {
        // check size
        if (size.length === 0) {
            // first value in matrix
            var v = matrix._data;
            // go deep
            while((0, $edQYF.isArray)(v))v = v[0];
            return v;
        }
        // resize matrix
        matrix._size = size.slice(0); // copy the array
        matrix._data = (0, $d80Xp.resize)(matrix._data, matrix._size, defaultValue);
        // return matrix
        return matrix;
    }
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * NOTE: This might be better suited to copy by default, instead of modifying
   *       in place. For now, it operates in place to remain consistent with
   *       resize().
   *
   * @memberof DenseMatrix
   * @param {number[]} size           The new size the matrix should have.
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ DenseMatrix.prototype.reshape = function(size, copy) {
        var m = copy ? this.clone() : this;
        m._data = (0, $d80Xp.reshape)(m._data, size);
        var currentLength = m._size.reduce((length, size)=>length * size);
        m._size = (0, $d80Xp.processSizesWildcard)(size, currentLength);
        return m;
    };
    /**
   * Enlarge the matrix when it is smaller than given size.
   * If the matrix is larger or equal sized, nothing is done.
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix           The matrix to be resized
   * @param {number[]} size
   * @param {*} defaultValue          Default value, filled in on new entries.
   * @private
   */ function _fit(matrix, size, defaultValue) {
        var // copy the array
        newSize = matrix._size.slice(0);
        var changed = false;
        // add dimensions when needed
        while(newSize.length < size.length){
            newSize.push(0);
            changed = true;
        }
        // enlarge size when needed
        for(var i = 0, ii = size.length; i < ii; i++)if (size[i] > newSize[i]) {
            newSize[i] = size[i];
            changed = true;
        }
        if (changed) // resize only when size is changed
        _resize(matrix, newSize, defaultValue);
    }
    /**
   * Create a clone of the matrix
   * @memberof DenseMatrix
   * @return {DenseMatrix} clone
   */ DenseMatrix.prototype.clone = function() {
        var m = new DenseMatrix({
            data: (0, $9v8q6.clone)(this._data),
            size: (0, $9v8q6.clone)(this._size),
            datatype: this._datatype
        });
        return m;
    };
    /**
   * Retrieve the size of the matrix.
   * @memberof DenseMatrix
   * @returns {number[]} size
   */ DenseMatrix.prototype.size = function() {
        return this._size.slice(0); // return a clone of _size
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @memberof DenseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} skipZeros   If true, the callback function is invoked only for non-zero entries
   * @param {boolean} isUnary     If true, the callback function is invoked with one parameter
   *
   * @return {DenseMatrix} matrix
   */ DenseMatrix.prototype.map = function(callback) {
        var skipZeros = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var isUnary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var me = this;
        var maxDepth = me._size.length - 1;
        if (maxDepth < 0) return me.clone();
        var fastCallback = (0, $bLcpf.optimizeCallback)(callback, me, 'map', isUnary);
        var fastCallbackFn = fastCallback.fn;
        var result = me.create(undefined, me._datatype);
        result._size = me._size;
        if (isUnary || fastCallback.isUnary) {
            result._data = iterateUnary(me._data);
            return result;
        }
        if (maxDepth === 0) {
            var inputData = me.valueOf();
            var data = Array(inputData.length);
            for(var i = 0; i < inputData.length; i++)data[i] = fastCallbackFn(inputData[i], [
                i
            ], me);
            result._data = data;
            return result;
        }
        var index = [];
        result._data = iterate(me._data);
        return result;
        function iterate(data) {
            var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var result = Array(data.length);
            if (depth < maxDepth) for(var _i = 0; _i < data.length; _i++){
                index[depth] = _i;
                result[_i] = iterate(data[_i], depth + 1);
            }
            else for(var _i2 = 0; _i2 < data.length; _i2++){
                index[depth] = _i2;
                result[_i2] = fastCallbackFn(data[_i2], index.slice(), me);
            }
            return result;
        }
        function iterateUnary(data) {
            var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var result = Array(data.length);
            if (depth < maxDepth) for(var _i3 = 0; _i3 < data.length; _i3++)result[_i3] = iterateUnary(data[_i3], depth + 1);
            else for(var _i4 = 0; _i4 < data.length; _i4++)result[_i4] = fastCallbackFn(data[_i4]);
            return result;
        }
    };
    /**
   * Execute a callback function on each entry of the matrix.
   * @memberof DenseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} skipZeros   If true, the callback function is invoked only for non-zero entries
   * @param {boolean} isUnary     If true, the callback function is invoked with one parameter
   */ DenseMatrix.prototype.forEach = function(callback) {
        var skipZeros = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var isUnary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var me = this;
        var maxDepth = me._size.length - 1;
        if (maxDepth < 0) return;
        var fastCallback = (0, $bLcpf.optimizeCallback)(callback, me, 'map', isUnary);
        var fastCallbackFn = fastCallback.fn;
        if (isUnary || fastCallback.isUnary) {
            iterateUnary(me._data);
            return;
        }
        if (maxDepth === 0) {
            for(var i = 0; i < me._data.length; i++)fastCallbackFn(me._data[i], [
                i
            ], me);
            return;
        }
        var index = [];
        iterate(me._data);
        function iterate(data) {
            var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            if (depth < maxDepth) for(var _i5 = 0; _i5 < data.length; _i5++){
                index[depth] = _i5;
                iterate(data[_i5], depth + 1);
            }
            else for(var _i6 = 0; _i6 < data.length; _i6++){
                index[depth] = _i6;
                fastCallbackFn(data[_i6], index.slice(), me);
            }
        }
        function iterateUnary(data) {
            var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            if (depth < maxDepth) for(var _i7 = 0; _i7 < data.length; _i7++)iterateUnary(data[_i7], depth + 1);
            else for(var _i8 = 0; _i8 < data.length; _i8++)fastCallbackFn(data[_i8]);
        }
    };
    /**
   * Iterate over the matrix elements
   * @return {Iterable<{ value, index: number[] }>}
   */ DenseMatrix.prototype[Symbol.iterator] = function*() {
        var maxDepth = this._size.length - 1;
        if (maxDepth < 0) return;
        if (maxDepth === 0) {
            for(var i = 0; i < this._data.length; i++)yield {
                value: this._data[i],
                index: [
                    i
                ]
            };
            return;
        }
        // Multi-dimensional matrix: iterate over all elements
        var index = Array(maxDepth + 1).fill(0);
        var totalElements = this._size.reduce((a, b)=>a * b, 1);
        for(var count = 0; count < totalElements; count++){
            // Traverse to the current element using indices
            var current = this._data;
            for(var d = 0; d < maxDepth; d++)current = current[index[d]];
            yield {
                value: current[index[maxDepth]],
                index: index.slice()
            };
            // Increment indices for next element
            for(var _d = maxDepth; _d >= 0; _d--){
                index[_d]++;
                if (index[_d] < this._size[_d]) break;
                index[_d] = 0;
            }
        }
    };
    /**
   * Returns an array containing the rows of a 2D matrix
   * @returns {Array<Matrix>}
   */ DenseMatrix.prototype.rows = function() {
        var result = [];
        var s = this.size();
        if (s.length !== 2) throw new TypeError('Rows can only be returned for a 2D matrix.');
        var data = this._data;
        for (var row of data)result.push(new DenseMatrix([
            row
        ], this._datatype));
        return result;
    };
    /**
   * Returns an array containing the columns of a 2D matrix
   * @returns {Array<Matrix>}
   */ DenseMatrix.prototype.columns = function() {
        var _this = this;
        var result = [];
        var s = this.size();
        if (s.length !== 2) throw new TypeError('Rows can only be returned for a 2D matrix.');
        var data = this._data;
        var _loop = function _loop(i) {
            var col = data.map((row)=>[
                    row[i]
                ]);
            result.push(new DenseMatrix(col, _this._datatype));
        };
        for(var i = 0; i < s[1]; i++)_loop(i);
        return result;
    };
    /**
   * Create an Array with a copy of the data of the DenseMatrix
   * @memberof DenseMatrix
   * @returns {Array} array
   */ DenseMatrix.prototype.toArray = function() {
        return (0, $9v8q6.clone)(this._data);
    };
    /**
   * Get the primitive value of the DenseMatrix: a multidimensional array
   * @memberof DenseMatrix
   * @returns {Array} array
   */ DenseMatrix.prototype.valueOf = function() {
        return this._data;
    };
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @memberof DenseMatrix
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ DenseMatrix.prototype.format = function(options) {
        return (0, $j2hDb.format)(this._data, options);
    };
    /**
   * Get a string representation of the matrix
   * @memberof DenseMatrix
   * @returns {string} str
   */ DenseMatrix.prototype.toString = function() {
        return (0, $j2hDb.format)(this._data);
    };
    /**
   * Get a JSON representation of the matrix
   * @memberof DenseMatrix
   * @returns {Object}
   */ DenseMatrix.prototype.toJSON = function() {
        return {
            mathjs: 'DenseMatrix',
            data: this._data,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Get the kth Matrix diagonal.
   *
   * @memberof DenseMatrix
   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
   *
   * @returns {Matrix}                     The matrix with the diagonal values.
   */ DenseMatrix.prototype.diagonal = function(k) {
        // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $edQYF.isBigNumber)(k)) k = k.toNumber();
            // is must be an integer
            if (!(0, $edQYF.isNumber)(k) || !(0, $6NnhX.isInteger)(k)) throw new TypeError('The parameter k must be an integer number');
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0;
        // rows & columns
        var rows = this._size[0];
        var columns = this._size[1];
        // number diagonal values
        var n = Math.min(rows - kSub, columns - kSuper);
        // x is a matrix get diagonal from matrix
        var data = [];
        // loop rows
        for(var i = 0; i < n; i++)data[i] = this._data[i + kSub][i + kSuper];
        // create DenseMatrix
        return new DenseMatrix({
            data: data,
            size: [
                n
            ],
            datatype: this._datatype
        });
    };
    /**
   * Create a diagonal matrix.
   *
   * @memberof DenseMatrix
   * @param {Array} size                     The matrix size.
   * @param {number | Matrix | Array } value The values for the diagonal.
   * @param {number | BigNumber} [k=0]       The kth diagonal where the vector will be filled in.
   * @param {number} [defaultValue]          The default value for non-diagonal
   * @param {string} [datatype]              The datatype for the diagonal
   *
   * @returns {DenseMatrix}
   */ DenseMatrix.diagonal = function(size, value, k, defaultValue) {
        if (!(0, $edQYF.isArray)(size)) throw new TypeError('Array expected, size parameter');
        if (size.length !== 2) throw new Error('Only two dimensions matrix are supported');
        // map size & validate
        size = size.map(function(s) {
            // check it is a big number
            if ((0, $edQYF.isBigNumber)(s)) // convert it
            s = s.toNumber();
            // validate arguments
            if (!(0, $edQYF.isNumber)(s) || !(0, $6NnhX.isInteger)(s) || s < 1) throw new Error('Size values must be positive integers');
            return s;
        });
        // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $edQYF.isBigNumber)(k)) k = k.toNumber();
            // is must be an integer
            if (!(0, $edQYF.isNumber)(k) || !(0, $6NnhX.isInteger)(k)) throw new TypeError('The parameter k must be an integer number');
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0;
        // rows and columns
        var rows = size[0];
        var columns = size[1];
        // number of non-zero items
        var n = Math.min(rows - kSub, columns - kSuper);
        // value extraction function
        var _value;
        // check value
        if ((0, $edQYF.isArray)(value)) {
            // validate array
            if (value.length !== n) // number of values in array must be n
            throw new Error('Invalid value array length');
            // define function
            _value = function _value(i) {
                // return value @ i
                return value[i];
            };
        } else if ((0, $edQYF.isMatrix)(value)) {
            // matrix size
            var ms = value.size();
            // validate matrix
            if (ms.length !== 1 || ms[0] !== n) // number of values in array must be n
            throw new Error('Invalid matrix length');
            // define function
            _value = function _value(i) {
                // return value @ i
                return value.get([
                    i
                ]);
            };
        } else // define function
        _value = function _value() {
            // return value
            return value;
        };
        // discover default value if needed
        if (!defaultValue) // check first value in array
        defaultValue = (0, $edQYF.isBigNumber)(_value(0)) ? _value(0).mul(0) // trick to create a BigNumber with value zero
         : 0;
        // empty array
        var data = [];
        // check we need to resize array
        if (size.length > 0) {
            // resize array
            data = (0, $d80Xp.resize)(data, size, defaultValue);
            // fill diagonal
            for(var d = 0; d < n; d++)data[d + kSub][d + kSuper] = _value(d);
        }
        // create DenseMatrix
        return new DenseMatrix({
            data: data,
            size: [
                rows,
                columns
            ]
        });
    };
    /**
   * Generate a matrix from a JSON object
   * @memberof DenseMatrix
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "DenseMatrix", data: [], size: []}`,
   *                       where mathjs is optional
   * @returns {DenseMatrix}
   */ DenseMatrix.fromJSON = function(json) {
        return new DenseMatrix(json);
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @memberof DenseMatrix
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ DenseMatrix.prototype.swapRows = function(i, j) {
        // check index
        if (!(0, $edQYF.isNumber)(i) || !(0, $6NnhX.isInteger)(i) || !(0, $edQYF.isNumber)(j) || !(0, $6NnhX.isInteger)(j)) throw new Error('Row index must be positive integers');
        // check dimensions
        if (this._size.length !== 2) throw new Error('Only two dimensional matrix is supported');
        // validate index
        (0, $d80Xp.validateIndex)(i, this._size[0]);
        (0, $d80Xp.validateIndex)(j, this._size[0]);
        // swap rows
        DenseMatrix._swapRows(i, j, this._data);
        // return current instance
        return this;
    };
    /**
   * Swap rows i and j in Dense Matrix data structure.
   *
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   * @param {Array} data     Matrix data
   */ DenseMatrix._swapRows = function(i, j, data) {
        // swap values i <-> j
        var vi = data[i];
        data[i] = data[j];
        data[j] = vi;
    };
    /**
   * Preprocess data, which can be an Array or DenseMatrix with nested Arrays and
   * Matrices. Clones all (nested) Arrays, and replaces all nested Matrices with Arrays
   * @memberof DenseMatrix
   * @param {Array | Matrix} data
   * @return {Array} data
   */ function preprocess(data) {
        if ((0, $edQYF.isMatrix)(data)) return preprocess(data.valueOf());
        if ((0, $edQYF.isArray)(data)) return data.map(preprocess);
        return data;
    }
    return DenseMatrix;
}, {
    isClass: true
});

});
parcelRegister("bLcpf", function(module, exports) {

$parcel$export(module.exports, "optimizeCallback", () => $88fdb52071ffa56f$export$9710464c56d2b565);

var $d3cj9 = parcelRequire("d3cj9");

var $d80Xp = parcelRequire("d80Xp");

var $edQYF = parcelRequire("edQYF");
function $88fdb52071ffa56f$export$9710464c56d2b565(callback, array, name, isUnary) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($d3cj9))).isTypedFunction(callback)) {
        var numberOfArguments;
        if (isUnary) numberOfArguments = 1;
        else {
            var firstIndex = (array.isMatrix ? array.size() : (0, $d80Xp.arraySize)(array)).map(()=>0);
            var firstValue = array.isMatrix ? array.get(firstIndex) : (0, $d80Xp.get)(array, firstIndex);
            numberOfArguments = $88fdb52071ffa56f$var$_findNumberOfArgumentsTyped(callback, firstValue, firstIndex, array);
        }
        var fastCallback;
        if (array.isMatrix && array.dataType !== 'mixed' && array.dataType !== undefined) {
            var singleSignature = $88fdb52071ffa56f$var$_findSingleSignatureWithArity(callback, numberOfArguments);
            fastCallback = singleSignature !== undefined ? singleSignature : callback;
        } else fastCallback = callback;
        if (numberOfArguments >= 1 && numberOfArguments <= 3) return {
            isUnary: numberOfArguments === 1,
            fn: function fn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return $88fdb52071ffa56f$var$_tryFunctionWithArgs(fastCallback, args.slice(0, numberOfArguments), name, callback.name);
            }
        };
        return {
            isUnary: false,
            fn: function fn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return $88fdb52071ffa56f$var$_tryFunctionWithArgs(fastCallback, args, name, callback.name);
            }
        };
    }
    if (isUnary === undefined) return {
        isUnary: $88fdb52071ffa56f$var$_findIfCallbackIsUnary(callback),
        fn: callback
    };
    else return {
        isUnary: isUnary,
        fn: callback
    };
}
function $88fdb52071ffa56f$var$_findSingleSignatureWithArity(callback, arity) {
    var matchingFunctions = [];
    Object.entries(callback.signatures).forEach((_ref)=>{
        var [signature, func] = _ref;
        if (signature.split(',').length === arity) matchingFunctions.push(func);
    });
    if (matchingFunctions.length === 1) return matchingFunctions[0];
}
/**
 * Determines if a given callback function is unary (i.e., takes exactly one argument).
 *
 * This function checks the following conditions to determine if the callback is unary:
 * 1. The callback function should have exactly one parameter.
 * 2. The callback function should not use the `arguments` object.
 * 3. The callback function should not use rest parameters (`...`).
 * If in doubt, this function shall return `false` to be safe
 *
 * @param {Function} callback - The callback function to be checked.
 * @returns {boolean} - Returns `true` if the callback is unary, otherwise `false`.
 */ function $88fdb52071ffa56f$var$_findIfCallbackIsUnary(callback) {
    if (callback.length !== 1) return false;
    var callbackStr = callback.toString();
    // Check if the callback function uses `arguments`
    if (/arguments/.test(callbackStr)) return false;
    // Extract the parameters of the callback function
    var paramsStr = callbackStr.match(/\(.*?\)/);
    // Check if the callback function uses rest parameters
    if (/\.\.\./.test(paramsStr)) return false;
    return true;
}
function $88fdb52071ffa56f$var$_findNumberOfArgumentsTyped(callback, value, index, array) {
    var testArgs = [
        value,
        index,
        array
    ];
    for(var i = 3; i > 0; i--){
        var args = testArgs.slice(0, i);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($d3cj9))).resolve(callback, args) !== null) return i;
    }
}
/**
   * @param {function} func The selected function taken from one of the signatures of the callback function
   * @param {Array} args List with arguments to apply to the selected signature
   * @param {string} mappingFnName the name of the function that is using the callback
   * @param {string} callbackName the name of the callback function
   * @returns {*} Returns the return value of the invoked signature
   * @throws {TypeError} Throws an error when no matching signature was found
   */ function $88fdb52071ffa56f$var$_tryFunctionWithArgs(func, args, mappingFnName, callbackName) {
    try {
        return func(...args);
    } catch (err) {
        $88fdb52071ffa56f$var$_createCallbackError(err, args, mappingFnName, callbackName);
    }
}
/**
 * Creates and throws a detailed TypeError when a callback function fails.
 *
 * @param {Error} err The original error thrown by the callback function.
 * @param {Array} args The arguments that were passed to the callback function.
 * @param {string} mappingFnName The name of the function that is using the callback.
 * @param {string} callbackName The name of the callback function.
 * @throws {TypeError} Throws a detailed TypeError with enriched error message.
 */ function $88fdb52071ffa56f$var$_createCallbackError(err, args, mappingFnName, callbackName) {
    var _err$data;
    // Enrich the error message so the user understands that it took place inside the callback function
    if (err instanceof TypeError && ((_err$data = err.data) === null || _err$data === void 0 ? void 0 : _err$data.category) === 'wrongType') {
        var argsDesc = [];
        argsDesc.push("value: ".concat((0, $edQYF.typeOf)(args[0])));
        if (args.length >= 2) argsDesc.push("index: ".concat((0, $edQYF.typeOf)(args[1])));
        if (args.length >= 3) argsDesc.push("array: ".concat((0, $edQYF.typeOf)(args[2])));
        throw new TypeError("Function ".concat(mappingFnName, " cannot apply callback arguments ") + "".concat(callbackName, "(").concat(argsDesc.join(', '), ") at index ").concat(JSON.stringify(args[1])));
    } else throw new TypeError("Function ".concat(mappingFnName, " cannot apply callback arguments ") + "to function ".concat(callbackName, ": ").concat(err.message));
}

});
parcelRegister("d3cj9", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function ok() {
        return true;
    }
    function notOk() {
        return false;
    }
    function undef() {
        return undefined;
    }
    const NOT_TYPED_FUNCTION = 'Argument is not a typed-function.';
    /**
   * @typedef {{
   *   params: Param[],
   *   fn: function,
   *   test: function,
   *   implementation: function
   * }} Signature
   *
   * @typedef {{
   *   types: Type[],
   *   hasAny: boolean,
   *   hasConversion: boolean,
   *   restParam: boolean
   * }} Param
   *
   * @typedef {{
   *   name: string,
   *   typeIndex: number,
   *   test: function,
   *   isAny: boolean,
   *   conversion?: ConversionDef,
   *   conversionIndex: number,
   * }} Type
   *
   * @typedef {{
   *   from: string,
   *   to: string,
   *   convert: function (*) : *
   * }} ConversionDef
   *
   * @typedef {{
   *   name: string,
   *   test: function(*) : boolean,
   *   isAny?: boolean
   * }} TypeDef
   */ /**
   * @returns {() => function}
   */ function create() {
        // data type tests
        /**
     * Returns true if the argument is a non-null "plain" object
     */ function isPlainObject(x) {
            return typeof x === 'object' && x !== null && x.constructor === Object;
        }
        const _types = [
            {
                name: 'number',
                test: function(x) {
                    return typeof x === 'number';
                }
            },
            {
                name: 'string',
                test: function(x) {
                    return typeof x === 'string';
                }
            },
            {
                name: 'boolean',
                test: function(x) {
                    return typeof x === 'boolean';
                }
            },
            {
                name: 'Function',
                test: function(x) {
                    return typeof x === 'function';
                }
            },
            {
                name: 'Array',
                test: Array.isArray
            },
            {
                name: 'Date',
                test: function(x) {
                    return x instanceof Date;
                }
            },
            {
                name: 'RegExp',
                test: function(x) {
                    return x instanceof RegExp;
                }
            },
            {
                name: 'Object',
                test: isPlainObject
            },
            {
                name: 'null',
                test: function(x) {
                    return x === null;
                }
            },
            {
                name: 'undefined',
                test: function(x) {
                    return x === undefined;
                }
            }
        ];
        const anyType = {
            name: 'any',
            test: ok,
            isAny: true
        };
        // Data structures to track the types. As these are local variables in
        // create(), each typed universe will get its own copy, but the variables
        // will only be accessible through the (closures of the) functions supplied
        // as properties of the typed object, not directly.
        // These will be initialized in clear() below
        let typeMap; // primary store of all types
        let typeList; // Array of just type names, for the sake of ordering
        // And similar data structures for the type conversions:
        let nConversions = 0;
        // the actual conversions are stored on a property of the destination types
        // This is a temporary object, will be replaced with a function at the end
        let typed = {
            createCount: 0
        };
        /**
     * Takes a type name and returns the corresponding official type object
     * for that type.
     *
     * @param {string} typeName
     * @returns {TypeDef} type
     */ function findType(typeName) {
            const type = typeMap.get(typeName);
            if (type) return type;
            // Remainder is error handling
            let message = 'Unknown type "' + typeName + '"';
            const name = typeName.toLowerCase();
            let otherName;
            for (otherName of typeList)if (otherName.toLowerCase() === name) {
                message += '. Did you mean "' + otherName + '" ?';
                break;
            }
            throw new TypeError(message);
        }
        /**
     * Adds an array `types` of type definitions to this typed instance.
     * Each type definition should be an object with properties:
     * 'name' - a string giving the name of the type; 'test' - function
     * returning a boolean that tests membership in the type; and optionally
     * 'isAny' - true only for the 'any' type.
     *
     * The second optional argument, `before`, gives the name of a type that
     * these types should be added before. The new types are added in the
     * order specified.
     * @param {TypeDef[]} types
     * @param {string | boolean} [beforeSpec='any'] before
     */ function addTypes(types) {
            let beforeSpec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'any';
            const beforeIndex = beforeSpec ? findType(beforeSpec).index : typeList.length;
            const newTypes = [];
            for(let i = 0; i < types.length; ++i){
                if (!types[i] || typeof types[i].name !== 'string' || typeof types[i].test !== 'function') throw new TypeError('Object with properties {name: string, test: function} expected');
                const typeName = types[i].name;
                if (typeMap.has(typeName)) throw new TypeError('Duplicate type name "' + typeName + '"');
                newTypes.push(typeName);
                typeMap.set(typeName, {
                    name: typeName,
                    test: types[i].test,
                    isAny: types[i].isAny,
                    index: beforeIndex + i,
                    conversionsTo: [] // Newly added type can't have any conversions to it
                });
            }
            // update the typeList
            const affectedTypes = typeList.slice(beforeIndex);
            typeList = typeList.slice(0, beforeIndex).concat(newTypes).concat(affectedTypes);
            // Fix the indices
            for(let i = beforeIndex + newTypes.length; i < typeList.length; ++i)typeMap.get(typeList[i]).index = i;
        }
        /**
     * Removes all types and conversions from this typed instance.
     * May cause previously constructed typed-functions to throw
     * strange errors when they are called with types that do not
     * match any of their signatures.
     */ function clear() {
            typeMap = new Map();
            typeList = [];
            nConversions = 0;
            addTypes([
                anyType
            ], false);
        }
        // initialize the types to the default list
        clear();
        addTypes(_types);
        /**
     * Removes all conversions, leaving the types alone.
     */ function clearConversions() {
            let typeName;
            for (typeName of typeList)typeMap.get(typeName).conversionsTo = [];
            nConversions = 0;
        }
        /**
     * Find the type names that match a value.
     * @param {*} value
     * @return {string[]} Array of names of types for which
     *                  the type test matches the value.
     */ function findTypeNames(value) {
            const matches = typeList.filter((name)=>{
                const type = typeMap.get(name);
                return !type.isAny && type.test(value);
            });
            if (matches.length) return matches;
            return [
                'any'
            ];
        }
        /**
     * Check if an entity is a typed function created by any instance
     * @param {any} entity
     * @returns {boolean}
     */ function isTypedFunction(entity) {
            return entity && typeof entity === 'function' && '_typedFunctionData' in entity;
        }
        /**
     * Find a specific signature from a (composed) typed function, for example:
     *
     *   typed.findSignature(fn, ['number', 'string'])
     *   typed.findSignature(fn, 'number, string')
     *   typed.findSignature(fn, 'number,string', {exact: true})
     *
     * This function findSignature will by default return the best match to
     * the given signature, possibly employing type conversions.
     *
     * The (optional) third argument is a plain object giving options
     * controlling the signature search. Currently the only implemented
     * option is `exact`: if specified as true (default is false), only
     * exact matches will be returned (i.e. signatures for which `fn` was
     * directly defined). Note that a (possibly different) type matching
     * `any`, or one or more instances of TYPE matching `...TYPE` are
     * considered exact matches in this regard, as no conversions are used.
     *
     * This function returns a "signature" object, as does `typed.resolve()`,
     * which is a plain object with four keys: `params` (the array of parameters
     * for this signature), `fn` (the originally supplied function for this
     * signature), `test` (a generated function that determines if an argument
     * list matches this signature, and `implementation` (the function to call
     * on a matching argument list, that performs conversions if necessary and
     * then calls the originally supplied function).
     *
     * @param {Function} fn                   A typed-function
     * @param {string | string[]} signature
     *     Signature to be found, can be an array or a comma separated string.
     * @param {object} options  Controls the signature search as documented
     * @return {{ params: Param[], fn: function, test: function, implementation: function }}
     *     Returns the matching signature, or throws an error when no signature
     *     is found.
     */ function findSignature(fn, signature, options) {
            if (!isTypedFunction(fn)) throw new TypeError(NOT_TYPED_FUNCTION);
            // Canonicalize input
            const exact = options && options.exact;
            const stringSignature = Array.isArray(signature) ? signature.join(',') : signature;
            const params = parseSignature(stringSignature);
            const canonicalSignature = stringifyParams(params);
            // First hope we get lucky and exactly match a signature
            if (!exact || canonicalSignature in fn.signatures) {
                // OK, we can check the internal signatures
                const match = fn._typedFunctionData.signatureMap.get(canonicalSignature);
                if (match) return match;
            }
            // Oh well, we did not; so we have to go back and check the parameters
            // one by one, in order to catch things like `any` and rest params.
            // Note here we can assume there is at least one parameter, because
            // the empty signature would have matched successfully above.
            const nParams = params.length;
            let remainingSignatures;
            if (exact) {
                remainingSignatures = [];
                let name;
                for(name in fn.signatures)remainingSignatures.push(fn._typedFunctionData.signatureMap.get(name));
            } else remainingSignatures = fn._typedFunctionData.signatures;
            for(let i = 0; i < nParams; ++i){
                const want = params[i];
                const filteredSignatures = [];
                let possibility;
                for (possibility of remainingSignatures){
                    const have = getParamAtIndex(possibility.params, i);
                    if (!have || want.restParam && !have.restParam) continue;
                    if (!have.hasAny) {
                        // have to check all of the wanted types are available
                        const haveTypes = paramTypeSet(have);
                        if (want.types.some((wtype)=>!haveTypes.has(wtype.name))) continue;
                    }
                    // OK, this looks good
                    filteredSignatures.push(possibility);
                }
                remainingSignatures = filteredSignatures;
                if (remainingSignatures.length === 0) break;
            }
            // Return the first remaining signature that was totally matched:
            let candidate;
            for (candidate of remainingSignatures){
                if (candidate.params.length <= nParams) return candidate;
            }
            throw new TypeError('Signature not found (signature: ' + (fn.name || 'unnamed') + '(' + stringifyParams(params, ', ') + '))');
        }
        /**
     * Find the proper function to call for a specific signature from
     * a (composed) typed function, for example:
     *
     *   typed.find(fn, ['number', 'string'])
     *   typed.find(fn, 'number, string')
     *   typed.find(fn, 'number,string', {exact: true})
     *
     * This function find will by default return the best match to
     * the given signature, possibly employing type conversions (and returning
     * a function that will perform those conversions as needed). The
     * (optional) third argument is a plain object giving options contolling
     * the signature search. Currently only the option `exact` is implemented,
     * which defaults to "false". If `exact` is specified as true, then only
     * exact matches will be returned (i.e. signatures for which `fn` was
     * directly defined). Uses of `any` and `...TYPE` are considered exact if
     * no conversions are necessary to apply the corresponding function.
     *
     * @param {Function} fn                   A typed-function
     * @param {string | string[]} signature
     *     Signature to be found, can be an array or a comma separated string.
     * @param {object} options  Controls the signature match as documented
     * @return {function}
     *     Returns the function to call for the given signature, or throws an
     *     error if no match is found.
     */ function find(fn, signature, options) {
            return findSignature(fn, signature, options).implementation;
        }
        /**
     * Convert a given value to another data type, specified by type name.
     *
     * @param {*} value
     * @param {string} typeName
     */ function convert(value, typeName) {
            // check conversion is needed
            const type = findType(typeName);
            if (type.test(value)) return value;
            const conversions = type.conversionsTo;
            if (conversions.length === 0) throw new Error('There are no conversions to ' + typeName + ' defined.');
            for(let i = 0; i < conversions.length; i++){
                const fromType = findType(conversions[i].from);
                if (fromType.test(value)) return conversions[i].convert(value);
            }
            throw new Error('Cannot convert ' + value + ' to ' + typeName);
        }
        /**
     * Stringify parameters in a normalized way
     * @param {Param[]} params
     * @param {string} [','] separator
     * @return {string}
     */ function stringifyParams(params) {
            let separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
            return params.map((p)=>p.name).join(separator);
        }
        /**
     * Parse a parameter, like "...number | boolean"
     * @param {string} param
     * @return {Param} param
     */ function parseParam(param) {
            const restParam = param.indexOf('...') === 0;
            const types = !restParam ? param : param.length > 3 ? param.slice(3) : 'any';
            const typeDefs = types.split('|').map((s)=>findType(s.trim()));
            let hasAny = false;
            let paramName = restParam ? '...' : '';
            const exactTypes = typeDefs.map(function(type) {
                hasAny = type.isAny || hasAny;
                paramName += type.name + '|';
                return {
                    name: type.name,
                    typeIndex: type.index,
                    test: type.test,
                    isAny: type.isAny,
                    conversion: null,
                    conversionIndex: -1
                };
            });
            return {
                types: exactTypes,
                name: paramName.slice(0, -1),
                hasAny: // remove trailing '|' from above
                hasAny,
                hasConversion: false,
                restParam: restParam
            };
        }
        /**
     * Expands a parsed parameter with the types available from currently
     * defined conversions.
     * @param {Param} param
     * @return {Param} param
     */ function expandParam(param) {
            const typeNames = param.types.map((t)=>t.name);
            const matchingConversions = availableConversions(typeNames);
            let hasAny = param.hasAny;
            let newName = param.name;
            const convertibleTypes = matchingConversions.map(function(conversion) {
                const type = findType(conversion.from);
                hasAny = type.isAny || hasAny;
                newName += '|' + conversion.from;
                return {
                    name: conversion.from,
                    typeIndex: type.index,
                    test: type.test,
                    isAny: type.isAny,
                    conversion: conversion,
                    conversionIndex: conversion.index
                };
            });
            return {
                types: param.types.concat(convertibleTypes),
                name: newName,
                hasAny: hasAny,
                hasConversion: convertibleTypes.length > 0,
                restParam: param.restParam
            };
        }
        /**
     * Return the set of type names in a parameter.
     * Caches the result for efficiency
     *
     * @param {Param} param
     * @return {Set<string>} typenames
     */ function paramTypeSet(param) {
            if (!param.typeSet) {
                param.typeSet = new Set();
                param.types.forEach((type)=>param.typeSet.add(type.name));
            }
            return param.typeSet;
        }
        /**
     * Parse a signature with comma separated parameters,
     * like "number | boolean, ...string"
     *
     * @param {string} signature
     * @return {Param[]} params
     */ function parseSignature(rawSignature) {
            const params = [];
            if (typeof rawSignature !== 'string') throw new TypeError('Signatures must be strings');
            const signature = rawSignature.trim();
            if (signature === '') return params;
            const rawParams = signature.split(',');
            for(let i = 0; i < rawParams.length; ++i){
                const parsedParam = parseParam(rawParams[i].trim());
                if (parsedParam.restParam && i !== rawParams.length - 1) throw new SyntaxError('Unexpected rest parameter "' + rawParams[i] + '": ' + 'only allowed for the last parameter');
                // if invalid, short-circuit (all the types may have been filtered)
                if (parsedParam.types.length === 0) return null;
                params.push(parsedParam);
            }
            return params;
        }
        /**
     * Test whether a set of params contains a restParam
     * @param {Param[]} params
     * @return {boolean} Returns true when the last parameter is a restParam
     */ function hasRestParam(params) {
            const param = last(params);
            return param ? param.restParam : false;
        }
        /**
     * Create a type test for a single parameter, which can have one or multiple
     * types.
     * @param {Param} param
     * @return {function(x: *) : boolean} Returns a test function
     */ function compileTest(param) {
            if (!param || param.types.length === 0) // nothing to do
            return ok;
            else if (param.types.length === 1) return findType(param.types[0].name).test;
            else if (param.types.length === 2) {
                const test0 = findType(param.types[0].name).test;
                const test1 = findType(param.types[1].name).test;
                return function or(x) {
                    return test0(x) || test1(x);
                };
            } else {
                // param.types.length > 2
                const tests = param.types.map(function(type) {
                    return findType(type.name).test;
                });
                return function or(x) {
                    for(let i = 0; i < tests.length; i++){
                        if (tests[i](x)) return true;
                    }
                    return false;
                };
            }
        }
        /**
     * Create a test for all parameters of a signature
     * @param {Param[]} params
     * @return {function(args: Array<*>) : boolean}
     */ function compileTests(params) {
            let tests, test0, test1;
            if (hasRestParam(params)) {
                // variable arguments like '...number'
                tests = initial(params).map(compileTest);
                const varIndex = tests.length;
                const lastTest = compileTest(last(params));
                const testRestParam = function(args) {
                    for(let i = varIndex; i < args.length; i++){
                        if (!lastTest(args[i])) return false;
                    }
                    return true;
                };
                return function testArgs(args) {
                    for(let i = 0; i < tests.length; i++){
                        if (!tests[i](args[i])) return false;
                    }
                    return testRestParam(args) && args.length >= varIndex + 1;
                };
            } else {
                // no variable arguments
                if (params.length === 0) return function testArgs(args) {
                    return args.length === 0;
                };
                else if (params.length === 1) {
                    test0 = compileTest(params[0]);
                    return function testArgs(args) {
                        return test0(args[0]) && args.length === 1;
                    };
                } else if (params.length === 2) {
                    test0 = compileTest(params[0]);
                    test1 = compileTest(params[1]);
                    return function testArgs(args) {
                        return test0(args[0]) && test1(args[1]) && args.length === 2;
                    };
                } else {
                    // arguments.length > 2
                    tests = params.map(compileTest);
                    return function testArgs(args) {
                        for(let i = 0; i < tests.length; i++){
                            if (!tests[i](args[i])) return false;
                        }
                        return args.length === tests.length;
                    };
                }
            }
        }
        /**
     * Find the parameter at a specific index of a Params list.
     * Handles rest parameters.
     * @param {Param[]} params
     * @param {number} index
     * @return {Param | null} Returns the matching parameter when found,
     *                        null otherwise.
     */ function getParamAtIndex(params, index) {
            return index < params.length ? params[index] : hasRestParam(params) ? last(params) : null;
        }
        /**
     * Get all type names of a parameter
     * @param {Params[]} params
     * @param {number} index
     * @return {string[]} Returns an array with type names
     */ function getTypeSetAtIndex(params, index) {
            const param = getParamAtIndex(params, index);
            if (!param) return new Set();
            return paramTypeSet(param);
        }
        /**
     * Test whether a type is an exact type or conversion
     * @param {Type} type
     * @return {boolean} Returns true when
     */ function isExactType(type) {
            return type.conversion === null || type.conversion === undefined;
        }
        /**
     * Helper function for creating error messages: create an array with
     * all available types on a specific argument index.
     * @param {Signature[]} signatures
     * @param {number} index
     * @return {string[]} Returns an array with available types
     */ function mergeExpectedParams(signatures, index) {
            const typeSet = new Set();
            signatures.forEach((signature)=>{
                const paramSet = getTypeSetAtIndex(signature.params, index);
                let name;
                for (name of paramSet)typeSet.add(name);
            });
            return typeSet.has('any') ? [
                'any'
            ] : Array.from(typeSet);
        }
        /**
     * Create
     * @param {string} name             The name of the function
     * @param {array.<*>} args          The actual arguments passed to the function
     * @param {Signature[]} signatures  A list with available signatures
     * @return {TypeError} Returns a type error with additional data
     *                     attached to it in the property `data`
     */ function createError(name, args, signatures) {
            let err, expected;
            const _name = name || 'unnamed';
            // test for wrong type at some index
            let matchingSignatures = signatures;
            let index;
            for(index = 0; index < args.length; index++){
                const nextMatchingDefs = [];
                matchingSignatures.forEach((signature)=>{
                    const param = getParamAtIndex(signature.params, index);
                    const test = compileTest(param);
                    if ((index < signature.params.length || hasRestParam(signature.params)) && test(args[index])) nextMatchingDefs.push(signature);
                });
                if (nextMatchingDefs.length === 0) {
                    // no matching signatures anymore, throw error "wrong type"
                    expected = mergeExpectedParams(matchingSignatures, index);
                    if (expected.length > 0) {
                        const actualTypes = findTypeNames(args[index]);
                        err = new TypeError('Unexpected type of argument in function ' + _name + ' (expected: ' + expected.join(' or ') + ', actual: ' + actualTypes.join(' | ') + ', index: ' + index + ')');
                        err.data = {
                            category: 'wrongType',
                            fn: _name,
                            index: index,
                            actual: actualTypes,
                            expected: expected
                        };
                        return err;
                    }
                } else matchingSignatures = nextMatchingDefs;
            }
            // test for too few arguments
            const lengths = matchingSignatures.map(function(signature) {
                return hasRestParam(signature.params) ? Infinity : signature.params.length;
            });
            if (args.length < Math.min.apply(null, lengths)) {
                expected = mergeExpectedParams(matchingSignatures, index);
                err = new TypeError('Too few arguments in function ' + _name + ' (expected: ' + expected.join(' or ') + ', index: ' + args.length + ')');
                err.data = {
                    category: 'tooFewArgs',
                    fn: _name,
                    index: args.length,
                    expected: expected
                };
                return err;
            }
            // test for too many arguments
            const maxLength = Math.max.apply(null, lengths);
            if (args.length > maxLength) {
                err = new TypeError('Too many arguments in function ' + _name + ' (expected: ' + maxLength + ', actual: ' + args.length + ')');
                err.data = {
                    category: 'tooManyArgs',
                    fn: _name,
                    index: args.length,
                    expectedLength: maxLength
                };
                return err;
            }
            // Generic error
            const argTypes = [];
            for(let i = 0; i < args.length; ++i)argTypes.push(findTypeNames(args[i]).join('|'));
            err = new TypeError('Arguments of type "' + argTypes.join(', ') + '" do not match any of the defined signatures of function ' + _name + '.');
            err.data = {
                category: 'mismatch',
                actual: argTypes
            };
            return err;
        }
        /**
     * Find the lowest index of all types of a parameter
     * @param {Param} param
     * @return {number} Returns the index of the lowest type in typed.types
     */ function getLowestTypeIndex(param) {
            let min = typeList.length + 1;
            for(let i = 0; i < param.types.length; i++)min = Math.min(min, param.types[i].typeIndex);
            return min;
        }
        /**
     * Find the lowest index of the conversion of all types of the parameter
     * having a conversion
     * @param {Param} param
     * @return {number} Returns the lowest index of the conversions of this type
     */ function getLowestConversionIndex(param) {
            let min = nConversions + 1;
            for(let i = 0; i < param.types.length; i++)if (!isExactType(param.types[i])) min = Math.min(min, param.types[i].conversionIndex);
            return min;
        }
        /**
     * Compare two params. The return value is a number that is
     * negative when param1 should be considered first, positive
     * when param2 should be considered first, and zero when the
     * params are indistinguishable. Primarily as a debugging aid,
     * the value is always less than one in absolute value, and
     * a smaller absolute value indicates a less important distinction
     * between the parameters.
     * @param {Param} param1
     * @param {Param} param2
     * @return {number} negative, positive, or zero depending on whether
     *                  param1 should be ordered before, after, or equivalently
     *                  to param2
     */ function compareParams(param1, param2) {
            // We compare a number of metrics on a param in turn:
            // 1) 'any' parameters are the least preferred
            if (param1.hasAny) {
                if (!param2.hasAny) return 0.1;
            } else if (param2.hasAny) return -0.1;
            // 2) Prefer non-rest to rest parameters
            if (param1.restParam) {
                if (!param2.restParam) return 0.01;
            } else if (param2.restParam) return -0.01;
            // 3) Prefer lower type index:
            const typeDiff = getLowestTypeIndex(param1) - getLowestTypeIndex(param2);
            if (typeDiff < 0) return -0.001;
            if (typeDiff > 0) return 0.001;
            // 4) Prefer exact type match to conversions, with a strength that
            //    grows with the conversion index
            const conv1 = getLowestConversionIndex(param1);
            const conv2 = getLowestConversionIndex(param2);
            if (param1.hasConversion) {
                if (!param2.hasConversion) return (1 + conv1) * 0.000001;
            } else if (param2.hasConversion) return -(1 + conv2) * 0.000001;
            // 5) Prefer lower conversion index
            const convDiff = conv1 - conv2;
            if (convDiff < 0) return -0.0000001;
            if (convDiff > 0) return 0.0000001;
            // Don't have a basis for preference
            return 0;
        }
        /**
     * Compare two signatures. The result is a number that is negative
     * when the first signature should be preferred to the second, positive
     * when the second signature should be preferred, and zero in case the
     * two signatures are essentially equivalent. Primarily as a debugging
     * aid, a larger absolute value indicates a more "important" difference.
     *
     * @param {Signature} signature1
     * @param {Signature} signature2
     * @return {number} returns a negative number when signature1 must get a
     *                  lower index than signature2, a positive number when the
     *                  opposite holds, or zero when both are equivalent.
     */ function compareSignatures(signature1, signature2) {
            const pars1 = signature1.params;
            const pars2 = signature2.params;
            const last1 = last(pars1);
            const last2 = last(pars2);
            const hasRest1 = hasRestParam(pars1);
            const hasRest2 = hasRestParam(pars2);
            // We compare a number of metrics on signatures in turn:
            // 1) An "any rest param" is least preferred
            if (hasRest1 && last1.hasAny) {
                if (!hasRest2 || !last2.hasAny) return 10000000;
            } else if (hasRest2 && last2.hasAny) return -10000000;
            // 2) Minimize the number of 'any' parameters
            let any1 = 0;
            let conv1 = 0;
            let par;
            for (par of pars1){
                if (par.hasAny) ++any1;
                if (par.hasConversion) ++conv1;
            }
            let any2 = 0;
            let conv2 = 0;
            for (par of pars2){
                if (par.hasAny) ++any2;
                if (par.hasConversion) ++conv2;
            }
            if (any1 !== any2) return (any1 - any2) * 1000000;
            // 3) A conversion rest param is less preferred
            if (hasRest1 && last1.hasConversion) {
                if (!hasRest2 || !last2.hasConversion) return 100000;
            } else if (hasRest2 && last2.hasConversion) return -100000;
            // 4) Minimize the number of conversions
            if (conv1 !== conv2) return (conv1 - conv2) * 10000;
            // 5) Prefer no rest param
            if (hasRest1) {
                if (!hasRest2) return 1000;
            } else if (hasRest2) return -1000;
            // 6) Prefer shorter with rest param, longer without
            const lengthCriterion = (pars1.length - pars2.length) * (hasRest1 ? -100 : 100);
            if (lengthCriterion !== 0) return lengthCriterion;
            // Signatures are identical in each of the above metrics.
            // In particular, they are the same length.
            // We can therefore compare the parameters one by one.
            // First we count which signature has more preferred parameters.
            const comparisons = [];
            let tc = 0;
            for(let i = 0; i < pars1.length; ++i){
                const thisComparison = compareParams(pars1[i], pars2[i]);
                comparisons.push(thisComparison);
                tc += thisComparison;
            }
            if (tc !== 0) return (tc < 0 ? -10 : 10) + tc;
            // They have the same number of preferred parameters, so go by the
            // earliest parameter in which we have a preference.
            // In other words, dispatch is driven somewhat more by earlier
            // parameters than later ones.
            let c;
            let bonus = 9;
            const decrement = bonus / (comparisons.length + 1);
            for (c of comparisons){
                if (c !== 0) return (c < 0 ? -bonus : bonus) + c;
                bonus -= decrement;
            }
            // It's a tossup:
            return 0;
        }
        /**
     * Produce a list of all conversions from distinct types to one of
     * the given types.
     *
     * @param {string[]} typeNames
     * @return {ConversionDef[]} Returns the conversions that are available
     *                        resulting in any given type (if any)
     */ function availableConversions(typeNames) {
            if (typeNames.length === 0) return [];
            const types = typeNames.map(findType);
            if (typeNames.length === 1) return types[0].conversionsTo;
            // Here, for each type that occurs as the from-type of any conversion
            // to any of the types found, we must select the conversion of
            // lowest index from that type. So first collect the types.
            const knownTypes = new Set(typeNames);
            const convertibleTypes = new Set();
            for(let i = 0; i < types.length; ++i){
                for (const match of types[i].conversionsTo)if (!knownTypes.has(match.from)) convertibleTypes.add(match.from);
            }
            // Now get the lowest-index conversion for each type
            const matches = [];
            for (const typeName of convertibleTypes){
                let bestIndex = nConversions + 1;
                let bestConversion = null;
                for(let i = 0; i < types.length; ++i){
                    for (const match of types[i].conversionsTo)if (match.from === typeName && match.index < bestIndex) {
                        bestIndex = match.index;
                        bestConversion = match;
                    }
                }
                matches.push(bestConversion);
            }
            return matches;
        }
        /**
     * Preprocess arguments before calling the original function:
     * - if needed convert the parameters
     * - in case of rest parameters, move the rest parameters into an Array
     * @param {Param[]} params
     * @param {function} fn
     * @return {function} Returns fn or a wrapped function if needed. If it
     *                    has conversions, the function will be named to indicate
     *                    what conversions are occurring.
     */ function compileArgsPreprocessing(params, fn) {
            let fnConvert = fn;
            // TODO: can we make this wrapper function smarter/simpler?
            let name = '';
            if (params.some((p)=>p.hasConversion)) {
                const restParam = hasRestParam(params);
                const compiledConversions = params.map(compileArgConversion);
                name = compiledConversions.map((conv)=>conv.name).join(';');
                fnConvert = function convertArgs() {
                    const args = [];
                    const last = restParam ? arguments.length - 1 : arguments.length;
                    for(let i = 0; i < last; i++)args[i] = compiledConversions[i](arguments[i]);
                    if (restParam) args[last] = arguments[last].map(compiledConversions[last]);
                    return fn.apply(this, args);
                };
            }
            let fnPreprocess = fnConvert;
            if (hasRestParam(params)) {
                const offset = params.length - 1;
                fnPreprocess = function preprocessRestParams() {
                    return fnConvert.apply(this, slice(arguments, 0, offset).concat([
                        slice(arguments, offset)
                    ]));
                };
            }
            if (name) Object.defineProperty(fnPreprocess, 'name', {
                value: name
            });
            return fnPreprocess;
        }
        /**
     * Compile conversion for a parameter to the right type
     * @param {Param} param
     * @return {function} Returns the wrapped function that will convert arguments
     *
     */ function compileArgConversion(param) {
            let test0, test1, conversion0, conversion1;
            const tests = [];
            const conversions = [];
            let name = '';
            param.types.forEach(function(type) {
                if (type.conversion) {
                    name += type.conversion.from + '~>' + type.conversion.to + ',';
                    tests.push(findType(type.conversion.from).test);
                    conversions.push(type.conversion.convert);
                }
            });
            if (name) name = name.slice(0, -1);
            else name = 'pass';
            // create optimized conversion functions depending on the number of conversions
            let convertor = (arg)=>arg;
            switch(conversions.length){
                case 0:
                    break;
                case 1:
                    test0 = tests[0];
                    conversion0 = conversions[0];
                    convertor = function convertArg(arg) {
                        if (test0(arg)) return conversion0(arg);
                        return arg;
                    };
                    break;
                case 2:
                    test0 = tests[0];
                    test1 = tests[1];
                    conversion0 = conversions[0];
                    conversion1 = conversions[1];
                    convertor = function convertArg(arg) {
                        if (test0(arg)) return conversion0(arg);
                        if (test1(arg)) return conversion1(arg);
                        return arg;
                    };
                    break;
                default:
                    convertor = function convertArg(arg) {
                        for(let i = 0; i < conversions.length; i++){
                            if (tests[i](arg)) return conversions[i](arg);
                        }
                        return arg;
                    };
            }
            Object.defineProperty(convertor, 'name', {
                value: name
            });
            return convertor;
        }
        /**
     * Split params with union types in to separate params.
     *
     * For example:
     *
     *     splitParams([['Array', 'Object'], ['string', 'RegExp'])
     *     // returns:
     *     // [
     *     //   ['Array', 'string'],
     *     //   ['Array', 'RegExp'],
     *     //   ['Object', 'string'],
     *     //   ['Object', 'RegExp']
     *     // ]
     *
     * @param {Param[]} params
     * @return {Param[]}
     */ function splitParams(params) {
            function _splitParams(params, index, paramsSoFar) {
                if (index < params.length) {
                    const param = params[index];
                    let resultingParams = [];
                    if (param.restParam) {
                        // split the types of a rest parameter in two:
                        // one with only exact types, and one with exact types and conversions
                        const exactTypes = param.types.filter(isExactType);
                        if (exactTypes.length < param.types.length) resultingParams.push({
                            types: exactTypes,
                            name: '...' + exactTypes.map((t)=>t.name).join('|'),
                            hasAny: exactTypes.some((t)=>t.isAny),
                            hasConversion: false,
                            restParam: true
                        });
                        resultingParams.push(param);
                    } else // split all the types of a regular parameter into one type per param
                    resultingParams = param.types.map(function(type) {
                        return {
                            types: [
                                type
                            ],
                            name: type.name,
                            hasAny: type.isAny,
                            hasConversion: type.conversion,
                            restParam: false
                        };
                    });
                    // recurse over the groups with types
                    return flatMap(resultingParams, function(nextParam) {
                        return _splitParams(params, index + 1, paramsSoFar.concat([
                            nextParam
                        ]));
                    });
                } else // we've reached the end of the parameters.
                return [
                    paramsSoFar
                ];
            }
            return _splitParams(params, 0, []);
        }
        /**
     * Test whether two param lists represent conflicting signatures
     * @param {Param[]} params1
     * @param {Param[]} params2
     * @return {boolean} Returns true when the signatures conflict, false otherwise.
     */ function conflicting(params1, params2) {
            const ii = Math.max(params1.length, params2.length);
            for(let i = 0; i < ii; i++){
                const typeSet1 = getTypeSetAtIndex(params1, i);
                const typeSet2 = getTypeSetAtIndex(params2, i);
                let overlap = false;
                let name;
                for (name of typeSet2)if (typeSet1.has(name)) {
                    overlap = true;
                    break;
                }
                if (!overlap) return false;
            }
            const len1 = params1.length;
            const len2 = params2.length;
            const restParam1 = hasRestParam(params1);
            const restParam2 = hasRestParam(params2);
            return restParam1 ? restParam2 ? len1 === len2 : len2 >= len1 : restParam2 ? len1 >= len2 : len1 === len2;
        }
        /**
     * Helper function for `resolveReferences` that returns a copy of
     * functionList wihe any prior resolutions cleared out, in case we are
     * recycling signatures from a prior typed function construction.
     *
     * @param {Array.<function|typed-reference>} functionList
     * @return {Array.<function|typed-reference>}
     */ function clearResolutions(functionList) {
            return functionList.map((fn)=>{
                if (isReferToSelf(fn)) return referToSelf(fn.referToSelf.callback);
                if (isReferTo(fn)) return makeReferTo(fn.referTo.references, fn.referTo.callback);
                return fn;
            });
        }
        /**
     * Take a list of references, a list of functions functionList, and a
     * signatureMap indexing signatures into functionList, and return
     * the list of resolutions, or a false-y value if they don't all
     * resolve in a valid way (yet).
     *
     * @param {string[]} references
     * @param {Array<function|typed-reference} functionList
     * @param {Object.<string, integer>} signatureMap
     * @return {function[] | false} resolutions
     */ function collectResolutions(references, functionList, signatureMap) {
            const resolvedReferences = [];
            let reference;
            for (reference of references){
                let resolution = signatureMap[reference];
                if (typeof resolution !== 'number') throw new TypeError('No definition for referenced signature "' + reference + '"');
                resolution = functionList[resolution];
                if (typeof resolution !== 'function') return false;
                resolvedReferences.push(resolution);
            }
            return resolvedReferences;
        }
        /**
     * Resolve any references in the functionList for the typed function
     * itself. The signatureMap tells which index in the functionList a
     * given signature should be mapped to (for use in resolving typed.referTo)
     * and self provides the destions of a typed.referToSelf.
     *
     * @param {Array<function | typed-reference-object>} functionList
     * @param {Object.<string, function>} signatureMap
     * @param {function} self  The typed-function itself
     * @return {Array<function>} The list of resolved functions
     */ function resolveReferences(functionList, signatureMap, self) {
            const resolvedFunctions = clearResolutions(functionList);
            const isResolved = new Array(resolvedFunctions.length).fill(false);
            let leftUnresolved = true;
            while(leftUnresolved){
                leftUnresolved = false;
                let nothingResolved = true;
                for(let i = 0; i < resolvedFunctions.length; ++i){
                    if (isResolved[i]) continue;
                    const fn = resolvedFunctions[i];
                    if (isReferToSelf(fn)) {
                        resolvedFunctions[i] = fn.referToSelf.callback(self);
                        // Preserve reference in case signature is reused someday:
                        resolvedFunctions[i].referToSelf = fn.referToSelf;
                        isResolved[i] = true;
                        nothingResolved = false;
                    } else if (isReferTo(fn)) {
                        const resolvedReferences = collectResolutions(fn.referTo.references, resolvedFunctions, signatureMap);
                        if (resolvedReferences) {
                            resolvedFunctions[i] = fn.referTo.callback.apply(this, resolvedReferences);
                            // Preserve reference in case signature is reused someday:
                            resolvedFunctions[i].referTo = fn.referTo;
                            isResolved[i] = true;
                            nothingResolved = false;
                        } else leftUnresolved = true;
                    }
                }
                if (nothingResolved && leftUnresolved) throw new SyntaxError('Circular reference detected in resolving typed.referTo');
            }
            return resolvedFunctions;
        }
        /**
     * Validate whether any of the function bodies contains a self-reference
     * usage like `this(...)` or `this.signatures`. This self-referencing is
     * deprecated since typed-function v3. It has been replaced with
     * the functions typed.referTo and typed.referToSelf.
     * @param {Object.<string, function>} signaturesMap
     */ function validateDeprecatedThis(signaturesMap) {
            // TODO: remove this deprecation warning logic some day (it's introduced in v3)
            // match occurrences like 'this(' and 'this.signatures'
            const deprecatedThisRegex = /\bthis(\(|\.signatures\b)/;
            Object.keys(signaturesMap).forEach((signature)=>{
                const fn = signaturesMap[signature];
                if (deprecatedThisRegex.test(fn.toString())) throw new SyntaxError("Using `this` to self-reference a function is deprecated since typed-function@3. Use typed.referTo and typed.referToSelf instead.");
            });
        }
        /**
     * Create a typed function
     * @param {String} name               The name for the typed function
     * @param {Object.<string, function>} rawSignaturesMap
     *                                    An object with one or
     *                                    multiple signatures as key, and the
     *                                    function corresponding to the
     *                                    signature as value.
     * @return {function}  Returns the created typed function.
     */ function createTypedFunction(name, rawSignaturesMap) {
            typed.createCount++;
            if (Object.keys(rawSignaturesMap).length === 0) throw new SyntaxError('No signatures provided');
            if (typed.warnAgainstDeprecatedThis) validateDeprecatedThis(rawSignaturesMap);
            // Main processing loop for signatures
            const parsedParams = [];
            const originalFunctions = [];
            const signaturesMap = {};
            const preliminarySignatures = []; // may have duplicates from conversions
            let signature;
            for(signature in rawSignaturesMap){
                // A) Protect against polluted Object prototype:
                if (!Object.prototype.hasOwnProperty.call(rawSignaturesMap, signature)) continue;
                // B) Parse the signature
                const params = parseSignature(signature);
                if (!params) continue;
                // C) Check for conflicts
                parsedParams.forEach(function(pp) {
                    if (conflicting(pp, params)) throw new TypeError('Conflicting signatures "' + stringifyParams(pp) + '" and "' + stringifyParams(params) + '".');
                });
                parsedParams.push(params);
                // D) Store the provided function and add conversions
                const functionIndex = originalFunctions.length;
                originalFunctions.push(rawSignaturesMap[signature]);
                const conversionParams = params.map(expandParam);
                // E) Split the signatures and collect them up
                let sp;
                for (sp of splitParams(conversionParams)){
                    const spName = stringifyParams(sp);
                    preliminarySignatures.push({
                        params: sp,
                        name: spName,
                        fn: functionIndex
                    });
                    if (sp.every((p)=>!p.hasConversion)) signaturesMap[spName] = functionIndex;
                }
            }
            preliminarySignatures.sort(compareSignatures);
            // Note the forward reference to theTypedFn
            const resolvedFunctions = resolveReferences(originalFunctions, signaturesMap, theTypedFn);
            // Fill in the proper function for each signature
            let s;
            for(s in signaturesMap)if (Object.prototype.hasOwnProperty.call(signaturesMap, s)) signaturesMap[s] = resolvedFunctions[signaturesMap[s]];
            const signatures = [];
            const internalSignatureMap = new Map(); // benchmarks faster than object
            for (s of preliminarySignatures)// Note it's only safe to eliminate duplicates like this
            // _after_ the signature sorting step above; otherwise we might
            // remove the wrong one.
            if (!internalSignatureMap.has(s.name)) {
                s.fn = resolvedFunctions[s.fn];
                signatures.push(s);
                internalSignatureMap.set(s.name, s);
            }
            // we create a highly optimized checks for the first couple of signatures with max 2 arguments
            const ok0 = signatures[0] && signatures[0].params.length <= 2 && !hasRestParam(signatures[0].params);
            const ok1 = signatures[1] && signatures[1].params.length <= 2 && !hasRestParam(signatures[1].params);
            const ok2 = signatures[2] && signatures[2].params.length <= 2 && !hasRestParam(signatures[2].params);
            const ok3 = signatures[3] && signatures[3].params.length <= 2 && !hasRestParam(signatures[3].params);
            const ok4 = signatures[4] && signatures[4].params.length <= 2 && !hasRestParam(signatures[4].params);
            const ok5 = signatures[5] && signatures[5].params.length <= 2 && !hasRestParam(signatures[5].params);
            const allOk = ok0 && ok1 && ok2 && ok3 && ok4 && ok5;
            // compile the tests
            for(let i = 0; i < signatures.length; ++i)signatures[i].test = compileTests(signatures[i].params);
            const test00 = ok0 ? compileTest(signatures[0].params[0]) : notOk;
            const test10 = ok1 ? compileTest(signatures[1].params[0]) : notOk;
            const test20 = ok2 ? compileTest(signatures[2].params[0]) : notOk;
            const test30 = ok3 ? compileTest(signatures[3].params[0]) : notOk;
            const test40 = ok4 ? compileTest(signatures[4].params[0]) : notOk;
            const test50 = ok5 ? compileTest(signatures[5].params[0]) : notOk;
            const test01 = ok0 ? compileTest(signatures[0].params[1]) : notOk;
            const test11 = ok1 ? compileTest(signatures[1].params[1]) : notOk;
            const test21 = ok2 ? compileTest(signatures[2].params[1]) : notOk;
            const test31 = ok3 ? compileTest(signatures[3].params[1]) : notOk;
            const test41 = ok4 ? compileTest(signatures[4].params[1]) : notOk;
            const test51 = ok5 ? compileTest(signatures[5].params[1]) : notOk;
            // compile the functions
            for(let i = 0; i < signatures.length; ++i)signatures[i].implementation = compileArgsPreprocessing(signatures[i].params, signatures[i].fn);
            const fn0 = ok0 ? signatures[0].implementation : undef;
            const fn1 = ok1 ? signatures[1].implementation : undef;
            const fn2 = ok2 ? signatures[2].implementation : undef;
            const fn3 = ok3 ? signatures[3].implementation : undef;
            const fn4 = ok4 ? signatures[4].implementation : undef;
            const fn5 = ok5 ? signatures[5].implementation : undef;
            const len0 = ok0 ? signatures[0].params.length : -1;
            const len1 = ok1 ? signatures[1].params.length : -1;
            const len2 = ok2 ? signatures[2].params.length : -1;
            const len3 = ok3 ? signatures[3].params.length : -1;
            const len4 = ok4 ? signatures[4].params.length : -1;
            const len5 = ok5 ? signatures[5].params.length : -1;
            // simple and generic, but also slow
            const iStart = allOk ? 6 : 0;
            const iEnd = signatures.length;
            // de-reference ahead for execution speed:
            const tests = signatures.map((s)=>s.test);
            const fns = signatures.map((s)=>s.implementation);
            const generic = function generic() {
                for(let i = iStart; i < iEnd; i++){
                    if (tests[i](arguments)) return fns[i].apply(this, arguments);
                }
                return typed.onMismatch(name, arguments, signatures);
            };
            // create the typed function
            // fast, specialized version. Falls back to the slower, generic one if needed
            function theTypedFn(arg0, arg1) {
                if (arguments.length === len0 && test00(arg0) && test01(arg1)) return fn0.apply(this, arguments);
                if (arguments.length === len1 && test10(arg0) && test11(arg1)) return fn1.apply(this, arguments);
                if (arguments.length === len2 && test20(arg0) && test21(arg1)) return fn2.apply(this, arguments);
                if (arguments.length === len3 && test30(arg0) && test31(arg1)) return fn3.apply(this, arguments);
                if (arguments.length === len4 && test40(arg0) && test41(arg1)) return fn4.apply(this, arguments);
                if (arguments.length === len5 && test50(arg0) && test51(arg1)) return fn5.apply(this, arguments);
                return generic.apply(this, arguments);
            }
            // attach name the typed function
            try {
                Object.defineProperty(theTypedFn, 'name', {
                    value: name
                });
            } catch (err) {
            // old browsers do not support Object.defineProperty and some don't support setting the name property
            // the function name is not essential for the functioning, it's mostly useful for debugging,
            // so it's fine to have unnamed functions.
            }
            // attach signatures to the function.
            // This property is close to the original collection of signatures
            // used to create the typed-function, just with unions split:
            theTypedFn.signatures = signaturesMap;
            // Store internal data for functions like resolve, find, etc.
            // Also serves as the flag that this is a typed-function
            theTypedFn._typedFunctionData = {
                signatures: signatures,
                signatureMap: internalSignatureMap
            };
            return theTypedFn;
        }
        /**
     * Action to take on mismatch
     * @param {string} name      Name of function that was attempted to be called
     * @param {Array} args       Actual arguments to the call
     * @param {Array} signatures Known signatures of the named typed-function
     */ function _onMismatch(name, args, signatures) {
            throw createError(name, args, signatures);
        }
        /**
     * Return all but the last items of an array or function Arguments
     * @param {Array | Arguments} arr
     * @return {Array}
     */ function initial(arr) {
            return slice(arr, 0, arr.length - 1);
        }
        /**
     * return the last item of an array or function Arguments
     * @param {Array | Arguments} arr
     * @return {*}
     */ function last(arr) {
            return arr[arr.length - 1];
        }
        /**
     * Slice an array or function Arguments
     * @param {Array | Arguments | IArguments} arr
     * @param {number} start
     * @param {number} [end]
     * @return {Array}
     */ function slice(arr, start, end) {
            return Array.prototype.slice.call(arr, start, end);
        }
        /**
     * Return the first item from an array for which test(arr[i]) returns true
     * @param {Array} arr
     * @param {function} test
     * @return {* | undefined} Returns the first matching item
     *                         or undefined when there is no match
     */ function findInArray(arr, test) {
            for(let i = 0; i < arr.length; i++){
                if (test(arr[i])) return arr[i];
            }
            return undefined;
        }
        /**
     * Flat map the result invoking a callback for every item in an array.
     * https://gist.github.com/samgiles/762ee337dff48623e729
     * @param {Array} arr
     * @param {function} callback
     * @return {Array}
     */ function flatMap(arr, callback) {
            return Array.prototype.concat.apply([], arr.map(callback));
        }
        /**
     * Create a reference callback to one or multiple signatures
     *
     * Syntax:
     *
     *     typed.referTo(signature1, signature2, ..., function callback(fn1, fn2, ...) {
     *       // ...
     *     })
     *
     * @returns {{referTo: {references: string[], callback}}}
     */ function referTo() {
            const references = initial(arguments).map((s)=>stringifyParams(parseSignature(s)));
            const callback = last(arguments);
            if (typeof callback !== 'function') throw new TypeError('Callback function expected as last argument');
            return makeReferTo(references, callback);
        }
        function makeReferTo(references, callback) {
            return {
                referTo: {
                    references: references,
                    callback: callback
                }
            };
        }
        /**
     * Create a reference callback to the typed-function itself
     *
     * @param {(self: function) => function} callback
     * @returns {{referToSelf: { callback: function }}}
     */ function referToSelf(callback) {
            if (typeof callback !== 'function') throw new TypeError('Callback function expected as first argument');
            return {
                referToSelf: {
                    callback: callback
                }
            };
        }
        /**
     * Test whether something is a referTo object, holding a list with reference
     * signatures and a callback.
     *
     * @param {Object | function} objectOrFn
     * @returns {boolean}
     */ function isReferTo(objectOrFn) {
            return objectOrFn && typeof objectOrFn.referTo === 'object' && Array.isArray(objectOrFn.referTo.references) && typeof objectOrFn.referTo.callback === 'function';
        }
        /**
     * Test whether something is a referToSelf object, holding a callback where
     * to pass `self`.
     *
     * @param {Object | function} objectOrFn
     * @returns {boolean}
     */ function isReferToSelf(objectOrFn) {
            return objectOrFn && typeof objectOrFn.referToSelf === 'object' && typeof objectOrFn.referToSelf.callback === 'function';
        }
        /**
     * Check if name is (A) new, (B) a match, or (C) a mismatch; and throw
     * an error in case (C).
     *
     * @param { string | undefined } nameSoFar
     * @param { string | undefined } newName
     * @returns { string } updated name
     */ function checkName(nameSoFar, newName) {
            if (!nameSoFar) return newName;
            if (newName && newName !== nameSoFar) {
                const err = new Error('Function names do not match (expected: ' + nameSoFar + ', actual: ' + newName + ')');
                err.data = {
                    actual: newName,
                    expected: nameSoFar
                };
                throw err;
            }
            return nameSoFar;
        }
        /**
     * Retrieve the implied name from an object with signature keys
     * and function values, checking whether all value names match
     *
     * @param { {string: function} } obj
     */ function getObjectName(obj) {
            let name;
            for(const key in obj)// Only pay attention to own properties, and only if their values
            // are typed functions or functions with a signature property
            if (Object.prototype.hasOwnProperty.call(obj, key) && (isTypedFunction(obj[key]) || typeof obj[key].signature === 'string')) name = checkName(name, obj[key].name);
            return name;
        }
        /**
     * Copy all of the signatures from the second argument into the first,
     * which is modified by side effect, checking for conflicts
     *
     * @param {Object.<string, function|typed-reference>} dest
     * @param {Object.<string, function|typed-reference>} source
     */ function mergeSignatures(dest, source) {
            let key;
            for(key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
                if (key in dest) {
                    if (source[key] !== dest[key]) {
                        const err = new Error('Signature "' + key + '" is defined twice');
                        err.data = {
                            signature: key,
                            sourceFunction: source[key],
                            destFunction: dest[key]
                        };
                        throw err;
                    }
                }
                dest[key] = source[key];
            }
        }
        const saveTyped = typed;
        /**
     * Originally the main function was a typed function itself, but then
     * it might not be able to generate error messages if the client
     * replaced the type system with different names.
     *
     * Main entry: typed([name], functions/objects with signatures...)
     *
     * Assembles and returns a new typed-function from the given items
     * that provide signatures and implementations, each of which may be
     * * a plain object mapping (string) signatures to implementing functions,
     * * a previously constructed typed function, or
     * * any other single function with a string-valued property `signature`.
      * The name of the resulting typed-function will be given by the
     * string-valued name argument if present, or if not, by the name
     * of any of the arguments that have one, as long as any that do are
     * consistent with each other. If no name is specified, the name will be
     * an empty string.
     *
     * @param {string} maybeName [optional]
     * @param {(function|object)[]} signature providers
     * @returns {typed-function}
     */ typed = function(maybeName) {
            const named = typeof maybeName === 'string';
            const start = named ? 1 : 0;
            let name = named ? maybeName : '';
            const allSignatures = {};
            for(let i = start; i < arguments.length; ++i){
                const item = arguments[i];
                let theseSignatures = {};
                let thisName;
                if (typeof item === 'function') {
                    thisName = item.name;
                    if (typeof item.signature === 'string') // Case 1: Ordinary function with a string 'signature' property
                    theseSignatures[item.signature] = item;
                    else if (isTypedFunction(item)) // Case 2: Existing typed function
                    theseSignatures = item.signatures;
                } else if (isPlainObject(item)) {
                    // Case 3: Plain object, assume keys = signatures, values = functions
                    theseSignatures = item;
                    if (!named) thisName = getObjectName(item);
                }
                if (Object.keys(theseSignatures).length === 0) {
                    const err = new TypeError('Argument to \'typed\' at index ' + i + ' is not a (typed) function, ' + 'nor an object with signatures as keys and functions as values.');
                    err.data = {
                        index: i,
                        argument: item
                    };
                    throw err;
                }
                if (!named) name = checkName(name, thisName);
                mergeSignatures(allSignatures, theseSignatures);
            }
            return createTypedFunction(name || '', allSignatures);
        };
        typed.create = create;
        typed.createCount = saveTyped.createCount;
        typed.onMismatch = _onMismatch;
        typed.throwMismatchError = _onMismatch;
        typed.createError = createError;
        typed.clear = clear;
        typed.clearConversions = clearConversions;
        typed.addTypes = addTypes;
        typed._findType = findType; // For unit testing only
        typed.referTo = referTo;
        typed.referToSelf = referToSelf;
        typed.convert = convert;
        typed.findSignature = findSignature;
        typed.find = find;
        typed.isTypedFunction = isTypedFunction;
        typed.warnAgainstDeprecatedThis = true;
        /**
     * add a type (convenience wrapper for typed.addTypes)
     * @param {{name: string, test: function}} type
     * @param {boolean} [beforeObjectTest=true]
     *                          If true, the new test will be inserted before
     *                          the test with name 'Object' (if any), since
     *                          tests for Object match Array and classes too.
     */ typed.addType = function(type, beforeObjectTest) {
            let before = 'any';
            if (beforeObjectTest !== false && typeMap.has('Object')) before = 'Object';
            typed.addTypes([
                type
            ], before);
        };
        /**
     * Verify that the ConversionDef conversion has a valid format.
     *
     * @param {conversionDef} conversion
     * @return {void}
     * @throws {TypeError|SyntaxError}
     */ function _validateConversion(conversion) {
            if (!conversion || typeof conversion.from !== 'string' || typeof conversion.to !== 'string' || typeof conversion.convert !== 'function') throw new TypeError('Object with properties {from: string, to: string, convert: function} expected');
            if (conversion.to === conversion.from) throw new SyntaxError('Illegal to define conversion from "' + conversion.from + '" to itself.');
        }
        /**
     * Add a conversion
     *
     * @param {ConversionDef} conversion
     * @param {{override: boolean}} [options]
     * @returns {void}
     * @throws {TypeError}
     */ typed.addConversion = function(conversion) {
            let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                override: false
            };
            _validateConversion(conversion);
            const to = findType(conversion.to);
            const existing = to.conversionsTo.find((other)=>other.from === conversion.from);
            if (existing) {
                if (options && options.override) typed.removeConversion({
                    from: existing.from,
                    to: conversion.to,
                    convert: existing.convert
                });
                else throw new Error('There is already a conversion from "' + conversion.from + '" to "' + to.name + '"');
            }
            to.conversionsTo.push({
                from: conversion.from,
                to: to.name,
                convert: conversion.convert,
                index: nConversions++
            });
        };
        /**
     * Convenience wrapper to call addConversion on each conversion in a list.
     *
     * @param {ConversionDef[]} conversions
     * @param {{override: boolean}} [options]
     * @returns {void}
     * @throws {TypeError}
     */ typed.addConversions = function(conversions, options) {
            conversions.forEach((conversion)=>typed.addConversion(conversion, options));
        };
        /**
     * Remove the specified conversion. The format is the same as for
     * addConversion, and the convert function must match or an error
     * is thrown.
     *
     * @param {{from: string, to: string, convert: function}} conversion
     * @returns {void}
     * @throws {TypeError|SyntaxError|Error}
     */ typed.removeConversion = function(conversion) {
            _validateConversion(conversion);
            const to = findType(conversion.to);
            const existingConversion = findInArray(to.conversionsTo, (c)=>c.from === conversion.from);
            if (!existingConversion) throw new Error('Attempt to remove nonexistent conversion from ' + conversion.from + ' to ' + conversion.to);
            if (existingConversion.convert !== conversion.convert) throw new Error('Conversion to remove does not match existing conversion');
            const index = to.conversionsTo.indexOf(existingConversion);
            to.conversionsTo.splice(index, 1);
        };
        /**
     * Produce the specific signature that a typed function
     * will execute on the given arguments. Here, a "signature" is an
     * object with properties 'params', 'test', 'fn', and 'implementation'.
     * This last property is a function that converts params as necessary
     * and then calls 'fn'. Returns null if there is no matching signature.
     * @param {typed-function} tf
     * @param {any[]} argList
     * @returns {{params: string, test: function, fn: function, implementation: function}}
     */ typed.resolve = function(tf, argList) {
            if (!isTypedFunction(tf)) throw new TypeError(NOT_TYPED_FUNCTION);
            const sigs = tf._typedFunctionData.signatures;
            for(let i = 0; i < sigs.length; ++i){
                if (sigs[i].test(argList)) return sigs[i];
            }
            return null;
        };
        return typed;
    }
    var typedFunction = create();
    return typedFunction;
});

});



parcelRegister("m5mef", function(module, exports) {

$parcel$export(module.exports, "createDet", () => $042636150c3ab783$export$93f810683c54b005);

var $edQYF = parcelRequire("edQYF");

var $9v8q6 = parcelRequire("9v8q6");

var $j2hDb = parcelRequire("j2hDb");

var $dsu7t = parcelRequire("dsu7t");
var $042636150c3ab783$var$name = 'det';
var $042636150c3ab783$var$dependencies = [
    'typed',
    'matrix',
    'subtractScalar',
    'multiply',
    'divideScalar',
    'isZero',
    'unaryMinus'
];
var $042636150c3ab783$export$93f810683c54b005 = /* #__PURE__ */ (0, $dsu7t.factory)($042636150c3ab783$var$name, $042636150c3ab783$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, subtractScalar: subtractScalar, multiply: multiply, divideScalar: divideScalar, isZero: isZero, unaryMinus: unaryMinus } = _ref;
    /**
   * Calculate the determinant of a matrix.
   *
   * Syntax:
   *
   *    math.det(x)
   *
   * Examples:
   *
   *    math.det([[1, 2], [3, 4]]) // returns -2
   *
   *    const A = [
   *      [-2, 2, 3],
   *      [-1, 1, 3],
   *      [2, 0, -1]
   *    ]
   *    math.det(A) // returns 6
   *
   * See also:
   *
   *    inv
   *
   * @param {Array | Matrix} x  A matrix
   * @return {number} The determinant of `x`
   */ return typed($042636150c3ab783$var$name, {
        any: function any(x) {
            return (0, $9v8q6.clone)(x);
        },
        'Array | Matrix': function det(x) {
            var size;
            if ((0, $edQYF.isMatrix)(x)) size = x.size();
            else if (Array.isArray(x)) {
                x = matrix(x);
                size = x.size();
            } else // a scalar
            size = [];
            switch(size.length){
                case 0:
                    // scalar
                    return (0, $9v8q6.clone)(x);
                case 1:
                    // vector
                    if (size[0] === 1) return (0, $9v8q6.clone)(x.valueOf()[0]);
                    if (size[0] === 0) return 1; // det of an empty matrix is per definition 1
                    else throw new RangeError("Matrix must be square (size: " + (0, $j2hDb.format)(size) + ')');
                case 2:
                    // two-dimensional array
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) return _det(x.clone().valueOf(), rows, cols);
                    if (cols === 0) return 1; // det of an empty matrix is per definition 1
                    else throw new RangeError("Matrix must be square (size: " + (0, $j2hDb.format)(size) + ')');
                default:
                    // multi dimensional array
                    throw new RangeError("Matrix must be two dimensional (size: " + (0, $j2hDb.format)(size) + ')');
            }
        }
    });
    /**
   * Calculate the determinant of a matrix
   * @param {Array[]} matrix  A square, two dimensional matrix
   * @param {number} rows     Number of rows of the matrix (zero-based)
   * @param {number} cols     Number of columns of the matrix (zero-based)
   * @returns {number} det
   * @private
   */ function _det(matrix, rows, cols) {
        if (rows === 1) // this is a 1 x 1 matrix
        return (0, $9v8q6.clone)(matrix[0][0]);
        else if (rows === 2) // this is a 2 x 2 matrix
        // the determinant of [a11,a12;a21,a22] is det = a11*a22-a21*a12
        return subtractScalar(multiply(matrix[0][0], matrix[1][1]), multiply(matrix[1][0], matrix[0][1]));
        else {
            // Bareiss algorithm
            // this algorithm have same complexity as LUP decomposition (O(n^3))
            // but it preserve precision of floating point more relative to the LUP decomposition
            var negated = false;
            var rowIndices = new Array(rows).fill(0).map((_, i)=>i); // matrix index of row i
            for(var k = 0; k < rows; k++){
                var k_ = rowIndices[k];
                if (isZero(matrix[k_][k])) {
                    var _k = void 0;
                    for(_k = k + 1; _k < rows; _k++)if (!isZero(matrix[rowIndices[_k]][k])) {
                        k_ = rowIndices[_k];
                        rowIndices[_k] = rowIndices[k];
                        rowIndices[k] = k_;
                        negated = !negated;
                        break;
                    }
                    if (_k === rows) return matrix[k_][k]; // some zero of the type
                }
                var piv = matrix[k_][k];
                var piv_ = k === 0 ? 1 : matrix[rowIndices[k - 1]][k - 1];
                for(var i = k + 1; i < rows; i++){
                    var i_ = rowIndices[i];
                    for(var j = k + 1; j < rows; j++)matrix[i_][j] = divideScalar(subtractScalar(multiply(matrix[i_][j], piv), multiply(matrix[i_][k], matrix[k_][j])), piv_);
                }
            }
            var det = matrix[rowIndices[rows - 1]][rows - 1];
            return negated ? unaryMinus(det) : det;
        }
    }
});

});

parcelRegister("egJXN", function(module, exports) {

$parcel$export(module.exports, "createDiag", () => $a63636aeb3ce2712$export$743a950f2cd4bacc);

var $edQYF = parcelRequire("edQYF");

var $d80Xp = parcelRequire("d80Xp");

var $6NnhX = parcelRequire("6NnhX");

var $dsu7t = parcelRequire("dsu7t");
var $a63636aeb3ce2712$var$name = 'diag';
var $a63636aeb3ce2712$var$dependencies = [
    'typed',
    'matrix',
    'DenseMatrix',
    'SparseMatrix'
];
var $a63636aeb3ce2712$export$743a950f2cd4bacc = /* #__PURE__ */ (0, $dsu7t.factory)($a63636aeb3ce2712$var$name, $a63636aeb3ce2712$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a diagonal matrix or retrieve the diagonal of a matrix
   *
   * When `x` is a vector, a matrix with vector `x` on the diagonal will be returned.
   * When `x` is a two dimensional matrix, the matrixes `k`th diagonal will be returned as vector.
   * When k is positive, the values are placed on the super diagonal.
   * When k is negative, the values are placed on the sub diagonal.
   *
   * Syntax:
   *
   *     math.diag(X)
   *     math.diag(X, format)
   *     math.diag(X, k)
   *     math.diag(X, k, format)
   *
   * Examples:
   *
   *     // create a diagonal matrix
   *     math.diag([1, 2, 3])      // returns [[1, 0, 0], [0, 2, 0], [0, 0, 3]]
   *     math.diag([1, 2, 3], 1)   // returns [[0, 1, 0, 0], [0, 0, 2, 0], [0, 0, 0, 3]]
   *     math.diag([1, 2, 3], -1)  // returns [[0, 0, 0], [1, 0, 0], [0, 2, 0], [0, 0, 3]]
   *
   *    // retrieve the diagonal from a matrix
   *    const a = [[1, 2, 3], [4, 5, 6], [7, 8, 9]]
   *    math.diag(a)   // returns [1, 5, 9]
   *
   * See also:
   *
   *     ones, zeros, identity
   *
   * @param {Matrix | Array} x          A two dimensional matrix or a vector
   * @param {number | BigNumber} [k=0]  The diagonal where the vector will be filled
   *                                    in or retrieved.
   * @param {string} [format='dense']   The matrix storage format.
   *
   * @returns {Matrix | Array} Diagonal matrix from input vector, or diagonal from input matrix.
   */ return typed($a63636aeb3ce2712$var$name, {
        // FIXME: simplify this huge amount of signatures as soon as typed-function supports optional arguments
        Array: function Array(x) {
            return _diag(x, 0, (0, $d80Xp.arraySize)(x), null);
        },
        'Array, number': function Array_number(x, k) {
            return _diag(x, k, (0, $d80Xp.arraySize)(x), null);
        },
        'Array, BigNumber': function Array_BigNumber(x, k) {
            return _diag(x, k.toNumber(), (0, $d80Xp.arraySize)(x), null);
        },
        'Array, string': function Array_string(x, format) {
            return _diag(x, 0, (0, $d80Xp.arraySize)(x), format);
        },
        'Array, number, string': function Array_number_string(x, k, format) {
            return _diag(x, k, (0, $d80Xp.arraySize)(x), format);
        },
        'Array, BigNumber, string': function Array_BigNumber_string(x, k, format) {
            return _diag(x, k.toNumber(), (0, $d80Xp.arraySize)(x), format);
        },
        Matrix: function Matrix(x) {
            return _diag(x, 0, x.size(), x.storage());
        },
        'Matrix, number': function Matrix_number(x, k) {
            return _diag(x, k, x.size(), x.storage());
        },
        'Matrix, BigNumber': function Matrix_BigNumber(x, k) {
            return _diag(x, k.toNumber(), x.size(), x.storage());
        },
        'Matrix, string': function Matrix_string(x, format) {
            return _diag(x, 0, x.size(), format);
        },
        'Matrix, number, string': function Matrix_number_string(x, k, format) {
            return _diag(x, k, x.size(), format);
        },
        'Matrix, BigNumber, string': function Matrix_BigNumber_string(x, k, format) {
            return _diag(x, k.toNumber(), x.size(), format);
        }
    });
    /**
   * Creeate diagonal matrix from a vector or vice versa
   * @param {Array | Matrix} x
   * @param {number} k
   * @param {string} format Storage format for matrix. If null,
   *                          an Array is returned
   * @returns {Array | Matrix}
   * @private
   */ function _diag(x, k, size, format) {
        if (!(0, $6NnhX.isInteger)(k)) throw new TypeError('Second parameter in function diag must be an integer');
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0;
        // check dimensions
        switch(size.length){
            case 1:
                return _createDiagonalMatrix(x, k, format, size[0], kSub, kSuper);
            case 2:
                return _getDiagonal(x, k, format, size, kSub, kSuper);
        }
        throw new RangeError('Matrix for function diag must be 2 dimensional');
    }
    function _createDiagonalMatrix(x, k, format, l, kSub, kSuper) {
        // matrix size
        var ms = [
            l + kSub,
            l + kSuper
        ];
        if (format && format !== 'sparse' && format !== 'dense') throw new TypeError("Unknown matrix type ".concat(format, "\""));
        // create diagonal matrix
        var m = format === 'sparse' ? SparseMatrix.diagonal(ms, x, k) : DenseMatrix.diagonal(ms, x, k);
        // check we need to return a matrix
        return format !== null ? m : m.valueOf();
    }
    function _getDiagonal(x, k, format, s, kSub, kSuper) {
        // check x is a Matrix
        if ((0, $edQYF.isMatrix)(x)) {
            // get diagonal matrix
            var dm = x.diagonal(k);
            // check we need to return a matrix
            if (format !== null) {
                // check we need to change matrix format
                if (format !== dm.storage()) return matrix(dm, format);
                return dm;
            }
            return dm.valueOf();
        }
        // vector size
        var n = Math.min(s[0] - kSub, s[1] - kSuper);
        // diagonal values
        var vector = [];
        // loop diagonal
        for(var i = 0; i < n; i++)vector[i] = x[i + kSub][i + kSuper];
        // check we need to return a matrix
        return format !== null ? matrix(vector) : vector;
    }
});

});

parcelRegister("g8GEJ", function(module, exports) {

$parcel$export(module.exports, "createDiff", () => $bbfe7b4c71498589$export$49df08fd121951b4);

var $dsu7t = parcelRequire("dsu7t");

var $6NnhX = parcelRequire("6NnhX");

var $edQYF = parcelRequire("edQYF");
var $bbfe7b4c71498589$var$name = 'diff';
var $bbfe7b4c71498589$var$dependencies = [
    'typed',
    'matrix',
    'subtract',
    'number'
];
var $bbfe7b4c71498589$export$49df08fd121951b4 = /* #__PURE__ */ (0, $dsu7t.factory)($bbfe7b4c71498589$var$name, $bbfe7b4c71498589$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, subtract: subtract, number: number } = _ref;
    /**
   * Create a new matrix or array of the difference between elements of the given array
   * The optional dim parameter lets you specify the dimension to evaluate the difference of
   * If no dimension parameter is passed it is assumed as dimension 0
   *
   * Dimension is zero-based in javascript and one-based in the parser and can be a number or bignumber
   * Arrays must be 'rectangular' meaning arrays like [1, 2]
   * If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays
   *
   * Syntax:
   *
   *     math.diff(arr)
   *     math.diff(arr, dim)
   *
   * Examples:
   *
   *     const arr = [1, 2, 4, 7, 0]
   *     math.diff(arr) // returns [1, 2, 3, -7] (no dimension passed so 0 is assumed)
   *     math.diff(math.matrix(arr)) // returns Matrix [1, 2, 3, -7]
   *
   *     const arr = [[1, 2, 3, 4, 5], [1, 2, 3, 4, 5], [9, 8, 7, 6, 4]]
   *     math.diff(arr) // returns [[0, 0, 0, 0, 0], [8, 6, 4, 2, -1]]
   *     math.diff(arr, 0) // returns [[0, 0, 0, 0, 0], [8, 6, 4, 2, -1]]
   *     math.diff(arr, 1) // returns [[1, 1, 1, 1], [1, 1, 1, 1], [-1, -1, -1, -2]]
   *     math.diff(arr, math.bignumber(1)) // returns [[1, 1, 1, 1], [1, 1, 1, 1], [-1, -1, -1, -2]]
   *
   *     math.diff(arr, 2) // throws RangeError as arr is 2 dimensional not 3
   *     math.diff(arr, -1) // throws RangeError as negative dimensions are not allowed
   *
   *     // These will all produce the same result
   *     math.diff([[1, 2], [3, 4]])
   *     math.diff([math.matrix([1, 2]), math.matrix([3, 4])])
   *     math.diff([[1, 2], math.matrix([3, 4])])
   *     math.diff([math.matrix([1, 2]), [3, 4]])
   *     // They do not produce the same result as  math.diff(math.matrix([[1, 2], [3, 4]])) as this returns a matrix
   *
   * See Also:
   *
   *      sum
   *      subtract
   *      partitionSelect
   *
   * @param {Array | Matrix} arr      An array or matrix
   * @param {number | BigNumber} dim  Dimension
   * @return {Array | Matrix}         Difference between array elements in given dimension
   */ return typed($bbfe7b4c71498589$var$name, {
        'Array | Matrix': function Array__Matrix(arr) {
            // No dimension specified => assume dimension 0
            if ((0, $edQYF.isMatrix)(arr)) return matrix(_diff(arr.toArray()));
            else return _diff(arr);
        },
        'Array | Matrix, number': function Array__Matrix_number(arr, dim) {
            if (!(0, $6NnhX.isInteger)(dim)) throw new RangeError('Dimension must be a whole number');
            if ((0, $edQYF.isMatrix)(arr)) return matrix(_recursive(arr.toArray(), dim));
            else return _recursive(arr, dim);
        },
        'Array, BigNumber': typed.referTo('Array,number', (selfAn)=>(arr, dim)=>selfAn(arr, number(dim))),
        'Matrix, BigNumber': typed.referTo('Matrix,number', (selfMn)=>(arr, dim)=>selfMn(arr, number(dim)))
    });
    /**
   * Recursively find the correct dimension in the array/matrix
   * Then Apply _diff to that dimension
   *
   * @param {Array} arr      The array
   * @param {number} dim     Dimension
   * @return {Array}         resulting array
   */ function _recursive(arr, dim) {
        if ((0, $edQYF.isMatrix)(arr)) arr = arr.toArray(); // Makes sure arrays like [ matrix([0, 1]), matrix([1, 0]) ] are processed properly
        if (!Array.isArray(arr)) throw RangeError('Array/Matrix does not have that many dimensions');
        if (dim > 0) {
            var result = [];
            arr.forEach((element)=>{
                result.push(_recursive(element, dim - 1));
            });
            return result;
        } else if (dim === 0) return _diff(arr);
        else throw RangeError('Cannot have negative dimension');
    }
    /**
   * Difference between elements in the array
   *
   * @param {Array} arr      An array
   * @return {Array}         resulting array
   */ function _diff(arr) {
        var result = [];
        var size = arr.length;
        for(var i = 1; i < size; i++)result.push(_ElementDiff(arr[i - 1], arr[i]));
        return result;
    }
    /**
   * Difference between 2 objects
   *
   * @param {Object} obj1    First object
   * @param {Object} obj2    Second object
   * @return {Array}         resulting array
   */ function _ElementDiff(obj1, obj2) {
        // Convert matrices to arrays
        if ((0, $edQYF.isMatrix)(obj1)) obj1 = obj1.toArray();
        if ((0, $edQYF.isMatrix)(obj2)) obj2 = obj2.toArray();
        var obj1IsArray = Array.isArray(obj1);
        var obj2IsArray = Array.isArray(obj2);
        if (obj1IsArray && obj2IsArray) return _ArrayDiff(obj1, obj2);
        if (!obj1IsArray && !obj2IsArray) return subtract(obj2, obj1); // Difference is (second - first) NOT (first - second)
        throw TypeError('Cannot calculate difference between 1 array and 1 non-array');
    }
    /**
   * Difference of elements in 2 arrays
   *
   * @param {Array} arr1     Array 1
   * @param {Array} arr2     Array 2
   * @return {Array}         resulting array
   */ function _ArrayDiff(arr1, arr2) {
        if (arr1.length !== arr2.length) throw RangeError('Not all sub-arrays have the same length');
        var result = [];
        var size = arr1.length;
        for(var i = 0; i < size; i++)result.push(_ElementDiff(arr1[i], arr2[i]));
        return result;
    }
});

});

parcelRegister("3DWZO", function(module, exports) {

$parcel$export(module.exports, "createDistance", () => $2a72c6f8d5341133$export$23f482ad1a94fa7e);

var $edQYF = parcelRequire("edQYF");

var $dsu7t = parcelRequire("dsu7t");
var $2a72c6f8d5341133$var$name = 'distance';
var $2a72c6f8d5341133$var$dependencies = [
    'typed',
    'addScalar',
    'subtractScalar',
    'divideScalar',
    'multiplyScalar',
    'deepEqual',
    'sqrt',
    'abs'
];
var $2a72c6f8d5341133$export$23f482ad1a94fa7e = /* #__PURE__ */ (0, $dsu7t.factory)($2a72c6f8d5341133$var$name, $2a72c6f8d5341133$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, subtractScalar: subtractScalar, multiplyScalar: multiplyScalar, divideScalar: divideScalar, deepEqual: deepEqual, sqrt: sqrt, abs: abs } = _ref;
    /**
    * Calculates:
    *    The eucledian distance between two points in N-dimensional spaces.
    *    Distance between point and a line in 2 and 3 dimensional spaces.
    *    Pairwise distance between a set of 2D or 3D points
    * NOTE:
    *    When substituting coefficients of a line(a, b and c), use ax + by + c = 0 instead of ax + by = c
    *    For parametric equation of a 3D line, x0, y0, z0, a, b, c are from: (x−x0, y−y0, z−z0) = t(a, b, c)
    *
    * Syntax:
    *
    *    math.distance([x1,y1], [x2,y2])
    *    math.distance({pointOneX, pointOneY}, {pointTwoX, pointTwoY})
    *    math.distance([x1,y1,z1], [x2,y2,z2])
    *    math.distance({pointOneX, pointOneY, pointOneZ}, {pointTwoX, pointTwoY, pointTwoZ})
    *    math.distance([x1,y1,z1,a1], [x2,y2,z2,a2])
    *    math.distance([[x1,y1], [x2,y2], [x3,y3]])
    *    math.distance([[x1,y1,z1], [x2,y2,z2], [x3,y3,z3]])
    *    math.distance([pointX,pointY], [a,b,c])
    *    math.distance([pointX,pointY], [lineOnePtX,lineOnePtY], [lineTwoPtX,lineTwoPtY])
    *    math.distance({pointX, pointY}, {lineOnePtX, lineOnePtY}, {lineTwoPtX, lineTwoPtY})
    *    math.distance([pointX,pointY,pointZ], [x0, y0, z0, a, b, c])
    *    math.distance({pointX, pointY, pointZ}, {x0, y0, z0, a, b, c})
    *
    * Examples:
    *    math.distance([0,0], [4,4])                     // Returns 5.656854249492381
    *    math.distance(
    *     {pointOneX: 0, pointOneY: 0},
    *     {pointTwoX: 10, pointTwoY: 10})                // Returns 14.142135623730951
    *    math.distance([1, 0, 1], [4, -2, 2])            // Returns 3.7416573867739413
    *    math.distance(
    *     {pointOneX: 4, pointOneY: 5, pointOneZ: 8},
    *     {pointTwoX: 2, pointTwoY: 7, pointTwoZ: 9})    // Returns 3
    *    math.distance([1, 0, 1, 0], [0, -1, 0, -1])     // Returns 2
    *    math.distance([[1, 2], [1, 2], [1, 3]])         // Returns [0, 1, 1]
    *    math.distance([[1,2,4], [1,2,6], [8,1,3]])      // Returns [2, 7.14142842854285, 7.681145747868608]
    *    math.distance([10, 10], [8, 1, 3])              // Returns 11.535230316796387
    *    math.distance([0, 0], [3, 0], [0, 4])        // Returns 2.4
    *    math.distance(
    *     {pointX: 0, pointY: 0},
    *     {lineOnePtX: 3, lineOnePtY: 0},
    *     {lineTwoPtX: 0, lineTwoPtY: 4})                // Returns 2.4
    *    math.distance([2, 3, 1], [1, 1, 2, 5, 0, 1])    // Returns 2.3204774044612857
    *    math.distance(
    *     {pointX: 2, pointY: 3, pointZ: 1},
    *     {x0: 1, y0: 1, z0: 2, a: 5, b: 0, c: 1})       // Returns 2.3204774044612857
    *
    * @param {Array | Matrix | Object} x    Co-ordinates of first point
    * @param {Array | Matrix | Object} y    Co-ordinates of second point
    * @return {Number | BigNumber} Returns the distance from two/three points
  */ return typed($2a72c6f8d5341133$var$name, {
        'Array, Array, Array': function Array_Array_Array(x, y, z) {
            // Point to Line 2D (x=Point, y=LinePoint1, z=LinePoint2)
            if (x.length === 2 && y.length === 2 && z.length === 2) {
                if (!_2d(x)) throw new TypeError('Array with 2 numbers or BigNumbers expected for first argument');
                if (!_2d(y)) throw new TypeError('Array with 2 numbers or BigNumbers expected for second argument');
                if (!_2d(z)) throw new TypeError('Array with 2 numbers or BigNumbers expected for third argument');
                if (deepEqual(y, z)) throw new TypeError('LinePoint1 should not be same with LinePoint2');
                var xCoeff = subtractScalar(z[1], y[1]);
                var yCoeff = subtractScalar(y[0], z[0]);
                var constant = subtractScalar(multiplyScalar(z[0], y[1]), multiplyScalar(y[0], z[1]));
                return _distancePointLine2D(x[0], x[1], xCoeff, yCoeff, constant);
            } else throw new TypeError('Invalid Arguments: Try again');
        },
        'Object, Object, Object': function Object_Object_Object(x, y, z) {
            if (Object.keys(x).length === 2 && Object.keys(y).length === 2 && Object.keys(z).length === 2) {
                if (!_2d(x)) throw new TypeError('Values of pointX and pointY should be numbers or BigNumbers');
                if (!_2d(y)) throw new TypeError('Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers');
                if (!_2d(z)) throw new TypeError('Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers');
                if (deepEqual(_objectToArray(y), _objectToArray(z))) throw new TypeError('LinePoint1 should not be same with LinePoint2');
                if ('pointX' in x && 'pointY' in x && 'lineOnePtX' in y && 'lineOnePtY' in y && 'lineTwoPtX' in z && 'lineTwoPtY' in z) {
                    var xCoeff = subtractScalar(z.lineTwoPtY, y.lineOnePtY);
                    var yCoeff = subtractScalar(y.lineOnePtX, z.lineTwoPtX);
                    var constant = subtractScalar(multiplyScalar(z.lineTwoPtX, y.lineOnePtY), multiplyScalar(y.lineOnePtX, z.lineTwoPtY));
                    return _distancePointLine2D(x.pointX, x.pointY, xCoeff, yCoeff, constant);
                } else throw new TypeError('Key names do not match');
            } else throw new TypeError('Invalid Arguments: Try again');
        },
        'Array, Array': function Array_Array(x, y) {
            // Point to Line 2D (x=[pointX, pointY], y=[x-coeff, y-coeff, const])
            if (x.length === 2 && y.length === 3) {
                if (!_2d(x)) throw new TypeError('Array with 2 numbers or BigNumbers expected for first argument');
                if (!_3d(y)) throw new TypeError('Array with 3 numbers or BigNumbers expected for second argument');
                return _distancePointLine2D(x[0], x[1], y[0], y[1], y[2]);
            } else if (x.length === 3 && y.length === 6) {
                // Point to Line 3D
                if (!_3d(x)) throw new TypeError('Array with 3 numbers or BigNumbers expected for first argument');
                if (!_parametricLine(y)) throw new TypeError('Array with 6 numbers or BigNumbers expected for second argument');
                return _distancePointLine3D(x[0], x[1], x[2], y[0], y[1], y[2], y[3], y[4], y[5]);
            } else if (x.length === y.length && x.length > 0) {
                // Point to Point N-dimensions
                if (!_containsOnlyNumbers(x)) throw new TypeError('All values of an array should be numbers or BigNumbers');
                if (!_containsOnlyNumbers(y)) throw new TypeError('All values of an array should be numbers or BigNumbers');
                return _euclideanDistance(x, y);
            } else throw new TypeError('Invalid Arguments: Try again');
        },
        'Object, Object': function Object_Object(x, y) {
            if (Object.keys(x).length === 2 && Object.keys(y).length === 3) {
                if (!_2d(x)) throw new TypeError('Values of pointX and pointY should be numbers or BigNumbers');
                if (!_3d(y)) throw new TypeError('Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers');
                if ('pointX' in x && 'pointY' in x && 'xCoeffLine' in y && 'yCoeffLine' in y && 'constant' in y) return _distancePointLine2D(x.pointX, x.pointY, y.xCoeffLine, y.yCoeffLine, y.constant);
                else throw new TypeError('Key names do not match');
            } else if (Object.keys(x).length === 3 && Object.keys(y).length === 6) {
                // Point to Line 3D
                if (!_3d(x)) throw new TypeError('Values of pointX, pointY and pointZ should be numbers or BigNumbers');
                if (!_parametricLine(y)) throw new TypeError('Values of x0, y0, z0, a, b and c should be numbers or BigNumbers');
                if ('pointX' in x && 'pointY' in x && 'x0' in y && 'y0' in y && 'z0' in y && 'a' in y && 'b' in y && 'c' in y) return _distancePointLine3D(x.pointX, x.pointY, x.pointZ, y.x0, y.y0, y.z0, y.a, y.b, y.c);
                else throw new TypeError('Key names do not match');
            } else if (Object.keys(x).length === 2 && Object.keys(y).length === 2) {
                // Point to Point 2D
                if (!_2d(x)) throw new TypeError('Values of pointOneX and pointOneY should be numbers or BigNumbers');
                if (!_2d(y)) throw new TypeError('Values of pointTwoX and pointTwoY should be numbers or BigNumbers');
                if ('pointOneX' in x && 'pointOneY' in x && 'pointTwoX' in y && 'pointTwoY' in y) return _euclideanDistance([
                    x.pointOneX,
                    x.pointOneY
                ], [
                    y.pointTwoX,
                    y.pointTwoY
                ]);
                else throw new TypeError('Key names do not match');
            } else if (Object.keys(x).length === 3 && Object.keys(y).length === 3) {
                // Point to Point 3D
                if (!_3d(x)) throw new TypeError('Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers');
                if (!_3d(y)) throw new TypeError('Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers');
                if ('pointOneX' in x && 'pointOneY' in x && 'pointOneZ' in x && 'pointTwoX' in y && 'pointTwoY' in y && 'pointTwoZ' in y) return _euclideanDistance([
                    x.pointOneX,
                    x.pointOneY,
                    x.pointOneZ
                ], [
                    y.pointTwoX,
                    y.pointTwoY,
                    y.pointTwoZ
                ]);
                else throw new TypeError('Key names do not match');
            } else throw new TypeError('Invalid Arguments: Try again');
        },
        Array: function Array1(arr) {
            if (!_pairwise(arr)) throw new TypeError('Incorrect array format entered for pairwise distance calculation');
            return _distancePairwise(arr);
        }
    });
    function _isNumber(a) {
        // distance supports numbers and bignumbers
        return typeof a === 'number' || (0, $edQYF.isBigNumber)(a);
    }
    function _2d(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]);
    }
    function _3d(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]) && _isNumber(a[2]);
    }
    function _containsOnlyNumbers(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (!Array.isArray(a)) a = _objectToArray(a);
        return a.every(_isNumber);
    }
    function _parametricLine(a) {
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]) && _isNumber(a[2]) && _isNumber(a[3]) && _isNumber(a[4]) && _isNumber(a[5]);
    }
    function _objectToArray(o) {
        var keys = Object.keys(o);
        var a = [];
        for(var i = 0; i < keys.length; i++)a.push(o[keys[i]]);
        return a;
    }
    function _pairwise(a) {
        // checks for valid arguments passed to _distancePairwise(Array)
        if (a[0].length === 2 && _isNumber(a[0][0]) && _isNumber(a[0][1])) {
            if (a.some((aI)=>aI.length !== 2 || !_isNumber(aI[0]) || !_isNumber(aI[1]))) return false;
        } else if (a[0].length === 3 && _isNumber(a[0][0]) && _isNumber(a[0][1]) && _isNumber(a[0][2])) {
            if (a.some((aI)=>aI.length !== 3 || !_isNumber(aI[0]) || !_isNumber(aI[1]) || !_isNumber(aI[2]))) return false;
        } else return false;
        return true;
    }
    function _distancePointLine2D(x, y, a, b, c) {
        var num = abs(addScalar(addScalar(multiplyScalar(a, x), multiplyScalar(b, y)), c));
        var den = sqrt(addScalar(multiplyScalar(a, a), multiplyScalar(b, b)));
        return divideScalar(num, den);
    }
    function _distancePointLine3D(x, y, z, x0, y0, z0, a, b, c) {
        var num = [
            subtractScalar(multiplyScalar(subtractScalar(y0, y), c), multiplyScalar(subtractScalar(z0, z), b)),
            subtractScalar(multiplyScalar(subtractScalar(z0, z), a), multiplyScalar(subtractScalar(x0, x), c)),
            subtractScalar(multiplyScalar(subtractScalar(x0, x), b), multiplyScalar(subtractScalar(y0, y), a))
        ];
        num = sqrt(addScalar(addScalar(multiplyScalar(num[0], num[0]), multiplyScalar(num[1], num[1])), multiplyScalar(num[2], num[2])));
        var den = sqrt(addScalar(addScalar(multiplyScalar(a, a), multiplyScalar(b, b)), multiplyScalar(c, c)));
        return divideScalar(num, den);
    }
    function _euclideanDistance(x, y) {
        var vectorSize = x.length;
        var result = 0;
        var diff = 0;
        for(var i = 0; i < vectorSize; i++){
            diff = subtractScalar(x[i], y[i]);
            result = addScalar(multiplyScalar(diff, diff), result);
        }
        return sqrt(result);
    }
    function _distancePairwise(a) {
        var result = [];
        var pointA = [];
        var pointB = [];
        for(var i = 0; i < a.length - 1; i++)for(var j = i + 1; j < a.length; j++){
            if (a[0].length === 2) {
                pointA = [
                    a[i][0],
                    a[i][1]
                ];
                pointB = [
                    a[j][0],
                    a[j][1]
                ];
            } else if (a[0].length === 3) {
                pointA = [
                    a[i][0],
                    a[i][1],
                    a[i][2]
                ];
                pointB = [
                    a[j][0],
                    a[j][1],
                    a[j][2]
                ];
            }
            result.push(_euclideanDistance(pointA, pointB));
        }
        return result;
    }
});

});

parcelRegister("2y6AI", function(module, exports) {

$parcel$export(module.exports, "createDivide", () => $1db3de9eca0119c2$export$4df5e56bb6d14758);

var $dsu7t = parcelRequire("dsu7t");

var $9v8q6 = parcelRequire("9v8q6");

var $52JKA = parcelRequire("52JKA");

var $dK2sh = parcelRequire("dK2sh");
var $1db3de9eca0119c2$var$name = 'divide';
var $1db3de9eca0119c2$var$dependencies = [
    'typed',
    'matrix',
    'multiply',
    'equalScalar',
    'divideScalar',
    'inv'
];
var $1db3de9eca0119c2$export$4df5e56bb6d14758 = /* #__PURE__ */ (0, $dsu7t.factory)($1db3de9eca0119c2$var$name, $1db3de9eca0119c2$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, multiply: multiply, equalScalar: equalScalar, divideScalar: divideScalar, inv: inv } = _ref;
    var matAlgo11xS0s = (0, $52JKA.createMatAlgo11xS0s)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo14xDs = (0, $dK2sh.createMatAlgo14xDs)({
        typed: typed
    });
    /**
   * Divide two values, `x / y`.
   * To divide matrices, `x` is multiplied with the inverse of `y`: `x * inv(y)`.
   *
   * Syntax:
   *
   *    math.divide(x, y)
   *
   * Examples:
   *
   *    math.divide(2, 3)            // returns number 0.6666666666666666
   *
   *    const a = math.complex(5, 14)
   *    const b = math.complex(4, 1)
   *    math.divide(a, b)            // returns Complex 2 + 3i
   *
   *    const c = [[7, -6], [13, -4]]
   *    const d = [[1, 2], [4, 3]]
   *    math.divide(c, d)            // returns Array [[-9, 4], [-11, 6]]
   *
   *    const e = math.unit('18 km')
   *    math.divide(e, 4.5)          // returns Unit 4 km
   *
   * See also:
   *
   *    multiply
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} x   Numerator
   * @param  {number | BigNumber | bigint | Fraction | Complex | Array | Matrix} y          Denominator
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix}                      Quotient, `x / y`
   */ return typed('divide', (0, $9v8q6.extend)({
        // we extend the signatures of divideScalar with signatures dealing with matrices
        'Array | Matrix, Array | Matrix': function Array__Matrix_Array__Matrix(x, y) {
            // TODO: implement matrix right division using pseudo inverse
            // https://www.mathworks.nl/help/matlab/ref/mrdivide.html
            // https://www.gnu.org/software/octave/doc/interpreter/Arithmetic-Ops.html
            // https://stackoverflow.com/questions/12263932/how-does-gnu-octave-matrix-division-work-getting-unexpected-behaviour
            return multiply(x, inv(y));
        },
        'DenseMatrix, any': function DenseMatrix_any(x, y) {
            return matAlgo14xDs(x, y, divideScalar, false);
        },
        'SparseMatrix, any': function SparseMatrix_any(x, y) {
            return matAlgo11xS0s(x, y, divideScalar, false);
        },
        'Array, any': function Array_any(x, y) {
            // use matrix implementation
            return matAlgo14xDs(matrix(x), y, divideScalar, false).valueOf();
        },
        'any, Array | Matrix': function any_Array__Matrix(x, y) {
            return multiply(x, inv(y));
        }
    }, divideScalar.signatures));
});

});

parcelRegister("iTHHP", function(module, exports) {

$parcel$export(module.exports, "createDivideScalar", () => $dc1f441e74a26fd6$export$399593177816ff82);

var $dsu7t = parcelRequire("dsu7t");
var $dc1f441e74a26fd6$var$name = 'divideScalar';
var $dc1f441e74a26fd6$var$dependencies = [
    'typed',
    'numeric'
];
var $dc1f441e74a26fd6$export$399593177816ff82 = /* #__PURE__ */ (0, $dsu7t.factory)($dc1f441e74a26fd6$var$name, $dc1f441e74a26fd6$var$dependencies, (_ref)=>{
    var { typed: typed, numeric: numeric } = _ref;
    /**
   * Divide two scalar values, `x / y`.
   * This function is meant for internal use: it is used by the public functions
   * `divide` and `inv`.
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit} x   Numerator
   * @param  {number | BigNumber | bigint | Fraction | Complex} y          Denominator
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit}     Quotient, `x / y`
   * @private
   */ return typed($dc1f441e74a26fd6$var$name, {
        'number, number': function number_number(x, y) {
            return x / y;
        },
        'Complex, Complex': function Complex_Complex(x, y) {
            return x.div(y);
        },
        'BigNumber, BigNumber': function BigNumber_BigNumber(x, y) {
            return x.div(y);
        },
        'bigint, bigint': function bigint_bigint(x, y) {
            return x / y;
        },
        'Fraction, Fraction': function Fraction_Fraction(x, y) {
            return x.div(y);
        },
        'Unit, number | Complex | Fraction | BigNumber | Unit': (x, y)=>x.divide(y),
        'number | Fraction | Complex | BigNumber, Unit': (x, y)=>y.divideInto(x)
    });
});

});

parcelRegister("5jhpz", function(module, exports) {

$parcel$export(module.exports, "createDot", () => $3ddc3ba06ae467fc$export$3dc59ff00984d687);

var $dsu7t = parcelRequire("dsu7t");

var $edQYF = parcelRequire("edQYF");
var $3ddc3ba06ae467fc$var$name = 'dot';
var $3ddc3ba06ae467fc$var$dependencies = [
    'typed',
    'addScalar',
    'multiplyScalar',
    'conj',
    'size'
];
var $3ddc3ba06ae467fc$export$3dc59ff00984d687 = /* #__PURE__ */ (0, $dsu7t.factory)($3ddc3ba06ae467fc$var$name, $3ddc3ba06ae467fc$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, multiplyScalar: multiplyScalar, conj: conj, size: size } = _ref;
    /**
   * Calculate the dot product of two vectors. The dot product of
   * `A = [a1, a2, ..., an]` and `B = [b1, b2, ..., bn]` is defined as:
   *
   *    dot(A, B) = conj(a1) * b1 + conj(a2) * b2 + ... + conj(an) * bn
   *
   * Syntax:
   *
   *    math.dot(x, y)
   *
   * Examples:
   *
   *    math.dot([2, 4, 1], [2, 2, 3])       // returns number 15
   *    math.multiply([2, 4, 1], [2, 2, 3])  // returns number 15
   *
   * See also:
   *
   *    multiply, cross
   *
   * @param  {Array | Matrix} x     First vector
   * @param  {Array | Matrix} y     Second vector
   * @return {number}               Returns the dot product of `x` and `y`
   */ return typed($3ddc3ba06ae467fc$var$name, {
        'Array | DenseMatrix, Array | DenseMatrix': _denseDot,
        'SparseMatrix, SparseMatrix': _sparseDot
    });
    function _validateDim(x, y) {
        var xSize = _size(x);
        var ySize = _size(y);
        var xLen, yLen;
        if (xSize.length === 1) xLen = xSize[0];
        else if (xSize.length === 2 && xSize[1] === 1) xLen = xSize[0];
        else throw new RangeError('Expected a column vector, instead got a matrix of size (' + xSize.join(', ') + ')');
        if (ySize.length === 1) yLen = ySize[0];
        else if (ySize.length === 2 && ySize[1] === 1) yLen = ySize[0];
        else throw new RangeError('Expected a column vector, instead got a matrix of size (' + ySize.join(', ') + ')');
        if (xLen !== yLen) throw new RangeError('Vectors must have equal length (' + xLen + ' != ' + yLen + ')');
        if (xLen === 0) throw new RangeError('Cannot calculate the dot product of empty vectors');
        return xLen;
    }
    function _denseDot(a, b) {
        var N = _validateDim(a, b);
        var adata = (0, $edQYF.isMatrix)(a) ? a._data : a;
        var adt = (0, $edQYF.isMatrix)(a) ? a._datatype || a.getDataType() : undefined;
        var bdata = (0, $edQYF.isMatrix)(b) ? b._data : b;
        var bdt = (0, $edQYF.isMatrix)(b) ? b._datatype || b.getDataType() : undefined;
        // are these 2-dimensional column vectors? (as opposed to 1-dimensional vectors)
        var aIsColumn = _size(a).length === 2;
        var bIsColumn = _size(b).length === 2;
        var add = addScalar;
        var mul = multiplyScalar;
        // process data types
        if (adt && bdt && adt === bdt && typeof adt === 'string' && adt !== 'mixed') {
            var dt = adt;
            // find signatures that matches (dt, dt)
            add = typed.find(addScalar, [
                dt,
                dt
            ]);
            mul = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        }
        // both vectors 1-dimensional
        if (!aIsColumn && !bIsColumn) {
            var c = mul(conj(adata[0]), bdata[0]);
            for(var i = 1; i < N; i++)c = add(c, mul(conj(adata[i]), bdata[i]));
            return c;
        }
        // a is 1-dim, b is column
        if (!aIsColumn && bIsColumn) {
            var _c = mul(conj(adata[0]), bdata[0][0]);
            for(var _i = 1; _i < N; _i++)_c = add(_c, mul(conj(adata[_i]), bdata[_i][0]));
            return _c;
        }
        // a is column, b is 1-dim
        if (aIsColumn && !bIsColumn) {
            var _c2 = mul(conj(adata[0][0]), bdata[0]);
            for(var _i2 = 1; _i2 < N; _i2++)_c2 = add(_c2, mul(conj(adata[_i2][0]), bdata[_i2]));
            return _c2;
        }
        // both vectors are column
        if (aIsColumn && bIsColumn) {
            var _c3 = mul(conj(adata[0][0]), bdata[0][0]);
            for(var _i3 = 1; _i3 < N; _i3++)_c3 = add(_c3, mul(conj(adata[_i3][0]), bdata[_i3][0]));
            return _c3;
        }
    }
    function _sparseDot(x, y) {
        _validateDim(x, y);
        var xindex = x._index;
        var xvalues = x._values;
        var yindex = y._index;
        var yvalues = y._values;
        // TODO optimize add & mul using datatype
        var c = 0;
        var add = addScalar;
        var mul = multiplyScalar;
        var i = 0;
        var j = 0;
        while(i < xindex.length && j < yindex.length){
            var I = xindex[i];
            var J = yindex[j];
            if (I < J) {
                i++;
                continue;
            }
            if (I > J) {
                j++;
                continue;
            }
            if (I === J) {
                c = add(c, mul(xvalues[i], yvalues[j]));
                i++;
                j++;
            }
        }
        return c;
    }
    // TODO remove this once #1771 is fixed
    function _size(x) {
        return (0, $edQYF.isMatrix)(x) ? x.size() : size(x);
    }
});

});

parcelRegister("b9Fwh", function(module, exports) {

$parcel$export(module.exports, "createDotDivide", () => $81f0bde931ae419d$export$e4930a420a373a24);

var $dsu7t = parcelRequire("dsu7t");

var $kycT3 = parcelRequire("kycT3");

var $a8bto = parcelRequire("a8bto");

var $6RFQP = parcelRequire("6RFQP");

var $52JKA = parcelRequire("52JKA");

var $19L2p = parcelRequire("19L2p");

var $6SJnV = parcelRequire("6SJnV");
var $81f0bde931ae419d$var$name = 'dotDivide';
var $81f0bde931ae419d$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'divideScalar',
    'DenseMatrix',
    'concat',
    'SparseMatrix'
];
var $81f0bde931ae419d$export$e4930a420a373a24 = /* #__PURE__ */ (0, $dsu7t.factory)($81f0bde931ae419d$var$name, $81f0bde931ae419d$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, divideScalar: divideScalar, DenseMatrix: DenseMatrix, concat: concat, SparseMatrix: SparseMatrix } = _ref;
    var matAlgo02xDS0 = (0, $kycT3.createMatAlgo02xDS0)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo03xDSf = (0, $a8bto.createMatAlgo03xDSf)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $6RFQP.createMatAlgo07xSSf)({
        typed: typed,
        SparseMatrix: SparseMatrix
    });
    var matAlgo11xS0s = (0, $52JKA.createMatAlgo11xS0s)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Divide two matrices element wise. The function accepts both matrices and
   * scalar values.
   *
   * Syntax:
   *
   *    math.dotDivide(x, y)
   *
   * Examples:
   *
   *    math.dotDivide(2, 4)   // returns 0.5
   *
   *    a = [[9, 5], [6, 1]]
   *    b = [[3, 2], [5, 2]]
   *
   *    math.dotDivide(a, b)   // returns [[3, 2.5], [1.2, 0.5]]
   *    math.divide(a, b)      // returns [[1.75, 0.75], [-1.75, 2.25]]
   *
   * See also:
   *
   *    divide, multiply, dotMultiply
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Numerator
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Denominator
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                    Quotient, `x ./ y`
   */ return typed($81f0bde931ae419d$var$name, matrixAlgorithmSuite({
        elop: divideScalar,
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        SD: matAlgo02xDS0,
        Ss: matAlgo11xS0s,
        sS: matAlgo12xSfs
    }));
});

});

parcelRegister("9KPav", function(module, exports) {

$parcel$export(module.exports, "createDotMultiply", () => $71a019f2985da8d8$export$a4620e84460f321e);

var $dsu7t = parcelRequire("dsu7t");

var $kycT3 = parcelRequire("kycT3");

var $8xtiv = parcelRequire("8xtiv");

var $52JKA = parcelRequire("52JKA");

var $6SJnV = parcelRequire("6SJnV");
var $71a019f2985da8d8$var$name = 'dotMultiply';
var $71a019f2985da8d8$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'multiplyScalar',
    'concat'
];
var $71a019f2985da8d8$export$a4620e84460f321e = /* #__PURE__ */ (0, $dsu7t.factory)($71a019f2985da8d8$var$name, $71a019f2985da8d8$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, multiplyScalar: multiplyScalar, concat: concat } = _ref;
    var matAlgo02xDS0 = (0, $kycT3.createMatAlgo02xDS0)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo09xS0Sf = (0, $8xtiv.createMatAlgo09xS0Sf)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo11xS0s = (0, $52JKA.createMatAlgo11xS0s)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Multiply two matrices element wise. The function accepts both matrices and
   * scalar values.
   *
   * Syntax:
   *
   *    math.dotMultiply(x, y)
   *
   * Examples:
   *
   *    math.dotMultiply(2, 4) // returns 8
   *
   *    a = [[9, 5], [6, 1]]
   *    b = [[3, 2], [5, 2]]
   *
   *    math.dotMultiply(a, b) // returns [[27, 10], [30, 2]]
   *    math.multiply(a, b)    // returns [[52, 28], [23, 14]]
   *
   * See also:
   *
   *    multiply, divide, dotDivide
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Left hand value
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Right hand value
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                    Multiplication of `x` and `y`
   */ return typed($71a019f2985da8d8$var$name, matrixAlgorithmSuite({
        elop: multiplyScalar,
        SS: matAlgo09xS0Sf,
        DS: matAlgo02xDS0,
        Ss: matAlgo11xS0s
    }));
});

});

parcelRegister("laeVF", function(module, exports) {

$parcel$export(module.exports, "createDotPow", () => $f6861cc5ebb0e98e$export$734b49568d8effd6);

var $dsu7t = parcelRequire("dsu7t");

var $a8bto = parcelRequire("a8bto");

var $6RFQP = parcelRequire("6RFQP");

var $52JKA = parcelRequire("52JKA");

var $19L2p = parcelRequire("19L2p");

var $6SJnV = parcelRequire("6SJnV");
var $f6861cc5ebb0e98e$var$name = 'dotPow';
var $f6861cc5ebb0e98e$var$dependencies = [
    'typed',
    'equalScalar',
    'matrix',
    'pow',
    'DenseMatrix',
    'concat',
    'SparseMatrix'
];
var $f6861cc5ebb0e98e$export$734b49568d8effd6 = /* #__PURE__ */ (0, $dsu7t.factory)($f6861cc5ebb0e98e$var$name, $f6861cc5ebb0e98e$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar, matrix: matrix, pow: pow, DenseMatrix: DenseMatrix, concat: concat, SparseMatrix: SparseMatrix } = _ref;
    var matAlgo03xDSf = (0, $a8bto.createMatAlgo03xDSf)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $6RFQP.createMatAlgo07xSSf)({
        typed: typed,
        SparseMatrix: SparseMatrix
    });
    var matAlgo11xS0s = (0, $52JKA.createMatAlgo11xS0s)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var powScalarSignatures = {};
    for(var signature in pow.signatures){
        if (Object.prototype.hasOwnProperty.call(pow.signatures, signature)) {
            if (!signature.includes('Matrix') && !signature.includes('Array')) powScalarSignatures[signature] = pow.signatures[signature];
        }
    }
    var powScalar = typed(powScalarSignatures);
    /**
   * Calculates the power of x to y element wise.
   *
   * Syntax:
   *
   *    math.dotPow(x, y)
   *
   * Examples:
   *
   *    math.dotPow(2, 3)            // returns number 8
   *
   *    const a = [[1, 2], [4, 3]]
   *    math.dotPow(a, 2)            // returns Array [[1, 4], [16, 9]]
   *    math.pow(a, 2)               // returns Array [[9, 8], [16, 17]]
   *
   * See also:
   *
   *    pow, sqrt, multiply
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x  The base
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y  The exponent
   * @return {number | BigNumber | Complex | Unit | Array | Matrix}                     The value of `x` to the power `y`
   */ return typed($f6861cc5ebb0e98e$var$name, matrixAlgorithmSuite({
        elop: powScalar,
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo11xS0s,
        sS: matAlgo12xSfs
    }));
});

});

parcelRegister("eQPyM", function(module, exports) {

$parcel$export(module.exports, "createTrue", () => $acfdeac755400b69$export$e13d32722e2756df);
$parcel$export(module.exports, "createFalse", () => $acfdeac755400b69$export$cb94e3a54c9e99b);
$parcel$export(module.exports, "createNull", () => $acfdeac755400b69$export$d07c6114481fc17b);
$parcel$export(module.exports, "createInfinity", () => $acfdeac755400b69$export$df1313fb6eb44f05);
$parcel$export(module.exports, "createNaN", () => $acfdeac755400b69$export$fbdaee11df58c3cc);
$parcel$export(module.exports, "createPi", () => $acfdeac755400b69$export$2dbe69c48ac7f49c);
$parcel$export(module.exports, "createTau", () => $acfdeac755400b69$export$d5973a6d5d95d479);
$parcel$export(module.exports, "createE", () => $acfdeac755400b69$export$6dca51ff4d4b257f);
$parcel$export(module.exports, "createPhi", () => $acfdeac755400b69$export$f131830080647892);
$parcel$export(module.exports, "createLN2", () => $acfdeac755400b69$export$ab67ddb9e8290a2c);
$parcel$export(module.exports, "createLN10", () => $acfdeac755400b69$export$5365e90aad1235b4);
$parcel$export(module.exports, "createLOG2E", () => $acfdeac755400b69$export$b57f4b4cfc057c2d);
$parcel$export(module.exports, "createLOG10E", () => $acfdeac755400b69$export$57f654bce66ec8ce);
$parcel$export(module.exports, "createSQRT1_2", () => $acfdeac755400b69$export$e6df2cb14f3e8316);
$parcel$export(module.exports, "createSQRT2", () => $acfdeac755400b69$export$f7a593fe98eba575);
$parcel$export(module.exports, "createI", () => $acfdeac755400b69$export$7122d2461a6f9b76);
$parcel$export(module.exports, "createVersion", () => $acfdeac755400b69$export$72a91d9326d5a672);

var $dsu7t = parcelRequire("dsu7t");

var $JxqFn = parcelRequire("JxqFn");

var $epoj7 = parcelRequire("epoj7");

var $iD2EQ = parcelRequire("iD2EQ");
var $acfdeac755400b69$export$e13d32722e2756df = /* #__PURE__ */ (0, $dsu7t.factory)('true', [], ()=>true);
var $acfdeac755400b69$export$cb94e3a54c9e99b = /* #__PURE__ */ (0, $dsu7t.factory)('false', [], ()=>false);
var $acfdeac755400b69$export$d07c6114481fc17b = /* #__PURE__ */ (0, $dsu7t.factory)('null', [], ()=>null);
var $acfdeac755400b69$export$df1313fb6eb44f05 = /* #__PURE__ */ $acfdeac755400b69$var$recreateFactory('Infinity', [
    'config',
    '?BigNumber'
], (_ref)=>{
    var { config: config, BigNumber: BigNumber } = _ref;
    return config.number === 'BigNumber' ? new BigNumber(Infinity) : Infinity;
});
var $acfdeac755400b69$export$fbdaee11df58c3cc = /* #__PURE__ */ $acfdeac755400b69$var$recreateFactory('NaN', [
    'config',
    '?BigNumber'
], (_ref2)=>{
    var { config: config, BigNumber: BigNumber } = _ref2;
    return config.number === 'BigNumber' ? new BigNumber(NaN) : NaN;
});
var $acfdeac755400b69$export$2dbe69c48ac7f49c = /* #__PURE__ */ $acfdeac755400b69$var$recreateFactory('pi', [
    'config',
    '?BigNumber'
], (_ref3)=>{
    var { config: config, BigNumber: BigNumber } = _ref3;
    return config.number === 'BigNumber' ? (0, $epoj7.createBigNumberPi)(BigNumber) : (0, $iD2EQ.pi);
});
var $acfdeac755400b69$export$d5973a6d5d95d479 = /* #__PURE__ */ $acfdeac755400b69$var$recreateFactory('tau', [
    'config',
    '?BigNumber'
], (_ref4)=>{
    var { config: config, BigNumber: BigNumber } = _ref4;
    return config.number === 'BigNumber' ? (0, $epoj7.createBigNumberTau)(BigNumber) : (0, $iD2EQ.tau);
});
var $acfdeac755400b69$export$6dca51ff4d4b257f = /* #__PURE__ */ $acfdeac755400b69$var$recreateFactory('e', [
    'config',
    '?BigNumber'
], (_ref5)=>{
    var { config: config, BigNumber: BigNumber } = _ref5;
    return config.number === 'BigNumber' ? (0, $epoj7.createBigNumberE)(BigNumber) : (0, $iD2EQ.e);
});
var $acfdeac755400b69$export$f131830080647892 = /* #__PURE__ */ $acfdeac755400b69$var$recreateFactory('phi', [
    'config',
    '?BigNumber'
], (_ref6)=>{
    var { config: config, BigNumber: BigNumber } = _ref6;
    return config.number === 'BigNumber' ? (0, $epoj7.createBigNumberPhi)(BigNumber) : (0, $iD2EQ.phi);
});
var $acfdeac755400b69$export$ab67ddb9e8290a2c = /* #__PURE__ */ $acfdeac755400b69$var$recreateFactory('LN2', [
    'config',
    '?BigNumber'
], (_ref7)=>{
    var { config: config, BigNumber: BigNumber } = _ref7;
    return config.number === 'BigNumber' ? new BigNumber(2).ln() : Math.LN2;
});
var $acfdeac755400b69$export$5365e90aad1235b4 = /* #__PURE__ */ $acfdeac755400b69$var$recreateFactory('LN10', [
    'config',
    '?BigNumber'
], (_ref8)=>{
    var { config: config, BigNumber: BigNumber } = _ref8;
    return config.number === 'BigNumber' ? new BigNumber(10).ln() : Math.LN10;
});
var $acfdeac755400b69$export$b57f4b4cfc057c2d = /* #__PURE__ */ $acfdeac755400b69$var$recreateFactory('LOG2E', [
    'config',
    '?BigNumber'
], (_ref9)=>{
    var { config: config, BigNumber: BigNumber } = _ref9;
    return config.number === 'BigNumber' ? new BigNumber(1).div(new BigNumber(2).ln()) : Math.LOG2E;
});
var $acfdeac755400b69$export$57f654bce66ec8ce = /* #__PURE__ */ $acfdeac755400b69$var$recreateFactory('LOG10E', [
    'config',
    '?BigNumber'
], (_ref0)=>{
    var { config: config, BigNumber: BigNumber } = _ref0;
    return config.number === 'BigNumber' ? new BigNumber(1).div(new BigNumber(10).ln()) : Math.LOG10E;
});
var $acfdeac755400b69$export$e6df2cb14f3e8316 = /* #__PURE__ */ $acfdeac755400b69$var$recreateFactory(// eslint-disable-line camelcase
'SQRT1_2', [
    'config',
    '?BigNumber'
], (_ref1)=>{
    var { config: config, BigNumber: BigNumber } = _ref1;
    return config.number === 'BigNumber' ? new BigNumber('0.5').sqrt() : Math.SQRT1_2;
});
var $acfdeac755400b69$export$f7a593fe98eba575 = /* #__PURE__ */ $acfdeac755400b69$var$recreateFactory('SQRT2', [
    'config',
    '?BigNumber'
], (_ref10)=>{
    var { config: config, BigNumber: BigNumber } = _ref10;
    return config.number === 'BigNumber' ? new BigNumber(2).sqrt() : Math.SQRT2;
});
var $acfdeac755400b69$export$7122d2461a6f9b76 = /* #__PURE__ */ $acfdeac755400b69$var$recreateFactory('i', [
    'Complex'
], (_ref11)=>{
    var { Complex: Complex } = _ref11;
    return Complex.I;
});
var $acfdeac755400b69$export$5aab935c59859292 = /* #__PURE__ */ (0, $dsu7t.factory)('PI', [
    'pi'
], (_ref12)=>{
    var { pi: pi } = _ref12;
    return pi;
});
var $acfdeac755400b69$export$56c791a240a1c942 = /* #__PURE__ */ (0, $dsu7t.factory)('E', [
    'e'
], (_ref13)=>{
    var { e: e } = _ref13;
    return e;
});
var $acfdeac755400b69$export$72a91d9326d5a672 = /* #__PURE__ */ (0, $dsu7t.factory)('version', [], ()=>(0, $JxqFn.version));
// helper function to create a factory with a flag recreateOnConfigChange
// idea: allow passing optional properties to be attached to the factory function as 4th argument?
function $acfdeac755400b69$var$recreateFactory(name, dependencies, create) {
    return (0, $dsu7t.factory)(name, dependencies, create, {
        recreateOnConfigChange: true
    });
}

});
parcelRegister("JxqFn", function(module, exports) {

$parcel$export(module.exports, "version", () => $088e226841588374$export$83d89fbfd8236492);
var $088e226841588374$export$83d89fbfd8236492 = '14.9.1'; // Note: This file is automatically generated when building math.js.
 // Changes made in this file will be overwritten.

});

parcelRegister("epoj7", function(module, exports) {

$parcel$export(module.exports, "createBigNumberE", () => $a7d6416f7a579595$export$737cba75de6dfb68);
$parcel$export(module.exports, "createBigNumberPhi", () => $a7d6416f7a579595$export$c7e121b24930c156);
$parcel$export(module.exports, "createBigNumberPi", () => $a7d6416f7a579595$export$d0a8190d955e3c5b);
$parcel$export(module.exports, "createBigNumberTau", () => $a7d6416f7a579595$export$83b6ee92a84f32c6);

var $5MAYL = parcelRequire("5MAYL");
var $a7d6416f7a579595$export$737cba75de6dfb68 = (0, $5MAYL.memoize)(function(BigNumber) {
    return new BigNumber(1).exp();
}, {
    hasher: $a7d6416f7a579595$var$hasher
});
var $a7d6416f7a579595$export$c7e121b24930c156 = (0, $5MAYL.memoize)(function(BigNumber) {
    return new BigNumber(1).plus(new BigNumber(5).sqrt()).div(2);
}, {
    hasher: $a7d6416f7a579595$var$hasher
});
var $a7d6416f7a579595$export$d0a8190d955e3c5b = (0, $5MAYL.memoize)(function(BigNumber) {
    return BigNumber.acos(-1);
}, {
    hasher: $a7d6416f7a579595$var$hasher
});
var $a7d6416f7a579595$export$83b6ee92a84f32c6 = (0, $5MAYL.memoize)(function(BigNumber) {
    return $a7d6416f7a579595$export$d0a8190d955e3c5b(BigNumber).times(2);
}, {
    hasher: $a7d6416f7a579595$var$hasher
});
/**
 * Create a hash for a BigNumber constructor function. The created has is
 * the configured precision
 * @param {Array} args         Supposed to contain a single entry with
 *                             a BigNumber constructor
 * @return {number} precision
 * @private
 */ function $a7d6416f7a579595$var$hasher(args) {
    return args[0].precision;
}

});
parcelRegister("5MAYL", function(module, exports) {

$parcel$export(module.exports, "memoize", () => $435e1eb70611d18b$export$fc10aeed3a532e2a);
// function utils

var $30uyQ = parcelRequire("30uyQ");
function $435e1eb70611d18b$export$fc10aeed3a532e2a(fn) {
    var { hasher: hasher, limit: limit } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    limit = limit == null ? Number.POSITIVE_INFINITY : limit;
    hasher = hasher == null ? JSON.stringify : hasher;
    return function memoize() {
        if (typeof memoize.cache !== 'object') memoize.cache = {
            values: new Map(),
            lru: (0, $30uyQ.lruQueue)(limit || Number.POSITIVE_INFINITY)
        };
        var args = [];
        for(var i = 0; i < arguments.length; i++)args[i] = arguments[i];
        var hash = hasher(args);
        if (memoize.cache.values.has(hash)) {
            memoize.cache.lru.hit(hash);
            return memoize.cache.values.get(hash);
        }
        var newVal = fn.apply(fn, args);
        memoize.cache.values.set(hash, newVal);
        memoize.cache.values.delete(memoize.cache.lru.hit(hash));
        return newVal;
    };
}
function $435e1eb70611d18b$export$22992fec26710d5a(fn, isEqual) {
    var memoize = function memoize() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args[i] = arguments[i];
        for(var c = 0; c < memoize.cache.length; c++){
            var cached = memoize.cache[c];
            if (isEqual(args, cached.args)) // TODO: move this cache entry to the top so recently used entries move up?
            return cached.res;
        }
        var res = fn.apply(fn, args);
        memoize.cache.unshift({
            args: args,
            res: res
        });
        return res;
    };
    memoize.cache = [];
    return memoize;
}

});
parcelRegister("30uyQ", function(module, exports) {

$parcel$export(module.exports, "lruQueue", () => $230913f528a818ec$export$6080faceac22b73a);
// (c) 2018, Mariusz Nowak
// SPDX-License-Identifier: ISC
// Derived from https://github.com/medikoo/lru-queue
function $230913f528a818ec$export$6080faceac22b73a(limit) {
    var size = 0;
    var base = 1;
    var queue = Object.create(null);
    var map = Object.create(null);
    var index = 0;
    var del = function del(id) {
        var oldIndex = map[id];
        if (!oldIndex) return;
        delete queue[oldIndex];
        delete map[id];
        --size;
        if (base !== oldIndex) return;
        if (!size) {
            index = 0;
            base = 1;
            return;
        }
        while(!Object.prototype.hasOwnProperty.call(queue, ++base));
    };
    limit = Math.abs(limit);
    return {
        hit: function hit(id) {
            var oldIndex = map[id];
            var nuIndex = ++index;
            queue[nuIndex] = id;
            map[id] = nuIndex;
            if (!oldIndex) {
                ++size;
                if (size <= limit) return undefined;
                id = queue[base];
                del(id);
                return id;
            }
            delete queue[oldIndex];
            if (base !== oldIndex) return undefined;
            while(!Object.prototype.hasOwnProperty.call(queue, ++base));
            return undefined;
        },
        delete: del,
        clear: function clear() {
            size = index = 0;
            base = 1;
            queue = Object.create(null);
            map = Object.create(null);
        }
    };
}

});



parcelRegister("iD2EQ", function(module, exports) {

$parcel$export(module.exports, "pi", () => $d8fdee4c546bf56b$export$18c7bea995a110f);
$parcel$export(module.exports, "tau", () => $d8fdee4c546bf56b$export$a4b4b4d4d776fe92);
$parcel$export(module.exports, "e", () => $d8fdee4c546bf56b$export$f1e1789686576879);
$parcel$export(module.exports, "phi", () => $d8fdee4c546bf56b$export$324943737027944a);
var $d8fdee4c546bf56b$export$18c7bea995a110f = Math.PI;
var $d8fdee4c546bf56b$export$a4b4b4d4d776fe92 = 2 * Math.PI;
var $d8fdee4c546bf56b$export$f1e1789686576879 = Math.E;
var $d8fdee4c546bf56b$export$324943737027944a = 1.6180339887498948; // eslint-disable-line no-loss-of-precision

});


parcelRegister("52vmX", function(module, exports) {

$parcel$export(module.exports, "createEigs", () => $3ab578f246333e56$export$ba9e077a2df092d7);

var $3p9rK = parcelRequire("3p9rK");

var $dsu7t = parcelRequire("dsu7t");

var $j2hDb = parcelRequire("j2hDb");

var $6Xsh4 = parcelRequire("6Xsh4");

var $cAZdU = parcelRequire("cAZdU");

var $edQYF = parcelRequire("edQYF");
var $3ab578f246333e56$var$name = 'eigs';
// The absolute state of math.js's dependency system:
var $3ab578f246333e56$var$dependencies = [
    'config',
    'typed',
    'matrix',
    'addScalar',
    'equal',
    'subtract',
    'abs',
    'atan',
    'cos',
    'sin',
    'multiplyScalar',
    'divideScalar',
    'inv',
    'bignumber',
    'multiply',
    'add',
    'larger',
    'column',
    'flatten',
    'number',
    'complex',
    'sqrt',
    'diag',
    'size',
    'reshape',
    'qr',
    'usolve',
    'usolveAll',
    'im',
    're',
    'smaller',
    'matrixFromColumns',
    'dot'
];
var $3ab578f246333e56$export$ba9e077a2df092d7 = /* #__PURE__ */ (0, $dsu7t.factory)($3ab578f246333e56$var$name, $3ab578f246333e56$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, matrix: matrix, addScalar: addScalar, subtract: subtract, equal: equal, abs: abs, atan: atan, cos: cos, sin: sin, multiplyScalar: multiplyScalar, divideScalar: divideScalar, inv: inv, bignumber: bignumber, multiply: multiply, add: add, larger: larger, column: column, flatten: flatten, number: number, complex: complex, sqrt: sqrt, diag: diag, size: size, reshape: reshape, qr: qr, usolve: usolve, usolveAll: usolveAll, im: im, re: re, smaller: smaller, matrixFromColumns: matrixFromColumns, dot: dot } = _ref;
    var doRealSymmetric = (0, $cAZdU.createRealSymmetric)({
        config: config,
        addScalar: addScalar,
        subtract: subtract,
        column: column,
        flatten: flatten,
        equal: equal,
        abs: abs,
        atan: atan,
        cos: cos,
        sin: sin,
        multiplyScalar: multiplyScalar,
        inv: inv,
        bignumber: bignumber,
        complex: complex,
        multiply: multiply,
        add: add
    });
    var doComplexEigs = (0, $6Xsh4.createComplexEigs)({
        config: config,
        addScalar: addScalar,
        subtract: subtract,
        multiply: multiply,
        multiplyScalar: multiplyScalar,
        flatten: flatten,
        divideScalar: divideScalar,
        sqrt: sqrt,
        abs: abs,
        bignumber: bignumber,
        diag: diag,
        size: size,
        reshape: reshape,
        qr: qr,
        inv: inv,
        usolve: usolve,
        usolveAll: usolveAll,
        equal: equal,
        complex: complex,
        larger: larger,
        smaller: smaller,
        matrixFromColumns: matrixFromColumns,
        dot: dot
    });
    /**
   * Compute eigenvalues and optionally eigenvectors of a square matrix.
   * The eigenvalues are sorted by their absolute value, ascending, and
   * returned as a vector in the `values` property of the returned project.
   * An eigenvalue with algebraic multiplicity k will be listed k times, so
   * that the returned `values` vector always has length equal to the size
   * of the input matrix.
   *
   * The `eigenvectors` property of the return value provides the eigenvectors.
   * It is an array of plain objects: the `value` property of each gives the
   * associated eigenvalue, and the `vector` property gives the eigenvector
   * itself. Note that the same `value` property will occur as many times in
   * the list provided by `eigenvectors` as the geometric multiplicity of
   * that value.
   *
   * If the algorithm fails to converge, it will throw an error –
   * in that case, however, you may still find useful information
   * in `err.values` and `err.vectors`.
   *
   * Note that the 'precision' option does not directly specify the _accuracy_
   * of the returned eigenvalues. Rather, it determines how small an entry
   * of the iterative approximations to an upper triangular matrix must be
   * in order to be considered zero. The actual accuracy of the returned
   * eigenvalues may be greater or less than the precision, depending on the
   * conditioning of the matrix and how far apart or close the actual
   * eigenvalues are. Note that currently, relatively simple, "traditional"
   * methods of eigenvalue computation are being used; this is not a modern,
   * high-precision eigenvalue computation. That said, it should typically
   * produce fairly reasonable results.
   *
   * Syntax:
   *
   *     math.eigs(x, [prec])
   *     math.eigs(x, {options})
   *
   * Examples:
   *
   *     const { eigs, multiply, column, transpose, matrixFromColumns } = math
   *     const H = [[5, 2.3], [2.3, 1]]
   *     const ans = eigs(H) // returns {values: [E1,E2...sorted], eigenvectors: [{value: E1, vector: v2}, {value: e, vector: v2}, ...]
   *     const E = ans.values
   *     const V = ans.eigenvectors
   *     multiply(H, V[0].vector)) // returns multiply(E[0], V[0].vector))
   *     const U = matrixFromColumns(...V.map(obj => obj.vector))
   *     const UTxHxU = multiply(transpose(U), H, U) // diagonalizes H if possible
   *     E[0] == UTxHxU[0][0]  // returns true always
   *
   *     // Compute only approximate eigenvalues:
   *     const {values} = eigs(H, {eigenvectors: false, precision: 1e-6})
   *
   * See also:
   *
   *     inv
   *
   * @param {Array | Matrix} x  Matrix to be diagonalized
   *
   * @param {number | BigNumber | OptsObject} [opts] Object with keys `precision`, defaulting to config.relTol, and `eigenvectors`, defaulting to true and specifying whether to compute eigenvectors. If just a number, specifies precision.
   * @return {{values: Array|Matrix, eigenvectors?: Array<EVobj>}} Object containing an array of eigenvalues and an array of {value: number|BigNumber, vector: Array|Matrix} objects. The eigenvectors property is undefined if eigenvectors were not requested.
   *
   */ return typed('eigs', {
        // The conversion to matrix in the first two implementations,
        // just to convert back to an array right away in
        // computeValuesAndVectors, is unfortunate, and should perhaps be
        // streamlined. It is done because the Matrix object carries some
        // type information about its entries, and so constructing the matrix
        // is a roundabout way of doing type detection.
        Array: function Array(x) {
            return doEigs(matrix(x));
        },
        'Array, number|BigNumber': function Array_numberBigNumber(x, prec) {
            return doEigs(matrix(x), {
                precision: prec
            });
        },
        'Array, Object' (x, opts) {
            return doEigs(matrix(x), opts);
        },
        Matrix: function Matrix(mat) {
            return doEigs(mat, {
                matricize: true
            });
        },
        'Matrix, number|BigNumber': function Matrix_numberBigNumber(mat, prec) {
            return doEigs(mat, {
                precision: prec,
                matricize: true
            });
        },
        'Matrix, Object': function Matrix_Object(mat, opts) {
            var useOpts = {
                matricize: true
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))(useOpts, opts);
            return doEigs(mat, useOpts);
        }
    });
    function doEigs(mat) {
        var _opts$precision;
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var computeVectors = 'eigenvectors' in opts ? opts.eigenvectors : true;
        var prec = (_opts$precision = opts.precision) !== null && _opts$precision !== void 0 ? _opts$precision : config.relTol;
        var result = computeValuesAndVectors(mat, prec, computeVectors);
        if (opts.matricize) {
            result.values = matrix(result.values);
            if (computeVectors) result.eigenvectors = result.eigenvectors.map((_ref2)=>{
                var { value: value, vector: vector } = _ref2;
                return {
                    value: value,
                    vector: matrix(vector)
                };
            });
        }
        if (computeVectors) Object.defineProperty(result, 'vectors', {
            enumerable: false,
            // to make sure that the eigenvectors can still be
            // converted to string.
            get: ()=>{
                throw new Error('eigs(M).vectors replaced with eigs(M).eigenvectors');
            }
        });
        return result;
    }
    function computeValuesAndVectors(mat, prec, computeVectors) {
        var arr = mat.toArray(); // NOTE: arr is guaranteed to be unaliased
        // and so safe to modify in place
        var asize = mat.size();
        if (asize.length !== 2 || asize[0] !== asize[1]) throw new RangeError("Matrix must be square (size: ".concat((0, $j2hDb.format)(asize), ")"));
        var N = asize[0];
        if (isReal(arr, N, prec)) {
            coerceReal(arr, N); // modifies arr by side effect
            if (isSymmetric(arr, N, prec)) {
                var _type = coerceTypes(mat, arr, N); // modifies arr by side effect
                return doRealSymmetric(arr, N, prec, _type, computeVectors);
            }
        }
        var type = coerceTypes(mat, arr, N); // modifies arr by side effect
        return doComplexEigs(arr, N, prec, type, computeVectors);
    }
    /** @return {boolean} */ function isSymmetric(arr, N, prec) {
        for(var i = 0; i < N; i++)for(var j = i; j < N; j++){
            // TODO proper comparison of bignum and frac
            if (larger(bignumber(abs(subtract(arr[i][j], arr[j][i]))), prec)) return false;
        }
        return true;
    }
    /** @return {boolean} */ function isReal(arr, N, prec) {
        for(var i = 0; i < N; i++)for(var j = 0; j < N; j++){
            // TODO proper comparison of bignum and frac
            if (larger(bignumber(abs(im(arr[i][j]))), prec)) return false;
        }
        return true;
    }
    function coerceReal(arr, N) {
        for(var i = 0; i < N; i++)for(var j = 0; j < N; j++)arr[i][j] = re(arr[i][j]);
    }
    /** @return {'number' | 'BigNumber' | 'Complex'} */ function coerceTypes(mat, arr, N) {
        /** @type {string} */ var type = mat.datatype();
        if (type === 'number' || type === 'BigNumber' || type === 'Complex') return type;
        var hasNumber = false;
        var hasBig = false;
        var hasComplex = false;
        for(var i = 0; i < N; i++)for(var j = 0; j < N; j++){
            var el = arr[i][j];
            if ((0, $edQYF.isNumber)(el) || (0, $edQYF.isFraction)(el)) hasNumber = true;
            else if ((0, $edQYF.isBigNumber)(el)) hasBig = true;
            else if ((0, $edQYF.isComplex)(el)) hasComplex = true;
            else throw TypeError('Unsupported type in Matrix: ' + (0, $edQYF.typeOf)(el));
        }
        if (hasBig && hasComplex) console.warn('Complex BigNumbers not supported, this operation will lose precission.');
        if (hasComplex) {
            for(var _i = 0; _i < N; _i++)for(var _j = 0; _j < N; _j++)arr[_i][_j] = complex(arr[_i][_j]);
            return 'Complex';
        }
        if (hasBig) {
            for(var _i2 = 0; _i2 < N; _i2++)for(var _j2 = 0; _j2 < N; _j2++)arr[_i2][_j2] = bignumber(arr[_i2][_j2]);
            return 'BigNumber';
        }
        if (hasNumber) {
            for(var _i3 = 0; _i3 < N; _i3++)for(var _j3 = 0; _j3 < N; _j3++)arr[_i3][_j3] = number(arr[_i3][_j3]);
            return 'number';
        } else throw TypeError('Matrix contains unsupported types only.');
    }
});

});
parcelRegister("6Xsh4", function(module, exports) {

$parcel$export(module.exports, "createComplexEigs", () => $510e2f774a74a637$export$190353ff415180b5);

var $9v8q6 = parcelRequire("9v8q6");
function $510e2f774a74a637$export$190353ff415180b5(_ref) {
    var { addScalar: addScalar, subtract: subtract, flatten: flatten, multiply: multiply, multiplyScalar: multiplyScalar, divideScalar: divideScalar, sqrt: sqrt, abs: abs, bignumber: bignumber, diag: diag, size: size, reshape: reshape, inv: inv, qr: qr, usolve: usolve, usolveAll: usolveAll, equal: equal, complex: complex, larger: larger, smaller: smaller, matrixFromColumns: matrixFromColumns, dot: dot } = _ref;
    /**
   * @param {number[][]} arr the matrix to find eigenvalues of
   * @param {number} N size of the matrix
   * @param {number|BigNumber} prec precision, anything lower will be considered zero
   * @param {'number'|'BigNumber'|'Complex'} type
   * @param {boolean} findVectors should we find eigenvectors?
   *
   * @returns {{ values: number[], vectors: number[][] }}
   */ function complexEigs(arr, N, prec, type) {
        var findVectors = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
        // TODO check if any row/col are zero except the diagonal
        // make sure corresponding rows and columns have similar magnitude
        // important because of numerical stability
        // MODIFIES arr by side effect!
        var R = balance(arr, N, prec, type, findVectors);
        // R is the row transformation matrix
        // arr = A' = R A R^-1, A is the original matrix
        // (if findVectors is false, R is undefined)
        // (And so to return to original matrix: A = R^-1 arr R)
        // TODO if magnitudes of elements vary over many orders,
        // move greatest elements to the top left corner
        // using similarity transformations, reduce the matrix
        // to Hessenberg form (upper triangular plus one subdiagonal row)
        // updates the transformation matrix R with new row operationsq
        // MODIFIES arr by side effect!
        reduceToHessenberg(arr, N, prec, type, findVectors, R);
        // still true that original A = R^-1 arr R)
        // find eigenvalues
        var { values: values, C: C } = iterateUntilTriangular(arr, N, prec, type, findVectors);
        // values is the list of eigenvalues, C is the column
        // transformation matrix that transforms arr, the hessenberg
        // matrix, to upper triangular
        // (So U = C^-1 arr C and the relationship between current arr
        // and original A is unchanged.)
        if (findVectors) {
            var eigenvectors = findEigenvectors(arr, N, C, R, values, prec, type);
            return {
                values: values,
                eigenvectors: eigenvectors
            };
        }
        return {
            values: values
        };
    }
    /**
   * @param {number[][]} arr
   * @param {number} N
   * @param {number} prec
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {number[][]}
   */ function balance(arr, N, prec, type, findVectors) {
        var big = type === 'BigNumber';
        var cplx = type === 'Complex';
        var realzero = big ? bignumber(0) : 0;
        var one = big ? bignumber(1) : cplx ? complex(1) : 1;
        var realone = big ? bignumber(1) : 1;
        // base of the floating-point arithmetic
        var radix = big ? bignumber(10) : 2;
        var radixSq = multiplyScalar(radix, radix);
        // the diagonal transformation matrix R
        var Rdiag;
        if (findVectors) Rdiag = Array(N).fill(one);
        // this isn't the only time we loop thru the matrix...
        var last = false;
        while(!last){
            // ...haha I'm joking! unless...
            last = true;
            for(var i = 0; i < N; i++){
                // compute the taxicab norm of i-th column and row
                // TODO optimize for complex numbers
                var colNorm = realzero;
                var rowNorm = realzero;
                for(var j = 0; j < N; j++){
                    if (i === j) continue;
                    colNorm = addScalar(colNorm, abs(arr[j][i]));
                    rowNorm = addScalar(rowNorm, abs(arr[i][j]));
                }
                if (!equal(colNorm, 0) && !equal(rowNorm, 0)) {
                    // find integer power closest to balancing the matrix
                    // (we want to scale only by integer powers of radix,
                    // so that we don't lose any precision due to round-off)
                    var f = realone;
                    var c = colNorm;
                    var rowDivRadix = divideScalar(rowNorm, radix);
                    var rowMulRadix = multiplyScalar(rowNorm, radix);
                    while(smaller(c, rowDivRadix)){
                        c = multiplyScalar(c, radixSq);
                        f = multiplyScalar(f, radix);
                    }
                    while(larger(c, rowMulRadix)){
                        c = divideScalar(c, radixSq);
                        f = divideScalar(f, radix);
                    }
                    // check whether balancing is needed
                    // condition = (c + rowNorm) / f < 0.95 * (colNorm + rowNorm)
                    var condition = smaller(divideScalar(addScalar(c, rowNorm), f), multiplyScalar(addScalar(colNorm, rowNorm), 0.95));
                    // apply balancing similarity transformation
                    if (condition) {
                        // we should loop once again to check whether
                        // another rebalancing is needed
                        last = false;
                        var g = divideScalar(1, f);
                        for(var _j = 0; _j < N; _j++){
                            if (i === _j) continue;
                            arr[i][_j] = multiplyScalar(arr[i][_j], g);
                            arr[_j][i] = multiplyScalar(arr[_j][i], f);
                        }
                        // keep track of transformations
                        if (findVectors) Rdiag[i] = multiplyScalar(Rdiag[i], g);
                    }
                }
            }
        }
        // return the diagonal row transformation matrix
        return findVectors ? diag(Rdiag) : null;
    }
    /**
   * @param {number[][]} arr
   * @param {number} N
   * @param {number} prec
   * @param {'number'|'BigNumber'|'Complex'} type
   * @param {boolean} findVectors
   * @param {number[][]} R the row transformation matrix that will be modified
   */ function reduceToHessenberg(arr, N, prec, type, findVectors, R) {
        var big = type === 'BigNumber';
        var cplx = type === 'Complex';
        var zero = big ? bignumber(0) : cplx ? complex(0) : 0;
        if (big) prec = bignumber(prec);
        for(var i = 0; i < N - 2; i++){
            // Find the largest subdiag element in the i-th col
            var maxIndex = 0;
            var max = zero;
            for(var j = i + 1; j < N; j++){
                var el = arr[j][i];
                if (smaller(abs(max), abs(el))) {
                    max = el;
                    maxIndex = j;
                }
            }
            // This col is pivoted, no need to do anything
            if (smaller(abs(max), prec)) continue;
            if (maxIndex !== i + 1) {
                // Interchange maxIndex-th and (i+1)-th row
                var tmp1 = arr[maxIndex];
                arr[maxIndex] = arr[i + 1];
                arr[i + 1] = tmp1;
                // Interchange maxIndex-th and (i+1)-th column
                for(var _j2 = 0; _j2 < N; _j2++){
                    var tmp2 = arr[_j2][maxIndex];
                    arr[_j2][maxIndex] = arr[_j2][i + 1];
                    arr[_j2][i + 1] = tmp2;
                }
                // keep track of transformations
                if (findVectors) {
                    var tmp3 = R[maxIndex];
                    R[maxIndex] = R[i + 1];
                    R[i + 1] = tmp3;
                }
            }
            // Reduce following rows and columns
            for(var _j3 = i + 2; _j3 < N; _j3++){
                var n = divideScalar(arr[_j3][i], max);
                if (n === 0) continue;
                // from j-th row subtract n-times (i+1)th row
                for(var k = 0; k < N; k++)arr[_j3][k] = subtract(arr[_j3][k], multiplyScalar(n, arr[i + 1][k]));
                // to (i+1)th column add n-times j-th column
                for(var _k = 0; _k < N; _k++)arr[_k][i + 1] = addScalar(arr[_k][i + 1], multiplyScalar(n, arr[_k][_j3]));
                // keep track of transformations
                if (findVectors) for(var _k2 = 0; _k2 < N; _k2++)R[_j3][_k2] = subtract(R[_j3][_k2], multiplyScalar(n, R[i + 1][_k2]));
            }
        }
        return R;
    }
    /**
   * @returns {{values: values, C: Matrix}}
   * @see Press, Wiliams: Numerical recipes in Fortran 77
   * @see https://en.wikipedia.org/wiki/QR_algorithm
   */ function iterateUntilTriangular(A, N, prec, type, findVectors) {
        var big = type === 'BigNumber';
        var cplx = type === 'Complex';
        var one = big ? bignumber(1) : cplx ? complex(1) : 1;
        if (big) prec = bignumber(prec);
        // The Francis Algorithm
        // The core idea of this algorithm is that doing successive
        // A' = QtAQ transformations will eventually converge to block-
        // upper-triangular with diagonal blocks either 1x1 or 2x2.
        // The Q here is the one from the QR decomposition, A = QR.
        // Since the eigenvalues of a block-upper-triangular matrix are
        // the eigenvalues of its diagonal blocks and we know how to find
        // eigenvalues of a 2x2 matrix, we know the eigenvalues of A.
        var arr = (0, $9v8q6.clone)(A);
        // the list of converged eigenvalues
        var lambdas = [];
        // size of arr, which will get smaller as eigenvalues converge
        var n = N;
        // the diagonal of the block-diagonal matrix that turns
        // converged 2x2 matrices into upper triangular matrices
        var Sdiag = [];
        // N×N matrix describing the overall transformation done during the QR algorithm
        var Qtotal = findVectors ? diag(Array(N).fill(one)) : undefined;
        // nxn matrix describing the QR transformations done since last convergence
        var Qpartial = findVectors ? diag(Array(n).fill(one)) : undefined;
        // last eigenvalue converged before this many steps
        var lastConvergenceBefore = 0;
        while(lastConvergenceBefore <= 100){
            lastConvergenceBefore += 1;
            // TODO if the convergence is slow, do something clever
            // Perform the factorization
            var k = arr[n - 1][n - 1]; // TODO this is apparently a somewhat
            // old-fashioned choice; ideally set close to an eigenvalue, or
            // perhaps better yet switch to the implicit QR version that is sometimes
            // specifically called the "Francis algorithm" that is alluded to
            // in the following TODO. (Or perhaps we switch to an independently
            // optimized third-party package for the linear algebra operations...)
            for(var i = 0; i < n; i++)arr[i][i] = subtract(arr[i][i], k);
            // TODO do an implicit QR transformation
            var { Q: Q, R: R } = qr(arr);
            arr = multiply(R, Q);
            for(var _i = 0; _i < n; _i++)arr[_i][_i] = addScalar(arr[_i][_i], k);
            // keep track of transformations
            if (findVectors) Qpartial = multiply(Qpartial, Q);
            // The rightmost diagonal element converged to an eigenvalue
            if (n === 1 || smaller(abs(arr[n - 1][n - 2]), prec)) {
                lastConvergenceBefore = 0;
                lambdas.push(arr[n - 1][n - 1]);
                // keep track of transformations
                if (findVectors) {
                    Sdiag.unshift([
                        [
                            1
                        ]
                    ]);
                    inflateMatrix(Qpartial, N);
                    Qtotal = multiply(Qtotal, Qpartial);
                    if (n > 1) Qpartial = diag(Array(n - 1).fill(one));
                }
                // reduce the matrix size
                n -= 1;
                arr.pop();
                for(var _i2 = 0; _i2 < n; _i2++)arr[_i2].pop();
            // The rightmost diagonal 2x2 block converged
            } else if (n === 2 || smaller(abs(arr[n - 2][n - 3]), prec)) {
                lastConvergenceBefore = 0;
                var ll = eigenvalues2x2(arr[n - 2][n - 2], arr[n - 2][n - 1], arr[n - 1][n - 2], arr[n - 1][n - 1]);
                lambdas.push(...ll);
                // keep track of transformations
                if (findVectors) {
                    Sdiag.unshift(jordanBase2x2(arr[n - 2][n - 2], arr[n - 2][n - 1], arr[n - 1][n - 2], arr[n - 1][n - 1], ll[0], ll[1], prec, type));
                    inflateMatrix(Qpartial, N);
                    Qtotal = multiply(Qtotal, Qpartial);
                    if (n > 2) Qpartial = diag(Array(n - 2).fill(one));
                }
                // reduce the matrix size
                n -= 2;
                arr.pop();
                arr.pop();
                for(var _i3 = 0; _i3 < n; _i3++){
                    arr[_i3].pop();
                    arr[_i3].pop();
                }
            }
            if (n === 0) break;
        }
        // standard sorting
        lambdas.sort((a, b)=>+subtract(abs(a), abs(b)));
        // the algorithm didn't converge
        if (lastConvergenceBefore > 100) {
            var err = Error('The eigenvalues failed to converge. Only found these eigenvalues: ' + lambdas.join(', '));
            err.values = lambdas;
            err.vectors = [];
            throw err;
        }
        // combine the overall QR transformation Qtotal with the subsequent
        // transformation S that turns the diagonal 2x2 blocks to upper triangular
        var C = findVectors ? multiply(Qtotal, blockDiag(Sdiag, N)) : undefined;
        return {
            values: lambdas,
            C: C
        };
    }
    /**
   * @param {Matrix} A hessenberg-form matrix
   * @param {number} N size of A
   * @param {Matrix} C column transformation matrix that turns A into upper triangular
   * @param {Matrix} R similarity that turns original matrix into A
   * @param {number[]} values array of eigenvalues of A
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {number[][]} eigenvalues
   */ function findEigenvectors(A, N, C, R, values, prec, type) {
        var Cinv = inv(C);
        var U = multiply(Cinv, A, C);
        var big = type === 'BigNumber';
        var cplx = type === 'Complex';
        var zero = big ? bignumber(0) : cplx ? complex(0) : 0;
        var one = big ? bignumber(1) : cplx ? complex(1) : 1;
        // turn values into a kind of "multiset"
        // this way it is easier to find eigenvectors
        var uniqueValues = [];
        var multiplicities = [];
        for (var lambda of values){
            var i = indexOf(uniqueValues, lambda, equal);
            if (i === -1) {
                uniqueValues.push(lambda);
                multiplicities.push(1);
            } else multiplicities[i] += 1;
        }
        // find eigenvectors by solving U − lambdaE = 0
        // TODO replace with an iterative eigenvector algorithm
        // (this one might fail for imprecise eigenvalues)
        var vectors = [];
        var len = uniqueValues.length;
        var b = Array(N).fill(zero);
        var E = diag(Array(N).fill(one));
        var _loop = function _loop() {
            var lambda = uniqueValues[_i4];
            var S = subtract(U, multiply(lambda, E)); // the characteristic matrix
            var solutions = usolveAll(S, b);
            solutions.shift(); // ignore the null vector
            // looks like we missed something, try inverse iteration
            // But if that fails, just presume that the original matrix truly
            // was defective.
            while(solutions.length < multiplicities[_i4]){
                var approxVec = inverseIterate(S, N, solutions, prec, type);
                if (approxVec === null) break;
                 // no more vectors were found
                solutions.push(approxVec);
            }
            // Transform back into original array coordinates
            var correction = multiply(inv(R), C);
            solutions = solutions.map((v)=>multiply(correction, v));
            vectors.push(...solutions.map((v)=>({
                    value: lambda,
                    vector: flatten(v)
                })));
        };
        for(var _i4 = 0; _i4 < len; _i4++)_loop();
        return vectors;
    }
    /**
   * Compute the eigenvalues of an 2x2 matrix
   * @return {[number,number]}
   */ function eigenvalues2x2(a, b, c, d) {
        // lambda_+- = 1/2 trA +- 1/2 sqrt( tr^2 A - 4 detA )
        var trA = addScalar(a, d);
        var detA = subtract(multiplyScalar(a, d), multiplyScalar(b, c));
        var x = multiplyScalar(trA, 0.5);
        var y = multiplyScalar(sqrt(subtract(multiplyScalar(trA, trA), multiplyScalar(4, detA))), 0.5);
        return [
            addScalar(x, y),
            subtract(x, y)
        ];
    }
    /**
   * For an 2x2 matrix compute the transformation matrix S,
   * so that SAS^-1 is an upper triangular matrix
   * @return {[[number,number],[number,number]]}
   * @see https://math.berkeley.edu/~ogus/old/Math_54-05/webfoils/jordan.pdf
   * @see http://people.math.harvard.edu/~knill/teaching/math21b2004/exhibits/2dmatrices/index.html
   */ function jordanBase2x2(a, b, c, d, l1, l2, prec, type) {
        var big = type === 'BigNumber';
        var cplx = type === 'Complex';
        var zero = big ? bignumber(0) : cplx ? complex(0) : 0;
        var one = big ? bignumber(1) : cplx ? complex(1) : 1;
        // matrix is already upper triangular
        // return an identity matrix
        if (smaller(abs(c), prec)) return [
            [
                one,
                zero
            ],
            [
                zero,
                one
            ]
        ];
        // matrix is diagonalizable
        // return its eigenvectors as columns
        if (larger(abs(subtract(l1, l2)), prec)) return [
            [
                subtract(l1, d),
                subtract(l2, d)
            ],
            [
                c,
                c
            ]
        ];
        // matrix is not diagonalizable
        // compute diagonal elements of N = A - lambdaI
        var na = subtract(a, l1);
        var nd = subtract(d, l1);
        // col(N,2) = 0  implies  S = ( col(N,1), e_1 )
        // col(N,2) != 0 implies  S = ( col(N,2), e_2 )
        if (smaller(abs(b), prec) && smaller(abs(nd), prec)) return [
            [
                na,
                one
            ],
            [
                c,
                zero
            ]
        ];
        else return [
            [
                b,
                zero
            ],
            [
                nd,
                one
            ]
        ];
    }
    /**
   * Enlarge the matrix from nxn to NxN, setting the new
   * elements to 1 on diagonal and 0 elsewhere
   */ function inflateMatrix(arr, N) {
        // add columns
        for(var i = 0; i < arr.length; i++)arr[i].push(...Array(N - arr[i].length).fill(0));
        // add rows
        for(var _i5 = arr.length; _i5 < N; _i5++){
            arr.push(Array(N).fill(0));
            arr[_i5][_i5] = 1;
        }
        return arr;
    }
    /**
   * Create a block-diagonal matrix with the given square matrices on the diagonal
   * @param {Matrix[] | number[][][]} arr array of matrices to be placed on the diagonal
   * @param {number} N the size of the resulting matrix
   */ function blockDiag(arr, N) {
        var M = [];
        for(var i = 0; i < N; i++)M[i] = Array(N).fill(0);
        var I = 0;
        for (var sub of arr){
            var n = sub.length;
            for(var _i6 = 0; _i6 < n; _i6++)for(var j = 0; j < n; j++)M[I + _i6][I + j] = sub[_i6][j];
            I += n;
        }
        return M;
    }
    /**
   * Finds the index of an element in an array using a custom equality function
   * @template T
   * @param {Array<T>} arr array in which to search
   * @param {T} el the element to find
   * @param {function(T, T): boolean} fn the equality function, first argument is an element of `arr`, the second is always `el`
   * @returns {number} the index of `el`, or -1 when it's not in `arr`
   */ function indexOf(arr, el, fn) {
        for(var i = 0; i < arr.length; i++){
            if (fn(arr[i], el)) return i;
        }
        return -1;
    }
    /**
   * Provided a near-singular upper-triangular matrix A and a list of vectors,
   * finds an eigenvector of A with the smallest eigenvalue, which is orthogonal
   * to each vector in the list
   * @template T
   * @param {T[][]} A near-singular square matrix
   * @param {number} N dimension
   * @param {T[][]} orthog list of vectors
   * @param {number} prec epsilon
   * @param {'number'|'BigNumber'|'Complex'} type
   * @return {T[] | null} eigenvector
   *
   * @see Numerical Recipes for Fortran 77 – 11.7 Eigenvalues or Eigenvectors by Inverse Iteration
   */ function inverseIterate(A, N, orthog, prec, type) {
        var largeNum = type === 'BigNumber' ? bignumber(1000) : 1000;
        var b; // the vector
        // you better choose a random vector before I count to five
        var i = 0;
        for(; i < 5; ++i){
            b = randomOrthogonalVector(N, orthog, type);
            try {
                b = usolve(A, b);
            } catch (_unused) {
                continue;
            }
            if (larger(norm(b), largeNum)) break;
        }
        if (i >= 5) return null; // couldn't find any orthogonal vector in the image
        // you better converge before I count to ten
        i = 0;
        while(true){
            var c = usolve(A, b);
            if (smaller(norm(orthogonalComplement(b, [
                c
            ])), prec)) break;
            if (++i >= 10) return null;
            b = normalize(c);
        }
        return b;
    }
    /**
   * Generates a random unit vector of dimension N, orthogonal to each vector in the list
   * @template T
   * @param {number} N dimension
   * @param {T[][]} orthog list of vectors
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {T[]} random vector
   */ function randomOrthogonalVector(N, orthog, type) {
        var big = type === 'BigNumber';
        var cplx = type === 'Complex';
        // generate random vector with the correct type
        var v = Array(N).fill(0).map((_)=>2 * Math.random() - 1);
        if (big) v = v.map((n)=>bignumber(n));
        if (cplx) v = v.map((n)=>complex(n));
        // project to orthogonal complement
        v = orthogonalComplement(v, orthog);
        // normalize
        return normalize(v, type);
    }
    /**
   * Project vector v to the orthogonal complement of an array of vectors
   */ function orthogonalComplement(v, orthog) {
        var vectorShape = size(v);
        for (var w of orthog){
            w = reshape(w, vectorShape); // make sure this is just a vector computation
            // v := v − (w, v)/|w|^2 w
            v = subtract(v, multiply(divideScalar(dot(w, v), dot(w, w)), w));
        }
        return v;
    }
    /**
   * Calculate the norm of a vector.
   * We can't use math.norm because factory can't handle circular dependency.
   * Seriously, I'm really fed up with factory.
   */ function norm(v) {
        return abs(sqrt(dot(v, v)));
    }
    /**
   * Normalize a vector
   * @template T
   * @param {T[]} v
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {T[]} normalized vec
   */ function normalize(v, type) {
        var big = type === 'BigNumber';
        var cplx = type === 'Complex';
        var one = big ? bignumber(1) : cplx ? complex(1) : 1;
        return multiply(divideScalar(one, norm(v)), v);
    }
    return complexEigs;
}

});

parcelRegister("cAZdU", function(module, exports) {

$parcel$export(module.exports, "createRealSymmetric", () => $92b85681218c2d7c$export$a8f76d83a88e1b99);

var $9v8q6 = parcelRequire("9v8q6");
function $92b85681218c2d7c$export$a8f76d83a88e1b99(_ref) {
    var { config: config, addScalar: addScalar, subtract: subtract, abs: abs, atan: atan, cos: cos, sin: sin, multiplyScalar: multiplyScalar, inv: inv, bignumber: bignumber, multiply: multiply, add: add } = _ref;
    /**
   * @param {number[] | BigNumber[]} arr
   * @param {number} N
   * @param {number} prec
   * @param {'number' | 'BigNumber'} type
   */ function main(arr, N) {
        var prec = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : config.relTol;
        var type = arguments.length > 3 ? arguments[3] : undefined;
        var computeVectors = arguments.length > 4 ? arguments[4] : undefined;
        if (type === 'number') return diag(arr, prec, computeVectors);
        if (type === 'BigNumber') return diagBig(arr, prec, computeVectors);
        throw TypeError('Unsupported data type: ' + type);
    }
    // diagonalization implementation for number (efficient)
    function diag(x, precision, computeVectors) {
        var N = x.length;
        var e0 = Math.abs(precision / N);
        var psi;
        var Sij;
        if (computeVectors) {
            Sij = new Array(N);
            // Sij is Identity Matrix
            for(var i = 0; i < N; i++){
                Sij[i] = Array(N).fill(0);
                Sij[i][i] = 1.0;
            }
        }
        // initial error
        var Vab = getAij(x);
        while(Math.abs(Vab[1]) >= Math.abs(e0)){
            var _i = Vab[0][0];
            var j = Vab[0][1];
            psi = getTheta(x[_i][_i], x[j][j], x[_i][j]);
            x = x1(x, psi, _i, j);
            if (computeVectors) Sij = Sij1(Sij, psi, _i, j);
            Vab = getAij(x);
        }
        var Ei = Array(N).fill(0); // eigenvalues
        for(var _i2 = 0; _i2 < N; _i2++)Ei[_i2] = x[_i2][_i2];
        return sorting((0, $9v8q6.clone)(Ei), Sij, computeVectors);
    }
    // diagonalization implementation for bigNumber
    function diagBig(x, precision, computeVectors) {
        var N = x.length;
        var e0 = abs(precision / N);
        var psi;
        var Sij;
        if (computeVectors) {
            Sij = new Array(N);
            // Sij is Identity Matrix
            for(var i = 0; i < N; i++){
                Sij[i] = Array(N).fill(0);
                Sij[i][i] = 1.0;
            }
        }
        // initial error
        var Vab = getAijBig(x);
        while(abs(Vab[1]) >= abs(e0)){
            var _i3 = Vab[0][0];
            var j = Vab[0][1];
            psi = getThetaBig(x[_i3][_i3], x[j][j], x[_i3][j]);
            x = x1Big(x, psi, _i3, j);
            if (computeVectors) Sij = Sij1Big(Sij, psi, _i3, j);
            Vab = getAijBig(x);
        }
        var Ei = Array(N).fill(0); // eigenvalues
        for(var _i4 = 0; _i4 < N; _i4++)Ei[_i4] = x[_i4][_i4];
        // return [clone(Ei), clone(Sij)]
        return sorting((0, $9v8q6.clone)(Ei), Sij, computeVectors);
    }
    // get angle
    function getTheta(aii, ajj, aij) {
        var denom = ajj - aii;
        if (Math.abs(denom) <= config.relTol) return Math.PI / 4.0;
        else return 0.5 * Math.atan(2.0 * aij / (ajj - aii));
    }
    // get angle
    function getThetaBig(aii, ajj, aij) {
        var denom = subtract(ajj, aii);
        if (abs(denom) <= config.relTol) return bignumber(-1).acos().div(4);
        else return multiplyScalar(0.5, atan(multiply(2.0, aij, inv(denom))));
    }
    // update eigvec
    function Sij1(Sij, theta, i, j) {
        var N = Sij.length;
        var c = Math.cos(theta);
        var s = Math.sin(theta);
        var Ski = Array(N).fill(0);
        var Skj = Array(N).fill(0);
        for(var k = 0; k < N; k++){
            Ski[k] = c * Sij[k][i] - s * Sij[k][j];
            Skj[k] = s * Sij[k][i] + c * Sij[k][j];
        }
        for(var _k = 0; _k < N; _k++){
            Sij[_k][i] = Ski[_k];
            Sij[_k][j] = Skj[_k];
        }
        return Sij;
    }
    // update eigvec for overlap
    function Sij1Big(Sij, theta, i, j) {
        var N = Sij.length;
        var c = cos(theta);
        var s = sin(theta);
        var Ski = Array(N).fill(bignumber(0));
        var Skj = Array(N).fill(bignumber(0));
        for(var k = 0; k < N; k++){
            Ski[k] = subtract(multiplyScalar(c, Sij[k][i]), multiplyScalar(s, Sij[k][j]));
            Skj[k] = addScalar(multiplyScalar(s, Sij[k][i]), multiplyScalar(c, Sij[k][j]));
        }
        for(var _k2 = 0; _k2 < N; _k2++){
            Sij[_k2][i] = Ski[_k2];
            Sij[_k2][j] = Skj[_k2];
        }
        return Sij;
    }
    // update matrix
    function x1Big(Hij, theta, i, j) {
        var N = Hij.length;
        var c = bignumber(cos(theta));
        var s = bignumber(sin(theta));
        var c2 = multiplyScalar(c, c);
        var s2 = multiplyScalar(s, s);
        var Aki = Array(N).fill(bignumber(0));
        var Akj = Array(N).fill(bignumber(0));
        // 2cs Hij
        var csHij = multiply(bignumber(2), c, s, Hij[i][j]);
        //  Aii
        var Aii = addScalar(subtract(multiplyScalar(c2, Hij[i][i]), csHij), multiplyScalar(s2, Hij[j][j]));
        var Ajj = add(multiplyScalar(s2, Hij[i][i]), csHij, multiplyScalar(c2, Hij[j][j]));
        // 0  to i
        for(var k = 0; k < N; k++){
            Aki[k] = subtract(multiplyScalar(c, Hij[i][k]), multiplyScalar(s, Hij[j][k]));
            Akj[k] = addScalar(multiplyScalar(s, Hij[i][k]), multiplyScalar(c, Hij[j][k]));
        }
        // Modify Hij
        Hij[i][i] = Aii;
        Hij[j][j] = Ajj;
        Hij[i][j] = bignumber(0);
        Hij[j][i] = bignumber(0);
        // 0  to i
        for(var _k3 = 0; _k3 < N; _k3++)if (_k3 !== i && _k3 !== j) {
            Hij[i][_k3] = Aki[_k3];
            Hij[_k3][i] = Aki[_k3];
            Hij[j][_k3] = Akj[_k3];
            Hij[_k3][j] = Akj[_k3];
        }
        return Hij;
    }
    // update matrix
    function x1(Hij, theta, i, j) {
        var N = Hij.length;
        var c = Math.cos(theta);
        var s = Math.sin(theta);
        var c2 = c * c;
        var s2 = s * s;
        var Aki = Array(N).fill(0);
        var Akj = Array(N).fill(0);
        //  Aii
        var Aii = c2 * Hij[i][i] - 2 * c * s * Hij[i][j] + s2 * Hij[j][j];
        var Ajj = s2 * Hij[i][i] + 2 * c * s * Hij[i][j] + c2 * Hij[j][j];
        // 0  to i
        for(var k = 0; k < N; k++){
            Aki[k] = c * Hij[i][k] - s * Hij[j][k];
            Akj[k] = s * Hij[i][k] + c * Hij[j][k];
        }
        // Modify Hij
        Hij[i][i] = Aii;
        Hij[j][j] = Ajj;
        Hij[i][j] = 0;
        Hij[j][i] = 0;
        // 0  to i
        for(var _k4 = 0; _k4 < N; _k4++)if (_k4 !== i && _k4 !== j) {
            Hij[i][_k4] = Aki[_k4];
            Hij[_k4][i] = Aki[_k4];
            Hij[j][_k4] = Akj[_k4];
            Hij[_k4][j] = Akj[_k4];
        }
        return Hij;
    }
    // get max off-diagonal value from Upper Diagonal
    function getAij(Mij) {
        var N = Mij.length;
        var maxMij = 0;
        var maxIJ = [
            0,
            1
        ];
        for(var i = 0; i < N; i++){
            for(var j = i + 1; j < N; j++)if (Math.abs(maxMij) < Math.abs(Mij[i][j])) {
                maxMij = Math.abs(Mij[i][j]);
                maxIJ = [
                    i,
                    j
                ];
            }
        }
        return [
            maxIJ,
            maxMij
        ];
    }
    // get max off-diagonal value from Upper Diagonal
    function getAijBig(Mij) {
        var N = Mij.length;
        var maxMij = 0;
        var maxIJ = [
            0,
            1
        ];
        for(var i = 0; i < N; i++){
            for(var j = i + 1; j < N; j++)if (abs(maxMij) < abs(Mij[i][j])) {
                maxMij = abs(Mij[i][j]);
                maxIJ = [
                    i,
                    j
                ];
            }
        }
        return [
            maxIJ,
            maxMij
        ];
    }
    // sort results
    function sorting(E, S, computeVectors) {
        var N = E.length;
        var values = Array(N);
        var vecs;
        if (computeVectors) {
            vecs = Array(N);
            for(var k = 0; k < N; k++)vecs[k] = Array(N);
        }
        for(var i = 0; i < N; i++){
            var minID = 0;
            var minE = E[0];
            for(var j = 0; j < E.length; j++)if (abs(E[j]) < abs(minE)) {
                minID = j;
                minE = E[minID];
            }
            values[i] = E.splice(minID, 1)[0];
            if (computeVectors) for(var _k5 = 0; _k5 < N; _k5++){
                vecs[i][_k5] = S[_k5][minID];
                S[_k5].splice(minID, 1);
            }
        }
        if (!computeVectors) return {
            values: values
        };
        var eigenvectors = vecs.map((vector, i)=>({
                value: values[i],
                vector: vector
            }));
        return {
            values: values,
            eigenvectors: eigenvectors
        };
    }
    return main;
}

});


parcelRegister("cuTl9", function(module, exports) {

$parcel$export(module.exports, "createEqual", () => $919336cd667ee852$export$988f37bc1f709b0d);

var $dsu7t = parcelRequire("dsu7t");

var $a8bto = parcelRequire("a8bto");

var $6RFQP = parcelRequire("6RFQP");

var $19L2p = parcelRequire("19L2p");

var $6SJnV = parcelRequire("6SJnV");
var $919336cd667ee852$var$name = 'equal';
var $919336cd667ee852$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'DenseMatrix',
    'concat',
    'SparseMatrix'
];
var $919336cd667ee852$export$988f37bc1f709b0d = /* #__PURE__ */ (0, $dsu7t.factory)($919336cd667ee852$var$name, $919336cd667ee852$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix, concat: concat, SparseMatrix: SparseMatrix } = _ref;
    var matAlgo03xDSf = (0, $a8bto.createMatAlgo03xDSf)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $6RFQP.createMatAlgo07xSSf)({
        typed: typed,
        SparseMatrix: SparseMatrix
    });
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Test whether two values are equal.
   *
   * The function tests whether the relative difference between x and y is
   * smaller than the configured relTol and absTol. The function cannot be used to
   * compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * In case of complex numbers, x.re must equal y.re, and x.im must equal y.im.
   *
   * Values `null` and `undefined` are compared strictly, thus `null` is only
   * equal to `null` and nothing else, and `undefined` is only equal to
   * `undefined` and nothing else. Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.equal(x, y)
   *
   * Examples:
   *
   *    math.equal(2 + 2, 3)         // returns false
   *    math.equal(2 + 2, 4)         // returns true
   *
   *    const a = math.unit('50 cm')
   *    const b = math.unit('5 m')
   *    math.equal(a, b)             // returns true
   *
   *    const c = [2, 5, 1]
   *    const d = [2, 7, 1]
   *
   *    math.equal(c, d)             // returns [true, false, true]
   *    math.deepEqual(c, d)         // returns false
   *
   *    math.equal("1000", "1e3")    // returns true
   *    math.equal(0, null)          // returns false
   *
   * See also:
   *
   *    unequal, smaller, smallerEq, larger, largerEq, compare, deepEqual, equalText
   *
   * @param  {number | BigNumber | bigint | boolean | Complex | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | bigint | boolean | Complex | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the compared values are equal, else returns false
   */ return typed($919336cd667ee852$var$name, $919336cd667ee852$export$87c1b92540f5e2ae({
        typed: typed,
        equalScalar: equalScalar
    }), matrixAlgorithmSuite({
        elop: equalScalar,
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
});
var $919336cd667ee852$export$87c1b92540f5e2ae = (0, $dsu7t.factory)($919336cd667ee852$var$name, [
    'typed',
    'equalScalar'
], (_ref2)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref2;
    return typed($919336cd667ee852$var$name, {
        'any, any': function any_any(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y === null;
            if (y === null) return x === null;
            if (x === undefined) return y === undefined;
            if (y === undefined) return x === undefined;
            return equalScalar(x, y);
        }
    });
});

});

parcelRegister("lv59z", function(module, exports) {

$parcel$export(module.exports, "createEqualScalar", () => $fa707d938a4d2836$export$c370bab664a0c9a2);

var $i7dfO = parcelRequire("i7dfO");

var $6NnhX = parcelRequire("6NnhX");

var $dsu7t = parcelRequire("dsu7t");

var $HvXI9 = parcelRequire("HvXI9");

var $33RBM = parcelRequire("33RBM");
var $fa707d938a4d2836$var$name = 'equalScalar';
var $fa707d938a4d2836$var$dependencies = [
    'typed',
    'config'
];
var $fa707d938a4d2836$export$c370bab664a0c9a2 = /* #__PURE__ */ (0, $dsu7t.factory)($fa707d938a4d2836$var$name, $fa707d938a4d2836$var$dependencies, (_ref)=>{
    var { typed: typed, config: config } = _ref;
    var compareUnits = (0, $33RBM.createCompareUnits)({
        typed: typed
    });
    /**
   * Test whether two scalar values are nearly equal.
   *
   * @param  {number | BigNumber | bigint | Fraction | boolean | Complex | Unit} x   First value to compare
   * @param  {number | BigNumber | bigint | Fraction | boolean | Complex} y          Second value to compare
   * @return {boolean}                                                  Returns true when the compared values are equal, else returns false
   * @private
   */ return typed($fa707d938a4d2836$var$name, {
        'boolean, boolean': function boolean_boolean(x, y) {
            return x === y;
        },
        'number, number': function number_number(x, y) {
            return (0, $6NnhX.nearlyEqual)(x, y, config.relTol, config.absTol);
        },
        'BigNumber, BigNumber': function BigNumber_BigNumber(x, y) {
            return x.eq(y) || (0, $i7dfO.nearlyEqual)(x, y, config.relTol, config.absTol);
        },
        'bigint, bigint': function bigint_bigint(x, y) {
            return x === y;
        },
        'Fraction, Fraction': function Fraction_Fraction(x, y) {
            return x.equals(y);
        },
        'Complex, Complex': function Complex_Complex(x, y) {
            return (0, $HvXI9.complexEquals)(x, y, config.relTol, config.absTol);
        }
    }, compareUnits);
});
var $fa707d938a4d2836$export$55f78fcc2979d648 = (0, $dsu7t.factory)($fa707d938a4d2836$var$name, [
    'typed',
    'config'
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($fa707d938a4d2836$var$name, {
        'number, number': function number_number(x, y) {
            return (0, $6NnhX.nearlyEqual)(x, y, config.relTol, config.absTol);
        }
    });
});

});
parcelRegister("HvXI9", function(module, exports) {

$parcel$export(module.exports, "complexEquals", () => $082ccf454bbb529f$export$852c8261c9f393e0);

var $6NnhX = parcelRequire("6NnhX");
function $082ccf454bbb529f$export$852c8261c9f393e0(x, y, relTol, absTol) {
    return (0, $6NnhX.nearlyEqual)(x.re, y.re, relTol, absTol) && (0, $6NnhX.nearlyEqual)(x.im, y.im, relTol, absTol);
}

});


parcelRegister("30GbH", function(module, exports) {

$parcel$export(module.exports, "createEqualText", () => $231218cee69f210e$export$1589aaa29568b87);

var $dsu7t = parcelRequire("dsu7t");
var $231218cee69f210e$var$name = 'equalText';
var $231218cee69f210e$var$dependencies = [
    'typed',
    'compareText',
    'isZero'
];
var $231218cee69f210e$export$1589aaa29568b87 = /* #__PURE__ */ (0, $dsu7t.factory)($231218cee69f210e$var$name, $231218cee69f210e$var$dependencies, (_ref)=>{
    var { typed: typed, compareText: compareText, isZero: isZero } = _ref;
    /**
   * Check equality of two strings. Comparison is case sensitive.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.equalText(x, y)
   *
   * Examples:
   *
   *    math.equalText('Hello', 'Hello')     // returns true
   *    math.equalText('a', 'A')             // returns false
   *    math.equal('2e3', '2000')            // returns true
   *    math.equalText('2e3', '2000')        // returns false
   *
   *    math.equalText('B', ['A', 'B', 'C']) // returns [false, true, false]
   *
   * See also:
   *
   *    equal, compareText, compare, compareNatural
   *
   * @param  {string | Array | DenseMatrix} x First string to compare
   * @param  {string | Array | DenseMatrix} y Second string to compare
   * @return {number | Array | DenseMatrix} Returns true if the values are equal, and false if not.
   */ return typed($231218cee69f210e$var$name, {
        'any, any': function any_any(x, y) {
            return isZero(compareText(x, y));
        }
    });
});

});

parcelRegister("gYCvX", function(module, exports) {

$parcel$export(module.exports, "createErf", () => $c5c0201ea9a8d89e$export$470dfa326d6cbdf5);
/* eslint-disable no-loss-of-precision */ 
var $20mkw = parcelRequire("20mkw");

var $6NnhX = parcelRequire("6NnhX");

var $dsu7t = parcelRequire("dsu7t");
var $c5c0201ea9a8d89e$var$name = 'erf';
var $c5c0201ea9a8d89e$var$dependencies = [
    'typed'
];
var $c5c0201ea9a8d89e$export$470dfa326d6cbdf5 = /* #__PURE__ */ (0, $dsu7t.factory)($c5c0201ea9a8d89e$var$name, $c5c0201ea9a8d89e$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the erf function of a value using a rational Chebyshev
   * approximations for different intervals of x.
   *
   * This is a translation of W. J. Cody's Fortran implementation from 1987
   * ( https://www.netlib.org/specfun/erf ). See the AMS publication
   * "Rational Chebyshev Approximations for the Error Function" by W. J. Cody
   * for an explanation of this process.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.erf(x)
   *
   * Examples:
   *
   *    math.erf(0.2)    // returns 0.22270258921047847
   *    math.erf(-0.5)   // returns -0.5204998778130465
   *    math.erf(4)      // returns 0.9999999845827421
   *
   * See also:
   *    zeta
   *
   * @param {number | Array | Matrix} x   A real number
   * @return {number | Array | Matrix}    The erf of `x`
   */ return typed('name', {
        number: function number(x) {
            var y = Math.abs(x);
            if (y >= $c5c0201ea9a8d89e$var$MAX_NUM) return (0, $6NnhX.sign)(x);
            if (y <= $c5c0201ea9a8d89e$var$THRESH) return (0, $6NnhX.sign)(x) * erf1(y);
            if (y <= 4.0) return (0, $6NnhX.sign)(x) * (1 - erfc2(y));
            return (0, $6NnhX.sign)(x) * (1 - erfc3(y));
        },
        'Array | Matrix': typed.referToSelf((self)=>(n)=>(0, $20mkw.deepMap)(n, self))
    });
    /**
   * Approximates the error function erf() for x <= 0.46875 using this function:
   *               n
   * erf(x) = x * sum (p_j * x^(2j)) / (q_j * x^(2j))
   *              j=0
   */ function erf1(y) {
        var ysq = y * y;
        var xnum = $c5c0201ea9a8d89e$var$P[0][4] * ysq;
        var xden = ysq;
        var i;
        for(i = 0; i < 3; i += 1){
            xnum = (xnum + $c5c0201ea9a8d89e$var$P[0][i]) * ysq;
            xden = (xden + $c5c0201ea9a8d89e$var$Q[0][i]) * ysq;
        }
        return y * (xnum + $c5c0201ea9a8d89e$var$P[0][3]) / (xden + $c5c0201ea9a8d89e$var$Q[0][3]);
    }
    /**
   * Approximates the complement of the error function erfc() for
   * 0.46875 <= x <= 4.0 using this function:
   *                       n
   * erfc(x) = e^(-x^2) * sum (p_j * x^j) / (q_j * x^j)
   *                      j=0
   */ function erfc2(y) {
        var xnum = $c5c0201ea9a8d89e$var$P[1][8] * y;
        var xden = y;
        var i;
        for(i = 0; i < 7; i += 1){
            xnum = (xnum + $c5c0201ea9a8d89e$var$P[1][i]) * y;
            xden = (xden + $c5c0201ea9a8d89e$var$Q[1][i]) * y;
        }
        var result = (xnum + $c5c0201ea9a8d89e$var$P[1][7]) / (xden + $c5c0201ea9a8d89e$var$Q[1][7]);
        var ysq = parseInt(y * 16) / 16;
        var del = (y - ysq) * (y + ysq);
        return Math.exp(-ysq * ysq) * Math.exp(-del) * result;
    }
    /**
   * Approximates the complement of the error function erfc() for x > 4.0 using
   * this function:
   *
   * erfc(x) = (e^(-x^2) / x) * [ 1/sqrt(pi) +
   *               n
   *    1/(x^2) * sum (p_j * x^(-2j)) / (q_j * x^(-2j)) ]
   *              j=0
   */ function erfc3(y) {
        var ysq = 1 / (y * y);
        var xnum = $c5c0201ea9a8d89e$var$P[2][5] * ysq;
        var xden = ysq;
        var i;
        for(i = 0; i < 4; i += 1){
            xnum = (xnum + $c5c0201ea9a8d89e$var$P[2][i]) * ysq;
            xden = (xden + $c5c0201ea9a8d89e$var$Q[2][i]) * ysq;
        }
        var result = ysq * (xnum + $c5c0201ea9a8d89e$var$P[2][4]) / (xden + $c5c0201ea9a8d89e$var$Q[2][4]);
        result = ($c5c0201ea9a8d89e$var$SQRPI - result) / y;
        ysq = parseInt(y * 16) / 16;
        var del = (y - ysq) * (y + ysq);
        return Math.exp(-ysq * ysq) * Math.exp(-del) * result;
    }
});
/**
 * Upper bound for the first approximation interval, 0 <= x <= THRESH
 * @constant
 */ var $c5c0201ea9a8d89e$var$THRESH = 0.46875;
/**
 * Constant used by W. J. Cody's Fortran77 implementation to denote sqrt(pi)
 * @constant
 */ var $c5c0201ea9a8d89e$var$SQRPI = 5.6418958354775628695e-1;
/**
 * Coefficients for each term of the numerator sum (p_j) for each approximation
 * interval (see W. J. Cody's paper for more details)
 * @constant
 */ var $c5c0201ea9a8d89e$var$P = [
    [
        3.16112374387056560e00,
        1.13864154151050156e02,
        3.77485237685302021e02,
        3.20937758913846947e03,
        1.85777706184603153e-1
    ],
    [
        5.64188496988670089e-1,
        8.88314979438837594e00,
        6.61191906371416295e01,
        2.98635138197400131e02,
        8.81952221241769090e02,
        1.71204761263407058e03,
        2.05107837782607147e03,
        1.23033935479799725e03,
        2.15311535474403846e-8
    ],
    [
        3.05326634961232344e-1,
        3.60344899949804439e-1,
        1.25781726111229246e-1,
        1.60837851487422766e-2,
        6.58749161529837803e-4,
        1.63153871373020978e-2
    ]
];
/**
 * Coefficients for each term of the denominator sum (q_j) for each approximation
 * interval (see W. J. Cody's paper for more details)
 * @constant
 */ var $c5c0201ea9a8d89e$var$Q = [
    [
        2.36012909523441209e01,
        2.44024637934444173e02,
        1.28261652607737228e03,
        2.84423683343917062e03
    ],
    [
        1.57449261107098347e01,
        1.17693950891312499e02,
        5.37181101862009858e02,
        1.62138957456669019e03,
        3.29079923573345963e03,
        4.36261909014324716e03,
        3.43936767414372164e03,
        1.23033935480374942e03
    ],
    [
        2.56852019228982242e00,
        1.87295284992346047e00,
        5.27905102951428412e-1,
        6.05183413124413191e-2,
        2.33520497626869185e-3
    ]
];
/**
 * Maximum/minimum safe numbers to input to erf() (in ES6+, this number is
 * Number.[MAX|MIN]_SAFE_INTEGER). erf() for all numbers beyond this limit will
 * return 1
 */ var $c5c0201ea9a8d89e$var$MAX_NUM = Math.pow(2, 53);

});

parcelRegister("fx5Am", function(module, exports) {

$parcel$export(module.exports, "createExp", () => $b4ee4540a522bbe3$export$95a576617fd015b1);

var $dsu7t = parcelRequire("dsu7t");

var $dmcGu = parcelRequire("dmcGu");
var $b4ee4540a522bbe3$var$name = 'exp';
var $b4ee4540a522bbe3$var$dependencies = [
    'typed'
];
var $b4ee4540a522bbe3$export$95a576617fd015b1 = /* #__PURE__ */ (0, $dsu7t.factory)($b4ee4540a522bbe3$var$name, $b4ee4540a522bbe3$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the exponential of a value.
   * For matrices, if you want the matrix exponential of square matrix, use
   * the `expm` function; if you want to take the exponential of each element,
   * see the examples.
   *
   * Syntax:
   *
   *    math.exp(x)
   *
   * Examples:
   *
   *    math.exp(2)                  // returns number 7.3890560989306495
   *    math.pow(math.e, 2)          // returns number 7.3890560989306495
   *    math.log(math.exp(2))        // returns number 2
   *
   *    math.map([1, 2, 3], math.exp)
   *    // returns Array [
   *    //   2.718281828459045,
   *    //   7.3890560989306495,
   *    //   20.085536923187668
   *    // ]
   *
   * See also:
   *
   *    expm1, expm, log, pow
   *
   * @param {number | BigNumber | Complex} x  A number to exponentiate
   * @return {number | BigNumber | Complex} Exponential of `x`
   */ return typed($b4ee4540a522bbe3$var$name, {
        number: (0, $dmcGu.expNumber),
        Complex: function Complex(x) {
            return x.exp();
        },
        BigNumber: function BigNumber(x) {
            return x.exp();
        }
    });
});

});

parcelRegister("lTpfe", function(module, exports) {

$parcel$export(module.exports, "createExpm", () => $ff025118c9bfa50c$export$f2c0a6357ff6cb4c);

var $edQYF = parcelRequire("edQYF");

var $j2hDb = parcelRequire("j2hDb");

var $dsu7t = parcelRequire("dsu7t");
var $ff025118c9bfa50c$var$name = 'expm';
var $ff025118c9bfa50c$var$dependencies = [
    'typed',
    'abs',
    'add',
    'identity',
    'inv',
    'multiply'
];
var $ff025118c9bfa50c$export$f2c0a6357ff6cb4c = /* #__PURE__ */ (0, $dsu7t.factory)($ff025118c9bfa50c$var$name, $ff025118c9bfa50c$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, identity: identity, inv: inv, multiply: multiply } = _ref;
    /**
   * Compute the matrix exponential, expm(A) = e^A. The matrix must be square.
   * Not to be confused with exp(a), which performs element-wise
   * exponentiation.
   *
   * The exponential is calculated using the Padé approximant with scaling and
   * squaring; see "Nineteen Dubious Ways to Compute the Exponential of a
   * Matrix," by Moler and Van Loan.
   *
   * Syntax:
   *
   *     math.expm(x)
   *
   * Examples:
   *
   *     const A = [[0,2],[0,0]]
   *     math.expm(A)        // returns [[1,2],[0,1]]
   *
   * See also:
   *
   *     exp
   *
   * @param {Matrix} x  A square Matrix
   * @return {Matrix}   The exponential of x
   */ return typed($ff025118c9bfa50c$var$name, {
        Matrix: function Matrix(A) {
            // Check matrix size
            var size = A.size();
            if (size.length !== 2 || size[0] !== size[1]) throw new RangeError("Matrix must be square (size: " + (0, $j2hDb.format)(size) + ')');
            var n = size[0];
            // Desired accuracy of the approximant (The actual accuracy
            // will be affected by round-off error)
            var eps = 1e-15;
            // The Padé approximant is not so accurate when the values of A
            // are "large", so scale A by powers of two. Then compute the
            // exponential, and square the result repeatedly according to
            // the identity e^A = (e^(A/m))^m
            // Compute infinity-norm of A, ||A||, to see how "big" it is
            var infNorm = infinityNorm(A);
            // Find the optimal scaling factor and number of terms in the
            // Padé approximant to reach the desired accuracy
            var params = findParams(infNorm, eps);
            var q = params.q;
            var j = params.j;
            // The Pade approximation to e^A is:
            // Rqq(A) = Dqq(A) ^ -1 * Nqq(A)
            // where
            // Nqq(A) = sum(i=0, q, (2q-i)!p! / [ (2q)!i!(q-i)! ] A^i
            // Dqq(A) = sum(i=0, q, (2q-i)!q! / [ (2q)!i!(q-i)! ] (-A)^i
            // Scale A by 1 / 2^j
            var Apos = multiply(A, Math.pow(2, -j));
            // The i=0 term is just the identity matrix
            var N = identity(n);
            var D = identity(n);
            // Initialization (i=0)
            var factor = 1;
            // Initialization (i=1)
            var AposToI = Apos; // Cloning not necessary
            var alternate = -1;
            for(var i = 1; i <= q; i++){
                if (i > 1) {
                    AposToI = multiply(AposToI, Apos);
                    alternate = -alternate;
                }
                factor = factor * (q - i + 1) / ((2 * q - i + 1) * i);
                N = add(N, multiply(factor, AposToI));
                D = add(D, multiply(factor * alternate, AposToI));
            }
            var R = multiply(inv(D), N);
            // Square j times
            for(var _i = 0; _i < j; _i++)R = multiply(R, R);
            return (0, $edQYF.isSparseMatrix)(A) ? A.createSparseMatrix(R) : R;
        }
    });
    function infinityNorm(A) {
        var n = A.size()[0];
        var infNorm = 0;
        for(var i = 0; i < n; i++){
            var rowSum = 0;
            for(var j = 0; j < n; j++)rowSum += abs(A.get([
                i,
                j
            ]));
            infNorm = Math.max(rowSum, infNorm);
        }
        return infNorm;
    }
    /**
   * Find the best parameters for the Pade approximant given
   * the matrix norm and desired accuracy. Returns the first acceptable
   * combination in order of increasing computational load.
   */ function findParams(infNorm, eps) {
        var maxSearchSize = 30;
        for(var k = 0; k < maxSearchSize; k++)for(var q = 0; q <= k; q++){
            var j = k - q;
            if (errorEstimate(infNorm, q, j) < eps) return {
                q: q,
                j: j
            };
        }
        throw new Error('Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)');
    }
    /**
   * Returns the estimated error of the Pade approximant for the given
   * parameters.
   */ function errorEstimate(infNorm, q, j) {
        var qfac = 1;
        for(var i = 2; i <= q; i++)qfac *= i;
        var twoqfac = qfac;
        for(var _i2 = q + 1; _i2 <= 2 * q; _i2++)twoqfac *= _i2;
        var twoqp1fac = twoqfac * (2 * q + 1);
        return 8.0 * Math.pow(infNorm / Math.pow(2, j), 2 * q) * qfac * qfac / (twoqfac * twoqp1fac);
    }
});

});

parcelRegister("7ptwt", function(module, exports) {

$parcel$export(module.exports, "createExpm1", () => $5651c4ceba41a80b$export$2b203b63f664bab3);

var $dsu7t = parcelRequire("dsu7t");

var $dmcGu = parcelRequire("dmcGu");
var $5651c4ceba41a80b$var$name = 'expm1';
var $5651c4ceba41a80b$var$dependencies = [
    'typed',
    'Complex'
];
var $5651c4ceba41a80b$export$2b203b63f664bab3 = /* #__PURE__ */ (0, $dsu7t.factory)($5651c4ceba41a80b$var$name, $5651c4ceba41a80b$var$dependencies, (_ref)=>{
    var { typed: typed, Complex: _Complex } = _ref;
    /**
   * Calculate the value of subtracting 1 from the exponential value.
   * This function is more accurate than `math.exp(x)-1` when `x` is near 0
   * To avoid ambiguity with the matrix exponential `expm`, this function
   * does not operate on matrices; if you wish to apply it elementwise, see
   * the examples.
   *
   * Syntax:
   *
   *    math.expm1(x)
   *
   * Examples:
   *
   *    math.expm1(2)                      // returns number 6.38905609893065
   *    math.pow(math.e, 2) - 1            // returns number 6.3890560989306495
   *    math.expm1(1e-8)                   // returns number 1.0000000050000001e-8
   *    math.exp(1e-8) - 1                 // returns number 9.9999999392253e-9
   *    math.log(math.expm1(2) + 1)        // returns number 2
   *
   *    math.map([1, 2, 3], math.expm1)
   *    // returns Array [
   *    //   1.718281828459045,
   *    //   6.3890560989306495,
   *    //   19.085536923187668
   *    // ]
   *
   * See also:
   *
   *    exp, expm, log, pow
   *
   * @param {number | BigNumber | Complex} x  The number to exponentiate
   * @return {number | BigNumber | Complex} Exponential of `x`, minus one
   */ return typed($5651c4ceba41a80b$var$name, {
        number: (0, $dmcGu.expm1Number),
        Complex: function Complex(x) {
            var r = Math.exp(x.re);
            return new _Complex(r * Math.cos(x.im) - 1, r * Math.sin(x.im));
        },
        BigNumber: function BigNumber(x) {
            return x.exp().minus(1);
        }
    });
});

});

parcelRegister("DY4K7", function(module, exports) {

$parcel$export(module.exports, "createFactorial", () => $07823e602fe66516$export$92c37ad44e3d0481);

var $20mkw = parcelRequire("20mkw");

var $dsu7t = parcelRequire("dsu7t");
var $07823e602fe66516$var$name = 'factorial';
var $07823e602fe66516$var$dependencies = [
    'typed',
    'gamma'
];
var $07823e602fe66516$export$92c37ad44e3d0481 = /* #__PURE__ */ (0, $dsu7t.factory)($07823e602fe66516$var$name, $07823e602fe66516$var$dependencies, (_ref)=>{
    var { typed: typed, gamma: gamma } = _ref;
    /**
   * Compute the factorial of a value
   *
   * Factorial only supports an integer value as argument.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.factorial(n)
   *
   * Examples:
   *
   *    math.factorial(5)    // returns 120
   *    math.factorial(3)    // returns 6
   *
   * See also:
   *
   *    combinations, combinationsWithRep, gamma, permutations
   *
   * @param {number | BigNumber | Array | Matrix} n   An integer number
   * @return {number | BigNumber | Array | Matrix}    The factorial of `n`
   */ return typed($07823e602fe66516$var$name, {
        number: function number(n) {
            if (n < 0) throw new Error('Value must be non-negative');
            return gamma(n + 1);
        },
        BigNumber: function BigNumber(n) {
            if (n.isNegative()) throw new Error('Value must be non-negative');
            return gamma(n.plus(1));
        },
        'Array | Matrix': typed.referToSelf((self)=>(n)=>(0, $20mkw.deepMap)(n, self))
    });
});

});

parcelRegister("049dG", function(module, exports) {

$parcel$export(module.exports, "createFft", () => $00c786b24164ca40$export$41ce8d9733cb73c1);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $00c786b24164ca40$var$name = 'fft';
var $00c786b24164ca40$var$dependencies = [
    'typed',
    'matrix',
    'addScalar',
    'multiplyScalar',
    'divideScalar',
    'exp',
    'tau',
    'i',
    'dotDivide',
    'conj',
    'pow',
    'ceil',
    'log2'
];
var $00c786b24164ca40$export$41ce8d9733cb73c1 = /* #__PURE__ */ (0, $dsu7t.factory)($00c786b24164ca40$var$name, $00c786b24164ca40$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, addScalar: addScalar, multiplyScalar: multiplyScalar, divideScalar: divideScalar, exp: exp, tau: tau, i: I, dotDivide: dotDivide, conj: conj, pow: pow, ceil: ceil, log2: log2 } = _ref;
    /**
   * Calculate N-dimensional Fourier transform
   *
   * Syntax:
   *
   *     math.fft(arr)
   *
   * Examples:
   *
   *    math.fft([[1, 0], [1, 0]]) // returns [[{re:2, im:0}, {re:2, im:0}], [{re:0, im:0}, {re:0, im:0}]]
   *
   *
   * See Also:
   *
   *      ifft
   *
   * @param {Array | Matrix} arr    An array or matrix
   * @return {Array | Matrix}       N-dimensional Fourier transformation of the array
   */ return typed($00c786b24164ca40$var$name, {
        Array: _ndFft,
        Matrix: function Matrix(matrix) {
            return matrix.create(_ndFft(matrix.valueOf()), matrix.datatype());
        }
    });
    /**
   * Perform an N-dimensional Fourier transform
   *
   * @param {Array} arr      The array
   * @return {Array}         resulting array
   */ function _ndFft(arr) {
        var size = (0, $d80Xp.arraySize)(arr);
        if (size.length === 1) return _fft(arr, size[0]);
        // ndFft along dimension 1,...,N-1 then 1dFft along dimension 0
        return _1dFft(arr.map((slice)=>_ndFft(slice, size.slice(1))), 0);
    }
    /**
   * Perform an 1-dimensional Fourier transform
   *
   * @param {Array} arr      The array
   * @param {number} dim     dimension of the array to perform on
   * @return {Array}         resulting array
   */ function _1dFft(arr, dim) {
        var size = (0, $d80Xp.arraySize)(arr);
        if (dim !== 0) return new Array(size[0]).fill(0).map((_, i)=>_1dFft(arr[i], dim - 1));
        if (size.length === 1) return _fft(arr);
        function _transpose(arr) {
            // Swap first 2 dimensions
            var size = (0, $d80Xp.arraySize)(arr);
            return new Array(size[1]).fill(0).map((_, j)=>new Array(size[0]).fill(0).map((_, i)=>arr[i][j]));
        }
        return _transpose(_1dFft(_transpose(arr), 1));
    }
    /**
   * Perform an 1-dimensional non-power-of-2 Fourier transform using Chirp-Z Transform
   *
   * @param {Array} arr      The array
   * @return {Array}         resulting array
   */ function _czt(arr) {
        var n = arr.length;
        var w = exp(divideScalar(multiplyScalar(-1, multiplyScalar(I, tau)), n));
        var chirp = [];
        for(var i = 1 - n; i < n; i++)chirp.push(pow(w, divideScalar(pow(i, 2), 2)));
        var N2 = pow(2, ceil(log2(n + n - 1)));
        var xp = [
            ...new Array(n).fill(0).map((_, i)=>multiplyScalar(arr[i], chirp[n - 1 + i])),
            ...new Array(N2 - n).fill(0)
        ];
        var ichirp = [
            ...new Array(n + n - 1).fill(0).map((_, i)=>divideScalar(1, chirp[i])),
            ...new Array(N2 - (n + n - 1)).fill(0)
        ];
        var fftXp = _fft(xp);
        var fftIchirp = _fft(ichirp);
        var fftProduct = new Array(N2).fill(0).map((_, i)=>multiplyScalar(fftXp[i], fftIchirp[i]));
        var ifftProduct = dotDivide(conj(_ndFft(conj(fftProduct))), N2);
        var ret = [];
        for(var _i = n - 1; _i < n + n - 1; _i++)ret.push(multiplyScalar(ifftProduct[_i], chirp[_i]));
        return ret;
    }
    /**
   * Perform an 1-dimensional Fourier transform
   *
   * @param {Array} arr      The array
   * @return {Array}         resulting array
   */ function _fft(arr) {
        var len = arr.length;
        if (len === 1) return [
            arr[0]
        ];
        if (len % 2 === 0) {
            var ret = [
                ..._fft(arr.filter((_, i)=>i % 2 === 0), len / 2),
                ..._fft(arr.filter((_, i)=>i % 2 === 1), len / 2)
            ];
            for(var k = 0; k < len / 2; k++){
                var p = ret[k];
                var q = multiplyScalar(ret[k + len / 2], exp(multiplyScalar(multiplyScalar(tau, I), divideScalar(-k, len))));
                ret[k] = addScalar(p, q);
                ret[k + len / 2] = addScalar(p, multiplyScalar(-1, q));
            }
            return ret;
        } else // use chirp-z transform for non-power-of-2 FFT
        return _czt(arr);
    // throw new Error('Can only calculate FFT of power-of-two size')
    }
});

});

parcelRegister("a5JMQ", function(module, exports) {

$parcel$export(module.exports, "createFibonacciHeapClass", () => $758de351c28cbb0c$export$3143a09e27a84c41);

var $dsu7t = parcelRequire("dsu7t");
var $758de351c28cbb0c$var$name = 'FibonacciHeap';
var $758de351c28cbb0c$var$dependencies = [
    'smaller',
    'larger'
];
var $758de351c28cbb0c$export$3143a09e27a84c41 = /* #__PURE__ */ (0, $dsu7t.factory)($758de351c28cbb0c$var$name, $758de351c28cbb0c$var$dependencies, (_ref)=>{
    var { smaller: smaller, larger: larger } = _ref;
    var oneOverLogPhi = 1.0 / Math.log((1.0 + Math.sqrt(5.0)) / 2.0);
    /**
   * Fibonacci Heap implementation, used interally for Matrix math.
   * @class FibonacciHeap
   * @constructor FibonacciHeap
   */ function FibonacciHeap() {
        if (!(this instanceof FibonacciHeap)) throw new SyntaxError('Constructor must be called with the new operator');
        // initialize fields
        this._minimum = null;
        this._size = 0;
    }
    /**
   * Attach type information
   */ FibonacciHeap.prototype.type = 'FibonacciHeap';
    FibonacciHeap.prototype.isFibonacciHeap = true;
    /**
   * Inserts a new data element into the heap. No heap consolidation is
   * performed at this time, the new node is simply inserted into the root
   * list of this heap. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.insert = function(key, value) {
        // create node
        var node = {
            key: key,
            value: value,
            degree: 0
        };
        // check we have a node in the minimum
        if (this._minimum) {
            // minimum node
            var minimum = this._minimum;
            // update left & right of node
            node.left = minimum;
            node.right = minimum.right;
            minimum.right = node;
            node.right.left = node;
            // update minimum node in heap if needed
            if (smaller(key, minimum.key)) // node has a smaller key, use it as minimum
            this._minimum = node;
        } else {
            // set left & right
            node.left = node;
            node.right = node;
            // this is the first node
            this._minimum = node;
        }
        // increment number of nodes in heap
        this._size++;
        // return node
        return node;
    };
    /**
   * Returns the number of nodes in heap. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.size = function() {
        return this._size;
    };
    /**
   * Removes all elements from this heap.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.clear = function() {
        this._minimum = null;
        this._size = 0;
    };
    /**
   * Returns true if the heap is empty, otherwise false.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.isEmpty = function() {
        return this._size === 0;
    };
    /**
   * Extracts the node with minimum key from heap. Amortized running
   * time: O(log n).
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.extractMinimum = function() {
        // node to remove
        var node = this._minimum;
        // check we have a minimum
        if (node === null) return node;
        // current minimum
        var minimum = this._minimum;
        // get number of children
        var numberOfChildren = node.degree;
        // pointer to the first child
        var x = node.child;
        // for each child of node do...
        while(numberOfChildren > 0){
            // store node in right side
            var tempRight = x.right;
            // remove x from child list
            x.left.right = x.right;
            x.right.left = x.left;
            // add x to root list of heap
            x.left = minimum;
            x.right = minimum.right;
            minimum.right = x;
            x.right.left = x;
            // set Parent[x] to null
            x.parent = null;
            x = tempRight;
            numberOfChildren--;
        }
        // remove node from root list of heap
        node.left.right = node.right;
        node.right.left = node.left;
        // update minimum
        if (node === node.right) // empty
        minimum = null;
        else {
            // update minimum
            minimum = node.right;
            // we need to update the pointer to the root with minimum key
            minimum = _findMinimumNode(minimum, this._size);
        }
        // decrement size of heap
        this._size--;
        // update minimum
        this._minimum = minimum;
        // return node
        return node;
    };
    /**
   * Removes a node from the heap given the reference to the node. The trees
   * in the heap will be consolidated, if necessary. This operation may fail
   * to remove the correct element if there are nodes with key value -Infinity.
   * Running time: O(log n) amortized.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.remove = function(node) {
        // decrease key value
        this._minimum = _decreaseKey(this._minimum, node, -1);
        // remove the smallest
        this.extractMinimum();
    };
    /**
   * Decreases the key value for a heap node, given the new value to take on.
   * The structure of the heap may be changed and will not be consolidated.
   * Running time: O(1) amortized.
   * @memberof FibonacciHeap
   */ function _decreaseKey(minimum, node, key) {
        // set node key
        node.key = key;
        // get parent node
        var parent = node.parent;
        if (parent && smaller(node.key, parent.key)) {
            // remove node from parent
            _cut(minimum, node, parent);
            // remove all nodes from parent to the root parent
            _cascadingCut(minimum, parent);
        }
        // update minimum node if needed
        if (smaller(node.key, minimum.key)) minimum = node;
        // return minimum
        return minimum;
    }
    /**
   * The reverse of the link operation: removes node from the child list of parent.
   * This method assumes that min is non-null. Running time: O(1).
   * @memberof FibonacciHeap
   */ function _cut(minimum, node, parent) {
        // remove node from parent children and decrement Degree[parent]
        node.left.right = node.right;
        node.right.left = node.left;
        parent.degree--;
        // reset y.child if necessary
        if (parent.child === node) parent.child = node.right;
        // remove child if degree is 0
        if (parent.degree === 0) parent.child = null;
        // add node to root list of heap
        node.left = minimum;
        node.right = minimum.right;
        minimum.right = node;
        node.right.left = node;
        // set parent[node] to null
        node.parent = null;
        // set mark[node] to false
        node.mark = false;
    }
    /**
   * Performs a cascading cut operation. This cuts node from its parent and then
   * does the same for its parent, and so on up the tree.
   * Running time: O(log n); O(1) excluding the recursion.
   * @memberof FibonacciHeap
   */ function _cascadingCut(minimum, node) {
        // store parent node
        var parent = node.parent;
        // if there's a parent...
        if (!parent) return;
        // if node is unmarked, set it marked
        if (!node.mark) node.mark = true;
        else {
            // it's marked, cut it from parent
            _cut(minimum, node, parent);
            // cut its parent as well
            _cascadingCut(parent);
        }
    }
    /**
   * Make the first node a child of the second one. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ var _linkNodes = function _linkNodes(node, parent) {
        // remove node from root list of heap
        node.left.right = node.right;
        node.right.left = node.left;
        // make node a Child of parent
        node.parent = parent;
        if (!parent.child) {
            parent.child = node;
            node.right = node;
            node.left = node;
        } else {
            node.left = parent.child;
            node.right = parent.child.right;
            parent.child.right = node;
            node.right.left = node;
        }
        // increase degree[parent]
        parent.degree++;
        // set mark[node] false
        node.mark = false;
    };
    function _findMinimumNode(minimum, size) {
        // to find trees of the same degree efficiently we use an array of length O(log n) in which we keep a pointer to one root of each degree
        var arraySize = Math.floor(Math.log(size) * oneOverLogPhi) + 1;
        // create list with initial capacity
        var array = new Array(arraySize);
        // find the number of root nodes.
        var numRoots = 0;
        var x = minimum;
        if (x) {
            numRoots++;
            x = x.right;
            while(x !== minimum){
                numRoots++;
                x = x.right;
            }
        }
        // vars
        var y;
        // For each node in root list do...
        while(numRoots > 0){
            // access this node's degree..
            var d = x.degree;
            // get next node
            var next = x.right;
            // check if there is a node already in array with the same degree
            while(true){
                // get node with the same degree is any
                y = array[d];
                if (!y) break;
                // make one node with the same degree a child of the other, do this based on the key value.
                if (larger(x.key, y.key)) {
                    var temp = y;
                    y = x;
                    x = temp;
                }
                // make y a child of x
                _linkNodes(y, x);
                // we have handled this degree, go to next one.
                array[d] = null;
                d++;
            }
            // save this node for later when we might encounter another of the same degree.
            array[d] = x;
            // move forward through list.
            x = next;
            numRoots--;
        }
        // Set min to null (effectively losing the root list) and reconstruct the root list from the array entries in array[].
        minimum = null;
        // loop nodes in array
        for(var i = 0; i < arraySize; i++){
            // get current node
            y = array[i];
            if (!y) continue;
            // check if we have a linked list
            if (minimum) {
                // First remove node from root list.
                y.left.right = y.right;
                y.right.left = y.left;
                // now add to root list, again.
                y.left = minimum;
                y.right = minimum.right;
                minimum.right = y;
                y.right.left = y;
                // check if this is a new min.
                if (smaller(y.key, minimum.key)) minimum = y;
            } else minimum = y;
        }
        return minimum;
    }
    return FibonacciHeap;
}, {
    isClass: true
});

});

parcelRegister("fAKD1", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $b59e633c1304f532$export$5d81789ff4aeccdf);

var $bLcpf = parcelRequire("bLcpf");

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $b59e633c1304f532$var$name = 'filter';
var $b59e633c1304f532$var$dependencies = [
    'typed'
];
var $b59e633c1304f532$export$5d81789ff4aeccdf = /* #__PURE__ */ (0, $dsu7t.factory)($b59e633c1304f532$var$name, $b59e633c1304f532$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Filter the items in an array or one dimensional matrix.
   *
   * The callback is invoked with three arguments: the current value,
   * the current index, and the matrix operated upon.
   * Note that because the matrix/array might be
   * multidimensional, the "index" argument is always an array of numbers giving
   * the index in each dimension. This is true even for vectors: the "index"
   * argument is an array of length 1, rather than simply a number.
   *
   * Syntax:
   *
   *    math.filter(x, test)
   *
   * Examples:
   *
   *    function isPositive (x) {
   *      return x > 0
   *    }
   *    math.filter([6, -2, -1, 4, 3], isPositive) // returns [6, 4, 3]
   *
   *    math.filter(["23", "foo", "100", "55", "bar"], /[0-9]+/) // returns ["23", "100", "55"]
   *
   * See also:
   *
   *    forEach, map, sort
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to filter
   * @param {Function | RegExp} test
   *        A function or regular expression to test items.
   *        All entries for which `test` returns true are returned.
   *        When `test` is a function, it is invoked with three parameters:
   *        the value of the element, the index of the element, and the
   *        matrix/array being traversed. The function must return a boolean.
   * @return {Matrix | Array} Returns the filtered matrix.
   */ return typed('filter', {
        'Array, function': $b59e633c1304f532$var$_filterCallback,
        'Matrix, function': function Matrix_function(x, test) {
            return x.create($b59e633c1304f532$var$_filterCallback(x.valueOf(), test), x.datatype());
        },
        'Array, RegExp': (0, $d80Xp.filterRegExp),
        'Matrix, RegExp': function Matrix_RegExp(x, test) {
            return x.create((0, $d80Xp.filterRegExp)(x.valueOf(), test), x.datatype());
        }
    });
});
/**
 * Filter values in a callback given a callback function
 * @param {Array} x
 * @param {Function} callback
 * @return {Array} Returns the filtered array
 * @private
 */ function $b59e633c1304f532$var$_filterCallback(x, callback) {
    var fastCallback = (0, $bLcpf.optimizeCallback)(callback, x, 'filter');
    if (fastCallback.isUnary) return (0, $d80Xp.filter)(x, fastCallback.fn);
    return (0, $d80Xp.filter)(x, function(value, index, array) {
        // invoke the callback function with the right number of arguments
        return fastCallback.fn(value, [
            index
        ], array);
    });
}

});

parcelRegister("ld1cu", function(module, exports) {

$parcel$export(module.exports, "createFix", () => $f70bbe445c58be54$export$3ed06081b8a4ee6);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");

var $19L2p = parcelRequire("19L2p");

var $dK2sh = parcelRequire("dK2sh");
var $f70bbe445c58be54$var$name = 'fix';
var $f70bbe445c58be54$var$dependencies = [
    'typed',
    'Complex',
    'matrix',
    'ceil',
    'floor',
    'equalScalar',
    'zeros',
    'DenseMatrix'
];
var $f70bbe445c58be54$export$595d114466bb5460 = /* #__PURE__ */ (0, $dsu7t.factory)($f70bbe445c58be54$var$name, [
    'typed',
    'ceil',
    'floor'
], (_ref)=>{
    var { typed: typed, ceil: ceil, floor: floor } = _ref;
    return typed($f70bbe445c58be54$var$name, {
        number: function number(x) {
            return x > 0 ? floor(x) : ceil(x);
        },
        'number, number': function number_number(x, n) {
            return x > 0 ? floor(x, n) : ceil(x, n);
        }
    });
});
var $f70bbe445c58be54$export$3ed06081b8a4ee6 = /* #__PURE__ */ (0, $dsu7t.factory)($f70bbe445c58be54$var$name, $f70bbe445c58be54$var$dependencies, (_ref2)=>{
    var { typed: typed, Complex: _Complex, matrix: matrix, ceil: ceil, floor: floor, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref2;
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo14xDs = (0, $dK2sh.createMatAlgo14xDs)({
        typed: typed
    });
    var fixNumber = $f70bbe445c58be54$export$595d114466bb5460({
        typed: typed,
        ceil: ceil,
        floor: floor
    });
    /**
   * Round a value towards zero.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.fix(x)
   *    math.fix(x,n)
   *    math.fix(unit, valuelessUnit)
   *    math.fix(unit, n, valuelessUnit)
   *
   * Examples:
   *
   *    math.fix(3.2)                // returns number 3
   *    math.fix(3.8)                // returns number 3
   *    math.fix(-4.2)               // returns number -4
   *    math.fix(-4.7)               // returns number -4
   *
   *    math.fix(3.12, 1)                // returns number 3.1
   *    math.fix(3.18, 1)                // returns number 3.1
   *    math.fix(-4.12, 1)               // returns number -4.1
   *    math.fix(-4.17, 1)               // returns number -4.1
   *
   *    const c = math.complex(3.22, -2.78)
   *    math.fix(c)                  // returns Complex 3 - 2i
   *    math.fix(c, 1)               // returns Complex 3.2 -2.7i
   *
   *    const unit = math.unit('3.241 cm')
   *    const cm = math.unit('cm')
   *    const mm = math.unit('mm')
   *    math.fix(unit, 1, cm)      // returns Unit 3.2 cm
   *    math.fix(unit, 1, mm)      // returns Unit 32.4 mm
   *
   *    math.fix([3.2, 3.8, -4.7])      // returns Array [3, 3, -4]
   *    math.fix([3.2, 3.8, -4.7], 1)   // returns Array [3.2, 3.8, -4.7]
   *
   * See also:
   *
   *    ceil, floor, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x  Value to be rounded
   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
   * @param  {Unit} [valuelessUnit]                                        A valueless unit
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Rounded value
   */ return typed('fix', {
        number: fixNumber.signatures.number,
        'number, number | BigNumber': fixNumber.signatures['number,number'],
        Complex: function Complex(x) {
            return new _Complex(x.re > 0 ? Math.floor(x.re) : Math.ceil(x.re), x.im > 0 ? Math.floor(x.im) : Math.ceil(x.im));
        },
        'Complex, number': function Complex_number(x, n) {
            return new _Complex(x.re > 0 ? floor(x.re, n) : ceil(x.re, n), x.im > 0 ? floor(x.im, n) : ceil(x.im, n));
        },
        'Complex, BigNumber': function Complex_BigNumber(x, bn) {
            var n = bn.toNumber();
            return new _Complex(x.re > 0 ? floor(x.re, n) : ceil(x.re, n), x.im > 0 ? floor(x.im, n) : ceil(x.im, n));
        },
        BigNumber: function BigNumber(x) {
            return x.isNegative() ? ceil(x) : floor(x);
        },
        'BigNumber, number | BigNumber': function BigNumber_number__BigNumber(x, n) {
            return x.isNegative() ? ceil(x, n) : floor(x, n);
        },
        bigint: (b)=>b,
        'bigint, number': (b, _dummy)=>b,
        'bigint, BigNumber': (b, _dummy)=>b,
        Fraction: function Fraction(x) {
            return x.s < 0n ? x.ceil() : x.floor();
        },
        'Fraction, number | BigNumber': function Fraction_number__BigNumber(x, n) {
            return x.s < 0n ? ceil(x, n) : floor(x, n);
        },
        'Unit, number, Unit': typed.referToSelf((self)=>function(x, n, unit) {
                var valueless = x.toNumeric(unit);
                return unit.multiply(self(valueless, n));
            }),
        'Unit, BigNumber, Unit': typed.referToSelf((self)=>(x, n, unit)=>self(x, n.toNumber(), unit)),
        'Array | Matrix, number | BigNumber, Unit': typed.referToSelf((self)=>(x, n, unit)=>{
                // deep map collection, skip zeros since fix(0) = 0
                return (0, $20mkw.deepMap)(x, (value)=>self(value, n, unit), true);
            }),
        'Array | Matrix | Unit, Unit': typed.referToSelf((self)=>(x, unit)=>self(x, 0, unit)),
        'Array | Matrix': typed.referToSelf((self)=>(x)=>{
                // deep map collection, skip zeros since fix(0) = 0
                return (0, $20mkw.deepMap)(x, self, true);
            }),
        'Array | Matrix, number | BigNumber': typed.referToSelf((self)=>(x, n)=>{
                // deep map collection, skip zeros since fix(0) = 0
                return (0, $20mkw.deepMap)(x, (i)=>self(i, n), true);
            }),
        'number | Complex | Fraction | BigNumber, Array': typed.referToSelf((self)=>(x, y)=>{
                // use matrix implementation
                return matAlgo14xDs(matrix(y), x, self, true).valueOf();
            }),
        'number | Complex | Fraction | BigNumber, Matrix': typed.referToSelf((self)=>(x, y)=>{
                if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
                if (y.storage() === 'dense') return matAlgo14xDs(y, x, self, true);
                return matAlgo12xSfs(y, x, self, true);
            })
    });
});

});

parcelRegister("3i4Xw", function(module, exports) {

$parcel$export(module.exports, "createFlatten", () => $2656e650c98af723$export$107988e3ee9f3d12);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $2656e650c98af723$var$name = 'flatten';
var $2656e650c98af723$var$dependencies = [
    'typed'
];
var $2656e650c98af723$export$107988e3ee9f3d12 = /* #__PURE__ */ (0, $dsu7t.factory)($2656e650c98af723$var$name, $2656e650c98af723$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Flatten a multidimensional matrix into a single dimensional matrix.
   * A new matrix is returned, the original matrix is left untouched.
   *
   * Syntax:
   *
   *    math.flatten(x)
   *
   * Examples:
   *
   *    math.flatten([[1,2], [3,4]])   // returns [1, 2, 3, 4]
   *
   * See also:
   *
   *    concat, resize, size, squeeze
   *
   * @param {Matrix | Array} x   Matrix to be flattened
   * @return {Matrix | Array} Returns the flattened matrix
   */ return typed($2656e650c98af723$var$name, {
        Array: function Array(x) {
            return (0, $d80Xp.flatten)(x);
        },
        Matrix: function Matrix(x) {
            // Return the same matrix type as x (Dense or Sparse Matrix)
            // Return the same data type as x
            return x.create((0, $d80Xp.flatten)(x.valueOf(), true), x.datatype());
        }
    });
});

});

parcelRegister("ajXgF", function(module, exports) {

$parcel$export(module.exports, "createFloor", () => $7839a7157e9e973d$export$e04e4803a9128c9b);

var $cIZs1 = parcelRequire("cIZs1");

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");

var $6NnhX = parcelRequire("6NnhX");

var $i7dfO = parcelRequire("i7dfO");

var $52JKA = parcelRequire("52JKA");

var $19L2p = parcelRequire("19L2p");

var $dK2sh = parcelRequire("dK2sh");
var $7839a7157e9e973d$var$name = 'floor';
var $7839a7157e9e973d$var$dependencies = [
    'typed',
    'config',
    'round',
    'matrix',
    'equalScalar',
    'zeros',
    'DenseMatrix'
];
var $7839a7157e9e973d$var$bigTen = new (0, (/*@__PURE__*/$parcel$interopDefault($cIZs1)))(10);
var $7839a7157e9e973d$export$a13f3226a75ff445 = /* #__PURE__ */ (0, $dsu7t.factory)($7839a7157e9e973d$var$name, [
    'typed',
    'config',
    'round'
], (_ref)=>{
    var { typed: typed, config: config, round: round } = _ref;
    function _floorNumber(x) {
        // First, if the floor and the round are identical we can be
        // quite comfortable that is the best answer:
        var f = Math.floor(x);
        var r = round(x);
        if (f === r) return f;
        // OK, they are different. If x is truly distinct from f but
        // appears indistinguishable from r, presume it really is just
        // the integer r with rounding/computation error, and return that
        if ((0, $6NnhX.nearlyEqual)(x, r, config.relTol, config.absTol) && !(0, $6NnhX.nearlyEqual)(x, f, config.relTol, config.absTol)) return r;
        // Otherwise (x distinct from both r and f, or indistinguishable from
        // both r and f) may as well just return f, as that's the best
        // candidate we can discern:
        return f;
    }
    return typed($7839a7157e9e973d$var$name, {
        number: _floorNumber,
        'number, number': function number_number(x, n) {
            if (!(0, $6NnhX.isInteger)(n)) throw new RangeError('number of decimals in function floor must be an integer');
            if (n < 0 || n > 15) throw new RangeError('number of decimals in floor number must be in range 0 - 15');
            var shift = 10 ** n;
            return _floorNumber(x * shift) / shift;
        }
    });
});
var $7839a7157e9e973d$export$e04e4803a9128c9b = /* #__PURE__ */ (0, $dsu7t.factory)($7839a7157e9e973d$var$name, $7839a7157e9e973d$var$dependencies, (_ref2)=>{
    var { typed: typed, config: config, round: round, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref2;
    var matAlgo11xS0s = (0, $52JKA.createMatAlgo11xS0s)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo14xDs = (0, $dK2sh.createMatAlgo14xDs)({
        typed: typed
    });
    var floorNumber = $7839a7157e9e973d$export$a13f3226a75ff445({
        typed: typed,
        config: config,
        round: round
    });
    function _bigFloor(x) {
        // see _floorNumber above for rationale
        var bne = (a, b)=>(0, $i7dfO.nearlyEqual)(a, b, config.relTol, config.absTol);
        var f = x.floor();
        var r = round(x);
        if (f.eq(r)) return f;
        if (bne(x, r) && !bne(x, f)) return r;
        return f;
    }
    /**
   * Round a value towards minus infinity.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.floor(x)
   *    math.floor(x, n)
   *    math.floor(unit, valuelessUnit)
   *    math.floor(unit, n, valuelessUnit)
   *
   * Examples:
   *
   *    math.floor(3.2)              // returns number 3
   *    math.floor(3.8)              // returns number 3
   *    math.floor(-4.2)             // returns number -5
   *    math.floor(-4.7)             // returns number -5
   *
   *    math.floor(3.212, 2)          // returns number 3.21
   *    math.floor(3.288, 2)          // returns number 3.28
   *    math.floor(-4.212, 2)         // returns number -4.22
   *    math.floor(-4.782, 2)         // returns number -4.79
   *
   *    const c = math.complex(3.24, -2.71)
   *    math.floor(c)                 // returns Complex 3 - 3i
   *    math.floor(c, 1)              // returns Complex 3.2 -2.8i
   *
   *    const unit = math.unit('3.241 cm')
   *    const cm = math.unit('cm')
   *    const mm = math.unit('mm')
   *    math.floor(unit, 1, cm)      // returns Unit 3.2 cm
   *    math.floor(unit, 1, mm)      // returns Unit 32.4 mm
   *
   *    math.floor([3.2, 3.8, -4.7])       // returns Array [3, 3, -5]
   *    math.floor([3.21, 3.82, -4.71], 1)  // returns Array [3.2, 3.8, -4.8]
   *
   *    math.floor(math.tau, [2, 3])  // returns Array [6.28, 6.283]
   *
   *    // Note that floor(array, array) currently not implemented.
   *
   * See also:
   *
   *    ceil, fix, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x  Value to be rounded
   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
   * @param  {Unit} [valuelessUnit]                                        A valueless unit
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Rounded value
   */ return typed('floor', {
        number: floorNumber.signatures.number,
        'number,number': floorNumber.signatures['number,number'],
        Complex: function Complex(x) {
            return x.floor();
        },
        'Complex, number': function Complex_number(x, n) {
            return x.floor(n);
        },
        'Complex, BigNumber': function Complex_BigNumber(x, n) {
            return x.floor(n.toNumber());
        },
        BigNumber: _bigFloor,
        'BigNumber, BigNumber': function BigNumber_BigNumber(x, n) {
            var shift = $7839a7157e9e973d$var$bigTen.pow(n);
            return _bigFloor(x.mul(shift)).div(shift);
        },
        bigint: (b)=>b,
        'bigint, number': (b, _dummy)=>b,
        'bigint, BigNumber': (b, _dummy)=>b,
        Fraction: function Fraction(x) {
            return x.floor();
        },
        'Fraction, number': function Fraction_number(x, n) {
            return x.floor(n);
        },
        'Fraction, BigNumber': function Fraction_BigNumber(x, n) {
            return x.floor(n.toNumber());
        },
        'Unit, number, Unit': typed.referToSelf((self)=>function(x, n, unit) {
                var valueless = x.toNumeric(unit);
                return unit.multiply(self(valueless, n));
            }),
        'Unit, BigNumber, Unit': typed.referToSelf((self)=>(x, n, unit)=>self(x, n.toNumber(), unit)),
        'Array | Matrix, number | BigNumber, Unit': typed.referToSelf((self)=>(x, n, unit)=>{
                // deep map collection, skip zeros since floor(0) = 0
                return (0, $20mkw.deepMap)(x, (value)=>self(value, n, unit), true);
            }),
        'Array | Matrix | Unit, Unit': typed.referToSelf((self)=>(x, unit)=>self(x, 0, unit)),
        'Array | Matrix': typed.referToSelf((self)=>(x)=>{
                // deep map collection, skip zeros since floor(0) = 0
                return (0, $20mkw.deepMap)(x, self, true);
            }),
        'Array, number | BigNumber': typed.referToSelf((self)=>(x, n)=>{
                // deep map collection, skip zeros since ceil(0) = 0
                return (0, $20mkw.deepMap)(x, (i)=>self(i, n), true);
            }),
        'SparseMatrix, number | BigNumber': typed.referToSelf((self)=>(x, y)=>{
                return matAlgo11xS0s(x, y, self, false);
            }),
        'DenseMatrix, number | BigNumber': typed.referToSelf((self)=>(x, y)=>{
                return matAlgo14xDs(x, y, self, false);
            }),
        'number | Complex | Fraction | BigNumber, Array': typed.referToSelf((self)=>(x, y)=>{
                // use matrix implementation
                return matAlgo14xDs(matrix(y), x, self, true).valueOf();
            }),
        'number | Complex | Fraction | BigNumber, Matrix': typed.referToSelf((self)=>(x, y)=>{
                if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
                if (y.storage() === 'dense') return matAlgo14xDs(y, x, self, true);
                return matAlgo12xSfs(y, x, self, true);
            })
    });
});

});

parcelRegister("fekL0", function(module, exports) {

$parcel$export(module.exports, "createForEach", () => $b16843bc9e1c16ab$export$a5218987e0811e05);

var $bLcpf = parcelRequire("bLcpf");

var $dsu7t = parcelRequire("dsu7t");

var $d80Xp = parcelRequire("d80Xp");
var $b16843bc9e1c16ab$var$name = 'forEach';
var $b16843bc9e1c16ab$var$dependencies = [
    'typed'
];
var $b16843bc9e1c16ab$export$a5218987e0811e05 = /* #__PURE__ */ (0, $dsu7t.factory)($b16843bc9e1c16ab$var$name, $b16843bc9e1c16ab$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterate over all elements of a matrix/array, and executes the given callback function.
   *
   * The callback is invoked with three arguments: the current value,
   * the current index, and the matrix operated upon.
   * Note that because the matrix/array might be
   * multidimensional, the "index" argument is always an array of numbers giving
   * the index in each dimension. This is true even for vectors: the "index"
   * argument is an array of length 1, rather than simply a number.
   *
   * Syntax:
   *
   *    math.forEach(x, callback)
   *
   * Examples:
   *
   *    math.forEach([1, 2, 3], function(value) {
   *      console.log(value)
   *    })
   *    // outputs 1, 2, 3
   *
   * See also:
   *
   *    filter, map, sort
   *
   * @param {Matrix | Array} x    The matrix to iterate on.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix/array being traversed.
   */ return typed($b16843bc9e1c16ab$var$name, {
        'Array, function': $b16843bc9e1c16ab$var$_forEach,
        'Matrix, function': function Matrix_function(x, callback) {
            x.forEach(callback);
        }
    });
});
/**
 * forEach for a multidimensional array
 * @param {Array} array
 * @param {Function} callback
 * @private
 */ function $b16843bc9e1c16ab$var$_forEach(array, callback) {
    var fastCallback = (0, $bLcpf.optimizeCallback)(callback, array, $b16843bc9e1c16ab$var$name);
    (0, $d80Xp.deepForEach)(array, fastCallback.fn, fastCallback.isUnary);
}

});

parcelRegister("2QvDu", function(module, exports) {

$parcel$export(module.exports, "createFormat", () => $2128fa5a982d809f$export$abf0d9399b60f9bb);

var $j2hDb = parcelRequire("j2hDb");

var $dsu7t = parcelRequire("dsu7t");
var $2128fa5a982d809f$var$name = 'format';
var $2128fa5a982d809f$var$dependencies = [
    'typed'
];
var $2128fa5a982d809f$export$abf0d9399b60f9bb = /* #__PURE__ */ (0, $dsu7t.factory)($2128fa5a982d809f$var$name, $2128fa5a982d809f$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Format a value of any type into a string.
   *
   * Syntax:
   *
   *    math.format(value)
   *    math.format(value, options)
   *    math.format(value, precision)
   *    math.format(value, callback)
   *
   * Where:
   *
   *  - `value: *`
   *    The value to be formatted
   *  - `options: Object`
   *    An object with formatting options. Available options:
   *    - `notation: string`
   *      Number notation. Choose from:
   *      - `'fixed'`
   *        Always use regular number notation.
   *        For example `'123.40'` and `'14000000'`
   *      - `'exponential'`
   *        Always use exponential notation.
   *        For example `'1.234e+2'` and `'1.4e+7'`
   *      - `'engineering'`
   *        Always use engineering notation: always have exponential notation,
   *        and select the exponent to be a multiple of `3`.
   *        For example `'123.4e+0'` and `'14.0e+6'`
   *      - `'auto'` (default)
   *        Regular number notation for numbers having an absolute value between
   *        `lower` and `upper` bounds, and uses exponential notation elsewhere.
   *        Lower bound is included, upper bound is excluded.
   *        For example `'123.4'` and `'1.4e7'`.
   *      - `'bin'`, `'oct'`, or `'hex'`
   *        Format the number using binary, octal, or hexadecimal notation.
   *        For example `'0b1101'` and `'0x10fe'`.
   *    - `wordSize: number | BigNumber`
   *      The word size in bits to use for formatting in binary, octal, or
   *      hexadecimal notation. To be used only with `'bin'`, `'oct'`, or `'hex'`
   *      values for `notation` option. When this option is defined the value
   *      is formatted as a signed twos complement integer of the given word
   *      size and the size suffix is appended to the output.
   *      For example `format(-1, {notation: 'hex', wordSize: 8}) === '0xffi8'`.
   *      Default value is undefined.
   *    - `precision: number | BigNumber`
   *      Limit the number of digits of the formatted value.
   *      For regular numbers, must be a number between `0` and `16`.
   *      For bignumbers, the maximum depends on the configured precision,
   *      see function `config()`.
   *      In case of notations `'exponential'`, `'engineering'`, and `'auto'`,
   *      `precision` defines the total number of significant digits returned.
   *      In case of notation `'fixed'`, `precision` defines the number of
   *      significant digits after the decimal point.
   *      `precision` is undefined by default.
   *    - `lowerExp: number`
   *      Exponent determining the lower boundary for formatting a value with
   *      an exponent when `notation='auto'`. Default value is `-3`.
   *    - `upperExp: number`
   *      Exponent determining the upper boundary for formatting a value with
   *      an exponent when `notation='auto'`. Default value is `5`.
   *    - `fraction: string`. Available values: `'ratio'` (default) or `'decimal'`.
   *      For example `format(fraction(1, 3))` will output `'1/3'` when `'ratio'`
   *      is configured, and will output `'0.(3)'` when `'decimal'` is configured.
   *    - `truncate: number`. Specifies the maximum allowed length of the
   *      returned string. If it had been longer, the excess characters
   *      are deleted and replaced with `'...'`.
   * - `callback: function`
   *   A custom formatting function, invoked for all numeric elements in `value`,
   *   for example all elements of a matrix, or the real and imaginary
   *   parts of a complex number. This callback can be used to override the
   *   built-in numeric notation with any type of formatting. Function `callback`
   *   is called with `value` as parameter and must return a string.
   *
   * When `value` is an Object:
   *
   * - When the object contains a property `format` being a function, this function
   *   is invoked as `value.format(options)` and the result is returned.
   * - When the object has its own `toString` method, this method is invoked
   *   and the result is returned.
   * - In other cases the function will loop over all object properties and
   *   return JSON object notation like '{"a": 2, "b": 3}'.
   *
   * When value is a function:
   *
   * - When the function has a property `syntax`, it returns this
   *   syntax description.
   * - In other cases, a string `'function'` is returned.
   *
   * Examples:
   *
   *    math.format(6.4)                                        // returns '6.4'
   *    math.format(1240000)                                    // returns '1.24e+6'
   *    math.format(1/3)                                        // returns '0.3333333333333333'
   *    math.format(1/3, 3)                                     // returns '0.333'
   *    math.format(21385, 2)                                   // returns '21000'
   *    math.format(12e8, {notation: 'fixed'})                  // returns '1200000000'
   *    math.format(2.3,  {notation: 'fixed', precision: 4})    // returns '2.3000'
   *    math.format(52.8, {notation: 'exponential'})            // returns '5.28e+1'
   *    math.format(12400, {notation: 'engineering'})           // returns '12.4e+3'
   *    math.format(2000, {lowerExp: -2, upperExp: 2})          // returns '2e+3'
   *
   *    function formatCurrency(value) {
   *      // return currency notation with two digits:
   *      return '$' + value.toFixed(2)
   *
   *      // you could also use math.format inside the callback:
   *      // return '$' + math.format(value, {notation: 'fixed', precision: 2})
   *    }
   *    math.format([2.1, 3, 0.016], formatCurrency)            // returns '[$2.10, $3.00, $0.02]'
   *
   * See also:
   *
   *    print
   *
   * @param {*} value                               Value to be stringified
   * @param {Object | Function | number} [options]  Formatting options
   * @return {string} The formatted value
   */ return typed($2128fa5a982d809f$var$name, {
        any: (0, $j2hDb.format),
        'any, Object | function | number | BigNumber': (0, $j2hDb.format)
    });
});

});

parcelRegister("deqLg", function(module, exports) {

$parcel$export(module.exports, "createFraction", () => $9a2157694924af3e$export$de147ca8498e0312);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");
var $9a2157694924af3e$var$name = 'fraction';
var $9a2157694924af3e$var$dependencies = [
    'typed',
    'Fraction'
];
var $9a2157694924af3e$export$de147ca8498e0312 = /* #__PURE__ */ (0, $dsu7t.factory)($9a2157694924af3e$var$name, $9a2157694924af3e$var$dependencies, (_ref)=>{
    var { typed: typed, Fraction: Fraction } = _ref;
    /**
   * Create a fraction or convert a value to a fraction.
   *
   * With one numeric argument, produces the closest rational approximation to the
   * input.
   * With two arguments, the first is the numerator and the second is the denominator,
   * and creates the corresponding fraction. Both numerator and denominator must be
   * integers.
   * With one object argument, looks for the integer numerator as the value of property
   * 'n' and the integer denominator as the value of property 'd'.
   * With a matrix argument, creates a matrix of the same shape with entries
   * converted into fractions.
   *
   * Syntax:
   *     math.fraction(value)
   *     math.fraction(numerator, denominator)
   *     math.fraction({n: numerator, d: denominator})
   *     math.fraction(matrix: Array | Matrix)
   *
   * Examples:
   *
   *     math.fraction(6.283)             // returns Fraction 6283/1000
   *     math.fraction(1, 3)              // returns Fraction 1/3
   *     math.fraction('2/3')             // returns Fraction 2/3
   *     math.fraction({n: 2, d: 3})      // returns Fraction 2/3
   *     math.fraction([0.2, 0.25, 1.25]) // returns Array [1/5, 1/4, 5/4]
   *     math.fraction(4, 5.1)            // throws Error: Parameters must be integer
   *
   * See also:
   *
   *    bignumber, number, string, unit
   *
   * @param {number | string | Fraction | BigNumber | bigint | Unit | Array | Matrix} [args]
   *            Arguments specifying the value, or numerator and denominator of
   *            the fraction
   * @return {Fraction | Array | Matrix} Returns a fraction
   */ return typed('fraction', {
        number: function number(x) {
            if (!isFinite(x) || isNaN(x)) throw new Error(x + ' cannot be represented as a fraction');
            return new Fraction(x);
        },
        string: function string(x) {
            return new Fraction(x);
        },
        'number, number': function number_number(numerator, denominator) {
            return new Fraction(numerator, denominator);
        },
        'bigint, bigint': function bigint_bigint(numerator, denominator) {
            return new Fraction(numerator, denominator);
        },
        null: function _null(x) {
            return new Fraction(0);
        },
        BigNumber: function BigNumber(x) {
            return new Fraction(x.toString());
        },
        bigint: function bigint(x) {
            return new Fraction(x.toString());
        },
        Fraction: function Fraction(x) {
            return x; // fractions are immutable
        },
        Unit: typed.referToSelf((self)=>(x)=>{
                var clone = x.clone();
                clone.value = self(x.value);
                return clone;
            }),
        Object: function Object(x) {
            return new Fraction(x);
        },
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});

parcelRegister("1u8WW", function(module, exports) {

$parcel$export(module.exports, "createFractionClass", () => $114f89014335c3bf$export$c317f082100fca89);

var $65EHw = parcelRequire("65EHw");

var $dsu7t = parcelRequire("dsu7t");
var $114f89014335c3bf$var$name = 'Fraction';
var $114f89014335c3bf$var$dependencies = [];
var $114f89014335c3bf$export$c317f082100fca89 = /* #__PURE__ */ (0, $dsu7t.factory)($114f89014335c3bf$var$name, $114f89014335c3bf$var$dependencies, ()=>{
    /**
   * Attach type information
   */ Object.defineProperty((0, (/*@__PURE__*/$parcel$interopDefault($65EHw))), 'name', {
        value: 'Fraction'
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($65EHw))).prototype.constructor = (0, (/*@__PURE__*/$parcel$interopDefault($65EHw)));
    (0, (/*@__PURE__*/$parcel$interopDefault($65EHw))).prototype.type = 'Fraction';
    (0, (/*@__PURE__*/$parcel$interopDefault($65EHw))).prototype.isFraction = true;
    /**
   * Get a JSON representation of a Fraction containing type information
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Fraction", "n": "3", "d": "8"}`
   */ (0, (/*@__PURE__*/$parcel$interopDefault($65EHw))).prototype.toJSON = function() {
        return {
            mathjs: 'Fraction',
            n: String(this.s * this.n),
            d: String(this.d)
        };
    };
    /**
   * Instantiate a Fraction from a JSON object
   * @param {Object} json  a JSON object structured as:
   *                       `{"mathjs": "Fraction", "n": "3", "d": "8"}`
   * @return {BigNumber}
   */ (0, (/*@__PURE__*/$parcel$interopDefault($65EHw))).fromJSON = function(json) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($65EHw)))(json);
    };
    return 0, (/*@__PURE__*/$parcel$interopDefault($65EHw));
}, {
    isClass: true
});

});
parcelRegister("65EHw", function(module, exports) {
/*
Fraction.js v5.3.4 8/22/2025
https://raw.org/article/rational-numbers-in-javascript/

Copyright (c) 2025, Robert Eisele (https://raw.org/)
Licensed under the MIT license.
*/ 'use strict';
(function(F) {
    function D() {
        return Error("Parameters must be integer");
    }
    function x() {
        return Error("Invalid argument");
    }
    function C() {
        return Error("Division by Zero");
    }
    function q(a, b) {
        var d = g, c = h;
        let f = h;
        if (void 0 !== a && null !== a) {
            if (void 0 !== b) {
                if ("bigint" === typeof a) d = a;
                else {
                    if (isNaN(a)) throw x();
                    if (0 !== a % 1) throw D();
                    d = BigInt(a);
                }
                if ("bigint" === typeof b) c = b;
                else {
                    if (isNaN(b)) throw x();
                    if (0 !== b % 1) throw D();
                    c = BigInt(b);
                }
                f = d * c;
            } else if ("object" === typeof a) {
                if ("d" in a && "n" in a) d = BigInt(a.n), c = BigInt(a.d), "s" in a && (d *= BigInt(a.s));
                else if (0 in a) d = BigInt(a[0]), 1 in a && (c = BigInt(a[1]));
                else if ("bigint" === typeof a) d = a;
                else throw x();
                f = d * c;
            } else if ("number" === typeof a) {
                if (isNaN(a)) throw x();
                0 > a && (f = -h, a = -a);
                if (0 === a % 1) d = BigInt(a);
                else {
                    b = 1;
                    var k = 0, l = 1, m = 1;
                    let r = 1;
                    1 <= a && (b = 10 ** Math.floor(1 + Math.log10(a)), a /= b);
                    for(; 1E7 >= l && 1E7 >= r;)if (c = (k + m) / (l + r), a === c) {
                        1E7 >= l + r ? (d = k + m, c = l + r) : r > l ? (d = m, c = r) : (d = k, c = l);
                        break;
                    } else a > c ? (k += m, l += r) : (m += k, r += l), 1E7 < l ? (d = m, c = r) : (d = k, c = l);
                    d = BigInt(d) * BigInt(b);
                    c = BigInt(c);
                }
            } else if ("string" === typeof a) {
                c = 0;
                k = b = d = g;
                l = m = h;
                a = a.replace(/_/g, "").match(/\d+|./g);
                if (null === a) throw x();
                "-" === a[c] ? (f = -h, c++) : "+" === a[c] && c++;
                if (a.length === c + 1) b = w(a[c++], f);
                else if ("." === a[c + 1] || "." === a[c]) {
                    "." !== a[c] && (d = w(a[c++], f));
                    c++;
                    if (c + 1 === a.length || "(" === a[c + 1] && ")" === a[c + 3] || "'" === a[c + 1] && "'" === a[c + 3]) b = w(a[c], f), m = t ** BigInt(a[c].length), c++;
                    if ("(" === a[c] && ")" === a[c + 2] || "'" === a[c] && "'" === a[c + 2]) k = w(a[c + 1], f), l = t ** BigInt(a[c + 1].length) - h, c += 3;
                } else "/" === a[c + 1] || ":" === a[c + 1] ? (b = w(a[c], f), m = w(a[c + 2], h), c += 3) : "/" === a[c + 3] && " " === a[c + 1] && (d = w(a[c], f), b = w(a[c + 2], f), m = w(a[c + 4], h), c += 5);
                if (a.length <= c) c = m * l, f = d = k + c * d + l * b;
                else throw x();
            } else if ("bigint" === typeof a) f = d = a, c = h;
            else throw x();
        }
        if (c === g) throw C();
        e.s = f < g ? -h : h;
        e.n = d < g ? -d : d;
        e.d = c < g ? -c : c;
    }
    function w(a, b) {
        try {
            a = BigInt(a);
        } catch (d) {
            throw x();
        }
        return a * b;
    }
    function u(a) {
        return "bigint" === typeof a ? a : Math.floor(a);
    }
    function n(a, b) {
        if (b === g) throw C();
        const d = Object.create(v.prototype);
        d.s = a < g ? -h : h;
        a = a < g ? -a : a;
        const c = y(a, b);
        d.n = a / c;
        d.d = b / c;
        return d;
    }
    function A(a) {
        const b = Object.create(null);
        if (a <= h) return b[a] = h, b;
        for(; a % p === g;)b[p] = (b[p] || g) + h, a /= p;
        for(; a % B === g;)b[B] = (b[B] || g) + h, a /= B;
        for(; a % z === g;)b[z] = (b[z] || g) + h, a /= z;
        for(let d = 0, c = p + z; c * c <= a;){
            for(; a % c === g;)b[c] = (b[c] || g) + h, a /= c;
            c += G[d];
            d = d + 1 & 7;
        }
        a > h && (b[a] = (b[a] || g) + h);
        return b;
    }
    function y(a, b) {
        if (!a) return b;
        if (!b) return a;
        for(;;){
            a %= b;
            if (!a) return b;
            b %= a;
            if (!b) return a;
        }
    }
    function v(a, b) {
        q(a, b);
        if (this instanceof v) a = y(e.d, e.n), this.s = e.s, this.n = e.n / a, this.d = e.d / a;
        else return n(e.s * e.n, e.d);
    }
    "undefined" === typeof BigInt && (BigInt = function(a) {
        if (isNaN(a)) throw Error("");
        return a;
    });
    const g = BigInt(0), h = BigInt(1), p = BigInt(2), B = BigInt(3), z = BigInt(5), t = BigInt(10), e = {
        s: h,
        n: g,
        d: h
    }, G = [
        p * p,
        p,
        p * p,
        p,
        p * p,
        p * B,
        p,
        p * B
    ];
    v.prototype = {
        s: h,
        n: g,
        d: h,
        abs: function() {
            return n(this.n, this.d);
        },
        neg: function() {
            return n(-this.s * this.n, this.d);
        },
        add: function(a, b) {
            q(a, b);
            return n(this.s * this.n * e.d + e.s * this.d * e.n, this.d * e.d);
        },
        sub: function(a, b) {
            q(a, b);
            return n(this.s * this.n * e.d - e.s * this.d * e.n, this.d * e.d);
        },
        mul: function(a, b) {
            q(a, b);
            return n(this.s * e.s * this.n * e.n, this.d * e.d);
        },
        div: function(a, b) {
            q(a, b);
            return n(this.s * e.s * this.n * e.d, this.d * e.n);
        },
        clone: function() {
            return n(this.s * this.n, this.d);
        },
        mod: function(a, b) {
            if (void 0 === a) return n(this.s * this.n % this.d, h);
            q(a, b);
            if (g === e.n * this.d) throw C();
            return n(this.s * e.d * this.n % (e.n * this.d), e.d * this.d);
        },
        gcd: function(a, b) {
            q(a, b);
            return n(y(e.n, this.n) * y(e.d, this.d), e.d * this.d);
        },
        lcm: function(a, b) {
            q(a, b);
            return e.n === g && this.n === g ? n(g, h) : n(e.n * this.n, y(e.n, this.n) * y(e.d, this.d));
        },
        inverse: function() {
            return n(this.s * this.d, this.n);
        },
        pow: function(a, b) {
            q(a, b);
            if (e.d === h) return e.s < g ? n((this.s * this.d) ** e.n, this.n ** e.n) : n((this.s * this.n) ** e.n, this.d ** e.n);
            if (this.s < g) return null;
            a = A(this.n);
            b = A(this.d);
            let d = h, c = h;
            for(let f in a)if ("1" !== f) {
                if ("0" === f) {
                    d = g;
                    break;
                }
                a[f] *= e.n;
                if (a[f] % e.d === g) a[f] /= e.d;
                else return null;
                d *= BigInt(f) ** a[f];
            }
            for(let f in b)if ("1" !== f) {
                b[f] *= e.n;
                if (b[f] % e.d === g) b[f] /= e.d;
                else return null;
                c *= BigInt(f) ** b[f];
            }
            return e.s < g ? n(c, d) : n(d, c);
        },
        log: function(a, b) {
            q(a, b);
            if (this.s <= g || e.s <= g) return null;
            var d = Object.create(null);
            a = A(e.n);
            const c = A(e.d);
            b = A(this.n);
            const f = A(this.d);
            for(var k in c)a[k] = (a[k] || g) - c[k];
            for(var l in f)b[l] = (b[l] || g) - f[l];
            for(var m in a)"1" !== m && (d[m] = !0);
            for(var r in b)"1" !== r && (d[r] = !0);
            l = k = null;
            for(const E in d)if (m = a[E] || g, d = b[E] || g, m === g) {
                if (d !== g) return null;
            } else if (r = y(d, m), d /= r, m /= r, null === k && null === l) k = d, l = m;
            else if (d * l !== k * m) return null;
            return null !== k && null !== l ? n(k, l) : null;
        },
        equals: function(a, b) {
            q(a, b);
            return this.s * this.n * e.d === e.s * e.n * this.d;
        },
        lt: function(a, b) {
            q(a, b);
            return this.s * this.n * e.d < e.s * e.n * this.d;
        },
        lte: function(a, b) {
            q(a, b);
            return this.s * this.n * e.d <= e.s * e.n * this.d;
        },
        gt: function(a, b) {
            q(a, b);
            return this.s * this.n * e.d > e.s * e.n * this.d;
        },
        gte: function(a, b) {
            q(a, b);
            return this.s * this.n * e.d >= e.s * e.n * this.d;
        },
        compare: function(a, b) {
            q(a, b);
            a = this.s * this.n * e.d - e.s * e.n * this.d;
            return (g < a) - (a < g);
        },
        ceil: function(a) {
            a = t ** BigInt(a || 0);
            return n(u(this.s * a * this.n / this.d) + (a * this.n % this.d > g && this.s >= g ? h : g), a);
        },
        floor: function(a) {
            a = t ** BigInt(a || 0);
            return n(u(this.s * a * this.n / this.d) - (a * this.n % this.d > g && this.s < g ? h : g), a);
        },
        round: function(a) {
            a = t ** BigInt(a || 0);
            return n(u(this.s * a * this.n / this.d) + this.s * ((this.s >= g ? h : g) + a * this.n % this.d * p > this.d ? h : g), a);
        },
        roundTo: function(a, b) {
            q(a, b);
            var d = this.n * e.d;
            a = this.d * e.n;
            b = d % a;
            d = u(d / a);
            b + b >= a && d++;
            return n(this.s * d * e.n, e.d);
        },
        divisible: function(a, b) {
            q(a, b);
            return e.n === g ? !1 : this.n * e.d % (e.n * this.d) === g;
        },
        valueOf: function() {
            return Number(this.s * this.n) / Number(this.d);
        },
        toString: function(a = 15) {
            let b = this.n, d = this.d;
            var c;
            a: {
                for(c = d; c % p === g; c /= p);
                for(; c % z === g; c /= z);
                if (c === h) c = g;
                else {
                    for(var f = t % c, k = 1; f !== h; k++)if (f = f * t % c, 2E3 < k) {
                        c = g;
                        break a;
                    }
                    c = BigInt(k);
                }
            }
            a: {
                f = h;
                k = t;
                var l = c;
                let m = h;
                for(; l > g; k = k * k % d, l >>= h)l & h && (m = m * k % d);
                k = m;
                for(l = 0; 300 > l; l++){
                    if (f === k) {
                        f = BigInt(l);
                        break a;
                    }
                    f = f * t % d;
                    k = k * t % d;
                }
                f = 0;
            }
            k = f;
            f = this.s < g ? "-" : "";
            f += u(b / d);
            (b = b % d * t) && (f += ".");
            if (c) {
                for(a = k; a--;)f += u(b / d), b %= d, b *= t;
                f += "(";
                for(a = c; a--;)f += u(b / d), b %= d, b *= t;
                f += ")";
            } else for(; b && a--;)f += u(b / d), b %= d, b *= t;
            return f;
        },
        toFraction: function(a = !1) {
            let b = this.n, d = this.d, c = this.s < g ? "-" : "";
            if (d === h) c += b;
            else {
                const f = u(b / d);
                a && f > g && (c += f, c += " ", b %= d);
                c = c + b + "/" + d;
            }
            return c;
        },
        toLatex: function(a = !1) {
            let b = this.n, d = this.d, c = this.s < g ? "-" : "";
            if (d === h) c += b;
            else {
                const f = u(b / d);
                a && f > g && (c += f, b %= d);
                c = c + "\\frac{" + b + "}{" + d;
                c += "}";
            }
            return c;
        },
        toContinued: function() {
            let a = this.n, b = this.d;
            const d = [];
            for(; b;){
                d.push(u(a / b));
                const c = a % b;
                a = b;
                b = c;
            }
            return d;
        },
        simplify: function(a = .001) {
            a = BigInt(Math.ceil(1 / a));
            const b = this.abs(), d = b.toContinued();
            for(let f = 1; f < d.length; f++){
                let k = n(d[f - 1], h);
                for(var c = f - 2; 0 <= c; c--)k = k.inverse().add(d[c]);
                c = k.sub(b);
                if (c.n * a < c.d) return k.mul(this.s);
            }
            return this;
        }
    };
    "function" === typeof define && define.amd ? define([], function() {
        return v;
    }) : (Object.defineProperty(v, "__esModule", {
        value: !0
    }), v["default"] = v, v.Fraction = v, module.exports = v);
})(module.exports);

});


parcelRegister("pU8n9", function(module, exports) {

$parcel$export(module.exports, "createFreqz", () => $04dde0f7165f3839$export$5a5299860d551a36);

var $dsu7t = parcelRequire("dsu7t");
var $04dde0f7165f3839$var$name = 'freqz';
var $04dde0f7165f3839$var$dependencies = [
    'typed',
    'add',
    'multiply',
    'Complex',
    'divide',
    'matrix'
];
var $04dde0f7165f3839$export$5a5299860d551a36 = /* #__PURE__ */ (0, $dsu7t.factory)($04dde0f7165f3839$var$name, $04dde0f7165f3839$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, multiply: multiply, Complex: Complex, divide: divide, matrix: matrix } = _ref;
    /**
     * Calculates the frequency response of a filter given its numerator and denominator coefficients.
     *
     * Syntax:
     *    math.freqz(b, a)
     *    math.freqz(b, a, w)
     *
     * Examples:
     *   math.freqz([1, 2], [1, 2, 3], 4) // returns { h: [0.5 + 0i, 0.4768589245763655 + 0.2861153547458193i, 0.25000000000000006 + 0.75i, -0.770976571635189 + 0.4625859429811135i], w: [0, 0.7853981633974483, 1.5707963267948966, 2.356194490192345 ] }
     *   math.freqz([1, 2], [1, 2, 3], [0, 1]) // returns { h: [0.5 + 0i, 0.45436781 + 0.38598051i], w: [0, 1] }
     *
     * See also:
     *  zpk2tf
     *
     * @param {Array.<number>} b The numerator coefficients of the filter.
     * @param {Array.<number>} a The denominator coefficients of the filter.
     * @param {Array.<number>} [w] A vector of frequencies (in radians/sample) at which the frequency response is to be computed or the number of points to compute (if a number is not provided, the default is 512 points)
     * @returns {Object} An object with two properties: h, a vector containing the complex frequency response, and w, a vector containing the normalized frequencies (in radians/sample) at which the response was computed.
     *
     *
     */ return typed($04dde0f7165f3839$var$name, {
        'Array, Array': function Array_Array(b, a) {
            var w = createBins(512);
            return _freqz(b, a, w);
        },
        'Array, Array, Array': function Array_Array_Array(b, a, w) {
            return _freqz(b, a, w);
        },
        'Array, Array, number': function Array_Array_number(b, a, w) {
            if (w < 0) throw new Error('w must be a positive number');
            var w2 = createBins(w);
            return _freqz(b, a, w2);
        },
        'Matrix, Matrix': function Matrix_Matrix(b, a) {
            // console.log('here')
            var _w = createBins(512);
            var { w: w, h: h } = _freqz(b.valueOf(), a.valueOf(), _w);
            return {
                w: matrix(w),
                h: matrix(h)
            };
        },
        'Matrix, Matrix, Matrix': function Matrix_Matrix_Matrix(b, a, w) {
            var { h: h } = _freqz(b.valueOf(), a.valueOf(), w.valueOf());
            return {
                h: matrix(h),
                w: matrix(w)
            };
        },
        'Matrix, Matrix, number': function Matrix_Matrix_number(b, a, w) {
            if (w < 0) throw new Error('w must be a positive number');
            var _w = createBins(w);
            var { h: h } = _freqz(b.valueOf(), a.valueOf(), _w);
            return {
                h: matrix(h),
                w: matrix(_w)
            };
        }
    });
    function _freqz(b, a, w) {
        var num = [];
        var den = [];
        for(var i = 0; i < w.length; i++){
            var sumNum = Complex(0, 0);
            var sumDen = Complex(0, 0);
            for(var j = 0; j < b.length; j++)sumNum = add(sumNum, multiply(b[j], Complex(Math.cos(-j * w[i]), Math.sin(-j * w[i]))));
            for(var _j = 0; _j < a.length; _j++)sumDen = add(sumDen, multiply(a[_j], Complex(Math.cos(-_j * w[i]), Math.sin(-_j * w[i]))));
            num.push(sumNum);
            den.push(sumDen);
        }
        var h = [];
        for(var _i = 0; _i < num.length; _i++)h.push(divide(num[_i], den[_i]));
        return {
            h: h,
            w: w
        };
    }
    function createBins(n) {
        var bins = [];
        for(var i = 0; i < n; i++)bins.push(i / n * Math.PI);
        return bins;
    }
});

});

parcelRegister("7cnsm", function(module, exports) {

$parcel$export(module.exports, "createGamma", () => $53dbd95bf496cd6d$export$115da31fc3cf3d15);

var $dsu7t = parcelRequire("dsu7t");

var $fE59v = parcelRequire("fE59v");
var $53dbd95bf496cd6d$var$name = 'gamma';
var $53dbd95bf496cd6d$var$dependencies = [
    'typed',
    'config',
    'multiplyScalar',
    'pow',
    'BigNumber',
    'Complex'
];
var $53dbd95bf496cd6d$export$115da31fc3cf3d15 = /* #__PURE__ */ (0, $dsu7t.factory)($53dbd95bf496cd6d$var$name, $53dbd95bf496cd6d$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, multiplyScalar: multiplyScalar, pow: pow, BigNumber: _BigNumber, Complex: Complex } = _ref;
    /**
   * Compute the gamma function of a value using Lanczos approximation for
   * small values, and an extended Stirling approximation for large values.
   *
   * To avoid confusion with the matrix Gamma function, this function does
   * not apply to matrices.
   *
   * Syntax:
   *
   *    math.gamma(n)
   *
   * Examples:
   *
   *    math.gamma(5)       // returns 24
   *    math.gamma(-0.5)    // returns -3.5449077018110335
   *    math.gamma(math.i)  // returns -0.15494982830180973 - 0.49801566811835596i
   *
   * See also:
   *
   *    combinations, factorial, permutations
   *
   * @param {number | BigNumber | Complex} n   A real or complex number
   * @return {number | BigNumber | Complex}    The gamma of `n`
   */ function gammaComplex(n) {
        if (n.im === 0) return (0, $fE59v.gammaNumber)(n.re);
        // Lanczos approximation doesn't work well with real part lower than 0.5
        // So reflection formula is required
        if (n.re < 0.5) {
            // Euler's reflection formula
            // gamma(1-z) * gamma(z) = PI / sin(PI * z)
            // real part of Z should not be integer [sin(PI) == 0 -> 1/0 - undefined]
            // thanks to imperfect sin implementation sin(PI * n) != 0
            // we can safely use it anyway
            var _t = new Complex(1 - n.re, -n.im);
            var r = new Complex(Math.PI * n.re, Math.PI * n.im);
            return new Complex(Math.PI).div(r.sin()).div(gammaComplex(_t));
        }
        // Lanczos approximation
        // z -= 1
        n = new Complex(n.re - 1, n.im);
        // x = gammaPval[0]
        var x = new Complex((0, $fE59v.gammaP)[0], 0);
        // for (i, gammaPval) in enumerate(gammaP):
        for(var i = 1; i < (0, $fE59v.gammaP).length; ++i){
            // x += gammaPval / (z + i)
            var gammaPval = new Complex((0, $fE59v.gammaP)[i], 0);
            x = x.add(gammaPval.div(n.add(i)));
        }
        // t = z + gammaG + 0.5
        var t = new Complex(n.re + (0, $fE59v.gammaG) + 0.5, n.im);
        // y = sqrt(2 * pi) * t ** (z + 0.5) * exp(-t) * x
        var twoPiSqrt = Math.sqrt(2 * Math.PI);
        var tpow = t.pow(n.add(0.5));
        var expt = t.neg().exp();
        // y = [x] * [sqrt(2 * pi)] * [t ** (z + 0.5)] * [exp(-t)]
        return x.mul(twoPiSqrt).mul(tpow).mul(expt);
    }
    return typed($53dbd95bf496cd6d$var$name, {
        number: (0, $fE59v.gammaNumber),
        Complex: gammaComplex,
        BigNumber: function BigNumber(n) {
            if (n.isInteger()) return n.isNegative() || n.isZero() ? new _BigNumber(Infinity) : bigFactorial(n.minus(1));
            if (!n.isFinite()) return new _BigNumber(n.isNegative() ? NaN : Infinity);
            throw new Error('Integer BigNumber expected');
        }
    });
    /**
   * Calculate factorial for a BigNumber
   * @param {BigNumber} n
   * @returns {BigNumber} Returns the factorial of n
   */ function bigFactorial(n) {
        if (n < 8) return new _BigNumber([
            1,
            1,
            2,
            6,
            24,
            120,
            720,
            5040
        ][n]);
        var precision = config.precision + (Math.log(n.toNumber()) | 0);
        var Big = _BigNumber.clone({
            precision: precision
        });
        if (n % 2 === 1) return n.times(bigFactorial(new _BigNumber(n - 1)));
        var p = n;
        var prod = new Big(n);
        var sum = n.toNumber();
        while(p > 2){
            p -= 2;
            sum += p;
            prod = prod.times(sum);
        }
        return new _BigNumber(prod.toPrecision(_BigNumber.precision));
    }
});

});
parcelRegister("fE59v", function(module, exports) {

$parcel$export(module.exports, "gammaNumber", () => $b63e969c4a7065c9$export$da03a9f23c941fae);
$parcel$export(module.exports, "gammaP", () => $b63e969c4a7065c9$export$4ef5d09c80bf8d89);
$parcel$export(module.exports, "gammaG", () => $b63e969c4a7065c9$export$c1392abb9fefd3b6);
$parcel$export(module.exports, "lnSqrt2PI", () => $b63e969c4a7065c9$export$6854df5fcb691251);
$parcel$export(module.exports, "lgammaNumber", () => $b63e969c4a7065c9$export$a9c1cdc6d03f0efc);
/* eslint-disable no-loss-of-precision */ 
var $6NnhX = parcelRequire("6NnhX");

var $kfXQy = parcelRequire("kfXQy");
function $b63e969c4a7065c9$export$da03a9f23c941fae(n) {
    var x;
    if ((0, $6NnhX.isInteger)(n)) {
        if (n <= 0) return isFinite(n) ? Infinity : NaN;
        if (n > 171) return Infinity; // Will overflow
        return (0, $kfXQy.product)(1, n - 1);
    }
    if (n < 0.5) return Math.PI / (Math.sin(Math.PI * n) * $b63e969c4a7065c9$export$da03a9f23c941fae(1 - n));
    if (n >= 171.35) return Infinity; // will overflow
    if (n > 85.0) {
        // Extended Stirling Approx
        var twoN = n * n;
        var threeN = twoN * n;
        var fourN = threeN * n;
        var fiveN = fourN * n;
        return Math.sqrt(2 * Math.PI / n) * Math.pow(n / Math.E, n) * (1 + 1 / (12 * n) + 1 / (288 * twoN) - 139 / (51840 * threeN) - 571 / (2488320 * fourN) + 163879 / (209018880 * fiveN) + 5246819 / (75246796800 * fiveN * n));
    }
    --n;
    x = $b63e969c4a7065c9$export$4ef5d09c80bf8d89[0];
    for(var i = 1; i < $b63e969c4a7065c9$export$4ef5d09c80bf8d89.length; ++i)x += $b63e969c4a7065c9$export$4ef5d09c80bf8d89[i] / (n + i);
    var t = n + $b63e969c4a7065c9$export$c1392abb9fefd3b6 + 0.5;
    return Math.sqrt(2 * Math.PI) * Math.pow(t, n + 0.5) * Math.exp(-t) * x;
}
$b63e969c4a7065c9$export$da03a9f23c941fae.signature = 'number';
var $b63e969c4a7065c9$export$c1392abb9fefd3b6 = 4.7421875;
var $b63e969c4a7065c9$export$4ef5d09c80bf8d89 = [
    0.99999999999999709182,
    57.156235665862923517,
    -59.59796035547549,
    14.136097974741747174,
    -0.4919138160976202,
    0.33994649984811888699e-4,
    0.46523628927048575665e-4,
    -0.00009837447530487956,
    0.15808870322491248884e-3,
    -0.00021026444172410488,
    0.21743961811521264320e-3,
    -0.0001643181065367639,
    0.84418223983852743293e-4,
    -0.000026190838401581408,
    0.36899182659531622704e-5
];
var $b63e969c4a7065c9$export$6854df5fcb691251 = 0.91893853320467274178;
var $b63e969c4a7065c9$export$ec32a260632ccc98 = 5; // Lanczos parameter "g"
var $b63e969c4a7065c9$export$e1cadc5b48a02cef = 7; // Range of coefficients "n"
var $b63e969c4a7065c9$export$591d8f773e88a995 = [
    1.000000000190015,
    76.18009172947146,
    -86.50532032941678,
    24.01409824083091,
    -1.231739572450155,
    0.1208650973866179e-2,
    -0.000005395239384953
];
function $b63e969c4a7065c9$export$a9c1cdc6d03f0efc(n) {
    if (n < 0) return NaN;
    if (n === 0) return Infinity;
    if (!isFinite(n)) return n;
    if (n < 0.5) // Use Euler's reflection formula:
    // gamma(z) = PI / (sin(PI * z) * gamma(1 - z))
    return Math.log(Math.PI / Math.sin(Math.PI * n)) - $b63e969c4a7065c9$export$a9c1cdc6d03f0efc(1 - n);
    // Compute the logarithm of the Gamma function using the Lanczos method
    n = n - 1;
    var base = n + $b63e969c4a7065c9$export$ec32a260632ccc98 + 0.5; // Base of the Lanczos exponential
    var sum = $b63e969c4a7065c9$export$591d8f773e88a995[0];
    // We start with the terms that have the smallest coefficients and largest denominator
    for(var i = $b63e969c4a7065c9$export$e1cadc5b48a02cef - 1; i >= 1; i--)sum += $b63e969c4a7065c9$export$591d8f773e88a995[i] / (n + i);
    return $b63e969c4a7065c9$export$6854df5fcb691251 + (n + 0.5) * Math.log(base) - base + Math.log(sum);
}
$b63e969c4a7065c9$export$a9c1cdc6d03f0efc.signature = 'number';

});


parcelRegister("ikPQi", function(module, exports) {

$parcel$export(module.exports, "createGcd", () => $d5924f109a8d30c7$export$2eb8acc96c598512);

var $6NnhX = parcelRequire("6NnhX");

var $dsu7t = parcelRequire("dsu7t");

var $c6uf2 = parcelRequire("c6uf2");

var $ahu8B = parcelRequire("ahu8B");

var $ibvF5 = parcelRequire("ibvF5");

var $enjrI = parcelRequire("enjrI");

var $6SJnV = parcelRequire("6SJnV");

var $1tI8o = parcelRequire("1tI8o");
var $d5924f109a8d30c7$var$name = 'gcd';
var $d5924f109a8d30c7$var$dependencies = [
    'typed',
    'config',
    'round',
    'matrix',
    'equalScalar',
    'zeros',
    'BigNumber',
    'DenseMatrix',
    'concat'
];
var $d5924f109a8d30c7$var$gcdTypes = 'number | BigNumber | Fraction | Matrix | Array';
var $d5924f109a8d30c7$var$gcdManyTypesSignature = "".concat($d5924f109a8d30c7$var$gcdTypes, ", ").concat($d5924f109a8d30c7$var$gcdTypes, ", ...").concat($d5924f109a8d30c7$var$gcdTypes);
function $d5924f109a8d30c7$var$is1d(array) {
    return !array.some((element)=>Array.isArray(element));
}
var $d5924f109a8d30c7$export$2eb8acc96c598512 = /* #__PURE__ */ (0, $dsu7t.factory)($d5924f109a8d30c7$var$name, $d5924f109a8d30c7$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, config: config, round: round, equalScalar: equalScalar, zeros: zeros, BigNumber: BigNumber, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var mod = (0, $c6uf2.createMod)({
        typed: typed,
        config: config,
        round: round,
        matrix: matrix,
        equalScalar: equalScalar,
        zeros: zeros,
        DenseMatrix: DenseMatrix,
        concat: concat
    });
    var matAlgo01xDSid = (0, $ahu8B.createMatAlgo01xDSid)({
        typed: typed
    });
    var matAlgo04xSidSid = (0, $ibvF5.createMatAlgo04xSidSid)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo10xSids = (0, $enjrI.createMatAlgo10xSids)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Calculate the greatest common divisor for two or more values or arrays.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.gcd(a, b)
   *    math.gcd(a, b, c, ...)
   *
   * Examples:
   *
   *    math.gcd(8, 12)              // returns 4
   *    math.gcd(-4, 6)              // returns 2
   *    math.gcd(25, 15, -10)        // returns 5
   *
   *    math.gcd([8, -4], [12, 6])   // returns [4, 2]
   *
   * See also:
   *
   *    lcm, xgcd
   *
   * @param {... number | BigNumber | Fraction | Array | Matrix} args  Two or more integer numbers
   * @return {number | BigNumber | Fraction | Array | Matrix}                           The greatest common divisor
   */ return typed($d5924f109a8d30c7$var$name, {
        'number, number': _gcdNumber,
        'BigNumber, BigNumber': _gcdBigNumber,
        'Fraction, Fraction': (x, y)=>x.gcd(y)
    }, matrixAlgorithmSuite({
        SS: matAlgo04xSidSid,
        DS: matAlgo01xDSid,
        Ss: matAlgo10xSids
    }), {
        [$d5924f109a8d30c7$var$gcdManyTypesSignature]: typed.referToSelf((self)=>(a, b, args)=>{
                var res = self(a, b);
                for(var i = 0; i < args.length; i++)res = self(res, args[i]);
                return res;
            }),
        Array: typed.referToSelf((self)=>(array)=>{
                if (array.length === 1 && Array.isArray(array[0]) && $d5924f109a8d30c7$var$is1d(array[0])) return self(...array[0]);
                if ($d5924f109a8d30c7$var$is1d(array)) return self(...array);
                throw new (0, $1tI8o.ArgumentsError)('gcd() supports only 1d matrices!');
            }),
        Matrix: typed.referToSelf((self)=>(matrix)=>{
                return self(matrix.toArray());
            })
    });
    /**
  * Calculate gcd for numbers
  * @param {number} a
  * @param {number} b
  * @returns {number} Returns the greatest common denominator of a and b
  * @private
  */ function _gcdNumber(a, b) {
        if (!(0, $6NnhX.isInteger)(a) || !(0, $6NnhX.isInteger)(b)) throw new Error('Parameters in function gcd must be integer numbers');
        // https://en.wikipedia.org/wiki/Euclidean_algorithm
        var r;
        while(b !== 0){
            r = mod(a, b);
            a = b;
            b = r;
        }
        return a < 0 ? -a : a;
    }
    /**
   * Calculate gcd for BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @returns {BigNumber} Returns greatest common denominator of a and b
   * @private
   */ function _gcdBigNumber(a, b) {
        if (!a.isInt() || !b.isInt()) throw new Error('Parameters in function gcd must be integer numbers');
        // https://en.wikipedia.org/wiki/Euclidean_algorithm
        var zero = new BigNumber(0);
        while(!b.isZero()){
            var r = mod(a, b);
            a = b;
            b = r;
        }
        return a.lt(zero) ? a.neg() : a;
    }
});

});
parcelRegister("c6uf2", function(module, exports) {

$parcel$export(module.exports, "createMod", () => $8cfd80e7fc600a9e$export$735bb6c30160c058);

var $dsu7t = parcelRequire("dsu7t");

var $ajXgF = parcelRequire("ajXgF");

var $kycT3 = parcelRequire("kycT3");

var $a8bto = parcelRequire("a8bto");

var $g1nxb = parcelRequire("g1nxb");

var $52JKA = parcelRequire("52JKA");

var $19L2p = parcelRequire("19L2p");

var $6SJnV = parcelRequire("6SJnV");
var $8cfd80e7fc600a9e$var$name = 'mod';
var $8cfd80e7fc600a9e$var$dependencies = [
    'typed',
    'config',
    'round',
    'matrix',
    'equalScalar',
    'zeros',
    'DenseMatrix',
    'concat'
];
var $8cfd80e7fc600a9e$export$735bb6c30160c058 = /* #__PURE__ */ (0, $dsu7t.factory)($8cfd80e7fc600a9e$var$name, $8cfd80e7fc600a9e$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, round: round, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var floor = (0, $ajXgF.createFloor)({
        typed: typed,
        config: config,
        round: round,
        matrix: matrix,
        equalScalar: equalScalar,
        zeros: zeros,
        DenseMatrix: DenseMatrix
    });
    var matAlgo02xDS0 = (0, $kycT3.createMatAlgo02xDS0)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo03xDSf = (0, $a8bto.createMatAlgo03xDSf)({
        typed: typed
    });
    var matAlgo05xSfSf = (0, $g1nxb.createMatAlgo05xSfSf)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo11xS0s = (0, $52JKA.createMatAlgo11xS0s)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Calculates the modulus, the remainder of an integer division.
   *
   * For matrices, the function is evaluated element wise.
   *
   * The modulus is defined as:
   *
   *     x - y * floor(x / y)
   *
   * See https://en.wikipedia.org/wiki/Modulo_operation.
   *
   * Syntax:
   *
   *    math.mod(x, y)
   *
   * Examples:
   *
   *    math.mod(8, 3)                // returns 2
   *    math.mod(11, 2)               // returns 1
   *
   *    function isOdd(x) {
   *      return math.mod(x, 2) != 0
   *    }
   *
   *    isOdd(2)                      // returns false
   *    isOdd(3)                      // returns true
   *
   * See also:
   *
   *    divide
   *
   * @param  {number | BigNumber | bigint | Fraction | Array | Matrix} x Dividend
   * @param  {number | BigNumber | bigint | Fraction | Array | Matrix} y Divisor
   * @return {number | BigNumber | bigint | Fraction | Array | Matrix} Returns the remainder of `x` divided by `y`.
   */ return typed($8cfd80e7fc600a9e$var$name, {
        'number, number': _modNumber,
        'BigNumber, BigNumber': function BigNumber_BigNumber(x, y) {
            return y.isZero() ? x : x.sub(y.mul(floor(x.div(y))));
        },
        'bigint, bigint': function bigint_bigint(x, y) {
            if (y === 0n) return x;
            if (x < 0) {
                var m = x % y;
                return m === 0n ? m : m + y;
            }
            return x % y;
        },
        'Fraction, Fraction': function Fraction_Fraction(x, y) {
            return y.equals(0) ? x : x.sub(y.mul(floor(x.div(y))));
        }
    }, matrixAlgorithmSuite({
        SS: matAlgo05xSfSf,
        DS: matAlgo03xDSf,
        SD: matAlgo02xDS0,
        Ss: matAlgo11xS0s,
        sS: matAlgo12xSfs
    }));
    /**
  * Calculate the modulus of two numbers
  * @param {number} x
  * @param {number} y
  * @returns {number} res
  * @private
  */ function _modNumber(x, y) {
        // We don't use JavaScript's % operator here as this doesn't work
        // correctly for x < 0 and x === 0
        // see https://en.wikipedia.org/wiki/Modulo_operation
        // We use mathjs floor to handle errors associated with
        // precision float approximation
        return y === 0 ? x : x - y * floor(x / y);
    }
});

});

parcelRegister("1tI8o", function(module, exports) {

$parcel$export(module.exports, "ArgumentsError", () => $113abc0793e0e89a$export$f27c2c74ddc37d80);
/**
 * Create a syntax error with the message:
 *     'Wrong number of arguments in function <fn> (<count> provided, <min>-<max> expected)'
 * @param {string} fn     Function name
 * @param {number} count  Actual argument count
 * @param {number} min    Minimum required argument count
 * @param {number} [max]  Maximum required argument count
 * @extends Error
 */ function $113abc0793e0e89a$export$f27c2c74ddc37d80(fn, count, min, max) {
    if (!(this instanceof $113abc0793e0e89a$export$f27c2c74ddc37d80)) throw new SyntaxError('Constructor must be called with the new operator');
    this.fn = fn;
    this.count = count;
    this.min = min;
    this.max = max;
    this.message = 'Wrong number of arguments in function ' + fn + ' (' + count + ' provided, ' + min + (max !== undefined && max !== null ? '-' + max : '') + ' expected)';
    this.stack = new Error().stack;
}
$113abc0793e0e89a$export$f27c2c74ddc37d80.prototype = new Error();
$113abc0793e0e89a$export$f27c2c74ddc37d80.prototype.constructor = Error;
$113abc0793e0e89a$export$f27c2c74ddc37d80.prototype.name = 'ArgumentsError';
$113abc0793e0e89a$export$f27c2c74ddc37d80.prototype.isArgumentsError = true;

});


parcelRegister("lGDl3", function(module, exports) {

$parcel$export(module.exports, "createGetMatrixDataType", () => $fc9c090a2581949d$export$b83055c9a38abe3c);

var $dsu7t = parcelRequire("dsu7t");

var $d80Xp = parcelRequire("d80Xp");

var $edQYF = parcelRequire("edQYF");
var $fc9c090a2581949d$var$name = 'getMatrixDataType';
var $fc9c090a2581949d$var$dependencies = [
    'typed'
];
var $fc9c090a2581949d$export$b83055c9a38abe3c = /* #__PURE__ */ (0, $dsu7t.factory)($fc9c090a2581949d$var$name, $fc9c090a2581949d$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Find the data type of all elements in a matrix or array,
   * for example 'number' if all items are a number and 'Complex' if all values
   * are complex numbers.
   * If a matrix contains more than one data type, it will return 'mixed'.
   *
   * Syntax:
   *
   *    math.getMatrixDataType(x)
   *
   * Examples:
   *
   *    const x = [ [1, 2, 3], [4, 5, 6] ]
   *    const mixedX = [ [1, true], [2, 3] ]
   *    const fractionX = [ [math.fraction(1, 3)], [math.fraction(1, 3)] ]
   *    const unitX = [ [math.unit('5cm')], [math.unit('5cm')] ]
   *    const bigNumberX = [ [math.bignumber(1)], [math.bignumber(0)] ]
   *    const sparse = math.sparse(x)
   *    const dense = math.matrix(x)
   *    math.getMatrixDataType(x)   // returns 'number'
   *    math.getMatrixDataType(sparse)   // returns 'number'
   *    math.getMatrixDataType(dense)   // returns 'number'
   *    math.getMatrixDataType(mixedX) // returns 'mixed'
   *    math.getMatrixDataType(fractionX) // returns 'Fraction'
   *    math.getMatrixDataType(unitX) // returns 'Unit'
   *    math.getMatrixDataType(bigNumberX) // return 'BigNumber'
   *
   * See also:
   *  SparseMatrix, DenseMatrix
   *
   * @param {...Matrix | Array} x   The Matrix with values.
   *
   * @return {string} A string representation of the matrix type
   */ return typed($fc9c090a2581949d$var$name, {
        Array: function Array(x) {
            return (0, $d80Xp.getArrayDataType)(x, (0, $edQYF.typeOf));
        },
        Matrix: function Matrix(x) {
            return x.getDataType();
        }
    });
});

});

parcelRegister("cfvpF", function(module, exports) {

$parcel$export(module.exports, "createHasNumericValue", () => $8eaf40bbe31a42b7$export$acff9f91b891ace6);

var $dsu7t = parcelRequire("dsu7t");
var $8eaf40bbe31a42b7$var$name = 'hasNumericValue';
var $8eaf40bbe31a42b7$var$dependencies = [
    'typed',
    'isNumeric'
];
var $8eaf40bbe31a42b7$export$acff9f91b891ace6 = /* #__PURE__ */ (0, $dsu7t.factory)($8eaf40bbe31a42b7$var$name, $8eaf40bbe31a42b7$var$dependencies, (_ref)=>{
    var { typed: typed, isNumeric: isNumeric } = _ref;
    /**
   * Test whether a value is an numeric value.
   *
   * In case of a string, true is returned if the string contains a numeric value.
   *
   * Syntax:
   *
   *     math.hasNumericValue(x)
   *
   * Examples:
   *
   *    math.hasNumericValue(2)                     // returns true
   *    math.hasNumericValue('2')                   // returns true
   *    math.isNumeric('2')                         // returns false
   *    math.hasNumericValue(0)                     // returns true
   *    math.hasNumericValue(math.bignumber('500')) // returns true
   *    math.hasNumericValue(math.bigint('42'))     // returns true
   *    math.hasNumericValue(42n)                   // returns true
   *    math.hasNumericValue(math.fraction(4))      // returns true
   *    math.hasNumericValue(math.complex('2-4i'))  // returns false
   *    math.hasNumericValue(false)                 // returns true
   *    math.hasNumericValue([2.3, 'foo', false])   // returns [true, false, true]
   *
   * See also:
   *
   *    isZero, isPositive, isNegative, isInteger, isNumeric
   *
   * @param {*} x       Value to be tested
   * @return {boolean}  Returns true when `x` is a `number`, `BigNumber`,
   *                    `Fraction`, `Boolean`, or a `String` containing number. Returns false for other types.
   *                    Throws an error in case of unknown types.
   */ return typed($8eaf40bbe31a42b7$var$name, {
        boolean: ()=>true,
        string: function string(x) {
            return x.trim().length > 0 && !isNaN(Number(x));
        },
        any: function any(x) {
            return isNumeric(x);
        }
    });
});

});

parcelRegister("f0Knz", function(module, exports) {

$parcel$export(module.exports, "createHex", () => $aedad50543c09275$export$9cafd9970d25a17c);

var $dsu7t = parcelRequire("dsu7t");
var $aedad50543c09275$var$name = 'hex';
var $aedad50543c09275$var$dependencies = [
    'typed',
    'format'
];
var $aedad50543c09275$export$9cafd9970d25a17c = (0, $dsu7t.factory)($aedad50543c09275$var$name, $aedad50543c09275$var$dependencies, (_ref)=>{
    var { typed: typed, format: format } = _ref;
    return typed($aedad50543c09275$var$name, {
        'number | BigNumber': function number__BigNumber(n) {
            return format(n, {
                notation: 'hex'
            });
        },
        'number | BigNumber, number | BigNumber': function number__BigNumber_number__BigNumber(n, wordSize) {
            return format(n, {
                notation: 'hex',
                wordSize: wordSize
            });
        }
    });
});

});

parcelRegister("lFuZG", function(module, exports) {

$parcel$export(module.exports, "createHypot", () => $fc657807d513179a$export$87e3687740a09cb);

var $dsu7t = parcelRequire("dsu7t");

var $d80Xp = parcelRequire("d80Xp");

var $edQYF = parcelRequire("edQYF");
var $fc657807d513179a$var$name = 'hypot';
var $fc657807d513179a$var$dependencies = [
    'typed',
    'abs',
    'addScalar',
    'divideScalar',
    'multiplyScalar',
    'sqrt',
    'smaller',
    'isPositive'
];
var $fc657807d513179a$export$87e3687740a09cb = /* #__PURE__ */ (0, $dsu7t.factory)($fc657807d513179a$var$name, $fc657807d513179a$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, sqrt: sqrt, smaller: smaller, isPositive: isPositive } = _ref;
    /**
   * Calculate the hypotenuse of a list with values. The hypotenuse is defined as:
   *
   *     hypot(a, b, c, ...) = sqrt(a^2 + b^2 + c^2 + ...)
   *
   * For matrix input, the hypotenuse is calculated for all values in the matrix.
   *
   * Syntax:
   *
   *     math.hypot(a, b, ...)
   *     math.hypot([a, b, c, ...])
   *
   * Examples:
   *
   *     math.hypot(3, 4)      // 5
   *     math.hypot(3, 4, 5)   // 7.0710678118654755
   *     math.hypot([3, 4, 5]) // 7.0710678118654755
   *     math.hypot(-2)        // 2
   *
   * See also:
   *
   *     abs, norm
   *
   * @param {... number | BigNumber | Array | Matrix} args    A list with numeric values or an Array or Matrix.
   *                                                          Matrix and Array input is flattened and returns a
   *                                                          single number for the whole matrix.
   * @return {number | BigNumber} Returns the hypothenusa of the input values.
   */ return typed($fc657807d513179a$var$name, {
        '... number | BigNumber': _hypot,
        Array: _hypot,
        Matrix: (M)=>_hypot((0, $d80Xp.flatten)(M.toArray(), true))
    });
    /**
   * Calculate the hypotenuse for an Array with values
   * @param {Array.<number | BigNumber>} args
   * @return {number | BigNumber} Returns the result
   * @private
   */ function _hypot(args) {
        // code based on `hypot` from es6-shim:
        // https://github.com/paulmillr/es6-shim/blob/master/es6-shim.js#L1619-L1633
        var result = 0;
        var largest = 0;
        for(var i = 0; i < args.length; i++){
            if ((0, $edQYF.isComplex)(args[i])) throw new TypeError('Unexpected type of argument to hypot');
            var value = abs(args[i]);
            if (smaller(largest, value)) {
                result = multiplyScalar(result, multiplyScalar(divideScalar(largest, value), divideScalar(largest, value)));
                result = addScalar(result, 1);
                largest = value;
            } else result = addScalar(result, isPositive(value) ? multiplyScalar(divideScalar(value, largest), divideScalar(value, largest)) : value);
        }
        return multiplyScalar(largest, sqrt(result));
    }
});

});

parcelRegister("9miC1", function(module, exports) {

$parcel$export(module.exports, "createIdentity", () => $6d049b21c2e54a05$export$2eca89e9ac669625);

var $edQYF = parcelRequire("edQYF");

var $d80Xp = parcelRequire("d80Xp");

var $6NnhX = parcelRequire("6NnhX");

var $dsu7t = parcelRequire("dsu7t");
var $6d049b21c2e54a05$var$name = 'identity';
var $6d049b21c2e54a05$var$dependencies = [
    'typed',
    'config',
    'matrix',
    'BigNumber',
    'DenseMatrix',
    'SparseMatrix'
];
var $6d049b21c2e54a05$export$2eca89e9ac669625 = /* #__PURE__ */ (0, $dsu7t.factory)($6d049b21c2e54a05$var$name, $6d049b21c2e54a05$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a 2-dimensional identity matrix with size m x n or n x n.
   * The matrix has ones on the diagonal and zeros elsewhere.
   *
   * Syntax:
   *
   *    math.identity(n)
   *    math.identity(n, format)
   *    math.identity(m, n)
   *    math.identity(m, n, format)
   *    math.identity([m, n])
   *    math.identity([m, n], format)
   *
   * Examples:
   *
   *    math.identity(3)                    // returns [[1, 0, 0], [0, 1, 0], [0, 0, 1]]
   *    math.identity(3, 2)                 // returns [[1, 0], [0, 1], [0, 0]]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.identity(math.size(A))         // returns [[1, 0, 0], [0, 1, 0]]
   *
   * See also:
   *
   *    diag, ones, zeros, size, range
   *
   * @param {...number | Matrix | Array} size   The size for the matrix
   * @param {string} [format]                   The Matrix storage format
   *
   * @return {Matrix | Array | number} A matrix with ones on the diagonal.
   */ return typed($6d049b21c2e54a05$var$name, {
        '': function _() {
            return config.matrix === 'Matrix' ? matrix([]) : [];
        },
        string: function string(format) {
            return matrix(format);
        },
        'number | BigNumber': function number__BigNumber(rows) {
            return _identity(rows, rows, config.matrix === 'Matrix' ? 'dense' : undefined);
        },
        'number | BigNumber, string': function number__BigNumber_string(rows, format) {
            return _identity(rows, rows, format);
        },
        'number | BigNumber, number | BigNumber': function number__BigNumber_number__BigNumber(rows, cols) {
            return _identity(rows, cols, config.matrix === 'Matrix' ? 'dense' : undefined);
        },
        'number | BigNumber, number | BigNumber, string': function number__BigNumber_number__BigNumber_string(rows, cols, format) {
            return _identity(rows, cols, format);
        },
        Array: function Array(size) {
            return _identityVector(size);
        },
        'Array, string': function Array_string(size, format) {
            return _identityVector(size, format);
        },
        Matrix: function Matrix(size) {
            return _identityVector(size.valueOf(), size.storage());
        },
        'Matrix, string': function Matrix_string(size, format) {
            return _identityVector(size.valueOf(), format);
        }
    });
    function _identityVector(size, format) {
        switch(size.length){
            case 0:
                return format ? matrix(format) : [];
            case 1:
                return _identity(size[0], size[0], format);
            case 2:
                return _identity(size[0], size[1], format);
            default:
                throw new Error('Vector containing two values expected');
        }
    }
    /**
   * Create an identity matrix
   * @param {number | BigNumber} rows
   * @param {number | BigNumber} cols
   * @param {string} [format]
   * @returns {Matrix}
   * @private
   */ function _identity(rows, cols, format) {
        // BigNumber constructor with the right precision
        var Big = (0, $edQYF.isBigNumber)(rows) || (0, $edQYF.isBigNumber)(cols) ? BigNumber : null;
        if ((0, $edQYF.isBigNumber)(rows)) rows = rows.toNumber();
        if ((0, $edQYF.isBigNumber)(cols)) cols = cols.toNumber();
        if (!(0, $6NnhX.isInteger)(rows) || rows < 1) throw new Error('Parameters in function identity must be positive integers');
        if (!(0, $6NnhX.isInteger)(cols) || cols < 1) throw new Error('Parameters in function identity must be positive integers');
        var one = Big ? new BigNumber(1) : 1;
        var defaultValue = Big ? new Big(0) : 0;
        var size = [
            rows,
            cols
        ];
        // check we need to return a matrix
        if (format) {
            // create diagonal matrix (use optimized implementation for storage format)
            if (format === 'sparse') return SparseMatrix.diagonal(size, one, 0, defaultValue);
            if (format === 'dense') return DenseMatrix.diagonal(size, one, 0, defaultValue);
            throw new TypeError("Unknown matrix type \"".concat(format, "\""));
        }
        // create and resize array
        var res = (0, $d80Xp.resize)([], size, defaultValue);
        // fill in ones on the diagonal
        var minimum = rows < cols ? rows : cols;
        // fill diagonal
        for(var d = 0; d < minimum; d++)res[d][d] = one;
        return res;
    }
});

});

parcelRegister("cUfFC", function(module, exports) {

$parcel$export(module.exports, "createIfft", () => $9656dece307f23d6$export$fb893320704d694a);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");

var $edQYF = parcelRequire("edQYF");
var $9656dece307f23d6$var$name = 'ifft';
var $9656dece307f23d6$var$dependencies = [
    'typed',
    'fft',
    'dotDivide',
    'conj'
];
var $9656dece307f23d6$export$fb893320704d694a = /* #__PURE__ */ (0, $dsu7t.factory)($9656dece307f23d6$var$name, $9656dece307f23d6$var$dependencies, (_ref)=>{
    var { typed: typed, fft: fft, dotDivide: dotDivide, conj: conj } = _ref;
    /**
   * Calculate N-dimensional inverse Fourier transform
   *
   * Syntax:
   *
   *     math.ifft(arr)
   *
   * Examples:
   *
   *    math.ifft([[2, 2], [0, 0]]) // returns [[{re:1, im:0}, {re:0, im:0}], [{re:1, im:0}, {re:0, im:0}]]
   *
   * See Also:
   *
   *      fft
   *
   * @param {Array | Matrix} arr    An array or matrix
   * @return {Array | Matrix}       N-dimensional Fourier transformation of the array
   */ return typed($9656dece307f23d6$var$name, {
        'Array | Matrix': function Array__Matrix(arr) {
            var size = (0, $edQYF.isMatrix)(arr) ? arr.size() : (0, $d80Xp.arraySize)(arr);
            return dotDivide(conj(fft(conj(arr))), size.reduce((acc, curr)=>acc * curr, 1));
        }
    });
});

});

parcelRegister("6Fyp7", function(module, exports) {

$parcel$export(module.exports, "createIm", () => $4db14255b0b1ef3b$export$47dfdf308b91581);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");
var $4db14255b0b1ef3b$var$name = 'im';
var $4db14255b0b1ef3b$var$dependencies = [
    'typed'
];
var $4db14255b0b1ef3b$export$47dfdf308b91581 = /* #__PURE__ */ (0, $dsu7t.factory)($4db14255b0b1ef3b$var$name, $4db14255b0b1ef3b$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Get the imaginary part of a complex number.
   * For a complex number `a + bi`, the function returns `b`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.im(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 3)
   *    math.re(a)                     // returns number 2
   *    math.im(a)                     // returns number 3
   *
   *    math.re(math.complex('-5.2i')) // returns number -5.2
   *    math.re(math.complex(2.4))     // returns number 0
   *
   * See also:
   *
   *    re, conj, abs, arg
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The imaginary part of x
   */ return typed($4db14255b0b1ef3b$var$name, {
        number: ()=>0,
        'BigNumber | Fraction': (x)=>x.mul(0),
        Complex: (x)=>x.im,
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});

parcelRegister("lyohe", function(module, exports) {

$parcel$export(module.exports, "createImmutableDenseMatrixClass", () => $fb0f9ad8ac677ef5$export$49a565643b9ab608);

var $edQYF = parcelRequire("edQYF");

var $9v8q6 = parcelRequire("9v8q6");

var $dsu7t = parcelRequire("dsu7t");
var $fb0f9ad8ac677ef5$var$name = 'ImmutableDenseMatrix';
var $fb0f9ad8ac677ef5$var$dependencies = [
    'smaller',
    'DenseMatrix'
];
var $fb0f9ad8ac677ef5$export$49a565643b9ab608 = /* #__PURE__ */ (0, $dsu7t.factory)($fb0f9ad8ac677ef5$var$name, $fb0f9ad8ac677ef5$var$dependencies, (_ref)=>{
    var { smaller: smaller, DenseMatrix: DenseMatrix } = _ref;
    function ImmutableDenseMatrix(data, datatype) {
        if (!(this instanceof ImmutableDenseMatrix)) throw new SyntaxError('Constructor must be called with the new operator');
        if (datatype && !(0, $edQYF.isString)(datatype)) throw new Error('Invalid datatype: ' + datatype);
        if ((0, $edQYF.isMatrix)(data) || (0, $edQYF.isArray)(data)) {
            // use DenseMatrix implementation
            var matrix = new DenseMatrix(data, datatype);
            // internal structures
            this._data = matrix._data;
            this._size = matrix._size;
            this._datatype = matrix._datatype;
            this._min = null;
            this._max = null;
        } else if (data && (0, $edQYF.isArray)(data.data) && (0, $edQYF.isArray)(data.size)) {
            // initialize fields from JSON representation
            this._data = data.data;
            this._size = data.size;
            this._datatype = data.datatype;
            this._min = typeof data.min !== 'undefined' ? data.min : null;
            this._max = typeof data.max !== 'undefined' ? data.max : null;
        } else if (data) // unsupported type
        throw new TypeError('Unsupported type of data (' + (0, $edQYF.typeOf)(data) + ')');
        else {
            // nothing provided
            this._data = [];
            this._size = [
                0
            ];
            this._datatype = datatype;
            this._min = null;
            this._max = null;
        }
    }
    ImmutableDenseMatrix.prototype = new DenseMatrix();
    /**
   * Attach type information
   */ ImmutableDenseMatrix.prototype.type = 'ImmutableDenseMatrix';
    ImmutableDenseMatrix.prototype.isImmutableDenseMatrix = true;
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @param {Index} index
   * @param {Array | ImmutableDenseMatrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ ImmutableDenseMatrix.prototype.subset = function(index) {
        switch(arguments.length){
            case 1:
                // use base implementation
                var m = DenseMatrix.prototype.subset.call(this, index);
                // check result is a matrix
                if ((0, $edQYF.isMatrix)(m)) // return immutable matrix
                return new ImmutableDenseMatrix({
                    data: m._data,
                    size: m._size,
                    datatype: m._datatype
                });
                return m;
            // intentional fall through
            case 2:
            case 3:
                throw new Error('Cannot invoke set subset on an Immutable Matrix instance');
            default:
                throw new SyntaxError('Wrong number of arguments');
        }
    };
    /**
   * Replace a single element in the matrix.
   * @param {Number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {ImmutableDenseMatrix} self
   */ ImmutableDenseMatrix.prototype.set = function() {
        throw new Error('Cannot invoke set on an Immutable Matrix instance');
    };
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @param {Number[]} size           The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ ImmutableDenseMatrix.prototype.resize = function() {
        throw new Error('Cannot invoke resize on an Immutable Matrix instance');
    };
    /**
   * Disallows reshaping in favor of immutability.
   *
   * @throws {Error} Operation not allowed
   */ ImmutableDenseMatrix.prototype.reshape = function() {
        throw new Error('Cannot invoke reshape on an Immutable Matrix instance');
    };
    /**
   * Create a clone of the matrix
   * @return {ImmutableDenseMatrix} clone
   */ ImmutableDenseMatrix.prototype.clone = function() {
        return new ImmutableDenseMatrix({
            data: (0, $9v8q6.clone)(this._data),
            size: (0, $9v8q6.clone)(this._size),
            datatype: this._datatype
        });
    };
    /**
   * Get a JSON representation of the matrix
   * @returns {Object}
   */ ImmutableDenseMatrix.prototype.toJSON = function() {
        return {
            mathjs: 'ImmutableDenseMatrix',
            data: this._data,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Generate a matrix from a JSON object
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ImmutableDenseMatrix", data: [], size: []}`,
   *                       where mathjs is optional
   * @returns {ImmutableDenseMatrix}
   */ ImmutableDenseMatrix.fromJSON = function(json) {
        return new ImmutableDenseMatrix(json);
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @param {Number} i       Matrix row index 1
   * @param {Number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ ImmutableDenseMatrix.prototype.swapRows = function() {
        throw new Error('Cannot invoke swapRows on an Immutable Matrix instance');
    };
    /**
   * Calculate the minimum value in the set
   * @return {Number | undefined} min
   */ ImmutableDenseMatrix.prototype.min = function() {
        // check min has been calculated before
        if (this._min === null) {
            // minimum
            var m = null;
            // compute min
            this.forEach(function(v) {
                if (m === null || smaller(v, m)) m = v;
            });
            this._min = m !== null ? m : undefined;
        }
        return this._min;
    };
    /**
   * Calculate the maximum value in the set
   * @return {Number | undefined} max
   */ ImmutableDenseMatrix.prototype.max = function() {
        // check max has been calculated before
        if (this._max === null) {
            // maximum
            var m = null;
            // compute max
            this.forEach(function(v) {
                if (m === null || smaller(m, v)) m = v;
            });
            this._max = m !== null ? m : undefined;
        }
        return this._max;
    };
    return ImmutableDenseMatrix;
}, {
    isClass: true
});

});

parcelRegister("koapm", function(module, exports) {

$parcel$export(module.exports, "createIndex", () => $ed7e1f5d1ddff505$export$c6d108d7c8095f19);

var $edQYF = parcelRequire("edQYF");

var $dsu7t = parcelRequire("dsu7t");
var $ed7e1f5d1ddff505$var$name = 'index';
var $ed7e1f5d1ddff505$var$dependencies = [
    'typed',
    'Index'
];
var $ed7e1f5d1ddff505$export$c6d108d7c8095f19 = /* #__PURE__ */ (0, $dsu7t.factory)($ed7e1f5d1ddff505$var$name, $ed7e1f5d1ddff505$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index } = _ref;
    /**
   * Create an index. An Index can store ranges having start, step, and end
   * for multiple dimensions.
   * Matrix.get, Matrix.set, and math.subset accept an Index as input.
   *
   * Syntax:
   *
   *     math.index(range1, range2, ...)
   *
   * Where each range can be any of:
   *
   * - A number
   * - A string for getting/setting an object property
   * - An instance of `Range`
   * - A one-dimensional Array or a Matrix with numbers or booleans
   *
   * Indexes must be zero-based, integer numbers.
   *
   * Examples:
   *
   *    const b = [1, 2, 3, 4, 5]
   *    math.subset(b, math.index([1, 2, 3]))                         // returns [2, 3, 4]
   *    math.subset(b, math.index([false, true, true, true, false]))  // returns [2, 3, 4]
   *
   *    const a = math.matrix([[1, 2], [3, 4]])
   *    a.subset(math.index(0, 1))             // returns 2
   *    a.subset(math.index(0, [false, true])) // returns 2
   *
   * See also:
   *
   *    bignumber, boolean, complex, matrix, number, string, unit
   *
   * @param {...*} ranges   Zero or more ranges or numbers.
   * @return {Index}        Returns the created index
   */ return typed($ed7e1f5d1ddff505$var$name, {
        '...number | string | BigNumber | Range | Array | Matrix': function number__string__BigNumber__Range__Array__Matrix(args) {
            var ranges = args.map(function(arg) {
                if ((0, $edQYF.isBigNumber)(arg)) return arg.toNumber(); // convert BigNumber to Number
                else if ((0, $edQYF.isArray)(arg) || (0, $edQYF.isMatrix)(arg)) return arg.map(function(elem) {
                    // convert BigNumber to Number
                    return (0, $edQYF.isBigNumber)(elem) ? elem.toNumber() : elem;
                });
                else return arg;
            });
            var res = new Index();
            Index.apply(res, ranges);
            return res;
        }
    });
});

});

parcelRegister("oF4VA", function(module, exports) {

$parcel$export(module.exports, "createIndexClass", () => $04a21b562f50cd73$export$300720b4fe34e62e);

var $edQYF = parcelRequire("edQYF");

var $9v8q6 = parcelRequire("9v8q6");

var $6NnhX = parcelRequire("6NnhX");

var $dsu7t = parcelRequire("dsu7t");
var $04a21b562f50cd73$var$name = 'Index';
var $04a21b562f50cd73$var$dependencies = [
    'ImmutableDenseMatrix',
    'getMatrixDataType'
];
var $04a21b562f50cd73$export$300720b4fe34e62e = /* #__PURE__ */ (0, $dsu7t.factory)($04a21b562f50cd73$var$name, $04a21b562f50cd73$var$dependencies, (_ref)=>{
    var { ImmutableDenseMatrix: ImmutableDenseMatrix, getMatrixDataType: getMatrixDataType } = _ref;
    /**
   * Create an index. An Index can store ranges and sets for multiple dimensions.
   * Matrix.get, Matrix.set, and math.subset accept an Index as input.
   *
   * Usage:
   *     const index = new Index(range1, range2, matrix1, array1, ...)
   *
   * Where each parameter can be any of:
   *     A number
   *     A string (containing a name of an object property)
   *     An instance of Range
   *     An Array with the Set values
   *     An Array with Booleans
   *     A Matrix with the Set values
   *     A Matrix with Booleans
   *
   * The parameters start, end, and step must be integer numbers.
   *
   * @class Index
   * @Constructor Index
   * @param {...*} ranges
   */ function Index(ranges) {
        if (!(this instanceof Index)) throw new SyntaxError('Constructor must be called with the new operator');
        this._dimensions = [];
        this._sourceSize = [];
        this._isScalar = true;
        for(var i = 0, ii = arguments.length; i < ii; i++){
            var arg = arguments[i];
            var argIsArray = (0, $edQYF.isArray)(arg);
            var argIsMatrix = (0, $edQYF.isMatrix)(arg);
            var argType = typeof arg;
            var sourceSize = null;
            if ((0, $edQYF.isRange)(arg)) {
                this._dimensions.push(arg);
                this._isScalar = false;
            } else if (argIsArray || argIsMatrix) {
                // create matrix
                var m = void 0;
                if (getMatrixDataType(arg) === 'boolean') {
                    if (argIsArray) m = _createImmutableMatrix($04a21b562f50cd73$var$_booleansArrayToNumbersForIndex(arg).valueOf());
                    if (argIsMatrix) m = _createImmutableMatrix($04a21b562f50cd73$var$_booleansArrayToNumbersForIndex(arg._data).valueOf());
                    sourceSize = arg.valueOf().length;
                } else m = _createImmutableMatrix(arg.valueOf());
                this._dimensions.push(m);
                // size
                var size = m.size();
                // scalar
                if (size.length !== 1 || size[0] !== 1 || sourceSize !== null) this._isScalar = false;
            } else if (argType === 'number') this._dimensions.push(_createImmutableMatrix([
                arg
            ]));
            else if (argType === 'bigint') this._dimensions.push(_createImmutableMatrix([
                Number(arg)
            ]));
            else if (argType === 'string') // object property (arguments.count should be 1)
            this._dimensions.push(arg);
            else throw new TypeError('Dimension must be an Array, Matrix, number, bigint, string, or Range');
            this._sourceSize.push(sourceSize);
        // TODO: implement support for wildcard '*'
        }
    }
    /**
   * Attach type information
   */ Index.prototype.type = 'Index';
    Index.prototype.isIndex = true;
    function _createImmutableMatrix(arg) {
        // loop array elements
        for(var i = 0, l = arg.length; i < l; i++){
            if (typeof arg[i] !== 'number' || !(0, $6NnhX.isInteger)(arg[i])) throw new TypeError('Index parameters must be positive integer numbers');
        }
        // create matrix
        return new ImmutableDenseMatrix(arg);
    }
    /**
   * Create a clone of the index
   * @memberof Index
   * @return {Index} clone
   */ Index.prototype.clone = function() {
        var index = new Index();
        index._dimensions = (0, $9v8q6.clone)(this._dimensions);
        index._isScalar = this._isScalar;
        index._sourceSize = this._sourceSize;
        return index;
    };
    /**
   * Create an index from an array with ranges/numbers
   * @memberof Index
   * @param {Array.<Array | number>} ranges
   * @return {Index} index
   * @private
   */ Index.create = function(ranges) {
        var index = new Index();
        Index.apply(index, ranges);
        return index;
    };
    /**
   * Retrieve the size of the index, the number of elements for each dimension.
   * @memberof Index
   * @returns {number[]} size
   */ Index.prototype.size = function() {
        var size = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var d = this._dimensions[i];
            size[i] = typeof d === 'string' ? 1 : d.size()[0];
        }
        return size;
    };
    /**
   * Get the maximum value for each of the indexes ranges.
   * @memberof Index
   * @returns {number[]} max
   */ Index.prototype.max = function() {
        var values = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var range = this._dimensions[i];
            values[i] = typeof range === 'string' ? range : range.max();
        }
        return values;
    };
    /**
   * Get the minimum value for each of the indexes ranges.
   * @memberof Index
   * @returns {number[]} min
   */ Index.prototype.min = function() {
        var values = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var range = this._dimensions[i];
            values[i] = typeof range === 'string' ? range : range.min();
        }
        return values;
    };
    /**
   * Loop over each of the ranges of the index
   * @memberof Index
   * @param {Function} callback   Called for each range with a Range as first
   *                              argument, the dimension as second, and the
   *                              index object as third.
   */ Index.prototype.forEach = function(callback) {
        for(var i = 0, ii = this._dimensions.length; i < ii; i++)callback(this._dimensions[i], i, this);
    };
    /**
   * Retrieve the dimension for the given index
   * @memberof Index
   * @param {Number} dim                  Number of the dimension
   * @returns {Range | null} range
   */ Index.prototype.dimension = function(dim) {
        if (typeof dim !== 'number') return null;
        return this._dimensions[dim] || null;
    };
    /**
   * Test whether this index contains an object property
   * @returns {boolean} Returns true if the index is an object property
   */ Index.prototype.isObjectProperty = function() {
        return this._dimensions.length === 1 && typeof this._dimensions[0] === 'string';
    };
    /**
   * Returns the object property name when the Index holds a single object property,
   * else returns null
   * @returns {string | null}
   */ Index.prototype.getObjectProperty = function() {
        return this.isObjectProperty() ? this._dimensions[0] : null;
    };
    /**
   * Test whether this index contains only a single value.
   *
   * This is the case when the index is created with only scalar values as ranges,
   * not for ranges resolving into a single value.
   * @memberof Index
   * @return {boolean} isScalar
   */ Index.prototype.isScalar = function() {
        return this._isScalar;
    };
    /**
   * Expand the Index into an array.
   * For example new Index([0,3], [2,7]) returns [[0,1,2], [2,3,4,5,6]]
   * @memberof Index
   * @returns {Array} array
   */ Index.prototype.toArray = function() {
        var array = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var dimension = this._dimensions[i];
            array.push(typeof dimension === 'string' ? dimension : dimension.toArray());
        }
        return array;
    };
    /**
   * Get the primitive value of the Index, a two dimensional array.
   * Equivalent to Index.toArray().
   * @memberof Index
   * @returns {Array} array
   */ Index.prototype.valueOf = Index.prototype.toArray;
    /**
   * Get the string representation of the index, for example '[2:6]' or '[0:2:10, 4:7, [1,2,3]]'
   * @memberof Index
   * @returns {String} str
   */ Index.prototype.toString = function() {
        var strings = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var dimension = this._dimensions[i];
            if (typeof dimension === 'string') strings.push(JSON.stringify(dimension));
            else strings.push(dimension.toString());
        }
        return '[' + strings.join(', ') + ']';
    };
    /**
   * Get a JSON representation of the Index
   * @memberof Index
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Index", "ranges": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
   */ Index.prototype.toJSON = function() {
        return {
            mathjs: 'Index',
            dimensions: this._dimensions
        };
    };
    /**
   * Instantiate an Index from a JSON object
   * @memberof Index
   * @param {Object} json A JSON object structured as:
   *                     `{"mathjs": "Index", "dimensions": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
   * @return {Index}
   */ Index.fromJSON = function(json) {
        return Index.create(json.dimensions);
    };
    return Index;
}, {
    isClass: true
});
/**
 * Receives an array of booleans and returns an array of Numbers for Index
 * @param {Array} booleanArrayIndex An array of booleans
 * @return {Array} A set of numbers ready for index
 */ function $04a21b562f50cd73$var$_booleansArrayToNumbersForIndex(booleanArrayIndex) {
    // gets an array of booleans and returns an array of numbers
    var indexOfNumbers = [];
    booleanArrayIndex.forEach((bool, idx)=>{
        if (bool) indexOfNumbers.push(idx);
    });
    return indexOfNumbers;
}

});

parcelRegister("hqZT1", function(module, exports) {

$parcel$export(module.exports, "createIntersect", () => $cb14debf0dea05b0$export$e2d92d8f89fdd92d);

var $dsu7t = parcelRequire("dsu7t");
var $cb14debf0dea05b0$var$name = 'intersect';
var $cb14debf0dea05b0$var$dependencies = [
    'typed',
    'config',
    'abs',
    'add',
    'addScalar',
    'matrix',
    'multiply',
    'multiplyScalar',
    'divideScalar',
    'subtract',
    'smaller',
    'equalScalar',
    'flatten',
    'isZero',
    'isNumeric'
];
var $cb14debf0dea05b0$export$e2d92d8f89fdd92d = /* #__PURE__ */ (0, $dsu7t.factory)($cb14debf0dea05b0$var$name, $cb14debf0dea05b0$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, abs: abs, add: add, addScalar: addScalar, matrix: matrix, multiply: multiply, multiplyScalar: multiplyScalar, divideScalar: divideScalar, subtract: subtract, smaller: smaller, equalScalar: equalScalar, flatten: flatten, isZero: isZero, isNumeric: isNumeric } = _ref;
    /**
   * Calculates the point of intersection of two lines in two or three dimensions
   * and of a line and a plane in three dimensions. The inputs are in the form of
   * arrays or 1 dimensional matrices. The line intersection functions return null
   * if the lines do not meet.
   *
   * Note: Fill the plane coefficients as `x + y + z = c` and not as `x + y + z + c = 0`.
   *
   * Syntax:
   *
   *    math.intersect(endPoint1Line1, endPoint2Line1, endPoint1Line2, endPoint2Line2)
   *    math.intersect(endPoint1, endPoint2, planeCoefficients)
   *
   * Examples:
   *
   *    math.intersect([0, 0], [10, 10], [10, 0], [0, 10])              // Returns [5, 5]
   *    math.intersect([0, 0, 0], [10, 10, 0], [10, 0, 0], [0, 10, 0])  // Returns [5, 5, 0]
   *    math.intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])            // Returns [7, -4, 3]
   *
   * @param  {Array | Matrix} w   Co-ordinates of first end-point of first line
   * @param  {Array | Matrix} x   Co-ordinates of second end-point of first line
   * @param  {Array | Matrix} y   Co-ordinates of first end-point of second line
   *                              OR Co-efficients of the plane's equation
   * @param  {Array | Matrix} z   Co-ordinates of second end-point of second line
   *                              OR undefined if the calculation is for line and plane
   * @return {Array}              Returns the point of intersection of lines/lines-planes
   */ return typed('intersect', {
        'Array, Array, Array': _AAA,
        'Array, Array, Array, Array': _AAAA,
        'Matrix, Matrix, Matrix': function Matrix_Matrix_Matrix(x, y, plane) {
            var arr = _AAA(x.valueOf(), y.valueOf(), plane.valueOf());
            return arr === null ? null : matrix(arr);
        },
        'Matrix, Matrix, Matrix, Matrix': function Matrix_Matrix_Matrix_Matrix(w, x, y, z) {
            // TODO: output matrix type should match input matrix type
            var arr = _AAAA(w.valueOf(), x.valueOf(), y.valueOf(), z.valueOf());
            return arr === null ? null : matrix(arr);
        }
    });
    function _AAA(x, y, plane) {
        x = _coerceArr(x);
        y = _coerceArr(y);
        plane = _coerceArr(plane);
        if (!_3d(x)) throw new TypeError('Array with 3 numbers or BigNumbers expected for first argument');
        if (!_3d(y)) throw new TypeError('Array with 3 numbers or BigNumbers expected for second argument');
        if (!_4d(plane)) throw new TypeError('Array with 4 numbers expected as third argument');
        return _intersectLinePlane(x[0], x[1], x[2], y[0], y[1], y[2], plane[0], plane[1], plane[2], plane[3]);
    }
    function _AAAA(w, x, y, z) {
        w = _coerceArr(w);
        x = _coerceArr(x);
        y = _coerceArr(y);
        z = _coerceArr(z);
        if (w.length === 2) {
            if (!_2d(w)) throw new TypeError('Array with 2 numbers or BigNumbers expected for first argument');
            if (!_2d(x)) throw new TypeError('Array with 2 numbers or BigNumbers expected for second argument');
            if (!_2d(y)) throw new TypeError('Array with 2 numbers or BigNumbers expected for third argument');
            if (!_2d(z)) throw new TypeError('Array with 2 numbers or BigNumbers expected for fourth argument');
            return _intersect2d(w, x, y, z);
        } else if (w.length === 3) {
            if (!_3d(w)) throw new TypeError('Array with 3 numbers or BigNumbers expected for first argument');
            if (!_3d(x)) throw new TypeError('Array with 3 numbers or BigNumbers expected for second argument');
            if (!_3d(y)) throw new TypeError('Array with 3 numbers or BigNumbers expected for third argument');
            if (!_3d(z)) throw new TypeError('Array with 3 numbers or BigNumbers expected for fourth argument');
            return _intersect3d(w[0], w[1], w[2], x[0], x[1], x[2], y[0], y[1], y[2], z[0], z[1], z[2]);
        } else throw new TypeError('Arrays with two or thee dimensional points expected');
    }
    /** Coerce row and column 2-dim arrays to 1-dim array */ function _coerceArr(arr) {
        // row matrix
        if (arr.length === 1) return arr[0];
        // column matrix
        if (arr.length > 1 && Array.isArray(arr[0])) {
            if (arr.every((el)=>Array.isArray(el) && el.length === 1)) return flatten(arr);
        }
        return arr;
    }
    function _2d(x) {
        return x.length === 2 && isNumeric(x[0]) && isNumeric(x[1]);
    }
    function _3d(x) {
        return x.length === 3 && isNumeric(x[0]) && isNumeric(x[1]) && isNumeric(x[2]);
    }
    function _4d(x) {
        return x.length === 4 && isNumeric(x[0]) && isNumeric(x[1]) && isNumeric(x[2]) && isNumeric(x[3]);
    }
    function _intersect2d(p1a, p1b, p2a, p2b) {
        var o1 = p1a;
        var o2 = p2a;
        var d1 = subtract(o1, p1b);
        var d2 = subtract(o2, p2b);
        var det = subtract(multiplyScalar(d1[0], d2[1]), multiplyScalar(d2[0], d1[1]));
        if (isZero(det)) return null;
        if (smaller(abs(det), config.relTol)) return null;
        var d20o11 = multiplyScalar(d2[0], o1[1]);
        var d21o10 = multiplyScalar(d2[1], o1[0]);
        var d20o21 = multiplyScalar(d2[0], o2[1]);
        var d21o20 = multiplyScalar(d2[1], o2[0]);
        var t = divideScalar(addScalar(subtract(subtract(d20o11, d21o10), d20o21), d21o20), det);
        return add(multiply(d1, t), o1);
    }
    function _intersect3dHelper(a, b, c, d, e, f, g, h, i, j, k, l) {
        // (a - b)*(c - d) + (e - f)*(g - h) + (i - j)*(k - l)
        var add1 = multiplyScalar(subtract(a, b), subtract(c, d));
        var add2 = multiplyScalar(subtract(e, f), subtract(g, h));
        var add3 = multiplyScalar(subtract(i, j), subtract(k, l));
        return addScalar(addScalar(add1, add2), add3);
    }
    function _intersect3d(x1, y1, z1, x2, y2, z2, x3, y3, z3, x4, y4, z4) {
        var d1343 = _intersect3dHelper(x1, x3, x4, x3, y1, y3, y4, y3, z1, z3, z4, z3);
        var d4321 = _intersect3dHelper(x4, x3, x2, x1, y4, y3, y2, y1, z4, z3, z2, z1);
        var d1321 = _intersect3dHelper(x1, x3, x2, x1, y1, y3, y2, y1, z1, z3, z2, z1);
        var d4343 = _intersect3dHelper(x4, x3, x4, x3, y4, y3, y4, y3, z4, z3, z4, z3);
        var d2121 = _intersect3dHelper(x2, x1, x2, x1, y2, y1, y2, y1, z2, z1, z2, z1);
        var numerator = subtract(multiplyScalar(d1343, d4321), multiplyScalar(d1321, d4343));
        var denominator = subtract(multiplyScalar(d2121, d4343), multiplyScalar(d4321, d4321));
        if (isZero(denominator)) return null;
        var ta = divideScalar(numerator, denominator);
        var tb = divideScalar(addScalar(d1343, multiplyScalar(ta, d4321)), d4343);
        var pax = addScalar(x1, multiplyScalar(ta, subtract(x2, x1)));
        var pay = addScalar(y1, multiplyScalar(ta, subtract(y2, y1)));
        var paz = addScalar(z1, multiplyScalar(ta, subtract(z2, z1)));
        var pbx = addScalar(x3, multiplyScalar(tb, subtract(x4, x3)));
        var pby = addScalar(y3, multiplyScalar(tb, subtract(y4, y3)));
        var pbz = addScalar(z3, multiplyScalar(tb, subtract(z4, z3)));
        if (equalScalar(pax, pbx) && equalScalar(pay, pby) && equalScalar(paz, pbz)) return [
            pax,
            pay,
            paz
        ];
        else return null;
    }
    function _intersectLinePlane(x1, y1, z1, x2, y2, z2, x, y, z, c) {
        var x1x = multiplyScalar(x1, x);
        var x2x = multiplyScalar(x2, x);
        var y1y = multiplyScalar(y1, y);
        var y2y = multiplyScalar(y2, y);
        var z1z = multiplyScalar(z1, z);
        var z2z = multiplyScalar(z2, z);
        var numerator = subtract(subtract(subtract(c, x1x), y1y), z1z);
        var denominator = subtract(subtract(subtract(addScalar(addScalar(x2x, y2y), z2z), x1x), y1y), z1z);
        var t = divideScalar(numerator, denominator);
        var px = addScalar(x1, multiplyScalar(t, subtract(x2, x1)));
        var py = addScalar(y1, multiplyScalar(t, subtract(y2, y1)));
        var pz = addScalar(z1, multiplyScalar(t, subtract(z2, z1)));
        return [
            px,
            py,
            pz
        ];
    // TODO: Add cases when line is parallel to the plane:
    //       (a) no intersection,
    //       (b) line contained in plane
    }
});

});

parcelRegister("eTWlp", function(module, exports) {

$parcel$export(module.exports, "createInv", () => $ad9375b1214a39b7$export$ad9771ef9eafe06a);

var $edQYF = parcelRequire("edQYF");

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");

var $j2hDb = parcelRequire("j2hDb");
var $ad9375b1214a39b7$var$name = 'inv';
var $ad9375b1214a39b7$var$dependencies = [
    'typed',
    'matrix',
    'divideScalar',
    'addScalar',
    'multiply',
    'unaryMinus',
    'det',
    'identity',
    'abs'
];
var $ad9375b1214a39b7$export$ad9771ef9eafe06a = /* #__PURE__ */ (0, $dsu7t.factory)($ad9375b1214a39b7$var$name, $ad9375b1214a39b7$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, addScalar: addScalar, multiply: multiply, unaryMinus: unaryMinus, det: det, identity: identity, abs: abs } = _ref;
    /**
   * Calculate the inverse of a square matrix.
   *
   * Syntax:
   *
   *     math.inv(x)
   *
   * Examples:
   *
   *     math.inv([[1, 2], [3, 4]])  // returns [[-2, 1], [1.5, -0.5]]
   *     math.inv(4)                 // returns 0.25
   *     1 / 4                       // returns 0.25
   *
   * See also:
   *
   *     det, transpose
   *
   * @param {number | Complex | Array | Matrix} x     Matrix to be inversed
   * @return {number | Complex | Array | Matrix} The inverse of `x`.
   */ return typed($ad9375b1214a39b7$var$name, {
        'Array | Matrix': function Array__Matrix(x) {
            var size = (0, $edQYF.isMatrix)(x) ? x.size() : (0, $d80Xp.arraySize)(x);
            switch(size.length){
                case 1:
                    // vector
                    if (size[0] === 1) {
                        if ((0, $edQYF.isMatrix)(x)) return matrix([
                            divideScalar(1, x.valueOf()[0])
                        ]);
                        else return [
                            divideScalar(1, x[0])
                        ];
                    } else throw new RangeError("Matrix must be square (size: " + (0, $j2hDb.format)(size) + ')');
                case 2:
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) {
                        if ((0, $edQYF.isMatrix)(x)) return matrix(_inv(x.valueOf(), rows, cols), x.storage());
                        else // return an Array
                        return _inv(x, rows, cols);
                    } else throw new RangeError("Matrix must be square (size: " + (0, $j2hDb.format)(size) + ')');
                default:
                    // multi dimensional array
                    throw new RangeError("Matrix must be two dimensional (size: " + (0, $j2hDb.format)(size) + ')');
            }
        },
        any: function any(x) {
            // scalar
            return divideScalar(1, x); // FIXME: create a BigNumber one when configured for bignumbers
        }
    });
    /**
   * Calculate the inverse of a square matrix
   * @param {Array[]} mat     A square matrix
   * @param {number} rows     Number of rows
   * @param {number} cols     Number of columns, must equal rows
   * @return {Array[]} inv    Inverse matrix
   * @private
   */ function _inv(mat, rows, cols) {
        var r, s, f, value, temp;
        if (rows === 1) {
            // this is a 1 x 1 matrix
            value = mat[0][0];
            if (value === 0) throw Error('Cannot calculate inverse, determinant is zero');
            return [
                [
                    divideScalar(1, value)
                ]
            ];
        } else if (rows === 2) {
            // this is a 2 x 2 matrix
            var d = det(mat);
            if (d === 0) throw Error('Cannot calculate inverse, determinant is zero');
            return [
                [
                    divideScalar(mat[1][1], d),
                    divideScalar(unaryMinus(mat[0][1]), d)
                ],
                [
                    divideScalar(unaryMinus(mat[1][0]), d),
                    divideScalar(mat[0][0], d)
                ]
            ];
        } else {
            // this is a matrix of 3 x 3 or larger
            // calculate inverse using gauss-jordan elimination
            //      https://en.wikipedia.org/wiki/Gaussian_elimination
            //      http://mathworld.wolfram.com/MatrixInverse.html
            //      http://math.uww.edu/~mcfarlat/inverse.htm
            // make a copy of the matrix (only the arrays, not of the elements)
            var A = mat.concat();
            for(r = 0; r < rows; r++)A[r] = A[r].concat();
            // create an identity matrix which in the end will contain the
            // matrix inverse
            var B = identity(rows).valueOf();
            // loop over all columns, and perform row reductions
            for(var c = 0; c < cols; c++){
                // Pivoting: Swap row c with row r, where row r contains the largest element A[r][c]
                var ABig = abs(A[c][c]);
                var rBig = c;
                r = c + 1;
                while(r < rows){
                    if (abs(A[r][c]) > ABig) {
                        ABig = abs(A[r][c]);
                        rBig = r;
                    }
                    r++;
                }
                if (ABig === 0) throw Error('Cannot calculate inverse, determinant is zero');
                r = rBig;
                if (r !== c) {
                    temp = A[c];
                    A[c] = A[r];
                    A[r] = temp;
                    temp = B[c];
                    B[c] = B[r];
                    B[r] = temp;
                }
                // eliminate non-zero values on the other rows at column c
                var Ac = A[c];
                var Bc = B[c];
                for(r = 0; r < rows; r++){
                    var Ar = A[r];
                    var Br = B[r];
                    if (r !== c) // eliminate value at column c and row r
                    {
                        if (Ar[c] !== 0) {
                            f = divideScalar(unaryMinus(Ar[c]), Ac[c]);
                            // add (f * row c) to row r to eliminate the value
                            // at column c
                            for(s = c; s < cols; s++)Ar[s] = addScalar(Ar[s], multiply(f, Ac[s]));
                            for(s = 0; s < cols; s++)Br[s] = addScalar(Br[s], multiply(f, Bc[s]));
                        }
                    } else {
                        // normalize value at Acc to 1,
                        // divide each value on row r with the value at Acc
                        f = Ac[c];
                        for(s = c; s < cols; s++)Ar[s] = divideScalar(Ar[s], f);
                        for(s = 0; s < cols; s++)Br[s] = divideScalar(Br[s], f);
                    }
                }
            }
            return B;
        }
    }
});

});

parcelRegister("dbSwX", function(module, exports) {

$parcel$export(module.exports, "createInvmod", () => $99a69a15970eb404$export$1e04c9355dadf1c8);

var $dsu7t = parcelRequire("dsu7t");
var $99a69a15970eb404$var$name = 'invmod';
var $99a69a15970eb404$var$dependencies = [
    'typed',
    'config',
    'BigNumber',
    'xgcd',
    'equal',
    'smaller',
    'mod',
    'add',
    'isInteger'
];
var $99a69a15970eb404$export$1e04c9355dadf1c8 = /* #__PURE__ */ (0, $dsu7t.factory)($99a69a15970eb404$var$name, $99a69a15970eb404$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, BigNumber: BigNumber, xgcd: xgcd, equal: equal, smaller: smaller, mod: mod, add: add, isInteger: isInteger } = _ref;
    /**
   * Calculate the (modular) multiplicative inverse of a modulo b. Solution to the equation `ax ≣ 1 (mod b)`
   * See https://en.wikipedia.org/wiki/Modular_multiplicative_inverse.
   *
   * Syntax:
   *
   *    math.invmod(a, b)
   *
   * Examples:
   *
   *    math.invmod(8, 12)             // returns NaN
   *    math.invmod(7, 13)             // returns 2
   *    math.invmod(15151, 15122)      // returns 10429
   *
   * See also:
   *
   *    gcd, xgcd
   *
   * @param {number | BigNumber} a  An integer number
   * @param {number | BigNumber} b  An integer number
   * @return {number | BigNumber }  Returns an integer number
   *                              where `invmod(a,b)*a ≣ 1 (mod b)`
   */ return typed($99a69a15970eb404$var$name, {
        'number, number': invmod,
        'BigNumber, BigNumber': invmod
    });
    function invmod(a, b) {
        if (!isInteger(a) || !isInteger(b)) throw new Error('Parameters in function invmod must be integer numbers');
        a = mod(a, b);
        if (equal(b, 0)) throw new Error('Divisor must be non zero');
        var res = xgcd(a, b);
        res = res.valueOf();
        var [gcd, inv] = res;
        if (!equal(gcd, BigNumber(1))) return NaN;
        inv = mod(inv, b);
        if (smaller(inv, BigNumber(0))) inv = add(inv, b);
        return inv;
    }
});

});

parcelRegister("5Cgkm", function(module, exports) {

$parcel$export(module.exports, "createIsInteger", () => $416d2a9e923d7fdc$export$766996d075d5608a);

var $20mkw = parcelRequire("20mkw");

var $6NnhX = parcelRequire("6NnhX");

var $dsu7t = parcelRequire("dsu7t");
var $416d2a9e923d7fdc$var$name = 'isInteger';
var $416d2a9e923d7fdc$var$dependencies = [
    'typed'
];
var $416d2a9e923d7fdc$export$766996d075d5608a = /* #__PURE__ */ (0, $dsu7t.factory)($416d2a9e923d7fdc$var$name, $416d2a9e923d7fdc$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is an integer number.
   * The function supports `number`, `BigNumber`, and `Fraction`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isInteger(x)
   *
   * Examples:
   *
   *    math.isInteger(2)                     // returns true
   *    math.isInteger(0)                     // returns true
   *    math.isInteger(0.5)                   // returns false
   *    math.isInteger(math.bignumber(500))   // returns true
   *    math.isInteger(math.fraction(4))      // returns true
   *    math.isInteger('3')                   // returns true
   *    math.isInteger([3, 0.5, -2])          // returns [true, false, true]
   *    math.isInteger(math.complex('2-4i'))  // throws TypeError
   *
   * See also:
   *
   *    isNumeric, isPositive, isNegative, isZero
   *
   * @param {number | BigNumber | bigint | Fraction | Array | Matrix} x   Value to be tested
   * @return {boolean}  Returns true when `x` contains a numeric, integer value.
   *                    Throws an error in case of an unknown data type.
   */ return typed($416d2a9e923d7fdc$var$name, {
        number: (0, $6NnhX.isInteger),
        // TODO: what to do with isInteger(add(0.1, 0.2))  ?
        BigNumber: function BigNumber(x) {
            return x.isInt();
        },
        bigint: function bigint(x) {
            return true;
        },
        Fraction: function Fraction(x) {
            return x.d === 1n;
        },
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});

parcelRegister("grleJ", function(module, exports) {

$parcel$export(module.exports, "createIsNaN", () => $bf7fa41f13c208b9$export$f85085363cf09711);

var $20mkw = parcelRequire("20mkw");

var $dsu7t = parcelRequire("dsu7t");

var $auVCP = parcelRequire("auVCP");
var $bf7fa41f13c208b9$var$name = 'isNaN';
var $bf7fa41f13c208b9$var$dependencies = [
    'typed'
];
var $bf7fa41f13c208b9$export$f85085363cf09711 = /* #__PURE__ */ (0, $dsu7t.factory)($bf7fa41f13c208b9$var$name, $bf7fa41f13c208b9$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is NaN (not a number).
   * The function supports types `number`, `BigNumber`, `Fraction`, `Unit` and `Complex`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNaN(x)
   *
   * Examples:
   *
   *    math.isNaN(3)                     // returns false
   *    math.isNaN(NaN)                   // returns true
   *    math.isNaN(0)                     // returns false
   *    math.isNaN(math.bignumber(NaN))   // returns true
   *    math.isNaN(math.bignumber(0))     // returns false
   *    math.isNaN(math.fraction(-2, 5))  // returns false
   *    math.isNaN('-2')                  // returns false
   *    math.isNaN([2, 0, -3, NaN])       // returns [false, false, false, true]
   *
   * See also:
   *
   *    isNumeric, isNegative, isPositive, isZero, isInteger
   *
   * @param {number | BigNumber | bigint | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is NaN.
   *                    Throws an error in case of an unknown data type.
   */ return typed($bf7fa41f13c208b9$var$name, {
        number: (0, $auVCP.isNaNNumber),
        BigNumber: function BigNumber(x) {
            return x.isNaN();
        },
        bigint: function bigint(x) {
            return false;
        },
        Fraction: function Fraction(x) {
            return false;
        },
        Complex: function Complex(x) {
            return x.isNaN();
        },
        Unit: function Unit(x) {
            return Number.isNaN(x.value);
        },
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});
parcelRegister("auVCP", function(module, exports) {

$parcel$export(module.exports, "isNegativeNumber", () => $7a4967e45043411f$export$6dbd64961904ec9a);
$parcel$export(module.exports, "isPositiveNumber", () => $7a4967e45043411f$export$5374bb854d0e41c8);
$parcel$export(module.exports, "isNaNNumber", () => $7a4967e45043411f$export$9fd08d8371c55110);

var $6NnhX = parcelRequire("6NnhX");
var $7a4967e45043411f$var$n1 = 'number';
function $7a4967e45043411f$export$312381923ba56895(x) {
    return (0, $6NnhX.isInteger)(x);
}
$7a4967e45043411f$export$312381923ba56895.signature = $7a4967e45043411f$var$n1;
function $7a4967e45043411f$export$6dbd64961904ec9a(x) {
    return x < 0;
}
$7a4967e45043411f$export$6dbd64961904ec9a.signature = $7a4967e45043411f$var$n1;
function $7a4967e45043411f$export$5374bb854d0e41c8(x) {
    return x > 0;
}
$7a4967e45043411f$export$5374bb854d0e41c8.signature = $7a4967e45043411f$var$n1;
function $7a4967e45043411f$export$83fb4ed1cc9804a(x) {
    return x === 0;
}
$7a4967e45043411f$export$83fb4ed1cc9804a.signature = $7a4967e45043411f$var$n1;
function $7a4967e45043411f$export$9fd08d8371c55110(x) {
    return Number.isNaN(x);
}
$7a4967e45043411f$export$9fd08d8371c55110.signature = $7a4967e45043411f$var$n1;

});


parcelRegister("9euwE", function(module, exports) {

$parcel$export(module.exports, "createIsNegative", () => $6b8d19a1289405a5$export$159ccd8c63e17c58);

var $20mkw = parcelRequire("20mkw");

var $dsu7t = parcelRequire("dsu7t");

var $auVCP = parcelRequire("auVCP");

var $i7dfO = parcelRequire("i7dfO");

var $6NnhX = parcelRequire("6NnhX");
var $6b8d19a1289405a5$var$name = 'isNegative';
var $6b8d19a1289405a5$var$dependencies = [
    'typed',
    'config'
];
var $6b8d19a1289405a5$export$159ccd8c63e17c58 = /* #__PURE__ */ (0, $dsu7t.factory)($6b8d19a1289405a5$var$name, $6b8d19a1289405a5$var$dependencies, (_ref)=>{
    var { typed: typed, config: config } = _ref;
    /**
   * Test whether a value is negative: smaller than zero.
   * The function supports types `number`, `BigNumber`, `Fraction`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNegative(x)
   *
   * Examples:
   *
   *    math.isNegative(3)                     // returns false
   *    math.isNegative(-2)                    // returns true
   *    math.isNegative(0)                     // returns false
   *    math.isNegative(-0)                    // returns false
   *    math.isNegative(math.bignumber(2))     // returns false
   *    math.isNegative(math.fraction(-2, 5))  // returns true
   *    math.isNegative('-2')                  // returns true
   *    math.isNegative([2, 0, -3])            // returns [false, false, true]
   *
   * See also:
   *
   *    isNumeric, isPositive, isZero, isInteger
   *
   * @param {number | BigNumber | bigint | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($6b8d19a1289405a5$var$name, {
        number: (x)=>(0, $6NnhX.nearlyEqual)(x, 0, config.relTol, config.absTol) ? false : (0, $auVCP.isNegativeNumber)(x),
        BigNumber: (x)=>(0, $i7dfO.nearlyEqual)(x, new x.constructor(0), config.relTol, config.absTol) ? false : x.isNeg() && !x.isZero() && !x.isNaN(),
        bigint: (x)=>x < 0n,
        Fraction: (x)=>x.s < 0n,
        // It's enough to decide on the sign
        Unit: typed.referToSelf((self)=>(x)=>typed.find(self, x.valueType())(x.value)),
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});

parcelRegister("gAq4N", function(module, exports) {

$parcel$export(module.exports, "createIsNumeric", () => $c1343c5dbd69dd91$export$85b0631fa122b7f1);

var $20mkw = parcelRequire("20mkw");

var $dsu7t = parcelRequire("dsu7t");
var $c1343c5dbd69dd91$var$name = 'isNumeric';
var $c1343c5dbd69dd91$var$dependencies = [
    'typed'
];
var $c1343c5dbd69dd91$export$85b0631fa122b7f1 = /* #__PURE__ */ (0, $dsu7t.factory)($c1343c5dbd69dd91$var$name, $c1343c5dbd69dd91$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is an numeric value.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNumeric(x)
   *
   * Examples:
   *
   *    math.isNumeric(2)                     // returns true
   *    math.isNumeric('2')                   // returns false
   *    math.hasNumericValue('2')             // returns true
   *    math.isNumeric(0)                     // returns true
   *    math.isNumeric(math.bignumber('42'))  // returns true
   *    math.isNumeric(math.bigint('42'))     // returns true
   *    math.isNumeric(math.fraction(4))      // returns true
   *    math.isNumeric(math.complex('2-4i'))  // returns false
   *    math.isNumeric([2.3, 'foo', false])   // returns [true, false, true]
   *
   * See also:
   *
   *    isZero, isPositive, isNegative, isInteger, hasNumericValue
   *
   * @param {*} x       Value to be tested
   * @return {boolean}  Returns true when `x` is a `number`, `BigNumber`,
   *                    `Fraction`, or `boolean`. Returns false for other types.
   *                    Throws an error in case of unknown types.
   */ return typed($c1343c5dbd69dd91$var$name, {
        'number | BigNumber | bigint | Fraction | boolean': ()=>true,
        'Complex | Unit | string | null | undefined | Node': ()=>false,
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});

parcelRegister("4Be3K", function(module, exports) {

$parcel$export(module.exports, "createIsPositive", () => $3595860f4d982410$export$2d862c12fb537dd9);

var $20mkw = parcelRequire("20mkw");

var $dsu7t = parcelRequire("dsu7t");

var $auVCP = parcelRequire("auVCP");

var $i7dfO = parcelRequire("i7dfO");

var $6NnhX = parcelRequire("6NnhX");
var $3595860f4d982410$var$name = 'isPositive';
var $3595860f4d982410$var$dependencies = [
    'typed',
    'config'
];
var $3595860f4d982410$export$2d862c12fb537dd9 = /* #__PURE__ */ (0, $dsu7t.factory)($3595860f4d982410$var$name, $3595860f4d982410$var$dependencies, (_ref)=>{
    var { typed: typed, config: config } = _ref;
    /**
   * Test whether a value is positive: larger than zero.
   * The function supports types `number`, `BigNumber`, `Fraction`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isPositive(x)
   *
   * Examples:
   *
   *    math.isPositive(3)                     // returns true
   *    math.isPositive(-2)                    // returns false
   *    math.isPositive(0)                     // returns false
   *    math.isPositive(-0)                    // returns false
   *    math.isPositive(0.5)                   // returns true
   *    math.isPositive(math.bignumber(2))     // returns true
   *    math.isPositive(math.fraction(-2, 5))  // returns false
   *    math.isPositive(math.fraction(1, 3))   // returns true
   *    math.isPositive('2')                   // returns true
   *    math.isPositive([2, 0, -3])            // returns [true, false, false]
   *
   * See also:
   *
   *    isNumeric, isZero, isNegative, isInteger
   *
   * @param {number | BigNumber | bigint | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($3595860f4d982410$var$name, {
        number: (x)=>(0, $6NnhX.nearlyEqual)(x, 0, config.relTol, config.absTol) ? false : (0, $auVCP.isPositiveNumber)(x),
        BigNumber: (x)=>(0, $i7dfO.nearlyEqual)(x, new x.constructor(0), config.relTol, config.absTol) ? false : !x.isNeg() && !x.isZero() && !x.isNaN(),
        bigint: (x)=>x > 0n,
        Fraction: (x)=>x.s > 0n && x.n > 0n,
        Unit: typed.referToSelf((self)=>(x)=>typed.find(self, x.valueType())(x.value)),
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});

parcelRegister("gSK9t", function(module, exports) {

$parcel$export(module.exports, "createIsPrime", () => $c4a57d4ae93d2f49$export$4e02350f5fb7a050);

var $20mkw = parcelRequire("20mkw");

var $dsu7t = parcelRequire("dsu7t");
var $c4a57d4ae93d2f49$var$name = 'isPrime';
var $c4a57d4ae93d2f49$var$dependencies = [
    'typed'
];
var $c4a57d4ae93d2f49$export$4e02350f5fb7a050 = /* #__PURE__ */ (0, $dsu7t.factory)($c4a57d4ae93d2f49$var$name, $c4a57d4ae93d2f49$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is prime: has no divisors other than itself and one.
   * The function supports type `number`, `bignumber`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isPrime(x)
   *
   * Examples:
   *
   *    math.isPrime(3)                     // returns true
   *    math.isPrime(-2)                    // returns false
   *    math.isPrime(0)                     // returns false
   *    math.isPrime(-0)                    // returns false
   *    math.isPrime(0.5)                   // returns false
   *    math.isPrime('2')                   // returns true
   *    math.isPrime([2, 17, 100])           // returns [true, true, false]
   *
   * See also:
   *
   *    isNumeric, isZero, isNegative, isInteger
   *
   * @param {number | BigNumber | bigint | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($c4a57d4ae93d2f49$var$name, {
        number: function number(x) {
            if (x <= 3) return x > 1;
            if (x % 2 === 0 || x % 3 === 0) return false;
            for(var i = 5; i * i <= x; i += 6){
                if (x % i === 0 || x % (i + 2) === 0) return false;
            }
            return true;
        },
        bigint: function bigint(x) {
            if (x <= 3n) return x > 1n;
            if (x % 2n === 0n || x % 3n === 0n) return false;
            for(var i = 5n; i * i <= x; i += 6n){
                if (x % i === 0n || x % (i + 2n) === 0n) return false;
            }
            return true;
        },
        BigNumber: function BigNumber(n) {
            if (n.lte(3)) return n.gt(1);
            if (n.mod(2).eq(0) || n.mod(3).eq(0)) return false;
            if (n.lt(Math.pow(2, 32))) {
                var x = n.toNumber();
                for(var i = 5; i * i <= x; i += 6){
                    if (x % i === 0 || x % (i + 2) === 0) return false;
                }
                return true;
            }
            function modPow(base, exponent, modulus) {
                // exponent can be huge, use non-recursive variant
                var accumulator = 1;
                while(!exponent.eq(0))if (exponent.mod(2).eq(0)) {
                    exponent = exponent.div(2);
                    base = base.mul(base).mod(modulus);
                } else {
                    exponent = exponent.sub(1);
                    accumulator = base.mul(accumulator).mod(modulus);
                }
                return accumulator;
            }
            // https://en.wikipedia.org/wiki/Miller%E2%80%93Rabin_primality_test#Deterministic_variants
            var Decimal = n.constructor.clone({
                precision: n.toFixed(0).length * 2
            });
            n = new Decimal(n);
            var r = 0;
            var d = n.sub(1);
            while(d.mod(2).eq(0)){
                d = d.div(2);
                r += 1;
            }
            var bases = null;
            // https://en.wikipedia.org/wiki/Miller–Rabin_primality_test#Testing_against_small_sets_of_bases
            if (n.lt('3317044064679887385961981')) bases = [
                2,
                3,
                5,
                7,
                11,
                13,
                17,
                19,
                23,
                29,
                31,
                37,
                41
            ].filter((x)=>x < n);
            else {
                var max = Math.min(n.toNumber() - 2, Math.floor(2 * Math.pow(n.toFixed(0).length * Math.log(10), 2)));
                bases = [];
                for(var _i = 2; _i <= max; _i += 1)bases.push(max);
            }
            for(var _i2 = 0; _i2 < bases.length; _i2 += 1){
                var a = bases[_i2];
                var adn = modPow(n.sub(n).add(a), d, n);
                if (!adn.eq(1)) for(var _i3 = 0, _x = adn; !_x.eq(n.sub(1)); _i3 += 1, _x = _x.mul(_x).mod(n)){
                    if (_i3 === r - 1) return false;
                }
            }
            return true;
        },
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});

parcelRegister("5Wtra", function(module, exports) {

$parcel$export(module.exports, "createIsZero", () => $4539342693d076fc$export$ea90652d00dab06e);

var $20mkw = parcelRequire("20mkw");

var $dsu7t = parcelRequire("dsu7t");
var $4539342693d076fc$var$name = 'isZero';
var $4539342693d076fc$var$dependencies = [
    'typed',
    'equalScalar'
];
var $4539342693d076fc$export$ea90652d00dab06e = /* #__PURE__ */ (0, $dsu7t.factory)($4539342693d076fc$var$name, $4539342693d076fc$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Test whether a value is zero.
   * The function can check for zero for types `number`, `BigNumber`, `Fraction`,
   * `Complex`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isZero(x)
   *
   * Examples:
   *
   *    math.isZero(0)                      // returns true
   *    math.isZero(2)                      // returns false
   *    math.isZero(0.5)                    // returns false
   *    math.isZero(math.bignumber(0))      // returns true
   *    math.isZero(math.fraction(0))       // returns true
   *    math.isZero(math.fraction(1,3))     // returns false
   *    math.isZero(math.complex('2 - 4i')) // returns false
   *    math.isZero(math.complex('0i'))     // returns true
   *    math.isZero('0')                    // returns true
   *    math.isZero('2')                    // returns false
   *    math.isZero([2, 0, -3])             // returns [false, true, false]
   *
   * See also:
   *
   *    isNumeric, isPositive, isNegative, isInteger
   *
   * @param {number | BigNumber | bigint | Complex | Fraction | Unit | Array | Matrix} x       Value to be tested
   * @return {boolean}  Returns true when `x` is zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($4539342693d076fc$var$name, {
        'number | BigNumber | Complex | Fraction': (x)=>equalScalar(x, 0),
        bigint: (x)=>x === 0n,
        Unit: typed.referToSelf((self)=>(x)=>typed.find(self, x.valueType())(x.value)),
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});

parcelRegister("5Q7md", function(module, exports) {

$parcel$export(module.exports, "createKldivergence", () => $4407841828d1b106$export$eaa5cb8fd86b8d43);

var $dsu7t = parcelRequire("dsu7t");
var $4407841828d1b106$var$name = 'kldivergence';
var $4407841828d1b106$var$dependencies = [
    'typed',
    'matrix',
    'divide',
    'sum',
    'multiply',
    'map',
    'dotDivide',
    'log',
    'isNumeric'
];
var $4407841828d1b106$export$eaa5cb8fd86b8d43 = /* #__PURE__ */ (0, $dsu7t.factory)($4407841828d1b106$var$name, $4407841828d1b106$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divide: divide, sum: sum, multiply: multiply, map: map, dotDivide: dotDivide, log: log, isNumeric: isNumeric } = _ref;
    /**
     * Calculate the Kullback-Leibler (KL) divergence  between two distributions
     *
     * Syntax:
     *
     *     math.kldivergence(x, y)
     *
     * Examples:
     *
     *     math.kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])   //returns 0.24376698773121153
     *
     *
     * @param  {Array | Matrix} q    First vector
     * @param  {Array | Matrix} p    Second vector
     * @return {number}              Returns distance between q and p
     */ return typed($4407841828d1b106$var$name, {
        'Array, Array': function Array_Array(q, p) {
            return _kldiv(matrix(q), matrix(p));
        },
        'Matrix, Array': function Matrix_Array(q, p) {
            return _kldiv(q, matrix(p));
        },
        'Array, Matrix': function Array_Matrix(q, p) {
            return _kldiv(matrix(q), p);
        },
        'Matrix, Matrix': function Matrix_Matrix(q, p) {
            return _kldiv(q, p);
        }
    });
    function _kldiv(q, p) {
        var plength = p.size().length;
        var qlength = q.size().length;
        if (plength > 1) throw new Error('first object must be one dimensional');
        if (qlength > 1) throw new Error('second object must be one dimensional');
        if (plength !== qlength) throw new Error('Length of two vectors must be equal');
        // Before calculation, apply normalization
        var sumq = sum(q);
        if (sumq === 0) throw new Error('Sum of elements in first object must be non zero');
        var sump = sum(p);
        if (sump === 0) throw new Error('Sum of elements in second object must be non zero');
        var qnorm = divide(q, sum(q));
        var pnorm = divide(p, sum(p));
        var result = sum(multiply(qnorm, map(dotDivide(qnorm, pnorm), (x)=>log(x))));
        if (isNumeric(result)) return result;
        else return Number.NaN;
    }
});

});

parcelRegister("5S0bI", function(module, exports) {

$parcel$export(module.exports, "createKron", () => $44622439eb2a8386$export$cee275bf38ddc295);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $44622439eb2a8386$var$name = 'kron';
var $44622439eb2a8386$var$dependencies = [
    'typed',
    'matrix',
    'multiplyScalar'
];
var $44622439eb2a8386$export$cee275bf38ddc295 = /* #__PURE__ */ (0, $dsu7t.factory)($44622439eb2a8386$var$name, $44622439eb2a8386$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, multiplyScalar: multiplyScalar } = _ref;
    /**
     * Calculates the Kronecker product of 2 matrices or vectors.
     *
     * NOTE: If a one dimensional vector / matrix is given, it will be
     * wrapped so its two dimensions.
     * See the examples.
     *
     * Syntax:
     *
     *    math.kron(x, y)
     *
     * Examples:
     *
     *    math.kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])
     *    // returns [ [ 1, 2, 0, 0 ], [ 3, 4, 0, 0 ], [ 0, 0, 1, 2 ], [ 0, 0, 3, 4 ] ]
     *
     *    math.kron([1,1], [2,3,4])
     *    // returns [ [ 2, 3, 4, 2, 3, 4 ] ]
     *
     * See also:
     *
     *    multiply, dot, cross
     *
     * @param  {Array | Matrix} x     First vector
     * @param  {Array | Matrix} y     Second vector
     * @return {Array | Matrix}       Returns the Kronecker product of `x` and `y`
     */ return typed($44622439eb2a8386$var$name, {
        'Matrix, Matrix': function Matrix_Matrix(x, y) {
            return matrix(_kron(x.toArray(), y.toArray()));
        },
        'Matrix, Array': function Matrix_Array(x, y) {
            return matrix(_kron(x.toArray(), y));
        },
        'Array, Matrix': function Array_Matrix(x, y) {
            return matrix(_kron(x, y.toArray()));
        },
        'Array, Array': _kron
    });
    /**
     * Calculate the Kronecker product of two matrices / vectors
     * @param {Array} a  First vector
     * @param {Array} b  Second vector
     * @returns {Array} Returns the Kronecker product of x and y
     * @private
     */ function _kron(a, b) {
        // Deal with the dimensions of the matricies.
        if ((0, $d80Xp.arraySize)(a).length === 1) // Wrap it in a 2D Matrix
        a = [
            a
        ];
        if ((0, $d80Xp.arraySize)(b).length === 1) // Wrap it in a 2D Matrix
        b = [
            b
        ];
        if ((0, $d80Xp.arraySize)(a).length > 2 || (0, $d80Xp.arraySize)(b).length > 2) throw new RangeError("Vectors with dimensions greater then 2 are not supported expected (Size x = " + JSON.stringify(a.length) + ', y = ' + JSON.stringify(b.length) + ')');
        var t = [];
        var r = [];
        return a.map(function(a) {
            return b.map(function(b) {
                r = [];
                t.push(r);
                return a.map(function(y) {
                    return b.map(function(x) {
                        return r.push(multiplyScalar(y, x));
                    });
                });
            });
        }) && t;
    }
});

});

parcelRegister("3guGi", function(module, exports) {

$parcel$export(module.exports, "createLarger", () => $260aaa5a89c73a9a$export$af9bc16ae70e9aa8);

var $i7dfO = parcelRequire("i7dfO");

var $6NnhX = parcelRequire("6NnhX");

var $dsu7t = parcelRequire("dsu7t");

var $a8bto = parcelRequire("a8bto");

var $6RFQP = parcelRequire("6RFQP");

var $19L2p = parcelRequire("19L2p");

var $6SJnV = parcelRequire("6SJnV");

var $33RBM = parcelRequire("33RBM");
var $260aaa5a89c73a9a$var$name = 'larger';
var $260aaa5a89c73a9a$var$dependencies = [
    'typed',
    'config',
    'bignumber',
    'matrix',
    'DenseMatrix',
    'concat',
    'SparseMatrix'
];
var $260aaa5a89c73a9a$export$af9bc16ae70e9aa8 = /* #__PURE__ */ (0, $dsu7t.factory)($260aaa5a89c73a9a$var$name, $260aaa5a89c73a9a$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, bignumber: bignumber, matrix: matrix, DenseMatrix: DenseMatrix, concat: concat, SparseMatrix: SparseMatrix } = _ref;
    var matAlgo03xDSf = (0, $a8bto.createMatAlgo03xDSf)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $6RFQP.createMatAlgo07xSSf)({
        typed: typed,
        SparseMatrix: SparseMatrix
    });
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var compareUnits = (0, $33RBM.createCompareUnits)({
        typed: typed
    });
    /**
   * Test whether value x is larger than y.
   *
   * The function returns true when x is larger than y and the relative
   * difference between x and y is larger than the configured relTol and absTol. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.larger(x, y)
   *
   * Examples:
   *
   *    math.larger(2, 3)             // returns false
   *    math.larger(5, 2 + 2)         // returns true
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('2 inch')
   *    math.larger(a, b)             // returns false
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, largerEq, compare
   *
   * @param  {number | BigNumber | bigint | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | bigint | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is larger than y, else returns false
   */ function bignumLarger(x, y) {
        return x.gt(y) && !(0, $i7dfO.nearlyEqual)(x, y, config.relTol, config.absTol);
    }
    return typed($260aaa5a89c73a9a$var$name, $260aaa5a89c73a9a$export$36e0507f86788708({
        typed: typed,
        config: config
    }), {
        'boolean, boolean': (x, y)=>x > y,
        'BigNumber, BigNumber': bignumLarger,
        'bigint, bigint': (x, y)=>x > y,
        'Fraction, Fraction': (x, y)=>x.compare(y) === 1,
        'Fraction, BigNumber': function Fraction_BigNumber(x, y) {
            return bignumLarger(bignumber(x), y);
        },
        'BigNumber, Fraction': function BigNumber_Fraction(x, y) {
            return bignumLarger(x, bignumber(y));
        },
        'Complex, Complex': function Complex_Complex() {
            throw new TypeError('No ordering relation is defined for complex numbers');
        }
    }, compareUnits, matrixAlgorithmSuite({
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
});
var $260aaa5a89c73a9a$export$36e0507f86788708 = /* #__PURE__ */ (0, $dsu7t.factory)($260aaa5a89c73a9a$var$name, [
    'typed',
    'config'
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($260aaa5a89c73a9a$var$name, {
        'number, number': function number_number(x, y) {
            return x > y && !(0, $6NnhX.nearlyEqual)(x, y, config.relTol, config.absTol);
        }
    });
});

});

parcelRegister("2hOpX", function(module, exports) {

$parcel$export(module.exports, "createLargerEq", () => $1aa4472d740dcbd4$export$26aa7f5b5fee1150);

var $i7dfO = parcelRequire("i7dfO");

var $6NnhX = parcelRequire("6NnhX");

var $dsu7t = parcelRequire("dsu7t");

var $a8bto = parcelRequire("a8bto");

var $6RFQP = parcelRequire("6RFQP");

var $19L2p = parcelRequire("19L2p");

var $6SJnV = parcelRequire("6SJnV");

var $33RBM = parcelRequire("33RBM");
var $1aa4472d740dcbd4$var$name = 'largerEq';
var $1aa4472d740dcbd4$var$dependencies = [
    'typed',
    'config',
    'matrix',
    'DenseMatrix',
    'concat',
    'SparseMatrix'
];
var $1aa4472d740dcbd4$export$26aa7f5b5fee1150 = /* #__PURE__ */ (0, $dsu7t.factory)($1aa4472d740dcbd4$var$name, $1aa4472d740dcbd4$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, DenseMatrix: DenseMatrix, concat: concat, SparseMatrix: SparseMatrix } = _ref;
    var matAlgo03xDSf = (0, $a8bto.createMatAlgo03xDSf)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $6RFQP.createMatAlgo07xSSf)({
        typed: typed,
        SparseMatrix: SparseMatrix
    });
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var compareUnits = (0, $33RBM.createCompareUnits)({
        typed: typed
    });
    /**
   * Test whether value x is larger or equal to y.
   *
   * The function returns true when x is larger than y or the relative
   * difference between x and y is smaller than the configured relTol and absTol. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.largerEq(x, y)
   *
   * Examples:
   *
   *    math.larger(2, 1 + 1)         // returns false
   *    math.largerEq(2, 1 + 1)       // returns true
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, larger, compare
   *
   * @param  {number | BigNumber | bigint | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | bigint | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is larger or equal to y, else returns false
   */ return typed($1aa4472d740dcbd4$var$name, $1aa4472d740dcbd4$export$494ed93834104475({
        typed: typed,
        config: config
    }), {
        'boolean, boolean': (x, y)=>x >= y,
        'BigNumber, BigNumber': function BigNumber_BigNumber(x, y) {
            return x.gte(y) || (0, $i7dfO.nearlyEqual)(x, y, config.relTol, config.absTol);
        },
        'bigint, bigint': function bigint_bigint(x, y) {
            return x >= y;
        },
        'Fraction, Fraction': (x, y)=>x.compare(y) !== -1,
        'Complex, Complex': function Complex_Complex() {
            throw new TypeError('No ordering relation is defined for complex numbers');
        }
    }, compareUnits, matrixAlgorithmSuite({
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
});
var $1aa4472d740dcbd4$export$494ed93834104475 = /* #__PURE__ */ (0, $dsu7t.factory)($1aa4472d740dcbd4$var$name, [
    'typed',
    'config'
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($1aa4472d740dcbd4$var$name, {
        'number, number': function number_number(x, y) {
            return x >= y || (0, $6NnhX.nearlyEqual)(x, y, config.relTol, config.absTol);
        }
    });
});

});

parcelRegister("6vrDt", function(module, exports) {

$parcel$export(module.exports, "createLcm", () => $4bcb1337d77e4405$export$5d3af1956d9bb33b);

var $dsu7t = parcelRequire("dsu7t");

var $kycT3 = parcelRequire("kycT3");

var $hF01R = parcelRequire("hF01R");

var $52JKA = parcelRequire("52JKA");

var $6SJnV = parcelRequire("6SJnV");

var $dmcGu = parcelRequire("dmcGu");
var $4bcb1337d77e4405$var$name = 'lcm';
var $4bcb1337d77e4405$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'concat'
];
var $4bcb1337d77e4405$export$5d3af1956d9bb33b = /* #__PURE__ */ (0, $dsu7t.factory)($4bcb1337d77e4405$var$name, $4bcb1337d77e4405$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, concat: concat } = _ref;
    var matAlgo02xDS0 = (0, $kycT3.createMatAlgo02xDS0)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo06xS0S0 = (0, $hF01R.createMatAlgo06xS0S0)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo11xS0s = (0, $52JKA.createMatAlgo11xS0s)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var lcmTypes = 'number | BigNumber | Fraction | Matrix | Array';
    var lcmManySignature = {};
    lcmManySignature["".concat(lcmTypes, ", ").concat(lcmTypes, ", ...").concat(lcmTypes)] = typed.referToSelf((self)=>(a, b, args)=>{
            var res = self(a, b);
            for(var i = 0; i < args.length; i++)res = self(res, args[i]);
            return res;
        });
    /**
   * Calculate the least common multiple for two or more values or arrays.
   *
   * lcm is defined as:
   *
   *     lcm(a, b) = abs(a * b) / gcd(a, b)
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.lcm(a, b)
   *    math.lcm(a, b, c, ...)
   *
   * Examples:
   *
   *    math.lcm(4, 6)               // returns 12
   *    math.lcm(6, 21)              // returns 42
   *    math.lcm(6, 21, 5)           // returns 210
   *
   *    math.lcm([4, 6], [6, 21])    // returns [12, 42]
   *
   * See also:
   *
   *    gcd, xgcd
   *
   * @param {... number | BigNumber | Array | Matrix} args  Two or more integer numbers
   * @return {number | BigNumber | Array | Matrix}                           The least common multiple
   */ return typed($4bcb1337d77e4405$var$name, {
        'number, number': (0, $dmcGu.lcmNumber),
        'BigNumber, BigNumber': _lcmBigNumber,
        'Fraction, Fraction': (x, y)=>x.lcm(y)
    }, matrixAlgorithmSuite({
        SS: matAlgo06xS0S0,
        DS: matAlgo02xDS0,
        Ss: matAlgo11xS0s
    }), lcmManySignature);
    /**
   * Calculate lcm for two BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @returns {BigNumber} Returns the least common multiple of a and b
   * @private
   */ function _lcmBigNumber(a, b) {
        if (!a.isInt() || !b.isInt()) throw new Error('Parameters in function lcm must be integer numbers');
        if (a.isZero()) return a;
        if (b.isZero()) return b;
        // https://en.wikipedia.org/wiki/Euclidean_algorithm
        // evaluate lcm here inline to reduce overhead
        var prod = a.times(b);
        while(!b.isZero()){
            var t = b;
            b = a.mod(t);
            a = t;
        }
        return prod.div(a).abs();
    }
});

});

parcelRegister("95PTL", function(module, exports) {

$parcel$export(module.exports, "createLeftShift", () => $69ecd69d43e594cd$export$ce15600b23f5e78);

var $kycT3 = parcelRequire("kycT3");

var $52JKA = parcelRequire("52JKA");

var $dK2sh = parcelRequire("dK2sh");

var $ahu8B = parcelRequire("ahu8B");

var $enjrI = parcelRequire("enjrI");

var $jLQxN = parcelRequire("jLQxN");

var $dsu7t = parcelRequire("dsu7t");

var $6SJnV = parcelRequire("6SJnV");

var $1Z19h = parcelRequire("1Z19h");

var $jbibQ = parcelRequire("jbibQ");

var $2704b = parcelRequire("2704b");
var $69ecd69d43e594cd$var$name = 'leftShift';
var $69ecd69d43e594cd$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'zeros',
    'DenseMatrix',
    'concat'
];
var $69ecd69d43e594cd$export$ce15600b23f5e78 = /* #__PURE__ */ (0, $dsu7t.factory)($69ecd69d43e594cd$var$name, $69ecd69d43e594cd$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo01xDSid = (0, $ahu8B.createMatAlgo01xDSid)({
        typed: typed
    });
    var matAlgo02xDS0 = (0, $kycT3.createMatAlgo02xDS0)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo08xS0Sid = (0, $jLQxN.createMatAlgo08xS0Sid)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo10xSids = (0, $enjrI.createMatAlgo10xSids)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo11xS0s = (0, $52JKA.createMatAlgo11xS0s)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo14xDs = (0, $dK2sh.createMatAlgo14xDs)({
        typed: typed
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var useMatrixForArrayScalar = (0, $1Z19h.createUseMatrixForArrayScalar)({
        typed: typed,
        matrix: matrix
    });
    /**
   * Bitwise left logical shift of a value x by y number of bits, `x << y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.leftShift(x, y)
   *
   * Examples:
   *
   *    math.leftShift(1, 2)               // returns number 4
   *
   *    math.leftShift([1, 2, 4], 4)       // returns Array [16, 32, 64]
   *
   * See also:
   *
   *    leftShift, bitNot, bitOr, bitXor, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | bigint | Array | Matrix} x Value to be shifted
   * @param  {number | BigNumber | bigint} y Amount of shifts
   * @return {number | BigNumber | bigint | Array | Matrix} `x` shifted left `y` times
   */ return typed($69ecd69d43e594cd$var$name, {
        'number, number': (0, $jbibQ.leftShiftNumber),
        'BigNumber, BigNumber': (0, $2704b.leftShiftBigNumber),
        'bigint, bigint': (x, y)=>x << y,
        'SparseMatrix, number | BigNumber': typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(y, 0)) return x.clone();
                return matAlgo11xS0s(x, y, self, false);
            }),
        'DenseMatrix, number | BigNumber': typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(y, 0)) return x.clone();
                return matAlgo14xDs(x, y, self, false);
            }),
        'number | BigNumber, SparseMatrix': typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
                return matAlgo10xSids(y, x, self, true);
            }),
        'number | BigNumber, DenseMatrix': typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
                return matAlgo14xDs(y, x, self, true);
            })
    }, useMatrixForArrayScalar, matrixAlgorithmSuite({
        SS: matAlgo08xS0Sid,
        DS: matAlgo01xDSid,
        SD: matAlgo02xDS0
    }));
});

});
parcelRegister("jLQxN", function(module, exports) {

$parcel$export(module.exports, "createMatAlgo08xS0Sid", () => $e64b2a431a91cc48$export$704047d0f247b5d8);

var $dsu7t = parcelRequire("dsu7t");

var $7asMt = parcelRequire("7asMt");
var $e64b2a431a91cc48$var$name = 'matAlgo08xS0Sid';
var $e64b2a431a91cc48$var$dependencies = [
    'typed',
    'equalScalar'
];
var $e64b2a431a91cc48$export$704047d0f247b5d8 = /* #__PURE__ */ (0, $dsu7t.factory)($e64b2a431a91cc48$var$name, $e64b2a431a91cc48$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0 && B(i,j) === 0
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function matAlgo08xS0Sid(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype || a._data === undefined ? a._datatype : a.getDataType();
        // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype || b._data === undefined ? b._datatype : b.getDataType();
        // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $7asMt.DimensionError)(asize.length, bsize.length);
        // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
        // sparse matrix cannot be a Pattern matrix
        if (!avalues || !bvalues) throw new Error('Cannot perform operation on Pattern Sparse Matrices');
        // rows & columns
        var rows = asize[0];
        var columns = asize[1];
        // datatype
        var dt;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // callback signature to use
        var cf = callback;
        // process data types
        if (typeof adt === 'string' && adt === bdt && adt !== 'mixed') {
            // datatype
            dt = adt;
            // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
            // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        }
        // result arrays
        var cvalues = [];
        var cindex = [];
        var cptr = [];
        // workspace
        var x = [];
        // marks indicating we have a value in x for a given column
        var w = [];
        // vars
        var k, k0, k1, i;
        // loop columns
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length;
            // columns mark
            var mark = j + 1;
            // loop values in a
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k];
                // mark workspace
                w[i] = mark;
                // set value
                x[i] = avalues[k];
                // add index
                cindex.push(i);
            }
            // loop values in b
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k];
                // check value exists in workspace
                if (w[i] === mark) // evaluate callback
                x[i] = cf(x[i], bvalues[k]);
            }
            // initialize first index in j
            k = cptr[j];
            // loop index in j
            while(k < cindex.length){
                // row
                i = cindex[k];
                // value @ i
                var v = x[i];
                // check for zero value
                if (!eq(v, zero)) {
                    // push value
                    cvalues.push(v);
                    // increment pointer
                    k++;
                } else // remove value @ i, do not increment pointer
                cindex.splice(k, 1);
            }
        }
        // update cptr
        cptr[columns] = cindex.length;
        // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    };
});

});

parcelRegister("1Z19h", function(module, exports) {

$parcel$export(module.exports, "createUseMatrixForArrayScalar", () => $171c610d011c0e6c$export$5ec2267d257aecc);

var $dsu7t = parcelRequire("dsu7t");
var $171c610d011c0e6c$export$5ec2267d257aecc = /* #__PURE__ */ (0, $dsu7t.factory)('useMatrixForArrayScalar', [
    'typed',
    'matrix'
], (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    return {
        'Array, number': typed.referTo('DenseMatrix, number', (selfDn)=>(x, y)=>selfDn(matrix(x), y).valueOf()),
        'Array, BigNumber': typed.referTo('DenseMatrix, BigNumber', (selfDB)=>(x, y)=>selfDB(matrix(x), y).valueOf()),
        'number, Array': typed.referTo('number, DenseMatrix', (selfnD)=>(x, y)=>selfnD(x, matrix(y)).valueOf()),
        'BigNumber, Array': typed.referTo('BigNumber, DenseMatrix', (selfBD)=>(x, y)=>selfBD(x, matrix(y)).valueOf())
    };
});

});


parcelRegister("6cHYx", function(module, exports) {

$parcel$export(module.exports, "createLgamma", () => $4845f9ad19053ec2$export$bc3a6f6286e9085a);
/* eslint-disable no-loss-of-precision */ // References
// ----------
// [1] Hare, "Computing the Principal Branch of log-Gamma", Journal of Algorithms, 1997.
// [2] https://math.stackexchange.com/questions/1338753/how-do-i-calculate-values-for-gamma-function-with-complex-arguments

var $fE59v = parcelRequire("fE59v");

var $dsu7t = parcelRequire("dsu7t");

var $6NnhX = parcelRequire("6NnhX");
var $4845f9ad19053ec2$var$name = 'lgamma';
var $4845f9ad19053ec2$var$dependencies = [
    'Complex',
    'typed'
];
var $4845f9ad19053ec2$export$bc3a6f6286e9085a = /* #__PURE__ */ (0, $dsu7t.factory)($4845f9ad19053ec2$var$name, $4845f9ad19053ec2$var$dependencies, (_ref)=>{
    var { Complex: Complex, typed: typed } = _ref;
    // Stirling series is non-convergent, we need to use the recurrence `lgamma(z) = lgamma(z+1) - log z` to get
    // sufficient accuracy.
    //
    // These two values are copied from Scipy implementation:
    // https://github.com/scipy/scipy/blob/v1.8.0/scipy/special/_loggamma.pxd#L37
    var SMALL_RE = 7;
    var SMALL_IM = 7;
    /**
   * The coefficients are B[2*n]/(2*n*(2*n - 1)) where B[2*n] is the (2*n)th Bernoulli number. See (1.1) in [1].
   *
   * If you cannot access the paper, can also get these values from the formula in [2].
   *
   *    1 /     12 = 0.00833333333333333333333333333333
   *    1 /    360 = 0.00277777777777777777777777777778
   * ...
   * 3617 / 133400 = 0.02955065359477124183006535947712
   */ var coeffs = [
        -0.029550653594771242,
        6.4102564102564102564e-3,
        -0.0019175269175269176,
        8.4175084175084175084e-4,
        -0.0005952380952380953,
        7.9365079365079365079e-4,
        -0.002777777777777778,
        8.3333333333333333333e-2
    ];
    /**
   * Logarithm of the gamma function for real, positive numbers and complex numbers,
   * using Lanczos approximation for numbers and Stirling series for complex numbers.
   *
   * Syntax:
   *
   *    math.lgamma(n)
   *
   * Examples:
   *
   *    math.lgamma(5)       // returns 3.178053830347945
   *    math.lgamma(0)       // returns Infinity
   *    math.lgamma(-0.5)    // returns NaN
   *    math.lgamma(math.i)  // returns -0.6509231993018536 - 1.8724366472624294i
   *
   * See also:
   *
   *    gamma
   *
   * @param {number | Complex} n   A real or complex number
   * @return {number | Complex}    The log gamma of `n`
   */ return typed($4845f9ad19053ec2$var$name, {
        number: (0, $fE59v.lgammaNumber),
        Complex: lgammaComplex,
        BigNumber: function BigNumber() {
            throw new Error("mathjs doesn't yet provide an implementation of the algorithm lgamma for BigNumber");
        }
    });
    function lgammaComplex(n) {
        var TWOPI = 6.2831853071795864769252842; // 2*pi
        var LOGPI = 1.1447298858494001741434262; // log(pi)
        var REFLECTION = 0.1;
        if (n.isNaN()) return new Complex(NaN, NaN);
        else if (n.im === 0) return new Complex((0, $fE59v.lgammaNumber)(n.re), 0);
        else if (n.re >= SMALL_RE || Math.abs(n.im) >= SMALL_IM) return lgammaStirling(n);
        else if (n.re <= REFLECTION) {
            // Reflection formula. see Proposition 3.1 in [1]
            var tmp = (0, $6NnhX.copysign)(TWOPI, n.im) * Math.floor(0.5 * n.re + 0.25);
            var a = n.mul(Math.PI).sin().log();
            var b = lgammaComplex(new Complex(1 - n.re, -n.im));
            return new Complex(LOGPI, tmp).sub(a).sub(b);
        } else if (n.im >= 0) return lgammaRecurrence(n);
        else return lgammaRecurrence(n.conjugate()).conjugate();
    }
    function lgammaStirling(z) {
        // formula ref in [2]
        // computation ref:
        // https://github.com/scipy/scipy/blob/v1.8.0/scipy/special/_loggamma.pxd#L101
        // left part
        // x (log(x) - 1) + 1/2 (log(2PI) - log(x))
        // => (x - 0.5) * log(x) - x + log(2PI) / 2
        var leftPart = z.sub(0.5).mul(z.log()).sub(z).add((0, $fE59v.lnSqrt2PI));
        // right part
        var rz = new Complex(1, 0).div(z);
        var rzz = rz.div(z);
        var a = coeffs[0];
        var b = coeffs[1];
        var r = 2 * rzz.re;
        var s = rzz.re * rzz.re + rzz.im * rzz.im;
        for(var i = 2; i < 8; i++){
            var tmp = b;
            b = -s * a + coeffs[i];
            a = r * a + tmp;
        }
        var rightPart = rz.mul(rzz.mul(a).add(b));
        // plus left and right
        return leftPart.add(rightPart);
    }
    function lgammaRecurrence(z) {
        // computation ref:
        // https://github.com/scipy/scipy/blob/v1.8.0/scipy/special/_loggamma.pxd#L78
        var signflips = 0;
        var sb = 0;
        var shiftprod = z;
        z = z.add(1);
        while(z.re <= SMALL_RE){
            shiftprod = shiftprod.mul(z);
            var nsb = shiftprod.im < 0 ? 1 : 0;
            if (nsb !== 0 && sb === 0) signflips++;
            sb = nsb;
            z = z.add(1);
        }
        return lgammaStirling(z).sub(shiftprod.log()).sub(new Complex(0, signflips * 2 * Math.PI * 1));
    }
});

});

parcelRegister("b01JM", function(module, exports) {

$parcel$export(module.exports, "createLog", () => $80210aca1000dfbe$export$aea8a16d5c9d1b93);

var $dsu7t = parcelRequire("dsu7t");

var $2GCvv = parcelRequire("2GCvv");

var $dmcGu = parcelRequire("dmcGu");
var $80210aca1000dfbe$var$name = 'log';
var $80210aca1000dfbe$var$dependencies = [
    'config',
    'typed',
    'typeOf',
    'divideScalar',
    'Complex'
];
var $80210aca1000dfbe$var$nlg16 = Math.log(16);
var $80210aca1000dfbe$export$aea8a16d5c9d1b93 = /* #__PURE__ */ (0, $dsu7t.factory)($80210aca1000dfbe$var$name, $80210aca1000dfbe$var$dependencies, (_ref)=>{
    var { typed: typed, typeOf: typeOf, config: config, divideScalar: divideScalar, Complex: Complex } = _ref;
    /**
   * Calculate the logarithm of a value.
   *
   * To avoid confusion with the matrix logarithm, this function does not
   * apply to matrices.
   *
   * Syntax:
   *
   *    math.log(x)
   *    math.log(x, base)
   *
   * Examples:
   *
   *    math.log(3.5)                  // returns 1.252762968495368
   *    math.exp(math.log(2.4))        // returns 2.4
   *
   *    math.pow(10, 4)                // returns 10000
   *    math.log(10000, 10)            // returns 4
   *    math.log(10000) / math.log(10) // returns 4
   *
   *    math.log(1024, 2)              // returns 10
   *    math.pow(2, 10)                // returns 1024
   *
   * See also:
   *
   *    exp, log2, log10, log1p
   *
   * @param {number | BigNumber | Fraction | Complex} x
   *            Value for which to calculate the logarithm.
   * @param {number | BigNumber | Fraction | Complex} [base=e]
   *            Optional base for the logarithm. If not provided, the natural
   *            logarithm of `x` is calculated.
   * @return {number | BigNumber | Fraction | Complex}
   *            Returns the logarithm of `x`
   */ function complexLog(c) {
        return c.log();
    }
    function complexLogNumber(x) {
        return complexLog(new Complex(x, 0));
    }
    return typed($80210aca1000dfbe$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $dmcGu.logNumber)(x);
            else // negative value -> complex value computation
            return complexLogNumber(x);
        },
        bigint: (0, $2GCvv.promoteLogarithm)($80210aca1000dfbe$var$nlg16, (0, $dmcGu.logNumber), config, complexLogNumber),
        Complex: complexLog,
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.ln();
            else // downgrade to number, return Complex valued result
            return complexLogNumber(x.toNumber());
        },
        'any, any': typed.referToSelf((self)=>(x, base)=>{
                // calculate logarithm for a specified base, log(x, base)
                if (typeOf(x) === 'Fraction' && typeOf(base) === 'Fraction') {
                    var result = x.log(base);
                    if (result !== null) return result;
                }
                return divideScalar(self(x), self(base));
            })
    });
});

});
parcelRegister("2GCvv", function(module, exports) {

$parcel$export(module.exports, "promoteLogarithm", () => $1f4d5fba1688b63e$export$a67cc797cd00a3d4);
/**
 * Build a bigint logarithm function from a number logarithm,
 * still returning a number. The idea is that 15 hexadecimal digits
 * (60 bits) saturates the mantissa of the log, and each additional hex
 * digit effectively just adds the log of 16 to the resulting value. So
 * convert the most significant 15 hex digits to a number and take its
 * log, and then add the log of 16 for each additional hex digit that
 * was in the bigint.
 * For negative numbers (complex logarithms), following the bignum
 * implementation, it just downgrades to number and uses the complex result.
 * @param {number} log16  the log of 16
 * @param {(number) -> number} numberLog  the logarithm function for numbers
 * @param {ConfigurationObject} config  the mathjs configuration
 * @param {(number) -> Complex} cplx  the associated Complex log
 * @returns {(bigint) -> number}   the corresponding logarithm for bigints
 */ function $1f4d5fba1688b63e$export$a67cc797cd00a3d4(log16, numberLog, config, cplx) {
    return function(b) {
        if (b > 0 || config.predictable) {
            if (b <= 0) return NaN;
            var s = b.toString(16);
            var s15 = s.substring(0, 15);
            return log16 * (s.length - s15.length) + numberLog(Number('0x' + s15));
        }
        return cplx(b.toNumber());
    };
}

});


parcelRegister("flkHO", function(module, exports) {

$parcel$export(module.exports, "createLog10", () => $b2b8e0ded00e8485$export$dea4efeb24d4590d);

var $dmcGu = parcelRequire("dmcGu");

var $2GCvv = parcelRequire("2GCvv");

var $20mkw = parcelRequire("20mkw");

var $dsu7t = parcelRequire("dsu7t");
var $b2b8e0ded00e8485$var$name = 'log10';
var $b2b8e0ded00e8485$var$dependencies = [
    'typed',
    'config',
    'Complex'
];
var $b2b8e0ded00e8485$var$log16 = (0, $dmcGu.log10Number)(16);
var $b2b8e0ded00e8485$export$dea4efeb24d4590d = /* #__PURE__ */ (0, $dsu7t.factory)($b2b8e0ded00e8485$var$name, $b2b8e0ded00e8485$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the 10-base logarithm of a value. This is the same as calculating `log(x, 10)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log10(x)
   *
   * Examples:
   *
   *    math.log10(0.00001)            // returns -5
   *    math.log10(10000)              // returns 4
   *    math.log(10000) / math.log(10) // returns 4
   *    math.pow(10, 4)                // returns 10000
   *
   * See also:
   *
   *    exp, log, log1p, log2
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the 10-base logarithm of `x`
   */ function complexLog(c) {
        return c.log().div(Math.LN10);
    }
    function complexLogNumber(x) {
        return complexLog(new Complex(x, 0));
    }
    return typed($b2b8e0ded00e8485$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $dmcGu.log10Number)(x);
            else // negative value -> complex value computation
            return complexLogNumber(x);
        },
        bigint: (0, $2GCvv.promoteLogarithm)($b2b8e0ded00e8485$var$log16, (0, $dmcGu.log10Number), config, complexLogNumber),
        Complex: complexLog,
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.log();
            else // downgrade to number, return Complex valued result
            return complexLogNumber(x.toNumber());
        },
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});

parcelRegister("itpcA", function(module, exports) {

$parcel$export(module.exports, "createLog1p", () => $d72e7c002b20fa24$export$93da279859a704f0);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");

var $6NnhX = parcelRequire("6NnhX");
var $d72e7c002b20fa24$var$name = 'log1p';
var $d72e7c002b20fa24$var$dependencies = [
    'typed',
    'config',
    'divideScalar',
    'log',
    'Complex'
];
var $d72e7c002b20fa24$export$93da279859a704f0 = /* #__PURE__ */ (0, $dsu7t.factory)($d72e7c002b20fa24$var$name, $d72e7c002b20fa24$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, divideScalar: divideScalar, log: log, Complex: Complex } = _ref;
    /**
   * Calculate the logarithm of a `value+1`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log1p(x)
   *    math.log1p(x, base)
   *
   * Examples:
   *
   *    math.log1p(2.5)                 // returns 1.252762968495368
   *    math.exp(math.log1p(1.4))       // returns 2.4
   *
   *    math.pow(10, 4)                 // returns 10000
   *    math.log1p(9999, 10)            // returns 4
   *    math.log1p(9999) / math.log(10) // returns 4
   *
   * See also:
   *
   *    exp, log, log2, log10
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm of `x+1`.
   * @param {number | BigNumber | Complex} [base=e]
   *            Optional base for the logarithm. If not provided, the natural
   *            logarithm of `x+1` is calculated.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the logarithm of `x+1`
   */ return typed($d72e7c002b20fa24$var$name, {
        number: function number(x) {
            if (x >= -1 || config.predictable) return (0, $6NnhX.log1p)(x);
            else // negative value -> complex value computation
            return _log1pComplex(new Complex(x, 0));
        },
        Complex: _log1pComplex,
        BigNumber: function BigNumber(x) {
            var y = x.plus(1);
            if (!y.isNegative() || config.predictable) return y.ln();
            else // downgrade to number, return Complex valued result
            return _log1pComplex(new Complex(x.toNumber(), 0));
        },
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self)),
        'any, any': typed.referToSelf((self)=>(x, base)=>{
                // calculate logarithm for a specified base, log1p(x, base)
                return divideScalar(self(x), log(base));
            })
    });
    /**
   * Calculate the natural logarithm of a complex number + 1
   * @param {Complex} x
   * @returns {Complex}
   * @private
   */ function _log1pComplex(x) {
        var xRe1p = x.re + 1;
        return new Complex(Math.log(Math.sqrt(xRe1p * xRe1p + x.im * x.im)), Math.atan2(x.im, xRe1p));
    }
});

});

parcelRegister("ctw1A", function(module, exports) {

$parcel$export(module.exports, "createLog2", () => $915108e411a8258e$export$a993dae3988e0f19);

var $dmcGu = parcelRequire("dmcGu");

var $2GCvv = parcelRequire("2GCvv");

var $20mkw = parcelRequire("20mkw");

var $dsu7t = parcelRequire("dsu7t");
var $915108e411a8258e$var$name = 'log2';
var $915108e411a8258e$var$dependencies = [
    'typed',
    'config',
    'Complex'
];
var $915108e411a8258e$export$a993dae3988e0f19 = /* #__PURE__ */ (0, $dsu7t.factory)($915108e411a8258e$var$name, $915108e411a8258e$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log2(x)
   *
   * Examples:
   *
   *    math.log2(0.03125)           // returns -5
   *    math.log2(16)                // returns 4
   *    math.log2(16) / math.log2(2) // returns 4
   *    math.pow(2, 4)               // returns 16
   *
   * See also:
   *
   *    exp, log, log1p, log10
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the 2-base logarithm of `x`
   */ function complexLog2Number(x) {
        return _log2Complex(new Complex(x, 0));
    }
    return typed($915108e411a8258e$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $dmcGu.log2Number)(x);
            else // negative value -> complex value computation
            return complexLog2Number(x);
        },
        bigint: (0, $2GCvv.promoteLogarithm)(4, (0, $dmcGu.log2Number), config, complexLog2Number),
        Complex: _log2Complex,
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.log(2);
            else // downgrade to number, return Complex valued result
            return complexLog2Number(x.toNumber());
        },
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
    /**
   * Calculate log2 for a complex value
   * @param {Complex} x
   * @returns {Complex}
   * @private
   */ function _log2Complex(x) {
        var newX = Math.sqrt(x.re * x.re + x.im * x.im);
        return new Complex(Math.log2 ? Math.log2(newX) : Math.log(newX) / Math.LN2, Math.atan2(x.im, x.re) / Math.LN2);
    }
});

});

parcelRegister("eydoy", function(module, exports) {

$parcel$export(module.exports, "createLsolve", () => $a97ea1a13538217f$export$1b88d04961967a10);

var $dsu7t = parcelRequire("dsu7t");

var $1pDtp = parcelRequire("1pDtp");
var $a97ea1a13538217f$var$name = 'lsolve';
var $a97ea1a13538217f$var$dependencies = [
    'typed',
    'matrix',
    'divideScalar',
    'multiplyScalar',
    'subtractScalar',
    'equalScalar',
    'DenseMatrix'
];
var $a97ea1a13538217f$export$1b88d04961967a10 = /* #__PURE__ */ (0, $dsu7t.factory)($a97ea1a13538217f$var$name, $a97ea1a13538217f$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtractScalar: subtractScalar, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $1pDtp.createSolveValidation)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds one solution of a linear equation system by forwards substitution. Matrix must be a lower triangular matrix. Throws an error if there's no solution.
   *
   * `L * x = b`
   *
   * Syntax:
   *
   *    math.lsolve(L, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = lsolve(a, b)  // [[-5.5], [20]]
   *
   * See also:
   *
   *    lsolveAll, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} L       A N x N matrix or array (L)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix | Array}  A column vector with the linear system solution (x)
   */ return typed($a97ea1a13538217f$var$name, {
        'SparseMatrix, Array | Matrix': function SparseMatrix_Array__Matrix(m, b) {
            return _sparseForwardSubstitution(m, b);
        },
        'DenseMatrix, Array | Matrix': function DenseMatrix_Array__Matrix(m, b) {
            return _denseForwardSubstitution(m, b);
        },
        'Array, Array | Matrix': function Array_Array__Matrix(a, b) {
            var m = matrix(a);
            var r = _denseForwardSubstitution(m, b);
            return r.valueOf();
        }
    });
    function _denseForwardSubstitution(m, b) {
        // validate matrix and vector, return copy of column vector b
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1];
        // result
        var x = [];
        var mdata = m._data;
        // loop columns
        for(var j = 0; j < columns; j++){
            var bj = bdata[j][0] || 0;
            var xj = void 0;
            if (!equalScalar(bj, 0)) {
                // non-degenerate row, find solution
                var vjj = mdata[j][j];
                if (equalScalar(vjj, 0)) throw new Error('Linear system cannot be solved since matrix is singular');
                xj = divideScalar(bj, vjj);
                // loop rows
                for(var i = j + 1; i < rows; i++)bdata[i] = [
                    subtractScalar(bdata[i][0] || 0, multiplyScalar(xj, mdata[i][j]))
                ];
            } else // degenerate row, we can choose any value
            xj = 0;
            x[j] = [
                xj
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
    function _sparseForwardSubstitution(m, b) {
        // validate matrix and vector, return copy of column vector b
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        // result
        var x = [];
        // loop columns
        for(var j = 0; j < columns; j++){
            var bj = bdata[j][0] || 0;
            if (!equalScalar(bj, 0)) {
                // non-degenerate row, find solution
                var vjj = 0;
                // matrix values & indices (column j)
                var jValues = [];
                var jIndices = [];
                // first and last index in the column
                var firstIndex = ptr[j];
                var lastIndex = ptr[j + 1];
                // values in column, find value at [j, j]
                for(var k = firstIndex; k < lastIndex; k++){
                    var i = index[k];
                    // check row (rows are not sorted!)
                    if (i === j) vjj = values[k];
                    else if (i > j) {
                        // store lower triangular
                        jValues.push(values[k]);
                        jIndices.push(i);
                    }
                }
                // at this point we must have a value in vjj
                if (equalScalar(vjj, 0)) throw new Error('Linear system cannot be solved since matrix is singular');
                var xj = divideScalar(bj, vjj);
                for(var _k = 0, l = jIndices.length; _k < l; _k++){
                    var _i = jIndices[_k];
                    bdata[_i] = [
                        subtractScalar(bdata[_i][0] || 0, multiplyScalar(xj, jValues[_k]))
                    ];
                }
                x[j] = [
                    xj
                ];
            } else // degenerate row, we can choose any value
            x[j] = [
                0
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
});

});
parcelRegister("1pDtp", function(module, exports) {

$parcel$export(module.exports, "createSolveValidation", () => $1076bed785ea0c42$export$6accbcba5dda801d);

var $edQYF = parcelRequire("edQYF");

var $d80Xp = parcelRequire("d80Xp");

var $j2hDb = parcelRequire("j2hDb");
function $1076bed785ea0c42$export$6accbcba5dda801d(_ref) {
    var { DenseMatrix: DenseMatrix } = _ref;
    /**
   * Validates matrix and column vector b for backward/forward substitution algorithms.
   *
   * @param {Matrix} m            An N x N matrix
   * @param {Array | Matrix} b    A column vector
   * @param {Boolean} copy        Return a copy of vector b
   *
   * @return {DenseMatrix}        Dense column vector b
   */ return function solveValidation(m, b, copy) {
        var mSize = m.size();
        if (mSize.length !== 2) throw new RangeError('Matrix must be two dimensional (size: ' + (0, $j2hDb.format)(mSize) + ')');
        var rows = mSize[0];
        var columns = mSize[1];
        if (rows !== columns) throw new RangeError('Matrix must be square (size: ' + (0, $j2hDb.format)(mSize) + ')');
        var data = [];
        if ((0, $edQYF.isMatrix)(b)) {
            var bSize = b.size();
            var bdata = b._data;
            // 1-dim vector
            if (bSize.length === 1) {
                if (bSize[0] !== rows) throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');
                for(var i = 0; i < rows; i++)data[i] = [
                    bdata[i]
                ];
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ],
                    datatype: b._datatype
                });
            }
            // 2-dim column
            if (bSize.length === 2) {
                if (bSize[0] !== rows || bSize[1] !== 1) throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');
                if ((0, $edQYF.isDenseMatrix)(b)) {
                    if (copy) {
                        data = [];
                        for(var _i = 0; _i < rows; _i++)data[_i] = [
                            bdata[_i][0]
                        ];
                        return new DenseMatrix({
                            data: data,
                            size: [
                                rows,
                                1
                            ],
                            datatype: b._datatype
                        });
                    }
                    return b;
                }
                if ((0, $edQYF.isSparseMatrix)(b)) {
                    for(var _i2 = 0; _i2 < rows; _i2++)data[_i2] = [
                        0
                    ];
                    var values = b._values;
                    var index = b._index;
                    var ptr = b._ptr;
                    for(var k1 = ptr[1], k = ptr[0]; k < k1; k++){
                        var _i3 = index[k];
                        data[_i3][0] = values[k];
                    }
                    return new DenseMatrix({
                        data: data,
                        size: [
                            rows,
                            1
                        ],
                        datatype: b._datatype
                    });
                }
            }
            throw new RangeError('Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.');
        }
        if ((0, $edQYF.isArray)(b)) {
            var bsize = (0, $d80Xp.arraySize)(b);
            if (bsize.length === 1) {
                if (bsize[0] !== rows) throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');
                for(var _i4 = 0; _i4 < rows; _i4++)data[_i4] = [
                    b[_i4]
                ];
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ]
                });
            }
            if (bsize.length === 2) {
                if (bsize[0] !== rows || bsize[1] !== 1) throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');
                for(var _i5 = 0; _i5 < rows; _i5++)data[_i5] = [
                    b[_i5][0]
                ];
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ]
                });
            }
            throw new RangeError('Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.');
        }
    };
}

});


parcelRegister("gE9Dr", function(module, exports) {

$parcel$export(module.exports, "createLsolveAll", () => $c1e7db1919ff0733$export$70743fd0ad1f42d7);

var $dsu7t = parcelRequire("dsu7t");

var $1pDtp = parcelRequire("1pDtp");
var $c1e7db1919ff0733$var$name = 'lsolveAll';
var $c1e7db1919ff0733$var$dependencies = [
    'typed',
    'matrix',
    'divideScalar',
    'multiplyScalar',
    'subtractScalar',
    'equalScalar',
    'DenseMatrix'
];
var $c1e7db1919ff0733$export$70743fd0ad1f42d7 = /* #__PURE__ */ (0, $dsu7t.factory)($c1e7db1919ff0733$var$name, $c1e7db1919ff0733$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtractScalar: subtractScalar, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $1pDtp.createSolveValidation)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds all solutions of a linear equation system by forwards substitution. Matrix must be a lower triangular matrix.
   *
   * `L * x = b`
   *
   * Syntax:
   *
   *    math.lsolveAll(L, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = lsolveAll(a, b)  // [ [[-5.5], [20]] ]
   *
   * See also:
   *
   *    lsolve, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} L       A N x N matrix or array (L)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix[] | Array[]}  An array of affine-independent column vectors (x) that solve the linear system
   */ return typed($c1e7db1919ff0733$var$name, {
        'SparseMatrix, Array | Matrix': function SparseMatrix_Array__Matrix(m, b) {
            return _sparseForwardSubstitution(m, b);
        },
        'DenseMatrix, Array | Matrix': function DenseMatrix_Array__Matrix(m, b) {
            return _denseForwardSubstitution(m, b);
        },
        'Array, Array | Matrix': function Array_Array__Matrix(a, b) {
            var m = matrix(a);
            var R = _denseForwardSubstitution(m, b);
            return R.map((r)=>r.valueOf());
        }
    });
    function _denseForwardSubstitution(m, b_) {
        // the algorithm is derived from
        // https://www.overleaf.com/read/csvgqdxggyjv
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var M = m._data;
        var rows = m._size[0];
        var columns = m._size[1];
        // loop columns
        for(var i = 0; i < columns; i++){
            var L = B.length;
            // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k];
                if (!equalScalar(M[i][i], 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], M[i][i]);
                    for(var j = i + 1; j < columns; j++)// b[j] -= b[i] * M[j,i]
                    b[j] = subtractScalar(b[j], multiplyScalar(b[i], M[j][i]));
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1;
                    for(var _j = i + 1; _j < columns; _j++)bNew[_j] = subtractScalar(bNew[_j], M[_j][i]);
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
    function _sparseForwardSubstitution(m, b_) {
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        // loop columns
        for(var i = 0; i < columns; i++){
            var L = B.length;
            // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k];
                // values & indices (column i)
                var iValues = [];
                var iIndices = [];
                // first & last indeces in column
                var firstIndex = ptr[i];
                var lastIndex = ptr[i + 1];
                // find the value at [i, i]
                var Mii = 0;
                for(var j = firstIndex; j < lastIndex; j++){
                    var J = index[j];
                    // check row
                    if (J === i) Mii = values[j];
                    else if (J > i) {
                        // store lower triangular
                        iValues.push(values[j]);
                        iIndices.push(J);
                    }
                }
                if (!equalScalar(Mii, 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], Mii);
                    for(var _j2 = 0, _lastIndex = iIndices.length; _j2 < _lastIndex; _j2++){
                        var _J = iIndices[_j2];
                        b[_J] = subtractScalar(b[_J], multiplyScalar(b[i], iValues[_j2]));
                    }
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1;
                    for(var _j3 = 0, _lastIndex2 = iIndices.length; _j3 < _lastIndex2; _j3++){
                        var _J2 = iIndices[_j3];
                        bNew[_J2] = subtractScalar(bNew[_J2], iValues[_j3]);
                    }
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
});

});

parcelRegister("jgcqf", function(module, exports) {

$parcel$export(module.exports, "createLup", () => $e05925c01e0b704c$export$86ddf344397699d5);

var $9v8q6 = parcelRequire("9v8q6");

var $dsu7t = parcelRequire("dsu7t");
var $e05925c01e0b704c$var$name = 'lup';
var $e05925c01e0b704c$var$dependencies = [
    'typed',
    'matrix',
    'abs',
    'addScalar',
    'divideScalar',
    'multiplyScalar',
    'subtractScalar',
    'larger',
    'equalScalar',
    'unaryMinus',
    'DenseMatrix',
    'SparseMatrix',
    'Spa'
];
var $e05925c01e0b704c$export$86ddf344397699d5 = /* #__PURE__ */ (0, $dsu7t.factory)($e05925c01e0b704c$var$name, $e05925c01e0b704c$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, abs: abs, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtractScalar: subtractScalar, larger: larger, equalScalar: equalScalar, unaryMinus: unaryMinus, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix, Spa: Spa } = _ref;
    /**
   * Calculate the Matrix LU decomposition with partial pivoting. Matrix `A` is decomposed in two matrices (`L`, `U`) and a
   * row permutation vector `p` where `A[p,:] = L * U`
   *
   * Syntax:
   *
   *    math.lup(A)
   *
   * Example:
   *
   *    const m = [[2, 1], [1, 4]]
   *    const r = math.lup(m)
   *    // r = {
   *    //   L: [[1, 0], [0.5, 1]],
   *    //   U: [[2, 1], [0, 3.5]],
   *    //   P: [0, 1]
   *    // }
   *
   * See also:
   *
   *    slu, lsolve, lusolve, usolve
   *
   * @param {Matrix | Array} A    A two dimensional matrix or array for which to get the LUP decomposition.
   *
   * @return {{L: Array | Matrix, U: Array | Matrix, P: Array.<number>}} The lower triangular matrix, the upper triangular matrix and the permutation matrix.
   */ return typed($e05925c01e0b704c$var$name, {
        DenseMatrix: function DenseMatrix(m) {
            return _denseLUP(m);
        },
        SparseMatrix: function SparseMatrix(m) {
            return _sparseLUP(m);
        },
        Array: function Array(a) {
            // create dense matrix from array
            var m = matrix(a);
            // lup, use matrix implementation
            var r = _denseLUP(m);
            // result
            return {
                L: r.L.valueOf(),
                U: r.U.valueOf(),
                p: r.p
            };
        }
    });
    function _denseLUP(m) {
        // rows & columns
        var rows = m._size[0];
        var columns = m._size[1];
        // minimum rows and columns
        var n = Math.min(rows, columns);
        // matrix array, clone original data
        var data = (0, $9v8q6.clone)(m._data);
        // l matrix arrays
        var ldata = [];
        var lsize = [
            rows,
            n
        ];
        // u matrix arrays
        var udata = [];
        var usize = [
            n,
            columns
        ];
        // vars
        var i, j, k;
        // permutation vector
        var p = [];
        for(i = 0; i < rows; i++)p[i] = i;
        // loop columns
        for(j = 0; j < columns; j++){
            // skip first column in upper triangular matrix
            if (j > 0) // loop rows
            for(i = 0; i < rows; i++){
                // min i,j
                var min = Math.min(i, j);
                // v[i, j]
                var s = 0;
                // loop up to min
                for(k = 0; k < min; k++)// s = l[i, k] - data[k, j]
                s = addScalar(s, multiplyScalar(data[i][k], data[k][j]));
                data[i][j] = subtractScalar(data[i][j], s);
            }
            // row with larger value in cvector, row >= j
            var pi = j;
            var pabsv = 0;
            var vjj = 0;
            // loop rows
            for(i = j; i < rows; i++){
                // data @ i, j
                var v = data[i][j];
                // absolute value
                var absv = abs(v);
                // value is greater than pivote value
                if (larger(absv, pabsv)) {
                    // store row
                    pi = i;
                    // update max value
                    pabsv = absv;
                    // value @ [j, j]
                    vjj = v;
                }
            }
            // swap rows (j <-> pi)
            if (j !== pi) {
                // swap values j <-> pi in p
                p[j] = [
                    p[pi],
                    p[pi] = p[j]
                ][0];
                // swap j <-> pi in data
                DenseMatrix._swapRows(j, pi, data);
            }
            // check column is in lower triangular matrix
            if (j < rows) // loop rows (lower triangular matrix)
            for(i = j + 1; i < rows; i++){
                // value @ i, j
                var vij = data[i][j];
                if (!equalScalar(vij, 0)) // update data
                data[i][j] = divideScalar(data[i][j], vjj);
            }
        }
        // loop columns
        for(j = 0; j < columns; j++)// loop rows
        for(i = 0; i < rows; i++){
            // initialize row in arrays
            if (j === 0) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i] = [];
                // L
                ldata[i] = [];
            }
            // check we are in the upper triangular matrix
            if (i < j) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i][j] = data[i][j];
                // check column exists in lower triangular matrix
                if (j < rows) // L
                ldata[i][j] = 0;
                continue;
            }
            // diagonal value
            if (i === j) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i][j] = data[i][j];
                // check column exists in lower triangular matrix
                if (j < rows) // L
                ldata[i][j] = 1;
                continue;
            }
            // check row exists in upper triangular matrix
            if (i < columns) // U
            udata[i][j] = 0;
            // check column exists in lower triangular matrix
            if (j < rows) // L
            ldata[i][j] = data[i][j];
        }
        // l matrix
        var l = new DenseMatrix({
            data: ldata,
            size: lsize
        });
        // u matrix
        var u = new DenseMatrix({
            data: udata,
            size: usize
        });
        // p vector
        var pv = [];
        for(i = 0, n = p.length; i < n; i++)pv[p[i]] = i;
        // return matrices
        return {
            L: l,
            U: u,
            p: pv,
            toString: function toString() {
                return 'L: ' + this.L.toString() + '\nU: ' + this.U.toString() + '\nP: ' + this.p;
            }
        };
    }
    function _sparseLUP(m) {
        // rows & columns
        var rows = m._size[0];
        var columns = m._size[1];
        // minimum rows and columns
        var n = Math.min(rows, columns);
        // matrix arrays (will not be modified, thanks to permutation vector)
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        // l matrix arrays
        var lvalues = [];
        var lindex = [];
        var lptr = [];
        var lsize = [
            rows,
            n
        ];
        // u matrix arrays
        var uvalues = [];
        var uindex = [];
        var uptr = [];
        var usize = [
            n,
            columns
        ];
        // vars
        var i, j, k;
        // permutation vectors, (current index -> original index) and (original index -> current index)
        var pvCo = [];
        var pvOc = [];
        for(i = 0; i < rows; i++){
            pvCo[i] = i;
            pvOc[i] = i;
        }
        // swap indices in permutation vectors (condition x < y)!
        var swapIndeces = function swapIndeces(x, y) {
            // find pv indeces getting data from x and y
            var kx = pvOc[x];
            var ky = pvOc[y];
            // update permutation vector current -> original
            pvCo[kx] = y;
            pvCo[ky] = x;
            // update permutation vector original -> current
            pvOc[x] = ky;
            pvOc[y] = kx;
        };
        // loop columns
        var _loop = function _loop() {
            // sparse accumulator
            var spa = new Spa();
            // check lower triangular matrix has a value @ column j
            if (j < rows) {
                // update ptr
                lptr.push(lvalues.length);
                // first value in j column for lower triangular matrix
                lvalues.push(1);
                lindex.push(j);
            }
            // update ptr
            uptr.push(uvalues.length);
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1];
            // copy column j into sparse accumulator
            for(k = k0; k < k1; k++){
                // row
                i = index[k];
                // copy column values into sparse accumulator (use permutation vector)
                spa.set(pvCo[i], values[k]);
            }
            // skip first column in upper triangular matrix
            if (j > 0) // loop rows in column j (above diagonal)
            spa.forEach(0, j - 1, function(k, vkj) {
                // loop rows in column k (L)
                SparseMatrix._forEachRow(k, lvalues, lindex, lptr, function(i, vik) {
                    // check row is below k
                    if (i > k) // update spa value
                    spa.accumulate(i, unaryMinus(multiplyScalar(vik, vkj)));
                });
            });
            // row with larger value in spa, row >= j
            var pi = j;
            var vjj = spa.get(j);
            var pabsv = abs(vjj);
            // loop values in spa (order by row, below diagonal)
            spa.forEach(j + 1, rows - 1, function(x, v) {
                // absolute value
                var absv = abs(v);
                // value is greater than pivote value
                if (larger(absv, pabsv)) {
                    // store row
                    pi = x;
                    // update max value
                    pabsv = absv;
                    // value @ [j, j]
                    vjj = v;
                }
            });
            // swap rows (j <-> pi)
            if (j !== pi) {
                // swap values j <-> pi in L
                SparseMatrix._swapRows(j, pi, lsize[1], lvalues, lindex, lptr);
                // swap values j <-> pi in U
                SparseMatrix._swapRows(j, pi, usize[1], uvalues, uindex, uptr);
                // swap values in spa
                spa.swap(j, pi);
                // update permutation vector (swap values @ j, pi)
                swapIndeces(j, pi);
            }
            // loop values in spa (order by row)
            spa.forEach(0, rows - 1, function(x, v) {
                // check we are above diagonal
                if (x <= j) {
                    // update upper triangular matrix
                    uvalues.push(v);
                    uindex.push(x);
                } else {
                    // update value
                    v = divideScalar(v, vjj);
                    // check value is non zero
                    if (!equalScalar(v, 0)) {
                        // update lower triangular matrix
                        lvalues.push(v);
                        lindex.push(x);
                    }
                }
            });
        };
        for(j = 0; j < columns; j++)_loop();
        // update ptrs
        uptr.push(uvalues.length);
        lptr.push(lvalues.length);
        // return matrices
        return {
            L: new SparseMatrix({
                values: lvalues,
                index: lindex,
                ptr: lptr,
                size: lsize
            }),
            U: new SparseMatrix({
                values: uvalues,
                index: uindex,
                ptr: uptr,
                size: usize
            }),
            p: pvCo,
            toString: function toString() {
                return 'L: ' + this.L.toString() + '\nU: ' + this.U.toString() + '\nP: ' + this.p;
            }
        };
    }
});

});

parcelRegister("2uHPV", function(module, exports) {

$parcel$export(module.exports, "createLusolve", () => $1d10631c23cfc9f8$export$a3f0777edf21dcd5);

var $edQYF = parcelRequire("edQYF");

var $dsu7t = parcelRequire("dsu7t");

var $1pDtp = parcelRequire("1pDtp");

var $lrxZ7 = parcelRequire("lrxZ7");
var $1d10631c23cfc9f8$var$name = 'lusolve';
var $1d10631c23cfc9f8$var$dependencies = [
    'typed',
    'matrix',
    'lup',
    'slu',
    'usolve',
    'lsolve',
    'DenseMatrix'
];
var $1d10631c23cfc9f8$export$a3f0777edf21dcd5 = /* #__PURE__ */ (0, $dsu7t.factory)($1d10631c23cfc9f8$var$name, $1d10631c23cfc9f8$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, lup: lup, slu: slu, usolve: usolve, lsolve: lsolve, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $1pDtp.createSolveValidation)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Solves the linear system `A * x = b` where `A` is an [n x n] matrix and `b` is a [n] column vector.
   *
   * Syntax:
   *
   *    math.lusolve(A, b)     // returns column vector with the solution to the linear system A * x = b
   *    math.lusolve(lup, b)   // returns column vector with the solution to the linear system A * x = b, lup = math.lup(A)
   *
   * Examples:
   *
   *    const m = [[1, 0, 0, 0], [0, 2, 0, 0], [0, 0, 3, 0], [0, 0, 0, 4]]
   *
   *    const x = math.lusolve(m, [-1, -1, -1, -1])        // x = [[-1], [-0.5], [-1/3], [-0.25]]
   *
   *    const f = math.lup(m)
   *    const x1 = math.lusolve(f, [-1, -1, -1, -1])       // x1 = [[-1], [-0.5], [-1/3], [-0.25]]
   *    const x2 = math.lusolve(f, [1, 2, 1, -1])          // x2 = [[1], [1], [1/3], [-0.25]]
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = math.lusolve(a, b)  // [[2], [5]]
   *
   * See also:
   *
   *    lup, slu, lsolve, usolve
   *
   * @param {Matrix | Array | Object} A      Invertible Matrix or the Matrix LU decomposition
   * @param {Matrix | Array} b               Column Vector
   * @param {number} [order]                 The Symbolic Ordering and Analysis order, see slu for details. Matrix must be a SparseMatrix
   * @param {Number} [threshold]             Partial pivoting threshold (1 for partial pivoting), see slu for details. Matrix must be a SparseMatrix.
   *
   * @return {DenseMatrix | Array}           Column vector with the solution to the linear system A * x = b
   */ return typed($1d10631c23cfc9f8$var$name, {
        'Array, Array | Matrix': function Array_Array__Matrix(a, b) {
            a = matrix(a);
            var d = lup(a);
            var x = _lusolve(d.L, d.U, d.p, null, b);
            return x.valueOf();
        },
        'DenseMatrix, Array | Matrix': function DenseMatrix_Array__Matrix(a, b) {
            var d = lup(a);
            return _lusolve(d.L, d.U, d.p, null, b);
        },
        'SparseMatrix, Array | Matrix': function SparseMatrix_Array__Matrix(a, b) {
            var d = lup(a);
            return _lusolve(d.L, d.U, d.p, null, b);
        },
        'SparseMatrix, Array | Matrix, number, number': function SparseMatrix_Array__Matrix_number_number(a, b, order, threshold) {
            var d = slu(a, order, threshold);
            return _lusolve(d.L, d.U, d.p, d.q, b);
        },
        'Object, Array | Matrix': function Object_Array__Matrix(d, b) {
            return _lusolve(d.L, d.U, d.p, d.q, b);
        }
    });
    function _toMatrix(a) {
        if ((0, $edQYF.isMatrix)(a)) return a;
        if ((0, $edQYF.isArray)(a)) return matrix(a);
        throw new TypeError('Invalid Matrix LU decomposition');
    }
    function _lusolve(l, u, p, q, b) {
        // verify decomposition
        l = _toMatrix(l);
        u = _toMatrix(u);
        // apply row permutations if needed (b is a DenseMatrix)
        if (p) {
            b = solveValidation(l, b, true);
            b._data = (0, $lrxZ7.csIpvec)(p, b._data);
        }
        // use forward substitution to resolve L * y = b
        var y = lsolve(l, b);
        // use backward substitution to resolve U * x = y
        var x = usolve(u, y);
        // apply column permutations if needed (x is a DenseMatrix)
        if (q) x._data = (0, $lrxZ7.csIpvec)(q, x._data);
        return x;
    }
});

});
parcelRegister("lrxZ7", function(module, exports) {

$parcel$export(module.exports, "csIpvec", () => $f9c67b3fc5cd58e6$export$29cc81cfd083fd62);
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
/**
 * Permutes a vector; x = P'b. In MATLAB notation, x(p)=b.
 *
 * @param {Array} p           The permutation vector of length n. null value denotes identity
 * @param {Array} b           The input vector
 *
 * @return {Array}            The output vector x = P'b
 */ function $f9c67b3fc5cd58e6$export$29cc81cfd083fd62(p, b) {
    // vars
    var k;
    var n = b.length;
    var x = [];
    // check permutation vector was provided, p = null denotes identity
    if (p) // loop vector
    for(k = 0; k < n; k++)// apply permutation
    x[p[k]] = b[k];
    else // loop vector
    for(k = 0; k < n; k++)// x[i] = b[i]
    x[k] = b[k];
    return x;
}

});


parcelRegister("jq3Rf", function(module, exports) {

$parcel$export(module.exports, "createLyap", () => $e23370224f36242d$export$4279d742852ce356);

var $dsu7t = parcelRequire("dsu7t");
var $e23370224f36242d$var$name = 'lyap';
var $e23370224f36242d$var$dependencies = [
    'typed',
    'matrix',
    'sylvester',
    'multiply',
    'transpose'
];
var $e23370224f36242d$export$4279d742852ce356 = /* #__PURE__ */ (0, $dsu7t.factory)($e23370224f36242d$var$name, $e23370224f36242d$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, sylvester: sylvester, multiply: multiply, transpose: transpose } = _ref;
    /**
   *
   * Solves the Continuous-time Lyapunov equation AP+PA'+Q=0 for P, where
   * Q is an input matrix. When Q is symmetric, P is also symmetric. Notice
   * that different equivalent definitions exist for the Continuous-time
   * Lyapunov equation.
   * https://en.wikipedia.org/wiki/Lyapunov_equation
   *
   * Syntax:
   *
   *     math.lyap(A, Q)
   *
   * Examples:
   *
   *     const A = [[-2, 0], [1, -4]]
   *     const Q = [[3, 1], [1, 3]]
   *     const P = math.lyap(A, Q)
   *
   * See also:
   *
   *     sylvester, schur
   *
   * @param {Matrix | Array} A  Matrix A
   * @param {Matrix | Array} Q  Matrix Q
   * @return {Matrix | Array} Matrix P solution to the Continuous-time Lyapunov equation AP+PA'=Q
   */ return typed($e23370224f36242d$var$name, {
        'Matrix, Matrix': function Matrix_Matrix(A, Q) {
            return sylvester(A, transpose(A), multiply(-1, Q));
        },
        'Array, Matrix': function Array_Matrix(A, Q) {
            return sylvester(matrix(A), transpose(matrix(A)), multiply(-1, Q));
        },
        'Matrix, Array': function Matrix_Array(A, Q) {
            return sylvester(A, transpose(matrix(A)), matrix(multiply(-1, Q)));
        },
        'Array, Array': function Array_Array(A, Q) {
            return sylvester(matrix(A), transpose(matrix(A)), matrix(multiply(-1, Q))).toArray();
        }
    });
});

});

parcelRegister("cWSx6", function(module, exports) {

$parcel$export(module.exports, "createMad", () => $96d533e87cddbc1c$export$7b17fbe41c88575a);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");

var $a2CJg = parcelRequire("a2CJg");
var $96d533e87cddbc1c$var$name = 'mad';
var $96d533e87cddbc1c$var$dependencies = [
    'typed',
    'abs',
    'map',
    'median',
    'subtract'
];
var $96d533e87cddbc1c$export$7b17fbe41c88575a = /* #__PURE__ */ (0, $dsu7t.factory)($96d533e87cddbc1c$var$name, $96d533e87cddbc1c$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, map: map, median: median, subtract: subtract } = _ref;
    /**
   * Compute the median absolute deviation of a matrix or a list with values.
   * The median absolute deviation is defined as the median of the absolute
   * deviations from the median.
   *
   * Syntax:
   *
   *     math.mad(a, b, c, ...)
   *     math.mad(A)
   *
   * Examples:
   *
   *     math.mad(10, 20, 30)             // returns 10
   *     math.mad([1, 2, 3])              // returns 1
   *     math.mad([[1, 2, 3], [4, 5, 6]]) // returns 1.5
   *
   * See also:
   *
   *     median, mean, std, abs
   *
   * @param {Array | Matrix} array
   *                        A single matrix or multiple scalar values.
   * @return {*} The median absolute deviation.
   */ return typed($96d533e87cddbc1c$var$name, {
        // mad([a, b, c, d, ...])
        'Array | Matrix': _mad,
        // mad(a, b, c, d, ...)
        '...': function _(args) {
            return _mad(args);
        }
    });
    function _mad(array) {
        array = (0, $d80Xp.flatten)(array.valueOf());
        if (array.length === 0) throw new Error('Cannot calculate median absolute deviation (mad) of an empty array');
        try {
            var med = median(array);
            return median(map(array, function(value) {
                return abs(subtract(value, med));
            }));
        } catch (err) {
            if (err instanceof TypeError && err.message.includes('median')) throw new TypeError(err.message.replace('median', 'mad'));
            else throw (0, $a2CJg.improveErrorMessage)(err, 'mad');
        }
    }
});

});

parcelRegister("upCur", function(module, exports) {

$parcel$export(module.exports, "createMap", () => $05b6ad043a5d641f$export$d49c9aa30b771d59);

var $bLcpf = parcelRequire("bLcpf");

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $05b6ad043a5d641f$var$name = 'map';
var $05b6ad043a5d641f$var$dependencies = [
    'typed'
];
var $05b6ad043a5d641f$export$d49c9aa30b771d59 = /* #__PURE__ */ (0, $dsu7t.factory)($05b6ad043a5d641f$var$name, $05b6ad043a5d641f$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a new matrix or array with the results of a callback function executed on
   * each entry of a given matrix/array.
   *
   * For each entry of the input,
   *
   * the callback is invoked with 2N + 1 arguments:
   * the N values of the entry, the index at which that entry occurs, and the N full
   * broadcasted matrix/array being traversed where N is the number of matrices being traversed.
   * Note that because the matrix/array might be
   * multidimensional, the "index" argument is always an array of numbers giving
   * the index in each dimension. This is true even for vectors: the "index"
   * argument is an array of length 1, rather than simply a number.
   *
   * Syntax:
   *
   *    math.map(x, callback)
   *    math.map(x, y, ..., callback)
   *
   * Examples:
   *
   *    math.map([1, 2, 3], function(value) {
   *      return value * value
   *    })  // returns [1, 4, 9]
   *    math.map([1, 2], [3, 4], function(a, b) {
   *     return a + b
   *    })  // returns [4, 6]
   *
   *    // The callback is normally called with three arguments:
   *    //    callback(value, index, Array)
   *    // If you want to call with only one argument, use:
   *    math.map([1, 2, 3], x => math.format(x)) // returns ['1', '2', '3']
   *    // It can also be called with 2N + 1 arguments: for N arrays
   *    //    callback(value1, value2, index, BroadcastedArray1, BroadcastedArray2)
   *
   * See also:
   *
   *    filter, forEach, sort
   *
   * @param {Matrix | Array} x    The input to iterate on.
   * @param {Function} callback
   *     The function to call (as described above) on each entry of the input
   * @return {Matrix | array}
   *     Transformed map of x; always has the same type and shape as x
   */ return typed($05b6ad043a5d641f$var$name, {
        'Array, function': _mapArray,
        'Matrix, function': function Matrix_function(x, callback) {
            return x.map(callback);
        },
        'Array|Matrix, Array|Matrix, ...Array|Matrix|function': (A, B, rest)=>_mapMultiple([
                A,
                B,
                ...rest.slice(0, rest.length - 1)
            ], rest[rest.length - 1])
    });
    /**
  * Maps over multiple arrays or matrices.
  *
  * @param {Array<Array|Matrix>} Arrays - An array of arrays or matrices to map over.
  * @param {function} multiCallback - The callback function to apply to each element.
  * @throws {Error} If the last argument is not a callback function.
  * @returns {Array|Matrix} A new array or matrix with each element being the result of the callback function.
  *
  * @example
  * _mapMultiple([[1, 2, 3], [4, 5, 6]], (a, b) => a + b); // Returns [5, 7, 9]
  */ function _mapMultiple(Arrays, multiCallback) {
        if (typeof multiCallback !== 'function') throw new Error('Last argument must be a callback function');
        var firstArrayIsMatrix = Arrays[0].isMatrix;
        var sizes = Arrays.map((M)=>M.isMatrix ? M.size() : (0, $d80Xp.arraySize)(M));
        var newSize = (0, $d80Xp.broadcastSizes)(...sizes);
        var numberOfArrays = Arrays.length;
        var _get = firstArrayIsMatrix ? (matrix, idx)=>matrix.get(idx) : (0, $d80Xp.get);
        var firstValues = Arrays.map((collection, i)=>{
            var firstIndex = sizes[i].map(()=>0);
            return collection.isMatrix ? collection.get(firstIndex) : (0, $d80Xp.get)(collection, firstIndex);
        });
        var callbackArgCount = typed.isTypedFunction(multiCallback) ? _getTypedCallbackArgCount(multiCallback, firstValues, newSize.map(()=>0), Arrays) : _getCallbackArgCount(multiCallback, numberOfArrays);
        if (callbackArgCount < 2) {
            var _callback = _getLimitedCallback(callbackArgCount, multiCallback, null);
            return mapMultiple(Arrays, _callback);
        }
        var broadcastedArrays = firstArrayIsMatrix ? Arrays.map((M)=>M.isMatrix ? M.create((0, $d80Xp.broadcastTo)(M.toArray(), newSize), M.datatype()) : Arrays[0].create((0, $d80Xp.broadcastTo)(M.valueOf(), newSize))) : Arrays.map((M)=>M.isMatrix ? (0, $d80Xp.broadcastTo)(M.toArray(), newSize) : (0, $d80Xp.broadcastTo)(M, newSize));
        var callback = _getLimitedCallback(callbackArgCount, multiCallback, broadcastedArrays);
        var broadcastedArraysCallback = (x, idx)=>callback([
                x,
                ...broadcastedArrays.slice(1).map((array)=>_get(array, idx))
            ], idx);
        if (firstArrayIsMatrix) return broadcastedArrays[0].map(broadcastedArraysCallback);
        else return _mapArray(broadcastedArrays[0], broadcastedArraysCallback);
    }
    function mapMultiple(collections, callback) {
        // collections can be matrices or arrays
        // callback must be a function of the form (collections, [index])
        var firstCollection = collections[0];
        var arrays = collections.map((collection)=>collection.isMatrix ? collection.valueOf() : collection);
        var sizes = collections.map((collection)=>collection.isMatrix ? collection.size() : (0, $d80Xp.arraySize)(collection));
        var finalSize = (0, $d80Xp.broadcastSizes)(...sizes);
        // the offset means for each initial array, how much smaller is it than the final size
        var offsets = sizes.map((size)=>finalSize.length - size.length);
        var maxDepth = finalSize.length - 1;
        var callbackUsesIndex = callback.length > 1;
        var index = callbackUsesIndex ? [] : null;
        var resultsArray = iterate(arrays, 0);
        if (firstCollection.isMatrix) {
            var resultsMatrix = firstCollection.create();
            resultsMatrix._data = resultsArray;
            resultsMatrix._size = finalSize;
            return resultsMatrix;
        } else return resultsArray;
        function iterate(arrays) {
            var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            // each array can have different sizes
            var currentDimensionSize = finalSize[depth];
            var result = Array(currentDimensionSize);
            if (depth < maxDepth) {
                var _loop = function _loop(i) {
                    if (index) index[depth] = i;
                    // if there is an offset greater than the current dimension
                    // pass the array, if the size of the array is 1 pass the first
                    // element of the array
                    result[i] = iterate(arrays.map((array, arrayIndex)=>offsets[arrayIndex] > depth ? array : array.length === 1 ? array[0] : array[i]), depth + 1);
                };
                for(var i = 0; i < currentDimensionSize; i++)_loop(i);
            } else {
                var _loop2 = function _loop2(_i) {
                    if (index) index[depth] = _i;
                    result[_i] = callback(arrays.map((a)=>a.length === 1 ? a[0] : a[_i]), index ? index.slice() : undefined);
                };
                for(var _i = 0; _i < currentDimensionSize; _i++)_loop2(_i);
            }
            return result;
        }
    }
    /**
    * Creates a limited callback based on the argument pattern.
    * @param {number} callbackArgCount - The argument pattern (0, 1, or 2)
    * @param {Function} multiCallback - The original callback function
    * @param {Array} broadcastedArrays - The broadcasted arrays (for case 2)
    * @returns {Function} The limited callback function
    */ function _getLimitedCallback(callbackArgCount, multiCallback, broadcastedArrays) {
        switch(callbackArgCount){
            case 0:
                return (x)=>multiCallback(...x);
            case 1:
                return (x, idx)=>multiCallback(...x, idx);
            case 2:
                return (x, idx)=>multiCallback(...x, idx, ...broadcastedArrays);
        }
    }
    /**
     * Determines the argument pattern of a regular callback function.
     * @param {Function} callback - The callback function to analyze
     * @param {number} numberOfArrays - Number of arrays being processed
     * @returns {number} 0 = values only, 1 = values + index, 2 = values + index + arrays
     */ function _getCallbackArgCount(callback, numberOfArrays) {
        var callbackStr = callback.toString();
        // Check if the callback function uses `arguments`
        if (/arguments/.test(callbackStr)) return 2;
        // Extract the parameters of the callback function
        var paramsStr = callbackStr.match(/\(.*?\)/);
        // Check if the callback function uses rest parameters
        if (/\.\.\./.test(paramsStr)) return 2;
        if (callback.length > numberOfArrays + 1) return 2;
        if (callback.length === numberOfArrays + 1) return 1;
        return 0;
    }
    /**
  * Determines the argument pattern of a typed callback function.
  * @param {Function} callback - The typed callback function to analyze
  * @param {Array} values - Sample values for signature resolution
  * @param {Array} idx - Sample index for signature resolution
  * @param {Array} arrays - Sample arrays for signature resolution
  * @returns {number} 0 = values only, 1 = values + index, 2 = values + index + arrays
  */ function _getTypedCallbackArgCount(callback, values, idx, arrays) {
        if (typed.resolve(callback, [
            ...values,
            idx,
            ...arrays
        ]) !== null) return 2;
        if (typed.resolve(callback, [
            ...values,
            idx
        ]) !== null) return 1;
        if (typed.resolve(callback, values) !== null) return 0;
        // this should never happen
        return 0;
    }
    /**
  * Map for a multi dimensional array
  * @param {Array} array
  * @param {Function} callback
  * @return {Array}
  * @private
  */ function _mapArray(array, callback) {
        var fastCallback = (0, $bLcpf.optimizeCallback)(callback, array, $05b6ad043a5d641f$var$name);
        return (0, $d80Xp.deepMap)(array, fastCallback.fn, fastCallback.isUnary);
    }
});

});

parcelRegister("6d0If", function(module, exports) {

$parcel$export(module.exports, "createMapSlices", () => $4854827ae4a09383$export$48f9c76d2387349d);

var $dsu7t = parcelRequire("dsu7t");

var $d80Xp = parcelRequire("d80Xp");

var $edQYF = parcelRequire("edQYF");

var $fFsPN = parcelRequire("fFsPN");
var $4854827ae4a09383$var$name = 'mapSlices';
var $4854827ae4a09383$var$dependencies = [
    'typed',
    'isInteger'
];
var $4854827ae4a09383$export$48f9c76d2387349d = /* #__PURE__ */ (0, $dsu7t.factory)($4854827ae4a09383$var$name, $4854827ae4a09383$var$dependencies, (_ref)=>{
    var { typed: typed, isInteger: isInteger } = _ref;
    /**
   * Apply a function that maps an array to a scalar
   * along a given axis of a matrix or array.
   * Returns a new matrix or array with one less dimension than the input.
   *
   * Syntax:
   *
   *     math.mapSlices(A, dim, callback)
   *
   * Where:
   *
   * - `dim: number` is a zero-based dimension over which to concatenate the matrices.
   *
   * Examples:
   *
   *    const A = [[1, 2], [3, 4]]
   *    const sum = math.sum
   *
   *    math.mapSlices(A, 0, sum)             // returns [4, 6]
   *    math.mapSlices(A, 1, sum)             // returns [3, 7]
   *
   * See also:
   *
   *    map, filter, forEach
   *
   * Note:
   *
   *    `mapSlices()` is also currently available via its deprecated
   *    synonym `apply()`.
   *
   * @param {Array | Matrix} array   The input Matrix
   * @param {number} dim             The dimension along which the callback is applied
   * @param {Function} callback      The callback function that is applied. This Function
   *                                 should take an array or 1-d matrix as an input and
   *                                 return a number.
   * @return {Array | Matrix} res    The residual matrix with the function mapped on the slices over some dimension.
   */ return typed($4854827ae4a09383$var$name, {
        'Array | Matrix, number | BigNumber, function': function Array__Matrix_number__BigNumber_function(mat, dim, callback) {
            if (!isInteger(dim)) throw new TypeError('Integer number expected for dimension');
            var size = Array.isArray(mat) ? (0, $d80Xp.arraySize)(mat) : mat.size();
            if (dim < 0 || dim >= size.length) throw new (0, $fFsPN.IndexError)(dim, size.length);
            if ((0, $edQYF.isMatrix)(mat)) return mat.create($4854827ae4a09383$var$_mapSlices(mat.valueOf(), dim, callback), mat.datatype());
            else return $4854827ae4a09383$var$_mapSlices(mat, dim, callback);
        }
    });
}, {
    formerly: 'apply'
});
/**
 * Recursively reduce a matrix
 * @param {Array} mat
 * @param {number} dim
 * @param {Function} callback
 * @returns {Array} ret
 * @private
 */ function $4854827ae4a09383$var$_mapSlices(mat, dim, callback) {
    var i, ret, tran;
    if (dim <= 0) {
        if (!Array.isArray(mat[0])) return callback(mat);
        else {
            tran = $4854827ae4a09383$var$_switch(mat);
            ret = [];
            for(i = 0; i < tran.length; i++)ret[i] = $4854827ae4a09383$var$_mapSlices(tran[i], dim - 1, callback);
            return ret;
        }
    } else {
        ret = [];
        for(i = 0; i < mat.length; i++)ret[i] = $4854827ae4a09383$var$_mapSlices(mat[i], dim - 1, callback);
        return ret;
    }
}
/**
 * Transpose a matrix
 * @param {Array} mat
 * @returns {Array} ret
 * @private
 */ function $4854827ae4a09383$var$_switch(mat) {
    var I = mat.length;
    var J = mat[0].length;
    var i, j;
    var ret = [];
    for(j = 0; j < J; j++){
        var tmp = [];
        for(i = 0; i < I; i++)tmp.push(mat[i][j]);
        ret.push(tmp);
    }
    return ret;
}

});

parcelRegister("61kHv", function(module, exports) {

$parcel$export(module.exports, "createMatrix", () => $4622e4cb271680fa$export$f3cf8b510f9cb8ab);

var $dsu7t = parcelRequire("dsu7t");
var $4622e4cb271680fa$var$name = 'matrix';
var $4622e4cb271680fa$var$dependencies = [
    'typed',
    'Matrix',
    'DenseMatrix',
    'SparseMatrix'
];
var $4622e4cb271680fa$export$f3cf8b510f9cb8ab = /* #__PURE__ */ (0, $dsu7t.factory)($4622e4cb271680fa$var$name, $4622e4cb271680fa$var$dependencies, (_ref)=>{
    var { typed: typed, Matrix: Matrix, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a Matrix. The function creates a new `math.Matrix` object from
   * an `Array`. A Matrix has utility functions to manipulate the data in the
   * matrix, like getting the size and getting or setting values in the matrix.
   * Supported storage formats are 'dense' and 'sparse'.
   *
   * Syntax:
   *
   *    math.matrix()                         // creates an empty matrix using default storage format (dense).
   *    math.matrix(data)                     // creates a matrix with initial data using default storage format (dense).
   *    math.matrix('dense')                  // creates an empty matrix using the given storage format.
   *    math.matrix(data, 'dense')            // creates a matrix with initial data using the given storage format.
   *    math.matrix(data, 'sparse')           // creates a sparse matrix with initial data.
   *    math.matrix(data, 'sparse', 'number') // creates a sparse matrix with initial data, number data type.
   *
   * Examples:
   *
   *    let m = math.matrix([[1, 2], [3, 4]])
   *    m.size()                        // Array [2, 2]
   *    m.resize([3, 2], 5)
   *    m.valueOf()                     // Array [[1, 2], [3, 4], [5, 5]]
   *    m.get([1, 0])                    // number 3
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, number, string, unit, sparse
   *
   * @param {Array | Matrix} [data]    A multi dimensional array
   * @param {string} [format]          The Matrix storage format, either `'dense'` or `'sparse'`
   * @param {string} [datatype]        Type of the values
   *
   * @return {Matrix} The created matrix
   */ return typed($4622e4cb271680fa$var$name, {
        '': function _() {
            return _create([]);
        },
        string: function string(format) {
            return _create([], format);
        },
        'string, string': function string_string(format, datatype) {
            return _create([], format, datatype);
        },
        Array: function Array(data) {
            return _create(data);
        },
        Matrix: function Matrix(data) {
            return _create(data, data.storage());
        },
        'Array | Matrix, string': _create,
        'Array | Matrix, string, string': _create
    });
    /**
   * Create a new Matrix with given storage format
   * @param {Array} data
   * @param {string} [format]
   * @param {string} [datatype]
   * @returns {Matrix} Returns a new Matrix
   * @private
   */ function _create(data, format, datatype) {
        // get storage format constructor
        if (format === 'dense' || format === 'default' || format === undefined) return new DenseMatrix(data, datatype);
        if (format === 'sparse') return new SparseMatrix(data, datatype);
        throw new TypeError('Unknown matrix type ' + JSON.stringify(format) + '.');
    }
});

});

parcelRegister("iL64T", function(module, exports) {

$parcel$export(module.exports, "createMatrixClass", () => $da8154b546720ffc$export$72d485cc3ed6a97a);

var $dsu7t = parcelRequire("dsu7t");
var $da8154b546720ffc$var$name = 'Matrix';
var $da8154b546720ffc$var$dependencies = [];
var $da8154b546720ffc$export$72d485cc3ed6a97a = /* #__PURE__ */ (0, $dsu7t.factory)($da8154b546720ffc$var$name, $da8154b546720ffc$var$dependencies, ()=>{
    /**
   * @constructor Matrix
   *
   * A Matrix is a wrapper around an Array. A matrix can hold a multi dimensional
   * array. A matrix can be constructed as:
   *
   *     let matrix = math.matrix(data)
   *
   * Matrix contains the functions to resize, get and set values, get the size,
   * clone the matrix and to convert the matrix to a vector, array, or scalar.
   * Furthermore, one can iterate over the matrix using map and forEach.
   * The internal Array of the Matrix can be accessed using the function valueOf.
   *
   * Example usage:
   *
   *     let matrix = math.matrix([[1, 2], [3, 4]])
   *     matix.size()              // [2, 2]
   *     matrix.resize([3, 2], 5)
   *     matrix.valueOf()          // [[1, 2], [3, 4], [5, 5]]
   *     matrix.subset([1,2])       // 3 (indexes are zero-based)
   *
   */ function Matrix() {
        if (!(this instanceof Matrix)) throw new SyntaxError('Constructor must be called with the new operator');
    }
    /**
   * Attach type information
   */ Matrix.prototype.type = 'Matrix';
    Matrix.prototype.isMatrix = true;
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()   // retrieve storage format
   *
   * @return {string}           The storage format.
   */ Matrix.prototype.storage = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke storage on a Matrix interface');
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()    // retrieve matrix datatype
   *
   * @return {string}           The datatype.
   */ Matrix.prototype.datatype = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke datatype on a Matrix interface');
    };
    /**
   * Create a new Matrix With the type of the current matrix instance
   * @param {Array | Object} data
   * @param {string} [datatype]
   */ Matrix.prototype.create = function(data, datatype) {
        throw new Error('Cannot invoke create on a Matrix interface');
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ Matrix.prototype.subset = function(index, replacement, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke subset on a Matrix interface');
    };
    /**
   * Get a single element from the matrix.
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ Matrix.prototype.get = function(index) {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke get on a Matrix interface');
    };
    /**
   * Replace a single element in the matrix.
   * @param {number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {Matrix} self
   */ Matrix.prototype.set = function(index, value, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke set on a Matrix interface');
    };
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @param {number[]} size           The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ Matrix.prototype.resize = function(size, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke resize on a Matrix interface');
    };
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * @param {number[]} size           The new size the matrix should have.
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ Matrix.prototype.reshape = function(size, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke reshape on a Matrix interface');
    };
    /**
   * Create a clone of the matrix
   * @return {Matrix} clone
   */ Matrix.prototype.clone = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke clone on a Matrix interface');
    };
    /**
   * Retrieve the size of the matrix.
   * @returns {number[]} size
   */ Matrix.prototype.size = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke size on a Matrix interface');
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *
   * @return {Matrix} matrix
   */ Matrix.prototype.map = function(callback, skipZeros) {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke map on a Matrix interface');
    };
    /**
   * Execute a callback function on each entry of the matrix.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   */ Matrix.prototype.forEach = function(callback) {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke forEach on a Matrix interface');
    };
    /**
   * Iterate over the matrix elements
   * @return {Iterable<{ value, index: number[] }>}
   */ Matrix.prototype[Symbol.iterator] = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot iterate a Matrix interface');
    };
    /**
   * Create an Array with a copy of the data of the Matrix
   * @returns {Array} array
   */ Matrix.prototype.toArray = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke toArray on a Matrix interface');
    };
    /**
   * Get the primitive value of the Matrix: a multidimensional array
   * @returns {Array} array
   */ Matrix.prototype.valueOf = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke valueOf on a Matrix interface');
    };
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ Matrix.prototype.format = function(options) {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke format on a Matrix interface');
    };
    /**
   * Get a string representation of the matrix
   * @returns {string} str
   */ Matrix.prototype.toString = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke toString on a Matrix interface');
    };
    return Matrix;
}, {
    isClass: true
});

});

parcelRegister("cyMSJ", function(module, exports) {

$parcel$export(module.exports, "createMatrixFromColumns", () => $924e93efa94fadac$export$65fefc9f63da4d13);

var $dsu7t = parcelRequire("dsu7t");
var $924e93efa94fadac$var$name = 'matrixFromColumns';
var $924e93efa94fadac$var$dependencies = [
    'typed',
    'matrix',
    'flatten',
    'size'
];
var $924e93efa94fadac$export$65fefc9f63da4d13 = /* #__PURE__ */ (0, $dsu7t.factory)($924e93efa94fadac$var$name, $924e93efa94fadac$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, flatten: flatten, size: size } = _ref;
    /**
   * Create a dense matrix from vectors as individual columns.
   * If you pass row vectors, they will be transposed (but not conjugated!)
   *
   * Syntax:
   *
   *    math.matrixFromColumns(...arr)
   *    math.matrixFromColumns(col1, col2)
   *    math.matrixFromColumns(col1, col2, col3)
   *
   * Examples:
   *
   *    math.matrixFromColumns([1, 2, 3], [[4],[5],[6]])
   *    math.matrixFromColumns(...vectors)
   *
   * See also:
   *
   *    matrix, matrixFromRows, matrixFromFunction, zeros
   *
   * @param {... Array | Matrix} cols Multiple columns
   * @return { number[][] | Matrix } if at least one of the arguments is an array, an array will be returned
   */ return typed($924e93efa94fadac$var$name, {
        '...Array': function Array(arr) {
            return _createArray(arr);
        },
        '...Matrix': function Matrix(arr) {
            return matrix(_createArray(arr.map((m)=>m.toArray())));
        }
    });
    function _createArray(arr) {
        if (arr.length === 0) throw new TypeError('At least one column is needed to construct a matrix.');
        var N = checkVectorTypeAndReturnLength(arr[0]);
        // create an array with empty rows
        var result = [];
        for(var i = 0; i < N; i++)result[i] = [];
        // loop columns
        for (var col of arr){
            var colLength = checkVectorTypeAndReturnLength(col);
            if (colLength !== N) throw new TypeError('The vectors had different length: ' + (N | 0) + " \u2260 " + (colLength | 0));
            var f = flatten(col);
            // push a value to each row
            for(var _i = 0; _i < N; _i++)result[_i].push(f[_i]);
        }
        return result;
    }
    function checkVectorTypeAndReturnLength(vec) {
        var s = size(vec);
        if (s.length === 1) // 1D vector
        return s[0];
        else if (s.length === 2) {
            // 2D vector
            if (s[0] === 1) // row vector
            return s[1];
            else if (s[1] === 1) // col vector
            return s[0];
            else throw new TypeError('At least one of the arguments is not a vector.');
        } else throw new TypeError('Only one- or two-dimensional vectors are supported.');
    }
});

});

parcelRegister("7ARxL", function(module, exports) {

$parcel$export(module.exports, "createMatrixFromFunction", () => $58756dd9da1b36c4$export$983d2c97138363e0);

var $dsu7t = parcelRequire("dsu7t");
var $58756dd9da1b36c4$var$name = 'matrixFromFunction';
var $58756dd9da1b36c4$var$dependencies = [
    'typed',
    'matrix',
    'isZero'
];
var $58756dd9da1b36c4$export$983d2c97138363e0 = /* #__PURE__ */ (0, $dsu7t.factory)($58756dd9da1b36c4$var$name, $58756dd9da1b36c4$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, isZero: isZero } = _ref;
    /**
   * Create a matrix by evaluating a generating function at each index.
   * The simplest overload returns a multi-dimensional array as long as `size`
   * is an array.
   * Passing `size` as a Matrix or specifying a `format` will result in
   * returning a Matrix.
   *
   * Syntax:
   *
   *    math.matrixFromFunction(size, fn)
   *    math.matrixFromFunction(size, fn, format)
   *    math.matrixFromFunction(size, fn, format, datatype)
   *    math.matrixFromFunction(size, format, fn)
   *    math.matrixFromFunction(size, format, datatype, fn)
   *
   * Where:
   *
   *    - `size: (number[] | Matrix)`
   *      A vector giving the extent of the array to be created in each
   *      dimension. If size has one entry, a vector is created; if it
   *      has two, a rectangular array/Matrix is created; if three, a
   *      three-dimensional array/Matrix is created; and so on.
   *    - `fn: (index: number[]) => MathType`
   *      The callback function that will generate the entries of the
   *      matrix. It is called in turn with the index of each entry of
   *      the matrix. The index is always an ordinary array of numbers
   *      with the same length as _size_. So for vectors, you will get
   *      indices like `[0]` or `[1]`, whereas for matrices, you will
   *      get indices like `[2, 0]` or `[1,3]`. The return value may
   *      be any type that can go in an array or Matrix entry, although
   *      if you supply the _datatype_ argument, you must yourself ensure
   *      the type of the return value matches. Note that currently,
   *      your callback _fn_ will receive 0-based indices for the matrix
   *      entries, regardless of whether matrixFromFunction is invoked
   *      directly from JavaScript or via the mathjs expression language.
   *    - `format: 'dense'|'sparse'`
   *      Specifies the storage format for the resulting Matrix. Note that
   *      if this argument is given, the return value will always be a
   *      Matrix (rather than possibly an Array).
   *    - `datatype: string`
   *      Specifies the data type of entries of the new matrix. If given,
   *      it should be the name of a data type that mathjs supports, as
   *      returned by the math.typeOf function. It is up to the caller
   *      to make certain that all values returned by _fn_ are consistent
   *      with this datatype if specified.
   *
   * Examples:
   *
   *    math.matrixFromFunction([3,3], i => i[0] - i[1]) // an antisymmetric matrix
   *    math.matrixFromFunction([100, 100], 'sparse', i => i[0] - i[1] === 1 ? 4 : 0) // a sparse subdiagonal matrix
   *    math.matrixFromFunction([5], i => math.random()) // a random vector
   *
   * See also:
   *
   *    matrix, typeOf, zeros
   *
   * @param {Array | Matrix} size   The size of the matrix to be created
   * @param {function} fn           Callback function invoked for every entry in the matrix
   * @param {string} [format]       The Matrix storage format, either `'dense'` or `'sparse'`
   * @param {string} [datatype]     Type of the values
   * @return {Array | Matrix} Returns the created matrix
   */ return typed($58756dd9da1b36c4$var$name, {
        'Array | Matrix, function, string, string': function Array__Matrix_function_string_string(size, fn, format, datatype) {
            return _create(size, fn, format, datatype);
        },
        'Array | Matrix, function, string': function Array__Matrix_function_string(size, fn, format) {
            return _create(size, fn, format);
        },
        'Matrix, function': function Matrix_function(size, fn) {
            return _create(size, fn, 'dense');
        },
        'Array, function': function Array_function(size, fn) {
            return _create(size, fn, 'dense').toArray();
        },
        'Array | Matrix, string, function': function Array__Matrix_string_function(size, format, fn) {
            return _create(size, fn, format);
        },
        'Array | Matrix, string, string, function': function Array__Matrix_string_string_function(size, format, datatype, fn) {
            return _create(size, fn, format, datatype);
        }
    });
    function _create(size, fn, format, datatype) {
        var m;
        if (datatype !== undefined) m = matrix(format, datatype);
        else m = matrix(format);
        m.resize(size);
        m.forEach(function(_, index) {
            var val = fn(index);
            if (isZero(val)) return;
            m.set(index, val);
        });
        return m;
    }
});

});

parcelRegister("63Mc1", function(module, exports) {

$parcel$export(module.exports, "createMatrixFromRows", () => $469867fec61147ca$export$b72d61f960d7c36b);

var $dsu7t = parcelRequire("dsu7t");
var $469867fec61147ca$var$name = 'matrixFromRows';
var $469867fec61147ca$var$dependencies = [
    'typed',
    'matrix',
    'flatten',
    'size'
];
var $469867fec61147ca$export$b72d61f960d7c36b = /* #__PURE__ */ (0, $dsu7t.factory)($469867fec61147ca$var$name, $469867fec61147ca$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, flatten: flatten, size: size } = _ref;
    /**
   * Create a dense matrix from vectors as individual rows.
   * If you pass column vectors, they will be transposed (but not conjugated!)
   *
   * Syntax:
   *
   *    math.matrixFromRows(...arr)
   *    math.matrixFromRows(row1, row2)
   *    math.matrixFromRows(row1, row2, row3)
   *
   * Examples:
   *
   *    math.matrixFromRows([1, 2, 3], [[4],[5],[6]])
   *    math.matrixFromRows(...vectors)
   *
   * See also:
   *
   *    matrix, matrixFromColumns, matrixFromFunction, zeros
   *
   * @param {... Array | Matrix} rows  Multiple rows
   * @return { number[][] | Matrix } if at least one of the arguments is an array, an array will be returned
   */ return typed($469867fec61147ca$var$name, {
        '...Array': function Array(arr) {
            return _createArray(arr);
        },
        '...Matrix': function Matrix(arr) {
            return matrix(_createArray(arr.map((m)=>m.toArray())));
        }
    });
    function _createArray(arr) {
        if (arr.length === 0) throw new TypeError('At least one row is needed to construct a matrix.');
        var N = checkVectorTypeAndReturnLength(arr[0]);
        var result = [];
        for (var row of arr){
            var rowLength = checkVectorTypeAndReturnLength(row);
            if (rowLength !== N) throw new TypeError('The vectors had different length: ' + (N | 0) + " \u2260 " + (rowLength | 0));
            result.push(flatten(row));
        }
        return result;
    }
    function checkVectorTypeAndReturnLength(vec) {
        var s = size(vec);
        if (s.length === 1) // 1D vector
        return s[0];
        else if (s.length === 2) {
            // 2D vector
            if (s[0] === 1) // row vector
            return s[1];
            else if (s[1] === 1) // col vector
            return s[0];
            else throw new TypeError('At least one of the arguments is not a vector.');
        } else throw new TypeError('Only one- or two-dimensional vectors are supported.');
    }
});

});

parcelRegister("h2Yyg", function(module, exports) {

$parcel$export(module.exports, "createMax", () => $c69197da6d2e9855$export$b18a1b0c26c000ee);

var $20mkw = parcelRequire("20mkw");

var $dsu7t = parcelRequire("dsu7t");

var $6NnhX = parcelRequire("6NnhX");

var $a2CJg = parcelRequire("a2CJg");
var $c69197da6d2e9855$var$name = 'max';
var $c69197da6d2e9855$var$dependencies = [
    'typed',
    'config',
    'numeric',
    'larger',
    'isNaN'
];
var $c69197da6d2e9855$export$b18a1b0c26c000ee = /* #__PURE__ */ (0, $dsu7t.factory)($c69197da6d2e9855$var$name, $c69197da6d2e9855$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, numeric: numeric, larger: larger, isNaN: mathIsNaN } = _ref;
    /**
   * Compute the maximum value of a matrix or a  list with values.
   * In case of a multidimensional array, the maximum of the flattened array
   * will be calculated. When `dim` is provided, the maximum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.max(a, b, c, ...)
   *     math.max(A)
   *     math.max(A, dimension)
   *
   * Examples:
   *
   *     math.max(2, 1, 4, 3)                  // returns 4
   *     math.max([2, 1, 4, 3])                // returns 4
   *
   *     // maximum over a specified dimension (zero-based)
   *     math.max([[2, 5], [4, 3], [1, 7]], 0) // returns [4, 7]
   *     math.max([[2, 5], [4, 3], [1, 7]], 1) // returns [5, 4, 7]
   *
   *     math.max(2.7, 7.1, -4.5, 2.0, 4.1)    // returns 7.1
   *     math.min(2.7, 7.1, -4.5, 2.0, 4.1)    // returns -4.5
   *
   * See also:
   *
   *    mean, median, min, prod, std, sum, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The maximum value
   */ return typed($c69197da6d2e9855$var$name, {
        // max([a, b, c, d, ...])
        'Array | Matrix': _max,
        // max([a, b, c, d, ...], dim)
        'Array | Matrix, number | BigNumber': function Array__Matrix_number__BigNumber(array, dim) {
            return (0, $20mkw.reduce)(array, dim.valueOf(), _largest);
        },
        // max(a, b, c, d, ...)
        '...': function _(args) {
            if ((0, $20mkw.containsCollections)(args)) throw new TypeError('Scalar values expected in function max');
            return _max(args);
        }
    });
    /**
   * Return the largest of two values
   * @param {*} x
   * @param {*} y
   * @returns {*} Returns x when x is largest, or y when y is largest
   * @private
   */ function _largest(x, y) {
        try {
            return larger(x, y) ? x : y;
        } catch (err) {
            throw (0, $a2CJg.improveErrorMessage)(err, 'max', y);
        }
    }
    /**
   * Recursively calculate the maximum value in an n-dimensional array
   * @param {Array} array
   * @return {number} max
   * @private
   */ function _max(array) {
        var res;
        (0, $20mkw.deepForEach)(array, function(value) {
            try {
                if (mathIsNaN(value)) res = value;
                else if (res === undefined || larger(value, res)) res = value;
            } catch (err) {
                throw (0, $a2CJg.improveErrorMessage)(err, 'max', value);
            }
        });
        if (res === undefined) throw new Error('Cannot calculate max of an empty array');
        // make sure returning numeric value: parse a string into a numeric value
        if (typeof res === 'string') res = numeric(res, (0, $6NnhX.safeNumberType)(res, config));
        return res;
    }
});

});

parcelRegister("dthUd", function(module, exports) {

$parcel$export(module.exports, "createMean", () => $9cebdf84a5ce199b$export$301ef7ca1de6782c);

var $20mkw = parcelRequire("20mkw");

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");

var $a2CJg = parcelRequire("a2CJg");
var $9cebdf84a5ce199b$var$name = 'mean';
var $9cebdf84a5ce199b$var$dependencies = [
    'typed',
    'add',
    'divide'
];
var $9cebdf84a5ce199b$export$301ef7ca1de6782c = /* #__PURE__ */ (0, $dsu7t.factory)($9cebdf84a5ce199b$var$name, $9cebdf84a5ce199b$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, divide: divide } = _ref;
    /**
   * Compute the mean value of matrix or a list with values.
   * In case of a multidimensional array, the mean of the flattened array
   * will be calculated. When `dim` is provided, the maximum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.mean(a, b, c, ...)
   *     math.mean(A)
   *     math.mean(A, dimension)
   *
   * Examples:
   *
   *     math.mean(2, 1, 4, 3)                     // returns 2.5
   *     math.mean([1, 2.7, 3.2, 4])               // returns 2.725
   *
   *     math.mean([[2, 5], [6, 3], [1, 7]], 0)    // returns [3, 5]
   *     math.mean([[2, 5], [6, 3], [1, 7]], 1)    // returns [3.5, 4.5, 4]
   *
   * See also:
   *
   *     median, min, max, sum, prod, std, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The mean of all values
   */ return typed($9cebdf84a5ce199b$var$name, {
        // mean([a, b, c, d, ...])
        'Array | Matrix': _mean,
        // mean([a, b, c, d, ...], dim)
        'Array | Matrix, number | BigNumber': _nmeanDim,
        // mean(a, b, c, d, ...)
        '...': function _(args) {
            if ((0, $20mkw.containsCollections)(args)) throw new TypeError('Scalar values expected in function mean');
            return _mean(args);
        }
    });
    /**
   * Calculate the mean value in an n-dimensional array, returning a
   * n-1 dimensional array
   * @param {Array} array
   * @param {number} dim
   * @return {number} mean
   * @private
   */ function _nmeanDim(array, dim) {
        try {
            var sum = (0, $20mkw.reduce)(array, dim, add);
            var s = Array.isArray(array) ? (0, $d80Xp.arraySize)(array) : array.size();
            return divide(sum, s[dim]);
        } catch (err) {
            throw (0, $a2CJg.improveErrorMessage)(err, 'mean');
        }
    }
    /**
   * Recursively calculate the mean value in an n-dimensional array
   * @param {Array} array
   * @return {number} mean
   * @private
   */ function _mean(array) {
        var sum;
        var num = 0;
        (0, $20mkw.deepForEach)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
                num++;
            } catch (err) {
                throw (0, $a2CJg.improveErrorMessage)(err, 'mean', value);
            }
        });
        if (num === 0) throw new Error('Cannot calculate the mean of an empty array');
        return divide(sum, num);
    }
});

});

parcelRegister("5KUxv", function(module, exports) {

$parcel$export(module.exports, "createMedian", () => $430d1b3162b920c0$export$cdebf3fc89add777);

var $20mkw = parcelRequire("20mkw");

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");

var $a2CJg = parcelRequire("a2CJg");
var $430d1b3162b920c0$var$name = 'median';
var $430d1b3162b920c0$var$dependencies = [
    'typed',
    'add',
    'divide',
    'compare',
    'partitionSelect'
];
var $430d1b3162b920c0$export$cdebf3fc89add777 = /* #__PURE__ */ (0, $dsu7t.factory)($430d1b3162b920c0$var$name, $430d1b3162b920c0$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, divide: divide, compare: compare, partitionSelect: partitionSelect } = _ref;
    /**
   * Recursively calculate the median of an n-dimensional array
   * @param {Array} array
   * @return {Number} median
   * @private
   */ function _median(array) {
        try {
            array = (0, $d80Xp.flatten)(array.valueOf());
            var num = array.length;
            if (num === 0) throw new Error('Cannot calculate median of an empty array');
            if (num % 2 === 0) {
                // even: return the average of the two middle values
                var mid = num / 2 - 1;
                var right = partitionSelect(array, mid + 1);
                // array now partitioned at mid + 1, take max of left part
                var left = array[mid];
                for(var i = 0; i < mid; ++i)if (compare(array[i], left) > 0) left = array[i];
                return middle2(left, right);
            } else {
                // odd: return the middle value
                var m = partitionSelect(array, (num - 1) / 2);
                return middle(m);
            }
        } catch (err) {
            throw (0, $a2CJg.improveErrorMessage)(err, 'median');
        }
    }
    // helper function to type check the middle value of the array
    var middle = typed({
        'number | BigNumber | Complex | Unit': function number__BigNumber__Complex__Unit(value) {
            return value;
        }
    });
    // helper function to type check the two middle value of the array
    var middle2 = typed({
        'number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit': function number__BigNumber__Complex__Unit_number__BigNumber__Complex__Unit(left, right) {
            return divide(add(left, right), 2);
        }
    });
    /**
   * Compute the median of a matrix or a list with values. The values are
   * sorted and the middle value is returned. In case of an even number of
   * values, the average of the two middle values is returned.
   * Supported types of values are: Number, BigNumber, Unit
   *
   * In case of a (multi dimensional) array or matrix, the median of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.median(a, b, c, ...)
   *     math.median(A)
   *
   * Examples:
   *
   *     math.median(5, 2, 7)        // returns 5
   *     math.median([3, -1, 5, 7])  // returns 4
   *
   * See also:
   *
   *     mean, min, max, sum, prod, std, variance, quantileSeq
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The median
   */ return typed($430d1b3162b920c0$var$name, {
        // median([a, b, c, d, ...])
        'Array | Matrix': _median,
        // median([a, b, c, d, ...], dim)
        'Array | Matrix, number | BigNumber': function Array__Matrix_number__BigNumber(array, dim) {
            // TODO: implement median(A, dim)
            throw new Error('median(A, dim) is not yet supported');
        // return reduce(arguments[0], arguments[1], ...)
        },
        // median(a, b, c, d, ...)
        '...': function _(args) {
            if ((0, $20mkw.containsCollections)(args)) throw new TypeError('Scalar values expected in function median');
            return _median(args);
        }
    });
});

});

parcelRegister("ejjoZ", function(module, exports) {

$parcel$export(module.exports, "createMin", () => $a6b1e3e48884365e$export$b795f47e2b99170);

var $20mkw = parcelRequire("20mkw");

var $dsu7t = parcelRequire("dsu7t");

var $6NnhX = parcelRequire("6NnhX");

var $a2CJg = parcelRequire("a2CJg");
var $a6b1e3e48884365e$var$name = 'min';
var $a6b1e3e48884365e$var$dependencies = [
    'typed',
    'config',
    'numeric',
    'smaller',
    'isNaN'
];
var $a6b1e3e48884365e$export$b795f47e2b99170 = /* #__PURE__ */ (0, $dsu7t.factory)($a6b1e3e48884365e$var$name, $a6b1e3e48884365e$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, numeric: numeric, smaller: smaller, isNaN: mathIsNaN } = _ref;
    /**
   * Compute the minimum value of a matrix or a  list of values.
   * In case of a multidimensional array, the minimum of the flattened array
   * will be calculated. When `dim` is provided, the minimum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.min(a, b, c, ...)
   *     math.min(A)
   *     math.min(A, dimension)
   *
   * Examples:
   *
   *     math.min(2, 1, 4, 3)                  // returns 1
   *     math.min([2, 1, 4, 3])                // returns 1
   *
   *     // minimum over a specified dimension (zero-based)
   *     math.min([[2, 5], [4, 3], [1, 7]], 0) // returns [1, 3]
   *     math.min([[2, 5], [4, 3], [1, 7]], 1) // returns [2, 3, 1]
   *
   *     math.max(2.7, 7.1, -4.5, 2.0, 4.1)    // returns 7.1
   *     math.min(2.7, 7.1, -4.5, 2.0, 4.1)    // returns -4.5
   *
   * See also:
   *
   *    mean, median, max, prod, std, sum, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The minimum value
   */ return typed($a6b1e3e48884365e$var$name, {
        // min([a, b, c, d, ...])
        'Array | Matrix': _min,
        // min([a, b, c, d, ...], dim)
        'Array | Matrix, number | BigNumber': function Array__Matrix_number__BigNumber(array, dim) {
            return (0, $20mkw.reduce)(array, dim.valueOf(), _smallest);
        },
        // min(a, b, c, d, ...)
        '...': function _(args) {
            if ((0, $20mkw.containsCollections)(args)) throw new TypeError('Scalar values expected in function min');
            return _min(args);
        }
    });
    /**
   * Return the smallest of two values
   * @param {*} x
   * @param {*} y
   * @returns {*} Returns x when x is smallest, or y when y is smallest
   * @private
   */ function _smallest(x, y) {
        try {
            return smaller(x, y) ? x : y;
        } catch (err) {
            throw (0, $a2CJg.improveErrorMessage)(err, 'min', y);
        }
    }
    /**
   * Recursively calculate the minimum value in an n-dimensional array
   * @param {Array} array
   * @return {number} min
   * @private
   */ function _min(array) {
        var min;
        (0, $20mkw.deepForEach)(array, function(value) {
            try {
                if (mathIsNaN(value)) min = value;
                else if (min === undefined || smaller(value, min)) min = value;
            } catch (err) {
                throw (0, $a2CJg.improveErrorMessage)(err, 'min', value);
            }
        });
        if (min === undefined) throw new Error('Cannot calculate min of an empty array');
        // make sure returning numeric value: parse a string into a numeric value
        if (typeof min === 'string') min = numeric(min, (0, $6NnhX.safeNumberType)(min, config));
        return min;
    }
});

});

parcelRegister("86wQA", function(module, exports) {

$parcel$export(module.exports, "createMode", () => $5e685d043db1948d$export$822530980ba269d9);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $5e685d043db1948d$var$name = 'mode';
var $5e685d043db1948d$var$dependencies = [
    'typed',
    'isNaN',
    'isNumeric'
];
var $5e685d043db1948d$export$822530980ba269d9 = /* #__PURE__ */ (0, $dsu7t.factory)($5e685d043db1948d$var$name, $5e685d043db1948d$var$dependencies, (_ref)=>{
    var { typed: typed, isNaN: mathIsNaN, isNumeric: isNumeric } = _ref;
    /**
  * Computes the mode of a set of numbers or a list with values(numbers or characters).
  * If there are multiple modes, it returns a list of those values.
  *
  * Syntax:
  *
  *     math.mode(a, b, c, ...)
  *     math.mode(A)
  *
  * Examples:
  *
  *     math.mode(2, 1, 4, 3, 1)                            // returns [1]
  *     math.mode([1, 2.7, 3.2, 4, 2.7])                    // returns [2.7]
  *     math.mode(1, 4, 6, 1, 6)                             // returns [1, 6]
  *     math.mode('a','a','b','c')                           // returns ["a"]
  *     math.mode(1, 1.5, 'abc')                             // returns [1, 1.5, "abc"]
  *
  * See also:
  *
  *     median,
  *     mean
  *
  * @param {... *} args  A single matrix
  * @return {*} The mode of all values
  */ return typed($5e685d043db1948d$var$name, {
        'Array | Matrix': _mode,
        '...': function _(args) {
            return _mode(args);
        }
    });
    /**
   * Calculates the mode in an 1-dimensional array
   * @param {Array} values
   * @return {Array} mode
   * @private
   */ function _mode(values) {
        values = (0, $d80Xp.flatten)(values.valueOf());
        var num = values.length;
        if (num === 0) throw new Error('Cannot calculate mode of an empty array');
        var count = {};
        var mode = [];
        var max = 0;
        for(var i = 0; i < values.length; i++){
            var value = values[i];
            if (isNumeric(value) && mathIsNaN(value)) throw new Error('Cannot calculate mode of an array containing NaN values');
            if (!(value in count)) count[value] = 0;
            count[value]++;
            if (count[value] === max) mode.push(value);
            else if (count[value] > max) {
                max = count[value];
                mode = [
                    value
                ];
            }
        }
        return mode;
    }
});

});

parcelRegister("cA8qu", function(module, exports) {

$parcel$export(module.exports, "createMultinomial", () => $928f621a4450335c$export$b15aee1001d110);

var $20mkw = parcelRequire("20mkw");

var $dsu7t = parcelRequire("dsu7t");
var $928f621a4450335c$var$name = 'multinomial';
var $928f621a4450335c$var$dependencies = [
    'typed',
    'add',
    'divide',
    'multiply',
    'factorial',
    'isInteger',
    'isPositive'
];
var $928f621a4450335c$export$b15aee1001d110 = /* #__PURE__ */ (0, $dsu7t.factory)($928f621a4450335c$var$name, $928f621a4450335c$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, divide: divide, multiply: multiply, factorial: factorial, isInteger: isInteger, isPositive: isPositive } = _ref;
    /**
   * Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities.
   *
   * multinomial takes one array of integers as an argument.
   * The following condition must be enforced: every ai <= 0
   *
   * Syntax:
   *
   *     math.multinomial(a) // a is an array type
   *
   * Examples:
   *
   *    math.multinomial([1,2,1]) // returns 12
   *
   * See also:
   *
   *    combinations, factorial
   *
   * @param {number[] | BigNumber[]} a    Integer numbers of objects in the subset
   * @return {Number | BigNumber}         Multinomial coefficient.
   */ return typed($928f621a4450335c$var$name, {
        'Array | Matrix': function Array__Matrix(a) {
            var sum = 0;
            var denom = 1;
            (0, $20mkw.deepForEach)(a, function(ai) {
                if (!isInteger(ai) || !isPositive(ai)) throw new TypeError('Positive integer value expected in function multinomial');
                sum = add(sum, ai);
                denom = multiply(denom, factorial(ai));
            });
            return divide(factorial(sum), denom);
        }
    });
});

});

parcelRegister("1VBfJ", function(module, exports) {

$parcel$export(module.exports, "createMultiply", () => $167802f07b66c3f1$export$86d08fd318fa07c8);

var $dsu7t = parcelRequire("dsu7t");

var $edQYF = parcelRequire("edQYF");

var $d80Xp = parcelRequire("d80Xp");

var $52JKA = parcelRequire("52JKA");

var $dK2sh = parcelRequire("dK2sh");
var $167802f07b66c3f1$var$name = 'multiply';
var $167802f07b66c3f1$var$dependencies = [
    'typed',
    'matrix',
    'addScalar',
    'multiplyScalar',
    'equalScalar',
    'dot'
];
var $167802f07b66c3f1$export$86d08fd318fa07c8 = /* #__PURE__ */ (0, $dsu7t.factory)($167802f07b66c3f1$var$name, $167802f07b66c3f1$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, addScalar: addScalar, multiplyScalar: multiplyScalar, equalScalar: equalScalar, dot: dot } = _ref;
    var matAlgo11xS0s = (0, $52JKA.createMatAlgo11xS0s)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo14xDs = (0, $dK2sh.createMatAlgo14xDs)({
        typed: typed
    });
    function _validateMatrixDimensions(size1, size2) {
        // check left operand dimensions
        switch(size1.length){
            case 1:
                // check size2
                switch(size2.length){
                    case 1:
                        // Vector x Vector
                        if (size1[0] !== size2[0]) // throw error
                        throw new RangeError('Dimension mismatch in multiplication. Vectors must have the same length');
                        break;
                    case 2:
                        // Vector x Matrix
                        if (size1[0] !== size2[0]) // throw error
                        throw new RangeError('Dimension mismatch in multiplication. Vector length (' + size1[0] + ') must match Matrix rows (' + size2[0] + ')');
                        break;
                    default:
                        throw new Error('Can only multiply a 1 or 2 dimensional matrix (Matrix B has ' + size2.length + ' dimensions)');
                }
                break;
            case 2:
                // check size2
                switch(size2.length){
                    case 1:
                        // Matrix x Vector
                        if (size1[1] !== size2[0]) // throw error
                        throw new RangeError('Dimension mismatch in multiplication. Matrix columns (' + size1[1] + ') must match Vector length (' + size2[0] + ')');
                        break;
                    case 2:
                        // Matrix x Matrix
                        if (size1[1] !== size2[0]) // throw error
                        throw new RangeError('Dimension mismatch in multiplication. Matrix A columns (' + size1[1] + ') must match Matrix B rows (' + size2[0] + ')');
                        break;
                    default:
                        throw new Error('Can only multiply a 1 or 2 dimensional matrix (Matrix B has ' + size2.length + ' dimensions)');
                }
                break;
            default:
                throw new Error('Can only multiply a 1 or 2 dimensional matrix (Matrix A has ' + size1.length + ' dimensions)');
        }
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (N)
   * @param {Matrix} b            Dense Vector   (N)
   *
   * @return {number}             Scalar value
   */ function _multiplyVectorVector(a, b, n) {
        // check empty vector
        if (n === 0) throw new Error('Cannot multiply two empty vectors');
        return dot(a, b);
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (M)
   * @param {Matrix} b            Matrix         (MxN)
   *
   * @return {Matrix}             Dense Vector   (N)
   */ function _multiplyVectorMatrix(a, b) {
        // process storage
        if (b.storage() !== 'dense') throw new Error('Support for SparseMatrix not implemented');
        return _multiplyVectorDenseMatrix(a, b);
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (M)
   * @param {Matrix} b            Dense Matrix   (MxN)
   *
   * @return {Matrix}             Dense Vector   (N)
   */ function _multiplyVectorDenseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype || a.getDataType();
        // b dense
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype || b.getDataType();
        // rows & columns
        var alength = asize[0];
        var bcolumns = bsize[1];
        // datatype
        var dt;
        // addScalar signature to use
        var af = addScalar;
        // multiplyScalar signature to use
        var mf = multiplyScalar;
        // process data types
        if (adt && bdt && adt === bdt && typeof adt === 'string' && adt !== 'mixed') {
            // datatype
            dt = adt;
            // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        }
        // result
        var c = [];
        // loop matrix columns
        for(var j = 0; j < bcolumns; j++){
            // sum (do not initialize it with zero)
            var sum = mf(adata[0], bdata[0][j]);
            // loop vector
            for(var i = 1; i < alength; i++)// multiply & accumulate
            sum = af(sum, mf(adata[i], bdata[i][j]));
            c[j] = sum;
        }
        // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                bcolumns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Matrix         (MxN)
   * @param {Matrix} b            Dense Vector   (N)
   *
   * @return {Matrix}             Dense Vector   (M)
   */ var _multiplyMatrixVector = typed('_multiplyMatrixVector', {
        'DenseMatrix, any': _multiplyDenseMatrixVector,
        'SparseMatrix, any': _multiplySparseMatrixVector
    });
    /**
   * C = A * B
   *
   * @param {Matrix} a            Matrix         (MxN)
   * @param {Matrix} b            Matrix         (NxC)
   *
   * @return {Matrix}             Matrix         (MxC)
   */ var _multiplyMatrixMatrix = typed('_multiplyMatrixMatrix', {
        'DenseMatrix, DenseMatrix': _multiplyDenseMatrixDenseMatrix,
        'DenseMatrix, SparseMatrix': _multiplyDenseMatrixSparseMatrix,
        'SparseMatrix, DenseMatrix': _multiplySparseMatrixDenseMatrix,
        'SparseMatrix, SparseMatrix': _multiplySparseMatrixSparseMatrix
    });
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix  (MxN)
   * @param {Matrix} b            Dense Vector (N)
   *
   * @return {Matrix}             Dense Vector (M)
   */ function _multiplyDenseMatrixVector(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype || a.getDataType();
        // b dense
        var bdata = b._data;
        var bdt = b._datatype || b.getDataType();
        // rows & columns
        var arows = asize[0];
        var acolumns = asize[1];
        // datatype
        var dt;
        // addScalar signature to use
        var af = addScalar;
        // multiplyScalar signature to use
        var mf = multiplyScalar;
        // process data types
        if (adt && bdt && adt === bdt && typeof adt === 'string' && adt !== 'mixed') {
            // datatype
            dt = adt;
            // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        }
        // result
        var c = [];
        // loop matrix a rows
        for(var i = 0; i < arows; i++){
            // current row
            var row = adata[i];
            // sum (do not initialize it with zero)
            var sum = mf(row[0], bdata[0]);
            // loop matrix a columns
            for(var j = 1; j < acolumns; j++)// multiply & accumulate
            sum = af(sum, mf(row[j], bdata[j]));
            c[i] = sum;
        }
        // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                arows
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix    (MxN)
   * @param {Matrix} b            DenseMatrix    (NxC)
   *
   * @return {Matrix}             DenseMatrix    (MxC)
   */ function _multiplyDenseMatrixDenseMatrix(a, b) {
        // getDataType()
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype || a.getDataType();
        // b dense
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype || b.getDataType();
        // rows & columns
        var arows = asize[0];
        var acolumns = asize[1];
        var bcolumns = bsize[1];
        // datatype
        var dt;
        // addScalar signature to use
        var af = addScalar;
        // multiplyScalar signature to use
        var mf = multiplyScalar;
        // process data types
        if (adt && bdt && adt === bdt && typeof adt === 'string' && adt !== 'mixed' && adt !== 'mixed') {
            // datatype
            dt = adt;
            // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        }
        // result
        var c = [];
        // loop matrix a rows
        for(var i = 0; i < arows; i++){
            // current row
            var row = adata[i];
            // initialize row array
            c[i] = [];
            // loop matrix b columns
            for(var j = 0; j < bcolumns; j++){
                // sum (avoid initializing sum to zero)
                var sum = mf(row[0], bdata[0][j]);
                // loop matrix a columns
                for(var x = 1; x < acolumns; x++)// multiply & accumulate
                sum = af(sum, mf(row[x], bdata[x][j]));
                c[i][j] = sum;
            }
        }
        // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                arows,
                bcolumns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix    (MxN)
   * @param {Matrix} b            SparseMatrix   (NxC)
   *
   * @return {Matrix}             SparseMatrix   (MxC)
   */ function _multiplyDenseMatrixSparseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype || a.getDataType();
        // b sparse
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype || b._data === undefined ? b._datatype : b.getDataType();
        // validate b matrix
        if (!bvalues) throw new Error('Cannot multiply Dense Matrix times Pattern only Matrix');
        // rows & columns
        var arows = asize[0];
        var bcolumns = bsize[1];
        // datatype
        var dt;
        // addScalar signature to use
        var af = addScalar;
        // multiplyScalar signature to use
        var mf = multiplyScalar;
        // equalScalar signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // process data types
        if (adt && bdt && adt === bdt && typeof adt === 'string' && adt !== 'mixed') {
            // datatype
            dt = adt;
            // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        }
        // result
        var cvalues = [];
        var cindex = [];
        var cptr = [];
        // c matrix
        var c = b.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
        // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length;
            // indeces in column jb
            var kb0 = bptr[jb];
            var kb1 = bptr[jb + 1];
            // do not process column jb if no data exists
            if (kb1 > kb0) {
                // last row mark processed
                var last = 0;
                // loop a rows
                for(var i = 0; i < arows; i++){
                    // column mark
                    var mark = i + 1;
                    // C[i, jb]
                    var cij = void 0;
                    // values in b column j
                    for(var kb = kb0; kb < kb1; kb++){
                        // row
                        var ib = bindex[kb];
                        // check value has been initialized
                        if (last !== mark) {
                            // first value in column jb
                            cij = mf(adata[i][ib], bvalues[kb]);
                            // update mark
                            last = mark;
                        } else // accumulate value
                        cij = af(cij, mf(adata[i][ib], bvalues[kb]));
                    }
                    // check column has been processed and value != 0
                    if (last === mark && !eq(cij, zero)) {
                        // push row & value
                        cindex.push(i);
                        cvalues.push(cij);
                    }
                }
            }
        }
        // update ptr
        cptr[bcolumns] = cindex.length;
        // return sparse matrix
        return c;
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix    (MxN)
   * @param {Matrix} b            Dense Vector (N)
   *
   * @return {Matrix}             SparseMatrix    (M, 1)
   */ function _multiplySparseMatrixVector(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype || a._data === undefined ? a._datatype : a.getDataType();
        // validate a matrix
        if (!avalues) throw new Error('Cannot multiply Pattern only Matrix times Dense Matrix');
        // b dense
        var bdata = b._data;
        var bdt = b._datatype || b.getDataType();
        // rows & columns
        var arows = a._size[0];
        var brows = b._size[0];
        // result
        var cvalues = [];
        var cindex = [];
        var cptr = [];
        // datatype
        var dt;
        // addScalar signature to use
        var af = addScalar;
        // multiplyScalar signature to use
        var mf = multiplyScalar;
        // equalScalar signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // process data types
        if (adt && bdt && adt === bdt && typeof adt === 'string' && adt !== 'mixed') {
            // datatype
            dt = adt;
            // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        }
        // workspace
        var x = [];
        // vector with marks indicating a value x[i] exists in a given column
        var w = [];
        // update ptr
        cptr[0] = 0;
        // rows in b
        for(var ib = 0; ib < brows; ib++){
            // b[ib]
            var vbi = bdata[ib];
            // check b[ib] != 0, avoid loops
            if (!eq(vbi, zero)) // A values & index in ib column
            for(var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                // a row
                var ia = aindex[ka];
                // check value exists in current j
                if (!w[ia]) {
                    // ia is new entry in j
                    w[ia] = true;
                    // add i to pattern of C
                    cindex.push(ia);
                    // x(ia) = A
                    x[ia] = mf(vbi, avalues[ka]);
                } else // i exists in C already
                x[ia] = af(x[ia], mf(vbi, avalues[ka]));
            }
        }
        // copy values from x to column jb of c
        for(var p1 = cindex.length, p = 0; p < p1; p++){
            // row
            var ic = cindex[p];
            // copy value
            cvalues[p] = x[ic];
        }
        // update ptr
        cptr[1] = cindex.length;
        // matrix to return
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                1
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix      (MxN)
   * @param {Matrix} b            DenseMatrix       (NxC)
   *
   * @return {Matrix}             SparseMatrix      (MxC)
   */ function _multiplySparseMatrixDenseMatrix(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype || a._data === undefined ? a._datatype : a.getDataType();
        // validate a matrix
        if (!avalues) throw new Error('Cannot multiply Pattern only Matrix times Dense Matrix');
        // b dense
        var bdata = b._data;
        var bdt = b._datatype || b.getDataType();
        // rows & columns
        var arows = a._size[0];
        var brows = b._size[0];
        var bcolumns = b._size[1];
        // datatype
        var dt;
        // addScalar signature to use
        var af = addScalar;
        // multiplyScalar signature to use
        var mf = multiplyScalar;
        // equalScalar signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        // process data types
        if (adt && bdt && adt === bdt && typeof adt === 'string' && adt !== 'mixed') {
            // datatype
            dt = adt;
            // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]);
            // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        }
        // result
        var cvalues = [];
        var cindex = [];
        var cptr = [];
        // c matrix
        var c = a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
        // workspace
        var x = [];
        // vector with marks indicating a value x[i] exists in a given column
        var w = [];
        // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length;
            // mark in workspace for current column
            var mark = jb + 1;
            // rows in jb
            for(var ib = 0; ib < brows; ib++){
                // b[ib, jb]
                var vbij = bdata[ib][jb];
                // check b[ib, jb] != 0, avoid loops
                if (!eq(vbij, zero)) // A values & index in ib column
                for(var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // a row
                    var ia = aindex[ka];
                    // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark;
                        // add i to pattern of C
                        cindex.push(ia);
                        // x(ia) = A
                        x[ia] = mf(vbij, avalues[ka]);
                    } else // i exists in C already
                    x[ia] = af(x[ia], mf(vbij, avalues[ka]));
                }
            }
            // copy values from x to column jb of c
            for(var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++){
                // row
                var ic = cindex[p];
                // copy value
                cvalues[p] = x[ic];
            }
        }
        // update ptr
        cptr[bcolumns] = cindex.length;
        // return sparse matrix
        return c;
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix      (MxN)
   * @param {Matrix} b            SparseMatrix      (NxC)
   *
   * @return {Matrix}             SparseMatrix      (MxC)
   */ function _multiplySparseMatrixSparseMatrix(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype || a._data === undefined ? a._datatype : a.getDataType();
        // b sparse
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bdt = b._datatype || b._data === undefined ? b._datatype : b.getDataType();
        // rows & columns
        var arows = a._size[0];
        var bcolumns = b._size[1];
        // flag indicating both matrices (a & b) contain data
        var values = avalues && bvalues;
        // datatype
        var dt;
        // addScalar signature to use
        var af = addScalar;
        // multiplyScalar signature to use
        var mf = multiplyScalar;
        // process data types
        if (adt && bdt && adt === bdt && typeof adt === 'string' && adt !== 'mixed') {
            // datatype
            dt = adt;
            // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        }
        // result
        var cvalues = values ? [] : undefined;
        var cindex = [];
        var cptr = [];
        // c matrix
        var c = a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: adt === a._datatype && bdt === b._datatype ? dt : undefined
        });
        // workspace
        var x = values ? [] : undefined;
        // vector with marks indicating a value x[i] exists in a given column
        var w = [];
        // variables
        var ka, ka0, ka1, kb, kb0, kb1, ia, ib;
        // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length;
            // mark in workspace for current column
            var mark = jb + 1;
            // B values & index in j
            for(kb0 = bptr[jb], kb1 = bptr[jb + 1], kb = kb0; kb < kb1; kb++){
                // b row
                ib = bindex[kb];
                // check we need to process values
                if (values) // loop values in a[:,ib]
                for(ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // row
                    ia = aindex[ka];
                    // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark;
                        // add i to pattern of C
                        cindex.push(ia);
                        // x(ia) = A
                        x[ia] = mf(bvalues[kb], avalues[ka]);
                    } else // i exists in C already
                    x[ia] = af(x[ia], mf(bvalues[kb], avalues[ka]));
                }
                else // loop values in a[:,ib]
                for(ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // row
                    ia = aindex[ka];
                    // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark;
                        // add i to pattern of C
                        cindex.push(ia);
                    }
                }
            }
            // check we need to process matrix values (pattern matrix)
            if (values) // copy values from x to column jb of c
            for(var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++){
                // row
                var ic = cindex[p];
                // copy value
                cvalues[p] = x[ic];
            }
        }
        // update ptr
        cptr[bcolumns] = cindex.length;
        // return sparse matrix
        return c;
    }
    /**
   * Multiply two or more values, `x * y`.
   * For matrices, the matrix product is calculated.
   *
   * Syntax:
   *
   *    math.multiply(x, y)
   *    math.multiply(x, y, z, ...)
   *
   * Examples:
   *
   *    math.multiply(4, 5.2)        // returns number 20.8
   *    math.multiply(2, 3, 4)       // returns number 24
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(4, 1)
   *    math.multiply(a, b)          // returns Complex 5 + 14i
   *
   *    const c = [[1, 2], [4, 3]]
   *    const d = [[1, 2, 3], [3, -4, 7]]
   *    math.multiply(c, d)          // returns Array [[7, -6, 17], [13, -4, 33]]
   *
   *    const e = math.unit('2.1 km')
   *    math.multiply(3, e)          // returns Unit 6.3 km
   *
   * See also:
   *
   *    divide, prod, cross, dot
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} x First value to multiply
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} y Second value to multiply
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} Multiplication of `x` and `y`
   */ return typed($167802f07b66c3f1$var$name, multiplyScalar, {
        // we extend the signatures of multiplyScalar with signatures dealing with matrices
        'Array, Array': typed.referTo('Matrix, Matrix', (selfMM)=>(x, y)=>{
                // check dimensions
                _validateMatrixDimensions((0, $d80Xp.arraySize)(x), (0, $d80Xp.arraySize)(y));
                // use dense matrix implementation
                var m = selfMM(matrix(x), matrix(y));
                // return array or scalar
                return (0, $edQYF.isMatrix)(m) ? m.valueOf() : m;
            }),
        'Matrix, Matrix': function Matrix_Matrix(x, y) {
            // dimensions
            var xsize = x.size();
            var ysize = y.size();
            // check dimensions
            _validateMatrixDimensions(xsize, ysize);
            // process dimensions
            if (xsize.length === 1) {
                // process y dimensions
                if (ysize.length === 1) // Vector * Vector
                return _multiplyVectorVector(x, y, xsize[0]);
                // Vector * Matrix
                return _multiplyVectorMatrix(x, y);
            }
            // process y dimensions
            if (ysize.length === 1) // Matrix * Vector
            return _multiplyMatrixVector(x, y);
            // Matrix * Matrix
            return _multiplyMatrixMatrix(x, y);
        },
        'Matrix, Array': typed.referTo('Matrix,Matrix', (selfMM)=>(x, y)=>selfMM(x, matrix(y))),
        'Array, Matrix': typed.referToSelf((self)=>(x, y)=>{
                // use Matrix * Matrix implementation
                return self(matrix(x, y.storage()), y);
            }),
        'SparseMatrix, any': function SparseMatrix_any(x, y) {
            return matAlgo11xS0s(x, y, multiplyScalar, false);
        },
        'DenseMatrix, any': function DenseMatrix_any(x, y) {
            return matAlgo14xDs(x, y, multiplyScalar, false);
        },
        'any, SparseMatrix': function any_SparseMatrix(x, y) {
            return matAlgo11xS0s(y, x, multiplyScalar, true);
        },
        'any, DenseMatrix': function any_DenseMatrix(x, y) {
            return matAlgo14xDs(y, x, multiplyScalar, true);
        },
        'Array, any': function Array_any(x, y) {
            // use matrix implementation
            return matAlgo14xDs(matrix(x), y, multiplyScalar, false).valueOf();
        },
        'any, Array': function any_Array(x, y) {
            // use matrix implementation
            return matAlgo14xDs(matrix(y), x, multiplyScalar, true).valueOf();
        },
        'any, any': multiplyScalar,
        'any, any, ...any': typed.referToSelf((self)=>(x, y, rest)=>{
                var result = self(x, y);
                for(var i = 0; i < rest.length; i++)result = self(result, rest[i]);
                return result;
            })
    });
});

});

parcelRegister("6MVKQ", function(module, exports) {

$parcel$export(module.exports, "createMultiplyScalar", () => $4f1406a2c3078b93$export$37dc64d7e8361b32);

var $dsu7t = parcelRequire("dsu7t");

var $dmcGu = parcelRequire("dmcGu");
var $4f1406a2c3078b93$var$name = 'multiplyScalar';
var $4f1406a2c3078b93$var$dependencies = [
    'typed'
];
var $4f1406a2c3078b93$export$37dc64d7e8361b32 = /* #__PURE__ */ (0, $dsu7t.factory)($4f1406a2c3078b93$var$name, $4f1406a2c3078b93$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Multiply two scalar values, `x * y`.
   * This function is meant for internal use: it is used by the public function
   * `multiply`
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit} x   First value to multiply
   * @param  {number | BigNumber | bigint | Fraction | Complex} y          Second value to multiply
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit}     Multiplication of `x` and `y`
   * @private
   */ return typed('multiplyScalar', {
        'number, number': (0, $dmcGu.multiplyNumber),
        'Complex, Complex': function Complex_Complex(x, y) {
            return x.mul(y);
        },
        'BigNumber, BigNumber': function BigNumber_BigNumber(x, y) {
            return x.times(y);
        },
        'bigint, bigint': function bigint_bigint(x, y) {
            return x * y;
        },
        'Fraction, Fraction': function Fraction_Fraction(x, y) {
            return x.mul(y);
        },
        'number | Fraction | BigNumber | Complex, Unit': (x, y)=>y.multiply(x),
        'Unit, number | Fraction | BigNumber | Complex | Unit': (x, y)=>x.multiply(y)
    });
});

});

parcelRegister("jA7Yu", function(module, exports) {

$parcel$export(module.exports, "createNorm", () => $e41790b2edfe9352$export$ce85a9d2952c2966);

var $dsu7t = parcelRequire("dsu7t");
var $e41790b2edfe9352$var$name = 'norm';
var $e41790b2edfe9352$var$dependencies = [
    'typed',
    'abs',
    'add',
    'pow',
    'conj',
    'sqrt',
    'multiply',
    'equalScalar',
    'larger',
    'smaller',
    'matrix',
    'ctranspose',
    'eigs'
];
var $e41790b2edfe9352$export$ce85a9d2952c2966 = /* #__PURE__ */ (0, $dsu7t.factory)($e41790b2edfe9352$var$name, $e41790b2edfe9352$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, pow: pow, conj: conj, sqrt: sqrt, multiply: multiply, equalScalar: equalScalar, larger: larger, smaller: smaller, matrix: matrix, ctranspose: ctranspose, eigs: eigs } = _ref;
    /**
   * Calculate the norm of a number, vector or matrix.
   *
   * The second parameter p is optional. If not provided, it defaults to 2.
   *
   * Syntax:
   *
   *    math.norm(x)
   *    math.norm(x, p)
   *
   * Examples:
   *
   *    math.abs(-3.5)                         // returns 3.5
   *    math.norm(-3.5)                        // returns 3.5
   *
   *    math.norm(math.complex(3, -4))         // returns 5
   *
   *    math.norm([1, 2, -3], Infinity)        // returns 3
   *    math.norm([1, 2, -3], -Infinity)       // returns 1
   *
   *    math.norm([3, 4], 2)                   // returns 5
   *
   *    math.norm([[1, 2], [3, 4]], 1)          // returns 6
   *    math.norm([[1, 2], [3, 4]], 'inf')     // returns 7
   *    math.norm([[1, 2], [3, 4]], 'fro')     // returns 5.477225575051661
   *
   * See also:
   *
   *    abs, hypot
   *
   * @param  {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the norm
   * @param  {number | BigNumber | string} [p=2]
   *            Vector space.
   *            Supported numbers include Infinity and -Infinity.
   *            Supported strings are: 'inf', '-inf', and 'fro' (The Frobenius norm)
   * @return {number | BigNumber} the p-norm
   */ return typed($e41790b2edfe9352$var$name, {
        number: Math.abs,
        Complex: function Complex(x) {
            return x.abs();
        },
        BigNumber: function BigNumber(x) {
            // norm(x) = abs(x)
            return x.abs();
        },
        boolean: function boolean(x) {
            // norm(x) = abs(x)
            return Math.abs(x);
        },
        Array: function Array(x) {
            return _norm(matrix(x), 2);
        },
        Matrix: function Matrix(x) {
            return _norm(x, 2);
        },
        'Array, number | BigNumber | string': function Array_number__BigNumber__string(x, p) {
            return _norm(matrix(x), p);
        },
        'Matrix, number | BigNumber | string': function Matrix_number__BigNumber__string(x, p) {
            return _norm(x, p);
        }
    });
    /**
   * Calculate the plus infinity norm for a vector
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _vectorNormPlusInfinity(x) {
        // norm(x, Infinity) = max(abs(x))
        var pinf = 0;
        // skip zeros since abs(0) === 0
        x.forEach(function(value) {
            var v = abs(value);
            if (larger(v, pinf)) pinf = v;
        }, true);
        return pinf;
    }
    /**
   * Calculate the minus infinity norm for a vector
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _vectorNormMinusInfinity(x) {
        // norm(x, -Infinity) = min(abs(x))
        var ninf;
        // skip zeros since abs(0) === 0
        x.forEach(function(value) {
            var v = abs(value);
            if (!ninf || smaller(v, ninf)) ninf = v;
        }, true);
        return ninf || 0;
    }
    /**
   * Calculate the norm for a vector
   * @param {Matrix} x
   * @param {number | string} p
   * @returns {number} Returns the norm
   * @private
   */ function _vectorNorm(x, p) {
        // check p
        if (p === Number.POSITIVE_INFINITY || p === 'inf') return _vectorNormPlusInfinity(x);
        if (p === Number.NEGATIVE_INFINITY || p === '-inf') return _vectorNormMinusInfinity(x);
        if (p === 'fro') return _norm(x, 2);
        if (typeof p === 'number' && !isNaN(p)) {
            // check p != 0
            if (!equalScalar(p, 0)) {
                // norm(x, p) = sum(abs(xi) ^ p) ^ 1/p
                var n = 0;
                // skip zeros since abs(0) === 0
                x.forEach(function(value) {
                    n = add(pow(abs(value), p), n);
                }, true);
                return pow(n, 1 / p);
            }
            return Number.POSITIVE_INFINITY;
        }
        // invalid parameter value
        throw new Error('Unsupported parameter value');
    }
    /**
   * Calculate the Frobenius norm for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormFrobenius(x) {
        // norm(x) = sqrt(sum(diag(x'x)))
        var fro = 0;
        x.forEach(function(value, index) {
            fro = add(fro, multiply(value, conj(value)));
        });
        return abs(sqrt(fro));
    }
    /**
   * Calculate the norm L1 for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormOne(x) {
        // norm(x) = the largest column sum
        var c = [];
        // result
        var maxc = 0;
        // skip zeros since abs(0) == 0
        x.forEach(function(value, index) {
            var j = index[1];
            var cj = add(c[j] || 0, abs(value));
            if (larger(cj, maxc)) maxc = cj;
            c[j] = cj;
        }, true);
        return maxc;
    }
    /**
   * Calculate the norm L2 for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormTwo(x) {
        // norm(x) = sqrt( max eigenvalue of A*.A)
        var sizeX = x.size();
        if (sizeX[0] !== sizeX[1]) throw new RangeError('Invalid matrix dimensions');
        var tx = ctranspose(x);
        var squaredX = multiply(tx, x);
        var eigenVals = eigs(squaredX).values.toArray();
        var rho = eigenVals[eigenVals.length - 1];
        return abs(sqrt(rho));
    }
    /**
   * Calculate the infinity norm for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormInfinity(x) {
        // norm(x) = the largest row sum
        var r = [];
        // result
        var maxr = 0;
        // skip zeros since abs(0) == 0
        x.forEach(function(value, index) {
            var i = index[0];
            var ri = add(r[i] || 0, abs(value));
            if (larger(ri, maxr)) maxr = ri;
            r[i] = ri;
        }, true);
        return maxr;
    }
    /**
   * Calculate the norm for a 2D Matrix (M*N)
   * @param {Matrix} x
   * @param {number | string} p
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNorm(x, p) {
        // check p
        if (p === 1) return _matrixNormOne(x);
        if (p === Number.POSITIVE_INFINITY || p === 'inf') return _matrixNormInfinity(x);
        if (p === 'fro') return _matrixNormFrobenius(x);
        if (p === 2) return _matrixNormTwo(x);
         // invalid parameter value
        throw new Error('Unsupported parameter value ' + p);
    }
    /**
   * Calculate the norm for an array
   * @param {Matrix} x
   * @param {number | string} p
   * @returns {number} Returns the norm
   * @private
   */ function _norm(x, p) {
        // size
        var sizeX = x.size();
        // check if it is a vector
        if (sizeX.length === 1) return _vectorNorm(x, p);
        // MxN matrix
        if (sizeX.length === 2) {
            if (sizeX[0] && sizeX[1]) return _matrixNorm(x, p);
            else throw new RangeError('Invalid matrix dimensions');
        }
    }
});

});

parcelRegister("j4eto", function(module, exports) {

$parcel$export(module.exports, "createNot", () => $de199e14e4d22b49$export$8dbfb388cd6a8853);

var $20mkw = parcelRequire("20mkw");

var $dsu7t = parcelRequire("dsu7t");

var $69vHM = parcelRequire("69vHM");
var $de199e14e4d22b49$var$name = 'not';
var $de199e14e4d22b49$var$dependencies = [
    'typed'
];
var $de199e14e4d22b49$export$8dbfb388cd6a8853 = /* #__PURE__ */ (0, $dsu7t.factory)($de199e14e4d22b49$var$name, $de199e14e4d22b49$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Logical `not`. Flips boolean value of a given parameter.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.not(x)
   *
   * Examples:
   *
   *    math.not(2)      // returns false
   *    math.not(0)      // returns true
   *    math.not(true)   // returns false
   *
   *    a = [2, -7, 0]
   *    math.not(a)      // returns [false, false, true]
   *
   * See also:
   *
   *    and, or, xor
   *
   * @param  {number | BigNumber | bigint | Complex | Unit | Array | Matrix} x First value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when input is a zero or empty value.
   */ return typed($de199e14e4d22b49$var$name, {
        'null | undefined': ()=>true,
        number: (0, $69vHM.notNumber),
        Complex: function Complex(x) {
            return x.re === 0 && x.im === 0;
        },
        BigNumber: function BigNumber(x) {
            return x.isZero() || x.isNaN();
        },
        bigint: (x)=>!x,
        Unit: typed.referToSelf((self)=>(x)=>typed.find(self, x.valueType())(x.value)),
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});

parcelRegister("e2sjL", function(module, exports) {

$parcel$export(module.exports, "createNthRoot", () => $a38737eb23cbf6dd$export$964e38ef60b1ac68);

var $dsu7t = parcelRequire("dsu7t");

var $ahu8B = parcelRequire("ahu8B");

var $kycT3 = parcelRequire("kycT3");

var $hF01R = parcelRequire("hF01R");

var $52JKA = parcelRequire("52JKA");

var $6SJnV = parcelRequire("6SJnV");

var $dmcGu = parcelRequire("dmcGu");
var $a38737eb23cbf6dd$var$name = 'nthRoot';
var $a38737eb23cbf6dd$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'BigNumber',
    'concat'
];
var $a38737eb23cbf6dd$export$964e38ef60b1ac68 = /* #__PURE__ */ (0, $dsu7t.factory)($a38737eb23cbf6dd$var$name, $a38737eb23cbf6dd$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, BigNumber: _BigNumber, concat: concat } = _ref;
    var matAlgo01xDSid = (0, $ahu8B.createMatAlgo01xDSid)({
        typed: typed
    });
    var matAlgo02xDS0 = (0, $kycT3.createMatAlgo02xDS0)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo06xS0S0 = (0, $hF01R.createMatAlgo06xS0S0)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo11xS0s = (0, $52JKA.createMatAlgo11xS0s)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Calculate the nth root of a value.
   * The principal nth root of a positive real number A, is the positive real
   * solution of the equation
   *
   *     x^root = A
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *     math.nthRoot(a)
   *     math.nthRoot(a, root)
   *
   * Examples:
   *
   *     math.nthRoot(9, 2)    // returns 3 (since 3^2 == 9)
   *     math.sqrt(9)          // returns 3 (since 3^2 == 9)
   *     math.nthRoot(64, 3)   // returns 4 (since 4^3 == 64)
   *
   * See also:
   *
   *     sqrt, pow
   *
   * @param {number | BigNumber | Array | Matrix | Complex} a
   *              Value for which to calculate the nth root
   * @param {number | BigNumber} [root=2]    The root.
   * @return {number | Complex | Array | Matrix} Returns the nth root of `a`
   */ function complexErr() {
        throw new Error('Complex number not supported in function nthRoot. Use nthRoots instead.');
    }
    return typed($a38737eb23cbf6dd$var$name, {
        number: (0, $dmcGu.nthRootNumber),
        'number, number': (0, $dmcGu.nthRootNumber),
        BigNumber: (x)=>_bigNthRoot(x, new _BigNumber(2)),
        'BigNumber, BigNumber': _bigNthRoot,
        Complex: complexErr,
        'Complex, number': complexErr,
        Array: typed.referTo('DenseMatrix,number', (selfDn)=>(x)=>selfDn(matrix(x), 2).valueOf()),
        DenseMatrix: typed.referTo('DenseMatrix,number', (selfDn)=>(x)=>selfDn(x, 2)),
        SparseMatrix: typed.referTo('SparseMatrix,number', (selfSn)=>(x)=>selfSn(x, 2)),
        'SparseMatrix, SparseMatrix': typed.referToSelf((self)=>(x, y)=>{
                // density must be one (no zeros in matrix)
                if (y.density() === 1) // sparse + sparse
                return matAlgo06xS0S0(x, y, self);
                else // throw exception
                throw new Error('Root must be non-zero');
            }),
        'DenseMatrix, SparseMatrix': typed.referToSelf((self)=>(x, y)=>{
                // density must be one (no zeros in matrix)
                if (y.density() === 1) // dense + sparse
                return matAlgo01xDSid(x, y, self, false);
                else // throw exception
                throw new Error('Root must be non-zero');
            }),
        'Array, SparseMatrix': typed.referTo('DenseMatrix,SparseMatrix', (selfDS)=>(x, y)=>selfDS(matrix(x), y)),
        'number | BigNumber, SparseMatrix': typed.referToSelf((self)=>(x, y)=>{
                // density must be one (no zeros in matrix)
                if (y.density() === 1) // sparse - scalar
                return matAlgo11xS0s(y, x, self, true);
                else // throw exception
                throw new Error('Root must be non-zero');
            })
    }, matrixAlgorithmSuite({
        scalar: 'number | BigNumber',
        SD: matAlgo02xDS0,
        Ss: matAlgo11xS0s,
        sS: false
    }));
    /**
   * Calculate the nth root of a for BigNumbers, solve x^root == a
   * https://rosettacode.org/wiki/Nth_root#JavaScript
   * @param {BigNumber} a
   * @param {BigNumber} root
   * @private
   */ function _bigNthRoot(a, root) {
        var precision = _BigNumber.precision;
        var Big = _BigNumber.clone({
            precision: precision + 2
        });
        var zero = new _BigNumber(0);
        var one = new Big(1);
        var inv = root.isNegative();
        if (inv) root = root.neg();
        if (root.isZero()) throw new Error('Root must be non-zero');
        if (a.isNegative() && !root.abs().mod(2).equals(1)) throw new Error('Root must be odd when a is negative.');
        // edge cases zero and infinity
        if (a.isZero()) return inv ? new Big(Infinity) : 0;
        if (!a.isFinite()) return inv ? zero : a;
        var x = a.abs().pow(one.div(root));
        // If a < 0, we require that root is an odd integer,
        // so (-1) ^ (1/root) = -1
        x = a.isNeg() ? x.neg() : x;
        return new _BigNumber((inv ? one.div(x) : x).toPrecision(precision));
    }
});
var $a38737eb23cbf6dd$export$f098cf3c4ef0f7ef = /* #__PURE__ */ (0, $dsu7t.factory)($a38737eb23cbf6dd$var$name, [
    'typed'
], (_ref2)=>{
    var { typed: typed } = _ref2;
    return typed($a38737eb23cbf6dd$var$name, {
        number: (0, $dmcGu.nthRootNumber),
        'number, number': (0, $dmcGu.nthRootNumber)
    });
});

});

parcelRegister("hjhCJ", function(module, exports) {

$parcel$export(module.exports, "createNthRoots", () => $c9a1e1b31810853e$export$36e27b45d2aa738c);

var $dsu7t = parcelRequire("dsu7t");
var $c9a1e1b31810853e$var$name = 'nthRoots';
var $c9a1e1b31810853e$var$dependencies = [
    'config',
    'typed',
    'divideScalar',
    'Complex'
];
var $c9a1e1b31810853e$export$36e27b45d2aa738c = /* #__PURE__ */ (0, $dsu7t.factory)($c9a1e1b31810853e$var$name, $c9a1e1b31810853e$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, divideScalar: divideScalar, Complex: Complex } = _ref;
    /**
   * Each function here returns a real multiple of i as a Complex value.
   * @param  {number} val
   * @return {Complex} val, i*val, -val or -i*val for index 0, 1, 2, 3
   */ // This is used to fix float artifacts for zero-valued components.
    var _calculateExactResult = [
        function realPos(val) {
            return new Complex(val, 0);
        },
        function imagPos(val) {
            return new Complex(0, val);
        },
        function realNeg(val) {
            return new Complex(-val, 0);
        },
        function imagNeg(val) {
            return new Complex(0, -val);
        }
    ];
    /**
   * Calculate the nth root of a Complex Number a using De Movire's Theorem.
   * @param  {Complex} a
   * @param  {number} root
   * @return {Array} array of n Complex Roots
   */ function _nthComplexRoots(a, root) {
        if (root < 0) throw new Error('Root must be greater than zero');
        if (root === 0) throw new Error('Root must be non-zero');
        if (root % 1 !== 0) throw new Error('Root must be an integer');
        if (a === 0 || a.abs() === 0) return [
            new Complex(0, 0)
        ];
        var aIsNumeric = typeof a === 'number';
        var offset;
        // determine the offset (argument of a)/(pi/2)
        if (aIsNumeric || a.re === 0 || a.im === 0) {
            if (aIsNumeric) offset = 2 * +(a < 0); // numeric value on the real axis
            else if (a.im === 0) offset = 2 * +(a.re < 0); // complex value on the real axis
            else offset = 2 * +(a.im < 0) + 1; // complex value on the imaginary axis
        }
        var arg = a.arg();
        var abs = a.abs();
        var roots = [];
        var r = Math.pow(abs, 1 / root);
        for(var k = 0; k < root; k++){
            var halfPiFactor = (offset + 4 * k) / root;
            /**
       * If (offset + 4*k)/root is an integral multiple of pi/2
       * then we can produce a more exact result.
       */ if (halfPiFactor === Math.round(halfPiFactor)) {
                roots.push(_calculateExactResult[halfPiFactor % 4](r));
                continue;
            }
            roots.push(new Complex({
                r: r,
                phi: (arg + 2 * Math.PI * k) / root
            }));
        }
        return roots;
    }
    /**
   * Calculate the nth roots of a value.
   * An nth root of a positive real number A,
   * is a positive real solution of the equation "x^root = A".
   * This function returns an array of complex values.
   *
   * Syntax:
   *
   *    math.nthRoots(x)
   *    math.nthRoots(x, root)
   *
   * Examples:
   *
   *    math.nthRoots(1)
   *    // returns [
   *    //   {re: 1, im: 0},
   *    //   {re: -1, im: 0}
   *    // ]
   *    math.nthRoots(1, 3)
   *    // returns [
   *    //   { re: 1, im: 0 },
   *    //   { re: -0.4999999999999998, im: 0.8660254037844387 },
   *    //   { re: -0.5000000000000004, im: -0.8660254037844385 }
   *    // ]
   *
   * See also:
   *
   *    nthRoot, pow, sqrt
   *
   * @param {number | BigNumber | Fraction | Complex} x Number to be rounded
   * @param {number} [root=2] Optional root, default value is 2
   * @return {number | BigNumber | Fraction | Complex} Returns the nth roots
   */ return typed($c9a1e1b31810853e$var$name, {
        Complex: function Complex(x) {
            return _nthComplexRoots(x, 2);
        },
        'Complex, number': _nthComplexRoots
    });
});

});

parcelRegister("1v1Vi", function(module, exports) {

$parcel$export(module.exports, "createNullish", () => $117a2d925437d9d0$export$589076e9f928a9a2);

var $dsu7t = parcelRequire("dsu7t");

var $a8bto = parcelRequire("a8bto");

var $dK2sh = parcelRequire("dK2sh");

var $bFZOG = parcelRequire("bFZOG");

var $7asMt = parcelRequire("7asMt");
var $117a2d925437d9d0$var$name = 'nullish';
var $117a2d925437d9d0$var$dependencies = [
    'typed',
    'matrix',
    'size',
    'flatten',
    'deepEqual'
];
var $117a2d925437d9d0$export$589076e9f928a9a2 = /* #__PURE__ */ (0, $dsu7t.factory)($117a2d925437d9d0$var$name, $117a2d925437d9d0$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, size: size, flatten: flatten, deepEqual: deepEqual } = _ref;
    var matAlgo03xDSf = (0, $a8bto.createMatAlgo03xDSf)({
        typed: typed
    });
    var matAlgo14xDs = (0, $dK2sh.createMatAlgo14xDs)({
        typed: typed
    });
    var matAlgo13xDD = (0, $bFZOG.createMatAlgo13xDD)({
        typed: typed
    });
    /**
   * Nullish coalescing operator (??). Returns the right-hand side operand
   * when the left-hand side operand is null or undefined, and otherwise
   * returns the left-hand side operand.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.nullish(x, y)
   *
   * Examples:
   *
   *    math.nullish(null, 42)        // returns 42
   *    math.nullish(undefined, 42)   // returns 42
   *    math.nullish(0, 42)           // returns 0
   *    math.nullish(false, 42)       // returns false
   *    math.nullish('', 42)          // returns ''
   *
   *    // Object property access with fallback
   *    const obj = {foo: 7, bar: 3}
   *    math.nullish(obj.baz, 0)      // returns 0
   *
   * See also:
   *
   *    and, or, not
   *
   * @param  {*} x First value to check
   * @param  {*} y Fallback value
   * @return {*} Returns y when x is null or undefined, otherwise returns x
   */ return typed($117a2d925437d9d0$var$name, {
        // Scalar and SparseMatrix-first short-circuit handlers
        'number|bigint|Complex|BigNumber|Fraction|Unit|string|boolean|SparseMatrix, any': (x, _y)=>x,
        'null, any': (_x, y)=>y,
        'undefined, any': (_x, y)=>y,
        // SparseMatrix-first with collection RHS: enforce exact shape match
        'SparseMatrix, Array | Matrix': (x, y)=>{
            var sx = flatten(size(x).valueOf()); // work around #3529/#3530
            var sy = flatten(size(y).valueOf());
            if (deepEqual(sx, sy)) return x;
            throw new (0, $7asMt.DimensionError)(sx, sy);
        },
        // DenseMatrix-first handlers (no broadcasting between collections)
        'DenseMatrix, DenseMatrix': typed.referToSelf((self)=>(x, y)=>matAlgo13xDD(x, y, self)),
        'DenseMatrix, SparseMatrix': typed.referToSelf((self)=>(x, y)=>matAlgo03xDSf(x, y, self, false)),
        'DenseMatrix, Array': typed.referToSelf((self)=>(x, y)=>matAlgo13xDD(x, matrix(y), self)),
        'DenseMatrix, any': typed.referToSelf((self)=>(x, y)=>matAlgo14xDs(x, y, self, false)),
        // Array-first handlers (bridge via matrix() where needed)
        'Array, Array': typed.referToSelf((self)=>(x, y)=>matAlgo13xDD(matrix(x), matrix(y), self).valueOf()),
        'Array, DenseMatrix': typed.referToSelf((self)=>(x, y)=>matAlgo13xDD(matrix(x), y, self)),
        'Array, SparseMatrix': typed.referToSelf((self)=>(x, y)=>matAlgo03xDSf(matrix(x), y, self, false)),
        'Array, any': typed.referToSelf((self)=>(x, y)=>matAlgo14xDs(matrix(x), y, self, false).valueOf())
    });
});

});

parcelRegister("dXF1L", function(module, exports) {

$parcel$export(module.exports, "createNumber", () => $a2a09c44e06649ae$export$763ee9f6477981ab);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");
var $a2a09c44e06649ae$var$name = 'number';
var $a2a09c44e06649ae$var$dependencies = [
    'typed'
];
/**
 * Separates the radix, integer part, and fractional part of a non decimal number string
 * @param {string} input string to parse
 * @returns {object} the parts of the string or null if not a valid input
 */ function $a2a09c44e06649ae$var$getNonDecimalNumberParts(input) {
    var nonDecimalWithRadixMatch = input.match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/);
    if (nonDecimalWithRadixMatch) {
        var radix = {
            '0b': 2,
            '0o': 8,
            '0x': 16
        }[nonDecimalWithRadixMatch[1]];
        var integerPart = nonDecimalWithRadixMatch[2];
        var fractionalPart = nonDecimalWithRadixMatch[3];
        return {
            input: input,
            radix: radix,
            integerPart: integerPart,
            fractionalPart: fractionalPart
        };
    } else return null;
}
/**
 * Makes a number from a radix, and integer part, and a fractional part
 * @param {parts} [x] parts of the number string (from getNonDecimalNumberParts)
 * @returns {number} the number
 */ function $a2a09c44e06649ae$var$makeNumberFromNonDecimalParts(parts) {
    var n = parseInt(parts.integerPart, parts.radix);
    var f = 0;
    for(var i = 0; i < parts.fractionalPart.length; i++){
        var digitValue = parseInt(parts.fractionalPart[i], parts.radix);
        f += digitValue / Math.pow(parts.radix, i + 1);
    }
    var result = n + f;
    if (isNaN(result)) throw new SyntaxError('String "' + parts.input + '" is not a valid number');
    return result;
}
var $a2a09c44e06649ae$export$763ee9f6477981ab = /* #__PURE__ */ (0, $dsu7t.factory)($a2a09c44e06649ae$var$name, $a2a09c44e06649ae$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a number or convert a string, boolean, or unit to a number.
   * When value is a matrix, all elements will be converted to number.
   *
   * Syntax:
   *
   *    math.number(value)
   *    math.number(unit, valuelessUnit)
   *
   * Examples:
   *
   *    math.number(2)                         // returns number 2
   *    math.number('7.2')                     // returns number 7.2
   *    math.number(true)                      // returns number 1
   *    math.number([true, false, true, true]) // returns [1, 0, 1, 1]
   *    math.number(math.unit('52cm'), 'm')    // returns 0.52
   *
   * See also:
   *
   *    bignumber, bigint, boolean, numeric, complex, index, matrix, string, unit
   *
   * @param {string | number | BigNumber | Fraction | boolean | Array | Matrix | Unit | null} [value]  Value to be converted
   * @param {Unit | string} [valuelessUnit] A valueless unit, used to convert a unit to a number
   * @return {number | Array | Matrix} The created number
   */ var number = typed('number', {
        '': function _() {
            return 0;
        },
        number: function number(x) {
            return x;
        },
        string: function string(x) {
            if (x === 'NaN') return NaN;
            var nonDecimalNumberParts = $a2a09c44e06649ae$var$getNonDecimalNumberParts(x);
            if (nonDecimalNumberParts) return $a2a09c44e06649ae$var$makeNumberFromNonDecimalParts(nonDecimalNumberParts);
            var size = 0;
            var wordSizeSuffixMatch = x.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
            if (wordSizeSuffixMatch) {
                // x includes a size suffix like 0xffffi32, so we extract
                // the suffix and remove it from x
                size = Number(wordSizeSuffixMatch[2]);
                x = wordSizeSuffixMatch[1];
            }
            var num = Number(x);
            if (isNaN(num)) throw new SyntaxError('String "' + x + '" is not a valid number');
            if (wordSizeSuffixMatch) {
                // x is a signed bin, oct, or hex literal
                // num is the value of string x if x is interpreted as unsigned
                if (num > 2 ** size - 1) // literal is too large for size suffix
                throw new SyntaxError("String \"".concat(x, "\" is out of range"));
                // check if the bit at index size - 1 is set and if so do the twos complement
                if (num >= 2 ** (size - 1)) num = num - 2 ** size;
            }
            return num;
        },
        BigNumber: function BigNumber(x) {
            return x.toNumber();
        },
        bigint: function bigint(x) {
            return Number(x);
        },
        Fraction: function Fraction(x) {
            return x.valueOf();
        },
        Unit: typed.referToSelf((self)=>(x)=>{
                var clone = x.clone();
                clone.value = self(x.value);
                return clone;
            }),
        null: function _null(x) {
            return 0;
        },
        'Unit, string | Unit': function Unit_string__Unit(unit, valuelessUnit) {
            return unit.toNumber(valuelessUnit);
        },
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
    // reviver function to parse a JSON object like:
    //
    //     {"mathjs":"number","value":"2.3"}
    //
    // into a number 2.3
    number.fromJSON = function(json) {
        return parseFloat(json.value);
    };
    return number;
});

});

parcelRegister("hALmx", function(module, exports) {

$parcel$export(module.exports, "createNumeric", () => $ccea89a73476f6a3$export$e3cf2d123164e554);

var $edQYF = parcelRequire("edQYF");

var $dsu7t = parcelRequire("dsu7t");

var $h5rrM = parcelRequire("h5rrM");
var $ccea89a73476f6a3$var$name = 'numeric';
var $ccea89a73476f6a3$var$dependencies = [
    'number',
    '?bignumber',
    '?fraction'
];
var $ccea89a73476f6a3$export$e3cf2d123164e554 = /* #__PURE__ */ (0, $dsu7t.factory)($ccea89a73476f6a3$var$name, $ccea89a73476f6a3$var$dependencies, (_ref)=>{
    var { number: _number, bignumber: bignumber, fraction: fraction } = _ref;
    var validInputTypes = {
        string: true,
        number: true,
        BigNumber: true,
        Fraction: true
    };
    // Load the conversion functions for each output type
    var validOutputTypes = {
        number: (x)=>_number(x),
        BigNumber: bignumber ? (x)=>bignumber(x) : (0, $h5rrM.noBignumber),
        bigint: (x)=>BigInt(x),
        Fraction: fraction ? (x)=>fraction(x) : (0, $h5rrM.noFraction)
    };
    /**
   * Convert a numeric input to a specific numeric type: number, BigNumber, bigint, or Fraction.
   *
   * Syntax:
   *
   *    math.numeric(x)
   *    math.numeric(value, outputType)
   *
   * Examples:
   *
   *    math.numeric('4')                           // returns 4
   *    math.numeric('4', 'number')                 // returns 4
   *    math.numeric('4', 'bigint')                 // returns 4n
   *    math.numeric('4', 'BigNumber')              // returns BigNumber 4
   *    math.numeric('4', 'Fraction')               // returns Fraction 4
   *    math.numeric(4, 'Fraction')                 // returns Fraction 4
   *    math.numeric(math.fraction(2, 5), 'number') // returns 0.4
   *
   * See also:
   *
   *    number, fraction, bignumber, bigint, string, format
   *
   * @param {string | number | BigNumber | bigint | Fraction } value
   *              A numeric value or a string containing a numeric value
   * @param {string} outputType
   *              Desired numeric output type.
   *              Available values: 'number', 'BigNumber', or 'Fraction'
   * @return {number | BigNumber | bigint | Fraction}
   *              Returns an instance of the numeric in the requested type
   */ return function numeric(value) {
        var outputType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'number';
        var check = arguments.length > 2 ? arguments[2] : undefined;
        if (check !== undefined) throw new SyntaxError('numeric() takes one or two arguments');
        var inputType = (0, $edQYF.typeOf)(value);
        if (!(inputType in validInputTypes)) throw new TypeError('Cannot convert ' + value + ' of type "' + inputType + '"; valid input types are ' + Object.keys(validInputTypes).join(', '));
        if (!(outputType in validOutputTypes)) throw new TypeError('Cannot convert ' + value + ' to type "' + outputType + '"; valid output types are ' + Object.keys(validOutputTypes).join(', '));
        if (outputType === inputType) return value;
        else return validOutputTypes[outputType](value);
    };
});

});
parcelRegister("h5rrM", function(module, exports) {

$parcel$export(module.exports, "noBignumber", () => $c70831b17e249316$export$f0829713dc162a8);
$parcel$export(module.exports, "noFraction", () => $c70831b17e249316$export$9978fd42ef220ba0);
$parcel$export(module.exports, "noMatrix", () => $c70831b17e249316$export$b81416cb7ecca475);
function $c70831b17e249316$export$f0829713dc162a8() {
    throw new Error('No "bignumber" implementation available');
}
function $c70831b17e249316$export$9978fd42ef220ba0() {
    throw new Error('No "fraction" implementation available');
}
function $c70831b17e249316$export$b81416cb7ecca475() {
    throw new Error('No "matrix" implementation available');
}
function $c70831b17e249316$export$a38f8cf2e48f2bd() {
    throw new Error('No "index" implementation available');
}
function $c70831b17e249316$export$32411ef9704d5eea() {
    throw new Error('No "matrix" implementation available');
}

});


parcelRegister("esLfW", function(module, exports) {

$parcel$export(module.exports, "createOct", () => $a878564c98644457$export$6692788ef49c21c9);

var $dsu7t = parcelRequire("dsu7t");
var $a878564c98644457$var$name = 'oct';
var $a878564c98644457$var$dependencies = [
    'typed',
    'format'
];
var $a878564c98644457$export$6692788ef49c21c9 = (0, $dsu7t.factory)($a878564c98644457$var$name, $a878564c98644457$var$dependencies, (_ref)=>{
    var { typed: typed, format: format } = _ref;
    return typed($a878564c98644457$var$name, {
        'number | BigNumber': function number__BigNumber(n) {
            return format(n, {
                notation: 'oct'
            });
        },
        'number | BigNumber, number | BigNumber': function number__BigNumber_number__BigNumber(n, wordSize) {
            return format(n, {
                notation: 'oct',
                wordSize: wordSize
            });
        }
    });
});

});

parcelRegister("lR7IP", function(module, exports) {

$parcel$export(module.exports, "createOnes", () => $fe9489ac3d2e3614$export$f524a435b9c16a90);

var $edQYF = parcelRequire("edQYF");

var $6NnhX = parcelRequire("6NnhX");

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $fe9489ac3d2e3614$var$name = 'ones';
var $fe9489ac3d2e3614$var$dependencies = [
    'typed',
    'config',
    'matrix',
    'BigNumber'
];
var $fe9489ac3d2e3614$export$f524a435b9c16a90 = /* #__PURE__ */ (0, $dsu7t.factory)($fe9489ac3d2e3614$var$name, $fe9489ac3d2e3614$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber } = _ref;
    /**
   * Create a matrix filled with ones. The created matrix can have one or
   * multiple dimensions.
   *
   * Syntax:
   *
   *    math.ones(m)
   *    math.ones(m, format)
   *    math.ones(m, n)
   *    math.ones(m, n, format)
   *    math.ones([m, n])
   *    math.ones([m, n], format)
   *    math.ones([m, n, p, ...])
   *    math.ones([m, n, p, ...], format)
   *
   * Examples:
   *
   *    math.ones()                    // returns []
   *    math.ones(3)                   // returns [1, 1, 1]
   *    math.ones(3, 2)                // returns [[1, 1], [1, 1], [1, 1]]
   *    math.ones(3, 2, 'dense')       // returns Dense Matrix [[1, 1], [1, 1], [1, 1]]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.ones(math.size(A))       // returns [[1, 1, 1], [1, 1, 1]]
   *
   * See also:
   *
   *    zeros, identity, size, range
   *
   * @param {...(number|BigNumber) | Array} size    The size of each dimension of the matrix
   * @param {string} [format]           The Matrix storage format
   *
   * @return {Array | Matrix | number}  A matrix filled with ones
   */ return typed('ones', {
        '': function _() {
            return config.matrix === 'Array' ? _ones([]) : _ones([], 'default');
        },
        // math.ones(m, n, p, ..., format)
        // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
        '...number | BigNumber | string': function number__BigNumber__string(size) {
            var last = size[size.length - 1];
            if (typeof last === 'string') {
                var format = size.pop();
                return _ones(size, format);
            } else if (config.matrix === 'Array') return _ones(size);
            else return _ones(size, 'default');
        },
        Array: _ones,
        Matrix: function Matrix(size) {
            var format = size.storage();
            return _ones(size.valueOf(), format);
        },
        'Array | Matrix, string': function Array__Matrix_string(size, format) {
            return _ones(size.valueOf(), format);
        }
    });
    /**
   * Create an Array or Matrix with ones
   * @param {Array} size
   * @param {string} [format='default']
   * @return {Array | Matrix}
   * @private
   */ function _ones(size, format) {
        var hasBigNumbers = _normalize(size);
        var defaultValue = hasBigNumbers ? new BigNumber(1) : 1;
        _validate(size);
        if (format) {
            // return a matrix
            var m = matrix(format);
            if (size.length > 0) return m.resize(size, defaultValue);
            return m;
        } else {
            // return an Array
            var arr = [];
            if (size.length > 0) return (0, $d80Xp.resize)(arr, size, defaultValue);
            return arr;
        }
    }
    // replace BigNumbers with numbers, returns true if size contained BigNumbers
    function _normalize(size) {
        var hasBigNumbers = false;
        size.forEach(function(value, index, arr) {
            if ((0, $edQYF.isBigNumber)(value)) {
                hasBigNumbers = true;
                arr[index] = value.toNumber();
            }
        });
        return hasBigNumbers;
    }
    // validate arguments
    function _validate(size) {
        size.forEach(function(value) {
            if (typeof value !== 'number' || !(0, $6NnhX.isInteger)(value) || value < 0) throw new Error('Parameters in function ones must be positive integers');
        });
    }
});

});

parcelRegister("jAxTW", function(module, exports) {

$parcel$export(module.exports, "createOr", () => $e42bad2ea6707798$export$3d19b09907d6fd4a);

var $a8bto = parcelRequire("a8bto");

var $19L2p = parcelRequire("19L2p");

var $g1nxb = parcelRequire("g1nxb");

var $dsu7t = parcelRequire("dsu7t");

var $6SJnV = parcelRequire("6SJnV");

var $69vHM = parcelRequire("69vHM");
var $e42bad2ea6707798$var$name = 'or';
var $e42bad2ea6707798$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'DenseMatrix',
    'concat'
];
var $e42bad2ea6707798$export$3d19b09907d6fd4a = /* #__PURE__ */ (0, $dsu7t.factory)($e42bad2ea6707798$var$name, $e42bad2ea6707798$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo03xDSf = (0, $a8bto.createMatAlgo03xDSf)({
        typed: typed
    });
    var matAlgo05xSfSf = (0, $g1nxb.createMatAlgo05xSfSf)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Logical `or`. Test if at least one value is defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.or(x, y)
   *
   * Examples:
   *
   *    math.or(2, 4)   // returns true
   *
   *    a = [2, 5, 0]
   *    b = [0, 22, 0]
   *    c = 0
   *
   *    math.or(a, b)   // returns [true, true, false]
   *    math.or(b, c)   // returns [false, true, false]
   *
   * See also:
   *
   *    and, not, xor
   *
   * @param  {number | BigNumber | bigint | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | bigint | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when one of the inputs is defined with a nonzero/nonempty value.
   */ return typed($e42bad2ea6707798$var$name, {
        'number, number': (0, $69vHM.orNumber),
        'Complex, Complex': function Complex_Complex(x, y) {
            return x.re !== 0 || x.im !== 0 || y.re !== 0 || y.im !== 0;
        },
        'BigNumber, BigNumber': function BigNumber_BigNumber(x, y) {
            return !x.isZero() && !x.isNaN() || !y.isZero() && !y.isNaN();
        },
        'bigint, bigint': (0, $69vHM.orNumber),
        'Unit, Unit': typed.referToSelf((self)=>(x, y)=>self(x.value || 0, y.value || 0))
    }, matrixAlgorithmSuite({
        SS: matAlgo05xSfSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
});

});

parcelRegister("5TCV2", function(module, exports) {

$parcel$export(module.exports, "createPartitionSelect", () => $44b0474ae8d636b0$export$47c1a746705f5c42);

var $edQYF = parcelRequire("edQYF");

var $6NnhX = parcelRequire("6NnhX");

var $dsu7t = parcelRequire("dsu7t");
var $44b0474ae8d636b0$var$name = 'partitionSelect';
var $44b0474ae8d636b0$var$dependencies = [
    'typed',
    'isNumeric',
    'isNaN',
    'compare'
];
var $44b0474ae8d636b0$export$47c1a746705f5c42 = /* #__PURE__ */ (0, $dsu7t.factory)($44b0474ae8d636b0$var$name, $44b0474ae8d636b0$var$dependencies, (_ref)=>{
    var { typed: typed, isNumeric: isNumeric, isNaN: mathIsNaN, compare: compare } = _ref;
    var asc = compare;
    var desc = (a, b)=>-compare(a, b);
    /**
   * Partition-based selection of an array or 1D matrix.
   * Will find the kth smallest value, and mutates the input array.
   * Uses Quickselect.
   *
   * Syntax:
   *
   *    math.partitionSelect(x, k)
   *    math.partitionSelect(x, k, compare)
   *
   * Examples:
   *
   *    math.partitionSelect([5, 10, 1], 2)                               // returns 10
   *    math.partitionSelect(['C', 'B', 'A', 'D'], 1, math.compareText)   // returns 'B'
   *
   *    function sortByLength (a, b) {
   *      return a.length - b.length
   *    }
   *    math.partitionSelect(['Langdon', 'Tom', 'Sara'], 2, sortByLength) // returns 'Langdon'
   *
   *    // the input array is mutated
   *    arr = [5, 2, 1]
   *    math.partitionSelect(arr, 0) // returns 1, arr is now: [1, 2, 5]
   *    math.partitionSelect(arr, 1, 'desc') // returns 2, arr is now: [5, 2, 1]
   *
   * See also:
   *
   *    sort
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to sort
   * @param {Number} k            The kth smallest value to be retrieved zero-based index
   * @param {Function | 'asc' | 'desc'} [compare='asc']
   *        An optional comparator function. The function is called as
   *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
   *        and 0 when a == b.
   * @return {*} Returns the kth lowest value.
   */ return typed($44b0474ae8d636b0$var$name, {
        'Array | Matrix, number': function Array__Matrix_number(x, k) {
            return _partitionSelect(x, k, asc);
        },
        'Array | Matrix, number, string': function Array__Matrix_number_string(x, k, compare) {
            if (compare === 'asc') return _partitionSelect(x, k, asc);
            else if (compare === 'desc') return _partitionSelect(x, k, desc);
            else throw new Error('Compare string must be "asc" or "desc"');
        },
        'Array | Matrix, number, function': _partitionSelect
    });
    function _partitionSelect(x, k, compare) {
        if (!(0, $6NnhX.isInteger)(k) || k < 0) throw new Error('k must be a non-negative integer');
        if ((0, $edQYF.isMatrix)(x)) {
            var size = x.size();
            if (size.length > 1) throw new Error('Only one dimensional matrices supported');
            return quickSelect(x.valueOf(), k, compare);
        }
        if (Array.isArray(x)) return quickSelect(x, k, compare);
    }
    /**
   * Quickselect algorithm.
   * Code adapted from:
   * https://blog.teamleadnet.com/2012/07/quick-select-algorithm-find-kth-element.html
   *
   * @param {Array} arr
   * @param {Number} k
   * @param {Function} compare
   * @private
   */ function quickSelect(arr, k, compare) {
        if (k >= arr.length) throw new Error('k out of bounds');
        // check for NaN values since these can cause an infinite while loop
        for(var i = 0; i < arr.length; i++){
            if (isNumeric(arr[i]) && mathIsNaN(arr[i])) return arr[i]; // return NaN
        }
        var from = 0;
        var to = arr.length - 1;
        // if from == to we reached the kth element
        while(from < to){
            var r = from;
            var w = to;
            var pivot = arr[Math.floor(Math.random() * (to - from + 1)) + from];
            // stop if the reader and writer meets
            while(r < w)// arr[r] >= pivot
            if (compare(arr[r], pivot) >= 0) {
                // put the large values at the end
                var tmp = arr[w];
                arr[w] = arr[r];
                arr[r] = tmp;
                --w;
            } else // the value is smaller than the pivot, skip
            ++r;
            // if we stepped up (r++) we need to step one down (arr[r] > pivot)
            if (compare(arr[r], pivot) > 0) --r;
            // the r pointer is on the end of the first k elements
            if (k <= r) to = r;
            else from = r + 1;
        }
        return arr[k];
    }
});

});

parcelRegister("7neEi", function(module, exports) {

$parcel$export(module.exports, "createPermutations", () => $55e60b5f68690e30$export$1d58d7915914cc9c);

var $6NnhX = parcelRequire("6NnhX");

var $kfXQy = parcelRequire("kfXQy");

var $dsu7t = parcelRequire("dsu7t");
var $55e60b5f68690e30$var$name = 'permutations';
var $55e60b5f68690e30$var$dependencies = [
    'typed',
    'factorial'
];
var $55e60b5f68690e30$export$1d58d7915914cc9c = /* #__PURE__ */ (0, $dsu7t.factory)($55e60b5f68690e30$var$name, $55e60b5f68690e30$var$dependencies, (_ref)=>{
    var { typed: typed, factorial: factorial } = _ref;
    /**
   * Compute the number of ways of obtaining an ordered subset of `k` elements
   * from a set of `n` elements.
   *
   * Permutations only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *     math.permutations(n)
   *     math.permutations(n, k)
   *
   * Examples:
   *
   *    math.permutations(5)     // 120
   *    math.permutations(5, 3)  // 60
   *
   * See also:
   *
   *    combinations, combinationsWithRep, factorial
   *
   * @param {number | BigNumber} n   The number of objects in total
   * @param {number | BigNumber} [k] The number of objects in the subset
   * @return {number | BigNumber}    The number of permutations
   */ return typed($55e60b5f68690e30$var$name, {
        'number | BigNumber': factorial,
        'number, number': function number_number(n, k) {
            if (!(0, $6NnhX.isInteger)(n) || n < 0) throw new TypeError('Positive integer value expected in function permutations');
            if (!(0, $6NnhX.isInteger)(k) || k < 0) throw new TypeError('Positive integer value expected in function permutations');
            if (k > n) throw new TypeError('second argument k must be less than or equal to first argument n');
            // Permute n objects, k at a time
            return (0, $kfXQy.product)(n - k + 1, n);
        },
        'BigNumber, BigNumber': function BigNumber_BigNumber(n, k) {
            var result, i;
            if (!$55e60b5f68690e30$var$isPositiveInteger(n) || !$55e60b5f68690e30$var$isPositiveInteger(k)) throw new TypeError('Positive integer value expected in function permutations');
            if (k.gt(n)) throw new TypeError('second argument k must be less than or equal to first argument n');
            var one = n.mul(0).add(1);
            result = one;
            for(i = n.minus(k).plus(1); i.lte(n); i = i.plus(1))result = result.times(i);
            return result;
        }
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $55e60b5f68690e30$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}

});

parcelRegister("ewJkG", function(module, exports) {

$parcel$export(module.exports, "createPickRandom", () => $a93737f3ed3c5b7c$export$fbe25b9f25feec34);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");

var $edQYF = parcelRequire("edQYF");

var $8unJy = parcelRequire("8unJy");
var $a93737f3ed3c5b7c$var$name = 'pickRandom';
var $a93737f3ed3c5b7c$var$dependencies = [
    'typed',
    'config',
    '?on'
];
var $a93737f3ed3c5b7c$export$fbe25b9f25feec34 = /* #__PURE__ */ (0, $dsu7t.factory)($a93737f3ed3c5b7c$var$name, $a93737f3ed3c5b7c$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, on: on } = _ref;
    // seeded pseudo random number generator
    var rng = (0, $8unJy.createRng)(config.randomSeed);
    if (on) on('config', function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $8unJy.createRng)(curr.randomSeed);
    });
    /**
   * Random pick one or more values from a one dimensional array.
   * Array elements are picked using a random function with uniform or weighted distribution.
   *
   * Syntax:
   *
   *     math.pickRandom(array)
   *     math.pickRandom(array, number)
   *     math.pickRandom(array, weights)
   *     math.pickRandom(array, number, weights)
   *     math.pickRandom(array, weights, number)
   *     math.pickRandom(array, { weights, number, elementWise })
   *
   * Examples:
   *
   *     math.pickRandom([3, 6, 12, 2])                  // returns one of the values in the array
   *     math.pickRandom([3, 6, 12, 2], 2)               // returns an array of two of the values in the array
   *     math.pickRandom([3, 6, 12, 2], { number: 2 })   // returns an array of two of the values in the array
   *     math.pickRandom([3, 6, 12, 2], [1, 3, 2, 1])    // returns one of the values in the array with weighted distribution
   *     math.pickRandom([3, 6, 12, 2], 2, [1, 3, 2, 1]) // returns an array of two of the values in the array with weighted distribution
   *     math.pickRandom([3, 6, 12, 2], [1, 3, 2, 1], 2) // returns an array of two of the values in the array with weighted distribution
   *
   *     math.pickRandom([{x: 1.0, y: 2.0}, {x: 1.1, y: 2.0}], { elementWise: false })
   *         // returns one of the items in the array
   *
   * See also:
   *
   *     random, randomInt
   *
   * @param {Array | Matrix} array     A one dimensional array
   * @param {Int} number               An int or float
   * @param {Array | Matrix} weights   An array of ints or floats
   * @return {number | Array}          Returns a single random value from array when number is undefined.
   *                                   Returns an array with the configured number of elements when number is defined.
   */ return typed($a93737f3ed3c5b7c$var$name, {
        'Array | Matrix': function Array__Matrix(possibles) {
            return _pickRandom(possibles, {});
        },
        'Array | Matrix, Object': function Array__Matrix_Object(possibles, options) {
            return _pickRandom(possibles, options);
        },
        'Array | Matrix, number': function Array__Matrix_number(possibles, number) {
            return _pickRandom(possibles, {
                number: number
            });
        },
        'Array | Matrix, Array | Matrix': function Array__Matrix_Array__Matrix(possibles, weights) {
            return _pickRandom(possibles, {
                weights: weights
            });
        },
        'Array | Matrix, Array | Matrix, number': function Array__Matrix_Array__Matrix_number(possibles, weights, number) {
            return _pickRandom(possibles, {
                number: number,
                weights: weights
            });
        },
        'Array | Matrix, number, Array | Matrix': function Array__Matrix_number_Array__Matrix(possibles, number, weights) {
            return _pickRandom(possibles, {
                number: number,
                weights: weights
            });
        }
    });
    /**
   * @param {Array | Matrix} possibles
   * @param {{
   *   number?: number,
   *   weights?: Array | Matrix,
   *   elementWise: boolean
   * }} options
   * @returns {number | Array}
   * @private
   */ function _pickRandom(possibles, _ref2) {
        var { number: number, weights: weights, elementWise: elementWise = true } = _ref2;
        var single = typeof number === 'undefined';
        if (single) number = 1;
        var createMatrix = (0, $edQYF.isMatrix)(possibles) ? possibles.create : (0, $edQYF.isMatrix)(weights) ? weights.create : null;
        possibles = possibles.valueOf(); // get Array
        if (weights) weights = weights.valueOf(); // get Array
        if (elementWise === true) {
            possibles = (0, $d80Xp.flatten)(possibles);
            weights = (0, $d80Xp.flatten)(weights);
        }
        var totalWeights = 0;
        if (typeof weights !== 'undefined') {
            if (weights.length !== possibles.length) throw new Error('Weights must have the same length as possibles');
            for(var i = 0, len = weights.length; i < len; i++){
                if (!(0, $edQYF.isNumber)(weights[i]) || weights[i] < 0) throw new Error('Weights must be an array of positive numbers');
                totalWeights += weights[i];
            }
        }
        var length = possibles.length;
        var result = [];
        var pick;
        while(result.length < number){
            if (typeof weights === 'undefined') pick = possibles[Math.floor(rng() * length)];
            else {
                var randKey = rng() * totalWeights;
                for(var _i = 0, _len = possibles.length; _i < _len; _i++){
                    randKey -= weights[_i];
                    if (randKey < 0) {
                        pick = possibles[_i];
                        break;
                    }
                }
            }
            result.push(pick);
        }
        return single ? result[0] : createMatrix ? createMatrix(result) : result;
    }
});

});
parcelRegister("8unJy", function(module, exports) {

$parcel$export(module.exports, "createRng", () => $62e389135a963f6e$export$eaf9227667332084);

var $3mnBW = parcelRequire("3mnBW");
var $62e389135a963f6e$var$singletonRandom = /* #__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($3mnBW)))(Date.now());
function $62e389135a963f6e$export$eaf9227667332084(randomSeed) {
    var random;
    // create a new random generator with given seed
    function setSeed(seed) {
        random = seed === null ? $62e389135a963f6e$var$singletonRandom : (0, (/*@__PURE__*/$parcel$interopDefault($3mnBW)))(String(seed));
    }
    // initialize a seeded pseudo random number generator with config's random seed
    setSeed(randomSeed);
    // wrapper function so the rng can be updated via generator
    function rng() {
        return random();
    }
    return rng;
}

});
parcelRegister("3mnBW", function(module, exports) {
// A library of seedable RNGs implemented in Javascript.
//
// Usage:
//
// var seedrandom = require('seedrandom');
// var random = seedrandom(1); // or any seed.
// var x = random();       // 0 <= x < 1.  Every bit is random.
// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.
// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
// Period: ~2^116
// Reported to pass all BigCrush tests.

var $cmoHh = parcelRequire("cmoHh");

var $euRi5 = parcelRequire("euRi5");

var $hDsEw = parcelRequire("hDsEw");

var $3J2Zm = parcelRequire("3J2Zm");

var $6Px8M = parcelRequire("6Px8M");

var $lDm0S = parcelRequire("lDm0S");

var $ixfky = parcelRequire("ixfky");
$ixfky.alea = $cmoHh;
$ixfky.xor128 = $euRi5;
$ixfky.xorwow = $hDsEw;
$ixfky.xorshift7 = $3J2Zm;
$ixfky.xor4096 = $6Px8M;
$ixfky.tychei = $lDm0S;
module.exports = $ixfky;

});
parcelRegister("ixfky", function(module, exports) {

/*
Copyright 2019 David Bau.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/ (function(global, pool, math) {
    //
    // The following constants are related to IEEE 754 limits.
    //
    var width = 256, chunks = 6, digits = 52, rngname = 'random', startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
    //
    // seedrandom()
    // This is the seedrandom function described above.
    //
    function seedrandom(seed, options, callback) {
        var key = [];
        options = options == true ? {
            entropy: true
        } : options || {};
        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(options.entropy ? [
            seed,
            tostring(pool)
        ] : seed == null ? autoseed() : seed, 3), key);
        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);
        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks), d = startdenom, x = 0; //   and no 'extra last byte'.
            while(n < significance){
                n = (n + x) * width; //   shifting numerator and
                d *= width; //   denominator and generating a
                x = arc4.g(1); //   new least-significant-byte.
            }
            while(n >= overflow){
                n /= 2; //   last byte, shift everything
                d /= 2; //   right using integer math until
                x >>>= 1; //   we have exactly the desired bits.
            }
            return (n + x) / d; // Form the number within [0, 1).
        };
        prng.int32 = function() {
            return arc4.g(4) | 0;
        };
        prng.quick = function() {
            return arc4.g(4) / 0x100000000;
        };
        prng.double = prng;
        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);
        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback || function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) copy(state, arc4);
                // Only provide the .state method if requested via options.state.
                prng.state = function() {
                    return copy(arc4, {});
                };
            }
            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) {
                math[rngname] = prng;
                return seed;
            } else return prng;
        })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
    }
    //
    // ARC4
    //
    // An ARC4 implementation.  The constructor takes a key in the form of
    // an array of at most (width) integers that should be 0 <= x < (width).
    //
    // The g(count) method returns a pseudorandom integer that concatenates
    // the next (count) outputs from ARC4.  Its return value is a number x
    // that is in the range 0 <= x < (width ^ count).
    //
    function ARC4(key) {
        var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
        // The empty key [] is treated as [0].
        if (!keylen) key = [
            keylen++
        ];
        // Set up S using the standard key scheduling algorithm.
        while(i < width)s[i] = i++;
        for(i = 0; i < width; i++){
            s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
            s[j] = t;
        }
        // The "g" method returns the next (count) outputs as one number.
        (me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0, i = me.i, j = me.j, s = me.S;
            while(count--){
                t = s[i = mask & i + 1];
                r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
            }
            me.i = i;
            me.j = j;
            return r;
        // For robust unpredictability, the function call below automatically
        // discards an initial batch of values.  This is called RC4-drop[256].
        // See http://google.com/search?q=rsa+fluhrer+response&btnI
        })(width);
    }
    //
    // copy()
    // Copies internal state of ARC4 to or from a plain object.
    //
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    }
    //
    // flatten()
    // Converts an object tree to nested arrays of strings.
    //
    function flatten(obj, depth) {
        var result = [], typ = typeof obj, prop;
        if (depth && typ == 'object') {
            for(prop in obj)try {
                result.push(flatten(obj[prop], depth - 1));
            } catch (e) {}
        }
        return result.length ? result : typ == 'string' ? obj : obj + '\0';
    }
    //
    // mixkey()
    // Mixes a string seed into a key that is an array of integers, and
    // returns a shortened string seed that is equivalent to the result key.
    //
    function mixkey(seed, key) {
        var stringseed = seed + '', smear, j = 0;
        while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
        return tostring(key);
    }
    //
    // autoseed()
    // Returns an object for autoseeding, using window.crypto and Node crypto
    // module if available.
    //
    function autoseed() {
        try {
            var out;
            if (nodecrypto && (out = nodecrypto.randomBytes)) // The use of 'out' to remember randomBytes makes tight minified code.
            out = out(width);
            else {
                out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
            }
            return tostring(out);
        } catch (e) {
            var browser = global.navigator, plugins = browser && browser.plugins;
            return [
                +new Date,
                global,
                plugins,
                global.screen,
                tostring(pool)
            ];
        }
    }
    //
    // tostring()
    // Converts an array of charcodes to a string
    //
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }
    //
    // When seedrandom.js is loaded, we immediately mix a few bits
    // from the built-in RNG into the entropy pool.  Because we do
    // not want to interfere with deterministic PRNG state later,
    // seedrandom will not call math.random on its own again after
    // initialization.
    //
    mixkey(math.random(), pool);
    //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    if (module.exports) {
        module.exports = seedrandom;
        // When in node.js, try using crypto package for autoseeding.
        try {
            nodecrypto = (parcelRequire("kjyEk"));
        } catch (ex) {}
    } else if (typeof define == 'function' && define.amd) define(function() {
        return seedrandom;
    });
    else // When included as a plain script, set up Math.seedrandom global.
    math['seed' + rngname] = seedrandom;
// End anonymous scope, and pass initial values.
})(// global: `self` in browsers (including strict mode and web workers),
// otherwise `this` in Node and other environments
typeof self !== 'undefined' ? self : module.exports, [], Math // math: package containing random, pow, and seedrandom
);

});




parcelRegister("dC6r9", function(module, exports) {

$parcel$export(module.exports, "createPinv", () => $9e93d130fe61b1a3$export$1456c5eaeee6aa07);

var $edQYF = parcelRequire("edQYF");

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");

var $j2hDb = parcelRequire("j2hDb");

var $9v8q6 = parcelRequire("9v8q6");
var $9e93d130fe61b1a3$var$name = 'pinv';
var $9e93d130fe61b1a3$var$dependencies = [
    'typed',
    'matrix',
    'inv',
    'deepEqual',
    'equal',
    'dotDivide',
    'dot',
    'ctranspose',
    'divideScalar',
    'multiply',
    'add',
    'Complex'
];
var $9e93d130fe61b1a3$export$1456c5eaeee6aa07 = /* #__PURE__ */ (0, $dsu7t.factory)($9e93d130fe61b1a3$var$name, $9e93d130fe61b1a3$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, inv: inv, deepEqual: deepEqual, equal: equal, dotDivide: dotDivide, dot: dot, ctranspose: ctranspose, divideScalar: divideScalar, multiply: multiply, add: add, Complex: Complex } = _ref;
    /**
   * Calculate the Moore–Penrose inverse of a matrix.
   *
   * Syntax:
   *
   *     math.pinv(x)
   *
   * Examples:
   *
   *     math.pinv([[1, 2], [3, 4]])          // returns [[-2, 1], [1.5, -0.5]]
   *     math.pinv([[1, 0], [0, 1], [0, 1]])  // returns [[1, 0, 0], [0, 0.5, 0.5]]
   *     math.pinv(4)                         // returns 0.25
   *
   * See also:
   *
   *     inv
   *
   * @param {number | Complex | Array | Matrix} x     Matrix to be inversed
   * @return {number | Complex | Array | Matrix} The inverse of `x`.
   */ return typed($9e93d130fe61b1a3$var$name, {
        'Array | Matrix': function Array__Matrix(x) {
            var size = (0, $edQYF.isMatrix)(x) ? x.size() : (0, $d80Xp.arraySize)(x);
            switch(size.length){
                case 1:
                    // vector
                    if (_isZeros(x)) return ctranspose(x); // null vector
                    if (size[0] === 1) return inv(x); // invertible matrix
                    else return dotDivide(ctranspose(x), dot(x, x));
                case 2:
                    if (_isZeros(x)) return ctranspose(x); // zero matrixx
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) try {
                        return inv(x); // invertible matrix
                    } catch (err) {
                        if (err instanceof Error && err.message.match(/Cannot calculate inverse, determinant is zero/)) ;
                        else throw err;
                    }
                    if ((0, $edQYF.isMatrix)(x)) return matrix(_pinv(x.valueOf(), rows, cols), x.storage());
                    else // return an Array
                    return _pinv(x, rows, cols);
                default:
                    // multi dimensional array
                    throw new RangeError("Matrix must be two dimensional (size: " + (0, $j2hDb.format)(size) + ')');
            }
        },
        any: function any(x) {
            // scalar
            if (equal(x, 0)) return (0, $9v8q6.clone)(x); // zero
            return divideScalar(1, x);
        }
    });
    /**
   * Calculate the Moore–Penrose inverse of a matrix
   * @param {Array[]} mat     A matrix
   * @param {number} rows     Number of rows
   * @param {number} cols     Number of columns
   * @return {Array[]} pinv    Pseudoinverse matrix
   * @private
   */ function _pinv(mat, rows, cols) {
        var { C: C, F: F } = _rankFact(mat, rows, cols); // TODO: Use SVD instead (may improve precision)
        var Cpinv = multiply(inv(multiply(ctranspose(C), C)), ctranspose(C));
        var Fpinv = multiply(ctranspose(F), inv(multiply(F, ctranspose(F))));
        return multiply(Fpinv, Cpinv);
    }
    /**
   * Calculate the reduced row echelon form of a matrix
   *
   * Modified from https://rosettacode.org/wiki/Reduced_row_echelon_form
   *
   * @param {Array[]} mat     A matrix
   * @param {number} rows     Number of rows
   * @param {number} cols     Number of columns
   * @return {Array[]}        Reduced row echelon form
   * @private
   */ function _rref(mat, rows, cols) {
        var M = (0, $9v8q6.clone)(mat);
        var lead = 0;
        for(var r = 0; r < rows; r++){
            if (cols <= lead) return M;
            var i = r;
            while(_isZero(M[i][lead])){
                i++;
                if (rows === i) {
                    i = r;
                    lead++;
                    if (cols === lead) return M;
                }
            }
            [M[i], M[r]] = [
                M[r],
                M[i]
            ];
            var val = M[r][lead];
            for(var j = 0; j < cols; j++)M[r][j] = dotDivide(M[r][j], val);
            for(var _i = 0; _i < rows; _i++){
                if (_i === r) continue;
                val = M[_i][lead];
                for(var _j = 0; _j < cols; _j++)M[_i][_j] = add(M[_i][_j], multiply(-1, multiply(val, M[r][_j])));
            }
            lead++;
        }
        return M;
    }
    /**
   * Calculate the rank factorization of a matrix
   *
   * @param {Array[]} mat                  A matrix (M)
   * @param {number} rows                  Number of rows
   * @param {number} cols                  Number of columns
   * @return {{C: Array, F: Array}}        rank factorization where M = C F
   * @private
   */ function _rankFact(mat, rows, cols) {
        var rref = _rref(mat, rows, cols);
        var C = mat.map((_, i)=>_.filter((_, j)=>j < rows && !_isZero(dot(rref[j], rref[j]))));
        var F = rref.filter((_, i)=>!_isZero(dot(rref[i], rref[i])));
        return {
            C: C,
            F: F
        };
    }
    function _isZero(x) {
        return equal(add(x, Complex(1, 1)), add(0, Complex(1, 1)));
    }
    function _isZeros(arr) {
        return deepEqual(add(arr, Complex(1, 1)), add(multiply(arr, 0), Complex(1, 1)));
    }
});

});

parcelRegister("e9HIC", function(module, exports) {

$parcel$export(module.exports, "createPolynomialRoot", () => $a4e3d18e9b855f34$export$b41551d8a03b9b7f);

var $dsu7t = parcelRequire("dsu7t");
var $a4e3d18e9b855f34$var$name = 'polynomialRoot';
var $a4e3d18e9b855f34$var$dependencies = [
    'typed',
    'isZero',
    'equalScalar',
    'add',
    'subtract',
    'multiply',
    'divide',
    'sqrt',
    'unaryMinus',
    'cbrt',
    'typeOf',
    'im',
    're'
];
var $a4e3d18e9b855f34$export$b41551d8a03b9b7f = /* #__PURE__ */ (0, $dsu7t.factory)($a4e3d18e9b855f34$var$name, $a4e3d18e9b855f34$var$dependencies, (_ref)=>{
    var { typed: typed, isZero: isZero, equalScalar: equalScalar, add: add, subtract: subtract, multiply: multiply, divide: divide, sqrt: sqrt, unaryMinus: unaryMinus, cbrt: cbrt, typeOf: typeOf, im: im, re: re } = _ref;
    /**
   * Finds the numerical values of the distinct roots of a polynomial with real or complex coefficients.
   * Currently operates only on linear, quadratic, and cubic polynomials using the standard
   * formulas for the roots.
   *
   * Syntax:
   *
   *     math.polynomialRoot(constant, linearCoeff, quadraticCoeff, cubicCoeff)
   *
   * Examples:
   *     // linear
   *     math.polynomialRoot(6, 3)                                        // [-2]
   *     math.polynomialRoot(math.complex(6,3), 3)                        // [-2 - i]
   *     math.polynomialRoot(math.complex(6,3), math.complex(2,1))        // [-3 + 0i]
   *     // quadratic
   *     math.polynomialRoot(2, -3, 1)                                    // [2, 1]
   *     math.polynomialRoot(8, 8, 2)                                     // [-2]
   *     math.polynomialRoot(-2, 0, 1)                                    // [1.4142135623730951, -1.4142135623730951]
   *     math.polynomialRoot(2, -2, 1)                                    // [1 + i, 1 - i]
   *     math.polynomialRoot(math.complex(1,3), math.complex(-3, -2), 1)  // [2 + i, 1 + i]
   *     // cubic
   *     math.polynomialRoot(-6, 11, -6, 1)                               // [1, 3, 2]
   *     math.polynomialRoot(-8, 0, 0, 1)                                 // [-1 - 1.7320508075688774i, 2, -1 + 1.7320508075688774i]
   *     math.polynomialRoot(0, 8, 8, 2)                                  // [0, -2]
   *     math.polynomialRoot(1, 1, 1, 1)                                  // [-1 + 0i, 0 - i, 0 + i]
   *
   * See also:
   *     cbrt, sqrt
   *
   * @param {... number | Complex} coeffs
   *     The coefficients of the polynomial, starting with with the constant coefficent, followed
   *     by the linear coefficient and subsequent coefficients of increasing powers.
   * @return {Array} The distinct roots of the polynomial
   */ return typed($a4e3d18e9b855f34$var$name, {
        'number|Complex, ...number|Complex': (constant, restCoeffs)=>{
            var coeffs = [
                constant,
                ...restCoeffs
            ];
            while(coeffs.length > 0 && isZero(coeffs[coeffs.length - 1]))coeffs.pop();
            if (coeffs.length < 2) throw new RangeError("Polynomial [".concat(constant, ", ").concat(restCoeffs, "] must have a non-zero non-constant coefficient"));
            switch(coeffs.length){
                case 2:
                    // linear
                    return [
                        unaryMinus(divide(coeffs[0], coeffs[1]))
                    ];
                case 3:
                    // quadratic
                    var [c, b, a] = coeffs;
                    var denom = multiply(2, a);
                    var d1 = multiply(b, b);
                    var d2 = multiply(4, a, c);
                    if (equalScalar(d1, d2)) return [
                        divide(unaryMinus(b), denom)
                    ];
                    var discriminant = sqrt(subtract(d1, d2));
                    return [
                        divide(subtract(discriminant, b), denom),
                        divide(subtract(unaryMinus(discriminant), b), denom)
                    ];
                case 4:
                    // cubic, cf. https://en.wikipedia.org/wiki/Cubic_equation
                    var [d, _c, _b, _a] = coeffs;
                    var _denom = unaryMinus(multiply(3, _a));
                    var D0_1 = multiply(_b, _b);
                    var D0_2 = multiply(3, _a, _c);
                    var D1_1 = add(multiply(2, _b, _b, _b), multiply(27, _a, _a, d));
                    var D1_2 = multiply(9, _a, _b, _c);
                    if (equalScalar(D0_1, D0_2) && equalScalar(D1_1, D1_2)) return [
                        divide(_b, _denom)
                    ];
                    var Delta0 = subtract(D0_1, D0_2);
                    var Delta1 = subtract(D1_1, D1_2);
                    var discriminant1 = add(multiply(18, _a, _b, _c, d), multiply(_b, _b, _c, _c));
                    var discriminant2 = add(multiply(4, _b, _b, _b, d), multiply(4, _a, _c, _c, _c), multiply(27, _a, _a, d, d));
                    if (equalScalar(discriminant1, discriminant2)) return [
                        divide(subtract(multiply(4, _a, _b, _c), add(multiply(9, _a, _a, d), multiply(_b, _b, _b))), multiply(_a, Delta0)),
                        // simple root
                        divide(subtract(multiply(9, _a, d), multiply(_b, _c)), multiply(2, Delta0)) // double root
                    ];
                    // OK, we have three distinct roots
                    var Ccubed;
                    if (equalScalar(D0_1, D0_2)) Ccubed = Delta1;
                    else Ccubed = divide(add(Delta1, sqrt(subtract(multiply(Delta1, Delta1), multiply(4, Delta0, Delta0, Delta0)))), 2);
                    var allRoots = true;
                    var rawRoots = cbrt(Ccubed, allRoots).toArray().map((C)=>divide(add(_b, C, divide(Delta0, C)), _denom));
                    return rawRoots.map((r)=>{
                        if (typeOf(r) === 'Complex' && equalScalar(re(r), re(r) + im(r))) return re(r);
                        return r;
                    });
                default:
                    throw new RangeError("only implemented for cubic or lower-order polynomials, not ".concat(coeffs));
            }
        }
    });
});

});

parcelRegister("aQvJl", function(module, exports) {

$parcel$export(module.exports, "createPow", () => $7e575faeaaab2ba1$export$9c94d2d08a8d8146);

var $dsu7t = parcelRequire("dsu7t");

var $6NnhX = parcelRequire("6NnhX");

var $d80Xp = parcelRequire("d80Xp");

var $dmcGu = parcelRequire("dmcGu");
var $7e575faeaaab2ba1$var$name = 'pow';
var $7e575faeaaab2ba1$var$dependencies = [
    'typed',
    'config',
    'identity',
    'multiply',
    'matrix',
    'inv',
    'fraction',
    'number',
    'Complex'
];
var $7e575faeaaab2ba1$export$9c94d2d08a8d8146 = /* #__PURE__ */ (0, $dsu7t.factory)($7e575faeaaab2ba1$var$name, $7e575faeaaab2ba1$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, identity: identity, multiply: multiply, matrix: matrix, inv: inv, number: number, fraction: fraction, Complex: Complex } = _ref;
    /**
   * Calculates the power of x to y, `x ^ y`.
   *
   * Matrix exponentiation is supported for square matrices `x` and integers `y`:
   * when `y` is nonnegative, `x` may be any square matrix; and when `y` is
   * negative, `x` must be invertible, and then this function returns
   * inv(x)^(-y).
   *
   * For cubic roots of negative numbers, the function returns the principal
   * root by default. In order to let the function return the real root,
   * math.js can be configured with `math.config({predictable: true})`.
   * To retrieve all cubic roots of a value, use `math.cbrt(x, true)`.
   *
   * Syntax:
   *
   *    math.pow(x, y)
   *
   * Examples:
   *
   *    math.pow(2, 3)               // returns number 8
   *
   *    const a = math.complex(2, 3)
   *    math.pow(a, 2)                // returns Complex -5 + 12i
   *
   *    const b = [[1, 2], [4, 3]]
   *    math.pow(b, 2)               // returns Array [[9, 8], [16, 17]]
   *
   *    const c = [[1, 2], [4, 3]]
   *    math.pow(c, -1)               // returns Array [[-0.6, 0.4], [0.8, -0.2]]
   *
   * See also:
   *
   *    multiply, sqrt, cbrt, nthRoot
   *
   * @param  {number | BigNumber | bigint | Complex | Unit | Array | Matrix} x  The base
   * @param  {number | BigNumber | bigint | Complex} y                          The exponent
   * @return {number | BigNumber | bigint | Complex | Array | Matrix} The value of `x` to the power `y`
   */ return typed($7e575faeaaab2ba1$var$name, {
        'number, number': _pow,
        'Complex, Complex': function Complex_Complex(x, y) {
            return x.pow(y);
        },
        'BigNumber, BigNumber': function BigNumber_BigNumber(x, y) {
            if (y.isInteger() || x >= 0 || config.predictable) return x.pow(y);
            else return new Complex(x.toNumber(), 0).pow(y.toNumber(), 0);
        },
        'bigint, bigint': (x, y)=>x ** y,
        'Fraction, Fraction': function Fraction_Fraction(x, y) {
            var result = x.pow(y);
            if (result != null) return result;
            if (config.predictable) throw new Error('Result of pow is non-rational and cannot be expressed as a fraction');
            else return _pow(x.valueOf(), y.valueOf());
        },
        'Array, number': _powArray,
        'Array, BigNumber': function Array_BigNumber(x, y) {
            return _powArray(x, y.toNumber());
        },
        'Matrix, number': _powMatrix,
        'Matrix, BigNumber': function Matrix_BigNumber(x, y) {
            return _powMatrix(x, y.toNumber());
        },
        'Unit, number | BigNumber': function Unit_number__BigNumber(x, y) {
            return x.pow(y);
        }
    });
    /**
   * Calculates the power of x to y, x^y, for two numbers.
   * @param {number} x
   * @param {number} y
   * @return {number | Complex} res
   * @private
   */ function _pow(x, y) {
        // Alternatively could define a 'realmode' config option or something, but
        // 'predictable' will work for now
        if (config.predictable && !(0, $6NnhX.isInteger)(y) && x < 0) // Check to see if y can be represented as a fraction
        try {
            var yFrac = fraction(y);
            var yNum = number(yFrac);
            if (y === yNum || Math.abs((y - yNum) / y) < 1e-14) {
                if (yFrac.d % 2n === 1n) return (yFrac.n % 2n === 0n ? 1 : -1) * Math.pow(-x, y);
            }
        } catch (ex) {
        // fraction() throws an error if y is Infinity, etc.
        }
        // **for predictable mode** x^Infinity === NaN if x < -1
        // N.B. this behavour is different from `Math.pow` which gives
        // (-2)^Infinity === Infinity
        if (config.predictable && (x < -1 && y === Infinity || x > -1 && x < 0 && y === -Infinity)) return NaN;
        if ((0, $6NnhX.isInteger)(y) || x >= 0 || config.predictable) return (0, $dmcGu.powNumber)(x, y);
        else {
            // TODO: the following infinity checks are duplicated from powNumber. Deduplicate this somehow
            // x^Infinity === 0 if -1 < x < 1
            // A real number 0 is returned instead of complex(0)
            if (x * x < 1 && y === Infinity || x * x > 1 && y === -Infinity) return 0;
            return new Complex(x, 0).pow(y, 0);
        }
    }
    /**
   * Calculate the power of a 2d array
   * @param {Array} x     must be a 2 dimensional, square matrix
   * @param {number} y    a integer value (positive if `x` is not invertible)
   * @returns {Array}
   * @private
   */ function _powArray(x, y) {
        if (!(0, $6NnhX.isInteger)(y)) throw new TypeError('For A^b, b must be an integer (value is ' + y + ')');
        // verify that A is a 2 dimensional square matrix
        var s = (0, $d80Xp.arraySize)(x);
        if (s.length !== 2) throw new Error('For A^b, A must be 2 dimensional (A has ' + s.length + ' dimensions)');
        if (s[0] !== s[1]) throw new Error('For A^b, A must be square (size is ' + s[0] + 'x' + s[1] + ')');
        if (y < 0) try {
            return _powArray(inv(x), -y);
        } catch (error) {
            if (error.message === 'Cannot calculate inverse, determinant is zero') throw new TypeError('For A^b, when A is not invertible, b must be a positive integer (value is ' + y + ')');
            throw error;
        }
        var res = identity(s[0]).valueOf();
        var px = x;
        while(y >= 1){
            if ((y & 1) === 1) res = multiply(px, res);
            y >>= 1;
            px = multiply(px, px);
        }
        return res;
    }
    /**
   * Calculate the power of a 2d matrix
   * @param {Matrix} x     must be a 2 dimensional, square matrix
   * @param {number} y    a positive, integer value
   * @returns {Matrix}
   * @private
   */ function _powMatrix(x, y) {
        return matrix(_powArray(x.valueOf(), y));
    }
});

});

parcelRegister("70UPj", function(module, exports) {

$parcel$export(module.exports, "createPrint", () => $51b49d16cb445bca$export$ea4b9d9569ff81cc);

var $j2hDb = parcelRequire("j2hDb");

var $edQYF = parcelRequire("edQYF");

var $dsu7t = parcelRequire("dsu7t");

var $5CyFj = parcelRequire("5CyFj");
var $51b49d16cb445bca$var$name = 'print';
var $51b49d16cb445bca$var$dependencies = [
    'typed'
];
var $51b49d16cb445bca$export$ea4b9d9569ff81cc = /* #__PURE__ */ (0, $dsu7t.factory)($51b49d16cb445bca$var$name, $51b49d16cb445bca$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Interpolate values into a string template.
   *
   * Syntax:
   *
   *     math.print(template, values)
   *     math.print(template, values, precision)
   *     math.print(template, values, options)
   *
   * Example usage:
   *
   *     // the following outputs: 'Lucy is 5 years old'
   *     math.print('Lucy is $age years old', {age: 5})
   *
   *     // the following outputs: 'The value of pi is 3.141592654'
   *     math.print('The value of pi is $pi', {pi: math.pi}, 10)
   *
   *     // the following outputs: 'Hello Mary! The date is 2013-03-23'
   *     math.print('Hello $user.name! The date is $date', {
   *       user: {
   *         name: 'Mary',
   *       },
   *       date: '2013-03-23'
   *     })
   *
   *     // the following outputs: 'My favorite fruits are apples and bananas !'
   *     math.print('My favorite fruits are $0 and $1 !', [
   *       'apples',
   *       'bananas'
   *     ])
   *
   * See also:
   *
   *     format
   *
   * @param {string} template           A string containing variable placeholders.
   * @param {Object | Array | Matrix}   values An object or array containing variables
   *                                    which will be filled in in the template.
   * @param {number | Object} [options] Formatting options,
   *                                    or the number of digits to format numbers.
   *                                    See function math.format for a description
   *                                    of all options.
   * @return {string} Interpolated string
   */ return typed($51b49d16cb445bca$var$name, {
        // note: Matrix will be converted automatically to an Array
        'string, Object | Array': $51b49d16cb445bca$var$_print,
        'string, Object | Array, number | Object': $51b49d16cb445bca$var$_print
    });
});
/**
 * Interpolate values into a string template.
 * @param {string} template
 * @param {Object} values
 * @param {number | Object} [options]
 * @returns {string} Interpolated string
 * @private
 */ function $51b49d16cb445bca$var$_print(template, values, options) {
    return template.replace((0, $5CyFj.printTemplate), function(original, key) {
        var keys = key.split('.');
        var value = values[keys.shift()];
        if (value !== undefined && value.isMatrix) value = value.toArray();
        while(keys.length && value !== undefined){
            var k = keys.shift();
            value = k ? value[k] : value + '.';
        }
        if (value !== undefined) {
            if (!(0, $edQYF.isString)(value)) return (0, $j2hDb.format)(value, options);
            else return value;
        }
        return original;
    });
}

});
parcelRegister("5CyFj", function(module, exports) {

$parcel$export(module.exports, "printTemplate", () => $417b64294e201b15$export$d0aef82ef51185f0);
var $417b64294e201b15$export$d0aef82ef51185f0 = /\$([\w.]+)/g;

});


parcelRegister("64EEP", function(module, exports) {

$parcel$export(module.exports, "createProd", () => $46c2a78821d556ea$export$60310f756e9cfd41);

var $20mkw = parcelRequire("20mkw");

var $dsu7t = parcelRequire("dsu7t");

var $6NnhX = parcelRequire("6NnhX");

var $a2CJg = parcelRequire("a2CJg");
var $46c2a78821d556ea$var$name = 'prod';
var $46c2a78821d556ea$var$dependencies = [
    'typed',
    'config',
    'multiplyScalar',
    'numeric'
];
var $46c2a78821d556ea$export$60310f756e9cfd41 = /* #__PURE__ */ (0, $dsu7t.factory)($46c2a78821d556ea$var$name, $46c2a78821d556ea$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, multiplyScalar: multiplyScalar, numeric: numeric } = _ref;
    /**
   * Compute the product of a matrix or a list with values.
   * In case of a multidimensional array or matrix, the sum of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.prod(a, b, c, ...)
   *     math.prod(A)
   *
   * Examples:
   *
   *     math.multiply(2, 3)           // returns 6
   *     math.prod(2, 3)               // returns 6
   *     math.prod(2, 3, 4)            // returns 24
   *     math.prod([2, 3, 4])          // returns 24
   *     math.prod([[2, 5], [4, 3]])   // returns 120
   *
   * See also:
   *
   *    mean, median, min, max, sum, std, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The product of all values
   */ return typed($46c2a78821d556ea$var$name, {
        // prod([a, b, c, d, ...])
        'Array | Matrix': _prod,
        // prod([a, b, c, d, ...], dim)
        'Array | Matrix, number | BigNumber': function Array__Matrix_number__BigNumber(array, dim) {
            // TODO: implement prod(A, dim)
            throw new Error('prod(A, dim) is not yet supported');
        // return reduce(arguments[0], arguments[1], math.prod)
        },
        // prod(a, b, c, d, ...)
        '...': function _(args) {
            return _prod(args);
        }
    });
    /**
   * Recursively calculate the product of an n-dimensional array
   * @param {Array} array
   * @return {number} prod
   * @private
   */ function _prod(array) {
        var prod;
        (0, $20mkw.deepForEach)(array, function(value) {
            try {
                prod = prod === undefined ? value : multiplyScalar(prod, value);
            } catch (err) {
                throw (0, $a2CJg.improveErrorMessage)(err, 'prod', value);
            }
        });
        // make sure returning numeric value: parse a string into a numeric value
        if (typeof prod === 'string') prod = numeric(prod, (0, $6NnhX.safeNumberType)(prod, config));
        if (prod === undefined) throw new Error('Cannot calculate prod of an empty array');
        return prod;
    }
});

});

parcelRegister("fEbH9", function(module, exports) {

$parcel$export(module.exports, "createQr", () => $b643a9d04d23123a$export$39b52312ba2c4d03);

var $3p9rK = parcelRequire("3p9rK");

var $dsu7t = parcelRequire("dsu7t");
var $b643a9d04d23123a$var$name = 'qr';
var $b643a9d04d23123a$var$dependencies = [
    'typed',
    'matrix',
    'zeros',
    'identity',
    'isZero',
    'equal',
    'sign',
    'sqrt',
    'conj',
    'unaryMinus',
    'addScalar',
    'divideScalar',
    'multiplyScalar',
    'subtractScalar',
    'complex'
];
var $b643a9d04d23123a$export$39b52312ba2c4d03 = /* #__PURE__ */ (0, $dsu7t.factory)($b643a9d04d23123a$var$name, $b643a9d04d23123a$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, zeros: zeros, identity: identity, isZero: isZero, equal: equal, sign: sign, sqrt: sqrt, conj: conj, unaryMinus: unaryMinus, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtractScalar: subtractScalar, complex: complex } = _ref;
    /**
   * Calculate the Matrix QR decomposition. Matrix `A` is decomposed in
   * two matrices (`Q`, `R`) where `Q` is an
   * orthogonal matrix and `R` is an upper triangular matrix.
   *
   * Syntax:
   *
   *    math.qr(A)
   *
   * Example:
   *
   *    const m = [
   *      [1, -1,  4],
   *      [1,  4, -2],
   *      [1,  4,  2],
   *      [1,  -1, 0]
   *    ]
   *    const result = math.qr(m)
   *    // r = {
   *    //   Q: [
   *    //     [0.5, -0.5,   0.5],
   *    //     [0.5,  0.5,  -0.5],
   *    //     [0.5,  0.5,   0.5],
   *    //     [0.5, -0.5,  -0.5],
   *    //   ],
   *    //   R: [
   *    //     [2, 3,  2],
   *    //     [0, 5, -2],
   *    //     [0, 0,  4],
   *    //     [0, 0,  0]
   *    //   ]
   *    // }
   *
   * See also:
   *
   *    lup, lusolve
   *
   * @param {Matrix | Array} A    A two dimensional matrix or array
   * for which to get the QR decomposition.
   *
   * @return {{Q: Array | Matrix, R: Array | Matrix}} Q: the orthogonal
   * matrix and R: the upper triangular matrix
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))(typed($b643a9d04d23123a$var$name, {
        DenseMatrix: function DenseMatrix(m) {
            return _denseQR(m);
        },
        SparseMatrix: function SparseMatrix(m) {
            return _sparseQR(m);
        },
        Array: function Array(a) {
            // create dense matrix from array
            var m = matrix(a);
            // lup, use matrix implementation
            var r = _denseQR(m);
            // result
            return {
                Q: r.Q.valueOf(),
                R: r.R.valueOf()
            };
        }
    }), {
        _denseQRimpl: _denseQRimpl
    });
    function _denseQRimpl(m) {
        // rows & columns (m x n)
        var rows = m._size[0]; // m
        var cols = m._size[1]; // n
        var Q = identity([
            rows
        ], 'dense');
        var Qdata = Q._data;
        var R = m.clone();
        var Rdata = R._data;
        // vars
        var i, j, k;
        var w = zeros([
            rows
        ], '');
        for(k = 0; k < Math.min(cols, rows); ++k){
            /*
       * **k-th Household matrix**
       *
       * The matrix I - 2*v*transpose(v)
       * x     = first column of A
       * x1    = first element of x
       * alpha = x1 / |x1| * |x|
       * e1    = tranpose([1, 0, 0, ...])
       * u     = x - alpha * e1
       * v     = u / |u|
       *
       * Household matrix = I - 2 * v * tranpose(v)
       *
       *  * Initially Q = I and R = A.
       *  * Household matrix is a reflection in a plane normal to v which
       *    will zero out all but the top right element in R.
       *  * Appplying reflection to both Q and R will not change product.
       *  * Repeat this process on the (1,1) minor to get R as an upper
       *    triangular matrix.
       *  * Reflections leave the magnitude of the columns of Q unchanged
       *    so Q remains othoganal.
       *
       */ var pivot = Rdata[k][k];
            var sgn = unaryMinus(equal(pivot, 0) ? 1 : sign(pivot));
            var conjSgn = conj(sgn);
            var alphaSquared = 0;
            for(i = k; i < rows; i++)alphaSquared = addScalar(alphaSquared, multiplyScalar(Rdata[i][k], conj(Rdata[i][k])));
            var alpha = multiplyScalar(sgn, sqrt(alphaSquared));
            if (!isZero(alpha)) {
                // first element in vector u
                var u1 = subtractScalar(pivot, alpha);
                // w = v * u1 / |u|    (only elements k to (rows-1) are used)
                w[k] = 1;
                for(i = k + 1; i < rows; i++)w[i] = divideScalar(Rdata[i][k], u1);
                // tau = - conj(u1 / alpha)
                var tau = unaryMinus(conj(divideScalar(u1, alpha)));
                var s = void 0;
                /*
         * tau and w have been choosen so that
         *
         * 2 * v * tranpose(v) = tau * w * tranpose(w)
         */ /*
         * -- calculate R = R - tau * w * tranpose(w) * R --
         * Only do calculation with rows k to (rows-1)
         * Additionally columns 0 to (k-1) will not be changed by this
         *   multiplication so do not bother recalculating them
         */ for(j = k; j < cols; j++){
                    s = 0.0;
                    // calculate jth element of [tranpose(w) * R]
                    for(i = k; i < rows; i++)s = addScalar(s, multiplyScalar(conj(w[i]), Rdata[i][j]));
                    // calculate the jth element of [tau * transpose(w) * R]
                    s = multiplyScalar(s, tau);
                    for(i = k; i < rows; i++)Rdata[i][j] = multiplyScalar(subtractScalar(Rdata[i][j], multiplyScalar(w[i], s)), conjSgn);
                }
                /*
         * -- calculate Q = Q - tau * Q * w * transpose(w) --
         * Q is a square matrix (rows x rows)
         * Only do calculation with columns k to (rows-1)
         * Additionally rows 0 to (k-1) will not be changed by this
         *   multiplication so do not bother recalculating them
         */ for(i = 0; i < rows; i++){
                    s = 0.0;
                    // calculate ith element of [Q * w]
                    for(j = k; j < rows; j++)s = addScalar(s, multiplyScalar(Qdata[i][j], w[j]));
                    // calculate the ith element of [tau * Q * w]
                    s = multiplyScalar(s, tau);
                    for(j = k; j < rows; ++j)Qdata[i][j] = divideScalar(subtractScalar(Qdata[i][j], multiplyScalar(s, conj(w[j]))), conjSgn);
                }
            }
        }
        // return matrices
        return {
            Q: Q,
            R: R,
            toString: function toString() {
                return 'Q: ' + this.Q.toString() + '\nR: ' + this.R.toString();
            }
        };
    }
    function _denseQR(m) {
        var ret = _denseQRimpl(m);
        var Rdata = ret.R._data;
        if (m._data.length > 0) {
            var zero = Rdata[0][0].type === 'Complex' ? complex(0) : 0;
            for(var i = 0; i < Rdata.length; ++i)for(var j = 0; j < i && j < (Rdata[0] || []).length; ++j)Rdata[i][j] = zero;
        }
        return ret;
    }
    function _sparseQR(m) {
        throw new Error('qr not implemented for sparse matrices yet');
    }
});

});

parcelRegister("6uMAY", function(module, exports) {

$parcel$export(module.exports, "createQuantileSeq", () => $4bab3d724c514847$export$524607d17ea053e9);

var $edQYF = parcelRequire("edQYF");

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $4bab3d724c514847$var$name = 'quantileSeq';
var $4bab3d724c514847$var$dependencies = [
    'typed',
    '?bignumber',
    'add',
    'subtract',
    'divide',
    'multiply',
    'partitionSelect',
    'compare',
    'isInteger',
    'smaller',
    'smallerEq',
    'larger',
    'mapSlices'
];
var $4bab3d724c514847$export$524607d17ea053e9 = /* #__PURE__ */ (0, $dsu7t.factory)($4bab3d724c514847$var$name, $4bab3d724c514847$var$dependencies, (_ref)=>{
    var { typed: typed, bignumber: bignumber, add: add, subtract: subtract, divide: divide, multiply: multiply, partitionSelect: partitionSelect, compare: compare, isInteger: isInteger, smaller: smaller, smallerEq: smallerEq, larger: larger, mapSlices: mapSlices } = _ref;
    /**
   * Compute the prob order quantile of a matrix or a list with values.
   * The sequence is sorted and the middle value is returned.
   * Supported types of sequence values are: Number, BigNumber, Unit
   * Supported types of probability are: Number, BigNumber
   *
   * In case of a multidimensional array or matrix, the prob order quantile
   * of all elements will be calculated.
   *
   * Syntax:
   *
   *     math.quantileSeq(A, prob[, sorted])
   *     math.quantileSeq(A, [prob1, prob2, ...][, sorted])
   *     math.quantileSeq(A, N[, sorted])
   *
   * Examples:
   *
   *     math.quantileSeq([3, -1, 5, 7], 0.5)         // returns 4
   *     math.quantileSeq([3, -1, 5, 7], [1/3, 2/3])  // returns [3, 5]
   *     math.quantileSeq([3, -1, 5, 7], 2)           // returns [3, 5]
   *     math.quantileSeq([-1, 3, 5, 7], 0.5, true)   // returns 4
   *
   * See also:
   *
   *     median, mean, min, max, sum, prod, std, variance
   *
   * @param {Array, Matrix} data                A single matrix or Array
   * @param {Number, BigNumber, Array} probOrN  prob is the order of the quantile, while N is
   *                                            the amount of evenly distributed steps of
   *                                            probabilities; only one of these options can
   *                                            be provided
   * @param {Boolean} sorted=false              is data sorted in ascending order
   * @return {Number, BigNumber, Unit, Array}   Quantile(s)
   */ return typed($4bab3d724c514847$var$name, {
        'Array | Matrix, number | BigNumber': (data, p)=>_quantileSeqProbNumber(data, p, false),
        'Array | Matrix, number | BigNumber, number': (data, prob, dim)=>_quantileSeqDim(data, prob, false, dim, _quantileSeqProbNumber),
        'Array | Matrix, number | BigNumber, boolean': _quantileSeqProbNumber,
        'Array | Matrix, number | BigNumber, boolean, number': (data, prob, sorted, dim)=>_quantileSeqDim(data, prob, sorted, dim, _quantileSeqProbNumber),
        'Array | Matrix, Array | Matrix': (data, p)=>_quantileSeqProbCollection(data, p, false),
        'Array | Matrix, Array | Matrix, number': (data, prob, dim)=>_quantileSeqDim(data, prob, false, dim, _quantileSeqProbCollection),
        'Array | Matrix, Array | Matrix, boolean': _quantileSeqProbCollection,
        'Array | Matrix, Array | Matrix, boolean, number': (data, prob, sorted, dim)=>_quantileSeqDim(data, prob, sorted, dim, _quantileSeqProbCollection)
    });
    function _quantileSeqDim(data, prob, sorted, dim, fn) {
        return mapSlices(data, dim, (x)=>fn(x, prob, sorted));
    }
    function _quantileSeqProbNumber(data, probOrN, sorted) {
        var probArr;
        var dataArr = data.valueOf();
        if (smaller(probOrN, 0)) throw new Error('N/prob must be non-negative');
        if (smallerEq(probOrN, 1)) // quantileSeq([a, b, c, d, ...], prob[,sorted])
        return (0, $edQYF.isNumber)(probOrN) ? _quantileSeq(dataArr, probOrN, sorted) : bignumber(_quantileSeq(dataArr, probOrN, sorted));
        if (larger(probOrN, 1)) {
            // quantileSeq([a, b, c, d, ...], N[,sorted])
            if (!isInteger(probOrN)) throw new Error('N must be a positive integer');
            // largest possible Array length is 2^32-1
            // 2^32 < 10^15, thus safe conversion guaranteed
            if (larger(probOrN, 4294967295)) throw new Error('N must be less than or equal to 2^32-1, as that is the maximum length of an Array');
            var nPlusOne = add(probOrN, 1);
            probArr = [];
            for(var i = 0; smaller(i, probOrN); i++){
                var prob = divide(i + 1, nPlusOne);
                probArr.push(_quantileSeq(dataArr, prob, sorted));
            }
            return (0, $edQYF.isNumber)(probOrN) ? probArr : bignumber(probArr);
        }
    }
    /**
   * Calculate the prob order quantile of an n-dimensional array.
   *
   * @param {Array, Matrix} array
   * @param {Array, Matrix} prob
   * @param {Boolean} sorted
   * @return {Number, BigNumber, Unit} prob order quantile
   * @private
   */ function _quantileSeqProbCollection(data, probOrN, sorted) {
        var dataArr = data.valueOf();
        // quantileSeq([a, b, c, d, ...], [prob1, prob2, ...][,sorted])
        var probOrNArr = probOrN.valueOf();
        var probArr = [];
        for(var i = 0; i < probOrNArr.length; ++i)probArr.push(_quantileSeq(dataArr, probOrNArr[i], sorted));
        return probArr;
    }
    /**
   * Calculate the prob order quantile of an n-dimensional array.
   *
   * @param {Array} array
   * @param {Number, BigNumber} prob
   * @param {Boolean} sorted
   * @return {Number, BigNumber, Unit} prob order quantile
   * @private
   */ function _quantileSeq(array, prob, sorted) {
        var flat = (0, $d80Xp.flatten)(array);
        var len = flat.length;
        if (len === 0) throw new Error('Cannot calculate quantile of an empty sequence');
        var index = (0, $edQYF.isNumber)(prob) ? prob * (len - 1) : prob.times(len - 1);
        var integerPart = (0, $edQYF.isNumber)(prob) ? Math.floor(index) : index.floor().toNumber();
        var fracPart = (0, $edQYF.isNumber)(prob) ? index % 1 : index.minus(integerPart);
        if (isInteger(index)) return sorted ? flat[index] : partitionSelect(flat, (0, $edQYF.isNumber)(prob) ? index : index.valueOf());
        var left;
        var right;
        if (sorted) {
            left = flat[integerPart];
            right = flat[integerPart + 1];
        } else {
            right = partitionSelect(flat, integerPart + 1);
            // max of partition is kth largest
            left = flat[integerPart];
            for(var i = 0; i < integerPart; ++i)if (compare(flat[i], left) > 0) left = flat[i];
        }
        // Q(prob) = (1-f)*A[floor(index)] + f*A[floor(index)+1]
        return add(multiply(left, subtract(1, fracPart)), multiply(right, fracPart));
    }
});

});

parcelRegister("bL0LQ", function(module, exports) {

$parcel$export(module.exports, "createRandom", () => $88f4ae88014218e2$export$5c03d20f483e909a);

var $dsu7t = parcelRequire("dsu7t");

var $edQYF = parcelRequire("edQYF");

var $8unJy = parcelRequire("8unJy");

var $lcjQ2 = parcelRequire("lcjQ2");
var $88f4ae88014218e2$var$name = 'random';
var $88f4ae88014218e2$var$dependencies = [
    'typed',
    'config',
    '?on'
];
var $88f4ae88014218e2$export$5c03d20f483e909a = /* #__PURE__ */ (0, $dsu7t.factory)($88f4ae88014218e2$var$name, $88f4ae88014218e2$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, on: on } = _ref;
    // seeded pseudo random number generator
    var rng = (0, $8unJy.createRng)(config.randomSeed);
    if (on) on('config', function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $8unJy.createRng)(curr.randomSeed);
    });
    /**
   * Return a random number larger or equal to `min` and smaller than `max`
   * using a uniform distribution.
   *
   * Syntax:
   *
   *     math.random()                // generate a random number between 0 and 1
   *     math.random(max)             // generate a random number between 0 and max
   *     math.random(min, max)        // generate a random number between min and max
   *     math.random(size)            // generate a matrix with random numbers between 0 and 1
   *     math.random(size, max)       // generate a matrix with random numbers between 0 and max
   *     math.random(size, min, max)  // generate a matrix with random numbers between min and max
   *
   * Examples:
   *
   *     math.random()       // returns a random number between 0 and 1
   *     math.random(100)    // returns a random number between 0 and 100
   *     math.random(30, 40) // returns a random number between 30 and 40
   *     math.random([2, 3]) // returns a 2x3 matrix with random numbers between 0 and 1
   *
   * See also:
   *
   *     randomInt, pickRandom
   *
   * @param {Array | Matrix} [size] If provided, an array or matrix with given
   *                                size and filled with random values is returned
   * @param {number} [min]  Minimum boundary for the random value, included
   * @param {number} [max]  Maximum boundary for the random value, excluded
   * @return {number | Array | Matrix} A random number
   */ return typed($88f4ae88014218e2$var$name, {
        '': ()=>_random(0, 1),
        number: (max)=>_random(0, max),
        'number, number': (min, max)=>_random(min, max),
        'Array | Matrix': (size)=>_randomMatrix(size, 0, 1),
        'Array | Matrix, number': (size, max)=>_randomMatrix(size, 0, max),
        'Array | Matrix, number, number': (size, min, max)=>_randomMatrix(size, min, max)
    });
    function _randomMatrix(size, min, max) {
        var res = (0, $lcjQ2.randomMatrix)(size.valueOf(), ()=>_random(min, max));
        return (0, $edQYF.isMatrix)(size) ? size.create(res, 'number') : res;
    }
    function _random(min, max) {
        return min + rng() * (max - min);
    }
});
var $88f4ae88014218e2$export$267a132af241f602 = /* #__PURE__ */ (0, $dsu7t.factory)($88f4ae88014218e2$var$name, [
    'typed',
    'config',
    '?on'
], (_ref2)=>{
    var { typed: typed, config: config, on: on, matrix: matrix } = _ref2;
    // seeded pseudo random number generator1
    var rng = (0, $8unJy.createRng)(config.randomSeed);
    if (on) on('config', function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $8unJy.createRng)(curr.randomSeed);
    });
    return typed($88f4ae88014218e2$var$name, {
        '': ()=>_random(0, 1),
        number: (max)=>_random(0, max),
        'number, number': (min, max)=>_random(min, max)
    });
    function _random(min, max) {
        return min + rng() * (max - min);
    }
});

});
parcelRegister("lcjQ2", function(module, exports) {

$parcel$export(module.exports, "randomMatrix", () => $f6ea1b75fc0dae80$export$6549281d357a44ec);
/**
 * This is a util function for generating a random matrix recursively.
 * @param {number[]} size
 * @param {function} random
 * @returns {Array}
 */ function $f6ea1b75fc0dae80$export$6549281d357a44ec(size, random) {
    var data = [];
    size = size.slice(0);
    if (size.length > 1) for(var i = 0, length = size.shift(); i < length; i++)data.push($f6ea1b75fc0dae80$export$6549281d357a44ec(size, random));
    else for(var _i = 0, _length = size.shift(); _i < _length; _i++)data.push(random());
    return data;
}

});


parcelRegister("fdZDy", function(module, exports) {

$parcel$export(module.exports, "createRandomInt", () => $b157e1b50da4f676$export$e158da47ae479dd4);

var $dsu7t = parcelRequire("dsu7t");

var $lcjQ2 = parcelRequire("lcjQ2");

var $8unJy = parcelRequire("8unJy");

var $edQYF = parcelRequire("edQYF");
var $b157e1b50da4f676$var$name = 'randomInt';
var $b157e1b50da4f676$var$dependencies = [
    'typed',
    'config',
    'log2',
    '?on'
];
var $b157e1b50da4f676$export$e158da47ae479dd4 = /* #__PURE__ */ (0, $dsu7t.factory)($b157e1b50da4f676$var$name, $b157e1b50da4f676$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, log2: log2, on: on } = _ref;
    // seeded pseudo random number generator
    var rng = (0, $8unJy.createRng)(config.randomSeed);
    if (on) on('config', function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $8unJy.createRng)(curr.randomSeed);
    });
    /**
   * Return a random integer number larger or equal to `min` and smaller than `max`
   * using a uniform distribution.
   *
   * Syntax:
   *
   *     math.randomInt()                // generate either 0 or 1, randomly
   *     math.randomInt(max)             // generate a random integer between 0 and max
   *     math.randomInt(min, max)        // generate a random integer between min and max
   *     math.randomInt(size)            // generate a matrix with random integer between 0 and 1
   *     math.randomInt(size, max)       // generate a matrix with random integer between 0 and max
   *     math.randomInt(size, min, max)  // generate a matrix with random integer between min and max
   *
   * Examples:
   *
   *     math.randomInt(100)    // returns a random integer between 0 and 100
   *     math.randomInt(30, 40) // returns a random integer between 30 and 40
   *     math.randomInt([2, 3]) // returns a 2x3 matrix with random integers between 0 and 1
   *
   * See also:
   *
   *     random, pickRandom
   *
   * @param {Array | Matrix} [size] If provided, an array or matrix with given
   *                                size and filled with random values is returned
   * @param {number} [min]  Minimum boundary for the random value, included
   * @param {number} [max]  Maximum boundary for the random value, excluded
   * @return {number | Array | Matrix} A random integer value
   */ return typed($b157e1b50da4f676$var$name, {
        '': ()=>_randomInt(0, 2),
        number: (max)=>_randomInt(0, max),
        'number, number': (min, max)=>_randomInt(min, max),
        bigint: (max)=>_randomBigint(0n, max),
        'bigint, bigint': _randomBigint,
        'Array | Matrix': (size)=>_randomIntMatrix(size, 0, 1),
        'Array | Matrix, number': (size, max)=>_randomIntMatrix(size, 0, max),
        'Array | Matrix, number, number': (size, min, max)=>_randomIntMatrix(size, min, max)
    });
    function _randomIntMatrix(size, min, max) {
        var res = (0, $lcjQ2.randomMatrix)(size.valueOf(), ()=>_randomInt(min, max));
        return (0, $edQYF.isMatrix)(size) ? size.create(res, 'number') : res;
    }
    function _randomInt(min, max) {
        return Math.floor(min + rng() * (max - min));
    }
    function _randomBigint(min, max) {
        var simpleCutoff = 2n ** 30n;
        var width = max - min; // number of choices
        if (width <= simpleCutoff) // do it with number type
        return min + BigInt(_randomInt(0, Number(width)));
        // Too big to choose accurately that way. Instead, choose the correct
        // number of random bits to cover the width, and repeat until the
        // resulting number falls within the width
        var bits = log2(width);
        var picked = width;
        while(picked >= width){
            picked = 0n;
            for(var i = 0; i < bits; ++i)picked = 2n * picked + (rng() < 0.5 ? 0n : 1n);
        }
        return min + picked;
    }
});

});

parcelRegister("76UYg", function(module, exports) {

$parcel$export(module.exports, "createRange", () => $52d549368b1e8816$export$d372f2f3c4d1b8e5);

var $dsu7t = parcelRequire("dsu7t");

var $h5rrM = parcelRequire("h5rrM");
var $52d549368b1e8816$var$name = 'range';
var $52d549368b1e8816$var$dependencies = [
    'typed',
    'config',
    '?matrix',
    '?bignumber',
    'equal',
    'smaller',
    'smallerEq',
    'larger',
    'largerEq',
    'add',
    'isZero',
    'isPositive'
];
var $52d549368b1e8816$export$d372f2f3c4d1b8e5 = /* #__PURE__ */ (0, $dsu7t.factory)($52d549368b1e8816$var$name, $52d549368b1e8816$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, bignumber: bignumber, smaller: smaller, smallerEq: smallerEq, larger: larger, largerEq: largerEq, add: add, isZero: isZero, isPositive: isPositive } = _ref;
    /**
   * Create a matrix or array containing a range of values.
   * By default, the range end is excluded. This can be customized by providing
   * an extra parameter `includeEnd`.
   *
   * Syntax:
   *
   *     math.range(str [, includeEnd])               // Create a range from a string,
   *                                                  // where the string contains the
   *                                                  // start, optional step, and end,
   *                                                  // separated by a colon.
   *     math.range(start, end [, includeEnd])        // Create a range with start and
   *                                                  // end and a step size of 1.
   *     math.range(start, end, step [, includeEnd])  // Create a range with start, step,
   *                                                  // and end.
   *
   * Where:
   *
   * - `str: string`
   *   A string 'start:end' or 'start:step:end'
   * - `start: {number | bigint | BigNumber | Fraction | Unit}`
   *   Start of the range
   * - `end: number | bigint | BigNumber | Fraction | Unit`
   *   End of the range, excluded by default, included when parameter includeEnd=true
   * - `step: number | bigint | BigNumber | Fraction | Unit`
   *   Step size. Default value is 1.
   * - `includeEnd: boolean`
   *   Option to specify whether to include the end or not. False by default.
   *
   * The function returns a `DenseMatrix` when the library is configured with
   * `config = { matrix: 'Matrix' }, and returns an Array otherwise.
   * Note that the type of the returned values is taken from the type of the
   * provided start/end value. If only one of these is a built-in `number` type,
   * it will be promoted to the type of the other endpoint. However, in the case
   * of Unit values, both endpoints must have compatible units, and the return
   * value will have compatible units as well.
   *
   * Examples:
   *
   *     math.range(2, 6)        // [2, 3, 4, 5]
   *     math.range(2, -3, -1)   // [2, 1, 0, -1, -2]
   *     math.range('2:1:6')     // [2, 3, 4, 5]
   *     math.range(2, 6, true)  // [2, 3, 4, 5, 6]
   *     math.range(2, math.fraction(8,3), math.fraction(1,3)) // [fraction(2), fraction(7,3)]
   *     math.range(math.unit(2, 'm'), math.unit(-3, 'm'), math.unit(-1, 'm')) // [2 m, 1 m, 0 m , -1 m, -2 m]
   *
   * See also:
   *
   *     ones, zeros, size, subset
   *
   * @param {*} args   Parameters describing the range's `start`, `end`, and optional `step`.
   * @return {Array | Matrix} range
   */ return typed($52d549368b1e8816$var$name, {
        // TODO: simplify signatures when typed-function supports default values and optional arguments
        string: _strRange,
        'string, boolean': _strRange,
        number: function number(oops) {
            throw new TypeError("Too few arguments to function range(): ".concat(oops));
        },
        boolean: function boolean(oops) {
            throw new TypeError("Unexpected type of argument 1 to function range(): ".concat(oops, ", number|bigint|BigNumber|Fraction"));
        },
        'number, number': function number_number(start, end) {
            return _out(_range(start, end, 1, false));
        },
        'number, number, number': function number_number_number(start, end, step) {
            return _out(_range(start, end, step, false));
        },
        'number, number, boolean': function number_number_boolean(start, end, includeEnd) {
            return _out(_range(start, end, 1, includeEnd));
        },
        'number, number, number, boolean': function number_number_number_boolean(start, end, step, includeEnd) {
            return _out(_range(start, end, step, includeEnd));
        },
        // Handle bigints; if either limit is bigint, range should be too
        'bigint, bigint|number': function bigint_bigintNumber(start, end) {
            return _out(_range(start, end, 1n, false));
        },
        'number, bigint': function number_bigint(start, end) {
            return _out(_range(BigInt(start), end, 1n, false));
        },
        'bigint, bigint|number, bigint|number': function bigint_bigintNumber_bigintNumber(start, end, step) {
            return _out(_range(start, end, BigInt(step), false));
        },
        'number, bigint, bigint|number': function number_bigint_bigintNumber(start, end, step) {
            return _out(_range(BigInt(start), end, BigInt(step), false));
        },
        'bigint, bigint|number, boolean': function bigint_bigintNumber_boolean(start, end, includeEnd) {
            return _out(_range(start, end, 1n, includeEnd));
        },
        'number, bigint, boolean': function number_bigint_boolean(start, end, includeEnd) {
            return _out(_range(BigInt(start), end, 1n, includeEnd));
        },
        'bigint, bigint|number, bigint|number, boolean': function bigint_bigintNumber_bigintNumber_boolean(start, end, step, includeEnd) {
            return _out(_range(start, end, BigInt(step), includeEnd));
        },
        'number, bigint, bigint|number, boolean': function number_bigint_bigintNumber_boolean(start, end, step, includeEnd) {
            return _out(_range(BigInt(start), end, BigInt(step), includeEnd));
        },
        'BigNumber, BigNumber': function BigNumber_BigNumber(start, end) {
            var BigNumber = start.constructor;
            return _out(_range(start, end, new BigNumber(1), false));
        },
        'BigNumber, BigNumber, BigNumber': function BigNumber_BigNumber_BigNumber(start, end, step) {
            return _out(_range(start, end, step, false));
        },
        'BigNumber, BigNumber, boolean': function BigNumber_BigNumber_boolean(start, end, includeEnd) {
            var BigNumber = start.constructor;
            return _out(_range(start, end, new BigNumber(1), includeEnd));
        },
        'BigNumber, BigNumber, BigNumber, boolean': function BigNumber_BigNumber_BigNumber_boolean(start, end, step, includeEnd) {
            return _out(_range(start, end, step, includeEnd));
        },
        'Fraction, Fraction': function Fraction_Fraction(start, end) {
            return _out(_range(start, end, 1, false));
        },
        'Fraction, Fraction, Fraction': function Fraction_Fraction_Fraction(start, end, step) {
            return _out(_range(start, end, step, false));
        },
        'Fraction, Fraction, boolean': function Fraction_Fraction_boolean(start, end, includeEnd) {
            return _out(_range(start, end, 1, includeEnd));
        },
        'Fraction, Fraction, Fraction, boolean': function Fraction_Fraction_Fraction_boolean(start, end, step, includeEnd) {
            return _out(_range(start, end, step, includeEnd));
        },
        'Unit, Unit, Unit': function Unit_Unit_Unit(start, end, step) {
            return _out(_range(start, end, step, false));
        },
        'Unit, Unit, Unit, boolean': function Unit_Unit_Unit_boolean(start, end, step, includeEnd) {
            return _out(_range(start, end, step, includeEnd));
        }
    });
    function _out(arr) {
        if (config.matrix === 'Matrix') return matrix ? matrix(arr) : (0, $h5rrM.noMatrix)();
        return arr;
    }
    function _strRange(str, includeEnd) {
        var r = _parse(str);
        if (!r) throw new SyntaxError('String "' + str + '" is no valid range');
        if (config.number === 'BigNumber') {
            if (bignumber === undefined) (0, $h5rrM.noBignumber)();
            return _out(_range(bignumber(r.start), bignumber(r.end), bignumber(r.step)), includeEnd);
        } else return _out(_range(r.start, r.end, r.step, includeEnd));
    }
    /**
   * Create a range with numbers or BigNumbers
   * @param {number | BigNumber | Unit} start
   * @param {number | BigNumber | Unit} end
   * @param {number | BigNumber | Unit} step
   * @param {boolean} includeEnd
   * @returns {Array} range
   * @private
   */ function _range(start, end, step, includeEnd) {
        var array = [];
        if (isZero(step)) throw new Error('Step must be non-zero');
        var ongoing = isPositive(step) ? includeEnd ? smallerEq : smaller : includeEnd ? largerEq : larger;
        var x = start;
        while(ongoing(x, end)){
            array.push(x);
            x = add(x, step);
        }
        return array;
    }
    /**
   * Parse a string into a range,
   * The string contains the start, optional step, and end, separated by a colon.
   * If the string does not contain a valid range, null is returned.
   * For example str='0:2:11'.
   * @param {string} str
   * @return {{start: number, end: number, step: number} | null} range Object containing properties start, end, step
   * @private
   */ function _parse(str) {
        var args = str.split(':');
        // number
        var nums = args.map(function(arg) {
            // use Number and not parseFloat as Number returns NaN on invalid garbage in the string
            return Number(arg);
        });
        var invalid = nums.some(function(num) {
            return isNaN(num);
        });
        if (invalid) return null;
        switch(nums.length){
            case 2:
                return {
                    start: nums[0],
                    end: nums[1],
                    step: 1
                };
            case 3:
                return {
                    start: nums[0],
                    end: nums[2],
                    step: nums[1]
                };
            default:
                return null;
        }
    }
});

});

parcelRegister("dOu7E", function(module, exports) {

$parcel$export(module.exports, "createRangeClass", () => $a0e74f8f1e572886$export$e87cc8d3f29c5e1b);

var $edQYF = parcelRequire("edQYF");

var $6NnhX = parcelRequire("6NnhX");

var $dsu7t = parcelRequire("dsu7t");
var $a0e74f8f1e572886$var$name = 'Range';
var $a0e74f8f1e572886$var$dependencies = [];
var $a0e74f8f1e572886$export$e87cc8d3f29c5e1b = /* #__PURE__ */ (0, $dsu7t.factory)($a0e74f8f1e572886$var$name, $a0e74f8f1e572886$var$dependencies, ()=>{
    /**
   * Create a range of numbers. A range has a start, step, and end,
   * and contains functions to iterate over the range.
   *
   * A range can be constructed as:
   *
   *     const range = new Range(start, end)
   *     const range = new Range(start, end, step)
   *
   * Note that the endpoints and step may be specified with other numeric
   * types such as bigint or BigNumber, but they will be demoted to the
   * built-in `number` type and the Range will only contain numbers. The
   * rationale for this demotion is that Range objects are primarily used
   * for indexing Matrix objects, and Matrix objects may only be indexed
   * with `number`s.
   *
   * To get the result of the range:
   *     range.forEach(function (x) {
   *         console.log(x)
   *     })
   *     range.map(function (x) {
   *         return math.sin(x)
   *     })
   *     range.toArray()
   *
   * Example usage:
   *
   *     const c = new Range(2, 6)       // 2:1:5
   *     c.toArray()                     // [2, 3, 4, 5]
   *     const d = new Range(2, -3, -1)  // 2:-1:-2
   *     d.toArray()                     // [2, 1, 0, -1, -2]
   *
   * @class Range
   * @constructor Range
   * @param {number} start  included lower bound
   * @param {number} end    excluded upper bound
   * @param {number} [step] step size, default value is 1
   */ function Range(start, end, step) {
        if (!(this instanceof Range)) throw new SyntaxError('Constructor must be called with the new operator');
        var hasStart = start !== null && start !== undefined;
        var hasEnd = end !== null && end !== undefined;
        var hasStep = step !== null && step !== undefined;
        if (hasStart) {
            if ((0, $edQYF.isBigNumber)(start)) start = start.toNumber();
            else if (typeof start !== 'number' && !(0, $edQYF.isBigInt)(start)) throw new TypeError('Parameter start must be a number or bigint');
        }
        if (hasEnd) {
            if ((0, $edQYF.isBigNumber)(end)) end = end.toNumber();
            else if (typeof end !== 'number' && !(0, $edQYF.isBigInt)(end)) throw new TypeError('Parameter end must be a number or bigint');
        }
        if (hasStep) {
            if ((0, $edQYF.isBigNumber)(step)) step = step.toNumber();
            else if (typeof step !== 'number' && !(0, $edQYF.isBigInt)(step)) throw new TypeError('Parameter step must be a number or bigint');
        }
        this.start = hasStart ? parseFloat(start) : 0;
        this.end = hasEnd ? parseFloat(end) : 0;
        this.step = hasStep ? parseFloat(step) : 1;
        if (hasStep && (0, $6NnhX.nearlyEqual)(this.step, 0)) throw new Error('Step must not be zero');
    }
    /**
   * Attach type information
   */ Range.prototype.type = 'Range';
    Range.prototype.isRange = true;
    /**
   * Parse a string into a range,
   * The string contains the start, optional step, and end, separated by a colon.
   * If the string does not contain a valid range, null is returned.
   * For example str='0:2:11'.
   * @memberof Range
   * @param {string} str
   * @return {Range | null} range
   */ Range.parse = function(str) {
        if (typeof str !== 'string') return null;
        var args = str.split(':');
        var nums = args.map(function(arg) {
            return parseFloat(arg);
        });
        var invalid = nums.some(function(num) {
            return isNaN(num);
        });
        if (invalid) return null;
        switch(nums.length){
            case 2:
                return new Range(nums[0], nums[1]);
            case 3:
                return new Range(nums[0], nums[2], nums[1]);
            default:
                return null;
        }
    };
    /**
   * Create a clone of the range
   * @return {Range} clone
   */ Range.prototype.clone = function() {
        return new Range(this.start, this.end, this.step);
    };
    /**
   * Retrieve the size of the range.
   * Returns an array containing one number, the number of elements in the range.
   * @memberof Range
   * @returns {number[]} size
   */ Range.prototype.size = function() {
        var len = 0;
        var start = this.start;
        var step = this.step;
        var end = this.end;
        var diff = end - start;
        if ((0, $6NnhX.sign)(step) === (0, $6NnhX.sign)(diff)) len = Math.ceil(diff / step);
        else if (diff === 0) len = 0;
        if (isNaN(len)) len = 0;
        return [
            len
        ];
    };
    /**
   * Calculate the minimum value in the range
   * @memberof Range
   * @return {number | undefined} min
   */ Range.prototype.min = function() {
        var size = this.size()[0];
        if (size > 0) {
            if (this.step > 0) // positive step
            return this.start;
            else // negative step
            return this.start + (size - 1) * this.step;
        } else return undefined;
    };
    /**
   * Calculate the maximum value in the range
   * @memberof Range
   * @return {number | undefined} max
   */ Range.prototype.max = function() {
        var size = this.size()[0];
        if (size > 0) {
            if (this.step > 0) // positive step
            return this.start + (size - 1) * this.step;
            else // negative step
            return this.start;
        } else return undefined;
    };
    /**
   * Execute a callback function for each value in the range.
   * @memberof Range
   * @param {function} callback   The callback method is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Range being traversed.
   */ Range.prototype.forEach = function(callback) {
        var x = this.start;
        var step = this.step;
        var end = this.end;
        var i = 0;
        if (step > 0) while(x < end){
            callback(x, [
                i
            ], this);
            x += step;
            i++;
        }
        else if (step < 0) while(x > end){
            callback(x, [
                i
            ], this);
            x += step;
            i++;
        }
    };
    /**
   * Execute a callback function for each value in the Range, and return the
   * results as an array
   * @memberof Range
   * @param {function} callback   The callback method is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @returns {Array} array
   */ Range.prototype.map = function(callback) {
        var array = [];
        this.forEach(function(value, index, obj) {
            array[index[0]] = callback(value, index, obj);
        });
        return array;
    };
    /**
   * Create an Array with a copy of the Ranges data
   * @memberof Range
   * @returns {Array} array
   */ Range.prototype.toArray = function() {
        var array = [];
        this.forEach(function(value, index) {
            array[index[0]] = value;
        });
        return array;
    };
    /**
   * Get the primitive value of the Range, a one dimensional array
   * @memberof Range
   * @returns {Array} array
   */ Range.prototype.valueOf = function() {
        // TODO: implement a caching mechanism for range.valueOf()
        return this.toArray();
    };
    /**
   * Get a string representation of the range, with optional formatting options.
   * Output is formatted as 'start:step:end', for example '2:6' or '0:0.2:11'
   * @memberof Range
   * @param {Object | number | function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ Range.prototype.format = function(options) {
        var str = (0, $6NnhX.format)(this.start, options);
        if (this.step !== 1) str += ':' + (0, $6NnhX.format)(this.step, options);
        str += ':' + (0, $6NnhX.format)(this.end, options);
        return str;
    };
    /**
   * Get a string representation of the range.
   * @memberof Range
   * @returns {string}
   */ Range.prototype.toString = function() {
        return this.format();
    };
    /**
   * Get a JSON representation of the range
   * @memberof Range
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
   */ Range.prototype.toJSON = function() {
        return {
            mathjs: 'Range',
            start: this.start,
            end: this.end,
            step: this.step
        };
    };
    /**
   * Instantiate a Range from a JSON object
   * @memberof Range
   * @param {Object} json A JSON object structured as:
   *                      `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
   * @return {Range}
   */ Range.fromJSON = function(json) {
        return new Range(json.start, json.end, json.step);
    };
    return Range;
}, {
    isClass: true
});

});

parcelRegister("bQS9i", function(module, exports) {

$parcel$export(module.exports, "createRe", () => $8a0e8de1cc4454ac$export$803e46d0de790dbf);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");
var $8a0e8de1cc4454ac$var$name = 're';
var $8a0e8de1cc4454ac$var$dependencies = [
    'typed'
];
var $8a0e8de1cc4454ac$export$803e46d0de790dbf = /* #__PURE__ */ (0, $dsu7t.factory)($8a0e8de1cc4454ac$var$name, $8a0e8de1cc4454ac$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Get the real part of a complex number.
   * For a complex number `a + bi`, the function returns `a`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.re(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 3)
   *    math.re(a)                     // returns number 2
   *    math.im(a)                     // returns number 3
   *
   *    math.re(math.complex('-5.2i')) // returns number 0
   *    math.re(math.complex(2.4))     // returns number 2.4
   *
   * See also:
   *
   *    im, conj, abs, arg
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The real part of x
   */ return typed($8a0e8de1cc4454ac$var$name, {
        'number | BigNumber | Fraction': (x)=>x,
        Complex: (x)=>x.re,
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});

parcelRegister("9prS4", function(module, exports) {

$parcel$export(module.exports, "createReplacer", () => $6d9c1180687a9abf$export$481a522c866104eb);

var $dsu7t = parcelRequire("dsu7t");
var $6d9c1180687a9abf$var$name = 'replacer';
var $6d9c1180687a9abf$var$dependencies = [];
var $6d9c1180687a9abf$export$481a522c866104eb = /* #__PURE__ */ (0, $dsu7t.factory)($6d9c1180687a9abf$var$name, $6d9c1180687a9abf$var$dependencies, ()=>{
    /**
   * Stringify data types into their JSON representation.
   * Most data types can be serialized using their `.toJSON` method,
   * but not all, for example the number `Infinity`. For these cases you have
   * to use the replacer. Example usage:
   *
   *     JSON.stringify([2, Infinity], math.replacer)
   *
   * @param {string} key
   * @param {*} value
   * @returns {*} Returns the replaced object
   */ return function replacer(key, value) {
        // the numeric values Infinitiy, -Infinity, and NaN cannot be serialized to JSON
        if (typeof value === 'number' && (!isFinite(value) || isNaN(value))) return {
            mathjs: 'number',
            value: String(value)
        };
        if (typeof value === 'bigint') return {
            mathjs: 'bigint',
            value: String(value)
        };
        return value;
    };
});

});

parcelRegister("5eonE", function(module, exports) {

$parcel$export(module.exports, "createReshape", () => $3cf12bfd88ad1898$export$76c9752f34fb3440);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $3cf12bfd88ad1898$var$name = 'reshape';
var $3cf12bfd88ad1898$var$dependencies = [
    'typed',
    'isInteger',
    'matrix'
];
var $3cf12bfd88ad1898$export$76c9752f34fb3440 = /* #__PURE__ */ (0, $dsu7t.factory)($3cf12bfd88ad1898$var$name, $3cf12bfd88ad1898$var$dependencies, (_ref)=>{
    var { typed: typed, isInteger: isInteger } = _ref;
    /**
   * Reshape a multi dimensional array to fit the specified dimensions
   *
   * Syntax:
   *
   *     math.reshape(x, sizes)
   *
   * Examples:
   *
   *     math.reshape([1, 2, 3, 4, 5, 6], [2, 3])
   *     // returns Array  [[1, 2, 3], [4, 5, 6]]
   *
   *     math.reshape([[1, 2], [3, 4]], [1, 4])
   *     // returns Array  [[1, 2, 3, 4]]
   *
   *     math.reshape([[1, 2], [3, 4]], [4])
   *     // returns Array [1, 2, 3, 4]
   *
   *     const x = math.matrix([1, 2, 3, 4, 5, 6, 7, 8])
   *     math.reshape(x, [2, 2, 2])
   *     // returns Matrix [[[1, 2], [3, 4]], [[5, 6], [7, 8]]]
   *
   *    math.reshape([1, 2, 3, 4], [-1, 2])
   *    // returns Matrix [[1, 2], [3, 4]]
   *
   * See also:
   *
   *     size, squeeze, resize
   *
   * @param {Array | Matrix | *} x  Matrix to be reshaped
   * @param {number[]} sizes        One dimensional array with integral sizes for
   *                                each dimension. One -1 is allowed as wildcard,
   *                                which calculates this dimension automatically.
   *
   * @return {* | Array | Matrix}   A reshaped clone of matrix `x`
   *
   * @throws {TypeError}            If `sizes` does not contain solely integers
   * @throws {DimensionError}       If the product of the new dimension sizes does
   *                                not equal that of the old ones
   */ return typed($3cf12bfd88ad1898$var$name, {
        'Matrix, Array': function Matrix_Array(x, sizes) {
            return x.reshape(sizes, true);
        },
        'Array, Array': function Array_Array(x, sizes) {
            sizes.forEach(function(size) {
                if (!isInteger(size)) throw new TypeError('Invalid size for dimension: ' + size);
            });
            return (0, $d80Xp.reshape)(x, sizes);
        }
    });
});

});

parcelRegister("iGaPH", function(module, exports) {

$parcel$export(module.exports, "createResize", () => $d9948d70c5552f03$export$58909557046ca413);

var $edQYF = parcelRequire("edQYF");

var $7asMt = parcelRequire("7asMt");

var $1tI8o = parcelRequire("1tI8o");

var $6NnhX = parcelRequire("6NnhX");

var $j2hDb = parcelRequire("j2hDb");

var $9v8q6 = parcelRequire("9v8q6");

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $d9948d70c5552f03$var$name = 'resize';
var $d9948d70c5552f03$var$dependencies = [
    'config',
    'matrix'
];
var $d9948d70c5552f03$export$58909557046ca413 = /* #__PURE__ */ (0, $dsu7t.factory)($d9948d70c5552f03$var$name, $d9948d70c5552f03$var$dependencies, (_ref)=>{
    var { config: config, matrix: matrix } = _ref;
    /**
   * Resize a matrix
   *
   * Syntax:
   *
   *     math.resize(x, size)
   *     math.resize(x, size, defaultValue)
   *
   * Examples:
   *
   *     math.resize([1, 2, 3, 4, 5], [3]) // returns Array  [1, 2, 3]
   *     math.resize([1, 2, 3], [5], 0)    // returns Array  [1, 2, 3, 0, 0]
   *     math.resize(2, [2, 3], 0)         // returns Matrix [[2, 0, 0], [0, 0, 0]]
   *     math.resize("hello", [8], "!")    // returns string 'hello!!!'
   *
   * See also:
   *
   *     size, squeeze, subset, reshape
   *
   * @param {Array | Matrix | *} x             Matrix to be resized
   * @param {Array | Matrix} size              One dimensional array with numbers
   * @param {number | string} [defaultValue=0] Zero by default, except in
   *                                           case of a string, in that case
   *                                           defaultValue = ' '
   * @return {* | Array | Matrix} A resized clone of matrix `x`
   */ // TODO: rework resize to a typed-function
    return function resize(x, size, defaultValue) {
        if (arguments.length !== 2 && arguments.length !== 3) throw new (0, $1tI8o.ArgumentsError)('resize', arguments.length, 2, 3);
        if ((0, $edQYF.isMatrix)(size)) size = size.valueOf(); // get Array
        if ((0, $edQYF.isBigNumber)(size[0])) // convert bignumbers to numbers
        size = size.map(function(value) {
            return !(0, $edQYF.isBigNumber)(value) ? value : value.toNumber();
        });
        // check x is a Matrix
        if ((0, $edQYF.isMatrix)(x)) // use optimized matrix implementation, return copy
        return x.resize(size, defaultValue, true);
        if (typeof x === 'string') // resize string
        return _resizeString(x, size, defaultValue);
        // check result should be a matrix
        var asMatrix = Array.isArray(x) ? false : config.matrix !== 'Array';
        if (size.length === 0) {
            // output a scalar
            while(Array.isArray(x))x = x[0];
            return (0, $9v8q6.clone)(x);
        } else {
            // output an array/matrix
            if (!Array.isArray(x)) x = [
                x
            ];
            x = (0, $9v8q6.clone)(x);
            var res = (0, $d80Xp.resize)(x, size, defaultValue);
            return asMatrix ? matrix(res) : res;
        }
    };
    /**
   * Resize a string
   * @param {string} str
   * @param {number[]} size
   * @param {string} [defaultChar=' ']
   * @private
   */ function _resizeString(str, size, defaultChar) {
        if (defaultChar !== undefined) {
            if (typeof defaultChar !== 'string' || defaultChar.length !== 1) throw new TypeError('Single character expected as defaultValue');
        } else defaultChar = ' ';
        if (size.length !== 1) throw new (0, $7asMt.DimensionError)(size.length, 1);
        var len = size[0];
        if (typeof len !== 'number' || !(0, $6NnhX.isInteger)(len)) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $j2hDb.format)(size) + ')');
        if (str.length > len) return str.substring(0, len);
        else if (str.length < len) {
            var res = str;
            for(var i = 0, ii = len - str.length; i < ii; i++)res += defaultChar;
            return res;
        } else return str;
    }
});

});

parcelRegister("3yS4h", function(module, exports) {

$parcel$export(module.exports, "createResultSet", () => $297e7cd7be318f83$export$dfb3187f1c4e3bbe);

var $dsu7t = parcelRequire("dsu7t");
var $297e7cd7be318f83$var$name = 'ResultSet';
var $297e7cd7be318f83$var$dependencies = [];
var $297e7cd7be318f83$export$dfb3187f1c4e3bbe = /* #__PURE__ */ (0, $dsu7t.factory)($297e7cd7be318f83$var$name, $297e7cd7be318f83$var$dependencies, ()=>{
    /**
   * A ResultSet contains a list or results
   * @class ResultSet
   * @param {Array} entries
   * @constructor ResultSet
   */ function ResultSet(entries) {
        if (!(this instanceof ResultSet)) throw new SyntaxError('Constructor must be called with the new operator');
        this.entries = entries || [];
    }
    /**
   * Attach type information
   */ ResultSet.prototype.type = 'ResultSet';
    ResultSet.prototype.isResultSet = true;
    /**
   * Returns the array with results hold by this ResultSet
   * @memberof ResultSet
   * @returns {Array} entries
   */ ResultSet.prototype.valueOf = function() {
        return this.entries;
    };
    /**
   * Returns the stringified results of the ResultSet
   * @memberof ResultSet
   * @returns {string} string
   */ ResultSet.prototype.toString = function() {
        return '[' + this.entries.map(String).join(', ') + ']';
    };
    /**
   * Get a JSON representation of the ResultSet
   * @memberof ResultSet
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "ResultSet", "entries": [...]}`
   */ ResultSet.prototype.toJSON = function() {
        return {
            mathjs: 'ResultSet',
            entries: this.entries
        };
    };
    /**
   * Instantiate a ResultSet from a JSON object
   * @memberof ResultSet
   * @param {Object} json  A JSON object structured as:
   *                       `{"mathjs": "ResultSet", "entries": [...]}`
   * @return {ResultSet}
   */ ResultSet.fromJSON = function(json) {
        return new ResultSet(json.entries);
    };
    return ResultSet;
}, {
    isClass: true
});

});

parcelRegister("5rj3t", function(module, exports) {

$parcel$export(module.exports, "createRightArithShift", () => $3f5e414c9b7af86d$export$ef742376390cbf7);

var $2704b = parcelRequire("2704b");

var $kycT3 = parcelRequire("kycT3");

var $52JKA = parcelRequire("52JKA");

var $dK2sh = parcelRequire("dK2sh");

var $ahu8B = parcelRequire("ahu8B");

var $enjrI = parcelRequire("enjrI");

var $jLQxN = parcelRequire("jLQxN");

var $dsu7t = parcelRequire("dsu7t");

var $6SJnV = parcelRequire("6SJnV");

var $1Z19h = parcelRequire("1Z19h");

var $jbibQ = parcelRequire("jbibQ");
var $3f5e414c9b7af86d$var$name = 'rightArithShift';
var $3f5e414c9b7af86d$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'zeros',
    'DenseMatrix',
    'concat'
];
var $3f5e414c9b7af86d$export$ef742376390cbf7 = /* #__PURE__ */ (0, $dsu7t.factory)($3f5e414c9b7af86d$var$name, $3f5e414c9b7af86d$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo01xDSid = (0, $ahu8B.createMatAlgo01xDSid)({
        typed: typed
    });
    var matAlgo02xDS0 = (0, $kycT3.createMatAlgo02xDS0)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo08xS0Sid = (0, $jLQxN.createMatAlgo08xS0Sid)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo10xSids = (0, $enjrI.createMatAlgo10xSids)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo11xS0s = (0, $52JKA.createMatAlgo11xS0s)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo14xDs = (0, $dK2sh.createMatAlgo14xDs)({
        typed: typed
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var useMatrixForArrayScalar = (0, $1Z19h.createUseMatrixForArrayScalar)({
        typed: typed,
        matrix: matrix
    });
    /**
   * Bitwise right arithmetic shift of a value x by y number of bits, `x >> y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.rightArithShift(x, y)
   *
   * Examples:
   *
   *    math.rightArithShift(4, 2)               // returns number 1
   *
   *    math.rightArithShift([16, -32, 64], 4)   // returns Array [1, -2, 4]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, bitXor, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | bigint | Array | Matrix} x Value to be shifted
   * @param  {number | BigNumber | bigint} y Amount of shifts
   * @return {number | BigNumber | bigint | Array | Matrix} `x` zero-filled shifted right `y` times
   */ return typed($3f5e414c9b7af86d$var$name, {
        'number, number': (0, $jbibQ.rightArithShiftNumber),
        'BigNumber, BigNumber': (0, $2704b.rightArithShiftBigNumber),
        'bigint, bigint': (x, y)=>x >> y,
        'SparseMatrix, number | BigNumber': typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(y, 0)) return x.clone();
                return matAlgo11xS0s(x, y, self, false);
            }),
        'DenseMatrix, number | BigNumber': typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(y, 0)) return x.clone();
                return matAlgo14xDs(x, y, self, false);
            }),
        'number | BigNumber, SparseMatrix': typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
                return matAlgo10xSids(y, x, self, true);
            }),
        'number | BigNumber, DenseMatrix': typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
                return matAlgo14xDs(y, x, self, true);
            })
    }, useMatrixForArrayScalar, matrixAlgorithmSuite({
        SS: matAlgo08xS0Sid,
        DS: matAlgo01xDSid,
        SD: matAlgo02xDS0
    }));
});

});

parcelRegister("1yReL", function(module, exports) {

$parcel$export(module.exports, "createRightLogShift", () => $12324334becd685c$export$2dd001e9fd66adcd);

var $kycT3 = parcelRequire("kycT3");

var $52JKA = parcelRequire("52JKA");

var $dK2sh = parcelRequire("dK2sh");

var $ahu8B = parcelRequire("ahu8B");

var $enjrI = parcelRequire("enjrI");

var $jLQxN = parcelRequire("jLQxN");

var $dsu7t = parcelRequire("dsu7t");

var $6SJnV = parcelRequire("6SJnV");

var $jbibQ = parcelRequire("jbibQ");

var $1Z19h = parcelRequire("1Z19h");
var $12324334becd685c$var$name = 'rightLogShift';
var $12324334becd685c$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'zeros',
    'DenseMatrix',
    'concat'
];
var $12324334becd685c$export$2dd001e9fd66adcd = /* #__PURE__ */ (0, $dsu7t.factory)($12324334becd685c$var$name, $12324334becd685c$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    var matAlgo01xDSid = (0, $ahu8B.createMatAlgo01xDSid)({
        typed: typed
    });
    var matAlgo02xDS0 = (0, $kycT3.createMatAlgo02xDS0)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo08xS0Sid = (0, $jLQxN.createMatAlgo08xS0Sid)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo10xSids = (0, $enjrI.createMatAlgo10xSids)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo11xS0s = (0, $52JKA.createMatAlgo11xS0s)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo14xDs = (0, $dK2sh.createMatAlgo14xDs)({
        typed: typed
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var useMatrixForArrayScalar = (0, $1Z19h.createUseMatrixForArrayScalar)({
        typed: typed,
        matrix: matrix
    });
    /**
   * Bitwise right logical shift of value x by y number of bits, `x >>> y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.rightLogShift(x, y)
   *
   * Examples:
   *
   *    math.rightLogShift(4, 2)               // returns number 1
   *
   *    math.rightLogShift([16, 32, 64], 4)    // returns Array [1, 2, 4]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, bitXor, leftShift, rightLogShift
   *
   * @param  {number | Array | Matrix} x Value to be shifted
   * @param  {number} y Amount of shifts
   * @return {number | Array | Matrix} `x` zero-filled shifted right `y` times
   */ return typed($12324334becd685c$var$name, {
        'number, number': (0, $jbibQ.rightLogShiftNumber),
        // 'BigNumber, BigNumber': ..., // TODO: implement BigNumber support for rightLogShift
        'SparseMatrix, number | BigNumber': typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(y, 0)) return x.clone();
                return matAlgo11xS0s(x, y, self, false);
            }),
        'DenseMatrix, number | BigNumber': typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(y, 0)) return x.clone();
                return matAlgo14xDs(x, y, self, false);
            }),
        'number | BigNumber, SparseMatrix': typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
                return matAlgo10xSids(y, x, self, true);
            }),
        'number | BigNumber, DenseMatrix': typed.referToSelf((self)=>(x, y)=>{
                // check scalar
                if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
                return matAlgo14xDs(y, x, self, true);
            })
    }, useMatrixForArrayScalar, matrixAlgorithmSuite({
        SS: matAlgo08xS0Sid,
        DS: matAlgo01xDSid,
        SD: matAlgo02xDS0
    }));
});

});

parcelRegister("k4T9A", function(module, exports) {

$parcel$export(module.exports, "createRotate", () => $e9def6b93f3c9083$export$484058214789ee04);

var $dsu7t = parcelRequire("dsu7t");

var $d80Xp = parcelRequire("d80Xp");
var $e9def6b93f3c9083$var$name = 'rotate';
var $e9def6b93f3c9083$var$dependencies = [
    'typed',
    'multiply',
    'rotationMatrix'
];
var $e9def6b93f3c9083$export$484058214789ee04 = /* #__PURE__ */ (0, $dsu7t.factory)($e9def6b93f3c9083$var$name, $e9def6b93f3c9083$var$dependencies, (_ref)=>{
    var { typed: typed, multiply: multiply, rotationMatrix: rotationMatrix } = _ref;
    /**
     * Rotate a vector of size 1x2 counter-clockwise by a given angle
     * Rotate a vector of size 1x3 counter-clockwise by a given angle around the given axis
     *
     * Syntax:
     *
     *    math.rotate(w, theta)
     *    math.rotate(w, theta, v)
     *
     * Examples:
     *
     *    math.rotate([11, 12], math.pi / 2)                           // returns [-12, 11]
     *    math.rotate(matrix([11, 12]), math.pi / 2)                   // returns [-12, 11]
     *
     *    math.rotate([1, 0, 0], unit('90deg'), [0, 0, 1])             // returns [0, 1, 0]
     *    math.rotate(matrix([1, 0, 0]), unit('90deg'), [0, 0, 1])     // returns Matrix [0, 1, 0]
     *
     *    math.rotate([1, 0], math.complex(1 + i))                     // returns [cos(1 + i) - sin(1 + i), sin(1 + i) + cos(1 + i)]
     *
     * See also:
     *
     *    matrix, rotationMatrix
     *
     * @param {Array | Matrix} w                             Vector to rotate
     * @param {number | BigNumber | Complex | Unit} theta    Rotation angle
     * @param {Array | Matrix} [v]                           Rotation axis
     * @return {Array | Matrix}                              Multiplication of the rotation matrix and w
     */ return typed($e9def6b93f3c9083$var$name, {
        'Array , number | BigNumber | Complex | Unit': function Array__number__BigNumber__Complex__Unit(w, theta) {
            _validateSize(w, 2);
            var matrixRes = multiply(rotationMatrix(theta), w);
            return matrixRes.toArray();
        },
        'Matrix , number | BigNumber | Complex | Unit': function Matrix__number__BigNumber__Complex__Unit(w, theta) {
            _validateSize(w, 2);
            return multiply(rotationMatrix(theta), w);
        },
        'Array, number | BigNumber | Complex | Unit, Array | Matrix': function Array_number__BigNumber__Complex__Unit_Array__Matrix(w, theta, v) {
            _validateSize(w, 3);
            var matrixRes = multiply(rotationMatrix(theta, v), w);
            return matrixRes;
        },
        'Matrix, number | BigNumber | Complex | Unit, Array | Matrix': function Matrix_number__BigNumber__Complex__Unit_Array__Matrix(w, theta, v) {
            _validateSize(w, 3);
            return multiply(rotationMatrix(theta, v), w);
        }
    });
    function _validateSize(v, expectedSize) {
        var actualSize = Array.isArray(v) ? (0, $d80Xp.arraySize)(v) : v.size();
        if (actualSize.length > 2) throw new RangeError("Vector must be of dimensions 1x".concat(expectedSize));
        if (actualSize.length === 2 && actualSize[1] !== 1) throw new RangeError("Vector must be of dimensions 1x".concat(expectedSize));
        if (actualSize[0] !== expectedSize) throw new RangeError("Vector must be of dimensions 1x".concat(expectedSize));
    }
});

});

parcelRegister("cYdow", function(module, exports) {

$parcel$export(module.exports, "createRotationMatrix", () => $97157a8628e63c67$export$7c79514a80dc15a2);

var $edQYF = parcelRequire("edQYF");

var $dsu7t = parcelRequire("dsu7t");
var $97157a8628e63c67$var$name = 'rotationMatrix';
var $97157a8628e63c67$var$dependencies = [
    'typed',
    'config',
    'multiplyScalar',
    'addScalar',
    'unaryMinus',
    'norm',
    'matrix',
    'BigNumber',
    'DenseMatrix',
    'SparseMatrix',
    'cos',
    'sin'
];
var $97157a8628e63c67$export$7c79514a80dc15a2 = /* #__PURE__ */ (0, $dsu7t.factory)($97157a8628e63c67$var$name, $97157a8628e63c67$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, multiplyScalar: multiplyScalar, addScalar: addScalar, unaryMinus: unaryMinus, norm: norm, BigNumber: BigNumber, matrix: matrix, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix, cos: cos, sin: sin } = _ref;
    /**
   * Create a 2-dimensional counter-clockwise rotation matrix (2x2) for a given angle (expressed in radians).
   * Create a 2-dimensional counter-clockwise rotation matrix (3x3) by a given angle (expressed in radians) around a given axis (1x3).
   *
   * Syntax:
   *
   *    math.rotationMatrix(theta)
   *    math.rotationMatrix(theta, format)
   *    math.rotationMatrix(theta, [v])
   *    math.rotationMatrix(theta, [v], format)
   *
   * Examples:
   *
   *    math.rotationMatrix(math.pi / 2)                      // returns [[0, -1], [1, 0]]
   *    math.rotationMatrix(math.bignumber(1))                // returns [[bignumber(cos(1)), bignumber(-sin(1))], [bignumber(sin(1)), bignumber(cos(1))]]
   *    math.rotationMatrix(math.complex(1 + i))              // returns [[cos(1 + i), -sin(1 + i)], [sin(1 + i), cos(1 + i)]]
   *    math.rotationMatrix(math.unit('1rad'))                // returns [[cos(1), -sin(1)], [sin(1), cos(1)]]
   *
   *    math.rotationMatrix(math.pi / 2, [0, 1, 0])           // returns [[0, 0, 1], [0, 1, 0], [-1, 0, 0]]
   *    math.rotationMatrix(math.pi / 2, matrix([0, 1, 0]))   // returns matrix([[0, 0, 1], [0, 1, 0], [-1, 0, 0]])
   *
   *
   * See also:
   *
   *    matrix, cos, sin
   *
   *
   * @param {number | BigNumber | Complex | Unit} theta    Rotation angle
   * @param {Array | Matrix} [v]                           Rotation axis
   * @param {string} [format]                              Result Matrix storage format
   * @return {Array | Matrix}                              Rotation matrix
   */ return typed($97157a8628e63c67$var$name, {
        '': function _() {
            return config.matrix === 'Matrix' ? matrix([]) : [];
        },
        string: function string(format) {
            return matrix(format);
        },
        'number | BigNumber | Complex | Unit': function number__BigNumber__Complex__Unit(theta) {
            return _rotationMatrix2x2(theta, config.matrix === 'Matrix' ? 'dense' : undefined);
        },
        'number | BigNumber | Complex | Unit, string': function number__BigNumber__Complex__Unit_string(theta, format) {
            return _rotationMatrix2x2(theta, format);
        },
        'number | BigNumber | Complex | Unit, Array': function number__BigNumber__Complex__Unit_Array(theta, v) {
            var matrixV = matrix(v);
            _validateVector(matrixV);
            return _rotationMatrix3x3(theta, matrixV, undefined);
        },
        'number | BigNumber | Complex | Unit, Matrix': function number__BigNumber__Complex__Unit_Matrix(theta, v) {
            _validateVector(v);
            var storageType = v.storage() || (config.matrix === 'Matrix' ? 'dense' : undefined);
            return _rotationMatrix3x3(theta, v, storageType);
        },
        'number | BigNumber | Complex | Unit, Array, string': function number__BigNumber__Complex__Unit_Array_string(theta, v, format) {
            var matrixV = matrix(v);
            _validateVector(matrixV);
            return _rotationMatrix3x3(theta, matrixV, format);
        },
        'number | BigNumber | Complex | Unit, Matrix, string': function number__BigNumber__Complex__Unit_Matrix_string(theta, v, format) {
            _validateVector(v);
            return _rotationMatrix3x3(theta, v, format);
        }
    });
    /**
   * Returns 2x2 matrix of 2D rotation of angle theta
   *
   * @param {number | BigNumber | Complex | Unit} theta  The rotation angle
   * @param {string} format                              The result Matrix storage format
   * @returns {Matrix}
   * @private
   */ function _rotationMatrix2x2(theta, format) {
        var Big = (0, $edQYF.isBigNumber)(theta);
        var minusOne = Big ? new BigNumber(-1) : -1;
        var cosTheta = cos(theta);
        var sinTheta = sin(theta);
        var data = [
            [
                cosTheta,
                multiplyScalar(minusOne, sinTheta)
            ],
            [
                sinTheta,
                cosTheta
            ]
        ];
        return _convertToFormat(data, format);
    }
    function _validateVector(v) {
        var size = v.size();
        if (size.length < 1 || size[0] !== 3) throw new RangeError('Vector must be of dimensions 1x3');
    }
    function _mul(array) {
        return array.reduce((p, curr)=>multiplyScalar(p, curr));
    }
    function _convertToFormat(data, format) {
        if (format) {
            if (format === 'sparse') return new SparseMatrix(data);
            if (format === 'dense') return new DenseMatrix(data);
            throw new TypeError("Unknown matrix type \"".concat(format, "\""));
        }
        return data;
    }
    /**
   * Returns a 3x3 matrix of rotation of angle theta around vector v
   *
   * @param {number | BigNumber | Complex | Unit} theta The rotation angle
   * @param {Matrix} v                                  The rotation axis vector
   * @param {string} format                             The storage format of the resulting matrix
   * @returns {Matrix}
   * @private
   */ function _rotationMatrix3x3(theta, v, format) {
        var normV = norm(v);
        if (normV === 0) throw new RangeError('Rotation around zero vector');
        var Big = (0, $edQYF.isBigNumber)(theta) ? BigNumber : null;
        var one = Big ? new Big(1) : 1;
        var minusOne = Big ? new Big(-1) : -1;
        var vx = Big ? new Big(v.get([
            0
        ]) / normV) : v.get([
            0
        ]) / normV;
        var vy = Big ? new Big(v.get([
            1
        ]) / normV) : v.get([
            1
        ]) / normV;
        var vz = Big ? new Big(v.get([
            2
        ]) / normV) : v.get([
            2
        ]) / normV;
        var c = cos(theta);
        var oneMinusC = addScalar(one, unaryMinus(c));
        var s = sin(theta);
        var r11 = addScalar(c, _mul([
            vx,
            vx,
            oneMinusC
        ]));
        var r12 = addScalar(_mul([
            vx,
            vy,
            oneMinusC
        ]), _mul([
            minusOne,
            vz,
            s
        ]));
        var r13 = addScalar(_mul([
            vx,
            vz,
            oneMinusC
        ]), _mul([
            vy,
            s
        ]));
        var r21 = addScalar(_mul([
            vx,
            vy,
            oneMinusC
        ]), _mul([
            vz,
            s
        ]));
        var r22 = addScalar(c, _mul([
            vy,
            vy,
            oneMinusC
        ]));
        var r23 = addScalar(_mul([
            vy,
            vz,
            oneMinusC
        ]), _mul([
            minusOne,
            vx,
            s
        ]));
        var r31 = addScalar(_mul([
            vx,
            vz,
            oneMinusC
        ]), _mul([
            minusOne,
            vy,
            s
        ]));
        var r32 = addScalar(_mul([
            vy,
            vz,
            oneMinusC
        ]), _mul([
            vx,
            s
        ]));
        var r33 = addScalar(c, _mul([
            vz,
            vz,
            oneMinusC
        ]));
        var data = [
            [
                r11,
                r12,
                r13
            ],
            [
                r21,
                r22,
                r23
            ],
            [
                r31,
                r32,
                r33
            ]
        ];
        return _convertToFormat(data, format);
    }
});

});

parcelRegister("dvZbE", function(module, exports) {

$parcel$export(module.exports, "createRound", () => $028a06be40985bf7$export$c41ddfead54b1fbc);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");

var $6NnhX = parcelRequire("6NnhX");

var $i7dfO = parcelRequire("i7dfO");

var $52JKA = parcelRequire("52JKA");

var $19L2p = parcelRequire("19L2p");

var $dK2sh = parcelRequire("dK2sh");

var $dmcGu = parcelRequire("dmcGu");
var $028a06be40985bf7$var$NO_INT = 'Number of decimals in function round must be an integer';
var $028a06be40985bf7$var$name = 'round';
var $028a06be40985bf7$var$dependencies = [
    'typed',
    'config',
    'matrix',
    'equalScalar',
    'zeros',
    'BigNumber',
    'DenseMatrix'
];
var $028a06be40985bf7$export$c41ddfead54b1fbc = /* #__PURE__ */ (0, $dsu7t.factory)($028a06be40985bf7$var$name, $028a06be40985bf7$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, equalScalar: equalScalar, zeros: zeros, BigNumber: _BigNumber, DenseMatrix: DenseMatrix } = _ref;
    var matAlgo11xS0s = (0, $52JKA.createMatAlgo11xS0s)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo14xDs = (0, $dK2sh.createMatAlgo14xDs)({
        typed: typed
    });
    function toExponent(epsilon) {
        return Math.abs((0, $6NnhX.splitNumber)(epsilon).exponent);
    }
    /**
   * Round a value towards the nearest rounded value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.round(x)
   *    math.round(x, n)
   *    math.round(unit, valuelessUnit)
   *    math.round(unit, n, valuelessUnit)
   *
   * Examples:
   *
   *    math.round(3.22)             // returns number 3
   *    math.round(3.82)             // returns number 4
   *    math.round(-4.2)             // returns number -4
   *    math.round(-4.7)             // returns number -5
   *    math.round(3.22, 1)          // returns number 3.2
   *    math.round(3.88, 1)          // returns number 3.9
   *    math.round(-4.21, 1)         // returns number -4.2
   *    math.round(-4.71, 1)         // returns number -4.7
   *    math.round(math.pi, 3)       // returns number 3.142
   *    math.round(123.45678, 2)     // returns number 123.46
   *
   *    const c = math.complex(3.2, -2.7)
   *    math.round(c)                // returns Complex 3 - 3i
   *
   *    const unit = math.unit('3.241 cm')
   *    const cm = math.unit('cm')
   *    const mm = math.unit('mm')
   *    math.round(unit, 1, cm)      // returns Unit 3.2 cm
   *    math.round(unit, 1, mm)      // returns Unit 32.4 mm
   *
   *    math.round([3.2, 3.8, -4.7]) // returns Array [3, 4, -5]
   *
   * See also:
   *
   *    ceil, fix, floor
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x  Value to be rounded
   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
   * @param  {Unit} [valuelessUnit]                                        A valueless unit
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Rounded value
   */ return typed($028a06be40985bf7$var$name, {
        number: function number(x) {
            // Handle round off errors by first rounding to relTol precision
            var xEpsilon = (0, $dmcGu.roundNumber)(x, toExponent(config.relTol));
            var xSelected = (0, $6NnhX.nearlyEqual)(x, xEpsilon, config.relTol, config.absTol) ? xEpsilon : x;
            return (0, $dmcGu.roundNumber)(xSelected);
        },
        'number, number': function number_number(x, n) {
            // Same as number: unless user specifies more decimals than relTol
            var epsilonExponent = toExponent(config.relTol);
            if (n >= epsilonExponent) return (0, $dmcGu.roundNumber)(x, n);
            var xEpsilon = (0, $dmcGu.roundNumber)(x, epsilonExponent);
            var xSelected = (0, $6NnhX.nearlyEqual)(x, xEpsilon, config.relTol, config.absTol) ? xEpsilon : x;
            return (0, $dmcGu.roundNumber)(xSelected, n);
        },
        'number, BigNumber': function number_BigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($028a06be40985bf7$var$NO_INT);
            return new _BigNumber(x).toDecimalPlaces(n.toNumber());
        },
        Complex: function Complex(x) {
            return x.round();
        },
        'Complex, number': function Complex_number(x, n) {
            if (n % 1) throw new TypeError($028a06be40985bf7$var$NO_INT);
            return x.round(n);
        },
        'Complex, BigNumber': function Complex_BigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($028a06be40985bf7$var$NO_INT);
            var _n = n.toNumber();
            return x.round(_n);
        },
        BigNumber: function BigNumber(x) {
            // Handle round off errors by first rounding to relTol precision
            var xEpsilon = new _BigNumber(x).toDecimalPlaces(toExponent(config.relTol));
            var xSelected = (0, $i7dfO.nearlyEqual)(x, xEpsilon, config.relTol, config.absTol) ? xEpsilon : x;
            return xSelected.toDecimalPlaces(0);
        },
        'BigNumber, BigNumber': function BigNumber_BigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($028a06be40985bf7$var$NO_INT);
            // Same as BigNumber: unless user specifies more decimals than relTol
            var epsilonExponent = toExponent(config.relTol);
            if (n >= epsilonExponent) return x.toDecimalPlaces(n.toNumber());
            var xEpsilon = x.toDecimalPlaces(epsilonExponent);
            var xSelected = (0, $i7dfO.nearlyEqual)(x, xEpsilon, config.relTol, config.absTol) ? xEpsilon : x;
            return xSelected.toDecimalPlaces(n.toNumber());
        },
        // bigints can't be rounded
        bigint: (b)=>b,
        'bigint, number': (b, _dummy)=>b,
        'bigint, BigNumber': (b, _dummy)=>b,
        Fraction: function Fraction(x) {
            return x.round();
        },
        'Fraction, number': function Fraction_number(x, n) {
            if (n % 1) throw new TypeError($028a06be40985bf7$var$NO_INT);
            return x.round(n);
        },
        'Fraction, BigNumber': function Fraction_BigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($028a06be40985bf7$var$NO_INT);
            return x.round(n.toNumber());
        },
        'Unit, number, Unit': typed.referToSelf((self)=>function(x, n, unit) {
                var valueless = x.toNumeric(unit);
                return unit.multiply(self(valueless, n));
            }),
        'Unit, BigNumber, Unit': typed.referToSelf((self)=>(x, n, unit)=>self(x, n.toNumber(), unit)),
        'Array | Matrix, number | BigNumber, Unit': typed.referToSelf((self)=>(x, n, unit)=>{
                // deep map collection, skip zeros since round(0) = 0
                return (0, $20mkw.deepMap)(x, (value)=>self(value, n, unit), true);
            }),
        'Array | Matrix | Unit, Unit': typed.referToSelf((self)=>(x, unit)=>self(x, 0, unit)),
        'Array | Matrix': typed.referToSelf((self)=>(x)=>{
                // deep map collection, skip zeros since round(0) = 0
                return (0, $20mkw.deepMap)(x, self, true);
            }),
        'SparseMatrix, number | BigNumber': typed.referToSelf((self)=>(x, n)=>{
                return matAlgo11xS0s(x, n, self, false);
            }),
        'DenseMatrix, number | BigNumber': typed.referToSelf((self)=>(x, n)=>{
                return matAlgo14xDs(x, n, self, false);
            }),
        'Array, number | BigNumber': typed.referToSelf((self)=>(x, n)=>{
                // use matrix implementation
                return matAlgo14xDs(matrix(x), n, self, false).valueOf();
            }),
        'number | Complex | BigNumber | Fraction, SparseMatrix': typed.referToSelf((self)=>(x, n)=>{
                // check scalar is zero
                if (equalScalar(x, 0)) // do not execute algorithm, result will be a zero matrix
                return zeros(n.size(), n.storage());
                return matAlgo12xSfs(n, x, self, true);
            }),
        'number | Complex | BigNumber | Fraction, DenseMatrix': typed.referToSelf((self)=>(x, n)=>{
                // check scalar is zero
                if (equalScalar(x, 0)) // do not execute algorithm, result will be a zero matrix
                return zeros(n.size(), n.storage());
                return matAlgo14xDs(n, x, self, true);
            }),
        'number | Complex | BigNumber | Fraction, Array': typed.referToSelf((self)=>(x, n)=>{
                // use matrix implementation
                return matAlgo14xDs(matrix(n), x, self, true).valueOf();
            })
    });
});

});

parcelRegister("46BSz", function(module, exports) {

$parcel$export(module.exports, "createRow", () => $2fd51af82121d31a$export$3442c5d213434705);

var $dsu7t = parcelRequire("dsu7t");

var $edQYF = parcelRequire("edQYF");

var $9v8q6 = parcelRequire("9v8q6");

var $d80Xp = parcelRequire("d80Xp");
var $2fd51af82121d31a$var$name = 'row';
var $2fd51af82121d31a$var$dependencies = [
    'typed',
    'Index',
    'matrix',
    'range'
];
var $2fd51af82121d31a$export$3442c5d213434705 = /* #__PURE__ */ (0, $dsu7t.factory)($2fd51af82121d31a$var$name, $2fd51af82121d31a$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index, matrix: matrix, range: range } = _ref;
    /**
   * Return a row from a Matrix.
   *
   * Syntax:
   *
   *     math.row(value, index)
   *
   * Example:
   *
   *     // get a row
   *     const d = [[1, 2], [3, 4]]
   *     math.row(d, 1) // returns [[3, 4]]
   *
   * See also:
   *
   *     column
   *
   * @param {Array | Matrix } value   An array or matrix
   * @param {number} row              The index of the row
   * @return {Array | Matrix}         The retrieved row
   */ return typed($2fd51af82121d31a$var$name, {
        'Matrix, number': _row,
        'Array, number': function Array_number(value, row) {
            return _row(matrix((0, $9v8q6.clone)(value)), row).valueOf();
        }
    });
    /**
   * Retrieve a row of a matrix
   * @param {Matrix } value  A matrix
   * @param {number} row     The index of the row
   * @return {Matrix}        The retrieved row
   */ function _row(value, row) {
        // check dimensions
        if (value.size().length !== 2) throw new Error('Only two dimensional matrix is supported');
        (0, $d80Xp.validateIndex)(row, value.size()[0]);
        var columnRange = range(0, value.size()[1]);
        var index = new Index(row, columnRange);
        var result = value.subset(index);
        return (0, $edQYF.isMatrix)(result) ? result : matrix([
            [
                result
            ]
        ]);
    }
});

});

parcelRegister("bPh4z", function(module, exports) {

$parcel$export(module.exports, "createSchur", () => $89c1b367f23bf137$export$7c8bdcd3ab83037d);

var $dsu7t = parcelRequire("dsu7t");
var $89c1b367f23bf137$var$name = 'schur';
var $89c1b367f23bf137$var$dependencies = [
    'typed',
    'matrix',
    'identity',
    'multiply',
    'qr',
    'norm',
    'subtract'
];
var $89c1b367f23bf137$export$7c8bdcd3ab83037d = /* #__PURE__ */ (0, $dsu7t.factory)($89c1b367f23bf137$var$name, $89c1b367f23bf137$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, identity: identity, multiply: multiply, qr: qr, norm: norm, subtract: subtract } = _ref;
    /**
   *
   * Performs a real Schur decomposition of the real matrix A = UTU' where U is orthogonal
   * and T is upper quasi-triangular.
   * https://en.wikipedia.org/wiki/Schur_decomposition
   *
   * Syntax:
   *
   *     math.schur(A)
   *
   * Examples:
   *
   *     const A = [[1, 0], [-4, 3]]
   *     math.schur(A) // returns {T: [[3, 4], [0, 1]], R: [[0, 1], [-1, 0]]}
   *
   * See also:
   *
   *     sylvester, lyap, qr
   *
   * @param {Array | Matrix} A  Matrix A
   * @return {{U: Array | Matrix, T: Array | Matrix}} Object containing both matrix U and T of the Schur Decomposition A=UTU'
   */ return typed($89c1b367f23bf137$var$name, {
        Array: function Array(X) {
            var r = _schur(matrix(X));
            return {
                U: r.U.valueOf(),
                T: r.T.valueOf()
            };
        },
        Matrix: function Matrix(X) {
            return _schur(X);
        }
    });
    function _schur(X) {
        var n = X.size()[0];
        var A = X;
        var U = identity(n);
        var k = 0;
        var A0;
        do {
            A0 = A;
            var QR = qr(A);
            var Q = QR.Q;
            var R = QR.R;
            A = multiply(R, Q);
            U = multiply(U, Q);
            if (k++ > 100) break;
        }while (norm(subtract(A, A0)) > 1e-4);
        return {
            U: U,
            T: A
        };
    }
});

});

parcelRegister("cJ0Yl", function(module, exports) {

$parcel$export(module.exports, "createSec", () => $943a7117b921a6d2$export$5c169ecd5c25a09e);

var $dsu7t = parcelRequire("dsu7t");

var $cOOcY = parcelRequire("cOOcY");

var $aS62J = parcelRequire("aS62J");
var $943a7117b921a6d2$var$name = 'sec';
var $943a7117b921a6d2$var$dependencies = [
    'typed',
    'BigNumber'
];
var $943a7117b921a6d2$export$5c169ecd5c25a09e = /* #__PURE__ */ (0, $dsu7t.factory)($943a7117b921a6d2$var$name, $943a7117b921a6d2$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    var trigUnit = (0, $aS62J.createTrigUnit)({
        typed: typed
    });
    /**
   * Calculate the secant of a value, defined as `sec(x) = 1/cos(x)`.
   *
   * To avoid confusion with the matrix secant, this function does not
   * apply to matrices.
   *
   * Syntax:
   *
   *    math.sec(x)
   *
   * Examples:
   *
   *    math.sec(2)      // returns number -2.4029979617223822
   *    1 / math.cos(2)  // returns number -2.4029979617223822
   *
   * See also:
   *
   *    cos, csc, cot
   *
   * @param {number | BigNumber | Complex | Unit} x  Function input
   * @return {number | BigNumber | Complex} Secant of x
   */ return typed($943a7117b921a6d2$var$name, {
        number: (0, $cOOcY.secNumber),
        Complex: (x)=>x.sec(),
        BigNumber: (x)=>new _BigNumber(1).div(x.cos())
    }, trigUnit);
});

});

parcelRegister("1KDoF", function(module, exports) {

$parcel$export(module.exports, "createSech", () => $1468a5b324b9cb7a$export$97a0cf2b7d31f38b);

var $dsu7t = parcelRequire("dsu7t");

var $cOOcY = parcelRequire("cOOcY");
var $1468a5b324b9cb7a$var$name = 'sech';
var $1468a5b324b9cb7a$var$dependencies = [
    'typed',
    'BigNumber'
];
var $1468a5b324b9cb7a$export$97a0cf2b7d31f38b = /* #__PURE__ */ (0, $dsu7t.factory)($1468a5b324b9cb7a$var$name, $1468a5b324b9cb7a$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic secant of a value,
   * defined as `sech(x) = 1 / cosh(x)`.
   *
   * To avoid confusion with the matrix hyperbolic secant, this function does
   * not apply to matrices.
   *
   * Syntax:
   *
   *    math.sech(x)
   *
   * Examples:
   *
   *    // sech(x) = 1/ cosh(x)
   *    math.sech(0.5)       // returns 0.886818883970074
   *    1 / math.cosh(0.5)   // returns 0.886818883970074
   *
   * See also:
   *
   *    cosh, csch, coth
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic secant of x
   */ return typed($1468a5b324b9cb7a$var$name, {
        number: (0, $cOOcY.sechNumber),
        Complex: (x)=>x.sech(),
        BigNumber: (x)=>new _BigNumber(1).div(x.cosh())
    });
});

});

parcelRegister("axDaN", function(module, exports) {

$parcel$export(module.exports, "createSetCartesian", () => $7acb5f6e8f0734e2$export$9fa12a9d198718c8);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $7acb5f6e8f0734e2$var$name = 'setCartesian';
var $7acb5f6e8f0734e2$var$dependencies = [
    'typed',
    'size',
    'subset',
    'compareNatural',
    'Index',
    'DenseMatrix'
];
var $7acb5f6e8f0734e2$export$9fa12a9d198718c8 = /* #__PURE__ */ (0, $dsu7t.factory)($7acb5f6e8f0734e2$var$name, $7acb5f6e8f0734e2$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Create the cartesian product of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays
   * and the values will be sorted in ascending order before the operation.
   *
   * Syntax:
   *
   *    math.setCartesian(set1, set2)
   *
   * Examples:
   *
   *    math.setCartesian([1, 2], [3, 4])        // returns [[1, 3], [1, 4], [2, 3], [2, 4]]
   *    math.setCartesian([4, 3], [2, 1])        // returns [[3, 1], [3, 2], [4, 1], [4, 2]]
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference, setPowerset
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The cartesian product of two (multi)sets
   */ return typed($7acb5f6e8f0734e2$var$name, {
        'Array | Matrix, Array | Matrix': function Array__Matrix_Array__Matrix(a1, a2) {
            var result = [];
            if (subset(size(a1), new Index(0)) !== 0 && subset(size(a2), new Index(0)) !== 0) {
                // if any of them is empty, return empty
                var b1 = (0, $d80Xp.flatten)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural);
                var b2 = (0, $d80Xp.flatten)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural);
                result = [];
                for(var i = 0; i < b1.length; i++)for(var j = 0; j < b2.length; j++)result.push([
                    b1[i],
                    b2[j]
                ]);
            }
            // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return result;
            // return a matrix otherwise
            return new DenseMatrix(result);
        }
    });
});

});

parcelRegister("l9m9S", function(module, exports) {

$parcel$export(module.exports, "createSetDifference", () => $f65ba06d5bb13a19$export$d81c0f9dab86d854);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $f65ba06d5bb13a19$var$name = 'setDifference';
var $f65ba06d5bb13a19$var$dependencies = [
    'typed',
    'size',
    'subset',
    'compareNatural',
    'Index',
    'DenseMatrix'
];
var $f65ba06d5bb13a19$export$d81c0f9dab86d854 = /* #__PURE__ */ (0, $dsu7t.factory)($f65ba06d5bb13a19$var$name, $f65ba06d5bb13a19$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Create the difference of two (multi)sets: every element of set1, that is not the element of set2.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setDifference(set1, set2)
   *
   * Examples:
   *
   *    math.setDifference([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2]
   *    math.setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2]
   *
   * See also:
   *
   *    setUnion, setIntersect, setSymDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The difference of two (multi)sets
   */ return typed($f65ba06d5bb13a19$var$name, {
        'Array | Matrix, Array | Matrix': function Array__Matrix_Array__Matrix(a1, a2) {
            var result;
            if (subset(size(a1), new Index(0)) === 0) // empty-anything=empty
            result = [];
            else if (subset(size(a2), new Index(0)) === 0) // anything-empty=anything
            return (0, $d80Xp.flatten)(a1.toArray());
            else {
                var b1 = (0, $d80Xp.identify)((0, $d80Xp.flatten)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
                var b2 = (0, $d80Xp.identify)((0, $d80Xp.flatten)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
                result = [];
                var inb2;
                for(var i = 0; i < b1.length; i++){
                    inb2 = false;
                    for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                        // the identifier is always a decimal int
                        inb2 = true;
                        break;
                    }
                    if (!inb2) result.push(b1[i]);
                }
            }
            // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return (0, $d80Xp.generalize)(result);
            // return a matrix otherwise
            return new DenseMatrix((0, $d80Xp.generalize)(result));
        }
    });
});

});

parcelRegister("dUzaX", function(module, exports) {

$parcel$export(module.exports, "createSetDistinct", () => $a20bca8313eec4da$export$c149680b9d8f2963);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $a20bca8313eec4da$var$name = 'setDistinct';
var $a20bca8313eec4da$var$dependencies = [
    'typed',
    'size',
    'subset',
    'compareNatural',
    'Index',
    'DenseMatrix'
];
var $a20bca8313eec4da$export$c149680b9d8f2963 = /* #__PURE__ */ (0, $dsu7t.factory)($a20bca8313eec4da$var$name, $a20bca8313eec4da$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Collect the distinct elements of a multiset.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setDistinct(set)
   *
   * Examples:
   *
   *    math.setDistinct([1, 1, 1, 2, 2, 3])        // returns [1, 2, 3]
   *
   * See also:
   *
   *    setMultiplicity
   *
   * @param {Array | Matrix}    a  A multiset
   * @return {Array | Matrix}    A set containing the distinc elements of the multiset
   */ return typed($a20bca8313eec4da$var$name, {
        'Array | Matrix': function Array__Matrix(a) {
            var result;
            if (subset(size(a), new Index(0)) === 0) // if empty, return empty
            result = [];
            else {
                var b = (0, $d80Xp.flatten)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
                result = [];
                result.push(b[0]);
                for(var i = 1; i < b.length; i++)if (compareNatural(b[i], b[i - 1]) !== 0) result.push(b[i]);
            }
            // return an array, if the input was an array
            if (Array.isArray(a)) return result;
            // return a matrix otherwise
            return new DenseMatrix(result);
        }
    });
});

});

parcelRegister("5h2xd", function(module, exports) {

$parcel$export(module.exports, "createSetIntersect", () => $3d7081a03b3f2896$export$b20ee2bdfbf6defd);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $3d7081a03b3f2896$var$name = 'setIntersect';
var $3d7081a03b3f2896$var$dependencies = [
    'typed',
    'size',
    'subset',
    'compareNatural',
    'Index',
    'DenseMatrix'
];
var $3d7081a03b3f2896$export$b20ee2bdfbf6defd = /* #__PURE__ */ (0, $dsu7t.factory)($3d7081a03b3f2896$var$name, $3d7081a03b3f2896$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Create the intersection of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setIntersect(set1, set2)
   *
   * Examples:
   *
   *    math.setIntersect([1, 2, 3, 4], [3, 4, 5, 6])            // returns [3, 4]
   *    math.setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [3, 4]
   *
   * See also:
   *
   *    setUnion, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The intersection of two (multi)sets
   */ return typed($3d7081a03b3f2896$var$name, {
        'Array | Matrix, Array | Matrix': function Array__Matrix_Array__Matrix(a1, a2) {
            var result;
            if (subset(size(a1), new Index(0)) === 0 || subset(size(a2), new Index(0)) === 0) // of any of them is empty, return empty
            result = [];
            else {
                var b1 = (0, $d80Xp.identify)((0, $d80Xp.flatten)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
                var b2 = (0, $d80Xp.identify)((0, $d80Xp.flatten)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
                result = [];
                for(var i = 0; i < b1.length; i++){
                    for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                        // the identifier is always a decimal int
                        result.push(b1[i]);
                        break;
                    }
                }
            }
            // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return (0, $d80Xp.generalize)(result);
            // return a matrix otherwise
            return new DenseMatrix((0, $d80Xp.generalize)(result));
        }
    });
});

});

parcelRegister("hRxKF", function(module, exports) {

$parcel$export(module.exports, "createSetIsSubset", () => $d011914cc374a6d4$export$40ad73493b9f8712);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $d011914cc374a6d4$var$name = 'setIsSubset';
var $d011914cc374a6d4$var$dependencies = [
    'typed',
    'size',
    'subset',
    'compareNatural',
    'Index'
];
var $d011914cc374a6d4$export$40ad73493b9f8712 = /* #__PURE__ */ (0, $dsu7t.factory)($d011914cc374a6d4$var$name, $d011914cc374a6d4$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index } = _ref;
    /**
   * Check whether a (multi)set is a subset of another (multi)set. (Every element of set1 is the element of set2.)
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setIsSubset(set1, set2)
   *
   * Examples:
   *
   *    math.setIsSubset([1, 2], [3, 4, 5, 6])        // returns false
   *    math.setIsSubset([3, 4], [3, 4, 5, 6])        // returns true
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {boolean} Returns true when a1 is a subset of a2, returns false otherwise
   */ return typed($d011914cc374a6d4$var$name, {
        'Array | Matrix, Array | Matrix': function Array__Matrix_Array__Matrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // empty is a subset of anything
            return true;
            else if (subset(size(a2), new Index(0)) === 0) // anything is not a subset of empty
            return false;
            var b1 = (0, $d80Xp.identify)((0, $d80Xp.flatten)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
            var b2 = (0, $d80Xp.identify)((0, $d80Xp.flatten)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
            var inb2;
            for(var i = 0; i < b1.length; i++){
                inb2 = false;
                for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                    // the identifier is always a decimal int
                    inb2 = true;
                    break;
                }
                if (inb2 === false) return false;
            }
            return true;
        }
    });
});

});

parcelRegister("gBiOl", function(module, exports) {

$parcel$export(module.exports, "createSetMultiplicity", () => $c15eb17fa82eb46c$export$d1f961d649e525df);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $c15eb17fa82eb46c$var$name = 'setMultiplicity';
var $c15eb17fa82eb46c$var$dependencies = [
    'typed',
    'size',
    'subset',
    'compareNatural',
    'Index'
];
var $c15eb17fa82eb46c$export$d1f961d649e525df = /* #__PURE__ */ (0, $dsu7t.factory)($c15eb17fa82eb46c$var$name, $c15eb17fa82eb46c$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index } = _ref;
    /**
   * Count the multiplicity of an element in a multiset.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setMultiplicity(element, set)
   *
   * Examples:
   *
   *    math.setMultiplicity(1, [1, 2, 2, 4])    // returns 1
   *    math.setMultiplicity(2, [1, 2, 2, 4])    // returns 2
   *
   * See also:
   *
   *    setDistinct, setSize
   *
   * @param {number | BigNumber | Fraction | Complex} e  An element in the multiset
   * @param {Array | Matrix}     a  A multiset
   * @return {number}            The number of how many times the multiset contains the element
   */ return typed($c15eb17fa82eb46c$var$name, {
        'number | BigNumber | Fraction | Complex, Array | Matrix': function number__BigNumber__Fraction__Complex_Array__Matrix(e, a) {
            if (subset(size(a), new Index(0)) === 0) // if empty, return 0
            return 0;
            var b = (0, $d80Xp.flatten)(Array.isArray(a) ? a : a.toArray());
            var count = 0;
            for(var i = 0; i < b.length; i++)if (compareNatural(b[i], e) === 0) count++;
            return count;
        }
    });
});

});

parcelRegister("jEsS4", function(module, exports) {

$parcel$export(module.exports, "createSetPowerset", () => $e4e825f216aae803$export$55c6b5cb0b0637db);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $e4e825f216aae803$var$name = 'setPowerset';
var $e4e825f216aae803$var$dependencies = [
    'typed',
    'size',
    'subset',
    'compareNatural',
    'Index'
];
var $e4e825f216aae803$export$55c6b5cb0b0637db = /* #__PURE__ */ (0, $dsu7t.factory)($e4e825f216aae803$var$name, $e4e825f216aae803$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index } = _ref;
    /**
   * Create the powerset of a (multi)set. (The powerset contains very possible subsets of a (multi)set.)
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setPowerset(set)
   *
   * Examples:
   *
   *    math.setPowerset([1, 2, 3])        // returns [[], [1], [2], [3], [1, 2], [1, 3], [2, 3], [1, 2, 3]]
   *
   * See also:
   *
   *    setCartesian
   *
   * @param {Array | Matrix}    a  A (multi)set
   * @return {Array}    The powerset of the (multi)set
   */ return typed($e4e825f216aae803$var$name, {
        'Array | Matrix': function Array__Matrix(a) {
            if (subset(size(a), new Index(0)) === 0) // if empty, return empty
            return [];
            var b = (0, $d80Xp.flatten)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
            var result = [];
            var number = 0;
            while(number.toString(2).length <= b.length){
                result.push(_subset(b, number.toString(2).split('').reverse()));
                number++;
            }
            // can not return a matrix, because of the different size of the subarrays
            return _sort(result);
        }
    });
    // create subset
    function _subset(array, bitarray) {
        var result = [];
        for(var i = 0; i < bitarray.length; i++)if (bitarray[i] === '1') result.push(array[i]);
        return result;
    }
    // sort subsests by length
    function _sort(array) {
        var temp = [];
        for(var i = array.length - 1; i > 0; i--){
            for(var j = 0; j < i; j++)if (array[j].length > array[j + 1].length) {
                temp = array[j];
                array[j] = array[j + 1];
                array[j + 1] = temp;
            }
        }
        return array;
    }
});

});

parcelRegister("aVxPF", function(module, exports) {

$parcel$export(module.exports, "createSetSize", () => $7f4978a7c86744a2$export$55134310fc79366a);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $7f4978a7c86744a2$var$name = 'setSize';
var $7f4978a7c86744a2$var$dependencies = [
    'typed',
    'compareNatural'
];
var $7f4978a7c86744a2$export$55134310fc79366a = /* #__PURE__ */ (0, $dsu7t.factory)($7f4978a7c86744a2$var$name, $7f4978a7c86744a2$var$dependencies, (_ref)=>{
    var { typed: typed, compareNatural: compareNatural } = _ref;
    /**
   * Count the number of elements of a (multi)set. When a second parameter is 'true', count only the unique values.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setSize(set)
   *    math.setSize(set, unique)
   *
   * Examples:
   *
   *    math.setSize([1, 2, 2, 4])          // returns 4
   *    math.setSize([1, 2, 2, 4], true)    // returns 3
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix} a  A multiset
   * @param {boolean} [unique]  If true, only the unique values are counted. False by default
   * @return {number}           The number of elements of the (multi)set
   */ return typed($7f4978a7c86744a2$var$name, {
        'Array | Matrix': function Array__Matrix(a) {
            return Array.isArray(a) ? (0, $d80Xp.flatten)(a).length : (0, $d80Xp.flatten)(a.toArray()).length;
        },
        'Array | Matrix, boolean': function Array__Matrix_boolean(a, unique) {
            if (unique === false || a.length === 0) return Array.isArray(a) ? (0, $d80Xp.flatten)(a).length : (0, $d80Xp.flatten)(a.toArray()).length;
            else {
                var b = (0, $d80Xp.flatten)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
                var count = 1;
                for(var i = 1; i < b.length; i++)if (compareNatural(b[i], b[i - 1]) !== 0) count++;
                return count;
            }
        }
    });
});

});

parcelRegister("aej5W", function(module, exports) {

$parcel$export(module.exports, "createSetSymDifference", () => $772a0609cc679950$export$4a9a0ead2012bfc4);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $772a0609cc679950$var$name = 'setSymDifference';
var $772a0609cc679950$var$dependencies = [
    'typed',
    'size',
    'concat',
    'subset',
    'setDifference',
    'Index'
];
var $772a0609cc679950$export$4a9a0ead2012bfc4 = /* #__PURE__ */ (0, $dsu7t.factory)($772a0609cc679950$var$name, $772a0609cc679950$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, concat: concat, subset: subset, setDifference: setDifference, Index: Index } = _ref;
    /**
   * Create the symmetric difference of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setSymDifference(set1, set2)
   *
   * Examples:
   *
   *    math.setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2, 5, 6]
   *    math.setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2, 5, 6]
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The symmetric difference of two (multi)sets
   */ return typed($772a0609cc679950$var$name, {
        'Array | Matrix, Array | Matrix': function Array__Matrix_Array__Matrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // if any of them is empty, return the other one
            return (0, $d80Xp.flatten)(a2);
            else if (subset(size(a2), new Index(0)) === 0) return (0, $d80Xp.flatten)(a1);
            var b1 = (0, $d80Xp.flatten)(a1);
            var b2 = (0, $d80Xp.flatten)(a2);
            return concat(setDifference(b1, b2), setDifference(b2, b1));
        }
    });
});

});

parcelRegister("9j3eN", function(module, exports) {

$parcel$export(module.exports, "createSetUnion", () => $6c686650754c3913$export$fbdfd2054d37f888);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $6c686650754c3913$var$name = 'setUnion';
var $6c686650754c3913$var$dependencies = [
    'typed',
    'size',
    'concat',
    'subset',
    'setIntersect',
    'setSymDifference',
    'Index'
];
var $6c686650754c3913$export$fbdfd2054d37f888 = /* #__PURE__ */ (0, $dsu7t.factory)($6c686650754c3913$var$name, $6c686650754c3913$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, concat: concat, subset: subset, setIntersect: setIntersect, setSymDifference: setSymDifference, Index: Index } = _ref;
    /**
   * Create the union of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setUnion(set1, set2)
   *
   * Examples:
   *
   *    math.setUnion([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2, 3, 4, 5, 6]
   *    math.setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2, 3, 4, 5, 6]
   *
   * See also:
   *
   *    setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The union of two (multi)sets
   */ return typed($6c686650754c3913$var$name, {
        'Array | Matrix, Array | Matrix': function Array__Matrix_Array__Matrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // if any of them is empty, return the other one
            return (0, $d80Xp.flatten)(a2);
            else if (subset(size(a2), new Index(0)) === 0) return (0, $d80Xp.flatten)(a1);
            var b1 = (0, $d80Xp.flatten)(a1);
            var b2 = (0, $d80Xp.flatten)(a2);
            return concat(setSymDifference(b1, b2), setIntersect(b1, b2));
        }
    });
});

});

parcelRegister("l9Qc7", function(module, exports) {

$parcel$export(module.exports, "createSign", () => $f672ecf4d729fe7c$export$45df7cae684751af);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");

var $dmcGu = parcelRequire("dmcGu");
var $f672ecf4d729fe7c$var$name = 'sign';
var $f672ecf4d729fe7c$var$dependencies = [
    'typed',
    'BigNumber',
    'Fraction',
    'complex'
];
var $f672ecf4d729fe7c$export$45df7cae684751af = /* #__PURE__ */ (0, $dsu7t.factory)($f672ecf4d729fe7c$var$name, $f672ecf4d729fe7c$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber, complex: complex, Fraction: _Fraction } = _ref;
    /**
   * Compute the sign of a value. The sign of a value x is:
   *
   * -  1 when x > 0
   * - -1 when x < 0
   * -  0 when x == 0
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sign(x)
   *
   * Examples:
   *
   *    math.sign(3.5)               // returns 1
   *    math.sign(-4.2)              // returns -1
   *    math.sign(0)                 // returns 0
   *
   *    math.sign([3, 5, -2, 0, 2])  // returns [1, 1, -1, 0, 1]
   *
   * See also:
   *
   *    abs
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Array | Matrix | Unit} x
   *            The number for which to determine the sign
   * @return {number | BigNumber | bigint | Fraction | Complex | Array | Matrix | Unit}
   *            The sign of `x`
   */ return typed($f672ecf4d729fe7c$var$name, {
        number: (0, $dmcGu.signNumber),
        Complex: function Complex(x) {
            return x.im === 0 ? complex((0, $dmcGu.signNumber)(x.re)) : x.sign();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(x.cmp(0));
        },
        bigint: function bigint(x) {
            return x > 0n ? 1n : x < 0n ? -1n : 0n;
        },
        Fraction: function Fraction(x) {
            return x.n === 0n ? new _Fraction(0) : new _Fraction(x.s);
        },
        // deep map collection, skip zeros since sign(0) = 0
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self, true)),
        Unit: typed.referToSelf((self)=>(x)=>{
                if (!x._isDerived() && x.units[0].unit.offset !== 0) throw new TypeError('sign is ambiguous for units with offset');
                return typed.find(self, x.valueType())(x.value);
            })
    });
});

});

parcelRegister("gNIfT", function(module, exports) {

$parcel$export(module.exports, "createSin", () => $c3b38d265202e25a$export$4b4fac44ef379cae);

var $dsu7t = parcelRequire("dsu7t");

var $aS62J = parcelRequire("aS62J");
var $c3b38d265202e25a$var$name = 'sin';
var $c3b38d265202e25a$var$dependencies = [
    'typed'
];
var $c3b38d265202e25a$export$4b4fac44ef379cae = /* #__PURE__ */ (0, $dsu7t.factory)($c3b38d265202e25a$var$name, $c3b38d265202e25a$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    var trigUnit = (0, $aS62J.createTrigUnit)({
        typed: typed
    });
    /**
   * Calculate the sine of a value.
   *
   * To avoid confusion with the matrix sine, this function does not apply
   * to matrices.
   *
   * Syntax:
   *
   *    math.sin(x)
   *
   * Examples:
   *
   *    math.sin(2)                      // returns number 0.9092974268256813
   *    math.sin(math.pi / 4)            // returns number 0.7071067811865475
   *    math.sin(math.unit(90, 'deg'))   // returns number 1
   *    math.sin(math.unit(30, 'deg'))   // returns number 0.5
   *
   *    const angle = 0.2
   *    math.pow(math.sin(angle), 2) + math.pow(math.cos(angle), 2) // returns number 1
   *
   * See also:
   *
   *    cos, tan
   *
   * @param {number | BigNumber | Complex | Unit} x  Function input
   * @return {number | BigNumber | Complex} Sine of x
   */ return typed($c3b38d265202e25a$var$name, {
        number: Math.sin,
        'Complex | BigNumber': (x)=>x.sin()
    }, trigUnit);
});

});

parcelRegister("acZ3d", function(module, exports) {

$parcel$export(module.exports, "createSinh", () => $76ea61c98700f8d9$export$c3a62182c56878d5);

var $dsu7t = parcelRequire("dsu7t");

var $cOOcY = parcelRequire("cOOcY");
var $76ea61c98700f8d9$var$name = 'sinh';
var $76ea61c98700f8d9$var$dependencies = [
    'typed'
];
var $76ea61c98700f8d9$export$c3a62182c56878d5 = /* #__PURE__ */ (0, $dsu7t.factory)($76ea61c98700f8d9$var$name, $76ea61c98700f8d9$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic sine of a value,
   * defined as `sinh(x) = 1/2 * (exp(x) - exp(-x))`.
   *
   * To avoid confusion with the matrix hyperbolic sine, this function does
   * not apply to matrices.
   *
   * Syntax:
   *
   *    math.sinh(x)
   *
   * Examples:
   *
   *    math.sinh(0.5)       // returns number 0.5210953054937474
   *
   * See also:
   *
   *    cosh, tanh
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic sine of x
   */ return typed($76ea61c98700f8d9$var$name, {
        number: (0, $cOOcY.sinhNumber),
        'Complex | BigNumber': (x)=>x.sinh()
    });
});

});

parcelRegister("ito8c", function(module, exports) {

$parcel$export(module.exports, "createSize", () => $d72da761ee23daae$export$9151c23a59ce3fb6);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");

var $h5rrM = parcelRequire("h5rrM");
var $d72da761ee23daae$var$name = 'size';
var $d72da761ee23daae$var$dependencies = [
    'typed',
    'config',
    '?matrix'
];
var $d72da761ee23daae$export$9151c23a59ce3fb6 = /* #__PURE__ */ (0, $dsu7t.factory)($d72da761ee23daae$var$name, $d72da761ee23daae$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix } = _ref;
    /**
   * Calculate the size of a matrix or scalar.
   *
   * Syntax:
   *
   *     math.size(x)
   *
   * Examples:
   *
   *     math.size(2.3)                       // returns []
   *     math.size('hello world')             // returns [11]
   *
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.size(A)                         // returns [2, 3]
   *     math.size(math.range(1,6).toArray()) // returns [5]
   *
   * See also:
   *
   *     count, resize, squeeze, subset
   *
   * @param {boolean | number | Complex | Unit | string | Array | Matrix} x  A matrix
   * @return {Array | Matrix} A vector with size of `x`.
   */ return typed($d72da761ee23daae$var$name, {
        Matrix: function Matrix(x) {
            return x.create(x.size(), 'number');
        },
        Array: (0, $d80Xp.arraySize),
        string: function string(x) {
            return config.matrix === 'Array' ? [
                x.length
            ] : matrix([
                x.length
            ], 'dense', 'number');
        },
        'number | Complex | BigNumber | Unit | boolean | null': function number__Complex__BigNumber__Unit__boolean__null(x) {
            // scalar
            return config.matrix === 'Array' ? [] : matrix ? matrix([], 'dense', 'number') : (0, $h5rrM.noMatrix)();
        }
    });
});

});

parcelRegister("8wvrW", function(module, exports) {

$parcel$export(module.exports, "createSlu", () => $6349b524afcb6d04$export$e44ac9822ce417ae);

var $6NnhX = parcelRequire("6NnhX");

var $dsu7t = parcelRequire("dsu7t");

var $3kbKY = parcelRequire("3kbKY");

var $faqfs = parcelRequire("faqfs");
var $6349b524afcb6d04$var$name = 'slu';
var $6349b524afcb6d04$var$dependencies = [
    'typed',
    'abs',
    'add',
    'multiply',
    'transpose',
    'divideScalar',
    'subtract',
    'larger',
    'largerEq',
    'SparseMatrix'
];
var $6349b524afcb6d04$export$e44ac9822ce417ae = /* #__PURE__ */ (0, $dsu7t.factory)($6349b524afcb6d04$var$name, $6349b524afcb6d04$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, multiply: multiply, transpose: transpose, divideScalar: divideScalar, subtract: subtract, larger: larger, largerEq: largerEq, SparseMatrix: SparseMatrix } = _ref;
    var csSqr = (0, $3kbKY.createCsSqr)({
        add: add,
        multiply: multiply,
        transpose: transpose
    });
    var csLu = (0, $faqfs.createCsLu)({
        abs: abs,
        divideScalar: divideScalar,
        multiply: multiply,
        subtract: subtract,
        larger: larger,
        largerEq: largerEq,
        SparseMatrix: SparseMatrix
    });
    /**
   * Calculate the Sparse Matrix LU decomposition with full pivoting. Sparse Matrix `A` is decomposed in two matrices (`L`, `U`) and two permutation vectors (`pinv`, `q`) where
   *
   * `P * A * Q = L * U`
   *
   * Syntax:
   *
   *    math.slu(A, order, threshold)
   *
   * Examples:
   *
   *    const A = math.sparse([[4,3], [6, 3]])
   *    math.slu(A, 1, 0.001)
   *    // returns:
   *    // {
   *    //   L: [[1, 0], [1.5, 1]]
   *    //   U: [[4, 3], [0, -1.5]]
   *    //   p: [0, 1]
   *    //   q: [0, 1]
   *    // }
   *
   * See also:
   *
   *    lup, lsolve, usolve, lusolve
   *
   * @param {SparseMatrix} A              A two dimensional sparse matrix for which to get the LU decomposition.
   * @param {Number}       order          The Symbolic Ordering and Analysis order:
   *                                       0 - Natural ordering, no permutation vector q is returned
   *                                       1 - Matrix must be square, symbolic ordering and analisis is performed on M = A + A'
   *                                       2 - Symbolic ordering and analisis is performed on M = A' * A. Dense columns from A' are dropped, A recreated from A'.
   *                                           This is appropriatefor LU factorization of unsymmetric matrices.
   *                                       3 - Symbolic ordering and analisis is performed on M = A' * A. This is best used for LU factorization is matrix M has no dense rows.
   *                                           A dense row is a row with more than 10*sqr(columns) entries.
   * @param {Number}       threshold       Partial pivoting threshold (1 for partial pivoting)
   *
   * @return {Object} The lower triangular matrix, the upper triangular matrix and the permutation vectors.
   */ return typed($6349b524afcb6d04$var$name, {
        'SparseMatrix, number, number': function SparseMatrix_number_number(a, order, threshold) {
            // verify order
            if (!(0, $6NnhX.isInteger)(order) || order < 0 || order > 3) throw new Error('Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]');
            // verify threshold
            if (threshold < 0 || threshold > 1) throw new Error('Partial pivoting threshold must be a number from 0 to 1');
            // perform symbolic ordering and analysis
            var s = csSqr(order, a, false);
            // perform lu decomposition
            var f = csLu(a, s, threshold);
            // return decomposition
            return {
                L: f.L,
                U: f.U,
                p: f.pinv,
                q: s.q,
                toString: function toString() {
                    return 'L: ' + this.L.toString() + '\nU: ' + this.U.toString() + '\np: ' + this.p.toString() + (this.q ? '\nq: ' + this.q.toString() : '') + '\n';
                }
            };
        }
    });
});

});
parcelRegister("3kbKY", function(module, exports) {

$parcel$export(module.exports, "createCsSqr", () => $26bc5bfe35396566$export$4d3f338d9cfe48c1);
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source

var $B9KQT = parcelRequire("B9KQT");

var $ju6ZE = parcelRequire("ju6ZE");

var $4cF3Q = parcelRequire("4cF3Q");

var $eXuN7 = parcelRequire("eXuN7");

var $hTsmb = parcelRequire("hTsmb");

var $dsu7t = parcelRequire("dsu7t");
var $26bc5bfe35396566$var$name = 'csSqr';
var $26bc5bfe35396566$var$dependencies = [
    'add',
    'multiply',
    'transpose'
];
var $26bc5bfe35396566$export$4d3f338d9cfe48c1 = /* #__PURE__ */ (0, $dsu7t.factory)($26bc5bfe35396566$var$name, $26bc5bfe35396566$var$dependencies, (_ref)=>{
    var { add: add, multiply: multiply, transpose: transpose } = _ref;
    var csAmd = (0, $eXuN7.createCsAmd)({
        add: add,
        multiply: multiply,
        transpose: transpose
    });
    var csCounts = (0, $hTsmb.createCsCounts)({
        transpose: transpose
    });
    /**
   * Symbolic ordering and analysis for QR and LU decompositions.
   *
   * @param {Number}  order           The ordering strategy (see csAmd for more details)
   * @param {Matrix}  a               The A matrix
   * @param {boolean} qr              Symbolic ordering and analysis for QR decomposition (true) or
   *                                  symbolic ordering and analysis for LU decomposition (false)
   *
   * @return {Object}                 The Symbolic ordering and analysis for matrix A
   */ return function csSqr(order, a, qr) {
        // a arrays
        var aptr = a._ptr;
        var asize = a._size;
        // columns
        var n = asize[1];
        // vars
        var k;
        // symbolic analysis result
        var s = {};
        // fill-reducing ordering
        s.q = csAmd(order, a);
        // validate results
        if (order && !s.q) return null;
        // QR symbolic analysis
        if (qr) {
            // apply permutations if needed
            var c = order ? (0, $B9KQT.csPermute)(a, null, s.q, 0) : a;
            // etree of C'*C, where C=A(:,q)
            s.parent = (0, $4cF3Q.csEtree)(c, 1);
            // post order elimination tree
            var post = (0, $ju6ZE.csPost)(s.parent, n);
            // col counts chol(C'*C)
            s.cp = csCounts(c, s.parent, post, 1);
            // check we have everything needed to calculate number of nonzero elements
            if (c && s.parent && s.cp && _vcount(c, s)) // calculate number of nonzero elements
            for(s.unz = 0, k = 0; k < n; k++)s.unz += s.cp[k];
        } else {
            // for LU factorization only, guess nnz(L) and nnz(U)
            s.unz = 4 * aptr[n] + n;
            s.lnz = s.unz;
        }
        // return result S
        return s;
    };
    /**
   * Compute nnz(V) = s.lnz, s.pinv, s.leftmost, s.m2 from A and s.parent
   */ function _vcount(a, s) {
        // a arrays
        var aptr = a._ptr;
        var aindex = a._index;
        var asize = a._size;
        // rows & columns
        var m = asize[0];
        var n = asize[1];
        // initialize s arrays
        s.pinv = []; // (m + n)
        s.leftmost = []; // (m)
        // vars
        var parent = s.parent;
        var pinv = s.pinv;
        var leftmost = s.leftmost;
        // workspace, next: first m entries, head: next n entries, tail: next n entries, nque: next n entries
        var w = []; // (m + 3 * n)
        var next = 0;
        var head = m;
        var tail = m + n;
        var nque = m + 2 * n;
        // vars
        var i, k, p, p0, p1;
        // initialize w
        for(k = 0; k < n; k++){
            // queue k is empty
            w[head + k] = -1;
            w[tail + k] = -1;
            w[nque + k] = 0;
        }
        // initialize row arrays
        for(i = 0; i < m; i++)leftmost[i] = -1;
        // loop columns backwards
        for(k = n - 1; k >= 0; k--)// values & index for column k
        for(p0 = aptr[k], p1 = aptr[k + 1], p = p0; p < p1; p++)// leftmost[i] = min(find(A(i,:)))
        leftmost[aindex[p]] = k;
        // scan rows in reverse order
        for(i = m - 1; i >= 0; i--){
            // row i is not yet ordered
            pinv[i] = -1;
            k = leftmost[i];
            // check row i is empty
            if (k === -1) continue;
            // first row in queue k
            if (w[nque + k]++ === 0) w[tail + k] = i;
            // put i at head of queue k
            w[next + i] = w[head + k];
            w[head + k] = i;
        }
        s.lnz = 0;
        s.m2 = m;
        // find row permutation and nnz(V)
        for(k = 0; k < n; k++){
            // remove row i from queue k
            i = w[head + k];
            // count V(k,k) as nonzero
            s.lnz++;
            // add a fictitious row
            if (i < 0) i = s.m2++;
            // associate row i with V(:,k)
            pinv[i] = k;
            // skip if V(k+1:m,k) is empty
            if (--nque[k] <= 0) continue;
            // nque[k] is nnz (V(k+1:m,k))
            s.lnz += w[nque + k];
            // move all rows to parent of k
            var pa = parent[k];
            if (pa !== -1) {
                if (w[nque + pa] === 0) w[tail + pa] = w[tail + k];
                w[next + w[tail + k]] = w[head + pa];
                w[head + pa] = w[next + i];
                w[nque + pa] += w[nque + k];
            }
        }
        for(i = 0; i < m; i++)if (pinv[i] < 0) pinv[i] = k++;
        return true;
    }
});

});
parcelRegister("B9KQT", function(module, exports) {

$parcel$export(module.exports, "csPermute", () => $06fb05e4764e24d2$export$76070a0ecffd0bb2);
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
/**
 * Permutes a sparse matrix C = P * A * Q
 *
 * @param {SparseMatrix}  a         The Matrix A
 * @param {Array}   pinv            The row permutation vector
 * @param {Array}   q               The column permutation vector
 * @param {boolean} values          Create a pattern matrix (false), values and pattern otherwise
 *
 * @return {Matrix}                 C = P * A * Q, null on error
 */ function $06fb05e4764e24d2$export$76070a0ecffd0bb2(a, pinv, q, values) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size;
    var adt = a._datatype;
    // rows & columns
    var m = asize[0];
    var n = asize[1];
    // c arrays
    var cvalues = values && a._values ? [] : null;
    var cindex = []; // (aptr[n])
    var cptr = []; // (n + 1)
    // initialize vars
    var nz = 0;
    // loop columns
    for(var k = 0; k < n; k++){
        // column k of C is column q[k] of A
        cptr[k] = nz;
        // apply column permutation
        var j = q ? q[k] : k;
        // loop values in column j of A
        for(var t0 = aptr[j], t1 = aptr[j + 1], t = t0; t < t1; t++){
            // row i of A is row pinv[i] of C
            var r = pinv ? pinv[aindex[t]] : aindex[t];
            // index
            cindex[nz] = r;
            // check we need to populate values
            if (cvalues) cvalues[nz] = avalues[t];
            // increment number of nonzero elements
            nz++;
        }
    }
    // finalize the last column of C
    cptr[n] = nz;
    // return C matrix
    return a.createSparseMatrix({
        values: cvalues,
        index: cindex,
        ptr: cptr,
        size: [
            m,
            n
        ],
        datatype: adt
    });
}

});

parcelRegister("ju6ZE", function(module, exports) {

$parcel$export(module.exports, "csPost", () => $e2f63e6c53f88b4b$export$90626b0a5705891a);
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source

var $bC7G8 = parcelRequire("bC7G8");
function $e2f63e6c53f88b4b$export$90626b0a5705891a(parent, n) {
    // check inputs
    if (!parent) return null;
    // vars
    var k = 0;
    var j;
    // allocate result
    var post = []; // (n)
    // workspace, head: first n entries, next: next n entries, stack: last n entries
    var w = []; // (3 * n)
    var head = 0;
    var next = n;
    var stack = 2 * n;
    // initialize workspace
    for(j = 0; j < n; j++)// empty linked lists
    w[head + j] = -1;
    // traverse nodes in reverse order
    for(j = n - 1; j >= 0; j--){
        // check j is a root
        if (parent[j] === -1) continue;
        // add j to list of its parent
        w[next + j] = w[head + parent[j]];
        w[head + parent[j]] = j;
    }
    // loop nodes
    for(j = 0; j < n; j++){
        // skip j if it is not a root
        if (parent[j] !== -1) continue;
        // depth-first search
        k = (0, $bC7G8.csTdfs)(j, k, w, head, next, post, stack);
    }
    return post;
}

});
parcelRegister("bC7G8", function(module, exports) {

$parcel$export(module.exports, "csTdfs", () => $87493322d6054792$export$18e42241aee7902a);
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
/**
 * Depth-first search and postorder of a tree rooted at node j
 *
 * @param {Number}  j               The tree node
 * @param {Number}  k
 * @param {Array}   w               The workspace array
 * @param {Number}  head            The index offset within the workspace for the head array
 * @param {Number}  next            The index offset within the workspace for the next array
 * @param {Array}   post            The post ordering array
 * @param {Number}  stack           The index offset within the workspace for the stack array
 */ function $87493322d6054792$export$18e42241aee7902a(j, k, w, head, next, post, stack) {
    // variables
    var top = 0;
    // place j on the stack
    w[stack] = j;
    // while (stack is not empty)
    while(top >= 0){
        // p = top of stack
        var p = w[stack + top];
        // i = youngest child of p
        var i = w[head + p];
        if (i === -1) {
            // p has no unordered children left
            top--;
            // node p is the kth postordered node
            post[k++] = p;
        } else {
            // remove i from children of p
            w[head + p] = w[next + i];
            // increment top
            ++top;
            // start dfs on child node i
            w[stack + top] = i;
        }
    }
    return k;
}

});


parcelRegister("4cF3Q", function(module, exports) {

$parcel$export(module.exports, "csEtree", () => $30f8224bfb77e453$export$720e2a9a0fdebf8c);
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
/**
 * Computes the elimination tree of Matrix A (using triu(A)) or the
 * elimination tree of A'A without forming A'A.
 *
 * @param {Matrix}  a               The A Matrix
 * @param {boolean} ata             A value of true the function computes the etree of A'A
 */ function $30f8224bfb77e453$export$720e2a9a0fdebf8c(a, ata) {
    // check inputs
    if (!a) return null;
    // a arrays
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size;
    // rows & columns
    var m = asize[0];
    var n = asize[1];
    // allocate result
    var parent = []; // (n)
    // allocate workspace
    var w = []; // (n + (ata ? m : 0))
    var ancestor = 0; // first n entries in w
    var prev = n; // last m entries (ata = true)
    var i, inext;
    // check we are calculating A'A
    if (ata) // initialize workspace
    for(i = 0; i < m; i++)w[prev + i] = -1;
    // loop columns
    for(var k = 0; k < n; k++){
        // node k has no parent yet
        parent[k] = -1;
        // nor does k have an ancestor
        w[ancestor + k] = -1;
        // values in column k
        for(var p0 = aptr[k], p1 = aptr[k + 1], p = p0; p < p1; p++){
            // row
            var r = aindex[p];
            // node
            i = ata ? w[prev + r] : r;
            // traverse from i to k
            for(; i !== -1 && i < k; i = inext){
                // inext = ancestor of i
                inext = w[ancestor + i];
                // path compression
                w[ancestor + i] = k;
                // check no anc., parent is k
                if (inext === -1) parent[i] = k;
            }
            if (ata) w[prev + r] = k;
        }
    }
    return parent;
}

});

parcelRegister("eXuN7", function(module, exports) {

$parcel$export(module.exports, "createCsAmd", () => $ae3e75e3e24f145f$export$485230eb48878637);
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source

var $dsu7t = parcelRequire("dsu7t");

var $jsq7e = parcelRequire("jsq7e");

var $ekW7Q = parcelRequire("ekW7Q");

var $bC7G8 = parcelRequire("bC7G8");
var $ae3e75e3e24f145f$var$name = 'csAmd';
var $ae3e75e3e24f145f$var$dependencies = [
    'add',
    'multiply',
    'transpose'
];
var $ae3e75e3e24f145f$export$485230eb48878637 = /* #__PURE__ */ (0, $dsu7t.factory)($ae3e75e3e24f145f$var$name, $ae3e75e3e24f145f$var$dependencies, (_ref)=>{
    var { add: add, multiply: multiply, transpose: transpose } = _ref;
    /**
   * Approximate minimum degree ordering. The minimum degree algorithm is a widely used
   * heuristic for finding a permutation P so that P*A*P' has fewer nonzeros in its factorization
   * than A. It is a gready method that selects the sparsest pivot row and column during the course
   * of a right looking sparse Cholesky factorization.
   *
   * @param {Number} order    0: Natural, 1: Cholesky, 2: LU, 3: QR
   * @param {Matrix} m        Sparse Matrix
   */ return function csAmd(order, a) {
        // check input parameters
        if (!a || order <= 0 || order > 3) return null;
        // a matrix arrays
        var asize = a._size;
        // rows and columns
        var m = asize[0];
        var n = asize[1];
        // initialize vars
        var lemax = 0;
        // dense threshold
        var dense = Math.max(16, 10 * Math.sqrt(n));
        dense = Math.min(n - 2, dense);
        // create target matrix C
        var cm = _createTargetMatrix(order, a, m, n, dense);
        // drop diagonal entries
        (0, $jsq7e.csFkeep)(cm, _diag, null);
        // C matrix arrays
        var cindex = cm._index;
        var cptr = cm._ptr;
        // number of nonzero elements in C
        var cnz = cptr[n];
        // allocate result (n+1)
        var P = [];
        // create workspace (8 * (n + 1))
        var W = [];
        var len = 0; // first n + 1 entries
        var nv = n + 1; // next n + 1 entries
        var next = 2 * (n + 1); // next n + 1 entries
        var head = 3 * (n + 1); // next n + 1 entries
        var elen = 4 * (n + 1); // next n + 1 entries
        var degree = 5 * (n + 1); // next n + 1 entries
        var w = 6 * (n + 1); // next n + 1 entries
        var hhead = 7 * (n + 1); // last n + 1 entries
        // use P as workspace for last
        var last = P;
        // initialize quotient graph
        var mark = _initializeQuotientGraph(n, cptr, W, len, head, last, next, hhead, nv, w, elen, degree);
        // initialize degree lists
        var nel = _initializeDegreeLists(n, cptr, W, degree, elen, w, dense, nv, head, last, next);
        // minimum degree node
        var mindeg = 0;
        // vars
        var i, j, k, k1, k2, e, pj, ln, nvi, pk, eln, p1, p2, pn, h, d;
        // while (selecting pivots) do
        while(nel < n){
            // select node of minimum approximate degree. amd() is now ready to start eliminating the graph. It first
            // finds a node k of minimum degree and removes it from its degree list. The variable nel keeps track of thow
            // many nodes have been eliminated.
            for(k = -1; mindeg < n && (k = W[head + mindeg]) === -1; mindeg++);
            if (W[next + k] !== -1) last[W[next + k]] = -1;
            // remove k from degree list
            W[head + mindeg] = W[next + k];
            // elenk = |Ek|
            var elenk = W[elen + k];
            // # of nodes k represents
            var nvk = W[nv + k];
            // W[nv + k] nodes of A eliminated
            nel += nvk;
            // Construct a new element. The new element Lk is constructed in place if |Ek| = 0. nv[i] is
            // negated for all nodes i in Lk to flag them as members of this set. Each node i is removed from the
            // degree lists. All elements e in Ek are absorved into element k.
            var dk = 0;
            // flag k as in Lk
            W[nv + k] = -nvk;
            var p = cptr[k];
            // do in place if W[elen + k] === 0
            var pk1 = elenk === 0 ? p : cnz;
            var pk2 = pk1;
            for(k1 = 1; k1 <= elenk + 1; k1++){
                if (k1 > elenk) {
                    // search the nodes in k
                    e = k;
                    // list of nodes starts at cindex[pj]
                    pj = p;
                    // length of list of nodes in k
                    ln = W[len + k] - elenk;
                } else {
                    // search the nodes in e
                    e = cindex[p++];
                    pj = cptr[e];
                    // length of list of nodes in e
                    ln = W[len + e];
                }
                for(k2 = 1; k2 <= ln; k2++){
                    i = cindex[pj++];
                    // check  node i dead, or seen
                    if ((nvi = W[nv + i]) <= 0) continue;
                    // W[degree + Lk] += size of node i
                    dk += nvi;
                    // negate W[nv + i] to denote i in Lk
                    W[nv + i] = -nvi;
                    // place i in Lk
                    cindex[pk2++] = i;
                    if (W[next + i] !== -1) last[W[next + i]] = last[i];
                    // check we need to remove i from degree list
                    if (last[i] !== -1) W[next + last[i]] = W[next + i];
                    else W[head + W[degree + i]] = W[next + i];
                }
                if (e !== k) {
                    // absorb e into k
                    cptr[e] = (0, $ekW7Q.csFlip)(k);
                    // e is now a dead element
                    W[w + e] = 0;
                }
            }
            // cindex[cnz...nzmax] is free
            if (elenk !== 0) cnz = pk2;
            // external degree of k - |Lk\i|
            W[degree + k] = dk;
            // element k is in cindex[pk1..pk2-1]
            cptr[k] = pk1;
            W[len + k] = pk2 - pk1;
            // k is now an element
            W[elen + k] = -2;
            // Find set differences. The scan1 function now computes the set differences |Le \ Lk| for all elements e. At the start of the
            // scan, no entry in the w array is greater than or equal to mark.
            // clear w if necessary
            mark = _wclear(mark, lemax, W, w, n);
            // scan 1: find |Le\Lk|
            for(pk = pk1; pk < pk2; pk++){
                i = cindex[pk];
                // check if W[elen + i] empty, skip it
                if ((eln = W[elen + i]) <= 0) continue;
                // W[nv + i] was negated
                nvi = -W[nv + i];
                var wnvi = mark - nvi;
                // scan Ei
                for(p = cptr[i], p1 = cptr[i] + eln - 1; p <= p1; p++){
                    e = cindex[p];
                    if (W[w + e] >= mark) // decrement |Le\Lk|
                    W[w + e] -= nvi;
                    else if (W[w + e] !== 0) // ensure e is a live element, 1st time e seen in scan 1
                    W[w + e] = W[degree + e] + wnvi;
                }
            }
            // degree update
            // The second pass computes the approximate degree di, prunes the sets Ei and Ai, and computes a hash
            // function h(i) for all nodes in Lk.
            // scan2: degree update
            for(pk = pk1; pk < pk2; pk++){
                // consider node i in Lk
                i = cindex[pk];
                p1 = cptr[i];
                p2 = p1 + W[elen + i] - 1;
                pn = p1;
                // scan Ei
                for(h = 0, d = 0, p = p1; p <= p2; p++){
                    e = cindex[p];
                    // check e is an unabsorbed element
                    if (W[w + e] !== 0) {
                        // dext = |Le\Lk|
                        var dext = W[w + e] - mark;
                        if (dext > 0) {
                            // sum up the set differences
                            d += dext;
                            // keep e in Ei
                            cindex[pn++] = e;
                            // compute the hash of node i
                            h += e;
                        } else {
                            // aggressive absorb. e->k
                            cptr[e] = (0, $ekW7Q.csFlip)(k);
                            // e is a dead element
                            W[w + e] = 0;
                        }
                    }
                }
                // W[elen + i] = |Ei|
                W[elen + i] = pn - p1 + 1;
                var p3 = pn;
                var p4 = p1 + W[len + i];
                // prune edges in Ai
                for(p = p2 + 1; p < p4; p++){
                    j = cindex[p];
                    // check node j dead or in Lk
                    var nvj = W[nv + j];
                    if (nvj <= 0) continue;
                    // degree(i) += |j|
                    d += nvj;
                    // place j in node list of i
                    cindex[pn++] = j;
                    // compute hash for node i
                    h += j;
                }
                // check for mass elimination
                if (d === 0) {
                    // absorb i into k
                    cptr[i] = (0, $ekW7Q.csFlip)(k);
                    nvi = -W[nv + i];
                    // |Lk| -= |i|
                    dk -= nvi;
                    // |k| += W[nv + i]
                    nvk += nvi;
                    nel += nvi;
                    W[nv + i] = 0;
                    // node i is dead
                    W[elen + i] = -1;
                } else {
                    // update degree(i)
                    W[degree + i] = Math.min(W[degree + i], d);
                    // move first node to end
                    cindex[pn] = cindex[p3];
                    // move 1st el. to end of Ei
                    cindex[p3] = cindex[p1];
                    // add k as 1st element in of Ei
                    cindex[p1] = k;
                    // new len of adj. list of node i
                    W[len + i] = pn - p1 + 1;
                    // finalize hash of i
                    h = (h < 0 ? -h : h) % n;
                    // place i in hash bucket
                    W[next + i] = W[hhead + h];
                    W[hhead + h] = i;
                    // save hash of i in last[i]
                    last[i] = h;
                }
            }
            // finalize |Lk|
            W[degree + k] = dk;
            lemax = Math.max(lemax, dk);
            // clear w
            mark = _wclear(mark + lemax, lemax, W, w, n);
            // Supernode detection. Supernode detection relies on the hash function h(i) computed for each node i.
            // If two nodes have identical adjacency lists, their hash functions wil be identical.
            for(pk = pk1; pk < pk2; pk++){
                i = cindex[pk];
                // check i is dead, skip it
                if (W[nv + i] >= 0) continue;
                // scan hash bucket of node i
                h = last[i];
                i = W[hhead + h];
                // hash bucket will be empty
                W[hhead + h] = -1;
                for(; i !== -1 && W[next + i] !== -1; i = W[next + i], mark++){
                    ln = W[len + i];
                    eln = W[elen + i];
                    for(p = cptr[i] + 1; p <= cptr[i] + ln - 1; p++)W[w + cindex[p]] = mark;
                    var jlast = i;
                    // compare i with all j
                    for(j = W[next + i]; j !== -1;){
                        var ok = W[len + j] === ln && W[elen + j] === eln;
                        for(p = cptr[j] + 1; ok && p <= cptr[j] + ln - 1; p++)// compare i and j
                        if (W[w + cindex[p]] !== mark) ok = 0;
                        // check i and j are identical
                        if (ok) {
                            // absorb j into i
                            cptr[j] = (0, $ekW7Q.csFlip)(i);
                            W[nv + i] += W[nv + j];
                            W[nv + j] = 0;
                            // node j is dead
                            W[elen + j] = -1;
                            // delete j from hash bucket
                            j = W[next + j];
                            W[next + jlast] = j;
                        } else {
                            // j and i are different
                            jlast = j;
                            j = W[next + j];
                        }
                    }
                }
            }
            // Finalize new element. The elimination of node k is nearly complete. All nodes i in Lk are scanned one last time.
            // Node i is removed from Lk if it is dead. The flagged status of nv[i] is cleared.
            for(p = pk1, pk = pk1; pk < pk2; pk++){
                i = cindex[pk];
                // check  i is dead, skip it
                if ((nvi = -W[nv + i]) <= 0) continue;
                // restore W[nv + i]
                W[nv + i] = nvi;
                // compute external degree(i)
                d = W[degree + i] + dk - nvi;
                d = Math.min(d, n - nel - nvi);
                if (W[head + d] !== -1) last[W[head + d]] = i;
                // put i back in degree list
                W[next + i] = W[head + d];
                last[i] = -1;
                W[head + d] = i;
                // find new minimum degree
                mindeg = Math.min(mindeg, d);
                W[degree + i] = d;
                // place i in Lk
                cindex[p++] = i;
            }
            // # nodes absorbed into k
            W[nv + k] = nvk;
            // length of adj list of element k
            if ((W[len + k] = p - pk1) === 0) {
                // k is a root of the tree
                cptr[k] = -1;
                // k is now a dead element
                W[w + k] = 0;
            }
            if (elenk !== 0) // free unused space in Lk
            cnz = p;
        }
        // Postordering. The elimination is complete, but no permutation has been computed. All that is left
        // of the graph is the assembly tree (ptr) and a set of dead nodes and elements (i is a dead node if
        // nv[i] is zero and a dead element if nv[i] > 0). It is from this information only that the final permutation
        // is computed. The tree is restored by unflipping all of ptr.
        // fix assembly tree
        for(i = 0; i < n; i++)cptr[i] = (0, $ekW7Q.csFlip)(cptr[i]);
        for(j = 0; j <= n; j++)W[head + j] = -1;
        // place unordered nodes in lists
        for(j = n; j >= 0; j--){
            // skip if j is an element
            if (W[nv + j] > 0) continue;
            // place j in list of its parent
            W[next + j] = W[head + cptr[j]];
            W[head + cptr[j]] = j;
        }
        // place elements in lists
        for(e = n; e >= 0; e--){
            // skip unless e is an element
            if (W[nv + e] <= 0) continue;
            if (cptr[e] !== -1) {
                // place e in list of its parent
                W[next + e] = W[head + cptr[e]];
                W[head + cptr[e]] = e;
            }
        }
        // postorder the assembly tree
        for(k = 0, i = 0; i <= n; i++)if (cptr[i] === -1) k = (0, $bC7G8.csTdfs)(i, k, W, head, next, P, w);
        // remove last item in array
        P.splice(P.length - 1, 1);
        // return P
        return P;
    };
    /**
   * Creates the matrix that will be used by the approximate minimum degree ordering algorithm. The function accepts the matrix M as input and returns a permutation
   * vector P. The amd algorithm operates on a symmetrix matrix, so one of three symmetric matrices is formed.
   *
   * Order: 0
   *   A natural ordering P=null matrix is returned.
   *
   * Order: 1
   *   Matrix must be square. This is appropriate for a Cholesky or LU factorization.
   *   P = M + M'
   *
   * Order: 2
   *   Dense columns from M' are dropped, M recreated from M'. This is appropriatefor LU factorization of unsymmetric matrices.
   *   P = M' * M
   *
   * Order: 3
   *   This is best used for QR factorization or LU factorization is matrix M has no dense rows. A dense row is a row with more than 10*sqr(columns) entries.
   *   P = M' * M
   */ function _createTargetMatrix(order, a, m, n, dense) {
        // compute A'
        var at = transpose(a);
        // check order = 1, matrix must be square
        if (order === 1 && n === m) // C = A + A'
        return add(a, at);
        // check order = 2, drop dense columns from M'
        if (order === 2) {
            // transpose arrays
            var tindex = at._index;
            var tptr = at._ptr;
            // new column index
            var p2 = 0;
            // loop A' columns (rows)
            for(var j = 0; j < m; j++){
                // column j of AT starts here
                var p = tptr[j];
                // new column j starts here
                tptr[j] = p2;
                // skip dense col j
                if (tptr[j + 1] - p > dense) continue;
                // map rows in column j of A
                for(var p1 = tptr[j + 1]; p < p1; p++)tindex[p2++] = tindex[p];
            }
            // finalize AT
            tptr[m] = p2;
            // recreate A from new transpose matrix
            a = transpose(at);
            // use A' * A
            return multiply(at, a);
        }
        // use A' * A, square or rectangular matrix
        return multiply(at, a);
    }
    /**
   * Initialize quotient graph. There are four kind of nodes and elements that must be represented:
   *
   *  - A live node is a node i (or a supernode) that has not been selected as a pivot nad has not been merged into another supernode.
   *  - A dead node i is one that has been removed from the graph, having been absorved into r = flip(ptr[i]).
   *  - A live element e is one that is in the graph, having been formed when node e was selected as the pivot.
   *  - A dead element e is one that has benn absorved into a subsequent element s = flip(ptr[e]).
   */ function _initializeQuotientGraph(n, cptr, W, len, head, last, next, hhead, nv, w, elen, degree) {
        // Initialize quotient graph
        for(var k = 0; k < n; k++)W[len + k] = cptr[k + 1] - cptr[k];
        W[len + n] = 0;
        // initialize workspace
        for(var i = 0; i <= n; i++){
            // degree list i is empty
            W[head + i] = -1;
            last[i] = -1;
            W[next + i] = -1;
            // hash list i is empty
            W[hhead + i] = -1;
            // node i is just one node
            W[nv + i] = 1;
            // node i is alive
            W[w + i] = 1;
            // Ek of node i is empty
            W[elen + i] = 0;
            // degree of node i
            W[degree + i] = W[len + i];
        }
        // clear w
        var mark = _wclear(0, 0, W, w, n);
        // n is a dead element
        W[elen + n] = -2;
        // n is a root of assembly tree
        cptr[n] = -1;
        // n is a dead element
        W[w + n] = 0;
        // return mark
        return mark;
    }
    /**
   * Initialize degree lists. Each node is placed in its degree lists. Nodes of zero degree are eliminated immediately. Nodes with
   * degree >= dense are alsol eliminated and merged into a placeholder node n, a dead element. Thes nodes will appera last in the
   * output permutation p.
   */ function _initializeDegreeLists(n, cptr, W, degree, elen, w, dense, nv, head, last, next) {
        // result
        var nel = 0;
        // loop columns
        for(var i = 0; i < n; i++){
            // degree @ i
            var d = W[degree + i];
            // check node i is empty
            if (d === 0) {
                // element i is dead
                W[elen + i] = -2;
                nel++;
                // i is a root of assembly tree
                cptr[i] = -1;
                W[w + i] = 0;
            } else if (d > dense) {
                // absorb i into element n
                W[nv + i] = 0;
                // node i is dead
                W[elen + i] = -1;
                nel++;
                cptr[i] = (0, $ekW7Q.csFlip)(n);
                W[nv + n]++;
            } else {
                var h = W[head + d];
                if (h !== -1) last[h] = i;
                // put node i in degree list d
                W[next + i] = W[head + d];
                W[head + d] = i;
            }
        }
        return nel;
    }
    function _wclear(mark, lemax, W, w, n) {
        if (mark < 2 || mark + lemax < 0) {
            for(var k = 0; k < n; k++)if (W[w + k] !== 0) W[w + k] = 1;
            mark = 2;
        }
        // at this point, W [0..n-1] < mark holds
        return mark;
    }
    function _diag(i, j) {
        return i !== j;
    }
});

});
parcelRegister("jsq7e", function(module, exports) {

$parcel$export(module.exports, "csFkeep", () => $e2a4e3d88c61c996$export$9453433d9395b8cb);
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
/**
 * Keeps entries in the matrix when the callback function returns true, removes the entry otherwise
 *
 * @param {Matrix}   a              The sparse matrix
 * @param {function} callback       The callback function, function will be invoked with the following args:
 *                                    - The entry row
 *                                    - The entry column
 *                                    - The entry value
 *                                    - The state parameter
 * @param {any}      other          The state
 *
 * @return                          The number of nonzero elements in the matrix
 */ function $e2a4e3d88c61c996$export$9453433d9395b8cb(a, callback, other) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size;
    // columns
    var n = asize[1];
    // nonzero items
    var nz = 0;
    // loop columns
    for(var j = 0; j < n; j++){
        // get current location of col j
        var p = aptr[j];
        // record new location of col j
        aptr[j] = nz;
        for(; p < aptr[j + 1]; p++)// check we need to keep this item
        if (callback(aindex[p], j, avalues ? avalues[p] : 1, other)) {
            // keep A(i,j)
            aindex[nz] = aindex[p];
            // check we need to process values (pattern only)
            if (avalues) avalues[nz] = avalues[p];
            // increment nonzero items
            nz++;
        }
    }
    // finalize A
    aptr[n] = nz;
    // trim arrays
    aindex.splice(nz, aindex.length - nz);
    // check we need to process values (pattern only)
    if (avalues) avalues.splice(nz, avalues.length - nz);
    // return number of nonzero items
    return nz;
}

});

parcelRegister("ekW7Q", function(module, exports) {

$parcel$export(module.exports, "csFlip", () => $a700057c2ec43c4c$export$d405b3d9168b83fa);
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
/**
 * This function "flips" its input about the integer -1.
 *
 * @param {Number}  i               The value to flip
 */ function $a700057c2ec43c4c$export$d405b3d9168b83fa(i) {
    // flip the value
    return -i - 2;
}

});


parcelRegister("hTsmb", function(module, exports) {

$parcel$export(module.exports, "createCsCounts", () => $d06d91c6133e8dae$export$1feb4fbda2abf3b3);
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source

var $dsu7t = parcelRequire("dsu7t");

var $fkiGD = parcelRequire("fkiGD");
var $d06d91c6133e8dae$var$name = 'csCounts';
var $d06d91c6133e8dae$var$dependencies = [
    'transpose'
];
var $d06d91c6133e8dae$export$1feb4fbda2abf3b3 = /* #__PURE__ */ (0, $dsu7t.factory)($d06d91c6133e8dae$var$name, $d06d91c6133e8dae$var$dependencies, (_ref)=>{
    var { transpose: transpose } = _ref;
    /**
   * Computes the column counts using the upper triangular part of A.
   * It transposes A internally, none of the input parameters are modified.
   *
   * @param {Matrix} a           The sparse matrix A
   *
   * @param {Matrix} ata         Count the columns of A'A instead
   *
   * @return                     An array of size n of the column counts or null on error
   */ return function(a, parent, post, ata) {
        // check inputs
        if (!a || !parent || !post) return null;
        // a matrix arrays
        var asize = a._size;
        // rows and columns
        var m = asize[0];
        var n = asize[1];
        // variables
        var i, j, k, J, p, p0, p1;
        // workspace size
        var s = 4 * n + (ata ? n + m + 1 : 0);
        // allocate workspace
        var w = []; // (s)
        var ancestor = 0; // first n entries
        var maxfirst = n; // next n entries
        var prevleaf = 2 * n; // next n entries
        var first = 3 * n; // next n entries
        var head = 4 * n; // next n + 1 entries (used when ata is true)
        var next = 5 * n + 1; // last entries in workspace
        // clear workspace w[0..s-1]
        for(k = 0; k < s; k++)w[k] = -1;
        // allocate result
        var colcount = []; // (n)
        // AT = A'
        var at = transpose(a);
        // at arrays
        var tindex = at._index;
        var tptr = at._ptr;
        // find w[first + j]
        for(k = 0; k < n; k++){
            j = post[k];
            // colcount[j]=1 if j is a leaf
            colcount[j] = w[first + j] === -1 ? 1 : 0;
            for(; j !== -1 && w[first + j] === -1; j = parent[j])w[first + j] = k;
        }
        // initialize ata if needed
        if (ata) {
            // invert post
            for(k = 0; k < n; k++)w[post[k]] = k;
            // loop rows (columns in AT)
            for(i = 0; i < m; i++){
                // values in column i of AT
                for(k = n, p0 = tptr[i], p1 = tptr[i + 1], p = p0; p < p1; p++)k = Math.min(k, w[tindex[p]]);
                // place row i in linked list k
                w[next + i] = w[head + k];
                w[head + k] = i;
            }
        }
        // each node in its own set
        for(i = 0; i < n; i++)w[ancestor + i] = i;
        for(k = 0; k < n; k++){
            // j is the kth node in postordered etree
            j = post[k];
            // check j is not a root
            if (parent[j] !== -1) colcount[parent[j]]--;
            // J=j for LL'=A case
            for(J = ata ? w[head + k] : j; J !== -1; J = ata ? w[next + J] : -1)for(p = tptr[J]; p < tptr[J + 1]; p++){
                i = tindex[p];
                var r = (0, $fkiGD.csLeaf)(i, j, w, first, maxfirst, prevleaf, ancestor);
                // check A(i,j) is in skeleton
                if (r.jleaf >= 1) colcount[j]++;
                // check account for overlap in q
                if (r.jleaf === 2) colcount[r.q]--;
            }
            if (parent[j] !== -1) w[ancestor + j] = parent[j];
        }
        // sum up colcount's of each child
        for(j = 0; j < n; j++)if (parent[j] !== -1) colcount[parent[j]] += colcount[j];
        return colcount;
    };
});

});
parcelRegister("fkiGD", function(module, exports) {

$parcel$export(module.exports, "csLeaf", () => $b287380c93f55210$export$e5adc9884f74ac27);
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
/**
 * This function determines if j is a leaf of the ith row subtree.
 * Consider A(i,j), node j in ith row subtree and return lca(jprev,j)
 *
 * @param {Number}  i               The ith row subtree
 * @param {Number}  j               The node to test
 * @param {Array}   w               The workspace array
 * @param {Number}  first           The index offset within the workspace for the first array
 * @param {Number}  maxfirst        The index offset within the workspace for the maxfirst array
 * @param {Number}  prevleaf        The index offset within the workspace for the prevleaf array
 * @param {Number}  ancestor        The index offset within the workspace for the ancestor array
 *
 * @return {Object}
 */ function $b287380c93f55210$export$e5adc9884f74ac27(i, j, w, first, maxfirst, prevleaf, ancestor) {
    var s, sparent;
    // our result
    var jleaf = 0;
    var q;
    // check j is a leaf
    if (i <= j || w[first + j] <= w[maxfirst + i]) return -1;
    // update max first[j] seen so far
    w[maxfirst + i] = w[first + j];
    // jprev = previous leaf of ith subtree
    var jprev = w[prevleaf + i];
    w[prevleaf + i] = j;
    // check j is first or subsequent leaf
    if (jprev === -1) {
        // 1st leaf, q = root of ith subtree
        jleaf = 1;
        q = i;
    } else {
        // update jleaf
        jleaf = 2;
        // q = least common ancester (jprev,j)
        for(q = jprev; q !== w[ancestor + q]; q = w[ancestor + q]);
        for(s = jprev; s !== q; s = sparent){
            // path compression
            sparent = w[ancestor + s];
            w[ancestor + s] = q;
        }
    }
    return {
        jleaf: jleaf,
        q: q
    };
}

});



parcelRegister("faqfs", function(module, exports) {

$parcel$export(module.exports, "createCsLu", () => $b0ac2687b7062f27$export$5487b5fadeacd2f6);
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source

var $dsu7t = parcelRequire("dsu7t");

var $eAbgK = parcelRequire("eAbgK");
var $b0ac2687b7062f27$var$name = 'csLu';
var $b0ac2687b7062f27$var$dependencies = [
    'abs',
    'divideScalar',
    'multiply',
    'subtract',
    'larger',
    'largerEq',
    'SparseMatrix'
];
var $b0ac2687b7062f27$export$5487b5fadeacd2f6 = /* #__PURE__ */ (0, $dsu7t.factory)($b0ac2687b7062f27$var$name, $b0ac2687b7062f27$var$dependencies, (_ref)=>{
    var { abs: abs, divideScalar: divideScalar, multiply: multiply, subtract: subtract, larger: larger, largerEq: largerEq, SparseMatrix: SparseMatrix } = _ref;
    var csSpsolve = (0, $eAbgK.createCsSpsolve)({
        divideScalar: divideScalar,
        multiply: multiply,
        subtract: subtract
    });
    /**
   * Computes the numeric LU factorization of the sparse matrix A. Implements a Left-looking LU factorization
   * algorithm that computes L and U one column at a tume. At the kth step, it access columns 1 to k-1 of L
   * and column k of A. Given the fill-reducing column ordering q (see parameter s) computes L, U and pinv so
   * L * U = A(p, q), where p is the inverse of pinv.
   *
   * @param {Matrix}  m               The A Matrix to factorize
   * @param {Object}  s               The symbolic analysis from csSqr(). Provides the fill-reducing
   *                                  column ordering q
   * @param {Number}  tol             Partial pivoting threshold (1 for partial pivoting)
   *
   * @return {Number}                 The numeric LU factorization of A or null
   */ return function csLu(m, s, tol) {
        // validate input
        if (!m) return null;
        // m arrays
        var size = m._size;
        // columns
        var n = size[1];
        // symbolic analysis result
        var q;
        var lnz = 100;
        var unz = 100;
        // update symbolic analysis parameters
        if (s) {
            q = s.q;
            lnz = s.lnz || lnz;
            unz = s.unz || unz;
        }
        // L arrays
        var lvalues = []; // (lnz)
        var lindex = []; // (lnz)
        var lptr = []; // (n + 1)
        // L
        var L = new SparseMatrix({
            values: lvalues,
            index: lindex,
            ptr: lptr,
            size: [
                n,
                n
            ]
        });
        // U arrays
        var uvalues = []; // (unz)
        var uindex = []; // (unz)
        var uptr = []; // (n + 1)
        // U
        var U = new SparseMatrix({
            values: uvalues,
            index: uindex,
            ptr: uptr,
            size: [
                n,
                n
            ]
        });
        // inverse of permutation vector
        var pinv = []; // (n)
        // vars
        var i, p;
        // allocate arrays
        var x = []; // (n)
        var xi = []; // (2 * n)
        // initialize variables
        for(i = 0; i < n; i++){
            // clear workspace
            x[i] = 0;
            // no rows pivotal yet
            pinv[i] = -1;
            // no cols of L yet
            lptr[i + 1] = 0;
        }
        // reset number of nonzero elements in L and U
        lnz = 0;
        unz = 0;
        // compute L(:,k) and U(:,k)
        for(var k = 0; k < n; k++){
            // update ptr
            lptr[k] = lnz;
            uptr[k] = unz;
            // apply column permutations if needed
            var col = q ? q[k] : k;
            // solve triangular system, x = L\A(:,col)
            var top = csSpsolve(L, m, col, xi, x, pinv, 1);
            // find pivot
            var ipiv = -1;
            var a = -1;
            // loop xi[] from top -> n
            for(p = top; p < n; p++){
                // x[i] is nonzero
                i = xi[p];
                // check row i is not yet pivotal
                if (pinv[i] < 0) {
                    // absolute value of x[i]
                    var xabs = abs(x[i]);
                    // check absoulte value is greater than pivot value
                    if (larger(xabs, a)) {
                        // largest pivot candidate so far
                        a = xabs;
                        ipiv = i;
                    }
                } else {
                    // x(i) is the entry U(pinv[i],k)
                    uindex[unz] = pinv[i];
                    uvalues[unz++] = x[i];
                }
            }
            // validate we found a valid pivot
            if (ipiv === -1 || a <= 0) return null;
            // update actual pivot column, give preference to diagonal value
            if (pinv[col] < 0 && largerEq(abs(x[col]), multiply(a, tol))) ipiv = col;
            // the chosen pivot
            var pivot = x[ipiv];
            // last entry in U(:,k) is U(k,k)
            uindex[unz] = k;
            uvalues[unz++] = pivot;
            // ipiv is the kth pivot row
            pinv[ipiv] = k;
            // first entry in L(:,k) is L(k,k) = 1
            lindex[lnz] = ipiv;
            lvalues[lnz++] = 1;
            // L(k+1:n,k) = x / pivot
            for(p = top; p < n; p++){
                // row
                i = xi[p];
                // check x(i) is an entry in L(:,k)
                if (pinv[i] < 0) {
                    // save unpermuted row in L
                    lindex[lnz] = i;
                    // scale pivot column
                    lvalues[lnz++] = divideScalar(x[i], pivot);
                }
                // x[0..n-1] = 0 for next k
                x[i] = 0;
            }
        }
        // update ptr
        lptr[n] = lnz;
        uptr[n] = unz;
        // fix row indices of L for final pinv
        for(p = 0; p < lnz; p++)lindex[p] = pinv[lindex[p]];
        // trim arrays
        lvalues.splice(lnz, lvalues.length - lnz);
        lindex.splice(lnz, lindex.length - lnz);
        uvalues.splice(unz, uvalues.length - unz);
        uindex.splice(unz, uindex.length - unz);
        // return LU factor
        return {
            L: L,
            U: U,
            pinv: pinv
        };
    };
});

});
parcelRegister("eAbgK", function(module, exports) {

$parcel$export(module.exports, "createCsSpsolve", () => $a9dd2b5173659d19$export$517933164557054f);
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source

var $apkHG = parcelRequire("apkHG");

var $dsu7t = parcelRequire("dsu7t");
var $a9dd2b5173659d19$var$name = 'csSpsolve';
var $a9dd2b5173659d19$var$dependencies = [
    'divideScalar',
    'multiply',
    'subtract'
];
var $a9dd2b5173659d19$export$517933164557054f = /* #__PURE__ */ (0, $dsu7t.factory)($a9dd2b5173659d19$var$name, $a9dd2b5173659d19$var$dependencies, (_ref)=>{
    var { divideScalar: divideScalar, multiply: multiply, subtract: subtract } = _ref;
    /**
   * The function csSpsolve() computes the solution to G * x = bk, where bk is the
   * kth column of B. When lo is true, the function assumes G = L is lower triangular with the
   * diagonal entry as the first entry in each column. When lo is true, the function assumes G = U
   * is upper triangular with the diagonal entry as the last entry in each column.
   *
   * @param {Matrix}  g               The G matrix
   * @param {Matrix}  b               The B matrix
   * @param {Number}  k               The kth column in B
   * @param {Array}   xi              The nonzero pattern xi[top] .. xi[n - 1], an array of size = 2 * n
   *                                  The first n entries is the nonzero pattern, the last n entries is the stack
   * @param {Array}   x               The soluton to the linear system G * x = b
   * @param {Array}   pinv            The inverse row permutation vector, must be null for L * x = b
   * @param {boolean} lo              The lower (true) upper triangular (false) flag
   *
   * @return {Number}                 The index for the nonzero pattern
   */ return function csSpsolve(g, b, k, xi, x, pinv, lo) {
        // g arrays
        var gvalues = g._values;
        var gindex = g._index;
        var gptr = g._ptr;
        var gsize = g._size;
        // columns
        var n = gsize[1];
        // b arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        // vars
        var p, p0, p1, q;
        // xi[top..n-1] = csReach(B(:,k))
        var top = (0, $apkHG.csReach)(g, b, k, xi, pinv);
        // clear x
        for(p = top; p < n; p++)x[xi[p]] = 0;
        // scatter b
        for(p0 = bptr[k], p1 = bptr[k + 1], p = p0; p < p1; p++)x[bindex[p]] = bvalues[p];
        // loop columns
        for(var px = top; px < n; px++){
            // x array index for px
            var j = xi[px];
            // apply permutation vector (U x = b), j maps to column J of G
            var J = pinv ? pinv[j] : j;
            // check column J is empty
            if (J < 0) continue;
            // column value indeces in G, p0 <= p < p1
            p0 = gptr[J];
            p1 = gptr[J + 1];
            // x(j) /= G(j,j)
            x[j] = divideScalar(x[j], gvalues[lo ? p0 : p1 - 1]);
            // first entry L(j,j)
            p = lo ? p0 + 1 : p0;
            q = lo ? p1 : p1 - 1;
            // loop
            for(; p < q; p++){
                // row
                var i = gindex[p];
                // x(i) -= G(i,j) * x(j)
                x[i] = subtract(x[i], multiply(gvalues[p], x[j]));
            }
        }
        // return top of stack
        return top;
    };
});

});
parcelRegister("apkHG", function(module, exports) {

$parcel$export(module.exports, "csReach", () => $793c4c7f7d154509$export$125cefbcd149ec98);
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source

var $h51zK = parcelRequire("h51zK");

var $bXwIS = parcelRequire("bXwIS");

var $hw7yi = parcelRequire("hw7yi");
function $793c4c7f7d154509$export$125cefbcd149ec98(g, b, k, xi, pinv) {
    // g arrays
    var gptr = g._ptr;
    var gsize = g._size;
    // b arrays
    var bindex = b._index;
    var bptr = b._ptr;
    // columns
    var n = gsize[1];
    // vars
    var p, p0, p1;
    // initialize top
    var top = n;
    // loop column indeces in B
    for(p0 = bptr[k], p1 = bptr[k + 1], p = p0; p < p1; p++){
        // node i
        var i = bindex[p];
        // check node i is marked
        if (!(0, $h51zK.csMarked)(gptr, i)) // start a dfs at unmarked node i
        top = (0, $hw7yi.csDfs)(i, g, top, xi, pinv);
    }
    // loop columns from top -> n - 1
    for(p = top; p < n; p++)// restore G
    (0, $bXwIS.csMark)(gptr, xi[p]);
    return top;
}

});
parcelRegister("h51zK", function(module, exports) {

$parcel$export(module.exports, "csMarked", () => $c6f420289de1aca7$export$f0d640c1b5bfa3e);
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source
/**
 * Checks if the node at w[j] is marked
 *
 * @param {Array}   w               The array
 * @param {Number}  j               The array index
 */ function $c6f420289de1aca7$export$f0d640c1b5bfa3e(w, j) {
    // check node is marked
    return w[j] < 0;
}

});

parcelRegister("bXwIS", function(module, exports) {

$parcel$export(module.exports, "csMark", () => $8b4e9677de5a9dfd$export$53b20e7656f0b914);
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source

var $ekW7Q = parcelRequire("ekW7Q");
function $8b4e9677de5a9dfd$export$53b20e7656f0b914(w, j) {
    // mark w[j]
    w[j] = (0, $ekW7Q.csFlip)(w[j]);
}

});

parcelRegister("hw7yi", function(module, exports) {

$parcel$export(module.exports, "csDfs", () => $cc0b4881e1403ffe$export$c913fe476af3832b);
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source

var $h51zK = parcelRequire("h51zK");

var $bXwIS = parcelRequire("bXwIS");

var $0afkO = parcelRequire("0afkO");
function $cc0b4881e1403ffe$export$c913fe476af3832b(j, g, top, xi, pinv) {
    // g arrays
    var index = g._index;
    var ptr = g._ptr;
    var size = g._size;
    // columns
    var n = size[1];
    // vars
    var i, p, p2;
    // initialize head
    var head = 0;
    // initialize the recursion stack
    xi[0] = j;
    // loop
    while(head >= 0){
        // get j from the top of the recursion stack
        j = xi[head];
        // apply permutation vector
        var jnew = pinv ? pinv[j] : j;
        // check node j is marked
        if (!(0, $h51zK.csMarked)(ptr, j)) {
            // mark node j as visited
            (0, $bXwIS.csMark)(ptr, j);
            // update stack (last n entries in xi)
            xi[n + head] = jnew < 0 ? 0 : (0, $0afkO.csUnflip)(ptr[jnew]);
        }
        // node j done if no unvisited neighbors
        var done = 1;
        // examine all neighbors of j, stack (last n entries in xi)
        for(p = xi[n + head], p2 = jnew < 0 ? 0 : (0, $0afkO.csUnflip)(ptr[jnew + 1]); p < p2; p++){
            // consider neighbor node i
            i = index[p];
            // check we have visited node i, skip it
            if ((0, $h51zK.csMarked)(ptr, i)) continue;
            // pause depth-first search of node j, update stack (last n entries in xi)
            xi[n + head] = p;
            // start dfs at node i
            xi[++head] = i;
            // node j is not done
            done = 0;
            break;
        }
        // check depth-first search at node j is done
        if (done) {
            // remove j from the recursion stack
            head--;
            // and place in the output stack
            xi[--top] = j;
        }
    }
    return top;
}

});
parcelRegister("0afkO", function(module, exports) {

$parcel$export(module.exports, "csUnflip", () => $0007f2e908d4e87a$export$8b1bf205e2e76d92);
// Copyright (c) 2006-2024, Timothy A. Davis, All Rights Reserved.
// SPDX-License-Identifier: LGPL-2.1+
// https://github.com/DrTimothyAldenDavis/SuiteSparse/tree/dev/CSparse/Source

var $ekW7Q = parcelRequire("ekW7Q");
function $0007f2e908d4e87a$export$8b1bf205e2e76d92(i) {
    // flip the value if it is negative
    return i < 0 ? (0, $ekW7Q.csFlip)(i) : i;
}

});






parcelRegister("6bhZk", function(module, exports) {

$parcel$export(module.exports, "createSmaller", () => $4801b93a5565298b$export$6b477d90b957f03e);

var $i7dfO = parcelRequire("i7dfO");

var $6NnhX = parcelRequire("6NnhX");

var $dsu7t = parcelRequire("dsu7t");

var $a8bto = parcelRequire("a8bto");

var $6RFQP = parcelRequire("6RFQP");

var $19L2p = parcelRequire("19L2p");

var $6SJnV = parcelRequire("6SJnV");

var $33RBM = parcelRequire("33RBM");
var $4801b93a5565298b$var$name = 'smaller';
var $4801b93a5565298b$var$dependencies = [
    'typed',
    'config',
    'bignumber',
    'matrix',
    'DenseMatrix',
    'concat',
    'SparseMatrix'
];
var $4801b93a5565298b$export$6b477d90b957f03e = /* #__PURE__ */ (0, $dsu7t.factory)($4801b93a5565298b$var$name, $4801b93a5565298b$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, bignumber: bignumber, matrix: matrix, DenseMatrix: DenseMatrix, concat: concat, SparseMatrix: SparseMatrix } = _ref;
    var matAlgo03xDSf = (0, $a8bto.createMatAlgo03xDSf)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $6RFQP.createMatAlgo07xSSf)({
        typed: typed,
        SparseMatrix: SparseMatrix
    });
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var compareUnits = (0, $33RBM.createCompareUnits)({
        typed: typed
    });
    /**
   * Test whether value x is smaller than y.
   *
   * The function returns true when x is smaller than y and the relative
   * difference between x and y is smaller than the configured relTol and absTol. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.smaller(x, y)
   *
   * Examples:
   *
   *    math.smaller(2, 3)            // returns true
   *    math.smaller(5, 2 * 2)        // returns false
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('2 inch')
   *    math.smaller(a, b)            // returns true
   *
   * See also:
   *
   *    equal, unequal, smallerEq, smaller, smallerEq, compare
   *
   * @param  {number | BigNumber | bigint | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | bigint | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
   */ function bignumSmaller(x, y) {
        return x.lt(y) && !(0, $i7dfO.nearlyEqual)(x, y, config.relTol, config.absTol);
    }
    return typed($4801b93a5565298b$var$name, $4801b93a5565298b$export$4f82e7db4d803209({
        typed: typed,
        config: config
    }), {
        'boolean, boolean': (x, y)=>x < y,
        'BigNumber, BigNumber': bignumSmaller,
        'bigint, bigint': (x, y)=>x < y,
        'Fraction, Fraction': (x, y)=>x.compare(y) === -1,
        'Fraction, BigNumber': function Fraction_BigNumber(x, y) {
            return bignumSmaller(bignumber(x), y);
        },
        'BigNumber, Fraction': function BigNumber_Fraction(x, y) {
            return bignumSmaller(x, bignumber(y));
        },
        'Complex, Complex': function Complex_Complex(x, y) {
            throw new TypeError('No ordering relation is defined for complex numbers');
        }
    }, compareUnits, matrixAlgorithmSuite({
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
});
var $4801b93a5565298b$export$4f82e7db4d803209 = /* #__PURE__ */ (0, $dsu7t.factory)($4801b93a5565298b$var$name, [
    'typed',
    'config'
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($4801b93a5565298b$var$name, {
        'number, number': function number_number(x, y) {
            return x < y && !(0, $6NnhX.nearlyEqual)(x, y, config.relTol, config.absTol);
        }
    });
});

});

parcelRegister("dxgXU", function(module, exports) {

$parcel$export(module.exports, "createSmallerEq", () => $9dab84639df2ee66$export$e1b2fff975be9083);

var $i7dfO = parcelRequire("i7dfO");

var $6NnhX = parcelRequire("6NnhX");

var $dsu7t = parcelRequire("dsu7t");

var $a8bto = parcelRequire("a8bto");

var $6RFQP = parcelRequire("6RFQP");

var $19L2p = parcelRequire("19L2p");

var $6SJnV = parcelRequire("6SJnV");

var $33RBM = parcelRequire("33RBM");
var $9dab84639df2ee66$var$name = 'smallerEq';
var $9dab84639df2ee66$var$dependencies = [
    'typed',
    'config',
    'matrix',
    'DenseMatrix',
    'concat',
    'SparseMatrix'
];
var $9dab84639df2ee66$export$e1b2fff975be9083 = /* #__PURE__ */ (0, $dsu7t.factory)($9dab84639df2ee66$var$name, $9dab84639df2ee66$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, DenseMatrix: DenseMatrix, concat: concat, SparseMatrix: SparseMatrix } = _ref;
    var matAlgo03xDSf = (0, $a8bto.createMatAlgo03xDSf)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $6RFQP.createMatAlgo07xSSf)({
        typed: typed,
        SparseMatrix: SparseMatrix
    });
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    var compareUnits = (0, $33RBM.createCompareUnits)({
        typed: typed
    });
    /**
   * Test whether value x is smaller or equal to y.
   *
   * The function returns true when x is smaller than y or the relative
   * difference between x and y is smaller than the configured relTol and absTol. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.smallerEq(x, y)
   *
   * Examples:
   *
   *    math.smaller(1 + 2, 3)        // returns false
   *    math.smallerEq(1 + 2, 3)      // returns true
   *
   * See also:
   *
   *    equal, unequal, smaller, larger, largerEq, compare
   *
   * @param  {number | BigNumber | bigint | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | bigint | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
   */ return typed($9dab84639df2ee66$var$name, $9dab84639df2ee66$export$78c24428429985da({
        typed: typed,
        config: config
    }), {
        'boolean, boolean': (x, y)=>x <= y,
        'BigNumber, BigNumber': function BigNumber_BigNumber(x, y) {
            return x.lte(y) || (0, $i7dfO.nearlyEqual)(x, y, config.relTol, config.absTol);
        },
        'bigint, bigint': (x, y)=>x <= y,
        'Fraction, Fraction': (x, y)=>x.compare(y) !== 1,
        'Complex, Complex': function Complex_Complex() {
            throw new TypeError('No ordering relation is defined for complex numbers');
        }
    }, compareUnits, matrixAlgorithmSuite({
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
});
var $9dab84639df2ee66$export$78c24428429985da = /* #__PURE__ */ (0, $dsu7t.factory)($9dab84639df2ee66$var$name, [
    'typed',
    'config'
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($9dab84639df2ee66$var$name, {
        'number, number': function number_number(x, y) {
            return x <= y || (0, $6NnhX.nearlyEqual)(x, y, config.relTol, config.absTol);
        }
    });
});

});

parcelRegister("ioEKX", function(module, exports) {

$parcel$export(module.exports, "createSolveODE", () => $d64a153b1607204e$export$73f8b9bd532fee8);

var $g5Zhu = parcelRequire("g5Zhu");

var $edQYF = parcelRequire("edQYF");

var $dsu7t = parcelRequire("dsu7t");
function $d64a153b1607204e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d64a153b1607204e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d64a153b1607204e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d64a153b1607204e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d64a153b1607204e$var$name = 'solveODE';
var $d64a153b1607204e$var$dependencies = [
    'typed',
    'add',
    'subtract',
    'multiply',
    'divide',
    'max',
    'map',
    'abs',
    'isPositive',
    'isNegative',
    'larger',
    'smaller',
    'matrix',
    'bignumber',
    'unaryMinus'
];
var $d64a153b1607204e$export$73f8b9bd532fee8 = /* #__PURE__ */ (0, $dsu7t.factory)($d64a153b1607204e$var$name, $d64a153b1607204e$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, subtract: subtract, multiply: multiply, divide: divide, max: max, map: map, abs: abs, isPositive: isPositive, isNegative: isNegative, larger: larger, smaller: smaller, matrix: matrix, bignumber: bignumber, unaryMinus: unaryMinus } = _ref;
    /**
     * Numerical Integration of Ordinary Differential Equations
     *
     * Two variable step methods are provided:
     * - "RK23": Bogacki–Shampine method
     * - "RK45": Dormand-Prince method RK5(4)7M (default)
     *
     * The arguments are expected as follows.
     *
     * - `func` should be the forcing function `f(t, y)`
     * - `tspan` should be a vector of two numbers or units `[tStart, tEnd]`
     * - `y0` the initial state values, should be a scalar or a flat array
     * - `options` should be an object with the following information:
     *   - `method` ('RK45'): ['RK23', 'RK45']
     *   - `tol` (1e-3): Numeric tolerance of the method, the solver keeps the error estimates less than this value
     *   - `firstStep`: Initial step size
     *   - `minStep`: minimum step size of the method
     *   - `maxStep`: maximum step size of the method
     *   - `minDelta` (0.2): minimum ratio of change for the step
     *   - `maxDelta` (5): maximum ratio of change for the step
     *   - `maxIter` (1e4): maximum number of iterations
     *
     * The returned value is an object with `{t, y}` please note that even though `t` means time, it can represent any other independant variable like `x`:
     * - `t` an array of size `[n]`
     * - `y` the states array can be in two ways
     *   - **if `y0` is a scalar:** returns an array-like of size `[n]`
     *   - **if `y0` is a flat array-like of size [m]:** returns an array like of size `[n, m]`
     *
     * Syntax:
     *
     *     math.solveODE(func, tspan, y0)
     *     math.solveODE(func, tspan, y0, options)
     *
     * Examples:
     *
     *     function func(t, y) {return y}
     *     const tspan = [0, 4]
     *     const y0 = 1
     *     math.solveODE(func, tspan, y0)
     *     math.solveODE(func, tspan, [1, 2])
     *     math.solveODE(func, tspan, y0, { method:"RK23", maxStep:0.1 })
     *
     * See also:
     *
     *     derivative, simplifyCore
     *
     * @param {function} func The forcing function f(t,y)
     * @param {Array | Matrix} tspan The time span
     * @param {number | BigNumber | Unit | Array | Matrix} y0 The initial value
     * @param {Object} [options] Optional configuration options
     * @return {Object} Return an object with t and y values as arrays
     */ function _rk(butcherTableau) {
        // generates an adaptive runge kutta method from it's butcher tableau
        return function(f, tspan, y0, options) {
            // adaptive runge kutta methods
            var wrongTSpan = !(tspan.length === 2 && (tspan.every(isNumOrBig) || tspan.every((0, $edQYF.isUnit))));
            if (wrongTSpan) throw new Error('"tspan" must be an Array of two numeric values or two units [tStart, tEnd]');
            var t0 = tspan[0]; // initial time
            var tf = tspan[1]; // final time
            var isForwards = larger(tf, t0);
            var firstStep = options.firstStep;
            if (firstStep !== undefined && !isPositive(firstStep)) throw new Error('"firstStep" must be positive');
            var maxStep = options.maxStep;
            if (maxStep !== undefined && !isPositive(maxStep)) throw new Error('"maxStep" must be positive');
            var minStep = options.minStep;
            if (minStep && isNegative(minStep)) throw new Error('"minStep" must be positive or zero');
            var timeVars = [
                t0,
                tf,
                firstStep,
                minStep,
                maxStep
            ].filter((x)=>x !== undefined);
            if (!(timeVars.every(isNumOrBig) || timeVars.every((0, $edQYF.isUnit)))) throw new Error('Inconsistent type of "t" dependant variables');
            var steps = 1; // divide time in this number of steps
            var tol = options.tol ? options.tol : 1e-4; // define a tolerance (must be an option)
            var minDelta = options.minDelta ? options.minDelta : 0.2;
            var maxDelta = options.maxDelta ? options.maxDelta : 5;
            var maxIter = options.maxIter ? options.maxIter : 10000; // stop inifite evaluation if something goes wrong
            var hasBigNumbers = [
                t0,
                tf,
                ...y0,
                maxStep,
                minStep
            ].some((0, $edQYF.isBigNumber));
            var [a, c, b, bp] = hasBigNumbers ? [
                bignumber(butcherTableau.a),
                bignumber(butcherTableau.c),
                bignumber(butcherTableau.b),
                bignumber(butcherTableau.bp)
            ] : [
                butcherTableau.a,
                butcherTableau.c,
                butcherTableau.b,
                butcherTableau.bp
            ];
            var h = firstStep ? isForwards ? firstStep : unaryMinus(firstStep) : divide(subtract(tf, t0), steps); // define the first step size
            var t = [
                t0
            ]; // start the time array
            var y = [
                y0
            ]; // start the solution array
            var deltaB = subtract(b, bp); // b - bp
            var n = 0;
            var iter = 0;
            var ongoing = _createOngoing(isForwards);
            var trimStep = _createTrimStep(isForwards);
            // iterate unitil it reaches either the final time or maximum iterations
            while(ongoing(t[n], tf)){
                var k = [];
                // trim the time step so that it doesn't overshoot
                h = trimStep(t[n], tf, h);
                // calculate the first value of k
                k.push(f(t[n], y[n]));
                // calculate the rest of the values of k
                for(var i = 1; i < c.length; ++i)k.push(f(add(t[n], multiply(c[i], h)), add(y[n], multiply(h, a[i], k))));
                // estimate the error by comparing solutions of different orders
                var TE = max(abs(map(multiply(deltaB, k), (X)=>(0, $edQYF.isUnit)(X) ? X.value : X)));
                if (TE < tol && tol / TE > 1 / 4) {
                    // push solution if within tol
                    t.push(add(t[n], h));
                    y.push(add(y[n], multiply(h, b, k)));
                    n++;
                }
                // estimate the delta value that will affect the step size
                var delta = 0.84 * (tol / TE) ** 0.2;
                if (smaller(delta, minDelta)) delta = minDelta;
                else if (larger(delta, maxDelta)) delta = maxDelta;
                delta = hasBigNumbers ? bignumber(delta) : delta;
                h = multiply(h, delta);
                if (maxStep && larger(abs(h), maxStep)) h = isForwards ? maxStep : unaryMinus(maxStep);
                else if (minStep && smaller(abs(h), minStep)) h = isForwards ? minStep : unaryMinus(minStep);
                iter++;
                if (iter > maxIter) throw new Error('Maximum number of iterations reached, try changing options');
            }
            return {
                t: t,
                y: y
            };
        };
    }
    function _rk23(f, tspan, y0, options) {
        // Bogacki–Shampine method
        // Define the butcher table
        var a = [
            [],
            [
                0.5
            ],
            [
                0,
                3 / 4
            ],
            [
                2 / 9,
                1 / 3,
                4 / 9
            ]
        ];
        var c = [
            null,
            0.5,
            3 / 4,
            1
        ];
        var b = [
            2 / 9,
            1 / 3,
            4 / 9,
            0
        ];
        var bp = [
            7 / 24,
            1 / 4,
            1 / 3,
            1 / 8
        ];
        var butcherTableau = {
            a: a,
            c: c,
            b: b,
            bp: bp
        };
        // Solve an adaptive step size rk method
        return _rk(butcherTableau)(f, tspan, y0, options);
    }
    function _rk45(f, tspan, y0, options) {
        // Dormand Prince method
        // Define the butcher tableau
        var a = [
            [],
            [
                0.2
            ],
            [
                3 / 40,
                9 / 40
            ],
            [
                44 / 45,
                -56 / 15,
                32 / 9
            ],
            [
                19372 / 6561,
                -25360 / 2187,
                64448 / 6561,
                -212 / 729
            ],
            [
                9017 / 3168,
                -355 / 33,
                46732 / 5247,
                49 / 176,
                -5103 / 18656
            ],
            [
                35 / 384,
                0,
                500 / 1113,
                125 / 192,
                -2187 / 6784,
                11 / 84
            ]
        ];
        var c = [
            null,
            0.2,
            0.3,
            0.8,
            8 / 9,
            1,
            1
        ];
        var b = [
            35 / 384,
            0,
            500 / 1113,
            125 / 192,
            -2187 / 6784,
            11 / 84,
            0
        ];
        var bp = [
            5179 / 57600,
            0,
            7571 / 16695,
            393 / 640,
            -92097 / 339200,
            187 / 2100,
            1 / 40
        ];
        var butcherTableau = {
            a: a,
            c: c,
            b: b,
            bp: bp
        };
        // Solve an adaptive step size rk method
        return _rk(butcherTableau)(f, tspan, y0, options);
    }
    function _solveODE(f, tspan, y0, opt) {
        var method = opt.method ? opt.method : 'RK45';
        var methods = {
            RK23: _rk23,
            RK45: _rk45
        };
        if (method.toUpperCase() in methods) {
            var methodOptions = $d64a153b1607204e$var$_objectSpread({}, opt); // clone the options object
            delete methodOptions.method; // delete the method as it won't be needed
            return methods[method.toUpperCase()](f, tspan, y0, methodOptions);
        } else {
            // throw an error indicating there is no such method
            var methodsWithQuotes = Object.keys(methods).map((x)=>"\"".concat(x, "\""));
            // generates a string of methods like: "BDF", "RK23" and "RK45"
            var availableMethodsString = "".concat(methodsWithQuotes.slice(0, -1).join(', '), " and ").concat(methodsWithQuotes.slice(-1));
            throw new Error("Unavailable method \"".concat(method, "\". Available methods are ").concat(availableMethodsString));
        }
    }
    function _createOngoing(isForwards) {
        // returns the correct function to test if it's still iterating
        return isForwards ? smaller : larger;
    }
    function _createTrimStep(isForwards) {
        var outOfBounds = isForwards ? larger : smaller;
        return function(t, tf, h) {
            var next = add(t, h);
            return outOfBounds(next, tf) ? subtract(tf, t) : h;
        };
    }
    function isNumOrBig(x) {
        // checks if it's a number or bignumber
        return (0, $edQYF.isBigNumber)(x) || (0, $edQYF.isNumber)(x);
    }
    function _matrixSolveODE(f, T, y0, options) {
        // receives matrices and returns matrices
        var sol = _solveODE(f, T.toArray(), y0.toArray(), options);
        return {
            t: matrix(sol.t),
            y: matrix(sol.y)
        };
    }
    return typed('solveODE', {
        'function, Array, Array, Object': _solveODE,
        'function, Matrix, Matrix, Object': _matrixSolveODE,
        'function, Array, Array': (f, T, y0)=>_solveODE(f, T, y0, {}),
        'function, Matrix, Matrix': (f, T, y0)=>_matrixSolveODE(f, T, y0, {}),
        'function, Array, number | BigNumber | Unit': (f, T, y0)=>{
            var sol = _solveODE(f, T, [
                y0
            ], {});
            return {
                t: sol.t,
                y: sol.y.map((Y)=>Y[0])
            };
        },
        'function, Matrix, number | BigNumber | Unit': (f, T, y0)=>{
            var sol = _solveODE(f, T.toArray(), [
                y0
            ], {});
            return {
                t: matrix(sol.t),
                y: matrix(sol.y.map((Y)=>Y[0]))
            };
        },
        'function, Array, number | BigNumber | Unit, Object': (f, T, y0, options)=>{
            var sol = _solveODE(f, T, [
                y0
            ], options);
            return {
                t: sol.t,
                y: sol.y.map((Y)=>Y[0])
            };
        },
        'function, Matrix, number | BigNumber | Unit, Object': (f, T, y0, options)=>{
            var sol = _solveODE(f, T.toArray(), [
                y0
            ], options);
            return {
                t: matrix(sol.t),
                y: matrix(sol.y.map((Y)=>Y[0]))
            };
        }
    });
});

});
parcelRegister("g5Zhu", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $bb7ca61ce45563c4$var$_defineProperty(e, r, t) {
    return (r = $5DKOa(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $bb7ca61ce45563c4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("cJr7t", function(module, exports) {

$parcel$export(module.exports, "createSort", () => $944eb95fdfacbd41$export$10463693a2093403);

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $944eb95fdfacbd41$var$name = 'sort';
var $944eb95fdfacbd41$var$dependencies = [
    'typed',
    'matrix',
    'compare',
    'compareNatural'
];
var $944eb95fdfacbd41$export$10463693a2093403 = /* #__PURE__ */ (0, $dsu7t.factory)($944eb95fdfacbd41$var$name, $944eb95fdfacbd41$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, compare: compare, compareNatural: compareNatural } = _ref;
    var compareAsc = compare;
    var compareDesc = (a, b)=>-compare(a, b);
    /**
   * Sort the items in a matrix.
   *
   * Syntax:
   *
   *    math.sort(x)
   *    math.sort(x, compare)
   *
   * Examples:
   *
   *    math.sort([5, 10, 1]) // returns [1, 5, 10]
   *    math.sort(['C', 'B', 'A', 'D'], math.compareNatural)
   *    // returns ['A', 'B', 'C', 'D']
   *
   *    function sortByLength (a, b) {
   *      return a.length - b.length
   *    }
   *    math.sort(['Langdon', 'Tom', 'Sara'], sortByLength)
   *    // returns ['Tom', 'Sara', 'Langdon']
   *
   * See also:
   *
   *    filter, forEach, map, compare, compareNatural
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to sort
   * @param {Function | 'asc' | 'desc' | 'natural'} [compare='asc']
   *        An optional _comparator function or name. The function is called as
   *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
   *        and 0 when a == b.
   * @return {Matrix | Array} Returns the sorted matrix.
   */ return typed($944eb95fdfacbd41$var$name, {
        Array: function Array(x) {
            _arrayIsVector(x);
            return x.sort(compareAsc);
        },
        Matrix: function Matrix(x) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(compareAsc), x.storage());
        },
        'Array, function': function Array_function(x, _comparator) {
            _arrayIsVector(x);
            return x.sort(_comparator);
        },
        'Matrix, function': function Matrix_function(x, _comparator) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(_comparator), x.storage());
        },
        'Array, string': function Array_string(x, order) {
            _arrayIsVector(x);
            return x.sort(_comparator(order));
        },
        'Matrix, string': function Matrix_string(x, order) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(_comparator(order)), x.storage());
        }
    });
    /**
   * Get the comparator for given order ('asc', 'desc', 'natural')
   * @param {'asc' | 'desc' | 'natural'} order
   * @return {Function} Returns a _comparator function
   */ function _comparator(order) {
        if (order === 'asc') return compareAsc;
        else if (order === 'desc') return compareDesc;
        else if (order === 'natural') return compareNatural;
        else throw new Error('String "asc", "desc", or "natural" expected');
    }
    /**
   * Validate whether an array is one dimensional
   * Throws an error when this is not the case
   * @param {Array} array
   * @private
   */ function _arrayIsVector(array) {
        if ((0, $d80Xp.arraySize)(array).length !== 1) throw new Error('One dimensional array expected');
    }
    /**
   * Validate whether a matrix is one dimensional
   * Throws an error when this is not the case
   * @param {Matrix} matrix
   * @private
   */ function _matrixIsVector(matrix) {
        if (matrix.size().length !== 1) throw new Error('One dimensional matrix expected');
    }
});

});

parcelRegister("g9W86", function(module, exports) {

$parcel$export(module.exports, "createSpaClass", () => $bc3a93f19abbc370$export$5e37e847685a0540);

var $dsu7t = parcelRequire("dsu7t");
var $bc3a93f19abbc370$var$name = 'Spa';
var $bc3a93f19abbc370$var$dependencies = [
    'addScalar',
    'equalScalar',
    'FibonacciHeap'
];
var $bc3a93f19abbc370$export$5e37e847685a0540 = /* #__PURE__ */ (0, $dsu7t.factory)($bc3a93f19abbc370$var$name, $bc3a93f19abbc370$var$dependencies, (_ref)=>{
    var { addScalar: addScalar, equalScalar: equalScalar, FibonacciHeap: FibonacciHeap } = _ref;
    /**
   * An ordered Sparse Accumulator is a representation for a sparse vector that includes a dense array
   * of the vector elements and an ordered list of non-zero elements.
   */ function Spa() {
        if (!(this instanceof Spa)) throw new SyntaxError('Constructor must be called with the new operator');
        // allocate vector, TODO use typed arrays
        this._values = [];
        this._heap = new FibonacciHeap();
    }
    /**
   * Attach type information
   */ Spa.prototype.type = 'Spa';
    Spa.prototype.isSpa = true;
    /**
   * Set the value for index i.
   *
   * @param {number} i                       The index
   * @param {number | BigNumber | Complex}   The value at index i
   */ Spa.prototype.set = function(i, v) {
        // check we have a value @ i
        if (!this._values[i]) {
            // insert in heap
            var node = this._heap.insert(i, v);
            // set the value @ i
            this._values[i] = node;
        } else // update the value @ i
        this._values[i].value = v;
    };
    Spa.prototype.get = function(i) {
        var node = this._values[i];
        if (node) return node.value;
        return 0;
    };
    Spa.prototype.accumulate = function(i, v) {
        // node @ i
        var node = this._values[i];
        if (!node) {
            // insert in heap
            node = this._heap.insert(i, v);
            // initialize value
            this._values[i] = node;
        } else // accumulate value
        node.value = addScalar(node.value, v);
    };
    Spa.prototype.forEach = function(from, to, callback) {
        // references
        var heap = this._heap;
        var values = this._values;
        // nodes
        var nodes = [];
        // node with minimum key, save it
        var node = heap.extractMinimum();
        if (node) nodes.push(node);
        // extract nodes from heap (ordered)
        while(node && node.key <= to){
            // check it is in range
            if (node.key >= from) // check value is not zero
            {
                if (!equalScalar(node.value, 0)) // invoke callback
                callback(node.key, node.value, this);
            }
            // extract next node, save it
            node = heap.extractMinimum();
            if (node) nodes.push(node);
        }
        // reinsert all nodes in heap
        for(var i = 0; i < nodes.length; i++){
            // current node
            var n = nodes[i];
            // insert node in heap
            node = heap.insert(n.key, n.value);
            // update values
            values[node.key] = node;
        }
    };
    Spa.prototype.swap = function(i, j) {
        // node @ i and j
        var nodei = this._values[i];
        var nodej = this._values[j];
        // check we need to insert indeces
        if (!nodei && nodej) {
            // insert in heap
            nodei = this._heap.insert(i, nodej.value);
            // remove from heap
            this._heap.remove(nodej);
            // set values
            this._values[i] = nodei;
            this._values[j] = undefined;
        } else if (nodei && !nodej) {
            // insert in heap
            nodej = this._heap.insert(j, nodei.value);
            // remove from heap
            this._heap.remove(nodei);
            // set values
            this._values[j] = nodej;
            this._values[i] = undefined;
        } else if (nodei && nodej) {
            // swap values
            var v = nodei.value;
            nodei.value = nodej.value;
            nodej.value = v;
        }
    };
    return Spa;
}, {
    isClass: true
});

});

parcelRegister("3Nmmf", function(module, exports) {

$parcel$export(module.exports, "createSparse", () => $2c374a7d8247f82d$export$89ff03fdb3964a99);

var $dsu7t = parcelRequire("dsu7t");
var $2c374a7d8247f82d$var$name = 'sparse';
var $2c374a7d8247f82d$var$dependencies = [
    'typed',
    'SparseMatrix'
];
var $2c374a7d8247f82d$export$89ff03fdb3964a99 = /* #__PURE__ */ (0, $dsu7t.factory)($2c374a7d8247f82d$var$name, $2c374a7d8247f82d$var$dependencies, (_ref)=>{
    var { typed: typed, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a Sparse Matrix. The function creates a new `math.Matrix` object from
   * an `Array`. A Matrix has utility functions to manipulate the data in the
   * matrix, like getting the size and getting or setting values in the matrix.
   * Note that a Sparse Matrix is always 2-dimensional, so for example if
   * you create one from a plain array of _n_ numbers, you get an _n_ by 1
   * Sparse "column vector".
   *
   * Syntax:
   *
   *    math.sparse()               // creates an empty sparse matrix.
   *    math.sparse(data)           // creates a sparse matrix with initial data.
   *    math.sparse(data, 'number') // creates a sparse matrix with initial data, number datatype.
   *
   * Examples:
   *
   *    let m = math.sparse([[1, 2], [3, 4]])
   *    m.size()                        // Array [2, 2]
   *    m.resize([3, 2], 5)
   *    m.valueOf()                     // Array [[1, 2], [3, 4], [5, 5]]
   *    m.get([1, 0])                    // number 3
   *    let v = math.sparse([0, 0, 1])
   *    v.size()                        // Array [3, 1]
   *    v.get([2, 0])                   // number 1
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, number, string, unit, matrix
   *
   * @param {Array | Matrix} [data]    A two dimensional array
   *
   * @return {Matrix} The created matrix
   */ return typed($2c374a7d8247f82d$var$name, {
        '': function _() {
            return new SparseMatrix([]);
        },
        string: function string(datatype) {
            return new SparseMatrix([], datatype);
        },
        'Array | Matrix': function Array__Matrix(data) {
            return new SparseMatrix(data);
        },
        'Array | Matrix, string': function Array__Matrix_string(data, datatype) {
            return new SparseMatrix(data, datatype);
        }
    });
});

});

parcelRegister("cwciU", function(module, exports) {

$parcel$export(module.exports, "createSparseMatrixClass", () => $91d2047e526cb442$export$a783ce8f6a98b2e5);

var $edQYF = parcelRequire("edQYF");

var $6NnhX = parcelRequire("6NnhX");

var $j2hDb = parcelRequire("j2hDb");

var $9v8q6 = parcelRequire("9v8q6");

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");

var $7asMt = parcelRequire("7asMt");

var $bLcpf = parcelRequire("bLcpf");
var $91d2047e526cb442$var$name = 'SparseMatrix';
var $91d2047e526cb442$var$dependencies = [
    'typed',
    'equalScalar',
    'Matrix'
];
var $91d2047e526cb442$export$a783ce8f6a98b2e5 = /* #__PURE__ */ (0, $dsu7t.factory)($91d2047e526cb442$var$name, $91d2047e526cb442$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar, Matrix: Matrix } = _ref;
    /**
   * Sparse Matrix implementation. This type implements
   * a [Compressed Column Storage](https://en.wikipedia.org/wiki/Sparse_matrix#Compressed_sparse_column_(CSC_or_CCS))
   * format for two-dimensional sparse matrices.
   * @class SparseMatrix
   */ function SparseMatrix(data, datatype) {
        if (!(this instanceof SparseMatrix)) throw new SyntaxError('Constructor must be called with the new operator');
        if (datatype && !(0, $edQYF.isString)(datatype)) throw new Error('Invalid datatype: ' + datatype);
        if ((0, $edQYF.isMatrix)(data)) // create from matrix
        _createFromMatrix(this, data, datatype);
        else if (data && (0, $edQYF.isArray)(data.index) && (0, $edQYF.isArray)(data.ptr) && (0, $edQYF.isArray)(data.size)) {
            // initialize fields
            this._values = data.values;
            this._index = data.index;
            this._ptr = data.ptr;
            this._size = data.size;
            this._datatype = datatype || data.datatype;
        } else if ((0, $edQYF.isArray)(data)) // create from array
        _createFromArray(this, data, datatype);
        else if (data) // unsupported type
        throw new TypeError('Unsupported type of data (' + (0, $edQYF.typeOf)(data) + ')');
        else {
            // nothing provided
            this._values = [];
            this._index = [];
            this._ptr = [
                0
            ];
            this._size = [
                0,
                0
            ];
            this._datatype = datatype;
        }
    }
    function _createFromMatrix(matrix, source, datatype) {
        // check matrix type
        if (source.type === 'SparseMatrix') {
            // clone arrays
            matrix._values = source._values ? (0, $9v8q6.clone)(source._values) : undefined;
            matrix._index = (0, $9v8q6.clone)(source._index);
            matrix._ptr = (0, $9v8q6.clone)(source._ptr);
            matrix._size = (0, $9v8q6.clone)(source._size);
            matrix._datatype = datatype || source._datatype;
        } else // build from matrix data
        _createFromArray(matrix, source.valueOf(), datatype || source._datatype);
    }
    function _createFromArray(matrix, data, datatype) {
        // initialize fields
        matrix._values = [];
        matrix._index = [];
        matrix._ptr = [];
        matrix._datatype = datatype;
        // discover rows & columns, do not use math.size() to avoid looping array twice
        var rows = data.length;
        var columns = 0;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        if ((0, $edQYF.isString)(datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                datatype,
                datatype
            ]) || equalScalar;
            // convert 0 to the same datatype
            zero = typed.convert(0, datatype);
        }
        // check we have rows (empty array)
        if (rows > 0) {
            // column index
            var j = 0;
            do {
                // store pointer to values index
                matrix._ptr.push(matrix._index.length);
                // loop rows
                for(var i = 0; i < rows; i++){
                    // current row
                    var row = data[i];
                    // check row is an array
                    if ((0, $edQYF.isArray)(row)) {
                        // update columns if needed (only on first column)
                        if (j === 0 && columns < row.length) columns = row.length;
                        // check row has column
                        if (j < row.length) {
                            // value
                            var v = row[j];
                            // check value != 0
                            if (!eq(v, zero)) {
                                // store value
                                matrix._values.push(v);
                                // index
                                matrix._index.push(i);
                            }
                        }
                    } else {
                        // update columns if needed (only on first column)
                        if (j === 0 && columns < 1) columns = 1;
                        // check value != 0 (row is a scalar)
                        if (!eq(row, zero)) {
                            // store value
                            matrix._values.push(row);
                            // index
                            matrix._index.push(i);
                        }
                    }
                }
                // increment index
                j++;
            }while (j < columns);
        }
        // store number of values in ptr
        matrix._ptr.push(matrix._index.length);
        // size
        matrix._size = [
            rows,
            columns
        ];
    }
    SparseMatrix.prototype = new Matrix();
    /**
   * Create a new SparseMatrix
   */ SparseMatrix.prototype.createSparseMatrix = function(data, datatype) {
        return new SparseMatrix(data, datatype);
    };
    /**
   * Attach type information
   */ Object.defineProperty(SparseMatrix, 'name', {
        value: 'SparseMatrix'
    });
    SparseMatrix.prototype.constructor = SparseMatrix;
    SparseMatrix.prototype.type = 'SparseMatrix';
    SparseMatrix.prototype.isSparseMatrix = true;
    /**
   * Get the matrix type
   *
   * Usage:
   *    const matrixType = matrix.getDataType()  // retrieves the matrix type
   *
   * @memberOf SparseMatrix
   * @return {string}   type information; if multiple types are found from the Matrix, it will return "mixed"
   */ SparseMatrix.prototype.getDataType = function() {
        return (0, $d80Xp.getArrayDataType)(this._values, (0, $edQYF.typeOf));
    };
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()   // retrieve storage format
   *
   * @memberof SparseMatrix
   * @return {string}           The storage format.
   */ SparseMatrix.prototype.storage = function() {
        return 'sparse';
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()    // retrieve matrix datatype
   *
   * @memberof SparseMatrix
   * @return {string}           The datatype.
   */ SparseMatrix.prototype.datatype = function() {
        return this._datatype;
    };
    /**
   * Create a new SparseMatrix
   * @memberof SparseMatrix
   * @param {Array} data
   * @param {string} [datatype]
   */ SparseMatrix.prototype.create = function(data, datatype) {
        return new SparseMatrix(data, datatype);
    };
    /**
   * Get the matrix density.
   *
   * Usage:
   *     const density = matrix.density()                   // retrieve matrix density
   *
   * @memberof SparseMatrix
   * @return {number}           The matrix density.
   */ SparseMatrix.prototype.density = function() {
        // rows & columns
        var rows = this._size[0];
        var columns = this._size[1];
        // calculate density
        return rows !== 0 && columns !== 0 ? this._index.length / (rows * columns) : 0;
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @memberof SparseMatrix
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ SparseMatrix.prototype.subset = function(index, replacement, defaultValue) {
        // check it is a pattern matrix
        if (!this._values) throw new Error('Cannot invoke subset on a Pattern only matrix');
        // check arguments
        switch(arguments.length){
            case 1:
                return _getsubset(this, index);
            // intentional fall through
            case 2:
            case 3:
                return _setsubset(this, index, replacement, defaultValue);
            default:
                throw new SyntaxError('Wrong number of arguments');
        }
    };
    function _getsubset(matrix, idx) {
        // check idx
        if (!(0, $edQYF.isIndex)(idx)) throw new TypeError('Invalid index');
        var isScalar = idx.isScalar();
        if (isScalar) // return a scalar
        return matrix.get(idx.min());
        // validate dimensions
        var size = idx.size();
        if (size.length !== matrix._size.length) throw new (0, $7asMt.DimensionError)(size.length, matrix._size.length);
        // vars
        var i, ii, k, kk;
        // validate if any of the ranges in the index is out of range
        var min = idx.min();
        var max = idx.max();
        for(i = 0, ii = matrix._size.length; i < ii; i++){
            (0, $d80Xp.validateIndex)(min[i], matrix._size[i]);
            (0, $d80Xp.validateIndex)(max[i], matrix._size[i]);
        }
        // matrix arrays
        var mvalues = matrix._values;
        var mindex = matrix._index;
        var mptr = matrix._ptr;
        // rows & columns dimensions for result matrix
        var rows = idx.dimension(0);
        var columns = idx.dimension(1);
        // workspace & permutation vector
        var w = [];
        var pv = [];
        // loop rows in resulting matrix
        rows.forEach(function(i, r) {
            // update permutation vector
            pv[i] = r[0];
            // mark i in workspace
            w[i] = true;
        });
        // result matrix arrays
        var values = mvalues ? [] : undefined;
        var index = [];
        var ptr = [];
        // loop columns in result matrix
        columns.forEach(function(j) {
            // update ptr
            ptr.push(index.length);
            // loop values in column j
            for(k = mptr[j], kk = mptr[j + 1]; k < kk; k++){
                // row
                i = mindex[k];
                // check row is in result matrix
                if (w[i] === true) {
                    // push index
                    index.push(pv[i]);
                    // check we need to process values
                    if (values) values.push(mvalues[k]);
                }
            }
        });
        // update ptr
        ptr.push(index.length);
        // return matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: size,
            datatype: matrix._datatype
        });
    }
    function _setsubset(matrix, index, submatrix, defaultValue) {
        // check index
        if (!index || index.isIndex !== true) throw new TypeError('Invalid index');
        // get index size and check whether the index contains a single value
        var iSize = index.size();
        var isScalar = index.isScalar();
        // calculate the size of the submatrix, and convert it into an Array if needed
        var sSize;
        if ((0, $edQYF.isMatrix)(submatrix)) {
            // submatrix size
            sSize = submatrix.size();
            // use array representation
            submatrix = submatrix.toArray();
        } else // get submatrix size (array, scalar)
        sSize = (0, $d80Xp.arraySize)(submatrix);
        // check index is a scalar
        if (isScalar) {
            // verify submatrix is a scalar
            if (sSize.length !== 0) throw new TypeError('Scalar expected');
            // set value
            matrix.set(index.min(), submatrix, defaultValue);
        } else {
            // validate dimensions, index size must be one or two dimensions
            if (iSize.length !== 1 && iSize.length !== 2) throw new (0, $7asMt.DimensionError)(iSize.length, matrix._size.length, '<');
            // check submatrix and index have the same dimensions
            if (sSize.length < iSize.length) {
                // calculate number of missing outer dimensions
                var i = 0;
                var outer = 0;
                while(iSize[i] === 1 && sSize[i] === 1)i++;
                while(iSize[i] === 1){
                    outer++;
                    i++;
                }
                // unsqueeze both outer and inner dimensions
                submatrix = (0, $d80Xp.unsqueeze)(submatrix, iSize.length, outer, sSize);
            }
            // check whether the size of the submatrix matches the index size
            if (!(0, $9v8q6.deepStrictEqual)(iSize, sSize)) throw new (0, $7asMt.DimensionError)(iSize, sSize, '>');
            // insert the sub matrix
            if (iSize.length === 1) {
                // if the replacement index only has 1 dimension, go trough each one and set its value
                var range = index.dimension(0);
                range.forEach(function(dataIndex, subIndex) {
                    (0, $d80Xp.validateIndex)(dataIndex);
                    matrix.set([
                        dataIndex,
                        0
                    ], submatrix[subIndex[0]], defaultValue);
                });
            } else {
                // if the replacement index has 2 dimensions, go through each one and set the value in the correct index
                var firstDimensionRange = index.dimension(0);
                var secondDimensionRange = index.dimension(1);
                firstDimensionRange.forEach(function(firstDataIndex, firstSubIndex) {
                    (0, $d80Xp.validateIndex)(firstDataIndex);
                    secondDimensionRange.forEach(function(secondDataIndex, secondSubIndex) {
                        (0, $d80Xp.validateIndex)(secondDataIndex);
                        matrix.set([
                            firstDataIndex,
                            secondDataIndex
                        ], submatrix[firstSubIndex[0]][secondSubIndex[0]], defaultValue);
                    });
                });
            }
        }
        return matrix;
    }
    /**
   * Get a single element from the matrix.
   * @memberof SparseMatrix
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ SparseMatrix.prototype.get = function(index) {
        if (!(0, $edQYF.isArray)(index)) throw new TypeError('Array expected');
        if (index.length !== this._size.length) throw new (0, $7asMt.DimensionError)(index.length, this._size.length);
        // check it is a pattern matrix
        if (!this._values) throw new Error('Cannot invoke get on a Pattern only matrix');
        // row and column
        var i = index[0];
        var j = index[1];
        // check i, j are valid
        (0, $d80Xp.validateIndex)(i, this._size[0]);
        (0, $d80Xp.validateIndex)(j, this._size[1]);
        // find value index
        var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index);
        // check k is prior to next column k and it is in the correct row
        if (k < this._ptr[j + 1] && this._index[k] === i) return this._values[k];
        return 0;
    };
    /**
   * Replace a single element in the matrix.
   * @memberof SparseMatrix
   * @param {number[]} index   Zero-based index
   * @param {*} v
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be set to zero.
   * @return {SparseMatrix} self
   */ SparseMatrix.prototype.set = function(index, v, defaultValue) {
        if (!(0, $edQYF.isArray)(index)) throw new TypeError('Array expected');
        if (index.length !== this._size.length) throw new (0, $7asMt.DimensionError)(index.length, this._size.length);
        // check it is a pattern matrix
        if (!this._values) throw new Error('Cannot invoke set on a Pattern only matrix');
        // row and column
        var i = index[0];
        var j = index[1];
        // rows & columns
        var rows = this._size[0];
        var columns = this._size[1];
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        if ((0, $edQYF.isString)(this._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                this._datatype,
                this._datatype
            ]) || equalScalar;
            // convert 0 to the same datatype
            zero = typed.convert(0, this._datatype);
        }
        // check we need to resize matrix
        if (i > rows - 1 || j > columns - 1) {
            // resize matrix
            _resize(this, Math.max(i + 1, rows), Math.max(j + 1, columns), defaultValue);
            // update rows & columns
            rows = this._size[0];
            columns = this._size[1];
        }
        // check i, j are valid
        (0, $d80Xp.validateIndex)(i, rows);
        (0, $d80Xp.validateIndex)(j, columns);
        // find value index
        var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index);
        // check k is prior to next column k and it is in the correct row
        if (k < this._ptr[j + 1] && this._index[k] === i) {
            // check value != 0
            if (!eq(v, zero)) // update value
            this._values[k] = v;
            else // remove value from matrix
            _remove(k, j, this._values, this._index, this._ptr);
        } else if (!eq(v, zero)) // insert value @ (i, j)
        _insert(k, i, j, v, this._values, this._index, this._ptr);
        return this;
    };
    function _getValueIndex(i, top, bottom, index) {
        // check row is on the bottom side
        if (bottom - top === 0) return bottom;
        // loop rows [top, bottom[
        for(var r = top; r < bottom; r++){
            // check we found value index
            if (index[r] === i) return r;
        }
        // we did not find row
        return top;
    }
    function _remove(k, j, values, index, ptr) {
        // remove value @ k
        values.splice(k, 1);
        index.splice(k, 1);
        // update pointers
        for(var x = j + 1; x < ptr.length; x++)ptr[x]--;
    }
    function _insert(k, i, j, v, values, index, ptr) {
        // insert value
        values.splice(k, 0, v);
        // update row for k
        index.splice(k, 0, i);
        // update column pointers
        for(var x = j + 1; x < ptr.length; x++)ptr[x]++;
    }
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @memberof SparseMatrix
   * @param {number[] | Matrix} size  The new size the matrix should have.
   *                                  Since sparse matrices are always two-dimensional,
   *                                  size must be two numbers in either an array or a matrix
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ SparseMatrix.prototype.resize = function(size, defaultValue, copy) {
        // validate arguments
        if (!(0, $edQYF.isCollection)(size)) throw new TypeError('Array or Matrix expected');
        // SparseMatrix input is always 2d, flatten this into 1d if it's indeed a vector
        var sizeArray = size.valueOf().map((value)=>{
            return Array.isArray(value) && value.length === 1 ? value[0] : value;
        });
        if (sizeArray.length !== 2) throw new Error('Only two dimensions matrix are supported');
        // check sizes
        sizeArray.forEach(function(value) {
            if (!(0, $edQYF.isNumber)(value) || !(0, $6NnhX.isInteger)(value) || value < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $j2hDb.format)(sizeArray) + ')');
        });
        // matrix to resize
        var m = copy ? this.clone() : this;
        // resize matrix
        return _resize(m, sizeArray[0], sizeArray[1], defaultValue);
    };
    function _resize(matrix, rows, columns, defaultValue) {
        // value to insert at the time of growing matrix
        var value = defaultValue || 0;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        if ((0, $edQYF.isString)(matrix._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                matrix._datatype,
                matrix._datatype
            ]) || equalScalar;
            // convert 0 to the same datatype
            zero = typed.convert(0, matrix._datatype);
            // convert value to the same datatype
            value = typed.convert(value, matrix._datatype);
        }
        // should we insert the value?
        var ins = !eq(value, zero);
        // old columns and rows
        var r = matrix._size[0];
        var c = matrix._size[1];
        var i, j, k;
        // check we need to increase columns
        if (columns > c) {
            // loop new columns
            for(j = c; j < columns; j++){
                // update matrix._ptr for current column
                matrix._ptr[j] = matrix._values.length;
                // check we need to insert matrix._values
                if (ins) // loop rows
                for(i = 0; i < r; i++){
                    // add new matrix._values
                    matrix._values.push(value);
                    // update matrix._index
                    matrix._index.push(i);
                }
            }
            // store number of matrix._values in matrix._ptr
            matrix._ptr[columns] = matrix._values.length;
        } else if (columns < c) {
            // truncate matrix._ptr
            matrix._ptr.splice(columns + 1, c - columns);
            // truncate matrix._values and matrix._index
            matrix._values.splice(matrix._ptr[columns], matrix._values.length);
            matrix._index.splice(matrix._ptr[columns], matrix._index.length);
        }
        // update columns
        c = columns;
        // check we need to increase rows
        if (rows > r) // check we have to insert values
        {
            if (ins) {
                // inserts
                var n = 0;
                // loop columns
                for(j = 0; j < c; j++){
                    // update matrix._ptr for current column
                    matrix._ptr[j] = matrix._ptr[j] + n;
                    // where to insert matrix._values
                    k = matrix._ptr[j + 1] + n;
                    // pointer
                    var p = 0;
                    // loop new rows, initialize pointer
                    for(i = r; i < rows; i++, p++){
                        // add value
                        matrix._values.splice(k + p, 0, value);
                        // update matrix._index
                        matrix._index.splice(k + p, 0, i);
                        // increment inserts
                        n++;
                    }
                }
                // store number of matrix._values in matrix._ptr
                matrix._ptr[c] = matrix._values.length;
            }
        } else if (rows < r) {
            // deletes
            var d = 0;
            // loop columns
            for(j = 0; j < c; j++){
                // update matrix._ptr for current column
                matrix._ptr[j] = matrix._ptr[j] - d;
                // where matrix._values start for next column
                var k0 = matrix._ptr[j];
                var k1 = matrix._ptr[j + 1] - d;
                // loop matrix._index
                for(k = k0; k < k1; k++){
                    // row
                    i = matrix._index[k];
                    // check we need to delete value and matrix._index
                    if (i > rows - 1) {
                        // remove value
                        matrix._values.splice(k, 1);
                        // remove item from matrix._index
                        matrix._index.splice(k, 1);
                        // increase deletes
                        d++;
                    }
                }
            }
            // update matrix._ptr for current column
            matrix._ptr[j] = matrix._values.length;
        }
        // update matrix._size
        matrix._size[0] = rows;
        matrix._size[1] = columns;
        // return matrix
        return matrix;
    }
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * NOTE: This might be better suited to copy by default, instead of modifying
   *       in place. For now, it operates in place to remain consistent with
   *       resize().
   *
   * @memberof SparseMatrix
   * @param {number[]} sizes          The new size the matrix should have.
   *                                  Since sparse matrices are always two-dimensional,
   *                                  size must be two numbers in either an array or a matrix
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ SparseMatrix.prototype.reshape = function(sizes, copy) {
        // validate arguments
        if (!(0, $edQYF.isArray)(sizes)) throw new TypeError('Array expected');
        if (sizes.length !== 2) throw new Error('Sparse matrices can only be reshaped in two dimensions');
        // check sizes
        sizes.forEach(function(value) {
            if (!(0, $edQYF.isNumber)(value) || !(0, $6NnhX.isInteger)(value) || value <= -2 || value === 0) throw new TypeError("Invalid size, must contain positive integers or -1 (size: " + (0, $j2hDb.format)(sizes) + ')');
        });
        var currentLength = this._size[0] * this._size[1];
        sizes = (0, $d80Xp.processSizesWildcard)(sizes, currentLength);
        var newLength = sizes[0] * sizes[1];
        // m * n must not change
        if (currentLength !== newLength) throw new Error('Reshaping sparse matrix will result in the wrong number of elements');
        // matrix to reshape
        var m = copy ? this.clone() : this;
        // return unchanged if the same shape
        if (this._size[0] === sizes[0] && this._size[1] === sizes[1]) return m;
        // Convert to COO format (generate a column index)
        var colIndex = [];
        for(var i = 0; i < m._ptr.length; i++)for(var j = 0; j < m._ptr[i + 1] - m._ptr[i]; j++)colIndex.push(i);
        // Clone the values array
        var values = m._values.slice();
        // Clone the row index array
        var rowIndex = m._index.slice();
        // Transform the (row, column) indices
        for(var _i = 0; _i < m._index.length; _i++){
            var r1 = rowIndex[_i];
            var c1 = colIndex[_i];
            var flat = r1 * m._size[1] + c1;
            colIndex[_i] = flat % sizes[1];
            rowIndex[_i] = Math.floor(flat / sizes[1]);
        }
        // Now reshaping is supposed to preserve the row-major order, BUT these sparse matrices are stored
        // in column-major order, so we have to reorder the value array now. One option is to use a multisort,
        // sorting several arrays based on some other array.
        // OR, we could easily just:
        // 1. Remove all values from the matrix
        m._values.length = 0;
        m._index.length = 0;
        m._ptr.length = sizes[1] + 1;
        m._size = sizes.slice();
        for(var _i2 = 0; _i2 < m._ptr.length; _i2++)m._ptr[_i2] = 0;
        // 2. Re-insert all elements in the proper order (simplified code from SparseMatrix.prototype.set)
        // This step is probably the most time-consuming
        for(var h = 0; h < values.length; h++){
            var _i3 = rowIndex[h];
            var _j = colIndex[h];
            var v = values[h];
            var k = _getValueIndex(_i3, m._ptr[_j], m._ptr[_j + 1], m._index);
            _insert(k, _i3, _j, v, m._values, m._index, m._ptr);
        }
        // The value indices are inserted out of order, but apparently that's... still OK?
        return m;
    };
    /**
   * Create a clone of the matrix
   * @memberof SparseMatrix
   * @return {SparseMatrix} clone
   */ SparseMatrix.prototype.clone = function() {
        var m = new SparseMatrix({
            values: this._values ? (0, $9v8q6.clone)(this._values) : undefined,
            index: (0, $9v8q6.clone)(this._index),
            ptr: (0, $9v8q6.clone)(this._ptr),
            size: (0, $9v8q6.clone)(this._size),
            datatype: this._datatype
        });
        return m;
    };
    /**
   * Retrieve the size of the matrix.
   * @memberof SparseMatrix
   * @returns {number[]} size
   */ SparseMatrix.prototype.size = function() {
        return this._size.slice(0); // copy the Array
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @memberof SparseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *
   * @return {SparseMatrix} matrix
   */ SparseMatrix.prototype.map = function(callback, skipZeros) {
        // check it is a pattern matrix
        if (!this._values) throw new Error('Cannot invoke map on a Pattern only matrix');
        // matrix instance
        var me = this;
        // rows and columns
        var rows = this._size[0];
        var columns = this._size[1];
        var fastCallback = (0, $bLcpf.optimizeCallback)(callback, me, 'map');
        // invoke callback
        var invoke = function invoke(v, i, j) {
            // invoke callback
            return fastCallback.fn(v, [
                i,
                j
            ], me);
        };
        // invoke _map
        return _map(this, 0, rows - 1, 0, columns - 1, invoke, skipZeros);
    };
    /**
   * Create a new matrix with the results of the callback function executed on the interval
   * [minRow..maxRow, minColumn..maxColumn].
   */ function _map(matrix, minRow, maxRow, minColumn, maxColumn, callback, skipZeros) {
        // result arrays
        var values = [];
        var index = [];
        var ptr = [];
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        if ((0, $edQYF.isString)(matrix._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                matrix._datatype,
                matrix._datatype
            ]) || equalScalar;
            // convert 0 to the same datatype
            zero = typed.convert(0, matrix._datatype);
        }
        // invoke callback
        var invoke = function invoke(v, x, y) {
            // invoke callback
            var value = callback(v, x, y);
            // check value != 0
            if (!eq(value, zero)) {
                // store value
                values.push(value);
                // index
                index.push(x);
            }
        };
        // loop columns
        for(var j = minColumn; j <= maxColumn; j++){
            // store pointer to values index
            ptr.push(values.length);
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = matrix._ptr[j];
            var k1 = matrix._ptr[j + 1];
            if (skipZeros) // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = matrix._index[k];
                // check i is in range
                if (i >= minRow && i <= maxRow) // value @ k
                invoke(matrix._values[k], i - minRow, j - minColumn);
            }
            else {
                // create a cache holding all defined values
                var _values = {};
                for(var _k = k0; _k < k1; _k++){
                    var _i4 = matrix._index[_k];
                    _values[_i4] = matrix._values[_k];
                }
                // loop over all rows (indexes can be unordered so we can't use that),
                // and either read the value or zero
                for(var _i5 = minRow; _i5 <= maxRow; _i5++){
                    var value = _i5 in _values ? _values[_i5] : 0;
                    invoke(value, _i5 - minRow, j - minColumn);
                }
            }
        }
        // store number of values in ptr
        ptr.push(values.length);
        // return sparse matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                maxRow - minRow + 1,
                maxColumn - minColumn + 1
            ]
        });
    }
    /**
   * Execute a callback function on each entry of the matrix.
   * @memberof SparseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *                              If false, the indices are guaranteed to be in order,
   *                              if true, the indices can be unordered.
   */ SparseMatrix.prototype.forEach = function(callback, skipZeros) {
        // check it is a pattern matrix
        if (!this._values) throw new Error('Cannot invoke forEach on a Pattern only matrix');
        // matrix instance
        var me = this;
        // rows and columns
        var rows = this._size[0];
        var columns = this._size[1];
        var fastCallback = (0, $bLcpf.optimizeCallback)(callback, me, 'forEach');
        // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1];
            if (skipZeros) // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k];
                // value @ k
                // TODO apply a non indexed version of algorithm in case fastCallback is not optimized
                fastCallback.fn(this._values[k], [
                    i,
                    j
                ], me);
            }
            else {
                // create a cache holding all defined values
                var values = {};
                for(var _k2 = k0; _k2 < k1; _k2++){
                    var _i6 = this._index[_k2];
                    values[_i6] = this._values[_k2];
                }
                // loop over all rows (indexes can be unordered so we can't use that),
                // and either read the value or zero
                for(var _i7 = 0; _i7 < rows; _i7++){
                    var value = _i7 in values ? values[_i7] : 0;
                    fastCallback.fn(value, [
                        _i7,
                        j
                    ], me);
                }
            }
        }
    };
    /**
   * Iterate over the matrix elements, skipping zeros
   * @return {Iterable<{ value, index: number[] }>}
   */ SparseMatrix.prototype[Symbol.iterator] = function*() {
        if (!this._values) throw new Error('Cannot iterate a Pattern only matrix');
        var columns = this._size[1];
        for(var j = 0; j < columns; j++){
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1];
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k];
                yield {
                    value: this._values[k],
                    index: [
                        i,
                        j
                    ]
                };
            }
        }
    };
    /**
   * Create an Array with a copy of the data of the SparseMatrix
   * @memberof SparseMatrix
   * @returns {Array} array
   */ SparseMatrix.prototype.toArray = function() {
        return _toArray(this._values, this._index, this._ptr, this._size, true);
    };
    /**
   * Get the primitive value of the SparseMatrix: a two dimensions array
   * @memberof SparseMatrix
   * @returns {Array} array
   */ SparseMatrix.prototype.valueOf = function() {
        return _toArray(this._values, this._index, this._ptr, this._size, false);
    };
    function _toArray(values, index, ptr, size, copy) {
        // rows and columns
        var rows = size[0];
        var columns = size[1];
        // result
        var a = [];
        // vars
        var i, j;
        // initialize array
        for(i = 0; i < rows; i++){
            a[i] = [];
            for(j = 0; j < columns; j++)a[i][j] = 0;
        }
        // loop columns
        for(j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1];
            // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                i = index[k];
                // set value (use one for pattern matrix)
                a[i][j] = values ? copy ? (0, $9v8q6.clone)(values[k]) : values[k] : 1;
            }
        }
        return a;
    }
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @memberof SparseMatrix
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ SparseMatrix.prototype.format = function(options) {
        // rows and columns
        var rows = this._size[0];
        var columns = this._size[1];
        // density
        var density = this.density();
        // rows & columns
        var str = 'Sparse Matrix [' + (0, $j2hDb.format)(rows, options) + ' x ' + (0, $j2hDb.format)(columns, options) + '] density: ' + (0, $j2hDb.format)(density, options) + '\n';
        // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1];
            // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k];
                // append value
                str += '\n    (' + (0, $j2hDb.format)(i, options) + ', ' + (0, $j2hDb.format)(j, options) + ') ==> ' + (this._values ? (0, $j2hDb.format)(this._values[k], options) : 'X');
            }
        }
        return str;
    };
    /**
   * Get a string representation of the matrix
   * @memberof SparseMatrix
   * @returns {string} str
   */ SparseMatrix.prototype.toString = function() {
        return (0, $j2hDb.format)(this.toArray());
    };
    /**
   * Get a JSON representation of the matrix
   * @memberof SparseMatrix
   * @returns {Object}
   */ SparseMatrix.prototype.toJSON = function() {
        return {
            mathjs: 'SparseMatrix',
            values: this._values,
            index: this._index,
            ptr: this._ptr,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Get the kth Matrix diagonal.
   *
   * @memberof SparseMatrix
   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
   *
   * @returns {Matrix}                     The matrix vector with the diagonal values.
   */ SparseMatrix.prototype.diagonal = function(k) {
        // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $edQYF.isBigNumber)(k)) k = k.toNumber();
            // is must be an integer
            if (!(0, $edQYF.isNumber)(k) || !(0, $6NnhX.isInteger)(k)) throw new TypeError('The parameter k must be an integer number');
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0;
        // rows & columns
        var rows = this._size[0];
        var columns = this._size[1];
        // number diagonal values
        var n = Math.min(rows - kSub, columns - kSuper);
        // diagonal arrays
        var values = [];
        var index = [];
        var ptr = [];
        // initial ptr value
        ptr[0] = 0;
        // loop columns
        for(var j = kSuper; j < columns && values.length < n; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1];
            // loop x within [k0, k1[
            for(var x = k0; x < k1; x++){
                // row index
                var i = this._index[x];
                // check row
                if (i === j - kSuper + kSub) {
                    // value on this column
                    values.push(this._values[x]);
                    // store row
                    index[values.length - 1] = i - kSub;
                    break;
                }
            }
        }
        // close ptr
        ptr.push(values.length);
        // return matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                n,
                1
            ]
        });
    };
    /**
   * Generate a matrix from a JSON object
   * @memberof SparseMatrix
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "SparseMatrix", "values": [], "index": [], "ptr": [], "size": []}`,
   *                       where mathjs is optional
   * @returns {SparseMatrix}
   */ SparseMatrix.fromJSON = function(json) {
        return new SparseMatrix(json);
    };
    /**
   * Create a diagonal matrix.
   *
   * @memberof SparseMatrix
   * @param {Array} size                       The matrix size.
   * @param {number | Array | Matrix } value   The values for the diagonal.
   * @param {number | BigNumber} [k=0]         The kth diagonal where the vector will be filled in.
   * @param {number} [defaultValue]            The default value for non-diagonal
   * @param {string} [datatype]                The Matrix datatype, values must be of this datatype.
   *
   * @returns {SparseMatrix}
   */ SparseMatrix.diagonal = function(size, value, k, defaultValue, datatype) {
        if (!(0, $edQYF.isArray)(size)) throw new TypeError('Array expected, size parameter');
        if (size.length !== 2) throw new Error('Only two dimensions matrix are supported');
        // map size & validate
        size = size.map(function(s) {
            // check it is a big number
            if ((0, $edQYF.isBigNumber)(s)) // convert it
            s = s.toNumber();
            // validate arguments
            if (!(0, $edQYF.isNumber)(s) || !(0, $6NnhX.isInteger)(s) || s < 1) throw new Error('Size values must be positive integers');
            return s;
        });
        // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $edQYF.isBigNumber)(k)) k = k.toNumber();
            // is must be an integer
            if (!(0, $edQYF.isNumber)(k) || !(0, $6NnhX.isInteger)(k)) throw new TypeError('The parameter k must be an integer number');
        } else // default value
        k = 0;
        // equal signature to use
        var eq = equalScalar;
        // zero value
        var zero = 0;
        if ((0, $edQYF.isString)(datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                datatype,
                datatype
            ]) || equalScalar;
            // convert 0 to the same datatype
            zero = typed.convert(0, datatype);
        }
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0;
        // rows and columns
        var rows = size[0];
        var columns = size[1];
        // number of non-zero items
        var n = Math.min(rows - kSub, columns - kSuper);
        // value extraction function
        var _value;
        // check value
        if ((0, $edQYF.isArray)(value)) {
            // validate array
            if (value.length !== n) // number of values in array must be n
            throw new Error('Invalid value array length');
            // define function
            _value = function _value(i) {
                // return value @ i
                return value[i];
            };
        } else if ((0, $edQYF.isMatrix)(value)) {
            // matrix size
            var ms = value.size();
            // validate matrix
            if (ms.length !== 1 || ms[0] !== n) // number of values in array must be n
            throw new Error('Invalid matrix length');
            // define function
            _value = function _value(i) {
                // return value @ i
                return value.get([
                    i
                ]);
            };
        } else // define function
        _value = function _value() {
            // return value
            return value;
        };
        // create arrays
        var values = [];
        var index = [];
        var ptr = [];
        // loop items
        for(var j = 0; j < columns; j++){
            // number of rows with value
            ptr.push(values.length);
            // diagonal index
            var i = j - kSuper;
            // check we need to set diagonal value
            if (i >= 0 && i < n) {
                // get value @ i
                var v = _value(i);
                // check for zero
                if (!eq(v, zero)) {
                    // column
                    index.push(i + kSub);
                    // add value
                    values.push(v);
                }
            }
        }
        // last value should be number of values
        ptr.push(values.length);
        // create SparseMatrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                rows,
                columns
            ]
        });
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @memberof SparseMatrix
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ SparseMatrix.prototype.swapRows = function(i, j) {
        // check index
        if (!(0, $edQYF.isNumber)(i) || !(0, $6NnhX.isInteger)(i) || !(0, $edQYF.isNumber)(j) || !(0, $6NnhX.isInteger)(j)) throw new Error('Row index must be positive integers');
        // check dimensions
        if (this._size.length !== 2) throw new Error('Only two dimensional matrix is supported');
        // validate index
        (0, $d80Xp.validateIndex)(i, this._size[0]);
        (0, $d80Xp.validateIndex)(j, this._size[0]);
        // swap rows
        SparseMatrix._swapRows(i, j, this._size[1], this._values, this._index, this._ptr);
        // return current instance
        return this;
    };
    /**
   * Loop rows with data in column j.
   *
   * @param {number} j            Column
   * @param {Array} values        Matrix values
   * @param {Array} index         Matrix row indeces
   * @param {Array} ptr           Matrix column pointers
   * @param {Function} callback   Callback function invoked for every row in column j
   */ SparseMatrix._forEachRow = function(j, values, index, ptr, callback) {
        // indeces for column j
        var k0 = ptr[j];
        var k1 = ptr[j + 1];
        // loop
        for(var k = k0; k < k1; k++)// invoke callback
        callback(index[k], values[k]);
    };
    /**
   * Swap rows x and y in Sparse Matrix data structures.
   *
   * @param {number} x         Matrix row index 1
   * @param {number} y         Matrix row index 2
   * @param {number} columns   Number of columns in matrix
   * @param {Array} values     Matrix values
   * @param {Array} index      Matrix row indeces
   * @param {Array} ptr        Matrix column pointers
   */ SparseMatrix._swapRows = function(x, y, columns, values, index, ptr) {
        // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1];
            // find value index @ x
            var kx = _getValueIndex(x, k0, k1, index);
            // find value index @ x
            var ky = _getValueIndex(y, k0, k1, index);
            // check both rows exist in matrix
            if (kx < k1 && ky < k1 && index[kx] === x && index[ky] === y) {
                // swap values (check for pattern matrix)
                if (values) {
                    var v = values[kx];
                    values[kx] = values[ky];
                    values[ky] = v;
                }
                continue;
            }
            // check x row exist & no y row
            if (kx < k1 && index[kx] === x && (ky >= k1 || index[ky] !== y)) {
                // value @ x (check for pattern matrix)
                var vx = values ? values[kx] : undefined;
                // insert value @ y
                index.splice(ky, 0, y);
                if (values) values.splice(ky, 0, vx);
                // remove value @ x (adjust array index if needed)
                index.splice(ky <= kx ? kx + 1 : kx, 1);
                if (values) values.splice(ky <= kx ? kx + 1 : kx, 1);
                continue;
            }
            // check y row exist & no x row
            if (ky < k1 && index[ky] === y && (kx >= k1 || index[kx] !== x)) {
                // value @ y (check for pattern matrix)
                var vy = values ? values[ky] : undefined;
                // insert value @ x
                index.splice(kx, 0, x);
                if (values) values.splice(kx, 0, vy);
                // remove value @ y (adjust array index if needed)
                index.splice(kx <= ky ? ky + 1 : ky, 1);
                if (values) values.splice(kx <= ky ? ky + 1 : ky, 1);
            }
        }
    };
    return SparseMatrix;
}, {
    isClass: true
});

});

parcelRegister("l9iNl", function(module, exports) {

$parcel$export(module.exports, "createSplitUnit", () => $f65904864a821c16$export$a9f61753ee14ea96);

var $dsu7t = parcelRequire("dsu7t");
var $f65904864a821c16$var$name = 'splitUnit';
var $f65904864a821c16$var$dependencies = [
    'typed'
];
var $f65904864a821c16$export$a9f61753ee14ea96 = /* #__PURE__ */ (0, $dsu7t.factory)($f65904864a821c16$var$name, $f65904864a821c16$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Split a unit in an array of units whose sum is equal to the original unit.
   *
   * Syntax:
   *
   *     math.splitUnit(unit: Unit, parts: Array.<Unit>)
   *
   * Example:
   *
   *     math.splitUnit(new Unit(1, 'm'), ['feet', 'inch'])
   *     // [ 3 feet, 3.3700787401575 inch ]
   *
   * See also:
   *
   *     unit
   *
   * @param {Array} [parts] An array of strings or valueless units.
   * @return {Array} An array of units.
   */ return typed($f65904864a821c16$var$name, {
        'Unit, Array': function Unit_Array(unit, parts) {
            return unit.splitUnit(parts);
        }
    });
});

});

parcelRegister("i4vJd", function(module, exports) {

$parcel$export(module.exports, "createSqrt", () => $d281364b541cd378$export$eb18ce1988c5f19c);

var $dsu7t = parcelRequire("dsu7t");
var $d281364b541cd378$var$name = 'sqrt';
var $d281364b541cd378$var$dependencies = [
    'config',
    'typed',
    'Complex'
];
var $d281364b541cd378$export$eb18ce1988c5f19c = /* #__PURE__ */ (0, $dsu7t.factory)($d281364b541cd378$var$name, $d281364b541cd378$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, Complex: Complex } = _ref;
    /**
   * Calculate the square root of a value.
   *
   * For matrices, if you want the matrix square root of a square matrix,
   * use the `sqrtm` function. If you wish to apply `sqrt` elementwise to
   * a matrix M, use `math.map(M, math.sqrt)`.
   *
   * Syntax:
   *
   *    math.sqrt(x)
   *
   * Examples:
   *
   *    math.sqrt(25)                // returns 5
   *    math.square(5)               // returns 25
   *    math.sqrt(-4)                // returns Complex 2i
   *
   * See also:
   *
   *    square, multiply, cube, cbrt, sqrtm
   *
   * @param {number | BigNumber | Complex | Unit} x
   *            Value for which to calculate the square root.
   * @return {number | BigNumber | Complex | Unit}
   *            Returns the square root of `x`
   */ return typed('sqrt', {
        number: _sqrtNumber,
        Complex: function Complex(x) {
            return x.sqrt();
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.sqrt();
            else // negative value -> downgrade to number to do complex value computation
            return _sqrtNumber(x.toNumber());
        },
        Unit: function Unit(x) {
            // Someday will work for complex units when they are implemented
            return x.pow(0.5);
        }
    });
    /**
   * Calculate sqrt for a number
   * @param {number} x
   * @returns {number | Complex} Returns the square root of x
   * @private
   */ function _sqrtNumber(x) {
        if (isNaN(x)) return NaN;
        else if (x >= 0 || config.predictable) return Math.sqrt(x);
        else return new Complex(x, 0).sqrt();
    }
});

});

parcelRegister("OrxWM", function(module, exports) {

$parcel$export(module.exports, "createSqrtm", () => $097a09cb61e919ee$export$71d0f952576e7511);

var $edQYF = parcelRequire("edQYF");

var $j2hDb = parcelRequire("j2hDb");

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $097a09cb61e919ee$var$name = 'sqrtm';
var $097a09cb61e919ee$var$dependencies = [
    'typed',
    'abs',
    'add',
    'multiply',
    'map',
    'sqrt',
    'subtract',
    'inv',
    'size',
    'max',
    'identity'
];
var $097a09cb61e919ee$export$71d0f952576e7511 = /* #__PURE__ */ (0, $dsu7t.factory)($097a09cb61e919ee$var$name, $097a09cb61e919ee$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, multiply: multiply, map: map, sqrt: sqrt, subtract: subtract, inv: inv, size: size, max: max, identity: identity } = _ref;
    var _maxIterations = 1e3;
    var _tolerance = 1e-6;
    /**
   * Calculate the principal square root matrix using the Denman–Beavers iterative method
   *
   * https://en.wikipedia.org/wiki/Square_root_of_a_matrix#By_Denman–Beavers_iteration
   *
   * @param  {Array | Matrix} A   The square matrix `A`
   * @return {Array | Matrix}     The principal square root of matrix `A`
   * @private
   */ function _denmanBeavers(A) {
        var error;
        var iterations = 0;
        var Y = A;
        var Z = identity(size(A));
        do {
            var Yk = Y;
            Y = multiply(0.5, add(Yk, inv(Z)));
            Z = multiply(0.5, add(Z, inv(Yk)));
            error = max(abs(subtract(Y, Yk)));
            if (error > _tolerance && ++iterations > _maxIterations) throw new Error('computing square root of matrix: iterative method could not converge');
        }while (error > _tolerance);
        return Y;
    }
    /**
   * Calculate the principal square root of a square matrix.
   * The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.
   *
   * https://en.wikipedia.org/wiki/Square_root_of_a_matrix
   *
   * Syntax:
   *
   *     math.sqrtm(A)
   *
   * Examples:
   *
   *     math.sqrtm([[33, 24], [48, 57]]) // returns [[5, 2], [4, 7]]
   *
   * See also:
   *
   *     sqrt, pow
   *
   * @param  {Array | Matrix} A   The square matrix `A`
   * @return {Array | Matrix}     The principal square root of matrix `A`
   */ return typed($097a09cb61e919ee$var$name, {
        'Array | Matrix': function Array__Matrix(A) {
            var size = (0, $edQYF.isMatrix)(A) ? A.size() : (0, $d80Xp.arraySize)(A);
            switch(size.length){
                case 1:
                    // Single element Array | Matrix
                    if (size[0] === 1) return map(A, sqrt);
                    else throw new RangeError("Matrix must be square (size: " + (0, $j2hDb.format)(size) + ')');
                case 2:
                    // Two-dimensional Array | Matrix
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) return _denmanBeavers(A);
                    else throw new RangeError("Matrix must be square (size: " + (0, $j2hDb.format)(size) + ')');
                default:
                    // Multi dimensional array
                    throw new RangeError("Matrix must be at most two dimensional (size: " + (0, $j2hDb.format)(size) + ')');
            }
        }
    });
});

});

parcelRegister("1gF0a", function(module, exports) {

$parcel$export(module.exports, "createSquare", () => $0ec7172a8b1c7d4a$export$4ba960a63f731b0b);

var $dsu7t = parcelRequire("dsu7t");

var $dmcGu = parcelRequire("dmcGu");
var $0ec7172a8b1c7d4a$var$name = 'square';
var $0ec7172a8b1c7d4a$var$dependencies = [
    'typed'
];
var $0ec7172a8b1c7d4a$export$4ba960a63f731b0b = /* #__PURE__ */ (0, $dsu7t.factory)($0ec7172a8b1c7d4a$var$name, $0ec7172a8b1c7d4a$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the square of a value, `x * x`.
   * To avoid confusion with multiplying a square matrix by itself,
   * this function does not apply to matrices. If you wish to square
   * every element of a matrix, see the examples.
   *
   * Syntax:
   *
   *    math.square(x)
   *
   * Examples:
   *
   *    math.square(2)           // returns number 4
   *    math.square(3)           // returns number 9
   *    math.pow(3, 2)           // returns number 9
   *    math.multiply(3, 3)      // returns number 9
   *
   *    math.map([1, 2, 3, 4], math.square)  // returns Array [1, 4, 9, 16]
   *
   * See also:
   *
   *    multiply, cube, sqrt, pow
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit} x
   *            Number for which to calculate the square
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit}
   *            Squared value
   */ return typed($0ec7172a8b1c7d4a$var$name, {
        number: (0, $dmcGu.squareNumber),
        Complex: function Complex(x) {
            return x.mul(x);
        },
        BigNumber: function BigNumber(x) {
            return x.times(x);
        },
        bigint: function bigint(x) {
            return x * x;
        },
        Fraction: function Fraction(x) {
            return x.mul(x);
        },
        Unit: function Unit(x) {
            return x.pow(2);
        }
    });
});

});

parcelRegister("d54fn", function(module, exports) {

$parcel$export(module.exports, "createSqueeze", () => $985f095d0a495f26$export$1a885844ffd505a4);

var $9v8q6 = parcelRequire("9v8q6");

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $985f095d0a495f26$var$name = 'squeeze';
var $985f095d0a495f26$var$dependencies = [
    'typed'
];
var $985f095d0a495f26$export$1a885844ffd505a4 = /* #__PURE__ */ (0, $dsu7t.factory)($985f095d0a495f26$var$name, $985f095d0a495f26$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Squeeze a matrix, remove inner and outer singleton dimensions from a matrix.
   *
   * Syntax:
   *
   *     math.squeeze(x)
   *
   * Examples:
   *
   *     math.squeeze([3])           // returns 3
   *     math.squeeze([[3]])         // returns 3
   *
   *     const A = math.zeros(3, 1)    // returns [[0], [0], [0]] (size 3x1)
   *     math.squeeze(A)             // returns [0, 0, 0] (size 3)
   *
   *     const B = math.zeros(1, 3)    // returns [[0, 0, 0]] (size 1x3)
   *     math.squeeze(B)             // returns [0, 0, 0] (size 3)
   *
   *     // only inner and outer dimensions are removed
   *     const C = math.zeros(2, 1, 3) // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
   *     math.squeeze(C)             // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
   *
   * See also:
   *
   *     subset
   *
   * @param {Matrix | Array} x      Matrix to be squeezed
   * @return {Matrix | Array} Squeezed matrix
   */ return typed($985f095d0a495f26$var$name, {
        Array: function Array1(x) {
            return (0, $d80Xp.squeeze)((0, $9v8q6.clone)(x));
        },
        Matrix: function Matrix(x) {
            var res = (0, $d80Xp.squeeze)(x.toArray());
            // FIXME: return the same type of matrix as the input
            return Array.isArray(res) ? x.create(res, x.datatype()) : res;
        },
        any: function any(x) {
            // scalar
            return (0, $9v8q6.clone)(x);
        }
    });
});

});

parcelRegister("6V7sZ", function(module, exports) {

$parcel$export(module.exports, "createStd", () => $509ddbabe68477cd$export$d3f0a8dda5df7afd);

var $dsu7t = parcelRequire("dsu7t");

var $edQYF = parcelRequire("edQYF");
var $509ddbabe68477cd$var$name = 'std';
var $509ddbabe68477cd$var$dependencies = [
    'typed',
    'map',
    'sqrt',
    'variance'
];
var $509ddbabe68477cd$export$d3f0a8dda5df7afd = /* #__PURE__ */ (0, $dsu7t.factory)($509ddbabe68477cd$var$name, $509ddbabe68477cd$var$dependencies, (_ref)=>{
    var { typed: typed, map: map, sqrt: sqrt, variance: variance } = _ref;
    /**
   * Compute the standard deviation of a matrix or a  list with values.
   * The standard deviations is defined as the square root of the variance:
   * `std(A) = sqrt(variance(A))`.
   * In case of a (multi dimensional) array or matrix, the standard deviation
   * over all elements will be calculated by default, unless an axis is specified
   * in which case the standard deviation will be computed along that axis.
   *
   * Additionally, it is possible to compute the standard deviation along the rows
   * or columns of a matrix by specifying the dimension as the second argument.
   *
   * Optionally, the type of normalization can be specified as the final
   * parameter. The parameter `normalization` can be one of the following values:
   *
   * - 'unbiased' (default) The sum of squared errors is divided by (n - 1)
   * - 'uncorrected'        The sum of squared errors is divided by n
   * - 'biased'             The sum of squared errors is divided by (n + 1)
   *
   *
   * Syntax:
   *
   *     math.std(a, b, c, ...)
   *     math.std(A)
   *     math.std(A, normalization)
   *     math.std(A, dimension)
   *     math.std(A, dimension, normalization)
   *
   * Examples:
   *
   *     math.std(2, 4, 6)                     // returns 2
   *     math.std([2, 4, 6, 8])                // returns 2.581988897471611
   *     math.std([2, 4, 6, 8], 'uncorrected') // returns 2.23606797749979
   *     math.std([2, 4, 6, 8], 'biased')      // returns 2
   *
   *     math.std([[1, 2, 3], [4, 5, 6]])      // returns 1.8708286933869707
   *     math.std([[1, 2, 3], [4, 6, 8]], 0)    // returns [2.1213203435596424, 2.8284271247461903, 3.5355339059327378]
   *     math.std([[1, 2, 3], [4, 6, 8]], 1)    // returns [1, 2]
   *     math.std([[1, 2, 3], [4, 6, 8]], 1, 'biased') // returns [0.7071067811865476, 1.4142135623730951]
   *
   * See also:
   *
   *    mean, median, max, min, prod, sum, variance
   *
   * @param {Array | Matrix} array
   *                        A single matrix or or multiple scalar values
   * @param {string} [normalization='unbiased']
   *                        Determines how to normalize the variance.
   *                        Choose 'unbiased' (default), 'uncorrected', or 'biased'.
   * @param dimension {number | BigNumber}
   *                        Determines the axis to compute the standard deviation for a matrix
   * @return {*} The standard deviation
   */ return typed($509ddbabe68477cd$var$name, {
        // std([a, b, c, d, ...])
        'Array | Matrix': _std,
        // std([a, b, c, d, ...], normalization)
        'Array | Matrix, string': _std,
        // std([a, b, c, c, ...], dim)
        'Array | Matrix, number | BigNumber': _std,
        // std([a, b, c, c, ...], dim, normalization)
        'Array | Matrix, number | BigNumber, string': _std,
        // std(a, b, c, d, ...)
        '...': function _(args) {
            return _std(args);
        }
    });
    function _std(array, normalization) {
        if (array.length === 0) throw new SyntaxError('Function std requires one or more parameters (0 provided)');
        try {
            var v = variance.apply(null, arguments);
            if ((0, $edQYF.isCollection)(v)) return map(v, sqrt);
            else return sqrt(v);
        } catch (err) {
            if (err instanceof TypeError && err.message.includes(' variance')) throw new TypeError(err.message.replace(' variance', ' std'));
            else throw err;
        }
    }
});

});

parcelRegister("hzajK", function(module, exports) {

$parcel$export(module.exports, "createStirlingS2", () => $cc9db563be76bf44$export$18813d136a9b83d0);

var $dsu7t = parcelRequire("dsu7t");

var $edQYF = parcelRequire("edQYF");
var $cc9db563be76bf44$var$name = 'stirlingS2';
var $cc9db563be76bf44$var$dependencies = [
    'typed',
    'addScalar',
    'subtractScalar',
    'multiplyScalar',
    'divideScalar',
    'pow',
    'factorial',
    'combinations',
    'isNegative',
    'isInteger',
    'number',
    '?bignumber',
    'larger'
];
var $cc9db563be76bf44$export$18813d136a9b83d0 = /* #__PURE__ */ (0, $dsu7t.factory)($cc9db563be76bf44$var$name, $cc9db563be76bf44$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, subtractScalar: subtractScalar, multiplyScalar: multiplyScalar, divideScalar: divideScalar, pow: pow, factorial: factorial, combinations: combinations, isNegative: isNegative, isInteger: isInteger, number: number, bignumber: bignumber, larger: larger } = _ref;
    var smallCache = [];
    var bigCache = [];
    /**
   * The Stirling numbers of the second kind, counts the number of ways to partition
   * a set of n labelled objects into k nonempty unlabelled subsets.
   * stirlingS2 only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   *  If n = k or k = 1 <= n, then s(n,k) = 1
   *  If k = 0 < n, then s(n,k) = 0
   *
   * Note that if either n or k is supplied as a BigNumber, the result will be
   * as well.
   *
   * Syntax:
   *
   *   math.stirlingS2(n, k)
   *
   * Examples:
   *
   *    math.stirlingS2(5, 3) //returns 25
   *
   * See also:
   *
   *    bellNumbers
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @param {Number | BigNumber} k    Number of objects in the subset
   * @return {Number | BigNumber}     S(n,k)
   */ return typed($cc9db563be76bf44$var$name, {
        'number | BigNumber, number | BigNumber': function number__BigNumber_number__BigNumber(n, k) {
            if (!isInteger(n) || isNegative(n) || !isInteger(k) || isNegative(k)) throw new TypeError('Non-negative integer value expected in function stirlingS2');
            else if (larger(k, n)) throw new TypeError('k must be less than or equal to n in function stirlingS2');
            var big = !((0, $edQYF.isNumber)(n) && (0, $edQYF.isNumber)(k));
            var cache = big ? bigCache : smallCache;
            var make = big ? bignumber : number;
            var nn = number(n);
            var nk = number(k);
            /* See if we already have the value: */ if (cache[nn] && cache[nn].length > nk) return cache[nn][nk];
            /* Fill the cache */ for(var m = 0; m <= nn; ++m){
                if (!cache[m]) cache[m] = [
                    m === 0 ? make(1) : make(0)
                ];
                if (m === 0) continue;
                var row = cache[m];
                var prev = cache[m - 1];
                for(var i = row.length; i <= m && i <= nk; ++i)if (i === m) row[i] = 1;
                else row[i] = addScalar(multiplyScalar(make(i), prev[i]), prev[i - 1]);
            }
            return cache[nn][nk];
        }
    });
});

});

parcelRegister("2qrbI", function(module, exports) {

$parcel$export(module.exports, "createString", () => $1c43196d79d6a1ff$export$b2cf5914f5f18823);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");

var $6NnhX = parcelRequire("6NnhX");
var $1c43196d79d6a1ff$var$name = 'string';
var $1c43196d79d6a1ff$var$dependencies = [
    'typed'
];
var $1c43196d79d6a1ff$export$b2cf5914f5f18823 = /* #__PURE__ */ (0, $dsu7t.factory)($1c43196d79d6a1ff$var$name, $1c43196d79d6a1ff$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a string or convert any object into a string.
   * Elements of Arrays and Matrices are processed element wise.
   *
   * Syntax:
   *
   *    math.string(value)
   *
   * Examples:
   *
   *    math.string(4.2)                // returns string '4.2'
   *    math.string(math.complex(3, 2)) // returns string '3 + 2i'
   *
   *    const u = math.unit(5, 'km')
   *    math.string(u.to('m'))          // returns string '5000 m'
   *
   *    math.string([true, false])      // returns ['true', 'false']
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, number, unit
   *
   * @param {* | Array | Matrix | null} [value]  A value to convert to a string
   * @return {string | Array | Matrix} The created string
   */ return typed($1c43196d79d6a1ff$var$name, {
        '': function _() {
            return '';
        },
        number: (0, $6NnhX.format),
        null: function _null(x) {
            return 'null';
        },
        boolean: function boolean(x) {
            return x + '';
        },
        string: function string(x) {
            return x;
        },
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self)),
        any: function any(x) {
            return String(x);
        }
    });
});

});

parcelRegister("itxOD", function(module, exports) {

$parcel$export(module.exports, "createSubset", () => $d7352a8a7954f640$export$d8c56e74d683bb33);

var $edQYF = parcelRequire("edQYF");

var $9v8q6 = parcelRequire("9v8q6");

var $d80Xp = parcelRequire("d80Xp");

var $1q0jW = parcelRequire("1q0jW");

var $7asMt = parcelRequire("7asMt");

var $dsu7t = parcelRequire("dsu7t");
var $d7352a8a7954f640$var$name = 'subset';
var $d7352a8a7954f640$var$dependencies = [
    'typed',
    'matrix',
    'zeros',
    'add'
];
var $d7352a8a7954f640$export$d8c56e74d683bb33 = /* #__PURE__ */ (0, $dsu7t.factory)($d7352a8a7954f640$var$name, $d7352a8a7954f640$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, zeros: zeros, add: add } = _ref;
    /**
   * Get or set a subset of a matrix or string.
   *
   * Syntax:
   *     math.subset(value, index)                                // retrieve a subset
   *     math.subset(value, index, replacement [, defaultValue])  // replace a subset
   *
   * Examples:
   *
   *     // get a subset
   *     const d = [[1, 2], [3, 4]]
   *     math.subset(d, math.index(1, 0))             // returns 3
   *     math.subset(d, math.index([0, 1], 1))        // returns [[2], [4]]
   *     math.subset(d, math.index([false, true], 0)) // returns [[3]]
   *
   *     // replace a subset
   *     const e = []
   *     const f = math.subset(e, math.index(0, [0, 2]), [5, 6])  // f = [[5, 0, 6]]
   *     const g = math.subset(f, math.index(1, 1), 7, 0)         // g = [[5, 0, 6], [0, 7, 0]]
   *     math.subset(g, math.index([false, true], 1), 8)          // returns [[5, 0, 6], [0, 8, 0]]
   *
   *     // get submatrix using ranges
   *     const M = [
   *       [1,2,3],
   *       [4,5,6],
   *       [7,8,9]
   *     ]
   *     math.subset(M, math.index(math.range(0,2), math.range(0,3))) // [[1, 2, 3], [4, 5, 6]]
   *
   * See also:
   *
   *     size, resize, squeeze, index
   *
   * @param {Array | Matrix | string} matrix  An array, matrix, or string
   * @param {Index} index
   *    For each dimension of the target, specifies an index or a list of
   *    indices to fetch or set. `subset` uses the cartesian product of
   *    the indices specified in each dimension.
   * @param {*} [replacement]                 An array, matrix, or scalar.
   *                                          If provided, the subset is replaced with replacement.
   *                                          If not provided, the subset is returned
   * @param {*} [defaultValue=undefined]      Default value, filled in on new entries when
   *                                          the matrix is resized. If not provided,
   *                                          math.matrix elements will be left undefined.
   * @return {Array | Matrix | string} Either the retrieved subset or the updated matrix.
   */ return typed($d7352a8a7954f640$var$name, {
        // get subset
        'Matrix, Index': function Matrix_Index(value, index) {
            if ((0, $d80Xp.isEmptyIndex)(index)) return matrix();
            (0, $d80Xp.validateIndexSourceSize)(value, index);
            return value.subset(index);
        },
        'Array, Index': typed.referTo('Matrix, Index', function(subsetRef) {
            return function(value, index) {
                var subsetResult = subsetRef(matrix(value), index);
                return index.isScalar() ? subsetResult : subsetResult.valueOf();
            };
        }),
        'Object, Index': $d7352a8a7954f640$var$_getObjectProperty,
        'string, Index': $d7352a8a7954f640$var$_getSubstring,
        // set subset
        'Matrix, Index, any, any': function Matrix_Index_any_any(value, index, replacement, defaultValue) {
            if ((0, $d80Xp.isEmptyIndex)(index)) return value;
            (0, $d80Xp.validateIndexSourceSize)(value, index);
            return value.clone().subset(index, _broadcastReplacement(replacement, index), defaultValue);
        },
        'Array, Index, any, any': typed.referTo('Matrix, Index, any, any', function(subsetRef) {
            return function(value, index, replacement, defaultValue) {
                var subsetResult = subsetRef(matrix(value), index, replacement, defaultValue);
                return subsetResult.isMatrix ? subsetResult.valueOf() : subsetResult;
            };
        }),
        'Array, Index, any': typed.referTo('Matrix, Index, any, any', function(subsetRef) {
            return function(value, index, replacement) {
                return subsetRef(matrix(value), index, replacement, undefined).valueOf();
            };
        }),
        'Matrix, Index, any': typed.referTo('Matrix, Index, any, any', function(subsetRef) {
            return function(value, index, replacement) {
                return subsetRef(value, index, replacement, undefined);
            };
        }),
        'string, Index, string': $d7352a8a7954f640$var$_setSubstring,
        'string, Index, string, string': $d7352a8a7954f640$var$_setSubstring,
        'Object, Index, any': $d7352a8a7954f640$var$_setObjectProperty
    });
    /**
   * Broadcasts a replacment value to be the same size as index
   * @param {number | BigNumber | Array | Matrix} replacement Replacement value to try to broadcast
   * @param {*} index Index value
   * @returns broadcasted replacement that matches the size of index
   */ function _broadcastReplacement(replacement, index) {
        if (typeof replacement === 'string') throw new Error('can\'t boradcast a string');
        if (index._isScalar) return replacement;
        var indexSize = index.size();
        if (indexSize.every((d)=>d > 0)) try {
            return add(replacement, zeros(indexSize));
        } catch (error) {
            return replacement;
        }
        else return replacement;
    }
});
/**
 * Retrieve a subset of a string
 * @param {string} str            string from which to get a substring
 * @param {Index} index           An index or list of indices (character positions)
 * @returns {string} substring
 * @private
 */ function $d7352a8a7954f640$var$_getSubstring(str, index) {
    if (!(0, $edQYF.isIndex)(index)) // TODO: better error message
    throw new TypeError('Index expected');
    if ((0, $d80Xp.isEmptyIndex)(index)) return '';
    (0, $d80Xp.validateIndexSourceSize)(Array.from(str), index);
    if (index.size().length !== 1) throw new (0, $7asMt.DimensionError)(index.size().length, 1);
    // validate whether the range is out of range
    var strLen = str.length;
    (0, $d80Xp.validateIndex)(index.min()[0], strLen);
    (0, $d80Xp.validateIndex)(index.max()[0], strLen);
    var range = index.dimension(0);
    var substr = '';
    range.forEach(function(v) {
        substr += str.charAt(v);
    });
    return substr;
}
/**
 * Replace a substring in a string
 * @param {string} str            string to be replaced
 * @param {Index} index           An index or list of indices (character positions)
 * @param {string} replacement    Replacement string
 * @param {string} [defaultValue] Default value to be used when resizing
 *                                the string. is ' ' by default
 * @returns {string} result
 * @private
 */ function $d7352a8a7954f640$var$_setSubstring(str, index, replacement, defaultValue) {
    if (!index || index.isIndex !== true) // TODO: better error message
    throw new TypeError('Index expected');
    if ((0, $d80Xp.isEmptyIndex)(index)) return str;
    (0, $d80Xp.validateIndexSourceSize)(Array.from(str), index);
    if (index.size().length !== 1) throw new (0, $7asMt.DimensionError)(index.size().length, 1);
    if (defaultValue !== undefined) {
        if (typeof defaultValue !== 'string' || defaultValue.length !== 1) throw new TypeError('Single character expected as defaultValue');
    } else defaultValue = ' ';
    var range = index.dimension(0);
    var len = range.size()[0];
    if (len !== replacement.length) throw new (0, $7asMt.DimensionError)(range.size()[0], replacement.length);
    // validate whether the range is out of range
    var strLen = str.length;
    (0, $d80Xp.validateIndex)(index.min()[0]);
    (0, $d80Xp.validateIndex)(index.max()[0]);
    // copy the string into an array with characters
    var chars = [];
    for(var i = 0; i < strLen; i++)chars[i] = str.charAt(i);
    range.forEach(function(v, i) {
        chars[v] = replacement.charAt(i[0]);
    });
    // initialize undefined characters with a space
    if (chars.length > strLen) {
        for(var _i = strLen - 1, _len = chars.length; _i < _len; _i++)if (!chars[_i]) chars[_i] = defaultValue;
    }
    return chars.join('');
}
/**
 * Retrieve a property from an object
 * @param {Object} object
 * @param {Index} index
 * @return {*} Returns the value of the property
 * @private
 */ function $d7352a8a7954f640$var$_getObjectProperty(object, index) {
    if ((0, $d80Xp.isEmptyIndex)(index)) return undefined;
    if (index.size().length !== 1) throw new (0, $7asMt.DimensionError)(index.size(), 1);
    var key = index.dimension(0);
    if (typeof key !== 'string') throw new TypeError('String expected as index to retrieve an object property');
    return (0, $1q0jW.getSafeProperty)(object, key);
}
/**
 * Set a property on an object
 * @param {Object} object
 * @param {Index} index
 * @param {*} replacement
 * @return {*} Returns the updated object
 * @private
 */ function $d7352a8a7954f640$var$_setObjectProperty(object, index, replacement) {
    if ((0, $d80Xp.isEmptyIndex)(index)) return object;
    if (index.size().length !== 1) throw new (0, $7asMt.DimensionError)(index.size(), 1);
    var key = index.dimension(0);
    if (typeof key !== 'string') throw new TypeError('String expected as index to retrieve an object property');
    // clone the object, and apply the property to the clone
    var updated = (0, $9v8q6.clone)(object);
    (0, $1q0jW.setSafeProperty)(updated, key, replacement);
    return updated;
}

});

parcelRegister("jDUs5", function(module, exports) {

$parcel$export(module.exports, "createSubtract", () => $e4cd730486699a61$export$cd7a6c131b18ab16);

var $dsu7t = parcelRequire("dsu7t");

var $ahu8B = parcelRequire("ahu8B");

var $a8bto = parcelRequire("a8bto");

var $g1nxb = parcelRequire("g1nxb");

var $enjrI = parcelRequire("enjrI");

var $19L2p = parcelRequire("19L2p");

var $6SJnV = parcelRequire("6SJnV");
var $e4cd730486699a61$var$name = 'subtract';
var $e4cd730486699a61$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'subtractScalar',
    'unaryMinus',
    'DenseMatrix',
    'concat'
];
var $e4cd730486699a61$export$cd7a6c131b18ab16 = /* #__PURE__ */ (0, $dsu7t.factory)($e4cd730486699a61$var$name, $e4cd730486699a61$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, subtractScalar: subtractScalar, unaryMinus: unaryMinus, DenseMatrix: DenseMatrix, concat: concat } = _ref;
    // TODO: split function subtract in two: subtract and subtractScalar
    var matAlgo01xDSid = (0, $ahu8B.createMatAlgo01xDSid)({
        typed: typed
    });
    var matAlgo03xDSf = (0, $a8bto.createMatAlgo03xDSf)({
        typed: typed
    });
    var matAlgo05xSfSf = (0, $g1nxb.createMatAlgo05xSfSf)({
        typed: typed,
        equalScalar: equalScalar
    });
    var matAlgo10xSids = (0, $enjrI.createMatAlgo10xSids)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Subtract two values, `x - y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.subtract(x, y)
   *
   * Examples:
   *
   *    math.subtract(5.3, 2)        // returns number 3.3
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(4, 1)
   *    math.subtract(a, b)          // returns Complex -2 + 2i
   *
   *    math.subtract([5, 7, 4], 4)  // returns Array [1, 3, 0]
   *
   *    const c = math.unit('2.1 km')
   *    const d = math.unit('500m')
   *    math.subtract(c, d)          // returns Unit 1.6 km
   *
   * See also:
   *
   *    add
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} x Initial value
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} y Value to subtract from `x`
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} Subtraction of `x` and `y`
   */ return typed($e4cd730486699a61$var$name, {
        'any, any': subtractScalar
    }, matrixAlgorithmSuite({
        elop: subtractScalar,
        SS: matAlgo05xSfSf,
        DS: matAlgo01xDSid,
        SD: matAlgo03xDSf,
        Ss: matAlgo12xSfs,
        sS: matAlgo10xSids
    }));
});

});

parcelRegister("g06cf", function(module, exports) {

$parcel$export(module.exports, "createSubtractScalar", () => $ba6173f302c1f0d7$export$7b5719caf153b43d);

var $dsu7t = parcelRequire("dsu7t");

var $dmcGu = parcelRequire("dmcGu");
var $ba6173f302c1f0d7$var$name = 'subtractScalar';
var $ba6173f302c1f0d7$var$dependencies = [
    'typed'
];
var $ba6173f302c1f0d7$export$7b5719caf153b43d = /* #__PURE__ */ (0, $dsu7t.factory)($ba6173f302c1f0d7$var$name, $ba6173f302c1f0d7$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Subtract two scalar values, `x - y`.
   * This function is meant for internal use: it is used by the public function
   * `subtract`
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit} x   First value
   * @param  {number | BigNumber | bigint | Fraction | Complex} y          Second value to be subtracted from `x`
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit}     Difference of `x` and `y`
   * @private
   */ return typed($ba6173f302c1f0d7$var$name, {
        'number, number': (0, $dmcGu.subtractNumber),
        'Complex, Complex': function Complex_Complex(x, y) {
            return x.sub(y);
        },
        'BigNumber, BigNumber': function BigNumber_BigNumber(x, y) {
            return x.minus(y);
        },
        'bigint, bigint': function bigint_bigint(x, y) {
            return x - y;
        },
        'Fraction, Fraction': function Fraction_Fraction(x, y) {
            return x.sub(y);
        },
        'Unit, Unit': typed.referToSelf((self)=>(x, y)=>{
                if (x.value === null || x.value === undefined) throw new Error('Parameter x contains a unit with undefined value');
                if (y.value === null || y.value === undefined) throw new Error('Parameter y contains a unit with undefined value');
                if (!x.equalBase(y)) throw new Error('Units do not match');
                var res = x.clone();
                res.value = typed.find(self, [
                    res.valueType(),
                    y.valueType()
                ])(res.value, y.value);
                res.fixPrefix = false;
                return res;
            })
    });
});

});

parcelRegister("5t5dw", function(module, exports) {

$parcel$export(module.exports, "createSum", () => $3fb3b52d86620eff$export$14d444d810bc35b5);

var $20mkw = parcelRequire("20mkw");

var $dsu7t = parcelRequire("dsu7t");

var $6NnhX = parcelRequire("6NnhX");

var $a2CJg = parcelRequire("a2CJg");
var $3fb3b52d86620eff$var$name = 'sum';
var $3fb3b52d86620eff$var$dependencies = [
    'typed',
    'config',
    'add',
    'numeric'
];
var $3fb3b52d86620eff$export$14d444d810bc35b5 = /* #__PURE__ */ (0, $dsu7t.factory)($3fb3b52d86620eff$var$name, $3fb3b52d86620eff$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, add: add, numeric: numeric } = _ref;
    /**
   * Compute the sum of a matrix or a list with values.
   * In case of a multidimensional array or matrix, the sum of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.sum(a, b, c, ...)
   *     math.sum(A)
   *     math.sum(A, dimension)
   *
   * Examples:
   *
   *     math.sum(2, 1, 4, 3)               // returns 10
   *     math.sum([2, 1, 4, 3])             // returns 10
   *     math.sum([[2, 5], [4, 3], [1, 7]]) // returns 22
   *
   * See also:
   *
   *    mean, median, min, max, prod, std, variance, cumsum
   *
   * @param {... *} args  A single matrix or multiple scalar values
   * @return {*} The sum of all values
   */ return typed($3fb3b52d86620eff$var$name, {
        // sum([a, b, c, d, ...])
        'Array | Matrix': _sum,
        // sum([a, b, c, d, ...], dim)
        'Array | Matrix, number | BigNumber': _nsumDim,
        // sum(a, b, c, d, ...)
        '...': function _(args) {
            if ((0, $20mkw.containsCollections)(args)) throw new TypeError('Scalar values expected in function sum');
            return _sum(args);
        }
    });
    /**
   * Recursively calculate the sum of an n-dimensional array
   * @param {Array | Matrix} array
   * @return {number} sum
   * @private
   */ function _sum(array) {
        var sum;
        (0, $20mkw.deepForEach)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
            } catch (err) {
                throw (0, $a2CJg.improveErrorMessage)(err, 'sum', value);
            }
        });
        // make sure returning numeric value: parse a string into a numeric value
        if (sum === undefined) sum = numeric(0, config.number);
        if (typeof sum === 'string') sum = numeric(sum, (0, $6NnhX.safeNumberType)(sum, config));
        return sum;
    }
    function _nsumDim(array, dim) {
        try {
            var sum = (0, $20mkw.reduce)(array, dim, add);
            return sum;
        } catch (err) {
            throw (0, $a2CJg.improveErrorMessage)(err, 'sum');
        }
    }
});

});

parcelRegister("3vNp3", function(module, exports) {

$parcel$export(module.exports, "createSylvester", () => $28ea96ca14084e14$export$9b5f479487e82b81);

var $dsu7t = parcelRequire("dsu7t");
var $28ea96ca14084e14$var$name = 'sylvester';
var $28ea96ca14084e14$var$dependencies = [
    'typed',
    'schur',
    'matrixFromColumns',
    'matrix',
    'multiply',
    'range',
    'concat',
    'transpose',
    'index',
    'subset',
    'add',
    'subtract',
    'identity',
    'lusolve',
    'abs'
];
var $28ea96ca14084e14$export$9b5f479487e82b81 = /* #__PURE__ */ (0, $dsu7t.factory)($28ea96ca14084e14$var$name, $28ea96ca14084e14$var$dependencies, (_ref)=>{
    var { typed: typed, schur: schur, matrixFromColumns: matrixFromColumns, matrix: matrix, multiply: multiply, range: range, concat: concat, transpose: transpose, index: index, subset: subset, add: add, subtract: subtract, identity: identity, lusolve: lusolve, abs: abs } = _ref;
    /**
   *
   * Solves the real-valued Sylvester equation AX+XB=C for X, where A, B and C are
   * matrices of appropriate dimensions, being A and B squared. Notice that other
   * equivalent definitions for the Sylvester equation exist and this function
   * assumes the one presented in the original publication of the the Bartels-
   * Stewart algorithm, which is implemented by this function.
   * https://en.wikipedia.org/wiki/Sylvester_equation
   *
   * Syntax:
   *
   *     math.sylvester(A, B, C)
   *
   * Examples:
   *
   *     const A = [[-1, -2], [1, 1]]
   *     const B = [[2, -1], [1, -2]]
   *     const C = [[-3, 2], [3, 0]]
   *     math.sylvester(A, B, C)      // returns DenseMatrix [[-0.25, 0.25], [1.5, -1.25]]
   *
   * See also:
   *
   *     schur, lyap
   *
   * @param {Matrix | Array} A  Matrix A
   * @param {Matrix | Array} B  Matrix B
   * @param {Matrix | Array} C  Matrix C
   * @return {Matrix | Array}   Matrix X, solving the Sylvester equation
   */ return typed($28ea96ca14084e14$var$name, {
        'Matrix, Matrix, Matrix': _sylvester,
        'Array, Matrix, Matrix': function Array_Matrix_Matrix(A, B, C) {
            return _sylvester(matrix(A), B, C);
        },
        'Array, Array, Matrix': function Array_Array_Matrix(A, B, C) {
            return _sylvester(matrix(A), matrix(B), C);
        },
        'Array, Matrix, Array': function Array_Matrix_Array(A, B, C) {
            return _sylvester(matrix(A), B, matrix(C));
        },
        'Matrix, Array, Matrix': function Matrix_Array_Matrix(A, B, C) {
            return _sylvester(A, matrix(B), C);
        },
        'Matrix, Array, Array': function Matrix_Array_Array(A, B, C) {
            return _sylvester(A, matrix(B), matrix(C));
        },
        'Matrix, Matrix, Array': function Matrix_Matrix_Array(A, B, C) {
            return _sylvester(A, B, matrix(C));
        },
        'Array, Array, Array': function Array_Array_Array(A, B, C) {
            return _sylvester(matrix(A), matrix(B), matrix(C)).toArray();
        }
    });
    function _sylvester(A, B, C) {
        var n = B.size()[0];
        var m = A.size()[0];
        var sA = schur(A);
        var F = sA.T;
        var U = sA.U;
        var sB = schur(multiply(-1, B));
        var G = sB.T;
        var V = sB.U;
        var D = multiply(multiply(transpose(U), C), V);
        var all = range(0, m);
        var y = [];
        var hc = (a, b)=>concat(a, b, 1);
        var vc = (a, b)=>concat(a, b, 0);
        for(var k = 0; k < n; k++)if (k < n - 1 && abs(subset(G, index(k + 1, k))) > 1e-5) {
            var RHS = vc(subset(D, index(all, k)), subset(D, index(all, k + 1)));
            for(var j = 0; j < k; j++)RHS = add(RHS, vc(multiply(y[j], subset(G, index(j, k))), multiply(y[j], subset(G, index(j, k + 1)))));
            var gkk = multiply(identity(m), multiply(-1, subset(G, index(k, k))));
            var gmk = multiply(identity(m), multiply(-1, subset(G, index(k + 1, k))));
            var gkm = multiply(identity(m), multiply(-1, subset(G, index(k, k + 1))));
            var gmm = multiply(identity(m), multiply(-1, subset(G, index(k + 1, k + 1))));
            var LHS = vc(hc(add(F, gkk), gmk), hc(gkm, add(F, gmm)));
            var yAux = lusolve(LHS, RHS);
            y[k] = yAux.subset(index(range(0, m), 0));
            y[k + 1] = yAux.subset(index(range(m, 2 * m), 0));
            k++;
        } else {
            var _RHS = subset(D, index(all, k));
            for(var _j = 0; _j < k; _j++)_RHS = add(_RHS, multiply(y[_j], subset(G, index(_j, k))));
            var _gkk = subset(G, index(k, k));
            var _LHS = subtract(F, multiply(_gkk, identity(m)));
            y[k] = lusolve(_LHS, _RHS);
        }
        var Y = matrix(matrixFromColumns(...y));
        var X = multiply(U, multiply(Y, transpose(V)));
        return X;
    }
});

});

parcelRegister("0192i", function(module, exports) {

$parcel$export(module.exports, "createTan", () => $00371a81b521a76e$export$b61ad4f38fd9301d);

var $dsu7t = parcelRequire("dsu7t");

var $aS62J = parcelRequire("aS62J");
var $00371a81b521a76e$var$name = 'tan';
var $00371a81b521a76e$var$dependencies = [
    'typed'
];
var $00371a81b521a76e$export$b61ad4f38fd9301d = /* #__PURE__ */ (0, $dsu7t.factory)($00371a81b521a76e$var$name, $00371a81b521a76e$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    var trigUnit = (0, $aS62J.createTrigUnit)({
        typed: typed
    });
    /**
   * Calculate the tangent of a value. `tan(x)` is equal to `sin(x) / cos(x)`.
   *
   * To avoid confusion with the matrix tangent, this function does not apply
   * to matrices.
   *
   * Syntax:
   *
   *    math.tan(x)
   *
   * Examples:
   *
   *    math.tan(0.5)                    // returns number 0.5463024898437905
   *    math.sin(0.5) / math.cos(0.5)    // returns number 0.5463024898437905
   *    math.tan(math.pi / 4)            // returns number 1
   *    math.tan(math.unit(45, 'deg'))   // returns number 1
   *
   * See also:
   *
   *    atan, sin, cos
   *
   * @param {number | BigNumber | Complex | Unit} x  Function input
   * @return {number | BigNumber | Complex} Tangent of x
   */ return typed($00371a81b521a76e$var$name, {
        number: Math.tan,
        'Complex | BigNumber': (x)=>x.tan()
    }, trigUnit);
});

});

parcelRegister("hUTLZ", function(module, exports) {

$parcel$export(module.exports, "createTanh", () => $d0b2edfc9f14cc17$export$e1f66a5bda779194);

var $dsu7t = parcelRequire("dsu7t");

var $6NnhX = parcelRequire("6NnhX");
var $d0b2edfc9f14cc17$var$name = 'tanh';
var $d0b2edfc9f14cc17$var$dependencies = [
    'typed'
];
var $d0b2edfc9f14cc17$export$e1f66a5bda779194 = /* #__PURE__ */ (0, $dsu7t.factory)($d0b2edfc9f14cc17$var$name, $d0b2edfc9f14cc17$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic tangent of a value,
   * defined as `tanh(x) = (exp(2 * x) - 1) / (exp(2 * x) + 1)`.
   *
   * To avoid confusion with matrix hyperbolic tangent, this function does
   * not apply to matrices.
   *
   * Syntax:
   *
   *    math.tanh(x)
   *
   * Examples:
   *
   *    // tanh(x) = sinh(x) / cosh(x) = 1 / coth(x)
   *    math.tanh(0.5)                   // returns 0.46211715726000974
   *    math.sinh(0.5) / math.cosh(0.5)  // returns 0.46211715726000974
   *    1 / math.coth(0.5)               // returns 0.46211715726000974
   *
   * See also:
   *
   *    sinh, cosh, coth
   *
   * @param {number | BigNumber | Complex} x  Function input
   * @return {number | BigNumber | Complex} Hyperbolic tangent of x
   */ return typed('tanh', {
        number: (0, $6NnhX.tanh),
        'Complex | BigNumber': (x)=>x.tanh()
    });
});

});

parcelRegister("iskkf", function(module, exports) {

$parcel$export(module.exports, "createTo", () => $d6fa9bbe52784133$export$6e6c19ceb4cd6856);

var $dsu7t = parcelRequire("dsu7t");

var $6SJnV = parcelRequire("6SJnV");
var $d6fa9bbe52784133$var$name = 'to';
var $d6fa9bbe52784133$var$dependencies = [
    'typed',
    'matrix',
    'concat'
];
var $d6fa9bbe52784133$export$6e6c19ceb4cd6856 = /* #__PURE__ */ (0, $dsu7t.factory)($d6fa9bbe52784133$var$name, $d6fa9bbe52784133$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, concat: concat } = _ref;
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Change the unit of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.to(x, unit)
   *
   * Examples:
   *
   *    math.to(math.unit('2 inch'), 'cm')             // returns Unit 5.08 cm
   *    math.to(math.unit('2 inch'), math.unit('cm'))  // returns Unit 5.08 cm
   *    math.to(math.unit(16, 'bytes'), 'bits')        // returns Unit 128 bits
   *
   * See also:
   *
   *    unit
   *
   * @param {Unit | Array | Matrix} x     The unit to be converted.
   * @param {Unit | Array | Matrix} unit  New unit. Can be a string like "cm"
   *                                      or a unit without value.
   * @return {Unit | Array | Matrix} value with changed, fixed unit.
   */ return typed($d6fa9bbe52784133$var$name, {
        'Unit, Unit | string': (x, unit)=>x.to(unit)
    }, matrixAlgorithmSuite({
        Ds: true
    }));
});

});

parcelRegister("xK9o8", function(module, exports) {

$parcel$export(module.exports, "createToBest", () => $0656e1b201375082$export$ae4808540ad44519);

var $dsu7t = parcelRequire("dsu7t");
var $0656e1b201375082$var$name = 'toBest';
var $0656e1b201375082$var$dependencies = [
    'typed'
];
var $0656e1b201375082$export$ae4808540ad44519 = /* #__PURE__ */ (0, $dsu7t.factory)($0656e1b201375082$var$name, $0656e1b201375082$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Converts a unit to the most appropriate display unit.
   * When no preferred units are provided, the function automatically find the best prefix.
   * When preferred units are provided, it converts to
   * the unit that gives a value closest to 1.
   *
   * Syntax:
   *
   *    math.toBest(unit)
   *    math.toBest(unit, unitList)
   *    math.toBest(unit, unitList, options)
   *
   * Where:
   * - `unitList` is an optional array of preferred target units as string or Unit.
   * - `options` is an optional object with options, formed as follows:
   * - `offset`: number | BigNumber
   *
   * Examples:
   *
   *   math.unit(0.05, 'm').toBest(['cm', 'mm'])                 // returns Unit 5 cm
   *   math.unit(2 / 3, 'cm').toBest()                           // returns Unit 0.6666666666666666 cm
   *   math.unit(10, 'm').toBest(['mm', 'km'], { offset: 1.5 })  // returns Unit 10000 mm
   *
   * See also:
   *
   *    unit, to, format
   *
   * @param {Unit} x                          The unit to be converted
   * @param {Array<string>} [unitList=[]]     Optional array of preferred target units
   * @param {Object} [options]                Optional options object
   * @return {Unit}                           Value converted to the best matching unit
   */ return typed($0656e1b201375082$var$name, {
        Unit: (x)=>x.toBest(),
        'Unit, string': (x, unitList)=>x.toBest(unitList.split(',')),
        'Unit, string, Object': (x, unitList, options)=>x.toBest(unitList.split(','), options),
        'Unit, Array': (x, unitList)=>x.toBest(unitList),
        'Unit, Array, Object': (x, unitList, options)=>x.toBest(unitList, options)
    });
});

});

parcelRegister("6Hcsa", function(module, exports) {

$parcel$export(module.exports, "createTrace", () => $4e006b383c24208f$export$acff8254414be03b);

var $9v8q6 = parcelRequire("9v8q6");

var $j2hDb = parcelRequire("j2hDb");

var $dsu7t = parcelRequire("dsu7t");
var $4e006b383c24208f$var$name = 'trace';
var $4e006b383c24208f$var$dependencies = [
    'typed',
    'matrix',
    'add'
];
var $4e006b383c24208f$export$acff8254414be03b = /* #__PURE__ */ (0, $dsu7t.factory)($4e006b383c24208f$var$name, $4e006b383c24208f$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, add: add } = _ref;
    /**
   * Calculate the trace of a matrix: the sum of the elements on the main
   * diagonal of a square matrix.
   *
   * Syntax:
   *
   *    math.trace(x)
   *
   * Examples:
   *
   *    math.trace([[1, 2], [3, 4]]) // returns 5
   *
   *    const A = [
   *      [1, 2, 3],
   *      [-1, 2, 3],
   *      [2, 0, 3]
   *    ]
   *    math.trace(A) // returns 6
   *
   * See also:
   *
   *    diag
   *
   * @param {Array | Matrix} x  A matrix
   *
   * @return {number} The trace of `x`
   */ return typed('trace', {
        Array: function _arrayTrace(x) {
            // use dense matrix implementation
            return _denseTrace(matrix(x));
        },
        SparseMatrix: _sparseTrace,
        DenseMatrix: _denseTrace,
        any: (0, $9v8q6.clone)
    });
    function _denseTrace(m) {
        // matrix size & data
        var size = m._size;
        var data = m._data;
        // process dimensions
        switch(size.length){
            case 1:
                // vector
                if (size[0] === 1) // return data[0]
                return (0, $9v8q6.clone)(data[0]);
                throw new RangeError('Matrix must be square (size: ' + (0, $j2hDb.format)(size) + ')');
            case 2:
                // two dimensional
                var rows = size[0];
                var cols = size[1];
                if (rows === cols) {
                    // calulate sum
                    var sum = 0;
                    // loop diagonal
                    for(var i = 0; i < rows; i++)sum = add(sum, data[i][i]);
                    // return trace
                    return sum;
                } else throw new RangeError('Matrix must be square (size: ' + (0, $j2hDb.format)(size) + ')');
            default:
                // multi dimensional
                throw new RangeError('Matrix must be two dimensional (size: ' + (0, $j2hDb.format)(size) + ')');
        }
    }
    function _sparseTrace(m) {
        // matrix arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        var size = m._size;
        // check dimensions
        var rows = size[0];
        var columns = size[1];
        // matrix must be square
        if (rows === columns) {
            // calulate sum
            var sum = 0;
            // check we have data (avoid looping columns)
            if (values.length > 0) // loop columns
            for(var j = 0; j < columns; j++){
                // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
                var k0 = ptr[j];
                var k1 = ptr[j + 1];
                // loop k within [k0, k1[
                for(var k = k0; k < k1; k++){
                    // row index
                    var i = index[k];
                    // check row
                    if (i === j) {
                        // accumulate value
                        sum = add(sum, values[k]);
                        break;
                    }
                    if (i > j) break;
                }
            }
            // return trace
            return sum;
        }
        throw new RangeError('Matrix must be square (size: ' + (0, $j2hDb.format)(size) + ')');
    }
});

});

parcelRegister("gFmi9", function(module, exports) {

$parcel$export(module.exports, "createTranspose", () => $c221c45f905b2cad$export$9a8c88485f8f638b);

var $9v8q6 = parcelRequire("9v8q6");

var $j2hDb = parcelRequire("j2hDb");

var $dsu7t = parcelRequire("dsu7t");
var $c221c45f905b2cad$var$name = 'transpose';
var $c221c45f905b2cad$var$dependencies = [
    'typed',
    'matrix'
];
var $c221c45f905b2cad$export$9a8c88485f8f638b = /* #__PURE__ */ (0, $dsu7t.factory)($c221c45f905b2cad$var$name, $c221c45f905b2cad$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    /**
   * Transpose a matrix. All values of the matrix are reflected over its
   * main diagonal. Only applicable to two dimensional matrices containing
   * a vector (i.e. having size `[1,n]` or `[n,1]`). One dimensional
   * vectors and scalars return the input unchanged.
   *
   * Syntax:
   *
   *     math.transpose(x)
   *
   * Examples:
   *
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.transpose(A)               // returns [[1, 4], [2, 5], [3, 6]]
   *
   * See also:
   *
   *     diag, inv, subset, squeeze
   *
   * @param {Array | Matrix} x  Matrix to be transposed
   * @return {Array | Matrix}   The transposed matrix
   */ return typed($c221c45f905b2cad$var$name, {
        Array: (x)=>transposeMatrix(matrix(x)).valueOf(),
        Matrix: transposeMatrix,
        any: (0, $9v8q6.clone // scalars
        )
    });
    function transposeMatrix(x) {
        // matrix size
        var size = x.size();
        // result
        var c;
        // process dimensions
        switch(size.length){
            case 1:
                // vector
                c = x.clone();
                break;
            case 2:
                // rows and columns
                var rows = size[0];
                var columns = size[1];
                // check columns
                if (columns === 0) // throw exception
                throw new RangeError('Cannot transpose a 2D matrix with no columns (size: ' + (0, $j2hDb.format)(size) + ')');
                // process storage format
                switch(x.storage()){
                    case 'dense':
                        c = _denseTranspose(x, rows, columns);
                        break;
                    case 'sparse':
                        c = _sparseTranspose(x, rows, columns);
                        break;
                }
                break;
            default:
                // multi dimensional
                throw new RangeError('Matrix must be a vector or two dimensional (size: ' + (0, $j2hDb.format)(size) + ')');
        }
        return c;
    }
    function _denseTranspose(m, rows, columns) {
        // matrix array
        var data = m._data;
        // transposed matrix data
        var transposed = [];
        var transposedRow;
        // loop columns
        for(var j = 0; j < columns; j++){
            // initialize row
            transposedRow = transposed[j] = [];
            // loop rows
            for(var i = 0; i < rows; i++)// set data
            transposedRow[i] = (0, $9v8q6.clone)(data[i][j]);
        }
        // return matrix
        return m.createDenseMatrix({
            data: transposed,
            size: [
                columns,
                rows
            ],
            datatype: m._datatype
        });
    }
    function _sparseTranspose(m, rows, columns) {
        // matrix arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        // result matrices
        var cvalues = values ? [] : undefined;
        var cindex = [];
        var cptr = [];
        // row counts
        var w = [];
        for(var x = 0; x < rows; x++)w[x] = 0;
        // vars
        var p, l, j;
        // loop values in matrix
        for(p = 0, l = index.length; p < l; p++)// number of values in row
        w[index[p]]++;
        // cumulative sum
        var sum = 0;
        // initialize cptr with the cummulative sum of row counts
        for(var i = 0; i < rows; i++){
            // update cptr
            cptr.push(sum);
            // update sum
            sum += w[i];
            // update w
            w[i] = cptr[i];
        }
        // update cptr
        cptr.push(sum);
        // loop columns
        for(j = 0; j < columns; j++)// values & index in column
        for(var k0 = ptr[j], k1 = ptr[j + 1], k = k0; k < k1; k++){
            // C values & index
            var q = w[index[k]]++;
            // C[j, i] = A[i, j]
            cindex[q] = j;
            // check we need to process values (pattern matrix)
            if (values) cvalues[q] = (0, $9v8q6.clone)(values[k]);
        }
        // return matrix
        return m.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                columns,
                rows
            ],
            datatype: m._datatype
        });
    }
});

});

parcelRegister("jy02X", function(module, exports) {

$parcel$export(module.exports, "createTyped", () => $e3b13a8b9cfe0a8d$export$8597b5d47504f989);
/**
 * Create a typed-function which checks the types of the arguments and
 * can match them against multiple provided signatures. The typed-function
 * automatically converts inputs in order to find a matching signature.
 * Typed functions throw informative errors in case of wrong input arguments.
 *
 * See the library [typed-function](https://github.com/josdejong/typed-function)
 * for detailed documentation.
 *
 * Syntax:
 *
 *     math.typed(name, signatures) : function
 *     math.typed(signatures) : function
 *
 * Examples:
 *
 *     // create a typed function with multiple types per argument (type union)
 *     const fn2 = typed({
 *       'number | boolean': function (b) {
 *         return 'b is a number or boolean'
 *       },
 *       'string, number | boolean': function (a, b) {
 *         return 'a is a string, b is a number or boolean'
 *       }
 *     })
 *
 *     // create a typed function with an any type argument
 *     const log = typed({
 *       'string, any': function (event, data) {
 *         console.log('event: ' + event + ', data: ' + JSON.stringify(data))
 *       }
 *     })
 *
 * @param {string} [name]                          Optional name for the typed-function
 * @param {Object<string, function>} signatures   Object with one or multiple function signatures
 * @returns {function} The created typed-function.
 */ 
var $d3cj9 = parcelRequire("d3cj9");

var $dsu7t = parcelRequire("dsu7t");

var $edQYF = parcelRequire("edQYF");

var $6NnhX = parcelRequire("6NnhX");
// returns a new instance of typed-function
var $e3b13a8b9cfe0a8d$var$_createTyped2 = function _createTyped() {
    // initially, return the original instance of typed-function
    // consecutively, return a new instance from typed.create.
    $e3b13a8b9cfe0a8d$var$_createTyped2 = (0, (/*@__PURE__*/$parcel$interopDefault($d3cj9))).create;
    return 0, (/*@__PURE__*/$parcel$interopDefault($d3cj9));
};
var $e3b13a8b9cfe0a8d$var$dependencies = [
    '?BigNumber',
    '?Complex',
    '?DenseMatrix',
    '?Fraction'
];
var $e3b13a8b9cfe0a8d$export$8597b5d47504f989 = /* #__PURE__ */ (0, $dsu7t.factory)('typed', $e3b13a8b9cfe0a8d$var$dependencies, function createTyped(_ref) {
    var { BigNumber: BigNumber, Complex: Complex, DenseMatrix: DenseMatrix, Fraction: Fraction } = _ref;
    // TODO: typed-function must be able to silently ignore signatures with unknown data types
    // get a new instance of typed-function
    var typed = $e3b13a8b9cfe0a8d$var$_createTyped2();
    // define all types. The order of the types determines in which order function
    // arguments are type-checked (so for performance it's important to put the
    // most used types first).
    typed.clear();
    typed.addTypes([
        {
            name: 'number',
            test: (0, $edQYF.isNumber)
        },
        {
            name: 'Complex',
            test: (0, $edQYF.isComplex)
        },
        {
            name: 'BigNumber',
            test: (0, $edQYF.isBigNumber)
        },
        {
            name: 'bigint',
            test: (0, $edQYF.isBigInt)
        },
        {
            name: 'Fraction',
            test: (0, $edQYF.isFraction)
        },
        {
            name: 'Unit',
            test: (0, $edQYF.isUnit)
        },
        // The following type matches a valid variable name, i.e., an alphanumeric
        // string starting with an alphabetic character. It is used (at least)
        // in the definition of the derivative() function, as the argument telling
        // what to differentiate over must (currently) be a variable.
        // TODO: deprecate the identifier type (it's not used anymore, see https://github.com/josdejong/mathjs/issues/3253)
        {
            name: 'identifier',
            test: (s)=>(0, $edQYF.isString) && /^(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC4\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])(?:[0-9A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC4\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])*$/.test(s)
        },
        {
            name: 'string',
            test: (0, $edQYF.isString)
        },
        {
            name: 'Chain',
            test: (0, $edQYF.isChain)
        },
        {
            name: 'Array',
            test: (0, $edQYF.isArray)
        },
        {
            name: 'Matrix',
            test: (0, $edQYF.isMatrix)
        },
        {
            name: 'DenseMatrix',
            test: (0, $edQYF.isDenseMatrix)
        },
        {
            name: 'SparseMatrix',
            test: (0, $edQYF.isSparseMatrix)
        },
        {
            name: 'Range',
            test: (0, $edQYF.isRange)
        },
        {
            name: 'Index',
            test: (0, $edQYF.isIndex)
        },
        {
            name: 'boolean',
            test: (0, $edQYF.isBoolean)
        },
        {
            name: 'ResultSet',
            test: (0, $edQYF.isResultSet)
        },
        {
            name: 'Help',
            test: (0, $edQYF.isHelp)
        },
        {
            name: 'function',
            test: (0, $edQYF.isFunction)
        },
        {
            name: 'Date',
            test: (0, $edQYF.isDate)
        },
        {
            name: 'RegExp',
            test: (0, $edQYF.isRegExp)
        },
        {
            name: 'null',
            test: (0, $edQYF.isNull)
        },
        {
            name: 'undefined',
            test: (0, $edQYF.isUndefined)
        },
        {
            name: 'AccessorNode',
            test: (0, $edQYF.isAccessorNode)
        },
        {
            name: 'ArrayNode',
            test: (0, $edQYF.isArrayNode)
        },
        {
            name: 'AssignmentNode',
            test: (0, $edQYF.isAssignmentNode)
        },
        {
            name: 'BlockNode',
            test: (0, $edQYF.isBlockNode)
        },
        {
            name: 'ConditionalNode',
            test: (0, $edQYF.isConditionalNode)
        },
        {
            name: 'ConstantNode',
            test: (0, $edQYF.isConstantNode)
        },
        {
            name: 'FunctionNode',
            test: (0, $edQYF.isFunctionNode)
        },
        {
            name: 'FunctionAssignmentNode',
            test: (0, $edQYF.isFunctionAssignmentNode)
        },
        {
            name: 'IndexNode',
            test: (0, $edQYF.isIndexNode)
        },
        {
            name: 'Node',
            test: (0, $edQYF.isNode)
        },
        {
            name: 'ObjectNode',
            test: (0, $edQYF.isObjectNode)
        },
        {
            name: 'OperatorNode',
            test: (0, $edQYF.isOperatorNode)
        },
        {
            name: 'ParenthesisNode',
            test: (0, $edQYF.isParenthesisNode)
        },
        {
            name: 'RangeNode',
            test: (0, $edQYF.isRangeNode)
        },
        {
            name: 'RelationalNode',
            test: (0, $edQYF.isRelationalNode)
        },
        {
            name: 'SymbolNode',
            test: (0, $edQYF.isSymbolNode)
        },
        {
            name: 'Map',
            test: (0, $edQYF.isMap)
        },
        {
            name: 'Object',
            test: (0, $edQYF.isObject)
        } // order 'Object' last, it matches on other classes too
    ]);
    typed.addConversions([
        {
            from: 'number',
            to: 'BigNumber',
            convert: function convert(x) {
                if (!BigNumber) $e3b13a8b9cfe0a8d$var$throwNoBignumber(x);
                // note: conversion from number to BigNumber can fail if x has >15 digits
                if ((0, $6NnhX.digits)(x) > 15) throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + x + '). ' + 'Use function bignumber(x) to convert to BigNumber.');
                return new BigNumber(x);
            }
        },
        {
            from: 'number',
            to: 'Complex',
            convert: function convert(x) {
                if (!Complex) $e3b13a8b9cfe0a8d$var$throwNoComplex(x);
                return new Complex(x, 0);
            }
        },
        {
            from: 'BigNumber',
            to: 'Complex',
            convert: function convert(x) {
                if (!Complex) $e3b13a8b9cfe0a8d$var$throwNoComplex(x);
                return new Complex(x.toNumber(), 0);
            }
        },
        {
            from: 'bigint',
            to: 'number',
            convert: function convert(x) {
                if (x > Number.MAX_SAFE_INTEGER) throw new TypeError("Cannot implicitly convert bigint to number: value exceeds the max safe integer value (value: " + x + ')');
                return Number(x);
            }
        },
        {
            from: 'bigint',
            to: 'BigNumber',
            convert: function convert(x) {
                if (!BigNumber) $e3b13a8b9cfe0a8d$var$throwNoBignumber(x);
                return new BigNumber(x.toString());
            }
        },
        {
            from: 'bigint',
            to: 'Fraction',
            convert: function convert(x) {
                if (!Fraction) $e3b13a8b9cfe0a8d$var$throwNoFraction(x);
                return new Fraction(x);
            }
        },
        {
            from: 'Fraction',
            to: 'BigNumber',
            convert: function convert(x) {
                throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
            }
        },
        {
            from: 'Fraction',
            to: 'Complex',
            convert: function convert(x) {
                if (!Complex) $e3b13a8b9cfe0a8d$var$throwNoComplex(x);
                return new Complex(x.valueOf(), 0);
            }
        },
        {
            from: 'number',
            to: 'Fraction',
            convert: function convert(x) {
                if (!Fraction) $e3b13a8b9cfe0a8d$var$throwNoFraction(x);
                var f = new Fraction(x);
                if (f.valueOf() !== x) throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + x + '). ' + 'Use function fraction(x) to convert to Fraction.');
                return f;
            }
        },
        {
            // FIXME: add conversion from Fraction to number, for example for `sqrt(fraction(1,3))`
            //  from: 'Fraction',
            //  to: 'number',
            //  convert: function (x) {
            //    return x.valueOf()
            //  }
            // }, {
            from: 'string',
            to: 'number',
            convert: function convert(x) {
                var n = Number(x);
                if (isNaN(n)) throw new Error('Cannot convert "' + x + '" to a number');
                return n;
            }
        },
        {
            from: 'string',
            to: 'BigNumber',
            convert: function convert(x) {
                if (!BigNumber) $e3b13a8b9cfe0a8d$var$throwNoBignumber(x);
                try {
                    return new BigNumber(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to BigNumber');
                }
            }
        },
        {
            from: 'string',
            to: 'bigint',
            convert: function convert(x) {
                try {
                    return BigInt(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to BigInt');
                }
            }
        },
        {
            from: 'string',
            to: 'Fraction',
            convert: function convert(x) {
                if (!Fraction) $e3b13a8b9cfe0a8d$var$throwNoFraction(x);
                try {
                    return new Fraction(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to Fraction');
                }
            }
        },
        {
            from: 'string',
            to: 'Complex',
            convert: function convert(x) {
                if (!Complex) $e3b13a8b9cfe0a8d$var$throwNoComplex(x);
                try {
                    return new Complex(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to Complex');
                }
            }
        },
        {
            from: 'boolean',
            to: 'number',
            convert: function convert(x) {
                return +x;
            }
        },
        {
            from: 'boolean',
            to: 'BigNumber',
            convert: function convert(x) {
                if (!BigNumber) $e3b13a8b9cfe0a8d$var$throwNoBignumber(x);
                return new BigNumber(+x);
            }
        },
        {
            from: 'boolean',
            to: 'bigint',
            convert: function convert(x) {
                return BigInt(+x);
            }
        },
        {
            from: 'boolean',
            to: 'Fraction',
            convert: function convert(x) {
                if (!Fraction) $e3b13a8b9cfe0a8d$var$throwNoFraction(x);
                return new Fraction(+x);
            }
        },
        {
            from: 'boolean',
            to: 'string',
            convert: function convert(x) {
                return String(x);
            }
        },
        {
            from: 'Array',
            to: 'Matrix',
            convert: function convert(array) {
                if (!DenseMatrix) $e3b13a8b9cfe0a8d$var$throwNoMatrix();
                return new DenseMatrix(array);
            }
        },
        {
            from: 'Matrix',
            to: 'Array',
            convert: function convert(matrix) {
                return matrix.valueOf();
            }
        }
    ]);
    // Provide a suggestion on how to call a function elementwise
    // This was added primarily as guidance for the v10 -> v11 transition,
    // and could potentially be removed in the future if it no longer seems
    // to be helpful.
    typed.onMismatch = (name, args, signatures)=>{
        var usualError = typed.createError(name, args, signatures);
        if ([
            'wrongType',
            'mismatch'
        ].includes(usualError.data.category) && args.length === 1 && (0, $edQYF.isCollection)(args[0]) && // check if the function can be unary:
        signatures.some((sig)=>!sig.params.includes(','))) {
            var err = new TypeError("Function '".concat(name, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(name, ")'."));
            err.data = usualError.data;
            throw err;
        }
        throw usualError;
    };
    // Provide a suggestion on how to call a function elementwise
    // This was added primarily as guidance for the v10 -> v11 transition,
    // and could potentially be removed in the future if it no longer seems
    // to be helpful.
    typed.onMismatch = (name, args, signatures)=>{
        var usualError = typed.createError(name, args, signatures);
        if ([
            'wrongType',
            'mismatch'
        ].includes(usualError.data.category) && args.length === 1 && (0, $edQYF.isCollection)(args[0]) && // check if the function can be unary:
        signatures.some((sig)=>!sig.params.includes(','))) {
            var err = new TypeError("Function '".concat(name, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(name, ")'."));
            err.data = usualError.data;
            throw err;
        }
        throw usualError;
    };
    return typed;
});
function $e3b13a8b9cfe0a8d$var$throwNoBignumber(x) {
    throw new Error("Cannot convert value ".concat(x, " into a BigNumber: no class 'BigNumber' provided"));
}
function $e3b13a8b9cfe0a8d$var$throwNoComplex(x) {
    throw new Error("Cannot convert value ".concat(x, " into a Complex number: no class 'Complex' provided"));
}
function $e3b13a8b9cfe0a8d$var$throwNoMatrix() {
    throw new Error('Cannot convert array into a Matrix: no class \'DenseMatrix\' provided');
}
function $e3b13a8b9cfe0a8d$var$throwNoFraction(x) {
    throw new Error("Cannot convert value ".concat(x, " into a Fraction, no class 'Fraction' provided."));
}

});

parcelRegister("1Yj4a", function(module, exports) {

$parcel$export(module.exports, "createTypeOf", () => $16fa2f365ad5549b$export$d7acf116afef7b4d);

var $dsu7t = parcelRequire("dsu7t");

var $edQYF = parcelRequire("edQYF");
var $16fa2f365ad5549b$var$name = 'typeOf';
var $16fa2f365ad5549b$var$dependencies = [
    'typed'
];
var $16fa2f365ad5549b$export$d7acf116afef7b4d = /* #__PURE__ */ (0, $dsu7t.factory)($16fa2f365ad5549b$var$name, $16fa2f365ad5549b$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Determine the type of an entity.
   *
   * Syntax:
   *
   *    math.typeOf(x)
   *
   * Examples:
   *
   *    // This list is intended to include all relevant types, for testing
   *    // purposes:
   *    math.typeOf(3.5)                      // returns 'number'
   *    math.typeOf(42n)                      // returns 'bigint'
   *    math.typeOf(math.complex('2-4i'))     // returns 'Complex'
   *    math.typeOf(math.unit('45 deg'))      // returns 'Unit'
   *    math.typeOf('hello world')            // returns 'string'
   *    math.typeOf(null)                     // returns 'null'
   *    math.typeOf(true)                     // returns 'boolean'
   *    math.typeOf([1, 2, 3])                // returns 'Array'
   *    math.typeOf(new Date())               // returns 'Date'
   *    math.typeOf(function () {})           // returns 'function'
   *    math.typeOf({a: 2, b: 3})             // returns 'Object'
   *    math.typeOf(/a regexp/)               // returns 'RegExp'
   *    math.typeOf(undefined)                // returns 'undefined'
   *    math.typeOf(math.bignumber('23e99'))  // returns 'BigNumber'
   *    math.typeOf(math.chain(2))            // returns 'Chain'
   *    math.typeOf(math.fraction(1, 3))      // returns 'Fraction'
   *    math.typeOf(math.help('sqrt'))        // returns 'Help'
   *    math.typeOf(math.index(1, 3))         // returns 'Index'
   *    math.typeOf(math.matrix([[1],[3]]))   // returns 'DenseMatrix'
   *    math.typeOf(math.matrix([],'sparse')) // returns 'SparseMatrix'
   *    math.typeOf(new math.Range(0, 10))    // returns 'Range'
   *    math.typeOf(math.evaluate('a=2\na'))  // returns 'ResultSet'
   *    math.typeOf(math.parse('A[2]'))       // returns 'AccessorNode'
   *    math.typeOf(math.parse('[1,2,3]'))    // returns 'ArrayNode'
   *    math.typeOf(math.parse('x=2'))        // returns 'AssignmentNode'
   *    math.typeOf(math.parse('a=2; b=3'))   // returns 'BlockNode'
   *    math.typeOf(math.parse('x<0?-1:1'))   // returns 'ConditionalNode'
   *    math.typeOf(math.parse('2.3'))        // returns 'ConstantNode'
   *    math.typeOf(math.parse('f(x)=x^2'))   // returns 'FunctionAssignmentNode'
   *    math.typeOf(math.parse('sqrt(4)'))    // returns 'FunctionNode'
   *    math.typeOf(math.parse('A[2]').index) // returns 'IndexNode'
   *    math.typeOf(math.parse('{a:2}'))      // returns 'ObjectNode'
   *    math.typeOf(math.parse('(2+3)'))      // returns 'ParenthesisNode'
   *    math.typeOf(math.parse('1:10'))       // returns 'RangeNode'
   *    math.typeOf(math.parse('a<b<c'))      // returns 'RelationalNode'
   *    math.typeOf(math.parse('x'))          // returns 'SymbolNode'
   *
   * @param {*} x     The variable for which to test the type.
   * @return {string} Returns the name of the type. Primitive types are lower case,
   *                  non-primitive types are upper-camel-case.
   *                  For example 'number', 'string', 'Array', 'Date'.
   */ return typed($16fa2f365ad5549b$var$name, {
        any: (0, $edQYF.typeOf)
    });
});

});

parcelRegister("e0BUK", function(module, exports) {

$parcel$export(module.exports, "createUnaryMinus", () => $a32e79c79dbb08db$export$939e1be6e134f392);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");

var $dmcGu = parcelRequire("dmcGu");
var $a32e79c79dbb08db$var$name = 'unaryMinus';
var $a32e79c79dbb08db$var$dependencies = [
    'typed'
];
var $a32e79c79dbb08db$export$939e1be6e134f392 = /* #__PURE__ */ (0, $dsu7t.factory)($a32e79c79dbb08db$var$name, $a32e79c79dbb08db$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Inverse the sign of a value, apply a unary minus operation.
   *
   * For matrices, the function is evaluated element wise. Boolean values and
   * strings will be converted to a number. For complex numbers, both real and
   * complex value are inverted.
   *
   * Syntax:
   *
   *    math.unaryMinus(x)
   *
   * Examples:
   *
   *    math.unaryMinus(3.5)      // returns -3.5
   *    math.unaryMinus(-4.2)     // returns 4.2
   *
   * See also:
   *
   *    add, subtract, unaryPlus
   *
   * @param  {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} x Number to be inverted.
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix} Returns the value with inverted sign.
   */ return typed($a32e79c79dbb08db$var$name, {
        number: (0, $dmcGu.unaryMinusNumber),
        'Complex | BigNumber | Fraction': (x)=>x.neg(),
        bigint: (x)=>-x,
        Unit: typed.referToSelf((self)=>(x)=>{
                var res = x.clone();
                res.value = typed.find(self, res.valueType())(x.value);
                return res;
            }),
        // deep map collection, skip zeros since unaryMinus(0) = 0
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self, true))
    });
});

});

parcelRegister("8YyM3", function(module, exports) {

$parcel$export(module.exports, "createUnaryPlus", () => $688ee6ba2ecaf5a8$export$cb425222dc08ff4e);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");

var $dmcGu = parcelRequire("dmcGu");

var $6NnhX = parcelRequire("6NnhX");
var $688ee6ba2ecaf5a8$var$name = 'unaryPlus';
var $688ee6ba2ecaf5a8$var$dependencies = [
    'typed',
    'config',
    'numeric'
];
var $688ee6ba2ecaf5a8$export$cb425222dc08ff4e = /* #__PURE__ */ (0, $dsu7t.factory)($688ee6ba2ecaf5a8$var$name, $688ee6ba2ecaf5a8$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, numeric: numeric } = _ref;
    /**
   * Unary plus operation.
   * Boolean values and strings will be converted to a number, numeric values will be returned as is.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.unaryPlus(x)
   *
   * Examples:
   *
   *    math.unaryPlus(3.5)      // returns 3.5
   *    math.unaryPlus(1)     // returns 1
   *
   * See also:
   *
   *    unaryMinus, add, subtract
   *
   * @param  {number | BigNumber | bigint | Fraction | string | Complex | Unit | Array | Matrix} x
   *            Input value
   * @return {number | BigNumber | bigint | Fraction | Complex | Unit | Array | Matrix}
   *            Returns the input value when numeric, converts to a number when input is non-numeric.
   */ return typed($688ee6ba2ecaf5a8$var$name, {
        number: (0, $dmcGu.unaryPlusNumber),
        Complex: function Complex(x) {
            return x; // complex numbers are immutable
        },
        BigNumber: function BigNumber(x) {
            return x; // bignumbers are immutable
        },
        bigint: function bigint(x) {
            return x;
        },
        Fraction: function Fraction(x) {
            return x; // fractions are immutable
        },
        Unit: function Unit(x) {
            return x.clone();
        },
        // deep map collection, skip zeros since unaryPlus(0) = 0
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self, true)),
        boolean: function boolean(x) {
            return numeric(x ? 1 : 0, config.number);
        },
        string: function string(x) {
            return numeric(x, (0, $6NnhX.safeNumberType)(x, config));
        }
    });
});

});

parcelRegister("f7FJr", function(module, exports) {

$parcel$export(module.exports, "createUnequal", () => $b027e1887e06530c$export$833e6c382e279d04);

var $dsu7t = parcelRequire("dsu7t");

var $a8bto = parcelRequire("a8bto");

var $6RFQP = parcelRequire("6RFQP");

var $19L2p = parcelRequire("19L2p");

var $6SJnV = parcelRequire("6SJnV");
var $b027e1887e06530c$var$name = 'unequal';
var $b027e1887e06530c$var$dependencies = [
    'typed',
    'config',
    'equalScalar',
    'matrix',
    'DenseMatrix',
    'concat',
    'SparseMatrix'
];
var $b027e1887e06530c$export$833e6c382e279d04 = /* #__PURE__ */ (0, $dsu7t.factory)($b027e1887e06530c$var$name, $b027e1887e06530c$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, equalScalar: equalScalar, matrix: matrix, DenseMatrix: DenseMatrix, concat: concat, SparseMatrix: SparseMatrix } = _ref;
    var matAlgo03xDSf = (0, $a8bto.createMatAlgo03xDSf)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $6RFQP.createMatAlgo07xSSf)({
        typed: typed,
        SparseMatrix: SparseMatrix
    });
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Test whether two values are unequal.
   *
   * The function tests whether the relative difference between x and y is
   * larger than the configured relTol and absTol. The function cannot be used to compare
   * values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * In case of complex numbers, x.re must unequal y.re, or x.im must unequal y.im.
   * Strings are compared by their numerical value.
   *
   * Values `null` and `undefined` are compared strictly, thus `null` is unequal
   * with everything except `null`, and `undefined` is unequal with everything
   * except `undefined`.
   *
   * Syntax:
   *
   *    math.unequal(x, y)
   *
   * Examples:
   *
   *    math.unequal(2 + 2, 3)       // returns true
   *    math.unequal(2 + 2, 4)       // returns false
   *
   *    const a = math.unit('50 cm')
   *    const b = math.unit('5 m')
   *    math.unequal(a, b)           // returns false
   *
   *    const c = [2, 5, 1]
   *    const d = [2, 7, 1]
   *
   *    math.unequal(c, d)           // returns [false, true, false]
   *    math.deepEqual(c, d)         // returns false
   *
   *    math.unequal(0, null)        // returns true
   * See also:
   *
   *    equal, deepEqual, smaller, smallerEq, larger, largerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit | string | Array | Matrix | undefined} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit | string | Array | Matrix | undefined} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the compared values are unequal, else returns false
   */ return typed($b027e1887e06530c$var$name, $b027e1887e06530c$export$b0b3dad01e54080b({
        typed: typed,
        equalScalar: equalScalar
    }), matrixAlgorithmSuite({
        elop: _unequal,
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
    function _unequal(x, y) {
        return !equalScalar(x, y);
    }
});
var $b027e1887e06530c$export$b0b3dad01e54080b = (0, $dsu7t.factory)($b027e1887e06530c$var$name, [
    'typed',
    'equalScalar'
], (_ref2)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref2;
    return typed($b027e1887e06530c$var$name, {
        'any, any': function any_any(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y !== null;
            if (y === null) return x !== null;
            if (x === undefined) return y !== undefined;
            if (y === undefined) return x !== undefined;
            return !equalScalar(x, y);
        }
    });
});

});

parcelRegister("i9Uex", function(module, exports) {

$parcel$export(module.exports, "createUnitClass", () => $d384b010ee22347e$export$3ad06557a3ac7a63);

var $g5Zhu = parcelRequire("g5Zhu");

var $3p9rK = parcelRequire("3p9rK");

var $edQYF = parcelRequire("edQYF");

var $dsu7t = parcelRequire("dsu7t");

var $5MAYL = parcelRequire("5MAYL");

var $j2hDb = parcelRequire("j2hDb");

var $9v8q6 = parcelRequire("9v8q6");

var $epoj7 = parcelRequire("epoj7");
function $d384b010ee22347e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d384b010ee22347e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d384b010ee22347e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d384b010ee22347e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d384b010ee22347e$var$name = 'Unit';
var $d384b010ee22347e$var$dependencies = [
    '?on',
    'config',
    'addScalar',
    'subtractScalar',
    'multiplyScalar',
    'divideScalar',
    'pow',
    'abs',
    'fix',
    'round',
    'equal',
    'isNumeric',
    'format',
    'toBest',
    'number',
    'Complex',
    'BigNumber',
    'Fraction'
];
var $d384b010ee22347e$export$3ad06557a3ac7a63 = /* #__PURE__ */ (0, $dsu7t.factory)($d384b010ee22347e$var$name, $d384b010ee22347e$var$dependencies, (_ref)=>{
    var { on: on, config: config, addScalar: addScalar, subtractScalar: subtractScalar, multiplyScalar: multiplyScalar, divideScalar: divideScalar, pow: pow, abs: abs, fix: fix, round: round, equal: equal, isNumeric: isNumeric, format: format, toBest: toBest, number: _number, Complex: Complex, BigNumber: _BigNumber, Fraction: _Fraction } = _ref;
    var toNumber = _number;
    /**
   * A unit can be constructed in the following ways:
   *
   *     const a = new Unit(value, valuelessUnit)
   *     const b = new Unit(null, valuelessUnit)
   *     const c = Unit.parse(str)
   *
   * Example usage:
   *
   *     const a = new Unit(5, 'cm')               // 50 mm
   *     const b = Unit.parse('23 kg')             // 23 kg
   *     const c = math.in(a, new Unit(null, 'm')  // 0.05 m
   *     const d = new Unit(9.81, "m/s^2")         // 9.81 m/s^2
   *
   * @class Unit
   * @constructor Unit
   * @param {number | BigNumber | Fraction | Complex | boolean} [value]  A value like 5.2
   * @param {string | Unit} valuelessUnit   A unit without value. Can have prefix, like "cm"
   */ function Unit(value, valuelessUnit) {
        if (!(this instanceof Unit)) throw new Error('Constructor must be called with the new operator');
        if (!(value === null || value === undefined || isNumeric(value) || (0, $edQYF.isComplex)(value))) throw new TypeError('First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined');
        this.fixPrefix = false; // if true, function format will not search for the
        // best prefix but leave it as initially provided.
        // fixPrefix is set true by the method Unit.to
        // The justification behind this is that if the constructor is explicitly called,
        // the caller wishes the units to be returned exactly as supplied.
        this.skipAutomaticSimplification = true;
        if (valuelessUnit === undefined) {
            this.units = [];
            this.dimensions = BASE_DIMENSIONS.map((x)=>0);
        } else if (typeof valuelessUnit === 'string') {
            var u = Unit.parse(valuelessUnit);
            this.units = u.units;
            this.dimensions = u.dimensions;
        } else if ((0, $edQYF.isUnit)(valuelessUnit) && valuelessUnit.value === null) {
            // clone from valuelessUnit
            this.fixPrefix = valuelessUnit.fixPrefix;
            this.skipAutomaticSimplification = valuelessUnit.skipAutomaticSimplification;
            this.dimensions = valuelessUnit.dimensions.slice(0);
            this.units = valuelessUnit.units.map((u)=>(0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, u));
        } else throw new TypeError('Second parameter in Unit constructor must be a string or valueless Unit');
        this.value = this._normalize(value);
    }
    /**
   * Attach type information
   */ Object.defineProperty(Unit, 'name', {
        value: 'Unit'
    });
    Unit.prototype.constructor = Unit;
    Unit.prototype.type = 'Unit';
    Unit.prototype.isUnit = true;
    // private variables and functions for the Unit parser
    var text, index, c;
    function skipWhitespace() {
        while(c === ' ' || c === '\t')next();
    }
    function isDigitDot(c) {
        return c >= '0' && c <= '9' || c === '.';
    }
    function isDigit(c) {
        return c >= '0' && c <= '9';
    }
    function next() {
        index++;
        c = text.charAt(index);
    }
    function revert(oldIndex) {
        index = oldIndex;
        c = text.charAt(index);
    }
    function parseNumber() {
        var number = '';
        var oldIndex = index;
        if (c === '+') next();
        else if (c === '-') {
            number += c;
            next();
        }
        if (!isDigitDot(c)) {
            // a + or - must be followed by a digit
            revert(oldIndex);
            return null;
        }
        // get number, can have a single dot
        if (c === '.') {
            number += c;
            next();
            if (!isDigit(c)) {
                // this is no legal number, it is just a dot
                revert(oldIndex);
                return null;
            }
        } else {
            while(isDigit(c)){
                number += c;
                next();
            }
            if (c === '.') {
                number += c;
                next();
            }
        }
        while(isDigit(c)){
            number += c;
            next();
        }
        // check for exponential notation like "2.3e-4" or "1.23e50"
        if (c === 'E' || c === 'e') {
            // The grammar branches here. This could either be part of an exponent or the start of a unit that begins with the letter e, such as "4exabytes"
            var tentativeNumber = '';
            var tentativeIndex = index;
            tentativeNumber += c;
            next();
            if (c === '+' || c === '-') {
                tentativeNumber += c;
                next();
            }
            // Scientific notation MUST be followed by an exponent (otherwise we assume it is not scientific notation)
            if (!isDigit(c)) {
                // The e or E must belong to something else, so return the number without the e or E.
                revert(tentativeIndex);
                return number;
            }
            // We can now safely say that this is scientific notation.
            number = number + tentativeNumber;
            while(isDigit(c)){
                number += c;
                next();
            }
        }
        return number;
    }
    function parseUnit() {
        var unitName = '';
        // Alphanumeric characters only; matches [a-zA-Z0-9]
        while(isDigit(c) || Unit.isValidAlpha(c)){
            unitName += c;
            next();
        }
        // Must begin with [a-zA-Z]
        var firstC = unitName.charAt(0);
        if (Unit.isValidAlpha(firstC)) return unitName;
        else return null;
    }
    function parseCharacter(toFind) {
        if (c === toFind) {
            next();
            return toFind;
        } else return null;
    }
    /**
   * Parse a string into a unit. The value of the unit is parsed as number,
   * BigNumber, or Fraction depending on the math.js config setting `number`.
   *
   * Throws an exception if the provided string does not contain a valid unit or
   * cannot be parsed.
   * @memberof Unit
   * @param {string} str        A string like "5.2 inch", "4e2 cm/s^2"
   * @return {Unit} unit
   */ Unit.parse = function(str, options) {
        options = options || {};
        text = str;
        index = -1;
        c = '';
        if (typeof text !== 'string') throw new TypeError('Invalid argument in Unit.parse, string expected');
        var unit = new Unit();
        unit.units = [];
        var powerMultiplierCurrent = 1;
        var expectingUnit = false;
        // A unit should follow this pattern:
        // [number] ...[ [*/] unit[^number] ]
        // unit[^number] ... [ [*/] unit[^number] ]
        // Rules:
        // number is any floating point number.
        // unit is any alphanumeric string beginning with an alpha. Units with names like e3 should be avoided because they look like the exponent of a floating point number!
        // The string may optionally begin with a number.
        // Each unit may optionally be followed by ^number.
        // Whitespace or a forward slash is recommended between consecutive units, although the following technically is parseable:
        //   2m^2kg/s^2
        // it is not good form. If a unit starts with e, then it could be confused as a floating point number:
        //   4erg
        next();
        skipWhitespace();
        // Optional number at the start of the string
        var valueStr = parseNumber();
        var value = null;
        if (valueStr) {
            if (config.number === 'BigNumber') value = new _BigNumber(valueStr);
            else if (config.number === 'Fraction') try {
                // not all numbers can be turned in Fractions, for example very small numbers not
                value = new _Fraction(valueStr);
            } catch (err) {
                value = parseFloat(valueStr);
            }
            else // number
            value = parseFloat(valueStr);
            skipWhitespace(); // Whitespace is not required here
            // handle multiplication or division right after the value, like '1/s'
            if (parseCharacter('*')) {
                powerMultiplierCurrent = 1;
                expectingUnit = true;
            } else if (parseCharacter('/')) {
                powerMultiplierCurrent = -1;
                expectingUnit = true;
            }
        }
        // Stack to keep track of powerMultipliers applied to each parentheses group
        var powerMultiplierStack = [];
        // Running product of all elements in powerMultiplierStack
        var powerMultiplierStackProduct = 1;
        while(true){
            skipWhitespace();
            // Check for and consume opening parentheses, pushing powerMultiplierCurrent to the stack
            // A '(' will always appear directly before a unit.
            while(c === '('){
                powerMultiplierStack.push(powerMultiplierCurrent);
                powerMultiplierStackProduct *= powerMultiplierCurrent;
                powerMultiplierCurrent = 1;
                next();
                skipWhitespace();
            }
            // Is there something here?
            var uStr = void 0;
            if (c) {
                var oldC = c;
                uStr = parseUnit();
                if (uStr === null) throw new SyntaxError('Unexpected "' + oldC + '" in "' + text + '" at index ' + index.toString());
            } else break;
            // Verify the unit exists and get the prefix (if any)
            var res = _findUnit(uStr);
            if (res === null) // Unit not found.
            throw new SyntaxError('Unit "' + uStr + '" not found.');
            var power = powerMultiplierCurrent * powerMultiplierStackProduct;
            // Is there a "^ number"?
            skipWhitespace();
            if (parseCharacter('^')) {
                skipWhitespace();
                var p = parseNumber();
                if (p === null) // No valid number found for the power!
                throw new SyntaxError('In "' + str + '", "^" must be followed by a floating-point number');
                power *= p;
            }
            // Add the unit to the list
            unit.units.push({
                unit: res.unit,
                prefix: res.prefix,
                power: power
            });
            for(var i = 0; i < BASE_DIMENSIONS.length; i++)unit.dimensions[i] += (res.unit.dimensions[i] || 0) * power;
            // Check for and consume closing parentheses, popping from the stack.
            // A ')' will always follow a unit.
            skipWhitespace();
            while(c === ')'){
                if (powerMultiplierStack.length === 0) throw new SyntaxError('Unmatched ")" in "' + text + '" at index ' + index.toString());
                powerMultiplierStackProduct /= powerMultiplierStack.pop();
                next();
                skipWhitespace();
            }
            // "*" and "/" should mean we are expecting something to come next.
            // Is there a forward slash? If so, negate powerMultiplierCurrent. The next unit or paren group is in the denominator.
            expectingUnit = false;
            if (parseCharacter('*')) {
                // explicit multiplication
                powerMultiplierCurrent = 1;
                expectingUnit = true;
            } else if (parseCharacter('/')) {
                // division
                powerMultiplierCurrent = -1;
                expectingUnit = true;
            } else // implicit multiplication
            powerMultiplierCurrent = 1;
            // Replace the unit into the auto unit system
            if (res.unit.base) {
                var baseDim = res.unit.base.key;
                UNIT_SYSTEMS.auto[baseDim] = {
                    unit: res.unit,
                    prefix: res.prefix
                };
            }
        }
        // Has the string been entirely consumed?
        skipWhitespace();
        if (c) throw new SyntaxError('Could not parse: "' + str + '"');
        // Is there a trailing slash?
        if (expectingUnit) throw new SyntaxError('Trailing characters: "' + str + '"');
        // Is the parentheses stack empty?
        if (powerMultiplierStack.length !== 0) throw new SyntaxError('Unmatched "(" in "' + text + '"');
        // Are there any units at all?
        if (unit.units.length === 0 && !options.allowNoUnits) throw new SyntaxError('"' + str + '" contains no units');
        unit.value = value !== undefined ? unit._normalize(value) : null;
        return unit;
    };
    /**
   * create a copy of this unit
   * @memberof Unit
   * @return {Unit} Returns a cloned version of the unit
   */ Unit.prototype.clone = function() {
        var unit = new Unit();
        unit.fixPrefix = this.fixPrefix;
        unit.skipAutomaticSimplification = this.skipAutomaticSimplification;
        unit.value = (0, $9v8q6.clone)(this.value);
        unit.dimensions = this.dimensions.slice(0);
        unit.units = [];
        for(var i = 0; i < this.units.length; i++){
            unit.units[i] = {};
            for(var p in this.units[i])if ((0, $9v8q6.hasOwnProperty)(this.units[i], p)) unit.units[i][p] = this.units[i][p];
        }
        return unit;
    };
    /**
   * Return the type of the value of this unit
   *
   * @memberof Unit
   * @return {string} type of the value of the unit
   */ Unit.prototype.valueType = function() {
        return (0, $edQYF.typeOf)(this.value);
    };
    /**
   * Return whether the unit is derived (such as m/s, or cm^2, but not N)
   * @memberof Unit
   * @return {boolean} True if the unit is derived
   * @private
   */ Unit.prototype._isDerived = function() {
        if (this.units.length === 0) return false;
        return this.units.length > 1 || Math.abs(this.units[0].power - 1.0) > 1e-15;
    };
    /**
   * Normalize a value, based on its currently set unit(s)
   * @memberof Unit
   * @param {number | BigNumber | Fraction | boolean} value
   * @return {number | BigNumber | Fraction | boolean} normalized value
   * @private
   */ Unit.prototype._normalize = function(value) {
        if (value === null || value === undefined || this.units.length === 0) return value;
        var res = value;
        var convert = Unit._getNumberConverter((0, $edQYF.typeOf)(value)); // convert to Fraction or BigNumber if needed
        for(var i = 0; i < this.units.length; i++){
            var unitValue = convert(this.units[i].unit.value);
            var unitPrefixValue = convert(this.units[i].prefix.value);
            var unitPower = convert(this.units[i].power);
            res = multiplyScalar(res, pow(multiplyScalar(unitValue, unitPrefixValue), unitPower));
        }
        return res;
    };
    /**
   * Denormalize a value, based on its currently set unit(s)
   * @memberof Unit
   * @param {number} value
   * @param {number} [prefixValue]    Optional prefix value to be used (ignored if this is a derived unit)
   * @return {number} denormalized value
   * @private
   */ Unit.prototype._denormalize = function(value, prefixValue) {
        if (value === null || value === undefined || this.units.length === 0) return value;
        var res = value;
        var convert = Unit._getNumberConverter((0, $edQYF.typeOf)(value)); // convert to Fraction or BigNumber if needed
        for(var i = 0; i < this.units.length; i++){
            var unitValue = convert(this.units[i].unit.value);
            var unitPrefixValue = convert(this.units[i].prefix.value);
            var unitPower = convert(this.units[i].power);
            res = divideScalar(res, pow(multiplyScalar(unitValue, unitPrefixValue), unitPower));
        }
        return res;
    };
    /**
   * Find a unit from a string
   * @memberof Unit
   * @param {string} str              A string like 'cm' or 'inch'
   * @returns {Object | null} result  When found, an object with fields unit and
   *                                  prefix is returned. Else, null is returned.
   * @private
   */ var _findUnit = (0, $5MAYL.memoize)((str)=>{
        // First, match units names exactly. For example, a user could define 'mm' as 10^-4 m, which is silly, but then we would want 'mm' to match the user-defined unit.
        if ((0, $9v8q6.hasOwnProperty)(UNITS, str)) {
            var unit = UNITS[str];
            var prefix = unit.prefixes[''];
            return {
                unit: unit,
                prefix: prefix
            };
        }
        for(var _name in UNITS){
            if ((0, $9v8q6.hasOwnProperty)(UNITS, _name)) {
                if ((0, $j2hDb.endsWith)(str, _name)) {
                    var _unit = UNITS[_name];
                    var prefixLen = str.length - _name.length;
                    var prefixName = str.substring(0, prefixLen);
                    var _prefix = (0, $9v8q6.hasOwnProperty)(_unit.prefixes, prefixName) ? _unit.prefixes[prefixName] : undefined;
                    if (_prefix !== undefined) // store unit, prefix, and value
                    return {
                        unit: _unit,
                        prefix: _prefix
                    };
                }
            }
        }
        return null;
    }, {
        hasher: (args)=>args[0],
        limit: 100
    });
    /**
   * Test if the given expression is a unit.
   * The unit can have a prefix but cannot have a value.
   * @memberof Unit
   * @param {string} name   A string to be tested whether it is a value less unit.
   *                        The unit can have prefix, like "cm"
   * @return {boolean}      true if the given string is a unit
   */ Unit.isValuelessUnit = function(name) {
        return _findUnit(name) !== null;
    };
    /**
   * check if this unit has given base unit
   * If this unit is a derived unit, this will ALWAYS return false, since by definition base units are not derived.
   * @memberof Unit
   * @param {BASE_UNIT | string | undefined} base
   */ Unit.prototype.hasBase = function(base) {
        if (typeof base === 'string') base = BASE_UNITS[base];
        if (!base) return false;
        // All dimensions must be the same
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            if (Math.abs((this.dimensions[i] || 0) - (base.dimensions[i] || 0)) > 1e-12) return false;
        }
        return true;
    };
    /**
   * Check if this unit has a base or bases equal to another base or bases
   * For derived units, the exponent on each base also must match
   * @memberof Unit
   * @param {Unit} other
   * @return {boolean} true if equal base
   */ Unit.prototype.equalBase = function(other) {
        // All dimensions must be the same
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            if (Math.abs((this.dimensions[i] || 0) - (other.dimensions[i] || 0)) > 1e-12) return false;
        }
        return true;
    };
    /**
   * Check if this unit equals another unit
   * @memberof Unit
   * @param {Unit} other
   * @return {boolean} true if both units are equal
   */ Unit.prototype.equals = function(other) {
        return this.equalBase(other) && equal(this.value, other.value);
    };
    /**
   * Multiply this unit with another one or with a scalar
   * @memberof Unit
   * @param {Unit} other
   * @return {Unit} product of this unit and the other unit
   */ Unit.prototype.multiply = function(_other) {
        var res = this.clone();
        var other = (0, $edQYF.isUnit)(_other) ? _other : new Unit(_other);
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) + (other.dimensions[i] || 0);
        // Append other's units list onto res
        for(var _i = 0; _i < other.units.length; _i++){
            // Make a shallow copy of every unit
            var inverted = $d384b010ee22347e$var$_objectSpread({}, other.units[_i]);
            res.units.push(inverted);
        }
        // If at least one operand has a value, then the result should also have a value
        if (this.value !== null || other.value !== null) {
            var valThis = this.value === null ? this._normalize(one(other.value)) : this.value;
            var valOther = other.value === null ? other._normalize(one(this.value)) : other.value;
            res.value = multiplyScalar(valThis, valOther);
        } else res.value = null;
        if ((0, $edQYF.isUnit)(_other)) res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Divide a number by this unit
   *
   * @memberof Unit
   * @param {numeric} numerator
   * @param {unit} result of dividing numerator by this unit
   */ Unit.prototype.divideInto = function(numerator) {
        return new Unit(numerator).divide(this);
    };
    /**
   * Divide this unit by another one
   * @memberof Unit
   * @param {Unit | numeric} other
   * @return {Unit} result of dividing this unit by the other unit
   */ Unit.prototype.divide = function(_other) {
        var res = this.clone();
        var other = (0, $edQYF.isUnit)(_other) ? _other : new Unit(_other);
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) - (other.dimensions[i] || 0);
        // Invert and append other's units list onto res
        for(var _i2 = 0; _i2 < other.units.length; _i2++){
            // Make a shallow copy of every unit
            var inverted = $d384b010ee22347e$var$_objectSpread($d384b010ee22347e$var$_objectSpread({}, other.units[_i2]), {}, {
                power: -other.units[_i2].power
            });
            res.units.push(inverted);
        }
        // If at least one operand has a value, the result should have a value
        if (this.value !== null || other.value !== null) {
            var valThis = this.value === null ? this._normalize(one(other.value)) : this.value;
            var valOther = other.value === null ? other._normalize(one(this.value)) : other.value;
            res.value = divideScalar(valThis, valOther);
        } else res.value = null;
        if ((0, $edQYF.isUnit)(_other)) res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Calculate the power of a unit
   * @memberof Unit
   * @param {number | Fraction | BigNumber} p
   * @returns {Unit}      The result: this^p
   */ Unit.prototype.pow = function(p) {
        var res = this.clone();
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) * p;
        // Adjust the power of each unit in the list
        for(var _i3 = 0; _i3 < res.units.length; _i3++)res.units[_i3].power *= p;
        if (res.value !== null) res.value = pow(res.value, p);
        else res.value = null;
        res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Return the numeric value of this unit if it is dimensionless, has a value, and config.predictable == false; or the original unit otherwise
   * @param {Unit} unit
   * @returns {number | Fraction | BigNumber | Unit}  The numeric value of the unit if conditions are met, or the original unit otherwise
   */ function getNumericIfUnitless(unit) {
        if (unit.equalBase(BASE_UNITS.NONE) && unit.value !== null && !config.predictable) return unit.value;
        else return unit;
    }
    /**
   * Create a value one with the numeric type of `typeOfValue`.
   * For example, `one(new BigNumber(3))` returns `BigNumber(1)`
   * @param {number | Fraction | BigNumber} typeOfValue
   * @returns {number | Fraction | BigNumber}
   */ function one(typeOfValue) {
        // TODO: this is a workaround to prevent the following BigNumber conversion error from throwing:
        //  "TypeError: Cannot implicitly convert a number with >15 significant digits to BigNumber"
        //  see https://github.com/josdejong/mathjs/issues/3450
        //      https://github.com/josdejong/mathjs/pull/3375
        var convert = Unit._getNumberConverter((0, $edQYF.typeOf)(typeOfValue));
        return convert(1);
    }
    /**
   * Calculate the absolute value of a unit
   * @memberof Unit
   * @param {number | Fraction | BigNumber} x
   * @returns {Unit}      The result: |x|, absolute value of x
   */ Unit.prototype.abs = function() {
        var ret = this.clone();
        if (ret.value !== null) {
            if (ret._isDerived() || ret.units.length === 0 || ret.units[0].unit.offset === 0) ret.value = abs(ret.value);
            else {
                // To give the correct, but unexpected, results for units with an offset.
                // For example, abs(-283.15 degC) = -263.15 degC !!!
                // We must take the offset into consideration here
                var convert = ret._numberConverter(); // convert to Fraction or BigNumber if needed
                var unitValue = convert(ret.units[0].unit.value);
                var nominalOffset = convert(ret.units[0].unit.offset);
                var unitOffset = multiplyScalar(unitValue, nominalOffset);
                ret.value = subtractScalar(abs(addScalar(ret.value, unitOffset)), unitOffset);
            }
        }
        for(var i in ret.units)if (ret.units[i].unit.name === 'VA' || ret.units[i].unit.name === 'VAR') ret.units[i].unit = UNITS.W;
        return ret;
    };
    /**
   * Convert the unit to a specific unit name.
   * @memberof Unit
   * @param {string | Unit} valuelessUnit   A unit without value. Can have prefix, like "cm"
   * @returns {Unit} Returns a clone of the unit with a fixed prefix and unit.
   */ Unit.prototype.to = function(valuelessUnit) {
        var value = this.value === null ? this._normalize(1) : this.value;
        var other;
        if (typeof valuelessUnit === 'string') other = Unit.parse(valuelessUnit);
        else if ((0, $edQYF.isUnit)(valuelessUnit)) other = valuelessUnit.clone();
        else throw new Error('String or Unit expected as parameter');
        if (!this.equalBase(other)) throw new Error("Units do not match ('".concat(other.toString(), "' != '").concat(this.toString(), "')"));
        if (other.value !== null) throw new Error('Cannot convert to a unit with a value');
        if (this.value === null || this._isDerived() || this.units.length === 0 || other.units.length === 0 || this.units[0].unit.offset === other.units[0].unit.offset) other.value = (0, $9v8q6.clone)(value);
        else {
            /* Need to adjust value by difference in offset to convert */ var convert = Unit._getNumberConverter((0, $edQYF.typeOf)(value)); // convert to Fraction or BigNumber if needed
            var thisUnitValue = this.units[0].unit.value;
            var thisNominalOffset = this.units[0].unit.offset;
            var thisUnitOffset = multiplyScalar(thisUnitValue, thisNominalOffset);
            var otherUnitValue = other.units[0].unit.value;
            var otherNominalOffset = other.units[0].unit.offset;
            var otherUnitOffset = multiplyScalar(otherUnitValue, otherNominalOffset);
            other.value = addScalar(value, convert(subtractScalar(thisUnitOffset, otherUnitOffset)));
        }
        other.fixPrefix = true;
        other.skipAutomaticSimplification = true;
        return other;
    };
    /**
   * Return the value of the unit when represented with given valueless unit
   * @memberof Unit
   * @param {string | Unit} valuelessUnit    For example 'cm' or 'inch'
   * @return {number} Returns the unit value as number.
   */ // TODO: deprecate Unit.toNumber? It's always better to use toNumeric
    Unit.prototype.toNumber = function(valuelessUnit) {
        return toNumber(this.toNumeric(valuelessUnit));
    };
    /**
   * Return the value of the unit in the original numeric type
   * @memberof Unit
   * @param {string | Unit} valuelessUnit    For example 'cm' or 'inch'
   * @return {number | BigNumber | Fraction} Returns the unit value
   */ Unit.prototype.toNumeric = function(valuelessUnit) {
        var other;
        if (valuelessUnit) // Allow getting the numeric value without converting to a different unit
        other = this.to(valuelessUnit);
        else other = this.clone();
        if (other._isDerived() || other.units.length === 0) return other._denormalize(other.value);
        else return other._denormalize(other.value, other.units[0].prefix.value);
    };
    /**
   * Get a string representation of the unit.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.toString = function() {
        return this.format();
    };
    /**
   * Get a JSON representation of the unit
   * @memberof Unit
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Unit", "value": 2, "unit": "cm", "fixPrefix": false}`
   */ Unit.prototype.toJSON = function() {
        return {
            mathjs: 'Unit',
            value: this._denormalize(this.value),
            unit: this.units.length > 0 ? this.formatUnits() : null,
            fixPrefix: this.fixPrefix
        };
    };
    /**
   * Instantiate a Unit from a JSON object
   * @memberof Unit
   * @param {Object} json  A JSON object structured as:
   *                       `{"mathjs": "Unit", "value": 2, "unit": "cm", "fixPrefix": false}`
   * @return {Unit}
   */ Unit.fromJSON = function(json) {
        var _json$unit;
        var unit = new Unit(json.value, (_json$unit = json.unit) !== null && _json$unit !== void 0 ? _json$unit : undefined);
        unit.fixPrefix = json.fixPrefix || false;
        return unit;
    };
    /**
   * Returns the string representation of the unit.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.valueOf = Unit.prototype.toString;
    /**
   * Simplify this Unit's unit list and return a new Unit with the simplified list.
   * The returned Unit will contain a list of the "best" units for formatting.
   */ Unit.prototype.simplify = function() {
        var ret = this.clone();
        var proposedUnitList = [];
        // Search for a matching base
        var matchingBase;
        for(var key in currentUnitSystem){
            if ((0, $9v8q6.hasOwnProperty)(currentUnitSystem, key)) {
                if (ret.hasBase(BASE_UNITS[key])) {
                    matchingBase = key;
                    break;
                }
            }
        }
        if (matchingBase === 'NONE') ret.units = [];
        else {
            var matchingUnit;
            if (matchingBase) // Does the unit system have a matching unit?
            {
                if ((0, $9v8q6.hasOwnProperty)(currentUnitSystem, matchingBase)) matchingUnit = currentUnitSystem[matchingBase];
            }
            if (matchingUnit) ret.units = [
                {
                    unit: matchingUnit.unit,
                    prefix: matchingUnit.prefix,
                    power: 1.0
                }
            ];
            else {
                // Multiple units or units with powers are formatted like this:
                // 5 (kg m^2) / (s^3 mol)
                // Build an representation from the base units of the current unit system
                var missingBaseDim = false;
                for(var i = 0; i < BASE_DIMENSIONS.length; i++){
                    var baseDim = BASE_DIMENSIONS[i];
                    if (Math.abs(ret.dimensions[i] || 0) > 1e-12) {
                        if ((0, $9v8q6.hasOwnProperty)(currentUnitSystem, baseDim)) proposedUnitList.push({
                            unit: currentUnitSystem[baseDim].unit,
                            prefix: currentUnitSystem[baseDim].prefix,
                            power: ret.dimensions[i] || 0
                        });
                        else missingBaseDim = true;
                    }
                }
                // Is the proposed unit list "simpler" than the existing one?
                if (proposedUnitList.length < ret.units.length && !missingBaseDim) // Replace this unit list with the proposed list
                ret.units = proposedUnitList;
            }
        }
        return ret;
    };
    /**
   * Returns a new Unit in the SI system with the same value as this one
   */ Unit.prototype.toSI = function() {
        var ret = this.clone();
        var proposedUnitList = [];
        // Multiple units or units with powers are formatted like this:
        // 5 (kg m^2) / (s^3 mol)
        // Build an representation from the base units of the SI unit system
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            var baseDim = BASE_DIMENSIONS[i];
            if (Math.abs(ret.dimensions[i] || 0) > 1e-12) {
                if ((0, $9v8q6.hasOwnProperty)(UNIT_SYSTEMS.si, baseDim)) proposedUnitList.push({
                    unit: UNIT_SYSTEMS.si[baseDim].unit,
                    prefix: UNIT_SYSTEMS.si[baseDim].prefix,
                    power: ret.dimensions[i] || 0
                });
                else throw new Error('Cannot express custom unit ' + baseDim + ' in SI units');
            }
        }
        // Replace this unit list with the proposed list
        ret.units = proposedUnitList;
        ret.fixPrefix = true;
        ret.skipAutomaticSimplification = true;
        if (this.value !== null) {
            ret.value = null;
            return this.to(ret);
        }
        return ret;
    };
    /**
   * Get a string representation of the units of this Unit, without the value. The unit list is formatted as-is without first being simplified.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.formatUnits = function() {
        var strNum = '';
        var strDen = '';
        var nNum = 0;
        var nDen = 0;
        for(var i = 0; i < this.units.length; i++){
            if (this.units[i].power > 0) {
                nNum++;
                strNum += ' ' + this.units[i].prefix.name + this.units[i].unit.name;
                if (Math.abs(this.units[i].power - 1.0) > 1e-15) strNum += '^' + this.units[i].power;
            } else if (this.units[i].power < 0) nDen++;
        }
        if (nDen > 0) {
            for(var _i4 = 0; _i4 < this.units.length; _i4++)if (this.units[_i4].power < 0) {
                if (nNum > 0) {
                    strDen += ' ' + this.units[_i4].prefix.name + this.units[_i4].unit.name;
                    if (Math.abs(this.units[_i4].power + 1.0) > 1e-15) strDen += '^' + -this.units[_i4].power;
                } else {
                    strDen += ' ' + this.units[_i4].prefix.name + this.units[_i4].unit.name;
                    strDen += '^' + this.units[_i4].power;
                }
            }
        }
        // Remove leading " "
        strNum = strNum.substr(1);
        strDen = strDen.substr(1);
        // Add parans for better copy/paste back into evaluate, for example, or for better pretty print formatting
        if (nNum > 1 && nDen > 0) strNum = '(' + strNum + ')';
        if (nDen > 1 && nNum > 0) strDen = '(' + strDen + ')';
        var str = strNum;
        if (nNum > 0 && nDen > 0) str += ' / ';
        str += strDen;
        return str;
    };
    /**
   * Get a unit, with optional formatting options.
   * @memberof Unit
   * @param {string[] | Unit[]} [units]  Array of units strings or valueLess Unit objects in wich choose the best one
   * @param {Object} [options]  Options for parsing the unit. See parseUnit for details.
   *
   * @return {Unit} Returns a new Unit with the given value and unit.
   */ Unit.prototype.toBest = function() {
        var unitList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (unitList && !Array.isArray(unitList)) throw new Error('Invalid unit type. Expected string or Unit.');
        var startPrefixes = this.units[0].unit.prefixes;
        if (unitList && unitList.length > 0) {
            var unitObjects = unitList.map((u)=>{
                var unit = null;
                if (typeof u === 'string') {
                    unit = Unit.parse(u);
                    if (!unit) throw new Error('Invalid unit type. Expected compatible string or Unit.');
                } else if (!(0, $edQYF.isUnit)(u)) throw new Error('Invalid unit type. Expected compatible string or Unit.');
                if (unit === null) unit = u.clone();
                try {
                    this.to(unit.formatUnits());
                    return unit;
                } catch (e) {
                    throw new Error('Invalid unit type. Expected compatible string or Unit.');
                }
            });
            var prefixes = unitObjects.map((el)=>el.units[0].prefix);
            this.units[0].unit.prefixes = prefixes.reduce((acc, prefix)=>{
                acc[prefix.name] = prefix;
                return acc;
            }, {});
            this.units[0].prefix = prefixes[0];
        }
        var result = formatBest(this, options).simp;
        this.units[0].unit.prefixes = startPrefixes;
        result.fixPrefix = true;
        return result;
    };
    /**
   * Get a string representation of the Unit, with optional formatting options.
   * @memberof Unit
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @return {string}
   */ Unit.prototype.format = function(options) {
        var { simp: simp, valueStr: valueStr, unitStr: unitStr } = formatBest(this, options);
        var str = valueStr;
        if (simp.value && (0, $edQYF.isComplex)(simp.value)) str = '(' + str + ')'; // Surround complex values with ( ) to enable better parsing
        if (unitStr.length > 0 && str.length > 0) str += ' ';
        str += unitStr;
        return str;
    };
    /**
  * Helper function to normalize a unit for conversion and formatting
  * @param {Unit} unit The unit to be normalized
  * @return {Object} Object with normalized unit and value
  * @private
  */ function formatBest(unit) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        // Simplfy the unit list, unless it is valueless or was created directly in the
        // constructor or as the result of to or toSI
        var simp = unit.skipAutomaticSimplification || unit.value === null ? unit.clone() : unit.simplify();
        // Apply some custom logic for handling VA and VAR. The goal is to express the value of the unit as a real value, if possible. Otherwise, use a real-valued unit instead of a complex-valued one.
        handleVAandVARUnits(simp);
        // Now apply the best prefix
        // Units must have only one unit and not have the fixPrefix flag set
        applyBestPrefixIfNeeded(simp, options.offset);
        var value = simp._denormalize(simp.value);
        var valueStr = simp.value !== null ? format(value, options || {}) : '';
        var unitStr = simp.formatUnits();
        return {
            simp: simp,
            valueStr: valueStr,
            unitStr: unitStr
        };
    }
    /**
   * Helper to handle VA and VAR units
   * @param {Unit} simp The unit to be normalized
   */ function handleVAandVARUnits(simp) {
        var isImaginary = false;
        if (typeof simp.value !== 'undefined' && simp.value !== null && (0, $edQYF.isComplex)(simp.value)) // TODO: Make this better, for example, use relative magnitude of re and im rather than absolute
        isImaginary = Math.abs(simp.value.re) < 1e-14;
        for(var i in simp.units){
            if ((0, $9v8q6.hasOwnProperty)(simp.units, i)) {
                if (simp.units[i].unit) {
                    if (simp.units[i].unit.name === 'VA' && isImaginary) simp.units[i].unit = UNITS.VAR;
                    else if (simp.units[i].unit.name === 'VAR' && !isImaginary) simp.units[i].unit = UNITS.VA;
                }
            }
        }
    }
    /**
   * Helper to apply the best prefix if needed
   * @param {Unit} simp The unit to be normalized
   */ function applyBestPrefixIfNeeded(simp, offset) {
        if (simp.units.length === 1 && !simp.fixPrefix) // Units must have integer powers, otherwise the prefix will change the
        // outputted value by not-an-integer-power-of-ten
        {
            if (Math.abs(simp.units[0].power - Math.round(simp.units[0].power)) < 1e-14) // Apply the best prefix
            simp.units[0].prefix = simp._bestPrefix(offset);
        }
    }
    /**
   * Calculate the best prefix using current value.
   * @memberof Unit
   * @returns {Object} prefix
   * @param {number} [offset]  Optional offset for the best prefix calculation (default 1.2)
   * @private
   */ Unit.prototype._bestPrefix = function() {
        var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.2;
        if (this.units.length !== 1) throw new Error('Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!');
        if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14) throw new Error('Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!');
        // find the best prefix value (resulting in the value of which
        // the absolute value of the log10 is closest to zero,
        // though with a little offset of 1.2 for nicer values: you get a
        // sequence 1mm 100mm 500mm 0.6m 1m 10m 100m 500m 0.6km 1km ...
        // Note: the units value can be any numeric type, but to find the best
        // prefix it's enough to work with limited precision of a regular number
        // Update: using mathjs abs since we also allow complex numbers
        var absValue = this.value !== null ? abs(this.value) : 0;
        var absUnitValue = abs(this.units[0].unit.value);
        var bestPrefix = this.units[0].prefix;
        if (absValue === 0) return bestPrefix;
        var power = this.units[0].power;
        var bestDiff = Math.log(absValue / Math.pow(bestPrefix.value * absUnitValue, power)) / Math.LN10 - offset;
        if (bestDiff > -2.200001 && bestDiff < 1.800001) return bestPrefix; // Allow the original prefix
        bestDiff = Math.abs(bestDiff);
        var prefixes = this.units[0].unit.prefixes;
        for(var p in prefixes)if ((0, $9v8q6.hasOwnProperty)(prefixes, p)) {
            var prefix = prefixes[p];
            if (prefix.scientific) {
                var diff = Math.abs(Math.log(absValue / Math.pow(prefix.value * absUnitValue, power)) / Math.LN10 - offset);
                if (diff < bestDiff || diff === bestDiff && prefix.name.length < bestPrefix.name.length) {
                    // choose the prefix with the smallest diff, or if equal, choose the one
                    // with the shortest name (can happen with SHORTLONG for example)
                    bestPrefix = prefix;
                    bestDiff = diff;
                }
            }
        }
        return bestPrefix;
    };
    /**
   * Returns an array of units whose sum is equal to this unit
   * @memberof Unit
   * @param {Array} [parts] An array of strings or valueless units.
   *
   *   Example:
   *
   *   const u = new Unit(1, 'm')
   *   u.splitUnit(['feet', 'inch'])
   *     [ 3 feet, 3.3700787401575 inch ]
   *
   * @return {Array} An array of units.
   */ Unit.prototype.splitUnit = function(parts) {
        var x = this.clone();
        var ret = [];
        for(var i = 0; i < parts.length; i++){
            // Convert x to the requested unit
            x = x.to(parts[i]);
            if (i === parts.length - 1) break;
            // Get the numeric value of this unit
            var xNumeric = x.toNumeric();
            // Check to see if xNumeric is nearly equal to an integer,
            // since fix can incorrectly round down if there is round-off error
            var xRounded = round(xNumeric);
            var xFixed = void 0;
            var isNearlyEqual = equal(xRounded, xNumeric);
            if (isNearlyEqual) xFixed = xRounded;
            else xFixed = fix(x.toNumeric());
            var y = new Unit(xFixed, parts[i].toString());
            ret.push(y);
            x = subtractScalar(x, y);
        }
        // This little bit fixes a bug where the remainder should be 0 but is a little bit off.
        // But instead of comparing x, the remainder, with zero--we will compare the sum of
        // all the parts so far with the original value. If they are nearly equal,
        // we set the remainder to 0.
        var testSum = 0;
        for(var _i5 = 0; _i5 < ret.length; _i5++)testSum = addScalar(testSum, ret[_i5].value);
        if (equal(testSum, this.value)) x.value = 0;
        ret.push(x);
        return ret;
    };
    var PREFIXES = {
        NONE: {
            '': {
                name: '',
                value: 1,
                scientific: true
            }
        },
        SHORT: {
            '': {
                name: '',
                value: 1,
                scientific: true
            },
            da: {
                name: 'da',
                value: 1e1,
                scientific: false
            },
            h: {
                name: 'h',
                value: 1e2,
                scientific: false
            },
            k: {
                name: 'k',
                value: 1e3,
                scientific: true
            },
            M: {
                name: 'M',
                value: 1e6,
                scientific: true
            },
            G: {
                name: 'G',
                value: 1e9,
                scientific: true
            },
            T: {
                name: 'T',
                value: 1e12,
                scientific: true
            },
            P: {
                name: 'P',
                value: 1e15,
                scientific: true
            },
            E: {
                name: 'E',
                value: 1e18,
                scientific: true
            },
            Z: {
                name: 'Z',
                value: 1e21,
                scientific: true
            },
            Y: {
                name: 'Y',
                value: 1e24,
                scientific: true
            },
            R: {
                name: 'R',
                value: 1e27,
                scientific: true
            },
            Q: {
                name: 'Q',
                value: 1e30,
                scientific: true
            },
            d: {
                name: 'd',
                value: 1e-1,
                scientific: false
            },
            c: {
                name: 'c',
                value: 1e-2,
                scientific: false
            },
            m: {
                name: 'm',
                value: 1e-3,
                scientific: true
            },
            u: {
                name: 'u',
                value: 1e-6,
                scientific: true
            },
            n: {
                name: 'n',
                value: 1e-9,
                scientific: true
            },
            p: {
                name: 'p',
                value: 1e-12,
                scientific: true
            },
            f: {
                name: 'f',
                value: 1e-15,
                scientific: true
            },
            a: {
                name: 'a',
                value: 1e-18,
                scientific: true
            },
            z: {
                name: 'z',
                value: 1e-21,
                scientific: true
            },
            y: {
                name: 'y',
                value: 1e-24,
                scientific: true
            },
            r: {
                name: 'r',
                value: 1e-27,
                scientific: true
            },
            q: {
                name: 'q',
                value: 1e-30,
                scientific: true
            }
        },
        LONG: {
            '': {
                name: '',
                value: 1,
                scientific: true
            },
            deca: {
                name: 'deca',
                value: 1e1,
                scientific: false
            },
            hecto: {
                name: 'hecto',
                value: 1e2,
                scientific: false
            },
            kilo: {
                name: 'kilo',
                value: 1e3,
                scientific: true
            },
            mega: {
                name: 'mega',
                value: 1e6,
                scientific: true
            },
            giga: {
                name: 'giga',
                value: 1e9,
                scientific: true
            },
            tera: {
                name: 'tera',
                value: 1e12,
                scientific: true
            },
            peta: {
                name: 'peta',
                value: 1e15,
                scientific: true
            },
            exa: {
                name: 'exa',
                value: 1e18,
                scientific: true
            },
            zetta: {
                name: 'zetta',
                value: 1e21,
                scientific: true
            },
            yotta: {
                name: 'yotta',
                value: 1e24,
                scientific: true
            },
            ronna: {
                name: 'ronna',
                value: 1e27,
                scientific: true
            },
            quetta: {
                name: 'quetta',
                value: 1e30,
                scientific: true
            },
            deci: {
                name: 'deci',
                value: 1e-1,
                scientific: false
            },
            centi: {
                name: 'centi',
                value: 1e-2,
                scientific: false
            },
            milli: {
                name: 'milli',
                value: 1e-3,
                scientific: true
            },
            micro: {
                name: 'micro',
                value: 1e-6,
                scientific: true
            },
            nano: {
                name: 'nano',
                value: 1e-9,
                scientific: true
            },
            pico: {
                name: 'pico',
                value: 1e-12,
                scientific: true
            },
            femto: {
                name: 'femto',
                value: 1e-15,
                scientific: true
            },
            atto: {
                name: 'atto',
                value: 1e-18,
                scientific: true
            },
            zepto: {
                name: 'zepto',
                value: 1e-21,
                scientific: true
            },
            yocto: {
                name: 'yocto',
                value: 1e-24,
                scientific: true
            },
            ronto: {
                name: 'ronto',
                value: 1e-27,
                scientific: true
            },
            quecto: {
                name: 'quecto',
                value: 1e-30,
                scientific: true
            }
        },
        SQUARED: {
            '': {
                name: '',
                value: 1,
                scientific: true
            },
            da: {
                name: 'da',
                value: 1e2,
                scientific: false
            },
            h: {
                name: 'h',
                value: 1e4,
                scientific: false
            },
            k: {
                name: 'k',
                value: 1e6,
                scientific: true
            },
            M: {
                name: 'M',
                value: 1e12,
                scientific: true
            },
            G: {
                name: 'G',
                value: 1e18,
                scientific: true
            },
            T: {
                name: 'T',
                value: 1e24,
                scientific: true
            },
            P: {
                name: 'P',
                value: 1e30,
                scientific: true
            },
            E: {
                name: 'E',
                value: 1e36,
                scientific: true
            },
            Z: {
                name: 'Z',
                value: 1e42,
                scientific: true
            },
            Y: {
                name: 'Y',
                value: 1e48,
                scientific: true
            },
            R: {
                name: 'R',
                value: 1e54,
                scientific: true
            },
            Q: {
                name: 'Q',
                value: 1e60,
                scientific: true
            },
            d: {
                name: 'd',
                value: 1e-2,
                scientific: false
            },
            c: {
                name: 'c',
                value: 1e-4,
                scientific: false
            },
            m: {
                name: 'm',
                value: 1e-6,
                scientific: true
            },
            u: {
                name: 'u',
                value: 1e-12,
                scientific: true
            },
            n: {
                name: 'n',
                value: 1e-18,
                scientific: true
            },
            p: {
                name: 'p',
                value: 1e-24,
                scientific: true
            },
            f: {
                name: 'f',
                value: 1e-30,
                scientific: true
            },
            a: {
                name: 'a',
                value: 1e-36,
                scientific: true
            },
            z: {
                name: 'z',
                value: 1e-42,
                scientific: true
            },
            y: {
                name: 'y',
                value: 1e-48,
                scientific: true
            },
            r: {
                name: 'r',
                value: 1e-54,
                scientific: true
            },
            q: {
                name: 'q',
                value: 1e-60,
                scientific: true
            }
        },
        CUBIC: {
            '': {
                name: '',
                value: 1,
                scientific: true
            },
            da: {
                name: 'da',
                value: 1e3,
                scientific: false
            },
            h: {
                name: 'h',
                value: 1e6,
                scientific: false
            },
            k: {
                name: 'k',
                value: 1e9,
                scientific: true
            },
            M: {
                name: 'M',
                value: 1e18,
                scientific: true
            },
            G: {
                name: 'G',
                value: 1e27,
                scientific: true
            },
            T: {
                name: 'T',
                value: 1e36,
                scientific: true
            },
            P: {
                name: 'P',
                value: 1e45,
                scientific: true
            },
            E: {
                name: 'E',
                value: 1e54,
                scientific: true
            },
            Z: {
                name: 'Z',
                value: 1e63,
                scientific: true
            },
            Y: {
                name: 'Y',
                value: 1e72,
                scientific: true
            },
            R: {
                name: 'R',
                value: 1e81,
                scientific: true
            },
            Q: {
                name: 'Q',
                value: 1e90,
                scientific: true
            },
            d: {
                name: 'd',
                value: 1e-3,
                scientific: false
            },
            c: {
                name: 'c',
                value: 1e-6,
                scientific: false
            },
            m: {
                name: 'm',
                value: 1e-9,
                scientific: true
            },
            u: {
                name: 'u',
                value: 1e-18,
                scientific: true
            },
            n: {
                name: 'n',
                value: 1e-27,
                scientific: true
            },
            p: {
                name: 'p',
                value: 1e-36,
                scientific: true
            },
            f: {
                name: 'f',
                value: 1e-45,
                scientific: true
            },
            a: {
                name: 'a',
                value: 1e-54,
                scientific: true
            },
            z: {
                name: 'z',
                value: 1e-63,
                scientific: true
            },
            y: {
                name: 'y',
                value: 1e-72,
                scientific: true
            },
            r: {
                name: 'r',
                value: 1e-81,
                scientific: true
            },
            q: {
                name: 'q',
                value: 1e-90,
                scientific: true
            }
        },
        BINARY_SHORT_SI: {
            '': {
                name: '',
                value: 1,
                scientific: true
            },
            k: {
                name: 'k',
                value: 1e3,
                scientific: true
            },
            M: {
                name: 'M',
                value: 1e6,
                scientific: true
            },
            G: {
                name: 'G',
                value: 1e9,
                scientific: true
            },
            T: {
                name: 'T',
                value: 1e12,
                scientific: true
            },
            P: {
                name: 'P',
                value: 1e15,
                scientific: true
            },
            E: {
                name: 'E',
                value: 1e18,
                scientific: true
            },
            Z: {
                name: 'Z',
                value: 1e21,
                scientific: true
            },
            Y: {
                name: 'Y',
                value: 1e24,
                scientific: true
            }
        },
        BINARY_SHORT_IEC: {
            '': {
                name: '',
                value: 1,
                scientific: true
            },
            Ki: {
                name: 'Ki',
                value: 1024,
                scientific: true
            },
            Mi: {
                name: 'Mi',
                value: Math.pow(1024, 2),
                scientific: true
            },
            Gi: {
                name: 'Gi',
                value: Math.pow(1024, 3),
                scientific: true
            },
            Ti: {
                name: 'Ti',
                value: Math.pow(1024, 4),
                scientific: true
            },
            Pi: {
                name: 'Pi',
                value: Math.pow(1024, 5),
                scientific: true
            },
            Ei: {
                name: 'Ei',
                value: Math.pow(1024, 6),
                scientific: true
            },
            Zi: {
                name: 'Zi',
                value: Math.pow(1024, 7),
                scientific: true
            },
            Yi: {
                name: 'Yi',
                value: Math.pow(1024, 8),
                scientific: true
            }
        },
        BINARY_LONG_SI: {
            '': {
                name: '',
                value: 1,
                scientific: true
            },
            kilo: {
                name: 'kilo',
                value: 1e3,
                scientific: true
            },
            mega: {
                name: 'mega',
                value: 1e6,
                scientific: true
            },
            giga: {
                name: 'giga',
                value: 1e9,
                scientific: true
            },
            tera: {
                name: 'tera',
                value: 1e12,
                scientific: true
            },
            peta: {
                name: 'peta',
                value: 1e15,
                scientific: true
            },
            exa: {
                name: 'exa',
                value: 1e18,
                scientific: true
            },
            zetta: {
                name: 'zetta',
                value: 1e21,
                scientific: true
            },
            yotta: {
                name: 'yotta',
                value: 1e24,
                scientific: true
            }
        },
        BINARY_LONG_IEC: {
            '': {
                name: '',
                value: 1,
                scientific: true
            },
            kibi: {
                name: 'kibi',
                value: 1024,
                scientific: true
            },
            mebi: {
                name: 'mebi',
                value: Math.pow(1024, 2),
                scientific: true
            },
            gibi: {
                name: 'gibi',
                value: Math.pow(1024, 3),
                scientific: true
            },
            tebi: {
                name: 'tebi',
                value: Math.pow(1024, 4),
                scientific: true
            },
            pebi: {
                name: 'pebi',
                value: Math.pow(1024, 5),
                scientific: true
            },
            exi: {
                name: 'exi',
                value: Math.pow(1024, 6),
                scientific: true
            },
            zebi: {
                name: 'zebi',
                value: Math.pow(1024, 7),
                scientific: true
            },
            yobi: {
                name: 'yobi',
                value: Math.pow(1024, 8),
                scientific: true
            }
        },
        BTU: {
            '': {
                name: '',
                value: 1,
                scientific: true
            },
            MM: {
                name: 'MM',
                value: 1e6,
                scientific: true
            }
        }
    };
    PREFIXES.SHORTLONG = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, PREFIXES.SHORT, PREFIXES.LONG);
    PREFIXES.BINARY_SHORT = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, PREFIXES.BINARY_SHORT_SI, PREFIXES.BINARY_SHORT_IEC);
    PREFIXES.BINARY_LONG = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, PREFIXES.BINARY_LONG_SI, PREFIXES.BINARY_LONG_IEC);
    /* Internally, each unit is represented by a value and a dimension array. The elements of the dimensions array have the following meaning:
   * Index  Dimension
   * -----  ---------
   *   0    Length
   *   1    Mass
   *   2    Time
   *   3    Current
   *   4    Temperature
   *   5    Luminous intensity
   *   6    Amount of substance
   *   7    Angle
   *   8    Bit (digital)
   * For example, the unit "298.15 K" is a pure temperature and would have a value of 298.15 and a dimension array of [0, 0, 0, 0, 1, 0, 0, 0, 0]. The unit "1 cal / (gm °C)" can be written in terms of the 9 fundamental dimensions as [length^2] / ([time^2] * [temperature]), and would a value of (after conversion to SI) 4184.0 and a dimensions array of [2, 0, -2, 0, -1, 0, 0, 0, 0].
   *
   */ var BASE_DIMENSIONS = [
        'MASS',
        'LENGTH',
        'TIME',
        'CURRENT',
        'TEMPERATURE',
        'LUMINOUS_INTENSITY',
        'AMOUNT_OF_SUBSTANCE',
        'ANGLE',
        'BIT'
    ];
    var BASE_UNITS = {
        NONE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MASS: {
            dimensions: [
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        LENGTH: {
            dimensions: [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        TIME: {
            dimensions: [
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        CURRENT: {
            dimensions: [
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        TEMPERATURE: {
            dimensions: [
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0
            ]
        },
        LUMINOUS_INTENSITY: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0
            ]
        },
        AMOUNT_OF_SUBSTANCE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0
            ]
        },
        FORCE: {
            dimensions: [
                1,
                1,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        SURFACE: {
            dimensions: [
                0,
                2,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        VOLUME: {
            dimensions: [
                0,
                3,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ENERGY: {
            dimensions: [
                1,
                2,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        POWER: {
            dimensions: [
                1,
                2,
                -3,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        PRESSURE: {
            dimensions: [
                1,
                -1,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CHARGE: {
            dimensions: [
                0,
                0,
                1,
                1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CAPACITANCE: {
            dimensions: [
                -1,
                -2,
                4,
                2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_POTENTIAL: {
            dimensions: [
                1,
                2,
                -3,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_RESISTANCE: {
            dimensions: [
                1,
                2,
                -3,
                -2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_INDUCTANCE: {
            dimensions: [
                1,
                2,
                -2,
                -2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CONDUCTANCE: {
            dimensions: [
                -1,
                -2,
                3,
                2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MAGNETIC_FLUX: {
            dimensions: [
                1,
                2,
                -2,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MAGNETIC_FLUX_DENSITY: {
            dimensions: [
                1,
                0,
                -2,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        FREQUENCY: {
            dimensions: [
                0,
                0,
                -1,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ANGLE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ]
        },
        BIT: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1
            ]
        }
    };
    for(var key in BASE_UNITS)if ((0, $9v8q6.hasOwnProperty)(BASE_UNITS, key)) BASE_UNITS[key].key = key;
    var BASE_UNIT_NONE = {};
    var UNIT_NONE = {
        name: '',
        base: BASE_UNIT_NONE,
        value: 1,
        offset: 0,
        dimensions: BASE_DIMENSIONS.map((x)=>0)
    };
    var UNITS = {
        // length
        meter: {
            name: 'meter',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        inch: {
            name: 'inch',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0254,
            offset: 0
        },
        foot: {
            name: 'foot',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.3048,
            offset: 0
        },
        yard: {
            name: 'yard',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.9144,
            offset: 0
        },
        mile: {
            name: 'mile',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1609.344,
            offset: 0
        },
        link: {
            name: 'link',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.201168,
            offset: 0
        },
        rod: {
            name: 'rod',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 5.0292,
            offset: 0
        },
        chain: {
            name: 'chain',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 20.1168,
            offset: 0
        },
        angstrom: {
            name: 'angstrom',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1e-10,
            offset: 0
        },
        m: {
            name: 'm',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        in: {
            name: 'in',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0254,
            offset: 0
        },
        ft: {
            name: 'ft',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.3048,
            offset: 0
        },
        yd: {
            name: 'yd',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.9144,
            offset: 0
        },
        mi: {
            name: 'mi',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1609.344,
            offset: 0
        },
        li: {
            name: 'li',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.201168,
            offset: 0
        },
        rd: {
            name: 'rd',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 5.029210,
            offset: 0
        },
        ch: {
            name: 'ch',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 20.1168,
            offset: 0
        },
        mil: {
            name: 'mil',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0000254,
            offset: 0
        },
        // 1/1000 inch
        // Surface
        m2: {
            name: 'm2',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.SQUARED,
            value: 1,
            offset: 0
        },
        sqin: {
            name: 'sqin',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.00064516,
            offset: 0
        },
        // 645.16 mm2
        sqft: {
            name: 'sqft',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.09290304,
            offset: 0
        },
        // 0.09290304 m2
        sqyd: {
            name: 'sqyd',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.83612736,
            offset: 0
        },
        // 0.83612736 m2
        sqmi: {
            name: 'sqmi',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 2589988.110336,
            offset: 0
        },
        // 2.589988110336 km2
        sqrd: {
            name: 'sqrd',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 25.29295,
            offset: 0
        },
        // 25.29295 m2
        sqch: {
            name: 'sqch',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 404.6873,
            offset: 0
        },
        // 404.6873 m2
        sqmil: {
            name: 'sqmil',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 6.4516e-10,
            offset: 0
        },
        // 6.4516 * 10^-10 m2
        acre: {
            name: 'acre',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 4046.86,
            offset: 0
        },
        // 4046.86 m2
        hectare: {
            name: 'hectare',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 10000,
            offset: 0
        },
        // 10000 m2
        // Volume
        m3: {
            name: 'm3',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.CUBIC,
            value: 1,
            offset: 0
        },
        L: {
            name: 'L',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        // litre
        l: {
            name: 'l',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        // litre
        litre: {
            name: 'litre',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.LONG,
            value: 0.001,
            offset: 0
        },
        cuin: {
            name: 'cuin',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 1.6387064e-5,
            offset: 0
        },
        // 1.6387064e-5 m3
        cuft: {
            name: 'cuft',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.028316846592,
            offset: 0
        },
        // 28.316 846 592 L
        cuyd: {
            name: 'cuyd',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.764554857984,
            offset: 0
        },
        // 764.554 857 984 L
        teaspoon: {
            name: 'teaspoon',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000005,
            offset: 0
        },
        // 5 mL
        tablespoon: {
            name: 'tablespoon',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000015,
            offset: 0
        },
        // 15 mL
        // {name: 'cup', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.000240, offset: 0}, // 240 mL  // not possible, we have already another cup
        drop: {
            name: 'drop',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 5e-8,
            offset: 0
        },
        // 0.05 mL = 5e-8 m3
        gtt: {
            name: 'gtt',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 5e-8,
            offset: 0
        },
        // 0.05 mL = 5e-8 m3
        // Liquid volume
        minim: {
            name: 'minim',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000000061611519921875,
            offset: 0
        },
        // 1/61440 gallons
        fluiddram: {
            name: 'fluiddram',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0000036966911953125,
            offset: 0
        },
        // 1/1024 gallons
        fluidounce: {
            name: 'fluidounce',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0000295735295625,
            offset: 0
        },
        // 1/128 gallons
        gill: {
            name: 'gill',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.00011829411825,
            offset: 0
        },
        // 1/32 gallons
        cc: {
            name: 'cc',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 1e-6,
            offset: 0
        },
        // 1e-6 L
        cup: {
            name: 'cup',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0002365882365,
            offset: 0
        },
        // 1/16 gallons
        pint: {
            name: 'pint',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000473176473,
            offset: 0
        },
        // 1/8 gallons
        quart: {
            name: 'quart',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000946352946,
            offset: 0
        },
        // 1/4 gallons
        gallon: {
            name: 'gallon',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.003785411784,
            offset: 0
        },
        // 3.785411784 L
        beerbarrel: {
            name: 'beerbarrel',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.117347765304,
            offset: 0
        },
        // 31 gallons
        oilbarrel: {
            name: 'oilbarrel',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.158987294928,
            offset: 0
        },
        // 42 gallons
        hogshead: {
            name: 'hogshead',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.238480942392,
            offset: 0
        },
        // 63 gallons
        // Mass
        g: {
            name: 'g',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        gram: {
            name: 'gram',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.LONG,
            value: 0.001,
            offset: 0
        },
        ton: {
            name: 'ton',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 907.18474,
            offset: 0
        },
        t: {
            name: 't',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 1000,
            offset: 0
        },
        tonne: {
            name: 'tonne',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.LONG,
            value: 1000,
            offset: 0
        },
        grain: {
            name: 'grain',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 64.79891e-6,
            offset: 0
        },
        dram: {
            name: 'dram',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 1.7718451953125e-3,
            offset: 0
        },
        ounce: {
            name: 'ounce',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 28.349523125e-3,
            offset: 0
        },
        poundmass: {
            name: 'poundmass',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 453.59237e-3,
            offset: 0
        },
        hundredweight: {
            name: 'hundredweight',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 45.359237,
            offset: 0
        },
        stick: {
            name: 'stick',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 115e-3,
            offset: 0
        },
        stone: {
            name: 'stone',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 6.35029318,
            offset: 0
        },
        gr: {
            name: 'gr',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 64.79891e-6,
            offset: 0
        },
        dr: {
            name: 'dr',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 1.7718451953125e-3,
            offset: 0
        },
        oz: {
            name: 'oz',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 28.349523125e-3,
            offset: 0
        },
        lbm: {
            name: 'lbm',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 453.59237e-3,
            offset: 0
        },
        cwt: {
            name: 'cwt',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 45.359237,
            offset: 0
        },
        // Time
        s: {
            name: 's',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        min: {
            name: 'min',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 60,
            offset: 0
        },
        h: {
            name: 'h',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3600,
            offset: 0
        },
        second: {
            name: 'second',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        sec: {
            name: 'sec',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        minute: {
            name: 'minute',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 60,
            offset: 0
        },
        hour: {
            name: 'hour',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3600,
            offset: 0
        },
        day: {
            name: 'day',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 86400,
            offset: 0
        },
        week: {
            name: 'week',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 604800,
            offset: 0
        },
        month: {
            name: 'month',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 2629800,
            // 1/12th of Julian year
            offset: 0
        },
        year: {
            name: 'year',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 31557600,
            // Julian year
            offset: 0
        },
        decade: {
            name: 'decade',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 315576000,
            // Julian decade
            offset: 0
        },
        century: {
            name: 'century',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3155760000,
            // Julian century
            offset: 0
        },
        millennium: {
            name: 'millennium',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 31557600000,
            // Julian millennium
            offset: 0
        },
        // Frequency
        hertz: {
            name: 'Hertz',
            base: BASE_UNITS.FREQUENCY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0,
            reciprocal: true
        },
        Hz: {
            name: 'Hz',
            base: BASE_UNITS.FREQUENCY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0,
            reciprocal: true
        },
        // Angle
        rad: {
            name: 'rad',
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        radian: {
            name: 'radian',
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // deg = rad / (2*pi) * 360 = rad / 0.017453292519943295769236907684888
        deg: {
            name: 'deg',
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        degree: {
            name: 'degree',
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // grad = rad / (2*pi) * 400  = rad / 0.015707963267948966192313216916399
        grad: {
            name: 'grad',
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        gradian: {
            name: 'gradian',
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // cycle = rad / (2*pi) = rad / 6.2831853071795864769252867665793
        cycle: {
            name: 'cycle',
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // arcsec = rad / (3600 * (360 / 2 * pi)) = rad / 0.0000048481368110953599358991410235795
        arcsec: {
            name: 'arcsec',
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // arcmin = rad / (60 * (360 / 2 * pi)) = rad / 0.00029088820866572159615394846141477
        arcmin: {
            name: 'arcmin',
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // Electric current
        A: {
            name: 'A',
            base: BASE_UNITS.CURRENT,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        ampere: {
            name: 'ampere',
            base: BASE_UNITS.CURRENT,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // Temperature
        // K(C) = °C + 273.15
        // K(F) = (°F + 459.67) * (5 / 9)
        // K(R) = °R * (5 / 9)
        K: {
            name: 'K',
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        degC: {
            name: 'degC',
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 273.15
        },
        degF: {
            name: 'degF',
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.SHORT,
            value: new _Fraction(5, 9),
            offset: 459.67
        },
        degR: {
            name: 'degR',
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.SHORT,
            value: new _Fraction(5, 9),
            offset: 0
        },
        kelvin: {
            name: 'kelvin',
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        celsius: {
            name: 'celsius',
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 273.15
        },
        fahrenheit: {
            name: 'fahrenheit',
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.LONG,
            value: new _Fraction(5, 9),
            offset: 459.67
        },
        rankine: {
            name: 'rankine',
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.LONG,
            value: new _Fraction(5, 9),
            offset: 0
        },
        // amount of substance
        mol: {
            name: 'mol',
            base: BASE_UNITS.AMOUNT_OF_SUBSTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        mole: {
            name: 'mole',
            base: BASE_UNITS.AMOUNT_OF_SUBSTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // luminous intensity
        cd: {
            name: 'cd',
            base: BASE_UNITS.LUMINOUS_INTENSITY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        candela: {
            name: 'candela',
            base: BASE_UNITS.LUMINOUS_INTENSITY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // TODO: units STERADIAN
        // {name: 'sr', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
        // {name: 'steradian', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
        // Force
        N: {
            name: 'N',
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        newton: {
            name: 'newton',
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        dyn: {
            name: 'dyn',
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.SHORT,
            value: 0.00001,
            offset: 0
        },
        dyne: {
            name: 'dyne',
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 0.00001,
            offset: 0
        },
        lbf: {
            name: 'lbf',
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 4.4482216152605,
            offset: 0
        },
        poundforce: {
            name: 'poundforce',
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 4.4482216152605,
            offset: 0
        },
        kip: {
            name: 'kip',
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 4448.2216,
            offset: 0
        },
        kilogramforce: {
            name: 'kilogramforce',
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 9.80665,
            offset: 0
        },
        // Energy
        J: {
            name: 'J',
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        joule: {
            name: 'joule',
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        erg: {
            name: 'erg',
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORTLONG,
            // Both kiloerg and kerg are acceptable
            value: 1e-7,
            offset: 0
        },
        Wh: {
            name: 'Wh',
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 3600,
            offset: 0
        },
        BTU: {
            name: 'BTU',
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.BTU,
            value: 1055.05585262,
            offset: 0
        },
        eV: {
            name: 'eV',
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1.602176565e-19,
            offset: 0
        },
        electronvolt: {
            name: 'electronvolt',
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.LONG,
            value: 1.602176565e-19,
            offset: 0
        },
        // Power
        W: {
            name: 'W',
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        watt: {
            name: 'watt',
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        hp: {
            name: 'hp',
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.NONE,
            value: 745.6998715386,
            offset: 0
        },
        // Electrical power units
        VAR: {
            name: 'VAR',
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: Complex.I,
            offset: 0
        },
        VA: {
            name: 'VA',
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Pressure
        Pa: {
            name: 'Pa',
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        psi: {
            name: 'psi',
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 6894.75729276459,
            offset: 0
        },
        atm: {
            name: 'atm',
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 101325,
            offset: 0
        },
        bar: {
            name: 'bar',
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.SHORTLONG,
            value: 100000,
            offset: 0
        },
        torr: {
            name: 'torr',
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 133.322,
            offset: 0
        },
        mmHg: {
            name: 'mmHg',
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 133.322,
            offset: 0
        },
        mmH2O: {
            name: 'mmH2O',
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 9.80665,
            offset: 0
        },
        cmH2O: {
            name: 'cmH2O',
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 98.0665,
            offset: 0
        },
        // Electric charge
        coulomb: {
            name: 'coulomb',
            base: BASE_UNITS.ELECTRIC_CHARGE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        C: {
            name: 'C',
            base: BASE_UNITS.ELECTRIC_CHARGE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric capacitance
        farad: {
            name: 'farad',
            base: BASE_UNITS.ELECTRIC_CAPACITANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        F: {
            name: 'F',
            base: BASE_UNITS.ELECTRIC_CAPACITANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric potential
        volt: {
            name: 'volt',
            base: BASE_UNITS.ELECTRIC_POTENTIAL,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        V: {
            name: 'V',
            base: BASE_UNITS.ELECTRIC_POTENTIAL,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric resistance
        ohm: {
            name: 'ohm',
            base: BASE_UNITS.ELECTRIC_RESISTANCE,
            prefixes: PREFIXES.SHORTLONG,
            // Both Mohm and megaohm are acceptable
            value: 1,
            offset: 0
        },
        /*
     * Unicode breaks in browsers if charset is not specified
    Ω: {
      name: 'Ω',
      base: BASE_UNITS.ELECTRIC_RESISTANCE,
      prefixes: PREFIXES.SHORT,
      value: 1,
      offset: 0
    },
    */ // Electric inductance
        henry: {
            name: 'henry',
            base: BASE_UNITS.ELECTRIC_INDUCTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        H: {
            name: 'H',
            base: BASE_UNITS.ELECTRIC_INDUCTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric conductance
        siemens: {
            name: 'siemens',
            base: BASE_UNITS.ELECTRIC_CONDUCTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        S: {
            name: 'S',
            base: BASE_UNITS.ELECTRIC_CONDUCTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Magnetic flux
        weber: {
            name: 'weber',
            base: BASE_UNITS.MAGNETIC_FLUX,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        Wb: {
            name: 'Wb',
            base: BASE_UNITS.MAGNETIC_FLUX,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Magnetic flux density
        tesla: {
            name: 'tesla',
            base: BASE_UNITS.MAGNETIC_FLUX_DENSITY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        T: {
            name: 'T',
            base: BASE_UNITS.MAGNETIC_FLUX_DENSITY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Binary
        b: {
            name: 'b',
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_SHORT,
            value: 1,
            offset: 0
        },
        bits: {
            name: 'bits',
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_LONG,
            value: 1,
            offset: 0
        },
        B: {
            name: 'B',
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_SHORT,
            value: 8,
            offset: 0
        },
        bytes: {
            name: 'bytes',
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_LONG,
            value: 8,
            offset: 0
        }
    };
    // aliases (formerly plurals)
    // note that ALIASES is only used at creation to create more entries in UNITS by copying the aliased units
    var ALIASES = {
        meters: 'meter',
        inches: 'inch',
        feet: 'foot',
        yards: 'yard',
        miles: 'mile',
        links: 'link',
        rods: 'rod',
        chains: 'chain',
        angstroms: 'angstrom',
        lt: 'l',
        litres: 'litre',
        liter: 'litre',
        liters: 'litre',
        teaspoons: 'teaspoon',
        tablespoons: 'tablespoon',
        minims: 'minim',
        fldr: 'fluiddram',
        fluiddrams: 'fluiddram',
        floz: 'fluidounce',
        fluidounces: 'fluidounce',
        gi: 'gill',
        gills: 'gill',
        cp: 'cup',
        cups: 'cup',
        pt: 'pint',
        pints: 'pint',
        qt: 'quart',
        quarts: 'quart',
        gal: 'gallon',
        gallons: 'gallon',
        bbl: 'beerbarrel',
        beerbarrels: 'beerbarrel',
        obl: 'oilbarrel',
        oilbarrels: 'oilbarrel',
        hogsheads: 'hogshead',
        gtts: 'gtt',
        grams: 'gram',
        tons: 'ton',
        tonnes: 'tonne',
        grains: 'grain',
        drams: 'dram',
        ounces: 'ounce',
        poundmasses: 'poundmass',
        hundredweights: 'hundredweight',
        sticks: 'stick',
        lb: 'lbm',
        lbs: 'lbm',
        kips: 'kip',
        kgf: 'kilogramforce',
        acres: 'acre',
        hectares: 'hectare',
        sqfeet: 'sqft',
        sqyard: 'sqyd',
        sqmile: 'sqmi',
        sqmiles: 'sqmi',
        mmhg: 'mmHg',
        mmh2o: 'mmH2O',
        cmh2o: 'cmH2O',
        seconds: 'second',
        secs: 'second',
        minutes: 'minute',
        mins: 'minute',
        hours: 'hour',
        hr: 'hour',
        hrs: 'hour',
        days: 'day',
        weeks: 'week',
        months: 'month',
        years: 'year',
        decades: 'decade',
        centuries: 'century',
        millennia: 'millennium',
        hertz: 'hertz',
        radians: 'radian',
        degrees: 'degree',
        gradians: 'gradian',
        cycles: 'cycle',
        arcsecond: 'arcsec',
        arcseconds: 'arcsec',
        arcminute: 'arcmin',
        arcminutes: 'arcmin',
        BTUs: 'BTU',
        watts: 'watt',
        joules: 'joule',
        amperes: 'ampere',
        amps: 'ampere',
        amp: 'ampere',
        coulombs: 'coulomb',
        volts: 'volt',
        ohms: 'ohm',
        farads: 'farad',
        webers: 'weber',
        teslas: 'tesla',
        electronvolts: 'electronvolt',
        moles: 'mole',
        bit: 'bits',
        byte: 'bytes'
    };
    /**
   * Calculate the values for the angle units.
   * Value is calculated as number or BigNumber depending on the configuration
   * @param {{number: 'number' | 'BigNumber'}} config
   */ function calculateAngleValues(config) {
        if (config.number === 'BigNumber') {
            var pi = (0, $epoj7.createBigNumberPi)(_BigNumber);
            UNITS.rad.value = new _BigNumber(1);
            UNITS.deg.value = pi.div(180); // 2 * pi / 360
            UNITS.grad.value = pi.div(200); // 2 * pi / 400
            UNITS.cycle.value = pi.times(2); // 2 * pi
            UNITS.arcsec.value = pi.div(648000); // 2 * pi / 360 / 3600
            UNITS.arcmin.value = pi.div(10800); // 2 * pi / 360 / 60
        } else {
            // number
            UNITS.rad.value = 1;
            UNITS.deg.value = Math.PI / 180; // 2 * pi / 360
            UNITS.grad.value = Math.PI / 200; // 2 * pi / 400
            UNITS.cycle.value = Math.PI * 2; // 2 * pi
            UNITS.arcsec.value = Math.PI / 648000; // 2 * pi / 360 / 3600
            UNITS.arcmin.value = Math.PI / 10800; // 2 * pi / 360 / 60
        }
        // copy to the full names of the angles
        UNITS.radian.value = UNITS.rad.value;
        UNITS.degree.value = UNITS.deg.value;
        UNITS.gradian.value = UNITS.grad.value;
    }
    // apply the angle values now
    calculateAngleValues(config);
    if (on) // recalculate the values on change of configuration
    on('config', function(curr, prev) {
        if (curr.number !== prev.number) calculateAngleValues(curr);
    });
    /**
   * A unit system is a set of dimensionally independent base units plus a set of derived units, formed by multiplication and division of the base units, that are by convention used with the unit system.
   * A user perhaps could issue a command to select a preferred unit system, or use the default (see below).
   * Auto unit system: The default unit system is updated on the fly anytime a unit is parsed. The corresponding unit in the default unit system is updated, so that answers are given in the same units the user supplies.
   */ var UNIT_SYSTEMS = {
        si: {
            // Base units
            NONE: {
                unit: UNIT_NONE,
                prefix: PREFIXES.NONE['']
            },
            LENGTH: {
                unit: UNITS.m,
                prefix: PREFIXES.SHORT['']
            },
            MASS: {
                unit: UNITS.g,
                prefix: PREFIXES.SHORT.k
            },
            TIME: {
                unit: UNITS.s,
                prefix: PREFIXES.SHORT['']
            },
            CURRENT: {
                unit: UNITS.A,
                prefix: PREFIXES.SHORT['']
            },
            TEMPERATURE: {
                unit: UNITS.K,
                prefix: PREFIXES.SHORT['']
            },
            LUMINOUS_INTENSITY: {
                unit: UNITS.cd,
                prefix: PREFIXES.SHORT['']
            },
            AMOUNT_OF_SUBSTANCE: {
                unit: UNITS.mol,
                prefix: PREFIXES.SHORT['']
            },
            ANGLE: {
                unit: UNITS.rad,
                prefix: PREFIXES.SHORT['']
            },
            BIT: {
                unit: UNITS.bits,
                prefix: PREFIXES.SHORT['']
            },
            // Derived units
            FORCE: {
                unit: UNITS.N,
                prefix: PREFIXES.SHORT['']
            },
            ENERGY: {
                unit: UNITS.J,
                prefix: PREFIXES.SHORT['']
            },
            POWER: {
                unit: UNITS.W,
                prefix: PREFIXES.SHORT['']
            },
            PRESSURE: {
                unit: UNITS.Pa,
                prefix: PREFIXES.SHORT['']
            },
            ELECTRIC_CHARGE: {
                unit: UNITS.C,
                prefix: PREFIXES.SHORT['']
            },
            ELECTRIC_CAPACITANCE: {
                unit: UNITS.F,
                prefix: PREFIXES.SHORT['']
            },
            ELECTRIC_POTENTIAL: {
                unit: UNITS.V,
                prefix: PREFIXES.SHORT['']
            },
            ELECTRIC_RESISTANCE: {
                unit: UNITS.ohm,
                prefix: PREFIXES.SHORT['']
            },
            ELECTRIC_INDUCTANCE: {
                unit: UNITS.H,
                prefix: PREFIXES.SHORT['']
            },
            ELECTRIC_CONDUCTANCE: {
                unit: UNITS.S,
                prefix: PREFIXES.SHORT['']
            },
            MAGNETIC_FLUX: {
                unit: UNITS.Wb,
                prefix: PREFIXES.SHORT['']
            },
            MAGNETIC_FLUX_DENSITY: {
                unit: UNITS.T,
                prefix: PREFIXES.SHORT['']
            },
            FREQUENCY: {
                unit: UNITS.Hz,
                prefix: PREFIXES.SHORT['']
            }
        }
    };
    // Clone to create the other unit systems
    UNIT_SYSTEMS.cgs = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
    UNIT_SYSTEMS.cgs.LENGTH = {
        unit: UNITS.m,
        prefix: PREFIXES.SHORT.c
    };
    UNIT_SYSTEMS.cgs.MASS = {
        unit: UNITS.g,
        prefix: PREFIXES.SHORT['']
    };
    UNIT_SYSTEMS.cgs.FORCE = {
        unit: UNITS.dyn,
        prefix: PREFIXES.SHORT['']
    };
    UNIT_SYSTEMS.cgs.ENERGY = {
        unit: UNITS.erg,
        prefix: PREFIXES.NONE['']
    };
    // there are wholly 4 unique cgs systems for electricity and magnetism,
    // so let's not worry about it unless somebody complains
    UNIT_SYSTEMS.us = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
    UNIT_SYSTEMS.us.LENGTH = {
        unit: UNITS.ft,
        prefix: PREFIXES.NONE['']
    };
    UNIT_SYSTEMS.us.MASS = {
        unit: UNITS.lbm,
        prefix: PREFIXES.NONE['']
    };
    UNIT_SYSTEMS.us.TEMPERATURE = {
        unit: UNITS.degF,
        prefix: PREFIXES.NONE['']
    };
    UNIT_SYSTEMS.us.FORCE = {
        unit: UNITS.lbf,
        prefix: PREFIXES.NONE['']
    };
    UNIT_SYSTEMS.us.ENERGY = {
        unit: UNITS.BTU,
        prefix: PREFIXES.BTU['']
    };
    UNIT_SYSTEMS.us.POWER = {
        unit: UNITS.hp,
        prefix: PREFIXES.NONE['']
    };
    UNIT_SYSTEMS.us.PRESSURE = {
        unit: UNITS.psi,
        prefix: PREFIXES.NONE['']
    };
    // Add additional unit systems here.
    // Choose a unit system to seed the auto unit system.
    UNIT_SYSTEMS.auto = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
    // Set the current unit system
    var currentUnitSystem = UNIT_SYSTEMS.auto;
    /**
   * Set a unit system for formatting derived units.
   * @memberof Unit
   * @param {string} [name] The name of the unit system.
   */ Unit.setUnitSystem = function(name) {
        if ((0, $9v8q6.hasOwnProperty)(UNIT_SYSTEMS, name)) currentUnitSystem = UNIT_SYSTEMS[name];
        else throw new Error('Unit system ' + name + ' does not exist. Choices are: ' + Object.keys(UNIT_SYSTEMS).join(', '));
    };
    /**
   * Return the current unit system.
   * @memberof Unit
   * @return {string} The current unit system.
   */ Unit.getUnitSystem = function() {
        for(var _key in UNIT_SYSTEMS)if ((0, $9v8q6.hasOwnProperty)(UNIT_SYSTEMS, _key)) {
            if (UNIT_SYSTEMS[_key] === currentUnitSystem) return _key;
        }
    };
    /**
   * Converters to convert from number to an other numeric type like BigNumber
   * or Fraction
   */ Unit.typeConverters = {
        BigNumber: function BigNumber(x) {
            if (x !== null && x !== void 0 && x.isFraction) return new _BigNumber(String(x.n)).div(String(x.d)).times(String(x.s));
            return new _BigNumber(x + ''); // stringify to prevent constructor error
        },
        Fraction: function Fraction(x) {
            return new _Fraction(x);
        },
        Complex: function Complex(x) {
            return x;
        },
        number: function number(x) {
            if (x !== null && x !== void 0 && x.isFraction) return _number(x);
            return x;
        }
    };
    /**
   * Retrieve the right converter function corresponding with this unit's
   * value
   *
   * @memberof Unit
   * @return {Function}
   */ Unit.prototype._numberConverter = function() {
        var convert = Unit.typeConverters[this.valueType()];
        if (convert) return convert;
        throw new TypeError('Unsupported Unit value type "' + this.valueType() + '"');
    };
    /**
   * Retrieve the right convertor function corresponding with the type
   * of provided exampleValue.
   *
   * @param {string} type   A string 'number', 'BigNumber', or 'Fraction'
   *                        In case of an unknown type,
   * @return {Function}
   */ Unit._getNumberConverter = function(type) {
        if (!Unit.typeConverters[type]) throw new TypeError('Unsupported type "' + type + '"');
        return Unit.typeConverters[type];
    };
    // Add dimensions to each built-in unit
    for(var _key2 in UNITS)if ((0, $9v8q6.hasOwnProperty)(UNITS, _key2)) {
        var unit = UNITS[_key2];
        unit.dimensions = unit.base.dimensions;
    }
    // Create aliases
    for(var _name2 in ALIASES)if ((0, $9v8q6.hasOwnProperty)(ALIASES, _name2)) {
        var _unit2 = UNITS[ALIASES[_name2]];
        var alias = {};
        for(var _key3 in _unit2)if ((0, $9v8q6.hasOwnProperty)(_unit2, _key3)) alias[_key3] = _unit2[_key3];
        alias.name = _name2;
        UNITS[_name2] = alias;
    }
    /**
   * Checks if a character is a valid latin letter (upper or lower case).
   * Note that this function can be overridden, for example to allow support of other alphabets.
   * @memberof Unit
   * @param {string} c Tested character
   * @return {boolean} true if the character is a latin letter
   */ Unit.isValidAlpha = function isValidAlpha(c) {
        return /^[a-zA-Z]$/.test(c);
    };
    function assertUnitNameIsValid(name) {
        for(var i = 0; i < name.length; i++){
            c = name.charAt(i);
            if (i === 0 && !Unit.isValidAlpha(c)) throw new Error('Invalid unit name (must begin with alpha character): "' + name + '"');
            if (i > 0 && !(Unit.isValidAlpha(c) || isDigit(c))) throw new Error('Invalid unit name (only alphanumeric characters are allowed): "' + name + '"');
        }
    }
    /**
   * Wrapper around createUnitSingle.
   * Example:
   *  createUnit( {
   *     foo: {
   *       prefixes: 'long',
   *       baseName: 'essence-of-foo'
   *     },
   *     bar: '40 foo',
   *     baz: {
   *       definition: '1 bar/hour',
   *       prefixes: 'long'
   *     }
   *   },
   *   {
   *     override: true
   *   })
   * @memberof Unit
   * @param {object} obj      Object map. Each key becomes a unit which is defined by its value.
   * @param {object} options
   * @return {Unit} the last created unit
   */ Unit.createUnit = function(obj, options) {
        if (typeof obj !== 'object') throw new TypeError("createUnit expects first parameter to be of type 'Object'");
        // Remove all units and aliases we are overriding
        if (options && options.override) for(var _key4 in obj){
            if ((0, $9v8q6.hasOwnProperty)(obj, _key4)) Unit.deleteUnit(_key4);
            if (obj[_key4].aliases) for(var i = 0; i < obj[_key4].aliases.length; i++)Unit.deleteUnit(obj[_key4].aliases[i]);
        }
        // TODO: traverse multiple times until all units have been added
        var lastUnit;
        for(var _key5 in obj)if ((0, $9v8q6.hasOwnProperty)(obj, _key5)) lastUnit = Unit.createUnitSingle(_key5, obj[_key5]);
        return lastUnit;
    };
    /**
   * Create a user-defined unit and register it with the Unit type.
   * Example:
   *  createUnitSingle('knot', '0.514444444 m/s')
   *
   * @memberof Unit
   * @param {string} name      The name of the new unit. Must be unique. Example: 'knot'
   * @param {string | Unit | object} definition      Definition of the unit in terms
   * of existing units. For example, '0.514444444 m / s'. Can be a Unit, a string,
   * or an Object. If an Object, may have the following properties:
   *   - definition {string | Unit} The definition of this unit.
   *   - prefixes {string} "none", "short", "long", "binary_short", or "binary_long".
   *     The default is "none".
   *   - aliases {Array} Array of strings. Example: ['knots', 'kt', 'kts']
   *   - offset {Numeric} An offset to apply when converting from the unit. For
   *     example, the offset for celsius is 273.15 and the offset for farhenheit
   *     is 459.67. Default is 0.
   *   - baseName {string} If the unit's dimension does not match that of any other
   *     base unit, the name of the newly create base unit. Otherwise, this property
   *     has no effect.
   *
   * @return {Unit}
   */ Unit.createUnitSingle = function(name, obj) {
        if (typeof obj === 'undefined' || obj === null) obj = {};
        if (typeof name !== 'string') throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");
        // Check collisions with existing units
        if ((0, $9v8q6.hasOwnProperty)(UNITS, name)) throw new Error('Cannot create unit "' + name + '": a unit with that name already exists');
        // TODO: Validate name for collisions with other built-in functions (like abs or cos, for example), and for acceptable variable names. For example, '42' is probably not a valid unit. Nor is '%', since it is also an operator.
        assertUnitNameIsValid(name);
        var defUnit = null; // The Unit from which the new unit will be created.
        var aliases = [];
        var offset = 0;
        var definition;
        var prefixes;
        var baseName;
        if (obj && obj.type === 'Unit') defUnit = obj.clone();
        else if (typeof obj === 'string') {
            if (obj !== '') definition = obj;
        } else if (typeof obj === 'object') {
            definition = obj.definition;
            prefixes = obj.prefixes;
            offset = obj.offset;
            baseName = obj.baseName;
            if (obj.aliases) aliases = obj.aliases.valueOf(); // aliases could be a Matrix, so convert to Array
        } else throw new TypeError('Cannot create unit "' + name + '" from "' + obj.toString() + '": expecting "string" or "Unit" or "Object"');
        if (aliases) for(var i = 0; i < aliases.length; i++){
            if ((0, $9v8q6.hasOwnProperty)(UNITS, aliases[i])) throw new Error('Cannot create alias "' + aliases[i] + '": a unit with that name already exists');
        }
        if (definition && typeof definition === 'string' && !defUnit) try {
            defUnit = Unit.parse(definition, {
                allowNoUnits: true
            });
        } catch (ex) {
            ex.message = 'Could not create unit "' + name + '" from "' + definition + '": ' + ex.message;
            throw ex;
        }
        else if (definition && definition.type === 'Unit') defUnit = definition.clone();
        aliases = aliases || [];
        offset = offset || 0;
        if (prefixes && prefixes.toUpperCase) prefixes = PREFIXES[prefixes.toUpperCase()] || PREFIXES.NONE;
        else prefixes = PREFIXES.NONE;
        // If defUnit is null, it is because the user did not
        // specify a defintion. So create a new base dimension.
        var newUnit = {};
        if (!defUnit) {
            // Add a new base dimension
            baseName = baseName || name + '_STUFF'; // foo --> foo_STUFF, or the essence of foo
            if (BASE_DIMENSIONS.indexOf(baseName) >= 0) throw new Error('Cannot create new base unit "' + name + '": a base unit with that name already exists (and cannot be overridden)');
            BASE_DIMENSIONS.push(baseName);
            // Push 0 onto existing base units
            for(var b in BASE_UNITS)if ((0, $9v8q6.hasOwnProperty)(BASE_UNITS, b)) BASE_UNITS[b].dimensions[BASE_DIMENSIONS.length - 1] = 0;
            // Add the new base unit
            var newBaseUnit = {
                dimensions: []
            };
            for(var _i6 = 0; _i6 < BASE_DIMENSIONS.length; _i6++)newBaseUnit.dimensions[_i6] = 0;
            newBaseUnit.dimensions[BASE_DIMENSIONS.length - 1] = 1;
            newBaseUnit.key = baseName;
            BASE_UNITS[baseName] = newBaseUnit;
            newUnit = {
                name: name,
                value: 1,
                dimensions: BASE_UNITS[baseName].dimensions.slice(0),
                prefixes: prefixes,
                offset: offset,
                base: BASE_UNITS[baseName]
            };
            currentUnitSystem[baseName] = {
                unit: newUnit,
                prefix: PREFIXES.NONE['']
            };
        } else {
            newUnit = {
                name: name,
                value: defUnit.value,
                dimensions: defUnit.dimensions.slice(0),
                prefixes: prefixes,
                offset: offset
            };
            // Create a new base if no matching base exists
            var anyMatch = false;
            for(var _i7 in BASE_UNITS)if ((0, $9v8q6.hasOwnProperty)(BASE_UNITS, _i7)) {
                var match = true;
                for(var j = 0; j < BASE_DIMENSIONS.length; j++)if (Math.abs((newUnit.dimensions[j] || 0) - (BASE_UNITS[_i7].dimensions[j] || 0)) > 1e-12) {
                    match = false;
                    break;
                }
                if (match) {
                    anyMatch = true;
                    newUnit.base = BASE_UNITS[_i7];
                    break;
                }
            }
            if (!anyMatch) {
                baseName = baseName || name + '_STUFF'; // foo --> foo_STUFF, or the essence of foo
                // Add the new base unit
                var _newBaseUnit = {
                    dimensions: defUnit.dimensions.slice(0)
                };
                _newBaseUnit.key = baseName;
                BASE_UNITS[baseName] = _newBaseUnit;
                currentUnitSystem[baseName] = {
                    unit: newUnit,
                    prefix: PREFIXES.NONE['']
                };
                newUnit.base = BASE_UNITS[baseName];
            }
        }
        Unit.UNITS[name] = newUnit;
        for(var _i8 = 0; _i8 < aliases.length; _i8++){
            var aliasName = aliases[_i8];
            var _alias = {};
            for(var _key6 in newUnit)if ((0, $9v8q6.hasOwnProperty)(newUnit, _key6)) _alias[_key6] = newUnit[_key6];
            _alias.name = aliasName;
            Unit.UNITS[aliasName] = _alias;
        }
        // delete the memoization cache because we created a new unit
        delete _findUnit.cache;
        return new Unit(null, name);
    };
    Unit.deleteUnit = function(name) {
        delete Unit.UNITS[name];
        // delete the memoization cache because we deleted a unit
        delete _findUnit.cache;
    };
    // expose arrays with prefixes, dimensions, units, systems
    Unit.PREFIXES = PREFIXES;
    Unit.BASE_DIMENSIONS = BASE_DIMENSIONS;
    Unit.BASE_UNITS = BASE_UNITS;
    Unit.UNIT_SYSTEMS = UNIT_SYSTEMS;
    Unit.UNITS = UNITS;
    return Unit;
}, {
    isClass: true
});

});

parcelRegister("dr4WD", function(module, exports) {

$parcel$export(module.exports, "createUnitFunction", () => $9c81a1dff4f880e5$export$17074f98b69d2545);

var $dsu7t = parcelRequire("dsu7t");

var $20mkw = parcelRequire("20mkw");
var $9c81a1dff4f880e5$var$name = 'unit';
var $9c81a1dff4f880e5$var$dependencies = [
    'typed',
    'Unit'
];
var $9c81a1dff4f880e5$export$17074f98b69d2545 = /* #__PURE__ */ (0, $dsu7t.factory)($9c81a1dff4f880e5$var$name, $9c81a1dff4f880e5$var$dependencies, (_ref)=>{
    var { typed: typed, Unit: Unit } = _ref;
    /**
   * Create a unit. Depending on the passed arguments, the function
   * will create and return a new math.Unit object.
   * When a matrix is provided, all elements will be converted to units.
   *
   * Syntax:
   *
   *     math.unit(unit : string)
   *     math.unit(value : number, valuelessUnit : Unit)
   *     math.unit(value : number, valuelessUnit : string)
   *
   * Examples:
   *
   *    const kph = math.unit('km/h')   // returns Unit km/h (valueless)
   *    const v = math.unit(25, kph)    // returns Unit 25 km/h
   *    const a = math.unit(5, 'cm')    // returns Unit 50 mm
   *    const b = math.unit('23 kg')    // returns Unit 23 kg
   *    a.to('m')                       // returns Unit 0.05 m
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, number, string, createUnit
   *
   * @param {* | Array | Matrix} args   A number and unit.
   * @return {Unit | Array | Matrix}    The created unit
   */ return typed($9c81a1dff4f880e5$var$name, {
        Unit: function Unit(x) {
            return x.clone();
        },
        string: function string(x) {
            if (Unit.isValuelessUnit(x)) return new Unit(null, x); // a pure unit
            return Unit.parse(x, {
                allowNoUnits: true
            }); // a unit with value, like '5cm'
        },
        'number | BigNumber | Fraction | Complex, string | Unit': function number__BigNumber__Fraction__Complex_string__Unit(value, unit) {
            return new Unit(value, unit);
        },
        'number | BigNumber | Fraction': function number__BigNumber__Fraction(value) {
            // dimensionless
            return new Unit(value);
        },
        'Array | Matrix': typed.referToSelf((self)=>(x)=>(0, $20mkw.deepMap)(x, self))
    });
});

});

parcelRegister("2M1iS", function(module, exports) {

$parcel$export(module.exports, "createUsolve", () => $20511348125bbf76$export$f652f5e8e3e838da);

var $dsu7t = parcelRequire("dsu7t");

var $1pDtp = parcelRequire("1pDtp");
var $20511348125bbf76$var$name = 'usolve';
var $20511348125bbf76$var$dependencies = [
    'typed',
    'matrix',
    'divideScalar',
    'multiplyScalar',
    'subtractScalar',
    'equalScalar',
    'DenseMatrix'
];
var $20511348125bbf76$export$f652f5e8e3e838da = /* #__PURE__ */ (0, $dsu7t.factory)($20511348125bbf76$var$name, $20511348125bbf76$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtractScalar: subtractScalar, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $1pDtp.createSolveValidation)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds one solution of a linear equation system by backward substitution. Matrix must be an upper triangular matrix. Throws an error if there's no solution.
   *
   * `U * x = b`
   *
   * Syntax:
   *
   *    math.usolve(U, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = usolve(a, b)  // [[8], [9]]
   *
   * See also:
   *
   *    usolveAll, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} U       A N x N matrix or array (U)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix | Array}  A column vector with the linear system solution (x)
   */ return typed($20511348125bbf76$var$name, {
        'SparseMatrix, Array | Matrix': function SparseMatrix_Array__Matrix(m, b) {
            return _sparseBackwardSubstitution(m, b);
        },
        'DenseMatrix, Array | Matrix': function DenseMatrix_Array__Matrix(m, b) {
            return _denseBackwardSubstitution(m, b);
        },
        'Array, Array | Matrix': function Array_Array__Matrix(a, b) {
            var m = matrix(a);
            var r = _denseBackwardSubstitution(m, b);
            return r.valueOf();
        }
    });
    function _denseBackwardSubstitution(m, b) {
        // make b into a column vector
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1];
        // result
        var x = [];
        var mdata = m._data;
        // loop columns backwards
        for(var j = columns - 1; j >= 0; j--){
            // b[j]
            var bj = bdata[j][0] || 0;
            // x[j]
            var xj = void 0;
            if (!equalScalar(bj, 0)) {
                // value at [j, j]
                var vjj = mdata[j][j];
                if (equalScalar(vjj, 0)) // system cannot be solved
                throw new Error('Linear system cannot be solved since matrix is singular');
                xj = divideScalar(bj, vjj);
                // loop rows
                for(var i = j - 1; i >= 0; i--)// update copy of b
                bdata[i] = [
                    subtractScalar(bdata[i][0] || 0, multiplyScalar(xj, mdata[i][j]))
                ];
            } else // zero value at j
            xj = 0;
            // update x
            x[j] = [
                xj
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
    function _sparseBackwardSubstitution(m, b) {
        // make b into a column vector
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        // result
        var x = [];
        // loop columns backwards
        for(var j = columns - 1; j >= 0; j--){
            var bj = bdata[j][0] || 0;
            if (!equalScalar(bj, 0)) {
                // non-degenerate row, find solution
                var vjj = 0;
                // upper triangular matrix values & index (column j)
                var jValues = [];
                var jIndices = [];
                // first & last indeces in column
                var firstIndex = ptr[j];
                var lastIndex = ptr[j + 1];
                // values in column, find value at [j, j], loop backwards
                for(var k = lastIndex - 1; k >= firstIndex; k--){
                    var i = index[k];
                    // check row (rows are not sorted!)
                    if (i === j) vjj = values[k];
                    else if (i < j) {
                        // store upper triangular
                        jValues.push(values[k]);
                        jIndices.push(i);
                    }
                }
                // at this point we must have a value in vjj
                if (equalScalar(vjj, 0)) throw new Error('Linear system cannot be solved since matrix is singular');
                var xj = divideScalar(bj, vjj);
                for(var _k = 0, _lastIndex = jIndices.length; _k < _lastIndex; _k++){
                    var _i = jIndices[_k];
                    bdata[_i] = [
                        subtractScalar(bdata[_i][0], multiplyScalar(xj, jValues[_k]))
                    ];
                }
                x[j] = [
                    xj
                ];
            } else // degenerate row, we can choose any value
            x[j] = [
                0
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
});

});

parcelRegister("gCCMo", function(module, exports) {

$parcel$export(module.exports, "createUsolveAll", () => $c19e46bd82ee07aa$export$c8bbc8bec60c7fc3);

var $dsu7t = parcelRequire("dsu7t");

var $1pDtp = parcelRequire("1pDtp");
var $c19e46bd82ee07aa$var$name = 'usolveAll';
var $c19e46bd82ee07aa$var$dependencies = [
    'typed',
    'matrix',
    'divideScalar',
    'multiplyScalar',
    'subtractScalar',
    'equalScalar',
    'DenseMatrix'
];
var $c19e46bd82ee07aa$export$c8bbc8bec60c7fc3 = /* #__PURE__ */ (0, $dsu7t.factory)($c19e46bd82ee07aa$var$name, $c19e46bd82ee07aa$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtractScalar: subtractScalar, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $1pDtp.createSolveValidation)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds all solutions of a linear equation system by backward substitution. Matrix must be an upper triangular matrix.
   *
   * `U * x = b`
   *
   * Syntax:
   *
   *    math.usolveAll(U, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = usolveAll(a, b)  // [ [[8], [9]] ]
   *
   * See also:
   *
   *    usolve, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} U       A N x N matrix or array (U)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix[] | Array[]}  An array of affine-independent column vectors (x) that solve the linear system
   */ return typed($c19e46bd82ee07aa$var$name, {
        'SparseMatrix, Array | Matrix': function SparseMatrix_Array__Matrix(m, b) {
            return _sparseBackwardSubstitution(m, b);
        },
        'DenseMatrix, Array | Matrix': function DenseMatrix_Array__Matrix(m, b) {
            return _denseBackwardSubstitution(m, b);
        },
        'Array, Array | Matrix': function Array_Array__Matrix(a, b) {
            var m = matrix(a);
            var R = _denseBackwardSubstitution(m, b);
            return R.map((r)=>r.valueOf());
        }
    });
    function _denseBackwardSubstitution(m, b_) {
        // the algorithm is derived from
        // https://www.overleaf.com/read/csvgqdxggyjv
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var M = m._data;
        var rows = m._size[0];
        var columns = m._size[1];
        // loop columns backwards
        for(var i = columns - 1; i >= 0; i--){
            var L = B.length;
            // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k];
                if (!equalScalar(M[i][i], 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], M[i][i]);
                    for(var j = i - 1; j >= 0; j--)// b[j] -= b[i] * M[j,i]
                    b[j] = subtractScalar(b[j], multiplyScalar(b[i], M[j][i]));
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1;
                    for(var _j = i - 1; _j >= 0; _j--)bNew[_j] = subtractScalar(bNew[_j], M[_j][i]);
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
    function _sparseBackwardSubstitution(m, b_) {
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        // loop columns backwards
        for(var i = columns - 1; i >= 0; i--){
            var L = B.length;
            // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k];
                // values & indices (column i)
                var iValues = [];
                var iIndices = [];
                // first & last indeces in column
                var firstIndex = ptr[i];
                var lastIndex = ptr[i + 1];
                // find the value at [i, i]
                var Mii = 0;
                for(var j = lastIndex - 1; j >= firstIndex; j--){
                    var J = index[j];
                    // check row
                    if (J === i) Mii = values[j];
                    else if (J < i) {
                        // store upper triangular
                        iValues.push(values[j]);
                        iIndices.push(J);
                    }
                }
                if (!equalScalar(Mii, 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], Mii);
                    // loop upper triangular
                    for(var _j2 = 0, _lastIndex = iIndices.length; _j2 < _lastIndex; _j2++){
                        var _J = iIndices[_j2];
                        b[_J] = subtractScalar(b[_J], multiplyScalar(b[i], iValues[_j2]));
                    }
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1;
                    // loop upper triangular
                    for(var _j3 = 0, _lastIndex2 = iIndices.length; _j3 < _lastIndex2; _j3++){
                        var _J2 = iIndices[_j3];
                        bNew[_J2] = subtractScalar(bNew[_J2], iValues[_j3]);
                    }
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
});

});

parcelRegister("aW39D", function(module, exports) {

$parcel$export(module.exports, "createVariance", () => $7f61c48dd496ed8d$export$b989221824390fb);

var $20mkw = parcelRequire("20mkw");

var $edQYF = parcelRequire("edQYF");

var $dsu7t = parcelRequire("dsu7t");

var $a2CJg = parcelRequire("a2CJg");
var $7f61c48dd496ed8d$var$DEFAULT_NORMALIZATION = 'unbiased';
var $7f61c48dd496ed8d$var$name = 'variance';
var $7f61c48dd496ed8d$var$dependencies = [
    'typed',
    'add',
    'subtract',
    'multiply',
    'divide',
    'mapSlices',
    'isNaN'
];
var $7f61c48dd496ed8d$export$b989221824390fb = /* #__PURE__ */ (0, $dsu7t.factory)($7f61c48dd496ed8d$var$name, $7f61c48dd496ed8d$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, subtract: subtract, multiply: multiply, divide: divide, mapSlices: mapSlices, isNaN: mathIsNaN } = _ref;
    /**
   * Compute the variance of a matrix or a  list with values.
   * In case of a multidimensional array or matrix, the variance over all
   * elements will be calculated.
   *
   * Additionally, it is possible to compute the variance along the rows
   * or columns of a matrix by specifying the dimension as the second argument.
   *
   * Optionally, the type of normalization can be specified as the final
   * parameter. The parameter `normalization` can be one of the following values:
   *
   * - 'unbiased' (default) The sum of squared errors is divided by (n - 1)
   * - 'uncorrected'        The sum of squared errors is divided by n
   * - 'biased'             The sum of squared errors is divided by (n + 1)
   *
   *
   * Note that older browser may not like the variable name `var`. In that
   * case, the function can be called as `math['var'](...)` instead of
   * `math.var(...)`.
   *
   * Syntax:
   *
   *     math.variance(a, b, c, ...)
   *     math.variance(A)
   *     math.variance(A, normalization)
   *     math.variance(A, dimension)
   *     math.variance(A, dimension, normalization)
   *
   * Examples:
   *
   *     math.variance(2, 4, 6)                     // returns 4
   *     math.variance([2, 4, 6, 8])                // returns 6.666666666666667
   *     math.variance([2, 4, 6, 8], 'uncorrected') // returns 5
   *     math.variance([2, 4, 6, 8], 'biased')      // returns 4
   *
   *     math.variance([[1, 2, 3], [4, 5, 6]])      // returns 3.5
   *     math.variance([[1, 2, 3], [4, 6, 8]], 0)   // returns [4.5, 8, 12.5]
   *     math.variance([[1, 2, 3], [4, 6, 8]], 1)   // returns [1, 4]
   *     math.variance([[1, 2, 3], [4, 6, 8]], 1, 'biased') // returns [0.5, 2]
   *
   * See also:
   *
   *    mean, median, max, min, prod, std, sum
   *
   * @param {Array | Matrix} array
   *                        A single matrix or or multiple scalar values
   * @param {string} [normalization='unbiased']
   *                        Determines how to normalize the variance.
   *                        Choose 'unbiased' (default), 'uncorrected', or 'biased'.
   * @param dimension {number | BigNumber}
   *                        Determines the axis to compute the variance for a matrix
   * @return {*} The variance
   */ return typed($7f61c48dd496ed8d$var$name, {
        // variance([a, b, c, d, ...])
        'Array | Matrix': function Array__Matrix(array) {
            return _var(array, $7f61c48dd496ed8d$var$DEFAULT_NORMALIZATION);
        },
        // variance([a, b, c, d, ...], normalization)
        'Array | Matrix, string': _var,
        // variance([a, b, c, c, ...], dim)
        'Array | Matrix, number | BigNumber': function Array__Matrix_number__BigNumber(array, dim) {
            return _varDim(array, dim, $7f61c48dd496ed8d$var$DEFAULT_NORMALIZATION);
        },
        // variance([a, b, c, c, ...], dim, normalization)
        'Array | Matrix, number | BigNumber, string': _varDim,
        // variance(a, b, c, d, ...)
        '...': function _(args) {
            return _var(args, $7f61c48dd496ed8d$var$DEFAULT_NORMALIZATION);
        }
    });
    /**
   * Recursively calculate the variance of an n-dimensional array
   * @param {Array} array
   * @param {string} normalization
   *                        Determines how to normalize the variance:
   *                        - 'unbiased'    The sum of squared errors is divided by (n - 1)
   *                        - 'uncorrected' The sum of squared errors is divided by n
   *                        - 'biased'      The sum of squared errors is divided by (n + 1)
   * @return {number | BigNumber} variance
   * @private
   */ function _var(array, normalization) {
        var sum;
        var num = 0;
        if (array.length === 0) throw new SyntaxError('Function variance requires one or more parameters (0 provided)');
        // calculate the mean and number of elements
        (0, $20mkw.deepForEach)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
                num++;
            } catch (err) {
                throw (0, $a2CJg.improveErrorMessage)(err, 'variance', value);
            }
        });
        if (num === 0) throw new Error('Cannot calculate variance of an empty array');
        var mean = divide(sum, num);
        // calculate the variance
        sum = undefined;
        (0, $20mkw.deepForEach)(array, function(value) {
            var diff = subtract(value, mean);
            sum = sum === undefined ? multiply(diff, diff) : add(sum, multiply(diff, diff));
        });
        if (mathIsNaN(sum)) return sum;
        switch(normalization){
            case 'uncorrected':
                return divide(sum, num);
            case 'biased':
                return divide(sum, num + 1);
            case 'unbiased':
                var zero = (0, $edQYF.isBigNumber)(sum) ? sum.mul(0) : 0;
                return num === 1 ? zero : divide(sum, num - 1);
            default:
                throw new Error('Unknown normalization "' + normalization + '". ' + 'Choose "unbiased" (default), "uncorrected", or "biased".');
        }
    }
    function _varDim(array, dim, normalization) {
        try {
            if (array.length === 0) throw new SyntaxError('Function variance requires one or more parameters (0 provided)');
            return mapSlices(array, dim, (x)=>_var(x, normalization));
        } catch (err) {
            throw (0, $a2CJg.improveErrorMessage)(err, 'variance');
        }
    }
});

});

parcelRegister("e2ZuL", function(module, exports) {

$parcel$export(module.exports, "createXgcd", () => $a3a0f43c987edb08$export$de8cbd18c98bf9d5);

var $dsu7t = parcelRequire("dsu7t");

var $dmcGu = parcelRequire("dmcGu");
var $a3a0f43c987edb08$var$name = 'xgcd';
var $a3a0f43c987edb08$var$dependencies = [
    'typed',
    'config',
    'matrix',
    'BigNumber'
];
var $a3a0f43c987edb08$export$de8cbd18c98bf9d5 = /* #__PURE__ */ (0, $dsu7t.factory)($a3a0f43c987edb08$var$name, $a3a0f43c987edb08$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber } = _ref;
    /**
   * Calculate the extended greatest common divisor for two values.
   * See https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm.
   *
   * Syntax:
   *
   *    math.xgcd(a, b)
   *
   * Examples:
   *
   *    math.xgcd(8, 12)             // returns [4, -1, 1]
   *    math.gcd(8, 12)              // returns 4
   *    math.xgcd(36163, 21199)      // returns [1247, -7, 12]
   *
   * See also:
   *
   *    gcd, lcm
   *
   * @param {number | BigNumber} a  An integer number
   * @param {number | BigNumber} b  An integer number
   * @return {Array}              Returns an array containing 3 integers `[div, m, n]`
   *                              where `div = gcd(a, b)` and `a*m + b*n = div`
   */ return typed($a3a0f43c987edb08$var$name, {
        'number, number': function number_number(a, b) {
            var res = (0, $dmcGu.xgcdNumber)(a, b);
            return config.matrix === 'Array' ? res : matrix(res);
        },
        'BigNumber, BigNumber': _xgcdBigNumber
    });
    /**
   * Calculate xgcd for two BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @return {BigNumber[]} result
   * @private
   */ function _xgcdBigNumber(a, b) {
        // source: https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm
        var // used to swap two variables
        t;
        var // quotient
        q;
        var // remainder
        r;
        var zero = new BigNumber(0);
        var one = new BigNumber(1);
        var x = zero;
        var lastx = one;
        var y = one;
        var lasty = zero;
        if (!a.isInt() || !b.isInt()) throw new Error('Parameters in function xgcd must be integer numbers');
        while(!b.isZero()){
            q = a.div(b).floor();
            r = a.mod(b);
            t = x;
            x = lastx.minus(q.times(x));
            lastx = t;
            t = y;
            y = lasty.minus(q.times(y));
            lasty = t;
            a = b;
            b = r;
        }
        var res;
        if (a.lt(zero)) res = [
            a.neg(),
            lastx.neg(),
            lasty.neg()
        ];
        else res = [
            a,
            !a.isZero() ? lastx : 0,
            lasty
        ];
        return config.matrix === 'Array' ? res : matrix(res);
    }
});

});

parcelRegister("1qcgB", function(module, exports) {

$parcel$export(module.exports, "createXor", () => $1091bc139be08485$export$a2b8cab2c7385f0e);

var $a8bto = parcelRequire("a8bto");

var $6RFQP = parcelRequire("6RFQP");

var $19L2p = parcelRequire("19L2p");

var $dsu7t = parcelRequire("dsu7t");

var $6SJnV = parcelRequire("6SJnV");

var $69vHM = parcelRequire("69vHM");
var $1091bc139be08485$var$name = 'xor';
var $1091bc139be08485$var$dependencies = [
    'typed',
    'matrix',
    'DenseMatrix',
    'concat',
    'SparseMatrix'
];
var $1091bc139be08485$export$a2b8cab2c7385f0e = /* #__PURE__ */ (0, $dsu7t.factory)($1091bc139be08485$var$name, $1091bc139be08485$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, DenseMatrix: DenseMatrix, concat: concat, SparseMatrix: SparseMatrix } = _ref;
    var matAlgo03xDSf = (0, $a8bto.createMatAlgo03xDSf)({
        typed: typed
    });
    var matAlgo07xSSf = (0, $6RFQP.createMatAlgo07xSSf)({
        typed: typed,
        SparseMatrix: SparseMatrix
    });
    var matAlgo12xSfs = (0, $19L2p.createMatAlgo12xSfs)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var matrixAlgorithmSuite = (0, $6SJnV.createMatrixAlgorithmSuite)({
        typed: typed,
        matrix: matrix,
        concat: concat
    });
    /**
   * Logical `xor`. Test whether one and only one value is defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.xor(x, y)
   *
   * Examples:
   *
   *    math.xor(2, 4)   // returns false
   *
   *    a = [2, 0, 0]
   *    b = [2, 7, 0]
   *    c = 0
   *
   *    math.xor(a, b)   // returns [false, true, false]
   *    math.xor(a, c)   // returns [true, false, false]
   *
   * See also:
   *
   *    and, not, or
   *
   * @param  {number | BigNumber | bigint | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | bigint | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when one and only one input is defined with a nonzero/nonempty value.
   */ return typed($1091bc139be08485$var$name, {
        'number, number': (0, $69vHM.xorNumber),
        'Complex, Complex': function Complex_Complex(x, y) {
            return (x.re !== 0 || x.im !== 0) !== (y.re !== 0 || y.im !== 0);
        },
        'bigint, bigint': (0, $69vHM.xorNumber),
        'BigNumber, BigNumber': function BigNumber_BigNumber(x, y) {
            return (!x.isZero() && !x.isNaN()) !== (!y.isZero() && !y.isNaN());
        },
        'Unit, Unit': typed.referToSelf((self)=>(x, y)=>self(x.value || 0, y.value || 0))
    }, matrixAlgorithmSuite({
        SS: matAlgo07xSSf,
        DS: matAlgo03xDSf,
        Ss: matAlgo12xSfs
    }));
});

});

parcelRegister("3XggM", function(module, exports) {

$parcel$export(module.exports, "createZeros", () => $2e1380951657beed$export$13096c1635fe6e3d);

var $edQYF = parcelRequire("edQYF");

var $6NnhX = parcelRequire("6NnhX");

var $d80Xp = parcelRequire("d80Xp");

var $dsu7t = parcelRequire("dsu7t");
var $2e1380951657beed$var$name = 'zeros';
var $2e1380951657beed$var$dependencies = [
    'typed',
    'config',
    'matrix',
    'BigNumber'
];
var $2e1380951657beed$export$13096c1635fe6e3d = /* #__PURE__ */ (0, $dsu7t.factory)($2e1380951657beed$var$name, $2e1380951657beed$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber } = _ref;
    /**
   * Create a matrix filled with zeros. The created matrix can have one or
   * multiple dimensions.
   *
   * Syntax:
   *
   *    math.zeros(m)
   *    math.zeros(m, format)
   *    math.zeros(m, n)
   *    math.zeros(m, n, format)
   *    math.zeros([m, n])
   *    math.zeros([m, n], format)
   *
   * Examples:
   *
   *    math.zeros()                   // returns []
   *    math.zeros(3)                  // returns [0, 0, 0]
   *    math.zeros(3, 2)               // returns [[0, 0], [0, 0], [0, 0]]
   *    math.zeros(3, 'dense')         // returns [0, 0, 0]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.zeros(math.size(A))       // returns [[0, 0, 0], [0, 0, 0]]
   *
   * See also:
   *
   *    ones, identity, size, range
   *
   * @param {...(number|BigNumber) | Array} size    The size of each dimension of the matrix
   * @param {string} [format]           The Matrix storage format
   *
   * @return {Array | Matrix}           A matrix filled with zeros
   */ return typed($2e1380951657beed$var$name, {
        '': function _() {
            return config.matrix === 'Array' ? _zeros([]) : _zeros([], 'default');
        },
        // math.zeros(m, n, p, ..., format)
        // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
        '...number | BigNumber | string': function number__BigNumber__string(size) {
            var last = size[size.length - 1];
            if (typeof last === 'string') {
                var format = size.pop();
                return _zeros(size, format);
            } else if (config.matrix === 'Array') return _zeros(size);
            else return _zeros(size, 'default');
        },
        Array: _zeros,
        Matrix: function Matrix(size) {
            var format = size.storage();
            return _zeros(size.valueOf(), format);
        },
        'Array | Matrix, string': function Array__Matrix_string(size, format) {
            return _zeros(size.valueOf(), format);
        }
    });
    /**
   * Create an Array or Matrix with zeros
   * @param {Array} size
   * @param {string} [format='default']
   * @return {Array | Matrix}
   * @private
   */ function _zeros(size, format) {
        var hasBigNumbers = _normalize(size);
        var defaultValue = hasBigNumbers ? new BigNumber(0) : 0;
        _validate(size);
        if (format) {
            // return a matrix
            var m = matrix(format);
            if (size.length > 0) return m.resize(size, defaultValue);
            return m;
        } else {
            // return an Array
            var arr = [];
            if (size.length > 0) return (0, $d80Xp.resize)(arr, size, defaultValue);
            return arr;
        }
    }
    // replace BigNumbers with numbers, returns true if size contained BigNumbers
    function _normalize(size) {
        var hasBigNumbers = false;
        size.forEach(function(value, index, arr) {
            if ((0, $edQYF.isBigNumber)(value)) {
                hasBigNumbers = true;
                arr[index] = value.toNumber();
            }
        });
        return hasBigNumbers;
    }
    // validate arguments
    function _validate(size) {
        size.forEach(function(value) {
            if (typeof value !== 'number' || !(0, $6NnhX.isInteger)(value) || value < 0) throw new Error('Parameters in function zeros must be positive integers');
        });
    }
}); // TODO: zeros contains almost the same code as ones. Reuse this?

});

parcelRegister("81RTn", function(module, exports) {

$parcel$export(module.exports, "createZeta", () => $5d883897be2e7745$export$7bb33f27b1ded438);

var $dsu7t = parcelRequire("dsu7t");
var $5d883897be2e7745$var$name = 'zeta';
var $5d883897be2e7745$var$dependencies = [
    'typed',
    'config',
    'multiply',
    'pow',
    'divide',
    'factorial',
    'equal',
    'smallerEq',
    'isNegative',
    'gamma',
    'sin',
    'subtract',
    'add',
    '?Complex',
    '?BigNumber',
    'pi'
];
var $5d883897be2e7745$export$7bb33f27b1ded438 = /* #__PURE__ */ (0, $dsu7t.factory)($5d883897be2e7745$var$name, $5d883897be2e7745$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, multiply: multiply, pow: pow, divide: divide, factorial: factorial, equal: equal, smallerEq: smallerEq, isNegative: isNegative, gamma: gamma, sin: sin, subtract: subtract, add: add, Complex: Complex, BigNumber: _BigNumber, pi: pi } = _ref;
    /**
   * Compute the Riemann Zeta function of a value using an infinite series for
   * all of the complex plane using Riemann's Functional equation.
   *
   * Based off the paper by Xavier Gourdon and Pascal Sebah
   * ( http://numbers.computation.free.fr/Constants/Miscellaneous/zetaevaluations.pdf )
   *
   * Implementation and slight modification by Anik Patel
   *
   * Note: the implementation is accurate up to about 6 digits.
   *
   * Syntax:
   *
   *    math.zeta(n)
   *
   * Examples:
   *
   *    math.zeta(5)       // returns 1.0369277551433895
   *    math.zeta(-0.5)    // returns -0.2078862249773449
   *    math.zeta(math.i)  // returns 0.0033002236853253153 - 0.4181554491413212i
   *
   * See also:
   *    erf
   *
   * @param {number | Complex | BigNumber} s   A Real, Complex or BigNumber parameter to the Riemann Zeta Function
   * @return {number | Complex | BigNumber}    The Riemann Zeta of `s`
   */ return typed($5d883897be2e7745$var$name, {
        number: (s)=>zetaNumeric(s, (value)=>value, ()=>20),
        BigNumber: (s)=>zetaNumeric(s, (value)=>new _BigNumber(value), ()=>{
                // relTol is for example 1e-12. Extract the positive exponent 12 from that
                return Math.abs(Math.log10(config.relTol));
            }),
        Complex: zetaComplex
    });
    /**
   * @param {number | BigNumber} s
   * @param {(value: number) => number | BigNumber} createValue
   * @param {(value: number | BigNumber | Complex) => number} determineDigits
   * @returns {number | BigNumber}
   */ function zetaNumeric(s, createValue, determineDigits) {
        if (equal(s, 0)) return createValue(-0.5);
        if (equal(s, 1)) return createValue(NaN);
        if (!isFinite(s)) return isNegative(s) ? createValue(NaN) : createValue(1);
        return zeta(s, createValue, determineDigits, (s)=>s);
    }
    /**
   * @param {Complex} s
   * @returns {Complex}
   */ function zetaComplex(s) {
        if (s.re === 0 && s.im === 0) return new Complex(-0.5);
        if (s.re === 1) return new Complex(NaN, NaN);
        if (s.re === Infinity && s.im === 0) return new Complex(1);
        if (s.im === Infinity || s.re === -Infinity) return new Complex(NaN, NaN);
        return zeta(s, (value)=>value, (s)=>Math.round(19.5 + 0.9 * Math.abs(s.im)), (s)=>s.re);
    }
    /**
   * @param {number | BigNumber | Complex} s
   * @param {(value: number) => number | BigNumber | Complex} createValue
   * @param {(value: number | BigNumber | Complex) => number} determineDigits
   * @param {(value: number | BigNumber | Complex) => number} getRe
   * @returns {*|number}
   */ function zeta(s, createValue, determineDigits, getRe) {
        var n = determineDigits(s);
        if (getRe(s) > -(n - 1) / 2) return f(s, createValue(n), createValue);
        else {
            // Function Equation for reflection to x < 1
            var c = multiply(pow(2, s), pow(createValue(pi), subtract(s, 1)));
            c = multiply(c, sin(multiply(divide(createValue(pi), 2), s)));
            c = multiply(c, gamma(subtract(1, s)));
            return multiply(c, zeta(subtract(1, s), createValue, determineDigits, getRe));
        }
    }
    /**
   * Calculate a portion of the sum
   * @param {number | BigNumber} k   a positive integer
   * @param {number | BigNumber} n   a positive integer
   * @return {number}    the portion of the sum
   **/ function d(k, n) {
        var S = k;
        for(var j = k; smallerEq(j, n); j = add(j, 1)){
            var factor = divide(multiply(factorial(add(n, subtract(j, 1))), pow(4, j)), multiply(factorial(subtract(n, j)), factorial(multiply(2, j))));
            S = add(S, factor);
        }
        return multiply(n, S);
    }
    /**
   * Calculate the positive Riemann Zeta function
   * @param {number} s   a real or complex number with s.re > 1
   * @param {number} n   a positive integer
   * @param {(number) => number | BigNumber | Complex} createValue
   * @return {number}    Riemann Zeta of s
   **/ function f(s, n, createValue) {
        var c = divide(1, multiply(d(createValue(0), n), subtract(1, pow(2, subtract(1, s)))));
        var S = createValue(0);
        for(var k = createValue(1); smallerEq(k, n); k = add(k, 1))S = add(S, divide(multiply((-1) ** (k - 1), d(k, n)), pow(k, s)));
        return multiply(c, S);
    }
});

});

parcelRegister("7gJ0l", function(module, exports) {

$parcel$export(module.exports, "createZpk2tf", () => $54aceff9409ebc9b$export$9d6f6343ff32e725);

var $dsu7t = parcelRequire("dsu7t");
var $54aceff9409ebc9b$var$name = 'zpk2tf';
var $54aceff9409ebc9b$var$dependencies = [
    'typed',
    'add',
    'multiply',
    'Complex',
    'number'
];
var $54aceff9409ebc9b$export$9d6f6343ff32e725 = /* #__PURE__ */ (0, $dsu7t.factory)($54aceff9409ebc9b$var$name, $54aceff9409ebc9b$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, multiply: multiply, Complex: Complex, number: number } = _ref;
    /**
     * Compute the transfer function of a zero-pole-gain model.
     *
     * Syntax:
     *      math.zpk2tf(z, p, k)
     *
     * Examples:
     *    math.zpk2tf([1, 2], [-1, -2], 1)    // returns [[1, -3, 2], [1, 3, 2]]
     *
     * See also:
     *   freqz
     *
     * @param {Array} z Array of zeros values
     * @param {Array} p Array of poles values
     * @param {number} k Gain value
     * @return {Array} Two dimensional array containing the numerator (first row) and denominator (second row) polynomials
     *
     */ return typed($54aceff9409ebc9b$var$name, {
        'Array,Array,number': function ArrayArrayNumber(z, p, k) {
            return _zpk2tf(z, p, k);
        },
        'Array,Array': function ArrayArray(z, p) {
            return _zpk2tf(z, p, 1);
        },
        'Matrix,Matrix,number': function MatrixMatrixNumber(z, p, k) {
            return _zpk2tf(z.valueOf(), p.valueOf(), k);
        },
        'Matrix,Matrix': function MatrixMatrix(z, p) {
            return _zpk2tf(z.valueOf(), p.valueOf(), 1);
        }
    });
    function _zpk2tf(z, p, k) {
        // if z is bignumber, convert it to number
        if (z.some((el)=>el.type === 'BigNumber')) z = z.map((el)=>number(el));
        // if p is bignumber, convert it to number
        if (p.some((el)=>el.type === 'BigNumber')) p = p.map((el)=>number(el));
        var num = [
            Complex(1, 0)
        ];
        var den = [
            Complex(1, 0)
        ];
        for(var i = 0; i < z.length; i++){
            var zero = z[i];
            if (typeof zero === 'number') zero = Complex(zero, 0);
            num = _multiply(num, [
                Complex(1, 0),
                Complex(-zero.re, -zero.im)
            ]);
        }
        for(var _i = 0; _i < p.length; _i++){
            var pole = p[_i];
            if (typeof pole === 'number') pole = Complex(pole, 0);
            den = _multiply(den, [
                Complex(1, 0),
                Complex(-pole.re, -pole.im)
            ]);
        }
        for(var _i2 = 0; _i2 < num.length; _i2++)num[_i2] = multiply(num[_i2], k);
        return [
            num,
            den
        ];
    }
    function _multiply(a, b) {
        var c = [];
        for(var i = 0; i < a.length + b.length - 1; i++){
            c[i] = Complex(0, 0);
            for(var j = 0; j < a.length; j++)if (i - j >= 0 && i - j < b.length) c[i] = add(c[i], multiply(a[j], b[i - j]));
        }
        return c;
    }
});

});


parcelRegister("dBOsW", function(module, exports) {

$parcel$export(module.exports, "WMS_request", () => $9e85e08a0654283f$export$2ae118a11ee39f6);

var $8wy2x = parcelRequire("8wy2x");

var $lBMGk = parcelRequire("lBMGk");

var $8Lu1J = parcelRequire("8Lu1J");

var $4aJ1U = parcelRequire("4aJ1U");

var $hCh95 = parcelRequire("hCh95");

var $iMQia = parcelRequire("iMQia");
class $9e85e08a0654283f$var$Tephi_var {
    constructor(nomvar){
        this.nomvar = nomvar;
        this.present = false;
        this.p_max = null;
        this.p_min = null;
        this.data = [];
        this.levels = [];
        this.diag = null;
        this.mult = null;
    }
}
class $9e85e08a0654283f$var$Tephi_prof {
    constructor(model, lat, lon){
        this.model = model;
        this.lat = lat;
        this.lon = lon;
        this.grid_point_coor = null; // Array [longitude,latitude]
        this.axisU = null; // Array [dLon,dLat], cf. wms-forecast-client/src/gridAxes.js
        this.axisV = null;
        this.dateo_wms_format = null;
        this.datev_wms_format = null;
        this.datev = null;
        this.p0 = null;
        this.knams = 0.5147910000000E+00;
        this.ind_T = 0;
        this.ind_Td = 1;
        this.ind_UU = 2;
        this.ind_WD = 3;
        this.ind_GZ = 4;
        this.tephi_var = new Array(5);
        this.tephi_var[0] = new $9e85e08a0654283f$var$Tephi_var("TT");
        this.tephi_var[1] = new $9e85e08a0654283f$var$Tephi_var("ES");
        this.tephi_var[2] = new $9e85e08a0654283f$var$Tephi_var("WSPD");
        this.tephi_var[3] = new $9e85e08a0654283f$var$Tephi_var("WD");
        this.tephi_var[4] = new $9e85e08a0654283f$var$Tephi_var("GZ");
        this.tephi_var[this.ind_T].mult = 1.;
        this.tephi_var[this.ind_Td].mult = 1.;
        this.tephi_var[this.ind_UU].mult = 1. / this.knams;
        this.tephi_var[this.ind_WD].mult = 1.;
        this.tephi_var[this.ind_GZ].mult = 1.;
        if (this.model == "HRDPS") this.resolution = 2.5;
        else if (this.model == "RDPS" || this.model == "GDPS") this.resolution = 10.;
        else {
            alert('Internal error in class Tephi_prof, add variable ' + this.model + ' to this.resolution');
            return;
        }
    }
    get_nb_of_layers() {
        var count = 0;
        for(let i = 0; i < this.tephi_var.length; i++)if (this.tephi_var[i].present) {
            count = count + this.tephi_var[i].levels.length;
            // Add diag level
            count++;
        }
        // Add surface pressure
        count++;
        return count;
    }
    is_a_sub_profile(profile) {
        // profile is the candidate to a match
        // "this." is the current user request.
        var debug = false;
        if (this.model != profile.model) {
            if (debug) console.log("From method is_a_sub_profile, not same model");
            return false;
        }
        if (this.lat != profile.lat && this.lon != profile.lon) // lat lon may not be the same but actual grid point may be the same.
        {
            if (this.distance_from_grid_point(profile.grid_point_coor[1], profile.grid_point_coor[0]) > .5 * this.resolution) {
                if (debug) console.log("From method is_a_sub_profile, not same grid point, distance=" + this.distance_from_grid_point(profile.grid_point_coor[1], profile.grid_point_coor[0]));
                return false;
            }
        }
        if (this.dateo_wms_format != profile.dateo_wms_format) {
            if (debug) console.log("From method is_a_sub_profile, not same dateo");
            return false;
        }
        if (this.datev_wms_format != profile.datev_wms_format) {
            if (debug) console.log("From method is_a_sub_profile, not same datev");
            return false;
        }
        for(let i = 0; i < this.tephi_var.length; i++)if (this.tephi_var[i].present == true) {
            if (profile.tephi_var[i].present == false) {
                if (debug) console.log("From method is_a_sub_profile, no " + this.tephi_var[i].nomvar);
                return false;
            }
            if (this.tephi_var[i].p_max == "Surface") {
                if (profile.tephi_var[i].p_max != "Surface") {
                    if (debug) console.log("From method is_a_sub_profile, no match for p_max, candidate is " + profile.tephi_var[i].p_max + " current value is " + this.tephi_var[i].p_max);
                    return false;
                }
            } else {
                if (profile.tephi_var[i].p_max == "Surface") {
                    if (debug) console.log("From method is_a_sub_profile, no match for p_max, candidate is " + profile.tephi_var[i].p_max + " current value is " + this.tephi_var[i].p_max);
                    return false;
                }
                if (parseInt(this.tephi_var[i].p_max) > parseInt(profile.tephi_var[i].p_max)) {
                    if (debug) console.log("From method is_a_sub_profile, no match for p_max, candidate is " + profile.tephi_var[i].p_max + " current value is " + this.tephi_var[i].p_max);
                    return false;
                }
            }
            if (parseInt(this.tephi_var[i].p_min) < parseInt(profile.tephi_var[i].p_min)) {
                if (debug) console.log("From method is_a_sub_profile, no match for p_min, candidate is " + profile.tephi_var[i].nomvar + " current value is " + this.tephi_var[i].p_min);
                return false;
            }
        }
        return true;
    }
    distance_from_grid_point(grid_point_lat, grid_point_lon) {
        var deg2rad = 0.017453292519944444;
        var lon1 = grid_point_lon * deg2rad;
        var lat1 = grid_point_lat * deg2rad;
        var lon2 = this.lon * deg2rad;
        var lat2 = this.lat * deg2rad;
        return Math.acos(Math.sin(lat1) * Math.sin(lat2) + Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1)) * 0.6371220000000E+04;
    }
}
class $9e85e08a0654283f$export$2ae118a11ee39f6 {
    constructor(tephi_control, levels, markers){
        this.controller = null;
        this.tephi_control = tephi_control;
        this.tephi_prof_list = [];
        this.markers = markers;
        this.levels = levels;
        this.model = null;
        this.progress_bar = new $9e85e08a0654283f$var$Progress_bar(document.getElementById("id_progress"));
        this.dateo = new Date();
        this.datev = new Date();
        this.request_completed = 1;
        this.now = null;
        this.hh_min_delta_fcst = null;
        this.hhh_end = null;
    }
    async get_fcst_dates(lat, lon) {
        this.clear_datev_menu();
        this.model = this.tephi_control.get_model();
        this.tephi_control.id_message.innerHTML = "Obtention de la date d'origine et des heures de pr&eacute;vision pour le " + this.model;
        // Abort any fetch requests in progress then create a fresh controller
        if (this.request_completed == 0) this.controller.abort();
        this.request_completed = 0;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.progress_bar.update_progress_bar(0.01);
        this.now = new Date();
        const p0Layer = (0, $8Lu1J.metaLayer)(this.model);
        let caps;
        try {
            caps = await (0, $8wy2x.fetchCapabilities)(p0Layer, signal);
        } catch (e) {
            if (signal.aborted) return;
            console.error('Erreur GetCapabilities:', e);
            this.request_completed = 1;
            return;
        }
        if (signal.aborted) return;
        this.dateo = caps.dateo;
        this.datef = caps.datef;
        this.hhh_end = (caps.datef - caps.dateo) / 3600000;
        this.hh_min_delta_fcst = caps.deltaHours;
        this.progress_bar.update_progress_bar(1.);
        this.set_datev_menu();
        this.request_completed = 1;
    }
    get_data(pendingMarker = null) {
        if (!this.model || this.model == "UNDEF") {
            alert("Vous devez choisir un mod\xe8le avec le menu en haut \xe0 gauche");
            return;
        }
        // Abort any fetch requests in progress then create a fresh controller
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        var tephi_prof = new $9e85e08a0654283f$var$Tephi_prof(this.model, this.lat, this.lon);
        tephi_prof.dateo_wms_format = $9e85e08a0654283f$var$Get_Wms_date_format(this.dateo);
        tephi_prof.datev = this.tephi_control.get_datev_menu_text();
        tephi_prof.datev_wms_format = this.tephi_control.get_datev_menu_value();
        var fetch_data_L = this.set_pressure_info(tephi_prof);
        //try to find a saved profiles with this request
        var tephi_prof_found = this.find_saved_profile(tephi_prof);
        if (tephi_prof_found) {
            (0, $iMQia.mytephi).clear_profile();
            this.tephi_control.id_message.innerHTML = "Donn&eacute;es obtenues de la cache";
            if (pendingMarker) pendingMarker.clear();
            // Ce point de grille a déjà été visité (find_saved_profile ne matche
            // que sur un point proche) : les axes ont déjà été sondés la première
            // fois, pas besoin de refaire de requêtes WMS pour redessiner le
            // maillage en rouge.
            if (tephi_prof_found.axisU) this.markers.promote(tephi_prof_found.model, tephi_prof_found.grid_point_coor[0], tephi_prof_found.grid_point_coor[1], tephi_prof_found.axisU, tephi_prof_found.axisV, tephi_prof_found.resolution);
            this.plot_tephi(tephi_prof_found);
            return;
        }
        if (!fetch_data_L) {
            this.tephi_control.id_message.innerHTML = "Aucune donn&eacute;e s&eacute;lectionn&eacute;e!";
            if (pendingMarker) pendingMarker.clear();
            return;
        }
        var nb = tephi_prof.get_nb_of_layers();
        this.tephi_control.id_message.innerHTML = "Il y a " + nb.toString() + " couches &agrave; t&eacute;l&eacute;charger.";
        // Met à jour la barre de progression selon le nombre de valeurs déjà reçues.
        const updateProgress = ()=>{
            var count = 0;
            for(let k = 0; k < tephi_prof.tephi_var.length; k++){
                if (!tephi_prof.tephi_var[k].present) continue;
                for(let g = 0; g < tephi_prof.tephi_var[k].levels.length; g++)if (tephi_prof.tephi_var[k].data[g] > -998) count++;
                // Le diag compte une seule fois par variable, pas une fois par niveau
                if (tephi_prof.tephi_var[k].diag > -998) count++;
            }
            if (tephi_prof.p0 > -998) count++;
            this.progress_bar.update_progress_bar(count / nb);
        };
        // Construire la liste des couches à télécharger (P0, profil de pression, diag)
        const tasks = [
            {
                type: 'p0'
            }
        ];
        for(let i = 0; i < tephi_prof.tephi_var.length; i++)if (tephi_prof.tephi_var[i].present) {
            for(let j = 0; j < tephi_prof.tephi_var[i].levels.length; j++)tasks.push({
                type: 'pres',
                i: i,
                j: j
            });
            tasks.push({
                type: 'diag',
                i: i
            });
        }
        // Nombre de requêtes en vol simultanément — au-delà, GeoMet répond 429
        const CONCURRENCY = 10;
        const worker = async (task)=>{
            if (task.type === 'p0') try {
                const { value: value, gridLon: gridLon, gridLat: gridLat } = await (0, $lBMGk.fetchFeatureInfo)({
                    layer: (0, $8Lu1J.metaLayer)(this.model),
                    lat: this.lat,
                    lon: this.lon,
                    time: tephi_prof.datev_wms_format,
                    refTime: tephi_prof.dateo_wms_format,
                    style: (0, $8Lu1J.styleForVariable)('P0')
                }, signal);
                tephi_prof.p0 = value / 100.;
                tephi_prof.grid_point_coor = [
                    gridLon,
                    gridLat
                ];
                if (pendingMarker) pendingMarker.clear();
                // Sonde les axes réels de la grille (3-6 requêtes WMS, cf.
                // wms-forecast-client/src/gridAxes.js) sans bloquer les autres
                // fetch en vol, puis dessine le maillage. Les axes sont mis en
                // cache sur tephi_prof pour qu'un futur hit sur ce même point de
                // grille n'ait pas à re-sonder (cf. branche find_saved_profile).
                (0, $4aJ1U.findGridAxes)({
                    layer: (0, $8Lu1J.metaLayer)(this.model),
                    style: (0, $8Lu1J.styleForVariable)('P0'),
                    time: tephi_prof.datev_wms_format,
                    refTime: tephi_prof.dateo_wms_format,
                    lon0: gridLon,
                    lat0: gridLat
                }, signal).then(({ axisU: axisU, axisV: axisV })=>{
                    if (signal.aborted) return;
                    tephi_prof.axisU = axisU;
                    tephi_prof.axisV = axisV;
                    this.markers.promote(this.model, gridLon, gridLat, axisU, axisV, tephi_prof.resolution);
                }).catch((error)=>{
                    if (signal.aborted) return;
                    console.error('Erreur lors du calcul du maillage de grille:', error);
                });
            } catch (error) {
                tephi_prof.p0 = -999;
                if (pendingMarker) pendingMarker.clear();
                console.error('Error:', error);
            }
            else if (task.type === 'pres') {
                const { i: i, j: j } = task;
                const isGZ_pres = tephi_prof.tephi_var[i].nomvar === 'GZ';
                try {
                    const { value: value } = await (0, $lBMGk.fetchFeatureInfo)({
                        layer: (0, $8Lu1J.layerName)(this.model, tephi_prof.tephi_var[i].nomvar, tephi_prof.tephi_var[i].levels[j]),
                        lat: this.lat,
                        lon: this.lon,
                        time: isGZ_pres ? tephi_prof.dateo_wms_format : tephi_prof.datev_wms_format,
                        refTime: tephi_prof.dateo_wms_format,
                        style: (0, $8Lu1J.styleForVariable)(tephi_prof.tephi_var[i].nomvar, this.model)
                    }, signal);
                    tephi_prof.tephi_var[i].data[j] = parseFloat(value * tephi_prof.tephi_var[i].mult);
                } catch (error) {
                    tephi_prof.tephi_var[i].data[j] = -999;
                    console.error('Error:', error);
                }
            } else {
                const { i: i } = task;
                const isGZ_diag = tephi_prof.tephi_var[i].nomvar === 'GZ';
                try {
                    const { value: value } = await (0, $lBMGk.fetchFeatureInfo)({
                        layer: (0, $8Lu1J.layerName)(this.model, tephi_prof.tephi_var[i].nomvar, 'diag'),
                        lat: this.lat,
                        lon: this.lon,
                        time: isGZ_diag ? tephi_prof.dateo_wms_format : tephi_prof.datev_wms_format,
                        refTime: tephi_prof.dateo_wms_format,
                        style: (0, $8Lu1J.styleForVariable)(tephi_prof.tephi_var[i].nomvar, this.model)
                    }, signal);
                    tephi_prof.tephi_var[i].diag = parseFloat(value * tephi_prof.tephi_var[i].mult);
                } catch (error) {
                    tephi_prof.tephi_var[i].diag = -999;
                    console.error('Error:', error);
                }
            }
            updateProgress();
        };
        (0, $lBMGk.runWithConcurrency)(tasks, worker, CONCURRENCY).then(()=>{
            // La requête a été annulée car l'utilisateur a recliqué — ne pas tracer
            if (signal.aborted) return;
            var OK = 1;
            for(let i = 0; i < tephi_prof.tephi_var.length; i++){
                for(let j = 0; j < tephi_prof.tephi_var[i].levels.length; j++)if (tephi_prof.tephi_var[i].data[j] < -998) OK = 0;
            }
            if (OK == 0) {
                this.tephi_control.id_message.innerHTML = "Probl&egrave;me avec le t&eacute;l&eacute;chargement de certaines donn&eacute;es";
                this.progress_bar.reset_progress_bar(0.);
                return;
            }
            this.progress_bar.update_progress_bar(1.);
            this.progress_bar.reset_progress_bar(0.);
            this.compute_td(tephi_prof);
            this.plot_tephi(tephi_prof);
            // Ne mettre en cache que les profils complets — un profil annulé/incomplet
            // ne doit jamais pouvoir être retrouvé par find_saved_profile()
            this.tephi_prof_list.push(tephi_prof);
            this.tephi_control.id_message.innerHTML = nb.toString() + " couches t&eacute;l&eacute;charg&eacute;es avec succ&egrave;s";
        }).catch((error)=>{
            this.tephi_control.id_message.innerHTML = "Requ&ecirc;te termin&eacute;e avec erreurs :-(";
            console.error('Error:', error);
        });
    }
    compute_td(tephi_prof) {
        for(let i = 0; i < tephi_prof.tephi_var[tephi_prof.ind_Td].data.length; i++){
            var found = false;
            var pres = tephi_prof.tephi_var[tephi_prof.ind_Td].levels[i];
            for(let j = 0; j < tephi_prof.tephi_var[tephi_prof.ind_T].data.length; j++)if (tephi_prof.tephi_var[tephi_prof.ind_T].levels[j] == pres) {
                found = true;
                tephi_prof.tephi_var[tephi_prof.ind_Td].data[i] = tephi_prof.tephi_var[tephi_prof.ind_T].data[j] - tephi_prof.tephi_var[tephi_prof.ind_Td].data[i];
            }
            if (!found) {
                alert("Tous les niveaux de Td doivent \xeatre inclus dans ceux de la temp\xe9rture");
                return;
            }
        }
        tephi_prof.tephi_var[tephi_prof.ind_Td].diag = tephi_prof.tephi_var[tephi_prof.ind_T].diag - tephi_prof.tephi_var[tephi_prof.ind_Td].diag;
    }
    plot_tephi(tephi_prof) {
        (0, $iMQia.mytephi).clear_profile();
        if (tephi_prof.tephi_var[tephi_prof.ind_T].present) (0, $iMQia.mytephi).plot_profile_wms(tephi_prof.p0, tephi_prof.tephi_var[tephi_prof.ind_T].diag, tephi_prof.tephi_var[tephi_prof.ind_T].data, tephi_prof.tephi_var[tephi_prof.ind_T].levels, "temp\xe9rature", 'red');
        if (tephi_prof.tephi_var[tephi_prof.ind_Td].present) (0, $iMQia.mytephi).plot_profile_wms(tephi_prof.p0, tephi_prof.tephi_var[tephi_prof.ind_Td].diag, tephi_prof.tephi_var[tephi_prof.ind_Td].data, tephi_prof.tephi_var[tephi_prof.ind_Td].levels, "point de ros\xe9e", 'blue');
        if (tephi_prof.tephi_var[tephi_prof.ind_UU].present) {
            // Find maximum index i of tt points over tephi wind data
            // to plot wind profile to the right of it.
            var found = false;
            var count = 0;
            if (tephi_prof.tephi_var[tephi_prof.ind_T].present) {
                for(var i = 0; i < tephi_prof.tephi_var[tephi_prof.ind_UU].data.length; i++){
                    for(var j = 0; j < tephi_prof.tephi_var[tephi_prof.ind_T].data.length; j++)if (tephi_prof.tephi_var[tephi_prof.ind_T].levels[j] == tephi_prof.tephi_var[tephi_prof.ind_UU].levels[i]) {
                        found = true;
                        ij = (0, $iMQia.mytephi).temp_pres_to_i_j(tephi_prof.tephi_var[tephi_prof.ind_T].data[j], tephi_prof.tephi_var[tephi_prof.ind_T].levels[j]);
                        break;
                    }
                    if (found) {
                        if (count == 0) {
                            var i_max = ij[0];
                            var T_imax = tephi_prof.tephi_var[tephi_prof.ind_T].data[j];
                            var p_imax = tephi_prof.tephi_var[tephi_prof.ind_T].levels[j];
                        } else if (ij[0] > i_max) {
                            var i_max = ij[0];
                            var T_imax = tephi_prof.tephi_var[tephi_prof.ind_T].data[j];
                            var p_imax = tephi_prof.tephi_var[tephi_prof.ind_T].levels[j];
                        }
                        count++;
                    }
                }
                if (!found) {
                    var T_imax = 0;
                    var p_imax = 1000.;
                    var ij = (0, $iMQia.mytephi).temp_pres_to_i_j(T_imax, p_imax);
                    i_max = ij[0];
                }
            } else {
                var T_imax = 0;
                var p_imax = 1000.;
                var ij = (0, $iMQia.mytephi).temp_pres_to_i_j(T_imax, p_imax);
                i_max = ij[0];
            }
            (0, $iMQia.mytephi).plot_winds_wms(tephi_prof.p0, tephi_prof.tephi_var[tephi_prof.ind_UU].diag, tephi_prof.tephi_var[tephi_prof.ind_UU].data, tephi_prof.tephi_var[tephi_prof.ind_WD].diag, tephi_prof.tephi_var[tephi_prof.ind_WD].data, tephi_prof.tephi_var[tephi_prof.ind_UU].levels, i_max, T_imax, p_imax);
        }
        if (tephi_prof.tephi_var[tephi_prof.ind_GZ].present) {
            // Find maximum index i of tt points over tephi wind data
            // to plot GZ profile to the right of it, add space if wind is present
            var found = false;
            var count = 0;
            if (tephi_prof.tephi_var[tephi_prof.ind_T].present) {
                for(var i = 0; i < tephi_prof.tephi_var[tephi_prof.ind_GZ].data.length; i++){
                    for(var j = 0; j < tephi_prof.tephi_var[tephi_prof.ind_T].data.length; j++)if (tephi_prof.tephi_var[tephi_prof.ind_T].levels[j] == tephi_prof.tephi_var[tephi_prof.ind_GZ].levels[i]) {
                        found = true;
                        ij = (0, $iMQia.mytephi).temp_pres_to_i_j(tephi_prof.tephi_var[tephi_prof.ind_T].data[j], tephi_prof.tephi_var[tephi_prof.ind_T].levels[j]);
                        break;
                    }
                    if (found) {
                        if (count == 0) {
                            var i_max = ij[0];
                            var T_imax = tephi_prof.tephi_var[tephi_prof.ind_T].data[j];
                            var p_imax = tephi_prof.tephi_var[tephi_prof.ind_T].levels[j];
                        } else if (ij[0] > i_max) {
                            var i_max = ij[0];
                            var T_imax = tephi_prof.tephi_var[tephi_prof.ind_T].data[j];
                            var p_imax = tephi_prof.tephi_var[tephi_prof.ind_T].levels[j];
                        }
                        count++;
                    }
                }
                if (!found) {
                    var T_imax = 0;
                    var p_imax = 1000.;
                    var ij = (0, $iMQia.mytephi).temp_pres_to_i_j(T_imax, p_imax);
                    i_max = ij[0];
                }
            } else {
                var T_imax = 0;
                var p_imax = 1000.;
                var ij = (0, $iMQia.mytephi).temp_pres_to_i_j(T_imax, p_imax);
                i_max = ij[0];
            }
            if (document.getElementById('id_height_no').checked == false) (0, $iMQia.mytephi).plot_GZ_profile_wms(tephi_prof.p0, tephi_prof.tephi_var[tephi_prof.ind_GZ].diag, tephi_prof.tephi_var[tephi_prof.ind_GZ].data, tephi_prof.tephi_var[tephi_prof.ind_GZ].levels, T_imax, p_imax);
        }
        this.tephi_control.id_product_displayed.innerHTML = "Affich&eacute; : mod&egrave;le " + this.model + ",\n valide : " + tephi_prof.datev;
    }
    clear_datev_menu() {
        const menu = this.tephi_control.id_datev_menu;
        var ni = menu.options.length - 1;
        for(let i = ni; i >= 0; i--)menu.remove(i);
    }
    set_datev_menu() {
        const menu = this.tephi_control.id_datev_menu;
        let i = 0;
        let ind = 0;
        var datev = new Date(this.dateo.getTime());
        const options = {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            timeZoneName: 'short'
        };
        while(i <= this.hhh_end){
            if (i == 1000) {
                console.log("Internale error, runaway loop in set_datev_menu");
                return;
            }
            if (datev <= this.now) ind = i;
            let option = document.createElement("option");
            option.setAttribute('value', $9e85e08a0654283f$var$Get_Wms_date_format(datev));
            option.appendChild(document.createTextNode('t+' + String(i) + "h : " + datev.toLocaleDateString('fr-fr', options)));
            menu.appendChild(option);
            i = i + this.hh_min_delta_fcst;
            datev.setHours(datev.getHours() + this.hh_min_delta_fcst);
        }
        this.progress_bar.reset_progress_bar(0.);
        menu.selectedIndex = ind;
        this.tephi_control.id_message.innerHTML = "Choisir les variables (cliquer sur le hamburger) et une date de validit&eacute;, et cliquer le point d&eacute;sir&eacute; sur la carte";
    }
    set_pressure_info(tephi_prof) {
        var fetch_data_L = false;
        var p_min = 2000;
        var p_max = -1;
        if (this.tephi_control.id_temp.checked) {
            fetch_data_L = true;
            tephi_prof.tephi_var[tephi_prof.ind_T].present = true;
            tephi_prof.tephi_var[tephi_prof.ind_T].p_max = this.get_levels(this.tephi_control.id_T_max_level);
            tephi_prof.tephi_var[tephi_prof.ind_T].p_min = this.get_levels(this.tephi_control.id_T_min_level);
            [p_min, p_max] = this.get_pmin_pmax(tephi_prof.tephi_var[tephi_prof.ind_T], p_min, p_max);
            this.get_pressure_list(tephi_prof.tephi_var[tephi_prof.ind_T]);
        //alert(tephi_prof.tephi_var[tephi_prof.ind_T].levels)
        }
        if (this.tephi_control.id_td.checked) {
            fetch_data_L = true;
            tephi_prof.tephi_var[tephi_prof.ind_Td].present = true;
            tephi_prof.tephi_var[tephi_prof.ind_Td].p_max = this.get_levels(this.tephi_control.id_Td_max_level);
            tephi_prof.tephi_var[tephi_prof.ind_Td].p_min = this.get_levels(this.tephi_control.id_Td_min_level);
            this.get_pressure_list(tephi_prof.tephi_var[tephi_prof.ind_Td]);
        //alert(tephi_prof.tephi_var[tephi_prof.ind_Td].levels)
        }
        if (this.tephi_control.id_wind.checked) {
            fetch_data_L = true;
            tephi_prof.tephi_var[tephi_prof.ind_UU].present = true;
            tephi_prof.tephi_var[tephi_prof.ind_UU].p_max = this.get_levels(this.tephi_control.id_V_max_level);
            tephi_prof.tephi_var[tephi_prof.ind_UU].p_min = this.get_levels(this.tephi_control.id_V_min_level);
            [p_min, p_max] = this.get_pmin_pmax(tephi_prof.tephi_var[tephi_prof.ind_UU], p_min, p_max);
            this.get_pressure_list(tephi_prof.tephi_var[tephi_prof.ind_UU]);
            //alert(tephi_prof.tephi_var[tephi_prof.ind_UU].levels)
            tephi_prof.tephi_var[tephi_prof.ind_WD].present = true;
            tephi_prof.tephi_var[tephi_prof.ind_WD].p_max = this.get_levels(this.tephi_control.id_V_max_level);
            tephi_prof.tephi_var[tephi_prof.ind_WD].p_min = this.get_levels(this.tephi_control.id_V_min_level);
            this.get_pressure_list(tephi_prof.tephi_var[tephi_prof.ind_WD]);
        //alert(tephi_prof.tephi_var[tephi_prof.ind_WD].levels)
        }
        if (this.tephi_control.id_height_agl.checked || this.tephi_control.id_height_asl.checked) {
            fetch_data_L = true;
            tephi_prof.tephi_var[tephi_prof.ind_GZ].present = true;
            tephi_prof.tephi_var[tephi_prof.ind_GZ].p_max = p_max;
            tephi_prof.tephi_var[tephi_prof.ind_GZ].p_min = p_min;
            this.get_pressure_list(tephi_prof.tephi_var[tephi_prof.ind_GZ]);
        //alert(tephi_prof.tephi_var[tephi_prof.ind_GZ].levels);
        }
        return fetch_data_L;
    }
    get_pmin_pmax(tephi_var, pmin, pmax) {
        if (tephi_var.p_min == "Surface") pmin = 2000;
        else if (parseInt(tephi_var.p_min) < pmin) pmin = parseInt(tephi_var.p_min);
        if (tephi_var.p_max == "Surface") pmax = 2000;
        else if (parseInt(tephi_var.p_max) > pmax) pmax = parseInt(tephi_var.p_max);
        return [
            pmin,
            pmax
        ];
    }
    get_pressure_list(tephi_var) {
        var list = [];
        if (tephi_var.p_max == "Surface") var p_max_i = 2000;
        else var p_max_i = parseInt(tephi_var.p_max);
        if (tephi_var.p_min == "Surface") {
            list.push(this.levels.length - 1);
            tephi_var.level = [
                ...list
            ];
            return;
        }
        var p_min_i = parseInt(tephi_var.p_min);
        for(let i = 0; i < this.levels.length; i++)if (this.levels[i] >= p_min_i && this.levels[i] <= p_max_i) list.push(this.levels[i]);
        tephi_var.levels = [
            ...list
        ];
        for(let i = 0; i < tephi_var.levels.length; i++)tephi_var.data.push(-999);
        tephi_var.diag = -999;
    }
    get_levels(id_menu) {
        return id_menu.options[id_menu.selectedIndex].value;
    }
    find_saved_profile(tephi_prof) {
        var found = null;
        for(var i = 0; i < this.tephi_prof_list.length; i++){
            found = tephi_prof.is_a_sub_profile(this.tephi_prof_list[i]);
            if (found) return this.tephi_prof_list[i];
        }
    }
    // Vide le cache et les marqueurs gris, tous modèles confondus, en gardant
    // uniquement le point courant (celui affiché en rouge sur la carte, s'il y
    // en a un).
    clear_past() {
        var cur = this.markers.current;
        if (cur) this.tephi_prof_list = this.tephi_prof_list.filter((p)=>p.model === cur.model && p.grid_point_coor && (0, $hCh95.distanceKm)(p.grid_point_coor[1], p.grid_point_coor[0], cur.lat, cur.lon) <= 0.5 * p.resolution);
        else this.tephi_prof_list = [];
        this.markers.clearPast();
    }
}
function $9e85e08a0654283f$var$Get_First_Date(date) {
    var res = new Date();
    res.setFullYear(date.getFullYear());
    res.setDate(date.getDate());
    res.setHours(date.getHours());
    res.setMinutes(0);
    res.setSeconds(0);
    res.setMilliseconds(0);
    return res;
}
function $9e85e08a0654283f$var$Get_Wms_date_format(date, hour_only = false) {
    var yyyy = String(date.getUTCFullYear());
    var mm = String(date.getUTCMonth() + 1).padStart(2, '0'); //January is 0!
    var dd = String(date.getUTCDate()).padStart(2, '0');
    var hh = String(date.getUTCHours()).padStart(2, '0');
    if (hour_only) return hh;
    else return yyyy + '-' + mm + '-' + dd + 'T' + hh + ':00:00Z';
}
function $9e85e08a0654283f$var$Get_graph_date_format(date) {
    var yyyy = String(date.getFullYear());
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var dd = String(date.getDate()).padStart(2, '0');
    var hh = String(date.getHours()).padStart(2, '0');
    return yyyy + '-' + mm + '-' + dd + ' ' + hh + ':00:00';
}
class $9e85e08a0654283f$var$Progress_bar {
    constructor(canvas){
        this.canvas = canvas;
        // Résolution du buffer de dessin = taille CSS réelle, pour un rendu net
        // (sinon le canvas garde sa résolution par défaut 300x150 et le navigateur
        // l'étire/floute pour remplir la boîte CSS).
        this.canvas.width = canvas.clientWidth || 300;
        this.canvas.height = canvas.clientHeight || 24;
    }
    update_progress_bar(percent) {
        var ctx = this.canvas.getContext("2d");
        var w = this.canvas.width;
        var h = this.canvas.height;
        ctx.clearRect(0, 0, w, h);
        // Rien à afficher au repos — espace blanc, pas de contour ni de %
        if (percent < .0001) return;
        ctx.fillStyle = "#EEE";
        ctx.fillRect(0, 0, w, h);
        ctx.fillStyle = "#F00";
        ctx.fillRect(0, 0, percent * w, h);
        ctx.strokeStyle = "#888";
        ctx.strokeRect(0.5, 0.5, w - 1, h - 1);
        ctx.fillStyle = "#000";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.font = Math.floor(h * 0.65) + "px sans-serif";
        ctx.fillText(Math.round(percent * 100) + " %", w / 2, h / 2);
    }
    reset_progress_bar() {
        this.update_progress_bar(0);
        this.precent = 0.;
    }
}

});
parcelRegister("8wy2x", function(module, exports) {

$parcel$export(module.exports, "fetchCapabilities", () => $634bb787c1977b31$export$a375cbb556047089);
/**
 * Parsing des GetCapabilities WMS du SMC.
 *
 * Le serveur retourne un XML; on l'analyse pour extraire :
 *   - dateo : date/heure d'origine de la prévision (Date)
 *   - datef : date/heure de fin disponible (Date)
 *   - deltaHours : pas de temps en heures (number)
 */ const $634bb787c1977b31$var$WMS_BASE_URL = 'https://geo.weather.gc.ca/geomet?SERVICE=WMS&VERSION=1.3.0';
/**
 * Télécharge et analyse les capabilities WMS pour une couche donnée.
 *
 * @param {string} layerName - ex: 'HRDPS.CONTINENTAL_TT'
 * @param {AbortSignal} [signal]
 * @returns {Promise<{dateo: Date, datef: Date, deltaHours: number}>}
 */ async function $634bb787c1977b31$var$fetchWithRetry(url, fetchOpts, maxRetries = 3) {
    let delay = 2000;
    for(let attempt = 0; attempt <= maxRetries; attempt++){
        const resp = await fetch(url, fetchOpts);
        if (resp.status !== 429 || attempt === maxRetries) return resp;
        await new Promise((resolve)=>setTimeout(resolve, delay));
        delay *= 2;
    }
}
async function $634bb787c1977b31$export$a375cbb556047089(layerName, signal) {
    const url = `${$634bb787c1977b31$var$WMS_BASE_URL}&REQUEST=GetCapabilities&LAYERS=${layerName}`;
    console.log(url);
    const resp = await $634bb787c1977b31$var$fetchWithRetry(url, signal ? {
        signal: signal
    } : {});
    if (!resp.ok) throw new Error(`GetCapabilities HTTP ${resp.status} pour ${layerName}`);
    const text = await resp.text();
    return $634bb787c1977b31$export$ed163fb8b653da17(text);
}
function $634bb787c1977b31$export$ed163fb8b653da17(xmlText) {
    const dimMatch = xmlText.match(/<Dimension name="time"[^>]*>([^<]+)<\/Dimension>/);
    if (!dimMatch) throw new Error('Dimension temporelle introuvable dans les capabilities WMS');
    const content = dimMatch[1];
    // Format intervalle : un ou plusieurs "dateo/datef/intervalle" séparés par des espaces
    // (HRDPS, RDPS — et certains modèles avec plusieurs runs dans le même élément)
    const rangeRe = /(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z)\/(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z)\/(PT?\d+H|P\d+D)/g;
    let best = null;
    let rm;
    while((rm = rangeRe.exec(content)) !== null){
        const dateo = new Date(rm[1]);
        const datef = new Date(rm[2]);
        const deltaHours = $634bb787c1977b31$export$3fd399519c79b98e(rm[3]);
        if (!best || dateo > best.dateo) best = {
            dateo: dateo,
            datef: datef,
            deltaHours: deltaHours
        };
    }
    if (best) {
        const { dateo: dateo, datef: datef, deltaHours: deltaHours } = best;
        const stepMs = deltaHours * 3600000;
        const times = [];
        for(let t = dateo.getTime(); t <= datef.getTime(); t += stepMs)times.push(new Date(t));
        return {
            dateo: dateo,
            datef: datef,
            deltaHours: deltaHours,
            times: times
        };
    }
    // Format liste : "t0,t1,t2,..." (GDPS)
    const timestamps = content.trim().split(',').map((s)=>new Date(s.trim()));
    if (timestamps.length < 2 || isNaN(timestamps[0])) throw new Error('Format de dimension temporelle non reconnu : ' + content.trim().slice(0, 80));
    let minMs = Infinity;
    for(let i = 1; i < timestamps.length; i++){
        const delta = timestamps[i] - timestamps[i - 1];
        if (delta > 0 && delta < minMs) minMs = delta;
    }
    return {
        dateo: timestamps[0],
        datef: timestamps[timestamps.length - 1],
        deltaHours: minMs / 3600000,
        times: timestamps
    };
}
function $634bb787c1977b31$export$3fd399519c79b98e(interval) {
    let m;
    // PTnH → n heures
    m = interval.match(/^PT(\d+)H$/);
    if (m) return parseInt(m[1], 10);
    // PnD → n * 24 heures
    m = interval.match(/^P(\d+)D$/);
    if (m) return parseInt(m[1], 10) * 24;
    throw new Error(`Format d'intervalle non support\xe9 : "${interval}"`);
}

});

parcelRegister("lBMGk", function(module, exports) {

$parcel$export(module.exports, "fetchFeatureInfo", () => $fbb2d0d75ccc524e$export$5345b976c9dd0277);
$parcel$export(module.exports, "runWithConcurrency", () => $fbb2d0d75ccc524e$export$afd518cbcafaaa03);
/**
 * Requêtes HTTP bas niveau vers le WMS du SMC.
 *
 * GetFeatureInfo : retourne la valeur d'une variable à un point et un instant donnés.
 */ const $fbb2d0d75ccc524e$var$WMS_BASE_URL = 'https://geo.weather.gc.ca/geomet?SERVICE=WMS&VERSION=1.3.0';
function $fbb2d0d75ccc524e$export$e7f1866a7611b7e7({ layer: layer, lat: lat, lon: lon, time: time, refTime: refTime, style: style = '' }) {
    const delta = 0.0001;
    const bbox = `${lat - delta},${lon - delta},${lat + delta},${lon + delta}`;
    return $fbb2d0d75ccc524e$var$WMS_BASE_URL + '&REQUEST=GetFeatureInfo' + '&INFO_FORMAT=application/json' + '&WIDTH=10&HEIGHT=10&I=5&J=5' + `&LAYERS=${layer}` + `&QUERY_LAYERS=${layer}` + (style ? `&STYLES=${style}` : '') + '&CRS=EPSG:4326' + `&BBOX=${bbox}` + `&TIME=${time}` + `&DIM_REFERENCE_TIME=${refTime}`;
}
function $fbb2d0d75ccc524e$export$273fb9b7638793a7(date) {
    return date.toISOString().slice(0, 19) + 'Z';
}
/**
 * Fait une requête fetch avec retry automatique sur HTTP 429.
 *
 * @param {string} url
 * @param {RequestInit} fetchOpts
 * @param {number} [maxRetries=3]
 * @returns {Promise<Response>}
 */ async function $fbb2d0d75ccc524e$var$fetchWithRetry(url, fetchOpts, maxRetries = 3) {
    let delay = 2000;
    for(let attempt = 0; attempt <= maxRetries; attempt++){
        const resp = await fetch(url, fetchOpts);
        if (resp.status !== 429 || attempt === maxRetries) return resp;
        await new Promise((resolve)=>setTimeout(resolve, delay));
        delay *= 2;
    }
}
async function $fbb2d0d75ccc524e$export$5345b976c9dd0277(params, signal) {
    const url = $fbb2d0d75ccc524e$export$e7f1866a7611b7e7(params);
    const resp = await $fbb2d0d75ccc524e$var$fetchWithRetry(url, signal ? {
        signal: signal
    } : {});
    if (!resp.ok) throw new Error(`GetFeatureInfo HTTP ${resp.status}`);
    let json;
    try {
        json = await resp.json();
    } catch  {
        // Le WMS retourne parfois une exception XML avec HTTP 200
        return {
            value: null,
            gridLon: null,
            gridLat: null
        };
    }
    const feature = json?.features?.[0];
    if (!feature) return {
        value: null,
        gridLon: null,
        gridLat: null
    };
    const value = feature.properties?.value;
    const [gridLon, gridLat] = feature.geometry?.coordinates ?? [
        null,
        null
    ];
    return {
        value: value != null ? parseFloat(value) : null,
        gridLon: gridLon,
        gridLat: gridLat
    };
}
async function $fbb2d0d75ccc524e$export$afd518cbcafaaa03(tasks, worker, concurrency) {
    const queue = [
        ...tasks
    ];
    async function runOne() {
        while(queue.length > 0){
            const task = queue.shift();
            await worker(task);
        }
    }
    await Promise.all(Array.from({
        length: Math.min(concurrency, queue.length)
    }, runOne));
}
function $fbb2d0d75ccc524e$export$2d7297bad12b699d(times, start, hours, deltaHours, startHour = 0) {
    const t0 = start.getTime();
    const isSchedule = Array.isArray(deltaHours);
    return times.filter((t)=>{
        const h = Math.round((t.getTime() - t0) / 3600000);
        if (h < startHour || h > hours) return false;
        const step = isSchedule ? (deltaHours.find((s)=>s.until === undefined || h < s.until) ?? deltaHours[deltaHours.length - 1]).step : deltaHours;
        return h % step === 0;
    });
}
function $fbb2d0d75ccc524e$export$36bfa2798d677738(dateo, hours, deltaHours, startHour = 0) {
    const schedule = Array.isArray(deltaHours) ? deltaHours : null;
    const times = [];
    const hhh = [];
    let h = 0;
    while(h <= hours){
        let step;
        if (schedule) {
            const seg = schedule.find((s)=>s.until === undefined || h < s.until) ?? schedule[schedule.length - 1];
            step = seg.step;
        } else step = deltaHours;
        if (h >= startHour) {
            const t = new Date(dateo.getTime() + h * 3600000);
            times.push($fbb2d0d75ccc524e$export$273fb9b7638793a7(t));
            hhh.push(h);
        }
        h += step;
    }
    return {
        times: times,
        hhh: hhh
    };
}

});

parcelRegister("8Lu1J", function(module, exports) {

$parcel$export(module.exports, "layerName", () => $661a0140e9927f0d$export$72a4307e8eeb6a9d);
$parcel$export(module.exports, "styleForVariable", () => $661a0140e9927f0d$export$b3ff1994f7e0f683);
$parcel$export(module.exports, "metaLayer", () => $661a0140e9927f0d$export$386068ba76b35f95);
/**
 * Mapping modèle + variable → nom de couche WMS complet
 *
 * Chaque modèle a un préfixe de région différent :
 *   RDPS  → RDPS_10km_AirTemp_2m
 *   GDPS  → GDPS.ETA_TT
 *   HRDPS → HRDPS.CONTINENTAL_TT
 *   RAQDPS → RAQDPS.EATM_PM2.5
 */ // Préfixe de région par modèle
const $661a0140e9927f0d$var$REGION_PREFIX = {
    RDPS: '_10km_',
    GDPS: '_15km_',
    HRDPS: '.CONTINENTAL_',
    RAQDPS: '.'
};
const $661a0140e9927f0d$var$HAS_PRESSURE_LEVELS = new Set([
    'TT',
    'ES',
    'WSPD',
    'WD',
    'GZ'
]);
const $661a0140e9927f0d$var$RDPS_vars = {
    TT: "AirTemp",
    ES: "DewPointDepression",
    PR: "Precip-Accum",
    RN: "Rain-Accum",
    SN: "Snow-Accum",
    FR: "FreezingRain-Accum",
    WSPD: "WindSpeed",
    WD: "WindDir",
    WGE: "WindGust_10m",
    NT: "TotalCloudCover",
    N4: "DownwardShortwaveRadiationFlux-Accum",
    GZ: "GeopotentialHeight"
};
function $661a0140e9927f0d$export$72a4307e8eeb6a9d(model, variable, level) {
    const modelU = model.toUpperCase();
    if (!(modelU in $661a0140e9927f0d$var$REGION_PREFIX)) throw new Error(`Mod\xe8le inconnu : "${model}". Mod\xe8les support\xe9s : ${Object.keys($661a0140e9927f0d$var$REGION_PREFIX).join(', ')}`);
    let varname = variable;
    if (modelU == "RDPS" || modelU == "GDPS") {
        if (level === undefined) throw new Error(`Le param\xe8tre level doit \xeatre pass\xe9 avec le mod\xe8le ${model}. Valeurs support\xe9es : diag, 1000, 500 `);
        let suffix = '';
        if (level == 'diag') {
            if (variable == 'TT' || variable == 'ES') suffix = '_2m';
            else if (variable == 'WSPD' || variable == 'WD') suffix = '_10m';
        } else {
            if (!$661a0140e9927f0d$var$HAS_PRESSURE_LEVELS.has(variable)) throw new Error(`La variable "${variable}" n'a pas de niveaux de pression.`);
            suffix = '_' + level + 'mb';
        }
        varname = $661a0140e9927f0d$var$RDPS_vars[variable] + suffix;
    } else if (modelU === "HRDPS" && level !== undefined && level !== 'diag') {
        if (!$661a0140e9927f0d$var$HAS_PRESSURE_LEVELS.has(variable)) throw new Error(`La variable "${variable}" n'a pas de niveaux de pression.`);
        return `${modelU}.CONTINENTAL.PRES_${variable}.${level}`;
    }
    if (varname === undefined) throw new Error(`Variable non d\xe9f\xe9nie pour "${model}" : "${variable}"`);
    return `${modelU}${$661a0140e9927f0d$var$REGION_PREFIX[modelU]}${varname}`;
}
function $661a0140e9927f0d$export$5792b81513a80aca(model, variables, level = 'diag') {
    return variables.map((v)=>$661a0140e9927f0d$export$72a4307e8eeb6a9d(model, v, level));
}
/**
 * Style WMS explicite par variable.
 *
 * On fixe le style pour chaque variable afin d'être indépendant des changements
 * de style par défaut côté SMC/GeoMet.
 *
 * Les valeurs correspondent aux styles par défaut observés le 2026-04-10,
 * sauf WGE : le défaut (GUST_INTERV_MS2KTS) masque les rafales < 15 kt ;
 * on utilise GUST_MS2KMH qui couvre toutes les valeurs à partir de 0.
 *
 * Pour GZ, HRDPS utilise GEOPOTENTIALHEIGHT-LINEAR tandis que RDPS/GDPS
 * utilisent GPHEIGHT — voir MODEL_VARIABLE_STYLE pour l'override.
 *
 * Pour mettre à jour cette liste : make list-styles (dans wms-forecast-client)
 */ const $661a0140e9927f0d$var$VARIABLE_STYLE = {
    ES: 'DEWPOINTDEP',
    FR: 'CAPA24-LINEAR',
    N4: 'SHORTWAVEFLUX-LINEAR',
    NT: 'CLOUD',
    P0: 'PRESSURE',
    PR: 'CAPA24-LINEAR',
    RN: 'CAPA24-LINEAR',
    SN: 'Snow-Accum_0to100cm_BlueRed',
    TT: 'TEMPERATURE-LINEAR',
    WD: 'WDIR6-LINEAR',
    WGE: 'GUST_MS2KMH',
    WSPD: 'WINDSPEEDKNOTS-LINEAR',
    'EATM_PM2.5': 'PM2.5_EAtm_1e-7to2e-4kgm2',
    'SFC_PM2.5': 'PM2.5_0to100ugm3_Dis'
};
/**
 * Overrides de style par modèle, pour les variables dont le style par défaut
 * diffère selon le modèle.
 */ const $661a0140e9927f0d$var$MODEL_VARIABLE_STYLE = {};
function $661a0140e9927f0d$export$b3ff1994f7e0f683(variable, model = '') {
    return $661a0140e9927f0d$var$MODEL_VARIABLE_STYLE[model]?.[variable] ?? $661a0140e9927f0d$var$VARIABLE_STYLE[variable] ?? '';
}
function $661a0140e9927f0d$export$3d089e58d505c417() {
    return Object.keys($661a0140e9927f0d$var$REGION_PREFIX);
}
/**
 * Couche WMS de référence par modèle, utilisée pour :
 *   - GetCapabilities (obtenir le dateo fiable)
 *   - GetFeatureInfo à P0 (obtenir le point de grille)
 *
 * On évite TT car les variables accumulées (PR, SN, RN…) ont un dateo
 * décalé d'une heure dans les capabilities — P0 n'a pas ce problème.
 * RAQDPS n'a pas de champ P0 ; on utilise SFC_PM2.5 à la place.
 */ const $661a0140e9927f0d$var$META_LAYER = {
    HRDPS: 'HRDPS.CONTINENTAL_P0',
    RDPS: 'RDPS_10km_Pressure',
    GDPS: 'GDPS_15km_Pressure',
    RAQDPS: 'RAQDPS.SFC_PM2.5'
};
function $661a0140e9927f0d$export$386068ba76b35f95(model) {
    const m = model.toUpperCase();
    const layer = $661a0140e9927f0d$var$META_LAYER[m];
    if (!layer) throw new Error(`Mod\xe8le inconnu : "${model}". Mod\xe8les support\xe9s : ${Object.keys($661a0140e9927f0d$var$META_LAYER).join(', ')}`);
    return layer;
}

});

parcelRegister("4aJ1U", function(module, exports) {

$parcel$export(module.exports, "findGridAxes", () => $309b068d830f0991$export$4da395e0980de86a);
/**
 * Trouve les deux vrais axes locaux (dLon, dLat) de la grille d'un modèle à
 * un point donné, en sondant les points de grille voisins via GetFeatureInfo.
 *
 * Sonder seulement l'est vrai ne suffit PAS pour une grille tournée (HRDPS,
 * RDPS, RAQDPS) : rien ne garantit que cette direction arbitraire tombe sur
 * un vrai voisin adjacent plutôt que sur un voisin en diagonale
 * (accidentellement ~√2× plus loin et mal orienté). On détecte ce cas en
 * comparant la magnitude trouvée à une devinette de résolution (voir
 * fetchGridSpacing) : si elle est trop grande, on corrige en sondant à ±45°
 * de cette direction, où se trouve un vrai voisin — puisque dans toute
 * grille régulière, même tournée, un voisin en diagonale se situe
 * exactement à 45° entre les deux vrais axes adjacents. Le second axe est
 * ensuite simplement perpendiculaire au premier (les deux axes d'une grille
 * régulière sont toujours orthogonaux, même tournée).
 */ 
var $lBMGk = parcelRequire("lBMGk");

var $iuDMR = parcelRequire("iuDMR");
// Au-delà de ce ratio (magnitude trouvée / devinette de résolution), on
// soupçonne un voisin en diagonale (~√2 ≈ 1.41×) plutôt qu'un vrai voisin
// adjacent (~1.0-1.3× selon le bruit de mesure observé empiriquement).
const $309b068d830f0991$var$DIAGONAL_RATIO = 1.3;
function $309b068d830f0991$var$rotateDeg(vec, deg) {
    const r = deg * Math.PI / 180;
    return [
        vec[0] * Math.cos(r) - vec[1] * Math.sin(r),
        vec[0] * Math.sin(r) + vec[1] * Math.cos(r)
    ];
}
async function $309b068d830f0991$export$4da395e0980de86a({ layer: layer, style: style, time: time, refTime: refTime, lon0: lon0, lat0: lat0 }, signal) {
    let guess;
    try {
        guess = await (0, $iuDMR.fetchGridSpacing)(layer, signal);
    } catch (error) {
        console.error('Erreur DescribeCoverage:', error);
        guess = {
            lonStep: 0.1,
            latStep: 0.1
        };
    }
    const refMag = Math.max(guess.lonStep, guess.latStep);
    // Sonde dans une direction donnée (vecteur non nécessairement unitaire)
    // en augmentant le pas jusqu'à trouver un point de grille distinct du
    // centre ; retourne le vecteur (dLon, dLat) complet vers ce voisin, ou
    // null si aucun n'a été trouvé.
    const probeDirection = async (dir)=>{
        const norm = Math.hypot(dir[0], dir[1]);
        const unit = [
            dir[0] / norm,
            dir[1] / norm
        ];
        let step = refMag;
        for(let attempt = 0; attempt < 8; attempt++){
            const probeLon = lon0 + unit[0] * step;
            const probeLat = lat0 + unit[1] * step;
            const { gridLon: gridLon, gridLat: gridLat } = await (0, $lBMGk.fetchFeatureInfo)({
                layer: layer,
                lat: probeLat,
                lon: probeLon,
                time: time,
                refTime: refTime,
                style: style
            }, signal);
            if (gridLon !== null && (gridLon !== lon0 || gridLat !== lat0)) return [
                gridLon - lon0,
                gridLat - lat0
            ];
            step *= 1.5;
        }
        return null;
    };
    let u = await probeDirection([
        1,
        0
    ]);
    if (u === null) throw new Error("Aucun point de grille voisin trouv\xe9 (est)");
    if (Math.hypot(...u) > $309b068d830f0991$var$DIAGONAL_RATIO * refMag) {
        const angleU = Math.atan2(u[1], u[0]) * 180 / Math.PI;
        const candidates = [
            u
        ];
        const uPlus = await probeDirection($309b068d830f0991$var$rotateDeg([
            1,
            0
        ], angleU + 45));
        if (uPlus !== null) candidates.push(uPlus);
        if (uPlus === null || Math.hypot(...uPlus) > $309b068d830f0991$var$DIAGONAL_RATIO * refMag) {
            const uMinus = await probeDirection($309b068d830f0991$var$rotateDeg([
                1,
                0
            ], angleU - 45));
            if (uMinus !== null) candidates.push(uMinus);
        }
        u = candidates.reduce((best, c)=>Math.hypot(...c) < Math.hypot(...best) ? c : best);
    }
    const v = await probeDirection([
        -u[1],
        u[0]
    ]);
    if (v === null) throw new Error("Aucun point de grille voisin trouv\xe9 (perpendiculaire)");
    return {
        axisU: u,
        axisV: v
    };
}

});
parcelRegister("iuDMR", function(module, exports) {

$parcel$export(module.exports, "fetchGridSpacing", () => $d769e439fa4b131d$export$6ec7116663b22b8e);
/**
 * Requête WCS DescribeCoverage — estimation grossière de l'espacement de grille.
 *
 * GeoMet expose, en plus du WMS, un service WCS où DescribeCoverage retourne
 * un <gml:offsetVector> par axe de grille. Pour les modèles à grille tournée
 * (HRDPS notamment), ce pas est exprimé dans le repère natif du modèle mais
 * étiqueté "EPSG:4326" par simplification du serveur — ce n'est donc PAS un
 * espacement géographique réel valide partout sur le domaine (un pas constant
 * en vraie lat/lon sur un domaine de plusieurs dizaines de degrés serait
 * géométriquement impossible pour une grille tournée).
 *
 * Le résultat ne doit donc servir que de point de départ pour une recherche
 * du point de grille voisin via GetFeatureInfo (voir series.js du projet
 * wms_time_series), qui donne elle la vraie distance géographique quel que
 * soit le repère natif du modèle.
 */ const $d769e439fa4b131d$var$WCS_BASE_URL = 'https://geo.weather.gc.ca/geomet?SERVICE=WCS&VERSION=2.0.1';
const $d769e439fa4b131d$var$cache = new Map();
async function $d769e439fa4b131d$export$6ec7116663b22b8e(coverageId, signal) {
    if ($d769e439fa4b131d$var$cache.has(coverageId)) return $d769e439fa4b131d$var$cache.get(coverageId);
    const url = `${$d769e439fa4b131d$var$WCS_BASE_URL}&REQUEST=DescribeCoverage&COVERAGEID=${coverageId}`;
    const resp = await fetch(url, signal ? {
        signal: signal
    } : {});
    if (!resp.ok) throw new Error(`DescribeCoverage HTTP ${resp.status} pour ${coverageId}`);
    const text = await resp.text();
    const spacing = $d769e439fa4b131d$export$c538f635b9ea8364(text);
    $d769e439fa4b131d$var$cache.set(coverageId, spacing);
    return spacing;
}
function $d769e439fa4b131d$export$c538f635b9ea8364(xmlText) {
    const vectors = [
        ...xmlText.matchAll(/<gml:offsetVector[^>]*>([^<]+)<\/gml:offsetVector>/g)
    ].map((m)=>m[1].trim().split(/\s+/).map(Number));
    if (vectors.length < 2) throw new Error('offsetVector introuvable dans le DescribeCoverage WCS');
    let latStep = 0;
    let lonStep = 0;
    for (const [lat, lon] of vectors){
        latStep += Math.abs(lat);
        lonStep += Math.abs(lon);
    }
    return {
        lonStep: lonStep,
        latStep: latStep
    };
}

});


parcelRegister("hCh95", function(module, exports) {

$parcel$export(module.exports, "distanceKm", () => $cd3349079b9aa4d2$export$f8a36e75ecb09d49);
$parcel$export(module.exports, "GridPointMarkers", () => $cd3349079b9aa4d2$export$8ec93ae708b74f77);

var $dIG9p = parcelRequire("dIG9p");

var $dpRHA = parcelRequire("dpRHA");

var $bnthu = parcelRequire("bnthu");

var $bdrRp = parcelRequire("bdrRp");

var $3xcD3 = parcelRequire("3xcD3");

var $l7VLp = parcelRequire("l7VLp");

var $lrKvI = parcelRequire("lrKvI");
var $c3RIb = parcelRequire("c3RIb");
const $cd3349079b9aa4d2$var$EARTH_RADIUS_KM = 6371.22;
const $cd3349079b9aa4d2$var$CURRENT_COLOR = 'red';
const $cd3349079b9aa4d2$var$PAST_COLOR = 'gray';
const $cd3349079b9aa4d2$var$PENDING_RADIUS_M = 2000;
// Le point courant doit toujours être visible par-dessus les points passés,
// peu importe lequel a été ajouté en dernier à la carte (l'ordre d'ajout des
// couches OpenLayers, pas l'ordre chronologique des clics, détermine sinon
// le z-order).
const $cd3349079b9aa4d2$var$PAST_ZINDEX = 1;
const $cd3349079b9aa4d2$var$CURRENT_ZINDEX = 2;
function $cd3349079b9aa4d2$export$f8a36e75ecb09d49(lat1, lon1, lat2, lon2) {
    const deg2rad = Math.PI / 180;
    return Math.acos(Math.sin(lat1 * deg2rad) * Math.sin(lat2 * deg2rad) + Math.cos(lat1 * deg2rad) * Math.cos(lat2 * deg2rad) * Math.cos((lon2 - lon1) * deg2rad)) * $cd3349079b9aa4d2$var$EARTH_RADIUS_KM;
}
// Dessine un maillage 3x3 (lignes) centré sur (lon0, lat0) + un petit cercle
// central, à l'échelle réelle des axes de grille du modèle (axisU/axisV,
// trouvés par wms-forecast-client/src/gridAxes.js — pas nécessairement
// est/nord, cf. grille tournée HRDPS/RDPS). Porté de
// wms_time_series_with_WMS_API/modules/series.js (fonction gridMesh).
function $cd3349079b9aa4d2$var$meshFeatures(lon0, lat0, axisU, axisV, color) {
    const style = new (0, $c3RIb.default)({
        stroke: new (0, $lrKvI.default)({
            color: color,
            width: 2
        })
    });
    const at = (i, j)=>[
            lon0 + i * axisU[0] + j * axisV[0],
            lat0 + i * axisU[1] + j * axisV[1]
        ];
    const lines = [];
    for(let j = -1; j <= 1; j++)lines.push([
        at(-1, j),
        at(1, j)
    ]);
    for(let i = -1; i <= 1; i++)lines.push([
        at(i, -1),
        at(i, 1)
    ]);
    const features = lines.map((coords)=>{
        const feature = new (0, $dIG9p.default)({
            geometry: new (0, $3xcD3.default)(coords.map((c)=>(0, $dpRHA.fromLonLat)(c)))
        });
        feature.setStyle(style);
        return feature;
    });
    // Cercle au point central, diamètre = une fraction de la plus petite
    // distance de grille, mesurée en coordonnées projetées le long de l'axe
    // le plus court pour rester correcte à l'échelle réelle peu importe la
    // latitude.
    const DIAMETER_FRACTION = 0.7;
    const shortestAxis = Math.hypot(...axisU) <= Math.hypot(...axisV) ? axisU : axisV;
    const centerProj = (0, $dpRHA.fromLonLat)([
        lon0,
        lat0
    ]);
    const edgeProj = (0, $dpRHA.fromLonLat)([
        lon0 + DIAMETER_FRACTION / 2 * shortestAxis[0],
        lat0 + DIAMETER_FRACTION / 2 * shortestAxis[1]
    ]);
    const radius = Math.hypot(edgeProj[0] - centerProj[0], edgeProj[1] - centerProj[1]);
    const circleFeature = new (0, $dIG9p.default)({
        geometry: new (0, $l7VLp.default)(centerProj, radius)
    });
    circleFeature.setStyle(style);
    features.push(circleFeature);
    return features;
}
class $cd3349079b9aa4d2$export$8ec93ae708b74f77 {
    constructor(map){
        this.map = map;
        this.markers = []; // {model, lon, lat, axisU, axisV, source, layer}
        this.current = null;
    }
    // Marqueur temporaire au point cliqué (brut, avant résolution du point de
    // grille) — juste un retour visuel immédiat pendant que findGridAxes sonde
    // les voisins (quelques requêtes WMS). Retourne un handle .clear()
    // idempotent.
    pending([lon, lat]) {
        const style = new (0, $c3RIb.default)({
            stroke: new (0, $lrKvI.default)({
                color: $cd3349079b9aa4d2$var$CURRENT_COLOR,
                width: 5
            })
        });
        const feature = new (0, $dIG9p.default)({
            geometry: new (0, $l7VLp.default)((0, $dpRHA.fromLonLat)([
                lon,
                lat
            ]), $cd3349079b9aa4d2$var$PENDING_RADIUS_M)
        });
        feature.setStyle(style);
        const source = new (0, $bnthu.default)({
            features: [
                feature
            ]
        });
        const layer = new (0, $bdrRp.default)({
            source: source
        });
        this.map.addLayer(layer);
        let cleared = false;
        return {
            clear: ()=>{
                if (cleared) return;
                cleared = true;
                this.map.removeLayer(layer);
            }
        };
    }
    // Ne matche que des marqueurs du même modèle : deux modèles ont des
    // grilles différentes (résolution, orientation), donc un point HRDPS et
    // un point RDPS proches l'un de l'autre restent deux points distincts.
    _findMarker(model, lon, lat, resolutionKm) {
        return this.markers.find((m)=>m.model === model && $cd3349079b9aa4d2$export$f8a36e75ecb09d49(lat, lon, m.lat, m.lon) <= 0.5 * resolutionKm);
    }
    _redraw(marker, color) {
        marker.source.clear();
        marker.source.addFeatures($cd3349079b9aa4d2$var$meshFeatures(marker.lon, marker.lat, marker.axisU, marker.axisV, color));
        marker.layer.setZIndex(color === $cd3349079b9aa4d2$var$CURRENT_COLOR ? $cd3349079b9aa4d2$var$CURRENT_ZINDEX : $cd3349079b9aa4d2$var$PAST_ZINDEX);
    }
    // Affiche/replace le maillage rouge sur le point de grille (lon, lat) du
    // modèle donné, réutilisant le marqueur existant du même modèle s'il y en
    // a déjà un à moins de 0.5 * resolutionKm (même point de grille revisité),
    // et repasse l'ancien point courant en gris.
    promote(model, lon, lat, axisU, axisV, resolutionKm) {
        let marker = this._findMarker(model, lon, lat, resolutionKm);
        if (marker) {
            marker.lon = lon;
            marker.lat = lat;
            marker.axisU = axisU;
            marker.axisV = axisV;
        } else {
            const source = new (0, $bnthu.default)({
                projection: 'EPSG:4326'
            });
            const layer = new (0, $bdrRp.default)({
                source: source
            });
            this.map.addLayer(layer);
            marker = {
                model: model,
                lon: lon,
                lat: lat,
                axisU: axisU,
                axisV: axisV,
                source: source,
                layer: layer
            };
            this.markers.push(marker);
        }
        if (this.current && this.current !== marker) this._redraw(this.current, $cd3349079b9aa4d2$var$PAST_COLOR);
        this._redraw(marker, $cd3349079b9aa4d2$var$CURRENT_COLOR);
        this.current = marker;
    }
    // Retire tous les marqueurs gris de la carte, en gardant seulement le
    // point courant (s'il y en a un).
    clearPast() {
        for (const marker of this.markers)if (marker !== this.current) this.map.removeLayer(marker.layer);
        this.markers = this.current ? [
            this.current
        ] : [];
    }
}

});





parcelRequire("iMQia");

//# sourceMappingURL=openlayers_tephi.e2e8f928.js.map
